/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.pond = (function() {

    /**
     * Namespace pond.
     * @exports pond
     * @namespace
     */
    var pond = {};

    pond.PondService = (function() {

        /**
         * Constructs a new PondService service.
         * @memberof pond
         * @classdesc Represents a PondService
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function PondService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (PondService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PondService;

        /**
         * Creates new PondService service using the specified rpc implementation.
         * @function create
         * @memberof pond.PondService
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {PondService} RPC service. Useful where requests and/or responses are streamed.
         */
        PondService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link pond.PondService#receiveQuack}.
         * @memberof pond.PondService
         * @typedef ReceiveQuackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ReceiveQuackResponse} [response] ReceiveQuackResponse
         */

        /**
         * Calls ReceiveQuack.
         * @function receiveQuack
         * @memberof pond.PondService
         * @instance
         * @param {pond.ReceiveQuackRequest} request ReceiveQuackRequest message or plain object
         * @param {pond.PondService.ReceiveQuackCallback} callback Node-style callback called with the error, if any, and ReceiveQuackResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.receiveQuack = function receiveQuack(request, callback) {
            return this.rpcCall(receiveQuack, $root.pond.ReceiveQuackRequest, $root.pond.ReceiveQuackResponse, request, callback);
        }, "name", { value: "ReceiveQuack" });

        /**
         * Calls ReceiveQuack.
         * @function receiveQuack
         * @memberof pond.PondService
         * @instance
         * @param {pond.ReceiveQuackRequest} request ReceiveQuackRequest message or plain object
         * @returns {Promise<pond.ReceiveQuackResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDevice}.
         * @memberof pond.PondService
         * @typedef GetDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Device} [response] Device
         */

        /**
         * Calls GetDevice.
         * @function getDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceRequest} request GetDeviceRequest message or plain object
         * @param {pond.PondService.GetDeviceCallback} callback Node-style callback called with the error, if any, and Device
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDevice = function getDevice(request, callback) {
            return this.rpcCall(getDevice, $root.pond.GetDeviceRequest, $root.pond.Device, request, callback);
        }, "name", { value: "GetDevice" });

        /**
         * Calls GetDevice.
         * @function getDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceRequest} request GetDeviceRequest message or plain object
         * @returns {Promise<pond.Device>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#clearDeviceQueue}.
         * @memberof pond.PondService
         * @typedef ClearDeviceQueueCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ClearDeviceQueueResponse} [response] ClearDeviceQueueResponse
         */

        /**
         * Calls ClearDeviceQueue.
         * @function clearDeviceQueue
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearDeviceQueueRequest} request ClearDeviceQueueRequest message or plain object
         * @param {pond.PondService.ClearDeviceQueueCallback} callback Node-style callback called with the error, if any, and ClearDeviceQueueResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.clearDeviceQueue = function clearDeviceQueue(request, callback) {
            return this.rpcCall(clearDeviceQueue, $root.pond.ClearDeviceQueueRequest, $root.pond.ClearDeviceQueueResponse, request, callback);
        }, "name", { value: "ClearDeviceQueue" });

        /**
         * Calls ClearDeviceQueue.
         * @function clearDeviceQueue
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearDeviceQueueRequest} request ClearDeviceQueueRequest message or plain object
         * @returns {Promise<pond.ClearDeviceQueueResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDeviceGeoJSON}.
         * @memberof pond.PondService
         * @typedef GetDeviceGeoJSONCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.DeviceGeoJSON} [response] DeviceGeoJSON
         */

        /**
         * Calls GetDeviceGeoJSON.
         * @function getDeviceGeoJSON
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceGeoJSONRequest} request GetDeviceGeoJSONRequest message or plain object
         * @param {pond.PondService.GetDeviceGeoJSONCallback} callback Node-style callback called with the error, if any, and DeviceGeoJSON
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDeviceGeoJSON = function getDeviceGeoJSON(request, callback) {
            return this.rpcCall(getDeviceGeoJSON, $root.pond.GetDeviceGeoJSONRequest, $root.pond.DeviceGeoJSON, request, callback);
        }, "name", { value: "GetDeviceGeoJSON" });

        /**
         * Calls GetDeviceGeoJSON.
         * @function getDeviceGeoJSON
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceGeoJSONRequest} request GetDeviceGeoJSONRequest message or plain object
         * @returns {Promise<pond.DeviceGeoJSON>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMultiDevice}.
         * @memberof pond.PondService
         * @typedef GetMultiDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMultiDeviceResponse} [response] GetMultiDeviceResponse
         */

        /**
         * Calls GetMultiDevice.
         * @function getMultiDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceRequest} request GetMultiDeviceRequest message or plain object
         * @param {pond.PondService.GetMultiDeviceCallback} callback Node-style callback called with the error, if any, and GetMultiDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMultiDevice = function getMultiDevice(request, callback) {
            return this.rpcCall(getMultiDevice, $root.pond.GetMultiDeviceRequest, $root.pond.GetMultiDeviceResponse, request, callback);
        }, "name", { value: "GetMultiDevice" });

        /**
         * Calls GetMultiDevice.
         * @function getMultiDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceRequest} request GetMultiDeviceRequest message or plain object
         * @returns {Promise<pond.GetMultiDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMultiDeviceGeoJSON}.
         * @memberof pond.PondService
         * @typedef GetMultiDeviceGeoJSONCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMultiDeviceGeoJSONResponse} [response] GetMultiDeviceGeoJSONResponse
         */

        /**
         * Calls GetMultiDeviceGeoJSON.
         * @function getMultiDeviceGeoJSON
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceGeoJSONRequest} request GetMultiDeviceGeoJSONRequest message or plain object
         * @param {pond.PondService.GetMultiDeviceGeoJSONCallback} callback Node-style callback called with the error, if any, and GetMultiDeviceGeoJSONResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMultiDeviceGeoJSON = function getMultiDeviceGeoJSON(request, callback) {
            return this.rpcCall(getMultiDeviceGeoJSON, $root.pond.GetMultiDeviceGeoJSONRequest, $root.pond.GetMultiDeviceGeoJSONResponse, request, callback);
        }, "name", { value: "GetMultiDeviceGeoJSON" });

        /**
         * Calls GetMultiDeviceGeoJSON.
         * @function getMultiDeviceGeoJSON
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceGeoJSONRequest} request GetMultiDeviceGeoJSONRequest message or plain object
         * @returns {Promise<pond.GetMultiDeviceGeoJSONResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDevices}.
         * @memberof pond.PondService
         * @typedef ListDevicesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDevicesResponse} [response] ListDevicesResponse
         */

        /**
         * Calls ListDevices.
         * @function listDevices
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDevicesRequest} request ListDevicesRequest message or plain object
         * @param {pond.PondService.ListDevicesCallback} callback Node-style callback called with the error, if any, and ListDevicesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDevices = function listDevices(request, callback) {
            return this.rpcCall(listDevices, $root.pond.ListDevicesRequest, $root.pond.ListDevicesResponse, request, callback);
        }, "name", { value: "ListDevices" });

        /**
         * Calls ListDevices.
         * @function listDevices
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDevicesRequest} request ListDevicesRequest message or plain object
         * @returns {Promise<pond.ListDevicesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDeviceUsage}.
         * @memberof pond.PondService
         * @typedef GetDeviceUsageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDeviceUsageResponse} [response] GetDeviceUsageResponse
         */

        /**
         * Calls GetDeviceUsage.
         * @function getDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceUsageRequest} request GetDeviceUsageRequest message or plain object
         * @param {pond.PondService.GetDeviceUsageCallback} callback Node-style callback called with the error, if any, and GetDeviceUsageResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDeviceUsage = function getDeviceUsage(request, callback) {
            return this.rpcCall(getDeviceUsage, $root.pond.GetDeviceUsageRequest, $root.pond.GetDeviceUsageResponse, request, callback);
        }, "name", { value: "GetDeviceUsage" });

        /**
         * Calls GetDeviceUsage.
         * @function getDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceUsageRequest} request GetDeviceUsageRequest message or plain object
         * @returns {Promise<pond.GetDeviceUsageResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMultiDeviceUsage}.
         * @memberof pond.PondService
         * @typedef GetMultiDeviceUsageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMultiDeviceUsageResponse} [response] GetMultiDeviceUsageResponse
         */

        /**
         * Calls GetMultiDeviceUsage.
         * @function getMultiDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceUsageRequest} request GetMultiDeviceUsageRequest message or plain object
         * @param {pond.PondService.GetMultiDeviceUsageCallback} callback Node-style callback called with the error, if any, and GetMultiDeviceUsageResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMultiDeviceUsage = function getMultiDeviceUsage(request, callback) {
            return this.rpcCall(getMultiDeviceUsage, $root.pond.GetMultiDeviceUsageRequest, $root.pond.GetMultiDeviceUsageResponse, request, callback);
        }, "name", { value: "GetMultiDeviceUsage" });

        /**
         * Calls GetMultiDeviceUsage.
         * @function getMultiDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiDeviceUsageRequest} request GetMultiDeviceUsageRequest message or plain object
         * @returns {Promise<pond.GetMultiDeviceUsageResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDeviceUsage}.
         * @memberof pond.PondService
         * @typedef ListDeviceUsageCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDeviceUsageResponse} [response] ListDeviceUsageResponse
         */

        /**
         * Calls ListDeviceUsage.
         * @function listDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceUsageRequest} request ListDeviceUsageRequest message or plain object
         * @param {pond.PondService.ListDeviceUsageCallback} callback Node-style callback called with the error, if any, and ListDeviceUsageResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDeviceUsage = function listDeviceUsage(request, callback) {
            return this.rpcCall(listDeviceUsage, $root.pond.ListDeviceUsageRequest, $root.pond.ListDeviceUsageResponse, request, callback);
        }, "name", { value: "ListDeviceUsage" });

        /**
         * Calls ListDeviceUsage.
         * @function listDeviceUsage
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceUsageRequest} request ListDeviceUsageRequest message or plain object
         * @returns {Promise<pond.ListDeviceUsageResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDeviceHistory}.
         * @memberof pond.PondService
         * @typedef ListDeviceHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDeviceHistoryResponse} [response] ListDeviceHistoryResponse
         */

        /**
         * Calls ListDeviceHistory.
         * @function listDeviceHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceHistoryRequest} request ListDeviceHistoryRequest message or plain object
         * @param {pond.PondService.ListDeviceHistoryCallback} callback Node-style callback called with the error, if any, and ListDeviceHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDeviceHistory = function listDeviceHistory(request, callback) {
            return this.rpcCall(listDeviceHistory, $root.pond.ListDeviceHistoryRequest, $root.pond.ListDeviceHistoryResponse, request, callback);
        }, "name", { value: "ListDeviceHistory" });

        /**
         * Calls ListDeviceHistory.
         * @function listDeviceHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceHistoryRequest} request ListDeviceHistoryRequest message or plain object
         * @returns {Promise<pond.ListDeviceHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMetrics}.
         * @memberof pond.PondService
         * @typedef GetMetricsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMetricsResponse} [response] GetMetricsResponse
         */

        /**
         * Calls GetMetrics.
         * @function getMetrics
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMetricsRequest} request GetMetricsRequest message or plain object
         * @param {pond.PondService.GetMetricsCallback} callback Node-style callback called with the error, if any, and GetMetricsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMetrics = function getMetrics(request, callback) {
            return this.rpcCall(getMetrics, $root.pond.GetMetricsRequest, $root.pond.GetMetricsResponse, request, callback);
        }, "name", { value: "GetMetrics" });

        /**
         * Calls GetMetrics.
         * @function getMetrics
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMetricsRequest} request GetMetricsRequest message or plain object
         * @returns {Promise<pond.GetMetricsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addDevice}.
         * @memberof pond.PondService
         * @typedef AddDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddDeviceResponse} [response] AddDeviceResponse
         */

        /**
         * Calls AddDevice.
         * @function addDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddDeviceRequest} request AddDeviceRequest message or plain object
         * @param {pond.PondService.AddDeviceCallback} callback Node-style callback called with the error, if any, and AddDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addDevice = function addDevice(request, callback) {
            return this.rpcCall(addDevice, $root.pond.AddDeviceRequest, $root.pond.AddDeviceResponse, request, callback);
        }, "name", { value: "AddDevice" });

        /**
         * Calls AddDevice.
         * @function addDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddDeviceRequest} request AddDeviceRequest message or plain object
         * @returns {Promise<pond.AddDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateDevice}.
         * @memberof pond.PondService
         * @typedef UpdateDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateDeviceResponse} [response] UpdateDeviceResponse
         */

        /**
         * Calls UpdateDevice.
         * @function updateDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceRequest} request UpdateDeviceRequest message or plain object
         * @param {pond.PondService.UpdateDeviceCallback} callback Node-style callback called with the error, if any, and UpdateDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateDevice = function updateDevice(request, callback) {
            return this.rpcCall(updateDevice, $root.pond.UpdateDeviceRequest, $root.pond.UpdateDeviceResponse, request, callback);
        }, "name", { value: "UpdateDevice" });

        /**
         * Calls UpdateDevice.
         * @function updateDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceRequest} request UpdateDeviceRequest message or plain object
         * @returns {Promise<pond.UpdateDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeDevice}.
         * @memberof pond.PondService
         * @typedef RemoveDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveDeviceResponse} [response] RemoveDeviceResponse
         */

        /**
         * Calls RemoveDevice.
         * @function removeDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveDeviceRequest} request RemoveDeviceRequest message or plain object
         * @param {pond.PondService.RemoveDeviceCallback} callback Node-style callback called with the error, if any, and RemoveDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeDevice = function removeDevice(request, callback) {
            return this.rpcCall(removeDevice, $root.pond.RemoveDeviceRequest, $root.pond.RemoveDeviceResponse, request, callback);
        }, "name", { value: "RemoveDevice" });

        /**
         * Calls RemoveDevice.
         * @function removeDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveDeviceRequest} request RemoveDeviceRequest message or plain object
         * @returns {Promise<pond.RemoveDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateDeviceStatus}.
         * @memberof pond.PondService
         * @typedef UpdateDeviceStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateDeviceStatusResponse} [response] UpdateDeviceStatusResponse
         */

        /**
         * Calls UpdateDeviceStatus.
         * @function updateDeviceStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceStatusRequest} request UpdateDeviceStatusRequest message or plain object
         * @param {pond.PondService.UpdateDeviceStatusCallback} callback Node-style callback called with the error, if any, and UpdateDeviceStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateDeviceStatus = function updateDeviceStatus(request, callback) {
            return this.rpcCall(updateDeviceStatus, $root.pond.UpdateDeviceStatusRequest, $root.pond.UpdateDeviceStatusResponse, request, callback);
        }, "name", { value: "UpdateDeviceStatus" });

        /**
         * Calls UpdateDeviceStatus.
         * @function updateDeviceStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceStatusRequest} request UpdateDeviceStatusRequest message or plain object
         * @returns {Promise<pond.UpdateDeviceStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateDeviceLastActive}.
         * @memberof pond.PondService
         * @typedef UpdateDeviceLastActiveCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateDeviceLastActiveResponse} [response] UpdateDeviceLastActiveResponse
         */

        /**
         * Calls UpdateDeviceLastActive.
         * @function updateDeviceLastActive
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceLastActiveRequest} request UpdateDeviceLastActiveRequest message or plain object
         * @param {pond.PondService.UpdateDeviceLastActiveCallback} callback Node-style callback called with the error, if any, and UpdateDeviceLastActiveResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateDeviceLastActive = function updateDeviceLastActive(request, callback) {
            return this.rpcCall(updateDeviceLastActive, $root.pond.UpdateDeviceLastActiveRequest, $root.pond.UpdateDeviceLastActiveResponse, request, callback);
        }, "name", { value: "UpdateDeviceLastActive" });

        /**
         * Calls UpdateDeviceLastActive.
         * @function updateDeviceLastActive
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceLastActiveRequest} request UpdateDeviceLastActiveRequest message or plain object
         * @returns {Promise<pond.UpdateDeviceLastActiveResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDeviceKey}.
         * @memberof pond.PondService
         * @typedef GetDeviceKeyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDeviceKeyResponse} [response] GetDeviceKeyResponse
         */

        /**
         * Calls GetDeviceKey.
         * @function getDeviceKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceKeyRequest} request GetDeviceKeyRequest message or plain object
         * @param {pond.PondService.GetDeviceKeyCallback} callback Node-style callback called with the error, if any, and GetDeviceKeyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDeviceKey = function getDeviceKey(request, callback) {
            return this.rpcCall(getDeviceKey, $root.pond.GetDeviceKeyRequest, $root.pond.GetDeviceKeyResponse, request, callback);
        }, "name", { value: "GetDeviceKey" });

        /**
         * Calls GetDeviceKey.
         * @function getDeviceKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceKeyRequest} request GetDeviceKeyRequest message or plain object
         * @returns {Promise<pond.GetDeviceKeyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#syncDevice}.
         * @memberof pond.PondService
         * @typedef SyncDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SyncDeviceResponse} [response] SyncDeviceResponse
         */

        /**
         * Calls SyncDevice.
         * @function syncDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.SyncDeviceRequest} request SyncDeviceRequest message or plain object
         * @param {pond.PondService.SyncDeviceCallback} callback Node-style callback called with the error, if any, and SyncDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.syncDevice = function syncDevice(request, callback) {
            return this.rpcCall(syncDevice, $root.pond.SyncDeviceRequest, $root.pond.SyncDeviceResponse, request, callback);
        }, "name", { value: "SyncDevice" });

        /**
         * Calls SyncDevice.
         * @function syncDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.SyncDeviceRequest} request SyncDeviceRequest message or plain object
         * @returns {Promise<pond.SyncDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#pushDevice}.
         * @memberof pond.PondService
         * @typedef PushDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.PushDeviceResponse} [response] PushDeviceResponse
         */

        /**
         * Calls PushDevice.
         * @function pushDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.PushDeviceRequest} request PushDeviceRequest message or plain object
         * @param {pond.PondService.PushDeviceCallback} callback Node-style callback called with the error, if any, and PushDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.pushDevice = function pushDevice(request, callback) {
            return this.rpcCall(pushDevice, $root.pond.PushDeviceRequest, $root.pond.PushDeviceResponse, request, callback);
        }, "name", { value: "PushDevice" });

        /**
         * Calls PushDevice.
         * @function pushDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.PushDeviceRequest} request PushDeviceRequest message or plain object
         * @returns {Promise<pond.PushDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#loadBackpack}.
         * @memberof pond.PondService
         * @typedef LoadBackpackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.LoadBackpackResponse} [response] LoadBackpackResponse
         */

        /**
         * Calls LoadBackpack.
         * @function loadBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.LoadBackpackRequest} request LoadBackpackRequest message or plain object
         * @param {pond.PondService.LoadBackpackCallback} callback Node-style callback called with the error, if any, and LoadBackpackResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.loadBackpack = function loadBackpack(request, callback) {
            return this.rpcCall(loadBackpack, $root.pond.LoadBackpackRequest, $root.pond.LoadBackpackResponse, request, callback);
        }, "name", { value: "LoadBackpack" });

        /**
         * Calls LoadBackpack.
         * @function loadBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.LoadBackpackRequest} request LoadBackpackRequest message or plain object
         * @returns {Promise<pond.LoadBackpackResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#clearDevice}.
         * @memberof pond.PondService
         * @typedef ClearDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ClearDeviceResponse} [response] ClearDeviceResponse
         */

        /**
         * Calls ClearDevice.
         * @function clearDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearDeviceRequest} request ClearDeviceRequest message or plain object
         * @param {pond.PondService.ClearDeviceCallback} callback Node-style callback called with the error, if any, and ClearDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.clearDevice = function clearDevice(request, callback) {
            return this.rpcCall(clearDevice, $root.pond.ClearDeviceRequest, $root.pond.ClearDeviceResponse, request, callback);
        }, "name", { value: "ClearDevice" });

        /**
         * Calls ClearDevice.
         * @function clearDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearDeviceRequest} request ClearDeviceRequest message or plain object
         * @returns {Promise<pond.ClearDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#pauseDevice}.
         * @memberof pond.PondService
         * @typedef PauseDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.PauseDeviceResponse} [response] PauseDeviceResponse
         */

        /**
         * Calls PauseDevice.
         * @function pauseDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.PauseDeviceRequest} request PauseDeviceRequest message or plain object
         * @param {pond.PondService.PauseDeviceCallback} callback Node-style callback called with the error, if any, and PauseDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.pauseDevice = function pauseDevice(request, callback) {
            return this.rpcCall(pauseDevice, $root.pond.PauseDeviceRequest, $root.pond.PauseDeviceResponse, request, callback);
        }, "name", { value: "PauseDevice" });

        /**
         * Calls PauseDevice.
         * @function pauseDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.PauseDeviceRequest} request PauseDeviceRequest message or plain object
         * @returns {Promise<pond.PauseDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#resumeDevice}.
         * @memberof pond.PondService
         * @typedef ResumeDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ResumeDeviceResponse} [response] ResumeDeviceResponse
         */

        /**
         * Calls ResumeDevice.
         * @function resumeDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResumeDeviceRequest} request ResumeDeviceRequest message or plain object
         * @param {pond.PondService.ResumeDeviceCallback} callback Node-style callback called with the error, if any, and ResumeDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.resumeDevice = function resumeDevice(request, callback) {
            return this.rpcCall(resumeDevice, $root.pond.ResumeDeviceRequest, $root.pond.ResumeDeviceResponse, request, callback);
        }, "name", { value: "ResumeDevice" });

        /**
         * Calls ResumeDevice.
         * @function resumeDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResumeDeviceRequest} request ResumeDeviceRequest message or plain object
         * @returns {Promise<pond.ResumeDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#connectWifiDevice}.
         * @memberof pond.PondService
         * @typedef ConnectWifiDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ConnectWifiDeviceResponse} [response] ConnectWifiDeviceResponse
         */

        /**
         * Calls ConnectWifiDevice.
         * @function connectWifiDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ConnectWifiDeviceRequest} request ConnectWifiDeviceRequest message or plain object
         * @param {pond.PondService.ConnectWifiDeviceCallback} callback Node-style callback called with the error, if any, and ConnectWifiDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.connectWifiDevice = function connectWifiDevice(request, callback) {
            return this.rpcCall(connectWifiDevice, $root.pond.ConnectWifiDeviceRequest, $root.pond.ConnectWifiDeviceResponse, request, callback);
        }, "name", { value: "ConnectWifiDevice" });

        /**
         * Calls ConnectWifiDevice.
         * @function connectWifiDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.ConnectWifiDeviceRequest} request ConnectWifiDeviceRequest message or plain object
         * @returns {Promise<pond.ConnectWifiDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#isPaused}.
         * @memberof pond.PondService
         * @typedef IsPausedCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.IsPausedDeviceResponse} [response] IsPausedDeviceResponse
         */

        /**
         * Calls IsPaused.
         * @function isPaused
         * @memberof pond.PondService
         * @instance
         * @param {pond.IsPausedDeviceRequest} request IsPausedDeviceRequest message or plain object
         * @param {pond.PondService.IsPausedCallback} callback Node-style callback called with the error, if any, and IsPausedDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.isPaused = function isPaused(request, callback) {
            return this.rpcCall(isPaused, $root.pond.IsPausedDeviceRequest, $root.pond.IsPausedDeviceResponse, request, callback);
        }, "name", { value: "IsPaused" });

        /**
         * Calls IsPaused.
         * @function isPaused
         * @memberof pond.PondService
         * @instance
         * @param {pond.IsPausedDeviceRequest} request IsPausedDeviceRequest message or plain object
         * @returns {Promise<pond.IsPausedDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMonthlyDataCap}.
         * @memberof pond.PondService
         * @typedef GetMonthlyDataCapCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMonthlyDataCapDeviceResponse} [response] GetMonthlyDataCapDeviceResponse
         */

        /**
         * Calls GetMonthlyDataCap.
         * @function getMonthlyDataCap
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMonthlyDataCapDeviceRequest} request GetMonthlyDataCapDeviceRequest message or plain object
         * @param {pond.PondService.GetMonthlyDataCapCallback} callback Node-style callback called with the error, if any, and GetMonthlyDataCapDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMonthlyDataCap = function getMonthlyDataCap(request, callback) {
            return this.rpcCall(getMonthlyDataCap, $root.pond.GetMonthlyDataCapDeviceRequest, $root.pond.GetMonthlyDataCapDeviceResponse, request, callback);
        }, "name", { value: "GetMonthlyDataCap" });

        /**
         * Calls GetMonthlyDataCap.
         * @function getMonthlyDataCap
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMonthlyDataCapDeviceRequest} request GetMonthlyDataCapDeviceRequest message or plain object
         * @returns {Promise<pond.GetMonthlyDataCapDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#setMonthlyDataCap}.
         * @memberof pond.PondService
         * @typedef SetMonthlyDataCapCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SetMonthlyDataCapDeviceResponse} [response] SetMonthlyDataCapDeviceResponse
         */

        /**
         * Calls SetMonthlyDataCap.
         * @function setMonthlyDataCap
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetMonthlyDataCapDeviceRequest} request SetMonthlyDataCapDeviceRequest message or plain object
         * @param {pond.PondService.SetMonthlyDataCapCallback} callback Node-style callback called with the error, if any, and SetMonthlyDataCapDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.setMonthlyDataCap = function setMonthlyDataCap(request, callback) {
            return this.rpcCall(setMonthlyDataCap, $root.pond.SetMonthlyDataCapDeviceRequest, $root.pond.SetMonthlyDataCapDeviceResponse, request, callback);
        }, "name", { value: "SetMonthlyDataCap" });

        /**
         * Calls SetMonthlyDataCap.
         * @function setMonthlyDataCap
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetMonthlyDataCapDeviceRequest} request SetMonthlyDataCapDeviceRequest message or plain object
         * @returns {Promise<pond.SetMonthlyDataCapDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#isMonthlyDatacapHit}.
         * @memberof pond.PondService
         * @typedef IsMonthlyDatacapHitCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.IsOverlimitDeviceResponse} [response] IsOverlimitDeviceResponse
         */

        /**
         * Calls IsMonthlyDatacapHit.
         * @function isMonthlyDatacapHit
         * @memberof pond.PondService
         * @instance
         * @param {pond.IsOverlimitDeviceRequest} request IsOverlimitDeviceRequest message or plain object
         * @param {pond.PondService.IsMonthlyDatacapHitCallback} callback Node-style callback called with the error, if any, and IsOverlimitDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.isMonthlyDatacapHit = function isMonthlyDatacapHit(request, callback) {
            return this.rpcCall(isMonthlyDatacapHit, $root.pond.IsOverlimitDeviceRequest, $root.pond.IsOverlimitDeviceResponse, request, callback);
        }, "name", { value: "IsMonthlyDatacapHit" });

        /**
         * Calls IsMonthlyDatacapHit.
         * @function isMonthlyDatacapHit
         * @memberof pond.PondService
         * @instance
         * @param {pond.IsOverlimitDeviceRequest} request IsOverlimitDeviceRequest message or plain object
         * @returns {Promise<pond.IsOverlimitDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDeviceCount}.
         * @memberof pond.PondService
         * @typedef GetDeviceCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDeviceCountResponse} [response] GetDeviceCountResponse
         */

        /**
         * Calls GetDeviceCount.
         * @function getDeviceCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceCountRequest} request GetDeviceCountRequest message or plain object
         * @param {pond.PondService.GetDeviceCountCallback} callback Node-style callback called with the error, if any, and GetDeviceCountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDeviceCount = function getDeviceCount(request, callback) {
            return this.rpcCall(getDeviceCount, $root.pond.GetDeviceCountRequest, $root.pond.GetDeviceCountResponse, request, callback);
        }, "name", { value: "GetDeviceCount" });

        /**
         * Calls GetDeviceCount.
         * @function getDeviceCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceCountRequest} request GetDeviceCountRequest message or plain object
         * @returns {Promise<pond.GetDeviceCountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#setDeviceCount}.
         * @memberof pond.PondService
         * @typedef SetDeviceCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SetDeviceCountResponse} [response] SetDeviceCountResponse
         */

        /**
         * Calls SetDeviceCount.
         * @function setDeviceCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetDeviceCountRequest} request SetDeviceCountRequest message or plain object
         * @param {pond.PondService.SetDeviceCountCallback} callback Node-style callback called with the error, if any, and SetDeviceCountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.setDeviceCount = function setDeviceCount(request, callback) {
            return this.rpcCall(setDeviceCount, $root.pond.SetDeviceCountRequest, $root.pond.SetDeviceCountResponse, request, callback);
        }, "name", { value: "SetDeviceCount" });

        /**
         * Calls SetDeviceCount.
         * @function setDeviceCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetDeviceCountRequest} request SetDeviceCountRequest message or plain object
         * @returns {Promise<pond.SetDeviceCountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDeviceArklesVersion}.
         * @memberof pond.PondService
         * @typedef GetDeviceArklesVersionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDeviceArklesVersionResponse} [response] GetDeviceArklesVersionResponse
         */

        /**
         * Calls GetDeviceArklesVersion.
         * @function getDeviceArklesVersion
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceArklesVersionRequest} request GetDeviceArklesVersionRequest message or plain object
         * @param {pond.PondService.GetDeviceArklesVersionCallback} callback Node-style callback called with the error, if any, and GetDeviceArklesVersionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDeviceArklesVersion = function getDeviceArklesVersion(request, callback) {
            return this.rpcCall(getDeviceArklesVersion, $root.pond.GetDeviceArklesVersionRequest, $root.pond.GetDeviceArklesVersionResponse, request, callback);
        }, "name", { value: "GetDeviceArklesVersion" });

        /**
         * Calls GetDeviceArklesVersion.
         * @function getDeviceArklesVersion
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDeviceArklesVersionRequest} request GetDeviceArklesVersionRequest message or plain object
         * @returns {Promise<pond.GetDeviceArklesVersionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#setDeviceArklesVersion}.
         * @memberof pond.PondService
         * @typedef SetDeviceArklesVersionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SetDeviceArklesVersionResponse} [response] SetDeviceArklesVersionResponse
         */

        /**
         * Calls SetDeviceArklesVersion.
         * @function setDeviceArklesVersion
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetDeviceArklesVersionRequest} request SetDeviceArklesVersionRequest message or plain object
         * @param {pond.PondService.SetDeviceArklesVersionCallback} callback Node-style callback called with the error, if any, and SetDeviceArklesVersionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.setDeviceArklesVersion = function setDeviceArklesVersion(request, callback) {
            return this.rpcCall(setDeviceArklesVersion, $root.pond.SetDeviceArklesVersionRequest, $root.pond.SetDeviceArklesVersionResponse, request, callback);
        }, "name", { value: "SetDeviceArklesVersion" });

        /**
         * Calls SetDeviceArklesVersion.
         * @function setDeviceArklesVersion
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetDeviceArklesVersionRequest} request SetDeviceArklesVersionRequest message or plain object
         * @returns {Promise<pond.SetDeviceArklesVersionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#cancelDeviceUpgrade}.
         * @memberof pond.PondService
         * @typedef CancelDeviceUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.CancelDeviceUpgradeResponse} [response] CancelDeviceUpgradeResponse
         */

        /**
         * Calls CancelDeviceUpgrade.
         * @function cancelDeviceUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.CancelDeviceUpgradeRequest} request CancelDeviceUpgradeRequest message or plain object
         * @param {pond.PondService.CancelDeviceUpgradeCallback} callback Node-style callback called with the error, if any, and CancelDeviceUpgradeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.cancelDeviceUpgrade = function cancelDeviceUpgrade(request, callback) {
            return this.rpcCall(cancelDeviceUpgrade, $root.pond.CancelDeviceUpgradeRequest, $root.pond.CancelDeviceUpgradeResponse, request, callback);
        }, "name", { value: "CancelDeviceUpgrade" });

        /**
         * Calls CancelDeviceUpgrade.
         * @function cancelDeviceUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.CancelDeviceUpgradeRequest} request CancelDeviceUpgradeRequest message or plain object
         * @returns {Promise<pond.CancelDeviceUpgradeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#clearPending}.
         * @memberof pond.PondService
         * @typedef ClearPendingCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ClearPendingResponse} [response] ClearPendingResponse
         */

        /**
         * Calls ClearPending.
         * @function clearPending
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearPendingRequest} request ClearPendingRequest message or plain object
         * @param {pond.PondService.ClearPendingCallback} callback Node-style callback called with the error, if any, and ClearPendingResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.clearPending = function clearPending(request, callback) {
            return this.rpcCall(clearPending, $root.pond.ClearPendingRequest, $root.pond.ClearPendingResponse, request, callback);
        }, "name", { value: "ClearPending" });

        /**
         * Calls ClearPending.
         * @function clearPending
         * @memberof pond.PondService
         * @instance
         * @param {pond.ClearPendingRequest} request ClearPendingRequest message or plain object
         * @returns {Promise<pond.ClearPendingResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#resetQuackCount}.
         * @memberof pond.PondService
         * @typedef ResetQuackCountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ResetQuackCountResponse} [response] ResetQuackCountResponse
         */

        /**
         * Calls ResetQuackCount.
         * @function resetQuackCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResetQuackCountRequest} request ResetQuackCountRequest message or plain object
         * @param {pond.PondService.ResetQuackCountCallback} callback Node-style callback called with the error, if any, and ResetQuackCountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.resetQuackCount = function resetQuackCount(request, callback) {
            return this.rpcCall(resetQuackCount, $root.pond.ResetQuackCountRequest, $root.pond.ResetQuackCountResponse, request, callback);
        }, "name", { value: "ResetQuackCount" });

        /**
         * Calls ResetQuackCount.
         * @function resetQuackCount
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResetQuackCountRequest} request ResetQuackCountRequest message or plain object
         * @returns {Promise<pond.ResetQuackCountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#resetQuackCountTx}.
         * @memberof pond.PondService
         * @typedef ResetQuackCountTxCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ResetQuackCountResponseTx} [response] ResetQuackCountResponseTx
         */

        /**
         * Calls ResetQuackCountTx.
         * @function resetQuackCountTx
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResetQuackCountRequestTx} request ResetQuackCountRequestTx message or plain object
         * @param {pond.PondService.ResetQuackCountTxCallback} callback Node-style callback called with the error, if any, and ResetQuackCountResponseTx
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.resetQuackCountTx = function resetQuackCountTx(request, callback) {
            return this.rpcCall(resetQuackCountTx, $root.pond.ResetQuackCountRequestTx, $root.pond.ResetQuackCountResponseTx, request, callback);
        }, "name", { value: "ResetQuackCountTx" });

        /**
         * Calls ResetQuackCountTx.
         * @function resetQuackCountTx
         * @memberof pond.PondService
         * @instance
         * @param {pond.ResetQuackCountRequestTx} request ResetQuackCountRequestTx message or plain object
         * @returns {Promise<pond.ResetQuackCountResponseTx>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#bulkPauseDevice}.
         * @memberof pond.PondService
         * @typedef BulkPauseDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.BulkPauseDeviceResponse} [response] BulkPauseDeviceResponse
         */

        /**
         * Calls BulkPauseDevice.
         * @function bulkPauseDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkPauseDeviceRequest} request BulkPauseDeviceRequest message or plain object
         * @param {pond.PondService.BulkPauseDeviceCallback} callback Node-style callback called with the error, if any, and BulkPauseDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.bulkPauseDevice = function bulkPauseDevice(request, callback) {
            return this.rpcCall(bulkPauseDevice, $root.pond.BulkPauseDeviceRequest, $root.pond.BulkPauseDeviceResponse, request, callback);
        }, "name", { value: "BulkPauseDevice" });

        /**
         * Calls BulkPauseDevice.
         * @function bulkPauseDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkPauseDeviceRequest} request BulkPauseDeviceRequest message or plain object
         * @returns {Promise<pond.BulkPauseDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#bulkChangeDataCaps}.
         * @memberof pond.PondService
         * @typedef BulkChangeDataCapsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.BulkChangeDataCapsResponse} [response] BulkChangeDataCapsResponse
         */

        /**
         * Calls BulkChangeDataCaps.
         * @function bulkChangeDataCaps
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkChangeDataCapsRequest} request BulkChangeDataCapsRequest message or plain object
         * @param {pond.PondService.BulkChangeDataCapsCallback} callback Node-style callback called with the error, if any, and BulkChangeDataCapsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.bulkChangeDataCaps = function bulkChangeDataCaps(request, callback) {
            return this.rpcCall(bulkChangeDataCaps, $root.pond.BulkChangeDataCapsRequest, $root.pond.BulkChangeDataCapsResponse, request, callback);
        }, "name", { value: "BulkChangeDataCaps" });

        /**
         * Calls BulkChangeDataCaps.
         * @function bulkChangeDataCaps
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkChangeDataCapsRequest} request BulkChangeDataCapsRequest message or plain object
         * @returns {Promise<pond.BulkChangeDataCapsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateDeviceComponentPreferences}.
         * @memberof pond.PondService
         * @typedef UpdateDeviceComponentPreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateDeviceComponentPreferencesResponse} [response] UpdateDeviceComponentPreferencesResponse
         */

        /**
         * Calls UpdateDeviceComponentPreferences.
         * @function updateDeviceComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceComponentPreferencesRequest} request UpdateDeviceComponentPreferencesRequest message or plain object
         * @param {pond.PondService.UpdateDeviceComponentPreferencesCallback} callback Node-style callback called with the error, if any, and UpdateDeviceComponentPreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateDeviceComponentPreferences = function updateDeviceComponentPreferences(request, callback) {
            return this.rpcCall(updateDeviceComponentPreferences, $root.pond.UpdateDeviceComponentPreferencesRequest, $root.pond.UpdateDeviceComponentPreferencesResponse, request, callback);
        }, "name", { value: "UpdateDeviceComponentPreferences" });

        /**
         * Calls UpdateDeviceComponentPreferences.
         * @function updateDeviceComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDeviceComponentPreferencesRequest} request UpdateDeviceComponentPreferencesRequest message or plain object
         * @returns {Promise<pond.UpdateDeviceComponentPreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDeviceComponentPreferences}.
         * @memberof pond.PondService
         * @typedef ListDeviceComponentPreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDeviceComponentPreferencesResponse} [response] ListDeviceComponentPreferencesResponse
         */

        /**
         * Calls ListDeviceComponentPreferences.
         * @function listDeviceComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceComponentPreferencesRequest} request ListDeviceComponentPreferencesRequest message or plain object
         * @param {pond.PondService.ListDeviceComponentPreferencesCallback} callback Node-style callback called with the error, if any, and ListDeviceComponentPreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDeviceComponentPreferences = function listDeviceComponentPreferences(request, callback) {
            return this.rpcCall(listDeviceComponentPreferences, $root.pond.ListDeviceComponentPreferencesRequest, $root.pond.ListDeviceComponentPreferencesResponse, request, callback);
        }, "name", { value: "ListDeviceComponentPreferences" });

        /**
         * Calls ListDeviceComponentPreferences.
         * @function listDeviceComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceComponentPreferencesRequest} request ListDeviceComponentPreferencesRequest message or plain object
         * @returns {Promise<pond.ListDeviceComponentPreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#deviceLinearMutation}.
         * @memberof pond.PondService
         * @typedef DeviceLinearMutationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.DeviceLinearMutationResponse} [response] DeviceLinearMutationResponse
         */

        /**
         * Calls DeviceLinearMutation.
         * @function deviceLinearMutation
         * @memberof pond.PondService
         * @instance
         * @param {pond.DeviceLinearMutationRequest} request DeviceLinearMutationRequest message or plain object
         * @param {pond.PondService.DeviceLinearMutationCallback} callback Node-style callback called with the error, if any, and DeviceLinearMutationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.deviceLinearMutation = function deviceLinearMutation(request, callback) {
            return this.rpcCall(deviceLinearMutation, $root.pond.DeviceLinearMutationRequest, $root.pond.DeviceLinearMutationResponse, request, callback);
        }, "name", { value: "DeviceLinearMutation" });

        /**
         * Calls DeviceLinearMutation.
         * @function deviceLinearMutation
         * @memberof pond.PondService
         * @instance
         * @param {pond.DeviceLinearMutationRequest} request DeviceLinearMutationRequest message or plain object
         * @returns {Promise<pond.DeviceLinearMutationResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getComponent}.
         * @memberof pond.PondService
         * @typedef GetComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Component} [response] Component
         */

        /**
         * Calls GetComponent.
         * @function getComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetComponentRequest} request GetComponentRequest message or plain object
         * @param {pond.PondService.GetComponentCallback} callback Node-style callback called with the error, if any, and Component
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getComponent = function getComponent(request, callback) {
            return this.rpcCall(getComponent, $root.pond.GetComponentRequest, $root.pond.Component, request, callback);
        }, "name", { value: "GetComponent" });

        /**
         * Calls GetComponent.
         * @function getComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetComponentRequest} request GetComponentRequest message or plain object
         * @returns {Promise<pond.Component>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listComponents}.
         * @memberof pond.PondService
         * @typedef ListComponentsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListComponentsResponse} [response] ListComponentsResponse
         */

        /**
         * Calls ListComponents.
         * @function listComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListComponentsRequest} request ListComponentsRequest message or plain object
         * @param {pond.PondService.ListComponentsCallback} callback Node-style callback called with the error, if any, and ListComponentsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listComponents = function listComponents(request, callback) {
            return this.rpcCall(listComponents, $root.pond.ListComponentsRequest, $root.pond.ListComponentsResponse, request, callback);
        }, "name", { value: "ListComponents" });

        /**
         * Calls ListComponents.
         * @function listComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListComponentsRequest} request ListComponentsRequest message or plain object
         * @returns {Promise<pond.ListComponentsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addComponent}.
         * @memberof pond.PondService
         * @typedef AddComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddComponentResponse} [response] AddComponentResponse
         */

        /**
         * Calls AddComponent.
         * @function addComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddComponentRequest} request AddComponentRequest message or plain object
         * @param {pond.PondService.AddComponentCallback} callback Node-style callback called with the error, if any, and AddComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addComponent = function addComponent(request, callback) {
            return this.rpcCall(addComponent, $root.pond.AddComponentRequest, $root.pond.AddComponentResponse, request, callback);
        }, "name", { value: "AddComponent" });

        /**
         * Calls AddComponent.
         * @function addComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddComponentRequest} request AddComponentRequest message or plain object
         * @returns {Promise<pond.AddComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addMultiComponents}.
         * @memberof pond.PondService
         * @typedef AddMultiComponentsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddMultiComponentsResponse} [response] AddMultiComponentsResponse
         */

        /**
         * Calls AddMultiComponents.
         * @function addMultiComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMultiComponentsRequest} request AddMultiComponentsRequest message or plain object
         * @param {pond.PondService.AddMultiComponentsCallback} callback Node-style callback called with the error, if any, and AddMultiComponentsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addMultiComponents = function addMultiComponents(request, callback) {
            return this.rpcCall(addMultiComponents, $root.pond.AddMultiComponentsRequest, $root.pond.AddMultiComponentsResponse, request, callback);
        }, "name", { value: "AddMultiComponents" });

        /**
         * Calls AddMultiComponents.
         * @function addMultiComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMultiComponentsRequest} request AddMultiComponentsRequest message or plain object
         * @returns {Promise<pond.AddMultiComponentsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateComponent}.
         * @memberof pond.PondService
         * @typedef UpdateComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateComponentResponse} [response] UpdateComponentResponse
         */

        /**
         * Calls UpdateComponent.
         * @function updateComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateComponentRequest} request UpdateComponentRequest message or plain object
         * @param {pond.PondService.UpdateComponentCallback} callback Node-style callback called with the error, if any, and UpdateComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateComponent = function updateComponent(request, callback) {
            return this.rpcCall(updateComponent, $root.pond.UpdateComponentRequest, $root.pond.UpdateComponentResponse, request, callback);
        }, "name", { value: "UpdateComponent" });

        /**
         * Calls UpdateComponent.
         * @function updateComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateComponentRequest} request UpdateComponentRequest message or plain object
         * @returns {Promise<pond.UpdateComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeComponent}.
         * @memberof pond.PondService
         * @typedef RemoveComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveComponentResponse} [response] RemoveComponentResponse
         */

        /**
         * Calls RemoveComponent.
         * @function removeComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveComponentRequest} request RemoveComponentRequest message or plain object
         * @param {pond.PondService.RemoveComponentCallback} callback Node-style callback called with the error, if any, and RemoveComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeComponent = function removeComponent(request, callback) {
            return this.rpcCall(removeComponent, $root.pond.RemoveComponentRequest, $root.pond.RemoveComponentResponse, request, callback);
        }, "name", { value: "RemoveComponent" });

        /**
         * Calls RemoveComponent.
         * @function removeComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveComponentRequest} request RemoveComponentRequest message or plain object
         * @returns {Promise<pond.RemoveComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listComponentHistory}.
         * @memberof pond.PondService
         * @typedef ListComponentHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListComponentHistoryResponse} [response] ListComponentHistoryResponse
         */

        /**
         * Calls ListComponentHistory.
         * @function listComponentHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListComponentHistoryRequest} request ListComponentHistoryRequest message or plain object
         * @param {pond.PondService.ListComponentHistoryCallback} callback Node-style callback called with the error, if any, and ListComponentHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listComponentHistory = function listComponentHistory(request, callback) {
            return this.rpcCall(listComponentHistory, $root.pond.ListComponentHistoryRequest, $root.pond.ListComponentHistoryResponse, request, callback);
        }, "name", { value: "ListComponentHistory" });

        /**
         * Calls ListComponentHistory.
         * @function listComponentHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListComponentHistoryRequest} request ListComponentHistoryRequest message or plain object
         * @returns {Promise<pond.ListComponentHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getInteraction}.
         * @memberof pond.PondService
         * @typedef GetInteractionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Interaction} [response] Interaction
         */

        /**
         * Calls GetInteraction.
         * @function getInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetInteractionRequest} request GetInteractionRequest message or plain object
         * @param {pond.PondService.GetInteractionCallback} callback Node-style callback called with the error, if any, and Interaction
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getInteraction = function getInteraction(request, callback) {
            return this.rpcCall(getInteraction, $root.pond.GetInteractionRequest, $root.pond.Interaction, request, callback);
        }, "name", { value: "GetInteraction" });

        /**
         * Calls GetInteraction.
         * @function getInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetInteractionRequest} request GetInteractionRequest message or plain object
         * @returns {Promise<pond.Interaction>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listInteractions}.
         * @memberof pond.PondService
         * @typedef ListInteractionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListInteractionsResponse} [response] ListInteractionsResponse
         */

        /**
         * Calls ListInteractions.
         * @function listInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListInteractionsRequest} request ListInteractionsRequest message or plain object
         * @param {pond.PondService.ListInteractionsCallback} callback Node-style callback called with the error, if any, and ListInteractionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listInteractions = function listInteractions(request, callback) {
            return this.rpcCall(listInteractions, $root.pond.ListInteractionsRequest, $root.pond.ListInteractionsResponse, request, callback);
        }, "name", { value: "ListInteractions" });

        /**
         * Calls ListInteractions.
         * @function listInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListInteractionsRequest} request ListInteractionsRequest message or plain object
         * @returns {Promise<pond.ListInteractionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addInteraction}.
         * @memberof pond.PondService
         * @typedef AddInteractionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddInteractionResponse} [response] AddInteractionResponse
         */

        /**
         * Calls AddInteraction.
         * @function addInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddInteractionRequest} request AddInteractionRequest message or plain object
         * @param {pond.PondService.AddInteractionCallback} callback Node-style callback called with the error, if any, and AddInteractionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addInteraction = function addInteraction(request, callback) {
            return this.rpcCall(addInteraction, $root.pond.AddInteractionRequest, $root.pond.AddInteractionResponse, request, callback);
        }, "name", { value: "AddInteraction" });

        /**
         * Calls AddInteraction.
         * @function addInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddInteractionRequest} request AddInteractionRequest message or plain object
         * @returns {Promise<pond.AddInteractionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addMultiInteractions}.
         * @memberof pond.PondService
         * @typedef AddMultiInteractionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddMultiInteractionsResponse} [response] AddMultiInteractionsResponse
         */

        /**
         * Calls AddMultiInteractions.
         * @function addMultiInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMultiInteractionsRequest} request AddMultiInteractionsRequest message or plain object
         * @param {pond.PondService.AddMultiInteractionsCallback} callback Node-style callback called with the error, if any, and AddMultiInteractionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addMultiInteractions = function addMultiInteractions(request, callback) {
            return this.rpcCall(addMultiInteractions, $root.pond.AddMultiInteractionsRequest, $root.pond.AddMultiInteractionsResponse, request, callback);
        }, "name", { value: "AddMultiInteractions" });

        /**
         * Calls AddMultiInteractions.
         * @function addMultiInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMultiInteractionsRequest} request AddMultiInteractionsRequest message or plain object
         * @returns {Promise<pond.AddMultiInteractionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateInteraction}.
         * @memberof pond.PondService
         * @typedef UpdateInteractionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateInteractionResponse} [response] UpdateInteractionResponse
         */

        /**
         * Calls UpdateInteraction.
         * @function updateInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateInteractionRequest} request UpdateInteractionRequest message or plain object
         * @param {pond.PondService.UpdateInteractionCallback} callback Node-style callback called with the error, if any, and UpdateInteractionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateInteraction = function updateInteraction(request, callback) {
            return this.rpcCall(updateInteraction, $root.pond.UpdateInteractionRequest, $root.pond.UpdateInteractionResponse, request, callback);
        }, "name", { value: "UpdateInteraction" });

        /**
         * Calls UpdateInteraction.
         * @function updateInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateInteractionRequest} request UpdateInteractionRequest message or plain object
         * @returns {Promise<pond.UpdateInteractionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateInteractionPondSettings}.
         * @memberof pond.PondService
         * @typedef UpdateInteractionPondSettingsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateInteractionPondSettingsResponse} [response] UpdateInteractionPondSettingsResponse
         */

        /**
         * Calls UpdateInteractionPondSettings.
         * @function updateInteractionPondSettings
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateInteractionPondSettingsRequest} request UpdateInteractionPondSettingsRequest message or plain object
         * @param {pond.PondService.UpdateInteractionPondSettingsCallback} callback Node-style callback called with the error, if any, and UpdateInteractionPondSettingsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateInteractionPondSettings = function updateInteractionPondSettings(request, callback) {
            return this.rpcCall(updateInteractionPondSettings, $root.pond.UpdateInteractionPondSettingsRequest, $root.pond.UpdateInteractionPondSettingsResponse, request, callback);
        }, "name", { value: "UpdateInteractionPondSettings" });

        /**
         * Calls UpdateInteractionPondSettings.
         * @function updateInteractionPondSettings
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateInteractionPondSettingsRequest} request UpdateInteractionPondSettingsRequest message or plain object
         * @returns {Promise<pond.UpdateInteractionPondSettingsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeInteraction}.
         * @memberof pond.PondService
         * @typedef RemoveInteractionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveInteractionResponse} [response] RemoveInteractionResponse
         */

        /**
         * Calls RemoveInteraction.
         * @function removeInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveInteractionRequest} request RemoveInteractionRequest message or plain object
         * @param {pond.PondService.RemoveInteractionCallback} callback Node-style callback called with the error, if any, and RemoveInteractionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeInteraction = function removeInteraction(request, callback) {
            return this.rpcCall(removeInteraction, $root.pond.RemoveInteractionRequest, $root.pond.RemoveInteractionResponse, request, callback);
        }, "name", { value: "RemoveInteraction" });

        /**
         * Calls RemoveInteraction.
         * @function removeInteraction
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveInteractionRequest} request RemoveInteractionRequest message or plain object
         * @returns {Promise<pond.RemoveInteractionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#setAlertInteractions}.
         * @memberof pond.PondService
         * @typedef SetAlertInteractionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SetAlertInteractionsResponse} [response] SetAlertInteractionsResponse
         */

        /**
         * Calls SetAlertInteractions.
         * @function setAlertInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetAlertInteractionsRequest} request SetAlertInteractionsRequest message or plain object
         * @param {pond.PondService.SetAlertInteractionsCallback} callback Node-style callback called with the error, if any, and SetAlertInteractionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.setAlertInteractions = function setAlertInteractions(request, callback) {
            return this.rpcCall(setAlertInteractions, $root.pond.SetAlertInteractionsRequest, $root.pond.SetAlertInteractionsResponse, request, callback);
        }, "name", { value: "SetAlertInteractions" });

        /**
         * Calls SetAlertInteractions.
         * @function setAlertInteractions
         * @memberof pond.PondService
         * @instance
         * @param {pond.SetAlertInteractionsRequest} request SetAlertInteractionsRequest message or plain object
         * @returns {Promise<pond.SetAlertInteractionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getGroup}.
         * @memberof pond.PondService
         * @typedef GetGroupCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Group} [response] Group
         */

        /**
         * Calls GetGroup.
         * @function getGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGroupRequest} request GetGroupRequest message or plain object
         * @param {pond.PondService.GetGroupCallback} callback Node-style callback called with the error, if any, and Group
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getGroup = function getGroup(request, callback) {
            return this.rpcCall(getGroup, $root.pond.GetGroupRequest, $root.pond.Group, request, callback);
        }, "name", { value: "GetGroup" });

        /**
         * Calls GetGroup.
         * @function getGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGroupRequest} request GetGroupRequest message or plain object
         * @returns {Promise<pond.Group>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGroups}.
         * @memberof pond.PondService
         * @typedef ListGroupsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGroupsResponse} [response] ListGroupsResponse
         */

        /**
         * Calls ListGroups.
         * @function listGroups
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGroupsRequest} request ListGroupsRequest message or plain object
         * @param {pond.PondService.ListGroupsCallback} callback Node-style callback called with the error, if any, and ListGroupsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGroups = function listGroups(request, callback) {
            return this.rpcCall(listGroups, $root.pond.ListGroupsRequest, $root.pond.ListGroupsResponse, request, callback);
        }, "name", { value: "ListGroups" });

        /**
         * Calls ListGroups.
         * @function listGroups
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGroupsRequest} request ListGroupsRequest message or plain object
         * @returns {Promise<pond.ListGroupsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addGroup}.
         * @memberof pond.PondService
         * @typedef AddGroupCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddGroupResponse} [response] AddGroupResponse
         */

        /**
         * Calls AddGroup.
         * @function addGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGroupRequest} request AddGroupRequest message or plain object
         * @param {pond.PondService.AddGroupCallback} callback Node-style callback called with the error, if any, and AddGroupResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addGroup = function addGroup(request, callback) {
            return this.rpcCall(addGroup, $root.pond.AddGroupRequest, $root.pond.AddGroupResponse, request, callback);
        }, "name", { value: "AddGroup" });

        /**
         * Calls AddGroup.
         * @function addGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGroupRequest} request AddGroupRequest message or plain object
         * @returns {Promise<pond.AddGroupResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateGroup}.
         * @memberof pond.PondService
         * @typedef UpdateGroupCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateGroupResponse} [response] UpdateGroupResponse
         */

        /**
         * Calls UpdateGroup.
         * @function updateGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGroupRequest} request UpdateGroupRequest message or plain object
         * @param {pond.PondService.UpdateGroupCallback} callback Node-style callback called with the error, if any, and UpdateGroupResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateGroup = function updateGroup(request, callback) {
            return this.rpcCall(updateGroup, $root.pond.UpdateGroupRequest, $root.pond.UpdateGroupResponse, request, callback);
        }, "name", { value: "UpdateGroup" });

        /**
         * Calls UpdateGroup.
         * @function updateGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGroupRequest} request UpdateGroupRequest message or plain object
         * @returns {Promise<pond.UpdateGroupResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeGroup}.
         * @memberof pond.PondService
         * @typedef RemoveGroupCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveGroupResponse} [response] RemoveGroupResponse
         */

        /**
         * Calls RemoveGroup.
         * @function removeGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGroupRequest} request RemoveGroupRequest message or plain object
         * @param {pond.PondService.RemoveGroupCallback} callback Node-style callback called with the error, if any, and RemoveGroupResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeGroup = function removeGroup(request, callback) {
            return this.rpcCall(removeGroup, $root.pond.RemoveGroupRequest, $root.pond.RemoveGroupResponse, request, callback);
        }, "name", { value: "RemoveGroup" });

        /**
         * Calls RemoveGroup.
         * @function removeGroup
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGroupRequest} request RemoveGroupRequest message or plain object
         * @returns {Promise<pond.RemoveGroupResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addGroupDevice}.
         * @memberof pond.PondService
         * @typedef AddGroupDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddGroupDeviceResponse} [response] AddGroupDeviceResponse
         */

        /**
         * Calls AddGroupDevice.
         * @function addGroupDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGroupDeviceRequest} request AddGroupDeviceRequest message or plain object
         * @param {pond.PondService.AddGroupDeviceCallback} callback Node-style callback called with the error, if any, and AddGroupDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addGroupDevice = function addGroupDevice(request, callback) {
            return this.rpcCall(addGroupDevice, $root.pond.AddGroupDeviceRequest, $root.pond.AddGroupDeviceResponse, request, callback);
        }, "name", { value: "AddGroupDevice" });

        /**
         * Calls AddGroupDevice.
         * @function addGroupDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGroupDeviceRequest} request AddGroupDeviceRequest message or plain object
         * @returns {Promise<pond.AddGroupDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeGroupDevice}.
         * @memberof pond.PondService
         * @typedef RemoveGroupDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveGroupDeviceResponse} [response] RemoveGroupDeviceResponse
         */

        /**
         * Calls RemoveGroupDevice.
         * @function removeGroupDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGroupDeviceRequest} request RemoveGroupDeviceRequest message or plain object
         * @param {pond.PondService.RemoveGroupDeviceCallback} callback Node-style callback called with the error, if any, and RemoveGroupDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeGroupDevice = function removeGroupDevice(request, callback) {
            return this.rpcCall(removeGroupDevice, $root.pond.RemoveGroupDeviceRequest, $root.pond.RemoveGroupDeviceResponse, request, callback);
        }, "name", { value: "RemoveGroupDevice" });

        /**
         * Calls RemoveGroupDevice.
         * @function removeGroupDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGroupDeviceRequest} request RemoveGroupDeviceRequest message or plain object
         * @returns {Promise<pond.RemoveGroupDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addMine}.
         * @memberof pond.PondService
         * @typedef AddMineCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddMineResponse} [response] AddMineResponse
         */

        /**
         * Calls AddMine.
         * @function addMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMineRequest} request AddMineRequest message or plain object
         * @param {pond.PondService.AddMineCallback} callback Node-style callback called with the error, if any, and AddMineResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addMine = function addMine(request, callback) {
            return this.rpcCall(addMine, $root.pond.AddMineRequest, $root.pond.AddMineResponse, request, callback);
        }, "name", { value: "AddMine" });

        /**
         * Calls AddMine.
         * @function addMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddMineRequest} request AddMineRequest message or plain object
         * @returns {Promise<pond.AddMineResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMine}.
         * @memberof pond.PondService
         * @typedef GetMineCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMineResponse} [response] GetMineResponse
         */

        /**
         * Calls GetMine.
         * @function getMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMineRequest} request GetMineRequest message or plain object
         * @param {pond.PondService.GetMineCallback} callback Node-style callback called with the error, if any, and GetMineResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMine = function getMine(request, callback) {
            return this.rpcCall(getMine, $root.pond.GetMineRequest, $root.pond.GetMineResponse, request, callback);
        }, "name", { value: "GetMine" });

        /**
         * Calls GetMine.
         * @function getMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMineRequest} request GetMineRequest message or plain object
         * @returns {Promise<pond.GetMineResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateMine}.
         * @memberof pond.PondService
         * @typedef UpdateMineCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateMineResponse} [response] UpdateMineResponse
         */

        /**
         * Calls UpdateMine.
         * @function updateMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateMineRequest} request UpdateMineRequest message or plain object
         * @param {pond.PondService.UpdateMineCallback} callback Node-style callback called with the error, if any, and UpdateMineResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateMine = function updateMine(request, callback) {
            return this.rpcCall(updateMine, $root.pond.UpdateMineRequest, $root.pond.UpdateMineResponse, request, callback);
        }, "name", { value: "UpdateMine" });

        /**
         * Calls UpdateMine.
         * @function updateMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateMineRequest} request UpdateMineRequest message or plain object
         * @returns {Promise<pond.UpdateMineResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeMine}.
         * @memberof pond.PondService
         * @typedef RemoveMineCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveMineResponse} [response] RemoveMineResponse
         */

        /**
         * Calls RemoveMine.
         * @function removeMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveMineRequest} request RemoveMineRequest message or plain object
         * @param {pond.PondService.RemoveMineCallback} callback Node-style callback called with the error, if any, and RemoveMineResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeMine = function removeMine(request, callback) {
            return this.rpcCall(removeMine, $root.pond.RemoveMineRequest, $root.pond.RemoveMineResponse, request, callback);
        }, "name", { value: "RemoveMine" });

        /**
         * Calls RemoveMine.
         * @function removeMine
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveMineRequest} request RemoveMineRequest message or plain object
         * @returns {Promise<pond.RemoveMineResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listMines}.
         * @memberof pond.PondService
         * @typedef ListMinesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListMinesResponse} [response] ListMinesResponse
         */

        /**
         * Calls ListMines.
         * @function listMines
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMinesRequest} request ListMinesRequest message or plain object
         * @param {pond.PondService.ListMinesCallback} callback Node-style callback called with the error, if any, and ListMinesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listMines = function listMines(request, callback) {
            return this.rpcCall(listMines, $root.pond.ListMinesRequest, $root.pond.ListMinesResponse, request, callback);
        }, "name", { value: "ListMines" });

        /**
         * Calls ListMines.
         * @function listMines
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMinesRequest} request ListMinesRequest message or plain object
         * @returns {Promise<pond.ListMinesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listMinesSimple}.
         * @memberof pond.PondService
         * @typedef ListMinesSimpleCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListMinesSimpleResponse} [response] ListMinesSimpleResponse
         */

        /**
         * Calls ListMinesSimple.
         * @function listMinesSimple
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMinesSimpleRequest} request ListMinesSimpleRequest message or plain object
         * @param {pond.PondService.ListMinesSimpleCallback} callback Node-style callback called with the error, if any, and ListMinesSimpleResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listMinesSimple = function listMinesSimple(request, callback) {
            return this.rpcCall(listMinesSimple, $root.pond.ListMinesSimpleRequest, $root.pond.ListMinesSimpleResponse, request, callback);
        }, "name", { value: "ListMinesSimple" });

        /**
         * Calls ListMinesSimple.
         * @function listMinesSimple
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMinesSimpleRequest} request ListMinesSimpleRequest message or plain object
         * @returns {Promise<pond.ListMinesSimpleResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#giveDevice}.
         * @memberof pond.PondService
         * @typedef GiveDeviceCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GiveMineDeviceResponse} [response] GiveMineDeviceResponse
         */

        /**
         * Calls GiveDevice.
         * @function giveDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GiveMineDeviceRequest} request GiveMineDeviceRequest message or plain object
         * @param {pond.PondService.GiveDeviceCallback} callback Node-style callback called with the error, if any, and GiveMineDeviceResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.giveDevice = function giveDevice(request, callback) {
            return this.rpcCall(giveDevice, $root.pond.GiveMineDeviceRequest, $root.pond.GiveMineDeviceResponse, request, callback);
        }, "name", { value: "GiveDevice" });

        /**
         * Calls GiveDevice.
         * @function giveDevice
         * @memberof pond.PondService
         * @instance
         * @param {pond.GiveMineDeviceRequest} request GiveMineDeviceRequest message or plain object
         * @returns {Promise<pond.GiveMineDeviceResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#giveComponent}.
         * @memberof pond.PondService
         * @typedef GiveComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GiveMineComponentResponse} [response] GiveMineComponentResponse
         */

        /**
         * Calls GiveComponent.
         * @function giveComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.GiveMineComponentRequest} request GiveMineComponentRequest message or plain object
         * @param {pond.PondService.GiveComponentCallback} callback Node-style callback called with the error, if any, and GiveMineComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.giveComponent = function giveComponent(request, callback) {
            return this.rpcCall(giveComponent, $root.pond.GiveMineComponentRequest, $root.pond.GiveMineComponentResponse, request, callback);
        }, "name", { value: "GiveComponent" });

        /**
         * Calls GiveComponent.
         * @function giveComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.GiveMineComponentRequest} request GiveMineComponentRequest message or plain object
         * @returns {Promise<pond.GiveMineComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getBin}.
         * @memberof pond.PondService
         * @typedef GetBinCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Bin} [response] Bin
         */

        /**
         * Calls GetBin.
         * @function getBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinRequest} request GetBinRequest message or plain object
         * @param {pond.PondService.GetBinCallback} callback Node-style callback called with the error, if any, and Bin
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getBin = function getBin(request, callback) {
            return this.rpcCall(getBin, $root.pond.GetBinRequest, $root.pond.Bin, request, callback);
        }, "name", { value: "GetBin" });

        /**
         * Calls GetBin.
         * @function getBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinRequest} request GetBinRequest message or plain object
         * @returns {Promise<pond.Bin>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBins}.
         * @memberof pond.PondService
         * @typedef ListBinsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinsResponse} [response] ListBinsResponse
         */

        /**
         * Calls ListBins.
         * @function listBins
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinsRequest} request ListBinsRequest message or plain object
         * @param {pond.PondService.ListBinsCallback} callback Node-style callback called with the error, if any, and ListBinsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBins = function listBins(request, callback) {
            return this.rpcCall(listBins, $root.pond.ListBinsRequest, $root.pond.ListBinsResponse, request, callback);
        }, "name", { value: "ListBins" });

        /**
         * Calls ListBins.
         * @function listBins
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinsRequest} request ListBinsRequest message or plain object
         * @returns {Promise<pond.ListBinsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinStatus}.
         * @memberof pond.PondService
         * @typedef ListBinStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinStatusResponse} [response] ListBinStatusResponse
         */

        /**
         * Calls ListBinStatus.
         * @function listBinStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinStatusRequest} request ListBinStatusRequest message or plain object
         * @param {pond.PondService.ListBinStatusCallback} callback Node-style callback called with the error, if any, and ListBinStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinStatus = function listBinStatus(request, callback) {
            return this.rpcCall(listBinStatus, $root.pond.ListBinStatusRequest, $root.pond.ListBinStatusResponse, request, callback);
        }, "name", { value: "ListBinStatus" });

        /**
         * Calls ListBinStatus.
         * @function listBinStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinStatusRequest} request ListBinStatusRequest message or plain object
         * @returns {Promise<pond.ListBinStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinComponents}.
         * @memberof pond.PondService
         * @typedef ListBinComponentsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinComponentsResponse} [response] ListBinComponentsResponse
         */

        /**
         * Calls ListBinComponents.
         * @function listBinComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentsRequest} request ListBinComponentsRequest message or plain object
         * @param {pond.PondService.ListBinComponentsCallback} callback Node-style callback called with the error, if any, and ListBinComponentsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinComponents = function listBinComponents(request, callback) {
            return this.rpcCall(listBinComponents, $root.pond.ListBinComponentsRequest, $root.pond.ListBinComponentsResponse, request, callback);
        }, "name", { value: "ListBinComponents" });

        /**
         * Calls ListBinComponents.
         * @function listBinComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentsRequest} request ListBinComponentsRequest message or plain object
         * @returns {Promise<pond.ListBinComponentsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinHistory}.
         * @memberof pond.PondService
         * @typedef ListBinHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinHistoryResponse} [response] ListBinHistoryResponse
         */

        /**
         * Calls ListBinHistory.
         * @function listBinHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinHistoryRequest} request ListBinHistoryRequest message or plain object
         * @param {pond.PondService.ListBinHistoryCallback} callback Node-style callback called with the error, if any, and ListBinHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinHistory = function listBinHistory(request, callback) {
            return this.rpcCall(listBinHistory, $root.pond.ListBinHistoryRequest, $root.pond.ListBinHistoryResponse, request, callback);
        }, "name", { value: "ListBinHistory" });

        /**
         * Calls ListBinHistory.
         * @function listBinHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinHistoryRequest} request ListBinHistoryRequest message or plain object
         * @returns {Promise<pond.ListBinHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinHistoryBetween}.
         * @memberof pond.PondService
         * @typedef ListBinHistoryBetweenCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinHistoryBetweenResponse} [response] ListBinHistoryBetweenResponse
         */

        /**
         * Calls ListBinHistoryBetween.
         * @function listBinHistoryBetween
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinHistoryBetweenRequest} request ListBinHistoryBetweenRequest message or plain object
         * @param {pond.PondService.ListBinHistoryBetweenCallback} callback Node-style callback called with the error, if any, and ListBinHistoryBetweenResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinHistoryBetween = function listBinHistoryBetween(request, callback) {
            return this.rpcCall(listBinHistoryBetween, $root.pond.ListBinHistoryBetweenRequest, $root.pond.ListBinHistoryBetweenResponse, request, callback);
        }, "name", { value: "ListBinHistoryBetween" });

        /**
         * Calls ListBinHistoryBetween.
         * @function listBinHistoryBetween
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinHistoryBetweenRequest} request ListBinHistoryBetweenRequest message or plain object
         * @returns {Promise<pond.ListBinHistoryBetweenResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getBinMetrics}.
         * @memberof pond.PondService
         * @typedef GetBinMetricsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetBinMetricsResponse} [response] GetBinMetricsResponse
         */

        /**
         * Calls GetBinMetrics.
         * @function getBinMetrics
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinMetricsRequest} request GetBinMetricsRequest message or plain object
         * @param {pond.PondService.GetBinMetricsCallback} callback Node-style callback called with the error, if any, and GetBinMetricsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getBinMetrics = function getBinMetrics(request, callback) {
            return this.rpcCall(getBinMetrics, $root.pond.GetBinMetricsRequest, $root.pond.GetBinMetricsResponse, request, callback);
        }, "name", { value: "GetBinMetrics" });

        /**
         * Calls GetBinMetrics.
         * @function getBinMetrics
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinMetricsRequest} request GetBinMetricsRequest message or plain object
         * @returns {Promise<pond.GetBinMetricsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinComponentsMeasurements}.
         * @memberof pond.PondService
         * @typedef ListBinComponentsMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinComponentsMeasurementsResponse} [response] ListBinComponentsMeasurementsResponse
         */

        /**
         * Calls ListBinComponentsMeasurements.
         * @function listBinComponentsMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentsMeasurementsRequest} request ListBinComponentsMeasurementsRequest message or plain object
         * @param {pond.PondService.ListBinComponentsMeasurementsCallback} callback Node-style callback called with the error, if any, and ListBinComponentsMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinComponentsMeasurements = function listBinComponentsMeasurements(request, callback) {
            return this.rpcCall(listBinComponentsMeasurements, $root.pond.ListBinComponentsMeasurementsRequest, $root.pond.ListBinComponentsMeasurementsResponse, request, callback);
        }, "name", { value: "ListBinComponentsMeasurements" });

        /**
         * Calls ListBinComponentsMeasurements.
         * @function listBinComponentsMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentsMeasurementsRequest} request ListBinComponentsMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListBinComponentsMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#grainSourceMap}.
         * @memberof pond.PondService
         * @typedef GrainSourceMapCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GrainSourceMapResponse} [response] GrainSourceMapResponse
         */

        /**
         * Calls GrainSourceMap.
         * @function grainSourceMap
         * @memberof pond.PondService
         * @instance
         * @param {pond.GrainSourceMapRequest} request GrainSourceMapRequest message or plain object
         * @param {pond.PondService.GrainSourceMapCallback} callback Node-style callback called with the error, if any, and GrainSourceMapResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.grainSourceMap = function grainSourceMap(request, callback) {
            return this.rpcCall(grainSourceMap, $root.pond.GrainSourceMapRequest, $root.pond.GrainSourceMapResponse, request, callback);
        }, "name", { value: "GrainSourceMap" });

        /**
         * Calls GrainSourceMap.
         * @function grainSourceMap
         * @memberof pond.PondService
         * @instance
         * @param {pond.GrainSourceMapRequest} request GrainSourceMapRequest message or plain object
         * @returns {Promise<pond.GrainSourceMapResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addBin}.
         * @memberof pond.PondService
         * @typedef AddBinCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddBinResponse} [response] AddBinResponse
         */

        /**
         * Calls AddBin.
         * @function addBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinRequest} request AddBinRequest message or plain object
         * @param {pond.PondService.AddBinCallback} callback Node-style callback called with the error, if any, and AddBinResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addBin = function addBin(request, callback) {
            return this.rpcCall(addBin, $root.pond.AddBinRequest, $root.pond.AddBinResponse, request, callback);
        }, "name", { value: "AddBin" });

        /**
         * Calls AddBin.
         * @function addBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinRequest} request AddBinRequest message or plain object
         * @returns {Promise<pond.AddBinResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateBin}.
         * @memberof pond.PondService
         * @typedef UpdateBinCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateBinResponse} [response] UpdateBinResponse
         */

        /**
         * Calls UpdateBin.
         * @function updateBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinRequest} request UpdateBinRequest message or plain object
         * @param {pond.PondService.UpdateBinCallback} callback Node-style callback called with the error, if any, and UpdateBinResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateBin = function updateBin(request, callback) {
            return this.rpcCall(updateBin, $root.pond.UpdateBinRequest, $root.pond.UpdateBinResponse, request, callback);
        }, "name", { value: "UpdateBin" });

        /**
         * Calls UpdateBin.
         * @function updateBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinRequest} request UpdateBinRequest message or plain object
         * @returns {Promise<pond.UpdateBinResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#bulkBinUpdate}.
         * @memberof pond.PondService
         * @typedef BulkBinUpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.BulkBinUpdateResponse} [response] BulkBinUpdateResponse
         */

        /**
         * Calls BulkBinUpdate.
         * @function bulkBinUpdate
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkBinUpdateRequest} request BulkBinUpdateRequest message or plain object
         * @param {pond.PondService.BulkBinUpdateCallback} callback Node-style callback called with the error, if any, and BulkBinUpdateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.bulkBinUpdate = function bulkBinUpdate(request, callback) {
            return this.rpcCall(bulkBinUpdate, $root.pond.BulkBinUpdateRequest, $root.pond.BulkBinUpdateResponse, request, callback);
        }, "name", { value: "BulkBinUpdate" });

        /**
         * Calls BulkBinUpdate.
         * @function bulkBinUpdate
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkBinUpdateRequest} request BulkBinUpdateRequest message or plain object
         * @returns {Promise<pond.BulkBinUpdateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateBinStatus}.
         * @memberof pond.PondService
         * @typedef UpdateBinStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateBinStatusResponse} [response] UpdateBinStatusResponse
         */

        /**
         * Calls UpdateBinStatus.
         * @function updateBinStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinStatusRequest} request UpdateBinStatusRequest message or plain object
         * @param {pond.PondService.UpdateBinStatusCallback} callback Node-style callback called with the error, if any, and UpdateBinStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateBinStatus = function updateBinStatus(request, callback) {
            return this.rpcCall(updateBinStatus, $root.pond.UpdateBinStatusRequest, $root.pond.UpdateBinStatusResponse, request, callback);
        }, "name", { value: "UpdateBinStatus" });

        /**
         * Calls UpdateBinStatus.
         * @function updateBinStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinStatusRequest} request UpdateBinStatusRequest message or plain object
         * @returns {Promise<pond.UpdateBinStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeBin}.
         * @memberof pond.PondService
         * @typedef RemoveBinCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveBinResponse} [response] RemoveBinResponse
         */

        /**
         * Calls RemoveBin.
         * @function removeBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinRequest} request RemoveBinRequest message or plain object
         * @param {pond.PondService.RemoveBinCallback} callback Node-style callback called with the error, if any, and RemoveBinResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeBin = function removeBin(request, callback) {
            return this.rpcCall(removeBin, $root.pond.RemoveBinRequest, $root.pond.RemoveBinResponse, request, callback);
        }, "name", { value: "RemoveBin" });

        /**
         * Calls RemoveBin.
         * @function removeBin
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinRequest} request RemoveBinRequest message or plain object
         * @returns {Promise<pond.RemoveBinResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinLiters}.
         * @memberof pond.PondService
         * @typedef ListBinLitersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinLiterResponse} [response] ListBinLiterResponse
         */

        /**
         * Calls ListBinLiters.
         * @function listBinLiters
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinLitersRequest} request ListBinLitersRequest message or plain object
         * @param {pond.PondService.ListBinLitersCallback} callback Node-style callback called with the error, if any, and ListBinLiterResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinLiters = function listBinLiters(request, callback) {
            return this.rpcCall(listBinLiters, $root.pond.ListBinLitersRequest, $root.pond.ListBinLiterResponse, request, callback);
        }, "name", { value: "ListBinLiters" });

        /**
         * Calls ListBinLiters.
         * @function listBinLiters
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinLitersRequest} request ListBinLitersRequest message or plain object
         * @returns {Promise<pond.ListBinLiterResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addBinComponent}.
         * @memberof pond.PondService
         * @typedef AddBinComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddBinComponentResponse} [response] AddBinComponentResponse
         */

        /**
         * Calls AddBinComponent.
         * @function addBinComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinComponentRequest} request AddBinComponentRequest message or plain object
         * @param {pond.PondService.AddBinComponentCallback} callback Node-style callback called with the error, if any, and AddBinComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addBinComponent = function addBinComponent(request, callback) {
            return this.rpcCall(addBinComponent, $root.pond.AddBinComponentRequest, $root.pond.AddBinComponentResponse, request, callback);
        }, "name", { value: "AddBinComponent" });

        /**
         * Calls AddBinComponent.
         * @function addBinComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinComponentRequest} request AddBinComponentRequest message or plain object
         * @returns {Promise<pond.AddBinComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeBinComponent}.
         * @memberof pond.PondService
         * @typedef RemoveBinComponentCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveBinComponentResponse} [response] RemoveBinComponentResponse
         */

        /**
         * Calls RemoveBinComponent.
         * @function removeBinComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinComponentRequest} request RemoveBinComponentRequest message or plain object
         * @param {pond.PondService.RemoveBinComponentCallback} callback Node-style callback called with the error, if any, and RemoveBinComponentResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeBinComponent = function removeBinComponent(request, callback) {
            return this.rpcCall(removeBinComponent, $root.pond.RemoveBinComponentRequest, $root.pond.RemoveBinComponentResponse, request, callback);
        }, "name", { value: "RemoveBinComponent" });

        /**
         * Calls RemoveBinComponent.
         * @function removeBinComponent
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinComponentRequest} request RemoveBinComponentRequest message or plain object
         * @returns {Promise<pond.RemoveBinComponentResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeAllBinComponents}.
         * @memberof pond.PondService
         * @typedef RemoveAllBinComponentsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveAllBinComponentsResponse} [response] RemoveAllBinComponentsResponse
         */

        /**
         * Calls RemoveAllBinComponents.
         * @function removeAllBinComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveAllBinComponentsRequest} request RemoveAllBinComponentsRequest message or plain object
         * @param {pond.PondService.RemoveAllBinComponentsCallback} callback Node-style callback called with the error, if any, and RemoveAllBinComponentsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeAllBinComponents = function removeAllBinComponents(request, callback) {
            return this.rpcCall(removeAllBinComponents, $root.pond.RemoveAllBinComponentsRequest, $root.pond.RemoveAllBinComponentsResponse, request, callback);
        }, "name", { value: "RemoveAllBinComponents" });

        /**
         * Calls RemoveAllBinComponents.
         * @function removeAllBinComponents
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveAllBinComponentsRequest} request RemoveAllBinComponentsRequest message or plain object
         * @returns {Promise<pond.RemoveAllBinComponentsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTopNodes}.
         * @memberof pond.PondService
         * @typedef UpdateTopNodesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTopNodesResponse} [response] UpdateTopNodesResponse
         */

        /**
         * Calls UpdateTopNodes.
         * @function updateTopNodes
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTopNodesRequest} request UpdateTopNodesRequest message or plain object
         * @param {pond.PondService.UpdateTopNodesCallback} callback Node-style callback called with the error, if any, and UpdateTopNodesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTopNodes = function updateTopNodes(request, callback) {
            return this.rpcCall(updateTopNodes, $root.pond.UpdateTopNodesRequest, $root.pond.UpdateTopNodesResponse, request, callback);
        }, "name", { value: "UpdateTopNodes" });

        /**
         * Calls UpdateTopNodes.
         * @function updateTopNodes
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTopNodesRequest} request UpdateTopNodesRequest message or plain object
         * @returns {Promise<pond.UpdateTopNodesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getBinsTrendData}.
         * @memberof pond.PondService
         * @typedef GetBinsTrendDataCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetBinsTrendDataResponse} [response] GetBinsTrendDataResponse
         */

        /**
         * Calls GetBinsTrendData.
         * @function getBinsTrendData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinsTrendDataRequest} request GetBinsTrendDataRequest message or plain object
         * @param {pond.PondService.GetBinsTrendDataCallback} callback Node-style callback called with the error, if any, and GetBinsTrendDataResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getBinsTrendData = function getBinsTrendData(request, callback) {
            return this.rpcCall(getBinsTrendData, $root.pond.GetBinsTrendDataRequest, $root.pond.GetBinsTrendDataResponse, request, callback);
        }, "name", { value: "GetBinsTrendData" });

        /**
         * Calls GetBinsTrendData.
         * @function getBinsTrendData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinsTrendDataRequest} request GetBinsTrendDataRequest message or plain object
         * @returns {Promise<pond.GetBinsTrendDataResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listMeasurements}.
         * @memberof pond.PondService
         * @typedef ListMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListMeasurementsResponse} [response] ListMeasurementsResponse
         */

        /**
         * Calls ListMeasurements.
         * @function listMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMeasurementsRequest} request ListMeasurementsRequest message or plain object
         * @param {pond.PondService.ListMeasurementsCallback} callback Node-style callback called with the error, if any, and ListMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listMeasurements = function listMeasurements(request, callback) {
            return this.rpcCall(listMeasurements, $root.pond.ListMeasurementsRequest, $root.pond.ListMeasurementsResponse, request, callback);
        }, "name", { value: "ListMeasurements" });

        /**
         * Calls ListMeasurements.
         * @function listMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListMeasurementsRequest} request ListMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listUnitMeasurements}.
         * @memberof pond.PondService
         * @typedef ListUnitMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListUnitMeasurementsResponse} [response] ListUnitMeasurementsResponse
         */

        /**
         * Calls ListUnitMeasurements.
         * @function listUnitMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUnitMeasurementsRequest} request ListUnitMeasurementsRequest message or plain object
         * @param {pond.PondService.ListUnitMeasurementsCallback} callback Node-style callback called with the error, if any, and ListUnitMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listUnitMeasurements = function listUnitMeasurements(request, callback) {
            return this.rpcCall(listUnitMeasurements, $root.pond.ListUnitMeasurementsRequest, $root.pond.ListUnitMeasurementsResponse, request, callback);
        }, "name", { value: "ListUnitMeasurements" });

        /**
         * Calls ListUnitMeasurements.
         * @function listUnitMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUnitMeasurementsRequest} request ListUnitMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListUnitMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listObjectMeasurements}.
         * @memberof pond.PondService
         * @typedef ListObjectMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListObjectMeasurementsResponse} [response] ListObjectMeasurementsResponse
         */

        /**
         * Calls ListObjectMeasurements.
         * @function listObjectMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectMeasurementsRequest} request ListObjectMeasurementsRequest message or plain object
         * @param {pond.PondService.ListObjectMeasurementsCallback} callback Node-style callback called with the error, if any, and ListObjectMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listObjectMeasurements = function listObjectMeasurements(request, callback) {
            return this.rpcCall(listObjectMeasurements, $root.pond.ListObjectMeasurementsRequest, $root.pond.ListObjectMeasurementsResponse, request, callback);
        }, "name", { value: "ListObjectMeasurements" });

        /**
         * Calls ListObjectMeasurements.
         * @function listObjectMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectMeasurementsRequest} request ListObjectMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListObjectMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#sampleMeasurements}.
         * @memberof pond.PondService
         * @typedef SampleMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SampleMeasurementsResponse} [response] SampleMeasurementsResponse
         */

        /**
         * Calls SampleMeasurements.
         * @function sampleMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.SampleMeasurementsRequest} request SampleMeasurementsRequest message or plain object
         * @param {pond.PondService.SampleMeasurementsCallback} callback Node-style callback called with the error, if any, and SampleMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.sampleMeasurements = function sampleMeasurements(request, callback) {
            return this.rpcCall(sampleMeasurements, $root.pond.SampleMeasurementsRequest, $root.pond.SampleMeasurementsResponse, request, callback);
        }, "name", { value: "SampleMeasurements" });

        /**
         * Calls SampleMeasurements.
         * @function sampleMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.SampleMeasurementsRequest} request SampleMeasurementsRequest message or plain object
         * @returns {Promise<pond.SampleMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#sampleUnitMeasurements}.
         * @memberof pond.PondService
         * @typedef SampleUnitMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SampleUnitMeasurementsResponse} [response] SampleUnitMeasurementsResponse
         */

        /**
         * Calls SampleUnitMeasurements.
         * @function sampleUnitMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.SampleUnitMeasurementsRequest} request SampleUnitMeasurementsRequest message or plain object
         * @param {pond.PondService.SampleUnitMeasurementsCallback} callback Node-style callback called with the error, if any, and SampleUnitMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.sampleUnitMeasurements = function sampleUnitMeasurements(request, callback) {
            return this.rpcCall(sampleUnitMeasurements, $root.pond.SampleUnitMeasurementsRequest, $root.pond.SampleUnitMeasurementsResponse, request, callback);
        }, "name", { value: "SampleUnitMeasurements" });

        /**
         * Calls SampleUnitMeasurements.
         * @function sampleUnitMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.SampleUnitMeasurementsRequest} request SampleUnitMeasurementsRequest message or plain object
         * @returns {Promise<pond.SampleUnitMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#lastMeasurements}.
         * @memberof pond.PondService
         * @typedef LastMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.LastMeasurementsResponse} [response] LastMeasurementsResponse
         */

        /**
         * Calls LastMeasurements.
         * @function lastMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.LastMeasurementsRequest} request LastMeasurementsRequest message or plain object
         * @param {pond.PondService.LastMeasurementsCallback} callback Node-style callback called with the error, if any, and LastMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.lastMeasurements = function lastMeasurements(request, callback) {
            return this.rpcCall(lastMeasurements, $root.pond.LastMeasurementsRequest, $root.pond.LastMeasurementsResponse, request, callback);
        }, "name", { value: "LastMeasurements" });

        /**
         * Calls LastMeasurements.
         * @function lastMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.LastMeasurementsRequest} request LastMeasurementsRequest message or plain object
         * @returns {Promise<pond.LastMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listExportedMeasurements}.
         * @memberof pond.PondService
         * @typedef ListExportedMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListExportedMeasurementsResponse} [response] ListExportedMeasurementsResponse
         */

        /**
         * Calls ListExportedMeasurements.
         * @function listExportedMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListExportedMeasurementsRequest} request ListExportedMeasurementsRequest message or plain object
         * @param {pond.PondService.ListExportedMeasurementsCallback} callback Node-style callback called with the error, if any, and ListExportedMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listExportedMeasurements = function listExportedMeasurements(request, callback) {
            return this.rpcCall(listExportedMeasurements, $root.pond.ListExportedMeasurementsRequest, $root.pond.ListExportedMeasurementsResponse, request, callback);
        }, "name", { value: "ListExportedMeasurements" });

        /**
         * Calls ListExportedMeasurements.
         * @function listExportedMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListExportedMeasurementsRequest} request ListExportedMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListExportedMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDeviceExportedMeasurements}.
         * @memberof pond.PondService
         * @typedef ListDeviceExportedMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDeviceExportedMeasurementsResponse} [response] ListDeviceExportedMeasurementsResponse
         */

        /**
         * Calls ListDeviceExportedMeasurements.
         * @function listDeviceExportedMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceExportedMeasurementsRequest} request ListDeviceExportedMeasurementsRequest message or plain object
         * @param {pond.PondService.ListDeviceExportedMeasurementsCallback} callback Node-style callback called with the error, if any, and ListDeviceExportedMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDeviceExportedMeasurements = function listDeviceExportedMeasurements(request, callback) {
            return this.rpcCall(listDeviceExportedMeasurements, $root.pond.ListDeviceExportedMeasurementsRequest, $root.pond.ListDeviceExportedMeasurementsResponse, request, callback);
        }, "name", { value: "ListDeviceExportedMeasurements" });

        /**
         * Calls ListDeviceExportedMeasurements.
         * @function listDeviceExportedMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDeviceExportedMeasurementsRequest} request ListDeviceExportedMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListDeviceExportedMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#exportDeviceMeasurementsFlat}.
         * @memberof pond.PondService
         * @typedef ExportDeviceMeasurementsFlatCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ExportDeviceMeasurementsFlatResponse} [response] ExportDeviceMeasurementsFlatResponse
         */

        /**
         * Calls ExportDeviceMeasurementsFlat.
         * @function exportDeviceMeasurementsFlat
         * @memberof pond.PondService
         * @instance
         * @param {pond.ExportDeviceMeasurementsFlatRequest} request ExportDeviceMeasurementsFlatRequest message or plain object
         * @param {pond.PondService.ExportDeviceMeasurementsFlatCallback} callback Node-style callback called with the error, if any, and ExportDeviceMeasurementsFlatResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.exportDeviceMeasurementsFlat = function exportDeviceMeasurementsFlat(request, callback) {
            return this.rpcCall(exportDeviceMeasurementsFlat, $root.pond.ExportDeviceMeasurementsFlatRequest, $root.pond.ExportDeviceMeasurementsFlatResponse, request, callback);
        }, "name", { value: "ExportDeviceMeasurementsFlat" });

        /**
         * Calls ExportDeviceMeasurementsFlat.
         * @function exportDeviceMeasurementsFlat
         * @memberof pond.PondService
         * @instance
         * @param {pond.ExportDeviceMeasurementsFlatRequest} request ExportDeviceMeasurementsFlatRequest message or plain object
         * @returns {Promise<pond.ExportDeviceMeasurementsFlatResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getFirmware}.
         * @memberof pond.PondService
         * @typedef GetFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Firmware} [response] Firmware
         */

        /**
         * Calls GetFirmware.
         * @function getFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFirmwareRequest} request GetFirmwareRequest message or plain object
         * @param {pond.PondService.GetFirmwareCallback} callback Node-style callback called with the error, if any, and Firmware
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getFirmware = function getFirmware(request, callback) {
            return this.rpcCall(getFirmware, $root.pond.GetFirmwareRequest, $root.pond.Firmware, request, callback);
        }, "name", { value: "GetFirmware" });

        /**
         * Calls GetFirmware.
         * @function getFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFirmwareRequest} request GetFirmwareRequest message or plain object
         * @returns {Promise<pond.Firmware>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listFirmware}.
         * @memberof pond.PondService
         * @typedef ListFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListFirmwareResponse} [response] ListFirmwareResponse
         */

        /**
         * Calls ListFirmware.
         * @function listFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFirmwareRequest} request ListFirmwareRequest message or plain object
         * @param {pond.PondService.ListFirmwareCallback} callback Node-style callback called with the error, if any, and ListFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listFirmware = function listFirmware(request, callback) {
            return this.rpcCall(listFirmware, $root.pond.ListFirmwareRequest, $root.pond.ListFirmwareResponse, request, callback);
        }, "name", { value: "ListFirmware" });

        /**
         * Calls ListFirmware.
         * @function listFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFirmwareRequest} request ListFirmwareRequest message or plain object
         * @returns {Promise<pond.ListFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#latestFirmware}.
         * @memberof pond.PondService
         * @typedef LatestFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.LatestFirmwareResponse} [response] LatestFirmwareResponse
         */

        /**
         * Calls LatestFirmware.
         * @function latestFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.LatestFirmwareRequest} request LatestFirmwareRequest message or plain object
         * @param {pond.PondService.LatestFirmwareCallback} callback Node-style callback called with the error, if any, and LatestFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.latestFirmware = function latestFirmware(request, callback) {
            return this.rpcCall(latestFirmware, $root.pond.LatestFirmwareRequest, $root.pond.LatestFirmwareResponse, request, callback);
        }, "name", { value: "LatestFirmware" });

        /**
         * Calls LatestFirmware.
         * @function latestFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.LatestFirmwareRequest} request LatestFirmwareRequest message or plain object
         * @returns {Promise<pond.LatestFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#allLatestFirmware}.
         * @memberof pond.PondService
         * @typedef AllLatestFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AllLatestFirmwareResponse} [response] AllLatestFirmwareResponse
         */

        /**
         * Calls AllLatestFirmware.
         * @function allLatestFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.AllLatestFirmwareRequest} request AllLatestFirmwareRequest message or plain object
         * @param {pond.PondService.AllLatestFirmwareCallback} callback Node-style callback called with the error, if any, and AllLatestFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.allLatestFirmware = function allLatestFirmware(request, callback) {
            return this.rpcCall(allLatestFirmware, $root.pond.AllLatestFirmwareRequest, $root.pond.AllLatestFirmwareResponse, request, callback);
        }, "name", { value: "AllLatestFirmware" });

        /**
         * Calls AllLatestFirmware.
         * @function allLatestFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.AllLatestFirmwareRequest} request AllLatestFirmwareRequest message or plain object
         * @returns {Promise<pond.AllLatestFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addFirmware}.
         * @memberof pond.PondService
         * @typedef AddFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddFirmwareResponse} [response] AddFirmwareResponse
         */

        /**
         * Calls AddFirmware.
         * @function addFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFirmwareRequest} request AddFirmwareRequest message or plain object
         * @param {pond.PondService.AddFirmwareCallback} callback Node-style callback called with the error, if any, and AddFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addFirmware = function addFirmware(request, callback) {
            return this.rpcCall(addFirmware, $root.pond.AddFirmwareRequest, $root.pond.AddFirmwareResponse, request, callback);
        }, "name", { value: "AddFirmware" });

        /**
         * Calls AddFirmware.
         * @function addFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFirmwareRequest} request AddFirmwareRequest message or plain object
         * @returns {Promise<pond.AddFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateFirmware}.
         * @memberof pond.PondService
         * @typedef UpdateFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateFirmwareResponse} [response] UpdateFirmwareResponse
         */

        /**
         * Calls UpdateFirmware.
         * @function updateFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFirmwareRequest} request UpdateFirmwareRequest message or plain object
         * @param {pond.PondService.UpdateFirmwareCallback} callback Node-style callback called with the error, if any, and UpdateFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateFirmware = function updateFirmware(request, callback) {
            return this.rpcCall(updateFirmware, $root.pond.UpdateFirmwareRequest, $root.pond.UpdateFirmwareResponse, request, callback);
        }, "name", { value: "UpdateFirmware" });

        /**
         * Calls UpdateFirmware.
         * @function updateFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFirmwareRequest} request UpdateFirmwareRequest message or plain object
         * @returns {Promise<pond.UpdateFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeFirmware}.
         * @memberof pond.PondService
         * @typedef RemoveFirmwareCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveFirmwareResponse} [response] RemoveFirmwareResponse
         */

        /**
         * Calls RemoveFirmware.
         * @function removeFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFirmwareRequest} request RemoveFirmwareRequest message or plain object
         * @param {pond.PondService.RemoveFirmwareCallback} callback Node-style callback called with the error, if any, and RemoveFirmwareResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeFirmware = function removeFirmware(request, callback) {
            return this.rpcCall(removeFirmware, $root.pond.RemoveFirmwareRequest, $root.pond.RemoveFirmwareResponse, request, callback);
        }, "name", { value: "RemoveFirmware" });

        /**
         * Calls RemoveFirmware.
         * @function removeFirmware
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFirmwareRequest} request RemoveFirmwareRequest message or plain object
         * @returns {Promise<pond.RemoveFirmwareResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getUpgrade}.
         * @memberof pond.PondService
         * @typedef GetUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Upgrade} [response] Upgrade
         */

        /**
         * Calls GetUpgrade.
         * @function getUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUpgradeRequest} request GetUpgradeRequest message or plain object
         * @param {pond.PondService.GetUpgradeCallback} callback Node-style callback called with the error, if any, and Upgrade
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getUpgrade = function getUpgrade(request, callback) {
            return this.rpcCall(getUpgrade, $root.pond.GetUpgradeRequest, $root.pond.Upgrade, request, callback);
        }, "name", { value: "GetUpgrade" });

        /**
         * Calls GetUpgrade.
         * @function getUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUpgradeRequest} request GetUpgradeRequest message or plain object
         * @returns {Promise<pond.Upgrade>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#latestUpgrade}.
         * @memberof pond.PondService
         * @typedef LatestUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.LatestUpgradeResponse} [response] LatestUpgradeResponse
         */

        /**
         * Calls LatestUpgrade.
         * @function latestUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.LatestUpgradeRequest} request LatestUpgradeRequest message or plain object
         * @param {pond.PondService.LatestUpgradeCallback} callback Node-style callback called with the error, if any, and LatestUpgradeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.latestUpgrade = function latestUpgrade(request, callback) {
            return this.rpcCall(latestUpgrade, $root.pond.LatestUpgradeRequest, $root.pond.LatestUpgradeResponse, request, callback);
        }, "name", { value: "LatestUpgrade" });

        /**
         * Calls LatestUpgrade.
         * @function latestUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.LatestUpgradeRequest} request LatestUpgradeRequest message or plain object
         * @returns {Promise<pond.LatestUpgradeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listUpgrades}.
         * @memberof pond.PondService
         * @typedef ListUpgradesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListUpgradesResponse} [response] ListUpgradesResponse
         */

        /**
         * Calls ListUpgrades.
         * @function listUpgrades
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUpgradesRequest} request ListUpgradesRequest message or plain object
         * @param {pond.PondService.ListUpgradesCallback} callback Node-style callback called with the error, if any, and ListUpgradesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listUpgrades = function listUpgrades(request, callback) {
            return this.rpcCall(listUpgrades, $root.pond.ListUpgradesRequest, $root.pond.ListUpgradesResponse, request, callback);
        }, "name", { value: "ListUpgrades" });

        /**
         * Calls ListUpgrades.
         * @function listUpgrades
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUpgradesRequest} request ListUpgradesRequest message or plain object
         * @returns {Promise<pond.ListUpgradesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addUpgrade}.
         * @memberof pond.PondService
         * @typedef AddUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddUpgradeResponse} [response] AddUpgradeResponse
         */

        /**
         * Calls AddUpgrade.
         * @function addUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddUpgradeRequest} request AddUpgradeRequest message or plain object
         * @param {pond.PondService.AddUpgradeCallback} callback Node-style callback called with the error, if any, and AddUpgradeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addUpgrade = function addUpgrade(request, callback) {
            return this.rpcCall(addUpgrade, $root.pond.AddUpgradeRequest, $root.pond.AddUpgradeResponse, request, callback);
        }, "name", { value: "AddUpgrade" });

        /**
         * Calls AddUpgrade.
         * @function addUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddUpgradeRequest} request AddUpgradeRequest message or plain object
         * @returns {Promise<pond.AddUpgradeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateUpgrade}.
         * @memberof pond.PondService
         * @typedef UpdateUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateUpgradeResponse} [response] UpdateUpgradeResponse
         */

        /**
         * Calls UpdateUpgrade.
         * @function updateUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateUpgradeRequest} request UpdateUpgradeRequest message or plain object
         * @param {pond.PondService.UpdateUpgradeCallback} callback Node-style callback called with the error, if any, and UpdateUpgradeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateUpgrade = function updateUpgrade(request, callback) {
            return this.rpcCall(updateUpgrade, $root.pond.UpdateUpgradeRequest, $root.pond.UpdateUpgradeResponse, request, callback);
        }, "name", { value: "UpdateUpgrade" });

        /**
         * Calls UpdateUpgrade.
         * @function updateUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateUpgradeRequest} request UpdateUpgradeRequest message or plain object
         * @returns {Promise<pond.UpdateUpgradeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeUpgrade}.
         * @memberof pond.PondService
         * @typedef RemoveUpgradeCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveUpgradeResponse} [response] RemoveUpgradeResponse
         */

        /**
         * Calls RemoveUpgrade.
         * @function removeUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveUpgradeRequest} request RemoveUpgradeRequest message or plain object
         * @param {pond.PondService.RemoveUpgradeCallback} callback Node-style callback called with the error, if any, and RemoveUpgradeResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeUpgrade = function removeUpgrade(request, callback) {
            return this.rpcCall(removeUpgrade, $root.pond.RemoveUpgradeRequest, $root.pond.RemoveUpgradeResponse, request, callback);
        }, "name", { value: "RemoveUpgrade" });

        /**
         * Calls RemoveUpgrade.
         * @function removeUpgrade
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveUpgradeRequest} request RemoveUpgradeRequest message or plain object
         * @returns {Promise<pond.RemoveUpgradeResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getUser}.
         * @memberof pond.PondService
         * @typedef GetUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.User} [response] User
         */

        /**
         * Calls GetUser.
         * @function getUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUserRequest} request GetUserRequest message or plain object
         * @param {pond.PondService.GetUserCallback} callback Node-style callback called with the error, if any, and User
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getUser = function getUser(request, callback) {
            return this.rpcCall(getUser, $root.pond.GetUserRequest, $root.pond.User, request, callback);
        }, "name", { value: "GetUser" });

        /**
         * Calls GetUser.
         * @function getUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUserRequest} request GetUserRequest message or plain object
         * @returns {Promise<pond.User>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getUsers}.
         * @memberof pond.PondService
         * @typedef GetUsersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetUsersResponse} [response] GetUsersResponse
         */

        /**
         * Calls GetUsers.
         * @function getUsers
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUsersRequest} request GetUsersRequest message or plain object
         * @param {pond.PondService.GetUsersCallback} callback Node-style callback called with the error, if any, and GetUsersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getUsers = function getUsers(request, callback) {
            return this.rpcCall(getUsers, $root.pond.GetUsersRequest, $root.pond.GetUsersResponse, request, callback);
        }, "name", { value: "GetUsers" });

        /**
         * Calls GetUsers.
         * @function getUsers
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUsersRequest} request GetUsersRequest message or plain object
         * @returns {Promise<pond.GetUsersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listUsers}.
         * @memberof pond.PondService
         * @typedef ListUsersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListUsersResponse} [response] ListUsersResponse
         */

        /**
         * Calls ListUsers.
         * @function listUsers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUsersRequest} request ListUsersRequest message or plain object
         * @param {pond.PondService.ListUsersCallback} callback Node-style callback called with the error, if any, and ListUsersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listUsers = function listUsers(request, callback) {
            return this.rpcCall(listUsers, $root.pond.ListUsersRequest, $root.pond.ListUsersResponse, request, callback);
        }, "name", { value: "ListUsers" });

        /**
         * Calls ListUsers.
         * @function listUsers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListUsersRequest} request ListUsersRequest message or plain object
         * @returns {Promise<pond.ListUsersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addUser}.
         * @memberof pond.PondService
         * @typedef AddUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddUserResponse} [response] AddUserResponse
         */

        /**
         * Calls AddUser.
         * @function addUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddUserRequest} request AddUserRequest message or plain object
         * @param {pond.PondService.AddUserCallback} callback Node-style callback called with the error, if any, and AddUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addUser = function addUser(request, callback) {
            return this.rpcCall(addUser, $root.pond.AddUserRequest, $root.pond.AddUserResponse, request, callback);
        }, "name", { value: "AddUser" });

        /**
         * Calls AddUser.
         * @function addUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddUserRequest} request AddUserRequest message or plain object
         * @returns {Promise<pond.AddUserResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateUser}.
         * @memberof pond.PondService
         * @typedef UpdateUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateUserResponse} [response] UpdateUserResponse
         */

        /**
         * Calls UpdateUser.
         * @function updateUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateUserRequest} request UpdateUserRequest message or plain object
         * @param {pond.PondService.UpdateUserCallback} callback Node-style callback called with the error, if any, and UpdateUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateUser = function updateUser(request, callback) {
            return this.rpcCall(updateUser, $root.pond.UpdateUserRequest, $root.pond.UpdateUserResponse, request, callback);
        }, "name", { value: "UpdateUser" });

        /**
         * Calls UpdateUser.
         * @function updateUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateUserRequest} request UpdateUserRequest message or plain object
         * @returns {Promise<pond.UpdateUserResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#signupUser}.
         * @memberof pond.PondService
         * @typedef SignupUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.SignupUserResponse} [response] SignupUserResponse
         */

        /**
         * Calls SignupUser.
         * @function signupUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.SignupUserRequest} request SignupUserRequest message or plain object
         * @param {pond.PondService.SignupUserCallback} callback Node-style callback called with the error, if any, and SignupUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.signupUser = function signupUser(request, callback) {
            return this.rpcCall(signupUser, $root.pond.SignupUserRequest, $root.pond.SignupUserResponse, request, callback);
        }, "name", { value: "SignupUser" });

        /**
         * Calls SignupUser.
         * @function signupUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.SignupUserRequest} request SignupUserRequest message or plain object
         * @returns {Promise<pond.SignupUserResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#completeSignupUser}.
         * @memberof pond.PondService
         * @typedef CompleteSignupUserCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.CompleteSignupUserResponse} [response] CompleteSignupUserResponse
         */

        /**
         * Calls CompleteSignupUser.
         * @function completeSignupUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.CompleteSignupUserRequest} request CompleteSignupUserRequest message or plain object
         * @param {pond.PondService.CompleteSignupUserCallback} callback Node-style callback called with the error, if any, and CompleteSignupUserResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.completeSignupUser = function completeSignupUser(request, callback) {
            return this.rpcCall(completeSignupUser, $root.pond.CompleteSignupUserRequest, $root.pond.CompleteSignupUserResponse, request, callback);
        }, "name", { value: "CompleteSignupUser" });

        /**
         * Calls CompleteSignupUser.
         * @function completeSignupUser
         * @memberof pond.PondService
         * @instance
         * @param {pond.CompleteSignupUserRequest} request CompleteSignupUserRequest message or plain object
         * @returns {Promise<pond.CompleteSignupUserResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#hasPermissions}.
         * @memberof pond.PondService
         * @typedef HasPermissionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.HasPermissionsResponse} [response] HasPermissionsResponse
         */

        /**
         * Calls HasPermissions.
         * @function hasPermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.HasPermissionsRequest} request HasPermissionsRequest message or plain object
         * @param {pond.PondService.HasPermissionsCallback} callback Node-style callback called with the error, if any, and HasPermissionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.hasPermissions = function hasPermissions(request, callback) {
            return this.rpcCall(hasPermissions, $root.pond.HasPermissionsRequest, $root.pond.HasPermissionsResponse, request, callback);
        }, "name", { value: "HasPermissions" });

        /**
         * Calls HasPermissions.
         * @function hasPermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.HasPermissionsRequest} request HasPermissionsRequest message or plain object
         * @returns {Promise<pond.HasPermissionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updatePermissions}.
         * @memberof pond.PondService
         * @typedef UpdatePermissionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdatePermissionsResponse} [response] UpdatePermissionsResponse
         */

        /**
         * Calls UpdatePermissions.
         * @function updatePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdatePermissionsRequest} request UpdatePermissionsRequest message or plain object
         * @param {pond.PondService.UpdatePermissionsCallback} callback Node-style callback called with the error, if any, and UpdatePermissionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updatePermissions = function updatePermissions(request, callback) {
            return this.rpcCall(updatePermissions, $root.pond.UpdatePermissionsRequest, $root.pond.UpdatePermissionsResponse, request, callback);
        }, "name", { value: "UpdatePermissions" });

        /**
         * Calls UpdatePermissions.
         * @function updatePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdatePermissionsRequest} request UpdatePermissionsRequest message or plain object
         * @returns {Promise<pond.UpdatePermissionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateRelativePermissions}.
         * @memberof pond.PondService
         * @typedef UpdateRelativePermissionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateRelativePermissionsResponse} [response] UpdateRelativePermissionsResponse
         */

        /**
         * Calls UpdateRelativePermissions.
         * @function updateRelativePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateRelativePermissionsRequest} request UpdateRelativePermissionsRequest message or plain object
         * @param {pond.PondService.UpdateRelativePermissionsCallback} callback Node-style callback called with the error, if any, and UpdateRelativePermissionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateRelativePermissions = function updateRelativePermissions(request, callback) {
            return this.rpcCall(updateRelativePermissions, $root.pond.UpdateRelativePermissionsRequest, $root.pond.UpdateRelativePermissionsResponse, request, callback);
        }, "name", { value: "UpdateRelativePermissions" });

        /**
         * Calls UpdateRelativePermissions.
         * @function updateRelativePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateRelativePermissionsRequest} request UpdateRelativePermissionsRequest message or plain object
         * @returns {Promise<pond.UpdateRelativePermissionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#evaluatePermissions}.
         * @memberof pond.PondService
         * @typedef EvaluatePermissionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.EvaluatePermissionsResponse} [response] EvaluatePermissionsResponse
         */

        /**
         * Calls EvaluatePermissions.
         * @function evaluatePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.EvaluatePermissionsRequest} request EvaluatePermissionsRequest message or plain object
         * @param {pond.PondService.EvaluatePermissionsCallback} callback Node-style callback called with the error, if any, and EvaluatePermissionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.evaluatePermissions = function evaluatePermissions(request, callback) {
            return this.rpcCall(evaluatePermissions, $root.pond.EvaluatePermissionsRequest, $root.pond.EvaluatePermissionsResponse, request, callback);
        }, "name", { value: "EvaluatePermissions" });

        /**
         * Calls EvaluatePermissions.
         * @function evaluatePermissions
         * @memberof pond.PondService
         * @instance
         * @param {pond.EvaluatePermissionsRequest} request EvaluatePermissionsRequest message or plain object
         * @returns {Promise<pond.EvaluatePermissionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getPreferences}.
         * @memberof pond.PondService
         * @typedef GetPreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetPreferencesResponse} [response] GetPreferencesResponse
         */

        /**
         * Calls GetPreferences.
         * @function getPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetPreferencesRequest} request GetPreferencesRequest message or plain object
         * @param {pond.PondService.GetPreferencesCallback} callback Node-style callback called with the error, if any, and GetPreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getPreferences = function getPreferences(request, callback) {
            return this.rpcCall(getPreferences, $root.pond.GetPreferencesRequest, $root.pond.GetPreferencesResponse, request, callback);
        }, "name", { value: "GetPreferences" });

        /**
         * Calls GetPreferences.
         * @function getPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetPreferencesRequest} request GetPreferencesRequest message or plain object
         * @returns {Promise<pond.GetPreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updatePreferences}.
         * @memberof pond.PondService
         * @typedef UpdatePreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdatePreferencesResponse} [response] UpdatePreferencesResponse
         */

        /**
         * Calls UpdatePreferences.
         * @function updatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdatePreferencesRequest} request UpdatePreferencesRequest message or plain object
         * @param {pond.PondService.UpdatePreferencesCallback} callback Node-style callback called with the error, if any, and UpdatePreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updatePreferences = function updatePreferences(request, callback) {
            return this.rpcCall(updatePreferences, $root.pond.UpdatePreferencesRequest, $root.pond.UpdatePreferencesResponse, request, callback);
        }, "name", { value: "UpdatePreferences" });

        /**
         * Calls UpdatePreferences.
         * @function updatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdatePreferencesRequest} request UpdatePreferencesRequest message or plain object
         * @returns {Promise<pond.UpdatePreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinComponentPreferences}.
         * @memberof pond.PondService
         * @typedef ListBinComponentPreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinComponentPreferencesResponse} [response] ListBinComponentPreferencesResponse
         */

        /**
         * Calls ListBinComponentPreferences.
         * @function listBinComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentPreferencesRequest} request ListBinComponentPreferencesRequest message or plain object
         * @param {pond.PondService.ListBinComponentPreferencesCallback} callback Node-style callback called with the error, if any, and ListBinComponentPreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinComponentPreferences = function listBinComponentPreferences(request, callback) {
            return this.rpcCall(listBinComponentPreferences, $root.pond.ListBinComponentPreferencesRequest, $root.pond.ListBinComponentPreferencesResponse, request, callback);
        }, "name", { value: "ListBinComponentPreferences" });

        /**
         * Calls ListBinComponentPreferences.
         * @function listBinComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinComponentPreferencesRequest} request ListBinComponentPreferencesRequest message or plain object
         * @returns {Promise<pond.ListBinComponentPreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateBinComponentPreferences}.
         * @memberof pond.PondService
         * @typedef UpdateBinComponentPreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateBinComponentPreferencesResponse} [response] UpdateBinComponentPreferencesResponse
         */

        /**
         * Calls UpdateBinComponentPreferences.
         * @function updateBinComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinComponentPreferencesRequest} request UpdateBinComponentPreferencesRequest message or plain object
         * @param {pond.PondService.UpdateBinComponentPreferencesCallback} callback Node-style callback called with the error, if any, and UpdateBinComponentPreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateBinComponentPreferences = function updateBinComponentPreferences(request, callback) {
            return this.rpcCall(updateBinComponentPreferences, $root.pond.UpdateBinComponentPreferencesRequest, $root.pond.UpdateBinComponentPreferencesResponse, request, callback);
        }, "name", { value: "UpdateBinComponentPreferences" });

        /**
         * Calls UpdateBinComponentPreferences.
         * @function updateBinComponentPreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinComponentPreferencesRequest} request UpdateBinComponentPreferencesRequest message or plain object
         * @returns {Promise<pond.UpdateBinComponentPreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDevicePreferences}.
         * @memberof pond.PondService
         * @typedef GetDevicePreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDevicePreferencesResponse} [response] GetDevicePreferencesResponse
         */

        /**
         * Calls GetDevicePreferences.
         * @function getDevicePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDevicePreferencesRequest} request GetDevicePreferencesRequest message or plain object
         * @param {pond.PondService.GetDevicePreferencesCallback} callback Node-style callback called with the error, if any, and GetDevicePreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDevicePreferences = function getDevicePreferences(request, callback) {
            return this.rpcCall(getDevicePreferences, $root.pond.GetDevicePreferencesRequest, $root.pond.GetDevicePreferencesResponse, request, callback);
        }, "name", { value: "GetDevicePreferences" });

        /**
         * Calls GetDevicePreferences.
         * @function getDevicePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDevicePreferencesRequest} request GetDevicePreferencesRequest message or plain object
         * @returns {Promise<pond.GetDevicePreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getUserObjectHistories}.
         * @memberof pond.PondService
         * @typedef GetUserObjectHistoriesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetUserObjectHistoriesResponse} [response] GetUserObjectHistoriesResponse
         */

        /**
         * Calls GetUserObjectHistories.
         * @function getUserObjectHistories
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUserObjectHistoriesRequest} request GetUserObjectHistoriesRequest message or plain object
         * @param {pond.PondService.GetUserObjectHistoriesCallback} callback Node-style callback called with the error, if any, and GetUserObjectHistoriesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getUserObjectHistories = function getUserObjectHistories(request, callback) {
            return this.rpcCall(getUserObjectHistories, $root.pond.GetUserObjectHistoriesRequest, $root.pond.GetUserObjectHistoriesResponse, request, callback);
        }, "name", { value: "GetUserObjectHistories" });

        /**
         * Calls GetUserObjectHistories.
         * @function getUserObjectHistories
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetUserObjectHistoriesRequest} request GetUserObjectHistoriesRequest message or plain object
         * @returns {Promise<pond.GetUserObjectHistoriesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getBackpack}.
         * @memberof pond.PondService
         * @typedef GetBackpackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Backpack} [response] Backpack
         */

        /**
         * Calls GetBackpack.
         * @function getBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBackpackRequest} request GetBackpackRequest message or plain object
         * @param {pond.PondService.GetBackpackCallback} callback Node-style callback called with the error, if any, and Backpack
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getBackpack = function getBackpack(request, callback) {
            return this.rpcCall(getBackpack, $root.pond.GetBackpackRequest, $root.pond.Backpack, request, callback);
        }, "name", { value: "GetBackpack" });

        /**
         * Calls GetBackpack.
         * @function getBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBackpackRequest} request GetBackpackRequest message or plain object
         * @returns {Promise<pond.Backpack>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBackpacks}.
         * @memberof pond.PondService
         * @typedef ListBackpacksCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBackpacksResponse} [response] ListBackpacksResponse
         */

        /**
         * Calls ListBackpacks.
         * @function listBackpacks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBackpacksRequest} request ListBackpacksRequest message or plain object
         * @param {pond.PondService.ListBackpacksCallback} callback Node-style callback called with the error, if any, and ListBackpacksResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBackpacks = function listBackpacks(request, callback) {
            return this.rpcCall(listBackpacks, $root.pond.ListBackpacksRequest, $root.pond.ListBackpacksResponse, request, callback);
        }, "name", { value: "ListBackpacks" });

        /**
         * Calls ListBackpacks.
         * @function listBackpacks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBackpacksRequest} request ListBackpacksRequest message or plain object
         * @returns {Promise<pond.ListBackpacksResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addBackpack}.
         * @memberof pond.PondService
         * @typedef AddBackpackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddBackpackResponse} [response] AddBackpackResponse
         */

        /**
         * Calls AddBackpack.
         * @function addBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBackpackRequest} request AddBackpackRequest message or plain object
         * @param {pond.PondService.AddBackpackCallback} callback Node-style callback called with the error, if any, and AddBackpackResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addBackpack = function addBackpack(request, callback) {
            return this.rpcCall(addBackpack, $root.pond.AddBackpackRequest, $root.pond.AddBackpackResponse, request, callback);
        }, "name", { value: "AddBackpack" });

        /**
         * Calls AddBackpack.
         * @function addBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBackpackRequest} request AddBackpackRequest message or plain object
         * @returns {Promise<pond.AddBackpackResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateBackpack}.
         * @memberof pond.PondService
         * @typedef UpdateBackpackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateBackpackResponse} [response] UpdateBackpackResponse
         */

        /**
         * Calls UpdateBackpack.
         * @function updateBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBackpackRequest} request UpdateBackpackRequest message or plain object
         * @param {pond.PondService.UpdateBackpackCallback} callback Node-style callback called with the error, if any, and UpdateBackpackResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateBackpack = function updateBackpack(request, callback) {
            return this.rpcCall(updateBackpack, $root.pond.UpdateBackpackRequest, $root.pond.UpdateBackpackResponse, request, callback);
        }, "name", { value: "UpdateBackpack" });

        /**
         * Calls UpdateBackpack.
         * @function updateBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBackpackRequest} request UpdateBackpackRequest message or plain object
         * @returns {Promise<pond.UpdateBackpackResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeBackpack}.
         * @memberof pond.PondService
         * @typedef RemoveBackpackCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveBackpackResponse} [response] RemoveBackpackResponse
         */

        /**
         * Calls RemoveBackpack.
         * @function removeBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBackpackRequest} request RemoveBackpackRequest message or plain object
         * @param {pond.PondService.RemoveBackpackCallback} callback Node-style callback called with the error, if any, and RemoveBackpackResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeBackpack = function removeBackpack(request, callback) {
            return this.rpcCall(removeBackpack, $root.pond.RemoveBackpackRequest, $root.pond.RemoveBackpackResponse, request, callback);
        }, "name", { value: "RemoveBackpack" });

        /**
         * Calls RemoveBackpack.
         * @function removeBackpack
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBackpackRequest} request RemoveBackpackRequest message or plain object
         * @returns {Promise<pond.RemoveBackpackResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTag}.
         * @memberof pond.PondService
         * @typedef GetTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Tag} [response] Tag
         */

        /**
         * Calls GetTag.
         * @function getTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTagRequest} request GetTagRequest message or plain object
         * @param {pond.PondService.GetTagCallback} callback Node-style callback called with the error, if any, and Tag
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTag = function getTag(request, callback) {
            return this.rpcCall(getTag, $root.pond.GetTagRequest, $root.pond.Tag, request, callback);
        }, "name", { value: "GetTag" });

        /**
         * Calls GetTag.
         * @function getTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTagRequest} request GetTagRequest message or plain object
         * @returns {Promise<pond.Tag>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTags}.
         * @memberof pond.PondService
         * @typedef GetTagsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetTagsResponse} [response] GetTagsResponse
         */

        /**
         * Calls GetTags.
         * @function getTags
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTagsRequest} request GetTagsRequest message or plain object
         * @param {pond.PondService.GetTagsCallback} callback Node-style callback called with the error, if any, and GetTagsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTags = function getTags(request, callback) {
            return this.rpcCall(getTags, $root.pond.GetTagsRequest, $root.pond.GetTagsResponse, request, callback);
        }, "name", { value: "GetTags" });

        /**
         * Calls GetTags.
         * @function getTags
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTagsRequest} request GetTagsRequest message or plain object
         * @returns {Promise<pond.GetTagsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listTags}.
         * @memberof pond.PondService
         * @typedef ListTagsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListTagsResponse} [response] ListTagsResponse
         */

        /**
         * Calls ListTags.
         * @function listTags
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTagsRequest} request ListTagsRequest message or plain object
         * @param {pond.PondService.ListTagsCallback} callback Node-style callback called with the error, if any, and ListTagsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listTags = function listTags(request, callback) {
            return this.rpcCall(listTags, $root.pond.ListTagsRequest, $root.pond.ListTagsResponse, request, callback);
        }, "name", { value: "ListTags" });

        /**
         * Calls ListTags.
         * @function listTags
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTagsRequest} request ListTagsRequest message or plain object
         * @returns {Promise<pond.ListTagsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addTag}.
         * @memberof pond.PondService
         * @typedef AddTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddTagResponse} [response] AddTagResponse
         */

        /**
         * Calls AddTag.
         * @function addTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTagRequest} request AddTagRequest message or plain object
         * @param {pond.PondService.AddTagCallback} callback Node-style callback called with the error, if any, and AddTagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addTag = function addTag(request, callback) {
            return this.rpcCall(addTag, $root.pond.AddTagRequest, $root.pond.AddTagResponse, request, callback);
        }, "name", { value: "AddTag" });

        /**
         * Calls AddTag.
         * @function addTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTagRequest} request AddTagRequest message or plain object
         * @returns {Promise<pond.AddTagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTag}.
         * @memberof pond.PondService
         * @typedef UpdateTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTagResponse} [response] UpdateTagResponse
         */

        /**
         * Calls UpdateTag.
         * @function updateTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTagRequest} request UpdateTagRequest message or plain object
         * @param {pond.PondService.UpdateTagCallback} callback Node-style callback called with the error, if any, and UpdateTagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTag = function updateTag(request, callback) {
            return this.rpcCall(updateTag, $root.pond.UpdateTagRequest, $root.pond.UpdateTagResponse, request, callback);
        }, "name", { value: "UpdateTag" });

        /**
         * Calls UpdateTag.
         * @function updateTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTagRequest} request UpdateTagRequest message or plain object
         * @returns {Promise<pond.UpdateTagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeTag}.
         * @memberof pond.PondService
         * @typedef RemoveTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveTagResponse} [response] RemoveTagResponse
         */

        /**
         * Calls RemoveTag.
         * @function removeTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTagRequest} request RemoveTagRequest message or plain object
         * @param {pond.PondService.RemoveTagCallback} callback Node-style callback called with the error, if any, and RemoveTagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeTag = function removeTag(request, callback) {
            return this.rpcCall(removeTag, $root.pond.RemoveTagRequest, $root.pond.RemoveTagResponse, request, callback);
        }, "name", { value: "RemoveTag" });

        /**
         * Calls RemoveTag.
         * @function removeTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTagRequest} request RemoveTagRequest message or plain object
         * @returns {Promise<pond.RemoveTagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#attachTag}.
         * @memberof pond.PondService
         * @typedef AttachTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AttachTagResponse} [response] AttachTagResponse
         */

        /**
         * Calls AttachTag.
         * @function attachTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AttachTagRequest} request AttachTagRequest message or plain object
         * @param {pond.PondService.AttachTagCallback} callback Node-style callback called with the error, if any, and AttachTagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.attachTag = function attachTag(request, callback) {
            return this.rpcCall(attachTag, $root.pond.AttachTagRequest, $root.pond.AttachTagResponse, request, callback);
        }, "name", { value: "AttachTag" });

        /**
         * Calls AttachTag.
         * @function attachTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AttachTagRequest} request AttachTagRequest message or plain object
         * @returns {Promise<pond.AttachTagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#detachTag}.
         * @memberof pond.PondService
         * @typedef DetachTagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.DetachTagResponse} [response] DetachTagResponse
         */

        /**
         * Calls DetachTag.
         * @function detachTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.DetachTagRequest} request DetachTagRequest message or plain object
         * @param {pond.PondService.DetachTagCallback} callback Node-style callback called with the error, if any, and DetachTagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.detachTag = function detachTag(request, callback) {
            return this.rpcCall(detachTag, $root.pond.DetachTagRequest, $root.pond.DetachTagResponse, request, callback);
        }, "name", { value: "DetachTag" });

        /**
         * Calls DetachTag.
         * @function detachTag
         * @memberof pond.PondService
         * @instance
         * @param {pond.DetachTagRequest} request DetachTagRequest message or plain object
         * @returns {Promise<pond.DetachTagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getShareableLink}.
         * @memberof pond.PondService
         * @typedef GetShareableLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ShareableLink} [response] ShareableLink
         */

        /**
         * Calls GetShareableLink.
         * @function getShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetShareableLinkRequest} request GetShareableLinkRequest message or plain object
         * @param {pond.PondService.GetShareableLinkCallback} callback Node-style callback called with the error, if any, and ShareableLink
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getShareableLink = function getShareableLink(request, callback) {
            return this.rpcCall(getShareableLink, $root.pond.GetShareableLinkRequest, $root.pond.ShareableLink, request, callback);
        }, "name", { value: "GetShareableLink" });

        /**
         * Calls GetShareableLink.
         * @function getShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetShareableLinkRequest} request GetShareableLinkRequest message or plain object
         * @returns {Promise<pond.ShareableLink>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listShareableLinks}.
         * @memberof pond.PondService
         * @typedef ListShareableLinksCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListShareableLinksResponse} [response] ListShareableLinksResponse
         */

        /**
         * Calls ListShareableLinks.
         * @function listShareableLinks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListShareableLinksRequest} request ListShareableLinksRequest message or plain object
         * @param {pond.PondService.ListShareableLinksCallback} callback Node-style callback called with the error, if any, and ListShareableLinksResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listShareableLinks = function listShareableLinks(request, callback) {
            return this.rpcCall(listShareableLinks, $root.pond.ListShareableLinksRequest, $root.pond.ListShareableLinksResponse, request, callback);
        }, "name", { value: "ListShareableLinks" });

        /**
         * Calls ListShareableLinks.
         * @function listShareableLinks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListShareableLinksRequest} request ListShareableLinksRequest message or plain object
         * @returns {Promise<pond.ListShareableLinksResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addShareableLink}.
         * @memberof pond.PondService
         * @typedef AddShareableLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddShareableLinkResponse} [response] AddShareableLinkResponse
         */

        /**
         * Calls AddShareableLink.
         * @function addShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddShareableLinkRequest} request AddShareableLinkRequest message or plain object
         * @param {pond.PondService.AddShareableLinkCallback} callback Node-style callback called with the error, if any, and AddShareableLinkResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addShareableLink = function addShareableLink(request, callback) {
            return this.rpcCall(addShareableLink, $root.pond.AddShareableLinkRequest, $root.pond.AddShareableLinkResponse, request, callback);
        }, "name", { value: "AddShareableLink" });

        /**
         * Calls AddShareableLink.
         * @function addShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddShareableLinkRequest} request AddShareableLinkRequest message or plain object
         * @returns {Promise<pond.AddShareableLinkResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeShareableLink}.
         * @memberof pond.PondService
         * @typedef RemoveShareableLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveShareableLinkResponse} [response] RemoveShareableLinkResponse
         */

        /**
         * Calls RemoveShareableLink.
         * @function removeShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveShareableLinkRequest} request RemoveShareableLinkRequest message or plain object
         * @param {pond.PondService.RemoveShareableLinkCallback} callback Node-style callback called with the error, if any, and RemoveShareableLinkResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeShareableLink = function removeShareableLink(request, callback) {
            return this.rpcCall(removeShareableLink, $root.pond.RemoveShareableLinkRequest, $root.pond.RemoveShareableLinkResponse, request, callback);
        }, "name", { value: "RemoveShareableLink" });

        /**
         * Calls RemoveShareableLink.
         * @function removeShareableLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveShareableLinkRequest} request RemoveShareableLinkRequest message or plain object
         * @returns {Promise<pond.RemoveShareableLinkResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDDLogs}.
         * @memberof pond.PondService
         * @typedef ListDDLogsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.DataDogLogsResponse} [response] DataDogLogsResponse
         */

        /**
         * Calls ListDDLogs.
         * @function listDDLogs
         * @memberof pond.PondService
         * @instance
         * @param {pond.DataDogLogsRequest} request DataDogLogsRequest message or plain object
         * @param {pond.PondService.ListDDLogsCallback} callback Node-style callback called with the error, if any, and DataDogLogsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDDLogs = function listDDLogs(request, callback) {
            return this.rpcCall(listDDLogs, $root.pond.DataDogLogsRequest, $root.pond.DataDogLogsResponse, request, callback);
        }, "name", { value: "ListDDLogs" });

        /**
         * Calls ListDDLogs.
         * @function listDDLogs
         * @memberof pond.PondService
         * @instance
         * @param {pond.DataDogLogsRequest} request DataDogLogsRequest message or plain object
         * @returns {Promise<pond.DataDogLogsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#newCron}.
         * @memberof pond.PondService
         * @typedef NewCronCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.NewCronResponse} [response] NewCronResponse
         */

        /**
         * Calls NewCron.
         * @function newCron
         * @memberof pond.PondService
         * @instance
         * @param {pond.NewCronRequest} request NewCronRequest message or plain object
         * @param {pond.PondService.NewCronCallback} callback Node-style callback called with the error, if any, and NewCronResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.newCron = function newCron(request, callback) {
            return this.rpcCall(newCron, $root.pond.NewCronRequest, $root.pond.NewCronResponse, request, callback);
        }, "name", { value: "NewCron" });

        /**
         * Calls NewCron.
         * @function newCron
         * @memberof pond.PondService
         * @instance
         * @param {pond.NewCronRequest} request NewCronRequest message or plain object
         * @returns {Promise<pond.NewCronResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listCompleteHistory}.
         * @memberof pond.PondService
         * @typedef ListCompleteHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListCompleteHistoryResponse} [response] ListCompleteHistoryResponse
         */

        /**
         * Calls ListCompleteHistory.
         * @function listCompleteHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCompleteHistoryRequest} request ListCompleteHistoryRequest message or plain object
         * @param {pond.PondService.ListCompleteHistoryCallback} callback Node-style callback called with the error, if any, and ListCompleteHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listCompleteHistory = function listCompleteHistory(request, callback) {
            return this.rpcCall(listCompleteHistory, $root.pond.ListCompleteHistoryRequest, $root.pond.ListCompleteHistoryResponse, request, callback);
        }, "name", { value: "ListCompleteHistory" });

        /**
         * Calls ListCompleteHistory.
         * @function listCompleteHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCompleteHistoryRequest} request ListCompleteHistoryRequest message or plain object
         * @returns {Promise<pond.ListCompleteHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addAPIKey}.
         * @memberof pond.PondService
         * @typedef AddAPIKeyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddAPIKeyResponse} [response] AddAPIKeyResponse
         */

        /**
         * Calls AddAPIKey.
         * @function addAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddAPIKeyRequest} request AddAPIKeyRequest message or plain object
         * @param {pond.PondService.AddAPIKeyCallback} callback Node-style callback called with the error, if any, and AddAPIKeyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addAPIKey = function addAPIKey(request, callback) {
            return this.rpcCall(addAPIKey, $root.pond.AddAPIKeyRequest, $root.pond.AddAPIKeyResponse, request, callback);
        }, "name", { value: "AddAPIKey" });

        /**
         * Calls AddAPIKey.
         * @function addAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddAPIKeyRequest} request AddAPIKeyRequest message or plain object
         * @returns {Promise<pond.AddAPIKeyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listAPIKeys}.
         * @memberof pond.PondService
         * @typedef ListAPIKeysCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListAPIKeysResponse} [response] ListAPIKeysResponse
         */

        /**
         * Calls ListAPIKeys.
         * @function listAPIKeys
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListAPIKeysRequest} request ListAPIKeysRequest message or plain object
         * @param {pond.PondService.ListAPIKeysCallback} callback Node-style callback called with the error, if any, and ListAPIKeysResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listAPIKeys = function listAPIKeys(request, callback) {
            return this.rpcCall(listAPIKeys, $root.pond.ListAPIKeysRequest, $root.pond.ListAPIKeysResponse, request, callback);
        }, "name", { value: "ListAPIKeys" });

        /**
         * Calls ListAPIKeys.
         * @function listAPIKeys
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListAPIKeysRequest} request ListAPIKeysRequest message or plain object
         * @returns {Promise<pond.ListAPIKeysResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeAPIKey}.
         * @memberof pond.PondService
         * @typedef RemoveAPIKeyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveAPIKeyResponse} [response] RemoveAPIKeyResponse
         */

        /**
         * Calls RemoveAPIKey.
         * @function removeAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveAPIKeyRequest} request RemoveAPIKeyRequest message or plain object
         * @param {pond.PondService.RemoveAPIKeyCallback} callback Node-style callback called with the error, if any, and RemoveAPIKeyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeAPIKey = function removeAPIKey(request, callback) {
            return this.rpcCall(removeAPIKey, $root.pond.RemoveAPIKeyRequest, $root.pond.RemoveAPIKeyResponse, request, callback);
        }, "name", { value: "RemoveAPIKey" });

        /**
         * Calls RemoveAPIKey.
         * @function removeAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveAPIKeyRequest} request RemoveAPIKeyRequest message or plain object
         * @returns {Promise<pond.RemoveAPIKeyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTeamIDFromAPIKey}.
         * @memberof pond.PondService
         * @typedef GetTeamIDFromAPIKeyCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetTeamIDFromAPIKeyResponse} [response] GetTeamIDFromAPIKeyResponse
         */

        /**
         * Calls GetTeamIDFromAPIKey.
         * @function getTeamIDFromAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTeamIDFromAPIKeyRequest} request GetTeamIDFromAPIKeyRequest message or plain object
         * @param {pond.PondService.GetTeamIDFromAPIKeyCallback} callback Node-style callback called with the error, if any, and GetTeamIDFromAPIKeyResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTeamIDFromAPIKey = function getTeamIDFromAPIKey(request, callback) {
            return this.rpcCall(getTeamIDFromAPIKey, $root.pond.GetTeamIDFromAPIKeyRequest, $root.pond.GetTeamIDFromAPIKeyResponse, request, callback);
        }, "name", { value: "GetTeamIDFromAPIKey" });

        /**
         * Calls GetTeamIDFromAPIKey.
         * @function getTeamIDFromAPIKey
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTeamIDFromAPIKeyRequest} request GetTeamIDFromAPIKeyRequest message or plain object
         * @returns {Promise<pond.GetTeamIDFromAPIKeyResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addTransaction}.
         * @memberof pond.PondService
         * @typedef AddTransactionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddTransactionResponse} [response] AddTransactionResponse
         */

        /**
         * Calls AddTransaction.
         * @function addTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTransactionRequest} request AddTransactionRequest message or plain object
         * @param {pond.PondService.AddTransactionCallback} callback Node-style callback called with the error, if any, and AddTransactionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addTransaction = function addTransaction(request, callback) {
            return this.rpcCall(addTransaction, $root.pond.AddTransactionRequest, $root.pond.AddTransactionResponse, request, callback);
        }, "name", { value: "AddTransaction" });

        /**
         * Calls AddTransaction.
         * @function addTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTransactionRequest} request AddTransactionRequest message or plain object
         * @returns {Promise<pond.AddTransactionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listTransactions}.
         * @memberof pond.PondService
         * @typedef ListTransactionsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListTransactionsResponse} [response] ListTransactionsResponse
         */

        /**
         * Calls ListTransactions.
         * @function listTransactions
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTransactionsRequest} request ListTransactionsRequest message or plain object
         * @param {pond.PondService.ListTransactionsCallback} callback Node-style callback called with the error, if any, and ListTransactionsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listTransactions = function listTransactions(request, callback) {
            return this.rpcCall(listTransactions, $root.pond.ListTransactionsRequest, $root.pond.ListTransactionsResponse, request, callback);
        }, "name", { value: "ListTransactions" });

        /**
         * Calls ListTransactions.
         * @function listTransactions
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTransactionsRequest} request ListTransactionsRequest message or plain object
         * @returns {Promise<pond.ListTransactionsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTransaction}.
         * @memberof pond.PondService
         * @typedef UpdateTransactionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTransactionResponse} [response] UpdateTransactionResponse
         */

        /**
         * Calls UpdateTransaction.
         * @function updateTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTransactionRequest} request UpdateTransactionRequest message or plain object
         * @param {pond.PondService.UpdateTransactionCallback} callback Node-style callback called with the error, if any, and UpdateTransactionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTransaction = function updateTransaction(request, callback) {
            return this.rpcCall(updateTransaction, $root.pond.UpdateTransactionRequest, $root.pond.UpdateTransactionResponse, request, callback);
        }, "name", { value: "UpdateTransaction" });

        /**
         * Calls UpdateTransaction.
         * @function updateTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTransactionRequest} request UpdateTransactionRequest message or plain object
         * @returns {Promise<pond.UpdateTransactionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#revokeTransaction}.
         * @memberof pond.PondService
         * @typedef RevokeTransactionCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RevokeTransactionResponse} [response] RevokeTransactionResponse
         */

        /**
         * Calls RevokeTransaction.
         * @function revokeTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.RevokeTransactionRequest} request RevokeTransactionRequest message or plain object
         * @param {pond.PondService.RevokeTransactionCallback} callback Node-style callback called with the error, if any, and RevokeTransactionResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.revokeTransaction = function revokeTransaction(request, callback) {
            return this.rpcCall(revokeTransaction, $root.pond.RevokeTransactionRequest, $root.pond.RevokeTransactionResponse, request, callback);
        }, "name", { value: "RevokeTransaction" });

        /**
         * Calls RevokeTransaction.
         * @function revokeTransaction
         * @memberof pond.PondService
         * @instance
         * @param {pond.RevokeTransactionRequest} request RevokeTransactionRequest message or plain object
         * @returns {Promise<pond.RevokeTransactionResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getBinYard}.
         * @memberof pond.PondService
         * @typedef GetBinYardCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetBinYardResponse} [response] GetBinYardResponse
         */

        /**
         * Calls GetBinYard.
         * @function getBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinYardRequest} request GetBinYardRequest message or plain object
         * @param {pond.PondService.GetBinYardCallback} callback Node-style callback called with the error, if any, and GetBinYardResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getBinYard = function getBinYard(request, callback) {
            return this.rpcCall(getBinYard, $root.pond.GetBinYardRequest, $root.pond.GetBinYardResponse, request, callback);
        }, "name", { value: "GetBinYard" });

        /**
         * Calls GetBinYard.
         * @function getBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetBinYardRequest} request GetBinYardRequest message or plain object
         * @returns {Promise<pond.GetBinYardResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listBinYards}.
         * @memberof pond.PondService
         * @typedef ListBinYardsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListBinYardsResponse} [response] ListBinYardsResponse
         */

        /**
         * Calls ListBinYards.
         * @function listBinYards
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinYardsRequest} request ListBinYardsRequest message or plain object
         * @param {pond.PondService.ListBinYardsCallback} callback Node-style callback called with the error, if any, and ListBinYardsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listBinYards = function listBinYards(request, callback) {
            return this.rpcCall(listBinYards, $root.pond.ListBinYardsRequest, $root.pond.ListBinYardsResponse, request, callback);
        }, "name", { value: "ListBinYards" });

        /**
         * Calls ListBinYards.
         * @function listBinYards
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListBinYardsRequest} request ListBinYardsRequest message or plain object
         * @returns {Promise<pond.ListBinYardsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addBinYard}.
         * @memberof pond.PondService
         * @typedef AddBinYardCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddBinYardResponse} [response] AddBinYardResponse
         */

        /**
         * Calls AddBinYard.
         * @function addBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinYardRequest} request AddBinYardRequest message or plain object
         * @param {pond.PondService.AddBinYardCallback} callback Node-style callback called with the error, if any, and AddBinYardResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addBinYard = function addBinYard(request, callback) {
            return this.rpcCall(addBinYard, $root.pond.AddBinYardRequest, $root.pond.AddBinYardResponse, request, callback);
        }, "name", { value: "AddBinYard" });

        /**
         * Calls AddBinYard.
         * @function addBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddBinYardRequest} request AddBinYardRequest message or plain object
         * @returns {Promise<pond.AddBinYardResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeBinYard}.
         * @memberof pond.PondService
         * @typedef RemoveBinYardCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveBinYardResponse} [response] RemoveBinYardResponse
         */

        /**
         * Calls RemoveBinYard.
         * @function removeBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinYardRequest} request RemoveBinYardRequest message or plain object
         * @param {pond.PondService.RemoveBinYardCallback} callback Node-style callback called with the error, if any, and RemoveBinYardResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeBinYard = function removeBinYard(request, callback) {
            return this.rpcCall(removeBinYard, $root.pond.RemoveBinYardRequest, $root.pond.RemoveBinYardResponse, request, callback);
        }, "name", { value: "RemoveBinYard" });

        /**
         * Calls RemoveBinYard.
         * @function removeBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveBinYardRequest} request RemoveBinYardRequest message or plain object
         * @returns {Promise<pond.RemoveBinYardResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateBinYard}.
         * @memberof pond.PondService
         * @typedef UpdateBinYardCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateBinYardResponse} [response] UpdateBinYardResponse
         */

        /**
         * Calls UpdateBinYard.
         * @function updateBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinYardRequest} request UpdateBinYardRequest message or plain object
         * @param {pond.PondService.UpdateBinYardCallback} callback Node-style callback called with the error, if any, and UpdateBinYardResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateBinYard = function updateBinYard(request, callback) {
            return this.rpcCall(updateBinYard, $root.pond.UpdateBinYardRequest, $root.pond.UpdateBinYardResponse, request, callback);
        }, "name", { value: "UpdateBinYard" });

        /**
         * Calls UpdateBinYard.
         * @function updateBinYard
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateBinYardRequest} request UpdateBinYardRequest message or plain object
         * @returns {Promise<pond.UpdateBinYardResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getHarvestPlan}.
         * @memberof pond.PondService
         * @typedef GetHarvestPlanCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.HarvestPlan} [response] HarvestPlan
         */

        /**
         * Calls GetHarvestPlan.
         * @function getHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHarvestPlanRequest} request GetHarvestPlanRequest message or plain object
         * @param {pond.PondService.GetHarvestPlanCallback} callback Node-style callback called with the error, if any, and HarvestPlan
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getHarvestPlan = function getHarvestPlan(request, callback) {
            return this.rpcCall(getHarvestPlan, $root.pond.GetHarvestPlanRequest, $root.pond.HarvestPlan, request, callback);
        }, "name", { value: "GetHarvestPlan" });

        /**
         * Calls GetHarvestPlan.
         * @function getHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHarvestPlanRequest} request GetHarvestPlanRequest message or plain object
         * @returns {Promise<pond.HarvestPlan>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listHarvestPlans}.
         * @memberof pond.PondService
         * @typedef ListHarvestPlansCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListHarvestPlansResponse} [response] ListHarvestPlansResponse
         */

        /**
         * Calls ListHarvestPlans.
         * @function listHarvestPlans
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestPlansRequest} request ListHarvestPlansRequest message or plain object
         * @param {pond.PondService.ListHarvestPlansCallback} callback Node-style callback called with the error, if any, and ListHarvestPlansResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listHarvestPlans = function listHarvestPlans(request, callback) {
            return this.rpcCall(listHarvestPlans, $root.pond.ListHarvestPlansRequest, $root.pond.ListHarvestPlansResponse, request, callback);
        }, "name", { value: "ListHarvestPlans" });

        /**
         * Calls ListHarvestPlans.
         * @function listHarvestPlans
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestPlansRequest} request ListHarvestPlansRequest message or plain object
         * @returns {Promise<pond.ListHarvestPlansResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listHarvestPlanHistory}.
         * @memberof pond.PondService
         * @typedef ListHarvestPlanHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListHarvestPlanHistoryResponse} [response] ListHarvestPlanHistoryResponse
         */

        /**
         * Calls ListHarvestPlanHistory.
         * @function listHarvestPlanHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestPlanHistoryRequest} request ListHarvestPlanHistoryRequest message or plain object
         * @param {pond.PondService.ListHarvestPlanHistoryCallback} callback Node-style callback called with the error, if any, and ListHarvestPlanHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listHarvestPlanHistory = function listHarvestPlanHistory(request, callback) {
            return this.rpcCall(listHarvestPlanHistory, $root.pond.ListHarvestPlanHistoryRequest, $root.pond.ListHarvestPlanHistoryResponse, request, callback);
        }, "name", { value: "ListHarvestPlanHistory" });

        /**
         * Calls ListHarvestPlanHistory.
         * @function listHarvestPlanHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestPlanHistoryRequest} request ListHarvestPlanHistoryRequest message or plain object
         * @returns {Promise<pond.ListHarvestPlanHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addHarvestPlan}.
         * @memberof pond.PondService
         * @typedef AddHarvestPlanCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddHarvestPlanResponse} [response] AddHarvestPlanResponse
         */

        /**
         * Calls AddHarvestPlan.
         * @function addHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHarvestPlanRequest} request AddHarvestPlanRequest message or plain object
         * @param {pond.PondService.AddHarvestPlanCallback} callback Node-style callback called with the error, if any, and AddHarvestPlanResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addHarvestPlan = function addHarvestPlan(request, callback) {
            return this.rpcCall(addHarvestPlan, $root.pond.AddHarvestPlanRequest, $root.pond.AddHarvestPlanResponse, request, callback);
        }, "name", { value: "AddHarvestPlan" });

        /**
         * Calls AddHarvestPlan.
         * @function addHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHarvestPlanRequest} request AddHarvestPlanRequest message or plain object
         * @returns {Promise<pond.AddHarvestPlanResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeHarvestPlan}.
         * @memberof pond.PondService
         * @typedef RemoveHarvestPlanCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveHarvestPlanResponse} [response] RemoveHarvestPlanResponse
         */

        /**
         * Calls RemoveHarvestPlan.
         * @function removeHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHarvestPlanRequest} request RemoveHarvestPlanRequest message or plain object
         * @param {pond.PondService.RemoveHarvestPlanCallback} callback Node-style callback called with the error, if any, and RemoveHarvestPlanResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeHarvestPlan = function removeHarvestPlan(request, callback) {
            return this.rpcCall(removeHarvestPlan, $root.pond.RemoveHarvestPlanRequest, $root.pond.RemoveHarvestPlanResponse, request, callback);
        }, "name", { value: "RemoveHarvestPlan" });

        /**
         * Calls RemoveHarvestPlan.
         * @function removeHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHarvestPlanRequest} request RemoveHarvestPlanRequest message or plain object
         * @returns {Promise<pond.RemoveHarvestPlanResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateHarvestPlan}.
         * @memberof pond.PondService
         * @typedef UpdateHarvestPlanCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateHarvestPlanResponse} [response] UpdateHarvestPlanResponse
         */

        /**
         * Calls UpdateHarvestPlan.
         * @function updateHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHarvestPlanRequest} request UpdateHarvestPlanRequest message or plain object
         * @param {pond.PondService.UpdateHarvestPlanCallback} callback Node-style callback called with the error, if any, and UpdateHarvestPlanResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateHarvestPlan = function updateHarvestPlan(request, callback) {
            return this.rpcCall(updateHarvestPlan, $root.pond.UpdateHarvestPlanRequest, $root.pond.UpdateHarvestPlanResponse, request, callback);
        }, "name", { value: "UpdateHarvestPlan" });

        /**
         * Calls UpdateHarvestPlan.
         * @function updateHarvestPlan
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHarvestPlanRequest} request UpdateHarvestPlanRequest message or plain object
         * @returns {Promise<pond.UpdateHarvestPlanResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTeam}.
         * @memberof pond.PondService
         * @typedef GetTeamCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Team} [response] Team
         */

        /**
         * Calls GetTeam.
         * @function getTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTeamRequest} request GetTeamRequest message or plain object
         * @param {pond.PondService.GetTeamCallback} callback Node-style callback called with the error, if any, and Team
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTeam = function getTeam(request, callback) {
            return this.rpcCall(getTeam, $root.pond.GetTeamRequest, $root.pond.Team, request, callback);
        }, "name", { value: "GetTeam" });

        /**
         * Calls GetTeam.
         * @function getTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTeamRequest} request GetTeamRequest message or plain object
         * @returns {Promise<pond.Team>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listTeams}.
         * @memberof pond.PondService
         * @typedef ListTeamsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListTeamsResponse} [response] ListTeamsResponse
         */

        /**
         * Calls ListTeams.
         * @function listTeams
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTeamsRequest} request ListTeamsRequest message or plain object
         * @param {pond.PondService.ListTeamsCallback} callback Node-style callback called with the error, if any, and ListTeamsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listTeams = function listTeams(request, callback) {
            return this.rpcCall(listTeams, $root.pond.ListTeamsRequest, $root.pond.ListTeamsResponse, request, callback);
        }, "name", { value: "ListTeams" });

        /**
         * Calls ListTeams.
         * @function listTeams
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTeamsRequest} request ListTeamsRequest message or plain object
         * @returns {Promise<pond.ListTeamsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addTeam}.
         * @memberof pond.PondService
         * @typedef AddTeamCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddTeamResponse} [response] AddTeamResponse
         */

        /**
         * Calls AddTeam.
         * @function addTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTeamRequest} request AddTeamRequest message or plain object
         * @param {pond.PondService.AddTeamCallback} callback Node-style callback called with the error, if any, and AddTeamResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addTeam = function addTeam(request, callback) {
            return this.rpcCall(addTeam, $root.pond.AddTeamRequest, $root.pond.AddTeamResponse, request, callback);
        }, "name", { value: "AddTeam" });

        /**
         * Calls AddTeam.
         * @function addTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTeamRequest} request AddTeamRequest message or plain object
         * @returns {Promise<pond.AddTeamResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeTeam}.
         * @memberof pond.PondService
         * @typedef RemoveTeamCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveTeamResponse} [response] RemoveTeamResponse
         */

        /**
         * Calls RemoveTeam.
         * @function removeTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTeamRequest} request RemoveTeamRequest message or plain object
         * @param {pond.PondService.RemoveTeamCallback} callback Node-style callback called with the error, if any, and RemoveTeamResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeTeam = function removeTeam(request, callback) {
            return this.rpcCall(removeTeam, $root.pond.RemoveTeamRequest, $root.pond.RemoveTeamResponse, request, callback);
        }, "name", { value: "RemoveTeam" });

        /**
         * Calls RemoveTeam.
         * @function removeTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTeamRequest} request RemoveTeamRequest message or plain object
         * @returns {Promise<pond.RemoveTeamResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTeam}.
         * @memberof pond.PondService
         * @typedef UpdateTeamCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTeamResponse} [response] UpdateTeamResponse
         */

        /**
         * Calls UpdateTeam.
         * @function updateTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTeamRequest} request UpdateTeamRequest message or plain object
         * @param {pond.PondService.UpdateTeamCallback} callback Node-style callback called with the error, if any, and UpdateTeamResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTeam = function updateTeam(request, callback) {
            return this.rpcCall(updateTeam, $root.pond.UpdateTeamRequest, $root.pond.UpdateTeamResponse, request, callback);
        }, "name", { value: "UpdateTeam" });

        /**
         * Calls UpdateTeam.
         * @function updateTeam
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTeamRequest} request UpdateTeamRequest message or plain object
         * @returns {Promise<pond.UpdateTeamResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getNote}.
         * @memberof pond.PondService
         * @typedef GetNoteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Note} [response] Note
         */

        /**
         * Calls GetNote.
         * @function getNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetNoteRequest} request GetNoteRequest message or plain object
         * @param {pond.PondService.GetNoteCallback} callback Node-style callback called with the error, if any, and Note
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getNote = function getNote(request, callback) {
            return this.rpcCall(getNote, $root.pond.GetNoteRequest, $root.pond.Note, request, callback);
        }, "name", { value: "GetNote" });

        /**
         * Calls GetNote.
         * @function getNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetNoteRequest} request GetNoteRequest message or plain object
         * @returns {Promise<pond.Note>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listNotes}.
         * @memberof pond.PondService
         * @typedef ListNotesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListNotesResponse} [response] ListNotesResponse
         */

        /**
         * Calls ListNotes.
         * @function listNotes
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotesRequest} request ListNotesRequest message or plain object
         * @param {pond.PondService.ListNotesCallback} callback Node-style callback called with the error, if any, and ListNotesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listNotes = function listNotes(request, callback) {
            return this.rpcCall(listNotes, $root.pond.ListNotesRequest, $root.pond.ListNotesResponse, request, callback);
        }, "name", { value: "ListNotes" });

        /**
         * Calls ListNotes.
         * @function listNotes
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotesRequest} request ListNotesRequest message or plain object
         * @returns {Promise<pond.ListNotesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addNote}.
         * @memberof pond.PondService
         * @typedef AddNoteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddNoteResponse} [response] AddNoteResponse
         */

        /**
         * Calls AddNote.
         * @function addNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNoteRequest} request AddNoteRequest message or plain object
         * @param {pond.PondService.AddNoteCallback} callback Node-style callback called with the error, if any, and AddNoteResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addNote = function addNote(request, callback) {
            return this.rpcCall(addNote, $root.pond.AddNoteRequest, $root.pond.AddNoteResponse, request, callback);
        }, "name", { value: "AddNote" });

        /**
         * Calls AddNote.
         * @function addNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNoteRequest} request AddNoteRequest message or plain object
         * @returns {Promise<pond.AddNoteResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeNote}.
         * @memberof pond.PondService
         * @typedef RemoveNoteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveNoteResponse} [response] RemoveNoteResponse
         */

        /**
         * Calls RemoveNote.
         * @function removeNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveNoteRequest} request RemoveNoteRequest message or plain object
         * @param {pond.PondService.RemoveNoteCallback} callback Node-style callback called with the error, if any, and RemoveNoteResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeNote = function removeNote(request, callback) {
            return this.rpcCall(removeNote, $root.pond.RemoveNoteRequest, $root.pond.RemoveNoteResponse, request, callback);
        }, "name", { value: "RemoveNote" });

        /**
         * Calls RemoveNote.
         * @function removeNote
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveNoteRequest} request RemoveNoteRequest message or plain object
         * @returns {Promise<pond.RemoveNoteResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateNoteSettings}.
         * @memberof pond.PondService
         * @typedef UpdateNoteSettingsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateNoteSettingsResponse} [response] UpdateNoteSettingsResponse
         */

        /**
         * Calls UpdateNoteSettings.
         * @function updateNoteSettings
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateNoteSettingsRequest} request UpdateNoteSettingsRequest message or plain object
         * @param {pond.PondService.UpdateNoteSettingsCallback} callback Node-style callback called with the error, if any, and UpdateNoteSettingsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateNoteSettings = function updateNoteSettings(request, callback) {
            return this.rpcCall(updateNoteSettings, $root.pond.UpdateNoteSettingsRequest, $root.pond.UpdateNoteSettingsResponse, request, callback);
        }, "name", { value: "UpdateNoteSettings" });

        /**
         * Calls UpdateNoteSettings.
         * @function updateNoteSettings
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateNoteSettingsRequest} request UpdateNoteSettingsRequest message or plain object
         * @returns {Promise<pond.UpdateNoteSettingsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addNotification}.
         * @memberof pond.PondService
         * @typedef AddNotificationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddNotificationResponse} [response] AddNotificationResponse
         */

        /**
         * Calls AddNotification.
         * @function addNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNotificationRequest} request AddNotificationRequest message or plain object
         * @param {pond.PondService.AddNotificationCallback} callback Node-style callback called with the error, if any, and AddNotificationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addNotification = function addNotification(request, callback) {
            return this.rpcCall(addNotification, $root.pond.AddNotificationRequest, $root.pond.AddNotificationResponse, request, callback);
        }, "name", { value: "AddNotification" });

        /**
         * Calls AddNotification.
         * @function addNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNotificationRequest} request AddNotificationRequest message or plain object
         * @returns {Promise<pond.AddNotificationResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listNotifications}.
         * @memberof pond.PondService
         * @typedef ListNotificationsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListNotificationsResponse} [response] ListNotificationsResponse
         */

        /**
         * Calls ListNotifications.
         * @function listNotifications
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotificationsRequest} request ListNotificationsRequest message or plain object
         * @param {pond.PondService.ListNotificationsCallback} callback Node-style callback called with the error, if any, and ListNotificationsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listNotifications = function listNotifications(request, callback) {
            return this.rpcCall(listNotifications, $root.pond.ListNotificationsRequest, $root.pond.ListNotificationsResponse, request, callback);
        }, "name", { value: "ListNotifications" });

        /**
         * Calls ListNotifications.
         * @function listNotifications
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotificationsRequest} request ListNotificationsRequest message or plain object
         * @returns {Promise<pond.ListNotificationsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listObjectNotifications}.
         * @memberof pond.PondService
         * @typedef ListObjectNotificationsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListObjectNotificationsResponse} [response] ListObjectNotificationsResponse
         */

        /**
         * Calls ListObjectNotifications.
         * @function listObjectNotifications
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectNotificationsRequest} request ListObjectNotificationsRequest message or plain object
         * @param {pond.PondService.ListObjectNotificationsCallback} callback Node-style callback called with the error, if any, and ListObjectNotificationsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listObjectNotifications = function listObjectNotifications(request, callback) {
            return this.rpcCall(listObjectNotifications, $root.pond.ListObjectNotificationsRequest, $root.pond.ListObjectNotificationsResponse, request, callback);
        }, "name", { value: "ListObjectNotifications" });

        /**
         * Calls ListObjectNotifications.
         * @function listObjectNotifications
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectNotificationsRequest} request ListObjectNotificationsRequest message or plain object
         * @returns {Promise<pond.ListObjectNotificationsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#hideNotification}.
         * @memberof pond.PondService
         * @typedef HideNotificationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.HideNotificationResponse} [response] HideNotificationResponse
         */

        /**
         * Calls HideNotification.
         * @function hideNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.HideNotificationRequest} request HideNotificationRequest message or plain object
         * @param {pond.PondService.HideNotificationCallback} callback Node-style callback called with the error, if any, and HideNotificationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.hideNotification = function hideNotification(request, callback) {
            return this.rpcCall(hideNotification, $root.pond.HideNotificationRequest, $root.pond.HideNotificationResponse, request, callback);
        }, "name", { value: "HideNotification" });

        /**
         * Calls HideNotification.
         * @function hideNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.HideNotificationRequest} request HideNotificationRequest message or plain object
         * @returns {Promise<pond.HideNotificationResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#shareNotification}.
         * @memberof pond.PondService
         * @typedef ShareNotificationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ShareNotificationResponse} [response] ShareNotificationResponse
         */

        /**
         * Calls ShareNotification.
         * @function shareNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.ShareNotificationRequest} request ShareNotificationRequest message or plain object
         * @param {pond.PondService.ShareNotificationCallback} callback Node-style callback called with the error, if any, and ShareNotificationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.shareNotification = function shareNotification(request, callback) {
            return this.rpcCall(shareNotification, $root.pond.ShareNotificationRequest, $root.pond.ShareNotificationResponse, request, callback);
        }, "name", { value: "ShareNotification" });

        /**
         * Calls ShareNotification.
         * @function shareNotification
         * @memberof pond.PondService
         * @instance
         * @param {pond.ShareNotificationRequest} request ShareNotificationRequest message or plain object
         * @returns {Promise<pond.ShareNotificationResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTask}.
         * @memberof pond.PondService
         * @typedef GetTaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Task} [response] Task
         */

        /**
         * Calls GetTask.
         * @function getTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTaskRequest} request GetTaskRequest message or plain object
         * @param {pond.PondService.GetTaskCallback} callback Node-style callback called with the error, if any, and Task
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTask = function getTask(request, callback) {
            return this.rpcCall(getTask, $root.pond.GetTaskRequest, $root.pond.Task, request, callback);
        }, "name", { value: "GetTask" });

        /**
         * Calls GetTask.
         * @function getTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTaskRequest} request GetTaskRequest message or plain object
         * @returns {Promise<pond.Task>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listTasks}.
         * @memberof pond.PondService
         * @typedef ListTasksCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListTasksResponse} [response] ListTasksResponse
         */

        /**
         * Calls ListTasks.
         * @function listTasks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTasksRequest} request ListTasksRequest message or plain object
         * @param {pond.PondService.ListTasksCallback} callback Node-style callback called with the error, if any, and ListTasksResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listTasks = function listTasks(request, callback) {
            return this.rpcCall(listTasks, $root.pond.ListTasksRequest, $root.pond.ListTasksResponse, request, callback);
        }, "name", { value: "ListTasks" });

        /**
         * Calls ListTasks.
         * @function listTasks
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTasksRequest} request ListTasksRequest message or plain object
         * @returns {Promise<pond.ListTasksResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addTask}.
         * @memberof pond.PondService
         * @typedef AddTaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddTaskResponse} [response] AddTaskResponse
         */

        /**
         * Calls AddTask.
         * @function addTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTaskRequest} request AddTaskRequest message or plain object
         * @param {pond.PondService.AddTaskCallback} callback Node-style callback called with the error, if any, and AddTaskResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addTask = function addTask(request, callback) {
            return this.rpcCall(addTask, $root.pond.AddTaskRequest, $root.pond.AddTaskResponse, request, callback);
        }, "name", { value: "AddTask" });

        /**
         * Calls AddTask.
         * @function addTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTaskRequest} request AddTaskRequest message or plain object
         * @returns {Promise<pond.AddTaskResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeTask}.
         * @memberof pond.PondService
         * @typedef RemoveTaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveTaskResponse} [response] RemoveTaskResponse
         */

        /**
         * Calls RemoveTask.
         * @function removeTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTaskRequest} request RemoveTaskRequest message or plain object
         * @param {pond.PondService.RemoveTaskCallback} callback Node-style callback called with the error, if any, and RemoveTaskResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeTask = function removeTask(request, callback) {
            return this.rpcCall(removeTask, $root.pond.RemoveTaskRequest, $root.pond.RemoveTaskResponse, request, callback);
        }, "name", { value: "RemoveTask" });

        /**
         * Calls RemoveTask.
         * @function removeTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTaskRequest} request RemoveTaskRequest message or plain object
         * @returns {Promise<pond.RemoveTaskResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTask}.
         * @memberof pond.PondService
         * @typedef UpdateTaskCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTaskResponse} [response] UpdateTaskResponse
         */

        /**
         * Calls UpdateTask.
         * @function updateTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTaskRequest} request UpdateTaskRequest message or plain object
         * @param {pond.PondService.UpdateTaskCallback} callback Node-style callback called with the error, if any, and UpdateTaskResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTask = function updateTask(request, callback) {
            return this.rpcCall(updateTask, $root.pond.UpdateTaskRequest, $root.pond.UpdateTaskResponse, request, callback);
        }, "name", { value: "UpdateTask" });

        /**
         * Calls UpdateTask.
         * @function updateTask
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTaskRequest} request UpdateTaskRequest message or plain object
         * @returns {Promise<pond.UpdateTaskResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getMultiTasks}.
         * @memberof pond.PondService
         * @typedef GetMultiTasksCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetMultiTasksResponse} [response] GetMultiTasksResponse
         */

        /**
         * Calls GetMultiTasks.
         * @function getMultiTasks
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiTasksRequest} request GetMultiTasksRequest message or plain object
         * @param {pond.PondService.GetMultiTasksCallback} callback Node-style callback called with the error, if any, and GetMultiTasksResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getMultiTasks = function getMultiTasks(request, callback) {
            return this.rpcCall(getMultiTasks, $root.pond.GetMultiTasksRequest, $root.pond.GetMultiTasksResponse, request, callback);
        }, "name", { value: "GetMultiTasks" });

        /**
         * Calls GetMultiTasks.
         * @function getMultiTasks
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetMultiTasksRequest} request GetMultiTasksRequest message or plain object
         * @returns {Promise<pond.GetMultiTasksResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getSite}.
         * @memberof pond.PondService
         * @typedef GetSiteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Site} [response] Site
         */

        /**
         * Calls GetSite.
         * @function getSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetSiteRequest} request GetSiteRequest message or plain object
         * @param {pond.PondService.GetSiteCallback} callback Node-style callback called with the error, if any, and Site
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getSite = function getSite(request, callback) {
            return this.rpcCall(getSite, $root.pond.GetSiteRequest, $root.pond.Site, request, callback);
        }, "name", { value: "GetSite" });

        /**
         * Calls GetSite.
         * @function getSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetSiteRequest} request GetSiteRequest message or plain object
         * @returns {Promise<pond.Site>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listSites}.
         * @memberof pond.PondService
         * @typedef ListSitesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListSitesResponse} [response] ListSitesResponse
         */

        /**
         * Calls ListSites.
         * @function listSites
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListSitesRequest} request ListSitesRequest message or plain object
         * @param {pond.PondService.ListSitesCallback} callback Node-style callback called with the error, if any, and ListSitesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listSites = function listSites(request, callback) {
            return this.rpcCall(listSites, $root.pond.ListSitesRequest, $root.pond.ListSitesResponse, request, callback);
        }, "name", { value: "ListSites" });

        /**
         * Calls ListSites.
         * @function listSites
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListSitesRequest} request ListSitesRequest message or plain object
         * @returns {Promise<pond.ListSitesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addSite}.
         * @memberof pond.PondService
         * @typedef AddSiteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddSiteResponse} [response] AddSiteResponse
         */

        /**
         * Calls AddSite.
         * @function addSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddSiteRequest} request AddSiteRequest message or plain object
         * @param {pond.PondService.AddSiteCallback} callback Node-style callback called with the error, if any, and AddSiteResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addSite = function addSite(request, callback) {
            return this.rpcCall(addSite, $root.pond.AddSiteRequest, $root.pond.AddSiteResponse, request, callback);
        }, "name", { value: "AddSite" });

        /**
         * Calls AddSite.
         * @function addSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddSiteRequest} request AddSiteRequest message or plain object
         * @returns {Promise<pond.AddSiteResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeSite}.
         * @memberof pond.PondService
         * @typedef RemoveSiteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveSiteResponse} [response] RemoveSiteResponse
         */

        /**
         * Calls RemoveSite.
         * @function removeSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveSiteRequest} request RemoveSiteRequest message or plain object
         * @param {pond.PondService.RemoveSiteCallback} callback Node-style callback called with the error, if any, and RemoveSiteResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeSite = function removeSite(request, callback) {
            return this.rpcCall(removeSite, $root.pond.RemoveSiteRequest, $root.pond.RemoveSiteResponse, request, callback);
        }, "name", { value: "RemoveSite" });

        /**
         * Calls RemoveSite.
         * @function removeSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveSiteRequest} request RemoveSiteRequest message or plain object
         * @returns {Promise<pond.RemoveSiteResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateSite}.
         * @memberof pond.PondService
         * @typedef UpdateSiteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateSiteResponse} [response] UpdateSiteResponse
         */

        /**
         * Calls UpdateSite.
         * @function updateSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateSiteRequest} request UpdateSiteRequest message or plain object
         * @param {pond.PondService.UpdateSiteCallback} callback Node-style callback called with the error, if any, and UpdateSiteResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateSite = function updateSite(request, callback) {
            return this.rpcCall(updateSite, $root.pond.UpdateSiteRequest, $root.pond.UpdateSiteResponse, request, callback);
        }, "name", { value: "UpdateSite" });

        /**
         * Calls UpdateSite.
         * @function updateSite
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateSiteRequest} request UpdateSiteRequest message or plain object
         * @returns {Promise<pond.UpdateSiteResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateSiteLink}.
         * @memberof pond.PondService
         * @typedef UpdateSiteLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateSiteLinkResponse} [response] UpdateSiteLinkResponse
         */

        /**
         * Calls UpdateSiteLink.
         * @function updateSiteLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateSiteLinkRequest} request UpdateSiteLinkRequest message or plain object
         * @param {pond.PondService.UpdateSiteLinkCallback} callback Node-style callback called with the error, if any, and UpdateSiteLinkResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateSiteLink = function updateSiteLink(request, callback) {
            return this.rpcCall(updateSiteLink, $root.pond.UpdateSiteLinkRequest, $root.pond.UpdateSiteLinkResponse, request, callback);
        }, "name", { value: "UpdateSiteLink" });

        /**
         * Calls UpdateSiteLink.
         * @function updateSiteLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateSiteLinkRequest} request UpdateSiteLinkRequest message or plain object
         * @returns {Promise<pond.UpdateSiteLinkResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listSitesPageData}.
         * @memberof pond.PondService
         * @typedef ListSitesPageDataCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListSitesPageDataResponse} [response] ListSitesPageDataResponse
         */

        /**
         * Calls ListSitesPageData.
         * @function listSitesPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListSitesPageDataRequest} request ListSitesPageDataRequest message or plain object
         * @param {pond.PondService.ListSitesPageDataCallback} callback Node-style callback called with the error, if any, and ListSitesPageDataResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listSitesPageData = function listSitesPageData(request, callback) {
            return this.rpcCall(listSitesPageData, $root.pond.ListSitesPageDataRequest, $root.pond.ListSitesPageDataResponse, request, callback);
        }, "name", { value: "ListSitesPageData" });

        /**
         * Calls ListSitesPageData.
         * @function listSitesPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListSitesPageDataRequest} request ListSitesPageDataRequest message or plain object
         * @returns {Promise<pond.ListSitesPageDataResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getSitePageData}.
         * @memberof pond.PondService
         * @typedef GetSitePageDataCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetSitePageDataResponse} [response] GetSitePageDataResponse
         */

        /**
         * Calls GetSitePageData.
         * @function getSitePageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetSitePageDataRequest} request GetSitePageDataRequest message or plain object
         * @param {pond.PondService.GetSitePageDataCallback} callback Node-style callback called with the error, if any, and GetSitePageDataResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getSitePageData = function getSitePageData(request, callback) {
            return this.rpcCall(getSitePageData, $root.pond.GetSitePageDataRequest, $root.pond.GetSitePageDataResponse, request, callback);
        }, "name", { value: "GetSitePageData" });

        /**
         * Calls GetSitePageData.
         * @function getSitePageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetSitePageDataRequest} request GetSitePageDataRequest message or plain object
         * @returns {Promise<pond.GetSitePageDataResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getField}.
         * @memberof pond.PondService
         * @typedef GetFieldCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.Field} [response] Field
         */

        /**
         * Calls GetField.
         * @function getField
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFieldRequest} request GetFieldRequest message or plain object
         * @param {pond.PondService.GetFieldCallback} callback Node-style callback called with the error, if any, and Field
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getField = function getField(request, callback) {
            return this.rpcCall(getField, $root.pond.GetFieldRequest, $root.pond.Field, request, callback);
        }, "name", { value: "GetField" });

        /**
         * Calls GetField.
         * @function getField
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFieldRequest} request GetFieldRequest message or plain object
         * @returns {Promise<pond.Field>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listFields}.
         * @memberof pond.PondService
         * @typedef ListFieldsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListFieldsResponse} [response] ListFieldsResponse
         */

        /**
         * Calls ListFields.
         * @function listFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFieldsRequest} request ListFieldsRequest message or plain object
         * @param {pond.PondService.ListFieldsCallback} callback Node-style callback called with the error, if any, and ListFieldsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listFields = function listFields(request, callback) {
            return this.rpcCall(listFields, $root.pond.ListFieldsRequest, $root.pond.ListFieldsResponse, request, callback);
        }, "name", { value: "ListFields" });

        /**
         * Calls ListFields.
         * @function listFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFieldsRequest} request ListFieldsRequest message or plain object
         * @returns {Promise<pond.ListFieldsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addField}.
         * @memberof pond.PondService
         * @typedef AddFieldCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddFieldResponse} [response] AddFieldResponse
         */

        /**
         * Calls AddField.
         * @function addField
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFieldRequest} request AddFieldRequest message or plain object
         * @param {pond.PondService.AddFieldCallback} callback Node-style callback called with the error, if any, and AddFieldResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addField = function addField(request, callback) {
            return this.rpcCall(addField, $root.pond.AddFieldRequest, $root.pond.AddFieldResponse, request, callback);
        }, "name", { value: "AddField" });

        /**
         * Calls AddField.
         * @function addField
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFieldRequest} request AddFieldRequest message or plain object
         * @returns {Promise<pond.AddFieldResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeField}.
         * @memberof pond.PondService
         * @typedef RemoveFieldCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveFieldResponse} [response] RemoveFieldResponse
         */

        /**
         * Calls RemoveField.
         * @function removeField
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFieldRequest} request RemoveFieldRequest message or plain object
         * @param {pond.PondService.RemoveFieldCallback} callback Node-style callback called with the error, if any, and RemoveFieldResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeField = function removeField(request, callback) {
            return this.rpcCall(removeField, $root.pond.RemoveFieldRequest, $root.pond.RemoveFieldResponse, request, callback);
        }, "name", { value: "RemoveField" });

        /**
         * Calls RemoveField.
         * @function removeField
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFieldRequest} request RemoveFieldRequest message or plain object
         * @returns {Promise<pond.RemoveFieldResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateField}.
         * @memberof pond.PondService
         * @typedef UpdateFieldCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateFieldResponse} [response] UpdateFieldResponse
         */

        /**
         * Calls UpdateField.
         * @function updateField
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFieldRequest} request UpdateFieldRequest message or plain object
         * @param {pond.PondService.UpdateFieldCallback} callback Node-style callback called with the error, if any, and UpdateFieldResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateField = function updateField(request, callback) {
            return this.rpcCall(updateField, $root.pond.UpdateFieldRequest, $root.pond.UpdateFieldResponse, request, callback);
        }, "name", { value: "UpdateField" });

        /**
         * Calls UpdateField.
         * @function updateField
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFieldRequest} request UpdateFieldRequest message or plain object
         * @returns {Promise<pond.UpdateFieldResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getFieldMarker}.
         * @memberof pond.PondService
         * @typedef GetFieldMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.FieldMarker} [response] FieldMarker
         */

        /**
         * Calls GetFieldMarker.
         * @function getFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFieldMarkerRequest} request GetFieldMarkerRequest message or plain object
         * @param {pond.PondService.GetFieldMarkerCallback} callback Node-style callback called with the error, if any, and FieldMarker
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getFieldMarker = function getFieldMarker(request, callback) {
            return this.rpcCall(getFieldMarker, $root.pond.GetFieldMarkerRequest, $root.pond.FieldMarker, request, callback);
        }, "name", { value: "GetFieldMarker" });

        /**
         * Calls GetFieldMarker.
         * @function getFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFieldMarkerRequest} request GetFieldMarkerRequest message or plain object
         * @returns {Promise<pond.FieldMarker>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listFieldMarkers}.
         * @memberof pond.PondService
         * @typedef ListFieldMarkersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListFieldMarkersResponse} [response] ListFieldMarkersResponse
         */

        /**
         * Calls ListFieldMarkers.
         * @function listFieldMarkers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFieldMarkersRequest} request ListFieldMarkersRequest message or plain object
         * @param {pond.PondService.ListFieldMarkersCallback} callback Node-style callback called with the error, if any, and ListFieldMarkersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listFieldMarkers = function listFieldMarkers(request, callback) {
            return this.rpcCall(listFieldMarkers, $root.pond.ListFieldMarkersRequest, $root.pond.ListFieldMarkersResponse, request, callback);
        }, "name", { value: "ListFieldMarkers" });

        /**
         * Calls ListFieldMarkers.
         * @function listFieldMarkers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFieldMarkersRequest} request ListFieldMarkersRequest message or plain object
         * @returns {Promise<pond.ListFieldMarkersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addFieldMarker}.
         * @memberof pond.PondService
         * @typedef AddFieldMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddFieldMarkerResponse} [response] AddFieldMarkerResponse
         */

        /**
         * Calls AddFieldMarker.
         * @function addFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFieldMarkerRequest} request AddFieldMarkerRequest message or plain object
         * @param {pond.PondService.AddFieldMarkerCallback} callback Node-style callback called with the error, if any, and AddFieldMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addFieldMarker = function addFieldMarker(request, callback) {
            return this.rpcCall(addFieldMarker, $root.pond.AddFieldMarkerRequest, $root.pond.AddFieldMarkerResponse, request, callback);
        }, "name", { value: "AddFieldMarker" });

        /**
         * Calls AddFieldMarker.
         * @function addFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFieldMarkerRequest} request AddFieldMarkerRequest message or plain object
         * @returns {Promise<pond.AddFieldMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeFieldMarker}.
         * @memberof pond.PondService
         * @typedef RemoveFieldMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveFieldMarkerResponse} [response] RemoveFieldMarkerResponse
         */

        /**
         * Calls RemoveFieldMarker.
         * @function removeFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFieldMarkerRequest} request RemoveFieldMarkerRequest message or plain object
         * @param {pond.PondService.RemoveFieldMarkerCallback} callback Node-style callback called with the error, if any, and RemoveFieldMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeFieldMarker = function removeFieldMarker(request, callback) {
            return this.rpcCall(removeFieldMarker, $root.pond.RemoveFieldMarkerRequest, $root.pond.RemoveFieldMarkerResponse, request, callback);
        }, "name", { value: "RemoveFieldMarker" });

        /**
         * Calls RemoveFieldMarker.
         * @function removeFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveFieldMarkerRequest} request RemoveFieldMarkerRequest message or plain object
         * @returns {Promise<pond.RemoveFieldMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateFieldMarker}.
         * @memberof pond.PondService
         * @typedef UpdateFieldMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateFieldMarkerResponse} [response] UpdateFieldMarkerResponse
         */

        /**
         * Calls UpdateFieldMarker.
         * @function updateFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFieldMarkerRequest} request UpdateFieldMarkerRequest message or plain object
         * @param {pond.PondService.UpdateFieldMarkerCallback} callback Node-style callback called with the error, if any, and UpdateFieldMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateFieldMarker = function updateFieldMarker(request, callback) {
            return this.rpcCall(updateFieldMarker, $root.pond.UpdateFieldMarkerRequest, $root.pond.UpdateFieldMarkerResponse, request, callback);
        }, "name", { value: "UpdateFieldMarker" });

        /**
         * Calls UpdateFieldMarker.
         * @function updateFieldMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFieldMarkerRequest} request UpdateFieldMarkerRequest message or plain object
         * @returns {Promise<pond.UpdateFieldMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getHomeMarker}.
         * @memberof pond.PondService
         * @typedef GetHomeMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.HomeMarker} [response] HomeMarker
         */

        /**
         * Calls GetHomeMarker.
         * @function getHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHomeMarkerRequest} request GetHomeMarkerRequest message or plain object
         * @param {pond.PondService.GetHomeMarkerCallback} callback Node-style callback called with the error, if any, and HomeMarker
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getHomeMarker = function getHomeMarker(request, callback) {
            return this.rpcCall(getHomeMarker, $root.pond.GetHomeMarkerRequest, $root.pond.HomeMarker, request, callback);
        }, "name", { value: "GetHomeMarker" });

        /**
         * Calls GetHomeMarker.
         * @function getHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHomeMarkerRequest} request GetHomeMarkerRequest message or plain object
         * @returns {Promise<pond.HomeMarker>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listHomeMarkers}.
         * @memberof pond.PondService
         * @typedef ListHomeMarkersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListHomeMarkersResponse} [response] ListHomeMarkersResponse
         */

        /**
         * Calls ListHomeMarkers.
         * @function listHomeMarkers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHomeMarkersRequest} request ListHomeMarkersRequest message or plain object
         * @param {pond.PondService.ListHomeMarkersCallback} callback Node-style callback called with the error, if any, and ListHomeMarkersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listHomeMarkers = function listHomeMarkers(request, callback) {
            return this.rpcCall(listHomeMarkers, $root.pond.ListHomeMarkersRequest, $root.pond.ListHomeMarkersResponse, request, callback);
        }, "name", { value: "ListHomeMarkers" });

        /**
         * Calls ListHomeMarkers.
         * @function listHomeMarkers
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHomeMarkersRequest} request ListHomeMarkersRequest message or plain object
         * @returns {Promise<pond.ListHomeMarkersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addHomeMarker}.
         * @memberof pond.PondService
         * @typedef AddHomeMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddHomeMarkerResponse} [response] AddHomeMarkerResponse
         */

        /**
         * Calls AddHomeMarker.
         * @function addHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHomeMarkerRequest} request AddHomeMarkerRequest message or plain object
         * @param {pond.PondService.AddHomeMarkerCallback} callback Node-style callback called with the error, if any, and AddHomeMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addHomeMarker = function addHomeMarker(request, callback) {
            return this.rpcCall(addHomeMarker, $root.pond.AddHomeMarkerRequest, $root.pond.AddHomeMarkerResponse, request, callback);
        }, "name", { value: "AddHomeMarker" });

        /**
         * Calls AddHomeMarker.
         * @function addHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHomeMarkerRequest} request AddHomeMarkerRequest message or plain object
         * @returns {Promise<pond.AddHomeMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeHomeMarker}.
         * @memberof pond.PondService
         * @typedef RemoveHomeMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveHomeMarkerResponse} [response] RemoveHomeMarkerResponse
         */

        /**
         * Calls RemoveHomeMarker.
         * @function removeHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHomeMarkerRequest} request RemoveHomeMarkerRequest message or plain object
         * @param {pond.PondService.RemoveHomeMarkerCallback} callback Node-style callback called with the error, if any, and RemoveHomeMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeHomeMarker = function removeHomeMarker(request, callback) {
            return this.rpcCall(removeHomeMarker, $root.pond.RemoveHomeMarkerRequest, $root.pond.RemoveHomeMarkerResponse, request, callback);
        }, "name", { value: "RemoveHomeMarker" });

        /**
         * Calls RemoveHomeMarker.
         * @function removeHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHomeMarkerRequest} request RemoveHomeMarkerRequest message or plain object
         * @returns {Promise<pond.RemoveHomeMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateHomeMarker}.
         * @memberof pond.PondService
         * @typedef UpdateHomeMarkerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateHomeMarkerResponse} [response] UpdateHomeMarkerResponse
         */

        /**
         * Calls UpdateHomeMarker.
         * @function updateHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHomeMarkerRequest} request UpdateHomeMarkerRequest message or plain object
         * @param {pond.PondService.UpdateHomeMarkerCallback} callback Node-style callback called with the error, if any, and UpdateHomeMarkerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateHomeMarker = function updateHomeMarker(request, callback) {
            return this.rpcCall(updateHomeMarker, $root.pond.UpdateHomeMarkerRequest, $root.pond.UpdateHomeMarkerResponse, request, callback);
        }, "name", { value: "UpdateHomeMarker" });

        /**
         * Calls UpdateHomeMarker.
         * @function updateHomeMarker
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHomeMarkerRequest} request UpdateHomeMarkerRequest message or plain object
         * @returns {Promise<pond.UpdateHomeMarkerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getHarvestYear}.
         * @memberof pond.PondService
         * @typedef GetHarvestYearCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.HarvestYear} [response] HarvestYear
         */

        /**
         * Calls GetHarvestYear.
         * @function getHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHarvestYearRequest} request GetHarvestYearRequest message or plain object
         * @param {pond.PondService.GetHarvestYearCallback} callback Node-style callback called with the error, if any, and HarvestYear
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getHarvestYear = function getHarvestYear(request, callback) {
            return this.rpcCall(getHarvestYear, $root.pond.GetHarvestYearRequest, $root.pond.HarvestYear, request, callback);
        }, "name", { value: "GetHarvestYear" });

        /**
         * Calls GetHarvestYear.
         * @function getHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetHarvestYearRequest} request GetHarvestYearRequest message or plain object
         * @returns {Promise<pond.HarvestYear>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listHarvestYears}.
         * @memberof pond.PondService
         * @typedef ListHarvestYearsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListHarvestYearsResponse} [response] ListHarvestYearsResponse
         */

        /**
         * Calls ListHarvestYears.
         * @function listHarvestYears
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestYearsRequest} request ListHarvestYearsRequest message or plain object
         * @param {pond.PondService.ListHarvestYearsCallback} callback Node-style callback called with the error, if any, and ListHarvestYearsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listHarvestYears = function listHarvestYears(request, callback) {
            return this.rpcCall(listHarvestYears, $root.pond.ListHarvestYearsRequest, $root.pond.ListHarvestYearsResponse, request, callback);
        }, "name", { value: "ListHarvestYears" });

        /**
         * Calls ListHarvestYears.
         * @function listHarvestYears
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListHarvestYearsRequest} request ListHarvestYearsRequest message or plain object
         * @returns {Promise<pond.ListHarvestYearsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addHarvestYear}.
         * @memberof pond.PondService
         * @typedef AddHarvestYearCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddHarvestYearResponse} [response] AddHarvestYearResponse
         */

        /**
         * Calls AddHarvestYear.
         * @function addHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHarvestYearRequest} request AddHarvestYearRequest message or plain object
         * @param {pond.PondService.AddHarvestYearCallback} callback Node-style callback called with the error, if any, and AddHarvestYearResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addHarvestYear = function addHarvestYear(request, callback) {
            return this.rpcCall(addHarvestYear, $root.pond.AddHarvestYearRequest, $root.pond.AddHarvestYearResponse, request, callback);
        }, "name", { value: "AddHarvestYear" });

        /**
         * Calls AddHarvestYear.
         * @function addHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddHarvestYearRequest} request AddHarvestYearRequest message or plain object
         * @returns {Promise<pond.AddHarvestYearResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeHarvestYear}.
         * @memberof pond.PondService
         * @typedef RemoveHarvestYearCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveHarvestYearResponse} [response] RemoveHarvestYearResponse
         */

        /**
         * Calls RemoveHarvestYear.
         * @function removeHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHarvestYearRequest} request RemoveHarvestYearRequest message or plain object
         * @param {pond.PondService.RemoveHarvestYearCallback} callback Node-style callback called with the error, if any, and RemoveHarvestYearResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeHarvestYear = function removeHarvestYear(request, callback) {
            return this.rpcCall(removeHarvestYear, $root.pond.RemoveHarvestYearRequest, $root.pond.RemoveHarvestYearResponse, request, callback);
        }, "name", { value: "RemoveHarvestYear" });

        /**
         * Calls RemoveHarvestYear.
         * @function removeHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveHarvestYearRequest} request RemoveHarvestYearRequest message or plain object
         * @returns {Promise<pond.RemoveHarvestYearResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateHarvestYear}.
         * @memberof pond.PondService
         * @typedef UpdateHarvestYearCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateHarvestYearResponse} [response] UpdateHarvestYearResponse
         */

        /**
         * Calls UpdateHarvestYear.
         * @function updateHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHarvestYearRequest} request UpdateHarvestYearRequest message or plain object
         * @param {pond.PondService.UpdateHarvestYearCallback} callback Node-style callback called with the error, if any, and UpdateHarvestYearResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateHarvestYear = function updateHarvestYear(request, callback) {
            return this.rpcCall(updateHarvestYear, $root.pond.UpdateHarvestYearRequest, $root.pond.UpdateHarvestYearResponse, request, callback);
        }, "name", { value: "UpdateHarvestYear" });

        /**
         * Calls UpdateHarvestYear.
         * @function updateHarvestYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateHarvestYearRequest} request UpdateHarvestYearRequest message or plain object
         * @returns {Promise<pond.UpdateHarvestYearResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addTerminal}.
         * @memberof pond.PondService
         * @typedef AddTerminalCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddTerminalResponse} [response] AddTerminalResponse
         */

        /**
         * Calls AddTerminal.
         * @function addTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTerminalRequest} request AddTerminalRequest message or plain object
         * @param {pond.PondService.AddTerminalCallback} callback Node-style callback called with the error, if any, and AddTerminalResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addTerminal = function addTerminal(request, callback) {
            return this.rpcCall(addTerminal, $root.pond.AddTerminalRequest, $root.pond.AddTerminalResponse, request, callback);
        }, "name", { value: "AddTerminal" });

        /**
         * Calls AddTerminal.
         * @function addTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddTerminalRequest} request AddTerminalRequest message or plain object
         * @returns {Promise<pond.AddTerminalResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getTerminal}.
         * @memberof pond.PondService
         * @typedef GetTerminalCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetTerminalResponse} [response] GetTerminalResponse
         */

        /**
         * Calls GetTerminal.
         * @function getTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTerminalRequest} request GetTerminalRequest message or plain object
         * @param {pond.PondService.GetTerminalCallback} callback Node-style callback called with the error, if any, and GetTerminalResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getTerminal = function getTerminal(request, callback) {
            return this.rpcCall(getTerminal, $root.pond.GetTerminalRequest, $root.pond.GetTerminalResponse, request, callback);
        }, "name", { value: "GetTerminal" });

        /**
         * Calls GetTerminal.
         * @function getTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetTerminalRequest} request GetTerminalRequest message or plain object
         * @returns {Promise<pond.GetTerminalResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listTerminals}.
         * @memberof pond.PondService
         * @typedef ListTerminalsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListTerminalsResponse} [response] ListTerminalsResponse
         */

        /**
         * Calls ListTerminals.
         * @function listTerminals
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTerminalsRequest} request ListTerminalsRequest message or plain object
         * @param {pond.PondService.ListTerminalsCallback} callback Node-style callback called with the error, if any, and ListTerminalsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listTerminals = function listTerminals(request, callback) {
            return this.rpcCall(listTerminals, $root.pond.ListTerminalsRequest, $root.pond.ListTerminalsResponse, request, callback);
        }, "name", { value: "ListTerminals" });

        /**
         * Calls ListTerminals.
         * @function listTerminals
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListTerminalsRequest} request ListTerminalsRequest message or plain object
         * @returns {Promise<pond.ListTerminalsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateTerminal}.
         * @memberof pond.PondService
         * @typedef UpdateTerminalCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateTerminalResponse} [response] UpdateTerminalResponse
         */

        /**
         * Calls UpdateTerminal.
         * @function updateTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTerminalRequest} request UpdateTerminalRequest message or plain object
         * @param {pond.PondService.UpdateTerminalCallback} callback Node-style callback called with the error, if any, and UpdateTerminalResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateTerminal = function updateTerminal(request, callback) {
            return this.rpcCall(updateTerminal, $root.pond.UpdateTerminalRequest, $root.pond.UpdateTerminalResponse, request, callback);
        }, "name", { value: "UpdateTerminal" });

        /**
         * Calls UpdateTerminal.
         * @function updateTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateTerminalRequest} request UpdateTerminalRequest message or plain object
         * @returns {Promise<pond.UpdateTerminalResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeTerminal}.
         * @memberof pond.PondService
         * @typedef RemoveTerminalCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveTerminalResponse} [response] RemoveTerminalResponse
         */

        /**
         * Calls RemoveTerminal.
         * @function removeTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTerminalRequest} request RemoveTerminalRequest message or plain object
         * @param {pond.PondService.RemoveTerminalCallback} callback Node-style callback called with the error, if any, and RemoveTerminalResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeTerminal = function removeTerminal(request, callback) {
            return this.rpcCall(removeTerminal, $root.pond.RemoveTerminalRequest, $root.pond.RemoveTerminalResponse, request, callback);
        }, "name", { value: "RemoveTerminal" });

        /**
         * Calls RemoveTerminal.
         * @function removeTerminal
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveTerminalRequest} request RemoveTerminalRequest message or plain object
         * @returns {Promise<pond.RemoveTerminalResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addGate}.
         * @memberof pond.PondService
         * @typedef AddGateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddGateResponse} [response] AddGateResponse
         */

        /**
         * Calls AddGate.
         * @function addGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGateRequest} request AddGateRequest message or plain object
         * @param {pond.PondService.AddGateCallback} callback Node-style callback called with the error, if any, and AddGateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addGate = function addGate(request, callback) {
            return this.rpcCall(addGate, $root.pond.AddGateRequest, $root.pond.AddGateResponse, request, callback);
        }, "name", { value: "AddGate" });

        /**
         * Calls AddGate.
         * @function addGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGateRequest} request AddGateRequest message or plain object
         * @returns {Promise<pond.AddGateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getGate}.
         * @memberof pond.PondService
         * @typedef GetGateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetGateResponse} [response] GetGateResponse
         */

        /**
         * Calls GetGate.
         * @function getGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGateRequest} request GetGateRequest message or plain object
         * @param {pond.PondService.GetGateCallback} callback Node-style callback called with the error, if any, and GetGateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getGate = function getGate(request, callback) {
            return this.rpcCall(getGate, $root.pond.GetGateRequest, $root.pond.GetGateResponse, request, callback);
        }, "name", { value: "GetGate" });

        /**
         * Calls GetGate.
         * @function getGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGateRequest} request GetGateRequest message or plain object
         * @returns {Promise<pond.GetGateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGates}.
         * @memberof pond.PondService
         * @typedef ListGatesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGatesResponse} [response] ListGatesResponse
         */

        /**
         * Calls ListGates.
         * @function listGates
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGatesRequest} request ListGatesRequest message or plain object
         * @param {pond.PondService.ListGatesCallback} callback Node-style callback called with the error, if any, and ListGatesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGates = function listGates(request, callback) {
            return this.rpcCall(listGates, $root.pond.ListGatesRequest, $root.pond.ListGatesResponse, request, callback);
        }, "name", { value: "ListGates" });

        /**
         * Calls ListGates.
         * @function listGates
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGatesRequest} request ListGatesRequest message or plain object
         * @returns {Promise<pond.ListGatesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateGate}.
         * @memberof pond.PondService
         * @typedef UpdateGateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateGateResponse} [response] UpdateGateResponse
         */

        /**
         * Calls UpdateGate.
         * @function updateGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGateRequest} request UpdateGateRequest message or plain object
         * @param {pond.PondService.UpdateGateCallback} callback Node-style callback called with the error, if any, and UpdateGateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateGate = function updateGate(request, callback) {
            return this.rpcCall(updateGate, $root.pond.UpdateGateRequest, $root.pond.UpdateGateResponse, request, callback);
        }, "name", { value: "UpdateGate" });

        /**
         * Calls UpdateGate.
         * @function updateGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGateRequest} request UpdateGateRequest message or plain object
         * @returns {Promise<pond.UpdateGateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeGate}.
         * @memberof pond.PondService
         * @typedef RemoveGateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveGateResponse} [response] RemoveGateResponse
         */

        /**
         * Calls RemoveGate.
         * @function removeGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGateRequest} request RemoveGateRequest message or plain object
         * @param {pond.PondService.RemoveGateCallback} callback Node-style callback called with the error, if any, and RemoveGateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeGate = function removeGate(request, callback) {
            return this.rpcCall(removeGate, $root.pond.RemoveGateRequest, $root.pond.RemoveGateResponse, request, callback);
        }, "name", { value: "RemoveGate" });

        /**
         * Calls RemoveGate.
         * @function removeGate
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGateRequest} request RemoveGateRequest message or plain object
         * @returns {Promise<pond.RemoveGateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateGateLink}.
         * @memberof pond.PondService
         * @typedef UpdateGateLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateGateLinkResponse} [response] UpdateGateLinkResponse
         */

        /**
         * Calls UpdateGateLink.
         * @function updateGateLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGateLinkRequest} request UpdateGateLinkRequest message or plain object
         * @param {pond.PondService.UpdateGateLinkCallback} callback Node-style callback called with the error, if any, and UpdateGateLinkResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateGateLink = function updateGateLink(request, callback) {
            return this.rpcCall(updateGateLink, $root.pond.UpdateGateLinkRequest, $root.pond.UpdateGateLinkResponse, request, callback);
        }, "name", { value: "UpdateGateLink" });

        /**
         * Calls UpdateGateLink.
         * @function updateGateLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGateLinkRequest} request UpdateGateLinkRequest message or plain object
         * @returns {Promise<pond.UpdateGateLinkResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getGatePreferences}.
         * @memberof pond.PondService
         * @typedef GetGatePreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetGatePreferencesResponse} [response] GetGatePreferencesResponse
         */

        /**
         * Calls GetGatePreferences.
         * @function getGatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGatePreferencesRequest} request GetGatePreferencesRequest message or plain object
         * @param {pond.PondService.GetGatePreferencesCallback} callback Node-style callback called with the error, if any, and GetGatePreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getGatePreferences = function getGatePreferences(request, callback) {
            return this.rpcCall(getGatePreferences, $root.pond.GetGatePreferencesRequest, $root.pond.GetGatePreferencesResponse, request, callback);
        }, "name", { value: "GetGatePreferences" });

        /**
         * Calls GetGatePreferences.
         * @function getGatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGatePreferencesRequest} request GetGatePreferencesRequest message or plain object
         * @returns {Promise<pond.GetGatePreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateGatePreferences}.
         * @memberof pond.PondService
         * @typedef UpdateGatePreferencesCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateGatePreferencesResponse} [response] UpdateGatePreferencesResponse
         */

        /**
         * Calls UpdateGatePreferences.
         * @function updateGatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGatePreferencesRequest} request UpdateGatePreferencesRequest message or plain object
         * @param {pond.PondService.UpdateGatePreferencesCallback} callback Node-style callback called with the error, if any, and UpdateGatePreferencesResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateGatePreferences = function updateGatePreferences(request, callback) {
            return this.rpcCall(updateGatePreferences, $root.pond.UpdateGatePreferencesRequest, $root.pond.UpdateGatePreferencesResponse, request, callback);
        }, "name", { value: "UpdateGatePreferences" });

        /**
         * Calls UpdateGatePreferences.
         * @function updateGatePreferences
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGatePreferencesRequest} request UpdateGatePreferencesRequest message or plain object
         * @returns {Promise<pond.UpdateGatePreferencesResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGateAirflow}.
         * @memberof pond.PondService
         * @typedef ListGateAirflowCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGateAirflowResponse} [response] ListGateAirflowResponse
         */

        /**
         * Calls ListGateAirflow.
         * @function listGateAirflow
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateAirflowRequest} request ListGateAirflowRequest message or plain object
         * @param {pond.PondService.ListGateAirflowCallback} callback Node-style callback called with the error, if any, and ListGateAirflowResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGateAirflow = function listGateAirflow(request, callback) {
            return this.rpcCall(listGateAirflow, $root.pond.ListGateAirflowRequest, $root.pond.ListGateAirflowResponse, request, callback);
        }, "name", { value: "ListGateAirflow" });

        /**
         * Calls ListGateAirflow.
         * @function listGateAirflow
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateAirflowRequest} request ListGateAirflowRequest message or plain object
         * @returns {Promise<pond.ListGateAirflowResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGateFlowEvents}.
         * @memberof pond.PondService
         * @typedef ListGateFlowEventsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGateFlowEventsResponse} [response] ListGateFlowEventsResponse
         */

        /**
         * Calls ListGateFlowEvents.
         * @function listGateFlowEvents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateFlowEventsRequest} request ListGateFlowEventsRequest message or plain object
         * @param {pond.PondService.ListGateFlowEventsCallback} callback Node-style callback called with the error, if any, and ListGateFlowEventsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGateFlowEvents = function listGateFlowEvents(request, callback) {
            return this.rpcCall(listGateFlowEvents, $root.pond.ListGateFlowEventsRequest, $root.pond.ListGateFlowEventsResponse, request, callback);
        }, "name", { value: "ListGateFlowEvents" });

        /**
         * Calls ListGateFlowEvents.
         * @function listGateFlowEvents
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateFlowEventsRequest} request ListGateFlowEventsRequest message or plain object
         * @returns {Promise<pond.ListGateFlowEventsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGateMeasurements}.
         * @memberof pond.PondService
         * @typedef ListGateMeasurementsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGateMeasurementsResponse} [response] ListGateMeasurementsResponse
         */

        /**
         * Calls ListGateMeasurements.
         * @function listGateMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateMeasurementsRequest} request ListGateMeasurementsRequest message or plain object
         * @param {pond.PondService.ListGateMeasurementsCallback} callback Node-style callback called with the error, if any, and ListGateMeasurementsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGateMeasurements = function listGateMeasurements(request, callback) {
            return this.rpcCall(listGateMeasurements, $root.pond.ListGateMeasurementsRequest, $root.pond.ListGateMeasurementsResponse, request, callback);
        }, "name", { value: "ListGateMeasurements" });

        /**
         * Calls ListGateMeasurements.
         * @function listGateMeasurements
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGateMeasurementsRequest} request ListGateMeasurementsRequest message or plain object
         * @returns {Promise<pond.ListGateMeasurementsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getObjectHeater}.
         * @memberof pond.PondService
         * @typedef GetObjectHeaterCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetObjectHeaterResponse} [response] GetObjectHeaterResponse
         */

        /**
         * Calls GetObjectHeater.
         * @function getObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetObjectHeaterRequest} request GetObjectHeaterRequest message or plain object
         * @param {pond.PondService.GetObjectHeaterCallback} callback Node-style callback called with the error, if any, and GetObjectHeaterResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getObjectHeater = function getObjectHeater(request, callback) {
            return this.rpcCall(getObjectHeater, $root.pond.GetObjectHeaterRequest, $root.pond.GetObjectHeaterResponse, request, callback);
        }, "name", { value: "GetObjectHeater" });

        /**
         * Calls GetObjectHeater.
         * @function getObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetObjectHeaterRequest} request GetObjectHeaterRequest message or plain object
         * @returns {Promise<pond.GetObjectHeaterResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addObjectHeater}.
         * @memberof pond.PondService
         * @typedef AddObjectHeaterCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddObjectHeaterResponse} [response] AddObjectHeaterResponse
         */

        /**
         * Calls AddObjectHeater.
         * @function addObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddObjectHeaterRequest} request AddObjectHeaterRequest message or plain object
         * @param {pond.PondService.AddObjectHeaterCallback} callback Node-style callback called with the error, if any, and AddObjectHeaterResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addObjectHeater = function addObjectHeater(request, callback) {
            return this.rpcCall(addObjectHeater, $root.pond.AddObjectHeaterRequest, $root.pond.AddObjectHeaterResponse, request, callback);
        }, "name", { value: "AddObjectHeater" });

        /**
         * Calls AddObjectHeater.
         * @function addObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddObjectHeaterRequest} request AddObjectHeaterRequest message or plain object
         * @returns {Promise<pond.AddObjectHeaterResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listObjectHeaters}.
         * @memberof pond.PondService
         * @typedef ListObjectHeatersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListObjectHeatersResponse} [response] ListObjectHeatersResponse
         */

        /**
         * Calls ListObjectHeaters.
         * @function listObjectHeaters
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectHeatersRequest} request ListObjectHeatersRequest message or plain object
         * @param {pond.PondService.ListObjectHeatersCallback} callback Node-style callback called with the error, if any, and ListObjectHeatersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listObjectHeaters = function listObjectHeaters(request, callback) {
            return this.rpcCall(listObjectHeaters, $root.pond.ListObjectHeatersRequest, $root.pond.ListObjectHeatersResponse, request, callback);
        }, "name", { value: "ListObjectHeaters" });

        /**
         * Calls ListObjectHeaters.
         * @function listObjectHeaters
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectHeatersRequest} request ListObjectHeatersRequest message or plain object
         * @returns {Promise<pond.ListObjectHeatersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateObjectHeater}.
         * @memberof pond.PondService
         * @typedef UpdateObjectHeaterCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateObjectHeaterResponse} [response] UpdateObjectHeaterResponse
         */

        /**
         * Calls UpdateObjectHeater.
         * @function updateObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateObjectHeaterRequest} request UpdateObjectHeaterRequest message or plain object
         * @param {pond.PondService.UpdateObjectHeaterCallback} callback Node-style callback called with the error, if any, and UpdateObjectHeaterResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateObjectHeater = function updateObjectHeater(request, callback) {
            return this.rpcCall(updateObjectHeater, $root.pond.UpdateObjectHeaterRequest, $root.pond.UpdateObjectHeaterResponse, request, callback);
        }, "name", { value: "UpdateObjectHeater" });

        /**
         * Calls UpdateObjectHeater.
         * @function updateObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateObjectHeaterRequest} request UpdateObjectHeaterRequest message or plain object
         * @returns {Promise<pond.UpdateObjectHeaterResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeObjectHeater}.
         * @memberof pond.PondService
         * @typedef RemoveObjectHeaterCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveObjectHeaterResponse} [response] RemoveObjectHeaterResponse
         */

        /**
         * Calls RemoveObjectHeater.
         * @function removeObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveObjectHeaterRequest} request RemoveObjectHeaterRequest message or plain object
         * @param {pond.PondService.RemoveObjectHeaterCallback} callback Node-style callback called with the error, if any, and RemoveObjectHeaterResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeObjectHeater = function removeObjectHeater(request, callback) {
            return this.rpcCall(removeObjectHeater, $root.pond.RemoveObjectHeaterRequest, $root.pond.RemoveObjectHeaterResponse, request, callback);
        }, "name", { value: "RemoveObjectHeater" });

        /**
         * Calls RemoveObjectHeater.
         * @function removeObjectHeater
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveObjectHeaterRequest} request RemoveObjectHeaterRequest message or plain object
         * @returns {Promise<pond.RemoveObjectHeaterResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateObjectHeaterLink}.
         * @memberof pond.PondService
         * @typedef UpdateObjectHeaterLinkCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateObjectHeaterLinkResponse} [response] UpdateObjectHeaterLinkResponse
         */

        /**
         * Calls UpdateObjectHeaterLink.
         * @function updateObjectHeaterLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateObjectHeaterLinkRequest} request UpdateObjectHeaterLinkRequest message or plain object
         * @param {pond.PondService.UpdateObjectHeaterLinkCallback} callback Node-style callback called with the error, if any, and UpdateObjectHeaterLinkResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateObjectHeaterLink = function updateObjectHeaterLink(request, callback) {
            return this.rpcCall(updateObjectHeaterLink, $root.pond.UpdateObjectHeaterLinkRequest, $root.pond.UpdateObjectHeaterLinkResponse, request, callback);
        }, "name", { value: "UpdateObjectHeaterLink" });

        /**
         * Calls UpdateObjectHeaterLink.
         * @function updateObjectHeaterLink
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateObjectHeaterLinkRequest} request UpdateObjectHeaterLinkRequest message or plain object
         * @returns {Promise<pond.UpdateObjectHeaterLinkResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listObjectHeatersPageData}.
         * @memberof pond.PondService
         * @typedef ListObjectHeatersPageDataCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListObjectHeatersPageDataResponse} [response] ListObjectHeatersPageDataResponse
         */

        /**
         * Calls ListObjectHeatersPageData.
         * @function listObjectHeatersPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectHeatersPageDataRequest} request ListObjectHeatersPageDataRequest message or plain object
         * @param {pond.PondService.ListObjectHeatersPageDataCallback} callback Node-style callback called with the error, if any, and ListObjectHeatersPageDataResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listObjectHeatersPageData = function listObjectHeatersPageData(request, callback) {
            return this.rpcCall(listObjectHeatersPageData, $root.pond.ListObjectHeatersPageDataRequest, $root.pond.ListObjectHeatersPageDataResponse, request, callback);
        }, "name", { value: "ListObjectHeatersPageData" });

        /**
         * Calls ListObjectHeatersPageData.
         * @function listObjectHeatersPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListObjectHeatersPageDataRequest} request ListObjectHeatersPageDataRequest message or plain object
         * @returns {Promise<pond.ListObjectHeatersPageDataResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addNotificationBanner}.
         * @memberof pond.PondService
         * @typedef AddNotificationBannerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddNotificationBannerResponse} [response] AddNotificationBannerResponse
         */

        /**
         * Calls AddNotificationBanner.
         * @function addNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNotificationBannerRequest} request AddNotificationBannerRequest message or plain object
         * @param {pond.PondService.AddNotificationBannerCallback} callback Node-style callback called with the error, if any, and AddNotificationBannerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addNotificationBanner = function addNotificationBanner(request, callback) {
            return this.rpcCall(addNotificationBanner, $root.pond.AddNotificationBannerRequest, $root.pond.AddNotificationBannerResponse, request, callback);
        }, "name", { value: "AddNotificationBanner" });

        /**
         * Calls AddNotificationBanner.
         * @function addNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddNotificationBannerRequest} request AddNotificationBannerRequest message or plain object
         * @returns {Promise<pond.AddNotificationBannerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getNotificationBanner}.
         * @memberof pond.PondService
         * @typedef GetNotificationBannerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetNotificationBannerResponse} [response] GetNotificationBannerResponse
         */

        /**
         * Calls GetNotificationBanner.
         * @function getNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetNotificationBannerRequest} request GetNotificationBannerRequest message or plain object
         * @param {pond.PondService.GetNotificationBannerCallback} callback Node-style callback called with the error, if any, and GetNotificationBannerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getNotificationBanner = function getNotificationBanner(request, callback) {
            return this.rpcCall(getNotificationBanner, $root.pond.GetNotificationBannerRequest, $root.pond.GetNotificationBannerResponse, request, callback);
        }, "name", { value: "GetNotificationBanner" });

        /**
         * Calls GetNotificationBanner.
         * @function getNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetNotificationBannerRequest} request GetNotificationBannerRequest message or plain object
         * @returns {Promise<pond.GetNotificationBannerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listNotificationBanners}.
         * @memberof pond.PondService
         * @typedef ListNotificationBannersCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListNotificationBannersResponse} [response] ListNotificationBannersResponse
         */

        /**
         * Calls ListNotificationBanners.
         * @function listNotificationBanners
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotificationBannersRequest} request ListNotificationBannersRequest message or plain object
         * @param {pond.PondService.ListNotificationBannersCallback} callback Node-style callback called with the error, if any, and ListNotificationBannersResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listNotificationBanners = function listNotificationBanners(request, callback) {
            return this.rpcCall(listNotificationBanners, $root.pond.ListNotificationBannersRequest, $root.pond.ListNotificationBannersResponse, request, callback);
        }, "name", { value: "ListNotificationBanners" });

        /**
         * Calls ListNotificationBanners.
         * @function listNotificationBanners
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListNotificationBannersRequest} request ListNotificationBannersRequest message or plain object
         * @returns {Promise<pond.ListNotificationBannersResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeNotificationBanner}.
         * @memberof pond.PondService
         * @typedef RemoveNotificationBannerCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveNotificationBannerResponse} [response] RemoveNotificationBannerResponse
         */

        /**
         * Calls RemoveNotificationBanner.
         * @function removeNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveNotificationBannerRequest} request RemoveNotificationBannerRequest message or plain object
         * @param {pond.PondService.RemoveNotificationBannerCallback} callback Node-style callback called with the error, if any, and RemoveNotificationBannerResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeNotificationBanner = function removeNotificationBanner(request, callback) {
            return this.rpcCall(removeNotificationBanner, $root.pond.RemoveNotificationBannerRequest, $root.pond.RemoveNotificationBannerResponse, request, callback);
        }, "name", { value: "RemoveNotificationBanner" });

        /**
         * Calls RemoveNotificationBanner.
         * @function removeNotificationBanner
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveNotificationBannerRequest} request RemoveNotificationBannerRequest message or plain object
         * @returns {Promise<pond.RemoveNotificationBannerResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getGrainBag}.
         * @memberof pond.PondService
         * @typedef GetGrainBagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetGrainBagResponse} [response] GetGrainBagResponse
         */

        /**
         * Calls GetGrainBag.
         * @function getGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGrainBagRequest} request GetGrainBagRequest message or plain object
         * @param {pond.PondService.GetGrainBagCallback} callback Node-style callback called with the error, if any, and GetGrainBagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getGrainBag = function getGrainBag(request, callback) {
            return this.rpcCall(getGrainBag, $root.pond.GetGrainBagRequest, $root.pond.GetGrainBagResponse, request, callback);
        }, "name", { value: "GetGrainBag" });

        /**
         * Calls GetGrainBag.
         * @function getGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetGrainBagRequest} request GetGrainBagRequest message or plain object
         * @returns {Promise<pond.GetGrainBagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addGrainBag}.
         * @memberof pond.PondService
         * @typedef AddGrainBagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddGrainBagResponse} [response] AddGrainBagResponse
         */

        /**
         * Calls AddGrainBag.
         * @function addGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGrainBagRequest} request AddGrainBagRequest message or plain object
         * @param {pond.PondService.AddGrainBagCallback} callback Node-style callback called with the error, if any, and AddGrainBagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addGrainBag = function addGrainBag(request, callback) {
            return this.rpcCall(addGrainBag, $root.pond.AddGrainBagRequest, $root.pond.AddGrainBagResponse, request, callback);
        }, "name", { value: "AddGrainBag" });

        /**
         * Calls AddGrainBag.
         * @function addGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddGrainBagRequest} request AddGrainBagRequest message or plain object
         * @returns {Promise<pond.AddGrainBagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGrainBags}.
         * @memberof pond.PondService
         * @typedef ListGrainBagsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGrainBagsResponse} [response] ListGrainBagsResponse
         */

        /**
         * Calls ListGrainBags.
         * @function listGrainBags
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGrainBagsRequest} request ListGrainBagsRequest message or plain object
         * @param {pond.PondService.ListGrainBagsCallback} callback Node-style callback called with the error, if any, and ListGrainBagsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGrainBags = function listGrainBags(request, callback) {
            return this.rpcCall(listGrainBags, $root.pond.ListGrainBagsRequest, $root.pond.ListGrainBagsResponse, request, callback);
        }, "name", { value: "ListGrainBags" });

        /**
         * Calls ListGrainBags.
         * @function listGrainBags
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGrainBagsRequest} request ListGrainBagsRequest message or plain object
         * @returns {Promise<pond.ListGrainBagsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateGrainBag}.
         * @memberof pond.PondService
         * @typedef UpdateGrainBagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateGrainBagResponse} [response] UpdateGrainBagResponse
         */

        /**
         * Calls UpdateGrainBag.
         * @function updateGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGrainBagRequest} request UpdateGrainBagRequest message or plain object
         * @param {pond.PondService.UpdateGrainBagCallback} callback Node-style callback called with the error, if any, and UpdateGrainBagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateGrainBag = function updateGrainBag(request, callback) {
            return this.rpcCall(updateGrainBag, $root.pond.UpdateGrainBagRequest, $root.pond.UpdateGrainBagResponse, request, callback);
        }, "name", { value: "UpdateGrainBag" });

        /**
         * Calls UpdateGrainBag.
         * @function updateGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateGrainBagRequest} request UpdateGrainBagRequest message or plain object
         * @returns {Promise<pond.UpdateGrainBagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeGrainBag}.
         * @memberof pond.PondService
         * @typedef RemoveGrainBagCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveGrainBagResponse} [response] RemoveGrainBagResponse
         */

        /**
         * Calls RemoveGrainBag.
         * @function removeGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGrainBagRequest} request RemoveGrainBagRequest message or plain object
         * @param {pond.PondService.RemoveGrainBagCallback} callback Node-style callback called with the error, if any, and RemoveGrainBagResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeGrainBag = function removeGrainBag(request, callback) {
            return this.rpcCall(removeGrainBag, $root.pond.RemoveGrainBagRequest, $root.pond.RemoveGrainBagResponse, request, callback);
        }, "name", { value: "RemoveGrainBag" });

        /**
         * Calls RemoveGrainBag.
         * @function removeGrainBag
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveGrainBagRequest} request RemoveGrainBagRequest message or plain object
         * @returns {Promise<pond.RemoveGrainBagResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listGrainBagHistory}.
         * @memberof pond.PondService
         * @typedef ListGrainBagHistoryCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListGrainBagHistoryResponse} [response] ListGrainBagHistoryResponse
         */

        /**
         * Calls ListGrainBagHistory.
         * @function listGrainBagHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGrainBagHistoryRequest} request ListGrainBagHistoryRequest message or plain object
         * @param {pond.PondService.ListGrainBagHistoryCallback} callback Node-style callback called with the error, if any, and ListGrainBagHistoryResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listGrainBagHistory = function listGrainBagHistory(request, callback) {
            return this.rpcCall(listGrainBagHistory, $root.pond.ListGrainBagHistoryRequest, $root.pond.ListGrainBagHistoryResponse, request, callback);
        }, "name", { value: "ListGrainBagHistory" });

        /**
         * Calls ListGrainBagHistory.
         * @function listGrainBagHistory
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListGrainBagHistoryRequest} request ListGrainBagHistoryRequest message or plain object
         * @returns {Promise<pond.ListGrainBagHistoryResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#bulkGrainBagUpdate}.
         * @memberof pond.PondService
         * @typedef BulkGrainBagUpdateCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.BulkGrainBagUpdateResponse} [response] BulkGrainBagUpdateResponse
         */

        /**
         * Calls BulkGrainBagUpdate.
         * @function bulkGrainBagUpdate
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkGrainBagUpdateRequest} request BulkGrainBagUpdateRequest message or plain object
         * @param {pond.PondService.BulkGrainBagUpdateCallback} callback Node-style callback called with the error, if any, and BulkGrainBagUpdateResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.bulkGrainBagUpdate = function bulkGrainBagUpdate(request, callback) {
            return this.rpcCall(bulkGrainBagUpdate, $root.pond.BulkGrainBagUpdateRequest, $root.pond.BulkGrainBagUpdateResponse, request, callback);
        }, "name", { value: "BulkGrainBagUpdate" });

        /**
         * Calls BulkGrainBagUpdate.
         * @function bulkGrainBagUpdate
         * @memberof pond.PondService
         * @instance
         * @param {pond.BulkGrainBagUpdateRequest} request BulkGrainBagUpdateRequest message or plain object
         * @returns {Promise<pond.BulkGrainBagUpdateResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listContracts}.
         * @memberof pond.PondService
         * @typedef ListContractsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListContractsResponse} [response] ListContractsResponse
         */

        /**
         * Calls ListContracts.
         * @function listContracts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListContractsRequest} request ListContractsRequest message or plain object
         * @param {pond.PondService.ListContractsCallback} callback Node-style callback called with the error, if any, and ListContractsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listContracts = function listContracts(request, callback) {
            return this.rpcCall(listContracts, $root.pond.ListContractsRequest, $root.pond.ListContractsResponse, request, callback);
        }, "name", { value: "ListContracts" });

        /**
         * Calls ListContracts.
         * @function listContracts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListContractsRequest} request ListContractsRequest message or plain object
         * @returns {Promise<pond.ListContractsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getContract}.
         * @memberof pond.PondService
         * @typedef GetContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetContractResponse} [response] GetContractResponse
         */

        /**
         * Calls GetContract.
         * @function getContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetContractRequest} request GetContractRequest message or plain object
         * @param {pond.PondService.GetContractCallback} callback Node-style callback called with the error, if any, and GetContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getContract = function getContract(request, callback) {
            return this.rpcCall(getContract, $root.pond.GetContractRequest, $root.pond.GetContractResponse, request, callback);
        }, "name", { value: "GetContract" });

        /**
         * Calls GetContract.
         * @function getContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetContractRequest} request GetContractRequest message or plain object
         * @returns {Promise<pond.GetContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addContract}.
         * @memberof pond.PondService
         * @typedef AddContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddContractResponse} [response] AddContractResponse
         */

        /**
         * Calls AddContract.
         * @function addContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddContractRequest} request AddContractRequest message or plain object
         * @param {pond.PondService.AddContractCallback} callback Node-style callback called with the error, if any, and AddContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addContract = function addContract(request, callback) {
            return this.rpcCall(addContract, $root.pond.AddContractRequest, $root.pond.AddContractResponse, request, callback);
        }, "name", { value: "AddContract" });

        /**
         * Calls AddContract.
         * @function addContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddContractRequest} request AddContractRequest message or plain object
         * @returns {Promise<pond.AddContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateContract}.
         * @memberof pond.PondService
         * @typedef UpdateContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateContractResponse} [response] UpdateContractResponse
         */

        /**
         * Calls UpdateContract.
         * @function updateContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateContractRequest} request UpdateContractRequest message or plain object
         * @param {pond.PondService.UpdateContractCallback} callback Node-style callback called with the error, if any, and UpdateContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateContract = function updateContract(request, callback) {
            return this.rpcCall(updateContract, $root.pond.UpdateContractRequest, $root.pond.UpdateContractResponse, request, callback);
        }, "name", { value: "UpdateContract" });

        /**
         * Calls UpdateContract.
         * @function updateContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateContractRequest} request UpdateContractRequest message or plain object
         * @returns {Promise<pond.UpdateContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#removeContract}.
         * @memberof pond.PondService
         * @typedef RemoveContractCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.RemoveContractResponse} [response] RemoveContractResponse
         */

        /**
         * Calls RemoveContract.
         * @function removeContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveContractRequest} request RemoveContractRequest message or plain object
         * @param {pond.PondService.RemoveContractCallback} callback Node-style callback called with the error, if any, and RemoveContractResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.removeContract = function removeContract(request, callback) {
            return this.rpcCall(removeContract, $root.pond.RemoveContractRequest, $root.pond.RemoveContractResponse, request, callback);
        }, "name", { value: "RemoveContract" });

        /**
         * Calls RemoveContract.
         * @function removeContract
         * @memberof pond.PondService
         * @instance
         * @param {pond.RemoveContractRequest} request RemoveContractRequest message or plain object
         * @returns {Promise<pond.RemoveContractResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listContractsByYear}.
         * @memberof pond.PondService
         * @typedef ListContractsByYearCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListContractsByYearResponse} [response] ListContractsByYearResponse
         */

        /**
         * Calls ListContractsByYear.
         * @function listContractsByYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListContractsByYearRequest} request ListContractsByYearRequest message or plain object
         * @param {pond.PondService.ListContractsByYearCallback} callback Node-style callback called with the error, if any, and ListContractsByYearResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listContractsByYear = function listContractsByYear(request, callback) {
            return this.rpcCall(listContractsByYear, $root.pond.ListContractsByYearRequest, $root.pond.ListContractsByYearResponse, request, callback);
        }, "name", { value: "ListContractsByYear" });

        /**
         * Calls ListContractsByYear.
         * @function listContractsByYear
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListContractsByYearRequest} request ListContractsByYearRequest message or plain object
         * @returns {Promise<pond.ListContractsByYearResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getContractPageData}.
         * @memberof pond.PondService
         * @typedef GetContractPageDataCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetContractPageDataResponse} [response] GetContractPageDataResponse
         */

        /**
         * Calls GetContractPageData.
         * @function getContractPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetContractPageDataRequest} request GetContractPageDataRequest message or plain object
         * @param {pond.PondService.GetContractPageDataCallback} callback Node-style callback called with the error, if any, and GetContractPageDataResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getContractPageData = function getContractPageData(request, callback) {
            return this.rpcCall(getContractPageData, $root.pond.GetContractPageDataRequest, $root.pond.GetContractPageDataResponse, request, callback);
        }, "name", { value: "GetContractPageData" });

        /**
         * Calls GetContractPageData.
         * @function getContractPageData
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetContractPageDataRequest} request GetContractPageDataRequest message or plain object
         * @returns {Promise<pond.GetContractPageDataResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addJDAccount}.
         * @memberof pond.PondService
         * @typedef AddJDAccountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddJDAccountResponse} [response] AddJDAccountResponse
         */

        /**
         * Calls AddJDAccount.
         * @function addJDAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddJDAccountRequest} request AddJDAccountRequest message or plain object
         * @param {pond.PondService.AddJDAccountCallback} callback Node-style callback called with the error, if any, and AddJDAccountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addJDAccount = function addJDAccount(request, callback) {
            return this.rpcCall(addJDAccount, $root.pond.AddJDAccountRequest, $root.pond.AddJDAccountResponse, request, callback);
        }, "name", { value: "AddJDAccount" });

        /**
         * Calls AddJDAccount.
         * @function addJDAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddJDAccountRequest} request AddJDAccountRequest message or plain object
         * @returns {Promise<pond.AddJDAccountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listJDAccounts}.
         * @memberof pond.PondService
         * @typedef ListJDAccountsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListJDAccountsResponse} [response] ListJDAccountsResponse
         */

        /**
         * Calls ListJDAccounts.
         * @function listJDAccounts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListJDAccountsRequest} request ListJDAccountsRequest message or plain object
         * @param {pond.PondService.ListJDAccountsCallback} callback Node-style callback called with the error, if any, and ListJDAccountsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listJDAccounts = function listJDAccounts(request, callback) {
            return this.rpcCall(listJDAccounts, $root.pond.ListJDAccountsRequest, $root.pond.ListJDAccountsResponse, request, callback);
        }, "name", { value: "ListJDAccounts" });

        /**
         * Calls ListJDAccounts.
         * @function listJDAccounts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListJDAccountsRequest} request ListJDAccountsRequest message or plain object
         * @returns {Promise<pond.ListJDAccountsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateJDAccount}.
         * @memberof pond.PondService
         * @typedef UpdateJDAccountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateJDAccountResponse} [response] UpdateJDAccountResponse
         */

        /**
         * Calls UpdateJDAccount.
         * @function updateJDAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateJDAccountRequest} request UpdateJDAccountRequest message or plain object
         * @param {pond.PondService.UpdateJDAccountCallback} callback Node-style callback called with the error, if any, and UpdateJDAccountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateJDAccount = function updateJDAccount(request, callback) {
            return this.rpcCall(updateJDAccount, $root.pond.UpdateJDAccountRequest, $root.pond.UpdateJDAccountResponse, request, callback);
        }, "name", { value: "UpdateJDAccount" });

        /**
         * Calls UpdateJDAccount.
         * @function updateJDAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateJDAccountRequest} request UpdateJDAccountRequest message or plain object
         * @returns {Promise<pond.UpdateJDAccountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listJDFields}.
         * @memberof pond.PondService
         * @typedef ListJDFieldsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListJDFieldsResponse} [response] ListJDFieldsResponse
         */

        /**
         * Calls ListJDFields.
         * @function listJDFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListJDFieldsRequest} request ListJDFieldsRequest message or plain object
         * @param {pond.PondService.ListJDFieldsCallback} callback Node-style callback called with the error, if any, and ListJDFieldsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listJDFields = function listJDFields(request, callback) {
            return this.rpcCall(listJDFields, $root.pond.ListJDFieldsRequest, $root.pond.ListJDFieldsResponse, request, callback);
        }, "name", { value: "ListJDFields" });

        /**
         * Calls ListJDFields.
         * @function listJDFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListJDFieldsRequest} request ListJDFieldsRequest message or plain object
         * @returns {Promise<pond.ListJDFieldsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addCNHiAccount}.
         * @memberof pond.PondService
         * @typedef AddCNHiAccountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddCNHiAccountResponse} [response] AddCNHiAccountResponse
         */

        /**
         * Calls AddCNHiAccount.
         * @function addCNHiAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddCNHiAccountRequest} request AddCNHiAccountRequest message or plain object
         * @param {pond.PondService.AddCNHiAccountCallback} callback Node-style callback called with the error, if any, and AddCNHiAccountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addCNHiAccount = function addCNHiAccount(request, callback) {
            return this.rpcCall(addCNHiAccount, $root.pond.AddCNHiAccountRequest, $root.pond.AddCNHiAccountResponse, request, callback);
        }, "name", { value: "AddCNHiAccount" });

        /**
         * Calls AddCNHiAccount.
         * @function addCNHiAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddCNHiAccountRequest} request AddCNHiAccountRequest message or plain object
         * @returns {Promise<pond.AddCNHiAccountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listCNHiAccounts}.
         * @memberof pond.PondService
         * @typedef ListCNHiAccountsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListCNHiAccountsResponse} [response] ListCNHiAccountsResponse
         */

        /**
         * Calls ListCNHiAccounts.
         * @function listCNHiAccounts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCNHiAccountsRequest} request ListCNHiAccountsRequest message or plain object
         * @param {pond.PondService.ListCNHiAccountsCallback} callback Node-style callback called with the error, if any, and ListCNHiAccountsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listCNHiAccounts = function listCNHiAccounts(request, callback) {
            return this.rpcCall(listCNHiAccounts, $root.pond.ListCNHiAccountsRequest, $root.pond.ListCNHiAccountsResponse, request, callback);
        }, "name", { value: "ListCNHiAccounts" });

        /**
         * Calls ListCNHiAccounts.
         * @function listCNHiAccounts
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCNHiAccountsRequest} request ListCNHiAccountsRequest message or plain object
         * @returns {Promise<pond.ListCNHiAccountsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateCNHiAccount}.
         * @memberof pond.PondService
         * @typedef UpdateCNHiAccountCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateCNHiAccountResponse} [response] UpdateCNHiAccountResponse
         */

        /**
         * Calls UpdateCNHiAccount.
         * @function updateCNHiAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateCNHiAccountRequest} request UpdateCNHiAccountRequest message or plain object
         * @param {pond.PondService.UpdateCNHiAccountCallback} callback Node-style callback called with the error, if any, and UpdateCNHiAccountResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateCNHiAccount = function updateCNHiAccount(request, callback) {
            return this.rpcCall(updateCNHiAccount, $root.pond.UpdateCNHiAccountRequest, $root.pond.UpdateCNHiAccountResponse, request, callback);
        }, "name", { value: "UpdateCNHiAccount" });

        /**
         * Calls UpdateCNHiAccount.
         * @function updateCNHiAccount
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateCNHiAccountRequest} request UpdateCNHiAccountRequest message or plain object
         * @returns {Promise<pond.UpdateCNHiAccountResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listCNHiFields}.
         * @memberof pond.PondService
         * @typedef ListCNHiFieldsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListCNHiFieldsResponse} [response] ListCNHiFieldsResponse
         */

        /**
         * Calls ListCNHiFields.
         * @function listCNHiFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCNHiFieldsRequest} request ListCNHiFieldsRequest message or plain object
         * @param {pond.PondService.ListCNHiFieldsCallback} callback Node-style callback called with the error, if any, and ListCNHiFieldsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listCNHiFields = function listCNHiFields(request, callback) {
            return this.rpcCall(listCNHiFields, $root.pond.ListCNHiFieldsRequest, $root.pond.ListCNHiFieldsResponse, request, callback);
        }, "name", { value: "ListCNHiFields" });

        /**
         * Calls ListCNHiFields.
         * @function listCNHiFields
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListCNHiFieldsRequest} request ListCNHiFieldsRequest message or plain object
         * @returns {Promise<pond.ListCNHiFieldsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addFile}.
         * @memberof pond.PondService
         * @typedef AddFileCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddFileResponse} [response] AddFileResponse
         */

        /**
         * Calls AddFile.
         * @function addFile
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFileRequest} request AddFileRequest message or plain object
         * @param {pond.PondService.AddFileCallback} callback Node-style callback called with the error, if any, and AddFileResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addFile = function addFile(request, callback) {
            return this.rpcCall(addFile, $root.pond.AddFileRequest, $root.pond.AddFileResponse, request, callback);
        }, "name", { value: "AddFile" });

        /**
         * Calls AddFile.
         * @function addFile
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddFileRequest} request AddFileRequest message or plain object
         * @returns {Promise<pond.AddFileResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateFileStatus}.
         * @memberof pond.PondService
         * @typedef UpdateFileStatusCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateFileStatusResponse} [response] UpdateFileStatusResponse
         */

        /**
         * Calls UpdateFileStatus.
         * @function updateFileStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFileStatusRequest} request UpdateFileStatusRequest message or plain object
         * @param {pond.PondService.UpdateFileStatusCallback} callback Node-style callback called with the error, if any, and UpdateFileStatusResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateFileStatus = function updateFileStatus(request, callback) {
            return this.rpcCall(updateFileStatus, $root.pond.UpdateFileStatusRequest, $root.pond.UpdateFileStatusResponse, request, callback);
        }, "name", { value: "UpdateFileStatus" });

        /**
         * Calls UpdateFileStatus.
         * @function updateFileStatus
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateFileStatusRequest} request UpdateFileStatusRequest message or plain object
         * @returns {Promise<pond.UpdateFileStatusResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listFileRefs}.
         * @memberof pond.PondService
         * @typedef ListFileRefsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListFileRefsResponse} [response] ListFileRefsResponse
         */

        /**
         * Calls ListFileRefs.
         * @function listFileRefs
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFileRefsRequest} request ListFileRefsRequest message or plain object
         * @param {pond.PondService.ListFileRefsCallback} callback Node-style callback called with the error, if any, and ListFileRefsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listFileRefs = function listFileRefs(request, callback) {
            return this.rpcCall(listFileRefs, $root.pond.ListFileRefsRequest, $root.pond.ListFileRefsResponse, request, callback);
        }, "name", { value: "ListFileRefs" });

        /**
         * Calls ListFileRefs.
         * @function listFileRefs
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListFileRefsRequest} request ListFileRefsRequest message or plain object
         * @returns {Promise<pond.ListFileRefsResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getFileRef}.
         * @memberof pond.PondService
         * @typedef GetFileRefCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetFileRefResponse} [response] GetFileRefResponse
         */

        /**
         * Calls GetFileRef.
         * @function getFileRef
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFileRefRequest} request GetFileRefRequest message or plain object
         * @param {pond.PondService.GetFileRefCallback} callback Node-style callback called with the error, if any, and GetFileRefResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getFileRef = function getFileRef(request, callback) {
            return this.rpcCall(getFileRef, $root.pond.GetFileRefRequest, $root.pond.GetFileRefResponse, request, callback);
        }, "name", { value: "GetFileRef" });

        /**
         * Calls GetFileRef.
         * @function getFileRef
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetFileRefRequest} request GetFileRefRequest message or plain object
         * @returns {Promise<pond.GetFileRefResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#addDevicePreset}.
         * @memberof pond.PondService
         * @typedef AddDevicePresetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.AddDevicePresetResponse} [response] AddDevicePresetResponse
         */

        /**
         * Calls AddDevicePreset.
         * @function addDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddDevicePresetRequest} request AddDevicePresetRequest message or plain object
         * @param {pond.PondService.AddDevicePresetCallback} callback Node-style callback called with the error, if any, and AddDevicePresetResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.addDevicePreset = function addDevicePreset(request, callback) {
            return this.rpcCall(addDevicePreset, $root.pond.AddDevicePresetRequest, $root.pond.AddDevicePresetResponse, request, callback);
        }, "name", { value: "AddDevicePreset" });

        /**
         * Calls AddDevicePreset.
         * @function addDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.AddDevicePresetRequest} request AddDevicePresetRequest message or plain object
         * @returns {Promise<pond.AddDevicePresetResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#updateDevicePreset}.
         * @memberof pond.PondService
         * @typedef UpdateDevicePresetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.UpdateDevicePresetResponse} [response] UpdateDevicePresetResponse
         */

        /**
         * Calls UpdateDevicePreset.
         * @function updateDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDevicePresetRequest} request UpdateDevicePresetRequest message or plain object
         * @param {pond.PondService.UpdateDevicePresetCallback} callback Node-style callback called with the error, if any, and UpdateDevicePresetResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.updateDevicePreset = function updateDevicePreset(request, callback) {
            return this.rpcCall(updateDevicePreset, $root.pond.UpdateDevicePresetRequest, $root.pond.UpdateDevicePresetResponse, request, callback);
        }, "name", { value: "UpdateDevicePreset" });

        /**
         * Calls UpdateDevicePreset.
         * @function updateDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.UpdateDevicePresetRequest} request UpdateDevicePresetRequest message or plain object
         * @returns {Promise<pond.UpdateDevicePresetResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#listDevicePresets}.
         * @memberof pond.PondService
         * @typedef ListDevicePresetsCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.ListDevicePresetResponse} [response] ListDevicePresetResponse
         */

        /**
         * Calls ListDevicePresets.
         * @function listDevicePresets
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDevicePresetRequest} request ListDevicePresetRequest message or plain object
         * @param {pond.PondService.ListDevicePresetsCallback} callback Node-style callback called with the error, if any, and ListDevicePresetResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.listDevicePresets = function listDevicePresets(request, callback) {
            return this.rpcCall(listDevicePresets, $root.pond.ListDevicePresetRequest, $root.pond.ListDevicePresetResponse, request, callback);
        }, "name", { value: "ListDevicePresets" });

        /**
         * Calls ListDevicePresets.
         * @function listDevicePresets
         * @memberof pond.PondService
         * @instance
         * @param {pond.ListDevicePresetRequest} request ListDevicePresetRequest message or plain object
         * @returns {Promise<pond.ListDevicePresetResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#deleteDevicePreset}.
         * @memberof pond.PondService
         * @typedef DeleteDevicePresetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.DeleteDevicePresetResponse} [response] DeleteDevicePresetResponse
         */

        /**
         * Calls DeleteDevicePreset.
         * @function deleteDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.DeleteDevicePresetRequest} request DeleteDevicePresetRequest message or plain object
         * @param {pond.PondService.DeleteDevicePresetCallback} callback Node-style callback called with the error, if any, and DeleteDevicePresetResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.deleteDevicePreset = function deleteDevicePreset(request, callback) {
            return this.rpcCall(deleteDevicePreset, $root.pond.DeleteDevicePresetRequest, $root.pond.DeleteDevicePresetResponse, request, callback);
        }, "name", { value: "DeleteDevicePreset" });

        /**
         * Calls DeleteDevicePreset.
         * @function deleteDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.DeleteDevicePresetRequest} request DeleteDevicePresetRequest message or plain object
         * @returns {Promise<pond.DeleteDevicePresetResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#getDevicePreset}.
         * @memberof pond.PondService
         * @typedef GetDevicePresetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.GetDevicePresetResponse} [response] GetDevicePresetResponse
         */

        /**
         * Calls GetDevicePreset.
         * @function getDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDevicePresetRequest} request GetDevicePresetRequest message or plain object
         * @param {pond.PondService.GetDevicePresetCallback} callback Node-style callback called with the error, if any, and GetDevicePresetResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.getDevicePreset = function getDevicePreset(request, callback) {
            return this.rpcCall(getDevicePreset, $root.pond.GetDevicePresetRequest, $root.pond.GetDevicePresetResponse, request, callback);
        }, "name", { value: "GetDevicePreset" });

        /**
         * Calls GetDevicePreset.
         * @function getDevicePreset
         * @memberof pond.PondService
         * @instance
         * @param {pond.GetDevicePresetRequest} request GetDevicePresetRequest message or plain object
         * @returns {Promise<pond.GetDevicePresetResponse>} Promise
         * @variation 2
         */

        /**
         * Callback as used by {@link pond.PondService#linearMutation}.
         * @memberof pond.PondService
         * @typedef LinearMutationCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {pond.LinearMutationResponse} [response] LinearMutationResponse
         */

        /**
         * Calls LinearMutation.
         * @function linearMutation
         * @memberof pond.PondService
         * @instance
         * @param {pond.LinearMutationRequest} request LinearMutationRequest message or plain object
         * @param {pond.PondService.LinearMutationCallback} callback Node-style callback called with the error, if any, and LinearMutationResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(PondService.prototype.linearMutation = function linearMutation(request, callback) {
            return this.rpcCall(linearMutation, $root.pond.LinearMutationRequest, $root.pond.LinearMutationResponse, request, callback);
        }, "name", { value: "LinearMutation" });

        /**
         * Calls LinearMutation.
         * @function linearMutation
         * @memberof pond.PondService
         * @instance
         * @param {pond.LinearMutationRequest} request LinearMutationRequest message or plain object
         * @returns {Promise<pond.LinearMutationResponse>} Promise
         * @variation 2
         */

        return PondService;
    })();

    pond.FileData = (function() {

        /**
         * Properties of a FileData.
         * @memberof pond
         * @interface IFileData
         * @property {string|null} [contentType] FileData contentType
         * @property {number|null} [fileSize] FileData fileSize
         */

        /**
         * Constructs a new FileData.
         * @memberof pond
         * @classdesc Represents a FileData.
         * @implements IFileData
         * @constructor
         * @param {pond.IFileData=} [properties] Properties to set
         */
        function FileData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileData contentType.
         * @member {string} contentType
         * @memberof pond.FileData
         * @instance
         */
        FileData.prototype.contentType = "";

        /**
         * FileData fileSize.
         * @member {number} fileSize
         * @memberof pond.FileData
         * @instance
         */
        FileData.prototype.fileSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new FileData instance using the specified properties.
         * @function create
         * @memberof pond.FileData
         * @static
         * @param {pond.IFileData=} [properties] Properties to set
         * @returns {pond.FileData} FileData instance
         */
        FileData.create = function create(properties) {
            return new FileData(properties);
        };

        /**
         * Creates a FileData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FileData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FileData} FileData
         */
        FileData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FileData)
                return object;
            var message = new $root.pond.FileData();
            if (object.contentType != null)
                message.contentType = String(object.contentType);
            if (object.fileSize != null)
                if ($util.Long)
                    (message.fileSize = $util.Long.fromValue(object.fileSize)).unsigned = false;
                else if (typeof object.fileSize === "string")
                    message.fileSize = parseInt(object.fileSize, 10);
                else if (typeof object.fileSize === "number")
                    message.fileSize = object.fileSize;
                else if (typeof object.fileSize === "object")
                    message.fileSize = new $util.LongBits(object.fileSize.low >>> 0, object.fileSize.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a FileData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FileData
         * @static
         * @param {pond.FileData} message FileData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.contentType = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.fileSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fileSize = options.longs === String ? "0" : 0;
            }
            if (message.contentType != null && message.hasOwnProperty("contentType"))
                object.contentType = message.contentType;
            if (message.fileSize != null && message.hasOwnProperty("fileSize"))
                if (typeof message.fileSize === "number")
                    object.fileSize = options.longs === String ? String(message.fileSize) : message.fileSize;
                else
                    object.fileSize = options.longs === String ? $util.Long.prototype.toString.call(message.fileSize) : options.longs === Number ? new $util.LongBits(message.fileSize.low >>> 0, message.fileSize.high >>> 0).toNumber() : message.fileSize;
            return object;
        };

        /**
         * Converts this FileData to JSON.
         * @function toJSON
         * @memberof pond.FileData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileData;
    })();

    /**
     * FileStatus enum.
     * @name pond.FileStatus
     * @enum {string}
     * @property {number} FILE_STATUS_UNKNOWN=0 FILE_STATUS_UNKNOWN value
     * @property {number} FILE_STATUS_PENDING=1 FILE_STATUS_PENDING value
     * @property {number} FILE_STATUS_OK=2 FILE_STATUS_OK value
     * @property {number} FILE_STATUS_DELETED=3 FILE_STATUS_DELETED value
     * @property {number} FILE_STATUS_ORPHAN=4 FILE_STATUS_ORPHAN value
     * @property {number} FILE_STATUS_UPLOAD_FAILED=5 FILE_STATUS_UPLOAD_FAILED value
     */
    pond.FileStatus = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FILE_STATUS_UNKNOWN"] = 0;
        values[valuesById[1] = "FILE_STATUS_PENDING"] = 1;
        values[valuesById[2] = "FILE_STATUS_OK"] = 2;
        values[valuesById[3] = "FILE_STATUS_DELETED"] = 3;
        values[valuesById[4] = "FILE_STATUS_ORPHAN"] = 4;
        values[valuesById[5] = "FILE_STATUS_UPLOAD_FAILED"] = 5;
        return values;
    })();

    pond.AddFileRequest = (function() {

        /**
         * Properties of an AddFileRequest.
         * @memberof pond
         * @interface IAddFileRequest
         * @property {string|null} [fileName] AddFileRequest fileName
         * @property {pond.FileData|null} [metadata] AddFileRequest metadata
         * @property {string|null} [toAttach] AddFileRequest toAttach
         * @property {pond.ObjectType|null} [objectType] AddFileRequest objectType
         */

        /**
         * Constructs a new AddFileRequest.
         * @memberof pond
         * @classdesc Represents an AddFileRequest.
         * @implements IAddFileRequest
         * @constructor
         * @param {pond.IAddFileRequest=} [properties] Properties to set
         */
        function AddFileRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFileRequest fileName.
         * @member {string} fileName
         * @memberof pond.AddFileRequest
         * @instance
         */
        AddFileRequest.prototype.fileName = "";

        /**
         * AddFileRequest metadata.
         * @member {pond.FileData|null|undefined} metadata
         * @memberof pond.AddFileRequest
         * @instance
         */
        AddFileRequest.prototype.metadata = null;

        /**
         * AddFileRequest toAttach.
         * @member {string} toAttach
         * @memberof pond.AddFileRequest
         * @instance
         */
        AddFileRequest.prototype.toAttach = "";

        /**
         * AddFileRequest objectType.
         * @member {pond.ObjectType} objectType
         * @memberof pond.AddFileRequest
         * @instance
         */
        AddFileRequest.prototype.objectType = 0;

        /**
         * Creates a new AddFileRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddFileRequest
         * @static
         * @param {pond.IAddFileRequest=} [properties] Properties to set
         * @returns {pond.AddFileRequest} AddFileRequest instance
         */
        AddFileRequest.create = function create(properties) {
            return new AddFileRequest(properties);
        };

        /**
         * Creates an AddFileRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFileRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFileRequest} AddFileRequest
         */
        AddFileRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFileRequest)
                return object;
            var message = new $root.pond.AddFileRequest();
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.metadata != null) {
                if (typeof object.metadata !== "object")
                    throw TypeError(".pond.AddFileRequest.metadata: object expected");
                message.metadata = $root.pond.FileData.fromObject(object.metadata);
            }
            if (object.toAttach != null)
                message.toAttach = String(object.toAttach);
            switch (object.objectType) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.objectType = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.objectType = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.objectType = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.objectType = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.objectType = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.objectType = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.objectType = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.objectType = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.objectType = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.objectType = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.objectType = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.objectType = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.objectType = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.objectType = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.objectType = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.objectType = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.objectType = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.objectType = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.objectType = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.objectType = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.objectType = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.objectType = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.objectType = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.objectType = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.objectType = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.objectType = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.objectType = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.objectType = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.objectType = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.objectType = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.objectType = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.objectType = 31;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an AddFileRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFileRequest
         * @static
         * @param {pond.AddFileRequest} message AddFileRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFileRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fileName = "";
                object.metadata = null;
                object.toAttach = "";
                object.objectType = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
            }
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.metadata != null && message.hasOwnProperty("metadata"))
                object.metadata = $root.pond.FileData.toObject(message.metadata, options);
            if (message.toAttach != null && message.hasOwnProperty("toAttach"))
                object.toAttach = message.toAttach;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = options.enums === String ? $root.pond.ObjectType[message.objectType] : message.objectType;
            return object;
        };

        /**
         * Converts this AddFileRequest to JSON.
         * @function toJSON
         * @memberof pond.AddFileRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFileRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFileRequest;
    })();

    pond.AddFileResponse = (function() {

        /**
         * Properties of an AddFileResponse.
         * @memberof pond
         * @interface IAddFileResponse
         * @property {string|null} [uuid] AddFileResponse uuid
         */

        /**
         * Constructs a new AddFileResponse.
         * @memberof pond
         * @classdesc Represents an AddFileResponse.
         * @implements IAddFileResponse
         * @constructor
         * @param {pond.IAddFileResponse=} [properties] Properties to set
         */
        function AddFileResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFileResponse uuid.
         * @member {string} uuid
         * @memberof pond.AddFileResponse
         * @instance
         */
        AddFileResponse.prototype.uuid = "";

        /**
         * Creates a new AddFileResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddFileResponse
         * @static
         * @param {pond.IAddFileResponse=} [properties] Properties to set
         * @returns {pond.AddFileResponse} AddFileResponse instance
         */
        AddFileResponse.create = function create(properties) {
            return new AddFileResponse(properties);
        };

        /**
         * Creates an AddFileResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFileResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFileResponse} AddFileResponse
         */
        AddFileResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFileResponse)
                return object;
            var message = new $root.pond.AddFileResponse();
            if (object.uuid != null)
                message.uuid = String(object.uuid);
            return message;
        };

        /**
         * Creates a plain object from an AddFileResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFileResponse
         * @static
         * @param {pond.AddFileResponse} message AddFileResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFileResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uuid = "";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = message.uuid;
            return object;
        };

        /**
         * Converts this AddFileResponse to JSON.
         * @function toJSON
         * @memberof pond.AddFileResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFileResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFileResponse;
    })();

    pond.UpdateFileStatusRequest = (function() {

        /**
         * Properties of an UpdateFileStatusRequest.
         * @memberof pond
         * @interface IUpdateFileStatusRequest
         * @property {string|null} [uuid] UpdateFileStatusRequest uuid
         * @property {pond.FileStatus|null} [newStatus] UpdateFileStatusRequest newStatus
         */

        /**
         * Constructs a new UpdateFileStatusRequest.
         * @memberof pond
         * @classdesc Represents an UpdateFileStatusRequest.
         * @implements IUpdateFileStatusRequest
         * @constructor
         * @param {pond.IUpdateFileStatusRequest=} [properties] Properties to set
         */
        function UpdateFileStatusRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateFileStatusRequest uuid.
         * @member {string} uuid
         * @memberof pond.UpdateFileStatusRequest
         * @instance
         */
        UpdateFileStatusRequest.prototype.uuid = "";

        /**
         * UpdateFileStatusRequest newStatus.
         * @member {pond.FileStatus} newStatus
         * @memberof pond.UpdateFileStatusRequest
         * @instance
         */
        UpdateFileStatusRequest.prototype.newStatus = 0;

        /**
         * Creates a new UpdateFileStatusRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFileStatusRequest
         * @static
         * @param {pond.IUpdateFileStatusRequest=} [properties] Properties to set
         * @returns {pond.UpdateFileStatusRequest} UpdateFileStatusRequest instance
         */
        UpdateFileStatusRequest.create = function create(properties) {
            return new UpdateFileStatusRequest(properties);
        };

        /**
         * Creates an UpdateFileStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFileStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFileStatusRequest} UpdateFileStatusRequest
         */
        UpdateFileStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFileStatusRequest)
                return object;
            var message = new $root.pond.UpdateFileStatusRequest();
            if (object.uuid != null)
                message.uuid = String(object.uuid);
            switch (object.newStatus) {
            case "FILE_STATUS_UNKNOWN":
            case 0:
                message.newStatus = 0;
                break;
            case "FILE_STATUS_PENDING":
            case 1:
                message.newStatus = 1;
                break;
            case "FILE_STATUS_OK":
            case 2:
                message.newStatus = 2;
                break;
            case "FILE_STATUS_DELETED":
            case 3:
                message.newStatus = 3;
                break;
            case "FILE_STATUS_ORPHAN":
            case 4:
                message.newStatus = 4;
                break;
            case "FILE_STATUS_UPLOAD_FAILED":
            case 5:
                message.newStatus = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateFileStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFileStatusRequest
         * @static
         * @param {pond.UpdateFileStatusRequest} message UpdateFileStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFileStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uuid = "";
                object.newStatus = options.enums === String ? "FILE_STATUS_UNKNOWN" : 0;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = message.uuid;
            if (message.newStatus != null && message.hasOwnProperty("newStatus"))
                object.newStatus = options.enums === String ? $root.pond.FileStatus[message.newStatus] : message.newStatus;
            return object;
        };

        /**
         * Converts this UpdateFileStatusRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateFileStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFileStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFileStatusRequest;
    })();

    pond.UpdateFileStatusResponse = (function() {

        /**
         * Properties of an UpdateFileStatusResponse.
         * @memberof pond
         * @interface IUpdateFileStatusResponse
         */

        /**
         * Constructs a new UpdateFileStatusResponse.
         * @memberof pond
         * @classdesc Represents an UpdateFileStatusResponse.
         * @implements IUpdateFileStatusResponse
         * @constructor
         * @param {pond.IUpdateFileStatusResponse=} [properties] Properties to set
         */
        function UpdateFileStatusResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateFileStatusResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFileStatusResponse
         * @static
         * @param {pond.IUpdateFileStatusResponse=} [properties] Properties to set
         * @returns {pond.UpdateFileStatusResponse} UpdateFileStatusResponse instance
         */
        UpdateFileStatusResponse.create = function create(properties) {
            return new UpdateFileStatusResponse(properties);
        };

        /**
         * Creates an UpdateFileStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFileStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFileStatusResponse} UpdateFileStatusResponse
         */
        UpdateFileStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFileStatusResponse)
                return object;
            return new $root.pond.UpdateFileStatusResponse();
        };

        /**
         * Creates a plain object from an UpdateFileStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFileStatusResponse
         * @static
         * @param {pond.UpdateFileStatusResponse} message UpdateFileStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFileStatusResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateFileStatusResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateFileStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFileStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFileStatusResponse;
    })();

    pond.ListFileRefsRequest = (function() {

        /**
         * Properties of a ListFileRefsRequest.
         * @memberof pond
         * @interface IListFileRefsRequest
         * @property {string|null} [objectKey] ListFileRefsRequest objectKey
         */

        /**
         * Constructs a new ListFileRefsRequest.
         * @memberof pond
         * @classdesc Represents a ListFileRefsRequest.
         * @implements IListFileRefsRequest
         * @constructor
         * @param {pond.IListFileRefsRequest=} [properties] Properties to set
         */
        function ListFileRefsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFileRefsRequest objectKey.
         * @member {string} objectKey
         * @memberof pond.ListFileRefsRequest
         * @instance
         */
        ListFileRefsRequest.prototype.objectKey = "";

        /**
         * Creates a new ListFileRefsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListFileRefsRequest
         * @static
         * @param {pond.IListFileRefsRequest=} [properties] Properties to set
         * @returns {pond.ListFileRefsRequest} ListFileRefsRequest instance
         */
        ListFileRefsRequest.create = function create(properties) {
            return new ListFileRefsRequest(properties);
        };

        /**
         * Creates a ListFileRefsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFileRefsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFileRefsRequest} ListFileRefsRequest
         */
        ListFileRefsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFileRefsRequest)
                return object;
            var message = new $root.pond.ListFileRefsRequest();
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            return message;
        };

        /**
         * Creates a plain object from a ListFileRefsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFileRefsRequest
         * @static
         * @param {pond.ListFileRefsRequest} message ListFileRefsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFileRefsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.objectKey = "";
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            return object;
        };

        /**
         * Converts this ListFileRefsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListFileRefsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFileRefsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFileRefsRequest;
    })();

    pond.FileReference = (function() {

        /**
         * Properties of a FileReference.
         * @memberof pond
         * @interface IFileReference
         * @property {string|null} [uuid] FileReference uuid
         * @property {string|null} [fileName] FileReference fileName
         * @property {string|null} [spacesPath] FileReference spacesPath
         * @property {pond.FileData|null} [metadata] FileReference metadata
         */

        /**
         * Constructs a new FileReference.
         * @memberof pond
         * @classdesc Represents a FileReference.
         * @implements IFileReference
         * @constructor
         * @param {pond.IFileReference=} [properties] Properties to set
         */
        function FileReference(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileReference uuid.
         * @member {string} uuid
         * @memberof pond.FileReference
         * @instance
         */
        FileReference.prototype.uuid = "";

        /**
         * FileReference fileName.
         * @member {string} fileName
         * @memberof pond.FileReference
         * @instance
         */
        FileReference.prototype.fileName = "";

        /**
         * FileReference spacesPath.
         * @member {string} spacesPath
         * @memberof pond.FileReference
         * @instance
         */
        FileReference.prototype.spacesPath = "";

        /**
         * FileReference metadata.
         * @member {pond.FileData|null|undefined} metadata
         * @memberof pond.FileReference
         * @instance
         */
        FileReference.prototype.metadata = null;

        /**
         * Creates a new FileReference instance using the specified properties.
         * @function create
         * @memberof pond.FileReference
         * @static
         * @param {pond.IFileReference=} [properties] Properties to set
         * @returns {pond.FileReference} FileReference instance
         */
        FileReference.create = function create(properties) {
            return new FileReference(properties);
        };

        /**
         * Creates a FileReference message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FileReference
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FileReference} FileReference
         */
        FileReference.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FileReference)
                return object;
            var message = new $root.pond.FileReference();
            if (object.uuid != null)
                message.uuid = String(object.uuid);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.spacesPath != null)
                message.spacesPath = String(object.spacesPath);
            if (object.metadata != null) {
                if (typeof object.metadata !== "object")
                    throw TypeError(".pond.FileReference.metadata: object expected");
                message.metadata = $root.pond.FileData.fromObject(object.metadata);
            }
            return message;
        };

        /**
         * Creates a plain object from a FileReference message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FileReference
         * @static
         * @param {pond.FileReference} message FileReference
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileReference.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uuid = "";
                object.fileName = "";
                object.spacesPath = "";
                object.metadata = null;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = message.uuid;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.spacesPath != null && message.hasOwnProperty("spacesPath"))
                object.spacesPath = message.spacesPath;
            if (message.metadata != null && message.hasOwnProperty("metadata"))
                object.metadata = $root.pond.FileData.toObject(message.metadata, options);
            return object;
        };

        /**
         * Converts this FileReference to JSON.
         * @function toJSON
         * @memberof pond.FileReference
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileReference.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileReference;
    })();

    pond.FileRefList = (function() {

        /**
         * Properties of a FileRefList.
         * @memberof pond
         * @interface IFileRefList
         * @property {Array.<pond.FileReference>|null} [refs] FileRefList refs
         */

        /**
         * Constructs a new FileRefList.
         * @memberof pond
         * @classdesc Represents a FileRefList.
         * @implements IFileRefList
         * @constructor
         * @param {pond.IFileRefList=} [properties] Properties to set
         */
        function FileRefList(properties) {
            this.refs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileRefList refs.
         * @member {Array.<pond.FileReference>} refs
         * @memberof pond.FileRefList
         * @instance
         */
        FileRefList.prototype.refs = $util.emptyArray;

        /**
         * Creates a new FileRefList instance using the specified properties.
         * @function create
         * @memberof pond.FileRefList
         * @static
         * @param {pond.IFileRefList=} [properties] Properties to set
         * @returns {pond.FileRefList} FileRefList instance
         */
        FileRefList.create = function create(properties) {
            return new FileRefList(properties);
        };

        /**
         * Creates a FileRefList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FileRefList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FileRefList} FileRefList
         */
        FileRefList.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FileRefList)
                return object;
            var message = new $root.pond.FileRefList();
            if (object.refs) {
                if (!Array.isArray(object.refs))
                    throw TypeError(".pond.FileRefList.refs: array expected");
                message.refs = [];
                for (var i = 0; i < object.refs.length; ++i) {
                    if (typeof object.refs[i] !== "object")
                        throw TypeError(".pond.FileRefList.refs: object expected");
                    message.refs[i] = $root.pond.FileReference.fromObject(object.refs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FileRefList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FileRefList
         * @static
         * @param {pond.FileRefList} message FileRefList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileRefList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.refs = [];
            if (message.refs && message.refs.length) {
                object.refs = [];
                for (var j = 0; j < message.refs.length; ++j)
                    object.refs[j] = $root.pond.FileReference.toObject(message.refs[j], options);
            }
            return object;
        };

        /**
         * Converts this FileRefList to JSON.
         * @function toJSON
         * @memberof pond.FileRefList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileRefList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileRefList;
    })();

    pond.ListFileRefsResponse = (function() {

        /**
         * Properties of a ListFileRefsResponse.
         * @memberof pond
         * @interface IListFileRefsResponse
         * @property {Array.<pond.FileReference>|null} [fileRefs] ListFileRefsResponse fileRefs
         */

        /**
         * Constructs a new ListFileRefsResponse.
         * @memberof pond
         * @classdesc Represents a ListFileRefsResponse.
         * @implements IListFileRefsResponse
         * @constructor
         * @param {pond.IListFileRefsResponse=} [properties] Properties to set
         */
        function ListFileRefsResponse(properties) {
            this.fileRefs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFileRefsResponse fileRefs.
         * @member {Array.<pond.FileReference>} fileRefs
         * @memberof pond.ListFileRefsResponse
         * @instance
         */
        ListFileRefsResponse.prototype.fileRefs = $util.emptyArray;

        /**
         * Creates a new ListFileRefsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListFileRefsResponse
         * @static
         * @param {pond.IListFileRefsResponse=} [properties] Properties to set
         * @returns {pond.ListFileRefsResponse} ListFileRefsResponse instance
         */
        ListFileRefsResponse.create = function create(properties) {
            return new ListFileRefsResponse(properties);
        };

        /**
         * Creates a ListFileRefsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFileRefsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFileRefsResponse} ListFileRefsResponse
         */
        ListFileRefsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFileRefsResponse)
                return object;
            var message = new $root.pond.ListFileRefsResponse();
            if (object.fileRefs) {
                if (!Array.isArray(object.fileRefs))
                    throw TypeError(".pond.ListFileRefsResponse.fileRefs: array expected");
                message.fileRefs = [];
                for (var i = 0; i < object.fileRefs.length; ++i) {
                    if (typeof object.fileRefs[i] !== "object")
                        throw TypeError(".pond.ListFileRefsResponse.fileRefs: object expected");
                    message.fileRefs[i] = $root.pond.FileReference.fromObject(object.fileRefs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFileRefsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFileRefsResponse
         * @static
         * @param {pond.ListFileRefsResponse} message ListFileRefsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFileRefsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fileRefs = [];
            if (message.fileRefs && message.fileRefs.length) {
                object.fileRefs = [];
                for (var j = 0; j < message.fileRefs.length; ++j)
                    object.fileRefs[j] = $root.pond.FileReference.toObject(message.fileRefs[j], options);
            }
            return object;
        };

        /**
         * Converts this ListFileRefsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListFileRefsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFileRefsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFileRefsResponse;
    })();

    pond.GetFileRefRequest = (function() {

        /**
         * Properties of a GetFileRefRequest.
         * @memberof pond
         * @interface IGetFileRefRequest
         * @property {string|null} [fileUuid] GetFileRefRequest fileUuid
         */

        /**
         * Constructs a new GetFileRefRequest.
         * @memberof pond
         * @classdesc Represents a GetFileRefRequest.
         * @implements IGetFileRefRequest
         * @constructor
         * @param {pond.IGetFileRefRequest=} [properties] Properties to set
         */
        function GetFileRefRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFileRefRequest fileUuid.
         * @member {string} fileUuid
         * @memberof pond.GetFileRefRequest
         * @instance
         */
        GetFileRefRequest.prototype.fileUuid = "";

        /**
         * Creates a new GetFileRefRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetFileRefRequest
         * @static
         * @param {pond.IGetFileRefRequest=} [properties] Properties to set
         * @returns {pond.GetFileRefRequest} GetFileRefRequest instance
         */
        GetFileRefRequest.create = function create(properties) {
            return new GetFileRefRequest(properties);
        };

        /**
         * Creates a GetFileRefRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetFileRefRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetFileRefRequest} GetFileRefRequest
         */
        GetFileRefRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetFileRefRequest)
                return object;
            var message = new $root.pond.GetFileRefRequest();
            if (object.fileUuid != null)
                message.fileUuid = String(object.fileUuid);
            return message;
        };

        /**
         * Creates a plain object from a GetFileRefRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetFileRefRequest
         * @static
         * @param {pond.GetFileRefRequest} message GetFileRefRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFileRefRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fileUuid = "";
            if (message.fileUuid != null && message.hasOwnProperty("fileUuid"))
                object.fileUuid = message.fileUuid;
            return object;
        };

        /**
         * Converts this GetFileRefRequest to JSON.
         * @function toJSON
         * @memberof pond.GetFileRefRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFileRefRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetFileRefRequest;
    })();

    pond.GetFileRefResponse = (function() {

        /**
         * Properties of a GetFileRefResponse.
         * @memberof pond
         * @interface IGetFileRefResponse
         * @property {pond.FileReference|null} [ref] GetFileRefResponse ref
         */

        /**
         * Constructs a new GetFileRefResponse.
         * @memberof pond
         * @classdesc Represents a GetFileRefResponse.
         * @implements IGetFileRefResponse
         * @constructor
         * @param {pond.IGetFileRefResponse=} [properties] Properties to set
         */
        function GetFileRefResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFileRefResponse ref.
         * @member {pond.FileReference|null|undefined} ref
         * @memberof pond.GetFileRefResponse
         * @instance
         */
        GetFileRefResponse.prototype.ref = null;

        /**
         * Creates a new GetFileRefResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetFileRefResponse
         * @static
         * @param {pond.IGetFileRefResponse=} [properties] Properties to set
         * @returns {pond.GetFileRefResponse} GetFileRefResponse instance
         */
        GetFileRefResponse.create = function create(properties) {
            return new GetFileRefResponse(properties);
        };

        /**
         * Creates a GetFileRefResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetFileRefResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetFileRefResponse} GetFileRefResponse
         */
        GetFileRefResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetFileRefResponse)
                return object;
            var message = new $root.pond.GetFileRefResponse();
            if (object.ref != null) {
                if (typeof object.ref !== "object")
                    throw TypeError(".pond.GetFileRefResponse.ref: object expected");
                message.ref = $root.pond.FileReference.fromObject(object.ref);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetFileRefResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetFileRefResponse
         * @static
         * @param {pond.GetFileRefResponse} message GetFileRefResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFileRefResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ref = null;
            if (message.ref != null && message.hasOwnProperty("ref"))
                object.ref = $root.pond.FileReference.toObject(message.ref, options);
            return object;
        };

        /**
         * Converts this GetFileRefResponse to JSON.
         * @function toJSON
         * @memberof pond.GetFileRefResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFileRefResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetFileRefResponse;
    })();

    pond.AddAPIKeyRequest = (function() {

        /**
         * Properties of an AddAPIKeyRequest.
         * @memberof pond
         * @interface IAddAPIKeyRequest
         * @property {string|null} [teamId] AddAPIKeyRequest teamId
         */

        /**
         * Constructs a new AddAPIKeyRequest.
         * @memberof pond
         * @classdesc Represents an AddAPIKeyRequest.
         * @implements IAddAPIKeyRequest
         * @constructor
         * @param {pond.IAddAPIKeyRequest=} [properties] Properties to set
         */
        function AddAPIKeyRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddAPIKeyRequest teamId.
         * @member {string} teamId
         * @memberof pond.AddAPIKeyRequest
         * @instance
         */
        AddAPIKeyRequest.prototype.teamId = "";

        /**
         * Creates a new AddAPIKeyRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddAPIKeyRequest
         * @static
         * @param {pond.IAddAPIKeyRequest=} [properties] Properties to set
         * @returns {pond.AddAPIKeyRequest} AddAPIKeyRequest instance
         */
        AddAPIKeyRequest.create = function create(properties) {
            return new AddAPIKeyRequest(properties);
        };

        /**
         * Creates an AddAPIKeyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddAPIKeyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddAPIKeyRequest} AddAPIKeyRequest
         */
        AddAPIKeyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddAPIKeyRequest)
                return object;
            var message = new $root.pond.AddAPIKeyRequest();
            if (object.teamId != null)
                message.teamId = String(object.teamId);
            return message;
        };

        /**
         * Creates a plain object from an AddAPIKeyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddAPIKeyRequest
         * @static
         * @param {pond.AddAPIKeyRequest} message AddAPIKeyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddAPIKeyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.teamId = "";
            if (message.teamId != null && message.hasOwnProperty("teamId"))
                object.teamId = message.teamId;
            return object;
        };

        /**
         * Converts this AddAPIKeyRequest to JSON.
         * @function toJSON
         * @memberof pond.AddAPIKeyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddAPIKeyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddAPIKeyRequest;
    })();

    pond.AddAPIKeyResponse = (function() {

        /**
         * Properties of an AddAPIKeyResponse.
         * @memberof pond
         * @interface IAddAPIKeyResponse
         * @property {string|null} [key] AddAPIKeyResponse key
         */

        /**
         * Constructs a new AddAPIKeyResponse.
         * @memberof pond
         * @classdesc Represents an AddAPIKeyResponse.
         * @implements IAddAPIKeyResponse
         * @constructor
         * @param {pond.IAddAPIKeyResponse=} [properties] Properties to set
         */
        function AddAPIKeyResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddAPIKeyResponse key.
         * @member {string} key
         * @memberof pond.AddAPIKeyResponse
         * @instance
         */
        AddAPIKeyResponse.prototype.key = "";

        /**
         * Creates a new AddAPIKeyResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddAPIKeyResponse
         * @static
         * @param {pond.IAddAPIKeyResponse=} [properties] Properties to set
         * @returns {pond.AddAPIKeyResponse} AddAPIKeyResponse instance
         */
        AddAPIKeyResponse.create = function create(properties) {
            return new AddAPIKeyResponse(properties);
        };

        /**
         * Creates an AddAPIKeyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddAPIKeyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddAPIKeyResponse} AddAPIKeyResponse
         */
        AddAPIKeyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddAPIKeyResponse)
                return object;
            var message = new $root.pond.AddAPIKeyResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddAPIKeyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddAPIKeyResponse
         * @static
         * @param {pond.AddAPIKeyResponse} message AddAPIKeyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddAPIKeyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddAPIKeyResponse to JSON.
         * @function toJSON
         * @memberof pond.AddAPIKeyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddAPIKeyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddAPIKeyResponse;
    })();

    pond.ListAPIKeysRequest = (function() {

        /**
         * Properties of a ListAPIKeysRequest.
         * @memberof pond
         * @interface IListAPIKeysRequest
         * @property {string|null} [teamId] ListAPIKeysRequest teamId
         */

        /**
         * Constructs a new ListAPIKeysRequest.
         * @memberof pond
         * @classdesc Represents a ListAPIKeysRequest.
         * @implements IListAPIKeysRequest
         * @constructor
         * @param {pond.IListAPIKeysRequest=} [properties] Properties to set
         */
        function ListAPIKeysRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListAPIKeysRequest teamId.
         * @member {string} teamId
         * @memberof pond.ListAPIKeysRequest
         * @instance
         */
        ListAPIKeysRequest.prototype.teamId = "";

        /**
         * Creates a new ListAPIKeysRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListAPIKeysRequest
         * @static
         * @param {pond.IListAPIKeysRequest=} [properties] Properties to set
         * @returns {pond.ListAPIKeysRequest} ListAPIKeysRequest instance
         */
        ListAPIKeysRequest.create = function create(properties) {
            return new ListAPIKeysRequest(properties);
        };

        /**
         * Creates a ListAPIKeysRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListAPIKeysRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListAPIKeysRequest} ListAPIKeysRequest
         */
        ListAPIKeysRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListAPIKeysRequest)
                return object;
            var message = new $root.pond.ListAPIKeysRequest();
            if (object.teamId != null)
                message.teamId = String(object.teamId);
            return message;
        };

        /**
         * Creates a plain object from a ListAPIKeysRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListAPIKeysRequest
         * @static
         * @param {pond.ListAPIKeysRequest} message ListAPIKeysRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListAPIKeysRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.teamId = "";
            if (message.teamId != null && message.hasOwnProperty("teamId"))
                object.teamId = message.teamId;
            return object;
        };

        /**
         * Converts this ListAPIKeysRequest to JSON.
         * @function toJSON
         * @memberof pond.ListAPIKeysRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListAPIKeysRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListAPIKeysRequest;
    })();

    pond.ListAPIKeysResponse = (function() {

        /**
         * Properties of a ListAPIKeysResponse.
         * @memberof pond
         * @interface IListAPIKeysResponse
         * @property {Array.<string>|null} [keys] ListAPIKeysResponse keys
         */

        /**
         * Constructs a new ListAPIKeysResponse.
         * @memberof pond
         * @classdesc Represents a ListAPIKeysResponse.
         * @implements IListAPIKeysResponse
         * @constructor
         * @param {pond.IListAPIKeysResponse=} [properties] Properties to set
         */
        function ListAPIKeysResponse(properties) {
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListAPIKeysResponse keys.
         * @member {Array.<string>} keys
         * @memberof pond.ListAPIKeysResponse
         * @instance
         */
        ListAPIKeysResponse.prototype.keys = $util.emptyArray;

        /**
         * Creates a new ListAPIKeysResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListAPIKeysResponse
         * @static
         * @param {pond.IListAPIKeysResponse=} [properties] Properties to set
         * @returns {pond.ListAPIKeysResponse} ListAPIKeysResponse instance
         */
        ListAPIKeysResponse.create = function create(properties) {
            return new ListAPIKeysResponse(properties);
        };

        /**
         * Creates a ListAPIKeysResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListAPIKeysResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListAPIKeysResponse} ListAPIKeysResponse
         */
        ListAPIKeysResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListAPIKeysResponse)
                return object;
            var message = new $root.pond.ListAPIKeysResponse();
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.ListAPIKeysResponse.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListAPIKeysResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListAPIKeysResponse
         * @static
         * @param {pond.ListAPIKeysResponse} message ListAPIKeysResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListAPIKeysResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            return object;
        };

        /**
         * Converts this ListAPIKeysResponse to JSON.
         * @function toJSON
         * @memberof pond.ListAPIKeysResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListAPIKeysResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListAPIKeysResponse;
    })();

    pond.GetTeamIDFromAPIKeyRequest = (function() {

        /**
         * Properties of a GetTeamIDFromAPIKeyRequest.
         * @memberof pond
         * @interface IGetTeamIDFromAPIKeyRequest
         * @property {string|null} [apiKey] GetTeamIDFromAPIKeyRequest apiKey
         */

        /**
         * Constructs a new GetTeamIDFromAPIKeyRequest.
         * @memberof pond
         * @classdesc Represents a GetTeamIDFromAPIKeyRequest.
         * @implements IGetTeamIDFromAPIKeyRequest
         * @constructor
         * @param {pond.IGetTeamIDFromAPIKeyRequest=} [properties] Properties to set
         */
        function GetTeamIDFromAPIKeyRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTeamIDFromAPIKeyRequest apiKey.
         * @member {string} apiKey
         * @memberof pond.GetTeamIDFromAPIKeyRequest
         * @instance
         */
        GetTeamIDFromAPIKeyRequest.prototype.apiKey = "";

        /**
         * Creates a new GetTeamIDFromAPIKeyRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTeamIDFromAPIKeyRequest
         * @static
         * @param {pond.IGetTeamIDFromAPIKeyRequest=} [properties] Properties to set
         * @returns {pond.GetTeamIDFromAPIKeyRequest} GetTeamIDFromAPIKeyRequest instance
         */
        GetTeamIDFromAPIKeyRequest.create = function create(properties) {
            return new GetTeamIDFromAPIKeyRequest(properties);
        };

        /**
         * Creates a GetTeamIDFromAPIKeyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTeamIDFromAPIKeyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTeamIDFromAPIKeyRequest} GetTeamIDFromAPIKeyRequest
         */
        GetTeamIDFromAPIKeyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTeamIDFromAPIKeyRequest)
                return object;
            var message = new $root.pond.GetTeamIDFromAPIKeyRequest();
            if (object.apiKey != null)
                message.apiKey = String(object.apiKey);
            return message;
        };

        /**
         * Creates a plain object from a GetTeamIDFromAPIKeyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTeamIDFromAPIKeyRequest
         * @static
         * @param {pond.GetTeamIDFromAPIKeyRequest} message GetTeamIDFromAPIKeyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTeamIDFromAPIKeyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.apiKey = "";
            if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                object.apiKey = message.apiKey;
            return object;
        };

        /**
         * Converts this GetTeamIDFromAPIKeyRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTeamIDFromAPIKeyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTeamIDFromAPIKeyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTeamIDFromAPIKeyRequest;
    })();

    pond.GetTeamIDFromAPIKeyResponse = (function() {

        /**
         * Properties of a GetTeamIDFromAPIKeyResponse.
         * @memberof pond
         * @interface IGetTeamIDFromAPIKeyResponse
         * @property {string|null} [teamId] GetTeamIDFromAPIKeyResponse teamId
         */

        /**
         * Constructs a new GetTeamIDFromAPIKeyResponse.
         * @memberof pond
         * @classdesc Represents a GetTeamIDFromAPIKeyResponse.
         * @implements IGetTeamIDFromAPIKeyResponse
         * @constructor
         * @param {pond.IGetTeamIDFromAPIKeyResponse=} [properties] Properties to set
         */
        function GetTeamIDFromAPIKeyResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTeamIDFromAPIKeyResponse teamId.
         * @member {string} teamId
         * @memberof pond.GetTeamIDFromAPIKeyResponse
         * @instance
         */
        GetTeamIDFromAPIKeyResponse.prototype.teamId = "";

        /**
         * Creates a new GetTeamIDFromAPIKeyResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetTeamIDFromAPIKeyResponse
         * @static
         * @param {pond.IGetTeamIDFromAPIKeyResponse=} [properties] Properties to set
         * @returns {pond.GetTeamIDFromAPIKeyResponse} GetTeamIDFromAPIKeyResponse instance
         */
        GetTeamIDFromAPIKeyResponse.create = function create(properties) {
            return new GetTeamIDFromAPIKeyResponse(properties);
        };

        /**
         * Creates a GetTeamIDFromAPIKeyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTeamIDFromAPIKeyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTeamIDFromAPIKeyResponse} GetTeamIDFromAPIKeyResponse
         */
        GetTeamIDFromAPIKeyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTeamIDFromAPIKeyResponse)
                return object;
            var message = new $root.pond.GetTeamIDFromAPIKeyResponse();
            if (object.teamId != null)
                message.teamId = String(object.teamId);
            return message;
        };

        /**
         * Creates a plain object from a GetTeamIDFromAPIKeyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTeamIDFromAPIKeyResponse
         * @static
         * @param {pond.GetTeamIDFromAPIKeyResponse} message GetTeamIDFromAPIKeyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTeamIDFromAPIKeyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.teamId = "";
            if (message.teamId != null && message.hasOwnProperty("teamId"))
                object.teamId = message.teamId;
            return object;
        };

        /**
         * Converts this GetTeamIDFromAPIKeyResponse to JSON.
         * @function toJSON
         * @memberof pond.GetTeamIDFromAPIKeyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTeamIDFromAPIKeyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTeamIDFromAPIKeyResponse;
    })();

    pond.RemoveAPIKeyRequest = (function() {

        /**
         * Properties of a RemoveAPIKeyRequest.
         * @memberof pond
         * @interface IRemoveAPIKeyRequest
         * @property {string|null} [teamId] RemoveAPIKeyRequest teamId
         * @property {string|null} [key] RemoveAPIKeyRequest key
         */

        /**
         * Constructs a new RemoveAPIKeyRequest.
         * @memberof pond
         * @classdesc Represents a RemoveAPIKeyRequest.
         * @implements IRemoveAPIKeyRequest
         * @constructor
         * @param {pond.IRemoveAPIKeyRequest=} [properties] Properties to set
         */
        function RemoveAPIKeyRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveAPIKeyRequest teamId.
         * @member {string} teamId
         * @memberof pond.RemoveAPIKeyRequest
         * @instance
         */
        RemoveAPIKeyRequest.prototype.teamId = "";

        /**
         * RemoveAPIKeyRequest key.
         * @member {string} key
         * @memberof pond.RemoveAPIKeyRequest
         * @instance
         */
        RemoveAPIKeyRequest.prototype.key = "";

        /**
         * Creates a new RemoveAPIKeyRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveAPIKeyRequest
         * @static
         * @param {pond.IRemoveAPIKeyRequest=} [properties] Properties to set
         * @returns {pond.RemoveAPIKeyRequest} RemoveAPIKeyRequest instance
         */
        RemoveAPIKeyRequest.create = function create(properties) {
            return new RemoveAPIKeyRequest(properties);
        };

        /**
         * Creates a RemoveAPIKeyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveAPIKeyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveAPIKeyRequest} RemoveAPIKeyRequest
         */
        RemoveAPIKeyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveAPIKeyRequest)
                return object;
            var message = new $root.pond.RemoveAPIKeyRequest();
            if (object.teamId != null)
                message.teamId = String(object.teamId);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveAPIKeyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveAPIKeyRequest
         * @static
         * @param {pond.RemoveAPIKeyRequest} message RemoveAPIKeyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveAPIKeyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.teamId = "";
                object.key = "";
            }
            if (message.teamId != null && message.hasOwnProperty("teamId"))
                object.teamId = message.teamId;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveAPIKeyRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveAPIKeyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveAPIKeyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveAPIKeyRequest;
    })();

    pond.RemoveAPIKeyResponse = (function() {

        /**
         * Properties of a RemoveAPIKeyResponse.
         * @memberof pond
         * @interface IRemoveAPIKeyResponse
         */

        /**
         * Constructs a new RemoveAPIKeyResponse.
         * @memberof pond
         * @classdesc Represents a RemoveAPIKeyResponse.
         * @implements IRemoveAPIKeyResponse
         * @constructor
         * @param {pond.IRemoveAPIKeyResponse=} [properties] Properties to set
         */
        function RemoveAPIKeyResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveAPIKeyResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveAPIKeyResponse
         * @static
         * @param {pond.IRemoveAPIKeyResponse=} [properties] Properties to set
         * @returns {pond.RemoveAPIKeyResponse} RemoveAPIKeyResponse instance
         */
        RemoveAPIKeyResponse.create = function create(properties) {
            return new RemoveAPIKeyResponse(properties);
        };

        /**
         * Creates a RemoveAPIKeyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveAPIKeyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveAPIKeyResponse} RemoveAPIKeyResponse
         */
        RemoveAPIKeyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveAPIKeyResponse)
                return object;
            return new $root.pond.RemoveAPIKeyResponse();
        };

        /**
         * Creates a plain object from a RemoveAPIKeyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveAPIKeyResponse
         * @static
         * @param {pond.RemoveAPIKeyResponse} message RemoveAPIKeyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveAPIKeyResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveAPIKeyResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveAPIKeyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveAPIKeyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveAPIKeyResponse;
    })();

    /**
     * TransactionType enum.
     * @name pond.TransactionType
     * @enum {string}
     * @property {number} TRANSACTION_TYPE_UNKNOWN=0 TRANSACTION_TYPE_UNKNOWN value
     * @property {number} TRANSACTION_TYPE_GRAIN=1 TRANSACTION_TYPE_GRAIN value
     */
    pond.TransactionType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TRANSACTION_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "TRANSACTION_TYPE_GRAIN"] = 1;
        return values;
    })();

    /**
     * TransactionState enum.
     * @name pond.TransactionState
     * @enum {string}
     * @property {number} TRANSACTION_STATE_UNKNOWN=0 TRANSACTION_STATE_UNKNOWN value
     * @property {number} TRANSACTION_STATE_VALID=1 TRANSACTION_STATE_VALID value
     * @property {number} TRANSACTION_STATE_CORRECTION=2 TRANSACTION_STATE_CORRECTION value
     * @property {number} TRANSACTION_STATE_REVOKED=3 TRANSACTION_STATE_REVOKED value
     * @property {number} TRANSACTION_STATE_REVOKED_CORRECTION=4 TRANSACTION_STATE_REVOKED_CORRECTION value
     * @property {number} TRANSACTION_STATE_PENDING=5 TRANSACTION_STATE_PENDING value
     * @property {number} TRANSACTION_STATE_REJECTED=6 TRANSACTION_STATE_REJECTED value
     */
    pond.TransactionState = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TRANSACTION_STATE_UNKNOWN"] = 0;
        values[valuesById[1] = "TRANSACTION_STATE_VALID"] = 1;
        values[valuesById[2] = "TRANSACTION_STATE_CORRECTION"] = 2;
        values[valuesById[3] = "TRANSACTION_STATE_REVOKED"] = 3;
        values[valuesById[4] = "TRANSACTION_STATE_REVOKED_CORRECTION"] = 4;
        values[valuesById[5] = "TRANSACTION_STATE_PENDING"] = 5;
        values[valuesById[6] = "TRANSACTION_STATE_REJECTED"] = 6;
        return values;
    })();

    pond.GrainTransaction = (function() {

        /**
         * Properties of a GrainTransaction.
         * @memberof pond
         * @interface IGrainTransaction
         * @property {pond.Grain|null} [grainType] GrainTransaction grainType
         * @property {string|null} [customGrain] GrainTransaction customGrain
         * @property {string|null} [subtype] GrainTransaction subtype
         * @property {number|null} [bushels] GrainTransaction bushels
         * @property {string|null} [message] GrainTransaction message
         * @property {number|null} [bushelsPerTonne] GrainTransaction bushelsPerTonne
         * @property {Object.<string,number>|null} [sourceCompositionAdjustment] GrainTransaction sourceCompositionAdjustment
         * @property {Object.<string,number>|null} [objectAdjustment] GrainTransaction objectAdjustment
         */

        /**
         * Constructs a new GrainTransaction.
         * @memberof pond
         * @classdesc Represents a GrainTransaction.
         * @implements IGrainTransaction
         * @constructor
         * @param {pond.IGrainTransaction=} [properties] Properties to set
         */
        function GrainTransaction(properties) {
            this.sourceCompositionAdjustment = {};
            this.objectAdjustment = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainTransaction grainType.
         * @member {pond.Grain} grainType
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.grainType = 0;

        /**
         * GrainTransaction customGrain.
         * @member {string} customGrain
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.customGrain = "";

        /**
         * GrainTransaction subtype.
         * @member {string} subtype
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.subtype = "";

        /**
         * GrainTransaction bushels.
         * @member {number} bushels
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.bushels = 0;

        /**
         * GrainTransaction message.
         * @member {string} message
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.message = "";

        /**
         * GrainTransaction bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.bushelsPerTonne = 0;

        /**
         * GrainTransaction sourceCompositionAdjustment.
         * @member {Object.<string,number>} sourceCompositionAdjustment
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.sourceCompositionAdjustment = $util.emptyObject;

        /**
         * GrainTransaction objectAdjustment.
         * @member {Object.<string,number>} objectAdjustment
         * @memberof pond.GrainTransaction
         * @instance
         */
        GrainTransaction.prototype.objectAdjustment = $util.emptyObject;

        /**
         * Creates a new GrainTransaction instance using the specified properties.
         * @function create
         * @memberof pond.GrainTransaction
         * @static
         * @param {pond.IGrainTransaction=} [properties] Properties to set
         * @returns {pond.GrainTransaction} GrainTransaction instance
         */
        GrainTransaction.create = function create(properties) {
            return new GrainTransaction(properties);
        };

        /**
         * Creates a GrainTransaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainTransaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainTransaction} GrainTransaction
         */
        GrainTransaction.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainTransaction)
                return object;
            var message = new $root.pond.GrainTransaction();
            switch (object.grainType) {
            case "GRAIN_INVALID":
            case 0:
                message.grainType = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.grainType = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.grainType = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.grainType = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.grainType = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.grainType = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.grainType = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.grainType = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.grainType = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.grainType = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.grainType = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.grainType = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.grainType = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.grainType = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.grainType = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.grainType = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.grainType = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.grainType = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.grainType = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.grainType = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.grainType = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.grainType = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.grainType = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.grainType = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.grainType = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.grainType = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.grainType = 26;
                break;
            }
            if (object.customGrain != null)
                message.customGrain = String(object.customGrain);
            if (object.subtype != null)
                message.subtype = String(object.subtype);
            if (object.bushels != null)
                message.bushels = Number(object.bushels);
            if (object.message != null)
                message.message = String(object.message);
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            if (object.sourceCompositionAdjustment) {
                if (typeof object.sourceCompositionAdjustment !== "object")
                    throw TypeError(".pond.GrainTransaction.sourceCompositionAdjustment: object expected");
                message.sourceCompositionAdjustment = {};
                for (var keys = Object.keys(object.sourceCompositionAdjustment), i = 0; i < keys.length; ++i)
                    message.sourceCompositionAdjustment[keys[i]] = Number(object.sourceCompositionAdjustment[keys[i]]);
            }
            if (object.objectAdjustment) {
                if (typeof object.objectAdjustment !== "object")
                    throw TypeError(".pond.GrainTransaction.objectAdjustment: object expected");
                message.objectAdjustment = {};
                for (var keys = Object.keys(object.objectAdjustment), i = 0; i < keys.length; ++i)
                    message.objectAdjustment[keys[i]] = Number(object.objectAdjustment[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainTransaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainTransaction
         * @static
         * @param {pond.GrainTransaction} message GrainTransaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainTransaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults) {
                object.sourceCompositionAdjustment = {};
                object.objectAdjustment = {};
            }
            if (options.defaults) {
                object.grainType = options.enums === String ? "GRAIN_INVALID" : 0;
                object.customGrain = "";
                object.subtype = "";
                object.bushels = 0;
                object.message = "";
                object.bushelsPerTonne = 0;
            }
            if (message.grainType != null && message.hasOwnProperty("grainType"))
                object.grainType = options.enums === String ? $root.pond.Grain[message.grainType] : message.grainType;
            if (message.customGrain != null && message.hasOwnProperty("customGrain"))
                object.customGrain = message.customGrain;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.bushels != null && message.hasOwnProperty("bushels"))
                object.bushels = options.json && !isFinite(message.bushels) ? String(message.bushels) : message.bushels;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            var keys2;
            if (message.sourceCompositionAdjustment && (keys2 = Object.keys(message.sourceCompositionAdjustment)).length) {
                object.sourceCompositionAdjustment = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.sourceCompositionAdjustment[keys2[j]] = options.json && !isFinite(message.sourceCompositionAdjustment[keys2[j]]) ? String(message.sourceCompositionAdjustment[keys2[j]]) : message.sourceCompositionAdjustment[keys2[j]];
            }
            if (message.objectAdjustment && (keys2 = Object.keys(message.objectAdjustment)).length) {
                object.objectAdjustment = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.objectAdjustment[keys2[j]] = options.json && !isFinite(message.objectAdjustment[keys2[j]]) ? String(message.objectAdjustment[keys2[j]]) : message.objectAdjustment[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this GrainTransaction to JSON.
         * @function toJSON
         * @memberof pond.GrainTransaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainTransaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainTransaction;
    })();

    pond.TransactionData = (function() {

        /**
         * Properties of a TransactionData.
         * @memberof pond
         * @interface ITransactionData
         * @property {pond.GrainTransaction|null} [grainTransaction] TransactionData grainTransaction
         */

        /**
         * Constructs a new TransactionData.
         * @memberof pond
         * @classdesc Represents a TransactionData.
         * @implements ITransactionData
         * @constructor
         * @param {pond.ITransactionData=} [properties] Properties to set
         */
        function TransactionData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TransactionData grainTransaction.
         * @member {pond.GrainTransaction|null|undefined} grainTransaction
         * @memberof pond.TransactionData
         * @instance
         */
        TransactionData.prototype.grainTransaction = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * TransactionData transaction.
         * @member {"grainTransaction"|undefined} transaction
         * @memberof pond.TransactionData
         * @instance
         */
        Object.defineProperty(TransactionData.prototype, "transaction", {
            get: $util.oneOfGetter($oneOfFields = ["grainTransaction"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new TransactionData instance using the specified properties.
         * @function create
         * @memberof pond.TransactionData
         * @static
         * @param {pond.ITransactionData=} [properties] Properties to set
         * @returns {pond.TransactionData} TransactionData instance
         */
        TransactionData.create = function create(properties) {
            return new TransactionData(properties);
        };

        /**
         * Creates a TransactionData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TransactionData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TransactionData} TransactionData
         */
        TransactionData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TransactionData)
                return object;
            var message = new $root.pond.TransactionData();
            if (object.grainTransaction != null) {
                if (typeof object.grainTransaction !== "object")
                    throw TypeError(".pond.TransactionData.grainTransaction: object expected");
                message.grainTransaction = $root.pond.GrainTransaction.fromObject(object.grainTransaction);
            }
            return message;
        };

        /**
         * Creates a plain object from a TransactionData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TransactionData
         * @static
         * @param {pond.TransactionData} message TransactionData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TransactionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (message.grainTransaction != null && message.hasOwnProperty("grainTransaction")) {
                object.grainTransaction = $root.pond.GrainTransaction.toObject(message.grainTransaction, options);
                if (options.oneofs)
                    object.transaction = "grainTransaction";
            }
            return object;
        };

        /**
         * Converts this TransactionData to JSON.
         * @function toJSON
         * @memberof pond.TransactionData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TransactionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TransactionData;
    })();

    pond.Transaction = (function() {

        /**
         * Properties of a Transaction.
         * @memberof pond
         * @interface ITransaction
         * @property {pond.ObjectType|null} [fromObject] Transaction fromObject
         * @property {pond.ObjectType|null} [toObject] Transaction toObject
         * @property {string|null} [fromKey] Transaction fromKey
         * @property {string|null} [toKey] Transaction toKey
         * @property {string|null} [timestamp] Transaction timestamp
         * @property {pond.TransactionData|null} [transaction] Transaction transaction
         * @property {pond.TransactionState|null} [state] Transaction state
         * @property {string|null} [userId] Transaction userId
         * @property {string|null} [key] Transaction key
         */

        /**
         * Constructs a new Transaction.
         * @memberof pond
         * @classdesc Represents a Transaction.
         * @implements ITransaction
         * @constructor
         * @param {pond.ITransaction=} [properties] Properties to set
         */
        function Transaction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Transaction fromObject.
         * @member {pond.ObjectType} fromObject
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.fromObject = 0;

        /**
         * Transaction toObject.
         * @member {pond.ObjectType} toObject
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.toObject = 0;

        /**
         * Transaction fromKey.
         * @member {string} fromKey
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.fromKey = "";

        /**
         * Transaction toKey.
         * @member {string} toKey
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.toKey = "";

        /**
         * Transaction timestamp.
         * @member {string} timestamp
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.timestamp = "";

        /**
         * Transaction transaction.
         * @member {pond.TransactionData|null|undefined} transaction
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.transaction = null;

        /**
         * Transaction state.
         * @member {pond.TransactionState} state
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.state = 0;

        /**
         * Transaction userId.
         * @member {string} userId
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.userId = "";

        /**
         * Transaction key.
         * @member {string} key
         * @memberof pond.Transaction
         * @instance
         */
        Transaction.prototype.key = "";

        /**
         * Creates a new Transaction instance using the specified properties.
         * @function create
         * @memberof pond.Transaction
         * @static
         * @param {pond.ITransaction=} [properties] Properties to set
         * @returns {pond.Transaction} Transaction instance
         */
        Transaction.create = function create(properties) {
            return new Transaction(properties);
        };

        /**
         * Creates a Transaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Transaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Transaction} Transaction
         */
        Transaction.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Transaction)
                return object;
            var message = new $root.pond.Transaction();
            switch (object.fromObject) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.fromObject = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.fromObject = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.fromObject = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.fromObject = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.fromObject = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.fromObject = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.fromObject = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.fromObject = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.fromObject = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.fromObject = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.fromObject = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.fromObject = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.fromObject = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.fromObject = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.fromObject = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.fromObject = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.fromObject = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.fromObject = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.fromObject = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.fromObject = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.fromObject = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.fromObject = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.fromObject = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.fromObject = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.fromObject = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.fromObject = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.fromObject = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.fromObject = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.fromObject = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.fromObject = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.fromObject = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.fromObject = 31;
                break;
            }
            switch (object.toObject) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.toObject = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.toObject = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.toObject = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.toObject = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.toObject = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.toObject = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.toObject = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.toObject = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.toObject = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.toObject = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.toObject = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.toObject = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.toObject = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.toObject = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.toObject = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.toObject = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.toObject = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.toObject = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.toObject = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.toObject = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.toObject = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.toObject = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.toObject = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.toObject = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.toObject = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.toObject = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.toObject = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.toObject = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.toObject = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.toObject = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.toObject = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.toObject = 31;
                break;
            }
            if (object.fromKey != null)
                message.fromKey = String(object.fromKey);
            if (object.toKey != null)
                message.toKey = String(object.toKey);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.transaction != null) {
                if (typeof object.transaction !== "object")
                    throw TypeError(".pond.Transaction.transaction: object expected");
                message.transaction = $root.pond.TransactionData.fromObject(object.transaction);
            }
            switch (object.state) {
            case "TRANSACTION_STATE_UNKNOWN":
            case 0:
                message.state = 0;
                break;
            case "TRANSACTION_STATE_VALID":
            case 1:
                message.state = 1;
                break;
            case "TRANSACTION_STATE_CORRECTION":
            case 2:
                message.state = 2;
                break;
            case "TRANSACTION_STATE_REVOKED":
            case 3:
                message.state = 3;
                break;
            case "TRANSACTION_STATE_REVOKED_CORRECTION":
            case 4:
                message.state = 4;
                break;
            case "TRANSACTION_STATE_PENDING":
            case 5:
                message.state = 5;
                break;
            case "TRANSACTION_STATE_REJECTED":
            case 6:
                message.state = 6;
                break;
            }
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a Transaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Transaction
         * @static
         * @param {pond.Transaction} message Transaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Transaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fromObject = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.toObject = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.fromKey = "";
                object.toKey = "";
                object.timestamp = "";
                object.transaction = null;
                object.state = options.enums === String ? "TRANSACTION_STATE_UNKNOWN" : 0;
                object.userId = "";
                object.key = "";
            }
            if (message.fromObject != null && message.hasOwnProperty("fromObject"))
                object.fromObject = options.enums === String ? $root.pond.ObjectType[message.fromObject] : message.fromObject;
            if (message.toObject != null && message.hasOwnProperty("toObject"))
                object.toObject = options.enums === String ? $root.pond.ObjectType[message.toObject] : message.toObject;
            if (message.fromKey != null && message.hasOwnProperty("fromKey"))
                object.fromKey = message.fromKey;
            if (message.toKey != null && message.hasOwnProperty("toKey"))
                object.toKey = message.toKey;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.transaction != null && message.hasOwnProperty("transaction"))
                object.transaction = $root.pond.TransactionData.toObject(message.transaction, options);
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = options.enums === String ? $root.pond.TransactionState[message.state] : message.state;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this Transaction to JSON.
         * @function toJSON
         * @memberof pond.Transaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Transaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Transaction;
    })();

    pond.AddTransactionRequest = (function() {

        /**
         * Properties of an AddTransactionRequest.
         * @memberof pond
         * @interface IAddTransactionRequest
         * @property {pond.Transaction|null} [newTransaction] AddTransactionRequest newTransaction
         * @property {Array.<string>|null} [fileIds] AddTransactionRequest fileIds
         */

        /**
         * Constructs a new AddTransactionRequest.
         * @memberof pond
         * @classdesc Represents an AddTransactionRequest.
         * @implements IAddTransactionRequest
         * @constructor
         * @param {pond.IAddTransactionRequest=} [properties] Properties to set
         */
        function AddTransactionRequest(properties) {
            this.fileIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTransactionRequest newTransaction.
         * @member {pond.Transaction|null|undefined} newTransaction
         * @memberof pond.AddTransactionRequest
         * @instance
         */
        AddTransactionRequest.prototype.newTransaction = null;

        /**
         * AddTransactionRequest fileIds.
         * @member {Array.<string>} fileIds
         * @memberof pond.AddTransactionRequest
         * @instance
         */
        AddTransactionRequest.prototype.fileIds = $util.emptyArray;

        /**
         * Creates a new AddTransactionRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddTransactionRequest
         * @static
         * @param {pond.IAddTransactionRequest=} [properties] Properties to set
         * @returns {pond.AddTransactionRequest} AddTransactionRequest instance
         */
        AddTransactionRequest.create = function create(properties) {
            return new AddTransactionRequest(properties);
        };

        /**
         * Creates an AddTransactionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTransactionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTransactionRequest} AddTransactionRequest
         */
        AddTransactionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTransactionRequest)
                return object;
            var message = new $root.pond.AddTransactionRequest();
            if (object.newTransaction != null) {
                if (typeof object.newTransaction !== "object")
                    throw TypeError(".pond.AddTransactionRequest.newTransaction: object expected");
                message.newTransaction = $root.pond.Transaction.fromObject(object.newTransaction);
            }
            if (object.fileIds) {
                if (!Array.isArray(object.fileIds))
                    throw TypeError(".pond.AddTransactionRequest.fileIds: array expected");
                message.fileIds = [];
                for (var i = 0; i < object.fileIds.length; ++i)
                    message.fileIds[i] = String(object.fileIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTransactionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTransactionRequest
         * @static
         * @param {pond.AddTransactionRequest} message AddTransactionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTransactionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fileIds = [];
            if (options.defaults)
                object.newTransaction = null;
            if (message.newTransaction != null && message.hasOwnProperty("newTransaction"))
                object.newTransaction = $root.pond.Transaction.toObject(message.newTransaction, options);
            if (message.fileIds && message.fileIds.length) {
                object.fileIds = [];
                for (var j = 0; j < message.fileIds.length; ++j)
                    object.fileIds[j] = message.fileIds[j];
            }
            return object;
        };

        /**
         * Converts this AddTransactionRequest to JSON.
         * @function toJSON
         * @memberof pond.AddTransactionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTransactionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTransactionRequest;
    })();

    pond.AddTransactionResponse = (function() {

        /**
         * Properties of an AddTransactionResponse.
         * @memberof pond
         * @interface IAddTransactionResponse
         * @property {string|null} [key] AddTransactionResponse key
         */

        /**
         * Constructs a new AddTransactionResponse.
         * @memberof pond
         * @classdesc Represents an AddTransactionResponse.
         * @implements IAddTransactionResponse
         * @constructor
         * @param {pond.IAddTransactionResponse=} [properties] Properties to set
         */
        function AddTransactionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTransactionResponse key.
         * @member {string} key
         * @memberof pond.AddTransactionResponse
         * @instance
         */
        AddTransactionResponse.prototype.key = "";

        /**
         * Creates a new AddTransactionResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddTransactionResponse
         * @static
         * @param {pond.IAddTransactionResponse=} [properties] Properties to set
         * @returns {pond.AddTransactionResponse} AddTransactionResponse instance
         */
        AddTransactionResponse.create = function create(properties) {
            return new AddTransactionResponse(properties);
        };

        /**
         * Creates an AddTransactionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTransactionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTransactionResponse} AddTransactionResponse
         */
        AddTransactionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTransactionResponse)
                return object;
            var message = new $root.pond.AddTransactionResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddTransactionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTransactionResponse
         * @static
         * @param {pond.AddTransactionResponse} message AddTransactionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTransactionResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddTransactionResponse to JSON.
         * @function toJSON
         * @memberof pond.AddTransactionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTransactionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTransactionResponse;
    })();

    pond.UpdateTransactionRequest = (function() {

        /**
         * Properties of an UpdateTransactionRequest.
         * @memberof pond
         * @interface IUpdateTransactionRequest
         * @property {string|null} [key] UpdateTransactionRequest key
         * @property {pond.TransactionData|null} [newData] UpdateTransactionRequest newData
         * @property {pond.TransactionState|null} [newState] UpdateTransactionRequest newState
         */

        /**
         * Constructs a new UpdateTransactionRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTransactionRequest.
         * @implements IUpdateTransactionRequest
         * @constructor
         * @param {pond.IUpdateTransactionRequest=} [properties] Properties to set
         */
        function UpdateTransactionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTransactionRequest key.
         * @member {string} key
         * @memberof pond.UpdateTransactionRequest
         * @instance
         */
        UpdateTransactionRequest.prototype.key = "";

        /**
         * UpdateTransactionRequest newData.
         * @member {pond.TransactionData|null|undefined} newData
         * @memberof pond.UpdateTransactionRequest
         * @instance
         */
        UpdateTransactionRequest.prototype.newData = null;

        /**
         * UpdateTransactionRequest newState.
         * @member {pond.TransactionState} newState
         * @memberof pond.UpdateTransactionRequest
         * @instance
         */
        UpdateTransactionRequest.prototype.newState = 0;

        /**
         * Creates a new UpdateTransactionRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTransactionRequest
         * @static
         * @param {pond.IUpdateTransactionRequest=} [properties] Properties to set
         * @returns {pond.UpdateTransactionRequest} UpdateTransactionRequest instance
         */
        UpdateTransactionRequest.create = function create(properties) {
            return new UpdateTransactionRequest(properties);
        };

        /**
         * Creates an UpdateTransactionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTransactionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTransactionRequest} UpdateTransactionRequest
         */
        UpdateTransactionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTransactionRequest)
                return object;
            var message = new $root.pond.UpdateTransactionRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.newData != null) {
                if (typeof object.newData !== "object")
                    throw TypeError(".pond.UpdateTransactionRequest.newData: object expected");
                message.newData = $root.pond.TransactionData.fromObject(object.newData);
            }
            switch (object.newState) {
            case "TRANSACTION_STATE_UNKNOWN":
            case 0:
                message.newState = 0;
                break;
            case "TRANSACTION_STATE_VALID":
            case 1:
                message.newState = 1;
                break;
            case "TRANSACTION_STATE_CORRECTION":
            case 2:
                message.newState = 2;
                break;
            case "TRANSACTION_STATE_REVOKED":
            case 3:
                message.newState = 3;
                break;
            case "TRANSACTION_STATE_REVOKED_CORRECTION":
            case 4:
                message.newState = 4;
                break;
            case "TRANSACTION_STATE_PENDING":
            case 5:
                message.newState = 5;
                break;
            case "TRANSACTION_STATE_REJECTED":
            case 6:
                message.newState = 6;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTransactionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTransactionRequest
         * @static
         * @param {pond.UpdateTransactionRequest} message UpdateTransactionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTransactionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.newData = null;
                object.newState = options.enums === String ? "TRANSACTION_STATE_UNKNOWN" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.newData != null && message.hasOwnProperty("newData"))
                object.newData = $root.pond.TransactionData.toObject(message.newData, options);
            if (message.newState != null && message.hasOwnProperty("newState"))
                object.newState = options.enums === String ? $root.pond.TransactionState[message.newState] : message.newState;
            return object;
        };

        /**
         * Converts this UpdateTransactionRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTransactionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTransactionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTransactionRequest;
    })();

    pond.UpdateTransactionResponse = (function() {

        /**
         * Properties of an UpdateTransactionResponse.
         * @memberof pond
         * @interface IUpdateTransactionResponse
         */

        /**
         * Constructs a new UpdateTransactionResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTransactionResponse.
         * @implements IUpdateTransactionResponse
         * @constructor
         * @param {pond.IUpdateTransactionResponse=} [properties] Properties to set
         */
        function UpdateTransactionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateTransactionResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTransactionResponse
         * @static
         * @param {pond.IUpdateTransactionResponse=} [properties] Properties to set
         * @returns {pond.UpdateTransactionResponse} UpdateTransactionResponse instance
         */
        UpdateTransactionResponse.create = function create(properties) {
            return new UpdateTransactionResponse(properties);
        };

        /**
         * Creates an UpdateTransactionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTransactionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTransactionResponse} UpdateTransactionResponse
         */
        UpdateTransactionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTransactionResponse)
                return object;
            return new $root.pond.UpdateTransactionResponse();
        };

        /**
         * Creates a plain object from an UpdateTransactionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTransactionResponse
         * @static
         * @param {pond.UpdateTransactionResponse} message UpdateTransactionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTransactionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateTransactionResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTransactionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTransactionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTransactionResponse;
    })();

    pond.ListTransactionsRequest = (function() {

        /**
         * Properties of a ListTransactionsRequest.
         * @memberof pond
         * @interface IListTransactionsRequest
         * @property {string|null} [start] ListTransactionsRequest start
         * @property {string|null} [end] ListTransactionsRequest end
         * @property {pond.ObjectType|null} [fromObject] ListTransactionsRequest fromObject
         * @property {pond.ObjectType|null} [toObject] ListTransactionsRequest toObject
         * @property {string|null} [fromKey] ListTransactionsRequest fromKey
         * @property {string|null} [toKey] ListTransactionsRequest toKey
         * @property {pond.Paging|null} [paging] ListTransactionsRequest paging
         * @property {pond.Sorting|null} [sorting] ListTransactionsRequest sorting
         * @property {string|null} [search] ListTransactionsRequest search
         */

        /**
         * Constructs a new ListTransactionsRequest.
         * @memberof pond
         * @classdesc Represents a ListTransactionsRequest.
         * @implements IListTransactionsRequest
         * @constructor
         * @param {pond.IListTransactionsRequest=} [properties] Properties to set
         */
        function ListTransactionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTransactionsRequest start.
         * @member {string} start
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.start = "";

        /**
         * ListTransactionsRequest end.
         * @member {string} end
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.end = "";

        /**
         * ListTransactionsRequest fromObject.
         * @member {pond.ObjectType} fromObject
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.fromObject = 0;

        /**
         * ListTransactionsRequest toObject.
         * @member {pond.ObjectType} toObject
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.toObject = 0;

        /**
         * ListTransactionsRequest fromKey.
         * @member {string} fromKey
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.fromKey = "";

        /**
         * ListTransactionsRequest toKey.
         * @member {string} toKey
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.toKey = "";

        /**
         * ListTransactionsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.paging = null;

        /**
         * ListTransactionsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.sorting = null;

        /**
         * ListTransactionsRequest search.
         * @member {string} search
         * @memberof pond.ListTransactionsRequest
         * @instance
         */
        ListTransactionsRequest.prototype.search = "";

        /**
         * Creates a new ListTransactionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListTransactionsRequest
         * @static
         * @param {pond.IListTransactionsRequest=} [properties] Properties to set
         * @returns {pond.ListTransactionsRequest} ListTransactionsRequest instance
         */
        ListTransactionsRequest.create = function create(properties) {
            return new ListTransactionsRequest(properties);
        };

        /**
         * Creates a ListTransactionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTransactionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTransactionsRequest} ListTransactionsRequest
         */
        ListTransactionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTransactionsRequest)
                return object;
            var message = new $root.pond.ListTransactionsRequest();
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            switch (object.fromObject) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.fromObject = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.fromObject = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.fromObject = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.fromObject = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.fromObject = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.fromObject = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.fromObject = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.fromObject = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.fromObject = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.fromObject = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.fromObject = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.fromObject = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.fromObject = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.fromObject = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.fromObject = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.fromObject = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.fromObject = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.fromObject = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.fromObject = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.fromObject = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.fromObject = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.fromObject = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.fromObject = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.fromObject = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.fromObject = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.fromObject = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.fromObject = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.fromObject = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.fromObject = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.fromObject = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.fromObject = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.fromObject = 31;
                break;
            }
            switch (object.toObject) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.toObject = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.toObject = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.toObject = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.toObject = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.toObject = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.toObject = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.toObject = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.toObject = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.toObject = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.toObject = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.toObject = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.toObject = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.toObject = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.toObject = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.toObject = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.toObject = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.toObject = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.toObject = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.toObject = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.toObject = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.toObject = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.toObject = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.toObject = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.toObject = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.toObject = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.toObject = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.toObject = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.toObject = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.toObject = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.toObject = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.toObject = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.toObject = 31;
                break;
            }
            if (object.fromKey != null)
                message.fromKey = String(object.fromKey);
            if (object.toKey != null)
                message.toKey = String(object.toKey);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListTransactionsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListTransactionsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListTransactionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTransactionsRequest
         * @static
         * @param {pond.ListTransactionsRequest} message ListTransactionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTransactionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.start = "";
                object.end = "";
                object.fromObject = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.toObject = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.fromKey = "";
                object.toKey = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            if (message.fromObject != null && message.hasOwnProperty("fromObject"))
                object.fromObject = options.enums === String ? $root.pond.ObjectType[message.fromObject] : message.fromObject;
            if (message.toObject != null && message.hasOwnProperty("toObject"))
                object.toObject = options.enums === String ? $root.pond.ObjectType[message.toObject] : message.toObject;
            if (message.fromKey != null && message.hasOwnProperty("fromKey"))
                object.fromKey = message.fromKey;
            if (message.toKey != null && message.hasOwnProperty("toKey"))
                object.toKey = message.toKey;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListTransactionsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListTransactionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTransactionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTransactionsRequest;
    })();

    pond.ListTransactionsResponse = (function() {

        /**
         * Properties of a ListTransactionsResponse.
         * @memberof pond
         * @interface IListTransactionsResponse
         * @property {Array.<pond.Transaction>|null} [transactions] ListTransactionsResponse transactions
         * @property {number|null} [nextOffset] ListTransactionsResponse nextOffset
         * @property {number|null} [total] ListTransactionsResponse total
         */

        /**
         * Constructs a new ListTransactionsResponse.
         * @memberof pond
         * @classdesc Represents a ListTransactionsResponse.
         * @implements IListTransactionsResponse
         * @constructor
         * @param {pond.IListTransactionsResponse=} [properties] Properties to set
         */
        function ListTransactionsResponse(properties) {
            this.transactions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTransactionsResponse transactions.
         * @member {Array.<pond.Transaction>} transactions
         * @memberof pond.ListTransactionsResponse
         * @instance
         */
        ListTransactionsResponse.prototype.transactions = $util.emptyArray;

        /**
         * ListTransactionsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListTransactionsResponse
         * @instance
         */
        ListTransactionsResponse.prototype.nextOffset = 0;

        /**
         * ListTransactionsResponse total.
         * @member {number} total
         * @memberof pond.ListTransactionsResponse
         * @instance
         */
        ListTransactionsResponse.prototype.total = 0;

        /**
         * Creates a new ListTransactionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTransactionsResponse
         * @static
         * @param {pond.IListTransactionsResponse=} [properties] Properties to set
         * @returns {pond.ListTransactionsResponse} ListTransactionsResponse instance
         */
        ListTransactionsResponse.create = function create(properties) {
            return new ListTransactionsResponse(properties);
        };

        /**
         * Creates a ListTransactionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTransactionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTransactionsResponse} ListTransactionsResponse
         */
        ListTransactionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTransactionsResponse)
                return object;
            var message = new $root.pond.ListTransactionsResponse();
            if (object.transactions) {
                if (!Array.isArray(object.transactions))
                    throw TypeError(".pond.ListTransactionsResponse.transactions: array expected");
                message.transactions = [];
                for (var i = 0; i < object.transactions.length; ++i) {
                    if (typeof object.transactions[i] !== "object")
                        throw TypeError(".pond.ListTransactionsResponse.transactions: object expected");
                    message.transactions[i] = $root.pond.Transaction.fromObject(object.transactions[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListTransactionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTransactionsResponse
         * @static
         * @param {pond.ListTransactionsResponse} message ListTransactionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTransactionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.transactions = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.transactions && message.transactions.length) {
                object.transactions = [];
                for (var j = 0; j < message.transactions.length; ++j)
                    object.transactions[j] = $root.pond.Transaction.toObject(message.transactions[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListTransactionsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTransactionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTransactionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTransactionsResponse;
    })();

    pond.RevokeTransactionRequest = (function() {

        /**
         * Properties of a RevokeTransactionRequest.
         * @memberof pond
         * @interface IRevokeTransactionRequest
         * @property {string|null} [key] RevokeTransactionRequest key
         */

        /**
         * Constructs a new RevokeTransactionRequest.
         * @memberof pond
         * @classdesc Represents a RevokeTransactionRequest.
         * @implements IRevokeTransactionRequest
         * @constructor
         * @param {pond.IRevokeTransactionRequest=} [properties] Properties to set
         */
        function RevokeTransactionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RevokeTransactionRequest key.
         * @member {string} key
         * @memberof pond.RevokeTransactionRequest
         * @instance
         */
        RevokeTransactionRequest.prototype.key = "";

        /**
         * Creates a new RevokeTransactionRequest instance using the specified properties.
         * @function create
         * @memberof pond.RevokeTransactionRequest
         * @static
         * @param {pond.IRevokeTransactionRequest=} [properties] Properties to set
         * @returns {pond.RevokeTransactionRequest} RevokeTransactionRequest instance
         */
        RevokeTransactionRequest.create = function create(properties) {
            return new RevokeTransactionRequest(properties);
        };

        /**
         * Creates a RevokeTransactionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RevokeTransactionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RevokeTransactionRequest} RevokeTransactionRequest
         */
        RevokeTransactionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RevokeTransactionRequest)
                return object;
            var message = new $root.pond.RevokeTransactionRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RevokeTransactionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RevokeTransactionRequest
         * @static
         * @param {pond.RevokeTransactionRequest} message RevokeTransactionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RevokeTransactionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RevokeTransactionRequest to JSON.
         * @function toJSON
         * @memberof pond.RevokeTransactionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RevokeTransactionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RevokeTransactionRequest;
    })();

    pond.RevokeTransactionResponse = (function() {

        /**
         * Properties of a RevokeTransactionResponse.
         * @memberof pond
         * @interface IRevokeTransactionResponse
         */

        /**
         * Constructs a new RevokeTransactionResponse.
         * @memberof pond
         * @classdesc Represents a RevokeTransactionResponse.
         * @implements IRevokeTransactionResponse
         * @constructor
         * @param {pond.IRevokeTransactionResponse=} [properties] Properties to set
         */
        function RevokeTransactionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RevokeTransactionResponse instance using the specified properties.
         * @function create
         * @memberof pond.RevokeTransactionResponse
         * @static
         * @param {pond.IRevokeTransactionResponse=} [properties] Properties to set
         * @returns {pond.RevokeTransactionResponse} RevokeTransactionResponse instance
         */
        RevokeTransactionResponse.create = function create(properties) {
            return new RevokeTransactionResponse(properties);
        };

        /**
         * Creates a RevokeTransactionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RevokeTransactionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RevokeTransactionResponse} RevokeTransactionResponse
         */
        RevokeTransactionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RevokeTransactionResponse)
                return object;
            return new $root.pond.RevokeTransactionResponse();
        };

        /**
         * Creates a plain object from a RevokeTransactionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RevokeTransactionResponse
         * @static
         * @param {pond.RevokeTransactionResponse} message RevokeTransactionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RevokeTransactionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RevokeTransactionResponse to JSON.
         * @function toJSON
         * @memberof pond.RevokeTransactionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RevokeTransactionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RevokeTransactionResponse;
    })();

    pond.TransactionPageDataRequest = (function() {

        /**
         * Properties of a TransactionPageDataRequest.
         * @memberof pond
         * @interface ITransactionPageDataRequest
         * @property {string|null} [start] TransactionPageDataRequest start
         * @property {string|null} [end] TransactionPageDataRequest end
         */

        /**
         * Constructs a new TransactionPageDataRequest.
         * @memberof pond
         * @classdesc Represents a TransactionPageDataRequest.
         * @implements ITransactionPageDataRequest
         * @constructor
         * @param {pond.ITransactionPageDataRequest=} [properties] Properties to set
         */
        function TransactionPageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TransactionPageDataRequest start.
         * @member {string} start
         * @memberof pond.TransactionPageDataRequest
         * @instance
         */
        TransactionPageDataRequest.prototype.start = "";

        /**
         * TransactionPageDataRequest end.
         * @member {string} end
         * @memberof pond.TransactionPageDataRequest
         * @instance
         */
        TransactionPageDataRequest.prototype.end = "";

        /**
         * Creates a new TransactionPageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.TransactionPageDataRequest
         * @static
         * @param {pond.ITransactionPageDataRequest=} [properties] Properties to set
         * @returns {pond.TransactionPageDataRequest} TransactionPageDataRequest instance
         */
        TransactionPageDataRequest.create = function create(properties) {
            return new TransactionPageDataRequest(properties);
        };

        /**
         * Creates a TransactionPageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TransactionPageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TransactionPageDataRequest} TransactionPageDataRequest
         */
        TransactionPageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TransactionPageDataRequest)
                return object;
            var message = new $root.pond.TransactionPageDataRequest();
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from a TransactionPageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TransactionPageDataRequest
         * @static
         * @param {pond.TransactionPageDataRequest} message TransactionPageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TransactionPageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.start = "";
                object.end = "";
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this TransactionPageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.TransactionPageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TransactionPageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TransactionPageDataRequest;
    })();

    pond.TransactionPageDataResponse = (function() {

        /**
         * Properties of a TransactionPageDataResponse.
         * @memberof pond
         * @interface ITransactionPageDataResponse
         * @property {Array.<pond.Transaction>|null} [transactions] TransactionPageDataResponse transactions
         * @property {Object.<string,string>|null} [nameMap] TransactionPageDataResponse nameMap
         */

        /**
         * Constructs a new TransactionPageDataResponse.
         * @memberof pond
         * @classdesc Represents a TransactionPageDataResponse.
         * @implements ITransactionPageDataResponse
         * @constructor
         * @param {pond.ITransactionPageDataResponse=} [properties] Properties to set
         */
        function TransactionPageDataResponse(properties) {
            this.transactions = [];
            this.nameMap = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TransactionPageDataResponse transactions.
         * @member {Array.<pond.Transaction>} transactions
         * @memberof pond.TransactionPageDataResponse
         * @instance
         */
        TransactionPageDataResponse.prototype.transactions = $util.emptyArray;

        /**
         * TransactionPageDataResponse nameMap.
         * @member {Object.<string,string>} nameMap
         * @memberof pond.TransactionPageDataResponse
         * @instance
         */
        TransactionPageDataResponse.prototype.nameMap = $util.emptyObject;

        /**
         * Creates a new TransactionPageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.TransactionPageDataResponse
         * @static
         * @param {pond.ITransactionPageDataResponse=} [properties] Properties to set
         * @returns {pond.TransactionPageDataResponse} TransactionPageDataResponse instance
         */
        TransactionPageDataResponse.create = function create(properties) {
            return new TransactionPageDataResponse(properties);
        };

        /**
         * Creates a TransactionPageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TransactionPageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TransactionPageDataResponse} TransactionPageDataResponse
         */
        TransactionPageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TransactionPageDataResponse)
                return object;
            var message = new $root.pond.TransactionPageDataResponse();
            if (object.transactions) {
                if (!Array.isArray(object.transactions))
                    throw TypeError(".pond.TransactionPageDataResponse.transactions: array expected");
                message.transactions = [];
                for (var i = 0; i < object.transactions.length; ++i) {
                    if (typeof object.transactions[i] !== "object")
                        throw TypeError(".pond.TransactionPageDataResponse.transactions: object expected");
                    message.transactions[i] = $root.pond.Transaction.fromObject(object.transactions[i]);
                }
            }
            if (object.nameMap) {
                if (typeof object.nameMap !== "object")
                    throw TypeError(".pond.TransactionPageDataResponse.nameMap: object expected");
                message.nameMap = {};
                for (var keys = Object.keys(object.nameMap), i = 0; i < keys.length; ++i)
                    message.nameMap[keys[i]] = String(object.nameMap[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a TransactionPageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TransactionPageDataResponse
         * @static
         * @param {pond.TransactionPageDataResponse} message TransactionPageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TransactionPageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.transactions = [];
            if (options.objects || options.defaults)
                object.nameMap = {};
            if (message.transactions && message.transactions.length) {
                object.transactions = [];
                for (var j = 0; j < message.transactions.length; ++j)
                    object.transactions[j] = $root.pond.Transaction.toObject(message.transactions[j], options);
            }
            var keys2;
            if (message.nameMap && (keys2 = Object.keys(message.nameMap)).length) {
                object.nameMap = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.nameMap[keys2[j]] = message.nameMap[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this TransactionPageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.TransactionPageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TransactionPageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TransactionPageDataResponse;
    })();

    /**
     * Mutator enum.
     * @name pond.Mutator
     * @enum {string}
     * @property {number} MUTATOR_NONE=0 MUTATOR_NONE value
     * @property {number} MUTATOR_EMC=1 MUTATOR_EMC value
     * @property {number} MUTATOR_CFM=2 MUTATOR_CFM value
     * @property {number} MUTATOR_FUEL_LEVEL=3 MUTATOR_FUEL_LEVEL value
     */
    pond.Mutator = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MUTATOR_NONE"] = 0;
        values[valuesById[1] = "MUTATOR_EMC"] = 1;
        values[valuesById[2] = "MUTATOR_CFM"] = 2;
        values[valuesById[3] = "MUTATOR_FUEL_LEVEL"] = 3;
        return values;
    })();

    pond.LinearMutation = (function() {

        /**
         * Properties of a LinearMutation.
         * @memberof pond
         * @interface ILinearMutation
         * @property {pond.Mutator|null} [mutation] LinearMutation mutation
         * @property {Array.<pond.ComponentCoefficients>|null} [componentCoefficients] LinearMutation componentCoefficients
         * @property {number|null} [constant] LinearMutation constant
         * @property {string|null} [mutationName] LinearMutation mutationName
         */

        /**
         * Constructs a new LinearMutation.
         * @memberof pond
         * @classdesc Represents a LinearMutation.
         * @implements ILinearMutation
         * @constructor
         * @param {pond.ILinearMutation=} [properties] Properties to set
         */
        function LinearMutation(properties) {
            this.componentCoefficients = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LinearMutation mutation.
         * @member {pond.Mutator} mutation
         * @memberof pond.LinearMutation
         * @instance
         */
        LinearMutation.prototype.mutation = 0;

        /**
         * LinearMutation componentCoefficients.
         * @member {Array.<pond.ComponentCoefficients>} componentCoefficients
         * @memberof pond.LinearMutation
         * @instance
         */
        LinearMutation.prototype.componentCoefficients = $util.emptyArray;

        /**
         * LinearMutation constant.
         * @member {number} constant
         * @memberof pond.LinearMutation
         * @instance
         */
        LinearMutation.prototype.constant = 0;

        /**
         * LinearMutation mutationName.
         * @member {string} mutationName
         * @memberof pond.LinearMutation
         * @instance
         */
        LinearMutation.prototype.mutationName = "";

        /**
         * Creates a new LinearMutation instance using the specified properties.
         * @function create
         * @memberof pond.LinearMutation
         * @static
         * @param {pond.ILinearMutation=} [properties] Properties to set
         * @returns {pond.LinearMutation} LinearMutation instance
         */
        LinearMutation.create = function create(properties) {
            return new LinearMutation(properties);
        };

        /**
         * Creates a LinearMutation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LinearMutation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LinearMutation} LinearMutation
         */
        LinearMutation.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LinearMutation)
                return object;
            var message = new $root.pond.LinearMutation();
            switch (object.mutation) {
            case "MUTATOR_NONE":
            case 0:
                message.mutation = 0;
                break;
            case "MUTATOR_EMC":
            case 1:
                message.mutation = 1;
                break;
            case "MUTATOR_CFM":
            case 2:
                message.mutation = 2;
                break;
            case "MUTATOR_FUEL_LEVEL":
            case 3:
                message.mutation = 3;
                break;
            }
            if (object.componentCoefficients) {
                if (!Array.isArray(object.componentCoefficients))
                    throw TypeError(".pond.LinearMutation.componentCoefficients: array expected");
                message.componentCoefficients = [];
                for (var i = 0; i < object.componentCoefficients.length; ++i) {
                    if (typeof object.componentCoefficients[i] !== "object")
                        throw TypeError(".pond.LinearMutation.componentCoefficients: object expected");
                    message.componentCoefficients[i] = $root.pond.ComponentCoefficients.fromObject(object.componentCoefficients[i]);
                }
            }
            if (object.constant != null)
                message.constant = Number(object.constant);
            if (object.mutationName != null)
                message.mutationName = String(object.mutationName);
            return message;
        };

        /**
         * Creates a plain object from a LinearMutation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LinearMutation
         * @static
         * @param {pond.LinearMutation} message LinearMutation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LinearMutation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.componentCoefficients = [];
            if (options.defaults) {
                object.mutation = options.enums === String ? "MUTATOR_NONE" : 0;
                object.constant = 0;
                object.mutationName = "";
            }
            if (message.mutation != null && message.hasOwnProperty("mutation"))
                object.mutation = options.enums === String ? $root.pond.Mutator[message.mutation] : message.mutation;
            if (message.componentCoefficients && message.componentCoefficients.length) {
                object.componentCoefficients = [];
                for (var j = 0; j < message.componentCoefficients.length; ++j)
                    object.componentCoefficients[j] = $root.pond.ComponentCoefficients.toObject(message.componentCoefficients[j], options);
            }
            if (message.constant != null && message.hasOwnProperty("constant"))
                object.constant = options.json && !isFinite(message.constant) ? String(message.constant) : message.constant;
            if (message.mutationName != null && message.hasOwnProperty("mutationName"))
                object.mutationName = message.mutationName;
            return object;
        };

        /**
         * Converts this LinearMutation to JSON.
         * @function toJSON
         * @memberof pond.LinearMutation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LinearMutation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LinearMutation;
    })();

    pond.ComponentCoefficients = (function() {

        /**
         * Properties of a ComponentCoefficients.
         * @memberof pond
         * @interface IComponentCoefficients
         * @property {string|null} [componentKey] ComponentCoefficients componentKey
         * @property {Array.<pond.MeasurementCoefficients>|null} [measurementCoefficients] ComponentCoefficients measurementCoefficients
         */

        /**
         * Constructs a new ComponentCoefficients.
         * @memberof pond
         * @classdesc Represents a ComponentCoefficients.
         * @implements IComponentCoefficients
         * @constructor
         * @param {pond.IComponentCoefficients=} [properties] Properties to set
         */
        function ComponentCoefficients(properties) {
            this.measurementCoefficients = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentCoefficients componentKey.
         * @member {string} componentKey
         * @memberof pond.ComponentCoefficients
         * @instance
         */
        ComponentCoefficients.prototype.componentKey = "";

        /**
         * ComponentCoefficients measurementCoefficients.
         * @member {Array.<pond.MeasurementCoefficients>} measurementCoefficients
         * @memberof pond.ComponentCoefficients
         * @instance
         */
        ComponentCoefficients.prototype.measurementCoefficients = $util.emptyArray;

        /**
         * Creates a new ComponentCoefficients instance using the specified properties.
         * @function create
         * @memberof pond.ComponentCoefficients
         * @static
         * @param {pond.IComponentCoefficients=} [properties] Properties to set
         * @returns {pond.ComponentCoefficients} ComponentCoefficients instance
         */
        ComponentCoefficients.create = function create(properties) {
            return new ComponentCoefficients(properties);
        };

        /**
         * Creates a ComponentCoefficients message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentCoefficients
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentCoefficients} ComponentCoefficients
         */
        ComponentCoefficients.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentCoefficients)
                return object;
            var message = new $root.pond.ComponentCoefficients();
            if (object.componentKey != null)
                message.componentKey = String(object.componentKey);
            if (object.measurementCoefficients) {
                if (!Array.isArray(object.measurementCoefficients))
                    throw TypeError(".pond.ComponentCoefficients.measurementCoefficients: array expected");
                message.measurementCoefficients = [];
                for (var i = 0; i < object.measurementCoefficients.length; ++i) {
                    if (typeof object.measurementCoefficients[i] !== "object")
                        throw TypeError(".pond.ComponentCoefficients.measurementCoefficients: object expected");
                    message.measurementCoefficients[i] = $root.pond.MeasurementCoefficients.fromObject(object.measurementCoefficients[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComponentCoefficients message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentCoefficients
         * @static
         * @param {pond.ComponentCoefficients} message ComponentCoefficients
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentCoefficients.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurementCoefficients = [];
            if (options.defaults)
                object.componentKey = "";
            if (message.componentKey != null && message.hasOwnProperty("componentKey"))
                object.componentKey = message.componentKey;
            if (message.measurementCoefficients && message.measurementCoefficients.length) {
                object.measurementCoefficients = [];
                for (var j = 0; j < message.measurementCoefficients.length; ++j)
                    object.measurementCoefficients[j] = $root.pond.MeasurementCoefficients.toObject(message.measurementCoefficients[j], options);
            }
            return object;
        };

        /**
         * Converts this ComponentCoefficients to JSON.
         * @function toJSON
         * @memberof pond.ComponentCoefficients
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentCoefficients.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentCoefficients;
    })();

    pond.MeasurementCoefficients = (function() {

        /**
         * Properties of a MeasurementCoefficients.
         * @memberof pond
         * @interface IMeasurementCoefficients
         * @property {quack.MeasurementType|null} [measurementType] MeasurementCoefficients measurementType
         * @property {Array.<number>|null} [coefficients] MeasurementCoefficients coefficients
         */

        /**
         * Constructs a new MeasurementCoefficients.
         * @memberof pond
         * @classdesc Represents a MeasurementCoefficients.
         * @implements IMeasurementCoefficients
         * @constructor
         * @param {pond.IMeasurementCoefficients=} [properties] Properties to set
         */
        function MeasurementCoefficients(properties) {
            this.coefficients = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MeasurementCoefficients measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof pond.MeasurementCoefficients
         * @instance
         */
        MeasurementCoefficients.prototype.measurementType = 0;

        /**
         * MeasurementCoefficients coefficients.
         * @member {Array.<number>} coefficients
         * @memberof pond.MeasurementCoefficients
         * @instance
         */
        MeasurementCoefficients.prototype.coefficients = $util.emptyArray;

        /**
         * Creates a new MeasurementCoefficients instance using the specified properties.
         * @function create
         * @memberof pond.MeasurementCoefficients
         * @static
         * @param {pond.IMeasurementCoefficients=} [properties] Properties to set
         * @returns {pond.MeasurementCoefficients} MeasurementCoefficients instance
         */
        MeasurementCoefficients.create = function create(properties) {
            return new MeasurementCoefficients(properties);
        };

        /**
         * Creates a MeasurementCoefficients message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MeasurementCoefficients
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MeasurementCoefficients} MeasurementCoefficients
         */
        MeasurementCoefficients.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MeasurementCoefficients)
                return object;
            var message = new $root.pond.MeasurementCoefficients();
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            if (object.coefficients) {
                if (!Array.isArray(object.coefficients))
                    throw TypeError(".pond.MeasurementCoefficients.coefficients: array expected");
                message.coefficients = [];
                for (var i = 0; i < object.coefficients.length; ++i)
                    message.coefficients[i] = Number(object.coefficients[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MeasurementCoefficients message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MeasurementCoefficients
         * @static
         * @param {pond.MeasurementCoefficients} message MeasurementCoefficients
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MeasurementCoefficients.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coefficients = [];
            if (options.defaults)
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            if (message.coefficients && message.coefficients.length) {
                object.coefficients = [];
                for (var j = 0; j < message.coefficients.length; ++j)
                    object.coefficients[j] = options.json && !isFinite(message.coefficients[j]) ? String(message.coefficients[j]) : message.coefficients[j];
            }
            return object;
        };

        /**
         * Converts this MeasurementCoefficients to JSON.
         * @function toJSON
         * @memberof pond.MeasurementCoefficients
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MeasurementCoefficients.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MeasurementCoefficients;
    })();

    /**
     * BinStorage enum.
     * @name pond.BinStorage
     * @enum {string}
     * @property {number} BIN_STORAGE_UNKNOWN=0 BIN_STORAGE_UNKNOWN value
     * @property {number} BIN_STORAGE_SUPPORTED_GRAIN=1 BIN_STORAGE_SUPPORTED_GRAIN value
     * @property {number} BIN_STORAGE_FERTILIZER=2 BIN_STORAGE_FERTILIZER value
     * @property {number} BIN_STORAGE_UNSUPPORTED_GRAIN=3 BIN_STORAGE_UNSUPPORTED_GRAIN value
     */
    pond.BinStorage = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BIN_STORAGE_UNKNOWN"] = 0;
        values[valuesById[1] = "BIN_STORAGE_SUPPORTED_GRAIN"] = 1;
        values[valuesById[2] = "BIN_STORAGE_FERTILIZER"] = 2;
        values[valuesById[3] = "BIN_STORAGE_UNSUPPORTED_GRAIN"] = 3;
        return values;
    })();

    pond.CompleteHistory = (function() {

        /**
         * Properties of a CompleteHistory.
         * @memberof pond
         * @interface ICompleteHistory
         * @property {pond.DeviceHistory|null} [deviceHistory] CompleteHistory deviceHistory
         * @property {pond.ComponentHistory|null} [componentHistory] CompleteHistory componentHistory
         * @property {pond.InteractionHistory|null} [interactionHistory] CompleteHistory interactionHistory
         * @property {pond.ObjectHistory|null} [objectHistory] CompleteHistory objectHistory
         * @property {string|null} [sourceTable] CompleteHistory sourceTable
         * @property {string|null} [progress] CompleteHistory progress
         */

        /**
         * Constructs a new CompleteHistory.
         * @memberof pond
         * @classdesc Represents a CompleteHistory.
         * @implements ICompleteHistory
         * @constructor
         * @param {pond.ICompleteHistory=} [properties] Properties to set
         */
        function CompleteHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompleteHistory deviceHistory.
         * @member {pond.DeviceHistory|null|undefined} deviceHistory
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.deviceHistory = null;

        /**
         * CompleteHistory componentHistory.
         * @member {pond.ComponentHistory|null|undefined} componentHistory
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.componentHistory = null;

        /**
         * CompleteHistory interactionHistory.
         * @member {pond.InteractionHistory|null|undefined} interactionHistory
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.interactionHistory = null;

        /**
         * CompleteHistory objectHistory.
         * @member {pond.ObjectHistory|null|undefined} objectHistory
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.objectHistory = null;

        /**
         * CompleteHistory sourceTable.
         * @member {string} sourceTable
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.sourceTable = "";

        /**
         * CompleteHistory progress.
         * @member {string} progress
         * @memberof pond.CompleteHistory
         * @instance
         */
        CompleteHistory.prototype.progress = "";

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * CompleteHistory history.
         * @member {"deviceHistory"|"componentHistory"|"interactionHistory"|"objectHistory"|undefined} history
         * @memberof pond.CompleteHistory
         * @instance
         */
        Object.defineProperty(CompleteHistory.prototype, "history", {
            get: $util.oneOfGetter($oneOfFields = ["deviceHistory", "componentHistory", "interactionHistory", "objectHistory"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CompleteHistory instance using the specified properties.
         * @function create
         * @memberof pond.CompleteHistory
         * @static
         * @param {pond.ICompleteHistory=} [properties] Properties to set
         * @returns {pond.CompleteHistory} CompleteHistory instance
         */
        CompleteHistory.create = function create(properties) {
            return new CompleteHistory(properties);
        };

        /**
         * Creates a CompleteHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CompleteHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CompleteHistory} CompleteHistory
         */
        CompleteHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CompleteHistory)
                return object;
            var message = new $root.pond.CompleteHistory();
            if (object.deviceHistory != null) {
                if (typeof object.deviceHistory !== "object")
                    throw TypeError(".pond.CompleteHistory.deviceHistory: object expected");
                message.deviceHistory = $root.pond.DeviceHistory.fromObject(object.deviceHistory);
            }
            if (object.componentHistory != null) {
                if (typeof object.componentHistory !== "object")
                    throw TypeError(".pond.CompleteHistory.componentHistory: object expected");
                message.componentHistory = $root.pond.ComponentHistory.fromObject(object.componentHistory);
            }
            if (object.interactionHistory != null) {
                if (typeof object.interactionHistory !== "object")
                    throw TypeError(".pond.CompleteHistory.interactionHistory: object expected");
                message.interactionHistory = $root.pond.InteractionHistory.fromObject(object.interactionHistory);
            }
            if (object.objectHistory != null) {
                if (typeof object.objectHistory !== "object")
                    throw TypeError(".pond.CompleteHistory.objectHistory: object expected");
                message.objectHistory = $root.pond.ObjectHistory.fromObject(object.objectHistory);
            }
            if (object.sourceTable != null)
                message.sourceTable = String(object.sourceTable);
            if (object.progress != null)
                message.progress = String(object.progress);
            return message;
        };

        /**
         * Creates a plain object from a CompleteHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CompleteHistory
         * @static
         * @param {pond.CompleteHistory} message CompleteHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.progress = "";
                object.sourceTable = "";
            }
            if (message.deviceHistory != null && message.hasOwnProperty("deviceHistory")) {
                object.deviceHistory = $root.pond.DeviceHistory.toObject(message.deviceHistory, options);
                if (options.oneofs)
                    object.history = "deviceHistory";
            }
            if (message.componentHistory != null && message.hasOwnProperty("componentHistory")) {
                object.componentHistory = $root.pond.ComponentHistory.toObject(message.componentHistory, options);
                if (options.oneofs)
                    object.history = "componentHistory";
            }
            if (message.interactionHistory != null && message.hasOwnProperty("interactionHistory")) {
                object.interactionHistory = $root.pond.InteractionHistory.toObject(message.interactionHistory, options);
                if (options.oneofs)
                    object.history = "interactionHistory";
            }
            if (message.objectHistory != null && message.hasOwnProperty("objectHistory")) {
                object.objectHistory = $root.pond.ObjectHistory.toObject(message.objectHistory, options);
                if (options.oneofs)
                    object.history = "objectHistory";
            }
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            if (message.sourceTable != null && message.hasOwnProperty("sourceTable"))
                object.sourceTable = message.sourceTable;
            return object;
        };

        /**
         * Converts this CompleteHistory to JSON.
         * @function toJSON
         * @memberof pond.CompleteHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteHistory;
    })();

    pond.ObjectHistory = (function() {

        /**
         * Properties of an ObjectHistory.
         * @memberof pond
         * @interface IObjectHistory
         * @property {pond.ObjectSettings|null} [object] ObjectHistory object
         * @property {string|null} [user] ObjectHistory user
         * @property {string|null} [timestamp] ObjectHistory timestamp
         * @property {pond.ObjectType|null} [type] ObjectHistory type
         * @property {string|null} [progress] ObjectHistory progress
         * @property {string|null} [parentDevice] ObjectHistory parentDevice
         */

        /**
         * Constructs a new ObjectHistory.
         * @memberof pond
         * @classdesc Represents an ObjectHistory.
         * @implements IObjectHistory
         * @constructor
         * @param {pond.IObjectHistory=} [properties] Properties to set
         */
        function ObjectHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectHistory object.
         * @member {pond.ObjectSettings|null|undefined} object
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.object = null;

        /**
         * ObjectHistory user.
         * @member {string} user
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.user = "";

        /**
         * ObjectHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.timestamp = "";

        /**
         * ObjectHistory type.
         * @member {pond.ObjectType} type
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.type = 0;

        /**
         * ObjectHistory progress.
         * @member {string} progress
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.progress = "";

        /**
         * ObjectHistory parentDevice.
         * @member {string} parentDevice
         * @memberof pond.ObjectHistory
         * @instance
         */
        ObjectHistory.prototype.parentDevice = "";

        /**
         * Creates a new ObjectHistory instance using the specified properties.
         * @function create
         * @memberof pond.ObjectHistory
         * @static
         * @param {pond.IObjectHistory=} [properties] Properties to set
         * @returns {pond.ObjectHistory} ObjectHistory instance
         */
        ObjectHistory.create = function create(properties) {
            return new ObjectHistory(properties);
        };

        /**
         * Creates an ObjectHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectHistory} ObjectHistory
         */
        ObjectHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectHistory)
                return object;
            var message = new $root.pond.ObjectHistory();
            if (object.object != null) {
                if (typeof object.object !== "object")
                    throw TypeError(".pond.ObjectHistory.object: object expected");
                message.object = $root.pond.ObjectSettings.fromObject(object.object);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            switch (object.type) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.type = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.type = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.type = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.type = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.type = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.type = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.type = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.type = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.type = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.type = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.type = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.type = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.type = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.type = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.type = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.type = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.type = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.type = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.type = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.type = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.type = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.type = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.type = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.type = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.type = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.type = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.type = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.type = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.type = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.type = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.type = 31;
                break;
            }
            if (object.progress != null)
                message.progress = String(object.progress);
            if (object.parentDevice != null)
                message.parentDevice = String(object.parentDevice);
            return message;
        };

        /**
         * Creates a plain object from an ObjectHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectHistory
         * @static
         * @param {pond.ObjectHistory} message ObjectHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.object = null;
                object.user = "";
                object.timestamp = "";
                object.type = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.progress = "";
                object.parentDevice = "";
            }
            if (message.object != null && message.hasOwnProperty("object"))
                object.object = $root.pond.ObjectSettings.toObject(message.object, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.ObjectType[message.type] : message.type;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            if (message.parentDevice != null && message.hasOwnProperty("parentDevice"))
                object.parentDevice = message.parentDevice;
            return object;
        };

        /**
         * Converts this ObjectHistory to JSON.
         * @function toJSON
         * @memberof pond.ObjectHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectHistory;
    })();

    pond.InteractionHistory = (function() {

        /**
         * Properties of an InteractionHistory.
         * @memberof pond
         * @interface IInteractionHistory
         * @property {pond.InteractionSettings|null} [interaction] InteractionHistory interaction
         * @property {string|null} [user] InteractionHistory user
         * @property {string|null} [timestamp] InteractionHistory timestamp
         * @property {string|null} [parentDevice] InteractionHistory parentDevice
         */

        /**
         * Constructs a new InteractionHistory.
         * @memberof pond
         * @classdesc Represents an InteractionHistory.
         * @implements IInteractionHistory
         * @constructor
         * @param {pond.IInteractionHistory=} [properties] Properties to set
         */
        function InteractionHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionHistory interaction.
         * @member {pond.InteractionSettings|null|undefined} interaction
         * @memberof pond.InteractionHistory
         * @instance
         */
        InteractionHistory.prototype.interaction = null;

        /**
         * InteractionHistory user.
         * @member {string} user
         * @memberof pond.InteractionHistory
         * @instance
         */
        InteractionHistory.prototype.user = "";

        /**
         * InteractionHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.InteractionHistory
         * @instance
         */
        InteractionHistory.prototype.timestamp = "";

        /**
         * InteractionHistory parentDevice.
         * @member {string} parentDevice
         * @memberof pond.InteractionHistory
         * @instance
         */
        InteractionHistory.prototype.parentDevice = "";

        /**
         * Creates a new InteractionHistory instance using the specified properties.
         * @function create
         * @memberof pond.InteractionHistory
         * @static
         * @param {pond.IInteractionHistory=} [properties] Properties to set
         * @returns {pond.InteractionHistory} InteractionHistory instance
         */
        InteractionHistory.create = function create(properties) {
            return new InteractionHistory(properties);
        };

        /**
         * Creates an InteractionHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionHistory} InteractionHistory
         */
        InteractionHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionHistory)
                return object;
            var message = new $root.pond.InteractionHistory();
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".pond.InteractionHistory.interaction: object expected");
                message.interaction = $root.pond.InteractionSettings.fromObject(object.interaction);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.parentDevice != null)
                message.parentDevice = String(object.parentDevice);
            return message;
        };

        /**
         * Creates a plain object from an InteractionHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionHistory
         * @static
         * @param {pond.InteractionHistory} message InteractionHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.interaction = null;
                object.user = "";
                object.timestamp = "";
                object.parentDevice = "";
            }
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.pond.InteractionSettings.toObject(message.interaction, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.parentDevice != null && message.hasOwnProperty("parentDevice"))
                object.parentDevice = message.parentDevice;
            return object;
        };

        /**
         * Converts this InteractionHistory to JSON.
         * @function toJSON
         * @memberof pond.InteractionHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionHistory;
    })();

    pond.ListCompleteHistoryRequest = (function() {

        /**
         * Properties of a ListCompleteHistoryRequest.
         * @memberof pond
         * @interface IListCompleteHistoryRequest
         * @property {number|null} [deviceId] ListCompleteHistoryRequest deviceId
         * @property {pond.Paging|null} [paging] ListCompleteHistoryRequest paging
         * @property {Array.<pond.ObjectType>|null} [types] ListCompleteHistoryRequest types
         */

        /**
         * Constructs a new ListCompleteHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListCompleteHistoryRequest.
         * @implements IListCompleteHistoryRequest
         * @constructor
         * @param {pond.IListCompleteHistoryRequest=} [properties] Properties to set
         */
        function ListCompleteHistoryRequest(properties) {
            this.types = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCompleteHistoryRequest deviceId.
         * @member {number} deviceId
         * @memberof pond.ListCompleteHistoryRequest
         * @instance
         */
        ListCompleteHistoryRequest.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListCompleteHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListCompleteHistoryRequest
         * @instance
         */
        ListCompleteHistoryRequest.prototype.paging = null;

        /**
         * ListCompleteHistoryRequest types.
         * @member {Array.<pond.ObjectType>} types
         * @memberof pond.ListCompleteHistoryRequest
         * @instance
         */
        ListCompleteHistoryRequest.prototype.types = $util.emptyArray;

        /**
         * Creates a new ListCompleteHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListCompleteHistoryRequest
         * @static
         * @param {pond.IListCompleteHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListCompleteHistoryRequest} ListCompleteHistoryRequest instance
         */
        ListCompleteHistoryRequest.create = function create(properties) {
            return new ListCompleteHistoryRequest(properties);
        };

        /**
         * Creates a ListCompleteHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCompleteHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCompleteHistoryRequest} ListCompleteHistoryRequest
         */
        ListCompleteHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCompleteHistoryRequest)
                return object;
            var message = new $root.pond.ListCompleteHistoryRequest();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListCompleteHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.types) {
                if (!Array.isArray(object.types))
                    throw TypeError(".pond.ListCompleteHistoryRequest.types: array expected");
                message.types = [];
                for (var i = 0; i < object.types.length; ++i)
                    switch (object.types[i]) {
                    default:
                    case "OBJECT_TYPE_UNKNOWN":
                    case 0:
                        message.types[i] = 0;
                        break;
                    case "OBJECT_TYPE_BIN":
                    case 1:
                        message.types[i] = 1;
                        break;
                    case "OBJECT_TYPE_SITE":
                    case 2:
                        message.types[i] = 2;
                        break;
                    case "OBJECT_TYPE_DEVICE":
                    case 3:
                        message.types[i] = 3;
                        break;
                    case "OBJECT_TYPE_COMPONENT":
                    case 4:
                        message.types[i] = 4;
                        break;
                    case "OBJECT_TYPE_INTERACTION":
                    case 5:
                        message.types[i] = 5;
                        break;
                    case "OBJECT_TYPE_NOTE":
                    case 6:
                        message.types[i] = 6;
                        break;
                    case "OBJECT_TYPE_FIELD":
                    case 7:
                        message.types[i] = 7;
                        break;
                    case "OBJECT_TYPE_FIELDMARKER":
                    case 8:
                        message.types[i] = 8;
                        break;
                    case "OBJECT_TYPE_HOMEMARKER":
                    case 9:
                        message.types[i] = 9;
                        break;
                    case "OBJECT_TYPE_HARVESTPLAN":
                    case 10:
                        message.types[i] = 10;
                        break;
                    case "OBJECT_TYPE_TASK":
                    case 11:
                        message.types[i] = 11;
                        break;
                    case "OBJECT_TYPE_MINE":
                    case 12:
                        message.types[i] = 12;
                        break;
                    case "OBJECT_TYPE_BINYARD":
                    case 13:
                        message.types[i] = 13;
                        break;
                    case "OBJECT_TYPE_TERMINAL":
                    case 14:
                        message.types[i] = 14;
                        break;
                    case "OBJECT_TYPE_GATE":
                    case 15:
                        message.types[i] = 15;
                        break;
                    case "OBJECT_TYPE_FIRMWARE":
                    case 16:
                        message.types[i] = 16;
                        break;
                    case "OBJECT_TYPE_GROUP":
                    case 17:
                        message.types[i] = 17;
                        break;
                    case "OBJECT_TYPE_UPGRADE":
                    case 18:
                        message.types[i] = 18;
                        break;
                    case "OBJECT_TYPE_USER":
                    case 19:
                        message.types[i] = 19;
                        break;
                    case "OBJECT_TYPE_BACKPACK":
                    case 20:
                        message.types[i] = 20;
                        break;
                    case "OBJECT_TYPE_HARVESTYEAR":
                    case 21:
                        message.types[i] = 21;
                        break;
                    case "OBJECT_TYPE_TAG":
                    case 22:
                        message.types[i] = 22;
                        break;
                    case "OBJECT_TYPE_TEAM":
                    case 23:
                        message.types[i] = 23;
                        break;
                    case "OBJECT_TYPE_LINK":
                    case 24:
                        message.types[i] = 24;
                        break;
                    case "OBJECT_TYPE_HEATER":
                    case 25:
                        message.types[i] = 25;
                        break;
                    case "OBJECT_TYPE_GRAIN_BAG":
                    case 26:
                        message.types[i] = 26;
                        break;
                    case "OBJECT_TYPE_CONTRACT":
                    case 27:
                        message.types[i] = 27;
                        break;
                    case "OBJECT_TYPE_TRANSACTION":
                    case 28:
                        message.types[i] = 28;
                        break;
                    case "OBJECT_TYPE_FILE":
                    case 29:
                        message.types[i] = 29;
                        break;
                    case "OBJECT_TYPE_NOTIFICATION_BANNER":
                    case 30:
                        message.types[i] = 30;
                        break;
                    case "OBJECT_TYPE_DEVICE_PRESET":
                    case 31:
                        message.types[i] = 31;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListCompleteHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCompleteHistoryRequest
         * @static
         * @param {pond.ListCompleteHistoryRequest} message ListCompleteHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCompleteHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.types = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.paging = null;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.types && message.types.length) {
                object.types = [];
                for (var j = 0; j < message.types.length; ++j)
                    object.types[j] = options.enums === String ? $root.pond.ObjectType[message.types[j]] : message.types[j];
            }
            return object;
        };

        /**
         * Converts this ListCompleteHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListCompleteHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCompleteHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCompleteHistoryRequest;
    })();

    pond.ListCompleteHistoryResponse = (function() {

        /**
         * Properties of a ListCompleteHistoryResponse.
         * @memberof pond
         * @interface IListCompleteHistoryResponse
         * @property {Array.<pond.ObjectHistory>|null} [history] ListCompleteHistoryResponse history
         * @property {number|null} [nextOffset] ListCompleteHistoryResponse nextOffset
         * @property {number|null} [total] ListCompleteHistoryResponse total
         */

        /**
         * Constructs a new ListCompleteHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListCompleteHistoryResponse.
         * @implements IListCompleteHistoryResponse
         * @constructor
         * @param {pond.IListCompleteHistoryResponse=} [properties] Properties to set
         */
        function ListCompleteHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCompleteHistoryResponse history.
         * @member {Array.<pond.ObjectHistory>} history
         * @memberof pond.ListCompleteHistoryResponse
         * @instance
         */
        ListCompleteHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListCompleteHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListCompleteHistoryResponse
         * @instance
         */
        ListCompleteHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListCompleteHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListCompleteHistoryResponse
         * @instance
         */
        ListCompleteHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListCompleteHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListCompleteHistoryResponse
         * @static
         * @param {pond.IListCompleteHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListCompleteHistoryResponse} ListCompleteHistoryResponse instance
         */
        ListCompleteHistoryResponse.create = function create(properties) {
            return new ListCompleteHistoryResponse(properties);
        };

        /**
         * Creates a ListCompleteHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCompleteHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCompleteHistoryResponse} ListCompleteHistoryResponse
         */
        ListCompleteHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCompleteHistoryResponse)
                return object;
            var message = new $root.pond.ListCompleteHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListCompleteHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListCompleteHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.ObjectHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListCompleteHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCompleteHistoryResponse
         * @static
         * @param {pond.ListCompleteHistoryResponse} message ListCompleteHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCompleteHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.ObjectHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListCompleteHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListCompleteHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCompleteHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCompleteHistoryResponse;
    })();

    pond.DataDogLogsRequest = (function() {

        /**
         * Properties of a DataDogLogsRequest.
         * @memberof pond
         * @interface IDataDogLogsRequest
         * @property {string|null} [filterQuery] DataDogLogsRequest filterQuery
         * @property {string|null} [filterFrom] DataDogLogsRequest filterFrom
         * @property {string|null} [filterTo] DataDogLogsRequest filterTo
         * @property {string|null} [sort] DataDogLogsRequest sort
         * @property {number|null} [limit] DataDogLogsRequest limit
         */

        /**
         * Constructs a new DataDogLogsRequest.
         * @memberof pond
         * @classdesc Represents a DataDogLogsRequest.
         * @implements IDataDogLogsRequest
         * @constructor
         * @param {pond.IDataDogLogsRequest=} [properties] Properties to set
         */
        function DataDogLogsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DataDogLogsRequest filterQuery.
         * @member {string} filterQuery
         * @memberof pond.DataDogLogsRequest
         * @instance
         */
        DataDogLogsRequest.prototype.filterQuery = "";

        /**
         * DataDogLogsRequest filterFrom.
         * @member {string} filterFrom
         * @memberof pond.DataDogLogsRequest
         * @instance
         */
        DataDogLogsRequest.prototype.filterFrom = "";

        /**
         * DataDogLogsRequest filterTo.
         * @member {string} filterTo
         * @memberof pond.DataDogLogsRequest
         * @instance
         */
        DataDogLogsRequest.prototype.filterTo = "";

        /**
         * DataDogLogsRequest sort.
         * @member {string} sort
         * @memberof pond.DataDogLogsRequest
         * @instance
         */
        DataDogLogsRequest.prototype.sort = "";

        /**
         * DataDogLogsRequest limit.
         * @member {number} limit
         * @memberof pond.DataDogLogsRequest
         * @instance
         */
        DataDogLogsRequest.prototype.limit = 0;

        /**
         * Creates a new DataDogLogsRequest instance using the specified properties.
         * @function create
         * @memberof pond.DataDogLogsRequest
         * @static
         * @param {pond.IDataDogLogsRequest=} [properties] Properties to set
         * @returns {pond.DataDogLogsRequest} DataDogLogsRequest instance
         */
        DataDogLogsRequest.create = function create(properties) {
            return new DataDogLogsRequest(properties);
        };

        /**
         * Creates a DataDogLogsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DataDogLogsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DataDogLogsRequest} DataDogLogsRequest
         */
        DataDogLogsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DataDogLogsRequest)
                return object;
            var message = new $root.pond.DataDogLogsRequest();
            if (object.filterQuery != null)
                message.filterQuery = String(object.filterQuery);
            if (object.filterFrom != null)
                message.filterFrom = String(object.filterFrom);
            if (object.filterTo != null)
                message.filterTo = String(object.filterTo);
            if (object.sort != null)
                message.sort = String(object.sort);
            if (object.limit != null)
                message.limit = object.limit >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a DataDogLogsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DataDogLogsRequest
         * @static
         * @param {pond.DataDogLogsRequest} message DataDogLogsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DataDogLogsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.filterQuery = "";
                object.filterFrom = "";
                object.filterTo = "";
                object.sort = "";
                object.limit = 0;
            }
            if (message.filterQuery != null && message.hasOwnProperty("filterQuery"))
                object.filterQuery = message.filterQuery;
            if (message.filterFrom != null && message.hasOwnProperty("filterFrom"))
                object.filterFrom = message.filterFrom;
            if (message.filterTo != null && message.hasOwnProperty("filterTo"))
                object.filterTo = message.filterTo;
            if (message.sort != null && message.hasOwnProperty("sort"))
                object.sort = message.sort;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this DataDogLogsRequest to JSON.
         * @function toJSON
         * @memberof pond.DataDogLogsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DataDogLogsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DataDogLogsRequest;
    })();

    pond.Log = (function() {

        /**
         * Properties of a Log.
         * @memberof pond
         * @interface ILog
         * @property {number|null} [device] Log device
         * @property {string|null} [level] Log level
         * @property {string|null} [message] Log message
         * @property {string|null} [error] Log error
         * @property {string|null} [timestamp] Log timestamp
         * @property {string|null} [attributes] Log attributes
         * @property {string|null} [service] Log service
         */

        /**
         * Constructs a new Log.
         * @memberof pond
         * @classdesc Represents a Log.
         * @implements ILog
         * @constructor
         * @param {pond.ILog=} [properties] Properties to set
         */
        function Log(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Log device.
         * @member {number} device
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.device = 0;

        /**
         * Log level.
         * @member {string} level
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.level = "";

        /**
         * Log message.
         * @member {string} message
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.message = "";

        /**
         * Log error.
         * @member {string} error
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.error = "";

        /**
         * Log timestamp.
         * @member {string} timestamp
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.timestamp = "";

        /**
         * Log attributes.
         * @member {string} attributes
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.attributes = "";

        /**
         * Log service.
         * @member {string} service
         * @memberof pond.Log
         * @instance
         */
        Log.prototype.service = "";

        /**
         * Creates a new Log instance using the specified properties.
         * @function create
         * @memberof pond.Log
         * @static
         * @param {pond.ILog=} [properties] Properties to set
         * @returns {pond.Log} Log instance
         */
        Log.create = function create(properties) {
            return new Log(properties);
        };

        /**
         * Creates a Log message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Log
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Log} Log
         */
        Log.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Log)
                return object;
            var message = new $root.pond.Log();
            if (object.device != null)
                message.device = object.device >>> 0;
            if (object.level != null)
                message.level = String(object.level);
            if (object.message != null)
                message.message = String(object.message);
            if (object.error != null)
                message.error = String(object.error);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.attributes != null)
                message.attributes = String(object.attributes);
            if (object.service != null)
                message.service = String(object.service);
            return message;
        };

        /**
         * Creates a plain object from a Log message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Log
         * @static
         * @param {pond.Log} message Log
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Log.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.device = 0;
                object.level = "";
                object.message = "";
                object.error = "";
                object.timestamp = "";
                object.attributes = "";
                object.service = "";
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            if (message.level != null && message.hasOwnProperty("level"))
                object.level = message.level;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.attributes != null && message.hasOwnProperty("attributes"))
                object.attributes = message.attributes;
            if (message.service != null && message.hasOwnProperty("service"))
                object.service = message.service;
            return object;
        };

        /**
         * Converts this Log to JSON.
         * @function toJSON
         * @memberof pond.Log
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Log.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Log;
    })();

    pond.DataDogLogsResponse = (function() {

        /**
         * Properties of a DataDogLogsResponse.
         * @memberof pond
         * @interface IDataDogLogsResponse
         * @property {Array.<pond.Log>|null} [logs] DataDogLogsResponse logs
         */

        /**
         * Constructs a new DataDogLogsResponse.
         * @memberof pond
         * @classdesc Represents a DataDogLogsResponse.
         * @implements IDataDogLogsResponse
         * @constructor
         * @param {pond.IDataDogLogsResponse=} [properties] Properties to set
         */
        function DataDogLogsResponse(properties) {
            this.logs = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DataDogLogsResponse logs.
         * @member {Array.<pond.Log>} logs
         * @memberof pond.DataDogLogsResponse
         * @instance
         */
        DataDogLogsResponse.prototype.logs = $util.emptyArray;

        /**
         * Creates a new DataDogLogsResponse instance using the specified properties.
         * @function create
         * @memberof pond.DataDogLogsResponse
         * @static
         * @param {pond.IDataDogLogsResponse=} [properties] Properties to set
         * @returns {pond.DataDogLogsResponse} DataDogLogsResponse instance
         */
        DataDogLogsResponse.create = function create(properties) {
            return new DataDogLogsResponse(properties);
        };

        /**
         * Creates a DataDogLogsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DataDogLogsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DataDogLogsResponse} DataDogLogsResponse
         */
        DataDogLogsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DataDogLogsResponse)
                return object;
            var message = new $root.pond.DataDogLogsResponse();
            if (object.logs) {
                if (!Array.isArray(object.logs))
                    throw TypeError(".pond.DataDogLogsResponse.logs: array expected");
                message.logs = [];
                for (var i = 0; i < object.logs.length; ++i) {
                    if (typeof object.logs[i] !== "object")
                        throw TypeError(".pond.DataDogLogsResponse.logs: object expected");
                    message.logs[i] = $root.pond.Log.fromObject(object.logs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a DataDogLogsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DataDogLogsResponse
         * @static
         * @param {pond.DataDogLogsResponse} message DataDogLogsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DataDogLogsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.logs = [];
            if (message.logs && message.logs.length) {
                object.logs = [];
                for (var j = 0; j < message.logs.length; ++j)
                    object.logs[j] = $root.pond.Log.toObject(message.logs[j], options);
            }
            return object;
        };

        /**
         * Converts this DataDogLogsResponse to JSON.
         * @function toJSON
         * @memberof pond.DataDogLogsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DataDogLogsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DataDogLogsResponse;
    })();

    pond.NewCronRequest = (function() {

        /**
         * Properties of a NewCronRequest.
         * @memberof pond
         * @interface INewCronRequest
         * @property {string|null} [time] NewCronRequest time
         * @property {string|null} [device] NewCronRequest device
         * @property {string|null} [componentId] NewCronRequest componentId
         * @property {string|null} [componentKey] NewCronRequest componentKey
         * @property {string|null} [url] NewCronRequest url
         */

        /**
         * Constructs a new NewCronRequest.
         * @memberof pond
         * @classdesc Represents a NewCronRequest.
         * @implements INewCronRequest
         * @constructor
         * @param {pond.INewCronRequest=} [properties] Properties to set
         */
        function NewCronRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NewCronRequest time.
         * @member {string} time
         * @memberof pond.NewCronRequest
         * @instance
         */
        NewCronRequest.prototype.time = "";

        /**
         * NewCronRequest device.
         * @member {string} device
         * @memberof pond.NewCronRequest
         * @instance
         */
        NewCronRequest.prototype.device = "";

        /**
         * NewCronRequest componentId.
         * @member {string} componentId
         * @memberof pond.NewCronRequest
         * @instance
         */
        NewCronRequest.prototype.componentId = "";

        /**
         * NewCronRequest componentKey.
         * @member {string} componentKey
         * @memberof pond.NewCronRequest
         * @instance
         */
        NewCronRequest.prototype.componentKey = "";

        /**
         * NewCronRequest url.
         * @member {string} url
         * @memberof pond.NewCronRequest
         * @instance
         */
        NewCronRequest.prototype.url = "";

        /**
         * Creates a new NewCronRequest instance using the specified properties.
         * @function create
         * @memberof pond.NewCronRequest
         * @static
         * @param {pond.INewCronRequest=} [properties] Properties to set
         * @returns {pond.NewCronRequest} NewCronRequest instance
         */
        NewCronRequest.create = function create(properties) {
            return new NewCronRequest(properties);
        };

        /**
         * Creates a NewCronRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NewCronRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NewCronRequest} NewCronRequest
         */
        NewCronRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NewCronRequest)
                return object;
            var message = new $root.pond.NewCronRequest();
            if (object.time != null)
                message.time = String(object.time);
            if (object.device != null)
                message.device = String(object.device);
            if (object.componentId != null)
                message.componentId = String(object.componentId);
            if (object.componentKey != null)
                message.componentKey = String(object.componentKey);
            if (object.url != null)
                message.url = String(object.url);
            return message;
        };

        /**
         * Creates a plain object from a NewCronRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NewCronRequest
         * @static
         * @param {pond.NewCronRequest} message NewCronRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NewCronRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.time = "";
                object.device = "";
                object.componentId = "";
                object.componentKey = "";
                object.url = "";
            }
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            if (message.componentId != null && message.hasOwnProperty("componentId"))
                object.componentId = message.componentId;
            if (message.componentKey != null && message.hasOwnProperty("componentKey"))
                object.componentKey = message.componentKey;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            return object;
        };

        /**
         * Converts this NewCronRequest to JSON.
         * @function toJSON
         * @memberof pond.NewCronRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NewCronRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NewCronRequest;
    })();

    pond.NewCronResponse = (function() {

        /**
         * Properties of a NewCronResponse.
         * @memberof pond
         * @interface INewCronResponse
         * @property {boolean|null} [cronCreated] NewCronResponse cronCreated
         */

        /**
         * Constructs a new NewCronResponse.
         * @memberof pond
         * @classdesc Represents a NewCronResponse.
         * @implements INewCronResponse
         * @constructor
         * @param {pond.INewCronResponse=} [properties] Properties to set
         */
        function NewCronResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NewCronResponse cronCreated.
         * @member {boolean} cronCreated
         * @memberof pond.NewCronResponse
         * @instance
         */
        NewCronResponse.prototype.cronCreated = false;

        /**
         * Creates a new NewCronResponse instance using the specified properties.
         * @function create
         * @memberof pond.NewCronResponse
         * @static
         * @param {pond.INewCronResponse=} [properties] Properties to set
         * @returns {pond.NewCronResponse} NewCronResponse instance
         */
        NewCronResponse.create = function create(properties) {
            return new NewCronResponse(properties);
        };

        /**
         * Creates a NewCronResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NewCronResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NewCronResponse} NewCronResponse
         */
        NewCronResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NewCronResponse)
                return object;
            var message = new $root.pond.NewCronResponse();
            if (object.cronCreated != null)
                message.cronCreated = Boolean(object.cronCreated);
            return message;
        };

        /**
         * Creates a plain object from a NewCronResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NewCronResponse
         * @static
         * @param {pond.NewCronResponse} message NewCronResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NewCronResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.cronCreated = false;
            if (message.cronCreated != null && message.hasOwnProperty("cronCreated"))
                object.cronCreated = message.cronCreated;
            return object;
        };

        /**
         * Converts this NewCronResponse to JSON.
         * @function toJSON
         * @memberof pond.NewCronResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NewCronResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NewCronResponse;
    })();

    pond.Empty = (function() {

        /**
         * Properties of an Empty.
         * @memberof pond
         * @interface IEmpty
         */

        /**
         * Constructs a new Empty.
         * @memberof pond
         * @classdesc Represents an Empty.
         * @implements IEmpty
         * @constructor
         * @param {pond.IEmpty=} [properties] Properties to set
         */
        function Empty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Empty instance using the specified properties.
         * @function create
         * @memberof pond.Empty
         * @static
         * @param {pond.IEmpty=} [properties] Properties to set
         * @returns {pond.Empty} Empty instance
         */
        Empty.create = function create(properties) {
            return new Empty(properties);
        };

        /**
         * Creates an Empty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Empty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Empty} Empty
         */
        Empty.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Empty)
                return object;
            return new $root.pond.Empty();
        };

        /**
         * Creates a plain object from an Empty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Empty
         * @static
         * @param {pond.Empty} message Empty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Empty.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Empty to JSON.
         * @function toJSON
         * @memberof pond.Empty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Empty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Empty;
    })();

    pond.ObjectTheme = (function() {

        /**
         * Properties of an ObjectTheme.
         * @memberof pond
         * @interface IObjectTheme
         * @property {string|null} [color] ObjectTheme color
         * @property {number|null} [height] ObjectTheme height
         * @property {number|null} [width] ObjectTheme width
         */

        /**
         * Constructs a new ObjectTheme.
         * @memberof pond
         * @classdesc Represents an ObjectTheme.
         * @implements IObjectTheme
         * @constructor
         * @param {pond.IObjectTheme=} [properties] Properties to set
         */
        function ObjectTheme(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectTheme color.
         * @member {string} color
         * @memberof pond.ObjectTheme
         * @instance
         */
        ObjectTheme.prototype.color = "";

        /**
         * ObjectTheme height.
         * @member {number} height
         * @memberof pond.ObjectTheme
         * @instance
         */
        ObjectTheme.prototype.height = 0;

        /**
         * ObjectTheme width.
         * @member {number} width
         * @memberof pond.ObjectTheme
         * @instance
         */
        ObjectTheme.prototype.width = 0;

        /**
         * Creates a new ObjectTheme instance using the specified properties.
         * @function create
         * @memberof pond.ObjectTheme
         * @static
         * @param {pond.IObjectTheme=} [properties] Properties to set
         * @returns {pond.ObjectTheme} ObjectTheme instance
         */
        ObjectTheme.create = function create(properties) {
            return new ObjectTheme(properties);
        };

        /**
         * Creates an ObjectTheme message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectTheme
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectTheme} ObjectTheme
         */
        ObjectTheme.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectTheme)
                return object;
            var message = new $root.pond.ObjectTheme();
            if (object.color != null)
                message.color = String(object.color);
            if (object.height != null)
                message.height = object.height >>> 0;
            if (object.width != null)
                message.width = object.width >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an ObjectTheme message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectTheme
         * @static
         * @param {pond.ObjectTheme} message ObjectTheme
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectTheme.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.color = "";
                object.height = 0;
                object.width = 0;
            }
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.height != null && message.hasOwnProperty("height"))
                object.height = message.height;
            if (message.width != null && message.hasOwnProperty("width"))
                object.width = message.width;
            return object;
        };

        /**
         * Converts this ObjectTheme to JSON.
         * @function toJSON
         * @memberof pond.ObjectTheme
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectTheme.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectTheme;
    })();

    pond.Paging = (function() {

        /**
         * Properties of a Paging.
         * @memberof pond
         * @interface IPaging
         * @property {number|null} [limit] Paging limit
         * @property {number|null} [offset] Paging offset
         */

        /**
         * Constructs a new Paging.
         * @memberof pond
         * @classdesc Represents a Paging.
         * @implements IPaging
         * @constructor
         * @param {pond.IPaging=} [properties] Properties to set
         */
        function Paging(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Paging limit.
         * @member {number} limit
         * @memberof pond.Paging
         * @instance
         */
        Paging.prototype.limit = 0;

        /**
         * Paging offset.
         * @member {number} offset
         * @memberof pond.Paging
         * @instance
         */
        Paging.prototype.offset = 0;

        /**
         * Creates a new Paging instance using the specified properties.
         * @function create
         * @memberof pond.Paging
         * @static
         * @param {pond.IPaging=} [properties] Properties to set
         * @returns {pond.Paging} Paging instance
         */
        Paging.create = function create(properties) {
            return new Paging(properties);
        };

        /**
         * Creates a Paging message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Paging
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Paging} Paging
         */
        Paging.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Paging)
                return object;
            var message = new $root.pond.Paging();
            if (object.limit != null)
                message.limit = object.limit >>> 0;
            if (object.offset != null)
                message.offset = object.offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Paging message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Paging
         * @static
         * @param {pond.Paging} message Paging
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Paging.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.limit = 0;
                object.offset = 0;
            }
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            return object;
        };

        /**
         * Converts this Paging to JSON.
         * @function toJSON
         * @memberof pond.Paging
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Paging.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Paging;
    })();

    /**
     * SortOrder enum.
     * @name pond.SortOrder
     * @enum {string}
     * @property {number} SORT_ORDER_ASC=0 SORT_ORDER_ASC value
     * @property {number} SORT_ORDER_DESC=1 SORT_ORDER_DESC value
     */
    pond.SortOrder = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SORT_ORDER_ASC"] = 0;
        values[valuesById[1] = "SORT_ORDER_DESC"] = 1;
        return values;
    })();

    pond.Sorting = (function() {

        /**
         * Properties of a Sorting.
         * @memberof pond
         * @interface ISorting
         * @property {pond.SortOrder|null} [order] Sorting order
         * @property {string|null} [by] Sorting by
         * @property {boolean|null} [numerical] Sorting numerical
         */

        /**
         * Constructs a new Sorting.
         * @memberof pond
         * @classdesc Represents a Sorting.
         * @implements ISorting
         * @constructor
         * @param {pond.ISorting=} [properties] Properties to set
         */
        function Sorting(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Sorting order.
         * @member {pond.SortOrder} order
         * @memberof pond.Sorting
         * @instance
         */
        Sorting.prototype.order = 0;

        /**
         * Sorting by.
         * @member {string} by
         * @memberof pond.Sorting
         * @instance
         */
        Sorting.prototype.by = "";

        /**
         * Sorting numerical.
         * @member {boolean} numerical
         * @memberof pond.Sorting
         * @instance
         */
        Sorting.prototype.numerical = false;

        /**
         * Creates a new Sorting instance using the specified properties.
         * @function create
         * @memberof pond.Sorting
         * @static
         * @param {pond.ISorting=} [properties] Properties to set
         * @returns {pond.Sorting} Sorting instance
         */
        Sorting.create = function create(properties) {
            return new Sorting(properties);
        };

        /**
         * Creates a Sorting message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Sorting
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Sorting} Sorting
         */
        Sorting.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Sorting)
                return object;
            var message = new $root.pond.Sorting();
            switch (object.order) {
            case "SORT_ORDER_ASC":
            case 0:
                message.order = 0;
                break;
            case "SORT_ORDER_DESC":
            case 1:
                message.order = 1;
                break;
            }
            if (object.by != null)
                message.by = String(object.by);
            if (object.numerical != null)
                message.numerical = Boolean(object.numerical);
            return message;
        };

        /**
         * Creates a plain object from a Sorting message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Sorting
         * @static
         * @param {pond.Sorting} message Sorting
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Sorting.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.order = options.enums === String ? "SORT_ORDER_ASC" : 0;
                object.by = "";
                object.numerical = false;
            }
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = options.enums === String ? $root.pond.SortOrder[message.order] : message.order;
            if (message.by != null && message.hasOwnProperty("by"))
                object.by = message.by;
            if (message.numerical != null && message.hasOwnProperty("numerical"))
                object.numerical = message.numerical;
            return object;
        };

        /**
         * Converts this Sorting to JSON.
         * @function toJSON
         * @memberof pond.Sorting
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Sorting.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Sorting;
    })();

    pond.Location = (function() {

        /**
         * Properties of a Location.
         * @memberof pond
         * @interface ILocation
         * @property {number|null} [latitude] Location latitude
         * @property {number|null} [longitude] Location longitude
         */

        /**
         * Constructs a new Location.
         * @memberof pond
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {pond.ILocation=} [properties] Properties to set
         */
        function Location(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Location latitude.
         * @member {number} latitude
         * @memberof pond.Location
         * @instance
         */
        Location.prototype.latitude = 0;

        /**
         * Location longitude.
         * @member {number} longitude
         * @memberof pond.Location
         * @instance
         */
        Location.prototype.longitude = 0;

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof pond.Location
         * @static
         * @param {pond.ILocation=} [properties] Properties to set
         * @returns {pond.Location} Location instance
         */
        Location.create = function create(properties) {
            return new Location(properties);
        };

        /**
         * Creates a Location message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Location
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Location} Location
         */
        Location.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Location)
                return object;
            var message = new $root.pond.Location();
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            return message;
        };

        /**
         * Creates a plain object from a Location message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Location
         * @static
         * @param {pond.Location} message Location
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Location.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.latitude = 0;
                object.longitude = 0;
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            return object;
        };

        /**
         * Converts this Location to JSON.
         * @function toJSON
         * @memberof pond.Location
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Location;
    })();

    pond.ReceiveQuackRequest = (function() {

        /**
         * Properties of a ReceiveQuackRequest.
         * @memberof pond
         * @interface IReceiveQuackRequest
         * @property {quack.Quack|null} [quack] ReceiveQuackRequest quack
         * @property {Uint8Array|null} [ackNonce] ReceiveQuackRequest ackNonce
         * @property {Array.<pond.QuackQueue>|null} [queue] ReceiveQuackRequest queue
         */

        /**
         * Constructs a new ReceiveQuackRequest.
         * @memberof pond
         * @classdesc Represents a ReceiveQuackRequest.
         * @implements IReceiveQuackRequest
         * @constructor
         * @param {pond.IReceiveQuackRequest=} [properties] Properties to set
         */
        function ReceiveQuackRequest(properties) {
            this.queue = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReceiveQuackRequest quack.
         * @member {quack.Quack|null|undefined} quack
         * @memberof pond.ReceiveQuackRequest
         * @instance
         */
        ReceiveQuackRequest.prototype.quack = null;

        /**
         * ReceiveQuackRequest ackNonce.
         * @member {Uint8Array} ackNonce
         * @memberof pond.ReceiveQuackRequest
         * @instance
         */
        ReceiveQuackRequest.prototype.ackNonce = $util.newBuffer([]);

        /**
         * ReceiveQuackRequest queue.
         * @member {Array.<pond.QuackQueue>} queue
         * @memberof pond.ReceiveQuackRequest
         * @instance
         */
        ReceiveQuackRequest.prototype.queue = $util.emptyArray;

        /**
         * Creates a new ReceiveQuackRequest instance using the specified properties.
         * @function create
         * @memberof pond.ReceiveQuackRequest
         * @static
         * @param {pond.IReceiveQuackRequest=} [properties] Properties to set
         * @returns {pond.ReceiveQuackRequest} ReceiveQuackRequest instance
         */
        ReceiveQuackRequest.create = function create(properties) {
            return new ReceiveQuackRequest(properties);
        };

        /**
         * Creates a ReceiveQuackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ReceiveQuackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ReceiveQuackRequest} ReceiveQuackRequest
         */
        ReceiveQuackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ReceiveQuackRequest)
                return object;
            var message = new $root.pond.ReceiveQuackRequest();
            if (object.quack != null) {
                if (typeof object.quack !== "object")
                    throw TypeError(".pond.ReceiveQuackRequest.quack: object expected");
                message.quack = $root.quack.Quack.fromObject(object.quack);
            }
            if (object.ackNonce != null)
                if (typeof object.ackNonce === "string")
                    $util.base64.decode(object.ackNonce, message.ackNonce = $util.newBuffer($util.base64.length(object.ackNonce)), 0);
                else if (object.ackNonce.length)
                    message.ackNonce = object.ackNonce;
            if (object.queue) {
                if (!Array.isArray(object.queue))
                    throw TypeError(".pond.ReceiveQuackRequest.queue: array expected");
                message.queue = [];
                for (var i = 0; i < object.queue.length; ++i) {
                    if (typeof object.queue[i] !== "object")
                        throw TypeError(".pond.ReceiveQuackRequest.queue: object expected");
                    message.queue[i] = $root.pond.QuackQueue.fromObject(object.queue[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ReceiveQuackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ReceiveQuackRequest
         * @static
         * @param {pond.ReceiveQuackRequest} message ReceiveQuackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiveQuackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.queue = [];
            if (options.defaults) {
                object.quack = null;
                if (options.bytes === String)
                    object.ackNonce = "";
                else {
                    object.ackNonce = [];
                    if (options.bytes !== Array)
                        object.ackNonce = $util.newBuffer(object.ackNonce);
                }
            }
            if (message.quack != null && message.hasOwnProperty("quack"))
                object.quack = $root.quack.Quack.toObject(message.quack, options);
            if (message.ackNonce != null && message.hasOwnProperty("ackNonce"))
                object.ackNonce = options.bytes === String ? $util.base64.encode(message.ackNonce, 0, message.ackNonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.ackNonce) : message.ackNonce;
            if (message.queue && message.queue.length) {
                object.queue = [];
                for (var j = 0; j < message.queue.length; ++j)
                    object.queue[j] = $root.pond.QuackQueue.toObject(message.queue[j], options);
            }
            return object;
        };

        /**
         * Converts this ReceiveQuackRequest to JSON.
         * @function toJSON
         * @memberof pond.ReceiveQuackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReceiveQuackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReceiveQuackRequest;
    })();

    pond.ReceiveQuackResponse = (function() {

        /**
         * Properties of a ReceiveQuackResponse.
         * @memberof pond
         * @interface IReceiveQuackResponse
         * @property {quack.Quack|null} [quack] ReceiveQuackResponse quack
         * @property {Uint8Array|null} [nonce] ReceiveQuackResponse nonce
         */

        /**
         * Constructs a new ReceiveQuackResponse.
         * @memberof pond
         * @classdesc Represents a ReceiveQuackResponse.
         * @implements IReceiveQuackResponse
         * @constructor
         * @param {pond.IReceiveQuackResponse=} [properties] Properties to set
         */
        function ReceiveQuackResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReceiveQuackResponse quack.
         * @member {quack.Quack|null|undefined} quack
         * @memberof pond.ReceiveQuackResponse
         * @instance
         */
        ReceiveQuackResponse.prototype.quack = null;

        /**
         * ReceiveQuackResponse nonce.
         * @member {Uint8Array} nonce
         * @memberof pond.ReceiveQuackResponse
         * @instance
         */
        ReceiveQuackResponse.prototype.nonce = $util.newBuffer([]);

        /**
         * Creates a new ReceiveQuackResponse instance using the specified properties.
         * @function create
         * @memberof pond.ReceiveQuackResponse
         * @static
         * @param {pond.IReceiveQuackResponse=} [properties] Properties to set
         * @returns {pond.ReceiveQuackResponse} ReceiveQuackResponse instance
         */
        ReceiveQuackResponse.create = function create(properties) {
            return new ReceiveQuackResponse(properties);
        };

        /**
         * Creates a ReceiveQuackResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ReceiveQuackResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ReceiveQuackResponse} ReceiveQuackResponse
         */
        ReceiveQuackResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ReceiveQuackResponse)
                return object;
            var message = new $root.pond.ReceiveQuackResponse();
            if (object.quack != null) {
                if (typeof object.quack !== "object")
                    throw TypeError(".pond.ReceiveQuackResponse.quack: object expected");
                message.quack = $root.quack.Quack.fromObject(object.quack);
            }
            if (object.nonce != null)
                if (typeof object.nonce === "string")
                    $util.base64.decode(object.nonce, message.nonce = $util.newBuffer($util.base64.length(object.nonce)), 0);
                else if (object.nonce.length)
                    message.nonce = object.nonce;
            return message;
        };

        /**
         * Creates a plain object from a ReceiveQuackResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ReceiveQuackResponse
         * @static
         * @param {pond.ReceiveQuackResponse} message ReceiveQuackResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiveQuackResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.quack = null;
                if (options.bytes === String)
                    object.nonce = "";
                else {
                    object.nonce = [];
                    if (options.bytes !== Array)
                        object.nonce = $util.newBuffer(object.nonce);
                }
            }
            if (message.quack != null && message.hasOwnProperty("quack"))
                object.quack = $root.quack.Quack.toObject(message.quack, options);
            if (message.nonce != null && message.hasOwnProperty("nonce"))
                object.nonce = options.bytes === String ? $util.base64.encode(message.nonce, 0, message.nonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.nonce) : message.nonce;
            return object;
        };

        /**
         * Converts this ReceiveQuackResponse to JSON.
         * @function toJSON
         * @memberof pond.ReceiveQuackResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReceiveQuackResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReceiveQuackResponse;
    })();

    pond.QuackQueue = (function() {

        /**
         * Properties of a QuackQueue.
         * @memberof pond
         * @interface IQuackQueue
         * @property {Uint8Array|null} [ackNonce] QuackQueue ackNonce
         * @property {Uint8Array|null} [payload] QuackQueue payload
         * @property {number|null} [deviceId] QuackQueue deviceId
         */

        /**
         * Constructs a new QuackQueue.
         * @memberof pond
         * @classdesc Represents a QuackQueue.
         * @implements IQuackQueue
         * @constructor
         * @param {pond.IQuackQueue=} [properties] Properties to set
         */
        function QuackQueue(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuackQueue ackNonce.
         * @member {Uint8Array} ackNonce
         * @memberof pond.QuackQueue
         * @instance
         */
        QuackQueue.prototype.ackNonce = $util.newBuffer([]);

        /**
         * QuackQueue payload.
         * @member {Uint8Array} payload
         * @memberof pond.QuackQueue
         * @instance
         */
        QuackQueue.prototype.payload = $util.newBuffer([]);

        /**
         * QuackQueue deviceId.
         * @member {number} deviceId
         * @memberof pond.QuackQueue
         * @instance
         */
        QuackQueue.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new QuackQueue instance using the specified properties.
         * @function create
         * @memberof pond.QuackQueue
         * @static
         * @param {pond.IQuackQueue=} [properties] Properties to set
         * @returns {pond.QuackQueue} QuackQueue instance
         */
        QuackQueue.create = function create(properties) {
            return new QuackQueue(properties);
        };

        /**
         * Creates a QuackQueue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.QuackQueue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.QuackQueue} QuackQueue
         */
        QuackQueue.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.QuackQueue)
                return object;
            var message = new $root.pond.QuackQueue();
            if (object.ackNonce != null)
                if (typeof object.ackNonce === "string")
                    $util.base64.decode(object.ackNonce, message.ackNonce = $util.newBuffer($util.base64.length(object.ackNonce)), 0);
                else if (object.ackNonce.length)
                    message.ackNonce = object.ackNonce;
            if (object.payload != null)
                if (typeof object.payload === "string")
                    $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
                else if (object.payload.length)
                    message.payload = object.payload;
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a QuackQueue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.QuackQueue
         * @static
         * @param {pond.QuackQueue} message QuackQueue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuackQueue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.ackNonce = "";
                else {
                    object.ackNonce = [];
                    if (options.bytes !== Array)
                        object.ackNonce = $util.newBuffer(object.ackNonce);
                }
                if (options.bytes === String)
                    object.payload = "";
                else {
                    object.payload = [];
                    if (options.bytes !== Array)
                        object.payload = $util.newBuffer(object.payload);
                }
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
            }
            if (message.ackNonce != null && message.hasOwnProperty("ackNonce"))
                object.ackNonce = options.bytes === String ? $util.base64.encode(message.ackNonce, 0, message.ackNonce.length) : options.bytes === Array ? Array.prototype.slice.call(message.ackNonce) : message.ackNonce;
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            return object;
        };

        /**
         * Converts this QuackQueue to JSON.
         * @function toJSON
         * @memberof pond.QuackQueue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuackQueue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuackQueue;
    })();

    pond.DevicePower = (function() {

        /**
         * Properties of a DevicePower.
         * @memberof pond
         * @interface IDevicePower
         * @property {quack.PowerSubtype|null} [type] DevicePower type
         * @property {number|null} [inputVoltage] DevicePower inputVoltage
         * @property {number|null} [chargePercent] DevicePower chargePercent
         */

        /**
         * Constructs a new DevicePower.
         * @memberof pond
         * @classdesc Represents a DevicePower.
         * @implements IDevicePower
         * @constructor
         * @param {pond.IDevicePower=} [properties] Properties to set
         */
        function DevicePower(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DevicePower type.
         * @member {quack.PowerSubtype} type
         * @memberof pond.DevicePower
         * @instance
         */
        DevicePower.prototype.type = 0;

        /**
         * DevicePower inputVoltage.
         * @member {number} inputVoltage
         * @memberof pond.DevicePower
         * @instance
         */
        DevicePower.prototype.inputVoltage = 0;

        /**
         * DevicePower chargePercent.
         * @member {number} chargePercent
         * @memberof pond.DevicePower
         * @instance
         */
        DevicePower.prototype.chargePercent = 0;

        /**
         * Creates a new DevicePower instance using the specified properties.
         * @function create
         * @memberof pond.DevicePower
         * @static
         * @param {pond.IDevicePower=} [properties] Properties to set
         * @returns {pond.DevicePower} DevicePower instance
         */
        DevicePower.create = function create(properties) {
            return new DevicePower(properties);
        };

        /**
         * Creates a DevicePower message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DevicePower
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DevicePower} DevicePower
         */
        DevicePower.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DevicePower)
                return object;
            var message = new $root.pond.DevicePower();
            switch (object.type) {
            case "POWER_SUBTYPE_NONE":
            case 0:
                message.type = 0;
                break;
            case "POWER_SUBTYPE_NO_BATTERY":
            case 1:
                message.type = 1;
                break;
            }
            if (object.inputVoltage != null)
                message.inputVoltage = Number(object.inputVoltage);
            if (object.chargePercent != null)
                message.chargePercent = Number(object.chargePercent);
            return message;
        };

        /**
         * Creates a plain object from a DevicePower message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DevicePower
         * @static
         * @param {pond.DevicePower} message DevicePower
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DevicePower.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "POWER_SUBTYPE_NONE" : 0;
                object.inputVoltage = 0;
                object.chargePercent = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.PowerSubtype[message.type] : message.type;
            if (message.inputVoltage != null && message.hasOwnProperty("inputVoltage"))
                object.inputVoltage = options.json && !isFinite(message.inputVoltage) ? String(message.inputVoltage) : message.inputVoltage;
            if (message.chargePercent != null && message.hasOwnProperty("chargePercent"))
                object.chargePercent = options.json && !isFinite(message.chargePercent) ? String(message.chargePercent) : message.chargePercent;
            return object;
        };

        /**
         * Converts this DevicePower to JSON.
         * @function toJSON
         * @memberof pond.DevicePower
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DevicePower.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DevicePower;
    })();

    /**
     * DevicePlatform enum.
     * @name pond.DevicePlatform
     * @enum {string}
     * @property {number} DEVICE_PLATFORM_INVALID=0 DEVICE_PLATFORM_INVALID value
     * @property {number} DEVICE_PLATFORM_PHOTON=1 DEVICE_PLATFORM_PHOTON value
     * @property {number} DEVICE_PLATFORM_ELECTRON=2 DEVICE_PLATFORM_ELECTRON value
     * @property {number} DEVICE_PLATFORM_V2_CELLULAR=3 DEVICE_PLATFORM_V2_CELLULAR value
     * @property {number} DEVICE_PLATFORM_V2_WIFI=4 DEVICE_PLATFORM_V2_WIFI value
     * @property {number} DEVICE_PLATFORM_V2_WIFI_S3=5 DEVICE_PLATFORM_V2_WIFI_S3 value
     * @property {number} DEVICE_PLATFORM_V2_CELLULAR_S3=6 DEVICE_PLATFORM_V2_CELLULAR_S3 value
     * @property {number} DEVICE_PLATFORM_V2_CELLULAR_BLACK=7 DEVICE_PLATFORM_V2_CELLULAR_BLACK value
     * @property {number} DEVICE_PLATFORM_V2_CELLULAR_GREEN=8 DEVICE_PLATFORM_V2_CELLULAR_GREEN value
     * @property {number} DEVICE_PLATFORM_V2_WIFI_BLUE=9 DEVICE_PLATFORM_V2_WIFI_BLUE value
     * @property {number} DEVICE_PLATFORM_V2_CELLULAR_BLUE=10 DEVICE_PLATFORM_V2_CELLULAR_BLUE value
     */
    pond.DevicePlatform = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEVICE_PLATFORM_INVALID"] = 0;
        values[valuesById[1] = "DEVICE_PLATFORM_PHOTON"] = 1;
        values[valuesById[2] = "DEVICE_PLATFORM_ELECTRON"] = 2;
        values[valuesById[3] = "DEVICE_PLATFORM_V2_CELLULAR"] = 3;
        values[valuesById[4] = "DEVICE_PLATFORM_V2_WIFI"] = 4;
        values[valuesById[5] = "DEVICE_PLATFORM_V2_WIFI_S3"] = 5;
        values[valuesById[6] = "DEVICE_PLATFORM_V2_CELLULAR_S3"] = 6;
        values[valuesById[7] = "DEVICE_PLATFORM_V2_CELLULAR_BLACK"] = 7;
        values[valuesById[8] = "DEVICE_PLATFORM_V2_CELLULAR_GREEN"] = 8;
        values[valuesById[9] = "DEVICE_PLATFORM_V2_WIFI_BLUE"] = 9;
        values[valuesById[10] = "DEVICE_PLATFORM_V2_CELLULAR_BLUE"] = 10;
        return values;
    })();

    /**
     * DeviceProduct enum.
     * @name pond.DeviceProduct
     * @enum {string}
     * @property {number} DEVICE_PRODUCT_NONE=0 DEVICE_PRODUCT_NONE value
     * @property {number} DEVICE_PRODUCT_BINDAPT_PLUS=1 DEVICE_PRODUCT_BINDAPT_PLUS value
     * @property {number} DEVICE_PRODUCT_BINDAPT_PLUS_PRO=2 DEVICE_PRODUCT_BINDAPT_PLUS_PRO value
     * @property {number} DEVICE_PRODUCT_BINDAPT_PLUS_LITE=3 DEVICE_PRODUCT_BINDAPT_PLUS_LITE value
     * @property {number} DEVICE_PRODUCT_BINDAPT_MINI=4 DEVICE_PRODUCT_BINDAPT_MINI value
     * @property {number} DEVICE_PRODUCT_WEATHER_STATION=5 DEVICE_PRODUCT_WEATHER_STATION value
     * @property {number} DEVICE_PRODUCT_NEXUS_ST=6 DEVICE_PRODUCT_NEXUS_ST value
     * @property {number} DEVICE_PRODUCT_OMNIAIR=7 DEVICE_PRODUCT_OMNIAIR value
     * @property {number} DEVICE_PRODUCT_BIN_MONITOR=8 DEVICE_PRODUCT_BIN_MONITOR value
     * @property {number} DEVICE_PRODUCT_BIN_HALO=9 DEVICE_PRODUCT_BIN_HALO value
     * @property {number} DEVICE_PRODUCT_BIN_ULTIMATE=10 DEVICE_PRODUCT_BIN_ULTIMATE value
     * @property {number} DEVICE_PRODUCT_MIPCA_V2=11 DEVICE_PRODUCT_MIPCA_V2 value
     * @property {number} DEVICE_PRODUCT_BINDAPT_PLUS_MOD=12 DEVICE_PRODUCT_BINDAPT_PLUS_MOD value
     * @property {number} DEVICE_PRODUCT_BINDAPT_PLUS_PRO_MOD=13 DEVICE_PRODUCT_BINDAPT_PLUS_PRO_MOD value
     * @property {number} DEVICE_PRODUCT_BINDAPT_V2_MONITOR=14 DEVICE_PRODUCT_BINDAPT_V2_MONITOR value
     * @property {number} DEVICE_PRODUCT_BINDAPT_V2_AUTOMATE=15 DEVICE_PRODUCT_BINDAPT_V2_AUTOMATE value
     * @property {number} DEVICE_PRODUCT_MIVENT=16 DEVICE_PRODUCT_MIVENT value
     * @property {number} DEVICE_PRODUCT_MIVENT_V2=17 DEVICE_PRODUCT_MIVENT_V2 value
     * @property {number} DEVICE_PRODUCT_STREAMLINE_MONITOR=18 DEVICE_PRODUCT_STREAMLINE_MONITOR value
     * @property {number} DEVICE_PRODUCT_STREAMLINE_AUTOMATE=19 DEVICE_PRODUCT_STREAMLINE_AUTOMATE value
     */
    pond.DeviceProduct = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEVICE_PRODUCT_NONE"] = 0;
        values[valuesById[1] = "DEVICE_PRODUCT_BINDAPT_PLUS"] = 1;
        values[valuesById[2] = "DEVICE_PRODUCT_BINDAPT_PLUS_PRO"] = 2;
        values[valuesById[3] = "DEVICE_PRODUCT_BINDAPT_PLUS_LITE"] = 3;
        values[valuesById[4] = "DEVICE_PRODUCT_BINDAPT_MINI"] = 4;
        values[valuesById[5] = "DEVICE_PRODUCT_WEATHER_STATION"] = 5;
        values[valuesById[6] = "DEVICE_PRODUCT_NEXUS_ST"] = 6;
        values[valuesById[7] = "DEVICE_PRODUCT_OMNIAIR"] = 7;
        values[valuesById[8] = "DEVICE_PRODUCT_BIN_MONITOR"] = 8;
        values[valuesById[9] = "DEVICE_PRODUCT_BIN_HALO"] = 9;
        values[valuesById[10] = "DEVICE_PRODUCT_BIN_ULTIMATE"] = 10;
        values[valuesById[11] = "DEVICE_PRODUCT_MIPCA_V2"] = 11;
        values[valuesById[12] = "DEVICE_PRODUCT_BINDAPT_PLUS_MOD"] = 12;
        values[valuesById[13] = "DEVICE_PRODUCT_BINDAPT_PLUS_PRO_MOD"] = 13;
        values[valuesById[14] = "DEVICE_PRODUCT_BINDAPT_V2_MONITOR"] = 14;
        values[valuesById[15] = "DEVICE_PRODUCT_BINDAPT_V2_AUTOMATE"] = 15;
        values[valuesById[16] = "DEVICE_PRODUCT_MIVENT"] = 16;
        values[valuesById[17] = "DEVICE_PRODUCT_MIVENT_V2"] = 17;
        values[valuesById[18] = "DEVICE_PRODUCT_STREAMLINE_MONITOR"] = 18;
        values[valuesById[19] = "DEVICE_PRODUCT_STREAMLINE_AUTOMATE"] = 19;
        return values;
    })();

    pond.DeviceComponentPreferences = (function() {

        /**
         * Properties of a DeviceComponentPreferences.
         * @memberof pond
         * @interface IDeviceComponentPreferences
         * @property {Array.<number>|null} [excludedNodes] DeviceComponentPreferences excludedNodes
         */

        /**
         * Constructs a new DeviceComponentPreferences.
         * @memberof pond
         * @classdesc Represents a DeviceComponentPreferences.
         * @implements IDeviceComponentPreferences
         * @constructor
         * @param {pond.IDeviceComponentPreferences=} [properties] Properties to set
         */
        function DeviceComponentPreferences(properties) {
            this.excludedNodes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceComponentPreferences excludedNodes.
         * @member {Array.<number>} excludedNodes
         * @memberof pond.DeviceComponentPreferences
         * @instance
         */
        DeviceComponentPreferences.prototype.excludedNodes = $util.emptyArray;

        /**
         * Creates a new DeviceComponentPreferences instance using the specified properties.
         * @function create
         * @memberof pond.DeviceComponentPreferences
         * @static
         * @param {pond.IDeviceComponentPreferences=} [properties] Properties to set
         * @returns {pond.DeviceComponentPreferences} DeviceComponentPreferences instance
         */
        DeviceComponentPreferences.create = function create(properties) {
            return new DeviceComponentPreferences(properties);
        };

        /**
         * Creates a DeviceComponentPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceComponentPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceComponentPreferences} DeviceComponentPreferences
         */
        DeviceComponentPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceComponentPreferences)
                return object;
            var message = new $root.pond.DeviceComponentPreferences();
            if (object.excludedNodes) {
                if (!Array.isArray(object.excludedNodes))
                    throw TypeError(".pond.DeviceComponentPreferences.excludedNodes: array expected");
                message.excludedNodes = [];
                for (var i = 0; i < object.excludedNodes.length; ++i)
                    message.excludedNodes[i] = object.excludedNodes[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceComponentPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceComponentPreferences
         * @static
         * @param {pond.DeviceComponentPreferences} message DeviceComponentPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceComponentPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.excludedNodes = [];
            if (message.excludedNodes && message.excludedNodes.length) {
                object.excludedNodes = [];
                for (var j = 0; j < message.excludedNodes.length; ++j)
                    object.excludedNodes[j] = message.excludedNodes[j];
            }
            return object;
        };

        /**
         * Converts this DeviceComponentPreferences to JSON.
         * @function toJSON
         * @memberof pond.DeviceComponentPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceComponentPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceComponentPreferences;
    })();

    pond.DeviceSettings = (function() {

        /**
         * Properties of a DeviceSettings.
         * @memberof pond
         * @interface IDeviceSettings
         * @property {number|null} [deviceId] DeviceSettings deviceId
         * @property {string|null} [name] DeviceSettings name
         * @property {string|null} [description] DeviceSettings description
         * @property {quack.SleepType|null} [sleepType] DeviceSettings sleepType
         * @property {number|null} [sleepDurationS] DeviceSettings sleepDurationS
         * @property {number|null} [sleepDelayMs] DeviceSettings sleepDelayMs
         * @property {number|null} [pondCheckPeriodS] DeviceSettings pondCheckPeriodS
         * @property {string|null} [removed] DeviceSettings removed
         * @property {pond.DevicePlatform|null} [platform] DeviceSettings platform
         * @property {number|null} [wakePin] DeviceSettings wakePin
         * @property {boolean|null} [automaticallyUpgrade] DeviceSettings automaticallyUpgrade
         * @property {pond.DeviceProduct|null} [product] DeviceSettings product
         * @property {pond.UpgradeChannel|null} [upgradeChannel] DeviceSettings upgradeChannel
         * @property {number|null} [latitude] DeviceSettings latitude
         * @property {number|null} [longitude] DeviceSettings longitude
         * @property {pond.ObjectTheme|null} [theme] DeviceSettings theme
         * @property {Array.<string>|null} [extensionComponents] DeviceSettings extensionComponents
         * @property {Array.<pond.LinearMutation>|null} [mutations] DeviceSettings mutations
         */

        /**
         * Constructs a new DeviceSettings.
         * @memberof pond
         * @classdesc Represents a DeviceSettings.
         * @implements IDeviceSettings
         * @constructor
         * @param {pond.IDeviceSettings=} [properties] Properties to set
         */
        function DeviceSettings(properties) {
            this.extensionComponents = [];
            this.mutations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceSettings deviceId.
         * @member {number} deviceId
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceSettings name.
         * @member {string} name
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.name = "";

        /**
         * DeviceSettings description.
         * @member {string} description
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.description = "";

        /**
         * DeviceSettings sleepType.
         * @member {quack.SleepType} sleepType
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.sleepType = 0;

        /**
         * DeviceSettings sleepDurationS.
         * @member {number} sleepDurationS
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.sleepDurationS = 0;

        /**
         * DeviceSettings sleepDelayMs.
         * @member {number} sleepDelayMs
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.sleepDelayMs = 0;

        /**
         * DeviceSettings pondCheckPeriodS.
         * @member {number} pondCheckPeriodS
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.pondCheckPeriodS = 0;

        /**
         * DeviceSettings removed.
         * @member {string} removed
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.removed = "";

        /**
         * DeviceSettings platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.platform = 0;

        /**
         * DeviceSettings wakePin.
         * @member {number} wakePin
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.wakePin = 0;

        /**
         * DeviceSettings automaticallyUpgrade.
         * @member {boolean} automaticallyUpgrade
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.automaticallyUpgrade = false;

        /**
         * DeviceSettings product.
         * @member {pond.DeviceProduct} product
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.product = 0;

        /**
         * DeviceSettings upgradeChannel.
         * @member {pond.UpgradeChannel} upgradeChannel
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.upgradeChannel = 0;

        /**
         * DeviceSettings latitude.
         * @member {number} latitude
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.latitude = 0;

        /**
         * DeviceSettings longitude.
         * @member {number} longitude
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.longitude = 0;

        /**
         * DeviceSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.theme = null;

        /**
         * DeviceSettings extensionComponents.
         * @member {Array.<string>} extensionComponents
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.extensionComponents = $util.emptyArray;

        /**
         * DeviceSettings mutations.
         * @member {Array.<pond.LinearMutation>} mutations
         * @memberof pond.DeviceSettings
         * @instance
         */
        DeviceSettings.prototype.mutations = $util.emptyArray;

        /**
         * Creates a new DeviceSettings instance using the specified properties.
         * @function create
         * @memberof pond.DeviceSettings
         * @static
         * @param {pond.IDeviceSettings=} [properties] Properties to set
         * @returns {pond.DeviceSettings} DeviceSettings instance
         */
        DeviceSettings.create = function create(properties) {
            return new DeviceSettings(properties);
        };

        /**
         * Creates a DeviceSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceSettings} DeviceSettings
         */
        DeviceSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceSettings)
                return object;
            var message = new $root.pond.DeviceSettings();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            switch (object.sleepType) {
            case "SLEEP_TYPE_NONE":
            case 0:
                message.sleepType = 0;
                break;
            case "SLEEP_TYPE_NAP":
            case 1:
                message.sleepType = 1;
                break;
            case "SLEEP_TYPE_DEEP":
            case 2:
                message.sleepType = 2;
                break;
            case "SLEEP_TYPE_HIBERNATE":
            case 3:
                message.sleepType = 3;
                break;
            }
            if (object.sleepDurationS != null)
                message.sleepDurationS = object.sleepDurationS >>> 0;
            if (object.sleepDelayMs != null)
                message.sleepDelayMs = object.sleepDelayMs >>> 0;
            if (object.pondCheckPeriodS != null)
                message.pondCheckPeriodS = object.pondCheckPeriodS >>> 0;
            if (object.removed != null)
                message.removed = String(object.removed);
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            if (object.wakePin != null)
                message.wakePin = object.wakePin >>> 0;
            if (object.automaticallyUpgrade != null)
                message.automaticallyUpgrade = Boolean(object.automaticallyUpgrade);
            switch (object.product) {
            case "DEVICE_PRODUCT_NONE":
            case 0:
                message.product = 0;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS":
            case 1:
                message.product = 1;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_PRO":
            case 2:
                message.product = 2;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_LITE":
            case 3:
                message.product = 3;
                break;
            case "DEVICE_PRODUCT_BINDAPT_MINI":
            case 4:
                message.product = 4;
                break;
            case "DEVICE_PRODUCT_WEATHER_STATION":
            case 5:
                message.product = 5;
                break;
            case "DEVICE_PRODUCT_NEXUS_ST":
            case 6:
                message.product = 6;
                break;
            case "DEVICE_PRODUCT_OMNIAIR":
            case 7:
                message.product = 7;
                break;
            case "DEVICE_PRODUCT_BIN_MONITOR":
            case 8:
                message.product = 8;
                break;
            case "DEVICE_PRODUCT_BIN_HALO":
            case 9:
                message.product = 9;
                break;
            case "DEVICE_PRODUCT_BIN_ULTIMATE":
            case 10:
                message.product = 10;
                break;
            case "DEVICE_PRODUCT_MIPCA_V2":
            case 11:
                message.product = 11;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_MOD":
            case 12:
                message.product = 12;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_PRO_MOD":
            case 13:
                message.product = 13;
                break;
            case "DEVICE_PRODUCT_BINDAPT_V2_MONITOR":
            case 14:
                message.product = 14;
                break;
            case "DEVICE_PRODUCT_BINDAPT_V2_AUTOMATE":
            case 15:
                message.product = 15;
                break;
            case "DEVICE_PRODUCT_MIVENT":
            case 16:
                message.product = 16;
                break;
            case "DEVICE_PRODUCT_MIVENT_V2":
            case 17:
                message.product = 17;
                break;
            case "DEVICE_PRODUCT_STREAMLINE_MONITOR":
            case 18:
                message.product = 18;
                break;
            case "DEVICE_PRODUCT_STREAMLINE_AUTOMATE":
            case 19:
                message.product = 19;
                break;
            }
            switch (object.upgradeChannel) {
            case "UPGRADE_CHANNEL_INVALID":
            case 0:
                message.upgradeChannel = 0;
                break;
            case "UPGRADE_CHANNEL_DEVELOPMENT":
            case 1:
                message.upgradeChannel = 1;
                break;
            case "UPGRADE_CHANNEL_ALPHA":
            case 2:
                message.upgradeChannel = 2;
                break;
            case "UPGRADE_CHANNEL_BETA":
            case 3:
                message.upgradeChannel = 3;
                break;
            case "UPGRADE_CHANNEL_STABLE":
            case 4:
                message.upgradeChannel = 4;
                break;
            case "UPGRADE_CHANNEL_RECOVERY":
            case 5:
                message.upgradeChannel = 5;
                break;
            }
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.DeviceSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            if (object.extensionComponents) {
                if (!Array.isArray(object.extensionComponents))
                    throw TypeError(".pond.DeviceSettings.extensionComponents: array expected");
                message.extensionComponents = [];
                for (var i = 0; i < object.extensionComponents.length; ++i)
                    message.extensionComponents[i] = String(object.extensionComponents[i]);
            }
            if (object.mutations) {
                if (!Array.isArray(object.mutations))
                    throw TypeError(".pond.DeviceSettings.mutations: array expected");
                message.mutations = [];
                for (var i = 0; i < object.mutations.length; ++i) {
                    if (typeof object.mutations[i] !== "object")
                        throw TypeError(".pond.DeviceSettings.mutations: object expected");
                    message.mutations[i] = $root.pond.LinearMutation.fromObject(object.mutations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceSettings
         * @static
         * @param {pond.DeviceSettings} message DeviceSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.extensionComponents = [];
                object.mutations = [];
            }
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.name = "";
                object.description = "";
                object.sleepType = options.enums === String ? "SLEEP_TYPE_NONE" : 0;
                object.sleepDurationS = 0;
                object.sleepDelayMs = 0;
                object.pondCheckPeriodS = 0;
                object.removed = "";
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
                object.wakePin = 0;
                object.automaticallyUpgrade = false;
                object.product = options.enums === String ? "DEVICE_PRODUCT_NONE" : 0;
                object.upgradeChannel = options.enums === String ? "UPGRADE_CHANNEL_INVALID" : 0;
                object.latitude = 0;
                object.longitude = 0;
                object.theme = null;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.sleepType != null && message.hasOwnProperty("sleepType"))
                object.sleepType = options.enums === String ? $root.quack.SleepType[message.sleepType] : message.sleepType;
            if (message.sleepDurationS != null && message.hasOwnProperty("sleepDurationS"))
                object.sleepDurationS = message.sleepDurationS;
            if (message.sleepDelayMs != null && message.hasOwnProperty("sleepDelayMs"))
                object.sleepDelayMs = message.sleepDelayMs;
            if (message.pondCheckPeriodS != null && message.hasOwnProperty("pondCheckPeriodS"))
                object.pondCheckPeriodS = message.pondCheckPeriodS;
            if (message.removed != null && message.hasOwnProperty("removed"))
                object.removed = message.removed;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            if (message.wakePin != null && message.hasOwnProperty("wakePin"))
                object.wakePin = message.wakePin;
            if (message.automaticallyUpgrade != null && message.hasOwnProperty("automaticallyUpgrade"))
                object.automaticallyUpgrade = message.automaticallyUpgrade;
            if (message.product != null && message.hasOwnProperty("product"))
                object.product = options.enums === String ? $root.pond.DeviceProduct[message.product] : message.product;
            if (message.upgradeChannel != null && message.hasOwnProperty("upgradeChannel"))
                object.upgradeChannel = options.enums === String ? $root.pond.UpgradeChannel[message.upgradeChannel] : message.upgradeChannel;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.extensionComponents && message.extensionComponents.length) {
                object.extensionComponents = [];
                for (var j = 0; j < message.extensionComponents.length; ++j)
                    object.extensionComponents[j] = message.extensionComponents[j];
            }
            if (message.mutations && message.mutations.length) {
                object.mutations = [];
                for (var j = 0; j < message.mutations.length; ++j)
                    object.mutations[j] = $root.pond.LinearMutation.toObject(message.mutations[j], options);
            }
            return object;
        };

        /**
         * Converts this DeviceSettings to JSON.
         * @function toJSON
         * @memberof pond.DeviceSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceSettings;
    })();

    /**
     * DeviceState enum.
     * @name pond.DeviceState
     * @enum {string}
     * @property {number} DEVICE_STATE_UNKNOWN=0 DEVICE_STATE_UNKNOWN value
     * @property {number} DEVICE_STATE_OK=1 DEVICE_STATE_OK value
     * @property {number} DEVICE_STATE_LOW_POWER=2 DEVICE_STATE_LOW_POWER value
     * @property {number} DEVICE_STATE_MISSING=3 DEVICE_STATE_MISSING value
     */
    pond.DeviceState = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEVICE_STATE_UNKNOWN"] = 0;
        values[valuesById[1] = "DEVICE_STATE_OK"] = 1;
        values[valuesById[2] = "DEVICE_STATE_LOW_POWER"] = 2;
        values[valuesById[3] = "DEVICE_STATE_MISSING"] = 3;
        return values;
    })();

    pond.StatusOverlay = (function() {

        /**
         * Properties of a StatusOverlay.
         * @memberof pond
         * @interface IStatusOverlay
         * @property {string|null} [color] StatusOverlay color
         * @property {string|null} [message] StatusOverlay message
         */

        /**
         * Constructs a new StatusOverlay.
         * @memberof pond
         * @classdesc Represents a StatusOverlay.
         * @implements IStatusOverlay
         * @constructor
         * @param {pond.IStatusOverlay=} [properties] Properties to set
         */
        function StatusOverlay(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StatusOverlay color.
         * @member {string} color
         * @memberof pond.StatusOverlay
         * @instance
         */
        StatusOverlay.prototype.color = "";

        /**
         * StatusOverlay message.
         * @member {string} message
         * @memberof pond.StatusOverlay
         * @instance
         */
        StatusOverlay.prototype.message = "";

        /**
         * Creates a new StatusOverlay instance using the specified properties.
         * @function create
         * @memberof pond.StatusOverlay
         * @static
         * @param {pond.IStatusOverlay=} [properties] Properties to set
         * @returns {pond.StatusOverlay} StatusOverlay instance
         */
        StatusOverlay.create = function create(properties) {
            return new StatusOverlay(properties);
        };

        /**
         * Creates a StatusOverlay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.StatusOverlay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.StatusOverlay} StatusOverlay
         */
        StatusOverlay.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.StatusOverlay)
                return object;
            var message = new $root.pond.StatusOverlay();
            if (object.color != null)
                message.color = String(object.color);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a StatusOverlay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.StatusOverlay
         * @static
         * @param {pond.StatusOverlay} message StatusOverlay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StatusOverlay.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.color = "";
                object.message = "";
            }
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this StatusOverlay to JSON.
         * @function toJSON
         * @memberof pond.StatusOverlay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StatusOverlay.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StatusOverlay;
    })();

    pond.DevicePlenum = (function() {

        /**
         * Properties of a DevicePlenum.
         * @memberof pond
         * @interface IDevicePlenum
         * @property {number|null} [temperature] DevicePlenum temperature
         * @property {number|null} [humidity] DevicePlenum humidity
         * @property {Array.<pond.StatusOverlay>|null} [overlays] DevicePlenum overlays
         */

        /**
         * Constructs a new DevicePlenum.
         * @memberof pond
         * @classdesc Represents a DevicePlenum.
         * @implements IDevicePlenum
         * @constructor
         * @param {pond.IDevicePlenum=} [properties] Properties to set
         */
        function DevicePlenum(properties) {
            this.overlays = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DevicePlenum temperature.
         * @member {number} temperature
         * @memberof pond.DevicePlenum
         * @instance
         */
        DevicePlenum.prototype.temperature = 0;

        /**
         * DevicePlenum humidity.
         * @member {number} humidity
         * @memberof pond.DevicePlenum
         * @instance
         */
        DevicePlenum.prototype.humidity = 0;

        /**
         * DevicePlenum overlays.
         * @member {Array.<pond.StatusOverlay>} overlays
         * @memberof pond.DevicePlenum
         * @instance
         */
        DevicePlenum.prototype.overlays = $util.emptyArray;

        /**
         * Creates a new DevicePlenum instance using the specified properties.
         * @function create
         * @memberof pond.DevicePlenum
         * @static
         * @param {pond.IDevicePlenum=} [properties] Properties to set
         * @returns {pond.DevicePlenum} DevicePlenum instance
         */
        DevicePlenum.create = function create(properties) {
            return new DevicePlenum(properties);
        };

        /**
         * Creates a DevicePlenum message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DevicePlenum
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DevicePlenum} DevicePlenum
         */
        DevicePlenum.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DevicePlenum)
                return object;
            var message = new $root.pond.DevicePlenum();
            if (object.temperature != null)
                message.temperature = Number(object.temperature);
            if (object.humidity != null)
                message.humidity = Number(object.humidity);
            if (object.overlays) {
                if (!Array.isArray(object.overlays))
                    throw TypeError(".pond.DevicePlenum.overlays: array expected");
                message.overlays = [];
                for (var i = 0; i < object.overlays.length; ++i) {
                    if (typeof object.overlays[i] !== "object")
                        throw TypeError(".pond.DevicePlenum.overlays: object expected");
                    message.overlays[i] = $root.pond.StatusOverlay.fromObject(object.overlays[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a DevicePlenum message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DevicePlenum
         * @static
         * @param {pond.DevicePlenum} message DevicePlenum
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DevicePlenum.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.overlays = [];
            if (options.defaults) {
                object.temperature = 0;
                object.humidity = 0;
            }
            if (message.temperature != null && message.hasOwnProperty("temperature"))
                object.temperature = options.json && !isFinite(message.temperature) ? String(message.temperature) : message.temperature;
            if (message.humidity != null && message.hasOwnProperty("humidity"))
                object.humidity = options.json && !isFinite(message.humidity) ? String(message.humidity) : message.humidity;
            if (message.overlays && message.overlays.length) {
                object.overlays = [];
                for (var j = 0; j < message.overlays.length; ++j)
                    object.overlays[j] = $root.pond.StatusOverlay.toObject(message.overlays[j], options);
            }
            return object;
        };

        /**
         * Converts this DevicePlenum to JSON.
         * @function toJSON
         * @memberof pond.DevicePlenum
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DevicePlenum.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DevicePlenum;
    })();

    pond.StatusSen5x = (function() {

        /**
         * Properties of a StatusSen5x.
         * @memberof pond
         * @interface IStatusSen5x
         * @property {number|null} [temperature] StatusSen5x temperature
         * @property {number|null} [humidity] StatusSen5x humidity
         * @property {number|null} [dust1ug] StatusSen5x dust1ug
         * @property {number|null} [dust2ug] StatusSen5x dust2ug
         * @property {number|null} [dust4ug] StatusSen5x dust4ug
         * @property {number|null} [dust10ug] StatusSen5x dust10ug
         * @property {number|null} [voc] StatusSen5x voc
         * @property {number|null} [nox] StatusSen5x nox
         * @property {Array.<pond.StatusOverlay>|null} [overlays] StatusSen5x overlays
         */

        /**
         * Constructs a new StatusSen5x.
         * @memberof pond
         * @classdesc Represents a StatusSen5x.
         * @implements IStatusSen5x
         * @constructor
         * @param {pond.IStatusSen5x=} [properties] Properties to set
         */
        function StatusSen5x(properties) {
            this.overlays = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StatusSen5x temperature.
         * @member {number} temperature
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.temperature = 0;

        /**
         * StatusSen5x humidity.
         * @member {number} humidity
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.humidity = 0;

        /**
         * StatusSen5x dust1ug.
         * @member {number} dust1ug
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.dust1ug = 0;

        /**
         * StatusSen5x dust2ug.
         * @member {number} dust2ug
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.dust2ug = 0;

        /**
         * StatusSen5x dust4ug.
         * @member {number} dust4ug
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.dust4ug = 0;

        /**
         * StatusSen5x dust10ug.
         * @member {number} dust10ug
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.dust10ug = 0;

        /**
         * StatusSen5x voc.
         * @member {number} voc
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.voc = 0;

        /**
         * StatusSen5x nox.
         * @member {number} nox
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.nox = 0;

        /**
         * StatusSen5x overlays.
         * @member {Array.<pond.StatusOverlay>} overlays
         * @memberof pond.StatusSen5x
         * @instance
         */
        StatusSen5x.prototype.overlays = $util.emptyArray;

        /**
         * Creates a new StatusSen5x instance using the specified properties.
         * @function create
         * @memberof pond.StatusSen5x
         * @static
         * @param {pond.IStatusSen5x=} [properties] Properties to set
         * @returns {pond.StatusSen5x} StatusSen5x instance
         */
        StatusSen5x.create = function create(properties) {
            return new StatusSen5x(properties);
        };

        /**
         * Creates a StatusSen5x message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.StatusSen5x
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.StatusSen5x} StatusSen5x
         */
        StatusSen5x.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.StatusSen5x)
                return object;
            var message = new $root.pond.StatusSen5x();
            if (object.temperature != null)
                message.temperature = Number(object.temperature);
            if (object.humidity != null)
                message.humidity = Number(object.humidity);
            if (object.dust1ug != null)
                message.dust1ug = Number(object.dust1ug);
            if (object.dust2ug != null)
                message.dust2ug = Number(object.dust2ug);
            if (object.dust4ug != null)
                message.dust4ug = Number(object.dust4ug);
            if (object.dust10ug != null)
                message.dust10ug = Number(object.dust10ug);
            if (object.voc != null)
                message.voc = Number(object.voc);
            if (object.nox != null)
                message.nox = Number(object.nox);
            if (object.overlays) {
                if (!Array.isArray(object.overlays))
                    throw TypeError(".pond.StatusSen5x.overlays: array expected");
                message.overlays = [];
                for (var i = 0; i < object.overlays.length; ++i) {
                    if (typeof object.overlays[i] !== "object")
                        throw TypeError(".pond.StatusSen5x.overlays: object expected");
                    message.overlays[i] = $root.pond.StatusOverlay.fromObject(object.overlays[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a StatusSen5x message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.StatusSen5x
         * @static
         * @param {pond.StatusSen5x} message StatusSen5x
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StatusSen5x.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.overlays = [];
            if (options.defaults) {
                object.temperature = 0;
                object.humidity = 0;
                object.dust1ug = 0;
                object.dust2ug = 0;
                object.dust4ug = 0;
                object.dust10ug = 0;
                object.voc = 0;
                object.nox = 0;
            }
            if (message.temperature != null && message.hasOwnProperty("temperature"))
                object.temperature = options.json && !isFinite(message.temperature) ? String(message.temperature) : message.temperature;
            if (message.humidity != null && message.hasOwnProperty("humidity"))
                object.humidity = options.json && !isFinite(message.humidity) ? String(message.humidity) : message.humidity;
            if (message.dust1ug != null && message.hasOwnProperty("dust1ug"))
                object.dust1ug = options.json && !isFinite(message.dust1ug) ? String(message.dust1ug) : message.dust1ug;
            if (message.dust2ug != null && message.hasOwnProperty("dust2ug"))
                object.dust2ug = options.json && !isFinite(message.dust2ug) ? String(message.dust2ug) : message.dust2ug;
            if (message.dust4ug != null && message.hasOwnProperty("dust4ug"))
                object.dust4ug = options.json && !isFinite(message.dust4ug) ? String(message.dust4ug) : message.dust4ug;
            if (message.dust10ug != null && message.hasOwnProperty("dust10ug"))
                object.dust10ug = options.json && !isFinite(message.dust10ug) ? String(message.dust10ug) : message.dust10ug;
            if (message.voc != null && message.hasOwnProperty("voc"))
                object.voc = options.json && !isFinite(message.voc) ? String(message.voc) : message.voc;
            if (message.nox != null && message.hasOwnProperty("nox"))
                object.nox = options.json && !isFinite(message.nox) ? String(message.nox) : message.nox;
            if (message.overlays && message.overlays.length) {
                object.overlays = [];
                for (var j = 0; j < message.overlays.length; ++j)
                    object.overlays[j] = $root.pond.StatusOverlay.toObject(message.overlays[j], options);
            }
            return object;
        };

        /**
         * Converts this StatusSen5x to JSON.
         * @function toJSON
         * @memberof pond.StatusSen5x
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StatusSen5x.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StatusSen5x;
    })();

    pond.DeviceStatus = (function() {

        /**
         * Properties of a DeviceStatus.
         * @memberof pond
         * @interface IDeviceStatus
         * @property {pond.DevicePower|null} [power] DeviceStatus power
         * @property {pond.DeviceState|null} [state] DeviceStatus state
         * @property {boolean|null} [synced] DeviceStatus synced
         * @property {string|null} [lastSynced] DeviceStatus lastSynced
         * @property {string|null} [sim] DeviceStatus sim
         * @property {string|null} [cellularId] DeviceStatus cellularId
         * @property {string|null} [lastActive] DeviceStatus lastActive
         * @property {string|null} [firmwareVersion] DeviceStatus firmwareVersion
         * @property {number|null} [quackCount] DeviceStatus quackCount
         * @property {string|null} [address] DeviceStatus address
         * @property {Array.<string>|null} [tagKeys] DeviceStatus tagKeys
         * @property {Array.<string>|null} [tagNames] DeviceStatus tagNames
         * @property {boolean|null} [paused] DeviceStatus paused
         * @property {string|null} [lastChanged] DeviceStatus lastChanged
         * @property {number|null} [latitude] DeviceStatus latitude
         * @property {number|null} [longitude] DeviceStatus longitude
         * @property {string|null} [imei] DeviceStatus imei
         * @property {number|null} [arkles] DeviceStatus arkles
         * @property {number|null} [quackCountTx] DeviceStatus quackCountTx
         * @property {number|null} [quackCountRx] DeviceStatus quackCountRx
         * @property {number|null} [userCost] DeviceStatus userCost
         * @property {number|null} [bytes] DeviceStatus bytes
         * @property {string|null} [bytesTimestamp] DeviceStatus bytesTimestamp
         * @property {pond.DevicePlenum|null} [plenum] DeviceStatus plenum
         * @property {Array.<pond.TagSettings>|null} [tags] DeviceStatus tags
         * @property {pond.StatusSen5x|null} [sen5x] DeviceStatus sen5x
         */

        /**
         * Constructs a new DeviceStatus.
         * @memberof pond
         * @classdesc Represents a DeviceStatus.
         * @implements IDeviceStatus
         * @constructor
         * @param {pond.IDeviceStatus=} [properties] Properties to set
         */
        function DeviceStatus(properties) {
            this.tagKeys = [];
            this.tagNames = [];
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceStatus power.
         * @member {pond.DevicePower|null|undefined} power
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.power = null;

        /**
         * DeviceStatus state.
         * @member {pond.DeviceState} state
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.state = 0;

        /**
         * DeviceStatus synced.
         * @member {boolean} synced
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.synced = false;

        /**
         * DeviceStatus lastSynced.
         * @member {string} lastSynced
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.lastSynced = "";

        /**
         * DeviceStatus sim.
         * @member {string} sim
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.sim = "";

        /**
         * DeviceStatus cellularId.
         * @member {string} cellularId
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.cellularId = "";

        /**
         * DeviceStatus lastActive.
         * @member {string} lastActive
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.lastActive = "";

        /**
         * DeviceStatus firmwareVersion.
         * @member {string} firmwareVersion
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.firmwareVersion = "";

        /**
         * DeviceStatus quackCount.
         * @member {number} quackCount
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.quackCount = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceStatus address.
         * @member {string} address
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.address = "";

        /**
         * DeviceStatus tagKeys.
         * @member {Array.<string>} tagKeys
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.tagKeys = $util.emptyArray;

        /**
         * DeviceStatus tagNames.
         * @member {Array.<string>} tagNames
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.tagNames = $util.emptyArray;

        /**
         * DeviceStatus paused.
         * @member {boolean} paused
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.paused = false;

        /**
         * DeviceStatus lastChanged.
         * @member {string} lastChanged
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.lastChanged = "";

        /**
         * DeviceStatus latitude.
         * @member {number} latitude
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.latitude = 0;

        /**
         * DeviceStatus longitude.
         * @member {number} longitude
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.longitude = 0;

        /**
         * DeviceStatus imei.
         * @member {string} imei
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.imei = "";

        /**
         * DeviceStatus arkles.
         * @member {number} arkles
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.arkles = 0;

        /**
         * DeviceStatus quackCountTx.
         * @member {number} quackCountTx
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.quackCountTx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceStatus quackCountRx.
         * @member {number} quackCountRx
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.quackCountRx = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceStatus userCost.
         * @member {number} userCost
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.userCost = 0;

        /**
         * DeviceStatus bytes.
         * @member {number} bytes
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceStatus bytesTimestamp.
         * @member {string} bytesTimestamp
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.bytesTimestamp = "";

        /**
         * DeviceStatus plenum.
         * @member {pond.DevicePlenum|null|undefined} plenum
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.plenum = null;

        /**
         * DeviceStatus tags.
         * @member {Array.<pond.TagSettings>} tags
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.tags = $util.emptyArray;

        /**
         * DeviceStatus sen5x.
         * @member {pond.StatusSen5x|null|undefined} sen5x
         * @memberof pond.DeviceStatus
         * @instance
         */
        DeviceStatus.prototype.sen5x = null;

        /**
         * Creates a new DeviceStatus instance using the specified properties.
         * @function create
         * @memberof pond.DeviceStatus
         * @static
         * @param {pond.IDeviceStatus=} [properties] Properties to set
         * @returns {pond.DeviceStatus} DeviceStatus instance
         */
        DeviceStatus.create = function create(properties) {
            return new DeviceStatus(properties);
        };

        /**
         * Creates a DeviceStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceStatus} DeviceStatus
         */
        DeviceStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceStatus)
                return object;
            var message = new $root.pond.DeviceStatus();
            if (object.power != null) {
                if (typeof object.power !== "object")
                    throw TypeError(".pond.DeviceStatus.power: object expected");
                message.power = $root.pond.DevicePower.fromObject(object.power);
            }
            switch (object.state) {
            case "DEVICE_STATE_UNKNOWN":
            case 0:
                message.state = 0;
                break;
            case "DEVICE_STATE_OK":
            case 1:
                message.state = 1;
                break;
            case "DEVICE_STATE_LOW_POWER":
            case 2:
                message.state = 2;
                break;
            case "DEVICE_STATE_MISSING":
            case 3:
                message.state = 3;
                break;
            }
            if (object.synced != null)
                message.synced = Boolean(object.synced);
            if (object.lastSynced != null)
                message.lastSynced = String(object.lastSynced);
            if (object.sim != null)
                message.sim = String(object.sim);
            if (object.cellularId != null)
                message.cellularId = String(object.cellularId);
            if (object.lastActive != null)
                message.lastActive = String(object.lastActive);
            if (object.firmwareVersion != null)
                message.firmwareVersion = String(object.firmwareVersion);
            if (object.quackCount != null)
                if ($util.Long)
                    (message.quackCount = $util.Long.fromValue(object.quackCount)).unsigned = true;
                else if (typeof object.quackCount === "string")
                    message.quackCount = parseInt(object.quackCount, 10);
                else if (typeof object.quackCount === "number")
                    message.quackCount = object.quackCount;
                else if (typeof object.quackCount === "object")
                    message.quackCount = new $util.LongBits(object.quackCount.low >>> 0, object.quackCount.high >>> 0).toNumber(true);
            if (object.address != null)
                message.address = String(object.address);
            if (object.tagKeys) {
                if (!Array.isArray(object.tagKeys))
                    throw TypeError(".pond.DeviceStatus.tagKeys: array expected");
                message.tagKeys = [];
                for (var i = 0; i < object.tagKeys.length; ++i)
                    message.tagKeys[i] = String(object.tagKeys[i]);
            }
            if (object.tagNames) {
                if (!Array.isArray(object.tagNames))
                    throw TypeError(".pond.DeviceStatus.tagNames: array expected");
                message.tagNames = [];
                for (var i = 0; i < object.tagNames.length; ++i)
                    message.tagNames[i] = String(object.tagNames[i]);
            }
            if (object.paused != null)
                message.paused = Boolean(object.paused);
            if (object.lastChanged != null)
                message.lastChanged = String(object.lastChanged);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.imei != null)
                message.imei = String(object.imei);
            if (object.arkles != null)
                message.arkles = object.arkles >>> 0;
            if (object.quackCountTx != null)
                if ($util.Long)
                    (message.quackCountTx = $util.Long.fromValue(object.quackCountTx)).unsigned = true;
                else if (typeof object.quackCountTx === "string")
                    message.quackCountTx = parseInt(object.quackCountTx, 10);
                else if (typeof object.quackCountTx === "number")
                    message.quackCountTx = object.quackCountTx;
                else if (typeof object.quackCountTx === "object")
                    message.quackCountTx = new $util.LongBits(object.quackCountTx.low >>> 0, object.quackCountTx.high >>> 0).toNumber(true);
            if (object.quackCountRx != null)
                if ($util.Long)
                    (message.quackCountRx = $util.Long.fromValue(object.quackCountRx)).unsigned = true;
                else if (typeof object.quackCountRx === "string")
                    message.quackCountRx = parseInt(object.quackCountRx, 10);
                else if (typeof object.quackCountRx === "number")
                    message.quackCountRx = object.quackCountRx;
                else if (typeof object.quackCountRx === "object")
                    message.quackCountRx = new $util.LongBits(object.quackCountRx.low >>> 0, object.quackCountRx.high >>> 0).toNumber(true);
            if (object.userCost != null)
                message.userCost = Number(object.userCost);
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            if (object.bytesTimestamp != null)
                message.bytesTimestamp = String(object.bytesTimestamp);
            if (object.plenum != null) {
                if (typeof object.plenum !== "object")
                    throw TypeError(".pond.DeviceStatus.plenum: object expected");
                message.plenum = $root.pond.DevicePlenum.fromObject(object.plenum);
            }
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.DeviceStatus.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i) {
                    if (typeof object.tags[i] !== "object")
                        throw TypeError(".pond.DeviceStatus.tags: object expected");
                    message.tags[i] = $root.pond.TagSettings.fromObject(object.tags[i]);
                }
            }
            if (object.sen5x != null) {
                if (typeof object.sen5x !== "object")
                    throw TypeError(".pond.DeviceStatus.sen5x: object expected");
                message.sen5x = $root.pond.StatusSen5x.fromObject(object.sen5x);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceStatus
         * @static
         * @param {pond.DeviceStatus} message DeviceStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.tagKeys = [];
                object.tagNames = [];
                object.tags = [];
            }
            if (options.defaults) {
                object.power = null;
                object.state = options.enums === String ? "DEVICE_STATE_UNKNOWN" : 0;
                object.synced = false;
                object.lastSynced = "";
                object.sim = "";
                object.cellularId = "";
                object.lastActive = "";
                object.firmwareVersion = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.quackCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.quackCount = options.longs === String ? "0" : 0;
                object.address = "";
                object.paused = false;
                object.lastChanged = "";
                object.latitude = 0;
                object.longitude = 0;
                object.imei = "";
                object.arkles = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.quackCountTx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.quackCountTx = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.quackCountRx = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.quackCountRx = options.longs === String ? "0" : 0;
                object.userCost = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
                object.bytesTimestamp = "";
                object.plenum = null;
                object.sen5x = null;
            }
            if (message.power != null && message.hasOwnProperty("power"))
                object.power = $root.pond.DevicePower.toObject(message.power, options);
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = options.enums === String ? $root.pond.DeviceState[message.state] : message.state;
            if (message.synced != null && message.hasOwnProperty("synced"))
                object.synced = message.synced;
            if (message.lastSynced != null && message.hasOwnProperty("lastSynced"))
                object.lastSynced = message.lastSynced;
            if (message.sim != null && message.hasOwnProperty("sim"))
                object.sim = message.sim;
            if (message.cellularId != null && message.hasOwnProperty("cellularId"))
                object.cellularId = message.cellularId;
            if (message.lastActive != null && message.hasOwnProperty("lastActive"))
                object.lastActive = message.lastActive;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            if (message.quackCount != null && message.hasOwnProperty("quackCount"))
                if (typeof message.quackCount === "number")
                    object.quackCount = options.longs === String ? String(message.quackCount) : message.quackCount;
                else
                    object.quackCount = options.longs === String ? $util.Long.prototype.toString.call(message.quackCount) : options.longs === Number ? new $util.LongBits(message.quackCount.low >>> 0, message.quackCount.high >>> 0).toNumber(true) : message.quackCount;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.tagKeys && message.tagKeys.length) {
                object.tagKeys = [];
                for (var j = 0; j < message.tagKeys.length; ++j)
                    object.tagKeys[j] = message.tagKeys[j];
            }
            if (message.tagNames && message.tagNames.length) {
                object.tagNames = [];
                for (var j = 0; j < message.tagNames.length; ++j)
                    object.tagNames[j] = message.tagNames[j];
            }
            if (message.paused != null && message.hasOwnProperty("paused"))
                object.paused = message.paused;
            if (message.lastChanged != null && message.hasOwnProperty("lastChanged"))
                object.lastChanged = message.lastChanged;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.imei != null && message.hasOwnProperty("imei"))
                object.imei = message.imei;
            if (message.arkles != null && message.hasOwnProperty("arkles"))
                object.arkles = message.arkles;
            if (message.quackCountTx != null && message.hasOwnProperty("quackCountTx"))
                if (typeof message.quackCountTx === "number")
                    object.quackCountTx = options.longs === String ? String(message.quackCountTx) : message.quackCountTx;
                else
                    object.quackCountTx = options.longs === String ? $util.Long.prototype.toString.call(message.quackCountTx) : options.longs === Number ? new $util.LongBits(message.quackCountTx.low >>> 0, message.quackCountTx.high >>> 0).toNumber(true) : message.quackCountTx;
            if (message.quackCountRx != null && message.hasOwnProperty("quackCountRx"))
                if (typeof message.quackCountRx === "number")
                    object.quackCountRx = options.longs === String ? String(message.quackCountRx) : message.quackCountRx;
                else
                    object.quackCountRx = options.longs === String ? $util.Long.prototype.toString.call(message.quackCountRx) : options.longs === Number ? new $util.LongBits(message.quackCountRx.low >>> 0, message.quackCountRx.high >>> 0).toNumber(true) : message.quackCountRx;
            if (message.userCost != null && message.hasOwnProperty("userCost"))
                object.userCost = options.json && !isFinite(message.userCost) ? String(message.userCost) : message.userCost;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            if (message.bytesTimestamp != null && message.hasOwnProperty("bytesTimestamp"))
                object.bytesTimestamp = message.bytesTimestamp;
            if (message.plenum != null && message.hasOwnProperty("plenum"))
                object.plenum = $root.pond.DevicePlenum.toObject(message.plenum, options);
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = $root.pond.TagSettings.toObject(message.tags[j], options);
            }
            if (message.sen5x != null && message.hasOwnProperty("sen5x"))
                object.sen5x = $root.pond.StatusSen5x.toObject(message.sen5x, options);
            return object;
        };

        /**
         * Converts this DeviceStatus to JSON.
         * @function toJSON
         * @memberof pond.DeviceStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceStatus;
    })();

    pond.GetDevicePageDataRequest = (function() {

        /**
         * Properties of a GetDevicePageDataRequest.
         * @memberof pond
         * @interface IGetDevicePageDataRequest
         * @property {number|null} [device] GetDevicePageDataRequest device
         */

        /**
         * Constructs a new GetDevicePageDataRequest.
         * @memberof pond
         * @classdesc Represents a GetDevicePageDataRequest.
         * @implements IGetDevicePageDataRequest
         * @constructor
         * @param {pond.IGetDevicePageDataRequest=} [properties] Properties to set
         */
        function GetDevicePageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePageDataRequest device.
         * @member {number} device
         * @memberof pond.GetDevicePageDataRequest
         * @instance
         */
        GetDevicePageDataRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDevicePageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePageDataRequest
         * @static
         * @param {pond.IGetDevicePageDataRequest=} [properties] Properties to set
         * @returns {pond.GetDevicePageDataRequest} GetDevicePageDataRequest instance
         */
        GetDevicePageDataRequest.create = function create(properties) {
            return new GetDevicePageDataRequest(properties);
        };

        /**
         * Creates a GetDevicePageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePageDataRequest} GetDevicePageDataRequest
         */
        GetDevicePageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePageDataRequest)
                return object;
            var message = new $root.pond.GetDevicePageDataRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePageDataRequest
         * @static
         * @param {pond.GetDevicePageDataRequest} message GetDevicePageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDevicePageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePageDataRequest;
    })();

    pond.GetDevicePageDataResponse = (function() {

        /**
         * Properties of a GetDevicePageDataResponse.
         * @memberof pond
         * @interface IGetDevicePageDataResponse
         * @property {pond.Device|null} [device] GetDevicePageDataResponse device
         * @property {Array.<pond.Component>|null} [components] GetDevicePageDataResponse components
         * @property {Array.<pond.Interaction>|null} [interactions] GetDevicePageDataResponse interactions
         * @property {pond.User|null} [user] GetDevicePageDataResponse user
         * @property {Array.<pond.Permission>|null} [permissions] GetDevicePageDataResponse permissions
         * @property {Array.<string>|null} [displayOrder] GetDevicePageDataResponse displayOrder
         * @property {Object.<string,pond.DeviceComponentPreferences>|null} [preferences] GetDevicePageDataResponse preferences
         * @property {Array.<pond.Tag>|null} [tags] GetDevicePageDataResponse tags
         */

        /**
         * Constructs a new GetDevicePageDataResponse.
         * @memberof pond
         * @classdesc Represents a GetDevicePageDataResponse.
         * @implements IGetDevicePageDataResponse
         * @constructor
         * @param {pond.IGetDevicePageDataResponse=} [properties] Properties to set
         */
        function GetDevicePageDataResponse(properties) {
            this.components = [];
            this.interactions = [];
            this.permissions = [];
            this.displayOrder = [];
            this.preferences = {};
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePageDataResponse device.
         * @member {pond.Device|null|undefined} device
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.device = null;

        /**
         * GetDevicePageDataResponse components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.components = $util.emptyArray;

        /**
         * GetDevicePageDataResponse interactions.
         * @member {Array.<pond.Interaction>} interactions
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.interactions = $util.emptyArray;

        /**
         * GetDevicePageDataResponse user.
         * @member {pond.User|null|undefined} user
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.user = null;

        /**
         * GetDevicePageDataResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.permissions = $util.emptyArray;

        /**
         * GetDevicePageDataResponse displayOrder.
         * @member {Array.<string>} displayOrder
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.displayOrder = $util.emptyArray;

        /**
         * GetDevicePageDataResponse preferences.
         * @member {Object.<string,pond.DeviceComponentPreferences>} preferences
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.preferences = $util.emptyObject;

        /**
         * GetDevicePageDataResponse tags.
         * @member {Array.<pond.Tag>} tags
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         */
        GetDevicePageDataResponse.prototype.tags = $util.emptyArray;

        /**
         * Creates a new GetDevicePageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePageDataResponse
         * @static
         * @param {pond.IGetDevicePageDataResponse=} [properties] Properties to set
         * @returns {pond.GetDevicePageDataResponse} GetDevicePageDataResponse instance
         */
        GetDevicePageDataResponse.create = function create(properties) {
            return new GetDevicePageDataResponse(properties);
        };

        /**
         * Creates a GetDevicePageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePageDataResponse} GetDevicePageDataResponse
         */
        GetDevicePageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePageDataResponse)
                return object;
            var message = new $root.pond.GetDevicePageDataResponse();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.GetDevicePageDataResponse.device: object expected");
                message.device = $root.pond.Device.fromObject(object.device);
            }
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.GetDevicePageDataResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.GetDevicePageDataResponse.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.GetDevicePageDataResponse.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.GetDevicePageDataResponse.interactions: object expected");
                    message.interactions[i] = $root.pond.Interaction.fromObject(object.interactions[i]);
                }
            }
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".pond.GetDevicePageDataResponse.user: object expected");
                message.user = $root.pond.User.fromObject(object.user);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GetDevicePageDataResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.displayOrder) {
                if (!Array.isArray(object.displayOrder))
                    throw TypeError(".pond.GetDevicePageDataResponse.displayOrder: array expected");
                message.displayOrder = [];
                for (var i = 0; i < object.displayOrder.length; ++i)
                    message.displayOrder[i] = String(object.displayOrder[i]);
            }
            if (object.preferences) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.GetDevicePageDataResponse.preferences: object expected");
                message.preferences = {};
                for (var keys = Object.keys(object.preferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.preferences[keys[i]] !== "object")
                        throw TypeError(".pond.GetDevicePageDataResponse.preferences: object expected");
                    message.preferences[keys[i]] = $root.pond.DeviceComponentPreferences.fromObject(object.preferences[keys[i]]);
                }
            }
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.GetDevicePageDataResponse.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i) {
                    if (typeof object.tags[i] !== "object")
                        throw TypeError(".pond.GetDevicePageDataResponse.tags: object expected");
                    message.tags[i] = $root.pond.Tag.fromObject(object.tags[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePageDataResponse
         * @static
         * @param {pond.GetDevicePageDataResponse} message GetDevicePageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.components = [];
                object.interactions = [];
                object.permissions = [];
                object.displayOrder = [];
                object.tags = [];
            }
            if (options.objects || options.defaults)
                object.preferences = {};
            if (options.defaults) {
                object.device = null;
                object.user = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.Device.toObject(message.device, options);
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.Interaction.toObject(message.interactions[j], options);
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.pond.User.toObject(message.user, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.displayOrder && message.displayOrder.length) {
                object.displayOrder = [];
                for (var j = 0; j < message.displayOrder.length; ++j)
                    object.displayOrder[j] = message.displayOrder[j];
            }
            var keys2;
            if (message.preferences && (keys2 = Object.keys(message.preferences)).length) {
                object.preferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.preferences[keys2[j]] = $root.pond.DeviceComponentPreferences.toObject(message.preferences[keys2[j]], options);
            }
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = $root.pond.Tag.toObject(message.tags[j], options);
            }
            return object;
        };

        /**
         * Converts this GetDevicePageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePageDataResponse;
    })();

    pond.DeviceStatistics = (function() {

        /**
         * Properties of a DeviceStatistics.
         * @memberof pond
         * @interface IDeviceStatistics
         * @property {number|null} [total] DeviceStatistics total
         * @property {number|null} [active] DeviceStatistics active
         * @property {number|null} [pending] DeviceStatistics pending
         * @property {number|null} [warning] DeviceStatistics warning
         * @property {number|null} [offline] DeviceStatistics offline
         */

        /**
         * Constructs a new DeviceStatistics.
         * @memberof pond
         * @classdesc Represents a DeviceStatistics.
         * @implements IDeviceStatistics
         * @constructor
         * @param {pond.IDeviceStatistics=} [properties] Properties to set
         */
        function DeviceStatistics(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceStatistics total.
         * @member {number} total
         * @memberof pond.DeviceStatistics
         * @instance
         */
        DeviceStatistics.prototype.total = 0;

        /**
         * DeviceStatistics active.
         * @member {number} active
         * @memberof pond.DeviceStatistics
         * @instance
         */
        DeviceStatistics.prototype.active = 0;

        /**
         * DeviceStatistics pending.
         * @member {number} pending
         * @memberof pond.DeviceStatistics
         * @instance
         */
        DeviceStatistics.prototype.pending = 0;

        /**
         * DeviceStatistics warning.
         * @member {number} warning
         * @memberof pond.DeviceStatistics
         * @instance
         */
        DeviceStatistics.prototype.warning = 0;

        /**
         * DeviceStatistics offline.
         * @member {number} offline
         * @memberof pond.DeviceStatistics
         * @instance
         */
        DeviceStatistics.prototype.offline = 0;

        /**
         * Creates a new DeviceStatistics instance using the specified properties.
         * @function create
         * @memberof pond.DeviceStatistics
         * @static
         * @param {pond.IDeviceStatistics=} [properties] Properties to set
         * @returns {pond.DeviceStatistics} DeviceStatistics instance
         */
        DeviceStatistics.create = function create(properties) {
            return new DeviceStatistics(properties);
        };

        /**
         * Creates a DeviceStatistics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceStatistics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceStatistics} DeviceStatistics
         */
        DeviceStatistics.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceStatistics)
                return object;
            var message = new $root.pond.DeviceStatistics();
            if (object.total != null)
                message.total = object.total >>> 0;
            if (object.active != null)
                message.active = object.active >>> 0;
            if (object.pending != null)
                message.pending = object.pending >>> 0;
            if (object.warning != null)
                message.warning = object.warning >>> 0;
            if (object.offline != null)
                message.offline = object.offline >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a DeviceStatistics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceStatistics
         * @static
         * @param {pond.DeviceStatistics} message DeviceStatistics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceStatistics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.total = 0;
                object.active = 0;
                object.pending = 0;
                object.warning = 0;
                object.offline = 0;
            }
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = message.active;
            if (message.pending != null && message.hasOwnProperty("pending"))
                object.pending = message.pending;
            if (message.warning != null && message.hasOwnProperty("warning"))
                object.warning = message.warning;
            if (message.offline != null && message.hasOwnProperty("offline"))
                object.offline = message.offline;
            return object;
        };

        /**
         * Converts this DeviceStatistics to JSON.
         * @function toJSON
         * @memberof pond.DeviceStatistics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceStatistics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceStatistics;
    })();

    pond.GetDeviceStatisticsRequest = (function() {

        /**
         * Properties of a GetDeviceStatisticsRequest.
         * @memberof pond
         * @interface IGetDeviceStatisticsRequest
         * @property {number|null} [device] GetDeviceStatisticsRequest device
         */

        /**
         * Constructs a new GetDeviceStatisticsRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceStatisticsRequest.
         * @implements IGetDeviceStatisticsRequest
         * @constructor
         * @param {pond.IGetDeviceStatisticsRequest=} [properties] Properties to set
         */
        function GetDeviceStatisticsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceStatisticsRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceStatisticsRequest
         * @instance
         */
        GetDeviceStatisticsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDeviceStatisticsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceStatisticsRequest
         * @static
         * @param {pond.IGetDeviceStatisticsRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceStatisticsRequest} GetDeviceStatisticsRequest instance
         */
        GetDeviceStatisticsRequest.create = function create(properties) {
            return new GetDeviceStatisticsRequest(properties);
        };

        /**
         * Creates a GetDeviceStatisticsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceStatisticsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceStatisticsRequest} GetDeviceStatisticsRequest
         */
        GetDeviceStatisticsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceStatisticsRequest)
                return object;
            var message = new $root.pond.GetDeviceStatisticsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceStatisticsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceStatisticsRequest
         * @static
         * @param {pond.GetDeviceStatisticsRequest} message GetDeviceStatisticsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceStatisticsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDeviceStatisticsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceStatisticsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceStatisticsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceStatisticsRequest;
    })();

    pond.GetDeviceStatisticsResponse = (function() {

        /**
         * Properties of a GetDeviceStatisticsResponse.
         * @memberof pond
         * @interface IGetDeviceStatisticsResponse
         * @property {pond.DeviceStatistics|null} [stats] GetDeviceStatisticsResponse stats
         */

        /**
         * Constructs a new GetDeviceStatisticsResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceStatisticsResponse.
         * @implements IGetDeviceStatisticsResponse
         * @constructor
         * @param {pond.IGetDeviceStatisticsResponse=} [properties] Properties to set
         */
        function GetDeviceStatisticsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceStatisticsResponse stats.
         * @member {pond.DeviceStatistics|null|undefined} stats
         * @memberof pond.GetDeviceStatisticsResponse
         * @instance
         */
        GetDeviceStatisticsResponse.prototype.stats = null;

        /**
         * Creates a new GetDeviceStatisticsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceStatisticsResponse
         * @static
         * @param {pond.IGetDeviceStatisticsResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceStatisticsResponse} GetDeviceStatisticsResponse instance
         */
        GetDeviceStatisticsResponse.create = function create(properties) {
            return new GetDeviceStatisticsResponse(properties);
        };

        /**
         * Creates a GetDeviceStatisticsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceStatisticsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceStatisticsResponse} GetDeviceStatisticsResponse
         */
        GetDeviceStatisticsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceStatisticsResponse)
                return object;
            var message = new $root.pond.GetDeviceStatisticsResponse();
            if (object.stats != null) {
                if (typeof object.stats !== "object")
                    throw TypeError(".pond.GetDeviceStatisticsResponse.stats: object expected");
                message.stats = $root.pond.DeviceStatistics.fromObject(object.stats);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceStatisticsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceStatisticsResponse
         * @static
         * @param {pond.GetDeviceStatisticsResponse} message GetDeviceStatisticsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceStatisticsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.stats = null;
            if (message.stats != null && message.hasOwnProperty("stats"))
                object.stats = $root.pond.DeviceStatistics.toObject(message.stats, options);
            return object;
        };

        /**
         * Converts this GetDeviceStatisticsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceStatisticsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceStatisticsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceStatisticsResponse;
    })();

    pond.GetDeviceKeyRequest = (function() {

        /**
         * Properties of a GetDeviceKeyRequest.
         * @memberof pond
         * @interface IGetDeviceKeyRequest
         * @property {number|null} [device] GetDeviceKeyRequest device
         */

        /**
         * Constructs a new GetDeviceKeyRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceKeyRequest.
         * @implements IGetDeviceKeyRequest
         * @constructor
         * @param {pond.IGetDeviceKeyRequest=} [properties] Properties to set
         */
        function GetDeviceKeyRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceKeyRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceKeyRequest
         * @instance
         */
        GetDeviceKeyRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDeviceKeyRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceKeyRequest
         * @static
         * @param {pond.IGetDeviceKeyRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceKeyRequest} GetDeviceKeyRequest instance
         */
        GetDeviceKeyRequest.create = function create(properties) {
            return new GetDeviceKeyRequest(properties);
        };

        /**
         * Creates a GetDeviceKeyRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceKeyRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceKeyRequest} GetDeviceKeyRequest
         */
        GetDeviceKeyRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceKeyRequest)
                return object;
            var message = new $root.pond.GetDeviceKeyRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceKeyRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceKeyRequest
         * @static
         * @param {pond.GetDeviceKeyRequest} message GetDeviceKeyRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceKeyRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDeviceKeyRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceKeyRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceKeyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceKeyRequest;
    })();

    pond.GetDeviceKeyResponse = (function() {

        /**
         * Properties of a GetDeviceKeyResponse.
         * @memberof pond
         * @interface IGetDeviceKeyResponse
         * @property {Uint8Array|null} [key] GetDeviceKeyResponse key
         */

        /**
         * Constructs a new GetDeviceKeyResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceKeyResponse.
         * @implements IGetDeviceKeyResponse
         * @constructor
         * @param {pond.IGetDeviceKeyResponse=} [properties] Properties to set
         */
        function GetDeviceKeyResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceKeyResponse key.
         * @member {Uint8Array} key
         * @memberof pond.GetDeviceKeyResponse
         * @instance
         */
        GetDeviceKeyResponse.prototype.key = $util.newBuffer([]);

        /**
         * Creates a new GetDeviceKeyResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceKeyResponse
         * @static
         * @param {pond.IGetDeviceKeyResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceKeyResponse} GetDeviceKeyResponse instance
         */
        GetDeviceKeyResponse.create = function create(properties) {
            return new GetDeviceKeyResponse(properties);
        };

        /**
         * Creates a GetDeviceKeyResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceKeyResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceKeyResponse} GetDeviceKeyResponse
         */
        GetDeviceKeyResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceKeyResponse)
                return object;
            var message = new $root.pond.GetDeviceKeyResponse();
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length)
                    message.key = object.key;
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceKeyResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceKeyResponse
         * @static
         * @param {pond.GetDeviceKeyResponse} message GetDeviceKeyResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceKeyResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            return object;
        };

        /**
         * Converts this GetDeviceKeyResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceKeyResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceKeyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceKeyResponse;
    })();

    pond.GetDeviceCountRequest = (function() {

        /**
         * Properties of a GetDeviceCountRequest.
         * @memberof pond
         * @interface IGetDeviceCountRequest
         * @property {number|null} [device] GetDeviceCountRequest device
         * @property {boolean|null} [tx] GetDeviceCountRequest tx
         */

        /**
         * Constructs a new GetDeviceCountRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceCountRequest.
         * @implements IGetDeviceCountRequest
         * @constructor
         * @param {pond.IGetDeviceCountRequest=} [properties] Properties to set
         */
        function GetDeviceCountRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceCountRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceCountRequest
         * @instance
         */
        GetDeviceCountRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetDeviceCountRequest tx.
         * @member {boolean} tx
         * @memberof pond.GetDeviceCountRequest
         * @instance
         */
        GetDeviceCountRequest.prototype.tx = false;

        /**
         * Creates a new GetDeviceCountRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceCountRequest
         * @static
         * @param {pond.IGetDeviceCountRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceCountRequest} GetDeviceCountRequest instance
         */
        GetDeviceCountRequest.create = function create(properties) {
            return new GetDeviceCountRequest(properties);
        };

        /**
         * Creates a GetDeviceCountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceCountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceCountRequest} GetDeviceCountRequest
         */
        GetDeviceCountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceCountRequest)
                return object;
            var message = new $root.pond.GetDeviceCountRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.tx != null)
                message.tx = Boolean(object.tx);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceCountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceCountRequest
         * @static
         * @param {pond.GetDeviceCountRequest} message GetDeviceCountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceCountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.tx = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.tx != null && message.hasOwnProperty("tx"))
                object.tx = message.tx;
            return object;
        };

        /**
         * Converts this GetDeviceCountRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceCountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceCountRequest;
    })();

    pond.ClearPendingRequest = (function() {

        /**
         * Properties of a ClearPendingRequest.
         * @memberof pond
         * @interface IClearPendingRequest
         * @property {number|null} [device] ClearPendingRequest device
         */

        /**
         * Constructs a new ClearPendingRequest.
         * @memberof pond
         * @classdesc Represents a ClearPendingRequest.
         * @implements IClearPendingRequest
         * @constructor
         * @param {pond.IClearPendingRequest=} [properties] Properties to set
         */
        function ClearPendingRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClearPendingRequest device.
         * @member {number} device
         * @memberof pond.ClearPendingRequest
         * @instance
         */
        ClearPendingRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ClearPendingRequest instance using the specified properties.
         * @function create
         * @memberof pond.ClearPendingRequest
         * @static
         * @param {pond.IClearPendingRequest=} [properties] Properties to set
         * @returns {pond.ClearPendingRequest} ClearPendingRequest instance
         */
        ClearPendingRequest.create = function create(properties) {
            return new ClearPendingRequest(properties);
        };

        /**
         * Creates a ClearPendingRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearPendingRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearPendingRequest} ClearPendingRequest
         */
        ClearPendingRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearPendingRequest)
                return object;
            var message = new $root.pond.ClearPendingRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ClearPendingRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearPendingRequest
         * @static
         * @param {pond.ClearPendingRequest} message ClearPendingRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearPendingRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this ClearPendingRequest to JSON.
         * @function toJSON
         * @memberof pond.ClearPendingRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearPendingRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearPendingRequest;
    })();

    pond.ClearPendingResponse = (function() {

        /**
         * Properties of a ClearPendingResponse.
         * @memberof pond
         * @interface IClearPendingResponse
         */

        /**
         * Constructs a new ClearPendingResponse.
         * @memberof pond
         * @classdesc Represents a ClearPendingResponse.
         * @implements IClearPendingResponse
         * @constructor
         * @param {pond.IClearPendingResponse=} [properties] Properties to set
         */
        function ClearPendingResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ClearPendingResponse instance using the specified properties.
         * @function create
         * @memberof pond.ClearPendingResponse
         * @static
         * @param {pond.IClearPendingResponse=} [properties] Properties to set
         * @returns {pond.ClearPendingResponse} ClearPendingResponse instance
         */
        ClearPendingResponse.create = function create(properties) {
            return new ClearPendingResponse(properties);
        };

        /**
         * Creates a ClearPendingResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearPendingResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearPendingResponse} ClearPendingResponse
         */
        ClearPendingResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearPendingResponse)
                return object;
            return new $root.pond.ClearPendingResponse();
        };

        /**
         * Creates a plain object from a ClearPendingResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearPendingResponse
         * @static
         * @param {pond.ClearPendingResponse} message ClearPendingResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearPendingResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ClearPendingResponse to JSON.
         * @function toJSON
         * @memberof pond.ClearPendingResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearPendingResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearPendingResponse;
    })();

    pond.SetDeviceCountRequest = (function() {

        /**
         * Properties of a SetDeviceCountRequest.
         * @memberof pond
         * @interface ISetDeviceCountRequest
         * @property {number|null} [device] SetDeviceCountRequest device
         * @property {number|null} [count] SetDeviceCountRequest count
         * @property {boolean|null} [tx] SetDeviceCountRequest tx
         */

        /**
         * Constructs a new SetDeviceCountRequest.
         * @memberof pond
         * @classdesc Represents a SetDeviceCountRequest.
         * @implements ISetDeviceCountRequest
         * @constructor
         * @param {pond.ISetDeviceCountRequest=} [properties] Properties to set
         */
        function SetDeviceCountRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetDeviceCountRequest device.
         * @member {number} device
         * @memberof pond.SetDeviceCountRequest
         * @instance
         */
        SetDeviceCountRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SetDeviceCountRequest count.
         * @member {number} count
         * @memberof pond.SetDeviceCountRequest
         * @instance
         */
        SetDeviceCountRequest.prototype.count = 0;

        /**
         * SetDeviceCountRequest tx.
         * @member {boolean} tx
         * @memberof pond.SetDeviceCountRequest
         * @instance
         */
        SetDeviceCountRequest.prototype.tx = false;

        /**
         * Creates a new SetDeviceCountRequest instance using the specified properties.
         * @function create
         * @memberof pond.SetDeviceCountRequest
         * @static
         * @param {pond.ISetDeviceCountRequest=} [properties] Properties to set
         * @returns {pond.SetDeviceCountRequest} SetDeviceCountRequest instance
         */
        SetDeviceCountRequest.create = function create(properties) {
            return new SetDeviceCountRequest(properties);
        };

        /**
         * Creates a SetDeviceCountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetDeviceCountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetDeviceCountRequest} SetDeviceCountRequest
         */
        SetDeviceCountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetDeviceCountRequest)
                return object;
            var message = new $root.pond.SetDeviceCountRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.count != null)
                message.count = object.count >>> 0;
            if (object.tx != null)
                message.tx = Boolean(object.tx);
            return message;
        };

        /**
         * Creates a plain object from a SetDeviceCountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetDeviceCountRequest
         * @static
         * @param {pond.SetDeviceCountRequest} message SetDeviceCountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetDeviceCountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.count = 0;
                object.tx = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            if (message.tx != null && message.hasOwnProperty("tx"))
                object.tx = message.tx;
            return object;
        };

        /**
         * Converts this SetDeviceCountRequest to JSON.
         * @function toJSON
         * @memberof pond.SetDeviceCountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetDeviceCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetDeviceCountRequest;
    })();

    pond.GetDeviceCountResponse = (function() {

        /**
         * Properties of a GetDeviceCountResponse.
         * @memberof pond
         * @interface IGetDeviceCountResponse
         * @property {number|null} [count] GetDeviceCountResponse count
         */

        /**
         * Constructs a new GetDeviceCountResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceCountResponse.
         * @implements IGetDeviceCountResponse
         * @constructor
         * @param {pond.IGetDeviceCountResponse=} [properties] Properties to set
         */
        function GetDeviceCountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceCountResponse count.
         * @member {number} count
         * @memberof pond.GetDeviceCountResponse
         * @instance
         */
        GetDeviceCountResponse.prototype.count = 0;

        /**
         * Creates a new GetDeviceCountResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceCountResponse
         * @static
         * @param {pond.IGetDeviceCountResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceCountResponse} GetDeviceCountResponse instance
         */
        GetDeviceCountResponse.create = function create(properties) {
            return new GetDeviceCountResponse(properties);
        };

        /**
         * Creates a GetDeviceCountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceCountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceCountResponse} GetDeviceCountResponse
         */
        GetDeviceCountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceCountResponse)
                return object;
            var message = new $root.pond.GetDeviceCountResponse();
            if (object.count != null)
                message.count = object.count >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceCountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceCountResponse
         * @static
         * @param {pond.GetDeviceCountResponse} message GetDeviceCountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceCountResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.count = 0;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            return object;
        };

        /**
         * Converts this GetDeviceCountResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceCountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceCountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceCountResponse;
    })();

    pond.SetDeviceCountResponse = (function() {

        /**
         * Properties of a SetDeviceCountResponse.
         * @memberof pond
         * @interface ISetDeviceCountResponse
         */

        /**
         * Constructs a new SetDeviceCountResponse.
         * @memberof pond
         * @classdesc Represents a SetDeviceCountResponse.
         * @implements ISetDeviceCountResponse
         * @constructor
         * @param {pond.ISetDeviceCountResponse=} [properties] Properties to set
         */
        function SetDeviceCountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SetDeviceCountResponse instance using the specified properties.
         * @function create
         * @memberof pond.SetDeviceCountResponse
         * @static
         * @param {pond.ISetDeviceCountResponse=} [properties] Properties to set
         * @returns {pond.SetDeviceCountResponse} SetDeviceCountResponse instance
         */
        SetDeviceCountResponse.create = function create(properties) {
            return new SetDeviceCountResponse(properties);
        };

        /**
         * Creates a SetDeviceCountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetDeviceCountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetDeviceCountResponse} SetDeviceCountResponse
         */
        SetDeviceCountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetDeviceCountResponse)
                return object;
            return new $root.pond.SetDeviceCountResponse();
        };

        /**
         * Creates a plain object from a SetDeviceCountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetDeviceCountResponse
         * @static
         * @param {pond.SetDeviceCountResponse} message SetDeviceCountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetDeviceCountResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SetDeviceCountResponse to JSON.
         * @function toJSON
         * @memberof pond.SetDeviceCountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetDeviceCountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetDeviceCountResponse;
    })();

    pond.GetDeviceArklesVersionRequest = (function() {

        /**
         * Properties of a GetDeviceArklesVersionRequest.
         * @memberof pond
         * @interface IGetDeviceArklesVersionRequest
         * @property {number|null} [id] GetDeviceArklesVersionRequest id
         */

        /**
         * Constructs a new GetDeviceArklesVersionRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceArklesVersionRequest.
         * @implements IGetDeviceArklesVersionRequest
         * @constructor
         * @param {pond.IGetDeviceArklesVersionRequest=} [properties] Properties to set
         */
        function GetDeviceArklesVersionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceArklesVersionRequest id.
         * @member {number} id
         * @memberof pond.GetDeviceArklesVersionRequest
         * @instance
         */
        GetDeviceArklesVersionRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDeviceArklesVersionRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceArklesVersionRequest
         * @static
         * @param {pond.IGetDeviceArklesVersionRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceArklesVersionRequest} GetDeviceArklesVersionRequest instance
         */
        GetDeviceArklesVersionRequest.create = function create(properties) {
            return new GetDeviceArklesVersionRequest(properties);
        };

        /**
         * Creates a GetDeviceArklesVersionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceArklesVersionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceArklesVersionRequest} GetDeviceArklesVersionRequest
         */
        GetDeviceArklesVersionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceArklesVersionRequest)
                return object;
            var message = new $root.pond.GetDeviceArklesVersionRequest();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceArklesVersionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceArklesVersionRequest
         * @static
         * @param {pond.GetDeviceArklesVersionRequest} message GetDeviceArklesVersionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceArklesVersionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            return object;
        };

        /**
         * Converts this GetDeviceArklesVersionRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceArklesVersionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceArklesVersionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceArklesVersionRequest;
    })();

    pond.GetDeviceArklesVersionResponse = (function() {

        /**
         * Properties of a GetDeviceArklesVersionResponse.
         * @memberof pond
         * @interface IGetDeviceArklesVersionResponse
         * @property {number|null} [version] GetDeviceArklesVersionResponse version
         */

        /**
         * Constructs a new GetDeviceArklesVersionResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceArklesVersionResponse.
         * @implements IGetDeviceArklesVersionResponse
         * @constructor
         * @param {pond.IGetDeviceArklesVersionResponse=} [properties] Properties to set
         */
        function GetDeviceArklesVersionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceArklesVersionResponse version.
         * @member {number} version
         * @memberof pond.GetDeviceArklesVersionResponse
         * @instance
         */
        GetDeviceArklesVersionResponse.prototype.version = 0;

        /**
         * Creates a new GetDeviceArklesVersionResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceArklesVersionResponse
         * @static
         * @param {pond.IGetDeviceArklesVersionResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceArklesVersionResponse} GetDeviceArklesVersionResponse instance
         */
        GetDeviceArklesVersionResponse.create = function create(properties) {
            return new GetDeviceArklesVersionResponse(properties);
        };

        /**
         * Creates a GetDeviceArklesVersionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceArklesVersionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceArklesVersionResponse} GetDeviceArklesVersionResponse
         */
        GetDeviceArklesVersionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceArklesVersionResponse)
                return object;
            var message = new $root.pond.GetDeviceArklesVersionResponse();
            if (object.version != null)
                message.version = object.version >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceArklesVersionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceArklesVersionResponse
         * @static
         * @param {pond.GetDeviceArklesVersionResponse} message GetDeviceArklesVersionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceArklesVersionResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.version = 0;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this GetDeviceArklesVersionResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceArklesVersionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceArklesVersionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceArklesVersionResponse;
    })();

    pond.SetDeviceArklesVersionRequest = (function() {

        /**
         * Properties of a SetDeviceArklesVersionRequest.
         * @memberof pond
         * @interface ISetDeviceArklesVersionRequest
         * @property {number|null} [id] SetDeviceArklesVersionRequest id
         * @property {number|null} [version] SetDeviceArklesVersionRequest version
         */

        /**
         * Constructs a new SetDeviceArklesVersionRequest.
         * @memberof pond
         * @classdesc Represents a SetDeviceArklesVersionRequest.
         * @implements ISetDeviceArklesVersionRequest
         * @constructor
         * @param {pond.ISetDeviceArklesVersionRequest=} [properties] Properties to set
         */
        function SetDeviceArklesVersionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetDeviceArklesVersionRequest id.
         * @member {number} id
         * @memberof pond.SetDeviceArklesVersionRequest
         * @instance
         */
        SetDeviceArklesVersionRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SetDeviceArklesVersionRequest version.
         * @member {number} version
         * @memberof pond.SetDeviceArklesVersionRequest
         * @instance
         */
        SetDeviceArklesVersionRequest.prototype.version = 0;

        /**
         * Creates a new SetDeviceArklesVersionRequest instance using the specified properties.
         * @function create
         * @memberof pond.SetDeviceArklesVersionRequest
         * @static
         * @param {pond.ISetDeviceArklesVersionRequest=} [properties] Properties to set
         * @returns {pond.SetDeviceArklesVersionRequest} SetDeviceArklesVersionRequest instance
         */
        SetDeviceArklesVersionRequest.create = function create(properties) {
            return new SetDeviceArklesVersionRequest(properties);
        };

        /**
         * Creates a SetDeviceArklesVersionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetDeviceArklesVersionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetDeviceArklesVersionRequest} SetDeviceArklesVersionRequest
         */
        SetDeviceArklesVersionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetDeviceArklesVersionRequest)
                return object;
            var message = new $root.pond.SetDeviceArklesVersionRequest();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.version != null)
                message.version = object.version >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SetDeviceArklesVersionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetDeviceArklesVersionRequest
         * @static
         * @param {pond.SetDeviceArklesVersionRequest} message SetDeviceArklesVersionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetDeviceArklesVersionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.version = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this SetDeviceArklesVersionRequest to JSON.
         * @function toJSON
         * @memberof pond.SetDeviceArklesVersionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetDeviceArklesVersionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetDeviceArklesVersionRequest;
    })();

    pond.SetDeviceArklesVersionResponse = (function() {

        /**
         * Properties of a SetDeviceArklesVersionResponse.
         * @memberof pond
         * @interface ISetDeviceArklesVersionResponse
         */

        /**
         * Constructs a new SetDeviceArklesVersionResponse.
         * @memberof pond
         * @classdesc Represents a SetDeviceArklesVersionResponse.
         * @implements ISetDeviceArklesVersionResponse
         * @constructor
         * @param {pond.ISetDeviceArklesVersionResponse=} [properties] Properties to set
         */
        function SetDeviceArklesVersionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SetDeviceArklesVersionResponse instance using the specified properties.
         * @function create
         * @memberof pond.SetDeviceArklesVersionResponse
         * @static
         * @param {pond.ISetDeviceArklesVersionResponse=} [properties] Properties to set
         * @returns {pond.SetDeviceArklesVersionResponse} SetDeviceArklesVersionResponse instance
         */
        SetDeviceArklesVersionResponse.create = function create(properties) {
            return new SetDeviceArklesVersionResponse(properties);
        };

        /**
         * Creates a SetDeviceArklesVersionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetDeviceArklesVersionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetDeviceArklesVersionResponse} SetDeviceArklesVersionResponse
         */
        SetDeviceArklesVersionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetDeviceArklesVersionResponse)
                return object;
            return new $root.pond.SetDeviceArklesVersionResponse();
        };

        /**
         * Creates a plain object from a SetDeviceArklesVersionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetDeviceArklesVersionResponse
         * @static
         * @param {pond.SetDeviceArklesVersionResponse} message SetDeviceArklesVersionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetDeviceArklesVersionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SetDeviceArklesVersionResponse to JSON.
         * @function toJSON
         * @memberof pond.SetDeviceArklesVersionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetDeviceArklesVersionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetDeviceArklesVersionResponse;
    })();

    pond.AddDeviceRequest = (function() {

        /**
         * Properties of an AddDeviceRequest.
         * @memberof pond
         * @interface IAddDeviceRequest
         * @property {pond.BackpackSettings|null} [backpack] AddDeviceRequest backpack
         * @property {string|null} [name] AddDeviceRequest name
         * @property {string|null} [description] AddDeviceRequest description
         */

        /**
         * Constructs a new AddDeviceRequest.
         * @memberof pond
         * @classdesc Represents an AddDeviceRequest.
         * @implements IAddDeviceRequest
         * @constructor
         * @param {pond.IAddDeviceRequest=} [properties] Properties to set
         */
        function AddDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddDeviceRequest backpack.
         * @member {pond.BackpackSettings|null|undefined} backpack
         * @memberof pond.AddDeviceRequest
         * @instance
         */
        AddDeviceRequest.prototype.backpack = null;

        /**
         * AddDeviceRequest name.
         * @member {string} name
         * @memberof pond.AddDeviceRequest
         * @instance
         */
        AddDeviceRequest.prototype.name = "";

        /**
         * AddDeviceRequest description.
         * @member {string} description
         * @memberof pond.AddDeviceRequest
         * @instance
         */
        AddDeviceRequest.prototype.description = "";

        /**
         * Creates a new AddDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddDeviceRequest
         * @static
         * @param {pond.IAddDeviceRequest=} [properties] Properties to set
         * @returns {pond.AddDeviceRequest} AddDeviceRequest instance
         */
        AddDeviceRequest.create = function create(properties) {
            return new AddDeviceRequest(properties);
        };

        /**
         * Creates an AddDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddDeviceRequest} AddDeviceRequest
         */
        AddDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddDeviceRequest)
                return object;
            var message = new $root.pond.AddDeviceRequest();
            if (object.backpack != null) {
                if (typeof object.backpack !== "object")
                    throw TypeError(".pond.AddDeviceRequest.backpack: object expected");
                message.backpack = $root.pond.BackpackSettings.fromObject(object.backpack);
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            return message;
        };

        /**
         * Creates a plain object from an AddDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddDeviceRequest
         * @static
         * @param {pond.AddDeviceRequest} message AddDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.backpack = null;
                object.name = "";
                object.description = "";
            }
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                object.backpack = $root.pond.BackpackSettings.toObject(message.backpack, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            return object;
        };

        /**
         * Converts this AddDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.AddDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddDeviceRequest;
    })();

    pond.AddDeviceResponse = (function() {

        /**
         * Properties of an AddDeviceResponse.
         * @memberof pond
         * @interface IAddDeviceResponse
         * @property {number|null} [id] AddDeviceResponse id
         * @property {Uint8Array|null} [key] AddDeviceResponse key
         * @property {string|null} [idHex] AddDeviceResponse idHex
         * @property {string|null} [keyHex] AddDeviceResponse keyHex
         */

        /**
         * Constructs a new AddDeviceResponse.
         * @memberof pond
         * @classdesc Represents an AddDeviceResponse.
         * @implements IAddDeviceResponse
         * @constructor
         * @param {pond.IAddDeviceResponse=} [properties] Properties to set
         */
        function AddDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddDeviceResponse id.
         * @member {number} id
         * @memberof pond.AddDeviceResponse
         * @instance
         */
        AddDeviceResponse.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddDeviceResponse key.
         * @member {Uint8Array} key
         * @memberof pond.AddDeviceResponse
         * @instance
         */
        AddDeviceResponse.prototype.key = $util.newBuffer([]);

        /**
         * AddDeviceResponse idHex.
         * @member {string} idHex
         * @memberof pond.AddDeviceResponse
         * @instance
         */
        AddDeviceResponse.prototype.idHex = "";

        /**
         * AddDeviceResponse keyHex.
         * @member {string} keyHex
         * @memberof pond.AddDeviceResponse
         * @instance
         */
        AddDeviceResponse.prototype.keyHex = "";

        /**
         * Creates a new AddDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddDeviceResponse
         * @static
         * @param {pond.IAddDeviceResponse=} [properties] Properties to set
         * @returns {pond.AddDeviceResponse} AddDeviceResponse instance
         */
        AddDeviceResponse.create = function create(properties) {
            return new AddDeviceResponse(properties);
        };

        /**
         * Creates an AddDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddDeviceResponse} AddDeviceResponse
         */
        AddDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddDeviceResponse)
                return object;
            var message = new $root.pond.AddDeviceResponse();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length)
                    message.key = object.key;
            if (object.idHex != null)
                message.idHex = String(object.idHex);
            if (object.keyHex != null)
                message.keyHex = String(object.keyHex);
            return message;
        };

        /**
         * Creates a plain object from an AddDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddDeviceResponse
         * @static
         * @param {pond.AddDeviceResponse} message AddDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
                object.idHex = "";
                object.keyHex = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.idHex != null && message.hasOwnProperty("idHex"))
                object.idHex = message.idHex;
            if (message.keyHex != null && message.hasOwnProperty("keyHex"))
                object.keyHex = message.keyHex;
            return object;
        };

        /**
         * Converts this AddDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.AddDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddDeviceResponse;
    })();

    pond.RemoveDeviceRequest = (function() {

        /**
         * Properties of a RemoveDeviceRequest.
         * @memberof pond
         * @interface IRemoveDeviceRequest
         * @property {number|null} [device] RemoveDeviceRequest device
         */

        /**
         * Constructs a new RemoveDeviceRequest.
         * @memberof pond
         * @classdesc Represents a RemoveDeviceRequest.
         * @implements IRemoveDeviceRequest
         * @constructor
         * @param {pond.IRemoveDeviceRequest=} [properties] Properties to set
         */
        function RemoveDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveDeviceRequest device.
         * @member {number} device
         * @memberof pond.RemoveDeviceRequest
         * @instance
         */
        RemoveDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RemoveDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveDeviceRequest
         * @static
         * @param {pond.IRemoveDeviceRequest=} [properties] Properties to set
         * @returns {pond.RemoveDeviceRequest} RemoveDeviceRequest instance
         */
        RemoveDeviceRequest.create = function create(properties) {
            return new RemoveDeviceRequest(properties);
        };

        /**
         * Creates a RemoveDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveDeviceRequest} RemoveDeviceRequest
         */
        RemoveDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveDeviceRequest)
                return object;
            var message = new $root.pond.RemoveDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RemoveDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveDeviceRequest
         * @static
         * @param {pond.RemoveDeviceRequest} message RemoveDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this RemoveDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveDeviceRequest;
    })();

    pond.RemoveDeviceResponse = (function() {

        /**
         * Properties of a RemoveDeviceResponse.
         * @memberof pond
         * @interface IRemoveDeviceResponse
         */

        /**
         * Constructs a new RemoveDeviceResponse.
         * @memberof pond
         * @classdesc Represents a RemoveDeviceResponse.
         * @implements IRemoveDeviceResponse
         * @constructor
         * @param {pond.IRemoveDeviceResponse=} [properties] Properties to set
         */
        function RemoveDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveDeviceResponse
         * @static
         * @param {pond.IRemoveDeviceResponse=} [properties] Properties to set
         * @returns {pond.RemoveDeviceResponse} RemoveDeviceResponse instance
         */
        RemoveDeviceResponse.create = function create(properties) {
            return new RemoveDeviceResponse(properties);
        };

        /**
         * Creates a RemoveDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveDeviceResponse} RemoveDeviceResponse
         */
        RemoveDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveDeviceResponse)
                return object;
            return new $root.pond.RemoveDeviceResponse();
        };

        /**
         * Creates a plain object from a RemoveDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveDeviceResponse
         * @static
         * @param {pond.RemoveDeviceResponse} message RemoveDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveDeviceResponse;
    })();

    pond.UpdateDeviceRequest = (function() {

        /**
         * Properties of an UpdateDeviceRequest.
         * @memberof pond
         * @interface IUpdateDeviceRequest
         * @property {pond.DeviceSettings|null} [device] UpdateDeviceRequest device
         */

        /**
         * Constructs a new UpdateDeviceRequest.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceRequest.
         * @implements IUpdateDeviceRequest
         * @constructor
         * @param {pond.IUpdateDeviceRequest=} [properties] Properties to set
         */
        function UpdateDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDeviceRequest device.
         * @member {pond.DeviceSettings|null|undefined} device
         * @memberof pond.UpdateDeviceRequest
         * @instance
         */
        UpdateDeviceRequest.prototype.device = null;

        /**
         * Creates a new UpdateDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceRequest
         * @static
         * @param {pond.IUpdateDeviceRequest=} [properties] Properties to set
         * @returns {pond.UpdateDeviceRequest} UpdateDeviceRequest instance
         */
        UpdateDeviceRequest.create = function create(properties) {
            return new UpdateDeviceRequest(properties);
        };

        /**
         * Creates an UpdateDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceRequest} UpdateDeviceRequest
         */
        UpdateDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceRequest)
                return object;
            var message = new $root.pond.UpdateDeviceRequest();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.UpdateDeviceRequest.device: object expected");
                message.device = $root.pond.DeviceSettings.fromObject(object.device);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceRequest
         * @static
         * @param {pond.UpdateDeviceRequest} message UpdateDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.device = null;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.DeviceSettings.toObject(message.device, options);
            return object;
        };

        /**
         * Converts this UpdateDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceRequest;
    })();

    pond.CancelDeviceUpgradeRequest = (function() {

        /**
         * Properties of a CancelDeviceUpgradeRequest.
         * @memberof pond
         * @interface ICancelDeviceUpgradeRequest
         * @property {number|null} [device] CancelDeviceUpgradeRequest device
         */

        /**
         * Constructs a new CancelDeviceUpgradeRequest.
         * @memberof pond
         * @classdesc Represents a CancelDeviceUpgradeRequest.
         * @implements ICancelDeviceUpgradeRequest
         * @constructor
         * @param {pond.ICancelDeviceUpgradeRequest=} [properties] Properties to set
         */
        function CancelDeviceUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CancelDeviceUpgradeRequest device.
         * @member {number} device
         * @memberof pond.CancelDeviceUpgradeRequest
         * @instance
         */
        CancelDeviceUpgradeRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CancelDeviceUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.CancelDeviceUpgradeRequest
         * @static
         * @param {pond.ICancelDeviceUpgradeRequest=} [properties] Properties to set
         * @returns {pond.CancelDeviceUpgradeRequest} CancelDeviceUpgradeRequest instance
         */
        CancelDeviceUpgradeRequest.create = function create(properties) {
            return new CancelDeviceUpgradeRequest(properties);
        };

        /**
         * Creates a CancelDeviceUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CancelDeviceUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CancelDeviceUpgradeRequest} CancelDeviceUpgradeRequest
         */
        CancelDeviceUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CancelDeviceUpgradeRequest)
                return object;
            var message = new $root.pond.CancelDeviceUpgradeRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CancelDeviceUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CancelDeviceUpgradeRequest
         * @static
         * @param {pond.CancelDeviceUpgradeRequest} message CancelDeviceUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CancelDeviceUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this CancelDeviceUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.CancelDeviceUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CancelDeviceUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CancelDeviceUpgradeRequest;
    })();

    pond.CancelDeviceUpgradeResponse = (function() {

        /**
         * Properties of a CancelDeviceUpgradeResponse.
         * @memberof pond
         * @interface ICancelDeviceUpgradeResponse
         */

        /**
         * Constructs a new CancelDeviceUpgradeResponse.
         * @memberof pond
         * @classdesc Represents a CancelDeviceUpgradeResponse.
         * @implements ICancelDeviceUpgradeResponse
         * @constructor
         * @param {pond.ICancelDeviceUpgradeResponse=} [properties] Properties to set
         */
        function CancelDeviceUpgradeResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CancelDeviceUpgradeResponse instance using the specified properties.
         * @function create
         * @memberof pond.CancelDeviceUpgradeResponse
         * @static
         * @param {pond.ICancelDeviceUpgradeResponse=} [properties] Properties to set
         * @returns {pond.CancelDeviceUpgradeResponse} CancelDeviceUpgradeResponse instance
         */
        CancelDeviceUpgradeResponse.create = function create(properties) {
            return new CancelDeviceUpgradeResponse(properties);
        };

        /**
         * Creates a CancelDeviceUpgradeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CancelDeviceUpgradeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CancelDeviceUpgradeResponse} CancelDeviceUpgradeResponse
         */
        CancelDeviceUpgradeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CancelDeviceUpgradeResponse)
                return object;
            return new $root.pond.CancelDeviceUpgradeResponse();
        };

        /**
         * Creates a plain object from a CancelDeviceUpgradeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CancelDeviceUpgradeResponse
         * @static
         * @param {pond.CancelDeviceUpgradeResponse} message CancelDeviceUpgradeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CancelDeviceUpgradeResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CancelDeviceUpgradeResponse to JSON.
         * @function toJSON
         * @memberof pond.CancelDeviceUpgradeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CancelDeviceUpgradeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CancelDeviceUpgradeResponse;
    })();

    pond.ResetQuackCountRequest = (function() {

        /**
         * Properties of a ResetQuackCountRequest.
         * @memberof pond
         * @interface IResetQuackCountRequest
         * @property {number|null} [device] ResetQuackCountRequest device
         */

        /**
         * Constructs a new ResetQuackCountRequest.
         * @memberof pond
         * @classdesc Represents a ResetQuackCountRequest.
         * @implements IResetQuackCountRequest
         * @constructor
         * @param {pond.IResetQuackCountRequest=} [properties] Properties to set
         */
        function ResetQuackCountRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetQuackCountRequest device.
         * @member {number} device
         * @memberof pond.ResetQuackCountRequest
         * @instance
         */
        ResetQuackCountRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ResetQuackCountRequest instance using the specified properties.
         * @function create
         * @memberof pond.ResetQuackCountRequest
         * @static
         * @param {pond.IResetQuackCountRequest=} [properties] Properties to set
         * @returns {pond.ResetQuackCountRequest} ResetQuackCountRequest instance
         */
        ResetQuackCountRequest.create = function create(properties) {
            return new ResetQuackCountRequest(properties);
        };

        /**
         * Creates a ResetQuackCountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResetQuackCountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResetQuackCountRequest} ResetQuackCountRequest
         */
        ResetQuackCountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResetQuackCountRequest)
                return object;
            var message = new $root.pond.ResetQuackCountRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ResetQuackCountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResetQuackCountRequest
         * @static
         * @param {pond.ResetQuackCountRequest} message ResetQuackCountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetQuackCountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this ResetQuackCountRequest to JSON.
         * @function toJSON
         * @memberof pond.ResetQuackCountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetQuackCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetQuackCountRequest;
    })();

    pond.ResetQuackCountRequestTx = (function() {

        /**
         * Properties of a ResetQuackCountRequestTx.
         * @memberof pond
         * @interface IResetQuackCountRequestTx
         * @property {number|null} [device] ResetQuackCountRequestTx device
         * @property {number|null} [val] ResetQuackCountRequestTx val
         */

        /**
         * Constructs a new ResetQuackCountRequestTx.
         * @memberof pond
         * @classdesc Represents a ResetQuackCountRequestTx.
         * @implements IResetQuackCountRequestTx
         * @constructor
         * @param {pond.IResetQuackCountRequestTx=} [properties] Properties to set
         */
        function ResetQuackCountRequestTx(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetQuackCountRequestTx device.
         * @member {number} device
         * @memberof pond.ResetQuackCountRequestTx
         * @instance
         */
        ResetQuackCountRequestTx.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ResetQuackCountRequestTx val.
         * @member {number} val
         * @memberof pond.ResetQuackCountRequestTx
         * @instance
         */
        ResetQuackCountRequestTx.prototype.val = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ResetQuackCountRequestTx instance using the specified properties.
         * @function create
         * @memberof pond.ResetQuackCountRequestTx
         * @static
         * @param {pond.IResetQuackCountRequestTx=} [properties] Properties to set
         * @returns {pond.ResetQuackCountRequestTx} ResetQuackCountRequestTx instance
         */
        ResetQuackCountRequestTx.create = function create(properties) {
            return new ResetQuackCountRequestTx(properties);
        };

        /**
         * Creates a ResetQuackCountRequestTx message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResetQuackCountRequestTx
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResetQuackCountRequestTx} ResetQuackCountRequestTx
         */
        ResetQuackCountRequestTx.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResetQuackCountRequestTx)
                return object;
            var message = new $root.pond.ResetQuackCountRequestTx();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.val != null)
                if ($util.Long)
                    (message.val = $util.Long.fromValue(object.val)).unsigned = true;
                else if (typeof object.val === "string")
                    message.val = parseInt(object.val, 10);
                else if (typeof object.val === "number")
                    message.val = object.val;
                else if (typeof object.val === "object")
                    message.val = new $util.LongBits(object.val.low >>> 0, object.val.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ResetQuackCountRequestTx message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResetQuackCountRequestTx
         * @static
         * @param {pond.ResetQuackCountRequestTx} message ResetQuackCountRequestTx
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetQuackCountRequestTx.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.val = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.val = options.longs === String ? "0" : 0;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.val != null && message.hasOwnProperty("val"))
                if (typeof message.val === "number")
                    object.val = options.longs === String ? String(message.val) : message.val;
                else
                    object.val = options.longs === String ? $util.Long.prototype.toString.call(message.val) : options.longs === Number ? new $util.LongBits(message.val.low >>> 0, message.val.high >>> 0).toNumber(true) : message.val;
            return object;
        };

        /**
         * Converts this ResetQuackCountRequestTx to JSON.
         * @function toJSON
         * @memberof pond.ResetQuackCountRequestTx
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetQuackCountRequestTx.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetQuackCountRequestTx;
    })();

    pond.ResetQuackCountResponse = (function() {

        /**
         * Properties of a ResetQuackCountResponse.
         * @memberof pond
         * @interface IResetQuackCountResponse
         * @property {boolean|null} [resetSuccessfull] ResetQuackCountResponse resetSuccessfull
         */

        /**
         * Constructs a new ResetQuackCountResponse.
         * @memberof pond
         * @classdesc Represents a ResetQuackCountResponse.
         * @implements IResetQuackCountResponse
         * @constructor
         * @param {pond.IResetQuackCountResponse=} [properties] Properties to set
         */
        function ResetQuackCountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetQuackCountResponse resetSuccessfull.
         * @member {boolean} resetSuccessfull
         * @memberof pond.ResetQuackCountResponse
         * @instance
         */
        ResetQuackCountResponse.prototype.resetSuccessfull = false;

        /**
         * Creates a new ResetQuackCountResponse instance using the specified properties.
         * @function create
         * @memberof pond.ResetQuackCountResponse
         * @static
         * @param {pond.IResetQuackCountResponse=} [properties] Properties to set
         * @returns {pond.ResetQuackCountResponse} ResetQuackCountResponse instance
         */
        ResetQuackCountResponse.create = function create(properties) {
            return new ResetQuackCountResponse(properties);
        };

        /**
         * Creates a ResetQuackCountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResetQuackCountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResetQuackCountResponse} ResetQuackCountResponse
         */
        ResetQuackCountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResetQuackCountResponse)
                return object;
            var message = new $root.pond.ResetQuackCountResponse();
            if (object.resetSuccessfull != null)
                message.resetSuccessfull = Boolean(object.resetSuccessfull);
            return message;
        };

        /**
         * Creates a plain object from a ResetQuackCountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResetQuackCountResponse
         * @static
         * @param {pond.ResetQuackCountResponse} message ResetQuackCountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetQuackCountResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.resetSuccessfull = false;
            if (message.resetSuccessfull != null && message.hasOwnProperty("resetSuccessfull"))
                object.resetSuccessfull = message.resetSuccessfull;
            return object;
        };

        /**
         * Converts this ResetQuackCountResponse to JSON.
         * @function toJSON
         * @memberof pond.ResetQuackCountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetQuackCountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetQuackCountResponse;
    })();

    pond.ResetQuackCountResponseTx = (function() {

        /**
         * Properties of a ResetQuackCountResponseTx.
         * @memberof pond
         * @interface IResetQuackCountResponseTx
         * @property {boolean|null} [resetSuccessfull] ResetQuackCountResponseTx resetSuccessfull
         */

        /**
         * Constructs a new ResetQuackCountResponseTx.
         * @memberof pond
         * @classdesc Represents a ResetQuackCountResponseTx.
         * @implements IResetQuackCountResponseTx
         * @constructor
         * @param {pond.IResetQuackCountResponseTx=} [properties] Properties to set
         */
        function ResetQuackCountResponseTx(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetQuackCountResponseTx resetSuccessfull.
         * @member {boolean} resetSuccessfull
         * @memberof pond.ResetQuackCountResponseTx
         * @instance
         */
        ResetQuackCountResponseTx.prototype.resetSuccessfull = false;

        /**
         * Creates a new ResetQuackCountResponseTx instance using the specified properties.
         * @function create
         * @memberof pond.ResetQuackCountResponseTx
         * @static
         * @param {pond.IResetQuackCountResponseTx=} [properties] Properties to set
         * @returns {pond.ResetQuackCountResponseTx} ResetQuackCountResponseTx instance
         */
        ResetQuackCountResponseTx.create = function create(properties) {
            return new ResetQuackCountResponseTx(properties);
        };

        /**
         * Creates a ResetQuackCountResponseTx message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResetQuackCountResponseTx
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResetQuackCountResponseTx} ResetQuackCountResponseTx
         */
        ResetQuackCountResponseTx.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResetQuackCountResponseTx)
                return object;
            var message = new $root.pond.ResetQuackCountResponseTx();
            if (object.resetSuccessfull != null)
                message.resetSuccessfull = Boolean(object.resetSuccessfull);
            return message;
        };

        /**
         * Creates a plain object from a ResetQuackCountResponseTx message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResetQuackCountResponseTx
         * @static
         * @param {pond.ResetQuackCountResponseTx} message ResetQuackCountResponseTx
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetQuackCountResponseTx.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.resetSuccessfull = false;
            if (message.resetSuccessfull != null && message.hasOwnProperty("resetSuccessfull"))
                object.resetSuccessfull = message.resetSuccessfull;
            return object;
        };

        /**
         * Converts this ResetQuackCountResponseTx to JSON.
         * @function toJSON
         * @memberof pond.ResetQuackCountResponseTx
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetQuackCountResponseTx.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetQuackCountResponseTx;
    })();

    pond.UpdateDeviceResponse = (function() {

        /**
         * Properties of an UpdateDeviceResponse.
         * @memberof pond
         * @interface IUpdateDeviceResponse
         */

        /**
         * Constructs a new UpdateDeviceResponse.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceResponse.
         * @implements IUpdateDeviceResponse
         * @constructor
         * @param {pond.IUpdateDeviceResponse=} [properties] Properties to set
         */
        function UpdateDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceResponse
         * @static
         * @param {pond.IUpdateDeviceResponse=} [properties] Properties to set
         * @returns {pond.UpdateDeviceResponse} UpdateDeviceResponse instance
         */
        UpdateDeviceResponse.create = function create(properties) {
            return new UpdateDeviceResponse(properties);
        };

        /**
         * Creates an UpdateDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceResponse} UpdateDeviceResponse
         */
        UpdateDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceResponse)
                return object;
            return new $root.pond.UpdateDeviceResponse();
        };

        /**
         * Creates a plain object from an UpdateDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceResponse
         * @static
         * @param {pond.UpdateDeviceResponse} message UpdateDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceResponse;
    })();

    pond.UpdateDeviceStatusRequest = (function() {

        /**
         * Properties of an UpdateDeviceStatusRequest.
         * @memberof pond
         * @interface IUpdateDeviceStatusRequest
         * @property {number|null} [device] UpdateDeviceStatusRequest device
         * @property {pond.DeviceStatus|null} [status] UpdateDeviceStatusRequest status
         */

        /**
         * Constructs a new UpdateDeviceStatusRequest.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceStatusRequest.
         * @implements IUpdateDeviceStatusRequest
         * @constructor
         * @param {pond.IUpdateDeviceStatusRequest=} [properties] Properties to set
         */
        function UpdateDeviceStatusRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDeviceStatusRequest device.
         * @member {number} device
         * @memberof pond.UpdateDeviceStatusRequest
         * @instance
         */
        UpdateDeviceStatusRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpdateDeviceStatusRequest status.
         * @member {pond.DeviceStatus|null|undefined} status
         * @memberof pond.UpdateDeviceStatusRequest
         * @instance
         */
        UpdateDeviceStatusRequest.prototype.status = null;

        /**
         * Creates a new UpdateDeviceStatusRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceStatusRequest
         * @static
         * @param {pond.IUpdateDeviceStatusRequest=} [properties] Properties to set
         * @returns {pond.UpdateDeviceStatusRequest} UpdateDeviceStatusRequest instance
         */
        UpdateDeviceStatusRequest.create = function create(properties) {
            return new UpdateDeviceStatusRequest(properties);
        };

        /**
         * Creates an UpdateDeviceStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceStatusRequest} UpdateDeviceStatusRequest
         */
        UpdateDeviceStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceStatusRequest)
                return object;
            var message = new $root.pond.UpdateDeviceStatusRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.UpdateDeviceStatusRequest.status: object expected");
                message.status = $root.pond.DeviceStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateDeviceStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceStatusRequest
         * @static
         * @param {pond.UpdateDeviceStatusRequest} message UpdateDeviceStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.status = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.DeviceStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this UpdateDeviceStatusRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceStatusRequest;
    })();

    pond.UpdateDeviceStatusResponse = (function() {

        /**
         * Properties of an UpdateDeviceStatusResponse.
         * @memberof pond
         * @interface IUpdateDeviceStatusResponse
         */

        /**
         * Constructs a new UpdateDeviceStatusResponse.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceStatusResponse.
         * @implements IUpdateDeviceStatusResponse
         * @constructor
         * @param {pond.IUpdateDeviceStatusResponse=} [properties] Properties to set
         */
        function UpdateDeviceStatusResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateDeviceStatusResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceStatusResponse
         * @static
         * @param {pond.IUpdateDeviceStatusResponse=} [properties] Properties to set
         * @returns {pond.UpdateDeviceStatusResponse} UpdateDeviceStatusResponse instance
         */
        UpdateDeviceStatusResponse.create = function create(properties) {
            return new UpdateDeviceStatusResponse(properties);
        };

        /**
         * Creates an UpdateDeviceStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceStatusResponse} UpdateDeviceStatusResponse
         */
        UpdateDeviceStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceStatusResponse)
                return object;
            return new $root.pond.UpdateDeviceStatusResponse();
        };

        /**
         * Creates a plain object from an UpdateDeviceStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceStatusResponse
         * @static
         * @param {pond.UpdateDeviceStatusResponse} message UpdateDeviceStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceStatusResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateDeviceStatusResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceStatusResponse;
    })();

    pond.UpdateDeviceLastActiveRequest = (function() {

        /**
         * Properties of an UpdateDeviceLastActiveRequest.
         * @memberof pond
         * @interface IUpdateDeviceLastActiveRequest
         * @property {pond.Device|null} [device] UpdateDeviceLastActiveRequest device
         */

        /**
         * Constructs a new UpdateDeviceLastActiveRequest.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceLastActiveRequest.
         * @implements IUpdateDeviceLastActiveRequest
         * @constructor
         * @param {pond.IUpdateDeviceLastActiveRequest=} [properties] Properties to set
         */
        function UpdateDeviceLastActiveRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDeviceLastActiveRequest device.
         * @member {pond.Device|null|undefined} device
         * @memberof pond.UpdateDeviceLastActiveRequest
         * @instance
         */
        UpdateDeviceLastActiveRequest.prototype.device = null;

        /**
         * Creates a new UpdateDeviceLastActiveRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceLastActiveRequest
         * @static
         * @param {pond.IUpdateDeviceLastActiveRequest=} [properties] Properties to set
         * @returns {pond.UpdateDeviceLastActiveRequest} UpdateDeviceLastActiveRequest instance
         */
        UpdateDeviceLastActiveRequest.create = function create(properties) {
            return new UpdateDeviceLastActiveRequest(properties);
        };

        /**
         * Creates an UpdateDeviceLastActiveRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceLastActiveRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceLastActiveRequest} UpdateDeviceLastActiveRequest
         */
        UpdateDeviceLastActiveRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceLastActiveRequest)
                return object;
            var message = new $root.pond.UpdateDeviceLastActiveRequest();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.UpdateDeviceLastActiveRequest.device: object expected");
                message.device = $root.pond.Device.fromObject(object.device);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateDeviceLastActiveRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceLastActiveRequest
         * @static
         * @param {pond.UpdateDeviceLastActiveRequest} message UpdateDeviceLastActiveRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceLastActiveRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.device = null;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.Device.toObject(message.device, options);
            return object;
        };

        /**
         * Converts this UpdateDeviceLastActiveRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceLastActiveRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceLastActiveRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceLastActiveRequest;
    })();

    pond.UpdateDeviceLastActiveResponse = (function() {

        /**
         * Properties of an UpdateDeviceLastActiveResponse.
         * @memberof pond
         * @interface IUpdateDeviceLastActiveResponse
         */

        /**
         * Constructs a new UpdateDeviceLastActiveResponse.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceLastActiveResponse.
         * @implements IUpdateDeviceLastActiveResponse
         * @constructor
         * @param {pond.IUpdateDeviceLastActiveResponse=} [properties] Properties to set
         */
        function UpdateDeviceLastActiveResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateDeviceLastActiveResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceLastActiveResponse
         * @static
         * @param {pond.IUpdateDeviceLastActiveResponse=} [properties] Properties to set
         * @returns {pond.UpdateDeviceLastActiveResponse} UpdateDeviceLastActiveResponse instance
         */
        UpdateDeviceLastActiveResponse.create = function create(properties) {
            return new UpdateDeviceLastActiveResponse(properties);
        };

        /**
         * Creates an UpdateDeviceLastActiveResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceLastActiveResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceLastActiveResponse} UpdateDeviceLastActiveResponse
         */
        UpdateDeviceLastActiveResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceLastActiveResponse)
                return object;
            return new $root.pond.UpdateDeviceLastActiveResponse();
        };

        /**
         * Creates a plain object from an UpdateDeviceLastActiveResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceLastActiveResponse
         * @static
         * @param {pond.UpdateDeviceLastActiveResponse} message UpdateDeviceLastActiveResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceLastActiveResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateDeviceLastActiveResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceLastActiveResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceLastActiveResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceLastActiveResponse;
    })();

    pond.GetDeviceRequest = (function() {

        /**
         * Properties of a GetDeviceRequest.
         * @memberof pond
         * @interface IGetDeviceRequest
         * @property {number|null} [device] GetDeviceRequest device
         */

        /**
         * Constructs a new GetDeviceRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceRequest.
         * @implements IGetDeviceRequest
         * @constructor
         * @param {pond.IGetDeviceRequest=} [properties] Properties to set
         */
        function GetDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceRequest
         * @instance
         */
        GetDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceRequest
         * @static
         * @param {pond.IGetDeviceRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceRequest} GetDeviceRequest instance
         */
        GetDeviceRequest.create = function create(properties) {
            return new GetDeviceRequest(properties);
        };

        /**
         * Creates a GetDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceRequest} GetDeviceRequest
         */
        GetDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceRequest)
                return object;
            var message = new $root.pond.GetDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceRequest
         * @static
         * @param {pond.GetDeviceRequest} message GetDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceRequest;
    })();

    pond.ClearDeviceQueueRequest = (function() {

        /**
         * Properties of a ClearDeviceQueueRequest.
         * @memberof pond
         * @interface IClearDeviceQueueRequest
         * @property {number|null} [device] ClearDeviceQueueRequest device
         */

        /**
         * Constructs a new ClearDeviceQueueRequest.
         * @memberof pond
         * @classdesc Represents a ClearDeviceQueueRequest.
         * @implements IClearDeviceQueueRequest
         * @constructor
         * @param {pond.IClearDeviceQueueRequest=} [properties] Properties to set
         */
        function ClearDeviceQueueRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClearDeviceQueueRequest device.
         * @member {number} device
         * @memberof pond.ClearDeviceQueueRequest
         * @instance
         */
        ClearDeviceQueueRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ClearDeviceQueueRequest instance using the specified properties.
         * @function create
         * @memberof pond.ClearDeviceQueueRequest
         * @static
         * @param {pond.IClearDeviceQueueRequest=} [properties] Properties to set
         * @returns {pond.ClearDeviceQueueRequest} ClearDeviceQueueRequest instance
         */
        ClearDeviceQueueRequest.create = function create(properties) {
            return new ClearDeviceQueueRequest(properties);
        };

        /**
         * Creates a ClearDeviceQueueRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearDeviceQueueRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearDeviceQueueRequest} ClearDeviceQueueRequest
         */
        ClearDeviceQueueRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearDeviceQueueRequest)
                return object;
            var message = new $root.pond.ClearDeviceQueueRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ClearDeviceQueueRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearDeviceQueueRequest
         * @static
         * @param {pond.ClearDeviceQueueRequest} message ClearDeviceQueueRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearDeviceQueueRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this ClearDeviceQueueRequest to JSON.
         * @function toJSON
         * @memberof pond.ClearDeviceQueueRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearDeviceQueueRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearDeviceQueueRequest;
    })();

    pond.ClearDeviceQueueResponse = (function() {

        /**
         * Properties of a ClearDeviceQueueResponse.
         * @memberof pond
         * @interface IClearDeviceQueueResponse
         */

        /**
         * Constructs a new ClearDeviceQueueResponse.
         * @memberof pond
         * @classdesc Represents a ClearDeviceQueueResponse.
         * @implements IClearDeviceQueueResponse
         * @constructor
         * @param {pond.IClearDeviceQueueResponse=} [properties] Properties to set
         */
        function ClearDeviceQueueResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ClearDeviceQueueResponse instance using the specified properties.
         * @function create
         * @memberof pond.ClearDeviceQueueResponse
         * @static
         * @param {pond.IClearDeviceQueueResponse=} [properties] Properties to set
         * @returns {pond.ClearDeviceQueueResponse} ClearDeviceQueueResponse instance
         */
        ClearDeviceQueueResponse.create = function create(properties) {
            return new ClearDeviceQueueResponse(properties);
        };

        /**
         * Creates a ClearDeviceQueueResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearDeviceQueueResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearDeviceQueueResponse} ClearDeviceQueueResponse
         */
        ClearDeviceQueueResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearDeviceQueueResponse)
                return object;
            return new $root.pond.ClearDeviceQueueResponse();
        };

        /**
         * Creates a plain object from a ClearDeviceQueueResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearDeviceQueueResponse
         * @static
         * @param {pond.ClearDeviceQueueResponse} message ClearDeviceQueueResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearDeviceQueueResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ClearDeviceQueueResponse to JSON.
         * @function toJSON
         * @memberof pond.ClearDeviceQueueResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearDeviceQueueResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearDeviceQueueResponse;
    })();

    pond.GetDeviceGeoJSONRequest = (function() {

        /**
         * Properties of a GetDeviceGeoJSONRequest.
         * @memberof pond
         * @interface IGetDeviceGeoJSONRequest
         * @property {number|null} [device] GetDeviceGeoJSONRequest device
         */

        /**
         * Constructs a new GetDeviceGeoJSONRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceGeoJSONRequest.
         * @implements IGetDeviceGeoJSONRequest
         * @constructor
         * @param {pond.IGetDeviceGeoJSONRequest=} [properties] Properties to set
         */
        function GetDeviceGeoJSONRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceGeoJSONRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceGeoJSONRequest
         * @instance
         */
        GetDeviceGeoJSONRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDeviceGeoJSONRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceGeoJSONRequest
         * @static
         * @param {pond.IGetDeviceGeoJSONRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceGeoJSONRequest} GetDeviceGeoJSONRequest instance
         */
        GetDeviceGeoJSONRequest.create = function create(properties) {
            return new GetDeviceGeoJSONRequest(properties);
        };

        /**
         * Creates a GetDeviceGeoJSONRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceGeoJSONRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceGeoJSONRequest} GetDeviceGeoJSONRequest
         */
        GetDeviceGeoJSONRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceGeoJSONRequest)
                return object;
            var message = new $root.pond.GetDeviceGeoJSONRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceGeoJSONRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceGeoJSONRequest
         * @static
         * @param {pond.GetDeviceGeoJSONRequest} message GetDeviceGeoJSONRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceGeoJSONRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDeviceGeoJSONRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceGeoJSONRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceGeoJSONRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceGeoJSONRequest;
    })();

    pond.GetMultiDeviceGeoJSONRequest = (function() {

        /**
         * Properties of a GetMultiDeviceGeoJSONRequest.
         * @memberof pond
         * @interface IGetMultiDeviceGeoJSONRequest
         * @property {Array.<number>|null} [deviceId] GetMultiDeviceGeoJSONRequest deviceId
         */

        /**
         * Constructs a new GetMultiDeviceGeoJSONRequest.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceGeoJSONRequest.
         * @implements IGetMultiDeviceGeoJSONRequest
         * @constructor
         * @param {pond.IGetMultiDeviceGeoJSONRequest=} [properties] Properties to set
         */
        function GetMultiDeviceGeoJSONRequest(properties) {
            this.deviceId = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceGeoJSONRequest deviceId.
         * @member {Array.<number>} deviceId
         * @memberof pond.GetMultiDeviceGeoJSONRequest
         * @instance
         */
        GetMultiDeviceGeoJSONRequest.prototype.deviceId = $util.emptyArray;

        /**
         * Creates a new GetMultiDeviceGeoJSONRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceGeoJSONRequest
         * @static
         * @param {pond.IGetMultiDeviceGeoJSONRequest=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceGeoJSONRequest} GetMultiDeviceGeoJSONRequest instance
         */
        GetMultiDeviceGeoJSONRequest.create = function create(properties) {
            return new GetMultiDeviceGeoJSONRequest(properties);
        };

        /**
         * Creates a GetMultiDeviceGeoJSONRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceGeoJSONRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceGeoJSONRequest} GetMultiDeviceGeoJSONRequest
         */
        GetMultiDeviceGeoJSONRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceGeoJSONRequest)
                return object;
            var message = new $root.pond.GetMultiDeviceGeoJSONRequest();
            if (object.deviceId) {
                if (!Array.isArray(object.deviceId))
                    throw TypeError(".pond.GetMultiDeviceGeoJSONRequest.deviceId: array expected");
                message.deviceId = [];
                for (var i = 0; i < object.deviceId.length; ++i)
                    if ($util.Long)
                        (message.deviceId[i] = $util.Long.fromValue(object.deviceId[i])).unsigned = true;
                    else if (typeof object.deviceId[i] === "string")
                        message.deviceId[i] = parseInt(object.deviceId[i], 10);
                    else if (typeof object.deviceId[i] === "number")
                        message.deviceId[i] = object.deviceId[i];
                    else if (typeof object.deviceId[i] === "object")
                        message.deviceId[i] = new $util.LongBits(object.deviceId[i].low >>> 0, object.deviceId[i].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceGeoJSONRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceGeoJSONRequest
         * @static
         * @param {pond.GetMultiDeviceGeoJSONRequest} message GetMultiDeviceGeoJSONRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceGeoJSONRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.deviceId = [];
            if (message.deviceId && message.deviceId.length) {
                object.deviceId = [];
                for (var j = 0; j < message.deviceId.length; ++j)
                    if (typeof message.deviceId[j] === "number")
                        object.deviceId[j] = options.longs === String ? String(message.deviceId[j]) : message.deviceId[j];
                    else
                        object.deviceId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId[j]) : options.longs === Number ? new $util.LongBits(message.deviceId[j].low >>> 0, message.deviceId[j].high >>> 0).toNumber(true) : message.deviceId[j];
            }
            return object;
        };

        /**
         * Converts this GetMultiDeviceGeoJSONRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceGeoJSONRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceGeoJSONRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceGeoJSONRequest;
    })();

    pond.GetMultiDeviceGeoJSONResponse = (function() {

        /**
         * Properties of a GetMultiDeviceGeoJSONResponse.
         * @memberof pond
         * @interface IGetMultiDeviceGeoJSONResponse
         * @property {Array.<pond.DeviceGeoJSON>|null} [geojsonDevices] GetMultiDeviceGeoJSONResponse geojsonDevices
         */

        /**
         * Constructs a new GetMultiDeviceGeoJSONResponse.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceGeoJSONResponse.
         * @implements IGetMultiDeviceGeoJSONResponse
         * @constructor
         * @param {pond.IGetMultiDeviceGeoJSONResponse=} [properties] Properties to set
         */
        function GetMultiDeviceGeoJSONResponse(properties) {
            this.geojsonDevices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceGeoJSONResponse geojsonDevices.
         * @member {Array.<pond.DeviceGeoJSON>} geojsonDevices
         * @memberof pond.GetMultiDeviceGeoJSONResponse
         * @instance
         */
        GetMultiDeviceGeoJSONResponse.prototype.geojsonDevices = $util.emptyArray;

        /**
         * Creates a new GetMultiDeviceGeoJSONResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceGeoJSONResponse
         * @static
         * @param {pond.IGetMultiDeviceGeoJSONResponse=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceGeoJSONResponse} GetMultiDeviceGeoJSONResponse instance
         */
        GetMultiDeviceGeoJSONResponse.create = function create(properties) {
            return new GetMultiDeviceGeoJSONResponse(properties);
        };

        /**
         * Creates a GetMultiDeviceGeoJSONResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceGeoJSONResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceGeoJSONResponse} GetMultiDeviceGeoJSONResponse
         */
        GetMultiDeviceGeoJSONResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceGeoJSONResponse)
                return object;
            var message = new $root.pond.GetMultiDeviceGeoJSONResponse();
            if (object.geojsonDevices) {
                if (!Array.isArray(object.geojsonDevices))
                    throw TypeError(".pond.GetMultiDeviceGeoJSONResponse.geojsonDevices: array expected");
                message.geojsonDevices = [];
                for (var i = 0; i < object.geojsonDevices.length; ++i) {
                    if (typeof object.geojsonDevices[i] !== "object")
                        throw TypeError(".pond.GetMultiDeviceGeoJSONResponse.geojsonDevices: object expected");
                    message.geojsonDevices[i] = $root.pond.DeviceGeoJSON.fromObject(object.geojsonDevices[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceGeoJSONResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceGeoJSONResponse
         * @static
         * @param {pond.GetMultiDeviceGeoJSONResponse} message GetMultiDeviceGeoJSONResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceGeoJSONResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.geojsonDevices = [];
            if (message.geojsonDevices && message.geojsonDevices.length) {
                object.geojsonDevices = [];
                for (var j = 0; j < message.geojsonDevices.length; ++j)
                    object.geojsonDevices[j] = $root.pond.DeviceGeoJSON.toObject(message.geojsonDevices[j], options);
            }
            return object;
        };

        /**
         * Converts this GetMultiDeviceGeoJSONResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceGeoJSONResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceGeoJSONResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceGeoJSONResponse;
    })();

    pond.DeviceGeometry = (function() {

        /**
         * Properties of a DeviceGeometry.
         * @memberof pond
         * @interface IDeviceGeometry
         * @property {string|null} [type] DeviceGeometry type
         * @property {Array.<number>|null} [coordinates] DeviceGeometry coordinates
         */

        /**
         * Constructs a new DeviceGeometry.
         * @memberof pond
         * @classdesc Represents a DeviceGeometry.
         * @implements IDeviceGeometry
         * @constructor
         * @param {pond.IDeviceGeometry=} [properties] Properties to set
         */
        function DeviceGeometry(properties) {
            this.coordinates = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceGeometry type.
         * @member {string} type
         * @memberof pond.DeviceGeometry
         * @instance
         */
        DeviceGeometry.prototype.type = "";

        /**
         * DeviceGeometry coordinates.
         * @member {Array.<number>} coordinates
         * @memberof pond.DeviceGeometry
         * @instance
         */
        DeviceGeometry.prototype.coordinates = $util.emptyArray;

        /**
         * Creates a new DeviceGeometry instance using the specified properties.
         * @function create
         * @memberof pond.DeviceGeometry
         * @static
         * @param {pond.IDeviceGeometry=} [properties] Properties to set
         * @returns {pond.DeviceGeometry} DeviceGeometry instance
         */
        DeviceGeometry.create = function create(properties) {
            return new DeviceGeometry(properties);
        };

        /**
         * Creates a DeviceGeometry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceGeometry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceGeometry} DeviceGeometry
         */
        DeviceGeometry.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceGeometry)
                return object;
            var message = new $root.pond.DeviceGeometry();
            if (object.type != null)
                message.type = String(object.type);
            if (object.coordinates) {
                if (!Array.isArray(object.coordinates))
                    throw TypeError(".pond.DeviceGeometry.coordinates: array expected");
                message.coordinates = [];
                for (var i = 0; i < object.coordinates.length; ++i)
                    message.coordinates[i] = Number(object.coordinates[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceGeometry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceGeometry
         * @static
         * @param {pond.DeviceGeometry} message DeviceGeometry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceGeometry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coordinates = [];
            if (options.defaults)
                object.type = "";
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.coordinates && message.coordinates.length) {
                object.coordinates = [];
                for (var j = 0; j < message.coordinates.length; ++j)
                    object.coordinates[j] = options.json && !isFinite(message.coordinates[j]) ? String(message.coordinates[j]) : message.coordinates[j];
            }
            return object;
        };

        /**
         * Converts this DeviceGeometry to JSON.
         * @function toJSON
         * @memberof pond.DeviceGeometry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceGeometry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceGeometry;
    })();

    pond.DeviceProperties = (function() {

        /**
         * Properties of a DeviceProperties.
         * @memberof pond
         * @interface IDeviceProperties
         * @property {number|null} [deviceId] DeviceProperties deviceId
         * @property {string|null} [deviceName] DeviceProperties deviceName
         * @property {string|null} [lastSynced] DeviceProperties lastSynced
         * @property {string|null} [lastActive] DeviceProperties lastActive
         * @property {string|null} [firmwareVersion] DeviceProperties firmwareVersion
         * @property {string|null} [lastChanged] DeviceProperties lastChanged
         */

        /**
         * Constructs a new DeviceProperties.
         * @memberof pond
         * @classdesc Represents a DeviceProperties.
         * @implements IDeviceProperties
         * @constructor
         * @param {pond.IDeviceProperties=} [properties] Properties to set
         */
        function DeviceProperties(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceProperties deviceId.
         * @member {number} deviceId
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceProperties deviceName.
         * @member {string} deviceName
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.deviceName = "";

        /**
         * DeviceProperties lastSynced.
         * @member {string} lastSynced
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.lastSynced = "";

        /**
         * DeviceProperties lastActive.
         * @member {string} lastActive
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.lastActive = "";

        /**
         * DeviceProperties firmwareVersion.
         * @member {string} firmwareVersion
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.firmwareVersion = "";

        /**
         * DeviceProperties lastChanged.
         * @member {string} lastChanged
         * @memberof pond.DeviceProperties
         * @instance
         */
        DeviceProperties.prototype.lastChanged = "";

        /**
         * Creates a new DeviceProperties instance using the specified properties.
         * @function create
         * @memberof pond.DeviceProperties
         * @static
         * @param {pond.IDeviceProperties=} [properties] Properties to set
         * @returns {pond.DeviceProperties} DeviceProperties instance
         */
        DeviceProperties.create = function create(properties) {
            return new DeviceProperties(properties);
        };

        /**
         * Creates a DeviceProperties message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceProperties
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceProperties} DeviceProperties
         */
        DeviceProperties.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceProperties)
                return object;
            var message = new $root.pond.DeviceProperties();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            if (object.lastSynced != null)
                message.lastSynced = String(object.lastSynced);
            if (object.lastActive != null)
                message.lastActive = String(object.lastActive);
            if (object.firmwareVersion != null)
                message.firmwareVersion = String(object.firmwareVersion);
            if (object.lastChanged != null)
                message.lastChanged = String(object.lastChanged);
            return message;
        };

        /**
         * Creates a plain object from a DeviceProperties message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceProperties
         * @static
         * @param {pond.DeviceProperties} message DeviceProperties
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceProperties.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.deviceName = "";
                object.lastSynced = "";
                object.lastActive = "";
                object.firmwareVersion = "";
                object.lastChanged = "";
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            if (message.lastSynced != null && message.hasOwnProperty("lastSynced"))
                object.lastSynced = message.lastSynced;
            if (message.lastActive != null && message.hasOwnProperty("lastActive"))
                object.lastActive = message.lastActive;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            if (message.lastChanged != null && message.hasOwnProperty("lastChanged"))
                object.lastChanged = message.lastChanged;
            return object;
        };

        /**
         * Converts this DeviceProperties to JSON.
         * @function toJSON
         * @memberof pond.DeviceProperties
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceProperties.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceProperties;
    })();

    pond.DeviceGeoJSON = (function() {

        /**
         * Properties of a DeviceGeoJSON.
         * @memberof pond
         * @interface IDeviceGeoJSON
         * @property {string|null} [type] DeviceGeoJSON type
         * @property {pond.DeviceGeometry|null} [geometry] DeviceGeoJSON geometry
         * @property {pond.DeviceProperties|null} [properties] DeviceGeoJSON properties
         */

        /**
         * Constructs a new DeviceGeoJSON.
         * @memberof pond
         * @classdesc Represents a DeviceGeoJSON.
         * @implements IDeviceGeoJSON
         * @constructor
         * @param {pond.IDeviceGeoJSON=} [properties] Properties to set
         */
        function DeviceGeoJSON(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceGeoJSON type.
         * @member {string} type
         * @memberof pond.DeviceGeoJSON
         * @instance
         */
        DeviceGeoJSON.prototype.type = "";

        /**
         * DeviceGeoJSON geometry.
         * @member {pond.DeviceGeometry|null|undefined} geometry
         * @memberof pond.DeviceGeoJSON
         * @instance
         */
        DeviceGeoJSON.prototype.geometry = null;

        /**
         * DeviceGeoJSON properties.
         * @member {pond.DeviceProperties|null|undefined} properties
         * @memberof pond.DeviceGeoJSON
         * @instance
         */
        DeviceGeoJSON.prototype.properties = null;

        /**
         * Creates a new DeviceGeoJSON instance using the specified properties.
         * @function create
         * @memberof pond.DeviceGeoJSON
         * @static
         * @param {pond.IDeviceGeoJSON=} [properties] Properties to set
         * @returns {pond.DeviceGeoJSON} DeviceGeoJSON instance
         */
        DeviceGeoJSON.create = function create(properties) {
            return new DeviceGeoJSON(properties);
        };

        /**
         * Creates a DeviceGeoJSON message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceGeoJSON
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceGeoJSON} DeviceGeoJSON
         */
        DeviceGeoJSON.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceGeoJSON)
                return object;
            var message = new $root.pond.DeviceGeoJSON();
            if (object.type != null)
                message.type = String(object.type);
            if (object.geometry != null) {
                if (typeof object.geometry !== "object")
                    throw TypeError(".pond.DeviceGeoJSON.geometry: object expected");
                message.geometry = $root.pond.DeviceGeometry.fromObject(object.geometry);
            }
            if (object.properties != null) {
                if (typeof object.properties !== "object")
                    throw TypeError(".pond.DeviceGeoJSON.properties: object expected");
                message.properties = $root.pond.DeviceProperties.fromObject(object.properties);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceGeoJSON message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceGeoJSON
         * @static
         * @param {pond.DeviceGeoJSON} message DeviceGeoJSON
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceGeoJSON.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = "";
                object.geometry = null;
                object.properties = null;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.geometry != null && message.hasOwnProperty("geometry"))
                object.geometry = $root.pond.DeviceGeometry.toObject(message.geometry, options);
            if (message.properties != null && message.hasOwnProperty("properties"))
                object.properties = $root.pond.DeviceProperties.toObject(message.properties, options);
            return object;
        };

        /**
         * Converts this DeviceGeoJSON to JSON.
         * @function toJSON
         * @memberof pond.DeviceGeoJSON
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceGeoJSON.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceGeoJSON;
    })();

    pond.Device = (function() {

        /**
         * Properties of a Device.
         * @memberof pond
         * @interface IDevice
         * @property {pond.DeviceSettings|null} [settings] Device settings
         * @property {pond.DeviceStatus|null} [status] Device status
         */

        /**
         * Constructs a new Device.
         * @memberof pond
         * @classdesc Represents a Device.
         * @implements IDevice
         * @constructor
         * @param {pond.IDevice=} [properties] Properties to set
         */
        function Device(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Device settings.
         * @member {pond.DeviceSettings|null|undefined} settings
         * @memberof pond.Device
         * @instance
         */
        Device.prototype.settings = null;

        /**
         * Device status.
         * @member {pond.DeviceStatus|null|undefined} status
         * @memberof pond.Device
         * @instance
         */
        Device.prototype.status = null;

        /**
         * Creates a new Device instance using the specified properties.
         * @function create
         * @memberof pond.Device
         * @static
         * @param {pond.IDevice=} [properties] Properties to set
         * @returns {pond.Device} Device instance
         */
        Device.create = function create(properties) {
            return new Device(properties);
        };

        /**
         * Creates a Device message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Device
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Device} Device
         */
        Device.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Device)
                return object;
            var message = new $root.pond.Device();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Device.settings: object expected");
                message.settings = $root.pond.DeviceSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Device.status: object expected");
                message.status = $root.pond.DeviceStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Device message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Device
         * @static
         * @param {pond.Device} message Device
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Device.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.DeviceSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.DeviceStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Device to JSON.
         * @function toJSON
         * @memberof pond.Device
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Device.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Device;
    })();

    pond.GetMultiDeviceRequest = (function() {

        /**
         * Properties of a GetMultiDeviceRequest.
         * @memberof pond
         * @interface IGetMultiDeviceRequest
         * @property {Array.<number>|null} [devices] GetMultiDeviceRequest devices
         * @property {pond.Paging|null} [paging] GetMultiDeviceRequest paging
         * @property {pond.Sorting|null} [sorting] GetMultiDeviceRequest sorting
         * @property {string|null} [search] GetMultiDeviceRequest search
         * @property {boolean|null} [comprehensive] GetMultiDeviceRequest comprehensive
         */

        /**
         * Constructs a new GetMultiDeviceRequest.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceRequest.
         * @implements IGetMultiDeviceRequest
         * @constructor
         * @param {pond.IGetMultiDeviceRequest=} [properties] Properties to set
         */
        function GetMultiDeviceRequest(properties) {
            this.devices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceRequest devices.
         * @member {Array.<number>} devices
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         */
        GetMultiDeviceRequest.prototype.devices = $util.emptyArray;

        /**
         * GetMultiDeviceRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         */
        GetMultiDeviceRequest.prototype.paging = null;

        /**
         * GetMultiDeviceRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         */
        GetMultiDeviceRequest.prototype.sorting = null;

        /**
         * GetMultiDeviceRequest search.
         * @member {string} search
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         */
        GetMultiDeviceRequest.prototype.search = "";

        /**
         * GetMultiDeviceRequest comprehensive.
         * @member {boolean} comprehensive
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         */
        GetMultiDeviceRequest.prototype.comprehensive = false;

        /**
         * Creates a new GetMultiDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceRequest
         * @static
         * @param {pond.IGetMultiDeviceRequest=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceRequest} GetMultiDeviceRequest instance
         */
        GetMultiDeviceRequest.create = function create(properties) {
            return new GetMultiDeviceRequest(properties);
        };

        /**
         * Creates a GetMultiDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceRequest} GetMultiDeviceRequest
         */
        GetMultiDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceRequest)
                return object;
            var message = new $root.pond.GetMultiDeviceRequest();
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GetMultiDeviceRequest.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i)
                    if ($util.Long)
                        (message.devices[i] = $util.Long.fromValue(object.devices[i])).unsigned = true;
                    else if (typeof object.devices[i] === "string")
                        message.devices[i] = parseInt(object.devices[i], 10);
                    else if (typeof object.devices[i] === "number")
                        message.devices[i] = object.devices[i];
                    else if (typeof object.devices[i] === "object")
                        message.devices[i] = new $util.LongBits(object.devices[i].low >>> 0, object.devices[i].high >>> 0).toNumber(true);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.GetMultiDeviceRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.GetMultiDeviceRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.comprehensive != null)
                message.comprehensive = Boolean(object.comprehensive);
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceRequest
         * @static
         * @param {pond.GetMultiDeviceRequest} message GetMultiDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.devices = [];
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.comprehensive = false;
            }
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    if (typeof message.devices[j] === "number")
                        object.devices[j] = options.longs === String ? String(message.devices[j]) : message.devices[j];
                    else
                        object.devices[j] = options.longs === String ? $util.Long.prototype.toString.call(message.devices[j]) : options.longs === Number ? new $util.LongBits(message.devices[j].low >>> 0, message.devices[j].high >>> 0).toNumber(true) : message.devices[j];
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.comprehensive != null && message.hasOwnProperty("comprehensive"))
                object.comprehensive = message.comprehensive;
            return object;
        };

        /**
         * Converts this GetMultiDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceRequest;
    })();

    pond.GetMultiDeviceResponse = (function() {

        /**
         * Properties of a GetMultiDeviceResponse.
         * @memberof pond
         * @interface IGetMultiDeviceResponse
         * @property {Array.<pond.Device>|null} [devices] GetMultiDeviceResponse devices
         * @property {number|null} [nextOffset] GetMultiDeviceResponse nextOffset
         * @property {number|null} [total] GetMultiDeviceResponse total
         * @property {Array.<pond.ComprehensiveDevice>|null} [comprehensiveDevices] GetMultiDeviceResponse comprehensiveDevices
         */

        /**
         * Constructs a new GetMultiDeviceResponse.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceResponse.
         * @implements IGetMultiDeviceResponse
         * @constructor
         * @param {pond.IGetMultiDeviceResponse=} [properties] Properties to set
         */
        function GetMultiDeviceResponse(properties) {
            this.devices = [];
            this.comprehensiveDevices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceResponse devices.
         * @member {Array.<pond.Device>} devices
         * @memberof pond.GetMultiDeviceResponse
         * @instance
         */
        GetMultiDeviceResponse.prototype.devices = $util.emptyArray;

        /**
         * GetMultiDeviceResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.GetMultiDeviceResponse
         * @instance
         */
        GetMultiDeviceResponse.prototype.nextOffset = 0;

        /**
         * GetMultiDeviceResponse total.
         * @member {number} total
         * @memberof pond.GetMultiDeviceResponse
         * @instance
         */
        GetMultiDeviceResponse.prototype.total = 0;

        /**
         * GetMultiDeviceResponse comprehensiveDevices.
         * @member {Array.<pond.ComprehensiveDevice>} comprehensiveDevices
         * @memberof pond.GetMultiDeviceResponse
         * @instance
         */
        GetMultiDeviceResponse.prototype.comprehensiveDevices = $util.emptyArray;

        /**
         * Creates a new GetMultiDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceResponse
         * @static
         * @param {pond.IGetMultiDeviceResponse=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceResponse} GetMultiDeviceResponse instance
         */
        GetMultiDeviceResponse.create = function create(properties) {
            return new GetMultiDeviceResponse(properties);
        };

        /**
         * Creates a GetMultiDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceResponse} GetMultiDeviceResponse
         */
        GetMultiDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceResponse)
                return object;
            var message = new $root.pond.GetMultiDeviceResponse();
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GetMultiDeviceResponse.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i) {
                    if (typeof object.devices[i] !== "object")
                        throw TypeError(".pond.GetMultiDeviceResponse.devices: object expected");
                    message.devices[i] = $root.pond.Device.fromObject(object.devices[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            if (object.comprehensiveDevices) {
                if (!Array.isArray(object.comprehensiveDevices))
                    throw TypeError(".pond.GetMultiDeviceResponse.comprehensiveDevices: array expected");
                message.comprehensiveDevices = [];
                for (var i = 0; i < object.comprehensiveDevices.length; ++i) {
                    if (typeof object.comprehensiveDevices[i] !== "object")
                        throw TypeError(".pond.GetMultiDeviceResponse.comprehensiveDevices: object expected");
                    message.comprehensiveDevices[i] = $root.pond.ComprehensiveDevice.fromObject(object.comprehensiveDevices[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceResponse
         * @static
         * @param {pond.GetMultiDeviceResponse} message GetMultiDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.devices = [];
                object.comprehensiveDevices = [];
            }
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    object.devices[j] = $root.pond.Device.toObject(message.devices[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.comprehensiveDevices && message.comprehensiveDevices.length) {
                object.comprehensiveDevices = [];
                for (var j = 0; j < message.comprehensiveDevices.length; ++j)
                    object.comprehensiveDevices[j] = $root.pond.ComprehensiveDevice.toObject(message.comprehensiveDevices[j], options);
            }
            return object;
        };

        /**
         * Converts this GetMultiDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceResponse;
    })();

    pond.ListDevicesRequest = (function() {

        /**
         * Properties of a ListDevicesRequest.
         * @memberof pond
         * @interface IListDevicesRequest
         * @property {pond.Paging|null} [paging] ListDevicesRequest paging
         * @property {pond.Sorting|null} [sorting] ListDevicesRequest sorting
         * @property {string|null} [search] ListDevicesRequest search
         * @property {pond.DeviceSettings|null} [settingsMatch] ListDevicesRequest settingsMatch
         * @property {pond.DeviceStatus|null} [statusMatch] ListDevicesRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListDevicesRequest fieldContains
         * @property {boolean|null} [asRoot] ListDevicesRequest asRoot
         * @property {boolean|null} [comprehensive] ListDevicesRequest comprehensive
         * @property {boolean|null} [withMeasurements] ListDevicesRequest withMeasurements
         * @property {boolean|null} [hologram] ListDevicesRequest hologram
         * @property {string|null} [prefixSearch] ListDevicesRequest prefixSearch
         */

        /**
         * Constructs a new ListDevicesRequest.
         * @memberof pond
         * @classdesc Represents a ListDevicesRequest.
         * @implements IListDevicesRequest
         * @constructor
         * @param {pond.IListDevicesRequest=} [properties] Properties to set
         */
        function ListDevicesRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDevicesRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.paging = null;

        /**
         * ListDevicesRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.sorting = null;

        /**
         * ListDevicesRequest search.
         * @member {string} search
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.search = "";

        /**
         * ListDevicesRequest settingsMatch.
         * @member {pond.DeviceSettings|null|undefined} settingsMatch
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.settingsMatch = null;

        /**
         * ListDevicesRequest statusMatch.
         * @member {pond.DeviceStatus|null|undefined} statusMatch
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.statusMatch = null;

        /**
         * ListDevicesRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListDevicesRequest asRoot.
         * @member {boolean} asRoot
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.asRoot = false;

        /**
         * ListDevicesRequest comprehensive.
         * @member {boolean} comprehensive
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.comprehensive = false;

        /**
         * ListDevicesRequest withMeasurements.
         * @member {boolean} withMeasurements
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.withMeasurements = false;

        /**
         * ListDevicesRequest hologram.
         * @member {boolean} hologram
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.hologram = false;

        /**
         * ListDevicesRequest prefixSearch.
         * @member {string} prefixSearch
         * @memberof pond.ListDevicesRequest
         * @instance
         */
        ListDevicesRequest.prototype.prefixSearch = "";

        /**
         * Creates a new ListDevicesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDevicesRequest
         * @static
         * @param {pond.IListDevicesRequest=} [properties] Properties to set
         * @returns {pond.ListDevicesRequest} ListDevicesRequest instance
         */
        ListDevicesRequest.create = function create(properties) {
            return new ListDevicesRequest(properties);
        };

        /**
         * Creates a ListDevicesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDevicesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDevicesRequest} ListDevicesRequest
         */
        ListDevicesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDevicesRequest)
                return object;
            var message = new $root.pond.ListDevicesRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListDevicesRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListDevicesRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListDevicesRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.DeviceSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListDevicesRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.DeviceStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListDevicesRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.asRoot != null)
                message.asRoot = Boolean(object.asRoot);
            if (object.comprehensive != null)
                message.comprehensive = Boolean(object.comprehensive);
            if (object.withMeasurements != null)
                message.withMeasurements = Boolean(object.withMeasurements);
            if (object.hologram != null)
                message.hologram = Boolean(object.hologram);
            if (object.prefixSearch != null)
                message.prefixSearch = String(object.prefixSearch);
            return message;
        };

        /**
         * Creates a plain object from a ListDevicesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDevicesRequest
         * @static
         * @param {pond.ListDevicesRequest} message ListDevicesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDevicesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
                object.asRoot = false;
                object.comprehensive = false;
                object.withMeasurements = false;
                object.hologram = false;
                object.prefixSearch = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.DeviceSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.DeviceStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.asRoot != null && message.hasOwnProperty("asRoot"))
                object.asRoot = message.asRoot;
            if (message.comprehensive != null && message.hasOwnProperty("comprehensive"))
                object.comprehensive = message.comprehensive;
            if (message.withMeasurements != null && message.hasOwnProperty("withMeasurements"))
                object.withMeasurements = message.withMeasurements;
            if (message.hologram != null && message.hasOwnProperty("hologram"))
                object.hologram = message.hologram;
            if (message.prefixSearch != null && message.hasOwnProperty("prefixSearch"))
                object.prefixSearch = message.prefixSearch;
            return object;
        };

        /**
         * Converts this ListDevicesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDevicesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDevicesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDevicesRequest;
    })();

    pond.ListDevicesResponse = (function() {

        /**
         * Properties of a ListDevicesResponse.
         * @memberof pond
         * @interface IListDevicesResponse
         * @property {Array.<pond.Device>|null} [devices] ListDevicesResponse devices
         * @property {number|null} [nextOffset] ListDevicesResponse nextOffset
         * @property {number|null} [total] ListDevicesResponse total
         * @property {Array.<pond.ComprehensiveDevice>|null} [comprehensiveDevices] ListDevicesResponse comprehensiveDevices
         * @property {Array.<pond.HologramDevice>|null} [hologramDevices] ListDevicesResponse hologramDevices
         */

        /**
         * Constructs a new ListDevicesResponse.
         * @memberof pond
         * @classdesc Represents a ListDevicesResponse.
         * @implements IListDevicesResponse
         * @constructor
         * @param {pond.IListDevicesResponse=} [properties] Properties to set
         */
        function ListDevicesResponse(properties) {
            this.devices = [];
            this.comprehensiveDevices = [];
            this.hologramDevices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDevicesResponse devices.
         * @member {Array.<pond.Device>} devices
         * @memberof pond.ListDevicesResponse
         * @instance
         */
        ListDevicesResponse.prototype.devices = $util.emptyArray;

        /**
         * ListDevicesResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListDevicesResponse
         * @instance
         */
        ListDevicesResponse.prototype.nextOffset = 0;

        /**
         * ListDevicesResponse total.
         * @member {number} total
         * @memberof pond.ListDevicesResponse
         * @instance
         */
        ListDevicesResponse.prototype.total = 0;

        /**
         * ListDevicesResponse comprehensiveDevices.
         * @member {Array.<pond.ComprehensiveDevice>} comprehensiveDevices
         * @memberof pond.ListDevicesResponse
         * @instance
         */
        ListDevicesResponse.prototype.comprehensiveDevices = $util.emptyArray;

        /**
         * ListDevicesResponse hologramDevices.
         * @member {Array.<pond.HologramDevice>} hologramDevices
         * @memberof pond.ListDevicesResponse
         * @instance
         */
        ListDevicesResponse.prototype.hologramDevices = $util.emptyArray;

        /**
         * Creates a new ListDevicesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDevicesResponse
         * @static
         * @param {pond.IListDevicesResponse=} [properties] Properties to set
         * @returns {pond.ListDevicesResponse} ListDevicesResponse instance
         */
        ListDevicesResponse.create = function create(properties) {
            return new ListDevicesResponse(properties);
        };

        /**
         * Creates a ListDevicesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDevicesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDevicesResponse} ListDevicesResponse
         */
        ListDevicesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDevicesResponse)
                return object;
            var message = new $root.pond.ListDevicesResponse();
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.ListDevicesResponse.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i) {
                    if (typeof object.devices[i] !== "object")
                        throw TypeError(".pond.ListDevicesResponse.devices: object expected");
                    message.devices[i] = $root.pond.Device.fromObject(object.devices[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            if (object.comprehensiveDevices) {
                if (!Array.isArray(object.comprehensiveDevices))
                    throw TypeError(".pond.ListDevicesResponse.comprehensiveDevices: array expected");
                message.comprehensiveDevices = [];
                for (var i = 0; i < object.comprehensiveDevices.length; ++i) {
                    if (typeof object.comprehensiveDevices[i] !== "object")
                        throw TypeError(".pond.ListDevicesResponse.comprehensiveDevices: object expected");
                    message.comprehensiveDevices[i] = $root.pond.ComprehensiveDevice.fromObject(object.comprehensiveDevices[i]);
                }
            }
            if (object.hologramDevices) {
                if (!Array.isArray(object.hologramDevices))
                    throw TypeError(".pond.ListDevicesResponse.hologramDevices: array expected");
                message.hologramDevices = [];
                for (var i = 0; i < object.hologramDevices.length; ++i) {
                    if (typeof object.hologramDevices[i] !== "object")
                        throw TypeError(".pond.ListDevicesResponse.hologramDevices: object expected");
                    message.hologramDevices[i] = $root.pond.HologramDevice.fromObject(object.hologramDevices[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDevicesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDevicesResponse
         * @static
         * @param {pond.ListDevicesResponse} message ListDevicesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDevicesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.devices = [];
                object.comprehensiveDevices = [];
                object.hologramDevices = [];
            }
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    object.devices[j] = $root.pond.Device.toObject(message.devices[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.comprehensiveDevices && message.comprehensiveDevices.length) {
                object.comprehensiveDevices = [];
                for (var j = 0; j < message.comprehensiveDevices.length; ++j)
                    object.comprehensiveDevices[j] = $root.pond.ComprehensiveDevice.toObject(message.comprehensiveDevices[j], options);
            }
            if (message.hologramDevices && message.hologramDevices.length) {
                object.hologramDevices = [];
                for (var j = 0; j < message.hologramDevices.length; ++j)
                    object.hologramDevices[j] = $root.pond.HologramDevice.toObject(message.hologramDevices[j], options);
            }
            return object;
        };

        /**
         * Converts this ListDevicesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDevicesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDevicesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDevicesResponse;
    })();

    pond.ComprehensiveDevice = (function() {

        /**
         * Properties of a ComprehensiveDevice.
         * @memberof pond
         * @interface IComprehensiveDevice
         * @property {pond.Device|null} [device] ComprehensiveDevice device
         * @property {Array.<pond.Component>|null} [components] ComprehensiveDevice components
         * @property {Array.<pond.Interaction>|null} [interactions] ComprehensiveDevice interactions
         * @property {pond.User|null} [user] ComprehensiveDevice user
         */

        /**
         * Constructs a new ComprehensiveDevice.
         * @memberof pond
         * @classdesc Represents a ComprehensiveDevice.
         * @implements IComprehensiveDevice
         * @constructor
         * @param {pond.IComprehensiveDevice=} [properties] Properties to set
         */
        function ComprehensiveDevice(properties) {
            this.components = [];
            this.interactions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComprehensiveDevice device.
         * @member {pond.Device|null|undefined} device
         * @memberof pond.ComprehensiveDevice
         * @instance
         */
        ComprehensiveDevice.prototype.device = null;

        /**
         * ComprehensiveDevice components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.ComprehensiveDevice
         * @instance
         */
        ComprehensiveDevice.prototype.components = $util.emptyArray;

        /**
         * ComprehensiveDevice interactions.
         * @member {Array.<pond.Interaction>} interactions
         * @memberof pond.ComprehensiveDevice
         * @instance
         */
        ComprehensiveDevice.prototype.interactions = $util.emptyArray;

        /**
         * ComprehensiveDevice user.
         * @member {pond.User|null|undefined} user
         * @memberof pond.ComprehensiveDevice
         * @instance
         */
        ComprehensiveDevice.prototype.user = null;

        /**
         * Creates a new ComprehensiveDevice instance using the specified properties.
         * @function create
         * @memberof pond.ComprehensiveDevice
         * @static
         * @param {pond.IComprehensiveDevice=} [properties] Properties to set
         * @returns {pond.ComprehensiveDevice} ComprehensiveDevice instance
         */
        ComprehensiveDevice.create = function create(properties) {
            return new ComprehensiveDevice(properties);
        };

        /**
         * Creates a ComprehensiveDevice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComprehensiveDevice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComprehensiveDevice} ComprehensiveDevice
         */
        ComprehensiveDevice.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComprehensiveDevice)
                return object;
            var message = new $root.pond.ComprehensiveDevice();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.ComprehensiveDevice.device: object expected");
                message.device = $root.pond.Device.fromObject(object.device);
            }
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.ComprehensiveDevice.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.ComprehensiveDevice.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.ComprehensiveDevice.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.ComprehensiveDevice.interactions: object expected");
                    message.interactions[i] = $root.pond.Interaction.fromObject(object.interactions[i]);
                }
            }
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".pond.ComprehensiveDevice.user: object expected");
                message.user = $root.pond.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from a ComprehensiveDevice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComprehensiveDevice
         * @static
         * @param {pond.ComprehensiveDevice} message ComprehensiveDevice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComprehensiveDevice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.components = [];
                object.interactions = [];
            }
            if (options.defaults) {
                object.device = null;
                object.user = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.Device.toObject(message.device, options);
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.Interaction.toObject(message.interactions[j], options);
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.pond.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this ComprehensiveDevice to JSON.
         * @function toJSON
         * @memberof pond.ComprehensiveDevice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComprehensiveDevice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComprehensiveDevice;
    })();

    pond.HologramDevice = (function() {

        /**
         * Properties of a HologramDevice.
         * @memberof pond
         * @interface IHologramDevice
         * @property {pond.Device|null} [device] HologramDevice device
         * @property {pond.DeviceActivity|null} [paused] HologramDevice paused
         * @property {number|null} [dataLimit] HologramDevice dataLimit
         * @property {number|null} [periodUsage] HologramDevice periodUsage
         * @property {pond.LimitStatus|null} [overLimit] HologramDevice overLimit
         */

        /**
         * Constructs a new HologramDevice.
         * @memberof pond
         * @classdesc Represents a HologramDevice.
         * @implements IHologramDevice
         * @constructor
         * @param {pond.IHologramDevice=} [properties] Properties to set
         */
        function HologramDevice(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HologramDevice device.
         * @member {pond.Device|null|undefined} device
         * @memberof pond.HologramDevice
         * @instance
         */
        HologramDevice.prototype.device = null;

        /**
         * HologramDevice paused.
         * @member {pond.DeviceActivity} paused
         * @memberof pond.HologramDevice
         * @instance
         */
        HologramDevice.prototype.paused = 0;

        /**
         * HologramDevice dataLimit.
         * @member {number} dataLimit
         * @memberof pond.HologramDevice
         * @instance
         */
        HologramDevice.prototype.dataLimit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * HologramDevice periodUsage.
         * @member {number} periodUsage
         * @memberof pond.HologramDevice
         * @instance
         */
        HologramDevice.prototype.periodUsage = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HologramDevice overLimit.
         * @member {pond.LimitStatus} overLimit
         * @memberof pond.HologramDevice
         * @instance
         */
        HologramDevice.prototype.overLimit = 0;

        /**
         * Creates a new HologramDevice instance using the specified properties.
         * @function create
         * @memberof pond.HologramDevice
         * @static
         * @param {pond.IHologramDevice=} [properties] Properties to set
         * @returns {pond.HologramDevice} HologramDevice instance
         */
        HologramDevice.create = function create(properties) {
            return new HologramDevice(properties);
        };

        /**
         * Creates a HologramDevice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HologramDevice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HologramDevice} HologramDevice
         */
        HologramDevice.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HologramDevice)
                return object;
            var message = new $root.pond.HologramDevice();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.HologramDevice.device: object expected");
                message.device = $root.pond.Device.fromObject(object.device);
            }
            switch (object.paused) {
            case "DEVICE_ACTIVITY_NONE":
            case 0:
                message.paused = 0;
                break;
            case "DEVICE_ACTIVITY_PAUSED":
            case 1:
                message.paused = 1;
                break;
            case "DEVICE_ACTIVITY_RUNNING":
            case 2:
                message.paused = 2;
                break;
            }
            if (object.dataLimit != null)
                if ($util.Long)
                    (message.dataLimit = $util.Long.fromValue(object.dataLimit)).unsigned = false;
                else if (typeof object.dataLimit === "string")
                    message.dataLimit = parseInt(object.dataLimit, 10);
                else if (typeof object.dataLimit === "number")
                    message.dataLimit = object.dataLimit;
                else if (typeof object.dataLimit === "object")
                    message.dataLimit = new $util.LongBits(object.dataLimit.low >>> 0, object.dataLimit.high >>> 0).toNumber();
            if (object.periodUsage != null)
                if ($util.Long)
                    (message.periodUsage = $util.Long.fromValue(object.periodUsage)).unsigned = true;
                else if (typeof object.periodUsage === "string")
                    message.periodUsage = parseInt(object.periodUsage, 10);
                else if (typeof object.periodUsage === "number")
                    message.periodUsage = object.periodUsage;
                else if (typeof object.periodUsage === "object")
                    message.periodUsage = new $util.LongBits(object.periodUsage.low >>> 0, object.periodUsage.high >>> 0).toNumber(true);
            switch (object.overLimit) {
            case "LIMIT_STATUS_NONE":
            case 0:
                message.overLimit = 0;
                break;
            case "LIMIT_STATUS_UNDER":
            case 1:
                message.overLimit = 1;
                break;
            case "LIMIT_STATUS_OVER":
            case 2:
                message.overLimit = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a HologramDevice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HologramDevice
         * @static
         * @param {pond.HologramDevice} message HologramDevice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HologramDevice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.device = null;
                object.paused = options.enums === String ? "DEVICE_ACTIVITY_NONE" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.dataLimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.dataLimit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.periodUsage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.periodUsage = options.longs === String ? "0" : 0;
                object.overLimit = options.enums === String ? "LIMIT_STATUS_NONE" : 0;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.Device.toObject(message.device, options);
            if (message.paused != null && message.hasOwnProperty("paused"))
                object.paused = options.enums === String ? $root.pond.DeviceActivity[message.paused] : message.paused;
            if (message.dataLimit != null && message.hasOwnProperty("dataLimit"))
                if (typeof message.dataLimit === "number")
                    object.dataLimit = options.longs === String ? String(message.dataLimit) : message.dataLimit;
                else
                    object.dataLimit = options.longs === String ? $util.Long.prototype.toString.call(message.dataLimit) : options.longs === Number ? new $util.LongBits(message.dataLimit.low >>> 0, message.dataLimit.high >>> 0).toNumber() : message.dataLimit;
            if (message.periodUsage != null && message.hasOwnProperty("periodUsage"))
                if (typeof message.periodUsage === "number")
                    object.periodUsage = options.longs === String ? String(message.periodUsage) : message.periodUsage;
                else
                    object.periodUsage = options.longs === String ? $util.Long.prototype.toString.call(message.periodUsage) : options.longs === Number ? new $util.LongBits(message.periodUsage.low >>> 0, message.periodUsage.high >>> 0).toNumber(true) : message.periodUsage;
            if (message.overLimit != null && message.hasOwnProperty("overLimit"))
                object.overLimit = options.enums === String ? $root.pond.LimitStatus[message.overLimit] : message.overLimit;
            return object;
        };

        /**
         * Converts this HologramDevice to JSON.
         * @function toJSON
         * @memberof pond.HologramDevice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HologramDevice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HologramDevice;
    })();

    /**
     * DeviceActivity enum.
     * @name pond.DeviceActivity
     * @enum {string}
     * @property {number} DEVICE_ACTIVITY_NONE=0 DEVICE_ACTIVITY_NONE value
     * @property {number} DEVICE_ACTIVITY_PAUSED=1 DEVICE_ACTIVITY_PAUSED value
     * @property {number} DEVICE_ACTIVITY_RUNNING=2 DEVICE_ACTIVITY_RUNNING value
     */
    pond.DeviceActivity = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEVICE_ACTIVITY_NONE"] = 0;
        values[valuesById[1] = "DEVICE_ACTIVITY_PAUSED"] = 1;
        values[valuesById[2] = "DEVICE_ACTIVITY_RUNNING"] = 2;
        return values;
    })();

    /**
     * LimitStatus enum.
     * @name pond.LimitStatus
     * @enum {string}
     * @property {number} LIMIT_STATUS_NONE=0 LIMIT_STATUS_NONE value
     * @property {number} LIMIT_STATUS_UNDER=1 LIMIT_STATUS_UNDER value
     * @property {number} LIMIT_STATUS_OVER=2 LIMIT_STATUS_OVER value
     */
    pond.LimitStatus = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LIMIT_STATUS_NONE"] = 0;
        values[valuesById[1] = "LIMIT_STATUS_UNDER"] = 1;
        values[valuesById[2] = "LIMIT_STATUS_OVER"] = 2;
        return values;
    })();

    pond.SyncDeviceRequest = (function() {

        /**
         * Properties of a SyncDeviceRequest.
         * @memberof pond
         * @interface ISyncDeviceRequest
         * @property {number|null} [device] SyncDeviceRequest device
         */

        /**
         * Constructs a new SyncDeviceRequest.
         * @memberof pond
         * @classdesc Represents a SyncDeviceRequest.
         * @implements ISyncDeviceRequest
         * @constructor
         * @param {pond.ISyncDeviceRequest=} [properties] Properties to set
         */
        function SyncDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncDeviceRequest device.
         * @member {number} device
         * @memberof pond.SyncDeviceRequest
         * @instance
         */
        SyncDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SyncDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.SyncDeviceRequest
         * @static
         * @param {pond.ISyncDeviceRequest=} [properties] Properties to set
         * @returns {pond.SyncDeviceRequest} SyncDeviceRequest instance
         */
        SyncDeviceRequest.create = function create(properties) {
            return new SyncDeviceRequest(properties);
        };

        /**
         * Creates a SyncDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SyncDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SyncDeviceRequest} SyncDeviceRequest
         */
        SyncDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SyncDeviceRequest)
                return object;
            var message = new $root.pond.SyncDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a SyncDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SyncDeviceRequest
         * @static
         * @param {pond.SyncDeviceRequest} message SyncDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this SyncDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.SyncDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncDeviceRequest;
    })();

    pond.SyncDeviceResponse = (function() {

        /**
         * Properties of a SyncDeviceResponse.
         * @memberof pond
         * @interface ISyncDeviceResponse
         */

        /**
         * Constructs a new SyncDeviceResponse.
         * @memberof pond
         * @classdesc Represents a SyncDeviceResponse.
         * @implements ISyncDeviceResponse
         * @constructor
         * @param {pond.ISyncDeviceResponse=} [properties] Properties to set
         */
        function SyncDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.SyncDeviceResponse
         * @static
         * @param {pond.ISyncDeviceResponse=} [properties] Properties to set
         * @returns {pond.SyncDeviceResponse} SyncDeviceResponse instance
         */
        SyncDeviceResponse.create = function create(properties) {
            return new SyncDeviceResponse(properties);
        };

        /**
         * Creates a SyncDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SyncDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SyncDeviceResponse} SyncDeviceResponse
         */
        SyncDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SyncDeviceResponse)
                return object;
            return new $root.pond.SyncDeviceResponse();
        };

        /**
         * Creates a plain object from a SyncDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SyncDeviceResponse
         * @static
         * @param {pond.SyncDeviceResponse} message SyncDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.SyncDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncDeviceResponse;
    })();

    pond.PushDeviceRequest = (function() {

        /**
         * Properties of a PushDeviceRequest.
         * @memberof pond
         * @interface IPushDeviceRequest
         * @property {number|null} [device] PushDeviceRequest device
         */

        /**
         * Constructs a new PushDeviceRequest.
         * @memberof pond
         * @classdesc Represents a PushDeviceRequest.
         * @implements IPushDeviceRequest
         * @constructor
         * @param {pond.IPushDeviceRequest=} [properties] Properties to set
         */
        function PushDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PushDeviceRequest device.
         * @member {number} device
         * @memberof pond.PushDeviceRequest
         * @instance
         */
        PushDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PushDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.PushDeviceRequest
         * @static
         * @param {pond.IPushDeviceRequest=} [properties] Properties to set
         * @returns {pond.PushDeviceRequest} PushDeviceRequest instance
         */
        PushDeviceRequest.create = function create(properties) {
            return new PushDeviceRequest(properties);
        };

        /**
         * Creates a PushDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.PushDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.PushDeviceRequest} PushDeviceRequest
         */
        PushDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.PushDeviceRequest)
                return object;
            var message = new $root.pond.PushDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a PushDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.PushDeviceRequest
         * @static
         * @param {pond.PushDeviceRequest} message PushDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PushDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this PushDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.PushDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PushDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PushDeviceRequest;
    })();

    pond.PushDeviceResponse = (function() {

        /**
         * Properties of a PushDeviceResponse.
         * @memberof pond
         * @interface IPushDeviceResponse
         */

        /**
         * Constructs a new PushDeviceResponse.
         * @memberof pond
         * @classdesc Represents a PushDeviceResponse.
         * @implements IPushDeviceResponse
         * @constructor
         * @param {pond.IPushDeviceResponse=} [properties] Properties to set
         */
        function PushDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new PushDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.PushDeviceResponse
         * @static
         * @param {pond.IPushDeviceResponse=} [properties] Properties to set
         * @returns {pond.PushDeviceResponse} PushDeviceResponse instance
         */
        PushDeviceResponse.create = function create(properties) {
            return new PushDeviceResponse(properties);
        };

        /**
         * Creates a PushDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.PushDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.PushDeviceResponse} PushDeviceResponse
         */
        PushDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.PushDeviceResponse)
                return object;
            return new $root.pond.PushDeviceResponse();
        };

        /**
         * Creates a plain object from a PushDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.PushDeviceResponse
         * @static
         * @param {pond.PushDeviceResponse} message PushDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PushDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this PushDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.PushDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PushDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PushDeviceResponse;
    })();

    pond.DeviceSuccess = (function() {

        /**
         * Properties of a DeviceSuccess.
         * @memberof pond
         * @interface IDeviceSuccess
         * @property {number|null} [deviceId] DeviceSuccess deviceId
         * @property {boolean|null} [success] DeviceSuccess success
         */

        /**
         * Constructs a new DeviceSuccess.
         * @memberof pond
         * @classdesc Represents a DeviceSuccess.
         * @implements IDeviceSuccess
         * @constructor
         * @param {pond.IDeviceSuccess=} [properties] Properties to set
         */
        function DeviceSuccess(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceSuccess deviceId.
         * @member {number} deviceId
         * @memberof pond.DeviceSuccess
         * @instance
         */
        DeviceSuccess.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceSuccess success.
         * @member {boolean} success
         * @memberof pond.DeviceSuccess
         * @instance
         */
        DeviceSuccess.prototype.success = false;

        /**
         * Creates a new DeviceSuccess instance using the specified properties.
         * @function create
         * @memberof pond.DeviceSuccess
         * @static
         * @param {pond.IDeviceSuccess=} [properties] Properties to set
         * @returns {pond.DeviceSuccess} DeviceSuccess instance
         */
        DeviceSuccess.create = function create(properties) {
            return new DeviceSuccess(properties);
        };

        /**
         * Creates a DeviceSuccess message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceSuccess
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceSuccess} DeviceSuccess
         */
        DeviceSuccess.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceSuccess)
                return object;
            var message = new $root.pond.DeviceSuccess();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from a DeviceSuccess message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceSuccess
         * @static
         * @param {pond.DeviceSuccess} message DeviceSuccess
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceSuccess.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.success = false;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this DeviceSuccess to JSON.
         * @function toJSON
         * @memberof pond.DeviceSuccess
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceSuccess.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceSuccess;
    })();

    pond.BulkPauseDeviceRequest = (function() {

        /**
         * Properties of a BulkPauseDeviceRequest.
         * @memberof pond
         * @interface IBulkPauseDeviceRequest
         * @property {Array.<number>|null} [ids] BulkPauseDeviceRequest ids
         * @property {boolean|null} [setPaused] BulkPauseDeviceRequest setPaused
         */

        /**
         * Constructs a new BulkPauseDeviceRequest.
         * @memberof pond
         * @classdesc Represents a BulkPauseDeviceRequest.
         * @implements IBulkPauseDeviceRequest
         * @constructor
         * @param {pond.IBulkPauseDeviceRequest=} [properties] Properties to set
         */
        function BulkPauseDeviceRequest(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkPauseDeviceRequest ids.
         * @member {Array.<number>} ids
         * @memberof pond.BulkPauseDeviceRequest
         * @instance
         */
        BulkPauseDeviceRequest.prototype.ids = $util.emptyArray;

        /**
         * BulkPauseDeviceRequest setPaused.
         * @member {boolean} setPaused
         * @memberof pond.BulkPauseDeviceRequest
         * @instance
         */
        BulkPauseDeviceRequest.prototype.setPaused = false;

        /**
         * Creates a new BulkPauseDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.BulkPauseDeviceRequest
         * @static
         * @param {pond.IBulkPauseDeviceRequest=} [properties] Properties to set
         * @returns {pond.BulkPauseDeviceRequest} BulkPauseDeviceRequest instance
         */
        BulkPauseDeviceRequest.create = function create(properties) {
            return new BulkPauseDeviceRequest(properties);
        };

        /**
         * Creates a BulkPauseDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkPauseDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkPauseDeviceRequest} BulkPauseDeviceRequest
         */
        BulkPauseDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkPauseDeviceRequest)
                return object;
            var message = new $root.pond.BulkPauseDeviceRequest();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".pond.BulkPauseDeviceRequest.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    if ($util.Long)
                        (message.ids[i] = $util.Long.fromValue(object.ids[i])).unsigned = true;
                    else if (typeof object.ids[i] === "string")
                        message.ids[i] = parseInt(object.ids[i], 10);
                    else if (typeof object.ids[i] === "number")
                        message.ids[i] = object.ids[i];
                    else if (typeof object.ids[i] === "object")
                        message.ids[i] = new $util.LongBits(object.ids[i].low >>> 0, object.ids[i].high >>> 0).toNumber(true);
            }
            if (object.setPaused != null)
                message.setPaused = Boolean(object.setPaused);
            return message;
        };

        /**
         * Creates a plain object from a BulkPauseDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkPauseDeviceRequest
         * @static
         * @param {pond.BulkPauseDeviceRequest} message BulkPauseDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkPauseDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (options.defaults)
                object.setPaused = false;
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    if (typeof message.ids[j] === "number")
                        object.ids[j] = options.longs === String ? String(message.ids[j]) : message.ids[j];
                    else
                        object.ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ids[j]) : options.longs === Number ? new $util.LongBits(message.ids[j].low >>> 0, message.ids[j].high >>> 0).toNumber(true) : message.ids[j];
            }
            if (message.setPaused != null && message.hasOwnProperty("setPaused"))
                object.setPaused = message.setPaused;
            return object;
        };

        /**
         * Converts this BulkPauseDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.BulkPauseDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkPauseDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkPauseDeviceRequest;
    })();

    pond.BulkPauseDeviceResponse = (function() {

        /**
         * Properties of a BulkPauseDeviceResponse.
         * @memberof pond
         * @interface IBulkPauseDeviceResponse
         * @property {Array.<pond.DeviceSuccess>|null} [devicesPaused] BulkPauseDeviceResponse devicesPaused
         */

        /**
         * Constructs a new BulkPauseDeviceResponse.
         * @memberof pond
         * @classdesc Represents a BulkPauseDeviceResponse.
         * @implements IBulkPauseDeviceResponse
         * @constructor
         * @param {pond.IBulkPauseDeviceResponse=} [properties] Properties to set
         */
        function BulkPauseDeviceResponse(properties) {
            this.devicesPaused = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkPauseDeviceResponse devicesPaused.
         * @member {Array.<pond.DeviceSuccess>} devicesPaused
         * @memberof pond.BulkPauseDeviceResponse
         * @instance
         */
        BulkPauseDeviceResponse.prototype.devicesPaused = $util.emptyArray;

        /**
         * Creates a new BulkPauseDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.BulkPauseDeviceResponse
         * @static
         * @param {pond.IBulkPauseDeviceResponse=} [properties] Properties to set
         * @returns {pond.BulkPauseDeviceResponse} BulkPauseDeviceResponse instance
         */
        BulkPauseDeviceResponse.create = function create(properties) {
            return new BulkPauseDeviceResponse(properties);
        };

        /**
         * Creates a BulkPauseDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkPauseDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkPauseDeviceResponse} BulkPauseDeviceResponse
         */
        BulkPauseDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkPauseDeviceResponse)
                return object;
            var message = new $root.pond.BulkPauseDeviceResponse();
            if (object.devicesPaused) {
                if (!Array.isArray(object.devicesPaused))
                    throw TypeError(".pond.BulkPauseDeviceResponse.devicesPaused: array expected");
                message.devicesPaused = [];
                for (var i = 0; i < object.devicesPaused.length; ++i) {
                    if (typeof object.devicesPaused[i] !== "object")
                        throw TypeError(".pond.BulkPauseDeviceResponse.devicesPaused: object expected");
                    message.devicesPaused[i] = $root.pond.DeviceSuccess.fromObject(object.devicesPaused[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BulkPauseDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkPauseDeviceResponse
         * @static
         * @param {pond.BulkPauseDeviceResponse} message BulkPauseDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkPauseDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.devicesPaused = [];
            if (message.devicesPaused && message.devicesPaused.length) {
                object.devicesPaused = [];
                for (var j = 0; j < message.devicesPaused.length; ++j)
                    object.devicesPaused[j] = $root.pond.DeviceSuccess.toObject(message.devicesPaused[j], options);
            }
            return object;
        };

        /**
         * Converts this BulkPauseDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.BulkPauseDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkPauseDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkPauseDeviceResponse;
    })();

    pond.BulkChangeDataCapsRequest = (function() {

        /**
         * Properties of a BulkChangeDataCapsRequest.
         * @memberof pond
         * @interface IBulkChangeDataCapsRequest
         * @property {Array.<number>|null} [ids] BulkChangeDataCapsRequest ids
         * @property {number|null} [bytes] BulkChangeDataCapsRequest bytes
         */

        /**
         * Constructs a new BulkChangeDataCapsRequest.
         * @memberof pond
         * @classdesc Represents a BulkChangeDataCapsRequest.
         * @implements IBulkChangeDataCapsRequest
         * @constructor
         * @param {pond.IBulkChangeDataCapsRequest=} [properties] Properties to set
         */
        function BulkChangeDataCapsRequest(properties) {
            this.ids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkChangeDataCapsRequest ids.
         * @member {Array.<number>} ids
         * @memberof pond.BulkChangeDataCapsRequest
         * @instance
         */
        BulkChangeDataCapsRequest.prototype.ids = $util.emptyArray;

        /**
         * BulkChangeDataCapsRequest bytes.
         * @member {number} bytes
         * @memberof pond.BulkChangeDataCapsRequest
         * @instance
         */
        BulkChangeDataCapsRequest.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new BulkChangeDataCapsRequest instance using the specified properties.
         * @function create
         * @memberof pond.BulkChangeDataCapsRequest
         * @static
         * @param {pond.IBulkChangeDataCapsRequest=} [properties] Properties to set
         * @returns {pond.BulkChangeDataCapsRequest} BulkChangeDataCapsRequest instance
         */
        BulkChangeDataCapsRequest.create = function create(properties) {
            return new BulkChangeDataCapsRequest(properties);
        };

        /**
         * Creates a BulkChangeDataCapsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkChangeDataCapsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkChangeDataCapsRequest} BulkChangeDataCapsRequest
         */
        BulkChangeDataCapsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkChangeDataCapsRequest)
                return object;
            var message = new $root.pond.BulkChangeDataCapsRequest();
            if (object.ids) {
                if (!Array.isArray(object.ids))
                    throw TypeError(".pond.BulkChangeDataCapsRequest.ids: array expected");
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                    if ($util.Long)
                        (message.ids[i] = $util.Long.fromValue(object.ids[i])).unsigned = true;
                    else if (typeof object.ids[i] === "string")
                        message.ids[i] = parseInt(object.ids[i], 10);
                    else if (typeof object.ids[i] === "number")
                        message.ids[i] = object.ids[i];
                    else if (typeof object.ids[i] === "object")
                        message.ids[i] = new $util.LongBits(object.ids[i].low >>> 0, object.ids[i].high >>> 0).toNumber(true);
            }
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a BulkChangeDataCapsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkChangeDataCapsRequest
         * @static
         * @param {pond.BulkChangeDataCapsRequest} message BulkChangeDataCapsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkChangeDataCapsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.ids = [];
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
            if (message.ids && message.ids.length) {
                object.ids = [];
                for (var j = 0; j < message.ids.length; ++j)
                    if (typeof message.ids[j] === "number")
                        object.ids[j] = options.longs === String ? String(message.ids[j]) : message.ids[j];
                    else
                        object.ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ids[j]) : options.longs === Number ? new $util.LongBits(message.ids[j].low >>> 0, message.ids[j].high >>> 0).toNumber(true) : message.ids[j];
            }
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            return object;
        };

        /**
         * Converts this BulkChangeDataCapsRequest to JSON.
         * @function toJSON
         * @memberof pond.BulkChangeDataCapsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkChangeDataCapsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkChangeDataCapsRequest;
    })();

    pond.BulkChangeDataCapsResponse = (function() {

        /**
         * Properties of a BulkChangeDataCapsResponse.
         * @memberof pond
         * @interface IBulkChangeDataCapsResponse
         * @property {Array.<pond.DeviceSuccess>|null} [capsChanged] BulkChangeDataCapsResponse capsChanged
         */

        /**
         * Constructs a new BulkChangeDataCapsResponse.
         * @memberof pond
         * @classdesc Represents a BulkChangeDataCapsResponse.
         * @implements IBulkChangeDataCapsResponse
         * @constructor
         * @param {pond.IBulkChangeDataCapsResponse=} [properties] Properties to set
         */
        function BulkChangeDataCapsResponse(properties) {
            this.capsChanged = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkChangeDataCapsResponse capsChanged.
         * @member {Array.<pond.DeviceSuccess>} capsChanged
         * @memberof pond.BulkChangeDataCapsResponse
         * @instance
         */
        BulkChangeDataCapsResponse.prototype.capsChanged = $util.emptyArray;

        /**
         * Creates a new BulkChangeDataCapsResponse instance using the specified properties.
         * @function create
         * @memberof pond.BulkChangeDataCapsResponse
         * @static
         * @param {pond.IBulkChangeDataCapsResponse=} [properties] Properties to set
         * @returns {pond.BulkChangeDataCapsResponse} BulkChangeDataCapsResponse instance
         */
        BulkChangeDataCapsResponse.create = function create(properties) {
            return new BulkChangeDataCapsResponse(properties);
        };

        /**
         * Creates a BulkChangeDataCapsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkChangeDataCapsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkChangeDataCapsResponse} BulkChangeDataCapsResponse
         */
        BulkChangeDataCapsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkChangeDataCapsResponse)
                return object;
            var message = new $root.pond.BulkChangeDataCapsResponse();
            if (object.capsChanged) {
                if (!Array.isArray(object.capsChanged))
                    throw TypeError(".pond.BulkChangeDataCapsResponse.capsChanged: array expected");
                message.capsChanged = [];
                for (var i = 0; i < object.capsChanged.length; ++i) {
                    if (typeof object.capsChanged[i] !== "object")
                        throw TypeError(".pond.BulkChangeDataCapsResponse.capsChanged: object expected");
                    message.capsChanged[i] = $root.pond.DeviceSuccess.fromObject(object.capsChanged[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BulkChangeDataCapsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkChangeDataCapsResponse
         * @static
         * @param {pond.BulkChangeDataCapsResponse} message BulkChangeDataCapsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkChangeDataCapsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.capsChanged = [];
            if (message.capsChanged && message.capsChanged.length) {
                object.capsChanged = [];
                for (var j = 0; j < message.capsChanged.length; ++j)
                    object.capsChanged[j] = $root.pond.DeviceSuccess.toObject(message.capsChanged[j], options);
            }
            return object;
        };

        /**
         * Converts this BulkChangeDataCapsResponse to JSON.
         * @function toJSON
         * @memberof pond.BulkChangeDataCapsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkChangeDataCapsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkChangeDataCapsResponse;
    })();

    pond.DeviceUsageRequestFilters = (function() {

        /**
         * Properties of a DeviceUsageRequestFilters.
         * @memberof pond
         * @interface IDeviceUsageRequestFilters
         * @property {string|null} [timestampStart] DeviceUsageRequestFilters timestampStart
         */

        /**
         * Constructs a new DeviceUsageRequestFilters.
         * @memberof pond
         * @classdesc Represents a DeviceUsageRequestFilters.
         * @implements IDeviceUsageRequestFilters
         * @constructor
         * @param {pond.IDeviceUsageRequestFilters=} [properties] Properties to set
         */
        function DeviceUsageRequestFilters(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceUsageRequestFilters timestampStart.
         * @member {string} timestampStart
         * @memberof pond.DeviceUsageRequestFilters
         * @instance
         */
        DeviceUsageRequestFilters.prototype.timestampStart = "";

        /**
         * Creates a new DeviceUsageRequestFilters instance using the specified properties.
         * @function create
         * @memberof pond.DeviceUsageRequestFilters
         * @static
         * @param {pond.IDeviceUsageRequestFilters=} [properties] Properties to set
         * @returns {pond.DeviceUsageRequestFilters} DeviceUsageRequestFilters instance
         */
        DeviceUsageRequestFilters.create = function create(properties) {
            return new DeviceUsageRequestFilters(properties);
        };

        /**
         * Creates a DeviceUsageRequestFilters message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceUsageRequestFilters
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceUsageRequestFilters} DeviceUsageRequestFilters
         */
        DeviceUsageRequestFilters.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceUsageRequestFilters)
                return object;
            var message = new $root.pond.DeviceUsageRequestFilters();
            if (object.timestampStart != null)
                message.timestampStart = String(object.timestampStart);
            return message;
        };

        /**
         * Creates a plain object from a DeviceUsageRequestFilters message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceUsageRequestFilters
         * @static
         * @param {pond.DeviceUsageRequestFilters} message DeviceUsageRequestFilters
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceUsageRequestFilters.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestampStart = "";
            if (message.timestampStart != null && message.hasOwnProperty("timestampStart"))
                object.timestampStart = message.timestampStart;
            return object;
        };

        /**
         * Converts this DeviceUsageRequestFilters to JSON.
         * @function toJSON
         * @memberof pond.DeviceUsageRequestFilters
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceUsageRequestFilters.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceUsageRequestFilters;
    })();

    pond.GetDeviceUsageRequest = (function() {

        /**
         * Properties of a GetDeviceUsageRequest.
         * @memberof pond
         * @interface IGetDeviceUsageRequest
         * @property {number|null} [device] GetDeviceUsageRequest device
         * @property {pond.DeviceUsageRequestFilters|null} [filters] GetDeviceUsageRequest filters
         */

        /**
         * Constructs a new GetDeviceUsageRequest.
         * @memberof pond
         * @classdesc Represents a GetDeviceUsageRequest.
         * @implements IGetDeviceUsageRequest
         * @constructor
         * @param {pond.IGetDeviceUsageRequest=} [properties] Properties to set
         */
        function GetDeviceUsageRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceUsageRequest device.
         * @member {number} device
         * @memberof pond.GetDeviceUsageRequest
         * @instance
         */
        GetDeviceUsageRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetDeviceUsageRequest filters.
         * @member {pond.DeviceUsageRequestFilters|null|undefined} filters
         * @memberof pond.GetDeviceUsageRequest
         * @instance
         */
        GetDeviceUsageRequest.prototype.filters = null;

        /**
         * Creates a new GetDeviceUsageRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceUsageRequest
         * @static
         * @param {pond.IGetDeviceUsageRequest=} [properties] Properties to set
         * @returns {pond.GetDeviceUsageRequest} GetDeviceUsageRequest instance
         */
        GetDeviceUsageRequest.create = function create(properties) {
            return new GetDeviceUsageRequest(properties);
        };

        /**
         * Creates a GetDeviceUsageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceUsageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceUsageRequest} GetDeviceUsageRequest
         */
        GetDeviceUsageRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceUsageRequest)
                return object;
            var message = new $root.pond.GetDeviceUsageRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.GetDeviceUsageRequest.filters: object expected");
                message.filters = $root.pond.DeviceUsageRequestFilters.fromObject(object.filters);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceUsageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceUsageRequest
         * @static
         * @param {pond.GetDeviceUsageRequest} message GetDeviceUsageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceUsageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.filters = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.DeviceUsageRequestFilters.toObject(message.filters, options);
            return object;
        };

        /**
         * Converts this GetDeviceUsageRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceUsageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceUsageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceUsageRequest;
    })();

    pond.DeviceLinearMutationRequest = (function() {

        /**
         * Properties of a DeviceLinearMutationRequest.
         * @memberof pond
         * @interface IDeviceLinearMutationRequest
         * @property {pond.LinearMutation|null} [mutation] DeviceLinearMutationRequest mutation
         */

        /**
         * Constructs a new DeviceLinearMutationRequest.
         * @memberof pond
         * @classdesc Represents a DeviceLinearMutationRequest.
         * @implements IDeviceLinearMutationRequest
         * @constructor
         * @param {pond.IDeviceLinearMutationRequest=} [properties] Properties to set
         */
        function DeviceLinearMutationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceLinearMutationRequest mutation.
         * @member {pond.LinearMutation|null|undefined} mutation
         * @memberof pond.DeviceLinearMutationRequest
         * @instance
         */
        DeviceLinearMutationRequest.prototype.mutation = null;

        /**
         * Creates a new DeviceLinearMutationRequest instance using the specified properties.
         * @function create
         * @memberof pond.DeviceLinearMutationRequest
         * @static
         * @param {pond.IDeviceLinearMutationRequest=} [properties] Properties to set
         * @returns {pond.DeviceLinearMutationRequest} DeviceLinearMutationRequest instance
         */
        DeviceLinearMutationRequest.create = function create(properties) {
            return new DeviceLinearMutationRequest(properties);
        };

        /**
         * Creates a DeviceLinearMutationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceLinearMutationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceLinearMutationRequest} DeviceLinearMutationRequest
         */
        DeviceLinearMutationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceLinearMutationRequest)
                return object;
            var message = new $root.pond.DeviceLinearMutationRequest();
            if (object.mutation != null) {
                if (typeof object.mutation !== "object")
                    throw TypeError(".pond.DeviceLinearMutationRequest.mutation: object expected");
                message.mutation = $root.pond.LinearMutation.fromObject(object.mutation);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceLinearMutationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceLinearMutationRequest
         * @static
         * @param {pond.DeviceLinearMutationRequest} message DeviceLinearMutationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceLinearMutationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.mutation = null;
            if (message.mutation != null && message.hasOwnProperty("mutation"))
                object.mutation = $root.pond.LinearMutation.toObject(message.mutation, options);
            return object;
        };

        /**
         * Converts this DeviceLinearMutationRequest to JSON.
         * @function toJSON
         * @memberof pond.DeviceLinearMutationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceLinearMutationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceLinearMutationRequest;
    })();

    pond.DeviceLinearMutationResponse = (function() {

        /**
         * Properties of a DeviceLinearMutationResponse.
         * @memberof pond
         * @interface IDeviceLinearMutationResponse
         * @property {Array.<pond.ValueAt>|null} [values] DeviceLinearMutationResponse values
         * @property {pond.Mutator|null} [mutationType] DeviceLinearMutationResponse mutationType
         */

        /**
         * Constructs a new DeviceLinearMutationResponse.
         * @memberof pond
         * @classdesc Represents a DeviceLinearMutationResponse.
         * @implements IDeviceLinearMutationResponse
         * @constructor
         * @param {pond.IDeviceLinearMutationResponse=} [properties] Properties to set
         */
        function DeviceLinearMutationResponse(properties) {
            this.values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceLinearMutationResponse values.
         * @member {Array.<pond.ValueAt>} values
         * @memberof pond.DeviceLinearMutationResponse
         * @instance
         */
        DeviceLinearMutationResponse.prototype.values = $util.emptyArray;

        /**
         * DeviceLinearMutationResponse mutationType.
         * @member {pond.Mutator} mutationType
         * @memberof pond.DeviceLinearMutationResponse
         * @instance
         */
        DeviceLinearMutationResponse.prototype.mutationType = 0;

        /**
         * Creates a new DeviceLinearMutationResponse instance using the specified properties.
         * @function create
         * @memberof pond.DeviceLinearMutationResponse
         * @static
         * @param {pond.IDeviceLinearMutationResponse=} [properties] Properties to set
         * @returns {pond.DeviceLinearMutationResponse} DeviceLinearMutationResponse instance
         */
        DeviceLinearMutationResponse.create = function create(properties) {
            return new DeviceLinearMutationResponse(properties);
        };

        /**
         * Creates a DeviceLinearMutationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceLinearMutationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceLinearMutationResponse} DeviceLinearMutationResponse
         */
        DeviceLinearMutationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceLinearMutationResponse)
                return object;
            var message = new $root.pond.DeviceLinearMutationResponse();
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.DeviceLinearMutationResponse.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".pond.DeviceLinearMutationResponse.values: object expected");
                    message.values[i] = $root.pond.ValueAt.fromObject(object.values[i]);
                }
            }
            switch (object.mutationType) {
            case "MUTATOR_NONE":
            case 0:
                message.mutationType = 0;
                break;
            case "MUTATOR_EMC":
            case 1:
                message.mutationType = 1;
                break;
            case "MUTATOR_CFM":
            case 2:
                message.mutationType = 2;
                break;
            case "MUTATOR_FUEL_LEVEL":
            case 3:
                message.mutationType = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceLinearMutationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceLinearMutationResponse
         * @static
         * @param {pond.DeviceLinearMutationResponse} message DeviceLinearMutationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceLinearMutationResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.values = [];
            if (options.defaults)
                object.mutationType = options.enums === String ? "MUTATOR_NONE" : 0;
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.pond.ValueAt.toObject(message.values[j], options);
            }
            if (message.mutationType != null && message.hasOwnProperty("mutationType"))
                object.mutationType = options.enums === String ? $root.pond.Mutator[message.mutationType] : message.mutationType;
            return object;
        };

        /**
         * Converts this DeviceLinearMutationResponse to JSON.
         * @function toJSON
         * @memberof pond.DeviceLinearMutationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceLinearMutationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceLinearMutationResponse;
    })();

    pond.ValueAt = (function() {

        /**
         * Properties of a ValueAt.
         * @memberof pond
         * @interface IValueAt
         * @property {string|null} [time] ValueAt time
         * @property {number|null} [value] ValueAt value
         */

        /**
         * Constructs a new ValueAt.
         * @memberof pond
         * @classdesc Represents a ValueAt.
         * @implements IValueAt
         * @constructor
         * @param {pond.IValueAt=} [properties] Properties to set
         */
        function ValueAt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValueAt time.
         * @member {string} time
         * @memberof pond.ValueAt
         * @instance
         */
        ValueAt.prototype.time = "";

        /**
         * ValueAt value.
         * @member {number} value
         * @memberof pond.ValueAt
         * @instance
         */
        ValueAt.prototype.value = 0;

        /**
         * Creates a new ValueAt instance using the specified properties.
         * @function create
         * @memberof pond.ValueAt
         * @static
         * @param {pond.IValueAt=} [properties] Properties to set
         * @returns {pond.ValueAt} ValueAt instance
         */
        ValueAt.create = function create(properties) {
            return new ValueAt(properties);
        };

        /**
         * Creates a ValueAt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ValueAt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ValueAt} ValueAt
         */
        ValueAt.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ValueAt)
                return object;
            var message = new $root.pond.ValueAt();
            if (object.time != null)
                message.time = String(object.time);
            if (object.value != null)
                message.value = Number(object.value);
            return message;
        };

        /**
         * Creates a plain object from a ValueAt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ValueAt
         * @static
         * @param {pond.ValueAt} message ValueAt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValueAt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.time = "";
                object.value = 0;
            }
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
            return object;
        };

        /**
         * Converts this ValueAt to JSON.
         * @function toJSON
         * @memberof pond.ValueAt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValueAt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValueAt;
    })();

    pond.Session = (function() {

        /**
         * Properties of a Session.
         * @memberof pond
         * @interface ISession
         * @property {number|null} [linkid] Session linkid
         * @property {string|null} [sessionBegin] Session sessionBegin
         * @property {number|null} [bytes] Session bytes
         * @property {number|null} [cellid] Session cellid
         * @property {number|null} [lac] Session lac
         * @property {string|null} [networkName] Session networkName
         * @property {string|null} [imei] Session imei
         * @property {string|null} [sessionEnd] Session sessionEnd
         * @property {string|null} [tadig] Session tadig
         * @property {boolean|null} [active] Session active
         * @property {number|null} [longitude] Session longitude
         * @property {number|null} [latitude] Session latitude
         * @property {number|null} [recordId] Session recordId
         * @property {string|null} [timestamp] Session timestamp
         * @property {string|null} [periodsBack] Session periodsBack
         * @property {string|null} [imeisv] Session imeisv
         * @property {Array.<string>|null} [tags] Session tags
         * @property {string|null} [radioAccessTechnology] Session radioAccessTechnology
         * @property {string|null} [sim] Session sim
         * @property {number|null} [isReportingWindowWithUsage] Session isReportingWindowWithUsage
         */

        /**
         * Constructs a new Session.
         * @memberof pond
         * @classdesc Represents a Session.
         * @implements ISession
         * @constructor
         * @param {pond.ISession=} [properties] Properties to set
         */
        function Session(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Session linkid.
         * @member {number} linkid
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.linkid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Session sessionBegin.
         * @member {string} sessionBegin
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.sessionBegin = "";

        /**
         * Session bytes.
         * @member {number} bytes
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.bytes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Session cellid.
         * @member {number} cellid
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.cellid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Session lac.
         * @member {number} lac
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.lac = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Session networkName.
         * @member {string} networkName
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.networkName = "";

        /**
         * Session imei.
         * @member {string} imei
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.imei = "";

        /**
         * Session sessionEnd.
         * @member {string} sessionEnd
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.sessionEnd = "";

        /**
         * Session tadig.
         * @member {string} tadig
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.tadig = "";

        /**
         * Session active.
         * @member {boolean} active
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.active = false;

        /**
         * Session longitude.
         * @member {number} longitude
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.longitude = 0;

        /**
         * Session latitude.
         * @member {number} latitude
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.latitude = 0;

        /**
         * Session recordId.
         * @member {number} recordId
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.recordId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Session timestamp.
         * @member {string} timestamp
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.timestamp = "";

        /**
         * Session periodsBack.
         * @member {string} periodsBack
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.periodsBack = "";

        /**
         * Session imeisv.
         * @member {string} imeisv
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.imeisv = "";

        /**
         * Session tags.
         * @member {Array.<string>} tags
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.tags = $util.emptyArray;

        /**
         * Session radioAccessTechnology.
         * @member {string} radioAccessTechnology
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.radioAccessTechnology = "";

        /**
         * Session sim.
         * @member {string} sim
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.sim = "";

        /**
         * Session isReportingWindowWithUsage.
         * @member {number} isReportingWindowWithUsage
         * @memberof pond.Session
         * @instance
         */
        Session.prototype.isReportingWindowWithUsage = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Session instance using the specified properties.
         * @function create
         * @memberof pond.Session
         * @static
         * @param {pond.ISession=} [properties] Properties to set
         * @returns {pond.Session} Session instance
         */
        Session.create = function create(properties) {
            return new Session(properties);
        };

        /**
         * Creates a Session message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Session
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Session} Session
         */
        Session.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Session)
                return object;
            var message = new $root.pond.Session();
            if (object.linkid != null)
                if ($util.Long)
                    (message.linkid = $util.Long.fromValue(object.linkid)).unsigned = true;
                else if (typeof object.linkid === "string")
                    message.linkid = parseInt(object.linkid, 10);
                else if (typeof object.linkid === "number")
                    message.linkid = object.linkid;
                else if (typeof object.linkid === "object")
                    message.linkid = new $util.LongBits(object.linkid.low >>> 0, object.linkid.high >>> 0).toNumber(true);
            if (object.sessionBegin != null)
                message.sessionBegin = String(object.sessionBegin);
            if (object.bytes != null)
                if ($util.Long)
                    (message.bytes = $util.Long.fromValue(object.bytes)).unsigned = true;
                else if (typeof object.bytes === "string")
                    message.bytes = parseInt(object.bytes, 10);
                else if (typeof object.bytes === "number")
                    message.bytes = object.bytes;
                else if (typeof object.bytes === "object")
                    message.bytes = new $util.LongBits(object.bytes.low >>> 0, object.bytes.high >>> 0).toNumber(true);
            if (object.cellid != null)
                if ($util.Long)
                    (message.cellid = $util.Long.fromValue(object.cellid)).unsigned = true;
                else if (typeof object.cellid === "string")
                    message.cellid = parseInt(object.cellid, 10);
                else if (typeof object.cellid === "number")
                    message.cellid = object.cellid;
                else if (typeof object.cellid === "object")
                    message.cellid = new $util.LongBits(object.cellid.low >>> 0, object.cellid.high >>> 0).toNumber(true);
            if (object.lac != null)
                if ($util.Long)
                    (message.lac = $util.Long.fromValue(object.lac)).unsigned = true;
                else if (typeof object.lac === "string")
                    message.lac = parseInt(object.lac, 10);
                else if (typeof object.lac === "number")
                    message.lac = object.lac;
                else if (typeof object.lac === "object")
                    message.lac = new $util.LongBits(object.lac.low >>> 0, object.lac.high >>> 0).toNumber(true);
            if (object.networkName != null)
                message.networkName = String(object.networkName);
            if (object.imei != null)
                message.imei = String(object.imei);
            if (object.sessionEnd != null)
                message.sessionEnd = String(object.sessionEnd);
            if (object.tadig != null)
                message.tadig = String(object.tadig);
            if (object.active != null)
                message.active = Boolean(object.active);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.recordId != null)
                if ($util.Long)
                    (message.recordId = $util.Long.fromValue(object.recordId)).unsigned = true;
                else if (typeof object.recordId === "string")
                    message.recordId = parseInt(object.recordId, 10);
                else if (typeof object.recordId === "number")
                    message.recordId = object.recordId;
                else if (typeof object.recordId === "object")
                    message.recordId = new $util.LongBits(object.recordId.low >>> 0, object.recordId.high >>> 0).toNumber(true);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.periodsBack != null)
                message.periodsBack = String(object.periodsBack);
            if (object.imeisv != null)
                message.imeisv = String(object.imeisv);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.Session.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.radioAccessTechnology != null)
                message.radioAccessTechnology = String(object.radioAccessTechnology);
            if (object.sim != null)
                message.sim = String(object.sim);
            if (object.isReportingWindowWithUsage != null)
                if ($util.Long)
                    (message.isReportingWindowWithUsage = $util.Long.fromValue(object.isReportingWindowWithUsage)).unsigned = true;
                else if (typeof object.isReportingWindowWithUsage === "string")
                    message.isReportingWindowWithUsage = parseInt(object.isReportingWindowWithUsage, 10);
                else if (typeof object.isReportingWindowWithUsage === "number")
                    message.isReportingWindowWithUsage = object.isReportingWindowWithUsage;
                else if (typeof object.isReportingWindowWithUsage === "object")
                    message.isReportingWindowWithUsage = new $util.LongBits(object.isReportingWindowWithUsage.low >>> 0, object.isReportingWindowWithUsage.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Session message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Session
         * @static
         * @param {pond.Session} message Session
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Session.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.linkid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.linkid = options.longs === String ? "0" : 0;
                object.sessionBegin = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.bytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.bytes = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.cellid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.cellid = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.lac = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lac = options.longs === String ? "0" : 0;
                object.networkName = "";
                object.imei = "";
                object.sessionEnd = "";
                object.tadig = "";
                object.active = false;
                object.longitude = 0;
                object.latitude = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.recordId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.recordId = options.longs === String ? "0" : 0;
                object.timestamp = "";
                object.periodsBack = "";
                object.imeisv = "";
                object.radioAccessTechnology = "";
                object.sim = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.isReportingWindowWithUsage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.isReportingWindowWithUsage = options.longs === String ? "0" : 0;
            }
            if (message.linkid != null && message.hasOwnProperty("linkid"))
                if (typeof message.linkid === "number")
                    object.linkid = options.longs === String ? String(message.linkid) : message.linkid;
                else
                    object.linkid = options.longs === String ? $util.Long.prototype.toString.call(message.linkid) : options.longs === Number ? new $util.LongBits(message.linkid.low >>> 0, message.linkid.high >>> 0).toNumber(true) : message.linkid;
            if (message.sessionBegin != null && message.hasOwnProperty("sessionBegin"))
                object.sessionBegin = message.sessionBegin;
            if (message.bytes != null && message.hasOwnProperty("bytes"))
                if (typeof message.bytes === "number")
                    object.bytes = options.longs === String ? String(message.bytes) : message.bytes;
                else
                    object.bytes = options.longs === String ? $util.Long.prototype.toString.call(message.bytes) : options.longs === Number ? new $util.LongBits(message.bytes.low >>> 0, message.bytes.high >>> 0).toNumber(true) : message.bytes;
            if (message.cellid != null && message.hasOwnProperty("cellid"))
                if (typeof message.cellid === "number")
                    object.cellid = options.longs === String ? String(message.cellid) : message.cellid;
                else
                    object.cellid = options.longs === String ? $util.Long.prototype.toString.call(message.cellid) : options.longs === Number ? new $util.LongBits(message.cellid.low >>> 0, message.cellid.high >>> 0).toNumber(true) : message.cellid;
            if (message.lac != null && message.hasOwnProperty("lac"))
                if (typeof message.lac === "number")
                    object.lac = options.longs === String ? String(message.lac) : message.lac;
                else
                    object.lac = options.longs === String ? $util.Long.prototype.toString.call(message.lac) : options.longs === Number ? new $util.LongBits(message.lac.low >>> 0, message.lac.high >>> 0).toNumber(true) : message.lac;
            if (message.networkName != null && message.hasOwnProperty("networkName"))
                object.networkName = message.networkName;
            if (message.imei != null && message.hasOwnProperty("imei"))
                object.imei = message.imei;
            if (message.sessionEnd != null && message.hasOwnProperty("sessionEnd"))
                object.sessionEnd = message.sessionEnd;
            if (message.tadig != null && message.hasOwnProperty("tadig"))
                object.tadig = message.tadig;
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = message.active;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.recordId != null && message.hasOwnProperty("recordId"))
                if (typeof message.recordId === "number")
                    object.recordId = options.longs === String ? String(message.recordId) : message.recordId;
                else
                    object.recordId = options.longs === String ? $util.Long.prototype.toString.call(message.recordId) : options.longs === Number ? new $util.LongBits(message.recordId.low >>> 0, message.recordId.high >>> 0).toNumber(true) : message.recordId;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.periodsBack != null && message.hasOwnProperty("periodsBack"))
                object.periodsBack = message.periodsBack;
            if (message.imeisv != null && message.hasOwnProperty("imeisv"))
                object.imeisv = message.imeisv;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.radioAccessTechnology != null && message.hasOwnProperty("radioAccessTechnology"))
                object.radioAccessTechnology = message.radioAccessTechnology;
            if (message.sim != null && message.hasOwnProperty("sim"))
                object.sim = message.sim;
            if (message.isReportingWindowWithUsage != null && message.hasOwnProperty("isReportingWindowWithUsage"))
                if (typeof message.isReportingWindowWithUsage === "number")
                    object.isReportingWindowWithUsage = options.longs === String ? String(message.isReportingWindowWithUsage) : message.isReportingWindowWithUsage;
                else
                    object.isReportingWindowWithUsage = options.longs === String ? $util.Long.prototype.toString.call(message.isReportingWindowWithUsage) : options.longs === Number ? new $util.LongBits(message.isReportingWindowWithUsage.low >>> 0, message.isReportingWindowWithUsage.high >>> 0).toNumber(true) : message.isReportingWindowWithUsage;
            return object;
        };

        /**
         * Converts this Session to JSON.
         * @function toJSON
         * @memberof pond.Session
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Session.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Session;
    })();

    pond.GetDeviceUsageResponse = (function() {

        /**
         * Properties of a GetDeviceUsageResponse.
         * @memberof pond
         * @interface IGetDeviceUsageResponse
         * @property {string|null} [status] GetDeviceUsageResponse status
         * @property {Array.<pond.Session>|null} [sessions] GetDeviceUsageResponse sessions
         * @property {number|null} [latitude] GetDeviceUsageResponse latitude
         * @property {number|null} [longitude] GetDeviceUsageResponse longitude
         */

        /**
         * Constructs a new GetDeviceUsageResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceUsageResponse.
         * @implements IGetDeviceUsageResponse
         * @constructor
         * @param {pond.IGetDeviceUsageResponse=} [properties] Properties to set
         */
        function GetDeviceUsageResponse(properties) {
            this.sessions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceUsageResponse status.
         * @member {string} status
         * @memberof pond.GetDeviceUsageResponse
         * @instance
         */
        GetDeviceUsageResponse.prototype.status = "";

        /**
         * GetDeviceUsageResponse sessions.
         * @member {Array.<pond.Session>} sessions
         * @memberof pond.GetDeviceUsageResponse
         * @instance
         */
        GetDeviceUsageResponse.prototype.sessions = $util.emptyArray;

        /**
         * GetDeviceUsageResponse latitude.
         * @member {number} latitude
         * @memberof pond.GetDeviceUsageResponse
         * @instance
         */
        GetDeviceUsageResponse.prototype.latitude = 0;

        /**
         * GetDeviceUsageResponse longitude.
         * @member {number} longitude
         * @memberof pond.GetDeviceUsageResponse
         * @instance
         */
        GetDeviceUsageResponse.prototype.longitude = 0;

        /**
         * Creates a new GetDeviceUsageResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceUsageResponse
         * @static
         * @param {pond.IGetDeviceUsageResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceUsageResponse} GetDeviceUsageResponse instance
         */
        GetDeviceUsageResponse.create = function create(properties) {
            return new GetDeviceUsageResponse(properties);
        };

        /**
         * Creates a GetDeviceUsageResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceUsageResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceUsageResponse} GetDeviceUsageResponse
         */
        GetDeviceUsageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceUsageResponse)
                return object;
            var message = new $root.pond.GetDeviceUsageResponse();
            if (object.status != null)
                message.status = String(object.status);
            if (object.sessions) {
                if (!Array.isArray(object.sessions))
                    throw TypeError(".pond.GetDeviceUsageResponse.sessions: array expected");
                message.sessions = [];
                for (var i = 0; i < object.sessions.length; ++i) {
                    if (typeof object.sessions[i] !== "object")
                        throw TypeError(".pond.GetDeviceUsageResponse.sessions: object expected");
                    message.sessions[i] = $root.pond.Session.fromObject(object.sessions[i]);
                }
            }
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceUsageResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceUsageResponse
         * @static
         * @param {pond.GetDeviceUsageResponse} message GetDeviceUsageResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceUsageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.sessions = [];
            if (options.defaults) {
                object.status = "";
                object.latitude = 0;
                object.longitude = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.sessions && message.sessions.length) {
                object.sessions = [];
                for (var j = 0; j < message.sessions.length; ++j)
                    object.sessions[j] = $root.pond.Session.toObject(message.sessions[j], options);
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            return object;
        };

        /**
         * Converts this GetDeviceUsageResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceUsageResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceUsageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceUsageResponse;
    })();

    pond.GetDeviceUsageHTTPResponse = (function() {

        /**
         * Properties of a GetDeviceUsageHTTPResponse.
         * @memberof pond
         * @interface IGetDeviceUsageHTTPResponse
         * @property {boolean|null} [success] GetDeviceUsageHTTPResponse success
         * @property {number|null} [limit] GetDeviceUsageHTTPResponse limit
         * @property {number|null} [size] GetDeviceUsageHTTPResponse size
         * @property {boolean|null} [continues] GetDeviceUsageHTTPResponse continues
         * @property {number|null} [lastid] GetDeviceUsageHTTPResponse lastid
         * @property {Array.<pond.Session>|null} [data] GetDeviceUsageHTTPResponse data
         */

        /**
         * Constructs a new GetDeviceUsageHTTPResponse.
         * @memberof pond
         * @classdesc Represents a GetDeviceUsageHTTPResponse.
         * @implements IGetDeviceUsageHTTPResponse
         * @constructor
         * @param {pond.IGetDeviceUsageHTTPResponse=} [properties] Properties to set
         */
        function GetDeviceUsageHTTPResponse(properties) {
            this.data = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDeviceUsageHTTPResponse success.
         * @member {boolean} success
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.success = false;

        /**
         * GetDeviceUsageHTTPResponse limit.
         * @member {number} limit
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetDeviceUsageHTTPResponse size.
         * @member {number} size
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetDeviceUsageHTTPResponse continues.
         * @member {boolean} continues
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.continues = false;

        /**
         * GetDeviceUsageHTTPResponse lastid.
         * @member {number} lastid
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.lastid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetDeviceUsageHTTPResponse data.
         * @member {Array.<pond.Session>} data
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         */
        GetDeviceUsageHTTPResponse.prototype.data = $util.emptyArray;

        /**
         * Creates a new GetDeviceUsageHTTPResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @static
         * @param {pond.IGetDeviceUsageHTTPResponse=} [properties] Properties to set
         * @returns {pond.GetDeviceUsageHTTPResponse} GetDeviceUsageHTTPResponse instance
         */
        GetDeviceUsageHTTPResponse.create = function create(properties) {
            return new GetDeviceUsageHTTPResponse(properties);
        };

        /**
         * Creates a GetDeviceUsageHTTPResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDeviceUsageHTTPResponse} GetDeviceUsageHTTPResponse
         */
        GetDeviceUsageHTTPResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDeviceUsageHTTPResponse)
                return object;
            var message = new $root.pond.GetDeviceUsageHTTPResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            if (object.limit != null)
                if ($util.Long)
                    (message.limit = $util.Long.fromValue(object.limit)).unsigned = true;
                else if (typeof object.limit === "string")
                    message.limit = parseInt(object.limit, 10);
                else if (typeof object.limit === "number")
                    message.limit = object.limit;
                else if (typeof object.limit === "object")
                    message.limit = new $util.LongBits(object.limit.low >>> 0, object.limit.high >>> 0).toNumber(true);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.continues != null)
                message.continues = Boolean(object.continues);
            if (object.lastid != null)
                if ($util.Long)
                    (message.lastid = $util.Long.fromValue(object.lastid)).unsigned = true;
                else if (typeof object.lastid === "string")
                    message.lastid = parseInt(object.lastid, 10);
                else if (typeof object.lastid === "number")
                    message.lastid = object.lastid;
                else if (typeof object.lastid === "object")
                    message.lastid = new $util.LongBits(object.lastid.low >>> 0, object.lastid.high >>> 0).toNumber(true);
            if (object.data) {
                if (!Array.isArray(object.data))
                    throw TypeError(".pond.GetDeviceUsageHTTPResponse.data: array expected");
                message.data = [];
                for (var i = 0; i < object.data.length; ++i) {
                    if (typeof object.data[i] !== "object")
                        throw TypeError(".pond.GetDeviceUsageHTTPResponse.data: object expected");
                    message.data[i] = $root.pond.Session.fromObject(object.data[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDeviceUsageHTTPResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @static
         * @param {pond.GetDeviceUsageHTTPResponse} message GetDeviceUsageHTTPResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDeviceUsageHTTPResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.data = [];
            if (options.defaults) {
                object.success = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.limit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.continues = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.lastid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastid = options.longs === String ? "0" : 0;
            }
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (typeof message.limit === "number")
                    object.limit = options.longs === String ? String(message.limit) : message.limit;
                else
                    object.limit = options.longs === String ? $util.Long.prototype.toString.call(message.limit) : options.longs === Number ? new $util.LongBits(message.limit.low >>> 0, message.limit.high >>> 0).toNumber(true) : message.limit;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.continues != null && message.hasOwnProperty("continues"))
                object.continues = message.continues;
            if (message.lastid != null && message.hasOwnProperty("lastid"))
                if (typeof message.lastid === "number")
                    object.lastid = options.longs === String ? String(message.lastid) : message.lastid;
                else
                    object.lastid = options.longs === String ? $util.Long.prototype.toString.call(message.lastid) : options.longs === Number ? new $util.LongBits(message.lastid.low >>> 0, message.lastid.high >>> 0).toNumber(true) : message.lastid;
            if (message.data && message.data.length) {
                object.data = [];
                for (var j = 0; j < message.data.length; ++j)
                    object.data[j] = $root.pond.Session.toObject(message.data[j], options);
            }
            return object;
        };

        /**
         * Converts this GetDeviceUsageHTTPResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDeviceUsageHTTPResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDeviceUsageHTTPResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDeviceUsageHTTPResponse;
    })();

    pond.GetMultiDeviceUsageRequest = (function() {

        /**
         * Properties of a GetMultiDeviceUsageRequest.
         * @memberof pond
         * @interface IGetMultiDeviceUsageRequest
         * @property {Array.<number>|null} [devices] GetMultiDeviceUsageRequest devices
         * @property {pond.DeviceUsageRequestFilters|null} [filters] GetMultiDeviceUsageRequest filters
         */

        /**
         * Constructs a new GetMultiDeviceUsageRequest.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceUsageRequest.
         * @implements IGetMultiDeviceUsageRequest
         * @constructor
         * @param {pond.IGetMultiDeviceUsageRequest=} [properties] Properties to set
         */
        function GetMultiDeviceUsageRequest(properties) {
            this.devices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceUsageRequest devices.
         * @member {Array.<number>} devices
         * @memberof pond.GetMultiDeviceUsageRequest
         * @instance
         */
        GetMultiDeviceUsageRequest.prototype.devices = $util.emptyArray;

        /**
         * GetMultiDeviceUsageRequest filters.
         * @member {pond.DeviceUsageRequestFilters|null|undefined} filters
         * @memberof pond.GetMultiDeviceUsageRequest
         * @instance
         */
        GetMultiDeviceUsageRequest.prototype.filters = null;

        /**
         * Creates a new GetMultiDeviceUsageRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceUsageRequest
         * @static
         * @param {pond.IGetMultiDeviceUsageRequest=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceUsageRequest} GetMultiDeviceUsageRequest instance
         */
        GetMultiDeviceUsageRequest.create = function create(properties) {
            return new GetMultiDeviceUsageRequest(properties);
        };

        /**
         * Creates a GetMultiDeviceUsageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceUsageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceUsageRequest} GetMultiDeviceUsageRequest
         */
        GetMultiDeviceUsageRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceUsageRequest)
                return object;
            var message = new $root.pond.GetMultiDeviceUsageRequest();
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GetMultiDeviceUsageRequest.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i)
                    if ($util.Long)
                        (message.devices[i] = $util.Long.fromValue(object.devices[i])).unsigned = true;
                    else if (typeof object.devices[i] === "string")
                        message.devices[i] = parseInt(object.devices[i], 10);
                    else if (typeof object.devices[i] === "number")
                        message.devices[i] = object.devices[i];
                    else if (typeof object.devices[i] === "object")
                        message.devices[i] = new $util.LongBits(object.devices[i].low >>> 0, object.devices[i].high >>> 0).toNumber(true);
            }
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.GetMultiDeviceUsageRequest.filters: object expected");
                message.filters = $root.pond.DeviceUsageRequestFilters.fromObject(object.filters);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceUsageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceUsageRequest
         * @static
         * @param {pond.GetMultiDeviceUsageRequest} message GetMultiDeviceUsageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceUsageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.devices = [];
            if (options.defaults)
                object.filters = null;
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    if (typeof message.devices[j] === "number")
                        object.devices[j] = options.longs === String ? String(message.devices[j]) : message.devices[j];
                    else
                        object.devices[j] = options.longs === String ? $util.Long.prototype.toString.call(message.devices[j]) : options.longs === Number ? new $util.LongBits(message.devices[j].low >>> 0, message.devices[j].high >>> 0).toNumber(true) : message.devices[j];
            }
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.DeviceUsageRequestFilters.toObject(message.filters, options);
            return object;
        };

        /**
         * Converts this GetMultiDeviceUsageRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceUsageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceUsageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceUsageRequest;
    })();

    pond.GetMultiDeviceUsageResponse = (function() {

        /**
         * Properties of a GetMultiDeviceUsageResponse.
         * @memberof pond
         * @interface IGetMultiDeviceUsageResponse
         * @property {Object.<string,pond.GetDeviceUsageResponse>|null} [usages] GetMultiDeviceUsageResponse usages
         */

        /**
         * Constructs a new GetMultiDeviceUsageResponse.
         * @memberof pond
         * @classdesc Represents a GetMultiDeviceUsageResponse.
         * @implements IGetMultiDeviceUsageResponse
         * @constructor
         * @param {pond.IGetMultiDeviceUsageResponse=} [properties] Properties to set
         */
        function GetMultiDeviceUsageResponse(properties) {
            this.usages = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiDeviceUsageResponse usages.
         * @member {Object.<string,pond.GetDeviceUsageResponse>} usages
         * @memberof pond.GetMultiDeviceUsageResponse
         * @instance
         */
        GetMultiDeviceUsageResponse.prototype.usages = $util.emptyObject;

        /**
         * Creates a new GetMultiDeviceUsageResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiDeviceUsageResponse
         * @static
         * @param {pond.IGetMultiDeviceUsageResponse=} [properties] Properties to set
         * @returns {pond.GetMultiDeviceUsageResponse} GetMultiDeviceUsageResponse instance
         */
        GetMultiDeviceUsageResponse.create = function create(properties) {
            return new GetMultiDeviceUsageResponse(properties);
        };

        /**
         * Creates a GetMultiDeviceUsageResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiDeviceUsageResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiDeviceUsageResponse} GetMultiDeviceUsageResponse
         */
        GetMultiDeviceUsageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiDeviceUsageResponse)
                return object;
            var message = new $root.pond.GetMultiDeviceUsageResponse();
            if (object.usages) {
                if (typeof object.usages !== "object")
                    throw TypeError(".pond.GetMultiDeviceUsageResponse.usages: object expected");
                message.usages = {};
                for (var keys = Object.keys(object.usages), i = 0; i < keys.length; ++i) {
                    if (typeof object.usages[keys[i]] !== "object")
                        throw TypeError(".pond.GetMultiDeviceUsageResponse.usages: object expected");
                    message.usages[keys[i]] = $root.pond.GetDeviceUsageResponse.fromObject(object.usages[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMultiDeviceUsageResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiDeviceUsageResponse
         * @static
         * @param {pond.GetMultiDeviceUsageResponse} message GetMultiDeviceUsageResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiDeviceUsageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.usages = {};
            var keys2;
            if (message.usages && (keys2 = Object.keys(message.usages)).length) {
                object.usages = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.usages[keys2[j]] = $root.pond.GetDeviceUsageResponse.toObject(message.usages[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this GetMultiDeviceUsageResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMultiDeviceUsageResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiDeviceUsageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiDeviceUsageResponse;
    })();

    pond.ListDeviceUsageRequest = (function() {

        /**
         * Properties of a ListDeviceUsageRequest.
         * @memberof pond
         * @interface IListDeviceUsageRequest
         * @property {pond.DeviceUsageRequestFilters|null} [filters] ListDeviceUsageRequest filters
         */

        /**
         * Constructs a new ListDeviceUsageRequest.
         * @memberof pond
         * @classdesc Represents a ListDeviceUsageRequest.
         * @implements IListDeviceUsageRequest
         * @constructor
         * @param {pond.IListDeviceUsageRequest=} [properties] Properties to set
         */
        function ListDeviceUsageRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceUsageRequest filters.
         * @member {pond.DeviceUsageRequestFilters|null|undefined} filters
         * @memberof pond.ListDeviceUsageRequest
         * @instance
         */
        ListDeviceUsageRequest.prototype.filters = null;

        /**
         * Creates a new ListDeviceUsageRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceUsageRequest
         * @static
         * @param {pond.IListDeviceUsageRequest=} [properties] Properties to set
         * @returns {pond.ListDeviceUsageRequest} ListDeviceUsageRequest instance
         */
        ListDeviceUsageRequest.create = function create(properties) {
            return new ListDeviceUsageRequest(properties);
        };

        /**
         * Creates a ListDeviceUsageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceUsageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceUsageRequest} ListDeviceUsageRequest
         */
        ListDeviceUsageRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceUsageRequest)
                return object;
            var message = new $root.pond.ListDeviceUsageRequest();
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListDeviceUsageRequest.filters: object expected");
                message.filters = $root.pond.DeviceUsageRequestFilters.fromObject(object.filters);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceUsageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceUsageRequest
         * @static
         * @param {pond.ListDeviceUsageRequest} message ListDeviceUsageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceUsageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.filters = null;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.DeviceUsageRequestFilters.toObject(message.filters, options);
            return object;
        };

        /**
         * Converts this ListDeviceUsageRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceUsageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceUsageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceUsageRequest;
    })();

    pond.ListDeviceUsageResponse = (function() {

        /**
         * Properties of a ListDeviceUsageResponse.
         * @memberof pond
         * @interface IListDeviceUsageResponse
         * @property {Object.<string,pond.GetDeviceUsageResponse>|null} [usages] ListDeviceUsageResponse usages
         */

        /**
         * Constructs a new ListDeviceUsageResponse.
         * @memberof pond
         * @classdesc Represents a ListDeviceUsageResponse.
         * @implements IListDeviceUsageResponse
         * @constructor
         * @param {pond.IListDeviceUsageResponse=} [properties] Properties to set
         */
        function ListDeviceUsageResponse(properties) {
            this.usages = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceUsageResponse usages.
         * @member {Object.<string,pond.GetDeviceUsageResponse>} usages
         * @memberof pond.ListDeviceUsageResponse
         * @instance
         */
        ListDeviceUsageResponse.prototype.usages = $util.emptyObject;

        /**
         * Creates a new ListDeviceUsageResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceUsageResponse
         * @static
         * @param {pond.IListDeviceUsageResponse=} [properties] Properties to set
         * @returns {pond.ListDeviceUsageResponse} ListDeviceUsageResponse instance
         */
        ListDeviceUsageResponse.create = function create(properties) {
            return new ListDeviceUsageResponse(properties);
        };

        /**
         * Creates a ListDeviceUsageResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceUsageResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceUsageResponse} ListDeviceUsageResponse
         */
        ListDeviceUsageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceUsageResponse)
                return object;
            var message = new $root.pond.ListDeviceUsageResponse();
            if (object.usages) {
                if (typeof object.usages !== "object")
                    throw TypeError(".pond.ListDeviceUsageResponse.usages: object expected");
                message.usages = {};
                for (var keys = Object.keys(object.usages), i = 0; i < keys.length; ++i) {
                    if (typeof object.usages[keys[i]] !== "object")
                        throw TypeError(".pond.ListDeviceUsageResponse.usages: object expected");
                    message.usages[keys[i]] = $root.pond.GetDeviceUsageResponse.fromObject(object.usages[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceUsageResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceUsageResponse
         * @static
         * @param {pond.ListDeviceUsageResponse} message ListDeviceUsageResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceUsageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.usages = {};
            var keys2;
            if (message.usages && (keys2 = Object.keys(message.usages)).length) {
                object.usages = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.usages[keys2[j]] = $root.pond.GetDeviceUsageResponse.toObject(message.usages[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this ListDeviceUsageResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceUsageResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceUsageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceUsageResponse;
    })();

    pond.ListDeviceHistoryRequest = (function() {

        /**
         * Properties of a ListDeviceHistoryRequest.
         * @memberof pond
         * @interface IListDeviceHistoryRequest
         * @property {number|null} [device] ListDeviceHistoryRequest device
         * @property {pond.Paging|null} [paging] ListDeviceHistoryRequest paging
         */

        /**
         * Constructs a new ListDeviceHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListDeviceHistoryRequest.
         * @implements IListDeviceHistoryRequest
         * @constructor
         * @param {pond.IListDeviceHistoryRequest=} [properties] Properties to set
         */
        function ListDeviceHistoryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceHistoryRequest device.
         * @member {number} device
         * @memberof pond.ListDeviceHistoryRequest
         * @instance
         */
        ListDeviceHistoryRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListDeviceHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListDeviceHistoryRequest
         * @instance
         */
        ListDeviceHistoryRequest.prototype.paging = null;

        /**
         * Creates a new ListDeviceHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceHistoryRequest
         * @static
         * @param {pond.IListDeviceHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListDeviceHistoryRequest} ListDeviceHistoryRequest instance
         */
        ListDeviceHistoryRequest.create = function create(properties) {
            return new ListDeviceHistoryRequest(properties);
        };

        /**
         * Creates a ListDeviceHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceHistoryRequest} ListDeviceHistoryRequest
         */
        ListDeviceHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceHistoryRequest)
                return object;
            var message = new $root.pond.ListDeviceHistoryRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListDeviceHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceHistoryRequest
         * @static
         * @param {pond.ListDeviceHistoryRequest} message ListDeviceHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.paging = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            return object;
        };

        /**
         * Converts this ListDeviceHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceHistoryRequest;
    })();

    pond.DeviceHistory = (function() {

        /**
         * Properties of a DeviceHistory.
         * @memberof pond
         * @interface IDeviceHistory
         * @property {pond.DeviceSettings|null} [device] DeviceHistory device
         * @property {string|null} [user] DeviceHistory user
         * @property {string|null} [timestamp] DeviceHistory timestamp
         * @property {string|null} [progress] DeviceHistory progress
         */

        /**
         * Constructs a new DeviceHistory.
         * @memberof pond
         * @classdesc Represents a DeviceHistory.
         * @implements IDeviceHistory
         * @constructor
         * @param {pond.IDeviceHistory=} [properties] Properties to set
         */
        function DeviceHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceHistory device.
         * @member {pond.DeviceSettings|null|undefined} device
         * @memberof pond.DeviceHistory
         * @instance
         */
        DeviceHistory.prototype.device = null;

        /**
         * DeviceHistory user.
         * @member {string} user
         * @memberof pond.DeviceHistory
         * @instance
         */
        DeviceHistory.prototype.user = "";

        /**
         * DeviceHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.DeviceHistory
         * @instance
         */
        DeviceHistory.prototype.timestamp = "";

        /**
         * DeviceHistory progress.
         * @member {string} progress
         * @memberof pond.DeviceHistory
         * @instance
         */
        DeviceHistory.prototype.progress = "";

        /**
         * Creates a new DeviceHistory instance using the specified properties.
         * @function create
         * @memberof pond.DeviceHistory
         * @static
         * @param {pond.IDeviceHistory=} [properties] Properties to set
         * @returns {pond.DeviceHistory} DeviceHistory instance
         */
        DeviceHistory.create = function create(properties) {
            return new DeviceHistory(properties);
        };

        /**
         * Creates a DeviceHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceHistory} DeviceHistory
         */
        DeviceHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceHistory)
                return object;
            var message = new $root.pond.DeviceHistory();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.DeviceHistory.device: object expected");
                message.device = $root.pond.DeviceSettings.fromObject(object.device);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.progress != null)
                message.progress = String(object.progress);
            return message;
        };

        /**
         * Creates a plain object from a DeviceHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceHistory
         * @static
         * @param {pond.DeviceHistory} message DeviceHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.device = null;
                object.user = "";
                object.timestamp = "";
                object.progress = "";
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.DeviceSettings.toObject(message.device, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            return object;
        };

        /**
         * Converts this DeviceHistory to JSON.
         * @function toJSON
         * @memberof pond.DeviceHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceHistory;
    })();

    pond.ListDeviceHistoryResponse = (function() {

        /**
         * Properties of a ListDeviceHistoryResponse.
         * @memberof pond
         * @interface IListDeviceHistoryResponse
         * @property {Array.<pond.DeviceHistory>|null} [history] ListDeviceHistoryResponse history
         * @property {number|null} [nextOffset] ListDeviceHistoryResponse nextOffset
         * @property {number|null} [total] ListDeviceHistoryResponse total
         */

        /**
         * Constructs a new ListDeviceHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListDeviceHistoryResponse.
         * @implements IListDeviceHistoryResponse
         * @constructor
         * @param {pond.IListDeviceHistoryResponse=} [properties] Properties to set
         */
        function ListDeviceHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceHistoryResponse history.
         * @member {Array.<pond.DeviceHistory>} history
         * @memberof pond.ListDeviceHistoryResponse
         * @instance
         */
        ListDeviceHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListDeviceHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListDeviceHistoryResponse
         * @instance
         */
        ListDeviceHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListDeviceHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListDeviceHistoryResponse
         * @instance
         */
        ListDeviceHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListDeviceHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceHistoryResponse
         * @static
         * @param {pond.IListDeviceHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListDeviceHistoryResponse} ListDeviceHistoryResponse instance
         */
        ListDeviceHistoryResponse.create = function create(properties) {
            return new ListDeviceHistoryResponse(properties);
        };

        /**
         * Creates a ListDeviceHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceHistoryResponse} ListDeviceHistoryResponse
         */
        ListDeviceHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceHistoryResponse)
                return object;
            var message = new $root.pond.ListDeviceHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListDeviceHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListDeviceHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.DeviceHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceHistoryResponse
         * @static
         * @param {pond.ListDeviceHistoryResponse} message ListDeviceHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.DeviceHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListDeviceHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceHistoryResponse;
    })();

    pond.LoadBackpackRequest = (function() {

        /**
         * Properties of a LoadBackpackRequest.
         * @memberof pond
         * @interface ILoadBackpackRequest
         * @property {number|null} [device] LoadBackpackRequest device
         * @property {number|null} [backpack] LoadBackpackRequest backpack
         */

        /**
         * Constructs a new LoadBackpackRequest.
         * @memberof pond
         * @classdesc Represents a LoadBackpackRequest.
         * @implements ILoadBackpackRequest
         * @constructor
         * @param {pond.ILoadBackpackRequest=} [properties] Properties to set
         */
        function LoadBackpackRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LoadBackpackRequest device.
         * @member {number} device
         * @memberof pond.LoadBackpackRequest
         * @instance
         */
        LoadBackpackRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LoadBackpackRequest backpack.
         * @member {number} backpack
         * @memberof pond.LoadBackpackRequest
         * @instance
         */
        LoadBackpackRequest.prototype.backpack = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new LoadBackpackRequest instance using the specified properties.
         * @function create
         * @memberof pond.LoadBackpackRequest
         * @static
         * @param {pond.ILoadBackpackRequest=} [properties] Properties to set
         * @returns {pond.LoadBackpackRequest} LoadBackpackRequest instance
         */
        LoadBackpackRequest.create = function create(properties) {
            return new LoadBackpackRequest(properties);
        };

        /**
         * Creates a LoadBackpackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LoadBackpackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LoadBackpackRequest} LoadBackpackRequest
         */
        LoadBackpackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LoadBackpackRequest)
                return object;
            var message = new $root.pond.LoadBackpackRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.backpack != null)
                if ($util.Long)
                    (message.backpack = $util.Long.fromValue(object.backpack)).unsigned = true;
                else if (typeof object.backpack === "string")
                    message.backpack = parseInt(object.backpack, 10);
                else if (typeof object.backpack === "number")
                    message.backpack = object.backpack;
                else if (typeof object.backpack === "object")
                    message.backpack = new $util.LongBits(object.backpack.low >>> 0, object.backpack.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a LoadBackpackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LoadBackpackRequest
         * @static
         * @param {pond.LoadBackpackRequest} message LoadBackpackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoadBackpackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.backpack = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.backpack = options.longs === String ? "0" : 0;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                if (typeof message.backpack === "number")
                    object.backpack = options.longs === String ? String(message.backpack) : message.backpack;
                else
                    object.backpack = options.longs === String ? $util.Long.prototype.toString.call(message.backpack) : options.longs === Number ? new $util.LongBits(message.backpack.low >>> 0, message.backpack.high >>> 0).toNumber(true) : message.backpack;
            return object;
        };

        /**
         * Converts this LoadBackpackRequest to JSON.
         * @function toJSON
         * @memberof pond.LoadBackpackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoadBackpackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LoadBackpackRequest;
    })();

    pond.LoadBackpackResponse = (function() {

        /**
         * Properties of a LoadBackpackResponse.
         * @memberof pond
         * @interface ILoadBackpackResponse
         */

        /**
         * Constructs a new LoadBackpackResponse.
         * @memberof pond
         * @classdesc Represents a LoadBackpackResponse.
         * @implements ILoadBackpackResponse
         * @constructor
         * @param {pond.ILoadBackpackResponse=} [properties] Properties to set
         */
        function LoadBackpackResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new LoadBackpackResponse instance using the specified properties.
         * @function create
         * @memberof pond.LoadBackpackResponse
         * @static
         * @param {pond.ILoadBackpackResponse=} [properties] Properties to set
         * @returns {pond.LoadBackpackResponse} LoadBackpackResponse instance
         */
        LoadBackpackResponse.create = function create(properties) {
            return new LoadBackpackResponse(properties);
        };

        /**
         * Creates a LoadBackpackResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LoadBackpackResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LoadBackpackResponse} LoadBackpackResponse
         */
        LoadBackpackResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LoadBackpackResponse)
                return object;
            return new $root.pond.LoadBackpackResponse();
        };

        /**
         * Creates a plain object from a LoadBackpackResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LoadBackpackResponse
         * @static
         * @param {pond.LoadBackpackResponse} message LoadBackpackResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoadBackpackResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this LoadBackpackResponse to JSON.
         * @function toJSON
         * @memberof pond.LoadBackpackResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoadBackpackResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LoadBackpackResponse;
    })();

    pond.ClearDeviceRequest = (function() {

        /**
         * Properties of a ClearDeviceRequest.
         * @memberof pond
         * @interface IClearDeviceRequest
         * @property {number|null} [device] ClearDeviceRequest device
         */

        /**
         * Constructs a new ClearDeviceRequest.
         * @memberof pond
         * @classdesc Represents a ClearDeviceRequest.
         * @implements IClearDeviceRequest
         * @constructor
         * @param {pond.IClearDeviceRequest=} [properties] Properties to set
         */
        function ClearDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClearDeviceRequest device.
         * @member {number} device
         * @memberof pond.ClearDeviceRequest
         * @instance
         */
        ClearDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ClearDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.ClearDeviceRequest
         * @static
         * @param {pond.IClearDeviceRequest=} [properties] Properties to set
         * @returns {pond.ClearDeviceRequest} ClearDeviceRequest instance
         */
        ClearDeviceRequest.create = function create(properties) {
            return new ClearDeviceRequest(properties);
        };

        /**
         * Creates a ClearDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearDeviceRequest} ClearDeviceRequest
         */
        ClearDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearDeviceRequest)
                return object;
            var message = new $root.pond.ClearDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ClearDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearDeviceRequest
         * @static
         * @param {pond.ClearDeviceRequest} message ClearDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this ClearDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.ClearDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearDeviceRequest;
    })();

    pond.ClearDeviceResponse = (function() {

        /**
         * Properties of a ClearDeviceResponse.
         * @memberof pond
         * @interface IClearDeviceResponse
         */

        /**
         * Constructs a new ClearDeviceResponse.
         * @memberof pond
         * @classdesc Represents a ClearDeviceResponse.
         * @implements IClearDeviceResponse
         * @constructor
         * @param {pond.IClearDeviceResponse=} [properties] Properties to set
         */
        function ClearDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ClearDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.ClearDeviceResponse
         * @static
         * @param {pond.IClearDeviceResponse=} [properties] Properties to set
         * @returns {pond.ClearDeviceResponse} ClearDeviceResponse instance
         */
        ClearDeviceResponse.create = function create(properties) {
            return new ClearDeviceResponse(properties);
        };

        /**
         * Creates a ClearDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ClearDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ClearDeviceResponse} ClearDeviceResponse
         */
        ClearDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ClearDeviceResponse)
                return object;
            return new $root.pond.ClearDeviceResponse();
        };

        /**
         * Creates a plain object from a ClearDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ClearDeviceResponse
         * @static
         * @param {pond.ClearDeviceResponse} message ClearDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ClearDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.ClearDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearDeviceResponse;
    })();

    pond.PauseDeviceRequest = (function() {

        /**
         * Properties of a PauseDeviceRequest.
         * @memberof pond
         * @interface IPauseDeviceRequest
         * @property {number|null} [device] PauseDeviceRequest device
         */

        /**
         * Constructs a new PauseDeviceRequest.
         * @memberof pond
         * @classdesc Represents a PauseDeviceRequest.
         * @implements IPauseDeviceRequest
         * @constructor
         * @param {pond.IPauseDeviceRequest=} [properties] Properties to set
         */
        function PauseDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PauseDeviceRequest device.
         * @member {number} device
         * @memberof pond.PauseDeviceRequest
         * @instance
         */
        PauseDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new PauseDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.PauseDeviceRequest
         * @static
         * @param {pond.IPauseDeviceRequest=} [properties] Properties to set
         * @returns {pond.PauseDeviceRequest} PauseDeviceRequest instance
         */
        PauseDeviceRequest.create = function create(properties) {
            return new PauseDeviceRequest(properties);
        };

        /**
         * Creates a PauseDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.PauseDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.PauseDeviceRequest} PauseDeviceRequest
         */
        PauseDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.PauseDeviceRequest)
                return object;
            var message = new $root.pond.PauseDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a PauseDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.PauseDeviceRequest
         * @static
         * @param {pond.PauseDeviceRequest} message PauseDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PauseDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this PauseDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.PauseDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PauseDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PauseDeviceRequest;
    })();

    pond.PauseDeviceResponse = (function() {

        /**
         * Properties of a PauseDeviceResponse.
         * @memberof pond
         * @interface IPauseDeviceResponse
         */

        /**
         * Constructs a new PauseDeviceResponse.
         * @memberof pond
         * @classdesc Represents a PauseDeviceResponse.
         * @implements IPauseDeviceResponse
         * @constructor
         * @param {pond.IPauseDeviceResponse=} [properties] Properties to set
         */
        function PauseDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new PauseDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.PauseDeviceResponse
         * @static
         * @param {pond.IPauseDeviceResponse=} [properties] Properties to set
         * @returns {pond.PauseDeviceResponse} PauseDeviceResponse instance
         */
        PauseDeviceResponse.create = function create(properties) {
            return new PauseDeviceResponse(properties);
        };

        /**
         * Creates a PauseDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.PauseDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.PauseDeviceResponse} PauseDeviceResponse
         */
        PauseDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.PauseDeviceResponse)
                return object;
            return new $root.pond.PauseDeviceResponse();
        };

        /**
         * Creates a plain object from a PauseDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.PauseDeviceResponse
         * @static
         * @param {pond.PauseDeviceResponse} message PauseDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PauseDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this PauseDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.PauseDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PauseDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PauseDeviceResponse;
    })();

    pond.ResumeDeviceRequest = (function() {

        /**
         * Properties of a ResumeDeviceRequest.
         * @memberof pond
         * @interface IResumeDeviceRequest
         * @property {number|null} [device] ResumeDeviceRequest device
         */

        /**
         * Constructs a new ResumeDeviceRequest.
         * @memberof pond
         * @classdesc Represents a ResumeDeviceRequest.
         * @implements IResumeDeviceRequest
         * @constructor
         * @param {pond.IResumeDeviceRequest=} [properties] Properties to set
         */
        function ResumeDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResumeDeviceRequest device.
         * @member {number} device
         * @memberof pond.ResumeDeviceRequest
         * @instance
         */
        ResumeDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ResumeDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.ResumeDeviceRequest
         * @static
         * @param {pond.IResumeDeviceRequest=} [properties] Properties to set
         * @returns {pond.ResumeDeviceRequest} ResumeDeviceRequest instance
         */
        ResumeDeviceRequest.create = function create(properties) {
            return new ResumeDeviceRequest(properties);
        };

        /**
         * Creates a ResumeDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResumeDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResumeDeviceRequest} ResumeDeviceRequest
         */
        ResumeDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResumeDeviceRequest)
                return object;
            var message = new $root.pond.ResumeDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ResumeDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResumeDeviceRequest
         * @static
         * @param {pond.ResumeDeviceRequest} message ResumeDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResumeDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this ResumeDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.ResumeDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResumeDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResumeDeviceRequest;
    })();

    pond.ResumeDeviceResponse = (function() {

        /**
         * Properties of a ResumeDeviceResponse.
         * @memberof pond
         * @interface IResumeDeviceResponse
         */

        /**
         * Constructs a new ResumeDeviceResponse.
         * @memberof pond
         * @classdesc Represents a ResumeDeviceResponse.
         * @implements IResumeDeviceResponse
         * @constructor
         * @param {pond.IResumeDeviceResponse=} [properties] Properties to set
         */
        function ResumeDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ResumeDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.ResumeDeviceResponse
         * @static
         * @param {pond.IResumeDeviceResponse=} [properties] Properties to set
         * @returns {pond.ResumeDeviceResponse} ResumeDeviceResponse instance
         */
        ResumeDeviceResponse.create = function create(properties) {
            return new ResumeDeviceResponse(properties);
        };

        /**
         * Creates a ResumeDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ResumeDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ResumeDeviceResponse} ResumeDeviceResponse
         */
        ResumeDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ResumeDeviceResponse)
                return object;
            return new $root.pond.ResumeDeviceResponse();
        };

        /**
         * Creates a plain object from a ResumeDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ResumeDeviceResponse
         * @static
         * @param {pond.ResumeDeviceResponse} message ResumeDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResumeDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ResumeDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.ResumeDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResumeDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResumeDeviceResponse;
    })();

    pond.ConnectWifiDeviceRequest = (function() {

        /**
         * Properties of a ConnectWifiDeviceRequest.
         * @memberof pond
         * @interface IConnectWifiDeviceRequest
         * @property {number|null} [deviceId] ConnectWifiDeviceRequest deviceId
         * @property {string|null} [gateway] ConnectWifiDeviceRequest gateway
         * @property {string|null} [password] ConnectWifiDeviceRequest password
         */

        /**
         * Constructs a new ConnectWifiDeviceRequest.
         * @memberof pond
         * @classdesc Represents a ConnectWifiDeviceRequest.
         * @implements IConnectWifiDeviceRequest
         * @constructor
         * @param {pond.IConnectWifiDeviceRequest=} [properties] Properties to set
         */
        function ConnectWifiDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConnectWifiDeviceRequest deviceId.
         * @member {number} deviceId
         * @memberof pond.ConnectWifiDeviceRequest
         * @instance
         */
        ConnectWifiDeviceRequest.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ConnectWifiDeviceRequest gateway.
         * @member {string} gateway
         * @memberof pond.ConnectWifiDeviceRequest
         * @instance
         */
        ConnectWifiDeviceRequest.prototype.gateway = "";

        /**
         * ConnectWifiDeviceRequest password.
         * @member {string} password
         * @memberof pond.ConnectWifiDeviceRequest
         * @instance
         */
        ConnectWifiDeviceRequest.prototype.password = "";

        /**
         * Creates a new ConnectWifiDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.ConnectWifiDeviceRequest
         * @static
         * @param {pond.IConnectWifiDeviceRequest=} [properties] Properties to set
         * @returns {pond.ConnectWifiDeviceRequest} ConnectWifiDeviceRequest instance
         */
        ConnectWifiDeviceRequest.create = function create(properties) {
            return new ConnectWifiDeviceRequest(properties);
        };

        /**
         * Creates a ConnectWifiDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ConnectWifiDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ConnectWifiDeviceRequest} ConnectWifiDeviceRequest
         */
        ConnectWifiDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ConnectWifiDeviceRequest)
                return object;
            var message = new $root.pond.ConnectWifiDeviceRequest();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.gateway != null)
                message.gateway = String(object.gateway);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a ConnectWifiDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ConnectWifiDeviceRequest
         * @static
         * @param {pond.ConnectWifiDeviceRequest} message ConnectWifiDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectWifiDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.gateway = "";
                object.password = "";
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.gateway != null && message.hasOwnProperty("gateway"))
                object.gateway = message.gateway;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            return object;
        };

        /**
         * Converts this ConnectWifiDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.ConnectWifiDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConnectWifiDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConnectWifiDeviceRequest;
    })();

    pond.DeviceMetrics = (function() {

        /**
         * Properties of a DeviceMetrics.
         * @memberof pond
         * @interface IDeviceMetrics
         * @property {number|null} [groups] DeviceMetrics groups
         * @property {number|null} [devices] DeviceMetrics devices
         * @property {number|null} [components] DeviceMetrics components
         * @property {number|null} [alarmingDevices] DeviceMetrics alarmingDevices
         * @property {number|null} [unknownDevices] DeviceMetrics unknownDevices
         * @property {number|null} [outdatedDevices] DeviceMetrics outdatedDevices
         * @property {number|null} [warningDevices] DeviceMetrics warningDevices
         */

        /**
         * Constructs a new DeviceMetrics.
         * @memberof pond
         * @classdesc Represents a DeviceMetrics.
         * @implements IDeviceMetrics
         * @constructor
         * @param {pond.IDeviceMetrics=} [properties] Properties to set
         */
        function DeviceMetrics(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceMetrics groups.
         * @member {number} groups
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.groups = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics devices.
         * @member {number} devices
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.devices = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics components.
         * @member {number} components
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.components = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics alarmingDevices.
         * @member {number} alarmingDevices
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.alarmingDevices = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics unknownDevices.
         * @member {number} unknownDevices
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.unknownDevices = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics outdatedDevices.
         * @member {number} outdatedDevices
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.outdatedDevices = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceMetrics warningDevices.
         * @member {number} warningDevices
         * @memberof pond.DeviceMetrics
         * @instance
         */
        DeviceMetrics.prototype.warningDevices = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new DeviceMetrics instance using the specified properties.
         * @function create
         * @memberof pond.DeviceMetrics
         * @static
         * @param {pond.IDeviceMetrics=} [properties] Properties to set
         * @returns {pond.DeviceMetrics} DeviceMetrics instance
         */
        DeviceMetrics.create = function create(properties) {
            return new DeviceMetrics(properties);
        };

        /**
         * Creates a DeviceMetrics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceMetrics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceMetrics} DeviceMetrics
         */
        DeviceMetrics.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceMetrics)
                return object;
            var message = new $root.pond.DeviceMetrics();
            if (object.groups != null)
                if ($util.Long)
                    (message.groups = $util.Long.fromValue(object.groups)).unsigned = true;
                else if (typeof object.groups === "string")
                    message.groups = parseInt(object.groups, 10);
                else if (typeof object.groups === "number")
                    message.groups = object.groups;
                else if (typeof object.groups === "object")
                    message.groups = new $util.LongBits(object.groups.low >>> 0, object.groups.high >>> 0).toNumber(true);
            if (object.devices != null)
                if ($util.Long)
                    (message.devices = $util.Long.fromValue(object.devices)).unsigned = true;
                else if (typeof object.devices === "string")
                    message.devices = parseInt(object.devices, 10);
                else if (typeof object.devices === "number")
                    message.devices = object.devices;
                else if (typeof object.devices === "object")
                    message.devices = new $util.LongBits(object.devices.low >>> 0, object.devices.high >>> 0).toNumber(true);
            if (object.components != null)
                if ($util.Long)
                    (message.components = $util.Long.fromValue(object.components)).unsigned = true;
                else if (typeof object.components === "string")
                    message.components = parseInt(object.components, 10);
                else if (typeof object.components === "number")
                    message.components = object.components;
                else if (typeof object.components === "object")
                    message.components = new $util.LongBits(object.components.low >>> 0, object.components.high >>> 0).toNumber(true);
            if (object.alarmingDevices != null)
                if ($util.Long)
                    (message.alarmingDevices = $util.Long.fromValue(object.alarmingDevices)).unsigned = true;
                else if (typeof object.alarmingDevices === "string")
                    message.alarmingDevices = parseInt(object.alarmingDevices, 10);
                else if (typeof object.alarmingDevices === "number")
                    message.alarmingDevices = object.alarmingDevices;
                else if (typeof object.alarmingDevices === "object")
                    message.alarmingDevices = new $util.LongBits(object.alarmingDevices.low >>> 0, object.alarmingDevices.high >>> 0).toNumber(true);
            if (object.unknownDevices != null)
                if ($util.Long)
                    (message.unknownDevices = $util.Long.fromValue(object.unknownDevices)).unsigned = true;
                else if (typeof object.unknownDevices === "string")
                    message.unknownDevices = parseInt(object.unknownDevices, 10);
                else if (typeof object.unknownDevices === "number")
                    message.unknownDevices = object.unknownDevices;
                else if (typeof object.unknownDevices === "object")
                    message.unknownDevices = new $util.LongBits(object.unknownDevices.low >>> 0, object.unknownDevices.high >>> 0).toNumber(true);
            if (object.outdatedDevices != null)
                if ($util.Long)
                    (message.outdatedDevices = $util.Long.fromValue(object.outdatedDevices)).unsigned = true;
                else if (typeof object.outdatedDevices === "string")
                    message.outdatedDevices = parseInt(object.outdatedDevices, 10);
                else if (typeof object.outdatedDevices === "number")
                    message.outdatedDevices = object.outdatedDevices;
                else if (typeof object.outdatedDevices === "object")
                    message.outdatedDevices = new $util.LongBits(object.outdatedDevices.low >>> 0, object.outdatedDevices.high >>> 0).toNumber(true);
            if (object.warningDevices != null)
                if ($util.Long)
                    (message.warningDevices = $util.Long.fromValue(object.warningDevices)).unsigned = true;
                else if (typeof object.warningDevices === "string")
                    message.warningDevices = parseInt(object.warningDevices, 10);
                else if (typeof object.warningDevices === "number")
                    message.warningDevices = object.warningDevices;
                else if (typeof object.warningDevices === "object")
                    message.warningDevices = new $util.LongBits(object.warningDevices.low >>> 0, object.warningDevices.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a DeviceMetrics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceMetrics
         * @static
         * @param {pond.DeviceMetrics} message DeviceMetrics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceMetrics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.groups = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.groups = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.devices = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.devices = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.components = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.components = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.alarmingDevices = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.alarmingDevices = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.unknownDevices = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unknownDevices = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.outdatedDevices = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.outdatedDevices = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.warningDevices = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.warningDevices = options.longs === String ? "0" : 0;
            }
            if (message.groups != null && message.hasOwnProperty("groups"))
                if (typeof message.groups === "number")
                    object.groups = options.longs === String ? String(message.groups) : message.groups;
                else
                    object.groups = options.longs === String ? $util.Long.prototype.toString.call(message.groups) : options.longs === Number ? new $util.LongBits(message.groups.low >>> 0, message.groups.high >>> 0).toNumber(true) : message.groups;
            if (message.devices != null && message.hasOwnProperty("devices"))
                if (typeof message.devices === "number")
                    object.devices = options.longs === String ? String(message.devices) : message.devices;
                else
                    object.devices = options.longs === String ? $util.Long.prototype.toString.call(message.devices) : options.longs === Number ? new $util.LongBits(message.devices.low >>> 0, message.devices.high >>> 0).toNumber(true) : message.devices;
            if (message.components != null && message.hasOwnProperty("components"))
                if (typeof message.components === "number")
                    object.components = options.longs === String ? String(message.components) : message.components;
                else
                    object.components = options.longs === String ? $util.Long.prototype.toString.call(message.components) : options.longs === Number ? new $util.LongBits(message.components.low >>> 0, message.components.high >>> 0).toNumber(true) : message.components;
            if (message.alarmingDevices != null && message.hasOwnProperty("alarmingDevices"))
                if (typeof message.alarmingDevices === "number")
                    object.alarmingDevices = options.longs === String ? String(message.alarmingDevices) : message.alarmingDevices;
                else
                    object.alarmingDevices = options.longs === String ? $util.Long.prototype.toString.call(message.alarmingDevices) : options.longs === Number ? new $util.LongBits(message.alarmingDevices.low >>> 0, message.alarmingDevices.high >>> 0).toNumber(true) : message.alarmingDevices;
            if (message.unknownDevices != null && message.hasOwnProperty("unknownDevices"))
                if (typeof message.unknownDevices === "number")
                    object.unknownDevices = options.longs === String ? String(message.unknownDevices) : message.unknownDevices;
                else
                    object.unknownDevices = options.longs === String ? $util.Long.prototype.toString.call(message.unknownDevices) : options.longs === Number ? new $util.LongBits(message.unknownDevices.low >>> 0, message.unknownDevices.high >>> 0).toNumber(true) : message.unknownDevices;
            if (message.outdatedDevices != null && message.hasOwnProperty("outdatedDevices"))
                if (typeof message.outdatedDevices === "number")
                    object.outdatedDevices = options.longs === String ? String(message.outdatedDevices) : message.outdatedDevices;
                else
                    object.outdatedDevices = options.longs === String ? $util.Long.prototype.toString.call(message.outdatedDevices) : options.longs === Number ? new $util.LongBits(message.outdatedDevices.low >>> 0, message.outdatedDevices.high >>> 0).toNumber(true) : message.outdatedDevices;
            if (message.warningDevices != null && message.hasOwnProperty("warningDevices"))
                if (typeof message.warningDevices === "number")
                    object.warningDevices = options.longs === String ? String(message.warningDevices) : message.warningDevices;
                else
                    object.warningDevices = options.longs === String ? $util.Long.prototype.toString.call(message.warningDevices) : options.longs === Number ? new $util.LongBits(message.warningDevices.low >>> 0, message.warningDevices.high >>> 0).toNumber(true) : message.warningDevices;
            return object;
        };

        /**
         * Converts this DeviceMetrics to JSON.
         * @function toJSON
         * @memberof pond.DeviceMetrics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceMetrics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceMetrics;
    })();

    pond.GetMetricsRequest = (function() {

        /**
         * Properties of a GetMetricsRequest.
         * @memberof pond
         * @interface IGetMetricsRequest
         */

        /**
         * Constructs a new GetMetricsRequest.
         * @memberof pond
         * @classdesc Represents a GetMetricsRequest.
         * @implements IGetMetricsRequest
         * @constructor
         * @param {pond.IGetMetricsRequest=} [properties] Properties to set
         */
        function GetMetricsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetMetricsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMetricsRequest
         * @static
         * @param {pond.IGetMetricsRequest=} [properties] Properties to set
         * @returns {pond.GetMetricsRequest} GetMetricsRequest instance
         */
        GetMetricsRequest.create = function create(properties) {
            return new GetMetricsRequest(properties);
        };

        /**
         * Creates a GetMetricsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMetricsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMetricsRequest} GetMetricsRequest
         */
        GetMetricsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMetricsRequest)
                return object;
            return new $root.pond.GetMetricsRequest();
        };

        /**
         * Creates a plain object from a GetMetricsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMetricsRequest
         * @static
         * @param {pond.GetMetricsRequest} message GetMetricsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetricsRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetMetricsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMetricsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetricsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMetricsRequest;
    })();

    pond.GetMetricsResponse = (function() {

        /**
         * Properties of a GetMetricsResponse.
         * @memberof pond
         * @interface IGetMetricsResponse
         * @property {pond.DeviceMetrics|null} [deviceMetrics] GetMetricsResponse deviceMetrics
         */

        /**
         * Constructs a new GetMetricsResponse.
         * @memberof pond
         * @classdesc Represents a GetMetricsResponse.
         * @implements IGetMetricsResponse
         * @constructor
         * @param {pond.IGetMetricsResponse=} [properties] Properties to set
         */
        function GetMetricsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMetricsResponse deviceMetrics.
         * @member {pond.DeviceMetrics|null|undefined} deviceMetrics
         * @memberof pond.GetMetricsResponse
         * @instance
         */
        GetMetricsResponse.prototype.deviceMetrics = null;

        /**
         * Creates a new GetMetricsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMetricsResponse
         * @static
         * @param {pond.IGetMetricsResponse=} [properties] Properties to set
         * @returns {pond.GetMetricsResponse} GetMetricsResponse instance
         */
        GetMetricsResponse.create = function create(properties) {
            return new GetMetricsResponse(properties);
        };

        /**
         * Creates a GetMetricsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMetricsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMetricsResponse} GetMetricsResponse
         */
        GetMetricsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMetricsResponse)
                return object;
            var message = new $root.pond.GetMetricsResponse();
            if (object.deviceMetrics != null) {
                if (typeof object.deviceMetrics !== "object")
                    throw TypeError(".pond.GetMetricsResponse.deviceMetrics: object expected");
                message.deviceMetrics = $root.pond.DeviceMetrics.fromObject(object.deviceMetrics);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMetricsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMetricsResponse
         * @static
         * @param {pond.GetMetricsResponse} message GetMetricsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetricsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.deviceMetrics = null;
            if (message.deviceMetrics != null && message.hasOwnProperty("deviceMetrics"))
                object.deviceMetrics = $root.pond.DeviceMetrics.toObject(message.deviceMetrics, options);
            return object;
        };

        /**
         * Converts this GetMetricsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMetricsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetricsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMetricsResponse;
    })();

    pond.ConnectWifiDeviceResponse = (function() {

        /**
         * Properties of a ConnectWifiDeviceResponse.
         * @memberof pond
         * @interface IConnectWifiDeviceResponse
         */

        /**
         * Constructs a new ConnectWifiDeviceResponse.
         * @memberof pond
         * @classdesc Represents a ConnectWifiDeviceResponse.
         * @implements IConnectWifiDeviceResponse
         * @constructor
         * @param {pond.IConnectWifiDeviceResponse=} [properties] Properties to set
         */
        function ConnectWifiDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ConnectWifiDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.ConnectWifiDeviceResponse
         * @static
         * @param {pond.IConnectWifiDeviceResponse=} [properties] Properties to set
         * @returns {pond.ConnectWifiDeviceResponse} ConnectWifiDeviceResponse instance
         */
        ConnectWifiDeviceResponse.create = function create(properties) {
            return new ConnectWifiDeviceResponse(properties);
        };

        /**
         * Creates a ConnectWifiDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ConnectWifiDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ConnectWifiDeviceResponse} ConnectWifiDeviceResponse
         */
        ConnectWifiDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ConnectWifiDeviceResponse)
                return object;
            return new $root.pond.ConnectWifiDeviceResponse();
        };

        /**
         * Creates a plain object from a ConnectWifiDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ConnectWifiDeviceResponse
         * @static
         * @param {pond.ConnectWifiDeviceResponse} message ConnectWifiDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectWifiDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ConnectWifiDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.ConnectWifiDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConnectWifiDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConnectWifiDeviceResponse;
    })();

    pond.UpdateDeviceComponentPreferencesRequest = (function() {

        /**
         * Properties of an UpdateDeviceComponentPreferencesRequest.
         * @memberof pond
         * @interface IUpdateDeviceComponentPreferencesRequest
         * @property {number|null} [device] UpdateDeviceComponentPreferencesRequest device
         * @property {string|null} [component] UpdateDeviceComponentPreferencesRequest component
         * @property {pond.DeviceComponentPreferences|null} [preferences] UpdateDeviceComponentPreferencesRequest preferences
         */

        /**
         * Constructs a new UpdateDeviceComponentPreferencesRequest.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceComponentPreferencesRequest.
         * @implements IUpdateDeviceComponentPreferencesRequest
         * @constructor
         * @param {pond.IUpdateDeviceComponentPreferencesRequest=} [properties] Properties to set
         */
        function UpdateDeviceComponentPreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDeviceComponentPreferencesRequest device.
         * @member {number} device
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @instance
         */
        UpdateDeviceComponentPreferencesRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpdateDeviceComponentPreferencesRequest component.
         * @member {string} component
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @instance
         */
        UpdateDeviceComponentPreferencesRequest.prototype.component = "";

        /**
         * UpdateDeviceComponentPreferencesRequest preferences.
         * @member {pond.DeviceComponentPreferences|null|undefined} preferences
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @instance
         */
        UpdateDeviceComponentPreferencesRequest.prototype.preferences = null;

        /**
         * Creates a new UpdateDeviceComponentPreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @static
         * @param {pond.IUpdateDeviceComponentPreferencesRequest=} [properties] Properties to set
         * @returns {pond.UpdateDeviceComponentPreferencesRequest} UpdateDeviceComponentPreferencesRequest instance
         */
        UpdateDeviceComponentPreferencesRequest.create = function create(properties) {
            return new UpdateDeviceComponentPreferencesRequest(properties);
        };

        /**
         * Creates an UpdateDeviceComponentPreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceComponentPreferencesRequest} UpdateDeviceComponentPreferencesRequest
         */
        UpdateDeviceComponentPreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceComponentPreferencesRequest)
                return object;
            var message = new $root.pond.UpdateDeviceComponentPreferencesRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.UpdateDeviceComponentPreferencesRequest.preferences: object expected");
                message.preferences = $root.pond.DeviceComponentPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateDeviceComponentPreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @static
         * @param {pond.UpdateDeviceComponentPreferencesRequest} message UpdateDeviceComponentPreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceComponentPreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.preferences = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.DeviceComponentPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this UpdateDeviceComponentPreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceComponentPreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceComponentPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceComponentPreferencesRequest;
    })();

    pond.UpdateDeviceComponentPreferencesResponse = (function() {

        /**
         * Properties of an UpdateDeviceComponentPreferencesResponse.
         * @memberof pond
         * @interface IUpdateDeviceComponentPreferencesResponse
         */

        /**
         * Constructs a new UpdateDeviceComponentPreferencesResponse.
         * @memberof pond
         * @classdesc Represents an UpdateDeviceComponentPreferencesResponse.
         * @implements IUpdateDeviceComponentPreferencesResponse
         * @constructor
         * @param {pond.IUpdateDeviceComponentPreferencesResponse=} [properties] Properties to set
         */
        function UpdateDeviceComponentPreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateDeviceComponentPreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDeviceComponentPreferencesResponse
         * @static
         * @param {pond.IUpdateDeviceComponentPreferencesResponse=} [properties] Properties to set
         * @returns {pond.UpdateDeviceComponentPreferencesResponse} UpdateDeviceComponentPreferencesResponse instance
         */
        UpdateDeviceComponentPreferencesResponse.create = function create(properties) {
            return new UpdateDeviceComponentPreferencesResponse(properties);
        };

        /**
         * Creates an UpdateDeviceComponentPreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDeviceComponentPreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDeviceComponentPreferencesResponse} UpdateDeviceComponentPreferencesResponse
         */
        UpdateDeviceComponentPreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDeviceComponentPreferencesResponse)
                return object;
            return new $root.pond.UpdateDeviceComponentPreferencesResponse();
        };

        /**
         * Creates a plain object from an UpdateDeviceComponentPreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDeviceComponentPreferencesResponse
         * @static
         * @param {pond.UpdateDeviceComponentPreferencesResponse} message UpdateDeviceComponentPreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDeviceComponentPreferencesResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateDeviceComponentPreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateDeviceComponentPreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDeviceComponentPreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDeviceComponentPreferencesResponse;
    })();

    pond.ListDeviceComponentPreferencesRequest = (function() {

        /**
         * Properties of a ListDeviceComponentPreferencesRequest.
         * @memberof pond
         * @interface IListDeviceComponentPreferencesRequest
         * @property {string|null} [device] ListDeviceComponentPreferencesRequest device
         */

        /**
         * Constructs a new ListDeviceComponentPreferencesRequest.
         * @memberof pond
         * @classdesc Represents a ListDeviceComponentPreferencesRequest.
         * @implements IListDeviceComponentPreferencesRequest
         * @constructor
         * @param {pond.IListDeviceComponentPreferencesRequest=} [properties] Properties to set
         */
        function ListDeviceComponentPreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceComponentPreferencesRequest device.
         * @member {string} device
         * @memberof pond.ListDeviceComponentPreferencesRequest
         * @instance
         */
        ListDeviceComponentPreferencesRequest.prototype.device = "";

        /**
         * Creates a new ListDeviceComponentPreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceComponentPreferencesRequest
         * @static
         * @param {pond.IListDeviceComponentPreferencesRequest=} [properties] Properties to set
         * @returns {pond.ListDeviceComponentPreferencesRequest} ListDeviceComponentPreferencesRequest instance
         */
        ListDeviceComponentPreferencesRequest.create = function create(properties) {
            return new ListDeviceComponentPreferencesRequest(properties);
        };

        /**
         * Creates a ListDeviceComponentPreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceComponentPreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceComponentPreferencesRequest} ListDeviceComponentPreferencesRequest
         */
        ListDeviceComponentPreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceComponentPreferencesRequest)
                return object;
            var message = new $root.pond.ListDeviceComponentPreferencesRequest();
            if (object.device != null)
                message.device = String(object.device);
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceComponentPreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceComponentPreferencesRequest
         * @static
         * @param {pond.ListDeviceComponentPreferencesRequest} message ListDeviceComponentPreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceComponentPreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.device = "";
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            return object;
        };

        /**
         * Converts this ListDeviceComponentPreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceComponentPreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceComponentPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceComponentPreferencesRequest;
    })();

    pond.ListDeviceComponentPreferencesResponse = (function() {

        /**
         * Properties of a ListDeviceComponentPreferencesResponse.
         * @memberof pond
         * @interface IListDeviceComponentPreferencesResponse
         * @property {Object.<string,pond.DeviceComponentPreferences>|null} [preferences] ListDeviceComponentPreferencesResponse preferences
         */

        /**
         * Constructs a new ListDeviceComponentPreferencesResponse.
         * @memberof pond
         * @classdesc Represents a ListDeviceComponentPreferencesResponse.
         * @implements IListDeviceComponentPreferencesResponse
         * @constructor
         * @param {pond.IListDeviceComponentPreferencesResponse=} [properties] Properties to set
         */
        function ListDeviceComponentPreferencesResponse(properties) {
            this.preferences = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceComponentPreferencesResponse preferences.
         * @member {Object.<string,pond.DeviceComponentPreferences>} preferences
         * @memberof pond.ListDeviceComponentPreferencesResponse
         * @instance
         */
        ListDeviceComponentPreferencesResponse.prototype.preferences = $util.emptyObject;

        /**
         * Creates a new ListDeviceComponentPreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceComponentPreferencesResponse
         * @static
         * @param {pond.IListDeviceComponentPreferencesResponse=} [properties] Properties to set
         * @returns {pond.ListDeviceComponentPreferencesResponse} ListDeviceComponentPreferencesResponse instance
         */
        ListDeviceComponentPreferencesResponse.create = function create(properties) {
            return new ListDeviceComponentPreferencesResponse(properties);
        };

        /**
         * Creates a ListDeviceComponentPreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceComponentPreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceComponentPreferencesResponse} ListDeviceComponentPreferencesResponse
         */
        ListDeviceComponentPreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceComponentPreferencesResponse)
                return object;
            var message = new $root.pond.ListDeviceComponentPreferencesResponse();
            if (object.preferences) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.ListDeviceComponentPreferencesResponse.preferences: object expected");
                message.preferences = {};
                for (var keys = Object.keys(object.preferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.preferences[keys[i]] !== "object")
                        throw TypeError(".pond.ListDeviceComponentPreferencesResponse.preferences: object expected");
                    message.preferences[keys[i]] = $root.pond.DeviceComponentPreferences.fromObject(object.preferences[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceComponentPreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceComponentPreferencesResponse
         * @static
         * @param {pond.ListDeviceComponentPreferencesResponse} message ListDeviceComponentPreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceComponentPreferencesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.preferences = {};
            var keys2;
            if (message.preferences && (keys2 = Object.keys(message.preferences)).length) {
                object.preferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.preferences[keys2[j]] = $root.pond.DeviceComponentPreferences.toObject(message.preferences[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this ListDeviceComponentPreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceComponentPreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceComponentPreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceComponentPreferencesResponse;
    })();

    /**
     * Grain enum.
     * @name pond.Grain
     * @enum {string}
     * @property {number} GRAIN_INVALID=0 GRAIN_INVALID value
     * @property {number} GRAIN_NONE=1 GRAIN_NONE value
     * @property {number} GRAIN_BARLEY=2 GRAIN_BARLEY value
     * @property {number} GRAIN_BUCKWHEAT=3 GRAIN_BUCKWHEAT value
     * @property {number} GRAIN_CANOLA=4 GRAIN_CANOLA value
     * @property {number} GRAIN_CORN=5 GRAIN_CORN value
     * @property {number} GRAIN_OATS=6 GRAIN_OATS value
     * @property {number} GRAIN_PEANUTS=7 GRAIN_PEANUTS value
     * @property {number} GRAIN_RAPESEED=8 GRAIN_RAPESEED value
     * @property {number} GRAIN_RICE_LONG=9 GRAIN_RICE_LONG value
     * @property {number} GRAIN_RICE_MEDIUM=10 GRAIN_RICE_MEDIUM value
     * @property {number} GRAIN_RICE_SHORT=11 GRAIN_RICE_SHORT value
     * @property {number} GRAIN_SORGHUM=12 GRAIN_SORGHUM value
     * @property {number} GRAIN_SOYBEANS=13 GRAIN_SOYBEANS value
     * @property {number} GRAIN_SUNFLOWER=14 GRAIN_SUNFLOWER value
     * @property {number} GRAIN_WHEAT_DURUM=15 GRAIN_WHEAT_DURUM value
     * @property {number} GRAIN_WHEAT_HARD_RED=16 GRAIN_WHEAT_HARD_RED value
     * @property {number} GRAIN_FLAX_UNRETTED=17 GRAIN_FLAX_UNRETTED value
     * @property {number} GRAIN_FLAX_DEW_RETTED=18 GRAIN_FLAX_DEW_RETTED value
     * @property {number} GRAIN_YELLOW_PEAS=19 GRAIN_YELLOW_PEAS value
     * @property {number} GRAIN_LENTILS_ROBIN=20 GRAIN_LENTILS_ROBIN value
     * @property {number} GRAIN_LENTILS_REDBERRY=21 GRAIN_LENTILS_REDBERRY value
     * @property {number} GRAIN_LENTILS_BLAZE=22 GRAIN_LENTILS_BLAZE value
     * @property {number} GRAIN_CUSTOM=23 GRAIN_CUSTOM value
     * @property {number} GRAIN_MAIZE_WHITE=24 GRAIN_MAIZE_WHITE value
     * @property {number} GRAIN_MAIZE_YELLOW=25 GRAIN_MAIZE_YELLOW value
     * @property {number} GRAIN_WHEAT_SAWOS=26 GRAIN_WHEAT_SAWOS value
     */
    pond.Grain = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GRAIN_INVALID"] = 0;
        values[valuesById[1] = "GRAIN_NONE"] = 1;
        values[valuesById[2] = "GRAIN_BARLEY"] = 2;
        values[valuesById[3] = "GRAIN_BUCKWHEAT"] = 3;
        values[valuesById[4] = "GRAIN_CANOLA"] = 4;
        values[valuesById[5] = "GRAIN_CORN"] = 5;
        values[valuesById[6] = "GRAIN_OATS"] = 6;
        values[valuesById[7] = "GRAIN_PEANUTS"] = 7;
        values[valuesById[8] = "GRAIN_RAPESEED"] = 8;
        values[valuesById[9] = "GRAIN_RICE_LONG"] = 9;
        values[valuesById[10] = "GRAIN_RICE_MEDIUM"] = 10;
        values[valuesById[11] = "GRAIN_RICE_SHORT"] = 11;
        values[valuesById[12] = "GRAIN_SORGHUM"] = 12;
        values[valuesById[13] = "GRAIN_SOYBEANS"] = 13;
        values[valuesById[14] = "GRAIN_SUNFLOWER"] = 14;
        values[valuesById[15] = "GRAIN_WHEAT_DURUM"] = 15;
        values[valuesById[16] = "GRAIN_WHEAT_HARD_RED"] = 16;
        values[valuesById[17] = "GRAIN_FLAX_UNRETTED"] = 17;
        values[valuesById[18] = "GRAIN_FLAX_DEW_RETTED"] = 18;
        values[valuesById[19] = "GRAIN_YELLOW_PEAS"] = 19;
        values[valuesById[20] = "GRAIN_LENTILS_ROBIN"] = 20;
        values[valuesById[21] = "GRAIN_LENTILS_REDBERRY"] = 21;
        values[valuesById[22] = "GRAIN_LENTILS_BLAZE"] = 22;
        values[valuesById[23] = "GRAIN_CUSTOM"] = 23;
        values[valuesById[24] = "GRAIN_MAIZE_WHITE"] = 24;
        values[valuesById[25] = "GRAIN_MAIZE_YELLOW"] = 25;
        values[valuesById[26] = "GRAIN_WHEAT_SAWOS"] = 26;
        return values;
    })();

    /**
     * BinComponent enum.
     * @name pond.BinComponent
     * @enum {string}
     * @property {number} BIN_COMPONENT_UNKNOWN=0 BIN_COMPONENT_UNKNOWN value
     * @property {number} BIN_COMPONENT_GRAIN_CABLE=1 BIN_COMPONENT_GRAIN_CABLE value
     * @property {number} BIN_COMPONENT_PLENUM=2 BIN_COMPONENT_PLENUM value
     * @property {number} BIN_COMPONENT_SECOND_PLENUM=3 BIN_COMPONENT_SECOND_PLENUM value
     * @property {number} BIN_COMPONENT_HEATER=4 BIN_COMPONENT_HEATER value
     * @property {number} BIN_COMPONENT_FAN=5 BIN_COMPONENT_FAN value
     * @property {number} BIN_COMPONENT_PRESSURE=6 BIN_COMPONENT_PRESSURE value
     * @property {number} BIN_COMPONENT_HEADSPACE=7 BIN_COMPONENT_HEADSPACE value
     * @property {number} BIN_COMPONENT_AMBIENT=8 BIN_COMPONENT_AMBIENT value
     */
    pond.BinComponent = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BIN_COMPONENT_UNKNOWN"] = 0;
        values[valuesById[1] = "BIN_COMPONENT_GRAIN_CABLE"] = 1;
        values[valuesById[2] = "BIN_COMPONENT_PLENUM"] = 2;
        values[valuesById[3] = "BIN_COMPONENT_SECOND_PLENUM"] = 3;
        values[valuesById[4] = "BIN_COMPONENT_HEATER"] = 4;
        values[valuesById[5] = "BIN_COMPONENT_FAN"] = 5;
        values[valuesById[6] = "BIN_COMPONENT_PRESSURE"] = 6;
        values[valuesById[7] = "BIN_COMPONENT_HEADSPACE"] = 7;
        values[valuesById[8] = "BIN_COMPONENT_AMBIENT"] = 8;
        return values;
    })();

    pond.ComponentOverlays = (function() {

        /**
         * Properties of a ComponentOverlays.
         * @memberof pond
         * @interface IComponentOverlays
         * @property {number|null} [min] ComponentOverlays min
         * @property {number|null} [max] ComponentOverlays max
         * @property {string|null} [colour] ComponentOverlays colour
         * @property {string|null} [message] ComponentOverlays message
         * @property {quack.MeasurementType|null} [measurementType] ComponentOverlays measurementType
         */

        /**
         * Constructs a new ComponentOverlays.
         * @memberof pond
         * @classdesc Represents a ComponentOverlays.
         * @implements IComponentOverlays
         * @constructor
         * @param {pond.IComponentOverlays=} [properties] Properties to set
         */
        function ComponentOverlays(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentOverlays min.
         * @member {number} min
         * @memberof pond.ComponentOverlays
         * @instance
         */
        ComponentOverlays.prototype.min = 0;

        /**
         * ComponentOverlays max.
         * @member {number} max
         * @memberof pond.ComponentOverlays
         * @instance
         */
        ComponentOverlays.prototype.max = 0;

        /**
         * ComponentOverlays colour.
         * @member {string} colour
         * @memberof pond.ComponentOverlays
         * @instance
         */
        ComponentOverlays.prototype.colour = "";

        /**
         * ComponentOverlays message.
         * @member {string} message
         * @memberof pond.ComponentOverlays
         * @instance
         */
        ComponentOverlays.prototype.message = "";

        /**
         * ComponentOverlays measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof pond.ComponentOverlays
         * @instance
         */
        ComponentOverlays.prototype.measurementType = 0;

        /**
         * Creates a new ComponentOverlays instance using the specified properties.
         * @function create
         * @memberof pond.ComponentOverlays
         * @static
         * @param {pond.IComponentOverlays=} [properties] Properties to set
         * @returns {pond.ComponentOverlays} ComponentOverlays instance
         */
        ComponentOverlays.create = function create(properties) {
            return new ComponentOverlays(properties);
        };

        /**
         * Creates a ComponentOverlays message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentOverlays
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentOverlays} ComponentOverlays
         */
        ComponentOverlays.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentOverlays)
                return object;
            var message = new $root.pond.ComponentOverlays();
            if (object.min != null)
                message.min = Number(object.min);
            if (object.max != null)
                message.max = Number(object.max);
            if (object.colour != null)
                message.colour = String(object.colour);
            if (object.message != null)
                message.message = String(object.message);
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ComponentOverlays message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentOverlays
         * @static
         * @param {pond.ComponentOverlays} message ComponentOverlays
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentOverlays.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.min = 0;
                object.max = 0;
                object.colour = "";
                object.message = "";
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            }
            if (message.min != null && message.hasOwnProperty("min"))
                object.min = options.json && !isFinite(message.min) ? String(message.min) : message.min;
            if (message.max != null && message.hasOwnProperty("max"))
                object.max = options.json && !isFinite(message.max) ? String(message.max) : message.max;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            return object;
        };

        /**
         * Converts this ComponentOverlays to JSON.
         * @function toJSON
         * @memberof pond.ComponentOverlays
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentOverlays.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentOverlays;
    })();

    pond.CurvePoint = (function() {

        /**
         * Properties of a CurvePoint.
         * @memberof pond
         * @interface ICurvePoint
         * @property {number|null} [airflow] CurvePoint airflow
         * @property {number|null} [pressure] CurvePoint pressure
         */

        /**
         * Constructs a new CurvePoint.
         * @memberof pond
         * @classdesc Represents a CurvePoint.
         * @implements ICurvePoint
         * @constructor
         * @param {pond.ICurvePoint=} [properties] Properties to set
         */
        function CurvePoint(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CurvePoint airflow.
         * @member {number} airflow
         * @memberof pond.CurvePoint
         * @instance
         */
        CurvePoint.prototype.airflow = 0;

        /**
         * CurvePoint pressure.
         * @member {number} pressure
         * @memberof pond.CurvePoint
         * @instance
         */
        CurvePoint.prototype.pressure = 0;

        /**
         * Creates a new CurvePoint instance using the specified properties.
         * @function create
         * @memberof pond.CurvePoint
         * @static
         * @param {pond.ICurvePoint=} [properties] Properties to set
         * @returns {pond.CurvePoint} CurvePoint instance
         */
        CurvePoint.create = function create(properties) {
            return new CurvePoint(properties);
        };

        /**
         * Creates a CurvePoint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CurvePoint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CurvePoint} CurvePoint
         */
        CurvePoint.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CurvePoint)
                return object;
            var message = new $root.pond.CurvePoint();
            if (object.airflow != null)
                message.airflow = Number(object.airflow);
            if (object.pressure != null)
                message.pressure = Number(object.pressure);
            return message;
        };

        /**
         * Creates a plain object from a CurvePoint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CurvePoint
         * @static
         * @param {pond.CurvePoint} message CurvePoint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CurvePoint.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.airflow = 0;
                object.pressure = 0;
            }
            if (message.airflow != null && message.hasOwnProperty("airflow"))
                object.airflow = options.json && !isFinite(message.airflow) ? String(message.airflow) : message.airflow;
            if (message.pressure != null && message.hasOwnProperty("pressure"))
                object.pressure = options.json && !isFinite(message.pressure) ? String(message.pressure) : message.pressure;
            return object;
        };

        /**
         * Converts this CurvePoint to JSON.
         * @function toJSON
         * @memberof pond.CurvePoint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CurvePoint.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CurvePoint;
    })();

    pond.Calibration = (function() {

        /**
         * Properties of a Calibration.
         * @memberof pond
         * @interface ICalibration
         * @property {number|null} [calibrationCoefficient] Calibration calibrationCoefficient
         * @property {number|null} [calibrationOffset] Calibration calibrationOffset
         * @property {quack.MeasurementType|null} [type] Calibration type
         */

        /**
         * Constructs a new Calibration.
         * @memberof pond
         * @classdesc Represents a Calibration.
         * @implements ICalibration
         * @constructor
         * @param {pond.ICalibration=} [properties] Properties to set
         */
        function Calibration(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Calibration calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof pond.Calibration
         * @instance
         */
        Calibration.prototype.calibrationCoefficient = 0;

        /**
         * Calibration calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof pond.Calibration
         * @instance
         */
        Calibration.prototype.calibrationOffset = 0;

        /**
         * Calibration type.
         * @member {quack.MeasurementType} type
         * @memberof pond.Calibration
         * @instance
         */
        Calibration.prototype.type = 0;

        /**
         * Creates a new Calibration instance using the specified properties.
         * @function create
         * @memberof pond.Calibration
         * @static
         * @param {pond.ICalibration=} [properties] Properties to set
         * @returns {pond.Calibration} Calibration instance
         */
        Calibration.create = function create(properties) {
            return new Calibration(properties);
        };

        /**
         * Creates a Calibration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Calibration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Calibration} Calibration
         */
        Calibration.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Calibration)
                return object;
            var message = new $root.pond.Calibration();
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            switch (object.type) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.type = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.type = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.type = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.type = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.type = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.type = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.type = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.type = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.type = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.type = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.type = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.type = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.type = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.type = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.type = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.type = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.type = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.type = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.type = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.type = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.type = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.type = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.type = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.type = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.type = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.type = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.type = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.type = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.type = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.type = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.type = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.type = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.type = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.type = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.type = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.type = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.type = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.type = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.type = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.type = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Calibration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Calibration
         * @static
         * @param {pond.Calibration} message Calibration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Calibration.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
                object.type = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            }
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.MeasurementType[message.type] : message.type;
            return object;
        };

        /**
         * Converts this Calibration to JSON.
         * @function toJSON
         * @memberof pond.Calibration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Calibration.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Calibration;
    })();

    pond.Dimensions = (function() {

        /**
         * Properties of a Dimensions.
         * @memberof pond
         * @interface IDimensions
         * @property {number|null} [lengthCm] Dimensions lengthCm
         * @property {number|null} [heightCm] Dimensions heightCm
         * @property {number|null} [widthCm] Dimensions widthCm
         */

        /**
         * Constructs a new Dimensions.
         * @memberof pond
         * @classdesc Represents a Dimensions.
         * @implements IDimensions
         * @constructor
         * @param {pond.IDimensions=} [properties] Properties to set
         */
        function Dimensions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Dimensions lengthCm.
         * @member {number} lengthCm
         * @memberof pond.Dimensions
         * @instance
         */
        Dimensions.prototype.lengthCm = 0;

        /**
         * Dimensions heightCm.
         * @member {number} heightCm
         * @memberof pond.Dimensions
         * @instance
         */
        Dimensions.prototype.heightCm = 0;

        /**
         * Dimensions widthCm.
         * @member {number} widthCm
         * @memberof pond.Dimensions
         * @instance
         */
        Dimensions.prototype.widthCm = 0;

        /**
         * Creates a new Dimensions instance using the specified properties.
         * @function create
         * @memberof pond.Dimensions
         * @static
         * @param {pond.IDimensions=} [properties] Properties to set
         * @returns {pond.Dimensions} Dimensions instance
         */
        Dimensions.create = function create(properties) {
            return new Dimensions(properties);
        };

        /**
         * Creates a Dimensions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Dimensions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Dimensions} Dimensions
         */
        Dimensions.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Dimensions)
                return object;
            var message = new $root.pond.Dimensions();
            if (object.lengthCm != null)
                message.lengthCm = Number(object.lengthCm);
            if (object.heightCm != null)
                message.heightCm = Number(object.heightCm);
            if (object.widthCm != null)
                message.widthCm = Number(object.widthCm);
            return message;
        };

        /**
         * Creates a plain object from a Dimensions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Dimensions
         * @static
         * @param {pond.Dimensions} message Dimensions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Dimensions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lengthCm = 0;
                object.heightCm = 0;
                object.widthCm = 0;
            }
            if (message.lengthCm != null && message.hasOwnProperty("lengthCm"))
                object.lengthCm = options.json && !isFinite(message.lengthCm) ? String(message.lengthCm) : message.lengthCm;
            if (message.heightCm != null && message.hasOwnProperty("heightCm"))
                object.heightCm = options.json && !isFinite(message.heightCm) ? String(message.heightCm) : message.heightCm;
            if (message.widthCm != null && message.hasOwnProperty("widthCm"))
                object.widthCm = options.json && !isFinite(message.widthCm) ? String(message.widthCm) : message.widthCm;
            return object;
        };

        /**
         * Converts this Dimensions to JSON.
         * @function toJSON
         * @memberof pond.Dimensions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Dimensions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Dimensions;
    })();

    pond.ComponentSettings = (function() {

        /**
         * Properties of a ComponentSettings.
         * @memberof pond
         * @interface IComponentSettings
         * @property {string|null} [key] ComponentSettings key
         * @property {quack.ComponentType|null} [type] ComponentSettings type
         * @property {number|null} [subtype] ComponentSettings subtype
         * @property {string|null} [name] ComponentSettings name
         * @property {number|null} [reportPeriodMs] ComponentSettings reportPeriodMs
         * @property {number|null} [measurementPeriodMs] ComponentSettings measurementPeriodMs
         * @property {number|null} [defaultOutputState] ComponentSettings defaultOutputState
         * @property {number|null} [minCycleTimeMs] ComponentSettings minCycleTimeMs
         * @property {string|null} [removed] ComponentSettings removed
         * @property {quack.AddressType|null} [addressType] ComponentSettings addressType
         * @property {number|null} [address] ComponentSettings address
         * @property {boolean|null} [calibrate] ComponentSettings calibrate
         * @property {number|null} [calibrationCoefficient] ComponentSettings calibrationCoefficient
         * @property {number|null} [calibrationOffset] ComponentSettings calibrationOffset
         * @property {pond.Grain|null} [grainType] ComponentSettings grainType
         * @property {number|null} [grainFilledTo] ComponentSettings grainFilledTo
         * @property {boolean|null} [hasOverlays] ComponentSettings hasOverlays
         * @property {Array.<pond.ComponentOverlays>|null} [overlays] ComponentSettings overlays
         * @property {Array.<pond.Mutator>|null} [defaultMutations] ComponentSettings defaultMutations
         * @property {number|null} [fanId] ComponentSettings fanId
         * @property {Array.<pond.CurvePoint>|null} [customCurve] ComponentSettings customCurve
         * @property {number|null} [smoothingAverages] ComponentSettings smoothingAverages
         * @property {Array.<pond.Calibration>|null} [calibrations] ComponentSettings calibrations
         * @property {pond.Dimensions|null} [containerDimensions] ComponentSettings containerDimensions
         * @property {number|null} [sensorDistanceCm] ComponentSettings sensorDistanceCm
         */

        /**
         * Constructs a new ComponentSettings.
         * @memberof pond
         * @classdesc Represents a ComponentSettings.
         * @implements IComponentSettings
         * @constructor
         * @param {pond.IComponentSettings=} [properties] Properties to set
         */
        function ComponentSettings(properties) {
            this.overlays = [];
            this.defaultMutations = [];
            this.customCurve = [];
            this.calibrations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentSettings key.
         * @member {string} key
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.key = "";

        /**
         * ComponentSettings type.
         * @member {quack.ComponentType} type
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.type = 0;

        /**
         * ComponentSettings subtype.
         * @member {number} subtype
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.subtype = 0;

        /**
         * ComponentSettings name.
         * @member {string} name
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.name = "";

        /**
         * ComponentSettings reportPeriodMs.
         * @member {number} reportPeriodMs
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.reportPeriodMs = 0;

        /**
         * ComponentSettings measurementPeriodMs.
         * @member {number} measurementPeriodMs
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.measurementPeriodMs = 0;

        /**
         * ComponentSettings defaultOutputState.
         * @member {number} defaultOutputState
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.defaultOutputState = 0;

        /**
         * ComponentSettings minCycleTimeMs.
         * @member {number} minCycleTimeMs
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.minCycleTimeMs = 0;

        /**
         * ComponentSettings removed.
         * @member {string} removed
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.removed = "";

        /**
         * ComponentSettings addressType.
         * @member {quack.AddressType} addressType
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.addressType = 0;

        /**
         * ComponentSettings address.
         * @member {number} address
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.address = 0;

        /**
         * ComponentSettings calibrate.
         * @member {boolean} calibrate
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.calibrate = false;

        /**
         * ComponentSettings calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.calibrationCoefficient = 0;

        /**
         * ComponentSettings calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.calibrationOffset = 0;

        /**
         * ComponentSettings grainType.
         * @member {pond.Grain} grainType
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.grainType = 0;

        /**
         * ComponentSettings grainFilledTo.
         * @member {number} grainFilledTo
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.grainFilledTo = 0;

        /**
         * ComponentSettings hasOverlays.
         * @member {boolean} hasOverlays
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.hasOverlays = false;

        /**
         * ComponentSettings overlays.
         * @member {Array.<pond.ComponentOverlays>} overlays
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.overlays = $util.emptyArray;

        /**
         * ComponentSettings defaultMutations.
         * @member {Array.<pond.Mutator>} defaultMutations
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.defaultMutations = $util.emptyArray;

        /**
         * ComponentSettings fanId.
         * @member {number} fanId
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.fanId = 0;

        /**
         * ComponentSettings customCurve.
         * @member {Array.<pond.CurvePoint>} customCurve
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.customCurve = $util.emptyArray;

        /**
         * ComponentSettings smoothingAverages.
         * @member {number} smoothingAverages
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.smoothingAverages = 0;

        /**
         * ComponentSettings calibrations.
         * @member {Array.<pond.Calibration>} calibrations
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.calibrations = $util.emptyArray;

        /**
         * ComponentSettings containerDimensions.
         * @member {pond.Dimensions|null|undefined} containerDimensions
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.containerDimensions = null;

        /**
         * ComponentSettings sensorDistanceCm.
         * @member {number} sensorDistanceCm
         * @memberof pond.ComponentSettings
         * @instance
         */
        ComponentSettings.prototype.sensorDistanceCm = 0;

        /**
         * Creates a new ComponentSettings instance using the specified properties.
         * @function create
         * @memberof pond.ComponentSettings
         * @static
         * @param {pond.IComponentSettings=} [properties] Properties to set
         * @returns {pond.ComponentSettings} ComponentSettings instance
         */
        ComponentSettings.create = function create(properties) {
            return new ComponentSettings(properties);
        };

        /**
         * Creates a ComponentSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentSettings} ComponentSettings
         */
        ComponentSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentSettings)
                return object;
            var message = new $root.pond.ComponentSettings();
            if (object.key != null)
                message.key = String(object.key);
            switch (object.type) {
            case "COMPONENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "COMPONENT_TYPE_POWER":
            case 1:
                message.type = 1;
                break;
            case "COMPONENT_TYPE_TEMPERATURE":
            case 2:
                message.type = 2;
                break;
            case "COMPONENT_TYPE_BOOLEAN_OUTPUT":
            case 3:
                message.type = 3;
                break;
            case "COMPONENT_TYPE_EDGE_TRIGGERED":
            case 4:
                message.type = 4;
                break;
            case "COMPONENT_TYPE_GRAIN_CABLE":
            case 5:
                message.type = 5;
                break;
            case "COMPONENT_TYPE_PRESSURE":
            case 6:
                message.type = 6;
                break;
            case "COMPONENT_TYPE_GPS":
            case 7:
                message.type = 7;
                break;
            case "COMPONENT_TYPE_BOOLEAN_INPUT":
            case 8:
                message.type = 8;
                break;
            case "COMPONENT_TYPE_DHT":
            case 9:
                message.type = 9;
                break;
            case "COMPONENT_TYPE_MODEM":
            case 10:
                message.type = 10;
                break;
            case "COMPONENT_TYPE_LIGHT":
            case 11:
                message.type = 11;
                break;
            case "COMPONENT_TYPE_CO2":
            case 12:
                message.type = 12;
                break;
            case "COMPONENT_TYPE_STEPPER_MOTOR":
            case 13:
                message.type = 13;
                break;
            case "COMPONENT_TYPE_ANALOG_INPUT":
            case 14:
                message.type = 14;
                break;
            case "COMPONENT_TYPE_O2":
            case 15:
                message.type = 15;
                break;
            case "COMPONENT_TYPE_ETHYLENE":
            case 16:
                message.type = 16;
                break;
            case "COMPONENT_TYPE_ORP":
            case 17:
                message.type = 17;
                break;
            case "COMPONENT_TYPE_PH":
            case 18:
                message.type = 18;
                break;
            case "COMPONENT_TYPE_VOLTAGE":
            case 19:
                message.type = 19;
                break;
            case "COMPONENT_TYPE_CALCIUM":
            case 20:
                message.type = 20;
                break;
            case "COMPONENT_TYPE_NITRATE":
            case 21:
                message.type = 21;
                break;
            case "COMPONENT_TYPE_POTASSIUM":
            case 22:
                message.type = 22;
                break;
            case "COMPONENT_TYPE_CONDUCTIVITY":
            case 23:
                message.type = 23;
                break;
            case "COMPONENT_TYPE_CAPACITANCE":
            case 24:
                message.type = 24;
                break;
            case "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT":
            case 25:
                message.type = 25;
                break;
            case "COMPONENT_TYPE_WEIGHT":
            case 26:
                message.type = 26;
                break;
            case "COMPONENT_TYPE_AIR_QUALITY":
            case 27:
                message.type = 27;
                break;
            case "COMPONENT_TYPE_LIDAR":
            case 28:
                message.type = 28;
                break;
            case "COMPONENT_TYPE_PRESSURE_CABLE":
            case 29:
                message.type = 29;
                break;
            case "COMPONENT_TYPE_INTERNAL_FUNCTION":
            case 30:
                message.type = 30;
                break;
            case "COMPONENT_TYPE_CAPACITOR_CABLE":
            case 31:
                message.type = 31;
                break;
            case "COMPONENT_TYPE_SEN5X":
            case 32:
                message.type = 32;
                break;
            case "COMPONENT_TYPE_VIBRATION_CHAIN":
            case 33:
                message.type = 33;
                break;
            case "COMPONENT_TYPE_DRAGER_GAS_DONGLE":
            case 34:
                message.type = 34;
                break;
            case "COMPONENT_TYPE_AIRFLOW":
            case 35:
                message.type = 35;
                break;
            }
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.name != null)
                message.name = String(object.name);
            if (object.reportPeriodMs != null)
                message.reportPeriodMs = object.reportPeriodMs >>> 0;
            if (object.measurementPeriodMs != null)
                message.measurementPeriodMs = object.measurementPeriodMs >>> 0;
            if (object.defaultOutputState != null)
                message.defaultOutputState = object.defaultOutputState >>> 0;
            if (object.minCycleTimeMs != null)
                message.minCycleTimeMs = object.minCycleTimeMs >>> 0;
            if (object.removed != null)
                message.removed = String(object.removed);
            switch (object.addressType) {
            case "ADDRESS_TYPE_INVALID":
            case 0:
                message.addressType = 0;
                break;
            case "ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY":
            case 1:
                message.addressType = 1;
                break;
            case "ADDRESS_TYPE_I2C":
            case 2:
                message.addressType = 2;
                break;
            case "ADDRESS_TYPE_DAC":
            case 3:
                message.addressType = 3;
                break;
            case "ADDRESS_TYPE_POWER":
            case 4:
                message.addressType = 4;
                break;
            case "ADDRESS_TYPE_GPS":
            case 5:
                message.addressType = 5;
                break;
            case "ADDRESS_TYPE_MODEM":
            case 6:
                message.addressType = 6;
                break;
            case "ADDRESS_TYPE_I2C_WITH_CHANNELS":
            case 7:
                message.addressType = 7;
                break;
            case "ADDRESS_TYPE_INCREMENTAL":
            case 8:
                message.addressType = 8;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET1":
            case 9:
                message.addressType = 9;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET2":
            case 10:
                message.addressType = 10;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET3":
            case 11:
                message.addressType = 11;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET4":
            case 12:
                message.addressType = 12;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET5":
            case 13:
                message.addressType = 13;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET6":
            case 14:
                message.addressType = 14;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET7":
            case 15:
                message.addressType = 15;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET8":
            case 16:
                message.addressType = 16;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET9":
            case 17:
                message.addressType = 17;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET10":
            case 18:
                message.addressType = 18;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET11":
            case 19:
                message.addressType = 19;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET12":
            case 20:
                message.addressType = 20;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET13":
            case 21:
                message.addressType = 21;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET14":
            case 22:
                message.addressType = 22;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET15":
            case 23:
                message.addressType = 23;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET16":
            case 24:
                message.addressType = 24;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET17":
            case 25:
                message.addressType = 25;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET18":
            case 26:
                message.addressType = 26;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET19":
            case 27:
                message.addressType = 27;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET20":
            case 28:
                message.addressType = 28;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET21":
            case 29:
                message.addressType = 29;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET22":
            case 30:
                message.addressType = 30;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET23":
            case 31:
                message.addressType = 31;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET24":
            case 32:
                message.addressType = 32;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET25":
            case 33:
                message.addressType = 33;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET26":
            case 34:
                message.addressType = 34;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET27":
            case 35:
                message.addressType = 35;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET28":
            case 36:
                message.addressType = 36;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET29":
            case 37:
                message.addressType = 37;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET30":
            case 38:
                message.addressType = 38;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET31":
            case 39:
                message.addressType = 39;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET32":
            case 40:
                message.addressType = 40;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET33":
            case 41:
                message.addressType = 41;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET34":
            case 42:
                message.addressType = 42;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET35":
            case 43:
                message.addressType = 43;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET36":
            case 44:
                message.addressType = 44;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET37":
            case 45:
                message.addressType = 45;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET38":
            case 46:
                message.addressType = 46;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET39":
            case 47:
                message.addressType = 47;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET40":
            case 48:
                message.addressType = 48;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET41":
            case 49:
                message.addressType = 49;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET42":
            case 50:
                message.addressType = 50;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET43":
            case 51:
                message.addressType = 51;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET44":
            case 52:
                message.addressType = 52;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET45":
            case 53:
                message.addressType = 53;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET46":
            case 54:
                message.addressType = 54;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET47":
            case 55:
                message.addressType = 55;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET48":
            case 56:
                message.addressType = 56;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET49":
            case 57:
                message.addressType = 57;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET50":
            case 58:
                message.addressType = 58;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET51":
            case 59:
                message.addressType = 59;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET52":
            case 60:
                message.addressType = 60;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET53":
            case 61:
                message.addressType = 61;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET54":
            case 62:
                message.addressType = 62;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET55":
            case 63:
                message.addressType = 63;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET56":
            case 64:
                message.addressType = 64;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET57":
            case 65:
                message.addressType = 65;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET58":
            case 66:
                message.addressType = 66;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET59":
            case 67:
                message.addressType = 67;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET60":
            case 68:
                message.addressType = 68;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET61":
            case 69:
                message.addressType = 69;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET62":
            case 70:
                message.addressType = 70;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET63":
            case 71:
                message.addressType = 71;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET64":
            case 72:
                message.addressType = 72;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET65":
            case 73:
                message.addressType = 73;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET66":
            case 74:
                message.addressType = 74;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET67":
            case 75:
                message.addressType = 75;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET68":
            case 76:
                message.addressType = 76;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET69":
            case 77:
                message.addressType = 77;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET70":
            case 78:
                message.addressType = 78;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET71":
            case 79:
                message.addressType = 79;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET72":
            case 80:
                message.addressType = 80;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET73":
            case 81:
                message.addressType = 81;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET74":
            case 82:
                message.addressType = 82;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET75":
            case 83:
                message.addressType = 83;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET76":
            case 84:
                message.addressType = 84;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET77":
            case 85:
                message.addressType = 85;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET78":
            case 86:
                message.addressType = 86;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET79":
            case 87:
                message.addressType = 87;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET80":
            case 88:
                message.addressType = 88;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET81":
            case 89:
                message.addressType = 89;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET82":
            case 90:
                message.addressType = 90;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET83":
            case 91:
                message.addressType = 91;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET84":
            case 92:
                message.addressType = 92;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET85":
            case 93:
                message.addressType = 93;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET86":
            case 94:
                message.addressType = 94;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET87":
            case 95:
                message.addressType = 95;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET88":
            case 96:
                message.addressType = 96;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET89":
            case 97:
                message.addressType = 97;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET90":
            case 98:
                message.addressType = 98;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET91":
            case 99:
                message.addressType = 99;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET92":
            case 100:
                message.addressType = 100;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET93":
            case 101:
                message.addressType = 101;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET94":
            case 102:
                message.addressType = 102;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET95":
            case 103:
                message.addressType = 103;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET96":
            case 104:
                message.addressType = 104;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET97":
            case 105:
                message.addressType = 105;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET98":
            case 106:
                message.addressType = 106;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET99":
            case 107:
                message.addressType = 107;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET100":
            case 108:
                message.addressType = 108;
                break;
            case "ADDRESS_TYPE_INTERNAL_SLEEP":
            case 109:
                message.addressType = 109;
                break;
            case "ADDRESS_TYPE_SPI":
            case 110:
                message.addressType = 110;
                break;
            }
            if (object.address != null)
                message.address = object.address >>> 0;
            if (object.calibrate != null)
                message.calibrate = Boolean(object.calibrate);
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            switch (object.grainType) {
            case "GRAIN_INVALID":
            case 0:
                message.grainType = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.grainType = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.grainType = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.grainType = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.grainType = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.grainType = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.grainType = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.grainType = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.grainType = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.grainType = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.grainType = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.grainType = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.grainType = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.grainType = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.grainType = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.grainType = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.grainType = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.grainType = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.grainType = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.grainType = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.grainType = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.grainType = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.grainType = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.grainType = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.grainType = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.grainType = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.grainType = 26;
                break;
            }
            if (object.grainFilledTo != null)
                message.grainFilledTo = object.grainFilledTo >>> 0;
            if (object.hasOverlays != null)
                message.hasOverlays = Boolean(object.hasOverlays);
            if (object.overlays) {
                if (!Array.isArray(object.overlays))
                    throw TypeError(".pond.ComponentSettings.overlays: array expected");
                message.overlays = [];
                for (var i = 0; i < object.overlays.length; ++i) {
                    if (typeof object.overlays[i] !== "object")
                        throw TypeError(".pond.ComponentSettings.overlays: object expected");
                    message.overlays[i] = $root.pond.ComponentOverlays.fromObject(object.overlays[i]);
                }
            }
            if (object.defaultMutations) {
                if (!Array.isArray(object.defaultMutations))
                    throw TypeError(".pond.ComponentSettings.defaultMutations: array expected");
                message.defaultMutations = [];
                for (var i = 0; i < object.defaultMutations.length; ++i)
                    switch (object.defaultMutations[i]) {
                    default:
                    case "MUTATOR_NONE":
                    case 0:
                        message.defaultMutations[i] = 0;
                        break;
                    case "MUTATOR_EMC":
                    case 1:
                        message.defaultMutations[i] = 1;
                        break;
                    case "MUTATOR_CFM":
                    case 2:
                        message.defaultMutations[i] = 2;
                        break;
                    case "MUTATOR_FUEL_LEVEL":
                    case 3:
                        message.defaultMutations[i] = 3;
                        break;
                    }
            }
            if (object.fanId != null)
                message.fanId = object.fanId >>> 0;
            if (object.customCurve) {
                if (!Array.isArray(object.customCurve))
                    throw TypeError(".pond.ComponentSettings.customCurve: array expected");
                message.customCurve = [];
                for (var i = 0; i < object.customCurve.length; ++i) {
                    if (typeof object.customCurve[i] !== "object")
                        throw TypeError(".pond.ComponentSettings.customCurve: object expected");
                    message.customCurve[i] = $root.pond.CurvePoint.fromObject(object.customCurve[i]);
                }
            }
            if (object.smoothingAverages != null)
                message.smoothingAverages = object.smoothingAverages >>> 0;
            if (object.calibrations) {
                if (!Array.isArray(object.calibrations))
                    throw TypeError(".pond.ComponentSettings.calibrations: array expected");
                message.calibrations = [];
                for (var i = 0; i < object.calibrations.length; ++i) {
                    if (typeof object.calibrations[i] !== "object")
                        throw TypeError(".pond.ComponentSettings.calibrations: object expected");
                    message.calibrations[i] = $root.pond.Calibration.fromObject(object.calibrations[i]);
                }
            }
            if (object.containerDimensions != null) {
                if (typeof object.containerDimensions !== "object")
                    throw TypeError(".pond.ComponentSettings.containerDimensions: object expected");
                message.containerDimensions = $root.pond.Dimensions.fromObject(object.containerDimensions);
            }
            if (object.sensorDistanceCm != null)
                message.sensorDistanceCm = Number(object.sensorDistanceCm);
            return message;
        };

        /**
         * Creates a plain object from a ComponentSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentSettings
         * @static
         * @param {pond.ComponentSettings} message ComponentSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.overlays = [];
                object.defaultMutations = [];
                object.customCurve = [];
                object.calibrations = [];
            }
            if (options.defaults) {
                object.key = "";
                object.type = options.enums === String ? "COMPONENT_TYPE_INVALID" : 0;
                object.subtype = 0;
                object.name = "";
                object.reportPeriodMs = 0;
                object.measurementPeriodMs = 0;
                object.defaultOutputState = 0;
                object.minCycleTimeMs = 0;
                object.removed = "";
                object.addressType = options.enums === String ? "ADDRESS_TYPE_INVALID" : 0;
                object.address = 0;
                object.calibrate = false;
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
                object.grainType = options.enums === String ? "GRAIN_INVALID" : 0;
                object.grainFilledTo = 0;
                object.hasOverlays = false;
                object.fanId = 0;
                object.smoothingAverages = 0;
                object.containerDimensions = null;
                object.sensorDistanceCm = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.ComponentType[message.type] : message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.reportPeriodMs != null && message.hasOwnProperty("reportPeriodMs"))
                object.reportPeriodMs = message.reportPeriodMs;
            if (message.measurementPeriodMs != null && message.hasOwnProperty("measurementPeriodMs"))
                object.measurementPeriodMs = message.measurementPeriodMs;
            if (message.defaultOutputState != null && message.hasOwnProperty("defaultOutputState"))
                object.defaultOutputState = message.defaultOutputState;
            if (message.minCycleTimeMs != null && message.hasOwnProperty("minCycleTimeMs"))
                object.minCycleTimeMs = message.minCycleTimeMs;
            if (message.removed != null && message.hasOwnProperty("removed"))
                object.removed = message.removed;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = options.enums === String ? $root.quack.AddressType[message.addressType] : message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.calibrate != null && message.hasOwnProperty("calibrate"))
                object.calibrate = message.calibrate;
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.grainType != null && message.hasOwnProperty("grainType"))
                object.grainType = options.enums === String ? $root.pond.Grain[message.grainType] : message.grainType;
            if (message.grainFilledTo != null && message.hasOwnProperty("grainFilledTo"))
                object.grainFilledTo = message.grainFilledTo;
            if (message.hasOverlays != null && message.hasOwnProperty("hasOverlays"))
                object.hasOverlays = message.hasOverlays;
            if (message.overlays && message.overlays.length) {
                object.overlays = [];
                for (var j = 0; j < message.overlays.length; ++j)
                    object.overlays[j] = $root.pond.ComponentOverlays.toObject(message.overlays[j], options);
            }
            if (message.defaultMutations && message.defaultMutations.length) {
                object.defaultMutations = [];
                for (var j = 0; j < message.defaultMutations.length; ++j)
                    object.defaultMutations[j] = options.enums === String ? $root.pond.Mutator[message.defaultMutations[j]] : message.defaultMutations[j];
            }
            if (message.fanId != null && message.hasOwnProperty("fanId"))
                object.fanId = message.fanId;
            if (message.customCurve && message.customCurve.length) {
                object.customCurve = [];
                for (var j = 0; j < message.customCurve.length; ++j)
                    object.customCurve[j] = $root.pond.CurvePoint.toObject(message.customCurve[j], options);
            }
            if (message.smoothingAverages != null && message.hasOwnProperty("smoothingAverages"))
                object.smoothingAverages = message.smoothingAverages;
            if (message.calibrations && message.calibrations.length) {
                object.calibrations = [];
                for (var j = 0; j < message.calibrations.length; ++j)
                    object.calibrations[j] = $root.pond.Calibration.toObject(message.calibrations[j], options);
            }
            if (message.containerDimensions != null && message.hasOwnProperty("containerDimensions"))
                object.containerDimensions = $root.pond.Dimensions.toObject(message.containerDimensions, options);
            if (message.sensorDistanceCm != null && message.hasOwnProperty("sensorDistanceCm"))
                object.sensorDistanceCm = options.json && !isFinite(message.sensorDistanceCm) ? String(message.sensorDistanceCm) : message.sensorDistanceCm;
            return object;
        };

        /**
         * Converts this ComponentSettings to JSON.
         * @function toJSON
         * @memberof pond.ComponentSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentSettings;
    })();

    pond.AddComponentRequest = (function() {

        /**
         * Properties of an AddComponentRequest.
         * @memberof pond
         * @interface IAddComponentRequest
         * @property {number|null} [device] AddComponentRequest device
         * @property {pond.ComponentSettings|null} [component] AddComponentRequest component
         * @property {boolean|null} [virtual] AddComponentRequest virtual
         */

        /**
         * Constructs a new AddComponentRequest.
         * @memberof pond
         * @classdesc Represents an AddComponentRequest.
         * @implements IAddComponentRequest
         * @constructor
         * @param {pond.IAddComponentRequest=} [properties] Properties to set
         */
        function AddComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddComponentRequest device.
         * @member {number} device
         * @memberof pond.AddComponentRequest
         * @instance
         */
        AddComponentRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddComponentRequest component.
         * @member {pond.ComponentSettings|null|undefined} component
         * @memberof pond.AddComponentRequest
         * @instance
         */
        AddComponentRequest.prototype.component = null;

        /**
         * AddComponentRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.AddComponentRequest
         * @instance
         */
        AddComponentRequest.prototype.virtual = false;

        /**
         * Creates a new AddComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddComponentRequest
         * @static
         * @param {pond.IAddComponentRequest=} [properties] Properties to set
         * @returns {pond.AddComponentRequest} AddComponentRequest instance
         */
        AddComponentRequest.create = function create(properties) {
            return new AddComponentRequest(properties);
        };

        /**
         * Creates an AddComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddComponentRequest} AddComponentRequest
         */
        AddComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddComponentRequest)
                return object;
            var message = new $root.pond.AddComponentRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.AddComponentRequest.component: object expected");
                message.component = $root.pond.ComponentSettings.fromObject(object.component);
            }
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from an AddComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddComponentRequest
         * @static
         * @param {pond.AddComponentRequest} message AddComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = null;
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.ComponentSettings.toObject(message.component, options);
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this AddComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.AddComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddComponentRequest;
    })();

    pond.AddComponentResponse = (function() {

        /**
         * Properties of an AddComponentResponse.
         * @memberof pond
         * @interface IAddComponentResponse
         */

        /**
         * Constructs a new AddComponentResponse.
         * @memberof pond
         * @classdesc Represents an AddComponentResponse.
         * @implements IAddComponentResponse
         * @constructor
         * @param {pond.IAddComponentResponse=} [properties] Properties to set
         */
        function AddComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddComponentResponse
         * @static
         * @param {pond.IAddComponentResponse=} [properties] Properties to set
         * @returns {pond.AddComponentResponse} AddComponentResponse instance
         */
        AddComponentResponse.create = function create(properties) {
            return new AddComponentResponse(properties);
        };

        /**
         * Creates an AddComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddComponentResponse} AddComponentResponse
         */
        AddComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddComponentResponse)
                return object;
            return new $root.pond.AddComponentResponse();
        };

        /**
         * Creates a plain object from an AddComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddComponentResponse
         * @static
         * @param {pond.AddComponentResponse} message AddComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.AddComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddComponentResponse;
    })();

    pond.MultiComponentSettings = (function() {

        /**
         * Properties of a MultiComponentSettings.
         * @memberof pond
         * @interface IMultiComponentSettings
         * @property {Array.<pond.ComponentSettings>|null} [components] MultiComponentSettings components
         */

        /**
         * Constructs a new MultiComponentSettings.
         * @memberof pond
         * @classdesc Represents a MultiComponentSettings.
         * @implements IMultiComponentSettings
         * @constructor
         * @param {pond.IMultiComponentSettings=} [properties] Properties to set
         */
        function MultiComponentSettings(properties) {
            this.components = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiComponentSettings components.
         * @member {Array.<pond.ComponentSettings>} components
         * @memberof pond.MultiComponentSettings
         * @instance
         */
        MultiComponentSettings.prototype.components = $util.emptyArray;

        /**
         * Creates a new MultiComponentSettings instance using the specified properties.
         * @function create
         * @memberof pond.MultiComponentSettings
         * @static
         * @param {pond.IMultiComponentSettings=} [properties] Properties to set
         * @returns {pond.MultiComponentSettings} MultiComponentSettings instance
         */
        MultiComponentSettings.create = function create(properties) {
            return new MultiComponentSettings(properties);
        };

        /**
         * Creates a MultiComponentSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MultiComponentSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MultiComponentSettings} MultiComponentSettings
         */
        MultiComponentSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MultiComponentSettings)
                return object;
            var message = new $root.pond.MultiComponentSettings();
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.MultiComponentSettings.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.MultiComponentSettings.components: object expected");
                    message.components[i] = $root.pond.ComponentSettings.fromObject(object.components[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiComponentSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MultiComponentSettings
         * @static
         * @param {pond.MultiComponentSettings} message MultiComponentSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiComponentSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.ComponentSettings.toObject(message.components[j], options);
            }
            return object;
        };

        /**
         * Converts this MultiComponentSettings to JSON.
         * @function toJSON
         * @memberof pond.MultiComponentSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiComponentSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiComponentSettings;
    })();

    pond.AddMultiComponentsRequest = (function() {

        /**
         * Properties of an AddMultiComponentsRequest.
         * @memberof pond
         * @interface IAddMultiComponentsRequest
         * @property {number|null} [device] AddMultiComponentsRequest device
         * @property {pond.MultiComponentSettings|null} [component] AddMultiComponentsRequest component
         */

        /**
         * Constructs a new AddMultiComponentsRequest.
         * @memberof pond
         * @classdesc Represents an AddMultiComponentsRequest.
         * @implements IAddMultiComponentsRequest
         * @constructor
         * @param {pond.IAddMultiComponentsRequest=} [properties] Properties to set
         */
        function AddMultiComponentsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddMultiComponentsRequest device.
         * @member {number} device
         * @memberof pond.AddMultiComponentsRequest
         * @instance
         */
        AddMultiComponentsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddMultiComponentsRequest component.
         * @member {pond.MultiComponentSettings|null|undefined} component
         * @memberof pond.AddMultiComponentsRequest
         * @instance
         */
        AddMultiComponentsRequest.prototype.component = null;

        /**
         * Creates a new AddMultiComponentsRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddMultiComponentsRequest
         * @static
         * @param {pond.IAddMultiComponentsRequest=} [properties] Properties to set
         * @returns {pond.AddMultiComponentsRequest} AddMultiComponentsRequest instance
         */
        AddMultiComponentsRequest.create = function create(properties) {
            return new AddMultiComponentsRequest(properties);
        };

        /**
         * Creates an AddMultiComponentsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMultiComponentsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMultiComponentsRequest} AddMultiComponentsRequest
         */
        AddMultiComponentsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMultiComponentsRequest)
                return object;
            var message = new $root.pond.AddMultiComponentsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.AddMultiComponentsRequest.component: object expected");
                message.component = $root.pond.MultiComponentSettings.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddMultiComponentsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMultiComponentsRequest
         * @static
         * @param {pond.AddMultiComponentsRequest} message AddMultiComponentsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMultiComponentsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.MultiComponentSettings.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this AddMultiComponentsRequest to JSON.
         * @function toJSON
         * @memberof pond.AddMultiComponentsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMultiComponentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMultiComponentsRequest;
    })();

    pond.AddMultiComponentsResponse = (function() {

        /**
         * Properties of an AddMultiComponentsResponse.
         * @memberof pond
         * @interface IAddMultiComponentsResponse
         */

        /**
         * Constructs a new AddMultiComponentsResponse.
         * @memberof pond
         * @classdesc Represents an AddMultiComponentsResponse.
         * @implements IAddMultiComponentsResponse
         * @constructor
         * @param {pond.IAddMultiComponentsResponse=} [properties] Properties to set
         */
        function AddMultiComponentsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddMultiComponentsResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddMultiComponentsResponse
         * @static
         * @param {pond.IAddMultiComponentsResponse=} [properties] Properties to set
         * @returns {pond.AddMultiComponentsResponse} AddMultiComponentsResponse instance
         */
        AddMultiComponentsResponse.create = function create(properties) {
            return new AddMultiComponentsResponse(properties);
        };

        /**
         * Creates an AddMultiComponentsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMultiComponentsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMultiComponentsResponse} AddMultiComponentsResponse
         */
        AddMultiComponentsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMultiComponentsResponse)
                return object;
            return new $root.pond.AddMultiComponentsResponse();
        };

        /**
         * Creates a plain object from an AddMultiComponentsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMultiComponentsResponse
         * @static
         * @param {pond.AddMultiComponentsResponse} message AddMultiComponentsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMultiComponentsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddMultiComponentsResponse to JSON.
         * @function toJSON
         * @memberof pond.AddMultiComponentsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMultiComponentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMultiComponentsResponse;
    })();

    pond.RemoveComponentRequest = (function() {

        /**
         * Properties of a RemoveComponentRequest.
         * @memberof pond
         * @interface IRemoveComponentRequest
         * @property {number|null} [device] RemoveComponentRequest device
         * @property {string|null} [component] RemoveComponentRequest component
         * @property {boolean|null} [virtual] RemoveComponentRequest virtual
         */

        /**
         * Constructs a new RemoveComponentRequest.
         * @memberof pond
         * @classdesc Represents a RemoveComponentRequest.
         * @implements IRemoveComponentRequest
         * @constructor
         * @param {pond.IRemoveComponentRequest=} [properties] Properties to set
         */
        function RemoveComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveComponentRequest device.
         * @member {number} device
         * @memberof pond.RemoveComponentRequest
         * @instance
         */
        RemoveComponentRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RemoveComponentRequest component.
         * @member {string} component
         * @memberof pond.RemoveComponentRequest
         * @instance
         */
        RemoveComponentRequest.prototype.component = "";

        /**
         * RemoveComponentRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.RemoveComponentRequest
         * @instance
         */
        RemoveComponentRequest.prototype.virtual = false;

        /**
         * Creates a new RemoveComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveComponentRequest
         * @static
         * @param {pond.IRemoveComponentRequest=} [properties] Properties to set
         * @returns {pond.RemoveComponentRequest} RemoveComponentRequest instance
         */
        RemoveComponentRequest.create = function create(properties) {
            return new RemoveComponentRequest(properties);
        };

        /**
         * Creates a RemoveComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveComponentRequest} RemoveComponentRequest
         */
        RemoveComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveComponentRequest)
                return object;
            var message = new $root.pond.RemoveComponentRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from a RemoveComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveComponentRequest
         * @static
         * @param {pond.RemoveComponentRequest} message RemoveComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this RemoveComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveComponentRequest;
    })();

    pond.RemoveComponentResponse = (function() {

        /**
         * Properties of a RemoveComponentResponse.
         * @memberof pond
         * @interface IRemoveComponentResponse
         */

        /**
         * Constructs a new RemoveComponentResponse.
         * @memberof pond
         * @classdesc Represents a RemoveComponentResponse.
         * @implements IRemoveComponentResponse
         * @constructor
         * @param {pond.IRemoveComponentResponse=} [properties] Properties to set
         */
        function RemoveComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveComponentResponse
         * @static
         * @param {pond.IRemoveComponentResponse=} [properties] Properties to set
         * @returns {pond.RemoveComponentResponse} RemoveComponentResponse instance
         */
        RemoveComponentResponse.create = function create(properties) {
            return new RemoveComponentResponse(properties);
        };

        /**
         * Creates a RemoveComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveComponentResponse} RemoveComponentResponse
         */
        RemoveComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveComponentResponse)
                return object;
            return new $root.pond.RemoveComponentResponse();
        };

        /**
         * Creates a plain object from a RemoveComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveComponentResponse
         * @static
         * @param {pond.RemoveComponentResponse} message RemoveComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveComponentResponse;
    })();

    pond.UpdateComponentRequest = (function() {

        /**
         * Properties of an UpdateComponentRequest.
         * @memberof pond
         * @interface IUpdateComponentRequest
         * @property {number|null} [device] UpdateComponentRequest device
         * @property {pond.ComponentSettings|null} [component] UpdateComponentRequest component
         * @property {boolean|null} [virtual] UpdateComponentRequest virtual
         */

        /**
         * Constructs a new UpdateComponentRequest.
         * @memberof pond
         * @classdesc Represents an UpdateComponentRequest.
         * @implements IUpdateComponentRequest
         * @constructor
         * @param {pond.IUpdateComponentRequest=} [properties] Properties to set
         */
        function UpdateComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateComponentRequest device.
         * @member {number} device
         * @memberof pond.UpdateComponentRequest
         * @instance
         */
        UpdateComponentRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpdateComponentRequest component.
         * @member {pond.ComponentSettings|null|undefined} component
         * @memberof pond.UpdateComponentRequest
         * @instance
         */
        UpdateComponentRequest.prototype.component = null;

        /**
         * UpdateComponentRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.UpdateComponentRequest
         * @instance
         */
        UpdateComponentRequest.prototype.virtual = false;

        /**
         * Creates a new UpdateComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateComponentRequest
         * @static
         * @param {pond.IUpdateComponentRequest=} [properties] Properties to set
         * @returns {pond.UpdateComponentRequest} UpdateComponentRequest instance
         */
        UpdateComponentRequest.create = function create(properties) {
            return new UpdateComponentRequest(properties);
        };

        /**
         * Creates an UpdateComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateComponentRequest} UpdateComponentRequest
         */
        UpdateComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateComponentRequest)
                return object;
            var message = new $root.pond.UpdateComponentRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.UpdateComponentRequest.component: object expected");
                message.component = $root.pond.ComponentSettings.fromObject(object.component);
            }
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from an UpdateComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateComponentRequest
         * @static
         * @param {pond.UpdateComponentRequest} message UpdateComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = null;
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.ComponentSettings.toObject(message.component, options);
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this UpdateComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateComponentRequest;
    })();

    pond.UpdateComponentResponse = (function() {

        /**
         * Properties of an UpdateComponentResponse.
         * @memberof pond
         * @interface IUpdateComponentResponse
         */

        /**
         * Constructs a new UpdateComponentResponse.
         * @memberof pond
         * @classdesc Represents an UpdateComponentResponse.
         * @implements IUpdateComponentResponse
         * @constructor
         * @param {pond.IUpdateComponentResponse=} [properties] Properties to set
         */
        function UpdateComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateComponentResponse
         * @static
         * @param {pond.IUpdateComponentResponse=} [properties] Properties to set
         * @returns {pond.UpdateComponentResponse} UpdateComponentResponse instance
         */
        UpdateComponentResponse.create = function create(properties) {
            return new UpdateComponentResponse(properties);
        };

        /**
         * Creates an UpdateComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateComponentResponse} UpdateComponentResponse
         */
        UpdateComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateComponentResponse)
                return object;
            return new $root.pond.UpdateComponentResponse();
        };

        /**
         * Creates a plain object from an UpdateComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateComponentResponse
         * @static
         * @param {pond.UpdateComponentResponse} message UpdateComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateComponentResponse;
    })();

    pond.GetComponentRequest = (function() {

        /**
         * Properties of a GetComponentRequest.
         * @memberof pond
         * @interface IGetComponentRequest
         * @property {number|null} [device] GetComponentRequest device
         * @property {string|null} [component] GetComponentRequest component
         * @property {boolean|null} [virtual] GetComponentRequest virtual
         */

        /**
         * Constructs a new GetComponentRequest.
         * @memberof pond
         * @classdesc Represents a GetComponentRequest.
         * @implements IGetComponentRequest
         * @constructor
         * @param {pond.IGetComponentRequest=} [properties] Properties to set
         */
        function GetComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetComponentRequest device.
         * @member {number} device
         * @memberof pond.GetComponentRequest
         * @instance
         */
        GetComponentRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetComponentRequest component.
         * @member {string} component
         * @memberof pond.GetComponentRequest
         * @instance
         */
        GetComponentRequest.prototype.component = "";

        /**
         * GetComponentRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.GetComponentRequest
         * @instance
         */
        GetComponentRequest.prototype.virtual = false;

        /**
         * Creates a new GetComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetComponentRequest
         * @static
         * @param {pond.IGetComponentRequest=} [properties] Properties to set
         * @returns {pond.GetComponentRequest} GetComponentRequest instance
         */
        GetComponentRequest.create = function create(properties) {
            return new GetComponentRequest(properties);
        };

        /**
         * Creates a GetComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetComponentRequest} GetComponentRequest
         */
        GetComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetComponentRequest)
                return object;
            var message = new $root.pond.GetComponentRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from a GetComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetComponentRequest
         * @static
         * @param {pond.GetComponentRequest} message GetComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this GetComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.GetComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetComponentRequest;
    })();

    pond.ComponentStatus = (function() {

        /**
         * Properties of a ComponentStatus.
         * @memberof pond
         * @interface IComponentStatus
         * @property {string|null} [lastUpdate] ComponentStatus lastUpdate
         * @property {boolean|null} [synced] ComponentStatus synced
         * @property {string|null} [lastSynced] ComponentStatus lastSynced
         * @property {pond.Measurement|null} [lastMeasurement] ComponentStatus lastMeasurement
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [measurement] ComponentStatus measurement
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [lastGoodMeasurement] ComponentStatus lastGoodMeasurement
         */

        /**
         * Constructs a new ComponentStatus.
         * @memberof pond
         * @classdesc Represents a ComponentStatus.
         * @implements IComponentStatus
         * @constructor
         * @param {pond.IComponentStatus=} [properties] Properties to set
         */
        function ComponentStatus(properties) {
            this.measurement = [];
            this.lastGoodMeasurement = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentStatus lastUpdate.
         * @member {string} lastUpdate
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.lastUpdate = "";

        /**
         * ComponentStatus synced.
         * @member {boolean} synced
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.synced = false;

        /**
         * ComponentStatus lastSynced.
         * @member {string} lastSynced
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.lastSynced = "";

        /**
         * ComponentStatus lastMeasurement.
         * @member {pond.Measurement|null|undefined} lastMeasurement
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.lastMeasurement = null;

        /**
         * ComponentStatus measurement.
         * @member {Array.<pond.UnitMeasurementsForComponent>} measurement
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.measurement = $util.emptyArray;

        /**
         * ComponentStatus lastGoodMeasurement.
         * @member {Array.<pond.UnitMeasurementsForComponent>} lastGoodMeasurement
         * @memberof pond.ComponentStatus
         * @instance
         */
        ComponentStatus.prototype.lastGoodMeasurement = $util.emptyArray;

        /**
         * Creates a new ComponentStatus instance using the specified properties.
         * @function create
         * @memberof pond.ComponentStatus
         * @static
         * @param {pond.IComponentStatus=} [properties] Properties to set
         * @returns {pond.ComponentStatus} ComponentStatus instance
         */
        ComponentStatus.create = function create(properties) {
            return new ComponentStatus(properties);
        };

        /**
         * Creates a ComponentStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentStatus} ComponentStatus
         */
        ComponentStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentStatus)
                return object;
            var message = new $root.pond.ComponentStatus();
            if (object.lastUpdate != null)
                message.lastUpdate = String(object.lastUpdate);
            if (object.synced != null)
                message.synced = Boolean(object.synced);
            if (object.lastSynced != null)
                message.lastSynced = String(object.lastSynced);
            if (object.lastMeasurement != null) {
                if (typeof object.lastMeasurement !== "object")
                    throw TypeError(".pond.ComponentStatus.lastMeasurement: object expected");
                message.lastMeasurement = $root.pond.Measurement.fromObject(object.lastMeasurement);
            }
            if (object.measurement) {
                if (!Array.isArray(object.measurement))
                    throw TypeError(".pond.ComponentStatus.measurement: array expected");
                message.measurement = [];
                for (var i = 0; i < object.measurement.length; ++i) {
                    if (typeof object.measurement[i] !== "object")
                        throw TypeError(".pond.ComponentStatus.measurement: object expected");
                    message.measurement[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.measurement[i]);
                }
            }
            if (object.lastGoodMeasurement) {
                if (!Array.isArray(object.lastGoodMeasurement))
                    throw TypeError(".pond.ComponentStatus.lastGoodMeasurement: array expected");
                message.lastGoodMeasurement = [];
                for (var i = 0; i < object.lastGoodMeasurement.length; ++i) {
                    if (typeof object.lastGoodMeasurement[i] !== "object")
                        throw TypeError(".pond.ComponentStatus.lastGoodMeasurement: object expected");
                    message.lastGoodMeasurement[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.lastGoodMeasurement[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComponentStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentStatus
         * @static
         * @param {pond.ComponentStatus} message ComponentStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.measurement = [];
                object.lastGoodMeasurement = [];
            }
            if (options.defaults) {
                object.lastUpdate = "";
                object.synced = false;
                object.lastSynced = "";
                object.lastMeasurement = null;
            }
            if (message.lastUpdate != null && message.hasOwnProperty("lastUpdate"))
                object.lastUpdate = message.lastUpdate;
            if (message.synced != null && message.hasOwnProperty("synced"))
                object.synced = message.synced;
            if (message.lastSynced != null && message.hasOwnProperty("lastSynced"))
                object.lastSynced = message.lastSynced;
            if (message.lastMeasurement != null && message.hasOwnProperty("lastMeasurement"))
                object.lastMeasurement = $root.pond.Measurement.toObject(message.lastMeasurement, options);
            if (message.measurement && message.measurement.length) {
                object.measurement = [];
                for (var j = 0; j < message.measurement.length; ++j)
                    object.measurement[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.measurement[j], options);
            }
            if (message.lastGoodMeasurement && message.lastGoodMeasurement.length) {
                object.lastGoodMeasurement = [];
                for (var j = 0; j < message.lastGoodMeasurement.length; ++j)
                    object.lastGoodMeasurement[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.lastGoodMeasurement[j], options);
            }
            return object;
        };

        /**
         * Converts this ComponentStatus to JSON.
         * @function toJSON
         * @memberof pond.ComponentStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentStatus;
    })();

    pond.Component = (function() {

        /**
         * Properties of a Component.
         * @memberof pond
         * @interface IComponent
         * @property {pond.ComponentSettings|null} [settings] Component settings
         * @property {pond.ComponentStatus|null} [status] Component status
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [lastMeasurement] Component lastMeasurement
         * @property {Array.<pond.Permission>|null} [permissions] Component permissions
         */

        /**
         * Constructs a new Component.
         * @memberof pond
         * @classdesc Represents a Component.
         * @implements IComponent
         * @constructor
         * @param {pond.IComponent=} [properties] Properties to set
         */
        function Component(properties) {
            this.lastMeasurement = [];
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Component settings.
         * @member {pond.ComponentSettings|null|undefined} settings
         * @memberof pond.Component
         * @instance
         */
        Component.prototype.settings = null;

        /**
         * Component status.
         * @member {pond.ComponentStatus|null|undefined} status
         * @memberof pond.Component
         * @instance
         */
        Component.prototype.status = null;

        /**
         * Component lastMeasurement.
         * @member {Array.<pond.UnitMeasurementsForComponent>} lastMeasurement
         * @memberof pond.Component
         * @instance
         */
        Component.prototype.lastMeasurement = $util.emptyArray;

        /**
         * Component permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.Component
         * @instance
         */
        Component.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new Component instance using the specified properties.
         * @function create
         * @memberof pond.Component
         * @static
         * @param {pond.IComponent=} [properties] Properties to set
         * @returns {pond.Component} Component instance
         */
        Component.create = function create(properties) {
            return new Component(properties);
        };

        /**
         * Creates a Component message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Component
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Component} Component
         */
        Component.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Component)
                return object;
            var message = new $root.pond.Component();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Component.settings: object expected");
                message.settings = $root.pond.ComponentSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Component.status: object expected");
                message.status = $root.pond.ComponentStatus.fromObject(object.status);
            }
            if (object.lastMeasurement) {
                if (!Array.isArray(object.lastMeasurement))
                    throw TypeError(".pond.Component.lastMeasurement: array expected");
                message.lastMeasurement = [];
                for (var i = 0; i < object.lastMeasurement.length; ++i) {
                    if (typeof object.lastMeasurement[i] !== "object")
                        throw TypeError(".pond.Component.lastMeasurement: object expected");
                    message.lastMeasurement[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.lastMeasurement[i]);
                }
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.Component.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a Component message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Component
         * @static
         * @param {pond.Component} message Component
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Component.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.lastMeasurement = [];
                object.permissions = [];
            }
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ComponentSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.ComponentStatus.toObject(message.status, options);
            if (message.lastMeasurement && message.lastMeasurement.length) {
                object.lastMeasurement = [];
                for (var j = 0; j < message.lastMeasurement.length; ++j)
                    object.lastMeasurement[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.lastMeasurement[j], options);
            }
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this Component to JSON.
         * @function toJSON
         * @memberof pond.Component
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Component.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Component;
    })();

    pond.ListComponentsRequest = (function() {

        /**
         * Properties of a ListComponentsRequest.
         * @memberof pond
         * @interface IListComponentsRequest
         * @property {pond.Paging|null} [paging] ListComponentsRequest paging
         * @property {pond.Sorting|null} [sorting] ListComponentsRequest sorting
         * @property {string|null} [search] ListComponentsRequest search
         * @property {pond.DeviceSettings|null} [settingsMatch] ListComponentsRequest settingsMatch
         * @property {pond.DeviceStatus|null} [statusMatch] ListComponentsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListComponentsRequest fieldContains
         * @property {boolean|null} [asRoot] ListComponentsRequest asRoot
         * @property {boolean|null} [comprehensive] ListComponentsRequest comprehensive
         * @property {boolean|null} [showErrors] ListComponentsRequest showErrors
         */

        /**
         * Constructs a new ListComponentsRequest.
         * @memberof pond
         * @classdesc Represents a ListComponentsRequest.
         * @implements IListComponentsRequest
         * @constructor
         * @param {pond.IListComponentsRequest=} [properties] Properties to set
         */
        function ListComponentsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.paging = null;

        /**
         * ListComponentsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.sorting = null;

        /**
         * ListComponentsRequest search.
         * @member {string} search
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.search = "";

        /**
         * ListComponentsRequest settingsMatch.
         * @member {pond.DeviceSettings|null|undefined} settingsMatch
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.settingsMatch = null;

        /**
         * ListComponentsRequest statusMatch.
         * @member {pond.DeviceStatus|null|undefined} statusMatch
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.statusMatch = null;

        /**
         * ListComponentsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListComponentsRequest asRoot.
         * @member {boolean} asRoot
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.asRoot = false;

        /**
         * ListComponentsRequest comprehensive.
         * @member {boolean} comprehensive
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.comprehensive = false;

        /**
         * ListComponentsRequest showErrors.
         * @member {boolean} showErrors
         * @memberof pond.ListComponentsRequest
         * @instance
         */
        ListComponentsRequest.prototype.showErrors = false;

        /**
         * Creates a new ListComponentsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentsRequest
         * @static
         * @param {pond.IListComponentsRequest=} [properties] Properties to set
         * @returns {pond.ListComponentsRequest} ListComponentsRequest instance
         */
        ListComponentsRequest.create = function create(properties) {
            return new ListComponentsRequest(properties);
        };

        /**
         * Creates a ListComponentsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentsRequest} ListComponentsRequest
         */
        ListComponentsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentsRequest)
                return object;
            var message = new $root.pond.ListComponentsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListComponentsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListComponentsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListComponentsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.DeviceSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListComponentsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.DeviceStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListComponentsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.asRoot != null)
                message.asRoot = Boolean(object.asRoot);
            if (object.comprehensive != null)
                message.comprehensive = Boolean(object.comprehensive);
            if (object.showErrors != null)
                message.showErrors = Boolean(object.showErrors);
            return message;
        };

        /**
         * Creates a plain object from a ListComponentsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentsRequest
         * @static
         * @param {pond.ListComponentsRequest} message ListComponentsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
                object.asRoot = false;
                object.comprehensive = false;
                object.showErrors = false;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.DeviceSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.DeviceStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.asRoot != null && message.hasOwnProperty("asRoot"))
                object.asRoot = message.asRoot;
            if (message.comprehensive != null && message.hasOwnProperty("comprehensive"))
                object.comprehensive = message.comprehensive;
            if (message.showErrors != null && message.hasOwnProperty("showErrors"))
                object.showErrors = message.showErrors;
            return object;
        };

        /**
         * Converts this ListComponentsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListComponentsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentsRequest;
    })();

    pond.ListComponentsResponse = (function() {

        /**
         * Properties of a ListComponentsResponse.
         * @memberof pond
         * @interface IListComponentsResponse
         * @property {Array.<pond.Component>|null} [components] ListComponentsResponse components
         * @property {Object.<string,number>|null} [componentDevices] ListComponentsResponse componentDevices
         */

        /**
         * Constructs a new ListComponentsResponse.
         * @memberof pond
         * @classdesc Represents a ListComponentsResponse.
         * @implements IListComponentsResponse
         * @constructor
         * @param {pond.IListComponentsResponse=} [properties] Properties to set
         */
        function ListComponentsResponse(properties) {
            this.components = [];
            this.componentDevices = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentsResponse components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.ListComponentsResponse
         * @instance
         */
        ListComponentsResponse.prototype.components = $util.emptyArray;

        /**
         * ListComponentsResponse componentDevices.
         * @member {Object.<string,number>} componentDevices
         * @memberof pond.ListComponentsResponse
         * @instance
         */
        ListComponentsResponse.prototype.componentDevices = $util.emptyObject;

        /**
         * Creates a new ListComponentsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentsResponse
         * @static
         * @param {pond.IListComponentsResponse=} [properties] Properties to set
         * @returns {pond.ListComponentsResponse} ListComponentsResponse instance
         */
        ListComponentsResponse.create = function create(properties) {
            return new ListComponentsResponse(properties);
        };

        /**
         * Creates a ListComponentsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentsResponse} ListComponentsResponse
         */
        ListComponentsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentsResponse)
                return object;
            var message = new $root.pond.ListComponentsResponse();
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.ListComponentsResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.ListComponentsResponse.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.componentDevices) {
                if (typeof object.componentDevices !== "object")
                    throw TypeError(".pond.ListComponentsResponse.componentDevices: object expected");
                message.componentDevices = {};
                for (var keys = Object.keys(object.componentDevices), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.componentDevices[keys[i]] = $util.Long.fromValue(object.componentDevices[keys[i]])).unsigned = true;
                    else if (typeof object.componentDevices[keys[i]] === "string")
                        message.componentDevices[keys[i]] = parseInt(object.componentDevices[keys[i]], 10);
                    else if (typeof object.componentDevices[keys[i]] === "number")
                        message.componentDevices[keys[i]] = object.componentDevices[keys[i]];
                    else if (typeof object.componentDevices[keys[i]] === "object")
                        message.componentDevices[keys[i]] = new $util.LongBits(object.componentDevices[keys[i]].low >>> 0, object.componentDevices[keys[i]].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListComponentsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentsResponse
         * @static
         * @param {pond.ListComponentsResponse} message ListComponentsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (options.objects || options.defaults)
                object.componentDevices = {};
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            var keys2;
            if (message.componentDevices && (keys2 = Object.keys(message.componentDevices)).length) {
                object.componentDevices = {};
                for (var j = 0; j < keys2.length; ++j)
                    if (typeof message.componentDevices[keys2[j]] === "number")
                        object.componentDevices[keys2[j]] = options.longs === String ? String(message.componentDevices[keys2[j]]) : message.componentDevices[keys2[j]];
                    else
                        object.componentDevices[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.componentDevices[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.componentDevices[keys2[j]].low >>> 0, message.componentDevices[keys2[j]].high >>> 0).toNumber(true) : message.componentDevices[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListComponentsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListComponentsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentsResponse;
    })();

    pond.IsComponentRemoveableRequest = (function() {

        /**
         * Properties of an IsComponentRemoveableRequest.
         * @memberof pond
         * @interface IIsComponentRemoveableRequest
         * @property {number|null} [device] IsComponentRemoveableRequest device
         * @property {quack.ComponentID|null} [component] IsComponentRemoveableRequest component
         */

        /**
         * Constructs a new IsComponentRemoveableRequest.
         * @memberof pond
         * @classdesc Represents an IsComponentRemoveableRequest.
         * @implements IIsComponentRemoveableRequest
         * @constructor
         * @param {pond.IIsComponentRemoveableRequest=} [properties] Properties to set
         */
        function IsComponentRemoveableRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsComponentRemoveableRequest device.
         * @member {number} device
         * @memberof pond.IsComponentRemoveableRequest
         * @instance
         */
        IsComponentRemoveableRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * IsComponentRemoveableRequest component.
         * @member {quack.ComponentID|null|undefined} component
         * @memberof pond.IsComponentRemoveableRequest
         * @instance
         */
        IsComponentRemoveableRequest.prototype.component = null;

        /**
         * Creates a new IsComponentRemoveableRequest instance using the specified properties.
         * @function create
         * @memberof pond.IsComponentRemoveableRequest
         * @static
         * @param {pond.IIsComponentRemoveableRequest=} [properties] Properties to set
         * @returns {pond.IsComponentRemoveableRequest} IsComponentRemoveableRequest instance
         */
        IsComponentRemoveableRequest.create = function create(properties) {
            return new IsComponentRemoveableRequest(properties);
        };

        /**
         * Creates an IsComponentRemoveableRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsComponentRemoveableRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsComponentRemoveableRequest} IsComponentRemoveableRequest
         */
        IsComponentRemoveableRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsComponentRemoveableRequest)
                return object;
            var message = new $root.pond.IsComponentRemoveableRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.IsComponentRemoveableRequest.component: object expected");
                message.component = $root.quack.ComponentID.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an IsComponentRemoveableRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsComponentRemoveableRequest
         * @static
         * @param {pond.IsComponentRemoveableRequest} message IsComponentRemoveableRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsComponentRemoveableRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.ComponentID.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this IsComponentRemoveableRequest to JSON.
         * @function toJSON
         * @memberof pond.IsComponentRemoveableRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsComponentRemoveableRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsComponentRemoveableRequest;
    })();

    pond.IsComponentRemoveableResponse = (function() {

        /**
         * Properties of an IsComponentRemoveableResponse.
         * @memberof pond
         * @interface IIsComponentRemoveableResponse
         * @property {boolean|null} [removeable] IsComponentRemoveableResponse removeable
         */

        /**
         * Constructs a new IsComponentRemoveableResponse.
         * @memberof pond
         * @classdesc Represents an IsComponentRemoveableResponse.
         * @implements IIsComponentRemoveableResponse
         * @constructor
         * @param {pond.IIsComponentRemoveableResponse=} [properties] Properties to set
         */
        function IsComponentRemoveableResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsComponentRemoveableResponse removeable.
         * @member {boolean} removeable
         * @memberof pond.IsComponentRemoveableResponse
         * @instance
         */
        IsComponentRemoveableResponse.prototype.removeable = false;

        /**
         * Creates a new IsComponentRemoveableResponse instance using the specified properties.
         * @function create
         * @memberof pond.IsComponentRemoveableResponse
         * @static
         * @param {pond.IIsComponentRemoveableResponse=} [properties] Properties to set
         * @returns {pond.IsComponentRemoveableResponse} IsComponentRemoveableResponse instance
         */
        IsComponentRemoveableResponse.create = function create(properties) {
            return new IsComponentRemoveableResponse(properties);
        };

        /**
         * Creates an IsComponentRemoveableResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsComponentRemoveableResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsComponentRemoveableResponse} IsComponentRemoveableResponse
         */
        IsComponentRemoveableResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsComponentRemoveableResponse)
                return object;
            var message = new $root.pond.IsComponentRemoveableResponse();
            if (object.removeable != null)
                message.removeable = Boolean(object.removeable);
            return message;
        };

        /**
         * Creates a plain object from an IsComponentRemoveableResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsComponentRemoveableResponse
         * @static
         * @param {pond.IsComponentRemoveableResponse} message IsComponentRemoveableResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsComponentRemoveableResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.removeable = false;
            if (message.removeable != null && message.hasOwnProperty("removeable"))
                object.removeable = message.removeable;
            return object;
        };

        /**
         * Converts this IsComponentRemoveableResponse to JSON.
         * @function toJSON
         * @memberof pond.IsComponentRemoveableResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsComponentRemoveableResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsComponentRemoveableResponse;
    })();

    pond.ListComponentHistoryRequest = (function() {

        /**
         * Properties of a ListComponentHistoryRequest.
         * @memberof pond
         * @interface IListComponentHistoryRequest
         * @property {string|null} [componentKey] ListComponentHistoryRequest componentKey
         * @property {pond.Paging|null} [paging] ListComponentHistoryRequest paging
         */

        /**
         * Constructs a new ListComponentHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListComponentHistoryRequest.
         * @implements IListComponentHistoryRequest
         * @constructor
         * @param {pond.IListComponentHistoryRequest=} [properties] Properties to set
         */
        function ListComponentHistoryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentHistoryRequest componentKey.
         * @member {string} componentKey
         * @memberof pond.ListComponentHistoryRequest
         * @instance
         */
        ListComponentHistoryRequest.prototype.componentKey = "";

        /**
         * ListComponentHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListComponentHistoryRequest
         * @instance
         */
        ListComponentHistoryRequest.prototype.paging = null;

        /**
         * Creates a new ListComponentHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentHistoryRequest
         * @static
         * @param {pond.IListComponentHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListComponentHistoryRequest} ListComponentHistoryRequest instance
         */
        ListComponentHistoryRequest.create = function create(properties) {
            return new ListComponentHistoryRequest(properties);
        };

        /**
         * Creates a ListComponentHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentHistoryRequest} ListComponentHistoryRequest
         */
        ListComponentHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentHistoryRequest)
                return object;
            var message = new $root.pond.ListComponentHistoryRequest();
            if (object.componentKey != null)
                message.componentKey = String(object.componentKey);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListComponentHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListComponentHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentHistoryRequest
         * @static
         * @param {pond.ListComponentHistoryRequest} message ListComponentHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.componentKey = "";
                object.paging = null;
            }
            if (message.componentKey != null && message.hasOwnProperty("componentKey"))
                object.componentKey = message.componentKey;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            return object;
        };

        /**
         * Converts this ListComponentHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListComponentHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentHistoryRequest;
    })();

    pond.ComponentHistory = (function() {

        /**
         * Properties of a ComponentHistory.
         * @memberof pond
         * @interface IComponentHistory
         * @property {pond.ComponentSettings|null} [component] ComponentHistory component
         * @property {string|null} [user] ComponentHistory user
         * @property {string|null} [timestamp] ComponentHistory timestamp
         * @property {string|null} [parentDevice] ComponentHistory parentDevice
         * @property {string|null} [progress] ComponentHistory progress
         */

        /**
         * Constructs a new ComponentHistory.
         * @memberof pond
         * @classdesc Represents a ComponentHistory.
         * @implements IComponentHistory
         * @constructor
         * @param {pond.IComponentHistory=} [properties] Properties to set
         */
        function ComponentHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentHistory component.
         * @member {pond.ComponentSettings|null|undefined} component
         * @memberof pond.ComponentHistory
         * @instance
         */
        ComponentHistory.prototype.component = null;

        /**
         * ComponentHistory user.
         * @member {string} user
         * @memberof pond.ComponentHistory
         * @instance
         */
        ComponentHistory.prototype.user = "";

        /**
         * ComponentHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.ComponentHistory
         * @instance
         */
        ComponentHistory.prototype.timestamp = "";

        /**
         * ComponentHistory parentDevice.
         * @member {string} parentDevice
         * @memberof pond.ComponentHistory
         * @instance
         */
        ComponentHistory.prototype.parentDevice = "";

        /**
         * ComponentHistory progress.
         * @member {string} progress
         * @memberof pond.ComponentHistory
         * @instance
         */
        ComponentHistory.prototype.progress = "";

        /**
         * Creates a new ComponentHistory instance using the specified properties.
         * @function create
         * @memberof pond.ComponentHistory
         * @static
         * @param {pond.IComponentHistory=} [properties] Properties to set
         * @returns {pond.ComponentHistory} ComponentHistory instance
         */
        ComponentHistory.create = function create(properties) {
            return new ComponentHistory(properties);
        };

        /**
         * Creates a ComponentHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentHistory} ComponentHistory
         */
        ComponentHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentHistory)
                return object;
            var message = new $root.pond.ComponentHistory();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.ComponentHistory.component: object expected");
                message.component = $root.pond.ComponentSettings.fromObject(object.component);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.parentDevice != null)
                message.parentDevice = String(object.parentDevice);
            if (object.progress != null)
                message.progress = String(object.progress);
            return message;
        };

        /**
         * Creates a plain object from a ComponentHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentHistory
         * @static
         * @param {pond.ComponentHistory} message ComponentHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.component = null;
                object.user = "";
                object.timestamp = "";
                object.parentDevice = "";
                object.progress = "";
            }
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.ComponentSettings.toObject(message.component, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.parentDevice != null && message.hasOwnProperty("parentDevice"))
                object.parentDevice = message.parentDevice;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            return object;
        };

        /**
         * Converts this ComponentHistory to JSON.
         * @function toJSON
         * @memberof pond.ComponentHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentHistory;
    })();

    pond.ListComponentHistoryResponse = (function() {

        /**
         * Properties of a ListComponentHistoryResponse.
         * @memberof pond
         * @interface IListComponentHistoryResponse
         * @property {Array.<pond.ComponentHistory>|null} [history] ListComponentHistoryResponse history
         * @property {number|null} [nextOffset] ListComponentHistoryResponse nextOffset
         * @property {number|null} [total] ListComponentHistoryResponse total
         */

        /**
         * Constructs a new ListComponentHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListComponentHistoryResponse.
         * @implements IListComponentHistoryResponse
         * @constructor
         * @param {pond.IListComponentHistoryResponse=} [properties] Properties to set
         */
        function ListComponentHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentHistoryResponse history.
         * @member {Array.<pond.ComponentHistory>} history
         * @memberof pond.ListComponentHistoryResponse
         * @instance
         */
        ListComponentHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListComponentHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListComponentHistoryResponse
         * @instance
         */
        ListComponentHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListComponentHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListComponentHistoryResponse
         * @instance
         */
        ListComponentHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListComponentHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentHistoryResponse
         * @static
         * @param {pond.IListComponentHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListComponentHistoryResponse} ListComponentHistoryResponse instance
         */
        ListComponentHistoryResponse.create = function create(properties) {
            return new ListComponentHistoryResponse(properties);
        };

        /**
         * Creates a ListComponentHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentHistoryResponse} ListComponentHistoryResponse
         */
        ListComponentHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentHistoryResponse)
                return object;
            var message = new $root.pond.ListComponentHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListComponentHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListComponentHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.ComponentHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListComponentHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentHistoryResponse
         * @static
         * @param {pond.ListComponentHistoryResponse} message ListComponentHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.ComponentHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListComponentHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListComponentHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentHistoryResponse;
    })();

    pond.InteractionCondition = (function() {

        /**
         * Properties of an InteractionCondition.
         * @memberof pond
         * @interface IInteractionCondition
         * @property {quack.MeasurementType|null} [measurementType] InteractionCondition measurementType
         * @property {quack.RelationalOperator|null} [comparison] InteractionCondition comparison
         * @property {number|null} [value] InteractionCondition value
         */

        /**
         * Constructs a new InteractionCondition.
         * @memberof pond
         * @classdesc Represents an InteractionCondition.
         * @implements IInteractionCondition
         * @constructor
         * @param {pond.IInteractionCondition=} [properties] Properties to set
         */
        function InteractionCondition(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionCondition measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof pond.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.measurementType = 0;

        /**
         * InteractionCondition comparison.
         * @member {quack.RelationalOperator} comparison
         * @memberof pond.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.comparison = 0;

        /**
         * InteractionCondition value.
         * @member {number} value
         * @memberof pond.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.value = 0;

        /**
         * Creates a new InteractionCondition instance using the specified properties.
         * @function create
         * @memberof pond.InteractionCondition
         * @static
         * @param {pond.IInteractionCondition=} [properties] Properties to set
         * @returns {pond.InteractionCondition} InteractionCondition instance
         */
        InteractionCondition.create = function create(properties) {
            return new InteractionCondition(properties);
        };

        /**
         * Creates an InteractionCondition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionCondition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionCondition} InteractionCondition
         */
        InteractionCondition.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionCondition)
                return object;
            var message = new $root.pond.InteractionCondition();
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            switch (object.comparison) {
            case "RELATIONAL_OPERATOR_INVALID":
            case 0:
                message.comparison = 0;
                break;
            case "RELATIONAL_OPERATOR_EQUAL_TO":
            case 1:
                message.comparison = 1;
                break;
            case "RELATIONAL_OPERATOR_LESS_THAN":
            case 2:
                message.comparison = 2;
                break;
            case "RELATIONAL_OPERATOR_GREATER_THAN":
            case 3:
                message.comparison = 3;
                break;
            }
            if (object.value != null)
                message.value = object.value | 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionCondition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionCondition
         * @static
         * @param {pond.InteractionCondition} message InteractionCondition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionCondition.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
                object.comparison = options.enums === String ? "RELATIONAL_OPERATOR_INVALID" : 0;
                object.value = 0;
            }
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            if (message.comparison != null && message.hasOwnProperty("comparison"))
                object.comparison = options.enums === String ? $root.quack.RelationalOperator[message.comparison] : message.comparison;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this InteractionCondition to JSON.
         * @function toJSON
         * @memberof pond.InteractionCondition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionCondition;
    })();

    pond.InteractionResult = (function() {

        /**
         * Properties of an InteractionResult.
         * @memberof pond
         * @interface IInteractionResult
         * @property {quack.InteractionResultType|null} [type] InteractionResult type
         * @property {number|null} [value] InteractionResult value
         * @property {number|null} [mode] InteractionResult mode
         * @property {number|null} [dutyCycle] InteractionResult dutyCycle
         */

        /**
         * Constructs a new InteractionResult.
         * @memberof pond
         * @classdesc Represents an InteractionResult.
         * @implements IInteractionResult
         * @constructor
         * @param {pond.IInteractionResult=} [properties] Properties to set
         */
        function InteractionResult(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionResult type.
         * @member {quack.InteractionResultType} type
         * @memberof pond.InteractionResult
         * @instance
         */
        InteractionResult.prototype.type = 0;

        /**
         * InteractionResult value.
         * @member {number} value
         * @memberof pond.InteractionResult
         * @instance
         */
        InteractionResult.prototype.value = 0;

        /**
         * InteractionResult mode.
         * @member {number} mode
         * @memberof pond.InteractionResult
         * @instance
         */
        InteractionResult.prototype.mode = 0;

        /**
         * InteractionResult dutyCycle.
         * @member {number} dutyCycle
         * @memberof pond.InteractionResult
         * @instance
         */
        InteractionResult.prototype.dutyCycle = 0;

        /**
         * Creates a new InteractionResult instance using the specified properties.
         * @function create
         * @memberof pond.InteractionResult
         * @static
         * @param {pond.IInteractionResult=} [properties] Properties to set
         * @returns {pond.InteractionResult} InteractionResult instance
         */
        InteractionResult.create = function create(properties) {
            return new InteractionResult(properties);
        };

        /**
         * Creates an InteractionResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionResult} InteractionResult
         */
        InteractionResult.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionResult)
                return object;
            var message = new $root.pond.InteractionResult();
            switch (object.type) {
            case "INTERACTION_RESULT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "INTERACTION_RESULT_TYPE_REPORT":
            case 1:
                message.type = 1;
                break;
            case "INTERACTION_RESULT_TYPE_TOGGLE":
            case 2:
                message.type = 2;
                break;
            case "INTERACTION_RESULT_TYPE_RUN":
            case 3:
                message.type = 3;
                break;
            case "INTERACTION_RESULT_TYPE_SET":
            case 4:
                message.type = 4;
                break;
            }
            if (object.value != null)
                message.value = object.value | 0;
            if (object.mode != null)
                message.mode = object.mode >>> 0;
            if (object.dutyCycle != null)
                message.dutyCycle = object.dutyCycle >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionResult
         * @static
         * @param {pond.InteractionResult} message InteractionResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "INTERACTION_RESULT_TYPE_INVALID" : 0;
                object.value = 0;
                object.mode = 0;
                object.dutyCycle = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.InteractionResultType[message.type] : message.type;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = message.mode;
            if (message.dutyCycle != null && message.hasOwnProperty("dutyCycle"))
                object.dutyCycle = message.dutyCycle;
            return object;
        };

        /**
         * Converts this InteractionResult to JSON.
         * @function toJSON
         * @memberof pond.InteractionResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionResult;
    })();

    pond.InteractionNotifications = (function() {

        /**
         * Properties of an InteractionNotifications.
         * @memberof pond
         * @interface IInteractionNotifications
         * @property {boolean|null} [reports] InteractionNotifications reports
         * @property {boolean|null} [notify] InteractionNotifications notify
         */

        /**
         * Constructs a new InteractionNotifications.
         * @memberof pond
         * @classdesc Represents an InteractionNotifications.
         * @implements IInteractionNotifications
         * @constructor
         * @param {pond.IInteractionNotifications=} [properties] Properties to set
         */
        function InteractionNotifications(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionNotifications reports.
         * @member {boolean} reports
         * @memberof pond.InteractionNotifications
         * @instance
         */
        InteractionNotifications.prototype.reports = false;

        /**
         * InteractionNotifications notify.
         * @member {boolean} notify
         * @memberof pond.InteractionNotifications
         * @instance
         */
        InteractionNotifications.prototype.notify = false;

        /**
         * Creates a new InteractionNotifications instance using the specified properties.
         * @function create
         * @memberof pond.InteractionNotifications
         * @static
         * @param {pond.IInteractionNotifications=} [properties] Properties to set
         * @returns {pond.InteractionNotifications} InteractionNotifications instance
         */
        InteractionNotifications.create = function create(properties) {
            return new InteractionNotifications(properties);
        };

        /**
         * Creates an InteractionNotifications message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionNotifications
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionNotifications} InteractionNotifications
         */
        InteractionNotifications.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionNotifications)
                return object;
            var message = new $root.pond.InteractionNotifications();
            if (object.reports != null)
                message.reports = Boolean(object.reports);
            if (object.notify != null)
                message.notify = Boolean(object.notify);
            return message;
        };

        /**
         * Creates a plain object from an InteractionNotifications message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionNotifications
         * @static
         * @param {pond.InteractionNotifications} message InteractionNotifications
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionNotifications.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.reports = false;
                object.notify = false;
            }
            if (message.reports != null && message.hasOwnProperty("reports"))
                object.reports = message.reports;
            if (message.notify != null && message.hasOwnProperty("notify"))
                object.notify = message.notify;
            return object;
        };

        /**
         * Converts this InteractionNotifications to JSON.
         * @function toJSON
         * @memberof pond.InteractionNotifications
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionNotifications.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionNotifications;
    })();

    pond.InteractionSchedule = (function() {

        /**
         * Properties of an InteractionSchedule.
         * @memberof pond
         * @interface IInteractionSchedule
         * @property {Array.<string>|null} [weekdays] InteractionSchedule weekdays
         * @property {string|null} [timeOfDayStart] InteractionSchedule timeOfDayStart
         * @property {string|null} [timeOfDayEnd] InteractionSchedule timeOfDayEnd
         * @property {string|null} [timezone] InteractionSchedule timezone
         */

        /**
         * Constructs a new InteractionSchedule.
         * @memberof pond
         * @classdesc Represents an InteractionSchedule.
         * @implements IInteractionSchedule
         * @constructor
         * @param {pond.IInteractionSchedule=} [properties] Properties to set
         */
        function InteractionSchedule(properties) {
            this.weekdays = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionSchedule weekdays.
         * @member {Array.<string>} weekdays
         * @memberof pond.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.weekdays = $util.emptyArray;

        /**
         * InteractionSchedule timeOfDayStart.
         * @member {string} timeOfDayStart
         * @memberof pond.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayStart = "";

        /**
         * InteractionSchedule timeOfDayEnd.
         * @member {string} timeOfDayEnd
         * @memberof pond.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayEnd = "";

        /**
         * InteractionSchedule timezone.
         * @member {string} timezone
         * @memberof pond.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timezone = "";

        /**
         * Creates a new InteractionSchedule instance using the specified properties.
         * @function create
         * @memberof pond.InteractionSchedule
         * @static
         * @param {pond.IInteractionSchedule=} [properties] Properties to set
         * @returns {pond.InteractionSchedule} InteractionSchedule instance
         */
        InteractionSchedule.create = function create(properties) {
            return new InteractionSchedule(properties);
        };

        /**
         * Creates an InteractionSchedule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionSchedule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionSchedule} InteractionSchedule
         */
        InteractionSchedule.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionSchedule)
                return object;
            var message = new $root.pond.InteractionSchedule();
            if (object.weekdays) {
                if (!Array.isArray(object.weekdays))
                    throw TypeError(".pond.InteractionSchedule.weekdays: array expected");
                message.weekdays = [];
                for (var i = 0; i < object.weekdays.length; ++i)
                    message.weekdays[i] = String(object.weekdays[i]);
            }
            if (object.timeOfDayStart != null)
                message.timeOfDayStart = String(object.timeOfDayStart);
            if (object.timeOfDayEnd != null)
                message.timeOfDayEnd = String(object.timeOfDayEnd);
            if (object.timezone != null)
                message.timezone = String(object.timezone);
            return message;
        };

        /**
         * Creates a plain object from an InteractionSchedule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionSchedule
         * @static
         * @param {pond.InteractionSchedule} message InteractionSchedule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionSchedule.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.weekdays = [];
            if (options.defaults) {
                object.timeOfDayStart = "";
                object.timeOfDayEnd = "";
                object.timezone = "";
            }
            if (message.weekdays && message.weekdays.length) {
                object.weekdays = [];
                for (var j = 0; j < message.weekdays.length; ++j)
                    object.weekdays[j] = message.weekdays[j];
            }
            if (message.timeOfDayStart != null && message.hasOwnProperty("timeOfDayStart"))
                object.timeOfDayStart = message.timeOfDayStart;
            if (message.timeOfDayEnd != null && message.hasOwnProperty("timeOfDayEnd"))
                object.timeOfDayEnd = message.timeOfDayEnd;
            if (message.timezone != null && message.hasOwnProperty("timezone"))
                object.timezone = message.timezone;
            return object;
        };

        /**
         * Converts this InteractionSchedule to JSON.
         * @function toJSON
         * @memberof pond.InteractionSchedule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionSchedule.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionSchedule;
    })();

    pond.InteractionSettings = (function() {

        /**
         * Properties of an InteractionSettings.
         * @memberof pond
         * @interface IInteractionSettings
         * @property {string|null} [key] InteractionSettings key
         * @property {quack.ComponentID|null} [source] InteractionSettings source
         * @property {quack.ComponentID|null} [sink] InteractionSettings sink
         * @property {number|null} [instance] InteractionSettings instance
         * @property {Array.<pond.InteractionCondition>|null} [conditions] InteractionSettings conditions
         * @property {pond.InteractionResult|null} [result] InteractionSettings result
         * @property {pond.InteractionNotifications|null} [notifications] InteractionSettings notifications
         * @property {string|null} [removed] InteractionSettings removed
         * @property {pond.InteractionSchedule|null} [schedule] InteractionSettings schedule
         * @property {number|null} [priority] InteractionSettings priority
         * @property {number|null} [subtype] InteractionSettings subtype
         * @property {number|null} [nodeOne] InteractionSettings nodeOne
         * @property {number|null} [nodeTwo] InteractionSettings nodeTwo
         * @property {number|null} [sortPriority] InteractionSettings sortPriority
         */

        /**
         * Constructs a new InteractionSettings.
         * @memberof pond
         * @classdesc Represents an InteractionSettings.
         * @implements IInteractionSettings
         * @constructor
         * @param {pond.IInteractionSettings=} [properties] Properties to set
         */
        function InteractionSettings(properties) {
            this.conditions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionSettings key.
         * @member {string} key
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.key = "";

        /**
         * InteractionSettings source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.source = null;

        /**
         * InteractionSettings sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.sink = null;

        /**
         * InteractionSettings instance.
         * @member {number} instance
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.instance = 0;

        /**
         * InteractionSettings conditions.
         * @member {Array.<pond.InteractionCondition>} conditions
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.conditions = $util.emptyArray;

        /**
         * InteractionSettings result.
         * @member {pond.InteractionResult|null|undefined} result
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.result = null;

        /**
         * InteractionSettings notifications.
         * @member {pond.InteractionNotifications|null|undefined} notifications
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.notifications = null;

        /**
         * InteractionSettings removed.
         * @member {string} removed
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.removed = "";

        /**
         * InteractionSettings schedule.
         * @member {pond.InteractionSchedule|null|undefined} schedule
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.schedule = null;

        /**
         * InteractionSettings priority.
         * @member {number} priority
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.priority = 0;

        /**
         * InteractionSettings subtype.
         * @member {number} subtype
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.subtype = 0;

        /**
         * InteractionSettings nodeOne.
         * @member {number} nodeOne
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.nodeOne = 0;

        /**
         * InteractionSettings nodeTwo.
         * @member {number} nodeTwo
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.nodeTwo = 0;

        /**
         * InteractionSettings sortPriority.
         * @member {number} sortPriority
         * @memberof pond.InteractionSettings
         * @instance
         */
        InteractionSettings.prototype.sortPriority = 0;

        /**
         * Creates a new InteractionSettings instance using the specified properties.
         * @function create
         * @memberof pond.InteractionSettings
         * @static
         * @param {pond.IInteractionSettings=} [properties] Properties to set
         * @returns {pond.InteractionSettings} InteractionSettings instance
         */
        InteractionSettings.create = function create(properties) {
            return new InteractionSettings(properties);
        };

        /**
         * Creates an InteractionSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionSettings} InteractionSettings
         */
        InteractionSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionSettings)
                return object;
            var message = new $root.pond.InteractionSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".pond.InteractionSettings.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".pond.InteractionSettings.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            if (object.instance != null)
                message.instance = object.instance >>> 0;
            if (object.conditions) {
                if (!Array.isArray(object.conditions))
                    throw TypeError(".pond.InteractionSettings.conditions: array expected");
                message.conditions = [];
                for (var i = 0; i < object.conditions.length; ++i) {
                    if (typeof object.conditions[i] !== "object")
                        throw TypeError(".pond.InteractionSettings.conditions: object expected");
                    message.conditions[i] = $root.pond.InteractionCondition.fromObject(object.conditions[i]);
                }
            }
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".pond.InteractionSettings.result: object expected");
                message.result = $root.pond.InteractionResult.fromObject(object.result);
            }
            if (object.notifications != null) {
                if (typeof object.notifications !== "object")
                    throw TypeError(".pond.InteractionSettings.notifications: object expected");
                message.notifications = $root.pond.InteractionNotifications.fromObject(object.notifications);
            }
            if (object.removed != null)
                message.removed = String(object.removed);
            if (object.schedule != null) {
                if (typeof object.schedule !== "object")
                    throw TypeError(".pond.InteractionSettings.schedule: object expected");
                message.schedule = $root.pond.InteractionSchedule.fromObject(object.schedule);
            }
            if (object.priority != null)
                message.priority = object.priority >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.nodeOne != null)
                message.nodeOne = object.nodeOne >>> 0;
            if (object.nodeTwo != null)
                message.nodeTwo = object.nodeTwo >>> 0;
            if (object.sortPriority != null)
                message.sortPriority = object.sortPriority >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionSettings
         * @static
         * @param {pond.InteractionSettings} message InteractionSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.conditions = [];
            if (options.defaults) {
                object.key = "";
                object.source = null;
                object.sink = null;
                object.instance = 0;
                object.result = null;
                object.notifications = null;
                object.removed = "";
                object.schedule = null;
                object.priority = 0;
                object.subtype = 0;
                object.nodeOne = 0;
                object.nodeTwo = 0;
                object.sortPriority = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            if (message.instance != null && message.hasOwnProperty("instance"))
                object.instance = message.instance;
            if (message.conditions && message.conditions.length) {
                object.conditions = [];
                for (var j = 0; j < message.conditions.length; ++j)
                    object.conditions[j] = $root.pond.InteractionCondition.toObject(message.conditions[j], options);
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.pond.InteractionResult.toObject(message.result, options);
            if (message.notifications != null && message.hasOwnProperty("notifications"))
                object.notifications = $root.pond.InteractionNotifications.toObject(message.notifications, options);
            if (message.removed != null && message.hasOwnProperty("removed"))
                object.removed = message.removed;
            if (message.schedule != null && message.hasOwnProperty("schedule"))
                object.schedule = $root.pond.InteractionSchedule.toObject(message.schedule, options);
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.nodeOne != null && message.hasOwnProperty("nodeOne"))
                object.nodeOne = message.nodeOne;
            if (message.nodeTwo != null && message.hasOwnProperty("nodeTwo"))
                object.nodeTwo = message.nodeTwo;
            if (message.sortPriority != null && message.hasOwnProperty("sortPriority"))
                object.sortPriority = message.sortPriority;
            return object;
        };

        /**
         * Converts this InteractionSettings to JSON.
         * @function toJSON
         * @memberof pond.InteractionSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionSettings;
    })();

    pond.InteractionPondSettings = (function() {

        /**
         * Properties of an InteractionPondSettings.
         * @memberof pond
         * @interface IInteractionPondSettings
         * @property {number|null} [sortPriority] InteractionPondSettings sortPriority
         */

        /**
         * Constructs a new InteractionPondSettings.
         * @memberof pond
         * @classdesc Represents an InteractionPondSettings.
         * @implements IInteractionPondSettings
         * @constructor
         * @param {pond.IInteractionPondSettings=} [properties] Properties to set
         */
        function InteractionPondSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionPondSettings sortPriority.
         * @member {number} sortPriority
         * @memberof pond.InteractionPondSettings
         * @instance
         */
        InteractionPondSettings.prototype.sortPriority = 0;

        /**
         * Creates a new InteractionPondSettings instance using the specified properties.
         * @function create
         * @memberof pond.InteractionPondSettings
         * @static
         * @param {pond.IInteractionPondSettings=} [properties] Properties to set
         * @returns {pond.InteractionPondSettings} InteractionPondSettings instance
         */
        InteractionPondSettings.create = function create(properties) {
            return new InteractionPondSettings(properties);
        };

        /**
         * Creates an InteractionPondSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionPondSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionPondSettings} InteractionPondSettings
         */
        InteractionPondSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionPondSettings)
                return object;
            var message = new $root.pond.InteractionPondSettings();
            if (object.sortPriority != null)
                message.sortPriority = object.sortPriority >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionPondSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionPondSettings
         * @static
         * @param {pond.InteractionPondSettings} message InteractionPondSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionPondSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.sortPriority = 0;
            if (message.sortPriority != null && message.hasOwnProperty("sortPriority"))
                object.sortPriority = message.sortPriority;
            return object;
        };

        /**
         * Converts this InteractionPondSettings to JSON.
         * @function toJSON
         * @memberof pond.InteractionPondSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionPondSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionPondSettings;
    })();

    pond.AddInteractionRequest = (function() {

        /**
         * Properties of an AddInteractionRequest.
         * @memberof pond
         * @interface IAddInteractionRequest
         * @property {number|null} [device] AddInteractionRequest device
         * @property {pond.InteractionSettings|null} [interaction] AddInteractionRequest interaction
         */

        /**
         * Constructs a new AddInteractionRequest.
         * @memberof pond
         * @classdesc Represents an AddInteractionRequest.
         * @implements IAddInteractionRequest
         * @constructor
         * @param {pond.IAddInteractionRequest=} [properties] Properties to set
         */
        function AddInteractionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddInteractionRequest device.
         * @member {number} device
         * @memberof pond.AddInteractionRequest
         * @instance
         */
        AddInteractionRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddInteractionRequest interaction.
         * @member {pond.InteractionSettings|null|undefined} interaction
         * @memberof pond.AddInteractionRequest
         * @instance
         */
        AddInteractionRequest.prototype.interaction = null;

        /**
         * Creates a new AddInteractionRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddInteractionRequest
         * @static
         * @param {pond.IAddInteractionRequest=} [properties] Properties to set
         * @returns {pond.AddInteractionRequest} AddInteractionRequest instance
         */
        AddInteractionRequest.create = function create(properties) {
            return new AddInteractionRequest(properties);
        };

        /**
         * Creates an AddInteractionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddInteractionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddInteractionRequest} AddInteractionRequest
         */
        AddInteractionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddInteractionRequest)
                return object;
            var message = new $root.pond.AddInteractionRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".pond.AddInteractionRequest.interaction: object expected");
                message.interaction = $root.pond.InteractionSettings.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddInteractionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddInteractionRequest
         * @static
         * @param {pond.AddInteractionRequest} message AddInteractionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteractionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.interaction = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.pond.InteractionSettings.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this AddInteractionRequest to JSON.
         * @function toJSON
         * @memberof pond.AddInteractionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteractionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteractionRequest;
    })();

    pond.MultiInteractionSettings = (function() {

        /**
         * Properties of a MultiInteractionSettings.
         * @memberof pond
         * @interface IMultiInteractionSettings
         * @property {Array.<pond.InteractionSettings>|null} [interactions] MultiInteractionSettings interactions
         */

        /**
         * Constructs a new MultiInteractionSettings.
         * @memberof pond
         * @classdesc Represents a MultiInteractionSettings.
         * @implements IMultiInteractionSettings
         * @constructor
         * @param {pond.IMultiInteractionSettings=} [properties] Properties to set
         */
        function MultiInteractionSettings(properties) {
            this.interactions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MultiInteractionSettings interactions.
         * @member {Array.<pond.InteractionSettings>} interactions
         * @memberof pond.MultiInteractionSettings
         * @instance
         */
        MultiInteractionSettings.prototype.interactions = $util.emptyArray;

        /**
         * Creates a new MultiInteractionSettings instance using the specified properties.
         * @function create
         * @memberof pond.MultiInteractionSettings
         * @static
         * @param {pond.IMultiInteractionSettings=} [properties] Properties to set
         * @returns {pond.MultiInteractionSettings} MultiInteractionSettings instance
         */
        MultiInteractionSettings.create = function create(properties) {
            return new MultiInteractionSettings(properties);
        };

        /**
         * Creates a MultiInteractionSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MultiInteractionSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MultiInteractionSettings} MultiInteractionSettings
         */
        MultiInteractionSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MultiInteractionSettings)
                return object;
            var message = new $root.pond.MultiInteractionSettings();
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.MultiInteractionSettings.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.MultiInteractionSettings.interactions: object expected");
                    message.interactions[i] = $root.pond.InteractionSettings.fromObject(object.interactions[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MultiInteractionSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MultiInteractionSettings
         * @static
         * @param {pond.MultiInteractionSettings} message MultiInteractionSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MultiInteractionSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.interactions = [];
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.InteractionSettings.toObject(message.interactions[j], options);
            }
            return object;
        };

        /**
         * Converts this MultiInteractionSettings to JSON.
         * @function toJSON
         * @memberof pond.MultiInteractionSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MultiInteractionSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MultiInteractionSettings;
    })();

    pond.AddMultiInteractionsRequest = (function() {

        /**
         * Properties of an AddMultiInteractionsRequest.
         * @memberof pond
         * @interface IAddMultiInteractionsRequest
         * @property {number|null} [device] AddMultiInteractionsRequest device
         * @property {pond.MultiInteractionSettings|null} [interactions] AddMultiInteractionsRequest interactions
         */

        /**
         * Constructs a new AddMultiInteractionsRequest.
         * @memberof pond
         * @classdesc Represents an AddMultiInteractionsRequest.
         * @implements IAddMultiInteractionsRequest
         * @constructor
         * @param {pond.IAddMultiInteractionsRequest=} [properties] Properties to set
         */
        function AddMultiInteractionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddMultiInteractionsRequest device.
         * @member {number} device
         * @memberof pond.AddMultiInteractionsRequest
         * @instance
         */
        AddMultiInteractionsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddMultiInteractionsRequest interactions.
         * @member {pond.MultiInteractionSettings|null|undefined} interactions
         * @memberof pond.AddMultiInteractionsRequest
         * @instance
         */
        AddMultiInteractionsRequest.prototype.interactions = null;

        /**
         * Creates a new AddMultiInteractionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddMultiInteractionsRequest
         * @static
         * @param {pond.IAddMultiInteractionsRequest=} [properties] Properties to set
         * @returns {pond.AddMultiInteractionsRequest} AddMultiInteractionsRequest instance
         */
        AddMultiInteractionsRequest.create = function create(properties) {
            return new AddMultiInteractionsRequest(properties);
        };

        /**
         * Creates an AddMultiInteractionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMultiInteractionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMultiInteractionsRequest} AddMultiInteractionsRequest
         */
        AddMultiInteractionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMultiInteractionsRequest)
                return object;
            var message = new $root.pond.AddMultiInteractionsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.interactions != null) {
                if (typeof object.interactions !== "object")
                    throw TypeError(".pond.AddMultiInteractionsRequest.interactions: object expected");
                message.interactions = $root.pond.MultiInteractionSettings.fromObject(object.interactions);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddMultiInteractionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMultiInteractionsRequest
         * @static
         * @param {pond.AddMultiInteractionsRequest} message AddMultiInteractionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMultiInteractionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.interactions = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.interactions != null && message.hasOwnProperty("interactions"))
                object.interactions = $root.pond.MultiInteractionSettings.toObject(message.interactions, options);
            return object;
        };

        /**
         * Converts this AddMultiInteractionsRequest to JSON.
         * @function toJSON
         * @memberof pond.AddMultiInteractionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMultiInteractionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMultiInteractionsRequest;
    })();

    pond.AddInteractionToComponentsRequest = (function() {

        /**
         * Properties of an AddInteractionToComponentsRequest.
         * @memberof pond
         * @interface IAddInteractionToComponentsRequest
         * @property {Array.<string>|null} [componentDevices] AddInteractionToComponentsRequest componentDevices
         * @property {pond.InteractionSettings|null} [interaction] AddInteractionToComponentsRequest interaction
         */

        /**
         * Constructs a new AddInteractionToComponentsRequest.
         * @memberof pond
         * @classdesc Represents an AddInteractionToComponentsRequest.
         * @implements IAddInteractionToComponentsRequest
         * @constructor
         * @param {pond.IAddInteractionToComponentsRequest=} [properties] Properties to set
         */
        function AddInteractionToComponentsRequest(properties) {
            this.componentDevices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddInteractionToComponentsRequest componentDevices.
         * @member {Array.<string>} componentDevices
         * @memberof pond.AddInteractionToComponentsRequest
         * @instance
         */
        AddInteractionToComponentsRequest.prototype.componentDevices = $util.emptyArray;

        /**
         * AddInteractionToComponentsRequest interaction.
         * @member {pond.InteractionSettings|null|undefined} interaction
         * @memberof pond.AddInteractionToComponentsRequest
         * @instance
         */
        AddInteractionToComponentsRequest.prototype.interaction = null;

        /**
         * Creates a new AddInteractionToComponentsRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddInteractionToComponentsRequest
         * @static
         * @param {pond.IAddInteractionToComponentsRequest=} [properties] Properties to set
         * @returns {pond.AddInteractionToComponentsRequest} AddInteractionToComponentsRequest instance
         */
        AddInteractionToComponentsRequest.create = function create(properties) {
            return new AddInteractionToComponentsRequest(properties);
        };

        /**
         * Creates an AddInteractionToComponentsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddInteractionToComponentsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddInteractionToComponentsRequest} AddInteractionToComponentsRequest
         */
        AddInteractionToComponentsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddInteractionToComponentsRequest)
                return object;
            var message = new $root.pond.AddInteractionToComponentsRequest();
            if (object.componentDevices) {
                if (!Array.isArray(object.componentDevices))
                    throw TypeError(".pond.AddInteractionToComponentsRequest.componentDevices: array expected");
                message.componentDevices = [];
                for (var i = 0; i < object.componentDevices.length; ++i)
                    message.componentDevices[i] = String(object.componentDevices[i]);
            }
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".pond.AddInteractionToComponentsRequest.interaction: object expected");
                message.interaction = $root.pond.InteractionSettings.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddInteractionToComponentsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddInteractionToComponentsRequest
         * @static
         * @param {pond.AddInteractionToComponentsRequest} message AddInteractionToComponentsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteractionToComponentsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.componentDevices = [];
            if (options.defaults)
                object.interaction = null;
            if (message.componentDevices && message.componentDevices.length) {
                object.componentDevices = [];
                for (var j = 0; j < message.componentDevices.length; ++j)
                    object.componentDevices[j] = message.componentDevices[j];
            }
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.pond.InteractionSettings.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this AddInteractionToComponentsRequest to JSON.
         * @function toJSON
         * @memberof pond.AddInteractionToComponentsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteractionToComponentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteractionToComponentsRequest;
    })();

    pond.AddInteractionToComponentsResponse = (function() {

        /**
         * Properties of an AddInteractionToComponentsResponse.
         * @memberof pond
         * @interface IAddInteractionToComponentsResponse
         */

        /**
         * Constructs a new AddInteractionToComponentsResponse.
         * @memberof pond
         * @classdesc Represents an AddInteractionToComponentsResponse.
         * @implements IAddInteractionToComponentsResponse
         * @constructor
         * @param {pond.IAddInteractionToComponentsResponse=} [properties] Properties to set
         */
        function AddInteractionToComponentsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddInteractionToComponentsResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddInteractionToComponentsResponse
         * @static
         * @param {pond.IAddInteractionToComponentsResponse=} [properties] Properties to set
         * @returns {pond.AddInteractionToComponentsResponse} AddInteractionToComponentsResponse instance
         */
        AddInteractionToComponentsResponse.create = function create(properties) {
            return new AddInteractionToComponentsResponse(properties);
        };

        /**
         * Creates an AddInteractionToComponentsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddInteractionToComponentsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddInteractionToComponentsResponse} AddInteractionToComponentsResponse
         */
        AddInteractionToComponentsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddInteractionToComponentsResponse)
                return object;
            return new $root.pond.AddInteractionToComponentsResponse();
        };

        /**
         * Creates a plain object from an AddInteractionToComponentsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddInteractionToComponentsResponse
         * @static
         * @param {pond.AddInteractionToComponentsResponse} message AddInteractionToComponentsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteractionToComponentsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddInteractionToComponentsResponse to JSON.
         * @function toJSON
         * @memberof pond.AddInteractionToComponentsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteractionToComponentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteractionToComponentsResponse;
    })();

    pond.AddInteractionResponse = (function() {

        /**
         * Properties of an AddInteractionResponse.
         * @memberof pond
         * @interface IAddInteractionResponse
         */

        /**
         * Constructs a new AddInteractionResponse.
         * @memberof pond
         * @classdesc Represents an AddInteractionResponse.
         * @implements IAddInteractionResponse
         * @constructor
         * @param {pond.IAddInteractionResponse=} [properties] Properties to set
         */
        function AddInteractionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddInteractionResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddInteractionResponse
         * @static
         * @param {pond.IAddInteractionResponse=} [properties] Properties to set
         * @returns {pond.AddInteractionResponse} AddInteractionResponse instance
         */
        AddInteractionResponse.create = function create(properties) {
            return new AddInteractionResponse(properties);
        };

        /**
         * Creates an AddInteractionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddInteractionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddInteractionResponse} AddInteractionResponse
         */
        AddInteractionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddInteractionResponse)
                return object;
            return new $root.pond.AddInteractionResponse();
        };

        /**
         * Creates a plain object from an AddInteractionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddInteractionResponse
         * @static
         * @param {pond.AddInteractionResponse} message AddInteractionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteractionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddInteractionResponse to JSON.
         * @function toJSON
         * @memberof pond.AddInteractionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteractionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteractionResponse;
    })();

    pond.AddMultiInteractionsResponse = (function() {

        /**
         * Properties of an AddMultiInteractionsResponse.
         * @memberof pond
         * @interface IAddMultiInteractionsResponse
         */

        /**
         * Constructs a new AddMultiInteractionsResponse.
         * @memberof pond
         * @classdesc Represents an AddMultiInteractionsResponse.
         * @implements IAddMultiInteractionsResponse
         * @constructor
         * @param {pond.IAddMultiInteractionsResponse=} [properties] Properties to set
         */
        function AddMultiInteractionsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddMultiInteractionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddMultiInteractionsResponse
         * @static
         * @param {pond.IAddMultiInteractionsResponse=} [properties] Properties to set
         * @returns {pond.AddMultiInteractionsResponse} AddMultiInteractionsResponse instance
         */
        AddMultiInteractionsResponse.create = function create(properties) {
            return new AddMultiInteractionsResponse(properties);
        };

        /**
         * Creates an AddMultiInteractionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMultiInteractionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMultiInteractionsResponse} AddMultiInteractionsResponse
         */
        AddMultiInteractionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMultiInteractionsResponse)
                return object;
            return new $root.pond.AddMultiInteractionsResponse();
        };

        /**
         * Creates a plain object from an AddMultiInteractionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMultiInteractionsResponse
         * @static
         * @param {pond.AddMultiInteractionsResponse} message AddMultiInteractionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMultiInteractionsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddMultiInteractionsResponse to JSON.
         * @function toJSON
         * @memberof pond.AddMultiInteractionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMultiInteractionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMultiInteractionsResponse;
    })();

    pond.RemoveInteractionRequest = (function() {

        /**
         * Properties of a RemoveInteractionRequest.
         * @memberof pond
         * @interface IRemoveInteractionRequest
         * @property {number|null} [device] RemoveInteractionRequest device
         * @property {string|null} [interaction] RemoveInteractionRequest interaction
         */

        /**
         * Constructs a new RemoveInteractionRequest.
         * @memberof pond
         * @classdesc Represents a RemoveInteractionRequest.
         * @implements IRemoveInteractionRequest
         * @constructor
         * @param {pond.IRemoveInteractionRequest=} [properties] Properties to set
         */
        function RemoveInteractionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveInteractionRequest device.
         * @member {number} device
         * @memberof pond.RemoveInteractionRequest
         * @instance
         */
        RemoveInteractionRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RemoveInteractionRequest interaction.
         * @member {string} interaction
         * @memberof pond.RemoveInteractionRequest
         * @instance
         */
        RemoveInteractionRequest.prototype.interaction = "";

        /**
         * Creates a new RemoveInteractionRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveInteractionRequest
         * @static
         * @param {pond.IRemoveInteractionRequest=} [properties] Properties to set
         * @returns {pond.RemoveInteractionRequest} RemoveInteractionRequest instance
         */
        RemoveInteractionRequest.create = function create(properties) {
            return new RemoveInteractionRequest(properties);
        };

        /**
         * Creates a RemoveInteractionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveInteractionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveInteractionRequest} RemoveInteractionRequest
         */
        RemoveInteractionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveInteractionRequest)
                return object;
            var message = new $root.pond.RemoveInteractionRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.interaction != null)
                message.interaction = String(object.interaction);
            return message;
        };

        /**
         * Creates a plain object from a RemoveInteractionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveInteractionRequest
         * @static
         * @param {pond.RemoveInteractionRequest} message RemoveInteractionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveInteractionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.interaction = "";
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = message.interaction;
            return object;
        };

        /**
         * Converts this RemoveInteractionRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveInteractionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveInteractionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveInteractionRequest;
    })();

    pond.RemoveInteractionResponse = (function() {

        /**
         * Properties of a RemoveInteractionResponse.
         * @memberof pond
         * @interface IRemoveInteractionResponse
         */

        /**
         * Constructs a new RemoveInteractionResponse.
         * @memberof pond
         * @classdesc Represents a RemoveInteractionResponse.
         * @implements IRemoveInteractionResponse
         * @constructor
         * @param {pond.IRemoveInteractionResponse=} [properties] Properties to set
         */
        function RemoveInteractionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveInteractionResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveInteractionResponse
         * @static
         * @param {pond.IRemoveInteractionResponse=} [properties] Properties to set
         * @returns {pond.RemoveInteractionResponse} RemoveInteractionResponse instance
         */
        RemoveInteractionResponse.create = function create(properties) {
            return new RemoveInteractionResponse(properties);
        };

        /**
         * Creates a RemoveInteractionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveInteractionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveInteractionResponse} RemoveInteractionResponse
         */
        RemoveInteractionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveInteractionResponse)
                return object;
            return new $root.pond.RemoveInteractionResponse();
        };

        /**
         * Creates a plain object from a RemoveInteractionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveInteractionResponse
         * @static
         * @param {pond.RemoveInteractionResponse} message RemoveInteractionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveInteractionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveInteractionResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveInteractionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveInteractionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveInteractionResponse;
    })();

    pond.UpdateInteractionRequest = (function() {

        /**
         * Properties of an UpdateInteractionRequest.
         * @memberof pond
         * @interface IUpdateInteractionRequest
         * @property {number|null} [device] UpdateInteractionRequest device
         * @property {pond.InteractionSettings|null} [interaction] UpdateInteractionRequest interaction
         */

        /**
         * Constructs a new UpdateInteractionRequest.
         * @memberof pond
         * @classdesc Represents an UpdateInteractionRequest.
         * @implements IUpdateInteractionRequest
         * @constructor
         * @param {pond.IUpdateInteractionRequest=} [properties] Properties to set
         */
        function UpdateInteractionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateInteractionRequest device.
         * @member {number} device
         * @memberof pond.UpdateInteractionRequest
         * @instance
         */
        UpdateInteractionRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpdateInteractionRequest interaction.
         * @member {pond.InteractionSettings|null|undefined} interaction
         * @memberof pond.UpdateInteractionRequest
         * @instance
         */
        UpdateInteractionRequest.prototype.interaction = null;

        /**
         * Creates a new UpdateInteractionRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateInteractionRequest
         * @static
         * @param {pond.IUpdateInteractionRequest=} [properties] Properties to set
         * @returns {pond.UpdateInteractionRequest} UpdateInteractionRequest instance
         */
        UpdateInteractionRequest.create = function create(properties) {
            return new UpdateInteractionRequest(properties);
        };

        /**
         * Creates an UpdateInteractionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateInteractionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateInteractionRequest} UpdateInteractionRequest
         */
        UpdateInteractionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateInteractionRequest)
                return object;
            var message = new $root.pond.UpdateInteractionRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".pond.UpdateInteractionRequest.interaction: object expected");
                message.interaction = $root.pond.InteractionSettings.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateInteractionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateInteractionRequest
         * @static
         * @param {pond.UpdateInteractionRequest} message UpdateInteractionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteractionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.interaction = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.pond.InteractionSettings.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this UpdateInteractionRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateInteractionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteractionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteractionRequest;
    })();

    pond.UpdateInteractionPondSettingsRequest = (function() {

        /**
         * Properties of an UpdateInteractionPondSettingsRequest.
         * @memberof pond
         * @interface IUpdateInteractionPondSettingsRequest
         * @property {number|null} [device] UpdateInteractionPondSettingsRequest device
         * @property {string|null} [key] UpdateInteractionPondSettingsRequest key
         * @property {pond.InteractionPondSettings|null} [interaction] UpdateInteractionPondSettingsRequest interaction
         */

        /**
         * Constructs a new UpdateInteractionPondSettingsRequest.
         * @memberof pond
         * @classdesc Represents an UpdateInteractionPondSettingsRequest.
         * @implements IUpdateInteractionPondSettingsRequest
         * @constructor
         * @param {pond.IUpdateInteractionPondSettingsRequest=} [properties] Properties to set
         */
        function UpdateInteractionPondSettingsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateInteractionPondSettingsRequest device.
         * @member {number} device
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @instance
         */
        UpdateInteractionPondSettingsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpdateInteractionPondSettingsRequest key.
         * @member {string} key
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @instance
         */
        UpdateInteractionPondSettingsRequest.prototype.key = "";

        /**
         * UpdateInteractionPondSettingsRequest interaction.
         * @member {pond.InteractionPondSettings|null|undefined} interaction
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @instance
         */
        UpdateInteractionPondSettingsRequest.prototype.interaction = null;

        /**
         * Creates a new UpdateInteractionPondSettingsRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @static
         * @param {pond.IUpdateInteractionPondSettingsRequest=} [properties] Properties to set
         * @returns {pond.UpdateInteractionPondSettingsRequest} UpdateInteractionPondSettingsRequest instance
         */
        UpdateInteractionPondSettingsRequest.create = function create(properties) {
            return new UpdateInteractionPondSettingsRequest(properties);
        };

        /**
         * Creates an UpdateInteractionPondSettingsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateInteractionPondSettingsRequest} UpdateInteractionPondSettingsRequest
         */
        UpdateInteractionPondSettingsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateInteractionPondSettingsRequest)
                return object;
            var message = new $root.pond.UpdateInteractionPondSettingsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.key != null)
                message.key = String(object.key);
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".pond.UpdateInteractionPondSettingsRequest.interaction: object expected");
                message.interaction = $root.pond.InteractionPondSettings.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateInteractionPondSettingsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @static
         * @param {pond.UpdateInteractionPondSettingsRequest} message UpdateInteractionPondSettingsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteractionPondSettingsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.key = "";
                object.interaction = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.pond.InteractionPondSettings.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this UpdateInteractionPondSettingsRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateInteractionPondSettingsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteractionPondSettingsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteractionPondSettingsRequest;
    })();

    pond.UpdateInteractionResponse = (function() {

        /**
         * Properties of an UpdateInteractionResponse.
         * @memberof pond
         * @interface IUpdateInteractionResponse
         */

        /**
         * Constructs a new UpdateInteractionResponse.
         * @memberof pond
         * @classdesc Represents an UpdateInteractionResponse.
         * @implements IUpdateInteractionResponse
         * @constructor
         * @param {pond.IUpdateInteractionResponse=} [properties] Properties to set
         */
        function UpdateInteractionResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateInteractionResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateInteractionResponse
         * @static
         * @param {pond.IUpdateInteractionResponse=} [properties] Properties to set
         * @returns {pond.UpdateInteractionResponse} UpdateInteractionResponse instance
         */
        UpdateInteractionResponse.create = function create(properties) {
            return new UpdateInteractionResponse(properties);
        };

        /**
         * Creates an UpdateInteractionResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateInteractionResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateInteractionResponse} UpdateInteractionResponse
         */
        UpdateInteractionResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateInteractionResponse)
                return object;
            return new $root.pond.UpdateInteractionResponse();
        };

        /**
         * Creates a plain object from an UpdateInteractionResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateInteractionResponse
         * @static
         * @param {pond.UpdateInteractionResponse} message UpdateInteractionResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteractionResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateInteractionResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateInteractionResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteractionResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteractionResponse;
    })();

    pond.UpdateInteractionPondSettingsResponse = (function() {

        /**
         * Properties of an UpdateInteractionPondSettingsResponse.
         * @memberof pond
         * @interface IUpdateInteractionPondSettingsResponse
         */

        /**
         * Constructs a new UpdateInteractionPondSettingsResponse.
         * @memberof pond
         * @classdesc Represents an UpdateInteractionPondSettingsResponse.
         * @implements IUpdateInteractionPondSettingsResponse
         * @constructor
         * @param {pond.IUpdateInteractionPondSettingsResponse=} [properties] Properties to set
         */
        function UpdateInteractionPondSettingsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateInteractionPondSettingsResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateInteractionPondSettingsResponse
         * @static
         * @param {pond.IUpdateInteractionPondSettingsResponse=} [properties] Properties to set
         * @returns {pond.UpdateInteractionPondSettingsResponse} UpdateInteractionPondSettingsResponse instance
         */
        UpdateInteractionPondSettingsResponse.create = function create(properties) {
            return new UpdateInteractionPondSettingsResponse(properties);
        };

        /**
         * Creates an UpdateInteractionPondSettingsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateInteractionPondSettingsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateInteractionPondSettingsResponse} UpdateInteractionPondSettingsResponse
         */
        UpdateInteractionPondSettingsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateInteractionPondSettingsResponse)
                return object;
            return new $root.pond.UpdateInteractionPondSettingsResponse();
        };

        /**
         * Creates a plain object from an UpdateInteractionPondSettingsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateInteractionPondSettingsResponse
         * @static
         * @param {pond.UpdateInteractionPondSettingsResponse} message UpdateInteractionPondSettingsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteractionPondSettingsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateInteractionPondSettingsResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateInteractionPondSettingsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteractionPondSettingsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteractionPondSettingsResponse;
    })();

    pond.GetInteractionRequest = (function() {

        /**
         * Properties of a GetInteractionRequest.
         * @memberof pond
         * @interface IGetInteractionRequest
         * @property {number|null} [device] GetInteractionRequest device
         * @property {string|null} [interaction] GetInteractionRequest interaction
         */

        /**
         * Constructs a new GetInteractionRequest.
         * @memberof pond
         * @classdesc Represents a GetInteractionRequest.
         * @implements IGetInteractionRequest
         * @constructor
         * @param {pond.IGetInteractionRequest=} [properties] Properties to set
         */
        function GetInteractionRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetInteractionRequest device.
         * @member {number} device
         * @memberof pond.GetInteractionRequest
         * @instance
         */
        GetInteractionRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetInteractionRequest interaction.
         * @member {string} interaction
         * @memberof pond.GetInteractionRequest
         * @instance
         */
        GetInteractionRequest.prototype.interaction = "";

        /**
         * Creates a new GetInteractionRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetInteractionRequest
         * @static
         * @param {pond.IGetInteractionRequest=} [properties] Properties to set
         * @returns {pond.GetInteractionRequest} GetInteractionRequest instance
         */
        GetInteractionRequest.create = function create(properties) {
            return new GetInteractionRequest(properties);
        };

        /**
         * Creates a GetInteractionRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetInteractionRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetInteractionRequest} GetInteractionRequest
         */
        GetInteractionRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetInteractionRequest)
                return object;
            var message = new $root.pond.GetInteractionRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.interaction != null)
                message.interaction = String(object.interaction);
            return message;
        };

        /**
         * Creates a plain object from a GetInteractionRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetInteractionRequest
         * @static
         * @param {pond.GetInteractionRequest} message GetInteractionRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetInteractionRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.interaction = "";
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = message.interaction;
            return object;
        };

        /**
         * Converts this GetInteractionRequest to JSON.
         * @function toJSON
         * @memberof pond.GetInteractionRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetInteractionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetInteractionRequest;
    })();

    pond.InteractionStatus = (function() {

        /**
         * Properties of an InteractionStatus.
         * @memberof pond
         * @interface IInteractionStatus
         * @property {string|null} [lastUpdate] InteractionStatus lastUpdate
         * @property {boolean|null} [synced] InteractionStatus synced
         * @property {string|null} [lastSynced] InteractionStatus lastSynced
         */

        /**
         * Constructs a new InteractionStatus.
         * @memberof pond
         * @classdesc Represents an InteractionStatus.
         * @implements IInteractionStatus
         * @constructor
         * @param {pond.IInteractionStatus=} [properties] Properties to set
         */
        function InteractionStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionStatus lastUpdate.
         * @member {string} lastUpdate
         * @memberof pond.InteractionStatus
         * @instance
         */
        InteractionStatus.prototype.lastUpdate = "";

        /**
         * InteractionStatus synced.
         * @member {boolean} synced
         * @memberof pond.InteractionStatus
         * @instance
         */
        InteractionStatus.prototype.synced = false;

        /**
         * InteractionStatus lastSynced.
         * @member {string} lastSynced
         * @memberof pond.InteractionStatus
         * @instance
         */
        InteractionStatus.prototype.lastSynced = "";

        /**
         * Creates a new InteractionStatus instance using the specified properties.
         * @function create
         * @memberof pond.InteractionStatus
         * @static
         * @param {pond.IInteractionStatus=} [properties] Properties to set
         * @returns {pond.InteractionStatus} InteractionStatus instance
         */
        InteractionStatus.create = function create(properties) {
            return new InteractionStatus(properties);
        };

        /**
         * Creates an InteractionStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.InteractionStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.InteractionStatus} InteractionStatus
         */
        InteractionStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.InteractionStatus)
                return object;
            var message = new $root.pond.InteractionStatus();
            if (object.lastUpdate != null)
                message.lastUpdate = String(object.lastUpdate);
            if (object.synced != null)
                message.synced = Boolean(object.synced);
            if (object.lastSynced != null)
                message.lastSynced = String(object.lastSynced);
            return message;
        };

        /**
         * Creates a plain object from an InteractionStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.InteractionStatus
         * @static
         * @param {pond.InteractionStatus} message InteractionStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lastUpdate = "";
                object.synced = false;
                object.lastSynced = "";
            }
            if (message.lastUpdate != null && message.hasOwnProperty("lastUpdate"))
                object.lastUpdate = message.lastUpdate;
            if (message.synced != null && message.hasOwnProperty("synced"))
                object.synced = message.synced;
            if (message.lastSynced != null && message.hasOwnProperty("lastSynced"))
                object.lastSynced = message.lastSynced;
            return object;
        };

        /**
         * Converts this InteractionStatus to JSON.
         * @function toJSON
         * @memberof pond.InteractionStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionStatus;
    })();

    pond.Interaction = (function() {

        /**
         * Properties of an Interaction.
         * @memberof pond
         * @interface IInteraction
         * @property {pond.InteractionSettings|null} [settings] Interaction settings
         * @property {pond.InteractionStatus|null} [status] Interaction status
         */

        /**
         * Constructs a new Interaction.
         * @memberof pond
         * @classdesc Represents an Interaction.
         * @implements IInteraction
         * @constructor
         * @param {pond.IInteraction=} [properties] Properties to set
         */
        function Interaction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Interaction settings.
         * @member {pond.InteractionSettings|null|undefined} settings
         * @memberof pond.Interaction
         * @instance
         */
        Interaction.prototype.settings = null;

        /**
         * Interaction status.
         * @member {pond.InteractionStatus|null|undefined} status
         * @memberof pond.Interaction
         * @instance
         */
        Interaction.prototype.status = null;

        /**
         * Creates a new Interaction instance using the specified properties.
         * @function create
         * @memberof pond.Interaction
         * @static
         * @param {pond.IInteraction=} [properties] Properties to set
         * @returns {pond.Interaction} Interaction instance
         */
        Interaction.create = function create(properties) {
            return new Interaction(properties);
        };

        /**
         * Creates an Interaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Interaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Interaction} Interaction
         */
        Interaction.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Interaction)
                return object;
            var message = new $root.pond.Interaction();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Interaction.settings: object expected");
                message.settings = $root.pond.InteractionSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Interaction.status: object expected");
                message.status = $root.pond.InteractionStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an Interaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Interaction
         * @static
         * @param {pond.Interaction} message Interaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Interaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.InteractionSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.InteractionStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Interaction to JSON.
         * @function toJSON
         * @memberof pond.Interaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Interaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Interaction;
    })();

    pond.ListInteractionsRequestFilters = (function() {

        /**
         * Properties of a ListInteractionsRequestFilters.
         * @memberof pond
         * @interface IListInteractionsRequestFilters
         * @property {number|null} [device] ListInteractionsRequestFilters device
         * @property {quack.ComponentID|null} [source] ListInteractionsRequestFilters source
         * @property {quack.ComponentID|null} [sink] ListInteractionsRequestFilters sink
         */

        /**
         * Constructs a new ListInteractionsRequestFilters.
         * @memberof pond
         * @classdesc Represents a ListInteractionsRequestFilters.
         * @implements IListInteractionsRequestFilters
         * @constructor
         * @param {pond.IListInteractionsRequestFilters=} [properties] Properties to set
         */
        function ListInteractionsRequestFilters(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListInteractionsRequestFilters device.
         * @member {number} device
         * @memberof pond.ListInteractionsRequestFilters
         * @instance
         */
        ListInteractionsRequestFilters.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListInteractionsRequestFilters source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof pond.ListInteractionsRequestFilters
         * @instance
         */
        ListInteractionsRequestFilters.prototype.source = null;

        /**
         * ListInteractionsRequestFilters sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof pond.ListInteractionsRequestFilters
         * @instance
         */
        ListInteractionsRequestFilters.prototype.sink = null;

        /**
         * Creates a new ListInteractionsRequestFilters instance using the specified properties.
         * @function create
         * @memberof pond.ListInteractionsRequestFilters
         * @static
         * @param {pond.IListInteractionsRequestFilters=} [properties] Properties to set
         * @returns {pond.ListInteractionsRequestFilters} ListInteractionsRequestFilters instance
         */
        ListInteractionsRequestFilters.create = function create(properties) {
            return new ListInteractionsRequestFilters(properties);
        };

        /**
         * Creates a ListInteractionsRequestFilters message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListInteractionsRequestFilters
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListInteractionsRequestFilters} ListInteractionsRequestFilters
         */
        ListInteractionsRequestFilters.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListInteractionsRequestFilters)
                return object;
            var message = new $root.pond.ListInteractionsRequestFilters();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".pond.ListInteractionsRequestFilters.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".pond.ListInteractionsRequestFilters.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListInteractionsRequestFilters message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListInteractionsRequestFilters
         * @static
         * @param {pond.ListInteractionsRequestFilters} message ListInteractionsRequestFilters
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListInteractionsRequestFilters.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.source = null;
                object.sink = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            return object;
        };

        /**
         * Converts this ListInteractionsRequestFilters to JSON.
         * @function toJSON
         * @memberof pond.ListInteractionsRequestFilters
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListInteractionsRequestFilters.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListInteractionsRequestFilters;
    })();

    pond.ListInteractionsRequest = (function() {

        /**
         * Properties of a ListInteractionsRequest.
         * @memberof pond
         * @interface IListInteractionsRequest
         * @property {pond.ListInteractionsRequestFilters|null} [filters] ListInteractionsRequest filters
         * @property {pond.Paging|null} [paging] ListInteractionsRequest paging
         * @property {pond.Sorting|null} [sorting] ListInteractionsRequest sorting
         * @property {string|null} [search] ListInteractionsRequest search
         */

        /**
         * Constructs a new ListInteractionsRequest.
         * @memberof pond
         * @classdesc Represents a ListInteractionsRequest.
         * @implements IListInteractionsRequest
         * @constructor
         * @param {pond.IListInteractionsRequest=} [properties] Properties to set
         */
        function ListInteractionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListInteractionsRequest filters.
         * @member {pond.ListInteractionsRequestFilters|null|undefined} filters
         * @memberof pond.ListInteractionsRequest
         * @instance
         */
        ListInteractionsRequest.prototype.filters = null;

        /**
         * ListInteractionsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListInteractionsRequest
         * @instance
         */
        ListInteractionsRequest.prototype.paging = null;

        /**
         * ListInteractionsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListInteractionsRequest
         * @instance
         */
        ListInteractionsRequest.prototype.sorting = null;

        /**
         * ListInteractionsRequest search.
         * @member {string} search
         * @memberof pond.ListInteractionsRequest
         * @instance
         */
        ListInteractionsRequest.prototype.search = "";

        /**
         * Creates a new ListInteractionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListInteractionsRequest
         * @static
         * @param {pond.IListInteractionsRequest=} [properties] Properties to set
         * @returns {pond.ListInteractionsRequest} ListInteractionsRequest instance
         */
        ListInteractionsRequest.create = function create(properties) {
            return new ListInteractionsRequest(properties);
        };

        /**
         * Creates a ListInteractionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListInteractionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListInteractionsRequest} ListInteractionsRequest
         */
        ListInteractionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListInteractionsRequest)
                return object;
            var message = new $root.pond.ListInteractionsRequest();
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListInteractionsRequest.filters: object expected");
                message.filters = $root.pond.ListInteractionsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListInteractionsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListInteractionsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListInteractionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListInteractionsRequest
         * @static
         * @param {pond.ListInteractionsRequest} message ListInteractionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListInteractionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.filters = null;
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListInteractionsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListInteractionsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListInteractionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListInteractionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListInteractionsRequest;
    })();

    pond.ListInteractionsResponse = (function() {

        /**
         * Properties of a ListInteractionsResponse.
         * @memberof pond
         * @interface IListInteractionsResponse
         * @property {Array.<pond.Interaction>|null} [interactions] ListInteractionsResponse interactions
         */

        /**
         * Constructs a new ListInteractionsResponse.
         * @memberof pond
         * @classdesc Represents a ListInteractionsResponse.
         * @implements IListInteractionsResponse
         * @constructor
         * @param {pond.IListInteractionsResponse=} [properties] Properties to set
         */
        function ListInteractionsResponse(properties) {
            this.interactions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListInteractionsResponse interactions.
         * @member {Array.<pond.Interaction>} interactions
         * @memberof pond.ListInteractionsResponse
         * @instance
         */
        ListInteractionsResponse.prototype.interactions = $util.emptyArray;

        /**
         * Creates a new ListInteractionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListInteractionsResponse
         * @static
         * @param {pond.IListInteractionsResponse=} [properties] Properties to set
         * @returns {pond.ListInteractionsResponse} ListInteractionsResponse instance
         */
        ListInteractionsResponse.create = function create(properties) {
            return new ListInteractionsResponse(properties);
        };

        /**
         * Creates a ListInteractionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListInteractionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListInteractionsResponse} ListInteractionsResponse
         */
        ListInteractionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListInteractionsResponse)
                return object;
            var message = new $root.pond.ListInteractionsResponse();
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.ListInteractionsResponse.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.ListInteractionsResponse.interactions: object expected");
                    message.interactions[i] = $root.pond.Interaction.fromObject(object.interactions[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListInteractionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListInteractionsResponse
         * @static
         * @param {pond.ListInteractionsResponse} message ListInteractionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListInteractionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.interactions = [];
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.Interaction.toObject(message.interactions[j], options);
            }
            return object;
        };

        /**
         * Converts this ListInteractionsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListInteractionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListInteractionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListInteractionsResponse;
    })();

    pond.AlertData = (function() {

        /**
         * Properties of an AlertData.
         * @memberof pond
         * @interface IAlertData
         * @property {pond.InteractionCondition|null} [condition] AlertData condition
         * @property {number|null} [device] AlertData device
         * @property {quack.ComponentID|null} [componentLocation] AlertData componentLocation
         * @property {number|null} [interactionSubtype] AlertData interactionSubtype
         * @property {number|null} [nodeOne] AlertData nodeOne
         * @property {number|null} [nodeTwo] AlertData nodeTwo
         */

        /**
         * Constructs a new AlertData.
         * @memberof pond
         * @classdesc Represents an AlertData.
         * @implements IAlertData
         * @constructor
         * @param {pond.IAlertData=} [properties] Properties to set
         */
        function AlertData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AlertData condition.
         * @member {pond.InteractionCondition|null|undefined} condition
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.condition = null;

        /**
         * AlertData device.
         * @member {number} device
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.device = 0;

        /**
         * AlertData componentLocation.
         * @member {quack.ComponentID|null|undefined} componentLocation
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.componentLocation = null;

        /**
         * AlertData interactionSubtype.
         * @member {number} interactionSubtype
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.interactionSubtype = 0;

        /**
         * AlertData nodeOne.
         * @member {number} nodeOne
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.nodeOne = 0;

        /**
         * AlertData nodeTwo.
         * @member {number} nodeTwo
         * @memberof pond.AlertData
         * @instance
         */
        AlertData.prototype.nodeTwo = 0;

        /**
         * Creates a new AlertData instance using the specified properties.
         * @function create
         * @memberof pond.AlertData
         * @static
         * @param {pond.IAlertData=} [properties] Properties to set
         * @returns {pond.AlertData} AlertData instance
         */
        AlertData.create = function create(properties) {
            return new AlertData(properties);
        };

        /**
         * Creates an AlertData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AlertData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AlertData} AlertData
         */
        AlertData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AlertData)
                return object;
            var message = new $root.pond.AlertData();
            if (object.condition != null) {
                if (typeof object.condition !== "object")
                    throw TypeError(".pond.AlertData.condition: object expected");
                message.condition = $root.pond.InteractionCondition.fromObject(object.condition);
            }
            if (object.device != null)
                message.device = object.device >>> 0;
            if (object.componentLocation != null) {
                if (typeof object.componentLocation !== "object")
                    throw TypeError(".pond.AlertData.componentLocation: object expected");
                message.componentLocation = $root.quack.ComponentID.fromObject(object.componentLocation);
            }
            if (object.interactionSubtype != null)
                message.interactionSubtype = object.interactionSubtype >>> 0;
            if (object.nodeOne != null)
                message.nodeOne = object.nodeOne >>> 0;
            if (object.nodeTwo != null)
                message.nodeTwo = object.nodeTwo >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AlertData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AlertData
         * @static
         * @param {pond.AlertData} message AlertData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AlertData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.condition = null;
                object.device = 0;
                object.componentLocation = null;
                object.interactionSubtype = 0;
                object.nodeOne = 0;
                object.nodeTwo = 0;
            }
            if (message.condition != null && message.hasOwnProperty("condition"))
                object.condition = $root.pond.InteractionCondition.toObject(message.condition, options);
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            if (message.componentLocation != null && message.hasOwnProperty("componentLocation"))
                object.componentLocation = $root.quack.ComponentID.toObject(message.componentLocation, options);
            if (message.interactionSubtype != null && message.hasOwnProperty("interactionSubtype"))
                object.interactionSubtype = message.interactionSubtype;
            if (message.nodeOne != null && message.hasOwnProperty("nodeOne"))
                object.nodeOne = message.nodeOne;
            if (message.nodeTwo != null && message.hasOwnProperty("nodeTwo"))
                object.nodeTwo = message.nodeTwo;
            return object;
        };

        /**
         * Converts this AlertData to JSON.
         * @function toJSON
         * @memberof pond.AlertData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AlertData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AlertData;
    })();

    pond.SetAlertInteractionsRequest = (function() {

        /**
         * Properties of a SetAlertInteractionsRequest.
         * @memberof pond
         * @interface ISetAlertInteractionsRequest
         * @property {Array.<pond.AlertData>|null} [data] SetAlertInteractionsRequest data
         */

        /**
         * Constructs a new SetAlertInteractionsRequest.
         * @memberof pond
         * @classdesc Represents a SetAlertInteractionsRequest.
         * @implements ISetAlertInteractionsRequest
         * @constructor
         * @param {pond.ISetAlertInteractionsRequest=} [properties] Properties to set
         */
        function SetAlertInteractionsRequest(properties) {
            this.data = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetAlertInteractionsRequest data.
         * @member {Array.<pond.AlertData>} data
         * @memberof pond.SetAlertInteractionsRequest
         * @instance
         */
        SetAlertInteractionsRequest.prototype.data = $util.emptyArray;

        /**
         * Creates a new SetAlertInteractionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.SetAlertInteractionsRequest
         * @static
         * @param {pond.ISetAlertInteractionsRequest=} [properties] Properties to set
         * @returns {pond.SetAlertInteractionsRequest} SetAlertInteractionsRequest instance
         */
        SetAlertInteractionsRequest.create = function create(properties) {
            return new SetAlertInteractionsRequest(properties);
        };

        /**
         * Creates a SetAlertInteractionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetAlertInteractionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetAlertInteractionsRequest} SetAlertInteractionsRequest
         */
        SetAlertInteractionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetAlertInteractionsRequest)
                return object;
            var message = new $root.pond.SetAlertInteractionsRequest();
            if (object.data) {
                if (!Array.isArray(object.data))
                    throw TypeError(".pond.SetAlertInteractionsRequest.data: array expected");
                message.data = [];
                for (var i = 0; i < object.data.length; ++i) {
                    if (typeof object.data[i] !== "object")
                        throw TypeError(".pond.SetAlertInteractionsRequest.data: object expected");
                    message.data[i] = $root.pond.AlertData.fromObject(object.data[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SetAlertInteractionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetAlertInteractionsRequest
         * @static
         * @param {pond.SetAlertInteractionsRequest} message SetAlertInteractionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetAlertInteractionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.data = [];
            if (message.data && message.data.length) {
                object.data = [];
                for (var j = 0; j < message.data.length; ++j)
                    object.data[j] = $root.pond.AlertData.toObject(message.data[j], options);
            }
            return object;
        };

        /**
         * Converts this SetAlertInteractionsRequest to JSON.
         * @function toJSON
         * @memberof pond.SetAlertInteractionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetAlertInteractionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetAlertInteractionsRequest;
    })();

    pond.SetAlertInteractionsResponse = (function() {

        /**
         * Properties of a SetAlertInteractionsResponse.
         * @memberof pond
         * @interface ISetAlertInteractionsResponse
         * @property {number|null} [numAlertsSet] SetAlertInteractionsResponse numAlertsSet
         * @property {number|null} [failedAlerts] SetAlertInteractionsResponse failedAlerts
         */

        /**
         * Constructs a new SetAlertInteractionsResponse.
         * @memberof pond
         * @classdesc Represents a SetAlertInteractionsResponse.
         * @implements ISetAlertInteractionsResponse
         * @constructor
         * @param {pond.ISetAlertInteractionsResponse=} [properties] Properties to set
         */
        function SetAlertInteractionsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetAlertInteractionsResponse numAlertsSet.
         * @member {number} numAlertsSet
         * @memberof pond.SetAlertInteractionsResponse
         * @instance
         */
        SetAlertInteractionsResponse.prototype.numAlertsSet = 0;

        /**
         * SetAlertInteractionsResponse failedAlerts.
         * @member {number} failedAlerts
         * @memberof pond.SetAlertInteractionsResponse
         * @instance
         */
        SetAlertInteractionsResponse.prototype.failedAlerts = 0;

        /**
         * Creates a new SetAlertInteractionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.SetAlertInteractionsResponse
         * @static
         * @param {pond.ISetAlertInteractionsResponse=} [properties] Properties to set
         * @returns {pond.SetAlertInteractionsResponse} SetAlertInteractionsResponse instance
         */
        SetAlertInteractionsResponse.create = function create(properties) {
            return new SetAlertInteractionsResponse(properties);
        };

        /**
         * Creates a SetAlertInteractionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetAlertInteractionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetAlertInteractionsResponse} SetAlertInteractionsResponse
         */
        SetAlertInteractionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetAlertInteractionsResponse)
                return object;
            var message = new $root.pond.SetAlertInteractionsResponse();
            if (object.numAlertsSet != null)
                message.numAlertsSet = object.numAlertsSet >>> 0;
            if (object.failedAlerts != null)
                message.failedAlerts = object.failedAlerts >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SetAlertInteractionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetAlertInteractionsResponse
         * @static
         * @param {pond.SetAlertInteractionsResponse} message SetAlertInteractionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetAlertInteractionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.numAlertsSet = 0;
                object.failedAlerts = 0;
            }
            if (message.numAlertsSet != null && message.hasOwnProperty("numAlertsSet"))
                object.numAlertsSet = message.numAlertsSet;
            if (message.failedAlerts != null && message.hasOwnProperty("failedAlerts"))
                object.failedAlerts = message.failedAlerts;
            return object;
        };

        /**
         * Converts this SetAlertInteractionsResponse to JSON.
         * @function toJSON
         * @memberof pond.SetAlertInteractionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetAlertInteractionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetAlertInteractionsResponse;
    })();

    pond.ListMeasurementsRequestFilters = (function() {

        /**
         * Properties of a ListMeasurementsRequestFilters.
         * @memberof pond
         * @interface IListMeasurementsRequestFilters
         * @property {string|null} [timestampStart] ListMeasurementsRequestFilters timestampStart
         * @property {string|null} [timestampEnd] ListMeasurementsRequestFilters timestampEnd
         */

        /**
         * Constructs a new ListMeasurementsRequestFilters.
         * @memberof pond
         * @classdesc Represents a ListMeasurementsRequestFilters.
         * @implements IListMeasurementsRequestFilters
         * @constructor
         * @param {pond.IListMeasurementsRequestFilters=} [properties] Properties to set
         */
        function ListMeasurementsRequestFilters(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMeasurementsRequestFilters timestampStart.
         * @member {string} timestampStart
         * @memberof pond.ListMeasurementsRequestFilters
         * @instance
         */
        ListMeasurementsRequestFilters.prototype.timestampStart = "";

        /**
         * ListMeasurementsRequestFilters timestampEnd.
         * @member {string} timestampEnd
         * @memberof pond.ListMeasurementsRequestFilters
         * @instance
         */
        ListMeasurementsRequestFilters.prototype.timestampEnd = "";

        /**
         * Creates a new ListMeasurementsRequestFilters instance using the specified properties.
         * @function create
         * @memberof pond.ListMeasurementsRequestFilters
         * @static
         * @param {pond.IListMeasurementsRequestFilters=} [properties] Properties to set
         * @returns {pond.ListMeasurementsRequestFilters} ListMeasurementsRequestFilters instance
         */
        ListMeasurementsRequestFilters.create = function create(properties) {
            return new ListMeasurementsRequestFilters(properties);
        };

        /**
         * Creates a ListMeasurementsRequestFilters message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMeasurementsRequestFilters
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMeasurementsRequestFilters} ListMeasurementsRequestFilters
         */
        ListMeasurementsRequestFilters.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMeasurementsRequestFilters)
                return object;
            var message = new $root.pond.ListMeasurementsRequestFilters();
            if (object.timestampStart != null)
                message.timestampStart = String(object.timestampStart);
            if (object.timestampEnd != null)
                message.timestampEnd = String(object.timestampEnd);
            return message;
        };

        /**
         * Creates a plain object from a ListMeasurementsRequestFilters message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMeasurementsRequestFilters
         * @static
         * @param {pond.ListMeasurementsRequestFilters} message ListMeasurementsRequestFilters
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMeasurementsRequestFilters.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timestampStart = "";
                object.timestampEnd = "";
            }
            if (message.timestampStart != null && message.hasOwnProperty("timestampStart"))
                object.timestampStart = message.timestampStart;
            if (message.timestampEnd != null && message.hasOwnProperty("timestampEnd"))
                object.timestampEnd = message.timestampEnd;
            return object;
        };

        /**
         * Converts this ListMeasurementsRequestFilters to JSON.
         * @function toJSON
         * @memberof pond.ListMeasurementsRequestFilters
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMeasurementsRequestFilters.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMeasurementsRequestFilters;
    })();

    pond.ListUnitMeasurementsRequest = (function() {

        /**
         * Properties of a ListUnitMeasurementsRequest.
         * @memberof pond
         * @interface IListUnitMeasurementsRequest
         * @property {number|null} [device] ListUnitMeasurementsRequest device
         * @property {string|null} [component] ListUnitMeasurementsRequest component
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] ListUnitMeasurementsRequest filters
         * @property {pond.Paging|null} [paging] ListUnitMeasurementsRequest paging
         * @property {pond.Sorting|null} [sorting] ListUnitMeasurementsRequest sorting
         * @property {quack.MeasurementType|null} [type] ListUnitMeasurementsRequest type
         * @property {pond.Mutator|null} [mutator] ListUnitMeasurementsRequest mutator
         * @property {boolean|null} [showErrors] ListUnitMeasurementsRequest showErrors
         */

        /**
         * Constructs a new ListUnitMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListUnitMeasurementsRequest.
         * @implements IListUnitMeasurementsRequest
         * @constructor
         * @param {pond.IListUnitMeasurementsRequest=} [properties] Properties to set
         */
        function ListUnitMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUnitMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListUnitMeasurementsRequest component.
         * @member {string} component
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.component = "";

        /**
         * ListUnitMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.filters = null;

        /**
         * ListUnitMeasurementsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.paging = null;

        /**
         * ListUnitMeasurementsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.sorting = null;

        /**
         * ListUnitMeasurementsRequest type.
         * @member {quack.MeasurementType} type
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.type = 0;

        /**
         * ListUnitMeasurementsRequest mutator.
         * @member {pond.Mutator} mutator
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.mutator = 0;

        /**
         * ListUnitMeasurementsRequest showErrors.
         * @member {boolean} showErrors
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         */
        ListUnitMeasurementsRequest.prototype.showErrors = false;

        /**
         * Creates a new ListUnitMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListUnitMeasurementsRequest
         * @static
         * @param {pond.IListUnitMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListUnitMeasurementsRequest} ListUnitMeasurementsRequest instance
         */
        ListUnitMeasurementsRequest.create = function create(properties) {
            return new ListUnitMeasurementsRequest(properties);
        };

        /**
         * Creates a ListUnitMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUnitMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUnitMeasurementsRequest} ListUnitMeasurementsRequest
         */
        ListUnitMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUnitMeasurementsRequest)
                return object;
            var message = new $root.pond.ListUnitMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListUnitMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListUnitMeasurementsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListUnitMeasurementsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            switch (object.type) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.type = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.type = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.type = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.type = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.type = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.type = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.type = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.type = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.type = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.type = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.type = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.type = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.type = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.type = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.type = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.type = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.type = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.type = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.type = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.type = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.type = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.type = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.type = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.type = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.type = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.type = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.type = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.type = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.type = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.type = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.type = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.type = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.type = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.type = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.type = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.type = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.type = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.type = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.type = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.type = 40;
                break;
            }
            switch (object.mutator) {
            case "MUTATOR_NONE":
            case 0:
                message.mutator = 0;
                break;
            case "MUTATOR_EMC":
            case 1:
                message.mutator = 1;
                break;
            case "MUTATOR_CFM":
            case 2:
                message.mutator = 2;
                break;
            case "MUTATOR_FUEL_LEVEL":
            case 3:
                message.mutator = 3;
                break;
            }
            if (object.showErrors != null)
                message.showErrors = Boolean(object.showErrors);
            return message;
        };

        /**
         * Creates a plain object from a ListUnitMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUnitMeasurementsRequest
         * @static
         * @param {pond.ListUnitMeasurementsRequest} message ListUnitMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUnitMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.filters = null;
                object.paging = null;
                object.sorting = null;
                object.type = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
                object.mutator = options.enums === String ? "MUTATOR_NONE" : 0;
                object.showErrors = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.MeasurementType[message.type] : message.type;
            if (message.mutator != null && message.hasOwnProperty("mutator"))
                object.mutator = options.enums === String ? $root.pond.Mutator[message.mutator] : message.mutator;
            if (message.showErrors != null && message.hasOwnProperty("showErrors"))
                object.showErrors = message.showErrors;
            return object;
        };

        /**
         * Converts this ListUnitMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListUnitMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUnitMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUnitMeasurementsRequest;
    })();

    pond.ListObjectMeasurementsRequest = (function() {

        /**
         * Properties of a ListObjectMeasurementsRequest.
         * @memberof pond
         * @interface IListObjectMeasurementsRequest
         * @property {string|null} [key] ListObjectMeasurementsRequest key
         * @property {pond.ObjectType|null} [type] ListObjectMeasurementsRequest type
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] ListObjectMeasurementsRequest filters
         * @property {pond.Paging|null} [paging] ListObjectMeasurementsRequest paging
         * @property {pond.Sorting|null} [sorting] ListObjectMeasurementsRequest sorting
         */

        /**
         * Constructs a new ListObjectMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListObjectMeasurementsRequest.
         * @implements IListObjectMeasurementsRequest
         * @constructor
         * @param {pond.IListObjectMeasurementsRequest=} [properties] Properties to set
         */
        function ListObjectMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectMeasurementsRequest key.
         * @member {string} key
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         */
        ListObjectMeasurementsRequest.prototype.key = "";

        /**
         * ListObjectMeasurementsRequest type.
         * @member {pond.ObjectType} type
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         */
        ListObjectMeasurementsRequest.prototype.type = 0;

        /**
         * ListObjectMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         */
        ListObjectMeasurementsRequest.prototype.filters = null;

        /**
         * ListObjectMeasurementsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         */
        ListObjectMeasurementsRequest.prototype.paging = null;

        /**
         * ListObjectMeasurementsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         */
        ListObjectMeasurementsRequest.prototype.sorting = null;

        /**
         * Creates a new ListObjectMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectMeasurementsRequest
         * @static
         * @param {pond.IListObjectMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListObjectMeasurementsRequest} ListObjectMeasurementsRequest instance
         */
        ListObjectMeasurementsRequest.create = function create(properties) {
            return new ListObjectMeasurementsRequest(properties);
        };

        /**
         * Creates a ListObjectMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectMeasurementsRequest} ListObjectMeasurementsRequest
         */
        ListObjectMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectMeasurementsRequest)
                return object;
            var message = new $root.pond.ListObjectMeasurementsRequest();
            if (object.key != null)
                message.key = String(object.key);
            switch (object.type) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.type = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.type = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.type = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.type = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.type = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.type = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.type = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.type = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.type = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.type = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.type = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.type = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.type = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.type = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.type = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.type = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.type = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.type = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.type = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.type = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.type = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.type = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.type = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.type = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.type = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.type = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.type = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.type = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.type = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.type = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.type = 31;
                break;
            }
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListObjectMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListObjectMeasurementsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListObjectMeasurementsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListObjectMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectMeasurementsRequest
         * @static
         * @param {pond.ListObjectMeasurementsRequest} message ListObjectMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.type = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.filters = null;
                object.paging = null;
                object.sorting = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.ObjectType[message.type] : message.type;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            return object;
        };

        /**
         * Converts this ListObjectMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListObjectMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectMeasurementsRequest;
    })();

    pond.ValueArray = (function() {

        /**
         * Properties of a ValueArray.
         * @memberof pond
         * @interface IValueArray
         * @property {Array.<number>|null} [values] ValueArray values
         * @property {boolean|null} [error] ValueArray error
         */

        /**
         * Constructs a new ValueArray.
         * @memberof pond
         * @classdesc Represents a ValueArray.
         * @implements IValueArray
         * @constructor
         * @param {pond.IValueArray=} [properties] Properties to set
         */
        function ValueArray(properties) {
            this.values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValueArray values.
         * @member {Array.<number>} values
         * @memberof pond.ValueArray
         * @instance
         */
        ValueArray.prototype.values = $util.emptyArray;

        /**
         * ValueArray error.
         * @member {boolean} error
         * @memberof pond.ValueArray
         * @instance
         */
        ValueArray.prototype.error = false;

        /**
         * Creates a new ValueArray instance using the specified properties.
         * @function create
         * @memberof pond.ValueArray
         * @static
         * @param {pond.IValueArray=} [properties] Properties to set
         * @returns {pond.ValueArray} ValueArray instance
         */
        ValueArray.create = function create(properties) {
            return new ValueArray(properties);
        };

        /**
         * Creates a ValueArray message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ValueArray
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ValueArray} ValueArray
         */
        ValueArray.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ValueArray)
                return object;
            var message = new $root.pond.ValueArray();
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.ValueArray.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i)
                    message.values[i] = Number(object.values[i]);
            }
            if (object.error != null)
                message.error = Boolean(object.error);
            return message;
        };

        /**
         * Creates a plain object from a ValueArray message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ValueArray
         * @static
         * @param {pond.ValueArray} message ValueArray
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValueArray.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.values = [];
            if (options.defaults)
                object.error = false;
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = options.json && !isFinite(message.values[j]) ? String(message.values[j]) : message.values[j];
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            return object;
        };

        /**
         * Converts this ValueArray to JSON.
         * @function toJSON
         * @memberof pond.ValueArray
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValueArray.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ValueArray;
    })();

    pond.UnitMeasurementsForComponent = (function() {

        /**
         * Properties of an UnitMeasurementsForComponent.
         * @memberof pond
         * @interface IUnitMeasurementsForComponent
         * @property {string|null} [componentId] UnitMeasurementsForComponent componentId
         * @property {Array.<pond.ValueArray>|null} [values] UnitMeasurementsForComponent values
         * @property {Array.<string>|null} [timestamps] UnitMeasurementsForComponent timestamps
         * @property {quack.MeasurementType|null} [type] UnitMeasurementsForComponent type
         * @property {quack.ComponentType|null} [componentType] UnitMeasurementsForComponent componentType
         */

        /**
         * Constructs a new UnitMeasurementsForComponent.
         * @memberof pond
         * @classdesc Represents an UnitMeasurementsForComponent.
         * @implements IUnitMeasurementsForComponent
         * @constructor
         * @param {pond.IUnitMeasurementsForComponent=} [properties] Properties to set
         */
        function UnitMeasurementsForComponent(properties) {
            this.values = [];
            this.timestamps = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnitMeasurementsForComponent componentId.
         * @member {string} componentId
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         */
        UnitMeasurementsForComponent.prototype.componentId = "";

        /**
         * UnitMeasurementsForComponent values.
         * @member {Array.<pond.ValueArray>} values
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         */
        UnitMeasurementsForComponent.prototype.values = $util.emptyArray;

        /**
         * UnitMeasurementsForComponent timestamps.
         * @member {Array.<string>} timestamps
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         */
        UnitMeasurementsForComponent.prototype.timestamps = $util.emptyArray;

        /**
         * UnitMeasurementsForComponent type.
         * @member {quack.MeasurementType} type
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         */
        UnitMeasurementsForComponent.prototype.type = 0;

        /**
         * UnitMeasurementsForComponent componentType.
         * @member {quack.ComponentType} componentType
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         */
        UnitMeasurementsForComponent.prototype.componentType = 0;

        /**
         * Creates a new UnitMeasurementsForComponent instance using the specified properties.
         * @function create
         * @memberof pond.UnitMeasurementsForComponent
         * @static
         * @param {pond.IUnitMeasurementsForComponent=} [properties] Properties to set
         * @returns {pond.UnitMeasurementsForComponent} UnitMeasurementsForComponent instance
         */
        UnitMeasurementsForComponent.create = function create(properties) {
            return new UnitMeasurementsForComponent(properties);
        };

        /**
         * Creates an UnitMeasurementsForComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UnitMeasurementsForComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UnitMeasurementsForComponent} UnitMeasurementsForComponent
         */
        UnitMeasurementsForComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UnitMeasurementsForComponent)
                return object;
            var message = new $root.pond.UnitMeasurementsForComponent();
            if (object.componentId != null)
                message.componentId = String(object.componentId);
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.UnitMeasurementsForComponent.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".pond.UnitMeasurementsForComponent.values: object expected");
                    message.values[i] = $root.pond.ValueArray.fromObject(object.values[i]);
                }
            }
            if (object.timestamps) {
                if (!Array.isArray(object.timestamps))
                    throw TypeError(".pond.UnitMeasurementsForComponent.timestamps: array expected");
                message.timestamps = [];
                for (var i = 0; i < object.timestamps.length; ++i)
                    message.timestamps[i] = String(object.timestamps[i]);
            }
            switch (object.type) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.type = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.type = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.type = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.type = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.type = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.type = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.type = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.type = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.type = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.type = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.type = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.type = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.type = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.type = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.type = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.type = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.type = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.type = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.type = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.type = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.type = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.type = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.type = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.type = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.type = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.type = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.type = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.type = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.type = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.type = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.type = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.type = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.type = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.type = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.type = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.type = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.type = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.type = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.type = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.type = 40;
                break;
            }
            switch (object.componentType) {
            case "COMPONENT_TYPE_INVALID":
            case 0:
                message.componentType = 0;
                break;
            case "COMPONENT_TYPE_POWER":
            case 1:
                message.componentType = 1;
                break;
            case "COMPONENT_TYPE_TEMPERATURE":
            case 2:
                message.componentType = 2;
                break;
            case "COMPONENT_TYPE_BOOLEAN_OUTPUT":
            case 3:
                message.componentType = 3;
                break;
            case "COMPONENT_TYPE_EDGE_TRIGGERED":
            case 4:
                message.componentType = 4;
                break;
            case "COMPONENT_TYPE_GRAIN_CABLE":
            case 5:
                message.componentType = 5;
                break;
            case "COMPONENT_TYPE_PRESSURE":
            case 6:
                message.componentType = 6;
                break;
            case "COMPONENT_TYPE_GPS":
            case 7:
                message.componentType = 7;
                break;
            case "COMPONENT_TYPE_BOOLEAN_INPUT":
            case 8:
                message.componentType = 8;
                break;
            case "COMPONENT_TYPE_DHT":
            case 9:
                message.componentType = 9;
                break;
            case "COMPONENT_TYPE_MODEM":
            case 10:
                message.componentType = 10;
                break;
            case "COMPONENT_TYPE_LIGHT":
            case 11:
                message.componentType = 11;
                break;
            case "COMPONENT_TYPE_CO2":
            case 12:
                message.componentType = 12;
                break;
            case "COMPONENT_TYPE_STEPPER_MOTOR":
            case 13:
                message.componentType = 13;
                break;
            case "COMPONENT_TYPE_ANALOG_INPUT":
            case 14:
                message.componentType = 14;
                break;
            case "COMPONENT_TYPE_O2":
            case 15:
                message.componentType = 15;
                break;
            case "COMPONENT_TYPE_ETHYLENE":
            case 16:
                message.componentType = 16;
                break;
            case "COMPONENT_TYPE_ORP":
            case 17:
                message.componentType = 17;
                break;
            case "COMPONENT_TYPE_PH":
            case 18:
                message.componentType = 18;
                break;
            case "COMPONENT_TYPE_VOLTAGE":
            case 19:
                message.componentType = 19;
                break;
            case "COMPONENT_TYPE_CALCIUM":
            case 20:
                message.componentType = 20;
                break;
            case "COMPONENT_TYPE_NITRATE":
            case 21:
                message.componentType = 21;
                break;
            case "COMPONENT_TYPE_POTASSIUM":
            case 22:
                message.componentType = 22;
                break;
            case "COMPONENT_TYPE_CONDUCTIVITY":
            case 23:
                message.componentType = 23;
                break;
            case "COMPONENT_TYPE_CAPACITANCE":
            case 24:
                message.componentType = 24;
                break;
            case "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT":
            case 25:
                message.componentType = 25;
                break;
            case "COMPONENT_TYPE_WEIGHT":
            case 26:
                message.componentType = 26;
                break;
            case "COMPONENT_TYPE_AIR_QUALITY":
            case 27:
                message.componentType = 27;
                break;
            case "COMPONENT_TYPE_LIDAR":
            case 28:
                message.componentType = 28;
                break;
            case "COMPONENT_TYPE_PRESSURE_CABLE":
            case 29:
                message.componentType = 29;
                break;
            case "COMPONENT_TYPE_INTERNAL_FUNCTION":
            case 30:
                message.componentType = 30;
                break;
            case "COMPONENT_TYPE_CAPACITOR_CABLE":
            case 31:
                message.componentType = 31;
                break;
            case "COMPONENT_TYPE_SEN5X":
            case 32:
                message.componentType = 32;
                break;
            case "COMPONENT_TYPE_VIBRATION_CHAIN":
            case 33:
                message.componentType = 33;
                break;
            case "COMPONENT_TYPE_DRAGER_GAS_DONGLE":
            case 34:
                message.componentType = 34;
                break;
            case "COMPONENT_TYPE_AIRFLOW":
            case 35:
                message.componentType = 35;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UnitMeasurementsForComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UnitMeasurementsForComponent
         * @static
         * @param {pond.UnitMeasurementsForComponent} message UnitMeasurementsForComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnitMeasurementsForComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.values = [];
                object.timestamps = [];
            }
            if (options.defaults) {
                object.componentId = "";
                object.type = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
                object.componentType = options.enums === String ? "COMPONENT_TYPE_INVALID" : 0;
            }
            if (message.componentId != null && message.hasOwnProperty("componentId"))
                object.componentId = message.componentId;
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.pond.ValueArray.toObject(message.values[j], options);
            }
            if (message.timestamps && message.timestamps.length) {
                object.timestamps = [];
                for (var j = 0; j < message.timestamps.length; ++j)
                    object.timestamps[j] = message.timestamps[j];
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.MeasurementType[message.type] : message.type;
            if (message.componentType != null && message.hasOwnProperty("componentType"))
                object.componentType = options.enums === String ? $root.quack.ComponentType[message.componentType] : message.componentType;
            return object;
        };

        /**
         * Converts this UnitMeasurementsForComponent to JSON.
         * @function toJSON
         * @memberof pond.UnitMeasurementsForComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnitMeasurementsForComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UnitMeasurementsForComponent;
    })();

    pond.UnitMeasurementsForObject = (function() {

        /**
         * Properties of an UnitMeasurementsForObject.
         * @memberof pond
         * @interface IUnitMeasurementsForObject
         * @property {string|null} [key] UnitMeasurementsForObject key
         * @property {pond.ObjectType|null} [objectType] UnitMeasurementsForObject objectType
         * @property {Array.<pond.ValueArray>|null} [values] UnitMeasurementsForObject values
         * @property {Array.<string>|null} [timestamps] UnitMeasurementsForObject timestamps
         * @property {quack.MeasurementType|null} [measurementType] UnitMeasurementsForObject measurementType
         */

        /**
         * Constructs a new UnitMeasurementsForObject.
         * @memberof pond
         * @classdesc Represents an UnitMeasurementsForObject.
         * @implements IUnitMeasurementsForObject
         * @constructor
         * @param {pond.IUnitMeasurementsForObject=} [properties] Properties to set
         */
        function UnitMeasurementsForObject(properties) {
            this.values = [];
            this.timestamps = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnitMeasurementsForObject key.
         * @member {string} key
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         */
        UnitMeasurementsForObject.prototype.key = "";

        /**
         * UnitMeasurementsForObject objectType.
         * @member {pond.ObjectType} objectType
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         */
        UnitMeasurementsForObject.prototype.objectType = 0;

        /**
         * UnitMeasurementsForObject values.
         * @member {Array.<pond.ValueArray>} values
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         */
        UnitMeasurementsForObject.prototype.values = $util.emptyArray;

        /**
         * UnitMeasurementsForObject timestamps.
         * @member {Array.<string>} timestamps
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         */
        UnitMeasurementsForObject.prototype.timestamps = $util.emptyArray;

        /**
         * UnitMeasurementsForObject measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         */
        UnitMeasurementsForObject.prototype.measurementType = 0;

        /**
         * Creates a new UnitMeasurementsForObject instance using the specified properties.
         * @function create
         * @memberof pond.UnitMeasurementsForObject
         * @static
         * @param {pond.IUnitMeasurementsForObject=} [properties] Properties to set
         * @returns {pond.UnitMeasurementsForObject} UnitMeasurementsForObject instance
         */
        UnitMeasurementsForObject.create = function create(properties) {
            return new UnitMeasurementsForObject(properties);
        };

        /**
         * Creates an UnitMeasurementsForObject message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UnitMeasurementsForObject
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UnitMeasurementsForObject} UnitMeasurementsForObject
         */
        UnitMeasurementsForObject.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UnitMeasurementsForObject)
                return object;
            var message = new $root.pond.UnitMeasurementsForObject();
            if (object.key != null)
                message.key = String(object.key);
            switch (object.objectType) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.objectType = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.objectType = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.objectType = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.objectType = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.objectType = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.objectType = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.objectType = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.objectType = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.objectType = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.objectType = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.objectType = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.objectType = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.objectType = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.objectType = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.objectType = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.objectType = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.objectType = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.objectType = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.objectType = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.objectType = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.objectType = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.objectType = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.objectType = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.objectType = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.objectType = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.objectType = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.objectType = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.objectType = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.objectType = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.objectType = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.objectType = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.objectType = 31;
                break;
            }
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.UnitMeasurementsForObject.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".pond.UnitMeasurementsForObject.values: object expected");
                    message.values[i] = $root.pond.ValueArray.fromObject(object.values[i]);
                }
            }
            if (object.timestamps) {
                if (!Array.isArray(object.timestamps))
                    throw TypeError(".pond.UnitMeasurementsForObject.timestamps: array expected");
                message.timestamps = [];
                for (var i = 0; i < object.timestamps.length; ++i)
                    message.timestamps[i] = String(object.timestamps[i]);
            }
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UnitMeasurementsForObject message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UnitMeasurementsForObject
         * @static
         * @param {pond.UnitMeasurementsForObject} message UnitMeasurementsForObject
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnitMeasurementsForObject.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.values = [];
                object.timestamps = [];
            }
            if (options.defaults) {
                object.key = "";
                object.objectType = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = options.enums === String ? $root.pond.ObjectType[message.objectType] : message.objectType;
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.pond.ValueArray.toObject(message.values[j], options);
            }
            if (message.timestamps && message.timestamps.length) {
                object.timestamps = [];
                for (var j = 0; j < message.timestamps.length; ++j)
                    object.timestamps[j] = message.timestamps[j];
            }
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            return object;
        };

        /**
         * Converts this UnitMeasurementsForObject to JSON.
         * @function toJSON
         * @memberof pond.UnitMeasurementsForObject
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnitMeasurementsForObject.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UnitMeasurementsForObject;
    })();

    pond.ListUnitMeasurementsResponse = (function() {

        /**
         * Properties of a ListUnitMeasurementsResponse.
         * @memberof pond
         * @interface IListUnitMeasurementsResponse
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [measurements] ListUnitMeasurementsResponse measurements
         * @property {number|null} [nextOffset] ListUnitMeasurementsResponse nextOffset
         * @property {number|null} [total] ListUnitMeasurementsResponse total
         */

        /**
         * Constructs a new ListUnitMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListUnitMeasurementsResponse.
         * @implements IListUnitMeasurementsResponse
         * @constructor
         * @param {pond.IListUnitMeasurementsResponse=} [properties] Properties to set
         */
        function ListUnitMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUnitMeasurementsResponse measurements.
         * @member {Array.<pond.UnitMeasurementsForComponent>} measurements
         * @memberof pond.ListUnitMeasurementsResponse
         * @instance
         */
        ListUnitMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * ListUnitMeasurementsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListUnitMeasurementsResponse
         * @instance
         */
        ListUnitMeasurementsResponse.prototype.nextOffset = 0;

        /**
         * ListUnitMeasurementsResponse total.
         * @member {number} total
         * @memberof pond.ListUnitMeasurementsResponse
         * @instance
         */
        ListUnitMeasurementsResponse.prototype.total = 0;

        /**
         * Creates a new ListUnitMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListUnitMeasurementsResponse
         * @static
         * @param {pond.IListUnitMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListUnitMeasurementsResponse} ListUnitMeasurementsResponse instance
         */
        ListUnitMeasurementsResponse.create = function create(properties) {
            return new ListUnitMeasurementsResponse(properties);
        };

        /**
         * Creates a ListUnitMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUnitMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUnitMeasurementsResponse} ListUnitMeasurementsResponse
         */
        ListUnitMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUnitMeasurementsResponse)
                return object;
            var message = new $root.pond.ListUnitMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.ListUnitMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.ListUnitMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.measurements[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListUnitMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUnitMeasurementsResponse
         * @static
         * @param {pond.ListUnitMeasurementsResponse} message ListUnitMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUnitMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.measurements[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListUnitMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListUnitMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUnitMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUnitMeasurementsResponse;
    })();

    pond.ListObjectMeasurementsResponse = (function() {

        /**
         * Properties of a ListObjectMeasurementsResponse.
         * @memberof pond
         * @interface IListObjectMeasurementsResponse
         * @property {Array.<pond.UnitMeasurementsForObject>|null} [measurements] ListObjectMeasurementsResponse measurements
         * @property {number|null} [nextOffset] ListObjectMeasurementsResponse nextOffset
         * @property {number|null} [total] ListObjectMeasurementsResponse total
         */

        /**
         * Constructs a new ListObjectMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListObjectMeasurementsResponse.
         * @implements IListObjectMeasurementsResponse
         * @constructor
         * @param {pond.IListObjectMeasurementsResponse=} [properties] Properties to set
         */
        function ListObjectMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectMeasurementsResponse measurements.
         * @member {Array.<pond.UnitMeasurementsForObject>} measurements
         * @memberof pond.ListObjectMeasurementsResponse
         * @instance
         */
        ListObjectMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * ListObjectMeasurementsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListObjectMeasurementsResponse
         * @instance
         */
        ListObjectMeasurementsResponse.prototype.nextOffset = 0;

        /**
         * ListObjectMeasurementsResponse total.
         * @member {number} total
         * @memberof pond.ListObjectMeasurementsResponse
         * @instance
         */
        ListObjectMeasurementsResponse.prototype.total = 0;

        /**
         * Creates a new ListObjectMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectMeasurementsResponse
         * @static
         * @param {pond.IListObjectMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListObjectMeasurementsResponse} ListObjectMeasurementsResponse instance
         */
        ListObjectMeasurementsResponse.create = function create(properties) {
            return new ListObjectMeasurementsResponse(properties);
        };

        /**
         * Creates a ListObjectMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectMeasurementsResponse} ListObjectMeasurementsResponse
         */
        ListObjectMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectMeasurementsResponse)
                return object;
            var message = new $root.pond.ListObjectMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.ListObjectMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.ListObjectMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.UnitMeasurementsForObject.fromObject(object.measurements[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListObjectMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectMeasurementsResponse
         * @static
         * @param {pond.ListObjectMeasurementsResponse} message ListObjectMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.UnitMeasurementsForObject.toObject(message.measurements[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListObjectMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListObjectMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectMeasurementsResponse;
    })();

    pond.ListMeasurementsRequest = (function() {

        /**
         * Properties of a ListMeasurementsRequest.
         * @memberof pond
         * @interface IListMeasurementsRequest
         * @property {number|null} [device] ListMeasurementsRequest device
         * @property {string|null} [component] ListMeasurementsRequest component
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] ListMeasurementsRequest filters
         * @property {pond.Paging|null} [paging] ListMeasurementsRequest paging
         * @property {pond.Sorting|null} [sorting] ListMeasurementsRequest sorting
         * @property {boolean|null} [virtual] ListMeasurementsRequest virtual
         */

        /**
         * Constructs a new ListMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListMeasurementsRequest.
         * @implements IListMeasurementsRequest
         * @constructor
         * @param {pond.IListMeasurementsRequest=} [properties] Properties to set
         */
        function ListMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListMeasurementsRequest component.
         * @member {string} component
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.component = "";

        /**
         * ListMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.filters = null;

        /**
         * ListMeasurementsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.paging = null;

        /**
         * ListMeasurementsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.sorting = null;

        /**
         * ListMeasurementsRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.ListMeasurementsRequest
         * @instance
         */
        ListMeasurementsRequest.prototype.virtual = false;

        /**
         * Creates a new ListMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListMeasurementsRequest
         * @static
         * @param {pond.IListMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListMeasurementsRequest} ListMeasurementsRequest instance
         */
        ListMeasurementsRequest.create = function create(properties) {
            return new ListMeasurementsRequest(properties);
        };

        /**
         * Creates a ListMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMeasurementsRequest} ListMeasurementsRequest
         */
        ListMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMeasurementsRequest)
                return object;
            var message = new $root.pond.ListMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListMeasurementsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListMeasurementsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from a ListMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMeasurementsRequest
         * @static
         * @param {pond.ListMeasurementsRequest} message ListMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.filters = null;
                object.paging = null;
                object.sorting = null;
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this ListMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMeasurementsRequest;
    })();

    pond.ListExportedMeasurementsRequest = (function() {

        /**
         * Properties of a ListExportedMeasurementsRequest.
         * @memberof pond
         * @interface IListExportedMeasurementsRequest
         * @property {number|null} [device] ListExportedMeasurementsRequest device
         * @property {string|null} [component] ListExportedMeasurementsRequest component
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] ListExportedMeasurementsRequest filters
         * @property {pond.Paging|null} [paging] ListExportedMeasurementsRequest paging
         * @property {pond.Sorting|null} [sorting] ListExportedMeasurementsRequest sorting
         */

        /**
         * Constructs a new ListExportedMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListExportedMeasurementsRequest.
         * @implements IListExportedMeasurementsRequest
         * @constructor
         * @param {pond.IListExportedMeasurementsRequest=} [properties] Properties to set
         */
        function ListExportedMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListExportedMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         */
        ListExportedMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListExportedMeasurementsRequest component.
         * @member {string} component
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         */
        ListExportedMeasurementsRequest.prototype.component = "";

        /**
         * ListExportedMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         */
        ListExportedMeasurementsRequest.prototype.filters = null;

        /**
         * ListExportedMeasurementsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         */
        ListExportedMeasurementsRequest.prototype.paging = null;

        /**
         * ListExportedMeasurementsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         */
        ListExportedMeasurementsRequest.prototype.sorting = null;

        /**
         * Creates a new ListExportedMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListExportedMeasurementsRequest
         * @static
         * @param {pond.IListExportedMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListExportedMeasurementsRequest} ListExportedMeasurementsRequest instance
         */
        ListExportedMeasurementsRequest.create = function create(properties) {
            return new ListExportedMeasurementsRequest(properties);
        };

        /**
         * Creates a ListExportedMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListExportedMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListExportedMeasurementsRequest} ListExportedMeasurementsRequest
         */
        ListExportedMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListExportedMeasurementsRequest)
                return object;
            var message = new $root.pond.ListExportedMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListExportedMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListExportedMeasurementsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListExportedMeasurementsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListExportedMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListExportedMeasurementsRequest
         * @static
         * @param {pond.ListExportedMeasurementsRequest} message ListExportedMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListExportedMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.filters = null;
                object.paging = null;
                object.sorting = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            return object;
        };

        /**
         * Converts this ListExportedMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListExportedMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListExportedMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListExportedMeasurementsRequest;
    })();

    pond.ListDeviceExportedMeasurementsRequest = (function() {

        /**
         * Properties of a ListDeviceExportedMeasurementsRequest.
         * @memberof pond
         * @interface IListDeviceExportedMeasurementsRequest
         * @property {number|null} [device] ListDeviceExportedMeasurementsRequest device
         * @property {Array.<string>|null} [componentKeys] ListDeviceExportedMeasurementsRequest componentKeys
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] ListDeviceExportedMeasurementsRequest filters
         * @property {pond.Paging|null} [paging] ListDeviceExportedMeasurementsRequest paging
         * @property {pond.Sorting|null} [sorting] ListDeviceExportedMeasurementsRequest sorting
         */

        /**
         * Constructs a new ListDeviceExportedMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListDeviceExportedMeasurementsRequest.
         * @implements IListDeviceExportedMeasurementsRequest
         * @constructor
         * @param {pond.IListDeviceExportedMeasurementsRequest=} [properties] Properties to set
         */
        function ListDeviceExportedMeasurementsRequest(properties) {
            this.componentKeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceExportedMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         */
        ListDeviceExportedMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListDeviceExportedMeasurementsRequest componentKeys.
         * @member {Array.<string>} componentKeys
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         */
        ListDeviceExportedMeasurementsRequest.prototype.componentKeys = $util.emptyArray;

        /**
         * ListDeviceExportedMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         */
        ListDeviceExportedMeasurementsRequest.prototype.filters = null;

        /**
         * ListDeviceExportedMeasurementsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         */
        ListDeviceExportedMeasurementsRequest.prototype.paging = null;

        /**
         * ListDeviceExportedMeasurementsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         */
        ListDeviceExportedMeasurementsRequest.prototype.sorting = null;

        /**
         * Creates a new ListDeviceExportedMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @static
         * @param {pond.IListDeviceExportedMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListDeviceExportedMeasurementsRequest} ListDeviceExportedMeasurementsRequest instance
         */
        ListDeviceExportedMeasurementsRequest.create = function create(properties) {
            return new ListDeviceExportedMeasurementsRequest(properties);
        };

        /**
         * Creates a ListDeviceExportedMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceExportedMeasurementsRequest} ListDeviceExportedMeasurementsRequest
         */
        ListDeviceExportedMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceExportedMeasurementsRequest)
                return object;
            var message = new $root.pond.ListDeviceExportedMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.componentKeys) {
                if (!Array.isArray(object.componentKeys))
                    throw TypeError(".pond.ListDeviceExportedMeasurementsRequest.componentKeys: array expected");
                message.componentKeys = [];
                for (var i = 0; i < object.componentKeys.length; ++i)
                    message.componentKeys[i] = String(object.componentKeys[i]);
            }
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListDeviceExportedMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListDeviceExportedMeasurementsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListDeviceExportedMeasurementsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceExportedMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @static
         * @param {pond.ListDeviceExportedMeasurementsRequest} message ListDeviceExportedMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceExportedMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.componentKeys = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.filters = null;
                object.paging = null;
                object.sorting = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.componentKeys && message.componentKeys.length) {
                object.componentKeys = [];
                for (var j = 0; j < message.componentKeys.length; ++j)
                    object.componentKeys[j] = message.componentKeys[j];
            }
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            return object;
        };

        /**
         * Converts this ListDeviceExportedMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceExportedMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceExportedMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceExportedMeasurementsRequest;
    })();

    pond.Measurement = (function() {

        /**
         * Properties of a Measurement.
         * @memberof pond
         * @interface IMeasurement
         * @property {string|null} [timestamp] Measurement timestamp
         * @property {quack.Measurement|null} [measurement] Measurement measurement
         * @property {number|null} [device] Measurement device
         */

        /**
         * Constructs a new Measurement.
         * @memberof pond
         * @classdesc Represents a Measurement.
         * @implements IMeasurement
         * @constructor
         * @param {pond.IMeasurement=} [properties] Properties to set
         */
        function Measurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Measurement timestamp.
         * @member {string} timestamp
         * @memberof pond.Measurement
         * @instance
         */
        Measurement.prototype.timestamp = "";

        /**
         * Measurement measurement.
         * @member {quack.Measurement|null|undefined} measurement
         * @memberof pond.Measurement
         * @instance
         */
        Measurement.prototype.measurement = null;

        /**
         * Measurement device.
         * @member {number} device
         * @memberof pond.Measurement
         * @instance
         */
        Measurement.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Measurement instance using the specified properties.
         * @function create
         * @memberof pond.Measurement
         * @static
         * @param {pond.IMeasurement=} [properties] Properties to set
         * @returns {pond.Measurement} Measurement instance
         */
        Measurement.create = function create(properties) {
            return new Measurement(properties);
        };

        /**
         * Creates a Measurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Measurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Measurement} Measurement
         */
        Measurement.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Measurement)
                return object;
            var message = new $root.pond.Measurement();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.measurement != null) {
                if (typeof object.measurement !== "object")
                    throw TypeError(".pond.Measurement.measurement: object expected");
                message.measurement = $root.quack.Measurement.fromObject(object.measurement);
            }
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Measurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Measurement
         * @static
         * @param {pond.Measurement} message Measurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Measurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timestamp = "";
                object.measurement = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.measurement != null && message.hasOwnProperty("measurement"))
                object.measurement = $root.quack.Measurement.toObject(message.measurement, options);
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this Measurement to JSON.
         * @function toJSON
         * @memberof pond.Measurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Measurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Measurement;
    })();

    pond.ExportedMeasurement = (function() {

        /**
         * Properties of an ExportedMeasurement.
         * @memberof pond
         * @interface IExportedMeasurement
         * @property {string|null} [timestamp] ExportedMeasurement timestamp
         * @property {string|null} [measurementType] ExportedMeasurement measurementType
         * @property {string|null} [measurementUnit] ExportedMeasurement measurementUnit
         * @property {number|null} [measurementValue] ExportedMeasurement measurementValue
         */

        /**
         * Constructs a new ExportedMeasurement.
         * @memberof pond
         * @classdesc Represents an ExportedMeasurement.
         * @implements IExportedMeasurement
         * @constructor
         * @param {pond.IExportedMeasurement=} [properties] Properties to set
         */
        function ExportedMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExportedMeasurement timestamp.
         * @member {string} timestamp
         * @memberof pond.ExportedMeasurement
         * @instance
         */
        ExportedMeasurement.prototype.timestamp = "";

        /**
         * ExportedMeasurement measurementType.
         * @member {string} measurementType
         * @memberof pond.ExportedMeasurement
         * @instance
         */
        ExportedMeasurement.prototype.measurementType = "";

        /**
         * ExportedMeasurement measurementUnit.
         * @member {string} measurementUnit
         * @memberof pond.ExportedMeasurement
         * @instance
         */
        ExportedMeasurement.prototype.measurementUnit = "";

        /**
         * ExportedMeasurement measurementValue.
         * @member {number} measurementValue
         * @memberof pond.ExportedMeasurement
         * @instance
         */
        ExportedMeasurement.prototype.measurementValue = 0;

        /**
         * Creates a new ExportedMeasurement instance using the specified properties.
         * @function create
         * @memberof pond.ExportedMeasurement
         * @static
         * @param {pond.IExportedMeasurement=} [properties] Properties to set
         * @returns {pond.ExportedMeasurement} ExportedMeasurement instance
         */
        ExportedMeasurement.create = function create(properties) {
            return new ExportedMeasurement(properties);
        };

        /**
         * Creates an ExportedMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ExportedMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ExportedMeasurement} ExportedMeasurement
         */
        ExportedMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ExportedMeasurement)
                return object;
            var message = new $root.pond.ExportedMeasurement();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.measurementType != null)
                message.measurementType = String(object.measurementType);
            if (object.measurementUnit != null)
                message.measurementUnit = String(object.measurementUnit);
            if (object.measurementValue != null)
                message.measurementValue = Number(object.measurementValue);
            return message;
        };

        /**
         * Creates a plain object from an ExportedMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ExportedMeasurement
         * @static
         * @param {pond.ExportedMeasurement} message ExportedMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExportedMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timestamp = "";
                object.measurementType = "";
                object.measurementUnit = "";
                object.measurementValue = 0;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = message.measurementType;
            if (message.measurementUnit != null && message.hasOwnProperty("measurementUnit"))
                object.measurementUnit = message.measurementUnit;
            if (message.measurementValue != null && message.hasOwnProperty("measurementValue"))
                object.measurementValue = options.json && !isFinite(message.measurementValue) ? String(message.measurementValue) : message.measurementValue;
            return object;
        };

        /**
         * Converts this ExportedMeasurement to JSON.
         * @function toJSON
         * @memberof pond.ExportedMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExportedMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExportedMeasurement;
    })();

    pond.ExportedUnitMeasurement = (function() {

        /**
         * Properties of an ExportedUnitMeasurement.
         * @memberof pond
         * @interface IExportedUnitMeasurement
         * @property {string|null} [timestamp] ExportedUnitMeasurement timestamp
         * @property {Array.<number>|null} [measurementValue] ExportedUnitMeasurement measurementValue
         */

        /**
         * Constructs a new ExportedUnitMeasurement.
         * @memberof pond
         * @classdesc Represents an ExportedUnitMeasurement.
         * @implements IExportedUnitMeasurement
         * @constructor
         * @param {pond.IExportedUnitMeasurement=} [properties] Properties to set
         */
        function ExportedUnitMeasurement(properties) {
            this.measurementValue = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExportedUnitMeasurement timestamp.
         * @member {string} timestamp
         * @memberof pond.ExportedUnitMeasurement
         * @instance
         */
        ExportedUnitMeasurement.prototype.timestamp = "";

        /**
         * ExportedUnitMeasurement measurementValue.
         * @member {Array.<number>} measurementValue
         * @memberof pond.ExportedUnitMeasurement
         * @instance
         */
        ExportedUnitMeasurement.prototype.measurementValue = $util.emptyArray;

        /**
         * Creates a new ExportedUnitMeasurement instance using the specified properties.
         * @function create
         * @memberof pond.ExportedUnitMeasurement
         * @static
         * @param {pond.IExportedUnitMeasurement=} [properties] Properties to set
         * @returns {pond.ExportedUnitMeasurement} ExportedUnitMeasurement instance
         */
        ExportedUnitMeasurement.create = function create(properties) {
            return new ExportedUnitMeasurement(properties);
        };

        /**
         * Creates an ExportedUnitMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ExportedUnitMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ExportedUnitMeasurement} ExportedUnitMeasurement
         */
        ExportedUnitMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ExportedUnitMeasurement)
                return object;
            var message = new $root.pond.ExportedUnitMeasurement();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.measurementValue) {
                if (!Array.isArray(object.measurementValue))
                    throw TypeError(".pond.ExportedUnitMeasurement.measurementValue: array expected");
                message.measurementValue = [];
                for (var i = 0; i < object.measurementValue.length; ++i)
                    message.measurementValue[i] = Number(object.measurementValue[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an ExportedUnitMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ExportedUnitMeasurement
         * @static
         * @param {pond.ExportedUnitMeasurement} message ExportedUnitMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExportedUnitMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurementValue = [];
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.measurementValue && message.measurementValue.length) {
                object.measurementValue = [];
                for (var j = 0; j < message.measurementValue.length; ++j)
                    object.measurementValue[j] = options.json && !isFinite(message.measurementValue[j]) ? String(message.measurementValue[j]) : message.measurementValue[j];
            }
            return object;
        };

        /**
         * Converts this ExportedUnitMeasurement to JSON.
         * @function toJSON
         * @memberof pond.ExportedUnitMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExportedUnitMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExportedUnitMeasurement;
    })();

    pond.ExportedComponentUnit = (function() {

        /**
         * Properties of an ExportedComponentUnit.
         * @memberof pond
         * @interface IExportedComponentUnit
         * @property {string|null} [componentId] ExportedComponentUnit componentId
         * @property {string|null} [componentName] ExportedComponentUnit componentName
         * @property {string|null} [measurementType] ExportedComponentUnit measurementType
         * @property {string|null} [measurementUnit] ExportedComponentUnit measurementUnit
         * @property {Array.<pond.ExportedUnitMeasurement>|null} [exportedMeasurements] ExportedComponentUnit exportedMeasurements
         */

        /**
         * Constructs a new ExportedComponentUnit.
         * @memberof pond
         * @classdesc Represents an ExportedComponentUnit.
         * @implements IExportedComponentUnit
         * @constructor
         * @param {pond.IExportedComponentUnit=} [properties] Properties to set
         */
        function ExportedComponentUnit(properties) {
            this.exportedMeasurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExportedComponentUnit componentId.
         * @member {string} componentId
         * @memberof pond.ExportedComponentUnit
         * @instance
         */
        ExportedComponentUnit.prototype.componentId = "";

        /**
         * ExportedComponentUnit componentName.
         * @member {string} componentName
         * @memberof pond.ExportedComponentUnit
         * @instance
         */
        ExportedComponentUnit.prototype.componentName = "";

        /**
         * ExportedComponentUnit measurementType.
         * @member {string} measurementType
         * @memberof pond.ExportedComponentUnit
         * @instance
         */
        ExportedComponentUnit.prototype.measurementType = "";

        /**
         * ExportedComponentUnit measurementUnit.
         * @member {string} measurementUnit
         * @memberof pond.ExportedComponentUnit
         * @instance
         */
        ExportedComponentUnit.prototype.measurementUnit = "";

        /**
         * ExportedComponentUnit exportedMeasurements.
         * @member {Array.<pond.ExportedUnitMeasurement>} exportedMeasurements
         * @memberof pond.ExportedComponentUnit
         * @instance
         */
        ExportedComponentUnit.prototype.exportedMeasurements = $util.emptyArray;

        /**
         * Creates a new ExportedComponentUnit instance using the specified properties.
         * @function create
         * @memberof pond.ExportedComponentUnit
         * @static
         * @param {pond.IExportedComponentUnit=} [properties] Properties to set
         * @returns {pond.ExportedComponentUnit} ExportedComponentUnit instance
         */
        ExportedComponentUnit.create = function create(properties) {
            return new ExportedComponentUnit(properties);
        };

        /**
         * Creates an ExportedComponentUnit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ExportedComponentUnit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ExportedComponentUnit} ExportedComponentUnit
         */
        ExportedComponentUnit.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ExportedComponentUnit)
                return object;
            var message = new $root.pond.ExportedComponentUnit();
            if (object.componentId != null)
                message.componentId = String(object.componentId);
            if (object.componentName != null)
                message.componentName = String(object.componentName);
            if (object.measurementType != null)
                message.measurementType = String(object.measurementType);
            if (object.measurementUnit != null)
                message.measurementUnit = String(object.measurementUnit);
            if (object.exportedMeasurements) {
                if (!Array.isArray(object.exportedMeasurements))
                    throw TypeError(".pond.ExportedComponentUnit.exportedMeasurements: array expected");
                message.exportedMeasurements = [];
                for (var i = 0; i < object.exportedMeasurements.length; ++i) {
                    if (typeof object.exportedMeasurements[i] !== "object")
                        throw TypeError(".pond.ExportedComponentUnit.exportedMeasurements: object expected");
                    message.exportedMeasurements[i] = $root.pond.ExportedUnitMeasurement.fromObject(object.exportedMeasurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ExportedComponentUnit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ExportedComponentUnit
         * @static
         * @param {pond.ExportedComponentUnit} message ExportedComponentUnit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExportedComponentUnit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.exportedMeasurements = [];
            if (options.defaults) {
                object.componentId = "";
                object.componentName = "";
                object.measurementType = "";
                object.measurementUnit = "";
            }
            if (message.componentId != null && message.hasOwnProperty("componentId"))
                object.componentId = message.componentId;
            if (message.componentName != null && message.hasOwnProperty("componentName"))
                object.componentName = message.componentName;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = message.measurementType;
            if (message.measurementUnit != null && message.hasOwnProperty("measurementUnit"))
                object.measurementUnit = message.measurementUnit;
            if (message.exportedMeasurements && message.exportedMeasurements.length) {
                object.exportedMeasurements = [];
                for (var j = 0; j < message.exportedMeasurements.length; ++j)
                    object.exportedMeasurements[j] = $root.pond.ExportedUnitMeasurement.toObject(message.exportedMeasurements[j], options);
            }
            return object;
        };

        /**
         * Converts this ExportedComponentUnit to JSON.
         * @function toJSON
         * @memberof pond.ExportedComponentUnit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExportedComponentUnit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExportedComponentUnit;
    })();

    pond.ListMeasurementsResponse = (function() {

        /**
         * Properties of a ListMeasurementsResponse.
         * @memberof pond
         * @interface IListMeasurementsResponse
         * @property {Array.<pond.Measurement>|null} [measurements] ListMeasurementsResponse measurements
         * @property {number|null} [nextOffset] ListMeasurementsResponse nextOffset
         * @property {number|null} [total] ListMeasurementsResponse total
         */

        /**
         * Constructs a new ListMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListMeasurementsResponse.
         * @implements IListMeasurementsResponse
         * @constructor
         * @param {pond.IListMeasurementsResponse=} [properties] Properties to set
         */
        function ListMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMeasurementsResponse measurements.
         * @member {Array.<pond.Measurement>} measurements
         * @memberof pond.ListMeasurementsResponse
         * @instance
         */
        ListMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * ListMeasurementsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListMeasurementsResponse
         * @instance
         */
        ListMeasurementsResponse.prototype.nextOffset = 0;

        /**
         * ListMeasurementsResponse total.
         * @member {number} total
         * @memberof pond.ListMeasurementsResponse
         * @instance
         */
        ListMeasurementsResponse.prototype.total = 0;

        /**
         * Creates a new ListMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListMeasurementsResponse
         * @static
         * @param {pond.IListMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListMeasurementsResponse} ListMeasurementsResponse instance
         */
        ListMeasurementsResponse.create = function create(properties) {
            return new ListMeasurementsResponse(properties);
        };

        /**
         * Creates a ListMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMeasurementsResponse} ListMeasurementsResponse
         */
        ListMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMeasurementsResponse)
                return object;
            var message = new $root.pond.ListMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.ListMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.ListMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.Measurement.fromObject(object.measurements[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMeasurementsResponse
         * @static
         * @param {pond.ListMeasurementsResponse} message ListMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.Measurement.toObject(message.measurements[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMeasurementsResponse;
    })();

    pond.ListExportedMeasurementsResponse = (function() {

        /**
         * Properties of a ListExportedMeasurementsResponse.
         * @memberof pond
         * @interface IListExportedMeasurementsResponse
         * @property {Array.<pond.ExportedMeasurement>|null} [exportedMeasurements] ListExportedMeasurementsResponse exportedMeasurements
         */

        /**
         * Constructs a new ListExportedMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListExportedMeasurementsResponse.
         * @implements IListExportedMeasurementsResponse
         * @constructor
         * @param {pond.IListExportedMeasurementsResponse=} [properties] Properties to set
         */
        function ListExportedMeasurementsResponse(properties) {
            this.exportedMeasurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListExportedMeasurementsResponse exportedMeasurements.
         * @member {Array.<pond.ExportedMeasurement>} exportedMeasurements
         * @memberof pond.ListExportedMeasurementsResponse
         * @instance
         */
        ListExportedMeasurementsResponse.prototype.exportedMeasurements = $util.emptyArray;

        /**
         * Creates a new ListExportedMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListExportedMeasurementsResponse
         * @static
         * @param {pond.IListExportedMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListExportedMeasurementsResponse} ListExportedMeasurementsResponse instance
         */
        ListExportedMeasurementsResponse.create = function create(properties) {
            return new ListExportedMeasurementsResponse(properties);
        };

        /**
         * Creates a ListExportedMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListExportedMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListExportedMeasurementsResponse} ListExportedMeasurementsResponse
         */
        ListExportedMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListExportedMeasurementsResponse)
                return object;
            var message = new $root.pond.ListExportedMeasurementsResponse();
            if (object.exportedMeasurements) {
                if (!Array.isArray(object.exportedMeasurements))
                    throw TypeError(".pond.ListExportedMeasurementsResponse.exportedMeasurements: array expected");
                message.exportedMeasurements = [];
                for (var i = 0; i < object.exportedMeasurements.length; ++i) {
                    if (typeof object.exportedMeasurements[i] !== "object")
                        throw TypeError(".pond.ListExportedMeasurementsResponse.exportedMeasurements: object expected");
                    message.exportedMeasurements[i] = $root.pond.ExportedMeasurement.fromObject(object.exportedMeasurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListExportedMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListExportedMeasurementsResponse
         * @static
         * @param {pond.ListExportedMeasurementsResponse} message ListExportedMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListExportedMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.exportedMeasurements = [];
            if (message.exportedMeasurements && message.exportedMeasurements.length) {
                object.exportedMeasurements = [];
                for (var j = 0; j < message.exportedMeasurements.length; ++j)
                    object.exportedMeasurements[j] = $root.pond.ExportedMeasurement.toObject(message.exportedMeasurements[j], options);
            }
            return object;
        };

        /**
         * Converts this ListExportedMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListExportedMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListExportedMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListExportedMeasurementsResponse;
    })();

    pond.ComponentMeasurements = (function() {

        /**
         * Properties of a ComponentMeasurements.
         * @memberof pond
         * @interface IComponentMeasurements
         * @property {string|null} [componentId] ComponentMeasurements componentId
         * @property {Array.<pond.ExportedMeasurement>|null} [exportedMeasurements] ComponentMeasurements exportedMeasurements
         */

        /**
         * Constructs a new ComponentMeasurements.
         * @memberof pond
         * @classdesc Represents a ComponentMeasurements.
         * @implements IComponentMeasurements
         * @constructor
         * @param {pond.IComponentMeasurements=} [properties] Properties to set
         */
        function ComponentMeasurements(properties) {
            this.exportedMeasurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentMeasurements componentId.
         * @member {string} componentId
         * @memberof pond.ComponentMeasurements
         * @instance
         */
        ComponentMeasurements.prototype.componentId = "";

        /**
         * ComponentMeasurements exportedMeasurements.
         * @member {Array.<pond.ExportedMeasurement>} exportedMeasurements
         * @memberof pond.ComponentMeasurements
         * @instance
         */
        ComponentMeasurements.prototype.exportedMeasurements = $util.emptyArray;

        /**
         * Creates a new ComponentMeasurements instance using the specified properties.
         * @function create
         * @memberof pond.ComponentMeasurements
         * @static
         * @param {pond.IComponentMeasurements=} [properties] Properties to set
         * @returns {pond.ComponentMeasurements} ComponentMeasurements instance
         */
        ComponentMeasurements.create = function create(properties) {
            return new ComponentMeasurements(properties);
        };

        /**
         * Creates a ComponentMeasurements message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentMeasurements
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentMeasurements} ComponentMeasurements
         */
        ComponentMeasurements.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentMeasurements)
                return object;
            var message = new $root.pond.ComponentMeasurements();
            if (object.componentId != null)
                message.componentId = String(object.componentId);
            if (object.exportedMeasurements) {
                if (!Array.isArray(object.exportedMeasurements))
                    throw TypeError(".pond.ComponentMeasurements.exportedMeasurements: array expected");
                message.exportedMeasurements = [];
                for (var i = 0; i < object.exportedMeasurements.length; ++i) {
                    if (typeof object.exportedMeasurements[i] !== "object")
                        throw TypeError(".pond.ComponentMeasurements.exportedMeasurements: object expected");
                    message.exportedMeasurements[i] = $root.pond.ExportedMeasurement.fromObject(object.exportedMeasurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComponentMeasurements message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentMeasurements
         * @static
         * @param {pond.ComponentMeasurements} message ComponentMeasurements
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentMeasurements.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.exportedMeasurements = [];
            if (options.defaults)
                object.componentId = "";
            if (message.componentId != null && message.hasOwnProperty("componentId"))
                object.componentId = message.componentId;
            if (message.exportedMeasurements && message.exportedMeasurements.length) {
                object.exportedMeasurements = [];
                for (var j = 0; j < message.exportedMeasurements.length; ++j)
                    object.exportedMeasurements[j] = $root.pond.ExportedMeasurement.toObject(message.exportedMeasurements[j], options);
            }
            return object;
        };

        /**
         * Converts this ComponentMeasurements to JSON.
         * @function toJSON
         * @memberof pond.ComponentMeasurements
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentMeasurements.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentMeasurements;
    })();

    pond.ListDeviceExportedMeasurementsResponse = (function() {

        /**
         * Properties of a ListDeviceExportedMeasurementsResponse.
         * @memberof pond
         * @interface IListDeviceExportedMeasurementsResponse
         * @property {string|null} [deviceName] ListDeviceExportedMeasurementsResponse deviceName
         * @property {number|null} [deviceId] ListDeviceExportedMeasurementsResponse deviceId
         * @property {Array.<pond.ExportedComponentUnit>|null} [components] ListDeviceExportedMeasurementsResponse components
         */

        /**
         * Constructs a new ListDeviceExportedMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListDeviceExportedMeasurementsResponse.
         * @implements IListDeviceExportedMeasurementsResponse
         * @constructor
         * @param {pond.IListDeviceExportedMeasurementsResponse=} [properties] Properties to set
         */
        function ListDeviceExportedMeasurementsResponse(properties) {
            this.components = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDeviceExportedMeasurementsResponse deviceName.
         * @member {string} deviceName
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @instance
         */
        ListDeviceExportedMeasurementsResponse.prototype.deviceName = "";

        /**
         * ListDeviceExportedMeasurementsResponse deviceId.
         * @member {number} deviceId
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @instance
         */
        ListDeviceExportedMeasurementsResponse.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListDeviceExportedMeasurementsResponse components.
         * @member {Array.<pond.ExportedComponentUnit>} components
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @instance
         */
        ListDeviceExportedMeasurementsResponse.prototype.components = $util.emptyArray;

        /**
         * Creates a new ListDeviceExportedMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @static
         * @param {pond.IListDeviceExportedMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListDeviceExportedMeasurementsResponse} ListDeviceExportedMeasurementsResponse instance
         */
        ListDeviceExportedMeasurementsResponse.create = function create(properties) {
            return new ListDeviceExportedMeasurementsResponse(properties);
        };

        /**
         * Creates a ListDeviceExportedMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDeviceExportedMeasurementsResponse} ListDeviceExportedMeasurementsResponse
         */
        ListDeviceExportedMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDeviceExportedMeasurementsResponse)
                return object;
            var message = new $root.pond.ListDeviceExportedMeasurementsResponse();
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.ListDeviceExportedMeasurementsResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.ListDeviceExportedMeasurementsResponse.components: object expected");
                    message.components[i] = $root.pond.ExportedComponentUnit.fromObject(object.components[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListDeviceExportedMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @static
         * @param {pond.ListDeviceExportedMeasurementsResponse} message ListDeviceExportedMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDeviceExportedMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (options.defaults) {
                object.deviceName = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
            }
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.ExportedComponentUnit.toObject(message.components[j], options);
            }
            return object;
        };

        /**
         * Converts this ListDeviceExportedMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDeviceExportedMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDeviceExportedMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDeviceExportedMeasurementsResponse;
    })();

    pond.LastMeasurementsRequest = (function() {

        /**
         * Properties of a LastMeasurementsRequest.
         * @memberof pond
         * @interface ILastMeasurementsRequest
         * @property {number|null} [device] LastMeasurementsRequest device
         * @property {boolean|null} [virtual] LastMeasurementsRequest virtual
         */

        /**
         * Constructs a new LastMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a LastMeasurementsRequest.
         * @implements ILastMeasurementsRequest
         * @constructor
         * @param {pond.ILastMeasurementsRequest=} [properties] Properties to set
         */
        function LastMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LastMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.LastMeasurementsRequest
         * @instance
         */
        LastMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * LastMeasurementsRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.LastMeasurementsRequest
         * @instance
         */
        LastMeasurementsRequest.prototype.virtual = false;

        /**
         * Creates a new LastMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.LastMeasurementsRequest
         * @static
         * @param {pond.ILastMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.LastMeasurementsRequest} LastMeasurementsRequest instance
         */
        LastMeasurementsRequest.create = function create(properties) {
            return new LastMeasurementsRequest(properties);
        };

        /**
         * Creates a LastMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LastMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LastMeasurementsRequest} LastMeasurementsRequest
         */
        LastMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LastMeasurementsRequest)
                return object;
            var message = new $root.pond.LastMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from a LastMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LastMeasurementsRequest
         * @static
         * @param {pond.LastMeasurementsRequest} message LastMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LastMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this LastMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.LastMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LastMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LastMeasurementsRequest;
    })();

    pond.LastMeasurementsResponse = (function() {

        /**
         * Properties of a LastMeasurementsResponse.
         * @memberof pond
         * @interface ILastMeasurementsResponse
         * @property {Object.<string,pond.Measurement>|null} [measurements] LastMeasurementsResponse measurements
         */

        /**
         * Constructs a new LastMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a LastMeasurementsResponse.
         * @implements ILastMeasurementsResponse
         * @constructor
         * @param {pond.ILastMeasurementsResponse=} [properties] Properties to set
         */
        function LastMeasurementsResponse(properties) {
            this.measurements = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LastMeasurementsResponse measurements.
         * @member {Object.<string,pond.Measurement>} measurements
         * @memberof pond.LastMeasurementsResponse
         * @instance
         */
        LastMeasurementsResponse.prototype.measurements = $util.emptyObject;

        /**
         * Creates a new LastMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.LastMeasurementsResponse
         * @static
         * @param {pond.ILastMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.LastMeasurementsResponse} LastMeasurementsResponse instance
         */
        LastMeasurementsResponse.create = function create(properties) {
            return new LastMeasurementsResponse(properties);
        };

        /**
         * Creates a LastMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LastMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LastMeasurementsResponse} LastMeasurementsResponse
         */
        LastMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LastMeasurementsResponse)
                return object;
            var message = new $root.pond.LastMeasurementsResponse();
            if (object.measurements) {
                if (typeof object.measurements !== "object")
                    throw TypeError(".pond.LastMeasurementsResponse.measurements: object expected");
                message.measurements = {};
                for (var keys = Object.keys(object.measurements), i = 0; i < keys.length; ++i) {
                    if (typeof object.measurements[keys[i]] !== "object")
                        throw TypeError(".pond.LastMeasurementsResponse.measurements: object expected");
                    message.measurements[keys[i]] = $root.pond.Measurement.fromObject(object.measurements[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a LastMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LastMeasurementsResponse
         * @static
         * @param {pond.LastMeasurementsResponse} message LastMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LastMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.measurements = {};
            var keys2;
            if (message.measurements && (keys2 = Object.keys(message.measurements)).length) {
                object.measurements = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.measurements[keys2[j]] = $root.pond.Measurement.toObject(message.measurements[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this LastMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.LastMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LastMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LastMeasurementsResponse;
    })();

    pond.SampleMeasurementsRequest = (function() {

        /**
         * Properties of a SampleMeasurementsRequest.
         * @memberof pond
         * @interface ISampleMeasurementsRequest
         * @property {number|null} [device] SampleMeasurementsRequest device
         * @property {string|null} [component] SampleMeasurementsRequest component
         * @property {number|null} [size] SampleMeasurementsRequest size
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] SampleMeasurementsRequest filters
         * @property {boolean|null} [virtual] SampleMeasurementsRequest virtual
         */

        /**
         * Constructs a new SampleMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a SampleMeasurementsRequest.
         * @implements ISampleMeasurementsRequest
         * @constructor
         * @param {pond.ISampleMeasurementsRequest=} [properties] Properties to set
         */
        function SampleMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SampleMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         */
        SampleMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SampleMeasurementsRequest component.
         * @member {string} component
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         */
        SampleMeasurementsRequest.prototype.component = "";

        /**
         * SampleMeasurementsRequest size.
         * @member {number} size
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         */
        SampleMeasurementsRequest.prototype.size = 0;

        /**
         * SampleMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         */
        SampleMeasurementsRequest.prototype.filters = null;

        /**
         * SampleMeasurementsRequest virtual.
         * @member {boolean} virtual
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         */
        SampleMeasurementsRequest.prototype.virtual = false;

        /**
         * Creates a new SampleMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.SampleMeasurementsRequest
         * @static
         * @param {pond.ISampleMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.SampleMeasurementsRequest} SampleMeasurementsRequest instance
         */
        SampleMeasurementsRequest.create = function create(properties) {
            return new SampleMeasurementsRequest(properties);
        };

        /**
         * Creates a SampleMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SampleMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SampleMeasurementsRequest} SampleMeasurementsRequest
         */
        SampleMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SampleMeasurementsRequest)
                return object;
            var message = new $root.pond.SampleMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.SampleMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            if (object.virtual != null)
                message.virtual = Boolean(object.virtual);
            return message;
        };

        /**
         * Creates a plain object from a SampleMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SampleMeasurementsRequest
         * @static
         * @param {pond.SampleMeasurementsRequest} message SampleMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SampleMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.size = 0;
                object.filters = null;
                object.virtual = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.virtual != null && message.hasOwnProperty("virtual"))
                object.virtual = message.virtual;
            return object;
        };

        /**
         * Converts this SampleMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.SampleMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SampleMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SampleMeasurementsRequest;
    })();

    pond.SampleMeasurementsResponse = (function() {

        /**
         * Properties of a SampleMeasurementsResponse.
         * @memberof pond
         * @interface ISampleMeasurementsResponse
         * @property {Array.<pond.Measurement>|null} [measurements] SampleMeasurementsResponse measurements
         */

        /**
         * Constructs a new SampleMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a SampleMeasurementsResponse.
         * @implements ISampleMeasurementsResponse
         * @constructor
         * @param {pond.ISampleMeasurementsResponse=} [properties] Properties to set
         */
        function SampleMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SampleMeasurementsResponse measurements.
         * @member {Array.<pond.Measurement>} measurements
         * @memberof pond.SampleMeasurementsResponse
         * @instance
         */
        SampleMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * Creates a new SampleMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.SampleMeasurementsResponse
         * @static
         * @param {pond.ISampleMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.SampleMeasurementsResponse} SampleMeasurementsResponse instance
         */
        SampleMeasurementsResponse.create = function create(properties) {
            return new SampleMeasurementsResponse(properties);
        };

        /**
         * Creates a SampleMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SampleMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SampleMeasurementsResponse} SampleMeasurementsResponse
         */
        SampleMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SampleMeasurementsResponse)
                return object;
            var message = new $root.pond.SampleMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.SampleMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.SampleMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.Measurement.fromObject(object.measurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SampleMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SampleMeasurementsResponse
         * @static
         * @param {pond.SampleMeasurementsResponse} message SampleMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SampleMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.Measurement.toObject(message.measurements[j], options);
            }
            return object;
        };

        /**
         * Converts this SampleMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.SampleMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SampleMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SampleMeasurementsResponse;
    })();

    pond.SampleUnitMeasurementsRequest = (function() {

        /**
         * Properties of a SampleUnitMeasurementsRequest.
         * @memberof pond
         * @interface ISampleUnitMeasurementsRequest
         * @property {number|null} [device] SampleUnitMeasurementsRequest device
         * @property {string|null} [component] SampleUnitMeasurementsRequest component
         * @property {number|null} [size] SampleUnitMeasurementsRequest size
         * @property {pond.ListMeasurementsRequestFilters|null} [filters] SampleUnitMeasurementsRequest filters
         * @property {pond.Mutator|null} [mutator] SampleUnitMeasurementsRequest mutator
         * @property {boolean|null} [showErrors] SampleUnitMeasurementsRequest showErrors
         */

        /**
         * Constructs a new SampleUnitMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a SampleUnitMeasurementsRequest.
         * @implements ISampleUnitMeasurementsRequest
         * @constructor
         * @param {pond.ISampleUnitMeasurementsRequest=} [properties] Properties to set
         */
        function SampleUnitMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SampleUnitMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SampleUnitMeasurementsRequest component.
         * @member {string} component
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.component = "";

        /**
         * SampleUnitMeasurementsRequest size.
         * @member {number} size
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.size = 0;

        /**
         * SampleUnitMeasurementsRequest filters.
         * @member {pond.ListMeasurementsRequestFilters|null|undefined} filters
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.filters = null;

        /**
         * SampleUnitMeasurementsRequest mutator.
         * @member {pond.Mutator} mutator
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.mutator = 0;

        /**
         * SampleUnitMeasurementsRequest showErrors.
         * @member {boolean} showErrors
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         */
        SampleUnitMeasurementsRequest.prototype.showErrors = false;

        /**
         * Creates a new SampleUnitMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.SampleUnitMeasurementsRequest
         * @static
         * @param {pond.ISampleUnitMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.SampleUnitMeasurementsRequest} SampleUnitMeasurementsRequest instance
         */
        SampleUnitMeasurementsRequest.create = function create(properties) {
            return new SampleUnitMeasurementsRequest(properties);
        };

        /**
         * Creates a SampleUnitMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SampleUnitMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SampleUnitMeasurementsRequest} SampleUnitMeasurementsRequest
         */
        SampleUnitMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SampleUnitMeasurementsRequest)
                return object;
            var message = new $root.pond.SampleUnitMeasurementsRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            if (object.size != null)
                message.size = object.size >>> 0;
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.SampleUnitMeasurementsRequest.filters: object expected");
                message.filters = $root.pond.ListMeasurementsRequestFilters.fromObject(object.filters);
            }
            switch (object.mutator) {
            case "MUTATOR_NONE":
            case 0:
                message.mutator = 0;
                break;
            case "MUTATOR_EMC":
            case 1:
                message.mutator = 1;
                break;
            case "MUTATOR_CFM":
            case 2:
                message.mutator = 2;
                break;
            case "MUTATOR_FUEL_LEVEL":
            case 3:
                message.mutator = 3;
                break;
            }
            if (object.showErrors != null)
                message.showErrors = Boolean(object.showErrors);
            return message;
        };

        /**
         * Creates a plain object from a SampleUnitMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SampleUnitMeasurementsRequest
         * @static
         * @param {pond.SampleUnitMeasurementsRequest} message SampleUnitMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SampleUnitMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.size = 0;
                object.filters = null;
                object.mutator = options.enums === String ? "MUTATOR_NONE" : 0;
                object.showErrors = false;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListMeasurementsRequestFilters.toObject(message.filters, options);
            if (message.mutator != null && message.hasOwnProperty("mutator"))
                object.mutator = options.enums === String ? $root.pond.Mutator[message.mutator] : message.mutator;
            if (message.showErrors != null && message.hasOwnProperty("showErrors"))
                object.showErrors = message.showErrors;
            return object;
        };

        /**
         * Converts this SampleUnitMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.SampleUnitMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SampleUnitMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SampleUnitMeasurementsRequest;
    })();

    pond.SampleUnitMeasurementsResponse = (function() {

        /**
         * Properties of a SampleUnitMeasurementsResponse.
         * @memberof pond
         * @interface ISampleUnitMeasurementsResponse
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [measurements] SampleUnitMeasurementsResponse measurements
         */

        /**
         * Constructs a new SampleUnitMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a SampleUnitMeasurementsResponse.
         * @implements ISampleUnitMeasurementsResponse
         * @constructor
         * @param {pond.ISampleUnitMeasurementsResponse=} [properties] Properties to set
         */
        function SampleUnitMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SampleUnitMeasurementsResponse measurements.
         * @member {Array.<pond.UnitMeasurementsForComponent>} measurements
         * @memberof pond.SampleUnitMeasurementsResponse
         * @instance
         */
        SampleUnitMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * Creates a new SampleUnitMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.SampleUnitMeasurementsResponse
         * @static
         * @param {pond.ISampleUnitMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.SampleUnitMeasurementsResponse} SampleUnitMeasurementsResponse instance
         */
        SampleUnitMeasurementsResponse.create = function create(properties) {
            return new SampleUnitMeasurementsResponse(properties);
        };

        /**
         * Creates a SampleUnitMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SampleUnitMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SampleUnitMeasurementsResponse} SampleUnitMeasurementsResponse
         */
        SampleUnitMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SampleUnitMeasurementsResponse)
                return object;
            var message = new $root.pond.SampleUnitMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.SampleUnitMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.SampleUnitMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.measurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SampleUnitMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SampleUnitMeasurementsResponse
         * @static
         * @param {pond.SampleUnitMeasurementsResponse} message SampleUnitMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SampleUnitMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.measurements[j], options);
            }
            return object;
        };

        /**
         * Converts this SampleUnitMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.SampleUnitMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SampleUnitMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SampleUnitMeasurementsResponse;
    })();

    pond.ExportDeviceMeasurementsFlatRequest = (function() {

        /**
         * Properties of an ExportDeviceMeasurementsFlatRequest.
         * @memberof pond
         * @interface IExportDeviceMeasurementsFlatRequest
         * @property {number|null} [deviceId] ExportDeviceMeasurementsFlatRequest deviceId
         */

        /**
         * Constructs a new ExportDeviceMeasurementsFlatRequest.
         * @memberof pond
         * @classdesc Represents an ExportDeviceMeasurementsFlatRequest.
         * @implements IExportDeviceMeasurementsFlatRequest
         * @constructor
         * @param {pond.IExportDeviceMeasurementsFlatRequest=} [properties] Properties to set
         */
        function ExportDeviceMeasurementsFlatRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExportDeviceMeasurementsFlatRequest deviceId.
         * @member {number} deviceId
         * @memberof pond.ExportDeviceMeasurementsFlatRequest
         * @instance
         */
        ExportDeviceMeasurementsFlatRequest.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ExportDeviceMeasurementsFlatRequest instance using the specified properties.
         * @function create
         * @memberof pond.ExportDeviceMeasurementsFlatRequest
         * @static
         * @param {pond.IExportDeviceMeasurementsFlatRequest=} [properties] Properties to set
         * @returns {pond.ExportDeviceMeasurementsFlatRequest} ExportDeviceMeasurementsFlatRequest instance
         */
        ExportDeviceMeasurementsFlatRequest.create = function create(properties) {
            return new ExportDeviceMeasurementsFlatRequest(properties);
        };

        /**
         * Creates an ExportDeviceMeasurementsFlatRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ExportDeviceMeasurementsFlatRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ExportDeviceMeasurementsFlatRequest} ExportDeviceMeasurementsFlatRequest
         */
        ExportDeviceMeasurementsFlatRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ExportDeviceMeasurementsFlatRequest)
                return object;
            var message = new $root.pond.ExportDeviceMeasurementsFlatRequest();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an ExportDeviceMeasurementsFlatRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ExportDeviceMeasurementsFlatRequest
         * @static
         * @param {pond.ExportDeviceMeasurementsFlatRequest} message ExportDeviceMeasurementsFlatRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExportDeviceMeasurementsFlatRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            return object;
        };

        /**
         * Converts this ExportDeviceMeasurementsFlatRequest to JSON.
         * @function toJSON
         * @memberof pond.ExportDeviceMeasurementsFlatRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExportDeviceMeasurementsFlatRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExportDeviceMeasurementsFlatRequest;
    })();

    pond.ExportDeviceMeasurementsFlatResponse = (function() {

        /**
         * Properties of an ExportDeviceMeasurementsFlatResponse.
         * @memberof pond
         * @interface IExportDeviceMeasurementsFlatResponse
         * @property {number|null} [deviceId] ExportDeviceMeasurementsFlatResponse deviceId
         * @property {string|null} [deviceName] ExportDeviceMeasurementsFlatResponse deviceName
         * @property {Array.<pond.FlatComponent>|null} [components] ExportDeviceMeasurementsFlatResponse components
         */

        /**
         * Constructs a new ExportDeviceMeasurementsFlatResponse.
         * @memberof pond
         * @classdesc Represents an ExportDeviceMeasurementsFlatResponse.
         * @implements IExportDeviceMeasurementsFlatResponse
         * @constructor
         * @param {pond.IExportDeviceMeasurementsFlatResponse=} [properties] Properties to set
         */
        function ExportDeviceMeasurementsFlatResponse(properties) {
            this.components = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExportDeviceMeasurementsFlatResponse deviceId.
         * @member {number} deviceId
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @instance
         */
        ExportDeviceMeasurementsFlatResponse.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ExportDeviceMeasurementsFlatResponse deviceName.
         * @member {string} deviceName
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @instance
         */
        ExportDeviceMeasurementsFlatResponse.prototype.deviceName = "";

        /**
         * ExportDeviceMeasurementsFlatResponse components.
         * @member {Array.<pond.FlatComponent>} components
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @instance
         */
        ExportDeviceMeasurementsFlatResponse.prototype.components = $util.emptyArray;

        /**
         * Creates a new ExportDeviceMeasurementsFlatResponse instance using the specified properties.
         * @function create
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @static
         * @param {pond.IExportDeviceMeasurementsFlatResponse=} [properties] Properties to set
         * @returns {pond.ExportDeviceMeasurementsFlatResponse} ExportDeviceMeasurementsFlatResponse instance
         */
        ExportDeviceMeasurementsFlatResponse.create = function create(properties) {
            return new ExportDeviceMeasurementsFlatResponse(properties);
        };

        /**
         * Creates an ExportDeviceMeasurementsFlatResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ExportDeviceMeasurementsFlatResponse} ExportDeviceMeasurementsFlatResponse
         */
        ExportDeviceMeasurementsFlatResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ExportDeviceMeasurementsFlatResponse)
                return object;
            var message = new $root.pond.ExportDeviceMeasurementsFlatResponse();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.ExportDeviceMeasurementsFlatResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.ExportDeviceMeasurementsFlatResponse.components: object expected");
                    message.components[i] = $root.pond.FlatComponent.fromObject(object.components[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ExportDeviceMeasurementsFlatResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @static
         * @param {pond.ExportDeviceMeasurementsFlatResponse} message ExportDeviceMeasurementsFlatResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExportDeviceMeasurementsFlatResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.deviceName = "";
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.FlatComponent.toObject(message.components[j], options);
            }
            return object;
        };

        /**
         * Converts this ExportDeviceMeasurementsFlatResponse to JSON.
         * @function toJSON
         * @memberof pond.ExportDeviceMeasurementsFlatResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExportDeviceMeasurementsFlatResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExportDeviceMeasurementsFlatResponse;
    })();

    pond.FlatComponent = (function() {

        /**
         * Properties of a FlatComponent.
         * @memberof pond
         * @interface IFlatComponent
         * @property {string|null} [address] FlatComponent address
         * @property {number|null} [time] FlatComponent time
         * @property {Array.<pond.UnitVal>|null} [measurement] FlatComponent measurement
         */

        /**
         * Constructs a new FlatComponent.
         * @memberof pond
         * @classdesc Represents a FlatComponent.
         * @implements IFlatComponent
         * @constructor
         * @param {pond.IFlatComponent=} [properties] Properties to set
         */
        function FlatComponent(properties) {
            this.measurement = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FlatComponent address.
         * @member {string} address
         * @memberof pond.FlatComponent
         * @instance
         */
        FlatComponent.prototype.address = "";

        /**
         * FlatComponent time.
         * @member {number} time
         * @memberof pond.FlatComponent
         * @instance
         */
        FlatComponent.prototype.time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FlatComponent measurement.
         * @member {Array.<pond.UnitVal>} measurement
         * @memberof pond.FlatComponent
         * @instance
         */
        FlatComponent.prototype.measurement = $util.emptyArray;

        /**
         * Creates a new FlatComponent instance using the specified properties.
         * @function create
         * @memberof pond.FlatComponent
         * @static
         * @param {pond.IFlatComponent=} [properties] Properties to set
         * @returns {pond.FlatComponent} FlatComponent instance
         */
        FlatComponent.create = function create(properties) {
            return new FlatComponent(properties);
        };

        /**
         * Creates a FlatComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FlatComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FlatComponent} FlatComponent
         */
        FlatComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FlatComponent)
                return object;
            var message = new $root.pond.FlatComponent();
            if (object.address != null)
                message.address = String(object.address);
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = true;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber(true);
            if (object.measurement) {
                if (!Array.isArray(object.measurement))
                    throw TypeError(".pond.FlatComponent.measurement: array expected");
                message.measurement = [];
                for (var i = 0; i < object.measurement.length; ++i) {
                    if (typeof object.measurement[i] !== "object")
                        throw TypeError(".pond.FlatComponent.measurement: object expected");
                    message.measurement[i] = $root.pond.UnitVal.fromObject(object.measurement[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a FlatComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FlatComponent
         * @static
         * @param {pond.FlatComponent} message FlatComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FlatComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurement = [];
            if (options.defaults) {
                object.address = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
            }
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber(true) : message.time;
            if (message.measurement && message.measurement.length) {
                object.measurement = [];
                for (var j = 0; j < message.measurement.length; ++j)
                    object.measurement[j] = $root.pond.UnitVal.toObject(message.measurement[j], options);
            }
            return object;
        };

        /**
         * Converts this FlatComponent to JSON.
         * @function toJSON
         * @memberof pond.FlatComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FlatComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FlatComponent;
    })();

    pond.UnitVal = (function() {

        /**
         * Properties of an UnitVal.
         * @memberof pond
         * @interface IUnitVal
         * @property {Array.<number>|null} [val] UnitVal val
         * @property {quack.MeasurementType|null} [unit] UnitVal unit
         */

        /**
         * Constructs a new UnitVal.
         * @memberof pond
         * @classdesc Represents an UnitVal.
         * @implements IUnitVal
         * @constructor
         * @param {pond.IUnitVal=} [properties] Properties to set
         */
        function UnitVal(properties) {
            this.val = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnitVal val.
         * @member {Array.<number>} val
         * @memberof pond.UnitVal
         * @instance
         */
        UnitVal.prototype.val = $util.emptyArray;

        /**
         * UnitVal unit.
         * @member {quack.MeasurementType} unit
         * @memberof pond.UnitVal
         * @instance
         */
        UnitVal.prototype.unit = 0;

        /**
         * Creates a new UnitVal instance using the specified properties.
         * @function create
         * @memberof pond.UnitVal
         * @static
         * @param {pond.IUnitVal=} [properties] Properties to set
         * @returns {pond.UnitVal} UnitVal instance
         */
        UnitVal.create = function create(properties) {
            return new UnitVal(properties);
        };

        /**
         * Creates an UnitVal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UnitVal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UnitVal} UnitVal
         */
        UnitVal.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UnitVal)
                return object;
            var message = new $root.pond.UnitVal();
            if (object.val) {
                if (!Array.isArray(object.val))
                    throw TypeError(".pond.UnitVal.val: array expected");
                message.val = [];
                for (var i = 0; i < object.val.length; ++i)
                    message.val[i] = Number(object.val[i]);
            }
            switch (object.unit) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.unit = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.unit = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.unit = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.unit = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.unit = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.unit = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.unit = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.unit = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.unit = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.unit = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.unit = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.unit = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.unit = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.unit = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.unit = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.unit = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.unit = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.unit = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.unit = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.unit = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.unit = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.unit = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.unit = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.unit = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.unit = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.unit = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.unit = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.unit = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.unit = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.unit = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.unit = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.unit = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.unit = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.unit = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.unit = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.unit = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.unit = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.unit = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.unit = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.unit = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.unit = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an UnitVal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UnitVal
         * @static
         * @param {pond.UnitVal} message UnitVal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnitVal.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.val = [];
            if (options.defaults)
                object.unit = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            if (message.val && message.val.length) {
                object.val = [];
                for (var j = 0; j < message.val.length; ++j)
                    object.val[j] = options.json && !isFinite(message.val[j]) ? String(message.val[j]) : message.val[j];
            }
            if (message.unit != null && message.hasOwnProperty("unit"))
                object.unit = options.enums === String ? $root.quack.MeasurementType[message.unit] : message.unit;
            return object;
        };

        /**
         * Converts this UnitVal to JSON.
         * @function toJSON
         * @memberof pond.UnitVal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnitVal.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UnitVal;
    })();

    /**
     * UpgradeChannel enum.
     * @name pond.UpgradeChannel
     * @enum {string}
     * @property {number} UPGRADE_CHANNEL_INVALID=0 UPGRADE_CHANNEL_INVALID value
     * @property {number} UPGRADE_CHANNEL_DEVELOPMENT=1 UPGRADE_CHANNEL_DEVELOPMENT value
     * @property {number} UPGRADE_CHANNEL_ALPHA=2 UPGRADE_CHANNEL_ALPHA value
     * @property {number} UPGRADE_CHANNEL_BETA=3 UPGRADE_CHANNEL_BETA value
     * @property {number} UPGRADE_CHANNEL_STABLE=4 UPGRADE_CHANNEL_STABLE value
     * @property {number} UPGRADE_CHANNEL_RECOVERY=5 UPGRADE_CHANNEL_RECOVERY value
     */
    pond.UpgradeChannel = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UPGRADE_CHANNEL_INVALID"] = 0;
        values[valuesById[1] = "UPGRADE_CHANNEL_DEVELOPMENT"] = 1;
        values[valuesById[2] = "UPGRADE_CHANNEL_ALPHA"] = 2;
        values[valuesById[3] = "UPGRADE_CHANNEL_BETA"] = 3;
        values[valuesById[4] = "UPGRADE_CHANNEL_STABLE"] = 4;
        values[valuesById[5] = "UPGRADE_CHANNEL_RECOVERY"] = 5;
        return values;
    })();

    pond.UploadFirmwareRequest = (function() {

        /**
         * Properties of an UploadFirmwareRequest.
         * @memberof pond
         * @interface IUploadFirmwareRequest
         * @property {string|null} [version] UploadFirmwareRequest version
         * @property {pond.DevicePlatform|null} [platform] UploadFirmwareRequest platform
         * @property {pond.UpgradeChannel|null} [channel] UploadFirmwareRequest channel
         * @property {Uint8Array|null} [data] UploadFirmwareRequest data
         * @property {boolean|null} [breaksStorage] UploadFirmwareRequest breaksStorage
         */

        /**
         * Constructs a new UploadFirmwareRequest.
         * @memberof pond
         * @classdesc Represents an UploadFirmwareRequest.
         * @implements IUploadFirmwareRequest
         * @constructor
         * @param {pond.IUploadFirmwareRequest=} [properties] Properties to set
         */
        function UploadFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadFirmwareRequest version.
         * @member {string} version
         * @memberof pond.UploadFirmwareRequest
         * @instance
         */
        UploadFirmwareRequest.prototype.version = "";

        /**
         * UploadFirmwareRequest platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.UploadFirmwareRequest
         * @instance
         */
        UploadFirmwareRequest.prototype.platform = 0;

        /**
         * UploadFirmwareRequest channel.
         * @member {pond.UpgradeChannel} channel
         * @memberof pond.UploadFirmwareRequest
         * @instance
         */
        UploadFirmwareRequest.prototype.channel = 0;

        /**
         * UploadFirmwareRequest data.
         * @member {Uint8Array} data
         * @memberof pond.UploadFirmwareRequest
         * @instance
         */
        UploadFirmwareRequest.prototype.data = $util.newBuffer([]);

        /**
         * UploadFirmwareRequest breaksStorage.
         * @member {boolean} breaksStorage
         * @memberof pond.UploadFirmwareRequest
         * @instance
         */
        UploadFirmwareRequest.prototype.breaksStorage = false;

        /**
         * Creates a new UploadFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.UploadFirmwareRequest
         * @static
         * @param {pond.IUploadFirmwareRequest=} [properties] Properties to set
         * @returns {pond.UploadFirmwareRequest} UploadFirmwareRequest instance
         */
        UploadFirmwareRequest.create = function create(properties) {
            return new UploadFirmwareRequest(properties);
        };

        /**
         * Creates an UploadFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UploadFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UploadFirmwareRequest} UploadFirmwareRequest
         */
        UploadFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UploadFirmwareRequest)
                return object;
            var message = new $root.pond.UploadFirmwareRequest();
            if (object.version != null)
                message.version = String(object.version);
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            switch (object.channel) {
            case "UPGRADE_CHANNEL_INVALID":
            case 0:
                message.channel = 0;
                break;
            case "UPGRADE_CHANNEL_DEVELOPMENT":
            case 1:
                message.channel = 1;
                break;
            case "UPGRADE_CHANNEL_ALPHA":
            case 2:
                message.channel = 2;
                break;
            case "UPGRADE_CHANNEL_BETA":
            case 3:
                message.channel = 3;
                break;
            case "UPGRADE_CHANNEL_STABLE":
            case 4:
                message.channel = 4;
                break;
            case "UPGRADE_CHANNEL_RECOVERY":
            case 5:
                message.channel = 5;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length)
                    message.data = object.data;
            if (object.breaksStorage != null)
                message.breaksStorage = Boolean(object.breaksStorage);
            return message;
        };

        /**
         * Creates a plain object from an UploadFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UploadFirmwareRequest
         * @static
         * @param {pond.UploadFirmwareRequest} message UploadFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
                object.channel = options.enums === String ? "UPGRADE_CHANNEL_INVALID" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.breaksStorage = false;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = options.enums === String ? $root.pond.UpgradeChannel[message.channel] : message.channel;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.breaksStorage != null && message.hasOwnProperty("breaksStorage"))
                object.breaksStorage = message.breaksStorage;
            return object;
        };

        /**
         * Converts this UploadFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.UploadFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UploadFirmwareRequest;
    })();

    pond.UploadFirmwareResponse = (function() {

        /**
         * Properties of an UploadFirmwareResponse.
         * @memberof pond
         * @interface IUploadFirmwareResponse
         */

        /**
         * Constructs a new UploadFirmwareResponse.
         * @memberof pond
         * @classdesc Represents an UploadFirmwareResponse.
         * @implements IUploadFirmwareResponse
         * @constructor
         * @param {pond.IUploadFirmwareResponse=} [properties] Properties to set
         */
        function UploadFirmwareResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UploadFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.UploadFirmwareResponse
         * @static
         * @param {pond.IUploadFirmwareResponse=} [properties] Properties to set
         * @returns {pond.UploadFirmwareResponse} UploadFirmwareResponse instance
         */
        UploadFirmwareResponse.create = function create(properties) {
            return new UploadFirmwareResponse(properties);
        };

        /**
         * Creates an UploadFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UploadFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UploadFirmwareResponse} UploadFirmwareResponse
         */
        UploadFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UploadFirmwareResponse)
                return object;
            return new $root.pond.UploadFirmwareResponse();
        };

        /**
         * Creates a plain object from an UploadFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UploadFirmwareResponse
         * @static
         * @param {pond.UploadFirmwareResponse} message UploadFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadFirmwareResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UploadFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.UploadFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UploadFirmwareResponse;
    })();

    pond.GetFirmwareRequest = (function() {

        /**
         * Properties of a GetFirmwareRequest.
         * @memberof pond
         * @interface IGetFirmwareRequest
         * @property {string|null} [version] GetFirmwareRequest version
         * @property {pond.DevicePlatform|null} [platform] GetFirmwareRequest platform
         */

        /**
         * Constructs a new GetFirmwareRequest.
         * @memberof pond
         * @classdesc Represents a GetFirmwareRequest.
         * @implements IGetFirmwareRequest
         * @constructor
         * @param {pond.IGetFirmwareRequest=} [properties] Properties to set
         */
        function GetFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFirmwareRequest version.
         * @member {string} version
         * @memberof pond.GetFirmwareRequest
         * @instance
         */
        GetFirmwareRequest.prototype.version = "";

        /**
         * GetFirmwareRequest platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.GetFirmwareRequest
         * @instance
         */
        GetFirmwareRequest.prototype.platform = 0;

        /**
         * Creates a new GetFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetFirmwareRequest
         * @static
         * @param {pond.IGetFirmwareRequest=} [properties] Properties to set
         * @returns {pond.GetFirmwareRequest} GetFirmwareRequest instance
         */
        GetFirmwareRequest.create = function create(properties) {
            return new GetFirmwareRequest(properties);
        };

        /**
         * Creates a GetFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetFirmwareRequest} GetFirmwareRequest
         */
        GetFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetFirmwareRequest)
                return object;
            var message = new $root.pond.GetFirmwareRequest();
            if (object.version != null)
                message.version = String(object.version);
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GetFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetFirmwareRequest
         * @static
         * @param {pond.GetFirmwareRequest} message GetFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            return object;
        };

        /**
         * Converts this GetFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.GetFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetFirmwareRequest;
    })();

    pond.FirmwareSettings = (function() {

        /**
         * Properties of a FirmwareSettings.
         * @memberof pond
         * @interface IFirmwareSettings
         * @property {string|null} [version] FirmwareSettings version
         * @property {pond.DevicePlatform|null} [platform] FirmwareSettings platform
         * @property {pond.UpgradeChannel|null} [channel] FirmwareSettings channel
         * @property {number|null} [size] FirmwareSettings size
         * @property {Uint8Array|null} [data] FirmwareSettings data
         * @property {boolean|null} [breaksStorage] FirmwareSettings breaksStorage
         */

        /**
         * Constructs a new FirmwareSettings.
         * @memberof pond
         * @classdesc Represents a FirmwareSettings.
         * @implements IFirmwareSettings
         * @constructor
         * @param {pond.IFirmwareSettings=} [properties] Properties to set
         */
        function FirmwareSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FirmwareSettings version.
         * @member {string} version
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.version = "";

        /**
         * FirmwareSettings platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.platform = 0;

        /**
         * FirmwareSettings channel.
         * @member {pond.UpgradeChannel} channel
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.channel = 0;

        /**
         * FirmwareSettings size.
         * @member {number} size
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FirmwareSettings data.
         * @member {Uint8Array} data
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.data = $util.newBuffer([]);

        /**
         * FirmwareSettings breaksStorage.
         * @member {boolean} breaksStorage
         * @memberof pond.FirmwareSettings
         * @instance
         */
        FirmwareSettings.prototype.breaksStorage = false;

        /**
         * Creates a new FirmwareSettings instance using the specified properties.
         * @function create
         * @memberof pond.FirmwareSettings
         * @static
         * @param {pond.IFirmwareSettings=} [properties] Properties to set
         * @returns {pond.FirmwareSettings} FirmwareSettings instance
         */
        FirmwareSettings.create = function create(properties) {
            return new FirmwareSettings(properties);
        };

        /**
         * Creates a FirmwareSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FirmwareSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FirmwareSettings} FirmwareSettings
         */
        FirmwareSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FirmwareSettings)
                return object;
            var message = new $root.pond.FirmwareSettings();
            if (object.version != null)
                message.version = String(object.version);
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            switch (object.channel) {
            case "UPGRADE_CHANNEL_INVALID":
            case 0:
                message.channel = 0;
                break;
            case "UPGRADE_CHANNEL_DEVELOPMENT":
            case 1:
                message.channel = 1;
                break;
            case "UPGRADE_CHANNEL_ALPHA":
            case 2:
                message.channel = 2;
                break;
            case "UPGRADE_CHANNEL_BETA":
            case 3:
                message.channel = 3;
                break;
            case "UPGRADE_CHANNEL_STABLE":
            case 4:
                message.channel = 4;
                break;
            case "UPGRADE_CHANNEL_RECOVERY":
            case 5:
                message.channel = 5;
                break;
            }
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length)
                    message.data = object.data;
            if (object.breaksStorage != null)
                message.breaksStorage = Boolean(object.breaksStorage);
            return message;
        };

        /**
         * Creates a plain object from a FirmwareSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FirmwareSettings
         * @static
         * @param {pond.FirmwareSettings} message FirmwareSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FirmwareSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
                object.channel = options.enums === String ? "UPGRADE_CHANNEL_INVALID" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.breaksStorage = false;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = options.enums === String ? $root.pond.UpgradeChannel[message.channel] : message.channel;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.breaksStorage != null && message.hasOwnProperty("breaksStorage"))
                object.breaksStorage = message.breaksStorage;
            return object;
        };

        /**
         * Converts this FirmwareSettings to JSON.
         * @function toJSON
         * @memberof pond.FirmwareSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FirmwareSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FirmwareSettings;
    })();

    pond.FirmwareStatus = (function() {

        /**
         * Properties of a FirmwareStatus.
         * @memberof pond
         * @interface IFirmwareStatus
         * @property {string|null} [uploaded] FirmwareStatus uploaded
         * @property {string|null} [changed] FirmwareStatus changed
         */

        /**
         * Constructs a new FirmwareStatus.
         * @memberof pond
         * @classdesc Represents a FirmwareStatus.
         * @implements IFirmwareStatus
         * @constructor
         * @param {pond.IFirmwareStatus=} [properties] Properties to set
         */
        function FirmwareStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FirmwareStatus uploaded.
         * @member {string} uploaded
         * @memberof pond.FirmwareStatus
         * @instance
         */
        FirmwareStatus.prototype.uploaded = "";

        /**
         * FirmwareStatus changed.
         * @member {string} changed
         * @memberof pond.FirmwareStatus
         * @instance
         */
        FirmwareStatus.prototype.changed = "";

        /**
         * Creates a new FirmwareStatus instance using the specified properties.
         * @function create
         * @memberof pond.FirmwareStatus
         * @static
         * @param {pond.IFirmwareStatus=} [properties] Properties to set
         * @returns {pond.FirmwareStatus} FirmwareStatus instance
         */
        FirmwareStatus.create = function create(properties) {
            return new FirmwareStatus(properties);
        };

        /**
         * Creates a FirmwareStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FirmwareStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FirmwareStatus} FirmwareStatus
         */
        FirmwareStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FirmwareStatus)
                return object;
            var message = new $root.pond.FirmwareStatus();
            if (object.uploaded != null)
                message.uploaded = String(object.uploaded);
            if (object.changed != null)
                message.changed = String(object.changed);
            return message;
        };

        /**
         * Creates a plain object from a FirmwareStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FirmwareStatus
         * @static
         * @param {pond.FirmwareStatus} message FirmwareStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FirmwareStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uploaded = "";
                object.changed = "";
            }
            if (message.uploaded != null && message.hasOwnProperty("uploaded"))
                object.uploaded = message.uploaded;
            if (message.changed != null && message.hasOwnProperty("changed"))
                object.changed = message.changed;
            return object;
        };

        /**
         * Converts this FirmwareStatus to JSON.
         * @function toJSON
         * @memberof pond.FirmwareStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FirmwareStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FirmwareStatus;
    })();

    pond.Firmware = (function() {

        /**
         * Properties of a Firmware.
         * @memberof pond
         * @interface IFirmware
         * @property {pond.FirmwareSettings|null} [settings] Firmware settings
         * @property {pond.FirmwareStatus|null} [status] Firmware status
         */

        /**
         * Constructs a new Firmware.
         * @memberof pond
         * @classdesc Represents a Firmware.
         * @implements IFirmware
         * @constructor
         * @param {pond.IFirmware=} [properties] Properties to set
         */
        function Firmware(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Firmware settings.
         * @member {pond.FirmwareSettings|null|undefined} settings
         * @memberof pond.Firmware
         * @instance
         */
        Firmware.prototype.settings = null;

        /**
         * Firmware status.
         * @member {pond.FirmwareStatus|null|undefined} status
         * @memberof pond.Firmware
         * @instance
         */
        Firmware.prototype.status = null;

        /**
         * Creates a new Firmware instance using the specified properties.
         * @function create
         * @memberof pond.Firmware
         * @static
         * @param {pond.IFirmware=} [properties] Properties to set
         * @returns {pond.Firmware} Firmware instance
         */
        Firmware.create = function create(properties) {
            return new Firmware(properties);
        };

        /**
         * Creates a Firmware message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Firmware
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Firmware} Firmware
         */
        Firmware.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Firmware)
                return object;
            var message = new $root.pond.Firmware();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Firmware.settings: object expected");
                message.settings = $root.pond.FirmwareSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Firmware.status: object expected");
                message.status = $root.pond.FirmwareStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Firmware message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Firmware
         * @static
         * @param {pond.Firmware} message Firmware
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Firmware.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.FirmwareSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.FirmwareStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Firmware to JSON.
         * @function toJSON
         * @memberof pond.Firmware
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Firmware.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Firmware;
    })();

    pond.ListFirmwareRequest = (function() {

        /**
         * Properties of a ListFirmwareRequest.
         * @memberof pond
         * @interface IListFirmwareRequest
         * @property {pond.Paging|null} [paging] ListFirmwareRequest paging
         * @property {pond.Sorting|null} [sorting] ListFirmwareRequest sorting
         * @property {string|null} [search] ListFirmwareRequest search
         * @property {pond.FirmwareSettings|null} [settingsMatch] ListFirmwareRequest settingsMatch
         * @property {Object.<string,string>|null} [fieldContains] ListFirmwareRequest fieldContains
         */

        /**
         * Constructs a new ListFirmwareRequest.
         * @memberof pond
         * @classdesc Represents a ListFirmwareRequest.
         * @implements IListFirmwareRequest
         * @constructor
         * @param {pond.IListFirmwareRequest=} [properties] Properties to set
         */
        function ListFirmwareRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFirmwareRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListFirmwareRequest
         * @instance
         */
        ListFirmwareRequest.prototype.paging = null;

        /**
         * ListFirmwareRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListFirmwareRequest
         * @instance
         */
        ListFirmwareRequest.prototype.sorting = null;

        /**
         * ListFirmwareRequest search.
         * @member {string} search
         * @memberof pond.ListFirmwareRequest
         * @instance
         */
        ListFirmwareRequest.prototype.search = "";

        /**
         * ListFirmwareRequest settingsMatch.
         * @member {pond.FirmwareSettings|null|undefined} settingsMatch
         * @memberof pond.ListFirmwareRequest
         * @instance
         */
        ListFirmwareRequest.prototype.settingsMatch = null;

        /**
         * ListFirmwareRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListFirmwareRequest
         * @instance
         */
        ListFirmwareRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListFirmwareRequest
         * @static
         * @param {pond.IListFirmwareRequest=} [properties] Properties to set
         * @returns {pond.ListFirmwareRequest} ListFirmwareRequest instance
         */
        ListFirmwareRequest.create = function create(properties) {
            return new ListFirmwareRequest(properties);
        };

        /**
         * Creates a ListFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFirmwareRequest} ListFirmwareRequest
         */
        ListFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFirmwareRequest)
                return object;
            var message = new $root.pond.ListFirmwareRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListFirmwareRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListFirmwareRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListFirmwareRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.FirmwareSettings.fromObject(object.settingsMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListFirmwareRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFirmwareRequest
         * @static
         * @param {pond.ListFirmwareRequest} message ListFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.FirmwareSettings.toObject(message.settingsMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.ListFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFirmwareRequest;
    })();

    pond.ListFirmwareResponse = (function() {

        /**
         * Properties of a ListFirmwareResponse.
         * @memberof pond
         * @interface IListFirmwareResponse
         * @property {Array.<pond.Firmware>|null} [firmware] ListFirmwareResponse firmware
         * @property {number|null} [nextOffset] ListFirmwareResponse nextOffset
         * @property {number|null} [total] ListFirmwareResponse total
         */

        /**
         * Constructs a new ListFirmwareResponse.
         * @memberof pond
         * @classdesc Represents a ListFirmwareResponse.
         * @implements IListFirmwareResponse
         * @constructor
         * @param {pond.IListFirmwareResponse=} [properties] Properties to set
         */
        function ListFirmwareResponse(properties) {
            this.firmware = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFirmwareResponse firmware.
         * @member {Array.<pond.Firmware>} firmware
         * @memberof pond.ListFirmwareResponse
         * @instance
         */
        ListFirmwareResponse.prototype.firmware = $util.emptyArray;

        /**
         * ListFirmwareResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListFirmwareResponse
         * @instance
         */
        ListFirmwareResponse.prototype.nextOffset = 0;

        /**
         * ListFirmwareResponse total.
         * @member {number} total
         * @memberof pond.ListFirmwareResponse
         * @instance
         */
        ListFirmwareResponse.prototype.total = 0;

        /**
         * Creates a new ListFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListFirmwareResponse
         * @static
         * @param {pond.IListFirmwareResponse=} [properties] Properties to set
         * @returns {pond.ListFirmwareResponse} ListFirmwareResponse instance
         */
        ListFirmwareResponse.create = function create(properties) {
            return new ListFirmwareResponse(properties);
        };

        /**
         * Creates a ListFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFirmwareResponse} ListFirmwareResponse
         */
        ListFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFirmwareResponse)
                return object;
            var message = new $root.pond.ListFirmwareResponse();
            if (object.firmware) {
                if (!Array.isArray(object.firmware))
                    throw TypeError(".pond.ListFirmwareResponse.firmware: array expected");
                message.firmware = [];
                for (var i = 0; i < object.firmware.length; ++i) {
                    if (typeof object.firmware[i] !== "object")
                        throw TypeError(".pond.ListFirmwareResponse.firmware: object expected");
                    message.firmware[i] = $root.pond.Firmware.fromObject(object.firmware[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFirmwareResponse
         * @static
         * @param {pond.ListFirmwareResponse} message ListFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFirmwareResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.firmware = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.firmware && message.firmware.length) {
                object.firmware = [];
                for (var j = 0; j < message.firmware.length; ++j)
                    object.firmware[j] = $root.pond.Firmware.toObject(message.firmware[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.ListFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFirmwareResponse;
    })();

    pond.LatestFirmwareRequest = (function() {

        /**
         * Properties of a LatestFirmwareRequest.
         * @memberof pond
         * @interface ILatestFirmwareRequest
         * @property {pond.DevicePlatform|null} [platform] LatestFirmwareRequest platform
         * @property {pond.UpgradeChannel|null} [channel] LatestFirmwareRequest channel
         */

        /**
         * Constructs a new LatestFirmwareRequest.
         * @memberof pond
         * @classdesc Represents a LatestFirmwareRequest.
         * @implements ILatestFirmwareRequest
         * @constructor
         * @param {pond.ILatestFirmwareRequest=} [properties] Properties to set
         */
        function LatestFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LatestFirmwareRequest platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.LatestFirmwareRequest
         * @instance
         */
        LatestFirmwareRequest.prototype.platform = 0;

        /**
         * LatestFirmwareRequest channel.
         * @member {pond.UpgradeChannel} channel
         * @memberof pond.LatestFirmwareRequest
         * @instance
         */
        LatestFirmwareRequest.prototype.channel = 0;

        /**
         * Creates a new LatestFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.LatestFirmwareRequest
         * @static
         * @param {pond.ILatestFirmwareRequest=} [properties] Properties to set
         * @returns {pond.LatestFirmwareRequest} LatestFirmwareRequest instance
         */
        LatestFirmwareRequest.create = function create(properties) {
            return new LatestFirmwareRequest(properties);
        };

        /**
         * Creates a LatestFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LatestFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LatestFirmwareRequest} LatestFirmwareRequest
         */
        LatestFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LatestFirmwareRequest)
                return object;
            var message = new $root.pond.LatestFirmwareRequest();
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            switch (object.channel) {
            case "UPGRADE_CHANNEL_INVALID":
            case 0:
                message.channel = 0;
                break;
            case "UPGRADE_CHANNEL_DEVELOPMENT":
            case 1:
                message.channel = 1;
                break;
            case "UPGRADE_CHANNEL_ALPHA":
            case 2:
                message.channel = 2;
                break;
            case "UPGRADE_CHANNEL_BETA":
            case 3:
                message.channel = 3;
                break;
            case "UPGRADE_CHANNEL_STABLE":
            case 4:
                message.channel = 4;
                break;
            case "UPGRADE_CHANNEL_RECOVERY":
            case 5:
                message.channel = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a LatestFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LatestFirmwareRequest
         * @static
         * @param {pond.LatestFirmwareRequest} message LatestFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LatestFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
                object.channel = options.enums === String ? "UPGRADE_CHANNEL_INVALID" : 0;
            }
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = options.enums === String ? $root.pond.UpgradeChannel[message.channel] : message.channel;
            return object;
        };

        /**
         * Converts this LatestFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.LatestFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LatestFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LatestFirmwareRequest;
    })();

    pond.LatestFirmwareResponse = (function() {

        /**
         * Properties of a LatestFirmwareResponse.
         * @memberof pond
         * @interface ILatestFirmwareResponse
         * @property {pond.Firmware|null} [firmware] LatestFirmwareResponse firmware
         */

        /**
         * Constructs a new LatestFirmwareResponse.
         * @memberof pond
         * @classdesc Represents a LatestFirmwareResponse.
         * @implements ILatestFirmwareResponse
         * @constructor
         * @param {pond.ILatestFirmwareResponse=} [properties] Properties to set
         */
        function LatestFirmwareResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LatestFirmwareResponse firmware.
         * @member {pond.Firmware|null|undefined} firmware
         * @memberof pond.LatestFirmwareResponse
         * @instance
         */
        LatestFirmwareResponse.prototype.firmware = null;

        /**
         * Creates a new LatestFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.LatestFirmwareResponse
         * @static
         * @param {pond.ILatestFirmwareResponse=} [properties] Properties to set
         * @returns {pond.LatestFirmwareResponse} LatestFirmwareResponse instance
         */
        LatestFirmwareResponse.create = function create(properties) {
            return new LatestFirmwareResponse(properties);
        };

        /**
         * Creates a LatestFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LatestFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LatestFirmwareResponse} LatestFirmwareResponse
         */
        LatestFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LatestFirmwareResponse)
                return object;
            var message = new $root.pond.LatestFirmwareResponse();
            if (object.firmware != null) {
                if (typeof object.firmware !== "object")
                    throw TypeError(".pond.LatestFirmwareResponse.firmware: object expected");
                message.firmware = $root.pond.Firmware.fromObject(object.firmware);
            }
            return message;
        };

        /**
         * Creates a plain object from a LatestFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LatestFirmwareResponse
         * @static
         * @param {pond.LatestFirmwareResponse} message LatestFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LatestFirmwareResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.firmware = null;
            if (message.firmware != null && message.hasOwnProperty("firmware"))
                object.firmware = $root.pond.Firmware.toObject(message.firmware, options);
            return object;
        };

        /**
         * Converts this LatestFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.LatestFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LatestFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LatestFirmwareResponse;
    })();

    pond.AllLatestFirmwareRequest = (function() {

        /**
         * Properties of an AllLatestFirmwareRequest.
         * @memberof pond
         * @interface IAllLatestFirmwareRequest
         */

        /**
         * Constructs a new AllLatestFirmwareRequest.
         * @memberof pond
         * @classdesc Represents an AllLatestFirmwareRequest.
         * @implements IAllLatestFirmwareRequest
         * @constructor
         * @param {pond.IAllLatestFirmwareRequest=} [properties] Properties to set
         */
        function AllLatestFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AllLatestFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.AllLatestFirmwareRequest
         * @static
         * @param {pond.IAllLatestFirmwareRequest=} [properties] Properties to set
         * @returns {pond.AllLatestFirmwareRequest} AllLatestFirmwareRequest instance
         */
        AllLatestFirmwareRequest.create = function create(properties) {
            return new AllLatestFirmwareRequest(properties);
        };

        /**
         * Creates an AllLatestFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AllLatestFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AllLatestFirmwareRequest} AllLatestFirmwareRequest
         */
        AllLatestFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AllLatestFirmwareRequest)
                return object;
            return new $root.pond.AllLatestFirmwareRequest();
        };

        /**
         * Creates a plain object from an AllLatestFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AllLatestFirmwareRequest
         * @static
         * @param {pond.AllLatestFirmwareRequest} message AllLatestFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AllLatestFirmwareRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AllLatestFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.AllLatestFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AllLatestFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AllLatestFirmwareRequest;
    })();

    pond.AllLatestFirmwareResponse = (function() {

        /**
         * Properties of an AllLatestFirmwareResponse.
         * @memberof pond
         * @interface IAllLatestFirmwareResponse
         * @property {Array.<pond.Firmware>|null} [firmware] AllLatestFirmwareResponse firmware
         */

        /**
         * Constructs a new AllLatestFirmwareResponse.
         * @memberof pond
         * @classdesc Represents an AllLatestFirmwareResponse.
         * @implements IAllLatestFirmwareResponse
         * @constructor
         * @param {pond.IAllLatestFirmwareResponse=} [properties] Properties to set
         */
        function AllLatestFirmwareResponse(properties) {
            this.firmware = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AllLatestFirmwareResponse firmware.
         * @member {Array.<pond.Firmware>} firmware
         * @memberof pond.AllLatestFirmwareResponse
         * @instance
         */
        AllLatestFirmwareResponse.prototype.firmware = $util.emptyArray;

        /**
         * Creates a new AllLatestFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.AllLatestFirmwareResponse
         * @static
         * @param {pond.IAllLatestFirmwareResponse=} [properties] Properties to set
         * @returns {pond.AllLatestFirmwareResponse} AllLatestFirmwareResponse instance
         */
        AllLatestFirmwareResponse.create = function create(properties) {
            return new AllLatestFirmwareResponse(properties);
        };

        /**
         * Creates an AllLatestFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AllLatestFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AllLatestFirmwareResponse} AllLatestFirmwareResponse
         */
        AllLatestFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AllLatestFirmwareResponse)
                return object;
            var message = new $root.pond.AllLatestFirmwareResponse();
            if (object.firmware) {
                if (!Array.isArray(object.firmware))
                    throw TypeError(".pond.AllLatestFirmwareResponse.firmware: array expected");
                message.firmware = [];
                for (var i = 0; i < object.firmware.length; ++i) {
                    if (typeof object.firmware[i] !== "object")
                        throw TypeError(".pond.AllLatestFirmwareResponse.firmware: object expected");
                    message.firmware[i] = $root.pond.Firmware.fromObject(object.firmware[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AllLatestFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AllLatestFirmwareResponse
         * @static
         * @param {pond.AllLatestFirmwareResponse} message AllLatestFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AllLatestFirmwareResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.firmware = [];
            if (message.firmware && message.firmware.length) {
                object.firmware = [];
                for (var j = 0; j < message.firmware.length; ++j)
                    object.firmware[j] = $root.pond.Firmware.toObject(message.firmware[j], options);
            }
            return object;
        };

        /**
         * Converts this AllLatestFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.AllLatestFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AllLatestFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AllLatestFirmwareResponse;
    })();

    pond.AddFirmwareRequest = (function() {

        /**
         * Properties of an AddFirmwareRequest.
         * @memberof pond
         * @interface IAddFirmwareRequest
         * @property {pond.FirmwareSettings|null} [settings] AddFirmwareRequest settings
         */

        /**
         * Constructs a new AddFirmwareRequest.
         * @memberof pond
         * @classdesc Represents an AddFirmwareRequest.
         * @implements IAddFirmwareRequest
         * @constructor
         * @param {pond.IAddFirmwareRequest=} [properties] Properties to set
         */
        function AddFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFirmwareRequest settings.
         * @member {pond.FirmwareSettings|null|undefined} settings
         * @memberof pond.AddFirmwareRequest
         * @instance
         */
        AddFirmwareRequest.prototype.settings = null;

        /**
         * Creates a new AddFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddFirmwareRequest
         * @static
         * @param {pond.IAddFirmwareRequest=} [properties] Properties to set
         * @returns {pond.AddFirmwareRequest} AddFirmwareRequest instance
         */
        AddFirmwareRequest.create = function create(properties) {
            return new AddFirmwareRequest(properties);
        };

        /**
         * Creates an AddFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFirmwareRequest} AddFirmwareRequest
         */
        AddFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFirmwareRequest)
                return object;
            var message = new $root.pond.AddFirmwareRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddFirmwareRequest.settings: object expected");
                message.settings = $root.pond.FirmwareSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFirmwareRequest
         * @static
         * @param {pond.AddFirmwareRequest} message AddFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.FirmwareSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.AddFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFirmwareRequest;
    })();

    pond.AddFirmwareResponse = (function() {

        /**
         * Properties of an AddFirmwareResponse.
         * @memberof pond
         * @interface IAddFirmwareResponse
         */

        /**
         * Constructs a new AddFirmwareResponse.
         * @memberof pond
         * @classdesc Represents an AddFirmwareResponse.
         * @implements IAddFirmwareResponse
         * @constructor
         * @param {pond.IAddFirmwareResponse=} [properties] Properties to set
         */
        function AddFirmwareResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddFirmwareResponse
         * @static
         * @param {pond.IAddFirmwareResponse=} [properties] Properties to set
         * @returns {pond.AddFirmwareResponse} AddFirmwareResponse instance
         */
        AddFirmwareResponse.create = function create(properties) {
            return new AddFirmwareResponse(properties);
        };

        /**
         * Creates an AddFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFirmwareResponse} AddFirmwareResponse
         */
        AddFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFirmwareResponse)
                return object;
            return new $root.pond.AddFirmwareResponse();
        };

        /**
         * Creates a plain object from an AddFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFirmwareResponse
         * @static
         * @param {pond.AddFirmwareResponse} message AddFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFirmwareResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.AddFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFirmwareResponse;
    })();

    pond.UpdateFirmwareRequest = (function() {

        /**
         * Properties of an UpdateFirmwareRequest.
         * @memberof pond
         * @interface IUpdateFirmwareRequest
         * @property {pond.FirmwareSettings|null} [settings] UpdateFirmwareRequest settings
         */

        /**
         * Constructs a new UpdateFirmwareRequest.
         * @memberof pond
         * @classdesc Represents an UpdateFirmwareRequest.
         * @implements IUpdateFirmwareRequest
         * @constructor
         * @param {pond.IUpdateFirmwareRequest=} [properties] Properties to set
         */
        function UpdateFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateFirmwareRequest settings.
         * @member {pond.FirmwareSettings|null|undefined} settings
         * @memberof pond.UpdateFirmwareRequest
         * @instance
         */
        UpdateFirmwareRequest.prototype.settings = null;

        /**
         * Creates a new UpdateFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFirmwareRequest
         * @static
         * @param {pond.IUpdateFirmwareRequest=} [properties] Properties to set
         * @returns {pond.UpdateFirmwareRequest} UpdateFirmwareRequest instance
         */
        UpdateFirmwareRequest.create = function create(properties) {
            return new UpdateFirmwareRequest(properties);
        };

        /**
         * Creates an UpdateFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFirmwareRequest} UpdateFirmwareRequest
         */
        UpdateFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFirmwareRequest)
                return object;
            var message = new $root.pond.UpdateFirmwareRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateFirmwareRequest.settings: object expected");
                message.settings = $root.pond.FirmwareSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFirmwareRequest
         * @static
         * @param {pond.UpdateFirmwareRequest} message UpdateFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.FirmwareSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFirmwareRequest;
    })();

    pond.UpdateFirmwareResponse = (function() {

        /**
         * Properties of an UpdateFirmwareResponse.
         * @memberof pond
         * @interface IUpdateFirmwareResponse
         */

        /**
         * Constructs a new UpdateFirmwareResponse.
         * @memberof pond
         * @classdesc Represents an UpdateFirmwareResponse.
         * @implements IUpdateFirmwareResponse
         * @constructor
         * @param {pond.IUpdateFirmwareResponse=} [properties] Properties to set
         */
        function UpdateFirmwareResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFirmwareResponse
         * @static
         * @param {pond.IUpdateFirmwareResponse=} [properties] Properties to set
         * @returns {pond.UpdateFirmwareResponse} UpdateFirmwareResponse instance
         */
        UpdateFirmwareResponse.create = function create(properties) {
            return new UpdateFirmwareResponse(properties);
        };

        /**
         * Creates an UpdateFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFirmwareResponse} UpdateFirmwareResponse
         */
        UpdateFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFirmwareResponse)
                return object;
            return new $root.pond.UpdateFirmwareResponse();
        };

        /**
         * Creates a plain object from an UpdateFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFirmwareResponse
         * @static
         * @param {pond.UpdateFirmwareResponse} message UpdateFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFirmwareResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFirmwareResponse;
    })();

    pond.RemoveFirmwareRequest = (function() {

        /**
         * Properties of a RemoveFirmwareRequest.
         * @memberof pond
         * @interface IRemoveFirmwareRequest
         * @property {string|null} [version] RemoveFirmwareRequest version
         * @property {pond.DevicePlatform|null} [platform] RemoveFirmwareRequest platform
         */

        /**
         * Constructs a new RemoveFirmwareRequest.
         * @memberof pond
         * @classdesc Represents a RemoveFirmwareRequest.
         * @implements IRemoveFirmwareRequest
         * @constructor
         * @param {pond.IRemoveFirmwareRequest=} [properties] Properties to set
         */
        function RemoveFirmwareRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFirmwareRequest version.
         * @member {string} version
         * @memberof pond.RemoveFirmwareRequest
         * @instance
         */
        RemoveFirmwareRequest.prototype.version = "";

        /**
         * RemoveFirmwareRequest platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.RemoveFirmwareRequest
         * @instance
         */
        RemoveFirmwareRequest.prototype.platform = 0;

        /**
         * Creates a new RemoveFirmwareRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFirmwareRequest
         * @static
         * @param {pond.IRemoveFirmwareRequest=} [properties] Properties to set
         * @returns {pond.RemoveFirmwareRequest} RemoveFirmwareRequest instance
         */
        RemoveFirmwareRequest.create = function create(properties) {
            return new RemoveFirmwareRequest(properties);
        };

        /**
         * Creates a RemoveFirmwareRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFirmwareRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFirmwareRequest} RemoveFirmwareRequest
         */
        RemoveFirmwareRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFirmwareRequest)
                return object;
            var message = new $root.pond.RemoveFirmwareRequest();
            if (object.version != null)
                message.version = String(object.version);
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a RemoveFirmwareRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFirmwareRequest
         * @static
         * @param {pond.RemoveFirmwareRequest} message RemoveFirmwareRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFirmwareRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.version = "";
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
            }
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            return object;
        };

        /**
         * Converts this RemoveFirmwareRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveFirmwareRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFirmwareRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFirmwareRequest;
    })();

    pond.RemoveFirmwareResponse = (function() {

        /**
         * Properties of a RemoveFirmwareResponse.
         * @memberof pond
         * @interface IRemoveFirmwareResponse
         */

        /**
         * Constructs a new RemoveFirmwareResponse.
         * @memberof pond
         * @classdesc Represents a RemoveFirmwareResponse.
         * @implements IRemoveFirmwareResponse
         * @constructor
         * @param {pond.IRemoveFirmwareResponse=} [properties] Properties to set
         */
        function RemoveFirmwareResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveFirmwareResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFirmwareResponse
         * @static
         * @param {pond.IRemoveFirmwareResponse=} [properties] Properties to set
         * @returns {pond.RemoveFirmwareResponse} RemoveFirmwareResponse instance
         */
        RemoveFirmwareResponse.create = function create(properties) {
            return new RemoveFirmwareResponse(properties);
        };

        /**
         * Creates a RemoveFirmwareResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFirmwareResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFirmwareResponse} RemoveFirmwareResponse
         */
        RemoveFirmwareResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFirmwareResponse)
                return object;
            return new $root.pond.RemoveFirmwareResponse();
        };

        /**
         * Creates a plain object from a RemoveFirmwareResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFirmwareResponse
         * @static
         * @param {pond.RemoveFirmwareResponse} message RemoveFirmwareResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFirmwareResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveFirmwareResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveFirmwareResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFirmwareResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFirmwareResponse;
    })();

    pond.UpgradeSettings = (function() {

        /**
         * Properties of an UpgradeSettings.
         * @memberof pond
         * @interface IUpgradeSettings
         * @property {string|null} [key] UpgradeSettings key
         * @property {number|null} [deviceId] UpgradeSettings deviceId
         * @property {string|null} [version] UpgradeSettings version
         */

        /**
         * Constructs a new UpgradeSettings.
         * @memberof pond
         * @classdesc Represents an UpgradeSettings.
         * @implements IUpgradeSettings
         * @constructor
         * @param {pond.IUpgradeSettings=} [properties] Properties to set
         */
        function UpgradeSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpgradeSettings key.
         * @member {string} key
         * @memberof pond.UpgradeSettings
         * @instance
         */
        UpgradeSettings.prototype.key = "";

        /**
         * UpgradeSettings deviceId.
         * @member {number} deviceId
         * @memberof pond.UpgradeSettings
         * @instance
         */
        UpgradeSettings.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpgradeSettings version.
         * @member {string} version
         * @memberof pond.UpgradeSettings
         * @instance
         */
        UpgradeSettings.prototype.version = "";

        /**
         * Creates a new UpgradeSettings instance using the specified properties.
         * @function create
         * @memberof pond.UpgradeSettings
         * @static
         * @param {pond.IUpgradeSettings=} [properties] Properties to set
         * @returns {pond.UpgradeSettings} UpgradeSettings instance
         */
        UpgradeSettings.create = function create(properties) {
            return new UpgradeSettings(properties);
        };

        /**
         * Creates an UpgradeSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpgradeSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpgradeSettings} UpgradeSettings
         */
        UpgradeSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpgradeSettings)
                return object;
            var message = new $root.pond.UpgradeSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.version != null)
                message.version = String(object.version);
            return message;
        };

        /**
         * Creates a plain object from an UpgradeSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpgradeSettings
         * @static
         * @param {pond.UpgradeSettings} message UpgradeSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpgradeSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.version = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Converts this UpgradeSettings to JSON.
         * @function toJSON
         * @memberof pond.UpgradeSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpgradeSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpgradeSettings;
    })();

    pond.UpgradeStatus = (function() {

        /**
         * Properties of an UpgradeStatus.
         * @memberof pond
         * @interface IUpgradeStatus
         * @property {pond.UpgradeChannel|null} [channel] UpgradeStatus channel
         * @property {pond.DevicePlatform|null} [platform] UpgradeStatus platform
         * @property {string|null} [progress] UpgradeStatus progress
         * @property {string|null} [started] UpgradeStatus started
         * @property {string|null} [changed] UpgradeStatus changed
         * @property {string|null} [stopped] UpgradeStatus stopped
         * @property {number|null} [offset] UpgradeStatus offset
         * @property {number|null} [size] UpgradeStatus size
         * @property {string|null} [fromVersion] UpgradeStatus fromVersion
         */

        /**
         * Constructs a new UpgradeStatus.
         * @memberof pond
         * @classdesc Represents an UpgradeStatus.
         * @implements IUpgradeStatus
         * @constructor
         * @param {pond.IUpgradeStatus=} [properties] Properties to set
         */
        function UpgradeStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpgradeStatus channel.
         * @member {pond.UpgradeChannel} channel
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.channel = 0;

        /**
         * UpgradeStatus platform.
         * @member {pond.DevicePlatform} platform
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.platform = 0;

        /**
         * UpgradeStatus progress.
         * @member {string} progress
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.progress = "";

        /**
         * UpgradeStatus started.
         * @member {string} started
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.started = "";

        /**
         * UpgradeStatus changed.
         * @member {string} changed
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.changed = "";

        /**
         * UpgradeStatus stopped.
         * @member {string} stopped
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.stopped = "";

        /**
         * UpgradeStatus offset.
         * @member {number} offset
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpgradeStatus size.
         * @member {number} size
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UpgradeStatus fromVersion.
         * @member {string} fromVersion
         * @memberof pond.UpgradeStatus
         * @instance
         */
        UpgradeStatus.prototype.fromVersion = "";

        /**
         * Creates a new UpgradeStatus instance using the specified properties.
         * @function create
         * @memberof pond.UpgradeStatus
         * @static
         * @param {pond.IUpgradeStatus=} [properties] Properties to set
         * @returns {pond.UpgradeStatus} UpgradeStatus instance
         */
        UpgradeStatus.create = function create(properties) {
            return new UpgradeStatus(properties);
        };

        /**
         * Creates an UpgradeStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpgradeStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpgradeStatus} UpgradeStatus
         */
        UpgradeStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpgradeStatus)
                return object;
            var message = new $root.pond.UpgradeStatus();
            switch (object.channel) {
            case "UPGRADE_CHANNEL_INVALID":
            case 0:
                message.channel = 0;
                break;
            case "UPGRADE_CHANNEL_DEVELOPMENT":
            case 1:
                message.channel = 1;
                break;
            case "UPGRADE_CHANNEL_ALPHA":
            case 2:
                message.channel = 2;
                break;
            case "UPGRADE_CHANNEL_BETA":
            case 3:
                message.channel = 3;
                break;
            case "UPGRADE_CHANNEL_STABLE":
            case 4:
                message.channel = 4;
                break;
            case "UPGRADE_CHANNEL_RECOVERY":
            case 5:
                message.channel = 5;
                break;
            }
            switch (object.platform) {
            case "DEVICE_PLATFORM_INVALID":
            case 0:
                message.platform = 0;
                break;
            case "DEVICE_PLATFORM_PHOTON":
            case 1:
                message.platform = 1;
                break;
            case "DEVICE_PLATFORM_ELECTRON":
            case 2:
                message.platform = 2;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR":
            case 3:
                message.platform = 3;
                break;
            case "DEVICE_PLATFORM_V2_WIFI":
            case 4:
                message.platform = 4;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_S3":
            case 5:
                message.platform = 5;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_S3":
            case 6:
                message.platform = 6;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLACK":
            case 7:
                message.platform = 7;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_GREEN":
            case 8:
                message.platform = 8;
                break;
            case "DEVICE_PLATFORM_V2_WIFI_BLUE":
            case 9:
                message.platform = 9;
                break;
            case "DEVICE_PLATFORM_V2_CELLULAR_BLUE":
            case 10:
                message.platform = 10;
                break;
            }
            if (object.progress != null)
                message.progress = String(object.progress);
            if (object.started != null)
                message.started = String(object.started);
            if (object.changed != null)
                message.changed = String(object.changed);
            if (object.stopped != null)
                message.stopped = String(object.stopped);
            if (object.offset != null)
                if ($util.Long)
                    (message.offset = $util.Long.fromValue(object.offset)).unsigned = true;
                else if (typeof object.offset === "string")
                    message.offset = parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.fromVersion != null)
                message.fromVersion = String(object.fromVersion);
            return message;
        };

        /**
         * Creates a plain object from an UpgradeStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpgradeStatus
         * @static
         * @param {pond.UpgradeStatus} message UpgradeStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpgradeStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.channel = options.enums === String ? "UPGRADE_CHANNEL_INVALID" : 0;
                object.platform = options.enums === String ? "DEVICE_PLATFORM_INVALID" : 0;
                object.progress = "";
                object.started = "";
                object.changed = "";
                object.stopped = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.offset = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.offset = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.fromVersion = "";
            }
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = options.enums === String ? $root.pond.UpgradeChannel[message.channel] : message.channel;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = options.enums === String ? $root.pond.DevicePlatform[message.platform] : message.platform;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            if (message.started != null && message.hasOwnProperty("started"))
                object.started = message.started;
            if (message.changed != null && message.hasOwnProperty("changed"))
                object.changed = message.changed;
            if (message.stopped != null && message.hasOwnProperty("stopped"))
                object.stopped = message.stopped;
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (typeof message.offset === "number")
                    object.offset = options.longs === String ? String(message.offset) : message.offset;
                else
                    object.offset = options.longs === String ? $util.Long.prototype.toString.call(message.offset) : options.longs === Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
                object.fromVersion = message.fromVersion;
            return object;
        };

        /**
         * Converts this UpgradeStatus to JSON.
         * @function toJSON
         * @memberof pond.UpgradeStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpgradeStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpgradeStatus;
    })();

    pond.GetUpgradeRequest = (function() {

        /**
         * Properties of a GetUpgradeRequest.
         * @memberof pond
         * @interface IGetUpgradeRequest
         * @property {string|null} [key] GetUpgradeRequest key
         */

        /**
         * Constructs a new GetUpgradeRequest.
         * @memberof pond
         * @classdesc Represents a GetUpgradeRequest.
         * @implements IGetUpgradeRequest
         * @constructor
         * @param {pond.IGetUpgradeRequest=} [properties] Properties to set
         */
        function GetUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUpgradeRequest key.
         * @member {string} key
         * @memberof pond.GetUpgradeRequest
         * @instance
         */
        GetUpgradeRequest.prototype.key = "";

        /**
         * Creates a new GetUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetUpgradeRequest
         * @static
         * @param {pond.IGetUpgradeRequest=} [properties] Properties to set
         * @returns {pond.GetUpgradeRequest} GetUpgradeRequest instance
         */
        GetUpgradeRequest.create = function create(properties) {
            return new GetUpgradeRequest(properties);
        };

        /**
         * Creates a GetUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUpgradeRequest} GetUpgradeRequest
         */
        GetUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUpgradeRequest)
                return object;
            var message = new $root.pond.GetUpgradeRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUpgradeRequest
         * @static
         * @param {pond.GetUpgradeRequest} message GetUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.GetUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUpgradeRequest;
    })();

    pond.Upgrade = (function() {

        /**
         * Properties of an Upgrade.
         * @memberof pond
         * @interface IUpgrade
         * @property {pond.UpgradeSettings|null} [settings] Upgrade settings
         * @property {pond.UpgradeStatus|null} [status] Upgrade status
         */

        /**
         * Constructs a new Upgrade.
         * @memberof pond
         * @classdesc Represents an Upgrade.
         * @implements IUpgrade
         * @constructor
         * @param {pond.IUpgrade=} [properties] Properties to set
         */
        function Upgrade(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Upgrade settings.
         * @member {pond.UpgradeSettings|null|undefined} settings
         * @memberof pond.Upgrade
         * @instance
         */
        Upgrade.prototype.settings = null;

        /**
         * Upgrade status.
         * @member {pond.UpgradeStatus|null|undefined} status
         * @memberof pond.Upgrade
         * @instance
         */
        Upgrade.prototype.status = null;

        /**
         * Creates a new Upgrade instance using the specified properties.
         * @function create
         * @memberof pond.Upgrade
         * @static
         * @param {pond.IUpgrade=} [properties] Properties to set
         * @returns {pond.Upgrade} Upgrade instance
         */
        Upgrade.create = function create(properties) {
            return new Upgrade(properties);
        };

        /**
         * Creates an Upgrade message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Upgrade
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Upgrade} Upgrade
         */
        Upgrade.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Upgrade)
                return object;
            var message = new $root.pond.Upgrade();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Upgrade.settings: object expected");
                message.settings = $root.pond.UpgradeSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Upgrade.status: object expected");
                message.status = $root.pond.UpgradeStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an Upgrade message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Upgrade
         * @static
         * @param {pond.Upgrade} message Upgrade
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Upgrade.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UpgradeSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.UpgradeStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Upgrade to JSON.
         * @function toJSON
         * @memberof pond.Upgrade
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Upgrade.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Upgrade;
    })();

    pond.LatestUpgradeRequest = (function() {

        /**
         * Properties of a LatestUpgradeRequest.
         * @memberof pond
         * @interface ILatestUpgradeRequest
         * @property {number|null} [device] LatestUpgradeRequest device
         */

        /**
         * Constructs a new LatestUpgradeRequest.
         * @memberof pond
         * @classdesc Represents a LatestUpgradeRequest.
         * @implements ILatestUpgradeRequest
         * @constructor
         * @param {pond.ILatestUpgradeRequest=} [properties] Properties to set
         */
        function LatestUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LatestUpgradeRequest device.
         * @member {number} device
         * @memberof pond.LatestUpgradeRequest
         * @instance
         */
        LatestUpgradeRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new LatestUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.LatestUpgradeRequest
         * @static
         * @param {pond.ILatestUpgradeRequest=} [properties] Properties to set
         * @returns {pond.LatestUpgradeRequest} LatestUpgradeRequest instance
         */
        LatestUpgradeRequest.create = function create(properties) {
            return new LatestUpgradeRequest(properties);
        };

        /**
         * Creates a LatestUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LatestUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LatestUpgradeRequest} LatestUpgradeRequest
         */
        LatestUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LatestUpgradeRequest)
                return object;
            var message = new $root.pond.LatestUpgradeRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a LatestUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LatestUpgradeRequest
         * @static
         * @param {pond.LatestUpgradeRequest} message LatestUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LatestUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this LatestUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.LatestUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LatestUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LatestUpgradeRequest;
    })();

    pond.LatestUpgradeResponse = (function() {

        /**
         * Properties of a LatestUpgradeResponse.
         * @memberof pond
         * @interface ILatestUpgradeResponse
         * @property {pond.Upgrade|null} [upgrade] LatestUpgradeResponse upgrade
         */

        /**
         * Constructs a new LatestUpgradeResponse.
         * @memberof pond
         * @classdesc Represents a LatestUpgradeResponse.
         * @implements ILatestUpgradeResponse
         * @constructor
         * @param {pond.ILatestUpgradeResponse=} [properties] Properties to set
         */
        function LatestUpgradeResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LatestUpgradeResponse upgrade.
         * @member {pond.Upgrade|null|undefined} upgrade
         * @memberof pond.LatestUpgradeResponse
         * @instance
         */
        LatestUpgradeResponse.prototype.upgrade = null;

        /**
         * Creates a new LatestUpgradeResponse instance using the specified properties.
         * @function create
         * @memberof pond.LatestUpgradeResponse
         * @static
         * @param {pond.ILatestUpgradeResponse=} [properties] Properties to set
         * @returns {pond.LatestUpgradeResponse} LatestUpgradeResponse instance
         */
        LatestUpgradeResponse.create = function create(properties) {
            return new LatestUpgradeResponse(properties);
        };

        /**
         * Creates a LatestUpgradeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LatestUpgradeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LatestUpgradeResponse} LatestUpgradeResponse
         */
        LatestUpgradeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LatestUpgradeResponse)
                return object;
            var message = new $root.pond.LatestUpgradeResponse();
            if (object.upgrade != null) {
                if (typeof object.upgrade !== "object")
                    throw TypeError(".pond.LatestUpgradeResponse.upgrade: object expected");
                message.upgrade = $root.pond.Upgrade.fromObject(object.upgrade);
            }
            return message;
        };

        /**
         * Creates a plain object from a LatestUpgradeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LatestUpgradeResponse
         * @static
         * @param {pond.LatestUpgradeResponse} message LatestUpgradeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LatestUpgradeResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.upgrade = null;
            if (message.upgrade != null && message.hasOwnProperty("upgrade"))
                object.upgrade = $root.pond.Upgrade.toObject(message.upgrade, options);
            return object;
        };

        /**
         * Converts this LatestUpgradeResponse to JSON.
         * @function toJSON
         * @memberof pond.LatestUpgradeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LatestUpgradeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LatestUpgradeResponse;
    })();

    pond.ListUpgradesRequest = (function() {

        /**
         * Properties of a ListUpgradesRequest.
         * @memberof pond
         * @interface IListUpgradesRequest
         * @property {pond.UpgradeSettings|null} [settingsMatch] ListUpgradesRequest settingsMatch
         * @property {pond.UpgradeStatus|null} [statusMatch] ListUpgradesRequest statusMatch
         */

        /**
         * Constructs a new ListUpgradesRequest.
         * @memberof pond
         * @classdesc Represents a ListUpgradesRequest.
         * @implements IListUpgradesRequest
         * @constructor
         * @param {pond.IListUpgradesRequest=} [properties] Properties to set
         */
        function ListUpgradesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUpgradesRequest settingsMatch.
         * @member {pond.UpgradeSettings|null|undefined} settingsMatch
         * @memberof pond.ListUpgradesRequest
         * @instance
         */
        ListUpgradesRequest.prototype.settingsMatch = null;

        /**
         * ListUpgradesRequest statusMatch.
         * @member {pond.UpgradeStatus|null|undefined} statusMatch
         * @memberof pond.ListUpgradesRequest
         * @instance
         */
        ListUpgradesRequest.prototype.statusMatch = null;

        /**
         * Creates a new ListUpgradesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListUpgradesRequest
         * @static
         * @param {pond.IListUpgradesRequest=} [properties] Properties to set
         * @returns {pond.ListUpgradesRequest} ListUpgradesRequest instance
         */
        ListUpgradesRequest.create = function create(properties) {
            return new ListUpgradesRequest(properties);
        };

        /**
         * Creates a ListUpgradesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUpgradesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUpgradesRequest} ListUpgradesRequest
         */
        ListUpgradesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUpgradesRequest)
                return object;
            var message = new $root.pond.ListUpgradesRequest();
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListUpgradesRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.UpgradeSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListUpgradesRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.UpgradeStatus.fromObject(object.statusMatch);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListUpgradesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUpgradesRequest
         * @static
         * @param {pond.ListUpgradesRequest} message ListUpgradesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUpgradesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.UpgradeSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.UpgradeStatus.toObject(message.statusMatch, options);
            return object;
        };

        /**
         * Converts this ListUpgradesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListUpgradesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUpgradesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUpgradesRequest;
    })();

    pond.ListUpgradesResponse = (function() {

        /**
         * Properties of a ListUpgradesResponse.
         * @memberof pond
         * @interface IListUpgradesResponse
         * @property {Array.<pond.Upgrade>|null} [upgrades] ListUpgradesResponse upgrades
         */

        /**
         * Constructs a new ListUpgradesResponse.
         * @memberof pond
         * @classdesc Represents a ListUpgradesResponse.
         * @implements IListUpgradesResponse
         * @constructor
         * @param {pond.IListUpgradesResponse=} [properties] Properties to set
         */
        function ListUpgradesResponse(properties) {
            this.upgrades = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUpgradesResponse upgrades.
         * @member {Array.<pond.Upgrade>} upgrades
         * @memberof pond.ListUpgradesResponse
         * @instance
         */
        ListUpgradesResponse.prototype.upgrades = $util.emptyArray;

        /**
         * Creates a new ListUpgradesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListUpgradesResponse
         * @static
         * @param {pond.IListUpgradesResponse=} [properties] Properties to set
         * @returns {pond.ListUpgradesResponse} ListUpgradesResponse instance
         */
        ListUpgradesResponse.create = function create(properties) {
            return new ListUpgradesResponse(properties);
        };

        /**
         * Creates a ListUpgradesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUpgradesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUpgradesResponse} ListUpgradesResponse
         */
        ListUpgradesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUpgradesResponse)
                return object;
            var message = new $root.pond.ListUpgradesResponse();
            if (object.upgrades) {
                if (!Array.isArray(object.upgrades))
                    throw TypeError(".pond.ListUpgradesResponse.upgrades: array expected");
                message.upgrades = [];
                for (var i = 0; i < object.upgrades.length; ++i) {
                    if (typeof object.upgrades[i] !== "object")
                        throw TypeError(".pond.ListUpgradesResponse.upgrades: object expected");
                    message.upgrades[i] = $root.pond.Upgrade.fromObject(object.upgrades[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListUpgradesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUpgradesResponse
         * @static
         * @param {pond.ListUpgradesResponse} message ListUpgradesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUpgradesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.upgrades = [];
            if (message.upgrades && message.upgrades.length) {
                object.upgrades = [];
                for (var j = 0; j < message.upgrades.length; ++j)
                    object.upgrades[j] = $root.pond.Upgrade.toObject(message.upgrades[j], options);
            }
            return object;
        };

        /**
         * Converts this ListUpgradesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListUpgradesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUpgradesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUpgradesResponse;
    })();

    pond.AddUpgradeRequest = (function() {

        /**
         * Properties of an AddUpgradeRequest.
         * @memberof pond
         * @interface IAddUpgradeRequest
         * @property {pond.UpgradeSettings|null} [settings] AddUpgradeRequest settings
         * @property {pond.UpgradeStatus|null} [status] AddUpgradeRequest status
         */

        /**
         * Constructs a new AddUpgradeRequest.
         * @memberof pond
         * @classdesc Represents an AddUpgradeRequest.
         * @implements IAddUpgradeRequest
         * @constructor
         * @param {pond.IAddUpgradeRequest=} [properties] Properties to set
         */
        function AddUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUpgradeRequest settings.
         * @member {pond.UpgradeSettings|null|undefined} settings
         * @memberof pond.AddUpgradeRequest
         * @instance
         */
        AddUpgradeRequest.prototype.settings = null;

        /**
         * AddUpgradeRequest status.
         * @member {pond.UpgradeStatus|null|undefined} status
         * @memberof pond.AddUpgradeRequest
         * @instance
         */
        AddUpgradeRequest.prototype.status = null;

        /**
         * Creates a new AddUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddUpgradeRequest
         * @static
         * @param {pond.IAddUpgradeRequest=} [properties] Properties to set
         * @returns {pond.AddUpgradeRequest} AddUpgradeRequest instance
         */
        AddUpgradeRequest.create = function create(properties) {
            return new AddUpgradeRequest(properties);
        };

        /**
         * Creates an AddUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddUpgradeRequest} AddUpgradeRequest
         */
        AddUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddUpgradeRequest)
                return object;
            var message = new $root.pond.AddUpgradeRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddUpgradeRequest.settings: object expected");
                message.settings = $root.pond.UpgradeSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.AddUpgradeRequest.status: object expected");
                message.status = $root.pond.UpgradeStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddUpgradeRequest
         * @static
         * @param {pond.AddUpgradeRequest} message AddUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UpgradeSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.UpgradeStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this AddUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.AddUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUpgradeRequest;
    })();

    pond.AddUpgradeResponse = (function() {

        /**
         * Properties of an AddUpgradeResponse.
         * @memberof pond
         * @interface IAddUpgradeResponse
         * @property {string|null} [key] AddUpgradeResponse key
         */

        /**
         * Constructs a new AddUpgradeResponse.
         * @memberof pond
         * @classdesc Represents an AddUpgradeResponse.
         * @implements IAddUpgradeResponse
         * @constructor
         * @param {pond.IAddUpgradeResponse=} [properties] Properties to set
         */
        function AddUpgradeResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUpgradeResponse key.
         * @member {string} key
         * @memberof pond.AddUpgradeResponse
         * @instance
         */
        AddUpgradeResponse.prototype.key = "";

        /**
         * Creates a new AddUpgradeResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddUpgradeResponse
         * @static
         * @param {pond.IAddUpgradeResponse=} [properties] Properties to set
         * @returns {pond.AddUpgradeResponse} AddUpgradeResponse instance
         */
        AddUpgradeResponse.create = function create(properties) {
            return new AddUpgradeResponse(properties);
        };

        /**
         * Creates an AddUpgradeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddUpgradeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddUpgradeResponse} AddUpgradeResponse
         */
        AddUpgradeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddUpgradeResponse)
                return object;
            var message = new $root.pond.AddUpgradeResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddUpgradeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddUpgradeResponse
         * @static
         * @param {pond.AddUpgradeResponse} message AddUpgradeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUpgradeResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddUpgradeResponse to JSON.
         * @function toJSON
         * @memberof pond.AddUpgradeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUpgradeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUpgradeResponse;
    })();

    pond.UpdateUpgradeRequest = (function() {

        /**
         * Properties of an UpdateUpgradeRequest.
         * @memberof pond
         * @interface IUpdateUpgradeRequest
         * @property {pond.UpgradeSettings|null} [settings] UpdateUpgradeRequest settings
         * @property {pond.UpgradeStatus|null} [status] UpdateUpgradeRequest status
         */

        /**
         * Constructs a new UpdateUpgradeRequest.
         * @memberof pond
         * @classdesc Represents an UpdateUpgradeRequest.
         * @implements IUpdateUpgradeRequest
         * @constructor
         * @param {pond.IUpdateUpgradeRequest=} [properties] Properties to set
         */
        function UpdateUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUpgradeRequest settings.
         * @member {pond.UpgradeSettings|null|undefined} settings
         * @memberof pond.UpdateUpgradeRequest
         * @instance
         */
        UpdateUpgradeRequest.prototype.settings = null;

        /**
         * UpdateUpgradeRequest status.
         * @member {pond.UpgradeStatus|null|undefined} status
         * @memberof pond.UpdateUpgradeRequest
         * @instance
         */
        UpdateUpgradeRequest.prototype.status = null;

        /**
         * Creates a new UpdateUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateUpgradeRequest
         * @static
         * @param {pond.IUpdateUpgradeRequest=} [properties] Properties to set
         * @returns {pond.UpdateUpgradeRequest} UpdateUpgradeRequest instance
         */
        UpdateUpgradeRequest.create = function create(properties) {
            return new UpdateUpgradeRequest(properties);
        };

        /**
         * Creates an UpdateUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateUpgradeRequest} UpdateUpgradeRequest
         */
        UpdateUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateUpgradeRequest)
                return object;
            var message = new $root.pond.UpdateUpgradeRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateUpgradeRequest.settings: object expected");
                message.settings = $root.pond.UpgradeSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.UpdateUpgradeRequest.status: object expected");
                message.status = $root.pond.UpgradeStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateUpgradeRequest
         * @static
         * @param {pond.UpdateUpgradeRequest} message UpdateUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UpgradeSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.UpgradeStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this UpdateUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUpgradeRequest;
    })();

    pond.UpdateUpgradeResponse = (function() {

        /**
         * Properties of an UpdateUpgradeResponse.
         * @memberof pond
         * @interface IUpdateUpgradeResponse
         */

        /**
         * Constructs a new UpdateUpgradeResponse.
         * @memberof pond
         * @classdesc Represents an UpdateUpgradeResponse.
         * @implements IUpdateUpgradeResponse
         * @constructor
         * @param {pond.IUpdateUpgradeResponse=} [properties] Properties to set
         */
        function UpdateUpgradeResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateUpgradeResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateUpgradeResponse
         * @static
         * @param {pond.IUpdateUpgradeResponse=} [properties] Properties to set
         * @returns {pond.UpdateUpgradeResponse} UpdateUpgradeResponse instance
         */
        UpdateUpgradeResponse.create = function create(properties) {
            return new UpdateUpgradeResponse(properties);
        };

        /**
         * Creates an UpdateUpgradeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateUpgradeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateUpgradeResponse} UpdateUpgradeResponse
         */
        UpdateUpgradeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateUpgradeResponse)
                return object;
            return new $root.pond.UpdateUpgradeResponse();
        };

        /**
         * Creates a plain object from an UpdateUpgradeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateUpgradeResponse
         * @static
         * @param {pond.UpdateUpgradeResponse} message UpdateUpgradeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUpgradeResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateUpgradeResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateUpgradeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUpgradeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUpgradeResponse;
    })();

    pond.RemoveUpgradeRequest = (function() {

        /**
         * Properties of a RemoveUpgradeRequest.
         * @memberof pond
         * @interface IRemoveUpgradeRequest
         * @property {string|null} [key] RemoveUpgradeRequest key
         */

        /**
         * Constructs a new RemoveUpgradeRequest.
         * @memberof pond
         * @classdesc Represents a RemoveUpgradeRequest.
         * @implements IRemoveUpgradeRequest
         * @constructor
         * @param {pond.IRemoveUpgradeRequest=} [properties] Properties to set
         */
        function RemoveUpgradeRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUpgradeRequest key.
         * @member {string} key
         * @memberof pond.RemoveUpgradeRequest
         * @instance
         */
        RemoveUpgradeRequest.prototype.key = "";

        /**
         * Creates a new RemoveUpgradeRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveUpgradeRequest
         * @static
         * @param {pond.IRemoveUpgradeRequest=} [properties] Properties to set
         * @returns {pond.RemoveUpgradeRequest} RemoveUpgradeRequest instance
         */
        RemoveUpgradeRequest.create = function create(properties) {
            return new RemoveUpgradeRequest(properties);
        };

        /**
         * Creates a RemoveUpgradeRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveUpgradeRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveUpgradeRequest} RemoveUpgradeRequest
         */
        RemoveUpgradeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveUpgradeRequest)
                return object;
            var message = new $root.pond.RemoveUpgradeRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUpgradeRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveUpgradeRequest
         * @static
         * @param {pond.RemoveUpgradeRequest} message RemoveUpgradeRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUpgradeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveUpgradeRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveUpgradeRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUpgradeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveUpgradeRequest;
    })();

    pond.RemoveUpgradeResponse = (function() {

        /**
         * Properties of a RemoveUpgradeResponse.
         * @memberof pond
         * @interface IRemoveUpgradeResponse
         */

        /**
         * Constructs a new RemoveUpgradeResponse.
         * @memberof pond
         * @classdesc Represents a RemoveUpgradeResponse.
         * @implements IRemoveUpgradeResponse
         * @constructor
         * @param {pond.IRemoveUpgradeResponse=} [properties] Properties to set
         */
        function RemoveUpgradeResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveUpgradeResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveUpgradeResponse
         * @static
         * @param {pond.IRemoveUpgradeResponse=} [properties] Properties to set
         * @returns {pond.RemoveUpgradeResponse} RemoveUpgradeResponse instance
         */
        RemoveUpgradeResponse.create = function create(properties) {
            return new RemoveUpgradeResponse(properties);
        };

        /**
         * Creates a RemoveUpgradeResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveUpgradeResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveUpgradeResponse} RemoveUpgradeResponse
         */
        RemoveUpgradeResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveUpgradeResponse)
                return object;
            return new $root.pond.RemoveUpgradeResponse();
        };

        /**
         * Creates a plain object from a RemoveUpgradeResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveUpgradeResponse
         * @static
         * @param {pond.RemoveUpgradeResponse} message RemoveUpgradeResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUpgradeResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveUpgradeResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveUpgradeResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUpgradeResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveUpgradeResponse;
    })();

    pond.GroupSettings = (function() {

        /**
         * Properties of a GroupSettings.
         * @memberof pond
         * @interface IGroupSettings
         * @property {number|null} [groupId] GroupSettings groupId
         * @property {string|null} [name] GroupSettings name
         * @property {string|null} [description] GroupSettings description
         * @property {Array.<number>|null} [devices] GroupSettings devices
         * @property {number|null} [longitude] GroupSettings longitude
         * @property {number|null} [latitude] GroupSettings latitude
         * @property {pond.ObjectTheme|null} [theme] GroupSettings theme
         */

        /**
         * Constructs a new GroupSettings.
         * @memberof pond
         * @classdesc Represents a GroupSettings.
         * @implements IGroupSettings
         * @constructor
         * @param {pond.IGroupSettings=} [properties] Properties to set
         */
        function GroupSettings(properties) {
            this.devices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GroupSettings groupId.
         * @member {number} groupId
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.groupId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GroupSettings name.
         * @member {string} name
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.name = "";

        /**
         * GroupSettings description.
         * @member {string} description
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.description = "";

        /**
         * GroupSettings devices.
         * @member {Array.<number>} devices
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.devices = $util.emptyArray;

        /**
         * GroupSettings longitude.
         * @member {number} longitude
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.longitude = 0;

        /**
         * GroupSettings latitude.
         * @member {number} latitude
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.latitude = 0;

        /**
         * GroupSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.GroupSettings
         * @instance
         */
        GroupSettings.prototype.theme = null;

        /**
         * Creates a new GroupSettings instance using the specified properties.
         * @function create
         * @memberof pond.GroupSettings
         * @static
         * @param {pond.IGroupSettings=} [properties] Properties to set
         * @returns {pond.GroupSettings} GroupSettings instance
         */
        GroupSettings.create = function create(properties) {
            return new GroupSettings(properties);
        };

        /**
         * Creates a GroupSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GroupSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GroupSettings} GroupSettings
         */
        GroupSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GroupSettings)
                return object;
            var message = new $root.pond.GroupSettings();
            if (object.groupId != null)
                if ($util.Long)
                    (message.groupId = $util.Long.fromValue(object.groupId)).unsigned = true;
                else if (typeof object.groupId === "string")
                    message.groupId = parseInt(object.groupId, 10);
                else if (typeof object.groupId === "number")
                    message.groupId = object.groupId;
                else if (typeof object.groupId === "object")
                    message.groupId = new $util.LongBits(object.groupId.low >>> 0, object.groupId.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GroupSettings.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i)
                    if ($util.Long)
                        (message.devices[i] = $util.Long.fromValue(object.devices[i])).unsigned = true;
                    else if (typeof object.devices[i] === "string")
                        message.devices[i] = parseInt(object.devices[i], 10);
                    else if (typeof object.devices[i] === "number")
                        message.devices[i] = object.devices[i];
                    else if (typeof object.devices[i] === "object")
                        message.devices[i] = new $util.LongBits(object.devices[i].low >>> 0, object.devices[i].high >>> 0).toNumber(true);
            }
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.GroupSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            return message;
        };

        /**
         * Creates a plain object from a GroupSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GroupSettings
         * @static
         * @param {pond.GroupSettings} message GroupSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.devices = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.groupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.groupId = options.longs === String ? "0" : 0;
                object.name = "";
                object.description = "";
                object.longitude = 0;
                object.latitude = 0;
                object.theme = null;
            }
            if (message.groupId != null && message.hasOwnProperty("groupId"))
                if (typeof message.groupId === "number")
                    object.groupId = options.longs === String ? String(message.groupId) : message.groupId;
                else
                    object.groupId = options.longs === String ? $util.Long.prototype.toString.call(message.groupId) : options.longs === Number ? new $util.LongBits(message.groupId.low >>> 0, message.groupId.high >>> 0).toNumber(true) : message.groupId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    if (typeof message.devices[j] === "number")
                        object.devices[j] = options.longs === String ? String(message.devices[j]) : message.devices[j];
                    else
                        object.devices[j] = options.longs === String ? $util.Long.prototype.toString.call(message.devices[j]) : options.longs === Number ? new $util.LongBits(message.devices[j].low >>> 0, message.devices[j].high >>> 0).toNumber(true) : message.devices[j];
            }
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            return object;
        };

        /**
         * Converts this GroupSettings to JSON.
         * @function toJSON
         * @memberof pond.GroupSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GroupSettings;
    })();

    pond.GroupStatus = (function() {

        /**
         * Properties of a GroupStatus.
         * @memberof pond
         * @interface IGroupStatus
         * @property {string|null} [lastActive] GroupStatus lastActive
         * @property {Array.<string>|null} [tagKeys] GroupStatus tagKeys
         * @property {Array.<string>|null} [tagNames] GroupStatus tagNames
         */

        /**
         * Constructs a new GroupStatus.
         * @memberof pond
         * @classdesc Represents a GroupStatus.
         * @implements IGroupStatus
         * @constructor
         * @param {pond.IGroupStatus=} [properties] Properties to set
         */
        function GroupStatus(properties) {
            this.tagKeys = [];
            this.tagNames = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GroupStatus lastActive.
         * @member {string} lastActive
         * @memberof pond.GroupStatus
         * @instance
         */
        GroupStatus.prototype.lastActive = "";

        /**
         * GroupStatus tagKeys.
         * @member {Array.<string>} tagKeys
         * @memberof pond.GroupStatus
         * @instance
         */
        GroupStatus.prototype.tagKeys = $util.emptyArray;

        /**
         * GroupStatus tagNames.
         * @member {Array.<string>} tagNames
         * @memberof pond.GroupStatus
         * @instance
         */
        GroupStatus.prototype.tagNames = $util.emptyArray;

        /**
         * Creates a new GroupStatus instance using the specified properties.
         * @function create
         * @memberof pond.GroupStatus
         * @static
         * @param {pond.IGroupStatus=} [properties] Properties to set
         * @returns {pond.GroupStatus} GroupStatus instance
         */
        GroupStatus.create = function create(properties) {
            return new GroupStatus(properties);
        };

        /**
         * Creates a GroupStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GroupStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GroupStatus} GroupStatus
         */
        GroupStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GroupStatus)
                return object;
            var message = new $root.pond.GroupStatus();
            if (object.lastActive != null)
                message.lastActive = String(object.lastActive);
            if (object.tagKeys) {
                if (!Array.isArray(object.tagKeys))
                    throw TypeError(".pond.GroupStatus.tagKeys: array expected");
                message.tagKeys = [];
                for (var i = 0; i < object.tagKeys.length; ++i)
                    message.tagKeys[i] = String(object.tagKeys[i]);
            }
            if (object.tagNames) {
                if (!Array.isArray(object.tagNames))
                    throw TypeError(".pond.GroupStatus.tagNames: array expected");
                message.tagNames = [];
                for (var i = 0; i < object.tagNames.length; ++i)
                    message.tagNames[i] = String(object.tagNames[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GroupStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GroupStatus
         * @static
         * @param {pond.GroupStatus} message GroupStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.tagKeys = [];
                object.tagNames = [];
            }
            if (options.defaults)
                object.lastActive = "";
            if (message.lastActive != null && message.hasOwnProperty("lastActive"))
                object.lastActive = message.lastActive;
            if (message.tagKeys && message.tagKeys.length) {
                object.tagKeys = [];
                for (var j = 0; j < message.tagKeys.length; ++j)
                    object.tagKeys[j] = message.tagKeys[j];
            }
            if (message.tagNames && message.tagNames.length) {
                object.tagNames = [];
                for (var j = 0; j < message.tagNames.length; ++j)
                    object.tagNames[j] = message.tagNames[j];
            }
            return object;
        };

        /**
         * Converts this GroupStatus to JSON.
         * @function toJSON
         * @memberof pond.GroupStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GroupStatus;
    })();

    pond.AddGroupRequest = (function() {

        /**
         * Properties of an AddGroupRequest.
         * @memberof pond
         * @interface IAddGroupRequest
         * @property {pond.GroupSettings|null} [group] AddGroupRequest group
         */

        /**
         * Constructs a new AddGroupRequest.
         * @memberof pond
         * @classdesc Represents an AddGroupRequest.
         * @implements IAddGroupRequest
         * @constructor
         * @param {pond.IAddGroupRequest=} [properties] Properties to set
         */
        function AddGroupRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGroupRequest group.
         * @member {pond.GroupSettings|null|undefined} group
         * @memberof pond.AddGroupRequest
         * @instance
         */
        AddGroupRequest.prototype.group = null;

        /**
         * Creates a new AddGroupRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddGroupRequest
         * @static
         * @param {pond.IAddGroupRequest=} [properties] Properties to set
         * @returns {pond.AddGroupRequest} AddGroupRequest instance
         */
        AddGroupRequest.create = function create(properties) {
            return new AddGroupRequest(properties);
        };

        /**
         * Creates an AddGroupRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGroupRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGroupRequest} AddGroupRequest
         */
        AddGroupRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGroupRequest)
                return object;
            var message = new $root.pond.AddGroupRequest();
            if (object.group != null) {
                if (typeof object.group !== "object")
                    throw TypeError(".pond.AddGroupRequest.group: object expected");
                message.group = $root.pond.GroupSettings.fromObject(object.group);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddGroupRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGroupRequest
         * @static
         * @param {pond.AddGroupRequest} message AddGroupRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGroupRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.group = null;
            if (message.group != null && message.hasOwnProperty("group"))
                object.group = $root.pond.GroupSettings.toObject(message.group, options);
            return object;
        };

        /**
         * Converts this AddGroupRequest to JSON.
         * @function toJSON
         * @memberof pond.AddGroupRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGroupRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGroupRequest;
    })();

    pond.AddGroupDeviceRequest = (function() {

        /**
         * Properties of an AddGroupDeviceRequest.
         * @memberof pond
         * @interface IAddGroupDeviceRequest
         * @property {number|null} [group] AddGroupDeviceRequest group
         * @property {number|null} [device] AddGroupDeviceRequest device
         */

        /**
         * Constructs a new AddGroupDeviceRequest.
         * @memberof pond
         * @classdesc Represents an AddGroupDeviceRequest.
         * @implements IAddGroupDeviceRequest
         * @constructor
         * @param {pond.IAddGroupDeviceRequest=} [properties] Properties to set
         */
        function AddGroupDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGroupDeviceRequest group.
         * @member {number} group
         * @memberof pond.AddGroupDeviceRequest
         * @instance
         */
        AddGroupDeviceRequest.prototype.group = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddGroupDeviceRequest device.
         * @member {number} device
         * @memberof pond.AddGroupDeviceRequest
         * @instance
         */
        AddGroupDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new AddGroupDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddGroupDeviceRequest
         * @static
         * @param {pond.IAddGroupDeviceRequest=} [properties] Properties to set
         * @returns {pond.AddGroupDeviceRequest} AddGroupDeviceRequest instance
         */
        AddGroupDeviceRequest.create = function create(properties) {
            return new AddGroupDeviceRequest(properties);
        };

        /**
         * Creates an AddGroupDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGroupDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGroupDeviceRequest} AddGroupDeviceRequest
         */
        AddGroupDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGroupDeviceRequest)
                return object;
            var message = new $root.pond.AddGroupDeviceRequest();
            if (object.group != null)
                if ($util.Long)
                    (message.group = $util.Long.fromValue(object.group)).unsigned = true;
                else if (typeof object.group === "string")
                    message.group = parseInt(object.group, 10);
                else if (typeof object.group === "number")
                    message.group = object.group;
                else if (typeof object.group === "object")
                    message.group = new $util.LongBits(object.group.low >>> 0, object.group.high >>> 0).toNumber(true);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an AddGroupDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGroupDeviceRequest
         * @static
         * @param {pond.AddGroupDeviceRequest} message AddGroupDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGroupDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.group = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.group != null && message.hasOwnProperty("group"))
                if (typeof message.group === "number")
                    object.group = options.longs === String ? String(message.group) : message.group;
                else
                    object.group = options.longs === String ? $util.Long.prototype.toString.call(message.group) : options.longs === Number ? new $util.LongBits(message.group.low >>> 0, message.group.high >>> 0).toNumber(true) : message.group;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this AddGroupDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.AddGroupDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGroupDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGroupDeviceRequest;
    })();

    pond.AddGroupDeviceResponse = (function() {

        /**
         * Properties of an AddGroupDeviceResponse.
         * @memberof pond
         * @interface IAddGroupDeviceResponse
         */

        /**
         * Constructs a new AddGroupDeviceResponse.
         * @memberof pond
         * @classdesc Represents an AddGroupDeviceResponse.
         * @implements IAddGroupDeviceResponse
         * @constructor
         * @param {pond.IAddGroupDeviceResponse=} [properties] Properties to set
         */
        function AddGroupDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddGroupDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddGroupDeviceResponse
         * @static
         * @param {pond.IAddGroupDeviceResponse=} [properties] Properties to set
         * @returns {pond.AddGroupDeviceResponse} AddGroupDeviceResponse instance
         */
        AddGroupDeviceResponse.create = function create(properties) {
            return new AddGroupDeviceResponse(properties);
        };

        /**
         * Creates an AddGroupDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGroupDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGroupDeviceResponse} AddGroupDeviceResponse
         */
        AddGroupDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGroupDeviceResponse)
                return object;
            return new $root.pond.AddGroupDeviceResponse();
        };

        /**
         * Creates a plain object from an AddGroupDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGroupDeviceResponse
         * @static
         * @param {pond.AddGroupDeviceResponse} message AddGroupDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGroupDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddGroupDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.AddGroupDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGroupDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGroupDeviceResponse;
    })();

    pond.RemoveGroupDeviceRequest = (function() {

        /**
         * Properties of a RemoveGroupDeviceRequest.
         * @memberof pond
         * @interface IRemoveGroupDeviceRequest
         * @property {number|null} [group] RemoveGroupDeviceRequest group
         * @property {number|null} [device] RemoveGroupDeviceRequest device
         */

        /**
         * Constructs a new RemoveGroupDeviceRequest.
         * @memberof pond
         * @classdesc Represents a RemoveGroupDeviceRequest.
         * @implements IRemoveGroupDeviceRequest
         * @constructor
         * @param {pond.IRemoveGroupDeviceRequest=} [properties] Properties to set
         */
        function RemoveGroupDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveGroupDeviceRequest group.
         * @member {number} group
         * @memberof pond.RemoveGroupDeviceRequest
         * @instance
         */
        RemoveGroupDeviceRequest.prototype.group = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RemoveGroupDeviceRequest device.
         * @member {number} device
         * @memberof pond.RemoveGroupDeviceRequest
         * @instance
         */
        RemoveGroupDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RemoveGroupDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGroupDeviceRequest
         * @static
         * @param {pond.IRemoveGroupDeviceRequest=} [properties] Properties to set
         * @returns {pond.RemoveGroupDeviceRequest} RemoveGroupDeviceRequest instance
         */
        RemoveGroupDeviceRequest.create = function create(properties) {
            return new RemoveGroupDeviceRequest(properties);
        };

        /**
         * Creates a RemoveGroupDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGroupDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGroupDeviceRequest} RemoveGroupDeviceRequest
         */
        RemoveGroupDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGroupDeviceRequest)
                return object;
            var message = new $root.pond.RemoveGroupDeviceRequest();
            if (object.group != null)
                if ($util.Long)
                    (message.group = $util.Long.fromValue(object.group)).unsigned = true;
                else if (typeof object.group === "string")
                    message.group = parseInt(object.group, 10);
                else if (typeof object.group === "number")
                    message.group = object.group;
                else if (typeof object.group === "object")
                    message.group = new $util.LongBits(object.group.low >>> 0, object.group.high >>> 0).toNumber(true);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RemoveGroupDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGroupDeviceRequest
         * @static
         * @param {pond.RemoveGroupDeviceRequest} message RemoveGroupDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGroupDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.group = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.group != null && message.hasOwnProperty("group"))
                if (typeof message.group === "number")
                    object.group = options.longs === String ? String(message.group) : message.group;
                else
                    object.group = options.longs === String ? $util.Long.prototype.toString.call(message.group) : options.longs === Number ? new $util.LongBits(message.group.low >>> 0, message.group.high >>> 0).toNumber(true) : message.group;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this RemoveGroupDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveGroupDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGroupDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGroupDeviceRequest;
    })();

    pond.RemoveGroupDeviceResponse = (function() {

        /**
         * Properties of a RemoveGroupDeviceResponse.
         * @memberof pond
         * @interface IRemoveGroupDeviceResponse
         */

        /**
         * Constructs a new RemoveGroupDeviceResponse.
         * @memberof pond
         * @classdesc Represents a RemoveGroupDeviceResponse.
         * @implements IRemoveGroupDeviceResponse
         * @constructor
         * @param {pond.IRemoveGroupDeviceResponse=} [properties] Properties to set
         */
        function RemoveGroupDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveGroupDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGroupDeviceResponse
         * @static
         * @param {pond.IRemoveGroupDeviceResponse=} [properties] Properties to set
         * @returns {pond.RemoveGroupDeviceResponse} RemoveGroupDeviceResponse instance
         */
        RemoveGroupDeviceResponse.create = function create(properties) {
            return new RemoveGroupDeviceResponse(properties);
        };

        /**
         * Creates a RemoveGroupDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGroupDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGroupDeviceResponse} RemoveGroupDeviceResponse
         */
        RemoveGroupDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGroupDeviceResponse)
                return object;
            return new $root.pond.RemoveGroupDeviceResponse();
        };

        /**
         * Creates a plain object from a RemoveGroupDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGroupDeviceResponse
         * @static
         * @param {pond.RemoveGroupDeviceResponse} message RemoveGroupDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGroupDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveGroupDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveGroupDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGroupDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGroupDeviceResponse;
    })();

    pond.AddGroupResponse = (function() {

        /**
         * Properties of an AddGroupResponse.
         * @memberof pond
         * @interface IAddGroupResponse
         * @property {number|null} [id] AddGroupResponse id
         */

        /**
         * Constructs a new AddGroupResponse.
         * @memberof pond
         * @classdesc Represents an AddGroupResponse.
         * @implements IAddGroupResponse
         * @constructor
         * @param {pond.IAddGroupResponse=} [properties] Properties to set
         */
        function AddGroupResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGroupResponse id.
         * @member {number} id
         * @memberof pond.AddGroupResponse
         * @instance
         */
        AddGroupResponse.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new AddGroupResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddGroupResponse
         * @static
         * @param {pond.IAddGroupResponse=} [properties] Properties to set
         * @returns {pond.AddGroupResponse} AddGroupResponse instance
         */
        AddGroupResponse.create = function create(properties) {
            return new AddGroupResponse(properties);
        };

        /**
         * Creates an AddGroupResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGroupResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGroupResponse} AddGroupResponse
         */
        AddGroupResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGroupResponse)
                return object;
            var message = new $root.pond.AddGroupResponse();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an AddGroupResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGroupResponse
         * @static
         * @param {pond.AddGroupResponse} message AddGroupResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGroupResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            return object;
        };

        /**
         * Converts this AddGroupResponse to JSON.
         * @function toJSON
         * @memberof pond.AddGroupResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGroupResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGroupResponse;
    })();

    pond.UpdateGroupRequest = (function() {

        /**
         * Properties of an UpdateGroupRequest.
         * @memberof pond
         * @interface IUpdateGroupRequest
         * @property {pond.GroupSettings|null} [group] UpdateGroupRequest group
         */

        /**
         * Constructs a new UpdateGroupRequest.
         * @memberof pond
         * @classdesc Represents an UpdateGroupRequest.
         * @implements IUpdateGroupRequest
         * @constructor
         * @param {pond.IUpdateGroupRequest=} [properties] Properties to set
         */
        function UpdateGroupRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGroupRequest group.
         * @member {pond.GroupSettings|null|undefined} group
         * @memberof pond.UpdateGroupRequest
         * @instance
         */
        UpdateGroupRequest.prototype.group = null;

        /**
         * Creates a new UpdateGroupRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGroupRequest
         * @static
         * @param {pond.IUpdateGroupRequest=} [properties] Properties to set
         * @returns {pond.UpdateGroupRequest} UpdateGroupRequest instance
         */
        UpdateGroupRequest.create = function create(properties) {
            return new UpdateGroupRequest(properties);
        };

        /**
         * Creates an UpdateGroupRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGroupRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGroupRequest} UpdateGroupRequest
         */
        UpdateGroupRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGroupRequest)
                return object;
            var message = new $root.pond.UpdateGroupRequest();
            if (object.group != null) {
                if (typeof object.group !== "object")
                    throw TypeError(".pond.UpdateGroupRequest.group: object expected");
                message.group = $root.pond.GroupSettings.fromObject(object.group);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateGroupRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGroupRequest
         * @static
         * @param {pond.UpdateGroupRequest} message UpdateGroupRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGroupRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.group = null;
            if (message.group != null && message.hasOwnProperty("group"))
                object.group = $root.pond.GroupSettings.toObject(message.group, options);
            return object;
        };

        /**
         * Converts this UpdateGroupRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateGroupRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGroupRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGroupRequest;
    })();

    pond.UpdateGroupResponse = (function() {

        /**
         * Properties of an UpdateGroupResponse.
         * @memberof pond
         * @interface IUpdateGroupResponse
         */

        /**
         * Constructs a new UpdateGroupResponse.
         * @memberof pond
         * @classdesc Represents an UpdateGroupResponse.
         * @implements IUpdateGroupResponse
         * @constructor
         * @param {pond.IUpdateGroupResponse=} [properties] Properties to set
         */
        function UpdateGroupResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGroupResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGroupResponse
         * @static
         * @param {pond.IUpdateGroupResponse=} [properties] Properties to set
         * @returns {pond.UpdateGroupResponse} UpdateGroupResponse instance
         */
        UpdateGroupResponse.create = function create(properties) {
            return new UpdateGroupResponse(properties);
        };

        /**
         * Creates an UpdateGroupResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGroupResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGroupResponse} UpdateGroupResponse
         */
        UpdateGroupResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGroupResponse)
                return object;
            return new $root.pond.UpdateGroupResponse();
        };

        /**
         * Creates a plain object from an UpdateGroupResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGroupResponse
         * @static
         * @param {pond.UpdateGroupResponse} message UpdateGroupResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGroupResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGroupResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateGroupResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGroupResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGroupResponse;
    })();

    pond.RemoveGroupRequest = (function() {

        /**
         * Properties of a RemoveGroupRequest.
         * @memberof pond
         * @interface IRemoveGroupRequest
         * @property {number|null} [group] RemoveGroupRequest group
         */

        /**
         * Constructs a new RemoveGroupRequest.
         * @memberof pond
         * @classdesc Represents a RemoveGroupRequest.
         * @implements IRemoveGroupRequest
         * @constructor
         * @param {pond.IRemoveGroupRequest=} [properties] Properties to set
         */
        function RemoveGroupRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveGroupRequest group.
         * @member {number} group
         * @memberof pond.RemoveGroupRequest
         * @instance
         */
        RemoveGroupRequest.prototype.group = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RemoveGroupRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGroupRequest
         * @static
         * @param {pond.IRemoveGroupRequest=} [properties] Properties to set
         * @returns {pond.RemoveGroupRequest} RemoveGroupRequest instance
         */
        RemoveGroupRequest.create = function create(properties) {
            return new RemoveGroupRequest(properties);
        };

        /**
         * Creates a RemoveGroupRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGroupRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGroupRequest} RemoveGroupRequest
         */
        RemoveGroupRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGroupRequest)
                return object;
            var message = new $root.pond.RemoveGroupRequest();
            if (object.group != null)
                if ($util.Long)
                    (message.group = $util.Long.fromValue(object.group)).unsigned = true;
                else if (typeof object.group === "string")
                    message.group = parseInt(object.group, 10);
                else if (typeof object.group === "number")
                    message.group = object.group;
                else if (typeof object.group === "object")
                    message.group = new $util.LongBits(object.group.low >>> 0, object.group.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RemoveGroupRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGroupRequest
         * @static
         * @param {pond.RemoveGroupRequest} message RemoveGroupRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGroupRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.group = options.longs === String ? "0" : 0;
            if (message.group != null && message.hasOwnProperty("group"))
                if (typeof message.group === "number")
                    object.group = options.longs === String ? String(message.group) : message.group;
                else
                    object.group = options.longs === String ? $util.Long.prototype.toString.call(message.group) : options.longs === Number ? new $util.LongBits(message.group.low >>> 0, message.group.high >>> 0).toNumber(true) : message.group;
            return object;
        };

        /**
         * Converts this RemoveGroupRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveGroupRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGroupRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGroupRequest;
    })();

    pond.RemoveGroupResponse = (function() {

        /**
         * Properties of a RemoveGroupResponse.
         * @memberof pond
         * @interface IRemoveGroupResponse
         */

        /**
         * Constructs a new RemoveGroupResponse.
         * @memberof pond
         * @classdesc Represents a RemoveGroupResponse.
         * @implements IRemoveGroupResponse
         * @constructor
         * @param {pond.IRemoveGroupResponse=} [properties] Properties to set
         */
        function RemoveGroupResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveGroupResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGroupResponse
         * @static
         * @param {pond.IRemoveGroupResponse=} [properties] Properties to set
         * @returns {pond.RemoveGroupResponse} RemoveGroupResponse instance
         */
        RemoveGroupResponse.create = function create(properties) {
            return new RemoveGroupResponse(properties);
        };

        /**
         * Creates a RemoveGroupResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGroupResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGroupResponse} RemoveGroupResponse
         */
        RemoveGroupResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGroupResponse)
                return object;
            return new $root.pond.RemoveGroupResponse();
        };

        /**
         * Creates a plain object from a RemoveGroupResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGroupResponse
         * @static
         * @param {pond.RemoveGroupResponse} message RemoveGroupResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGroupResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveGroupResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveGroupResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGroupResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGroupResponse;
    })();

    pond.GetGroupRequest = (function() {

        /**
         * Properties of a GetGroupRequest.
         * @memberof pond
         * @interface IGetGroupRequest
         * @property {number|null} [group] GetGroupRequest group
         */

        /**
         * Constructs a new GetGroupRequest.
         * @memberof pond
         * @classdesc Represents a GetGroupRequest.
         * @implements IGetGroupRequest
         * @constructor
         * @param {pond.IGetGroupRequest=} [properties] Properties to set
         */
        function GetGroupRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGroupRequest group.
         * @member {number} group
         * @memberof pond.GetGroupRequest
         * @instance
         */
        GetGroupRequest.prototype.group = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetGroupRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGroupRequest
         * @static
         * @param {pond.IGetGroupRequest=} [properties] Properties to set
         * @returns {pond.GetGroupRequest} GetGroupRequest instance
         */
        GetGroupRequest.create = function create(properties) {
            return new GetGroupRequest(properties);
        };

        /**
         * Creates a GetGroupRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGroupRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGroupRequest} GetGroupRequest
         */
        GetGroupRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGroupRequest)
                return object;
            var message = new $root.pond.GetGroupRequest();
            if (object.group != null)
                if ($util.Long)
                    (message.group = $util.Long.fromValue(object.group)).unsigned = true;
                else if (typeof object.group === "string")
                    message.group = parseInt(object.group, 10);
                else if (typeof object.group === "number")
                    message.group = object.group;
                else if (typeof object.group === "object")
                    message.group = new $util.LongBits(object.group.low >>> 0, object.group.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetGroupRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGroupRequest
         * @static
         * @param {pond.GetGroupRequest} message GetGroupRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGroupRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.group = options.longs === String ? "0" : 0;
            if (message.group != null && message.hasOwnProperty("group"))
                if (typeof message.group === "number")
                    object.group = options.longs === String ? String(message.group) : message.group;
                else
                    object.group = options.longs === String ? $util.Long.prototype.toString.call(message.group) : options.longs === Number ? new $util.LongBits(message.group.low >>> 0, message.group.high >>> 0).toNumber(true) : message.group;
            return object;
        };

        /**
         * Converts this GetGroupRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGroupRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGroupRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGroupRequest;
    })();

    pond.GetGroupAndPermissionsRequest = (function() {

        /**
         * Properties of a GetGroupAndPermissionsRequest.
         * @memberof pond
         * @interface IGetGroupAndPermissionsRequest
         * @property {number|null} [group] GetGroupAndPermissionsRequest group
         */

        /**
         * Constructs a new GetGroupAndPermissionsRequest.
         * @memberof pond
         * @classdesc Represents a GetGroupAndPermissionsRequest.
         * @implements IGetGroupAndPermissionsRequest
         * @constructor
         * @param {pond.IGetGroupAndPermissionsRequest=} [properties] Properties to set
         */
        function GetGroupAndPermissionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGroupAndPermissionsRequest group.
         * @member {number} group
         * @memberof pond.GetGroupAndPermissionsRequest
         * @instance
         */
        GetGroupAndPermissionsRequest.prototype.group = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetGroupAndPermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGroupAndPermissionsRequest
         * @static
         * @param {pond.IGetGroupAndPermissionsRequest=} [properties] Properties to set
         * @returns {pond.GetGroupAndPermissionsRequest} GetGroupAndPermissionsRequest instance
         */
        GetGroupAndPermissionsRequest.create = function create(properties) {
            return new GetGroupAndPermissionsRequest(properties);
        };

        /**
         * Creates a GetGroupAndPermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGroupAndPermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGroupAndPermissionsRequest} GetGroupAndPermissionsRequest
         */
        GetGroupAndPermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGroupAndPermissionsRequest)
                return object;
            var message = new $root.pond.GetGroupAndPermissionsRequest();
            if (object.group != null)
                if ($util.Long)
                    (message.group = $util.Long.fromValue(object.group)).unsigned = true;
                else if (typeof object.group === "string")
                    message.group = parseInt(object.group, 10);
                else if (typeof object.group === "number")
                    message.group = object.group;
                else if (typeof object.group === "object")
                    message.group = new $util.LongBits(object.group.low >>> 0, object.group.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetGroupAndPermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGroupAndPermissionsRequest
         * @static
         * @param {pond.GetGroupAndPermissionsRequest} message GetGroupAndPermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGroupAndPermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.group = options.longs === String ? "0" : 0;
            if (message.group != null && message.hasOwnProperty("group"))
                if (typeof message.group === "number")
                    object.group = options.longs === String ? String(message.group) : message.group;
                else
                    object.group = options.longs === String ? $util.Long.prototype.toString.call(message.group) : options.longs === Number ? new $util.LongBits(message.group.low >>> 0, message.group.high >>> 0).toNumber(true) : message.group;
            return object;
        };

        /**
         * Converts this GetGroupAndPermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGroupAndPermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGroupAndPermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGroupAndPermissionsRequest;
    })();

    pond.GetGroupAndPermissionsResponse = (function() {

        /**
         * Properties of a GetGroupAndPermissionsResponse.
         * @memberof pond
         * @interface IGetGroupAndPermissionsResponse
         * @property {pond.Group|null} [group] GetGroupAndPermissionsResponse group
         * @property {Array.<pond.Permission>|null} [permissions] GetGroupAndPermissionsResponse permissions
         */

        /**
         * Constructs a new GetGroupAndPermissionsResponse.
         * @memberof pond
         * @classdesc Represents a GetGroupAndPermissionsResponse.
         * @implements IGetGroupAndPermissionsResponse
         * @constructor
         * @param {pond.IGetGroupAndPermissionsResponse=} [properties] Properties to set
         */
        function GetGroupAndPermissionsResponse(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGroupAndPermissionsResponse group.
         * @member {pond.Group|null|undefined} group
         * @memberof pond.GetGroupAndPermissionsResponse
         * @instance
         */
        GetGroupAndPermissionsResponse.prototype.group = null;

        /**
         * GetGroupAndPermissionsResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.GetGroupAndPermissionsResponse
         * @instance
         */
        GetGroupAndPermissionsResponse.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new GetGroupAndPermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetGroupAndPermissionsResponse
         * @static
         * @param {pond.IGetGroupAndPermissionsResponse=} [properties] Properties to set
         * @returns {pond.GetGroupAndPermissionsResponse} GetGroupAndPermissionsResponse instance
         */
        GetGroupAndPermissionsResponse.create = function create(properties) {
            return new GetGroupAndPermissionsResponse(properties);
        };

        /**
         * Creates a GetGroupAndPermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGroupAndPermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGroupAndPermissionsResponse} GetGroupAndPermissionsResponse
         */
        GetGroupAndPermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGroupAndPermissionsResponse)
                return object;
            var message = new $root.pond.GetGroupAndPermissionsResponse();
            if (object.group != null) {
                if (typeof object.group !== "object")
                    throw TypeError(".pond.GetGroupAndPermissionsResponse.group: object expected");
                message.group = $root.pond.Group.fromObject(object.group);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GetGroupAndPermissionsResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetGroupAndPermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGroupAndPermissionsResponse
         * @static
         * @param {pond.GetGroupAndPermissionsResponse} message GetGroupAndPermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGroupAndPermissionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults)
                object.group = null;
            if (message.group != null && message.hasOwnProperty("group"))
                object.group = $root.pond.Group.toObject(message.group, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this GetGroupAndPermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetGroupAndPermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGroupAndPermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGroupAndPermissionsResponse;
    })();

    pond.Group = (function() {

        /**
         * Properties of a Group.
         * @memberof pond
         * @interface IGroup
         * @property {pond.GroupSettings|null} [settings] Group settings
         * @property {pond.GroupStatus|null} [status] Group status
         */

        /**
         * Constructs a new Group.
         * @memberof pond
         * @classdesc Represents a Group.
         * @implements IGroup
         * @constructor
         * @param {pond.IGroup=} [properties] Properties to set
         */
        function Group(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Group settings.
         * @member {pond.GroupSettings|null|undefined} settings
         * @memberof pond.Group
         * @instance
         */
        Group.prototype.settings = null;

        /**
         * Group status.
         * @member {pond.GroupStatus|null|undefined} status
         * @memberof pond.Group
         * @instance
         */
        Group.prototype.status = null;

        /**
         * Creates a new Group instance using the specified properties.
         * @function create
         * @memberof pond.Group
         * @static
         * @param {pond.IGroup=} [properties] Properties to set
         * @returns {pond.Group} Group instance
         */
        Group.create = function create(properties) {
            return new Group(properties);
        };

        /**
         * Creates a Group message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Group
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Group} Group
         */
        Group.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Group)
                return object;
            var message = new $root.pond.Group();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Group.settings: object expected");
                message.settings = $root.pond.GroupSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Group.status: object expected");
                message.status = $root.pond.GroupStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Group message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Group
         * @static
         * @param {pond.Group} message Group
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Group.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GroupSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.GroupStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Group to JSON.
         * @function toJSON
         * @memberof pond.Group
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Group.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Group;
    })();

    pond.ListGroupsRequest = (function() {

        /**
         * Properties of a ListGroupsRequest.
         * @memberof pond
         * @interface IListGroupsRequest
         * @property {pond.Paging|null} [paging] ListGroupsRequest paging
         * @property {pond.Sorting|null} [sorting] ListGroupsRequest sorting
         * @property {string|null} [search] ListGroupsRequest search
         * @property {pond.DeviceSettings|null} [settingsMatch] ListGroupsRequest settingsMatch
         * @property {pond.DeviceStatus|null} [statusMatch] ListGroupsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListGroupsRequest fieldContains
         * @property {boolean|null} [asRoot] ListGroupsRequest asRoot
         */

        /**
         * Constructs a new ListGroupsRequest.
         * @memberof pond
         * @classdesc Represents a ListGroupsRequest.
         * @implements IListGroupsRequest
         * @constructor
         * @param {pond.IListGroupsRequest=} [properties] Properties to set
         */
        function ListGroupsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGroupsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.paging = null;

        /**
         * ListGroupsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.sorting = null;

        /**
         * ListGroupsRequest search.
         * @member {string} search
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.search = "";

        /**
         * ListGroupsRequest settingsMatch.
         * @member {pond.DeviceSettings|null|undefined} settingsMatch
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.settingsMatch = null;

        /**
         * ListGroupsRequest statusMatch.
         * @member {pond.DeviceStatus|null|undefined} statusMatch
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.statusMatch = null;

        /**
         * ListGroupsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListGroupsRequest asRoot.
         * @member {boolean} asRoot
         * @memberof pond.ListGroupsRequest
         * @instance
         */
        ListGroupsRequest.prototype.asRoot = false;

        /**
         * Creates a new ListGroupsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGroupsRequest
         * @static
         * @param {pond.IListGroupsRequest=} [properties] Properties to set
         * @returns {pond.ListGroupsRequest} ListGroupsRequest instance
         */
        ListGroupsRequest.create = function create(properties) {
            return new ListGroupsRequest(properties);
        };

        /**
         * Creates a ListGroupsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGroupsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGroupsRequest} ListGroupsRequest
         */
        ListGroupsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGroupsRequest)
                return object;
            var message = new $root.pond.ListGroupsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListGroupsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListGroupsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListGroupsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.DeviceSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListGroupsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.DeviceStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListGroupsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.asRoot != null)
                message.asRoot = Boolean(object.asRoot);
            return message;
        };

        /**
         * Creates a plain object from a ListGroupsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGroupsRequest
         * @static
         * @param {pond.ListGroupsRequest} message ListGroupsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGroupsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
                object.asRoot = false;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.DeviceSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.DeviceStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.asRoot != null && message.hasOwnProperty("asRoot"))
                object.asRoot = message.asRoot;
            return object;
        };

        /**
         * Converts this ListGroupsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGroupsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGroupsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGroupsRequest;
    })();

    pond.ListGroupsResponse = (function() {

        /**
         * Properties of a ListGroupsResponse.
         * @memberof pond
         * @interface IListGroupsResponse
         * @property {Array.<pond.Group>|null} [groups] ListGroupsResponse groups
         * @property {number|null} [nextOffset] ListGroupsResponse nextOffset
         * @property {number|null} [total] ListGroupsResponse total
         */

        /**
         * Constructs a new ListGroupsResponse.
         * @memberof pond
         * @classdesc Represents a ListGroupsResponse.
         * @implements IListGroupsResponse
         * @constructor
         * @param {pond.IListGroupsResponse=} [properties] Properties to set
         */
        function ListGroupsResponse(properties) {
            this.groups = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGroupsResponse groups.
         * @member {Array.<pond.Group>} groups
         * @memberof pond.ListGroupsResponse
         * @instance
         */
        ListGroupsResponse.prototype.groups = $util.emptyArray;

        /**
         * ListGroupsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListGroupsResponse
         * @instance
         */
        ListGroupsResponse.prototype.nextOffset = 0;

        /**
         * ListGroupsResponse total.
         * @member {number} total
         * @memberof pond.ListGroupsResponse
         * @instance
         */
        ListGroupsResponse.prototype.total = 0;

        /**
         * Creates a new ListGroupsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGroupsResponse
         * @static
         * @param {pond.IListGroupsResponse=} [properties] Properties to set
         * @returns {pond.ListGroupsResponse} ListGroupsResponse instance
         */
        ListGroupsResponse.create = function create(properties) {
            return new ListGroupsResponse(properties);
        };

        /**
         * Creates a ListGroupsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGroupsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGroupsResponse} ListGroupsResponse
         */
        ListGroupsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGroupsResponse)
                return object;
            var message = new $root.pond.ListGroupsResponse();
            if (object.groups) {
                if (!Array.isArray(object.groups))
                    throw TypeError(".pond.ListGroupsResponse.groups: array expected");
                message.groups = [];
                for (var i = 0; i < object.groups.length; ++i) {
                    if (typeof object.groups[i] !== "object")
                        throw TypeError(".pond.ListGroupsResponse.groups: object expected");
                    message.groups[i] = $root.pond.Group.fromObject(object.groups[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListGroupsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGroupsResponse
         * @static
         * @param {pond.ListGroupsResponse} message ListGroupsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGroupsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.groups = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.groups && message.groups.length) {
                object.groups = [];
                for (var j = 0; j < message.groups.length; ++j)
                    object.groups[j] = $root.pond.Group.toObject(message.groups[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListGroupsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGroupsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGroupsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGroupsResponse;
    })();

    pond.Team = (function() {

        /**
         * Properties of a Team.
         * @memberof pond
         * @interface ITeam
         * @property {pond.TeamSettings|null} [settings] Team settings
         * @property {pond.TeamStatus|null} [status] Team status
         * @property {Array.<pond.Permission>|null} [permissions] Team permissions
         * @property {pond.TeamPreferences|null} [preferences] Team preferences
         */

        /**
         * Constructs a new Team.
         * @memberof pond
         * @classdesc Represents a Team.
         * @implements ITeam
         * @constructor
         * @param {pond.ITeam=} [properties] Properties to set
         */
        function Team(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team settings.
         * @member {pond.TeamSettings|null|undefined} settings
         * @memberof pond.Team
         * @instance
         */
        Team.prototype.settings = null;

        /**
         * Team status.
         * @member {pond.TeamStatus|null|undefined} status
         * @memberof pond.Team
         * @instance
         */
        Team.prototype.status = null;

        /**
         * Team permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.Team
         * @instance
         */
        Team.prototype.permissions = $util.emptyArray;

        /**
         * Team preferences.
         * @member {pond.TeamPreferences|null|undefined} preferences
         * @memberof pond.Team
         * @instance
         */
        Team.prototype.preferences = null;

        /**
         * Creates a new Team instance using the specified properties.
         * @function create
         * @memberof pond.Team
         * @static
         * @param {pond.ITeam=} [properties] Properties to set
         * @returns {pond.Team} Team instance
         */
        Team.create = function create(properties) {
            return new Team(properties);
        };

        /**
         * Creates a Team message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Team
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Team} Team
         */
        Team.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Team)
                return object;
            var message = new $root.pond.Team();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Team.settings: object expected");
                message.settings = $root.pond.TeamSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Team.status: object expected");
                message.status = $root.pond.TeamStatus.fromObject(object.status);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.Team.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.Team.preferences: object expected");
                message.preferences = $root.pond.TeamPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from a Team message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Team
         * @static
         * @param {pond.Team} message Team
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.settings = null;
                object.status = null;
                object.preferences = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TeamSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.TeamStatus.toObject(message.status, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.TeamPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this Team to JSON.
         * @function toJSON
         * @memberof pond.Team
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Team;
    })();

    pond.TeamSettings = (function() {

        /**
         * Properties of a TeamSettings.
         * @memberof pond
         * @interface ITeamSettings
         * @property {string|null} [name] TeamSettings name
         * @property {string|null} [info] TeamSettings info
         * @property {string|null} [owner] TeamSettings owner
         * @property {string|null} [avatar] TeamSettings avatar
         * @property {string|null} [key] TeamSettings key
         * @property {string|null} [lastChatTimestamp] TeamSettings lastChatTimestamp
         * @property {string|null} [stripeKey] TeamSettings stripeKey
         */

        /**
         * Constructs a new TeamSettings.
         * @memberof pond
         * @classdesc Represents a TeamSettings.
         * @implements ITeamSettings
         * @constructor
         * @param {pond.ITeamSettings=} [properties] Properties to set
         */
        function TeamSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TeamSettings name.
         * @member {string} name
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.name = "";

        /**
         * TeamSettings info.
         * @member {string} info
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.info = "";

        /**
         * TeamSettings owner.
         * @member {string} owner
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.owner = "";

        /**
         * TeamSettings avatar.
         * @member {string} avatar
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.avatar = "";

        /**
         * TeamSettings key.
         * @member {string} key
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.key = "";

        /**
         * TeamSettings lastChatTimestamp.
         * @member {string} lastChatTimestamp
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.lastChatTimestamp = "";

        /**
         * TeamSettings stripeKey.
         * @member {string} stripeKey
         * @memberof pond.TeamSettings
         * @instance
         */
        TeamSettings.prototype.stripeKey = "";

        /**
         * Creates a new TeamSettings instance using the specified properties.
         * @function create
         * @memberof pond.TeamSettings
         * @static
         * @param {pond.ITeamSettings=} [properties] Properties to set
         * @returns {pond.TeamSettings} TeamSettings instance
         */
        TeamSettings.create = function create(properties) {
            return new TeamSettings(properties);
        };

        /**
         * Creates a TeamSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TeamSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TeamSettings} TeamSettings
         */
        TeamSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TeamSettings)
                return object;
            var message = new $root.pond.TeamSettings();
            if (object.name != null)
                message.name = String(object.name);
            if (object.info != null)
                message.info = String(object.info);
            if (object.owner != null)
                message.owner = String(object.owner);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.key != null)
                message.key = String(object.key);
            if (object.lastChatTimestamp != null)
                message.lastChatTimestamp = String(object.lastChatTimestamp);
            if (object.stripeKey != null)
                message.stripeKey = String(object.stripeKey);
            return message;
        };

        /**
         * Creates a plain object from a TeamSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TeamSettings
         * @static
         * @param {pond.TeamSettings} message TeamSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TeamSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.info = "";
                object.owner = "";
                object.avatar = "";
                object.key = "";
                object.lastChatTimestamp = "";
                object.stripeKey = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.info != null && message.hasOwnProperty("info"))
                object.info = message.info;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = message.owner;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.lastChatTimestamp != null && message.hasOwnProperty("lastChatTimestamp"))
                object.lastChatTimestamp = message.lastChatTimestamp;
            if (message.stripeKey != null && message.hasOwnProperty("stripeKey"))
                object.stripeKey = message.stripeKey;
            return object;
        };

        /**
         * Converts this TeamSettings to JSON.
         * @function toJSON
         * @memberof pond.TeamSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TeamSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TeamSettings;
    })();

    pond.TeamStatus = (function() {

        /**
         * Properties of a TeamStatus.
         * @memberof pond
         * @interface ITeamStatus
         * @property {Array.<string>|null} [members] TeamStatus members
         * @property {Array.<string>|null} [tagKeys] TeamStatus tagKeys
         * @property {string|null} [lastNotifiedTimestamp] TeamStatus lastNotifiedTimestamp
         * @property {string|null} [lastNotificationViewed] TeamStatus lastNotificationViewed
         */

        /**
         * Constructs a new TeamStatus.
         * @memberof pond
         * @classdesc Represents a TeamStatus.
         * @implements ITeamStatus
         * @constructor
         * @param {pond.ITeamStatus=} [properties] Properties to set
         */
        function TeamStatus(properties) {
            this.members = [];
            this.tagKeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TeamStatus members.
         * @member {Array.<string>} members
         * @memberof pond.TeamStatus
         * @instance
         */
        TeamStatus.prototype.members = $util.emptyArray;

        /**
         * TeamStatus tagKeys.
         * @member {Array.<string>} tagKeys
         * @memberof pond.TeamStatus
         * @instance
         */
        TeamStatus.prototype.tagKeys = $util.emptyArray;

        /**
         * TeamStatus lastNotifiedTimestamp.
         * @member {string} lastNotifiedTimestamp
         * @memberof pond.TeamStatus
         * @instance
         */
        TeamStatus.prototype.lastNotifiedTimestamp = "";

        /**
         * TeamStatus lastNotificationViewed.
         * @member {string} lastNotificationViewed
         * @memberof pond.TeamStatus
         * @instance
         */
        TeamStatus.prototype.lastNotificationViewed = "";

        /**
         * Creates a new TeamStatus instance using the specified properties.
         * @function create
         * @memberof pond.TeamStatus
         * @static
         * @param {pond.ITeamStatus=} [properties] Properties to set
         * @returns {pond.TeamStatus} TeamStatus instance
         */
        TeamStatus.create = function create(properties) {
            return new TeamStatus(properties);
        };

        /**
         * Creates a TeamStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TeamStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TeamStatus} TeamStatus
         */
        TeamStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TeamStatus)
                return object;
            var message = new $root.pond.TeamStatus();
            if (object.members) {
                if (!Array.isArray(object.members))
                    throw TypeError(".pond.TeamStatus.members: array expected");
                message.members = [];
                for (var i = 0; i < object.members.length; ++i)
                    message.members[i] = String(object.members[i]);
            }
            if (object.tagKeys) {
                if (!Array.isArray(object.tagKeys))
                    throw TypeError(".pond.TeamStatus.tagKeys: array expected");
                message.tagKeys = [];
                for (var i = 0; i < object.tagKeys.length; ++i)
                    message.tagKeys[i] = String(object.tagKeys[i]);
            }
            if (object.lastNotifiedTimestamp != null)
                message.lastNotifiedTimestamp = String(object.lastNotifiedTimestamp);
            if (object.lastNotificationViewed != null)
                message.lastNotificationViewed = String(object.lastNotificationViewed);
            return message;
        };

        /**
         * Creates a plain object from a TeamStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TeamStatus
         * @static
         * @param {pond.TeamStatus} message TeamStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TeamStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.members = [];
                object.tagKeys = [];
            }
            if (options.defaults) {
                object.lastNotifiedTimestamp = "";
                object.lastNotificationViewed = "";
            }
            if (message.members && message.members.length) {
                object.members = [];
                for (var j = 0; j < message.members.length; ++j)
                    object.members[j] = message.members[j];
            }
            if (message.tagKeys && message.tagKeys.length) {
                object.tagKeys = [];
                for (var j = 0; j < message.tagKeys.length; ++j)
                    object.tagKeys[j] = message.tagKeys[j];
            }
            if (message.lastNotifiedTimestamp != null && message.hasOwnProperty("lastNotifiedTimestamp"))
                object.lastNotifiedTimestamp = message.lastNotifiedTimestamp;
            if (message.lastNotificationViewed != null && message.hasOwnProperty("lastNotificationViewed"))
                object.lastNotificationViewed = message.lastNotificationViewed;
            return object;
        };

        /**
         * Converts this TeamStatus to JSON.
         * @function toJSON
         * @memberof pond.TeamStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TeamStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TeamStatus;
    })();

    pond.TeamPreferences = (function() {

        /**
         * Properties of a TeamPreferences.
         * @memberof pond
         * @interface ITeamPreferences
         * @property {boolean|null} [notify] TeamPreferences notify
         * @property {string|null} [chatViewedTimestamp] TeamPreferences chatViewedTimestamp
         */

        /**
         * Constructs a new TeamPreferences.
         * @memberof pond
         * @classdesc Represents a TeamPreferences.
         * @implements ITeamPreferences
         * @constructor
         * @param {pond.ITeamPreferences=} [properties] Properties to set
         */
        function TeamPreferences(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TeamPreferences notify.
         * @member {boolean} notify
         * @memberof pond.TeamPreferences
         * @instance
         */
        TeamPreferences.prototype.notify = false;

        /**
         * TeamPreferences chatViewedTimestamp.
         * @member {string} chatViewedTimestamp
         * @memberof pond.TeamPreferences
         * @instance
         */
        TeamPreferences.prototype.chatViewedTimestamp = "";

        /**
         * Creates a new TeamPreferences instance using the specified properties.
         * @function create
         * @memberof pond.TeamPreferences
         * @static
         * @param {pond.ITeamPreferences=} [properties] Properties to set
         * @returns {pond.TeamPreferences} TeamPreferences instance
         */
        TeamPreferences.create = function create(properties) {
            return new TeamPreferences(properties);
        };

        /**
         * Creates a TeamPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TeamPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TeamPreferences} TeamPreferences
         */
        TeamPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TeamPreferences)
                return object;
            var message = new $root.pond.TeamPreferences();
            if (object.notify != null)
                message.notify = Boolean(object.notify);
            if (object.chatViewedTimestamp != null)
                message.chatViewedTimestamp = String(object.chatViewedTimestamp);
            return message;
        };

        /**
         * Creates a plain object from a TeamPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TeamPreferences
         * @static
         * @param {pond.TeamPreferences} message TeamPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TeamPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.notify = false;
                object.chatViewedTimestamp = "";
            }
            if (message.notify != null && message.hasOwnProperty("notify"))
                object.notify = message.notify;
            if (message.chatViewedTimestamp != null && message.hasOwnProperty("chatViewedTimestamp"))
                object.chatViewedTimestamp = message.chatViewedTimestamp;
            return object;
        };

        /**
         * Converts this TeamPreferences to JSON.
         * @function toJSON
         * @memberof pond.TeamPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TeamPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TeamPreferences;
    })();

    pond.GetTeamRequest = (function() {

        /**
         * Properties of a GetTeamRequest.
         * @memberof pond
         * @interface IGetTeamRequest
         * @property {string|null} [key] GetTeamRequest key
         * @property {string|null} [kind] GetTeamRequest kind
         * @property {string|null} [objectKey] GetTeamRequest objectKey
         */

        /**
         * Constructs a new GetTeamRequest.
         * @memberof pond
         * @classdesc Represents a GetTeamRequest.
         * @implements IGetTeamRequest
         * @constructor
         * @param {pond.IGetTeamRequest=} [properties] Properties to set
         */
        function GetTeamRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTeamRequest key.
         * @member {string} key
         * @memberof pond.GetTeamRequest
         * @instance
         */
        GetTeamRequest.prototype.key = "";

        /**
         * GetTeamRequest kind.
         * @member {string} kind
         * @memberof pond.GetTeamRequest
         * @instance
         */
        GetTeamRequest.prototype.kind = "";

        /**
         * GetTeamRequest objectKey.
         * @member {string} objectKey
         * @memberof pond.GetTeamRequest
         * @instance
         */
        GetTeamRequest.prototype.objectKey = "";

        /**
         * Creates a new GetTeamRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTeamRequest
         * @static
         * @param {pond.IGetTeamRequest=} [properties] Properties to set
         * @returns {pond.GetTeamRequest} GetTeamRequest instance
         */
        GetTeamRequest.create = function create(properties) {
            return new GetTeamRequest(properties);
        };

        /**
         * Creates a GetTeamRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTeamRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTeamRequest} GetTeamRequest
         */
        GetTeamRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTeamRequest)
                return object;
            var message = new $root.pond.GetTeamRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            return message;
        };

        /**
         * Creates a plain object from a GetTeamRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTeamRequest
         * @static
         * @param {pond.GetTeamRequest} message GetTeamRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTeamRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.kind = "";
                object.objectKey = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            return object;
        };

        /**
         * Converts this GetTeamRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTeamRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTeamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTeamRequest;
    })();

    pond.AddTeamRequest = (function() {

        /**
         * Properties of an AddTeamRequest.
         * @memberof pond
         * @interface IAddTeamRequest
         * @property {pond.TeamSettings|null} [team] AddTeamRequest team
         */

        /**
         * Constructs a new AddTeamRequest.
         * @memberof pond
         * @classdesc Represents an AddTeamRequest.
         * @implements IAddTeamRequest
         * @constructor
         * @param {pond.IAddTeamRequest=} [properties] Properties to set
         */
        function AddTeamRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTeamRequest team.
         * @member {pond.TeamSettings|null|undefined} team
         * @memberof pond.AddTeamRequest
         * @instance
         */
        AddTeamRequest.prototype.team = null;

        /**
         * Creates a new AddTeamRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddTeamRequest
         * @static
         * @param {pond.IAddTeamRequest=} [properties] Properties to set
         * @returns {pond.AddTeamRequest} AddTeamRequest instance
         */
        AddTeamRequest.create = function create(properties) {
            return new AddTeamRequest(properties);
        };

        /**
         * Creates an AddTeamRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTeamRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTeamRequest} AddTeamRequest
         */
        AddTeamRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTeamRequest)
                return object;
            var message = new $root.pond.AddTeamRequest();
            if (object.team != null) {
                if (typeof object.team !== "object")
                    throw TypeError(".pond.AddTeamRequest.team: object expected");
                message.team = $root.pond.TeamSettings.fromObject(object.team);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTeamRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTeamRequest
         * @static
         * @param {pond.AddTeamRequest} message AddTeamRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTeamRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.team = null;
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = $root.pond.TeamSettings.toObject(message.team, options);
            return object;
        };

        /**
         * Converts this AddTeamRequest to JSON.
         * @function toJSON
         * @memberof pond.AddTeamRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTeamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTeamRequest;
    })();

    pond.AddTeamResponse = (function() {

        /**
         * Properties of an AddTeamResponse.
         * @memberof pond
         * @interface IAddTeamResponse
         * @property {string|null} [team] AddTeamResponse team
         */

        /**
         * Constructs a new AddTeamResponse.
         * @memberof pond
         * @classdesc Represents an AddTeamResponse.
         * @implements IAddTeamResponse
         * @constructor
         * @param {pond.IAddTeamResponse=} [properties] Properties to set
         */
        function AddTeamResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTeamResponse team.
         * @member {string} team
         * @memberof pond.AddTeamResponse
         * @instance
         */
        AddTeamResponse.prototype.team = "";

        /**
         * Creates a new AddTeamResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddTeamResponse
         * @static
         * @param {pond.IAddTeamResponse=} [properties] Properties to set
         * @returns {pond.AddTeamResponse} AddTeamResponse instance
         */
        AddTeamResponse.create = function create(properties) {
            return new AddTeamResponse(properties);
        };

        /**
         * Creates an AddTeamResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTeamResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTeamResponse} AddTeamResponse
         */
        AddTeamResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTeamResponse)
                return object;
            var message = new $root.pond.AddTeamResponse();
            if (object.team != null)
                message.team = String(object.team);
            return message;
        };

        /**
         * Creates a plain object from an AddTeamResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTeamResponse
         * @static
         * @param {pond.AddTeamResponse} message AddTeamResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTeamResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.team = "";
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = message.team;
            return object;
        };

        /**
         * Converts this AddTeamResponse to JSON.
         * @function toJSON
         * @memberof pond.AddTeamResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTeamResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTeamResponse;
    })();

    pond.ListTeamsRequest = (function() {

        /**
         * Properties of a ListTeamsRequest.
         * @memberof pond
         * @interface IListTeamsRequest
         * @property {string|null} [key] ListTeamsRequest key
         * @property {string|null} [kind] ListTeamsRequest kind
         * @property {pond.Paging|null} [paging] ListTeamsRequest paging
         * @property {pond.Sorting|null} [sorting] ListTeamsRequest sorting
         * @property {string|null} [search] ListTeamsRequest search
         * @property {pond.TeamSettings|null} [settingsMatch] ListTeamsRequest settingsMatch
         * @property {pond.TeamStatus|null} [statusMatch] ListTeamsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListTeamsRequest fieldContains
         * @property {string|null} [prefixSearch] ListTeamsRequest prefixSearch
         */

        /**
         * Constructs a new ListTeamsRequest.
         * @memberof pond
         * @classdesc Represents a ListTeamsRequest.
         * @implements IListTeamsRequest
         * @constructor
         * @param {pond.IListTeamsRequest=} [properties] Properties to set
         */
        function ListTeamsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTeamsRequest key.
         * @member {string} key
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.key = "";

        /**
         * ListTeamsRequest kind.
         * @member {string} kind
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.kind = "";

        /**
         * ListTeamsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.paging = null;

        /**
         * ListTeamsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.sorting = null;

        /**
         * ListTeamsRequest search.
         * @member {string} search
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.search = "";

        /**
         * ListTeamsRequest settingsMatch.
         * @member {pond.TeamSettings|null|undefined} settingsMatch
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.settingsMatch = null;

        /**
         * ListTeamsRequest statusMatch.
         * @member {pond.TeamStatus|null|undefined} statusMatch
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.statusMatch = null;

        /**
         * ListTeamsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListTeamsRequest prefixSearch.
         * @member {string} prefixSearch
         * @memberof pond.ListTeamsRequest
         * @instance
         */
        ListTeamsRequest.prototype.prefixSearch = "";

        /**
         * Creates a new ListTeamsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListTeamsRequest
         * @static
         * @param {pond.IListTeamsRequest=} [properties] Properties to set
         * @returns {pond.ListTeamsRequest} ListTeamsRequest instance
         */
        ListTeamsRequest.create = function create(properties) {
            return new ListTeamsRequest(properties);
        };

        /**
         * Creates a ListTeamsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTeamsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTeamsRequest} ListTeamsRequest
         */
        ListTeamsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTeamsRequest)
                return object;
            var message = new $root.pond.ListTeamsRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListTeamsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListTeamsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListTeamsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.TeamSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListTeamsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.TeamStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListTeamsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.prefixSearch != null)
                message.prefixSearch = String(object.prefixSearch);
            return message;
        };

        /**
         * Creates a plain object from a ListTeamsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTeamsRequest
         * @static
         * @param {pond.ListTeamsRequest} message ListTeamsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTeamsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.kind = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
                object.prefixSearch = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.TeamSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.TeamStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.prefixSearch != null && message.hasOwnProperty("prefixSearch"))
                object.prefixSearch = message.prefixSearch;
            return object;
        };

        /**
         * Converts this ListTeamsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListTeamsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTeamsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTeamsRequest;
    })();

    pond.ListTeamsResponse = (function() {

        /**
         * Properties of a ListTeamsResponse.
         * @memberof pond
         * @interface IListTeamsResponse
         * @property {Array.<pond.Team>|null} [teams] ListTeamsResponse teams
         * @property {number|null} [nextOffset] ListTeamsResponse nextOffset
         * @property {number|null} [total] ListTeamsResponse total
         */

        /**
         * Constructs a new ListTeamsResponse.
         * @memberof pond
         * @classdesc Represents a ListTeamsResponse.
         * @implements IListTeamsResponse
         * @constructor
         * @param {pond.IListTeamsResponse=} [properties] Properties to set
         */
        function ListTeamsResponse(properties) {
            this.teams = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTeamsResponse teams.
         * @member {Array.<pond.Team>} teams
         * @memberof pond.ListTeamsResponse
         * @instance
         */
        ListTeamsResponse.prototype.teams = $util.emptyArray;

        /**
         * ListTeamsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListTeamsResponse
         * @instance
         */
        ListTeamsResponse.prototype.nextOffset = 0;

        /**
         * ListTeamsResponse total.
         * @member {number} total
         * @memberof pond.ListTeamsResponse
         * @instance
         */
        ListTeamsResponse.prototype.total = 0;

        /**
         * Creates a new ListTeamsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTeamsResponse
         * @static
         * @param {pond.IListTeamsResponse=} [properties] Properties to set
         * @returns {pond.ListTeamsResponse} ListTeamsResponse instance
         */
        ListTeamsResponse.create = function create(properties) {
            return new ListTeamsResponse(properties);
        };

        /**
         * Creates a ListTeamsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTeamsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTeamsResponse} ListTeamsResponse
         */
        ListTeamsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTeamsResponse)
                return object;
            var message = new $root.pond.ListTeamsResponse();
            if (object.teams) {
                if (!Array.isArray(object.teams))
                    throw TypeError(".pond.ListTeamsResponse.teams: array expected");
                message.teams = [];
                for (var i = 0; i < object.teams.length; ++i) {
                    if (typeof object.teams[i] !== "object")
                        throw TypeError(".pond.ListTeamsResponse.teams: object expected");
                    message.teams[i] = $root.pond.Team.fromObject(object.teams[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListTeamsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTeamsResponse
         * @static
         * @param {pond.ListTeamsResponse} message ListTeamsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTeamsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.teams = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.teams && message.teams.length) {
                object.teams = [];
                for (var j = 0; j < message.teams.length; ++j)
                    object.teams[j] = $root.pond.Team.toObject(message.teams[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListTeamsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTeamsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTeamsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTeamsResponse;
    })();

    pond.RemoveTeamRequest = (function() {

        /**
         * Properties of a RemoveTeamRequest.
         * @memberof pond
         * @interface IRemoveTeamRequest
         * @property {string|null} [team] RemoveTeamRequest team
         */

        /**
         * Constructs a new RemoveTeamRequest.
         * @memberof pond
         * @classdesc Represents a RemoveTeamRequest.
         * @implements IRemoveTeamRequest
         * @constructor
         * @param {pond.IRemoveTeamRequest=} [properties] Properties to set
         */
        function RemoveTeamRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTeamRequest team.
         * @member {string} team
         * @memberof pond.RemoveTeamRequest
         * @instance
         */
        RemoveTeamRequest.prototype.team = "";

        /**
         * Creates a new RemoveTeamRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTeamRequest
         * @static
         * @param {pond.IRemoveTeamRequest=} [properties] Properties to set
         * @returns {pond.RemoveTeamRequest} RemoveTeamRequest instance
         */
        RemoveTeamRequest.create = function create(properties) {
            return new RemoveTeamRequest(properties);
        };

        /**
         * Creates a RemoveTeamRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTeamRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTeamRequest} RemoveTeamRequest
         */
        RemoveTeamRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTeamRequest)
                return object;
            var message = new $root.pond.RemoveTeamRequest();
            if (object.team != null)
                message.team = String(object.team);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTeamRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTeamRequest
         * @static
         * @param {pond.RemoveTeamRequest} message RemoveTeamRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTeamRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.team = "";
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = message.team;
            return object;
        };

        /**
         * Converts this RemoveTeamRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveTeamRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTeamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTeamRequest;
    })();

    pond.RemoveTeamResponse = (function() {

        /**
         * Properties of a RemoveTeamResponse.
         * @memberof pond
         * @interface IRemoveTeamResponse
         */

        /**
         * Constructs a new RemoveTeamResponse.
         * @memberof pond
         * @classdesc Represents a RemoveTeamResponse.
         * @implements IRemoveTeamResponse
         * @constructor
         * @param {pond.IRemoveTeamResponse=} [properties] Properties to set
         */
        function RemoveTeamResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveTeamResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTeamResponse
         * @static
         * @param {pond.IRemoveTeamResponse=} [properties] Properties to set
         * @returns {pond.RemoveTeamResponse} RemoveTeamResponse instance
         */
        RemoveTeamResponse.create = function create(properties) {
            return new RemoveTeamResponse(properties);
        };

        /**
         * Creates a RemoveTeamResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTeamResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTeamResponse} RemoveTeamResponse
         */
        RemoveTeamResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTeamResponse)
                return object;
            return new $root.pond.RemoveTeamResponse();
        };

        /**
         * Creates a plain object from a RemoveTeamResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTeamResponse
         * @static
         * @param {pond.RemoveTeamResponse} message RemoveTeamResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTeamResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveTeamResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveTeamResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTeamResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTeamResponse;
    })();

    pond.UpdateTeamRequest = (function() {

        /**
         * Properties of an UpdateTeamRequest.
         * @memberof pond
         * @interface IUpdateTeamRequest
         * @property {pond.TeamSettings|null} [team] UpdateTeamRequest team
         */

        /**
         * Constructs a new UpdateTeamRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTeamRequest.
         * @implements IUpdateTeamRequest
         * @constructor
         * @param {pond.IUpdateTeamRequest=} [properties] Properties to set
         */
        function UpdateTeamRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTeamRequest team.
         * @member {pond.TeamSettings|null|undefined} team
         * @memberof pond.UpdateTeamRequest
         * @instance
         */
        UpdateTeamRequest.prototype.team = null;

        /**
         * Creates a new UpdateTeamRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTeamRequest
         * @static
         * @param {pond.IUpdateTeamRequest=} [properties] Properties to set
         * @returns {pond.UpdateTeamRequest} UpdateTeamRequest instance
         */
        UpdateTeamRequest.create = function create(properties) {
            return new UpdateTeamRequest(properties);
        };

        /**
         * Creates an UpdateTeamRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTeamRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTeamRequest} UpdateTeamRequest
         */
        UpdateTeamRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTeamRequest)
                return object;
            var message = new $root.pond.UpdateTeamRequest();
            if (object.team != null) {
                if (typeof object.team !== "object")
                    throw TypeError(".pond.UpdateTeamRequest.team: object expected");
                message.team = $root.pond.TeamSettings.fromObject(object.team);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTeamRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTeamRequest
         * @static
         * @param {pond.UpdateTeamRequest} message UpdateTeamRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTeamRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.team = null;
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = $root.pond.TeamSettings.toObject(message.team, options);
            return object;
        };

        /**
         * Converts this UpdateTeamRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTeamRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTeamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTeamRequest;
    })();

    pond.UpdateTeamResponse = (function() {

        /**
         * Properties of an UpdateTeamResponse.
         * @memberof pond
         * @interface IUpdateTeamResponse
         */

        /**
         * Constructs a new UpdateTeamResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTeamResponse.
         * @implements IUpdateTeamResponse
         * @constructor
         * @param {pond.IUpdateTeamResponse=} [properties] Properties to set
         */
        function UpdateTeamResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateTeamResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTeamResponse
         * @static
         * @param {pond.IUpdateTeamResponse=} [properties] Properties to set
         * @returns {pond.UpdateTeamResponse} UpdateTeamResponse instance
         */
        UpdateTeamResponse.create = function create(properties) {
            return new UpdateTeamResponse(properties);
        };

        /**
         * Creates an UpdateTeamResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTeamResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTeamResponse} UpdateTeamResponse
         */
        UpdateTeamResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTeamResponse)
                return object;
            return new $root.pond.UpdateTeamResponse();
        };

        /**
         * Creates a plain object from an UpdateTeamResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTeamResponse
         * @static
         * @param {pond.UpdateTeamResponse} message UpdateTeamResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTeamResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateTeamResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTeamResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTeamResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTeamResponse;
    })();

    /**
     * BlockType enum.
     * @name pond.BlockType
     * @enum {string}
     * @property {number} BLOCK_TYPE_NONE=0 BLOCK_TYPE_NONE value
     * @property {number} BLOCK_TYPE_VENT=1 BLOCK_TYPE_VENT value
     * @property {number} BLOCK_TYPE_VENT_CORNER=2 BLOCK_TYPE_VENT_CORNER value
     */
    pond.BlockType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BLOCK_TYPE_NONE"] = 0;
        values[valuesById[1] = "BLOCK_TYPE_VENT"] = 1;
        values[valuesById[2] = "BLOCK_TYPE_VENT_CORNER"] = 2;
        return values;
    })();

    pond.Block = (function() {

        /**
         * Properties of a Block.
         * @memberof pond
         * @interface IBlock
         * @property {pond.BlockSettings|null} [settings] Block settings
         */

        /**
         * Constructs a new Block.
         * @memberof pond
         * @classdesc Represents a Block.
         * @implements IBlock
         * @constructor
         * @param {pond.IBlock=} [properties] Properties to set
         */
        function Block(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Block settings.
         * @member {pond.BlockSettings|null|undefined} settings
         * @memberof pond.Block
         * @instance
         */
        Block.prototype.settings = null;

        /**
         * Creates a new Block instance using the specified properties.
         * @function create
         * @memberof pond.Block
         * @static
         * @param {pond.IBlock=} [properties] Properties to set
         * @returns {pond.Block} Block instance
         */
        Block.create = function create(properties) {
            return new Block(properties);
        };

        /**
         * Creates a Block message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Block
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Block} Block
         */
        Block.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Block)
                return object;
            var message = new $root.pond.Block();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Block.settings: object expected");
                message.settings = $root.pond.BlockSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Block message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Block
         * @static
         * @param {pond.Block} message Block
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Block.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.BlockSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this Block to JSON.
         * @function toJSON
         * @memberof pond.Block
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Block.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Block;
    })();

    pond.BlockSettings = (function() {

        /**
         * Properties of a BlockSettings.
         * @memberof pond
         * @interface IBlockSettings
         * @property {number|null} [x] BlockSettings x
         * @property {number|null} [y] BlockSettings y
         * @property {number|null} [width] BlockSettings width
         * @property {number|null} [height] BlockSettings height
         * @property {pond.BlockType|null} [type] BlockSettings type
         * @property {number|null} [angle] BlockSettings angle
         */

        /**
         * Constructs a new BlockSettings.
         * @memberof pond
         * @classdesc Represents a BlockSettings.
         * @implements IBlockSettings
         * @constructor
         * @param {pond.IBlockSettings=} [properties] Properties to set
         */
        function BlockSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BlockSettings x.
         * @member {number} x
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.x = 0;

        /**
         * BlockSettings y.
         * @member {number} y
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.y = 0;

        /**
         * BlockSettings width.
         * @member {number} width
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.width = 0;

        /**
         * BlockSettings height.
         * @member {number} height
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.height = 0;

        /**
         * BlockSettings type.
         * @member {pond.BlockType} type
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.type = 0;

        /**
         * BlockSettings angle.
         * @member {number} angle
         * @memberof pond.BlockSettings
         * @instance
         */
        BlockSettings.prototype.angle = 0;

        /**
         * Creates a new BlockSettings instance using the specified properties.
         * @function create
         * @memberof pond.BlockSettings
         * @static
         * @param {pond.IBlockSettings=} [properties] Properties to set
         * @returns {pond.BlockSettings} BlockSettings instance
         */
        BlockSettings.create = function create(properties) {
            return new BlockSettings(properties);
        };

        /**
         * Creates a BlockSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BlockSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BlockSettings} BlockSettings
         */
        BlockSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BlockSettings)
                return object;
            var message = new $root.pond.BlockSettings();
            if (object.x != null)
                message.x = object.x >>> 0;
            if (object.y != null)
                message.y = object.y >>> 0;
            if (object.width != null)
                message.width = object.width >>> 0;
            if (object.height != null)
                message.height = object.height >>> 0;
            switch (object.type) {
            case "BLOCK_TYPE_NONE":
            case 0:
                message.type = 0;
                break;
            case "BLOCK_TYPE_VENT":
            case 1:
                message.type = 1;
                break;
            case "BLOCK_TYPE_VENT_CORNER":
            case 2:
                message.type = 2;
                break;
            }
            if (object.angle != null)
                message.angle = object.angle >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BlockSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BlockSettings
         * @static
         * @param {pond.BlockSettings} message BlockSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BlockSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.x = 0;
                object.y = 0;
                object.width = 0;
                object.height = 0;
                object.type = options.enums === String ? "BLOCK_TYPE_NONE" : 0;
                object.angle = 0;
            }
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = message.y;
            if (message.width != null && message.hasOwnProperty("width"))
                object.width = message.width;
            if (message.height != null && message.hasOwnProperty("height"))
                object.height = message.height;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.BlockType[message.type] : message.type;
            if (message.angle != null && message.hasOwnProperty("angle"))
                object.angle = message.angle;
            return object;
        };

        /**
         * Converts this BlockSettings to JSON.
         * @function toJSON
         * @memberof pond.BlockSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BlockSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BlockSettings;
    })();

    /**
     * NoteType enum.
     * @name pond.NoteType
     * @enum {string}
     * @property {number} NOTE_TYPE_UNKNOWN=0 NOTE_TYPE_UNKNOWN value
     * @property {number} NOTE_TYPE_BIN=1 NOTE_TYPE_BIN value
     * @property {number} NOTE_TYPE_DEVICE=2 NOTE_TYPE_DEVICE value
     * @property {number} NOTE_TYPE_COMPONENT=3 NOTE_TYPE_COMPONENT value
     * @property {number} NOTE_TYPE_TEAM=4 NOTE_TYPE_TEAM value
     * @property {number} NOTE_TYPE_TASK=5 NOTE_TYPE_TASK value
     * @property {number} NOTE_TYPE_HARVEST_PLAN=6 NOTE_TYPE_HARVEST_PLAN value
     * @property {number} NOTE_TYPE_FIELD=7 NOTE_TYPE_FIELD value
     * @property {number} NOTE_TYPE_GATE=8 NOTE_TYPE_GATE value
     * @property {number} NOTE_TYPE_CONTRACT=9 NOTE_TYPE_CONTRACT value
     */
    pond.NoteType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NOTE_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "NOTE_TYPE_BIN"] = 1;
        values[valuesById[2] = "NOTE_TYPE_DEVICE"] = 2;
        values[valuesById[3] = "NOTE_TYPE_COMPONENT"] = 3;
        values[valuesById[4] = "NOTE_TYPE_TEAM"] = 4;
        values[valuesById[5] = "NOTE_TYPE_TASK"] = 5;
        values[valuesById[6] = "NOTE_TYPE_HARVEST_PLAN"] = 6;
        values[valuesById[7] = "NOTE_TYPE_FIELD"] = 7;
        values[valuesById[8] = "NOTE_TYPE_GATE"] = 8;
        values[valuesById[9] = "NOTE_TYPE_CONTRACT"] = 9;
        return values;
    })();

    pond.Note = (function() {

        /**
         * Properties of a Note.
         * @memberof pond
         * @interface INote
         * @property {pond.NoteSettings|null} [settings] Note settings
         * @property {pond.NoteStatus|null} [status] Note status
         */

        /**
         * Constructs a new Note.
         * @memberof pond
         * @classdesc Represents a Note.
         * @implements INote
         * @constructor
         * @param {pond.INote=} [properties] Properties to set
         */
        function Note(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Note settings.
         * @member {pond.NoteSettings|null|undefined} settings
         * @memberof pond.Note
         * @instance
         */
        Note.prototype.settings = null;

        /**
         * Note status.
         * @member {pond.NoteStatus|null|undefined} status
         * @memberof pond.Note
         * @instance
         */
        Note.prototype.status = null;

        /**
         * Creates a new Note instance using the specified properties.
         * @function create
         * @memberof pond.Note
         * @static
         * @param {pond.INote=} [properties] Properties to set
         * @returns {pond.Note} Note instance
         */
        Note.create = function create(properties) {
            return new Note(properties);
        };

        /**
         * Creates a Note message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Note
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Note} Note
         */
        Note.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Note)
                return object;
            var message = new $root.pond.Note();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Note.settings: object expected");
                message.settings = $root.pond.NoteSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Note.status: object expected");
                message.status = $root.pond.NoteStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Note message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Note
         * @static
         * @param {pond.Note} message Note
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Note.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.NoteSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.NoteStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Note to JSON.
         * @function toJSON
         * @memberof pond.Note
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Note.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Note;
    })();

    pond.NoteSettings = (function() {

        /**
         * Properties of a NoteSettings.
         * @memberof pond
         * @interface INoteSettings
         * @property {string|null} [key] NoteSettings key
         * @property {string|null} [userId] NoteSettings userId
         * @property {string|null} [content] NoteSettings content
         * @property {string|null} [objectKey] NoteSettings objectKey
         * @property {number|null} [objectType] NoteSettings objectType
         * @property {number|null} [timestamp] NoteSettings timestamp
         * @property {Array.<string>|null} [fileIds] NoteSettings fileIds
         */

        /**
         * Constructs a new NoteSettings.
         * @memberof pond
         * @classdesc Represents a NoteSettings.
         * @implements INoteSettings
         * @constructor
         * @param {pond.INoteSettings=} [properties] Properties to set
         */
        function NoteSettings(properties) {
            this.fileIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoteSettings key.
         * @member {string} key
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.key = "";

        /**
         * NoteSettings userId.
         * @member {string} userId
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.userId = "";

        /**
         * NoteSettings content.
         * @member {string} content
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.content = "";

        /**
         * NoteSettings objectKey.
         * @member {string} objectKey
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.objectKey = "";

        /**
         * NoteSettings objectType.
         * @member {number} objectType
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.objectType = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * NoteSettings timestamp.
         * @member {number} timestamp
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * NoteSettings fileIds.
         * @member {Array.<string>} fileIds
         * @memberof pond.NoteSettings
         * @instance
         */
        NoteSettings.prototype.fileIds = $util.emptyArray;

        /**
         * Creates a new NoteSettings instance using the specified properties.
         * @function create
         * @memberof pond.NoteSettings
         * @static
         * @param {pond.INoteSettings=} [properties] Properties to set
         * @returns {pond.NoteSettings} NoteSettings instance
         */
        NoteSettings.create = function create(properties) {
            return new NoteSettings(properties);
        };

        /**
         * Creates a NoteSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NoteSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NoteSettings} NoteSettings
         */
        NoteSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NoteSettings)
                return object;
            var message = new $root.pond.NoteSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.content != null)
                message.content = String(object.content);
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.objectType != null)
                if ($util.Long)
                    (message.objectType = $util.Long.fromValue(object.objectType)).unsigned = true;
                else if (typeof object.objectType === "string")
                    message.objectType = parseInt(object.objectType, 10);
                else if (typeof object.objectType === "number")
                    message.objectType = object.objectType;
                else if (typeof object.objectType === "object")
                    message.objectType = new $util.LongBits(object.objectType.low >>> 0, object.objectType.high >>> 0).toNumber(true);
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.fileIds) {
                if (!Array.isArray(object.fileIds))
                    throw TypeError(".pond.NoteSettings.fileIds: array expected");
                message.fileIds = [];
                for (var i = 0; i < object.fileIds.length; ++i)
                    message.fileIds[i] = String(object.fileIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a NoteSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NoteSettings
         * @static
         * @param {pond.NoteSettings} message NoteSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoteSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fileIds = [];
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.content = "";
                object.objectKey = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.objectType = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.objectType = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                if (typeof message.objectType === "number")
                    object.objectType = options.longs === String ? String(message.objectType) : message.objectType;
                else
                    object.objectType = options.longs === String ? $util.Long.prototype.toString.call(message.objectType) : options.longs === Number ? new $util.LongBits(message.objectType.low >>> 0, message.objectType.high >>> 0).toNumber(true) : message.objectType;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.fileIds && message.fileIds.length) {
                object.fileIds = [];
                for (var j = 0; j < message.fileIds.length; ++j)
                    object.fileIds[j] = message.fileIds[j];
            }
            return object;
        };

        /**
         * Converts this NoteSettings to JSON.
         * @function toJSON
         * @memberof pond.NoteSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoteSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoteSettings;
    })();

    pond.NoteStatus = (function() {

        /**
         * Properties of a NoteStatus.
         * @memberof pond
         * @interface INoteStatus
         * @property {string|null} [timestamp] NoteStatus timestamp
         */

        /**
         * Constructs a new NoteStatus.
         * @memberof pond
         * @classdesc Represents a NoteStatus.
         * @implements INoteStatus
         * @constructor
         * @param {pond.INoteStatus=} [properties] Properties to set
         */
        function NoteStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoteStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.NoteStatus
         * @instance
         */
        NoteStatus.prototype.timestamp = "";

        /**
         * Creates a new NoteStatus instance using the specified properties.
         * @function create
         * @memberof pond.NoteStatus
         * @static
         * @param {pond.INoteStatus=} [properties] Properties to set
         * @returns {pond.NoteStatus} NoteStatus instance
         */
        NoteStatus.create = function create(properties) {
            return new NoteStatus(properties);
        };

        /**
         * Creates a NoteStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NoteStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NoteStatus} NoteStatus
         */
        NoteStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NoteStatus)
                return object;
            var message = new $root.pond.NoteStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a NoteStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NoteStatus
         * @static
         * @param {pond.NoteStatus} message NoteStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoteStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this NoteStatus to JSON.
         * @function toJSON
         * @memberof pond.NoteStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoteStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoteStatus;
    })();

    pond.GetNoteRequest = (function() {

        /**
         * Properties of a GetNoteRequest.
         * @memberof pond
         * @interface IGetNoteRequest
         * @property {string|null} [note] GetNoteRequest note
         */

        /**
         * Constructs a new GetNoteRequest.
         * @memberof pond
         * @classdesc Represents a GetNoteRequest.
         * @implements IGetNoteRequest
         * @constructor
         * @param {pond.IGetNoteRequest=} [properties] Properties to set
         */
        function GetNoteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetNoteRequest note.
         * @member {string} note
         * @memberof pond.GetNoteRequest
         * @instance
         */
        GetNoteRequest.prototype.note = "";

        /**
         * Creates a new GetNoteRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetNoteRequest
         * @static
         * @param {pond.IGetNoteRequest=} [properties] Properties to set
         * @returns {pond.GetNoteRequest} GetNoteRequest instance
         */
        GetNoteRequest.create = function create(properties) {
            return new GetNoteRequest(properties);
        };

        /**
         * Creates a GetNoteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetNoteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetNoteRequest} GetNoteRequest
         */
        GetNoteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetNoteRequest)
                return object;
            var message = new $root.pond.GetNoteRequest();
            if (object.note != null)
                message.note = String(object.note);
            return message;
        };

        /**
         * Creates a plain object from a GetNoteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetNoteRequest
         * @static
         * @param {pond.GetNoteRequest} message GetNoteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetNoteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.note = "";
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = message.note;
            return object;
        };

        /**
         * Converts this GetNoteRequest to JSON.
         * @function toJSON
         * @memberof pond.GetNoteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetNoteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetNoteRequest;
    })();

    pond.AddNoteRequest = (function() {

        /**
         * Properties of an AddNoteRequest.
         * @memberof pond
         * @interface IAddNoteRequest
         * @property {pond.NoteSettings|null} [note] AddNoteRequest note
         * @property {Array.<string>|null} [fileAttachments] AddNoteRequest fileAttachments
         */

        /**
         * Constructs a new AddNoteRequest.
         * @memberof pond
         * @classdesc Represents an AddNoteRequest.
         * @implements IAddNoteRequest
         * @constructor
         * @param {pond.IAddNoteRequest=} [properties] Properties to set
         */
        function AddNoteRequest(properties) {
            this.fileAttachments = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNoteRequest note.
         * @member {pond.NoteSettings|null|undefined} note
         * @memberof pond.AddNoteRequest
         * @instance
         */
        AddNoteRequest.prototype.note = null;

        /**
         * AddNoteRequest fileAttachments.
         * @member {Array.<string>} fileAttachments
         * @memberof pond.AddNoteRequest
         * @instance
         */
        AddNoteRequest.prototype.fileAttachments = $util.emptyArray;

        /**
         * Creates a new AddNoteRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddNoteRequest
         * @static
         * @param {pond.IAddNoteRequest=} [properties] Properties to set
         * @returns {pond.AddNoteRequest} AddNoteRequest instance
         */
        AddNoteRequest.create = function create(properties) {
            return new AddNoteRequest(properties);
        };

        /**
         * Creates an AddNoteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNoteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNoteRequest} AddNoteRequest
         */
        AddNoteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNoteRequest)
                return object;
            var message = new $root.pond.AddNoteRequest();
            if (object.note != null) {
                if (typeof object.note !== "object")
                    throw TypeError(".pond.AddNoteRequest.note: object expected");
                message.note = $root.pond.NoteSettings.fromObject(object.note);
            }
            if (object.fileAttachments) {
                if (!Array.isArray(object.fileAttachments))
                    throw TypeError(".pond.AddNoteRequest.fileAttachments: array expected");
                message.fileAttachments = [];
                for (var i = 0; i < object.fileAttachments.length; ++i)
                    message.fileAttachments[i] = String(object.fileAttachments[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddNoteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNoteRequest
         * @static
         * @param {pond.AddNoteRequest} message AddNoteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNoteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fileAttachments = [];
            if (options.defaults)
                object.note = null;
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = $root.pond.NoteSettings.toObject(message.note, options);
            if (message.fileAttachments && message.fileAttachments.length) {
                object.fileAttachments = [];
                for (var j = 0; j < message.fileAttachments.length; ++j)
                    object.fileAttachments[j] = message.fileAttachments[j];
            }
            return object;
        };

        /**
         * Converts this AddNoteRequest to JSON.
         * @function toJSON
         * @memberof pond.AddNoteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNoteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNoteRequest;
    })();

    pond.UpdateNoteSettingsRequest = (function() {

        /**
         * Properties of an UpdateNoteSettingsRequest.
         * @memberof pond
         * @interface IUpdateNoteSettingsRequest
         * @property {pond.NoteSettings|null} [note] UpdateNoteSettingsRequest note
         */

        /**
         * Constructs a new UpdateNoteSettingsRequest.
         * @memberof pond
         * @classdesc Represents an UpdateNoteSettingsRequest.
         * @implements IUpdateNoteSettingsRequest
         * @constructor
         * @param {pond.IUpdateNoteSettingsRequest=} [properties] Properties to set
         */
        function UpdateNoteSettingsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateNoteSettingsRequest note.
         * @member {pond.NoteSettings|null|undefined} note
         * @memberof pond.UpdateNoteSettingsRequest
         * @instance
         */
        UpdateNoteSettingsRequest.prototype.note = null;

        /**
         * Creates a new UpdateNoteSettingsRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateNoteSettingsRequest
         * @static
         * @param {pond.IUpdateNoteSettingsRequest=} [properties] Properties to set
         * @returns {pond.UpdateNoteSettingsRequest} UpdateNoteSettingsRequest instance
         */
        UpdateNoteSettingsRequest.create = function create(properties) {
            return new UpdateNoteSettingsRequest(properties);
        };

        /**
         * Creates an UpdateNoteSettingsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateNoteSettingsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateNoteSettingsRequest} UpdateNoteSettingsRequest
         */
        UpdateNoteSettingsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateNoteSettingsRequest)
                return object;
            var message = new $root.pond.UpdateNoteSettingsRequest();
            if (object.note != null) {
                if (typeof object.note !== "object")
                    throw TypeError(".pond.UpdateNoteSettingsRequest.note: object expected");
                message.note = $root.pond.NoteSettings.fromObject(object.note);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateNoteSettingsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateNoteSettingsRequest
         * @static
         * @param {pond.UpdateNoteSettingsRequest} message UpdateNoteSettingsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateNoteSettingsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.note = null;
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = $root.pond.NoteSettings.toObject(message.note, options);
            return object;
        };

        /**
         * Converts this UpdateNoteSettingsRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateNoteSettingsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateNoteSettingsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateNoteSettingsRequest;
    })();

    pond.AddNoteResponse = (function() {

        /**
         * Properties of an AddNoteResponse.
         * @memberof pond
         * @interface IAddNoteResponse
         * @property {string|null} [note] AddNoteResponse note
         */

        /**
         * Constructs a new AddNoteResponse.
         * @memberof pond
         * @classdesc Represents an AddNoteResponse.
         * @implements IAddNoteResponse
         * @constructor
         * @param {pond.IAddNoteResponse=} [properties] Properties to set
         */
        function AddNoteResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNoteResponse note.
         * @member {string} note
         * @memberof pond.AddNoteResponse
         * @instance
         */
        AddNoteResponse.prototype.note = "";

        /**
         * Creates a new AddNoteResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddNoteResponse
         * @static
         * @param {pond.IAddNoteResponse=} [properties] Properties to set
         * @returns {pond.AddNoteResponse} AddNoteResponse instance
         */
        AddNoteResponse.create = function create(properties) {
            return new AddNoteResponse(properties);
        };

        /**
         * Creates an AddNoteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNoteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNoteResponse} AddNoteResponse
         */
        AddNoteResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNoteResponse)
                return object;
            var message = new $root.pond.AddNoteResponse();
            if (object.note != null)
                message.note = String(object.note);
            return message;
        };

        /**
         * Creates a plain object from an AddNoteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNoteResponse
         * @static
         * @param {pond.AddNoteResponse} message AddNoteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNoteResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.note = "";
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = message.note;
            return object;
        };

        /**
         * Converts this AddNoteResponse to JSON.
         * @function toJSON
         * @memberof pond.AddNoteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNoteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNoteResponse;
    })();

    pond.UpdateNoteSettingsResponse = (function() {

        /**
         * Properties of an UpdateNoteSettingsResponse.
         * @memberof pond
         * @interface IUpdateNoteSettingsResponse
         */

        /**
         * Constructs a new UpdateNoteSettingsResponse.
         * @memberof pond
         * @classdesc Represents an UpdateNoteSettingsResponse.
         * @implements IUpdateNoteSettingsResponse
         * @constructor
         * @param {pond.IUpdateNoteSettingsResponse=} [properties] Properties to set
         */
        function UpdateNoteSettingsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateNoteSettingsResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateNoteSettingsResponse
         * @static
         * @param {pond.IUpdateNoteSettingsResponse=} [properties] Properties to set
         * @returns {pond.UpdateNoteSettingsResponse} UpdateNoteSettingsResponse instance
         */
        UpdateNoteSettingsResponse.create = function create(properties) {
            return new UpdateNoteSettingsResponse(properties);
        };

        /**
         * Creates an UpdateNoteSettingsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateNoteSettingsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateNoteSettingsResponse} UpdateNoteSettingsResponse
         */
        UpdateNoteSettingsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateNoteSettingsResponse)
                return object;
            return new $root.pond.UpdateNoteSettingsResponse();
        };

        /**
         * Creates a plain object from an UpdateNoteSettingsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateNoteSettingsResponse
         * @static
         * @param {pond.UpdateNoteSettingsResponse} message UpdateNoteSettingsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateNoteSettingsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateNoteSettingsResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateNoteSettingsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateNoteSettingsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateNoteSettingsResponse;
    })();

    pond.ListNotesRequest = (function() {

        /**
         * Properties of a ListNotesRequest.
         * @memberof pond
         * @interface IListNotesRequest
         * @property {string|null} [key] ListNotesRequest key
         * @property {number|null} [type] ListNotesRequest type
         * @property {pond.Paging|null} [paging] ListNotesRequest paging
         * @property {pond.Sorting|null} [sorting] ListNotesRequest sorting
         * @property {string|null} [search] ListNotesRequest search
         * @property {pond.NoteSettings|null} [settingsMatch] ListNotesRequest settingsMatch
         * @property {pond.NoteStatus|null} [statusMatch] ListNotesRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListNotesRequest fieldContains
         */

        /**
         * Constructs a new ListNotesRequest.
         * @memberof pond
         * @classdesc Represents a ListNotesRequest.
         * @implements IListNotesRequest
         * @constructor
         * @param {pond.IListNotesRequest=} [properties] Properties to set
         */
        function ListNotesRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotesRequest key.
         * @member {string} key
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.key = "";

        /**
         * ListNotesRequest type.
         * @member {number} type
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListNotesRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.paging = null;

        /**
         * ListNotesRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.sorting = null;

        /**
         * ListNotesRequest search.
         * @member {string} search
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.search = "";

        /**
         * ListNotesRequest settingsMatch.
         * @member {pond.NoteSettings|null|undefined} settingsMatch
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.settingsMatch = null;

        /**
         * ListNotesRequest statusMatch.
         * @member {pond.NoteStatus|null|undefined} statusMatch
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.statusMatch = null;

        /**
         * ListNotesRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListNotesRequest
         * @instance
         */
        ListNotesRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListNotesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListNotesRequest
         * @static
         * @param {pond.IListNotesRequest=} [properties] Properties to set
         * @returns {pond.ListNotesRequest} ListNotesRequest instance
         */
        ListNotesRequest.create = function create(properties) {
            return new ListNotesRequest(properties);
        };

        /**
         * Creates a ListNotesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotesRequest} ListNotesRequest
         */
        ListNotesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotesRequest)
                return object;
            var message = new $root.pond.ListNotesRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListNotesRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListNotesRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListNotesRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.NoteSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListNotesRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.NoteStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListNotesRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListNotesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotesRequest
         * @static
         * @param {pond.ListNotesRequest} message ListNotesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.NoteSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.NoteStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListNotesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListNotesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotesRequest;
    })();

    pond.ListNotesResponse = (function() {

        /**
         * Properties of a ListNotesResponse.
         * @memberof pond
         * @interface IListNotesResponse
         * @property {Array.<pond.Note>|null} [notes] ListNotesResponse notes
         * @property {Object.<string,pond.FileRefList>|null} [attachments] ListNotesResponse attachments
         * @property {number|null} [nextOffset] ListNotesResponse nextOffset
         * @property {number|null} [total] ListNotesResponse total
         */

        /**
         * Constructs a new ListNotesResponse.
         * @memberof pond
         * @classdesc Represents a ListNotesResponse.
         * @implements IListNotesResponse
         * @constructor
         * @param {pond.IListNotesResponse=} [properties] Properties to set
         */
        function ListNotesResponse(properties) {
            this.notes = [];
            this.attachments = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotesResponse notes.
         * @member {Array.<pond.Note>} notes
         * @memberof pond.ListNotesResponse
         * @instance
         */
        ListNotesResponse.prototype.notes = $util.emptyArray;

        /**
         * ListNotesResponse attachments.
         * @member {Object.<string,pond.FileRefList>} attachments
         * @memberof pond.ListNotesResponse
         * @instance
         */
        ListNotesResponse.prototype.attachments = $util.emptyObject;

        /**
         * ListNotesResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListNotesResponse
         * @instance
         */
        ListNotesResponse.prototype.nextOffset = 0;

        /**
         * ListNotesResponse total.
         * @member {number} total
         * @memberof pond.ListNotesResponse
         * @instance
         */
        ListNotesResponse.prototype.total = 0;

        /**
         * Creates a new ListNotesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListNotesResponse
         * @static
         * @param {pond.IListNotesResponse=} [properties] Properties to set
         * @returns {pond.ListNotesResponse} ListNotesResponse instance
         */
        ListNotesResponse.create = function create(properties) {
            return new ListNotesResponse(properties);
        };

        /**
         * Creates a ListNotesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotesResponse} ListNotesResponse
         */
        ListNotesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotesResponse)
                return object;
            var message = new $root.pond.ListNotesResponse();
            if (object.notes) {
                if (!Array.isArray(object.notes))
                    throw TypeError(".pond.ListNotesResponse.notes: array expected");
                message.notes = [];
                for (var i = 0; i < object.notes.length; ++i) {
                    if (typeof object.notes[i] !== "object")
                        throw TypeError(".pond.ListNotesResponse.notes: object expected");
                    message.notes[i] = $root.pond.Note.fromObject(object.notes[i]);
                }
            }
            if (object.attachments) {
                if (typeof object.attachments !== "object")
                    throw TypeError(".pond.ListNotesResponse.attachments: object expected");
                message.attachments = {};
                for (var keys = Object.keys(object.attachments), i = 0; i < keys.length; ++i) {
                    if (typeof object.attachments[keys[i]] !== "object")
                        throw TypeError(".pond.ListNotesResponse.attachments: object expected");
                    message.attachments[keys[i]] = $root.pond.FileRefList.fromObject(object.attachments[keys[i]]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListNotesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotesResponse
         * @static
         * @param {pond.ListNotesResponse} message ListNotesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.notes = [];
            if (options.objects || options.defaults)
                object.attachments = {};
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.notes && message.notes.length) {
                object.notes = [];
                for (var j = 0; j < message.notes.length; ++j)
                    object.notes[j] = $root.pond.Note.toObject(message.notes[j], options);
            }
            var keys2;
            if (message.attachments && (keys2 = Object.keys(message.attachments)).length) {
                object.attachments = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.attachments[keys2[j]] = $root.pond.FileRefList.toObject(message.attachments[keys2[j]], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListNotesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListNotesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotesResponse;
    })();

    pond.Chat = (function() {

        /**
         * Properties of a Chat.
         * @memberof pond
         * @interface IChat
         * @property {pond.Note|null} [note] Chat note
         * @property {Array.<pond.Permission>|null} [permissions] Chat permissions
         * @property {pond.UserProfile|null} [profile] Chat profile
         */

        /**
         * Constructs a new Chat.
         * @memberof pond
         * @classdesc Represents a Chat.
         * @implements IChat
         * @constructor
         * @param {pond.IChat=} [properties] Properties to set
         */
        function Chat(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Chat note.
         * @member {pond.Note|null|undefined} note
         * @memberof pond.Chat
         * @instance
         */
        Chat.prototype.note = null;

        /**
         * Chat permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.Chat
         * @instance
         */
        Chat.prototype.permissions = $util.emptyArray;

        /**
         * Chat profile.
         * @member {pond.UserProfile|null|undefined} profile
         * @memberof pond.Chat
         * @instance
         */
        Chat.prototype.profile = null;

        /**
         * Creates a new Chat instance using the specified properties.
         * @function create
         * @memberof pond.Chat
         * @static
         * @param {pond.IChat=} [properties] Properties to set
         * @returns {pond.Chat} Chat instance
         */
        Chat.create = function create(properties) {
            return new Chat(properties);
        };

        /**
         * Creates a Chat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Chat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Chat} Chat
         */
        Chat.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Chat)
                return object;
            var message = new $root.pond.Chat();
            if (object.note != null) {
                if (typeof object.note !== "object")
                    throw TypeError(".pond.Chat.note: object expected");
                message.note = $root.pond.Note.fromObject(object.note);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.Chat.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.profile != null) {
                if (typeof object.profile !== "object")
                    throw TypeError(".pond.Chat.profile: object expected");
                message.profile = $root.pond.UserProfile.fromObject(object.profile);
            }
            return message;
        };

        /**
         * Creates a plain object from a Chat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Chat
         * @static
         * @param {pond.Chat} message Chat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Chat.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.note = null;
                object.profile = null;
            }
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = $root.pond.Note.toObject(message.note, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.profile != null && message.hasOwnProperty("profile"))
                object.profile = $root.pond.UserProfile.toObject(message.profile, options);
            return object;
        };

        /**
         * Converts this Chat to JSON.
         * @function toJSON
         * @memberof pond.Chat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Chat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Chat;
    })();

    pond.ListChatsResponse = (function() {

        /**
         * Properties of a ListChatsResponse.
         * @memberof pond
         * @interface IListChatsResponse
         * @property {Array.<pond.Chat>|null} [chats] ListChatsResponse chats
         * @property {Object.<string,pond.FileRefList>|null} [attachments] ListChatsResponse attachments
         * @property {number|null} [nextOffset] ListChatsResponse nextOffset
         * @property {number|null} [total] ListChatsResponse total
         */

        /**
         * Constructs a new ListChatsResponse.
         * @memberof pond
         * @classdesc Represents a ListChatsResponse.
         * @implements IListChatsResponse
         * @constructor
         * @param {pond.IListChatsResponse=} [properties] Properties to set
         */
        function ListChatsResponse(properties) {
            this.chats = [];
            this.attachments = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListChatsResponse chats.
         * @member {Array.<pond.Chat>} chats
         * @memberof pond.ListChatsResponse
         * @instance
         */
        ListChatsResponse.prototype.chats = $util.emptyArray;

        /**
         * ListChatsResponse attachments.
         * @member {Object.<string,pond.FileRefList>} attachments
         * @memberof pond.ListChatsResponse
         * @instance
         */
        ListChatsResponse.prototype.attachments = $util.emptyObject;

        /**
         * ListChatsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListChatsResponse
         * @instance
         */
        ListChatsResponse.prototype.nextOffset = 0;

        /**
         * ListChatsResponse total.
         * @member {number} total
         * @memberof pond.ListChatsResponse
         * @instance
         */
        ListChatsResponse.prototype.total = 0;

        /**
         * Creates a new ListChatsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListChatsResponse
         * @static
         * @param {pond.IListChatsResponse=} [properties] Properties to set
         * @returns {pond.ListChatsResponse} ListChatsResponse instance
         */
        ListChatsResponse.create = function create(properties) {
            return new ListChatsResponse(properties);
        };

        /**
         * Creates a ListChatsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListChatsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListChatsResponse} ListChatsResponse
         */
        ListChatsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListChatsResponse)
                return object;
            var message = new $root.pond.ListChatsResponse();
            if (object.chats) {
                if (!Array.isArray(object.chats))
                    throw TypeError(".pond.ListChatsResponse.chats: array expected");
                message.chats = [];
                for (var i = 0; i < object.chats.length; ++i) {
                    if (typeof object.chats[i] !== "object")
                        throw TypeError(".pond.ListChatsResponse.chats: object expected");
                    message.chats[i] = $root.pond.Chat.fromObject(object.chats[i]);
                }
            }
            if (object.attachments) {
                if (typeof object.attachments !== "object")
                    throw TypeError(".pond.ListChatsResponse.attachments: object expected");
                message.attachments = {};
                for (var keys = Object.keys(object.attachments), i = 0; i < keys.length; ++i) {
                    if (typeof object.attachments[keys[i]] !== "object")
                        throw TypeError(".pond.ListChatsResponse.attachments: object expected");
                    message.attachments[keys[i]] = $root.pond.FileRefList.fromObject(object.attachments[keys[i]]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListChatsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListChatsResponse
         * @static
         * @param {pond.ListChatsResponse} message ListChatsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListChatsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.chats = [];
            if (options.objects || options.defaults)
                object.attachments = {};
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.chats && message.chats.length) {
                object.chats = [];
                for (var j = 0; j < message.chats.length; ++j)
                    object.chats[j] = $root.pond.Chat.toObject(message.chats[j], options);
            }
            var keys2;
            if (message.attachments && (keys2 = Object.keys(message.attachments)).length) {
                object.attachments = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.attachments[keys2[j]] = $root.pond.FileRefList.toObject(message.attachments[keys2[j]], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListChatsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListChatsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListChatsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListChatsResponse;
    })();

    pond.ListNotificationsRequest = (function() {

        /**
         * Properties of a ListNotificationsRequest.
         * @memberof pond
         * @interface IListNotificationsRequest
         * @property {string|null} [key] ListNotificationsRequest key
         * @property {number|null} [type] ListNotificationsRequest type
         * @property {pond.Paging|null} [paging] ListNotificationsRequest paging
         * @property {pond.Sorting|null} [sorting] ListNotificationsRequest sorting
         * @property {string|null} [search] ListNotificationsRequest search
         * @property {pond.NotificationSettings|null} [settingsMatch] ListNotificationsRequest settingsMatch
         * @property {pond.NotificationStatus|null} [statusMatch] ListNotificationsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListNotificationsRequest fieldContains
         */

        /**
         * Constructs a new ListNotificationsRequest.
         * @memberof pond
         * @classdesc Represents a ListNotificationsRequest.
         * @implements IListNotificationsRequest
         * @constructor
         * @param {pond.IListNotificationsRequest=} [properties] Properties to set
         */
        function ListNotificationsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotificationsRequest key.
         * @member {string} key
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.key = "";

        /**
         * ListNotificationsRequest type.
         * @member {number} type
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.type = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListNotificationsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.paging = null;

        /**
         * ListNotificationsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.sorting = null;

        /**
         * ListNotificationsRequest search.
         * @member {string} search
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.search = "";

        /**
         * ListNotificationsRequest settingsMatch.
         * @member {pond.NotificationSettings|null|undefined} settingsMatch
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.settingsMatch = null;

        /**
         * ListNotificationsRequest statusMatch.
         * @member {pond.NotificationStatus|null|undefined} statusMatch
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.statusMatch = null;

        /**
         * ListNotificationsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListNotificationsRequest
         * @instance
         */
        ListNotificationsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListNotificationsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListNotificationsRequest
         * @static
         * @param {pond.IListNotificationsRequest=} [properties] Properties to set
         * @returns {pond.ListNotificationsRequest} ListNotificationsRequest instance
         */
        ListNotificationsRequest.create = function create(properties) {
            return new ListNotificationsRequest(properties);
        };

        /**
         * Creates a ListNotificationsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotificationsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotificationsRequest} ListNotificationsRequest
         */
        ListNotificationsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotificationsRequest)
                return object;
            var message = new $root.pond.ListNotificationsRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                if ($util.Long)
                    (message.type = $util.Long.fromValue(object.type)).unsigned = true;
                else if (typeof object.type === "string")
                    message.type = parseInt(object.type, 10);
                else if (typeof object.type === "number")
                    message.type = object.type;
                else if (typeof object.type === "object")
                    message.type = new $util.LongBits(object.type.low >>> 0, object.type.high >>> 0).toNumber(true);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListNotificationsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListNotificationsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListNotificationsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.NotificationSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListNotificationsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.NotificationStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListNotificationsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListNotificationsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotificationsRequest
         * @static
         * @param {pond.ListNotificationsRequest} message ListNotificationsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotificationsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.type = options.longs === String ? "0" : 0;
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                if (typeof message.type === "number")
                    object.type = options.longs === String ? String(message.type) : message.type;
                else
                    object.type = options.longs === String ? $util.Long.prototype.toString.call(message.type) : options.longs === Number ? new $util.LongBits(message.type.low >>> 0, message.type.high >>> 0).toNumber(true) : message.type;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.NotificationSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.NotificationStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListNotificationsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListNotificationsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotificationsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotificationsRequest;
    })();

    pond.AddNotificationRequest = (function() {

        /**
         * Properties of an AddNotificationRequest.
         * @memberof pond
         * @interface IAddNotificationRequest
         * @property {pond.NotificationSettings|null} [notification] AddNotificationRequest notification
         */

        /**
         * Constructs a new AddNotificationRequest.
         * @memberof pond
         * @classdesc Represents an AddNotificationRequest.
         * @implements IAddNotificationRequest
         * @constructor
         * @param {pond.IAddNotificationRequest=} [properties] Properties to set
         */
        function AddNotificationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNotificationRequest notification.
         * @member {pond.NotificationSettings|null|undefined} notification
         * @memberof pond.AddNotificationRequest
         * @instance
         */
        AddNotificationRequest.prototype.notification = null;

        /**
         * Creates a new AddNotificationRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddNotificationRequest
         * @static
         * @param {pond.IAddNotificationRequest=} [properties] Properties to set
         * @returns {pond.AddNotificationRequest} AddNotificationRequest instance
         */
        AddNotificationRequest.create = function create(properties) {
            return new AddNotificationRequest(properties);
        };

        /**
         * Creates an AddNotificationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNotificationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNotificationRequest} AddNotificationRequest
         */
        AddNotificationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNotificationRequest)
                return object;
            var message = new $root.pond.AddNotificationRequest();
            if (object.notification != null) {
                if (typeof object.notification !== "object")
                    throw TypeError(".pond.AddNotificationRequest.notification: object expected");
                message.notification = $root.pond.NotificationSettings.fromObject(object.notification);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddNotificationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNotificationRequest
         * @static
         * @param {pond.AddNotificationRequest} message AddNotificationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNotificationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.notification = null;
            if (message.notification != null && message.hasOwnProperty("notification"))
                object.notification = $root.pond.NotificationSettings.toObject(message.notification, options);
            return object;
        };

        /**
         * Converts this AddNotificationRequest to JSON.
         * @function toJSON
         * @memberof pond.AddNotificationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNotificationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNotificationRequest;
    })();

    pond.ListNotificationsResponse = (function() {

        /**
         * Properties of a ListNotificationsResponse.
         * @memberof pond
         * @interface IListNotificationsResponse
         * @property {Array.<pond.Notification>|null} [notifications] ListNotificationsResponse notifications
         * @property {number|null} [nextOffset] ListNotificationsResponse nextOffset
         * @property {number|null} [total] ListNotificationsResponse total
         */

        /**
         * Constructs a new ListNotificationsResponse.
         * @memberof pond
         * @classdesc Represents a ListNotificationsResponse.
         * @implements IListNotificationsResponse
         * @constructor
         * @param {pond.IListNotificationsResponse=} [properties] Properties to set
         */
        function ListNotificationsResponse(properties) {
            this.notifications = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotificationsResponse notifications.
         * @member {Array.<pond.Notification>} notifications
         * @memberof pond.ListNotificationsResponse
         * @instance
         */
        ListNotificationsResponse.prototype.notifications = $util.emptyArray;

        /**
         * ListNotificationsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListNotificationsResponse
         * @instance
         */
        ListNotificationsResponse.prototype.nextOffset = 0;

        /**
         * ListNotificationsResponse total.
         * @member {number} total
         * @memberof pond.ListNotificationsResponse
         * @instance
         */
        ListNotificationsResponse.prototype.total = 0;

        /**
         * Creates a new ListNotificationsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListNotificationsResponse
         * @static
         * @param {pond.IListNotificationsResponse=} [properties] Properties to set
         * @returns {pond.ListNotificationsResponse} ListNotificationsResponse instance
         */
        ListNotificationsResponse.create = function create(properties) {
            return new ListNotificationsResponse(properties);
        };

        /**
         * Creates a ListNotificationsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotificationsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotificationsResponse} ListNotificationsResponse
         */
        ListNotificationsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotificationsResponse)
                return object;
            var message = new $root.pond.ListNotificationsResponse();
            if (object.notifications) {
                if (!Array.isArray(object.notifications))
                    throw TypeError(".pond.ListNotificationsResponse.notifications: array expected");
                message.notifications = [];
                for (var i = 0; i < object.notifications.length; ++i) {
                    if (typeof object.notifications[i] !== "object")
                        throw TypeError(".pond.ListNotificationsResponse.notifications: object expected");
                    message.notifications[i] = $root.pond.Notification.fromObject(object.notifications[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListNotificationsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotificationsResponse
         * @static
         * @param {pond.ListNotificationsResponse} message ListNotificationsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotificationsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.notifications = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.notifications && message.notifications.length) {
                object.notifications = [];
                for (var j = 0; j < message.notifications.length; ++j)
                    object.notifications[j] = $root.pond.Notification.toObject(message.notifications[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListNotificationsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListNotificationsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotificationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotificationsResponse;
    })();

    pond.ListObjectNotificationsRequest = (function() {

        /**
         * Properties of a ListObjectNotificationsRequest.
         * @memberof pond
         * @interface IListObjectNotificationsRequest
         * @property {string|null} [objectKey] ListObjectNotificationsRequest objectKey
         * @property {pond.ObjectType|null} [objectType] ListObjectNotificationsRequest objectType
         * @property {pond.Paging|null} [paging] ListObjectNotificationsRequest paging
         * @property {pond.Sorting|null} [sorting] ListObjectNotificationsRequest sorting
         * @property {string|null} [search] ListObjectNotificationsRequest search
         */

        /**
         * Constructs a new ListObjectNotificationsRequest.
         * @memberof pond
         * @classdesc Represents a ListObjectNotificationsRequest.
         * @implements IListObjectNotificationsRequest
         * @constructor
         * @param {pond.IListObjectNotificationsRequest=} [properties] Properties to set
         */
        function ListObjectNotificationsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectNotificationsRequest objectKey.
         * @member {string} objectKey
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         */
        ListObjectNotificationsRequest.prototype.objectKey = "";

        /**
         * ListObjectNotificationsRequest objectType.
         * @member {pond.ObjectType} objectType
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         */
        ListObjectNotificationsRequest.prototype.objectType = 0;

        /**
         * ListObjectNotificationsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         */
        ListObjectNotificationsRequest.prototype.paging = null;

        /**
         * ListObjectNotificationsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         */
        ListObjectNotificationsRequest.prototype.sorting = null;

        /**
         * ListObjectNotificationsRequest search.
         * @member {string} search
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         */
        ListObjectNotificationsRequest.prototype.search = "";

        /**
         * Creates a new ListObjectNotificationsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectNotificationsRequest
         * @static
         * @param {pond.IListObjectNotificationsRequest=} [properties] Properties to set
         * @returns {pond.ListObjectNotificationsRequest} ListObjectNotificationsRequest instance
         */
        ListObjectNotificationsRequest.create = function create(properties) {
            return new ListObjectNotificationsRequest(properties);
        };

        /**
         * Creates a ListObjectNotificationsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectNotificationsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectNotificationsRequest} ListObjectNotificationsRequest
         */
        ListObjectNotificationsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectNotificationsRequest)
                return object;
            var message = new $root.pond.ListObjectNotificationsRequest();
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            switch (object.objectType) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.objectType = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.objectType = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.objectType = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.objectType = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.objectType = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.objectType = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.objectType = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.objectType = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.objectType = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.objectType = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.objectType = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.objectType = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.objectType = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.objectType = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.objectType = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.objectType = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.objectType = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.objectType = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.objectType = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.objectType = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.objectType = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.objectType = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.objectType = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.objectType = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.objectType = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.objectType = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.objectType = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.objectType = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.objectType = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.objectType = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.objectType = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.objectType = 31;
                break;
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListObjectNotificationsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListObjectNotificationsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListObjectNotificationsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectNotificationsRequest
         * @static
         * @param {pond.ListObjectNotificationsRequest} message ListObjectNotificationsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectNotificationsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.objectKey = "";
                object.objectType = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = options.enums === String ? $root.pond.ObjectType[message.objectType] : message.objectType;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListObjectNotificationsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListObjectNotificationsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectNotificationsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectNotificationsRequest;
    })();

    pond.ListObjectNotificationsResponse = (function() {

        /**
         * Properties of a ListObjectNotificationsResponse.
         * @memberof pond
         * @interface IListObjectNotificationsResponse
         * @property {Array.<pond.Notification>|null} [notifications] ListObjectNotificationsResponse notifications
         * @property {number|null} [nextOffset] ListObjectNotificationsResponse nextOffset
         * @property {number|null} [total] ListObjectNotificationsResponse total
         */

        /**
         * Constructs a new ListObjectNotificationsResponse.
         * @memberof pond
         * @classdesc Represents a ListObjectNotificationsResponse.
         * @implements IListObjectNotificationsResponse
         * @constructor
         * @param {pond.IListObjectNotificationsResponse=} [properties] Properties to set
         */
        function ListObjectNotificationsResponse(properties) {
            this.notifications = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectNotificationsResponse notifications.
         * @member {Array.<pond.Notification>} notifications
         * @memberof pond.ListObjectNotificationsResponse
         * @instance
         */
        ListObjectNotificationsResponse.prototype.notifications = $util.emptyArray;

        /**
         * ListObjectNotificationsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListObjectNotificationsResponse
         * @instance
         */
        ListObjectNotificationsResponse.prototype.nextOffset = 0;

        /**
         * ListObjectNotificationsResponse total.
         * @member {number} total
         * @memberof pond.ListObjectNotificationsResponse
         * @instance
         */
        ListObjectNotificationsResponse.prototype.total = 0;

        /**
         * Creates a new ListObjectNotificationsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectNotificationsResponse
         * @static
         * @param {pond.IListObjectNotificationsResponse=} [properties] Properties to set
         * @returns {pond.ListObjectNotificationsResponse} ListObjectNotificationsResponse instance
         */
        ListObjectNotificationsResponse.create = function create(properties) {
            return new ListObjectNotificationsResponse(properties);
        };

        /**
         * Creates a ListObjectNotificationsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectNotificationsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectNotificationsResponse} ListObjectNotificationsResponse
         */
        ListObjectNotificationsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectNotificationsResponse)
                return object;
            var message = new $root.pond.ListObjectNotificationsResponse();
            if (object.notifications) {
                if (!Array.isArray(object.notifications))
                    throw TypeError(".pond.ListObjectNotificationsResponse.notifications: array expected");
                message.notifications = [];
                for (var i = 0; i < object.notifications.length; ++i) {
                    if (typeof object.notifications[i] !== "object")
                        throw TypeError(".pond.ListObjectNotificationsResponse.notifications: object expected");
                    message.notifications[i] = $root.pond.Notification.fromObject(object.notifications[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListObjectNotificationsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectNotificationsResponse
         * @static
         * @param {pond.ListObjectNotificationsResponse} message ListObjectNotificationsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectNotificationsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.notifications = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.notifications && message.notifications.length) {
                object.notifications = [];
                for (var j = 0; j < message.notifications.length; ++j)
                    object.notifications[j] = $root.pond.Notification.toObject(message.notifications[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListObjectNotificationsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListObjectNotificationsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectNotificationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectNotificationsResponse;
    })();

    pond.NotificationKeys = (function() {

        /**
         * Properties of a NotificationKeys.
         * @memberof pond
         * @interface INotificationKeys
         * @property {Array.<string>|null} [keys] NotificationKeys keys
         */

        /**
         * Constructs a new NotificationKeys.
         * @memberof pond
         * @classdesc Represents a NotificationKeys.
         * @implements INotificationKeys
         * @constructor
         * @param {pond.INotificationKeys=} [properties] Properties to set
         */
        function NotificationKeys(properties) {
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationKeys keys.
         * @member {Array.<string>} keys
         * @memberof pond.NotificationKeys
         * @instance
         */
        NotificationKeys.prototype.keys = $util.emptyArray;

        /**
         * Creates a new NotificationKeys instance using the specified properties.
         * @function create
         * @memberof pond.NotificationKeys
         * @static
         * @param {pond.INotificationKeys=} [properties] Properties to set
         * @returns {pond.NotificationKeys} NotificationKeys instance
         */
        NotificationKeys.create = function create(properties) {
            return new NotificationKeys(properties);
        };

        /**
         * Creates a NotificationKeys message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NotificationKeys
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NotificationKeys} NotificationKeys
         */
        NotificationKeys.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NotificationKeys)
                return object;
            var message = new $root.pond.NotificationKeys();
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.NotificationKeys.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a NotificationKeys message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NotificationKeys
         * @static
         * @param {pond.NotificationKeys} message NotificationKeys
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationKeys.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            return object;
        };

        /**
         * Converts this NotificationKeys to JSON.
         * @function toJSON
         * @memberof pond.NotificationKeys
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationKeys.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationKeys;
    })();

    pond.HideNotificationRequest = (function() {

        /**
         * Properties of a HideNotificationRequest.
         * @memberof pond
         * @interface IHideNotificationRequest
         * @property {pond.NotificationKeys|null} [notifications] HideNotificationRequest notifications
         */

        /**
         * Constructs a new HideNotificationRequest.
         * @memberof pond
         * @classdesc Represents a HideNotificationRequest.
         * @implements IHideNotificationRequest
         * @constructor
         * @param {pond.IHideNotificationRequest=} [properties] Properties to set
         */
        function HideNotificationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HideNotificationRequest notifications.
         * @member {pond.NotificationKeys|null|undefined} notifications
         * @memberof pond.HideNotificationRequest
         * @instance
         */
        HideNotificationRequest.prototype.notifications = null;

        /**
         * Creates a new HideNotificationRequest instance using the specified properties.
         * @function create
         * @memberof pond.HideNotificationRequest
         * @static
         * @param {pond.IHideNotificationRequest=} [properties] Properties to set
         * @returns {pond.HideNotificationRequest} HideNotificationRequest instance
         */
        HideNotificationRequest.create = function create(properties) {
            return new HideNotificationRequest(properties);
        };

        /**
         * Creates a HideNotificationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HideNotificationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HideNotificationRequest} HideNotificationRequest
         */
        HideNotificationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HideNotificationRequest)
                return object;
            var message = new $root.pond.HideNotificationRequest();
            if (object.notifications != null) {
                if (typeof object.notifications !== "object")
                    throw TypeError(".pond.HideNotificationRequest.notifications: object expected");
                message.notifications = $root.pond.NotificationKeys.fromObject(object.notifications);
            }
            return message;
        };

        /**
         * Creates a plain object from a HideNotificationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HideNotificationRequest
         * @static
         * @param {pond.HideNotificationRequest} message HideNotificationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HideNotificationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.notifications = null;
            if (message.notifications != null && message.hasOwnProperty("notifications"))
                object.notifications = $root.pond.NotificationKeys.toObject(message.notifications, options);
            return object;
        };

        /**
         * Converts this HideNotificationRequest to JSON.
         * @function toJSON
         * @memberof pond.HideNotificationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HideNotificationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HideNotificationRequest;
    })();

    pond.ShareNotificationRequest = (function() {

        /**
         * Properties of a ShareNotificationRequest.
         * @memberof pond
         * @interface IShareNotificationRequest
         * @property {string|null} [notification] ShareNotificationRequest notification
         * @property {string|null} [user] ShareNotificationRequest user
         */

        /**
         * Constructs a new ShareNotificationRequest.
         * @memberof pond
         * @classdesc Represents a ShareNotificationRequest.
         * @implements IShareNotificationRequest
         * @constructor
         * @param {pond.IShareNotificationRequest=} [properties] Properties to set
         */
        function ShareNotificationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShareNotificationRequest notification.
         * @member {string} notification
         * @memberof pond.ShareNotificationRequest
         * @instance
         */
        ShareNotificationRequest.prototype.notification = "";

        /**
         * ShareNotificationRequest user.
         * @member {string} user
         * @memberof pond.ShareNotificationRequest
         * @instance
         */
        ShareNotificationRequest.prototype.user = "";

        /**
         * Creates a new ShareNotificationRequest instance using the specified properties.
         * @function create
         * @memberof pond.ShareNotificationRequest
         * @static
         * @param {pond.IShareNotificationRequest=} [properties] Properties to set
         * @returns {pond.ShareNotificationRequest} ShareNotificationRequest instance
         */
        ShareNotificationRequest.create = function create(properties) {
            return new ShareNotificationRequest(properties);
        };

        /**
         * Creates a ShareNotificationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ShareNotificationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ShareNotificationRequest} ShareNotificationRequest
         */
        ShareNotificationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ShareNotificationRequest)
                return object;
            var message = new $root.pond.ShareNotificationRequest();
            if (object.notification != null)
                message.notification = String(object.notification);
            if (object.user != null)
                message.user = String(object.user);
            return message;
        };

        /**
         * Creates a plain object from a ShareNotificationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ShareNotificationRequest
         * @static
         * @param {pond.ShareNotificationRequest} message ShareNotificationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShareNotificationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.notification = "";
                object.user = "";
            }
            if (message.notification != null && message.hasOwnProperty("notification"))
                object.notification = message.notification;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            return object;
        };

        /**
         * Converts this ShareNotificationRequest to JSON.
         * @function toJSON
         * @memberof pond.ShareNotificationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShareNotificationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShareNotificationRequest;
    })();

    pond.AddNotificationResponse = (function() {

        /**
         * Properties of an AddNotificationResponse.
         * @memberof pond
         * @interface IAddNotificationResponse
         * @property {string|null} [key] AddNotificationResponse key
         */

        /**
         * Constructs a new AddNotificationResponse.
         * @memberof pond
         * @classdesc Represents an AddNotificationResponse.
         * @implements IAddNotificationResponse
         * @constructor
         * @param {pond.IAddNotificationResponse=} [properties] Properties to set
         */
        function AddNotificationResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNotificationResponse key.
         * @member {string} key
         * @memberof pond.AddNotificationResponse
         * @instance
         */
        AddNotificationResponse.prototype.key = "";

        /**
         * Creates a new AddNotificationResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddNotificationResponse
         * @static
         * @param {pond.IAddNotificationResponse=} [properties] Properties to set
         * @returns {pond.AddNotificationResponse} AddNotificationResponse instance
         */
        AddNotificationResponse.create = function create(properties) {
            return new AddNotificationResponse(properties);
        };

        /**
         * Creates an AddNotificationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNotificationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNotificationResponse} AddNotificationResponse
         */
        AddNotificationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNotificationResponse)
                return object;
            var message = new $root.pond.AddNotificationResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddNotificationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNotificationResponse
         * @static
         * @param {pond.AddNotificationResponse} message AddNotificationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNotificationResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddNotificationResponse to JSON.
         * @function toJSON
         * @memberof pond.AddNotificationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNotificationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNotificationResponse;
    })();

    pond.HideNotificationResponse = (function() {

        /**
         * Properties of a HideNotificationResponse.
         * @memberof pond
         * @interface IHideNotificationResponse
         */

        /**
         * Constructs a new HideNotificationResponse.
         * @memberof pond
         * @classdesc Represents a HideNotificationResponse.
         * @implements IHideNotificationResponse
         * @constructor
         * @param {pond.IHideNotificationResponse=} [properties] Properties to set
         */
        function HideNotificationResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new HideNotificationResponse instance using the specified properties.
         * @function create
         * @memberof pond.HideNotificationResponse
         * @static
         * @param {pond.IHideNotificationResponse=} [properties] Properties to set
         * @returns {pond.HideNotificationResponse} HideNotificationResponse instance
         */
        HideNotificationResponse.create = function create(properties) {
            return new HideNotificationResponse(properties);
        };

        /**
         * Creates a HideNotificationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HideNotificationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HideNotificationResponse} HideNotificationResponse
         */
        HideNotificationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HideNotificationResponse)
                return object;
            return new $root.pond.HideNotificationResponse();
        };

        /**
         * Creates a plain object from a HideNotificationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HideNotificationResponse
         * @static
         * @param {pond.HideNotificationResponse} message HideNotificationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HideNotificationResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this HideNotificationResponse to JSON.
         * @function toJSON
         * @memberof pond.HideNotificationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HideNotificationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HideNotificationResponse;
    })();

    pond.ShareNotificationResponse = (function() {

        /**
         * Properties of a ShareNotificationResponse.
         * @memberof pond
         * @interface IShareNotificationResponse
         */

        /**
         * Constructs a new ShareNotificationResponse.
         * @memberof pond
         * @classdesc Represents a ShareNotificationResponse.
         * @implements IShareNotificationResponse
         * @constructor
         * @param {pond.IShareNotificationResponse=} [properties] Properties to set
         */
        function ShareNotificationResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ShareNotificationResponse instance using the specified properties.
         * @function create
         * @memberof pond.ShareNotificationResponse
         * @static
         * @param {pond.IShareNotificationResponse=} [properties] Properties to set
         * @returns {pond.ShareNotificationResponse} ShareNotificationResponse instance
         */
        ShareNotificationResponse.create = function create(properties) {
            return new ShareNotificationResponse(properties);
        };

        /**
         * Creates a ShareNotificationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ShareNotificationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ShareNotificationResponse} ShareNotificationResponse
         */
        ShareNotificationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ShareNotificationResponse)
                return object;
            return new $root.pond.ShareNotificationResponse();
        };

        /**
         * Creates a plain object from a ShareNotificationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ShareNotificationResponse
         * @static
         * @param {pond.ShareNotificationResponse} message ShareNotificationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShareNotificationResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ShareNotificationResponse to JSON.
         * @function toJSON
         * @memberof pond.ShareNotificationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShareNotificationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShareNotificationResponse;
    })();

    pond.RemoveNoteRequest = (function() {

        /**
         * Properties of a RemoveNoteRequest.
         * @memberof pond
         * @interface IRemoveNoteRequest
         * @property {string|null} [note] RemoveNoteRequest note
         */

        /**
         * Constructs a new RemoveNoteRequest.
         * @memberof pond
         * @classdesc Represents a RemoveNoteRequest.
         * @implements IRemoveNoteRequest
         * @constructor
         * @param {pond.IRemoveNoteRequest=} [properties] Properties to set
         */
        function RemoveNoteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveNoteRequest note.
         * @member {string} note
         * @memberof pond.RemoveNoteRequest
         * @instance
         */
        RemoveNoteRequest.prototype.note = "";

        /**
         * Creates a new RemoveNoteRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveNoteRequest
         * @static
         * @param {pond.IRemoveNoteRequest=} [properties] Properties to set
         * @returns {pond.RemoveNoteRequest} RemoveNoteRequest instance
         */
        RemoveNoteRequest.create = function create(properties) {
            return new RemoveNoteRequest(properties);
        };

        /**
         * Creates a RemoveNoteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveNoteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveNoteRequest} RemoveNoteRequest
         */
        RemoveNoteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveNoteRequest)
                return object;
            var message = new $root.pond.RemoveNoteRequest();
            if (object.note != null)
                message.note = String(object.note);
            return message;
        };

        /**
         * Creates a plain object from a RemoveNoteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveNoteRequest
         * @static
         * @param {pond.RemoveNoteRequest} message RemoveNoteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveNoteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.note = "";
            if (message.note != null && message.hasOwnProperty("note"))
                object.note = message.note;
            return object;
        };

        /**
         * Converts this RemoveNoteRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveNoteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveNoteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveNoteRequest;
    })();

    pond.RemoveNoteResponse = (function() {

        /**
         * Properties of a RemoveNoteResponse.
         * @memberof pond
         * @interface IRemoveNoteResponse
         */

        /**
         * Constructs a new RemoveNoteResponse.
         * @memberof pond
         * @classdesc Represents a RemoveNoteResponse.
         * @implements IRemoveNoteResponse
         * @constructor
         * @param {pond.IRemoveNoteResponse=} [properties] Properties to set
         */
        function RemoveNoteResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveNoteResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveNoteResponse
         * @static
         * @param {pond.IRemoveNoteResponse=} [properties] Properties to set
         * @returns {pond.RemoveNoteResponse} RemoveNoteResponse instance
         */
        RemoveNoteResponse.create = function create(properties) {
            return new RemoveNoteResponse(properties);
        };

        /**
         * Creates a RemoveNoteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveNoteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveNoteResponse} RemoveNoteResponse
         */
        RemoveNoteResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveNoteResponse)
                return object;
            return new $root.pond.RemoveNoteResponse();
        };

        /**
         * Creates a plain object from a RemoveNoteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveNoteResponse
         * @static
         * @param {pond.RemoveNoteResponse} message RemoveNoteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveNoteResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveNoteResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveNoteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveNoteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveNoteResponse;
    })();

    pond.Shape = (function() {

        /**
         * Properties of a Shape.
         * @memberof pond
         * @interface IShape
         * @property {Array.<pond.Coordinates>|null} [points] Shape points
         * @property {number|null} [key] Shape key
         */

        /**
         * Constructs a new Shape.
         * @memberof pond
         * @classdesc Represents a Shape.
         * @implements IShape
         * @constructor
         * @param {pond.IShape=} [properties] Properties to set
         */
        function Shape(properties) {
            this.points = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Shape points.
         * @member {Array.<pond.Coordinates>} points
         * @memberof pond.Shape
         * @instance
         */
        Shape.prototype.points = $util.emptyArray;

        /**
         * Shape key.
         * @member {number} key
         * @memberof pond.Shape
         * @instance
         */
        Shape.prototype.key = 0;

        /**
         * Creates a new Shape instance using the specified properties.
         * @function create
         * @memberof pond.Shape
         * @static
         * @param {pond.IShape=} [properties] Properties to set
         * @returns {pond.Shape} Shape instance
         */
        Shape.create = function create(properties) {
            return new Shape(properties);
        };

        /**
         * Creates a Shape message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Shape
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Shape} Shape
         */
        Shape.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Shape)
                return object;
            var message = new $root.pond.Shape();
            if (object.points) {
                if (!Array.isArray(object.points))
                    throw TypeError(".pond.Shape.points: array expected");
                message.points = [];
                for (var i = 0; i < object.points.length; ++i) {
                    if (typeof object.points[i] !== "object")
                        throw TypeError(".pond.Shape.points: object expected");
                    message.points[i] = $root.pond.Coordinates.fromObject(object.points[i]);
                }
            }
            if (object.key != null)
                message.key = object.key | 0;
            return message;
        };

        /**
         * Creates a plain object from a Shape message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Shape
         * @static
         * @param {pond.Shape} message Shape
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Shape.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.points = [];
            if (options.defaults)
                object.key = 0;
            if (message.points && message.points.length) {
                object.points = [];
                for (var j = 0; j < message.points.length; ++j)
                    object.points[j] = $root.pond.Coordinates.toObject(message.points[j], options);
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this Shape to JSON.
         * @function toJSON
         * @memberof pond.Shape
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Shape.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Shape;
    })();

    /**
     * DataOrigin enum.
     * @name pond.DataOrigin
     * @enum {string}
     * @property {number} DATA_ORIGIN_UNKNOWN=0 DATA_ORIGIN_UNKNOWN value
     * @property {number} DATA_ORIGIN_ADAPTIVE=1 DATA_ORIGIN_ADAPTIVE value
     * @property {number} DATA_ORIGIN_JOHN_DEERE=2 DATA_ORIGIN_JOHN_DEERE value
     * @property {number} DATA_ORIGIN_CASE_NEW_HOLLAND=3 DATA_ORIGIN_CASE_NEW_HOLLAND value
     */
    pond.DataOrigin = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DATA_ORIGIN_UNKNOWN"] = 0;
        values[valuesById[1] = "DATA_ORIGIN_ADAPTIVE"] = 1;
        values[valuesById[2] = "DATA_ORIGIN_JOHN_DEERE"] = 2;
        values[valuesById[3] = "DATA_ORIGIN_CASE_NEW_HOLLAND"] = 3;
        return values;
    })();

    pond.GeoData = (function() {

        /**
         * Properties of a GeoData.
         * @memberof pond
         * @interface IGeoData
         * @property {string|null} [objectKey] GeoData objectKey
         * @property {string|null} [geoShape] GeoData geoShape
         * @property {string|null} [colour] GeoData colour
         * @property {Array.<pond.Shape>|null} [shapes] GeoData shapes
         * @property {Array.<pond.Shape>|null} [holes] GeoData holes
         * @property {string|null} [title] GeoData title
         * @property {pond.DataOrigin|null} [origin] GeoData origin
         */

        /**
         * Constructs a new GeoData.
         * @memberof pond
         * @classdesc Represents a GeoData.
         * @implements IGeoData
         * @constructor
         * @param {pond.IGeoData=} [properties] Properties to set
         */
        function GeoData(properties) {
            this.shapes = [];
            this.holes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GeoData objectKey.
         * @member {string} objectKey
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.objectKey = "";

        /**
         * GeoData geoShape.
         * @member {string} geoShape
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.geoShape = "";

        /**
         * GeoData colour.
         * @member {string} colour
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.colour = "";

        /**
         * GeoData shapes.
         * @member {Array.<pond.Shape>} shapes
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.shapes = $util.emptyArray;

        /**
         * GeoData holes.
         * @member {Array.<pond.Shape>} holes
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.holes = $util.emptyArray;

        /**
         * GeoData title.
         * @member {string} title
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.title = "";

        /**
         * GeoData origin.
         * @member {pond.DataOrigin} origin
         * @memberof pond.GeoData
         * @instance
         */
        GeoData.prototype.origin = 0;

        /**
         * Creates a new GeoData instance using the specified properties.
         * @function create
         * @memberof pond.GeoData
         * @static
         * @param {pond.IGeoData=} [properties] Properties to set
         * @returns {pond.GeoData} GeoData instance
         */
        GeoData.create = function create(properties) {
            return new GeoData(properties);
        };

        /**
         * Creates a GeoData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GeoData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GeoData} GeoData
         */
        GeoData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GeoData)
                return object;
            var message = new $root.pond.GeoData();
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.geoShape != null)
                message.geoShape = String(object.geoShape);
            if (object.colour != null)
                message.colour = String(object.colour);
            if (object.shapes) {
                if (!Array.isArray(object.shapes))
                    throw TypeError(".pond.GeoData.shapes: array expected");
                message.shapes = [];
                for (var i = 0; i < object.shapes.length; ++i) {
                    if (typeof object.shapes[i] !== "object")
                        throw TypeError(".pond.GeoData.shapes: object expected");
                    message.shapes[i] = $root.pond.Shape.fromObject(object.shapes[i]);
                }
            }
            if (object.holes) {
                if (!Array.isArray(object.holes))
                    throw TypeError(".pond.GeoData.holes: array expected");
                message.holes = [];
                for (var i = 0; i < object.holes.length; ++i) {
                    if (typeof object.holes[i] !== "object")
                        throw TypeError(".pond.GeoData.holes: object expected");
                    message.holes[i] = $root.pond.Shape.fromObject(object.holes[i]);
                }
            }
            if (object.title != null)
                message.title = String(object.title);
            switch (object.origin) {
            case "DATA_ORIGIN_UNKNOWN":
            case 0:
                message.origin = 0;
                break;
            case "DATA_ORIGIN_ADAPTIVE":
            case 1:
                message.origin = 1;
                break;
            case "DATA_ORIGIN_JOHN_DEERE":
            case 2:
                message.origin = 2;
                break;
            case "DATA_ORIGIN_CASE_NEW_HOLLAND":
            case 3:
                message.origin = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GeoData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GeoData
         * @static
         * @param {pond.GeoData} message GeoData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GeoData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.shapes = [];
                object.holes = [];
            }
            if (options.defaults) {
                object.objectKey = "";
                object.geoShape = "";
                object.colour = "";
                object.title = "";
                object.origin = options.enums === String ? "DATA_ORIGIN_UNKNOWN" : 0;
            }
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.geoShape != null && message.hasOwnProperty("geoShape"))
                object.geoShape = message.geoShape;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            if (message.shapes && message.shapes.length) {
                object.shapes = [];
                for (var j = 0; j < message.shapes.length; ++j)
                    object.shapes[j] = $root.pond.Shape.toObject(message.shapes[j], options);
            }
            if (message.holes && message.holes.length) {
                object.holes = [];
                for (var j = 0; j < message.holes.length; ++j)
                    object.holes[j] = $root.pond.Shape.toObject(message.holes[j], options);
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.origin != null && message.hasOwnProperty("origin"))
                object.origin = options.enums === String ? $root.pond.DataOrigin[message.origin] : message.origin;
            return object;
        };

        /**
         * Converts this GeoData to JSON.
         * @function toJSON
         * @memberof pond.GeoData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GeoData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GeoData;
    })();

    pond.Field = (function() {

        /**
         * Properties of a Field.
         * @memberof pond
         * @interface IField
         * @property {pond.FieldSettings|null} [settings] Field settings
         * @property {pond.FieldStatus|null} [status] Field status
         * @property {Array.<pond.Permission>|null} [fieldPermissions] Field fieldPermissions
         */

        /**
         * Constructs a new Field.
         * @memberof pond
         * @classdesc Represents a Field.
         * @implements IField
         * @constructor
         * @param {pond.IField=} [properties] Properties to set
         */
        function Field(properties) {
            this.fieldPermissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Field settings.
         * @member {pond.FieldSettings|null|undefined} settings
         * @memberof pond.Field
         * @instance
         */
        Field.prototype.settings = null;

        /**
         * Field status.
         * @member {pond.FieldStatus|null|undefined} status
         * @memberof pond.Field
         * @instance
         */
        Field.prototype.status = null;

        /**
         * Field fieldPermissions.
         * @member {Array.<pond.Permission>} fieldPermissions
         * @memberof pond.Field
         * @instance
         */
        Field.prototype.fieldPermissions = $util.emptyArray;

        /**
         * Creates a new Field instance using the specified properties.
         * @function create
         * @memberof pond.Field
         * @static
         * @param {pond.IField=} [properties] Properties to set
         * @returns {pond.Field} Field instance
         */
        Field.create = function create(properties) {
            return new Field(properties);
        };

        /**
         * Creates a Field message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Field
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Field} Field
         */
        Field.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Field)
                return object;
            var message = new $root.pond.Field();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Field.settings: object expected");
                message.settings = $root.pond.FieldSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Field.status: object expected");
                message.status = $root.pond.FieldStatus.fromObject(object.status);
            }
            if (object.fieldPermissions) {
                if (!Array.isArray(object.fieldPermissions))
                    throw TypeError(".pond.Field.fieldPermissions: array expected");
                message.fieldPermissions = [];
                for (var i = 0; i < object.fieldPermissions.length; ++i)
                    switch (object.fieldPermissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.fieldPermissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.fieldPermissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.fieldPermissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.fieldPermissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.fieldPermissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.fieldPermissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.fieldPermissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a Field message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Field
         * @static
         * @param {pond.Field} message Field
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Field.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fieldPermissions = [];
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.FieldSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.FieldStatus.toObject(message.status, options);
            if (message.fieldPermissions && message.fieldPermissions.length) {
                object.fieldPermissions = [];
                for (var j = 0; j < message.fieldPermissions.length; ++j)
                    object.fieldPermissions[j] = options.enums === String ? $root.pond.Permission[message.fieldPermissions[j]] : message.fieldPermissions[j];
            }
            return object;
        };

        /**
         * Converts this Field to JSON.
         * @function toJSON
         * @memberof pond.Field
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Field.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Field;
    })();

    pond.FieldSettings = (function() {

        /**
         * Properties of a FieldSettings.
         * @memberof pond
         * @interface IFieldSettings
         * @property {string|null} [key] FieldSettings key
         * @property {string|null} [userId] FieldSettings userId
         * @property {string|null} [objectKey] FieldSettings objectKey
         * @property {string|null} [fieldName] FieldSettings fieldName
         * @property {pond.Grain|null} [crop] FieldSettings crop
         * @property {string|null} [landLocation] FieldSettings landLocation
         * @property {Array.<pond.FieldMapping>|null} [fieldMapping] FieldSettings fieldMapping
         * @property {string|null} [grainSubtype] FieldSettings grainSubtype
         * @property {string|null} [geosysField] FieldSettings geosysField
         * @property {string|null} [sowingDate] FieldSettings sowingDate
         * @property {string|null} [customGrain] FieldSettings customGrain
         * @property {pond.GeoData|null} [fieldGeoData] FieldSettings fieldGeoData
         * @property {number|null} [bushelsPerTonne] FieldSettings bushelsPerTonne
         * @property {number|null} [acres] FieldSettings acres
         */

        /**
         * Constructs a new FieldSettings.
         * @memberof pond
         * @classdesc Represents a FieldSettings.
         * @implements IFieldSettings
         * @constructor
         * @param {pond.IFieldSettings=} [properties] Properties to set
         */
        function FieldSettings(properties) {
            this.fieldMapping = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldSettings key.
         * @member {string} key
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.key = "";

        /**
         * FieldSettings userId.
         * @member {string} userId
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.userId = "";

        /**
         * FieldSettings objectKey.
         * @member {string} objectKey
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.objectKey = "";

        /**
         * FieldSettings fieldName.
         * @member {string} fieldName
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.fieldName = "";

        /**
         * FieldSettings crop.
         * @member {pond.Grain} crop
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.crop = 0;

        /**
         * FieldSettings landLocation.
         * @member {string} landLocation
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.landLocation = "";

        /**
         * FieldSettings fieldMapping.
         * @member {Array.<pond.FieldMapping>} fieldMapping
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.fieldMapping = $util.emptyArray;

        /**
         * FieldSettings grainSubtype.
         * @member {string} grainSubtype
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.grainSubtype = "";

        /**
         * FieldSettings geosysField.
         * @member {string} geosysField
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.geosysField = "";

        /**
         * FieldSettings sowingDate.
         * @member {string} sowingDate
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.sowingDate = "";

        /**
         * FieldSettings customGrain.
         * @member {string} customGrain
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.customGrain = "";

        /**
         * FieldSettings fieldGeoData.
         * @member {pond.GeoData|null|undefined} fieldGeoData
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.fieldGeoData = null;

        /**
         * FieldSettings bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.bushelsPerTonne = 0;

        /**
         * FieldSettings acres.
         * @member {number} acres
         * @memberof pond.FieldSettings
         * @instance
         */
        FieldSettings.prototype.acres = 0;

        /**
         * Creates a new FieldSettings instance using the specified properties.
         * @function create
         * @memberof pond.FieldSettings
         * @static
         * @param {pond.IFieldSettings=} [properties] Properties to set
         * @returns {pond.FieldSettings} FieldSettings instance
         */
        FieldSettings.create = function create(properties) {
            return new FieldSettings(properties);
        };

        /**
         * Creates a FieldSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldSettings} FieldSettings
         */
        FieldSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldSettings)
                return object;
            var message = new $root.pond.FieldSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.fieldName != null)
                message.fieldName = String(object.fieldName);
            switch (object.crop) {
            case "GRAIN_INVALID":
            case 0:
                message.crop = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.crop = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.crop = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.crop = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.crop = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.crop = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.crop = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.crop = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.crop = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.crop = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.crop = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.crop = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.crop = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.crop = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.crop = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.crop = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.crop = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.crop = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.crop = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.crop = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.crop = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.crop = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.crop = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.crop = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.crop = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.crop = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.crop = 26;
                break;
            }
            if (object.landLocation != null)
                message.landLocation = String(object.landLocation);
            if (object.fieldMapping) {
                if (!Array.isArray(object.fieldMapping))
                    throw TypeError(".pond.FieldSettings.fieldMapping: array expected");
                message.fieldMapping = [];
                for (var i = 0; i < object.fieldMapping.length; ++i) {
                    if (typeof object.fieldMapping[i] !== "object")
                        throw TypeError(".pond.FieldSettings.fieldMapping: object expected");
                    message.fieldMapping[i] = $root.pond.FieldMapping.fromObject(object.fieldMapping[i]);
                }
            }
            if (object.grainSubtype != null)
                message.grainSubtype = String(object.grainSubtype);
            if (object.geosysField != null)
                message.geosysField = String(object.geosysField);
            if (object.sowingDate != null)
                message.sowingDate = String(object.sowingDate);
            if (object.customGrain != null)
                message.customGrain = String(object.customGrain);
            if (object.fieldGeoData != null) {
                if (typeof object.fieldGeoData !== "object")
                    throw TypeError(".pond.FieldSettings.fieldGeoData: object expected");
                message.fieldGeoData = $root.pond.GeoData.fromObject(object.fieldGeoData);
            }
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            if (object.acres != null)
                message.acres = Number(object.acres);
            return message;
        };

        /**
         * Creates a plain object from a FieldSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldSettings
         * @static
         * @param {pond.FieldSettings} message FieldSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fieldMapping = [];
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.objectKey = "";
                object.fieldName = "";
                object.crop = options.enums === String ? "GRAIN_INVALID" : 0;
                object.landLocation = "";
                object.grainSubtype = "";
                object.geosysField = "";
                object.sowingDate = "";
                object.customGrain = "";
                object.fieldGeoData = null;
                object.bushelsPerTonne = 0;
                object.acres = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.fieldName != null && message.hasOwnProperty("fieldName"))
                object.fieldName = message.fieldName;
            if (message.crop != null && message.hasOwnProperty("crop"))
                object.crop = options.enums === String ? $root.pond.Grain[message.crop] : message.crop;
            if (message.landLocation != null && message.hasOwnProperty("landLocation"))
                object.landLocation = message.landLocation;
            if (message.fieldMapping && message.fieldMapping.length) {
                object.fieldMapping = [];
                for (var j = 0; j < message.fieldMapping.length; ++j)
                    object.fieldMapping[j] = $root.pond.FieldMapping.toObject(message.fieldMapping[j], options);
            }
            if (message.grainSubtype != null && message.hasOwnProperty("grainSubtype"))
                object.grainSubtype = message.grainSubtype;
            if (message.geosysField != null && message.hasOwnProperty("geosysField"))
                object.geosysField = message.geosysField;
            if (message.sowingDate != null && message.hasOwnProperty("sowingDate"))
                object.sowingDate = message.sowingDate;
            if (message.customGrain != null && message.hasOwnProperty("customGrain"))
                object.customGrain = message.customGrain;
            if (message.fieldGeoData != null && message.hasOwnProperty("fieldGeoData"))
                object.fieldGeoData = $root.pond.GeoData.toObject(message.fieldGeoData, options);
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            if (message.acres != null && message.hasOwnProperty("acres"))
                object.acres = options.json && !isFinite(message.acres) ? String(message.acres) : message.acres;
            return object;
        };

        /**
         * Converts this FieldSettings to JSON.
         * @function toJSON
         * @memberof pond.FieldSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldSettings;
    })();

    pond.FieldMapping = (function() {

        /**
         * Properties of a FieldMapping.
         * @memberof pond
         * @interface IFieldMapping
         * @property {string|null} [key] FieldMapping key
         * @property {string|null} [type] FieldMapping type
         * @property {pond.Properties|null} [properties] FieldMapping properties
         * @property {pond.Geometry|null} [geometry] FieldMapping geometry
         */

        /**
         * Constructs a new FieldMapping.
         * @memberof pond
         * @classdesc Represents a FieldMapping.
         * @implements IFieldMapping
         * @constructor
         * @param {pond.IFieldMapping=} [properties] Properties to set
         */
        function FieldMapping(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldMapping key.
         * @member {string} key
         * @memberof pond.FieldMapping
         * @instance
         */
        FieldMapping.prototype.key = "";

        /**
         * FieldMapping type.
         * @member {string} type
         * @memberof pond.FieldMapping
         * @instance
         */
        FieldMapping.prototype.type = "";

        /**
         * FieldMapping properties.
         * @member {pond.Properties|null|undefined} properties
         * @memberof pond.FieldMapping
         * @instance
         */
        FieldMapping.prototype.properties = null;

        /**
         * FieldMapping geometry.
         * @member {pond.Geometry|null|undefined} geometry
         * @memberof pond.FieldMapping
         * @instance
         */
        FieldMapping.prototype.geometry = null;

        /**
         * Creates a new FieldMapping instance using the specified properties.
         * @function create
         * @memberof pond.FieldMapping
         * @static
         * @param {pond.IFieldMapping=} [properties] Properties to set
         * @returns {pond.FieldMapping} FieldMapping instance
         */
        FieldMapping.create = function create(properties) {
            return new FieldMapping(properties);
        };

        /**
         * Creates a FieldMapping message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldMapping
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldMapping} FieldMapping
         */
        FieldMapping.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldMapping)
                return object;
            var message = new $root.pond.FieldMapping();
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                message.type = String(object.type);
            if (object.properties != null) {
                if (typeof object.properties !== "object")
                    throw TypeError(".pond.FieldMapping.properties: object expected");
                message.properties = $root.pond.Properties.fromObject(object.properties);
            }
            if (object.geometry != null) {
                if (typeof object.geometry !== "object")
                    throw TypeError(".pond.FieldMapping.geometry: object expected");
                message.geometry = $root.pond.Geometry.fromObject(object.geometry);
            }
            return message;
        };

        /**
         * Creates a plain object from a FieldMapping message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldMapping
         * @static
         * @param {pond.FieldMapping} message FieldMapping
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldMapping.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.type = "";
                object.properties = null;
                object.geometry = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.properties != null && message.hasOwnProperty("properties"))
                object.properties = $root.pond.Properties.toObject(message.properties, options);
            if (message.geometry != null && message.hasOwnProperty("geometry"))
                object.geometry = $root.pond.Geometry.toObject(message.geometry, options);
            return object;
        };

        /**
         * Converts this FieldMapping to JSON.
         * @function toJSON
         * @memberof pond.FieldMapping
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldMapping.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldMapping;
    })();

    pond.Properties = (function() {

        /**
         * Properties of a Properties.
         * @memberof pond
         * @interface IProperties
         * @property {boolean|null} [exclusion] Properties exclusion
         * @property {string|null} [field] Properties field
         * @property {boolean|null} [main] Properties main
         * @property {string|null} [color] Properties color
         */

        /**
         * Constructs a new Properties.
         * @memberof pond
         * @classdesc Represents a Properties.
         * @implements IProperties
         * @constructor
         * @param {pond.IProperties=} [properties] Properties to set
         */
        function Properties(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Properties exclusion.
         * @member {boolean} exclusion
         * @memberof pond.Properties
         * @instance
         */
        Properties.prototype.exclusion = false;

        /**
         * Properties field.
         * @member {string} field
         * @memberof pond.Properties
         * @instance
         */
        Properties.prototype.field = "";

        /**
         * Properties main.
         * @member {boolean} main
         * @memberof pond.Properties
         * @instance
         */
        Properties.prototype.main = false;

        /**
         * Properties color.
         * @member {string} color
         * @memberof pond.Properties
         * @instance
         */
        Properties.prototype.color = "";

        /**
         * Creates a new Properties instance using the specified properties.
         * @function create
         * @memberof pond.Properties
         * @static
         * @param {pond.IProperties=} [properties] Properties to set
         * @returns {pond.Properties} Properties instance
         */
        Properties.create = function create(properties) {
            return new Properties(properties);
        };

        /**
         * Creates a Properties message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Properties
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Properties} Properties
         */
        Properties.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Properties)
                return object;
            var message = new $root.pond.Properties();
            if (object.exclusion != null)
                message.exclusion = Boolean(object.exclusion);
            if (object.field != null)
                message.field = String(object.field);
            if (object.main != null)
                message.main = Boolean(object.main);
            if (object.color != null)
                message.color = String(object.color);
            return message;
        };

        /**
         * Creates a plain object from a Properties message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Properties
         * @static
         * @param {pond.Properties} message Properties
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Properties.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.exclusion = false;
                object.field = "";
                object.main = false;
                object.color = "";
            }
            if (message.exclusion != null && message.hasOwnProperty("exclusion"))
                object.exclusion = message.exclusion;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            if (message.main != null && message.hasOwnProperty("main"))
                object.main = message.main;
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            return object;
        };

        /**
         * Converts this Properties to JSON.
         * @function toJSON
         * @memberof pond.Properties
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Properties.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Properties;
    })();

    pond.Geometry = (function() {

        /**
         * Properties of a Geometry.
         * @memberof pond
         * @interface IGeometry
         * @property {Array.<pond.Coordinates>|null} [coordinates] Geometry coordinates
         * @property {string|null} [type] Geometry type
         */

        /**
         * Constructs a new Geometry.
         * @memberof pond
         * @classdesc Represents a Geometry.
         * @implements IGeometry
         * @constructor
         * @param {pond.IGeometry=} [properties] Properties to set
         */
        function Geometry(properties) {
            this.coordinates = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Geometry coordinates.
         * @member {Array.<pond.Coordinates>} coordinates
         * @memberof pond.Geometry
         * @instance
         */
        Geometry.prototype.coordinates = $util.emptyArray;

        /**
         * Geometry type.
         * @member {string} type
         * @memberof pond.Geometry
         * @instance
         */
        Geometry.prototype.type = "";

        /**
         * Creates a new Geometry instance using the specified properties.
         * @function create
         * @memberof pond.Geometry
         * @static
         * @param {pond.IGeometry=} [properties] Properties to set
         * @returns {pond.Geometry} Geometry instance
         */
        Geometry.create = function create(properties) {
            return new Geometry(properties);
        };

        /**
         * Creates a Geometry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Geometry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Geometry} Geometry
         */
        Geometry.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Geometry)
                return object;
            var message = new $root.pond.Geometry();
            if (object.coordinates) {
                if (!Array.isArray(object.coordinates))
                    throw TypeError(".pond.Geometry.coordinates: array expected");
                message.coordinates = [];
                for (var i = 0; i < object.coordinates.length; ++i) {
                    if (typeof object.coordinates[i] !== "object")
                        throw TypeError(".pond.Geometry.coordinates: object expected");
                    message.coordinates[i] = $root.pond.Coordinates.fromObject(object.coordinates[i]);
                }
            }
            if (object.type != null)
                message.type = String(object.type);
            return message;
        };

        /**
         * Creates a plain object from a Geometry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Geometry
         * @static
         * @param {pond.Geometry} message Geometry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Geometry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coordinates = [];
            if (options.defaults)
                object.type = "";
            if (message.coordinates && message.coordinates.length) {
                object.coordinates = [];
                for (var j = 0; j < message.coordinates.length; ++j)
                    object.coordinates[j] = $root.pond.Coordinates.toObject(message.coordinates[j], options);
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this Geometry to JSON.
         * @function toJSON
         * @memberof pond.Geometry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Geometry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Geometry;
    })();

    pond.Coordinates = (function() {

        /**
         * Properties of a Coordinates.
         * @memberof pond
         * @interface ICoordinates
         * @property {number|null} [longitude] Coordinates longitude
         * @property {number|null} [latitude] Coordinates latitude
         */

        /**
         * Constructs a new Coordinates.
         * @memberof pond
         * @classdesc Represents a Coordinates.
         * @implements ICoordinates
         * @constructor
         * @param {pond.ICoordinates=} [properties] Properties to set
         */
        function Coordinates(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Coordinates longitude.
         * @member {number} longitude
         * @memberof pond.Coordinates
         * @instance
         */
        Coordinates.prototype.longitude = 0;

        /**
         * Coordinates latitude.
         * @member {number} latitude
         * @memberof pond.Coordinates
         * @instance
         */
        Coordinates.prototype.latitude = 0;

        /**
         * Creates a new Coordinates instance using the specified properties.
         * @function create
         * @memberof pond.Coordinates
         * @static
         * @param {pond.ICoordinates=} [properties] Properties to set
         * @returns {pond.Coordinates} Coordinates instance
         */
        Coordinates.create = function create(properties) {
            return new Coordinates(properties);
        };

        /**
         * Creates a Coordinates message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Coordinates
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Coordinates} Coordinates
         */
        Coordinates.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Coordinates)
                return object;
            var message = new $root.pond.Coordinates();
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            return message;
        };

        /**
         * Creates a plain object from a Coordinates message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Coordinates
         * @static
         * @param {pond.Coordinates} message Coordinates
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Coordinates.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.longitude = 0;
                object.latitude = 0;
            }
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            return object;
        };

        /**
         * Converts this Coordinates to JSON.
         * @function toJSON
         * @memberof pond.Coordinates
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Coordinates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Coordinates;
    })();

    pond.FieldStatus = (function() {

        /**
         * Properties of a FieldStatus.
         * @memberof pond
         * @interface IFieldStatus
         * @property {string|null} [timestamp] FieldStatus timestamp
         */

        /**
         * Constructs a new FieldStatus.
         * @memberof pond
         * @classdesc Represents a FieldStatus.
         * @implements IFieldStatus
         * @constructor
         * @param {pond.IFieldStatus=} [properties] Properties to set
         */
        function FieldStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.FieldStatus
         * @instance
         */
        FieldStatus.prototype.timestamp = "";

        /**
         * Creates a new FieldStatus instance using the specified properties.
         * @function create
         * @memberof pond.FieldStatus
         * @static
         * @param {pond.IFieldStatus=} [properties] Properties to set
         * @returns {pond.FieldStatus} FieldStatus instance
         */
        FieldStatus.create = function create(properties) {
            return new FieldStatus(properties);
        };

        /**
         * Creates a FieldStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldStatus} FieldStatus
         */
        FieldStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldStatus)
                return object;
            var message = new $root.pond.FieldStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a FieldStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldStatus
         * @static
         * @param {pond.FieldStatus} message FieldStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this FieldStatus to JSON.
         * @function toJSON
         * @memberof pond.FieldStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldStatus;
    })();

    pond.GetFieldRequest = (function() {

        /**
         * Properties of a GetFieldRequest.
         * @memberof pond
         * @interface IGetFieldRequest
         * @property {string|null} [field] GetFieldRequest field
         */

        /**
         * Constructs a new GetFieldRequest.
         * @memberof pond
         * @classdesc Represents a GetFieldRequest.
         * @implements IGetFieldRequest
         * @constructor
         * @param {pond.IGetFieldRequest=} [properties] Properties to set
         */
        function GetFieldRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFieldRequest field.
         * @member {string} field
         * @memberof pond.GetFieldRequest
         * @instance
         */
        GetFieldRequest.prototype.field = "";

        /**
         * Creates a new GetFieldRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetFieldRequest
         * @static
         * @param {pond.IGetFieldRequest=} [properties] Properties to set
         * @returns {pond.GetFieldRequest} GetFieldRequest instance
         */
        GetFieldRequest.create = function create(properties) {
            return new GetFieldRequest(properties);
        };

        /**
         * Creates a GetFieldRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetFieldRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetFieldRequest} GetFieldRequest
         */
        GetFieldRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetFieldRequest)
                return object;
            var message = new $root.pond.GetFieldRequest();
            if (object.field != null)
                message.field = String(object.field);
            return message;
        };

        /**
         * Creates a plain object from a GetFieldRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetFieldRequest
         * @static
         * @param {pond.GetFieldRequest} message GetFieldRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFieldRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.field = "";
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            return object;
        };

        /**
         * Converts this GetFieldRequest to JSON.
         * @function toJSON
         * @memberof pond.GetFieldRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFieldRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetFieldRequest;
    })();

    pond.AddFieldRequest = (function() {

        /**
         * Properties of an AddFieldRequest.
         * @memberof pond
         * @interface IAddFieldRequest
         * @property {pond.FieldSettings|null} [field] AddFieldRequest field
         */

        /**
         * Constructs a new AddFieldRequest.
         * @memberof pond
         * @classdesc Represents an AddFieldRequest.
         * @implements IAddFieldRequest
         * @constructor
         * @param {pond.IAddFieldRequest=} [properties] Properties to set
         */
        function AddFieldRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFieldRequest field.
         * @member {pond.FieldSettings|null|undefined} field
         * @memberof pond.AddFieldRequest
         * @instance
         */
        AddFieldRequest.prototype.field = null;

        /**
         * Creates a new AddFieldRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddFieldRequest
         * @static
         * @param {pond.IAddFieldRequest=} [properties] Properties to set
         * @returns {pond.AddFieldRequest} AddFieldRequest instance
         */
        AddFieldRequest.create = function create(properties) {
            return new AddFieldRequest(properties);
        };

        /**
         * Creates an AddFieldRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFieldRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFieldRequest} AddFieldRequest
         */
        AddFieldRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFieldRequest)
                return object;
            var message = new $root.pond.AddFieldRequest();
            if (object.field != null) {
                if (typeof object.field !== "object")
                    throw TypeError(".pond.AddFieldRequest.field: object expected");
                message.field = $root.pond.FieldSettings.fromObject(object.field);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddFieldRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFieldRequest
         * @static
         * @param {pond.AddFieldRequest} message AddFieldRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFieldRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.field = null;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = $root.pond.FieldSettings.toObject(message.field, options);
            return object;
        };

        /**
         * Converts this AddFieldRequest to JSON.
         * @function toJSON
         * @memberof pond.AddFieldRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFieldRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFieldRequest;
    })();

    pond.AddFieldResponse = (function() {

        /**
         * Properties of an AddFieldResponse.
         * @memberof pond
         * @interface IAddFieldResponse
         * @property {string|null} [field] AddFieldResponse field
         */

        /**
         * Constructs a new AddFieldResponse.
         * @memberof pond
         * @classdesc Represents an AddFieldResponse.
         * @implements IAddFieldResponse
         * @constructor
         * @param {pond.IAddFieldResponse=} [properties] Properties to set
         */
        function AddFieldResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFieldResponse field.
         * @member {string} field
         * @memberof pond.AddFieldResponse
         * @instance
         */
        AddFieldResponse.prototype.field = "";

        /**
         * Creates a new AddFieldResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddFieldResponse
         * @static
         * @param {pond.IAddFieldResponse=} [properties] Properties to set
         * @returns {pond.AddFieldResponse} AddFieldResponse instance
         */
        AddFieldResponse.create = function create(properties) {
            return new AddFieldResponse(properties);
        };

        /**
         * Creates an AddFieldResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFieldResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFieldResponse} AddFieldResponse
         */
        AddFieldResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFieldResponse)
                return object;
            var message = new $root.pond.AddFieldResponse();
            if (object.field != null)
                message.field = String(object.field);
            return message;
        };

        /**
         * Creates a plain object from an AddFieldResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFieldResponse
         * @static
         * @param {pond.AddFieldResponse} message AddFieldResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFieldResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.field = "";
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            return object;
        };

        /**
         * Converts this AddFieldResponse to JSON.
         * @function toJSON
         * @memberof pond.AddFieldResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFieldResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFieldResponse;
    })();

    pond.ListFieldsRequest = (function() {

        /**
         * Properties of a ListFieldsRequest.
         * @memberof pond
         * @interface IListFieldsRequest
         * @property {string|null} [key] ListFieldsRequest key
         * @property {string|null} [userId] ListFieldsRequest userId
         * @property {pond.Paging|null} [paging] ListFieldsRequest paging
         * @property {pond.Sorting|null} [sorting] ListFieldsRequest sorting
         * @property {string|null} [search] ListFieldsRequest search
         * @property {pond.FieldSettings|null} [settingsMatch] ListFieldsRequest settingsMatch
         * @property {pond.FieldStatus|null} [statusMatch] ListFieldsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListFieldsRequest fieldContains
         */

        /**
         * Constructs a new ListFieldsRequest.
         * @memberof pond
         * @classdesc Represents a ListFieldsRequest.
         * @implements IListFieldsRequest
         * @constructor
         * @param {pond.IListFieldsRequest=} [properties] Properties to set
         */
        function ListFieldsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFieldsRequest key.
         * @member {string} key
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.key = "";

        /**
         * ListFieldsRequest userId.
         * @member {string} userId
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.userId = "";

        /**
         * ListFieldsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.paging = null;

        /**
         * ListFieldsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.sorting = null;

        /**
         * ListFieldsRequest search.
         * @member {string} search
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.search = "";

        /**
         * ListFieldsRequest settingsMatch.
         * @member {pond.FieldSettings|null|undefined} settingsMatch
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.settingsMatch = null;

        /**
         * ListFieldsRequest statusMatch.
         * @member {pond.FieldStatus|null|undefined} statusMatch
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.statusMatch = null;

        /**
         * ListFieldsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListFieldsRequest
         * @instance
         */
        ListFieldsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListFieldsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListFieldsRequest
         * @static
         * @param {pond.IListFieldsRequest=} [properties] Properties to set
         * @returns {pond.ListFieldsRequest} ListFieldsRequest instance
         */
        ListFieldsRequest.create = function create(properties) {
            return new ListFieldsRequest(properties);
        };

        /**
         * Creates a ListFieldsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFieldsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFieldsRequest} ListFieldsRequest
         */
        ListFieldsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFieldsRequest)
                return object;
            var message = new $root.pond.ListFieldsRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListFieldsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListFieldsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListFieldsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.FieldSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListFieldsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.FieldStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListFieldsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFieldsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFieldsRequest
         * @static
         * @param {pond.ListFieldsRequest} message ListFieldsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFieldsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.FieldSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.FieldStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListFieldsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListFieldsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFieldsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFieldsRequest;
    })();

    pond.ListFieldsResponse = (function() {

        /**
         * Properties of a ListFieldsResponse.
         * @memberof pond
         * @interface IListFieldsResponse
         * @property {Array.<pond.Field>|null} [fields] ListFieldsResponse fields
         * @property {number|null} [nextOffset] ListFieldsResponse nextOffset
         * @property {number|null} [total] ListFieldsResponse total
         */

        /**
         * Constructs a new ListFieldsResponse.
         * @memberof pond
         * @classdesc Represents a ListFieldsResponse.
         * @implements IListFieldsResponse
         * @constructor
         * @param {pond.IListFieldsResponse=} [properties] Properties to set
         */
        function ListFieldsResponse(properties) {
            this.fields = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFieldsResponse fields.
         * @member {Array.<pond.Field>} fields
         * @memberof pond.ListFieldsResponse
         * @instance
         */
        ListFieldsResponse.prototype.fields = $util.emptyArray;

        /**
         * ListFieldsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListFieldsResponse
         * @instance
         */
        ListFieldsResponse.prototype.nextOffset = 0;

        /**
         * ListFieldsResponse total.
         * @member {number} total
         * @memberof pond.ListFieldsResponse
         * @instance
         */
        ListFieldsResponse.prototype.total = 0;

        /**
         * Creates a new ListFieldsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListFieldsResponse
         * @static
         * @param {pond.IListFieldsResponse=} [properties] Properties to set
         * @returns {pond.ListFieldsResponse} ListFieldsResponse instance
         */
        ListFieldsResponse.create = function create(properties) {
            return new ListFieldsResponse(properties);
        };

        /**
         * Creates a ListFieldsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFieldsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFieldsResponse} ListFieldsResponse
         */
        ListFieldsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFieldsResponse)
                return object;
            var message = new $root.pond.ListFieldsResponse();
            if (object.fields) {
                if (!Array.isArray(object.fields))
                    throw TypeError(".pond.ListFieldsResponse.fields: array expected");
                message.fields = [];
                for (var i = 0; i < object.fields.length; ++i) {
                    if (typeof object.fields[i] !== "object")
                        throw TypeError(".pond.ListFieldsResponse.fields: object expected");
                    message.fields[i] = $root.pond.Field.fromObject(object.fields[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListFieldsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFieldsResponse
         * @static
         * @param {pond.ListFieldsResponse} message ListFieldsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFieldsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fields = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.fields && message.fields.length) {
                object.fields = [];
                for (var j = 0; j < message.fields.length; ++j)
                    object.fields[j] = $root.pond.Field.toObject(message.fields[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListFieldsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListFieldsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFieldsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFieldsResponse;
    })();

    pond.RemoveFieldRequest = (function() {

        /**
         * Properties of a RemoveFieldRequest.
         * @memberof pond
         * @interface IRemoveFieldRequest
         * @property {string|null} [field] RemoveFieldRequest field
         */

        /**
         * Constructs a new RemoveFieldRequest.
         * @memberof pond
         * @classdesc Represents a RemoveFieldRequest.
         * @implements IRemoveFieldRequest
         * @constructor
         * @param {pond.IRemoveFieldRequest=} [properties] Properties to set
         */
        function RemoveFieldRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFieldRequest field.
         * @member {string} field
         * @memberof pond.RemoveFieldRequest
         * @instance
         */
        RemoveFieldRequest.prototype.field = "";

        /**
         * Creates a new RemoveFieldRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFieldRequest
         * @static
         * @param {pond.IRemoveFieldRequest=} [properties] Properties to set
         * @returns {pond.RemoveFieldRequest} RemoveFieldRequest instance
         */
        RemoveFieldRequest.create = function create(properties) {
            return new RemoveFieldRequest(properties);
        };

        /**
         * Creates a RemoveFieldRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFieldRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFieldRequest} RemoveFieldRequest
         */
        RemoveFieldRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFieldRequest)
                return object;
            var message = new $root.pond.RemoveFieldRequest();
            if (object.field != null)
                message.field = String(object.field);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFieldRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFieldRequest
         * @static
         * @param {pond.RemoveFieldRequest} message RemoveFieldRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFieldRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.field = "";
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            return object;
        };

        /**
         * Converts this RemoveFieldRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveFieldRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFieldRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFieldRequest;
    })();

    pond.RemoveFieldResponse = (function() {

        /**
         * Properties of a RemoveFieldResponse.
         * @memberof pond
         * @interface IRemoveFieldResponse
         */

        /**
         * Constructs a new RemoveFieldResponse.
         * @memberof pond
         * @classdesc Represents a RemoveFieldResponse.
         * @implements IRemoveFieldResponse
         * @constructor
         * @param {pond.IRemoveFieldResponse=} [properties] Properties to set
         */
        function RemoveFieldResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveFieldResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFieldResponse
         * @static
         * @param {pond.IRemoveFieldResponse=} [properties] Properties to set
         * @returns {pond.RemoveFieldResponse} RemoveFieldResponse instance
         */
        RemoveFieldResponse.create = function create(properties) {
            return new RemoveFieldResponse(properties);
        };

        /**
         * Creates a RemoveFieldResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFieldResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFieldResponse} RemoveFieldResponse
         */
        RemoveFieldResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFieldResponse)
                return object;
            return new $root.pond.RemoveFieldResponse();
        };

        /**
         * Creates a plain object from a RemoveFieldResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFieldResponse
         * @static
         * @param {pond.RemoveFieldResponse} message RemoveFieldResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFieldResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveFieldResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveFieldResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFieldResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFieldResponse;
    })();

    pond.UpdateFieldRequest = (function() {

        /**
         * Properties of an UpdateFieldRequest.
         * @memberof pond
         * @interface IUpdateFieldRequest
         * @property {pond.FieldSettings|null} [field] UpdateFieldRequest field
         */

        /**
         * Constructs a new UpdateFieldRequest.
         * @memberof pond
         * @classdesc Represents an UpdateFieldRequest.
         * @implements IUpdateFieldRequest
         * @constructor
         * @param {pond.IUpdateFieldRequest=} [properties] Properties to set
         */
        function UpdateFieldRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateFieldRequest field.
         * @member {pond.FieldSettings|null|undefined} field
         * @memberof pond.UpdateFieldRequest
         * @instance
         */
        UpdateFieldRequest.prototype.field = null;

        /**
         * Creates a new UpdateFieldRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFieldRequest
         * @static
         * @param {pond.IUpdateFieldRequest=} [properties] Properties to set
         * @returns {pond.UpdateFieldRequest} UpdateFieldRequest instance
         */
        UpdateFieldRequest.create = function create(properties) {
            return new UpdateFieldRequest(properties);
        };

        /**
         * Creates an UpdateFieldRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFieldRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFieldRequest} UpdateFieldRequest
         */
        UpdateFieldRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFieldRequest)
                return object;
            var message = new $root.pond.UpdateFieldRequest();
            if (object.field != null) {
                if (typeof object.field !== "object")
                    throw TypeError(".pond.UpdateFieldRequest.field: object expected");
                message.field = $root.pond.FieldSettings.fromObject(object.field);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateFieldRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFieldRequest
         * @static
         * @param {pond.UpdateFieldRequest} message UpdateFieldRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFieldRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.field = null;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = $root.pond.FieldSettings.toObject(message.field, options);
            return object;
        };

        /**
         * Converts this UpdateFieldRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateFieldRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFieldRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFieldRequest;
    })();

    pond.UpdateFieldResponse = (function() {

        /**
         * Properties of an UpdateFieldResponse.
         * @memberof pond
         * @interface IUpdateFieldResponse
         */

        /**
         * Constructs a new UpdateFieldResponse.
         * @memberof pond
         * @classdesc Represents an UpdateFieldResponse.
         * @implements IUpdateFieldResponse
         * @constructor
         * @param {pond.IUpdateFieldResponse=} [properties] Properties to set
         */
        function UpdateFieldResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateFieldResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFieldResponse
         * @static
         * @param {pond.IUpdateFieldResponse=} [properties] Properties to set
         * @returns {pond.UpdateFieldResponse} UpdateFieldResponse instance
         */
        UpdateFieldResponse.create = function create(properties) {
            return new UpdateFieldResponse(properties);
        };

        /**
         * Creates an UpdateFieldResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFieldResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFieldResponse} UpdateFieldResponse
         */
        UpdateFieldResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFieldResponse)
                return object;
            return new $root.pond.UpdateFieldResponse();
        };

        /**
         * Creates a plain object from an UpdateFieldResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFieldResponse
         * @static
         * @param {pond.UpdateFieldResponse} message UpdateFieldResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFieldResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateFieldResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateFieldResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFieldResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFieldResponse;
    })();

    /**
     * FieldMarkerType enum.
     * @name pond.FieldMarkerType
     * @enum {string}
     * @property {number} FIELD_MARKER_TYPE_PESTS=0 FIELD_MARKER_TYPE_PESTS value
     * @property {number} FIELD_MARKER_TYPE_WEEDS=1 FIELD_MARKER_TYPE_WEEDS value
     * @property {number} FIELD_MARKER_TYPE_DISEASE=2 FIELD_MARKER_TYPE_DISEASE value
     * @property {number} FIELD_MARKER_TYPE_OTHER=3 FIELD_MARKER_TYPE_OTHER value
     * @property {number} FIELD_MARKER_TYPE_ROCKS=4 FIELD_MARKER_TYPE_ROCKS value
     */
    pond.FieldMarkerType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FIELD_MARKER_TYPE_PESTS"] = 0;
        values[valuesById[1] = "FIELD_MARKER_TYPE_WEEDS"] = 1;
        values[valuesById[2] = "FIELD_MARKER_TYPE_DISEASE"] = 2;
        values[valuesById[3] = "FIELD_MARKER_TYPE_OTHER"] = 3;
        values[valuesById[4] = "FIELD_MARKER_TYPE_ROCKS"] = 4;
        return values;
    })();

    pond.FieldMarker = (function() {

        /**
         * Properties of a FieldMarker.
         * @memberof pond
         * @interface IFieldMarker
         * @property {pond.FieldMarkerSettings|null} [settings] FieldMarker settings
         * @property {pond.FieldMarkerStatus|null} [status] FieldMarker status
         */

        /**
         * Constructs a new FieldMarker.
         * @memberof pond
         * @classdesc Represents a FieldMarker.
         * @implements IFieldMarker
         * @constructor
         * @param {pond.IFieldMarker=} [properties] Properties to set
         */
        function FieldMarker(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldMarker settings.
         * @member {pond.FieldMarkerSettings|null|undefined} settings
         * @memberof pond.FieldMarker
         * @instance
         */
        FieldMarker.prototype.settings = null;

        /**
         * FieldMarker status.
         * @member {pond.FieldMarkerStatus|null|undefined} status
         * @memberof pond.FieldMarker
         * @instance
         */
        FieldMarker.prototype.status = null;

        /**
         * Creates a new FieldMarker instance using the specified properties.
         * @function create
         * @memberof pond.FieldMarker
         * @static
         * @param {pond.IFieldMarker=} [properties] Properties to set
         * @returns {pond.FieldMarker} FieldMarker instance
         */
        FieldMarker.create = function create(properties) {
            return new FieldMarker(properties);
        };

        /**
         * Creates a FieldMarker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldMarker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldMarker} FieldMarker
         */
        FieldMarker.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldMarker)
                return object;
            var message = new $root.pond.FieldMarker();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.FieldMarker.settings: object expected");
                message.settings = $root.pond.FieldMarkerSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.FieldMarker.status: object expected");
                message.status = $root.pond.FieldMarkerStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a FieldMarker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldMarker
         * @static
         * @param {pond.FieldMarker} message FieldMarker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldMarker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.FieldMarkerSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.FieldMarkerStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this FieldMarker to JSON.
         * @function toJSON
         * @memberof pond.FieldMarker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldMarker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldMarker;
    })();

    pond.FieldMarkerSettings = (function() {

        /**
         * Properties of a FieldMarkerSettings.
         * @memberof pond
         * @interface IFieldMarkerSettings
         * @property {string|null} [key] FieldMarkerSettings key
         * @property {number|null} [longitude] FieldMarkerSettings longitude
         * @property {number|null} [latitude] FieldMarkerSettings latitude
         * @property {string|null} [description] FieldMarkerSettings description
         * @property {pond.ObjectTheme|null} [theme] FieldMarkerSettings theme
         * @property {pond.FieldMarkerType|null} [type] FieldMarkerSettings type
         * @property {string|null} [name] FieldMarkerSettings name
         * @property {number|null} [severity] FieldMarkerSettings severity
         * @property {number|null} [affectedArea] FieldMarkerSettings affectedArea
         */

        /**
         * Constructs a new FieldMarkerSettings.
         * @memberof pond
         * @classdesc Represents a FieldMarkerSettings.
         * @implements IFieldMarkerSettings
         * @constructor
         * @param {pond.IFieldMarkerSettings=} [properties] Properties to set
         */
        function FieldMarkerSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldMarkerSettings key.
         * @member {string} key
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.key = "";

        /**
         * FieldMarkerSettings longitude.
         * @member {number} longitude
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.longitude = 0;

        /**
         * FieldMarkerSettings latitude.
         * @member {number} latitude
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.latitude = 0;

        /**
         * FieldMarkerSettings description.
         * @member {string} description
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.description = "";

        /**
         * FieldMarkerSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.theme = null;

        /**
         * FieldMarkerSettings type.
         * @member {pond.FieldMarkerType} type
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.type = 0;

        /**
         * FieldMarkerSettings name.
         * @member {string} name
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.name = "";

        /**
         * FieldMarkerSettings severity.
         * @member {number} severity
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.severity = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FieldMarkerSettings affectedArea.
         * @member {number} affectedArea
         * @memberof pond.FieldMarkerSettings
         * @instance
         */
        FieldMarkerSettings.prototype.affectedArea = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FieldMarkerSettings instance using the specified properties.
         * @function create
         * @memberof pond.FieldMarkerSettings
         * @static
         * @param {pond.IFieldMarkerSettings=} [properties] Properties to set
         * @returns {pond.FieldMarkerSettings} FieldMarkerSettings instance
         */
        FieldMarkerSettings.create = function create(properties) {
            return new FieldMarkerSettings(properties);
        };

        /**
         * Creates a FieldMarkerSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldMarkerSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldMarkerSettings} FieldMarkerSettings
         */
        FieldMarkerSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldMarkerSettings)
                return object;
            var message = new $root.pond.FieldMarkerSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.description != null)
                message.description = String(object.description);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.FieldMarkerSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            switch (object.type) {
            case "FIELD_MARKER_TYPE_PESTS":
            case 0:
                message.type = 0;
                break;
            case "FIELD_MARKER_TYPE_WEEDS":
            case 1:
                message.type = 1;
                break;
            case "FIELD_MARKER_TYPE_DISEASE":
            case 2:
                message.type = 2;
                break;
            case "FIELD_MARKER_TYPE_OTHER":
            case 3:
                message.type = 3;
                break;
            case "FIELD_MARKER_TYPE_ROCKS":
            case 4:
                message.type = 4;
                break;
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.severity != null)
                if ($util.Long)
                    (message.severity = $util.Long.fromValue(object.severity)).unsigned = true;
                else if (typeof object.severity === "string")
                    message.severity = parseInt(object.severity, 10);
                else if (typeof object.severity === "number")
                    message.severity = object.severity;
                else if (typeof object.severity === "object")
                    message.severity = new $util.LongBits(object.severity.low >>> 0, object.severity.high >>> 0).toNumber(true);
            if (object.affectedArea != null)
                if ($util.Long)
                    (message.affectedArea = $util.Long.fromValue(object.affectedArea)).unsigned = true;
                else if (typeof object.affectedArea === "string")
                    message.affectedArea = parseInt(object.affectedArea, 10);
                else if (typeof object.affectedArea === "number")
                    message.affectedArea = object.affectedArea;
                else if (typeof object.affectedArea === "object")
                    message.affectedArea = new $util.LongBits(object.affectedArea.low >>> 0, object.affectedArea.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FieldMarkerSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldMarkerSettings
         * @static
         * @param {pond.FieldMarkerSettings} message FieldMarkerSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldMarkerSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.longitude = 0;
                object.latitude = 0;
                object.description = "";
                object.theme = null;
                object.type = options.enums === String ? "FIELD_MARKER_TYPE_PESTS" : 0;
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.severity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.severity = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.affectedArea = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.affectedArea = options.longs === String ? "0" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.FieldMarkerType[message.type] : message.type;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.severity != null && message.hasOwnProperty("severity"))
                if (typeof message.severity === "number")
                    object.severity = options.longs === String ? String(message.severity) : message.severity;
                else
                    object.severity = options.longs === String ? $util.Long.prototype.toString.call(message.severity) : options.longs === Number ? new $util.LongBits(message.severity.low >>> 0, message.severity.high >>> 0).toNumber(true) : message.severity;
            if (message.affectedArea != null && message.hasOwnProperty("affectedArea"))
                if (typeof message.affectedArea === "number")
                    object.affectedArea = options.longs === String ? String(message.affectedArea) : message.affectedArea;
                else
                    object.affectedArea = options.longs === String ? $util.Long.prototype.toString.call(message.affectedArea) : options.longs === Number ? new $util.LongBits(message.affectedArea.low >>> 0, message.affectedArea.high >>> 0).toNumber(true) : message.affectedArea;
            return object;
        };

        /**
         * Converts this FieldMarkerSettings to JSON.
         * @function toJSON
         * @memberof pond.FieldMarkerSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldMarkerSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldMarkerSettings;
    })();

    pond.FieldMarkerStatus = (function() {

        /**
         * Properties of a FieldMarkerStatus.
         * @memberof pond
         * @interface IFieldMarkerStatus
         * @property {string|null} [timestamp] FieldMarkerStatus timestamp
         */

        /**
         * Constructs a new FieldMarkerStatus.
         * @memberof pond
         * @classdesc Represents a FieldMarkerStatus.
         * @implements IFieldMarkerStatus
         * @constructor
         * @param {pond.IFieldMarkerStatus=} [properties] Properties to set
         */
        function FieldMarkerStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldMarkerStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.FieldMarkerStatus
         * @instance
         */
        FieldMarkerStatus.prototype.timestamp = "";

        /**
         * Creates a new FieldMarkerStatus instance using the specified properties.
         * @function create
         * @memberof pond.FieldMarkerStatus
         * @static
         * @param {pond.IFieldMarkerStatus=} [properties] Properties to set
         * @returns {pond.FieldMarkerStatus} FieldMarkerStatus instance
         */
        FieldMarkerStatus.create = function create(properties) {
            return new FieldMarkerStatus(properties);
        };

        /**
         * Creates a FieldMarkerStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FieldMarkerStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FieldMarkerStatus} FieldMarkerStatus
         */
        FieldMarkerStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FieldMarkerStatus)
                return object;
            var message = new $root.pond.FieldMarkerStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a FieldMarkerStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FieldMarkerStatus
         * @static
         * @param {pond.FieldMarkerStatus} message FieldMarkerStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldMarkerStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this FieldMarkerStatus to JSON.
         * @function toJSON
         * @memberof pond.FieldMarkerStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldMarkerStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldMarkerStatus;
    })();

    pond.GetFieldMarkerRequest = (function() {

        /**
         * Properties of a GetFieldMarkerRequest.
         * @memberof pond
         * @interface IGetFieldMarkerRequest
         * @property {string|null} [fieldMarker] GetFieldMarkerRequest fieldMarker
         */

        /**
         * Constructs a new GetFieldMarkerRequest.
         * @memberof pond
         * @classdesc Represents a GetFieldMarkerRequest.
         * @implements IGetFieldMarkerRequest
         * @constructor
         * @param {pond.IGetFieldMarkerRequest=} [properties] Properties to set
         */
        function GetFieldMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFieldMarkerRequest fieldMarker.
         * @member {string} fieldMarker
         * @memberof pond.GetFieldMarkerRequest
         * @instance
         */
        GetFieldMarkerRequest.prototype.fieldMarker = "";

        /**
         * Creates a new GetFieldMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetFieldMarkerRequest
         * @static
         * @param {pond.IGetFieldMarkerRequest=} [properties] Properties to set
         * @returns {pond.GetFieldMarkerRequest} GetFieldMarkerRequest instance
         */
        GetFieldMarkerRequest.create = function create(properties) {
            return new GetFieldMarkerRequest(properties);
        };

        /**
         * Creates a GetFieldMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetFieldMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetFieldMarkerRequest} GetFieldMarkerRequest
         */
        GetFieldMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetFieldMarkerRequest)
                return object;
            var message = new $root.pond.GetFieldMarkerRequest();
            if (object.fieldMarker != null)
                message.fieldMarker = String(object.fieldMarker);
            return message;
        };

        /**
         * Creates a plain object from a GetFieldMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetFieldMarkerRequest
         * @static
         * @param {pond.GetFieldMarkerRequest} message GetFieldMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFieldMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fieldMarker = "";
            if (message.fieldMarker != null && message.hasOwnProperty("fieldMarker"))
                object.fieldMarker = message.fieldMarker;
            return object;
        };

        /**
         * Converts this GetFieldMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.GetFieldMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFieldMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetFieldMarkerRequest;
    })();

    pond.AddFieldMarkerRequest = (function() {

        /**
         * Properties of an AddFieldMarkerRequest.
         * @memberof pond
         * @interface IAddFieldMarkerRequest
         * @property {pond.FieldMarkerSettings|null} [fieldMarker] AddFieldMarkerRequest fieldMarker
         */

        /**
         * Constructs a new AddFieldMarkerRequest.
         * @memberof pond
         * @classdesc Represents an AddFieldMarkerRequest.
         * @implements IAddFieldMarkerRequest
         * @constructor
         * @param {pond.IAddFieldMarkerRequest=} [properties] Properties to set
         */
        function AddFieldMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFieldMarkerRequest fieldMarker.
         * @member {pond.FieldMarkerSettings|null|undefined} fieldMarker
         * @memberof pond.AddFieldMarkerRequest
         * @instance
         */
        AddFieldMarkerRequest.prototype.fieldMarker = null;

        /**
         * Creates a new AddFieldMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddFieldMarkerRequest
         * @static
         * @param {pond.IAddFieldMarkerRequest=} [properties] Properties to set
         * @returns {pond.AddFieldMarkerRequest} AddFieldMarkerRequest instance
         */
        AddFieldMarkerRequest.create = function create(properties) {
            return new AddFieldMarkerRequest(properties);
        };

        /**
         * Creates an AddFieldMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFieldMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFieldMarkerRequest} AddFieldMarkerRequest
         */
        AddFieldMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFieldMarkerRequest)
                return object;
            var message = new $root.pond.AddFieldMarkerRequest();
            if (object.fieldMarker != null) {
                if (typeof object.fieldMarker !== "object")
                    throw TypeError(".pond.AddFieldMarkerRequest.fieldMarker: object expected");
                message.fieldMarker = $root.pond.FieldMarkerSettings.fromObject(object.fieldMarker);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddFieldMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFieldMarkerRequest
         * @static
         * @param {pond.AddFieldMarkerRequest} message AddFieldMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFieldMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fieldMarker = null;
            if (message.fieldMarker != null && message.hasOwnProperty("fieldMarker"))
                object.fieldMarker = $root.pond.FieldMarkerSettings.toObject(message.fieldMarker, options);
            return object;
        };

        /**
         * Converts this AddFieldMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.AddFieldMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFieldMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFieldMarkerRequest;
    })();

    pond.AddFieldMarkerResponse = (function() {

        /**
         * Properties of an AddFieldMarkerResponse.
         * @memberof pond
         * @interface IAddFieldMarkerResponse
         * @property {string|null} [fieldMarker] AddFieldMarkerResponse fieldMarker
         */

        /**
         * Constructs a new AddFieldMarkerResponse.
         * @memberof pond
         * @classdesc Represents an AddFieldMarkerResponse.
         * @implements IAddFieldMarkerResponse
         * @constructor
         * @param {pond.IAddFieldMarkerResponse=} [properties] Properties to set
         */
        function AddFieldMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddFieldMarkerResponse fieldMarker.
         * @member {string} fieldMarker
         * @memberof pond.AddFieldMarkerResponse
         * @instance
         */
        AddFieldMarkerResponse.prototype.fieldMarker = "";

        /**
         * Creates a new AddFieldMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddFieldMarkerResponse
         * @static
         * @param {pond.IAddFieldMarkerResponse=} [properties] Properties to set
         * @returns {pond.AddFieldMarkerResponse} AddFieldMarkerResponse instance
         */
        AddFieldMarkerResponse.create = function create(properties) {
            return new AddFieldMarkerResponse(properties);
        };

        /**
         * Creates an AddFieldMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddFieldMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddFieldMarkerResponse} AddFieldMarkerResponse
         */
        AddFieldMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddFieldMarkerResponse)
                return object;
            var message = new $root.pond.AddFieldMarkerResponse();
            if (object.fieldMarker != null)
                message.fieldMarker = String(object.fieldMarker);
            return message;
        };

        /**
         * Creates a plain object from an AddFieldMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddFieldMarkerResponse
         * @static
         * @param {pond.AddFieldMarkerResponse} message AddFieldMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddFieldMarkerResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fieldMarker = "";
            if (message.fieldMarker != null && message.hasOwnProperty("fieldMarker"))
                object.fieldMarker = message.fieldMarker;
            return object;
        };

        /**
         * Converts this AddFieldMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.AddFieldMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddFieldMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddFieldMarkerResponse;
    })();

    pond.ListFieldMarkersRequest = (function() {

        /**
         * Properties of a ListFieldMarkersRequest.
         * @memberof pond
         * @interface IListFieldMarkersRequest
         * @property {string|null} [key] ListFieldMarkersRequest key
         * @property {string|null} [userId] ListFieldMarkersRequest userId
         * @property {pond.Paging|null} [paging] ListFieldMarkersRequest paging
         * @property {pond.Sorting|null} [sorting] ListFieldMarkersRequest sorting
         * @property {string|null} [search] ListFieldMarkersRequest search
         * @property {pond.FieldMarkerSettings|null} [settingsMatch] ListFieldMarkersRequest settingsMatch
         * @property {pond.FieldMarkerStatus|null} [statusMatch] ListFieldMarkersRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListFieldMarkersRequest fieldContains
         */

        /**
         * Constructs a new ListFieldMarkersRequest.
         * @memberof pond
         * @classdesc Represents a ListFieldMarkersRequest.
         * @implements IListFieldMarkersRequest
         * @constructor
         * @param {pond.IListFieldMarkersRequest=} [properties] Properties to set
         */
        function ListFieldMarkersRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFieldMarkersRequest key.
         * @member {string} key
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.key = "";

        /**
         * ListFieldMarkersRequest userId.
         * @member {string} userId
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.userId = "";

        /**
         * ListFieldMarkersRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.paging = null;

        /**
         * ListFieldMarkersRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.sorting = null;

        /**
         * ListFieldMarkersRequest search.
         * @member {string} search
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.search = "";

        /**
         * ListFieldMarkersRequest settingsMatch.
         * @member {pond.FieldMarkerSettings|null|undefined} settingsMatch
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.settingsMatch = null;

        /**
         * ListFieldMarkersRequest statusMatch.
         * @member {pond.FieldMarkerStatus|null|undefined} statusMatch
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.statusMatch = null;

        /**
         * ListFieldMarkersRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         */
        ListFieldMarkersRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListFieldMarkersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListFieldMarkersRequest
         * @static
         * @param {pond.IListFieldMarkersRequest=} [properties] Properties to set
         * @returns {pond.ListFieldMarkersRequest} ListFieldMarkersRequest instance
         */
        ListFieldMarkersRequest.create = function create(properties) {
            return new ListFieldMarkersRequest(properties);
        };

        /**
         * Creates a ListFieldMarkersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFieldMarkersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFieldMarkersRequest} ListFieldMarkersRequest
         */
        ListFieldMarkersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFieldMarkersRequest)
                return object;
            var message = new $root.pond.ListFieldMarkersRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListFieldMarkersRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListFieldMarkersRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListFieldMarkersRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.FieldMarkerSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListFieldMarkersRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.FieldMarkerStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListFieldMarkersRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFieldMarkersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFieldMarkersRequest
         * @static
         * @param {pond.ListFieldMarkersRequest} message ListFieldMarkersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFieldMarkersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.FieldMarkerSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.FieldMarkerStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListFieldMarkersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListFieldMarkersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFieldMarkersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFieldMarkersRequest;
    })();

    pond.ListFieldMarkersResponse = (function() {

        /**
         * Properties of a ListFieldMarkersResponse.
         * @memberof pond
         * @interface IListFieldMarkersResponse
         * @property {Array.<pond.FieldMarker>|null} [fieldMarker] ListFieldMarkersResponse fieldMarker
         * @property {number|null} [nextOffset] ListFieldMarkersResponse nextOffset
         * @property {number|null} [total] ListFieldMarkersResponse total
         */

        /**
         * Constructs a new ListFieldMarkersResponse.
         * @memberof pond
         * @classdesc Represents a ListFieldMarkersResponse.
         * @implements IListFieldMarkersResponse
         * @constructor
         * @param {pond.IListFieldMarkersResponse=} [properties] Properties to set
         */
        function ListFieldMarkersResponse(properties) {
            this.fieldMarker = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFieldMarkersResponse fieldMarker.
         * @member {Array.<pond.FieldMarker>} fieldMarker
         * @memberof pond.ListFieldMarkersResponse
         * @instance
         */
        ListFieldMarkersResponse.prototype.fieldMarker = $util.emptyArray;

        /**
         * ListFieldMarkersResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListFieldMarkersResponse
         * @instance
         */
        ListFieldMarkersResponse.prototype.nextOffset = 0;

        /**
         * ListFieldMarkersResponse total.
         * @member {number} total
         * @memberof pond.ListFieldMarkersResponse
         * @instance
         */
        ListFieldMarkersResponse.prototype.total = 0;

        /**
         * Creates a new ListFieldMarkersResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListFieldMarkersResponse
         * @static
         * @param {pond.IListFieldMarkersResponse=} [properties] Properties to set
         * @returns {pond.ListFieldMarkersResponse} ListFieldMarkersResponse instance
         */
        ListFieldMarkersResponse.create = function create(properties) {
            return new ListFieldMarkersResponse(properties);
        };

        /**
         * Creates a ListFieldMarkersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListFieldMarkersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListFieldMarkersResponse} ListFieldMarkersResponse
         */
        ListFieldMarkersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListFieldMarkersResponse)
                return object;
            var message = new $root.pond.ListFieldMarkersResponse();
            if (object.fieldMarker) {
                if (!Array.isArray(object.fieldMarker))
                    throw TypeError(".pond.ListFieldMarkersResponse.fieldMarker: array expected");
                message.fieldMarker = [];
                for (var i = 0; i < object.fieldMarker.length; ++i) {
                    if (typeof object.fieldMarker[i] !== "object")
                        throw TypeError(".pond.ListFieldMarkersResponse.fieldMarker: object expected");
                    message.fieldMarker[i] = $root.pond.FieldMarker.fromObject(object.fieldMarker[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListFieldMarkersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListFieldMarkersResponse
         * @static
         * @param {pond.ListFieldMarkersResponse} message ListFieldMarkersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFieldMarkersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fieldMarker = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.fieldMarker && message.fieldMarker.length) {
                object.fieldMarker = [];
                for (var j = 0; j < message.fieldMarker.length; ++j)
                    object.fieldMarker[j] = $root.pond.FieldMarker.toObject(message.fieldMarker[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListFieldMarkersResponse to JSON.
         * @function toJSON
         * @memberof pond.ListFieldMarkersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFieldMarkersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListFieldMarkersResponse;
    })();

    pond.RemoveFieldMarkerRequest = (function() {

        /**
         * Properties of a RemoveFieldMarkerRequest.
         * @memberof pond
         * @interface IRemoveFieldMarkerRequest
         * @property {string|null} [fieldMarker] RemoveFieldMarkerRequest fieldMarker
         */

        /**
         * Constructs a new RemoveFieldMarkerRequest.
         * @memberof pond
         * @classdesc Represents a RemoveFieldMarkerRequest.
         * @implements IRemoveFieldMarkerRequest
         * @constructor
         * @param {pond.IRemoveFieldMarkerRequest=} [properties] Properties to set
         */
        function RemoveFieldMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFieldMarkerRequest fieldMarker.
         * @member {string} fieldMarker
         * @memberof pond.RemoveFieldMarkerRequest
         * @instance
         */
        RemoveFieldMarkerRequest.prototype.fieldMarker = "";

        /**
         * Creates a new RemoveFieldMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFieldMarkerRequest
         * @static
         * @param {pond.IRemoveFieldMarkerRequest=} [properties] Properties to set
         * @returns {pond.RemoveFieldMarkerRequest} RemoveFieldMarkerRequest instance
         */
        RemoveFieldMarkerRequest.create = function create(properties) {
            return new RemoveFieldMarkerRequest(properties);
        };

        /**
         * Creates a RemoveFieldMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFieldMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFieldMarkerRequest} RemoveFieldMarkerRequest
         */
        RemoveFieldMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFieldMarkerRequest)
                return object;
            var message = new $root.pond.RemoveFieldMarkerRequest();
            if (object.fieldMarker != null)
                message.fieldMarker = String(object.fieldMarker);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFieldMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFieldMarkerRequest
         * @static
         * @param {pond.RemoveFieldMarkerRequest} message RemoveFieldMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFieldMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fieldMarker = "";
            if (message.fieldMarker != null && message.hasOwnProperty("fieldMarker"))
                object.fieldMarker = message.fieldMarker;
            return object;
        };

        /**
         * Converts this RemoveFieldMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveFieldMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFieldMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFieldMarkerRequest;
    })();

    pond.RemoveFieldMarkerResponse = (function() {

        /**
         * Properties of a RemoveFieldMarkerResponse.
         * @memberof pond
         * @interface IRemoveFieldMarkerResponse
         */

        /**
         * Constructs a new RemoveFieldMarkerResponse.
         * @memberof pond
         * @classdesc Represents a RemoveFieldMarkerResponse.
         * @implements IRemoveFieldMarkerResponse
         * @constructor
         * @param {pond.IRemoveFieldMarkerResponse=} [properties] Properties to set
         */
        function RemoveFieldMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveFieldMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveFieldMarkerResponse
         * @static
         * @param {pond.IRemoveFieldMarkerResponse=} [properties] Properties to set
         * @returns {pond.RemoveFieldMarkerResponse} RemoveFieldMarkerResponse instance
         */
        RemoveFieldMarkerResponse.create = function create(properties) {
            return new RemoveFieldMarkerResponse(properties);
        };

        /**
         * Creates a RemoveFieldMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveFieldMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveFieldMarkerResponse} RemoveFieldMarkerResponse
         */
        RemoveFieldMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveFieldMarkerResponse)
                return object;
            return new $root.pond.RemoveFieldMarkerResponse();
        };

        /**
         * Creates a plain object from a RemoveFieldMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveFieldMarkerResponse
         * @static
         * @param {pond.RemoveFieldMarkerResponse} message RemoveFieldMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFieldMarkerResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveFieldMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveFieldMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFieldMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveFieldMarkerResponse;
    })();

    pond.UpdateFieldMarkerRequest = (function() {

        /**
         * Properties of an UpdateFieldMarkerRequest.
         * @memberof pond
         * @interface IUpdateFieldMarkerRequest
         * @property {pond.FieldMarkerSettings|null} [fieldMarker] UpdateFieldMarkerRequest fieldMarker
         */

        /**
         * Constructs a new UpdateFieldMarkerRequest.
         * @memberof pond
         * @classdesc Represents an UpdateFieldMarkerRequest.
         * @implements IUpdateFieldMarkerRequest
         * @constructor
         * @param {pond.IUpdateFieldMarkerRequest=} [properties] Properties to set
         */
        function UpdateFieldMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateFieldMarkerRequest fieldMarker.
         * @member {pond.FieldMarkerSettings|null|undefined} fieldMarker
         * @memberof pond.UpdateFieldMarkerRequest
         * @instance
         */
        UpdateFieldMarkerRequest.prototype.fieldMarker = null;

        /**
         * Creates a new UpdateFieldMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFieldMarkerRequest
         * @static
         * @param {pond.IUpdateFieldMarkerRequest=} [properties] Properties to set
         * @returns {pond.UpdateFieldMarkerRequest} UpdateFieldMarkerRequest instance
         */
        UpdateFieldMarkerRequest.create = function create(properties) {
            return new UpdateFieldMarkerRequest(properties);
        };

        /**
         * Creates an UpdateFieldMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFieldMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFieldMarkerRequest} UpdateFieldMarkerRequest
         */
        UpdateFieldMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFieldMarkerRequest)
                return object;
            var message = new $root.pond.UpdateFieldMarkerRequest();
            if (object.fieldMarker != null) {
                if (typeof object.fieldMarker !== "object")
                    throw TypeError(".pond.UpdateFieldMarkerRequest.fieldMarker: object expected");
                message.fieldMarker = $root.pond.FieldMarkerSettings.fromObject(object.fieldMarker);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateFieldMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFieldMarkerRequest
         * @static
         * @param {pond.UpdateFieldMarkerRequest} message UpdateFieldMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFieldMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.fieldMarker = null;
            if (message.fieldMarker != null && message.hasOwnProperty("fieldMarker"))
                object.fieldMarker = $root.pond.FieldMarkerSettings.toObject(message.fieldMarker, options);
            return object;
        };

        /**
         * Converts this UpdateFieldMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateFieldMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFieldMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFieldMarkerRequest;
    })();

    pond.UpdateFieldMarkerResponse = (function() {

        /**
         * Properties of an UpdateFieldMarkerResponse.
         * @memberof pond
         * @interface IUpdateFieldMarkerResponse
         */

        /**
         * Constructs a new UpdateFieldMarkerResponse.
         * @memberof pond
         * @classdesc Represents an UpdateFieldMarkerResponse.
         * @implements IUpdateFieldMarkerResponse
         * @constructor
         * @param {pond.IUpdateFieldMarkerResponse=} [properties] Properties to set
         */
        function UpdateFieldMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateFieldMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateFieldMarkerResponse
         * @static
         * @param {pond.IUpdateFieldMarkerResponse=} [properties] Properties to set
         * @returns {pond.UpdateFieldMarkerResponse} UpdateFieldMarkerResponse instance
         */
        UpdateFieldMarkerResponse.create = function create(properties) {
            return new UpdateFieldMarkerResponse(properties);
        };

        /**
         * Creates an UpdateFieldMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateFieldMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateFieldMarkerResponse} UpdateFieldMarkerResponse
         */
        UpdateFieldMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateFieldMarkerResponse)
                return object;
            return new $root.pond.UpdateFieldMarkerResponse();
        };

        /**
         * Creates a plain object from an UpdateFieldMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateFieldMarkerResponse
         * @static
         * @param {pond.UpdateFieldMarkerResponse} message UpdateFieldMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateFieldMarkerResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateFieldMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateFieldMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateFieldMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateFieldMarkerResponse;
    })();

    pond.HomeMarker = (function() {

        /**
         * Properties of a HomeMarker.
         * @memberof pond
         * @interface IHomeMarker
         * @property {pond.HomeMarkerSettings|null} [settings] HomeMarker settings
         * @property {pond.HomeMarkerStatus|null} [status] HomeMarker status
         */

        /**
         * Constructs a new HomeMarker.
         * @memberof pond
         * @classdesc Represents a HomeMarker.
         * @implements IHomeMarker
         * @constructor
         * @param {pond.IHomeMarker=} [properties] Properties to set
         */
        function HomeMarker(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HomeMarker settings.
         * @member {pond.HomeMarkerSettings|null|undefined} settings
         * @memberof pond.HomeMarker
         * @instance
         */
        HomeMarker.prototype.settings = null;

        /**
         * HomeMarker status.
         * @member {pond.HomeMarkerStatus|null|undefined} status
         * @memberof pond.HomeMarker
         * @instance
         */
        HomeMarker.prototype.status = null;

        /**
         * Creates a new HomeMarker instance using the specified properties.
         * @function create
         * @memberof pond.HomeMarker
         * @static
         * @param {pond.IHomeMarker=} [properties] Properties to set
         * @returns {pond.HomeMarker} HomeMarker instance
         */
        HomeMarker.create = function create(properties) {
            return new HomeMarker(properties);
        };

        /**
         * Creates a HomeMarker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HomeMarker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HomeMarker} HomeMarker
         */
        HomeMarker.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HomeMarker)
                return object;
            var message = new $root.pond.HomeMarker();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.HomeMarker.settings: object expected");
                message.settings = $root.pond.HomeMarkerSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.HomeMarker.status: object expected");
                message.status = $root.pond.HomeMarkerStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a HomeMarker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HomeMarker
         * @static
         * @param {pond.HomeMarker} message HomeMarker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HomeMarker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.HomeMarkerSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.HomeMarkerStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this HomeMarker to JSON.
         * @function toJSON
         * @memberof pond.HomeMarker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HomeMarker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HomeMarker;
    })();

    pond.HomeMarkerSettings = (function() {

        /**
         * Properties of a HomeMarkerSettings.
         * @memberof pond
         * @interface IHomeMarkerSettings
         * @property {string|null} [key] HomeMarkerSettings key
         * @property {string|null} [userId] HomeMarkerSettings userId
         * @property {number|null} [longitude] HomeMarkerSettings longitude
         * @property {number|null} [latitude] HomeMarkerSettings latitude
         */

        /**
         * Constructs a new HomeMarkerSettings.
         * @memberof pond
         * @classdesc Represents a HomeMarkerSettings.
         * @implements IHomeMarkerSettings
         * @constructor
         * @param {pond.IHomeMarkerSettings=} [properties] Properties to set
         */
        function HomeMarkerSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HomeMarkerSettings key.
         * @member {string} key
         * @memberof pond.HomeMarkerSettings
         * @instance
         */
        HomeMarkerSettings.prototype.key = "";

        /**
         * HomeMarkerSettings userId.
         * @member {string} userId
         * @memberof pond.HomeMarkerSettings
         * @instance
         */
        HomeMarkerSettings.prototype.userId = "";

        /**
         * HomeMarkerSettings longitude.
         * @member {number} longitude
         * @memberof pond.HomeMarkerSettings
         * @instance
         */
        HomeMarkerSettings.prototype.longitude = 0;

        /**
         * HomeMarkerSettings latitude.
         * @member {number} latitude
         * @memberof pond.HomeMarkerSettings
         * @instance
         */
        HomeMarkerSettings.prototype.latitude = 0;

        /**
         * Creates a new HomeMarkerSettings instance using the specified properties.
         * @function create
         * @memberof pond.HomeMarkerSettings
         * @static
         * @param {pond.IHomeMarkerSettings=} [properties] Properties to set
         * @returns {pond.HomeMarkerSettings} HomeMarkerSettings instance
         */
        HomeMarkerSettings.create = function create(properties) {
            return new HomeMarkerSettings(properties);
        };

        /**
         * Creates a HomeMarkerSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HomeMarkerSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HomeMarkerSettings} HomeMarkerSettings
         */
        HomeMarkerSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HomeMarkerSettings)
                return object;
            var message = new $root.pond.HomeMarkerSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            return message;
        };

        /**
         * Creates a plain object from a HomeMarkerSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HomeMarkerSettings
         * @static
         * @param {pond.HomeMarkerSettings} message HomeMarkerSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HomeMarkerSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.longitude = 0;
                object.latitude = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            return object;
        };

        /**
         * Converts this HomeMarkerSettings to JSON.
         * @function toJSON
         * @memberof pond.HomeMarkerSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HomeMarkerSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HomeMarkerSettings;
    })();

    pond.HomeMarkerStatus = (function() {

        /**
         * Properties of a HomeMarkerStatus.
         * @memberof pond
         * @interface IHomeMarkerStatus
         * @property {string|null} [timestamp] HomeMarkerStatus timestamp
         */

        /**
         * Constructs a new HomeMarkerStatus.
         * @memberof pond
         * @classdesc Represents a HomeMarkerStatus.
         * @implements IHomeMarkerStatus
         * @constructor
         * @param {pond.IHomeMarkerStatus=} [properties] Properties to set
         */
        function HomeMarkerStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HomeMarkerStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.HomeMarkerStatus
         * @instance
         */
        HomeMarkerStatus.prototype.timestamp = "";

        /**
         * Creates a new HomeMarkerStatus instance using the specified properties.
         * @function create
         * @memberof pond.HomeMarkerStatus
         * @static
         * @param {pond.IHomeMarkerStatus=} [properties] Properties to set
         * @returns {pond.HomeMarkerStatus} HomeMarkerStatus instance
         */
        HomeMarkerStatus.create = function create(properties) {
            return new HomeMarkerStatus(properties);
        };

        /**
         * Creates a HomeMarkerStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HomeMarkerStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HomeMarkerStatus} HomeMarkerStatus
         */
        HomeMarkerStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HomeMarkerStatus)
                return object;
            var message = new $root.pond.HomeMarkerStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a HomeMarkerStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HomeMarkerStatus
         * @static
         * @param {pond.HomeMarkerStatus} message HomeMarkerStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HomeMarkerStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this HomeMarkerStatus to JSON.
         * @function toJSON
         * @memberof pond.HomeMarkerStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HomeMarkerStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HomeMarkerStatus;
    })();

    pond.GetHomeMarkerRequest = (function() {

        /**
         * Properties of a GetHomeMarkerRequest.
         * @memberof pond
         * @interface IGetHomeMarkerRequest
         * @property {string|null} [homeMarker] GetHomeMarkerRequest homeMarker
         */

        /**
         * Constructs a new GetHomeMarkerRequest.
         * @memberof pond
         * @classdesc Represents a GetHomeMarkerRequest.
         * @implements IGetHomeMarkerRequest
         * @constructor
         * @param {pond.IGetHomeMarkerRequest=} [properties] Properties to set
         */
        function GetHomeMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetHomeMarkerRequest homeMarker.
         * @member {string} homeMarker
         * @memberof pond.GetHomeMarkerRequest
         * @instance
         */
        GetHomeMarkerRequest.prototype.homeMarker = "";

        /**
         * Creates a new GetHomeMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetHomeMarkerRequest
         * @static
         * @param {pond.IGetHomeMarkerRequest=} [properties] Properties to set
         * @returns {pond.GetHomeMarkerRequest} GetHomeMarkerRequest instance
         */
        GetHomeMarkerRequest.create = function create(properties) {
            return new GetHomeMarkerRequest(properties);
        };

        /**
         * Creates a GetHomeMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetHomeMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetHomeMarkerRequest} GetHomeMarkerRequest
         */
        GetHomeMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetHomeMarkerRequest)
                return object;
            var message = new $root.pond.GetHomeMarkerRequest();
            if (object.homeMarker != null)
                message.homeMarker = String(object.homeMarker);
            return message;
        };

        /**
         * Creates a plain object from a GetHomeMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetHomeMarkerRequest
         * @static
         * @param {pond.GetHomeMarkerRequest} message GetHomeMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHomeMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.homeMarker = "";
            if (message.homeMarker != null && message.hasOwnProperty("homeMarker"))
                object.homeMarker = message.homeMarker;
            return object;
        };

        /**
         * Converts this GetHomeMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.GetHomeMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHomeMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetHomeMarkerRequest;
    })();

    pond.AddHomeMarkerRequest = (function() {

        /**
         * Properties of an AddHomeMarkerRequest.
         * @memberof pond
         * @interface IAddHomeMarkerRequest
         * @property {pond.HomeMarkerSettings|null} [homeMarker] AddHomeMarkerRequest homeMarker
         */

        /**
         * Constructs a new AddHomeMarkerRequest.
         * @memberof pond
         * @classdesc Represents an AddHomeMarkerRequest.
         * @implements IAddHomeMarkerRequest
         * @constructor
         * @param {pond.IAddHomeMarkerRequest=} [properties] Properties to set
         */
        function AddHomeMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHomeMarkerRequest homeMarker.
         * @member {pond.HomeMarkerSettings|null|undefined} homeMarker
         * @memberof pond.AddHomeMarkerRequest
         * @instance
         */
        AddHomeMarkerRequest.prototype.homeMarker = null;

        /**
         * Creates a new AddHomeMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddHomeMarkerRequest
         * @static
         * @param {pond.IAddHomeMarkerRequest=} [properties] Properties to set
         * @returns {pond.AddHomeMarkerRequest} AddHomeMarkerRequest instance
         */
        AddHomeMarkerRequest.create = function create(properties) {
            return new AddHomeMarkerRequest(properties);
        };

        /**
         * Creates an AddHomeMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHomeMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHomeMarkerRequest} AddHomeMarkerRequest
         */
        AddHomeMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHomeMarkerRequest)
                return object;
            var message = new $root.pond.AddHomeMarkerRequest();
            if (object.homeMarker != null) {
                if (typeof object.homeMarker !== "object")
                    throw TypeError(".pond.AddHomeMarkerRequest.homeMarker: object expected");
                message.homeMarker = $root.pond.HomeMarkerSettings.fromObject(object.homeMarker);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddHomeMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHomeMarkerRequest
         * @static
         * @param {pond.AddHomeMarkerRequest} message AddHomeMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHomeMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.homeMarker = null;
            if (message.homeMarker != null && message.hasOwnProperty("homeMarker"))
                object.homeMarker = $root.pond.HomeMarkerSettings.toObject(message.homeMarker, options);
            return object;
        };

        /**
         * Converts this AddHomeMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.AddHomeMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHomeMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHomeMarkerRequest;
    })();

    pond.AddHomeMarkerResponse = (function() {

        /**
         * Properties of an AddHomeMarkerResponse.
         * @memberof pond
         * @interface IAddHomeMarkerResponse
         * @property {string|null} [homeMarker] AddHomeMarkerResponse homeMarker
         */

        /**
         * Constructs a new AddHomeMarkerResponse.
         * @memberof pond
         * @classdesc Represents an AddHomeMarkerResponse.
         * @implements IAddHomeMarkerResponse
         * @constructor
         * @param {pond.IAddHomeMarkerResponse=} [properties] Properties to set
         */
        function AddHomeMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHomeMarkerResponse homeMarker.
         * @member {string} homeMarker
         * @memberof pond.AddHomeMarkerResponse
         * @instance
         */
        AddHomeMarkerResponse.prototype.homeMarker = "";

        /**
         * Creates a new AddHomeMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddHomeMarkerResponse
         * @static
         * @param {pond.IAddHomeMarkerResponse=} [properties] Properties to set
         * @returns {pond.AddHomeMarkerResponse} AddHomeMarkerResponse instance
         */
        AddHomeMarkerResponse.create = function create(properties) {
            return new AddHomeMarkerResponse(properties);
        };

        /**
         * Creates an AddHomeMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHomeMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHomeMarkerResponse} AddHomeMarkerResponse
         */
        AddHomeMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHomeMarkerResponse)
                return object;
            var message = new $root.pond.AddHomeMarkerResponse();
            if (object.homeMarker != null)
                message.homeMarker = String(object.homeMarker);
            return message;
        };

        /**
         * Creates a plain object from an AddHomeMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHomeMarkerResponse
         * @static
         * @param {pond.AddHomeMarkerResponse} message AddHomeMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHomeMarkerResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.homeMarker = "";
            if (message.homeMarker != null && message.hasOwnProperty("homeMarker"))
                object.homeMarker = message.homeMarker;
            return object;
        };

        /**
         * Converts this AddHomeMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.AddHomeMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHomeMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHomeMarkerResponse;
    })();

    pond.ListHomeMarkersRequest = (function() {

        /**
         * Properties of a ListHomeMarkersRequest.
         * @memberof pond
         * @interface IListHomeMarkersRequest
         * @property {string|null} [key] ListHomeMarkersRequest key
         * @property {string|null} [userId] ListHomeMarkersRequest userId
         * @property {pond.Paging|null} [paging] ListHomeMarkersRequest paging
         * @property {pond.Sorting|null} [sorting] ListHomeMarkersRequest sorting
         * @property {string|null} [search] ListHomeMarkersRequest search
         * @property {pond.HomeMarkerSettings|null} [settingsMatch] ListHomeMarkersRequest settingsMatch
         * @property {pond.HomeMarkerStatus|null} [statusMatch] ListHomeMarkersRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListHomeMarkersRequest fieldContains
         */

        /**
         * Constructs a new ListHomeMarkersRequest.
         * @memberof pond
         * @classdesc Represents a ListHomeMarkersRequest.
         * @implements IListHomeMarkersRequest
         * @constructor
         * @param {pond.IListHomeMarkersRequest=} [properties] Properties to set
         */
        function ListHomeMarkersRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHomeMarkersRequest key.
         * @member {string} key
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.key = "";

        /**
         * ListHomeMarkersRequest userId.
         * @member {string} userId
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.userId = "";

        /**
         * ListHomeMarkersRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.paging = null;

        /**
         * ListHomeMarkersRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.sorting = null;

        /**
         * ListHomeMarkersRequest search.
         * @member {string} search
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.search = "";

        /**
         * ListHomeMarkersRequest settingsMatch.
         * @member {pond.HomeMarkerSettings|null|undefined} settingsMatch
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.settingsMatch = null;

        /**
         * ListHomeMarkersRequest statusMatch.
         * @member {pond.HomeMarkerStatus|null|undefined} statusMatch
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.statusMatch = null;

        /**
         * ListHomeMarkersRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         */
        ListHomeMarkersRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListHomeMarkersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListHomeMarkersRequest
         * @static
         * @param {pond.IListHomeMarkersRequest=} [properties] Properties to set
         * @returns {pond.ListHomeMarkersRequest} ListHomeMarkersRequest instance
         */
        ListHomeMarkersRequest.create = function create(properties) {
            return new ListHomeMarkersRequest(properties);
        };

        /**
         * Creates a ListHomeMarkersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHomeMarkersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHomeMarkersRequest} ListHomeMarkersRequest
         */
        ListHomeMarkersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHomeMarkersRequest)
                return object;
            var message = new $root.pond.ListHomeMarkersRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListHomeMarkersRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListHomeMarkersRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListHomeMarkersRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.HomeMarkerSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListHomeMarkersRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.HomeMarkerStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListHomeMarkersRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListHomeMarkersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHomeMarkersRequest
         * @static
         * @param {pond.ListHomeMarkersRequest} message ListHomeMarkersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHomeMarkersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.HomeMarkerSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.HomeMarkerStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListHomeMarkersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListHomeMarkersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHomeMarkersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHomeMarkersRequest;
    })();

    pond.ListHomeMarkersResponse = (function() {

        /**
         * Properties of a ListHomeMarkersResponse.
         * @memberof pond
         * @interface IListHomeMarkersResponse
         * @property {Array.<pond.HomeMarker>|null} [homeMarker] ListHomeMarkersResponse homeMarker
         * @property {number|null} [nextOffset] ListHomeMarkersResponse nextOffset
         * @property {number|null} [total] ListHomeMarkersResponse total
         */

        /**
         * Constructs a new ListHomeMarkersResponse.
         * @memberof pond
         * @classdesc Represents a ListHomeMarkersResponse.
         * @implements IListHomeMarkersResponse
         * @constructor
         * @param {pond.IListHomeMarkersResponse=} [properties] Properties to set
         */
        function ListHomeMarkersResponse(properties) {
            this.homeMarker = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHomeMarkersResponse homeMarker.
         * @member {Array.<pond.HomeMarker>} homeMarker
         * @memberof pond.ListHomeMarkersResponse
         * @instance
         */
        ListHomeMarkersResponse.prototype.homeMarker = $util.emptyArray;

        /**
         * ListHomeMarkersResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListHomeMarkersResponse
         * @instance
         */
        ListHomeMarkersResponse.prototype.nextOffset = 0;

        /**
         * ListHomeMarkersResponse total.
         * @member {number} total
         * @memberof pond.ListHomeMarkersResponse
         * @instance
         */
        ListHomeMarkersResponse.prototype.total = 0;

        /**
         * Creates a new ListHomeMarkersResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListHomeMarkersResponse
         * @static
         * @param {pond.IListHomeMarkersResponse=} [properties] Properties to set
         * @returns {pond.ListHomeMarkersResponse} ListHomeMarkersResponse instance
         */
        ListHomeMarkersResponse.create = function create(properties) {
            return new ListHomeMarkersResponse(properties);
        };

        /**
         * Creates a ListHomeMarkersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHomeMarkersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHomeMarkersResponse} ListHomeMarkersResponse
         */
        ListHomeMarkersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHomeMarkersResponse)
                return object;
            var message = new $root.pond.ListHomeMarkersResponse();
            if (object.homeMarker) {
                if (!Array.isArray(object.homeMarker))
                    throw TypeError(".pond.ListHomeMarkersResponse.homeMarker: array expected");
                message.homeMarker = [];
                for (var i = 0; i < object.homeMarker.length; ++i) {
                    if (typeof object.homeMarker[i] !== "object")
                        throw TypeError(".pond.ListHomeMarkersResponse.homeMarker: object expected");
                    message.homeMarker[i] = $root.pond.HomeMarker.fromObject(object.homeMarker[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListHomeMarkersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHomeMarkersResponse
         * @static
         * @param {pond.ListHomeMarkersResponse} message ListHomeMarkersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHomeMarkersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.homeMarker = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.homeMarker && message.homeMarker.length) {
                object.homeMarker = [];
                for (var j = 0; j < message.homeMarker.length; ++j)
                    object.homeMarker[j] = $root.pond.HomeMarker.toObject(message.homeMarker[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListHomeMarkersResponse to JSON.
         * @function toJSON
         * @memberof pond.ListHomeMarkersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHomeMarkersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHomeMarkersResponse;
    })();

    pond.RemoveHomeMarkerRequest = (function() {

        /**
         * Properties of a RemoveHomeMarkerRequest.
         * @memberof pond
         * @interface IRemoveHomeMarkerRequest
         * @property {string|null} [homeMarker] RemoveHomeMarkerRequest homeMarker
         */

        /**
         * Constructs a new RemoveHomeMarkerRequest.
         * @memberof pond
         * @classdesc Represents a RemoveHomeMarkerRequest.
         * @implements IRemoveHomeMarkerRequest
         * @constructor
         * @param {pond.IRemoveHomeMarkerRequest=} [properties] Properties to set
         */
        function RemoveHomeMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveHomeMarkerRequest homeMarker.
         * @member {string} homeMarker
         * @memberof pond.RemoveHomeMarkerRequest
         * @instance
         */
        RemoveHomeMarkerRequest.prototype.homeMarker = "";

        /**
         * Creates a new RemoveHomeMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHomeMarkerRequest
         * @static
         * @param {pond.IRemoveHomeMarkerRequest=} [properties] Properties to set
         * @returns {pond.RemoveHomeMarkerRequest} RemoveHomeMarkerRequest instance
         */
        RemoveHomeMarkerRequest.create = function create(properties) {
            return new RemoveHomeMarkerRequest(properties);
        };

        /**
         * Creates a RemoveHomeMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHomeMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHomeMarkerRequest} RemoveHomeMarkerRequest
         */
        RemoveHomeMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHomeMarkerRequest)
                return object;
            var message = new $root.pond.RemoveHomeMarkerRequest();
            if (object.homeMarker != null)
                message.homeMarker = String(object.homeMarker);
            return message;
        };

        /**
         * Creates a plain object from a RemoveHomeMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHomeMarkerRequest
         * @static
         * @param {pond.RemoveHomeMarkerRequest} message RemoveHomeMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHomeMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.homeMarker = "";
            if (message.homeMarker != null && message.hasOwnProperty("homeMarker"))
                object.homeMarker = message.homeMarker;
            return object;
        };

        /**
         * Converts this RemoveHomeMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveHomeMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHomeMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHomeMarkerRequest;
    })();

    pond.RemoveHomeMarkerResponse = (function() {

        /**
         * Properties of a RemoveHomeMarkerResponse.
         * @memberof pond
         * @interface IRemoveHomeMarkerResponse
         */

        /**
         * Constructs a new RemoveHomeMarkerResponse.
         * @memberof pond
         * @classdesc Represents a RemoveHomeMarkerResponse.
         * @implements IRemoveHomeMarkerResponse
         * @constructor
         * @param {pond.IRemoveHomeMarkerResponse=} [properties] Properties to set
         */
        function RemoveHomeMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveHomeMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHomeMarkerResponse
         * @static
         * @param {pond.IRemoveHomeMarkerResponse=} [properties] Properties to set
         * @returns {pond.RemoveHomeMarkerResponse} RemoveHomeMarkerResponse instance
         */
        RemoveHomeMarkerResponse.create = function create(properties) {
            return new RemoveHomeMarkerResponse(properties);
        };

        /**
         * Creates a RemoveHomeMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHomeMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHomeMarkerResponse} RemoveHomeMarkerResponse
         */
        RemoveHomeMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHomeMarkerResponse)
                return object;
            return new $root.pond.RemoveHomeMarkerResponse();
        };

        /**
         * Creates a plain object from a RemoveHomeMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHomeMarkerResponse
         * @static
         * @param {pond.RemoveHomeMarkerResponse} message RemoveHomeMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHomeMarkerResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveHomeMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveHomeMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHomeMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHomeMarkerResponse;
    })();

    pond.UpdateHomeMarkerRequest = (function() {

        /**
         * Properties of an UpdateHomeMarkerRequest.
         * @memberof pond
         * @interface IUpdateHomeMarkerRequest
         * @property {pond.HomeMarkerSettings|null} [homeMarker] UpdateHomeMarkerRequest homeMarker
         */

        /**
         * Constructs a new UpdateHomeMarkerRequest.
         * @memberof pond
         * @classdesc Represents an UpdateHomeMarkerRequest.
         * @implements IUpdateHomeMarkerRequest
         * @constructor
         * @param {pond.IUpdateHomeMarkerRequest=} [properties] Properties to set
         */
        function UpdateHomeMarkerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateHomeMarkerRequest homeMarker.
         * @member {pond.HomeMarkerSettings|null|undefined} homeMarker
         * @memberof pond.UpdateHomeMarkerRequest
         * @instance
         */
        UpdateHomeMarkerRequest.prototype.homeMarker = null;

        /**
         * Creates a new UpdateHomeMarkerRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHomeMarkerRequest
         * @static
         * @param {pond.IUpdateHomeMarkerRequest=} [properties] Properties to set
         * @returns {pond.UpdateHomeMarkerRequest} UpdateHomeMarkerRequest instance
         */
        UpdateHomeMarkerRequest.create = function create(properties) {
            return new UpdateHomeMarkerRequest(properties);
        };

        /**
         * Creates an UpdateHomeMarkerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHomeMarkerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHomeMarkerRequest} UpdateHomeMarkerRequest
         */
        UpdateHomeMarkerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHomeMarkerRequest)
                return object;
            var message = new $root.pond.UpdateHomeMarkerRequest();
            if (object.homeMarker != null) {
                if (typeof object.homeMarker !== "object")
                    throw TypeError(".pond.UpdateHomeMarkerRequest.homeMarker: object expected");
                message.homeMarker = $root.pond.HomeMarkerSettings.fromObject(object.homeMarker);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateHomeMarkerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHomeMarkerRequest
         * @static
         * @param {pond.UpdateHomeMarkerRequest} message UpdateHomeMarkerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHomeMarkerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.homeMarker = null;
            if (message.homeMarker != null && message.hasOwnProperty("homeMarker"))
                object.homeMarker = $root.pond.HomeMarkerSettings.toObject(message.homeMarker, options);
            return object;
        };

        /**
         * Converts this UpdateHomeMarkerRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateHomeMarkerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHomeMarkerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHomeMarkerRequest;
    })();

    pond.UpdateHomeMarkerResponse = (function() {

        /**
         * Properties of an UpdateHomeMarkerResponse.
         * @memberof pond
         * @interface IUpdateHomeMarkerResponse
         */

        /**
         * Constructs a new UpdateHomeMarkerResponse.
         * @memberof pond
         * @classdesc Represents an UpdateHomeMarkerResponse.
         * @implements IUpdateHomeMarkerResponse
         * @constructor
         * @param {pond.IUpdateHomeMarkerResponse=} [properties] Properties to set
         */
        function UpdateHomeMarkerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateHomeMarkerResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHomeMarkerResponse
         * @static
         * @param {pond.IUpdateHomeMarkerResponse=} [properties] Properties to set
         * @returns {pond.UpdateHomeMarkerResponse} UpdateHomeMarkerResponse instance
         */
        UpdateHomeMarkerResponse.create = function create(properties) {
            return new UpdateHomeMarkerResponse(properties);
        };

        /**
         * Creates an UpdateHomeMarkerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHomeMarkerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHomeMarkerResponse} UpdateHomeMarkerResponse
         */
        UpdateHomeMarkerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHomeMarkerResponse)
                return object;
            return new $root.pond.UpdateHomeMarkerResponse();
        };

        /**
         * Creates a plain object from an UpdateHomeMarkerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHomeMarkerResponse
         * @static
         * @param {pond.UpdateHomeMarkerResponse} message UpdateHomeMarkerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHomeMarkerResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateHomeMarkerResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateHomeMarkerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHomeMarkerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHomeMarkerResponse;
    })();

    pond.HarvestYear = (function() {

        /**
         * Properties of a HarvestYear.
         * @memberof pond
         * @interface IHarvestYear
         * @property {pond.HarvestYearSettings|null} [settings] HarvestYear settings
         * @property {pond.HarvestYearStatus|null} [status] HarvestYear status
         */

        /**
         * Constructs a new HarvestYear.
         * @memberof pond
         * @classdesc Represents a HarvestYear.
         * @implements IHarvestYear
         * @constructor
         * @param {pond.IHarvestYear=} [properties] Properties to set
         */
        function HarvestYear(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestYear settings.
         * @member {pond.HarvestYearSettings|null|undefined} settings
         * @memberof pond.HarvestYear
         * @instance
         */
        HarvestYear.prototype.settings = null;

        /**
         * HarvestYear status.
         * @member {pond.HarvestYearStatus|null|undefined} status
         * @memberof pond.HarvestYear
         * @instance
         */
        HarvestYear.prototype.status = null;

        /**
         * Creates a new HarvestYear instance using the specified properties.
         * @function create
         * @memberof pond.HarvestYear
         * @static
         * @param {pond.IHarvestYear=} [properties] Properties to set
         * @returns {pond.HarvestYear} HarvestYear instance
         */
        HarvestYear.create = function create(properties) {
            return new HarvestYear(properties);
        };

        /**
         * Creates a HarvestYear message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestYear
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestYear} HarvestYear
         */
        HarvestYear.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestYear)
                return object;
            var message = new $root.pond.HarvestYear();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.HarvestYear.settings: object expected");
                message.settings = $root.pond.HarvestYearSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.HarvestYear.status: object expected");
                message.status = $root.pond.HarvestYearStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a HarvestYear message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestYear
         * @static
         * @param {pond.HarvestYear} message HarvestYear
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestYear.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.HarvestYearSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.HarvestYearStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this HarvestYear to JSON.
         * @function toJSON
         * @memberof pond.HarvestYear
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestYear.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestYear;
    })();

    pond.HarvestYearSettings = (function() {

        /**
         * Properties of a HarvestYearSettings.
         * @memberof pond
         * @interface IHarvestYearSettings
         * @property {string|null} [key] HarvestYearSettings key
         * @property {string|null} [field] HarvestYearSettings field
         * @property {number|null} [year] HarvestYearSettings year
         * @property {number|null} [bushels] HarvestYearSettings bushels
         * @property {pond.Grain|null} [grain] HarvestYearSettings grain
         */

        /**
         * Constructs a new HarvestYearSettings.
         * @memberof pond
         * @classdesc Represents a HarvestYearSettings.
         * @implements IHarvestYearSettings
         * @constructor
         * @param {pond.IHarvestYearSettings=} [properties] Properties to set
         */
        function HarvestYearSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestYearSettings key.
         * @member {string} key
         * @memberof pond.HarvestYearSettings
         * @instance
         */
        HarvestYearSettings.prototype.key = "";

        /**
         * HarvestYearSettings field.
         * @member {string} field
         * @memberof pond.HarvestYearSettings
         * @instance
         */
        HarvestYearSettings.prototype.field = "";

        /**
         * HarvestYearSettings year.
         * @member {number} year
         * @memberof pond.HarvestYearSettings
         * @instance
         */
        HarvestYearSettings.prototype.year = 0;

        /**
         * HarvestYearSettings bushels.
         * @member {number} bushels
         * @memberof pond.HarvestYearSettings
         * @instance
         */
        HarvestYearSettings.prototype.bushels = 0;

        /**
         * HarvestYearSettings grain.
         * @member {pond.Grain} grain
         * @memberof pond.HarvestYearSettings
         * @instance
         */
        HarvestYearSettings.prototype.grain = 0;

        /**
         * Creates a new HarvestYearSettings instance using the specified properties.
         * @function create
         * @memberof pond.HarvestYearSettings
         * @static
         * @param {pond.IHarvestYearSettings=} [properties] Properties to set
         * @returns {pond.HarvestYearSettings} HarvestYearSettings instance
         */
        HarvestYearSettings.create = function create(properties) {
            return new HarvestYearSettings(properties);
        };

        /**
         * Creates a HarvestYearSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestYearSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestYearSettings} HarvestYearSettings
         */
        HarvestYearSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestYearSettings)
                return object;
            var message = new $root.pond.HarvestYearSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.field != null)
                message.field = String(object.field);
            if (object.year != null)
                message.year = object.year >>> 0;
            if (object.bushels != null)
                message.bushels = object.bushels >>> 0;
            switch (object.grain) {
            case "GRAIN_INVALID":
            case 0:
                message.grain = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.grain = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.grain = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.grain = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.grain = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.grain = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.grain = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.grain = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.grain = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.grain = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.grain = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.grain = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.grain = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.grain = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.grain = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.grain = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.grain = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.grain = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.grain = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.grain = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.grain = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.grain = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.grain = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.grain = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.grain = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.grain = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.grain = 26;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a HarvestYearSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestYearSettings
         * @static
         * @param {pond.HarvestYearSettings} message HarvestYearSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestYearSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.field = "";
                object.year = 0;
                object.bushels = 0;
                object.grain = options.enums === String ? "GRAIN_INVALID" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            if (message.bushels != null && message.hasOwnProperty("bushels"))
                object.bushels = message.bushels;
            if (message.grain != null && message.hasOwnProperty("grain"))
                object.grain = options.enums === String ? $root.pond.Grain[message.grain] : message.grain;
            return object;
        };

        /**
         * Converts this HarvestYearSettings to JSON.
         * @function toJSON
         * @memberof pond.HarvestYearSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestYearSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestYearSettings;
    })();

    pond.HarvestYearStatus = (function() {

        /**
         * Properties of a HarvestYearStatus.
         * @memberof pond
         * @interface IHarvestYearStatus
         * @property {string|null} [timestamp] HarvestYearStatus timestamp
         */

        /**
         * Constructs a new HarvestYearStatus.
         * @memberof pond
         * @classdesc Represents a HarvestYearStatus.
         * @implements IHarvestYearStatus
         * @constructor
         * @param {pond.IHarvestYearStatus=} [properties] Properties to set
         */
        function HarvestYearStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestYearStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.HarvestYearStatus
         * @instance
         */
        HarvestYearStatus.prototype.timestamp = "";

        /**
         * Creates a new HarvestYearStatus instance using the specified properties.
         * @function create
         * @memberof pond.HarvestYearStatus
         * @static
         * @param {pond.IHarvestYearStatus=} [properties] Properties to set
         * @returns {pond.HarvestYearStatus} HarvestYearStatus instance
         */
        HarvestYearStatus.create = function create(properties) {
            return new HarvestYearStatus(properties);
        };

        /**
         * Creates a HarvestYearStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestYearStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestYearStatus} HarvestYearStatus
         */
        HarvestYearStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestYearStatus)
                return object;
            var message = new $root.pond.HarvestYearStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a HarvestYearStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestYearStatus
         * @static
         * @param {pond.HarvestYearStatus} message HarvestYearStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestYearStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this HarvestYearStatus to JSON.
         * @function toJSON
         * @memberof pond.HarvestYearStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestYearStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestYearStatus;
    })();

    pond.GetHarvestYearRequest = (function() {

        /**
         * Properties of a GetHarvestYearRequest.
         * @memberof pond
         * @interface IGetHarvestYearRequest
         * @property {string|null} [harvestYear] GetHarvestYearRequest harvestYear
         */

        /**
         * Constructs a new GetHarvestYearRequest.
         * @memberof pond
         * @classdesc Represents a GetHarvestYearRequest.
         * @implements IGetHarvestYearRequest
         * @constructor
         * @param {pond.IGetHarvestYearRequest=} [properties] Properties to set
         */
        function GetHarvestYearRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetHarvestYearRequest harvestYear.
         * @member {string} harvestYear
         * @memberof pond.GetHarvestYearRequest
         * @instance
         */
        GetHarvestYearRequest.prototype.harvestYear = "";

        /**
         * Creates a new GetHarvestYearRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetHarvestYearRequest
         * @static
         * @param {pond.IGetHarvestYearRequest=} [properties] Properties to set
         * @returns {pond.GetHarvestYearRequest} GetHarvestYearRequest instance
         */
        GetHarvestYearRequest.create = function create(properties) {
            return new GetHarvestYearRequest(properties);
        };

        /**
         * Creates a GetHarvestYearRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetHarvestYearRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetHarvestYearRequest} GetHarvestYearRequest
         */
        GetHarvestYearRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetHarvestYearRequest)
                return object;
            var message = new $root.pond.GetHarvestYearRequest();
            if (object.harvestYear != null)
                message.harvestYear = String(object.harvestYear);
            return message;
        };

        /**
         * Creates a plain object from a GetHarvestYearRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetHarvestYearRequest
         * @static
         * @param {pond.GetHarvestYearRequest} message GetHarvestYearRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHarvestYearRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestYear = "";
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = message.harvestYear;
            return object;
        };

        /**
         * Converts this GetHarvestYearRequest to JSON.
         * @function toJSON
         * @memberof pond.GetHarvestYearRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHarvestYearRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetHarvestYearRequest;
    })();

    pond.AddHarvestYearRequest = (function() {

        /**
         * Properties of an AddHarvestYearRequest.
         * @memberof pond
         * @interface IAddHarvestYearRequest
         * @property {pond.HarvestYearSettings|null} [harvestYear] AddHarvestYearRequest harvestYear
         */

        /**
         * Constructs a new AddHarvestYearRequest.
         * @memberof pond
         * @classdesc Represents an AddHarvestYearRequest.
         * @implements IAddHarvestYearRequest
         * @constructor
         * @param {pond.IAddHarvestYearRequest=} [properties] Properties to set
         */
        function AddHarvestYearRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHarvestYearRequest harvestYear.
         * @member {pond.HarvestYearSettings|null|undefined} harvestYear
         * @memberof pond.AddHarvestYearRequest
         * @instance
         */
        AddHarvestYearRequest.prototype.harvestYear = null;

        /**
         * Creates a new AddHarvestYearRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddHarvestYearRequest
         * @static
         * @param {pond.IAddHarvestYearRequest=} [properties] Properties to set
         * @returns {pond.AddHarvestYearRequest} AddHarvestYearRequest instance
         */
        AddHarvestYearRequest.create = function create(properties) {
            return new AddHarvestYearRequest(properties);
        };

        /**
         * Creates an AddHarvestYearRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHarvestYearRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHarvestYearRequest} AddHarvestYearRequest
         */
        AddHarvestYearRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHarvestYearRequest)
                return object;
            var message = new $root.pond.AddHarvestYearRequest();
            if (object.harvestYear != null) {
                if (typeof object.harvestYear !== "object")
                    throw TypeError(".pond.AddHarvestYearRequest.harvestYear: object expected");
                message.harvestYear = $root.pond.HarvestYearSettings.fromObject(object.harvestYear);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddHarvestYearRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHarvestYearRequest
         * @static
         * @param {pond.AddHarvestYearRequest} message AddHarvestYearRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHarvestYearRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestYear = null;
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = $root.pond.HarvestYearSettings.toObject(message.harvestYear, options);
            return object;
        };

        /**
         * Converts this AddHarvestYearRequest to JSON.
         * @function toJSON
         * @memberof pond.AddHarvestYearRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHarvestYearRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHarvestYearRequest;
    })();

    pond.AddHarvestYearResponse = (function() {

        /**
         * Properties of an AddHarvestYearResponse.
         * @memberof pond
         * @interface IAddHarvestYearResponse
         * @property {string|null} [harvestYear] AddHarvestYearResponse harvestYear
         */

        /**
         * Constructs a new AddHarvestYearResponse.
         * @memberof pond
         * @classdesc Represents an AddHarvestYearResponse.
         * @implements IAddHarvestYearResponse
         * @constructor
         * @param {pond.IAddHarvestYearResponse=} [properties] Properties to set
         */
        function AddHarvestYearResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHarvestYearResponse harvestYear.
         * @member {string} harvestYear
         * @memberof pond.AddHarvestYearResponse
         * @instance
         */
        AddHarvestYearResponse.prototype.harvestYear = "";

        /**
         * Creates a new AddHarvestYearResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddHarvestYearResponse
         * @static
         * @param {pond.IAddHarvestYearResponse=} [properties] Properties to set
         * @returns {pond.AddHarvestYearResponse} AddHarvestYearResponse instance
         */
        AddHarvestYearResponse.create = function create(properties) {
            return new AddHarvestYearResponse(properties);
        };

        /**
         * Creates an AddHarvestYearResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHarvestYearResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHarvestYearResponse} AddHarvestYearResponse
         */
        AddHarvestYearResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHarvestYearResponse)
                return object;
            var message = new $root.pond.AddHarvestYearResponse();
            if (object.harvestYear != null)
                message.harvestYear = String(object.harvestYear);
            return message;
        };

        /**
         * Creates a plain object from an AddHarvestYearResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHarvestYearResponse
         * @static
         * @param {pond.AddHarvestYearResponse} message AddHarvestYearResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHarvestYearResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestYear = "";
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = message.harvestYear;
            return object;
        };

        /**
         * Converts this AddHarvestYearResponse to JSON.
         * @function toJSON
         * @memberof pond.AddHarvestYearResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHarvestYearResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHarvestYearResponse;
    })();

    pond.ListHarvestYearsRequest = (function() {

        /**
         * Properties of a ListHarvestYearsRequest.
         * @memberof pond
         * @interface IListHarvestYearsRequest
         * @property {string|null} [key] ListHarvestYearsRequest key
         * @property {string|null} [field] ListHarvestYearsRequest field
         * @property {pond.Paging|null} [paging] ListHarvestYearsRequest paging
         * @property {pond.Sorting|null} [sorting] ListHarvestYearsRequest sorting
         * @property {string|null} [search] ListHarvestYearsRequest search
         * @property {pond.HarvestYearSettings|null} [settingsMatch] ListHarvestYearsRequest settingsMatch
         * @property {pond.HarvestYearStatus|null} [statusMatch] ListHarvestYearsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListHarvestYearsRequest fieldContains
         */

        /**
         * Constructs a new ListHarvestYearsRequest.
         * @memberof pond
         * @classdesc Represents a ListHarvestYearsRequest.
         * @implements IListHarvestYearsRequest
         * @constructor
         * @param {pond.IListHarvestYearsRequest=} [properties] Properties to set
         */
        function ListHarvestYearsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestYearsRequest key.
         * @member {string} key
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.key = "";

        /**
         * ListHarvestYearsRequest field.
         * @member {string} field
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.field = "";

        /**
         * ListHarvestYearsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.paging = null;

        /**
         * ListHarvestYearsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.sorting = null;

        /**
         * ListHarvestYearsRequest search.
         * @member {string} search
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.search = "";

        /**
         * ListHarvestYearsRequest settingsMatch.
         * @member {pond.HarvestYearSettings|null|undefined} settingsMatch
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.settingsMatch = null;

        /**
         * ListHarvestYearsRequest statusMatch.
         * @member {pond.HarvestYearStatus|null|undefined} statusMatch
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.statusMatch = null;

        /**
         * ListHarvestYearsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         */
        ListHarvestYearsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListHarvestYearsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestYearsRequest
         * @static
         * @param {pond.IListHarvestYearsRequest=} [properties] Properties to set
         * @returns {pond.ListHarvestYearsRequest} ListHarvestYearsRequest instance
         */
        ListHarvestYearsRequest.create = function create(properties) {
            return new ListHarvestYearsRequest(properties);
        };

        /**
         * Creates a ListHarvestYearsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestYearsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestYearsRequest} ListHarvestYearsRequest
         */
        ListHarvestYearsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestYearsRequest)
                return object;
            var message = new $root.pond.ListHarvestYearsRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.field != null)
                message.field = String(object.field);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListHarvestYearsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListHarvestYearsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListHarvestYearsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.HarvestYearSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListHarvestYearsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.HarvestYearStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListHarvestYearsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestYearsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestYearsRequest
         * @static
         * @param {pond.ListHarvestYearsRequest} message ListHarvestYearsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestYearsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.field = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.HarvestYearSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.HarvestYearStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListHarvestYearsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestYearsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestYearsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestYearsRequest;
    })();

    pond.ListHarvestYearsResponse = (function() {

        /**
         * Properties of a ListHarvestYearsResponse.
         * @memberof pond
         * @interface IListHarvestYearsResponse
         * @property {Array.<pond.HarvestYear>|null} [harvestYear] ListHarvestYearsResponse harvestYear
         * @property {number|null} [nextOffset] ListHarvestYearsResponse nextOffset
         * @property {number|null} [total] ListHarvestYearsResponse total
         */

        /**
         * Constructs a new ListHarvestYearsResponse.
         * @memberof pond
         * @classdesc Represents a ListHarvestYearsResponse.
         * @implements IListHarvestYearsResponse
         * @constructor
         * @param {pond.IListHarvestYearsResponse=} [properties] Properties to set
         */
        function ListHarvestYearsResponse(properties) {
            this.harvestYear = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestYearsResponse harvestYear.
         * @member {Array.<pond.HarvestYear>} harvestYear
         * @memberof pond.ListHarvestYearsResponse
         * @instance
         */
        ListHarvestYearsResponse.prototype.harvestYear = $util.emptyArray;

        /**
         * ListHarvestYearsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListHarvestYearsResponse
         * @instance
         */
        ListHarvestYearsResponse.prototype.nextOffset = 0;

        /**
         * ListHarvestYearsResponse total.
         * @member {number} total
         * @memberof pond.ListHarvestYearsResponse
         * @instance
         */
        ListHarvestYearsResponse.prototype.total = 0;

        /**
         * Creates a new ListHarvestYearsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestYearsResponse
         * @static
         * @param {pond.IListHarvestYearsResponse=} [properties] Properties to set
         * @returns {pond.ListHarvestYearsResponse} ListHarvestYearsResponse instance
         */
        ListHarvestYearsResponse.create = function create(properties) {
            return new ListHarvestYearsResponse(properties);
        };

        /**
         * Creates a ListHarvestYearsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestYearsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestYearsResponse} ListHarvestYearsResponse
         */
        ListHarvestYearsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestYearsResponse)
                return object;
            var message = new $root.pond.ListHarvestYearsResponse();
            if (object.harvestYear) {
                if (!Array.isArray(object.harvestYear))
                    throw TypeError(".pond.ListHarvestYearsResponse.harvestYear: array expected");
                message.harvestYear = [];
                for (var i = 0; i < object.harvestYear.length; ++i) {
                    if (typeof object.harvestYear[i] !== "object")
                        throw TypeError(".pond.ListHarvestYearsResponse.harvestYear: object expected");
                    message.harvestYear[i] = $root.pond.HarvestYear.fromObject(object.harvestYear[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestYearsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestYearsResponse
         * @static
         * @param {pond.ListHarvestYearsResponse} message ListHarvestYearsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestYearsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.harvestYear = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.harvestYear && message.harvestYear.length) {
                object.harvestYear = [];
                for (var j = 0; j < message.harvestYear.length; ++j)
                    object.harvestYear[j] = $root.pond.HarvestYear.toObject(message.harvestYear[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListHarvestYearsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestYearsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestYearsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestYearsResponse;
    })();

    pond.RemoveHarvestYearRequest = (function() {

        /**
         * Properties of a RemoveHarvestYearRequest.
         * @memberof pond
         * @interface IRemoveHarvestYearRequest
         * @property {string|null} [harvestYear] RemoveHarvestYearRequest harvestYear
         */

        /**
         * Constructs a new RemoveHarvestYearRequest.
         * @memberof pond
         * @classdesc Represents a RemoveHarvestYearRequest.
         * @implements IRemoveHarvestYearRequest
         * @constructor
         * @param {pond.IRemoveHarvestYearRequest=} [properties] Properties to set
         */
        function RemoveHarvestYearRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveHarvestYearRequest harvestYear.
         * @member {string} harvestYear
         * @memberof pond.RemoveHarvestYearRequest
         * @instance
         */
        RemoveHarvestYearRequest.prototype.harvestYear = "";

        /**
         * Creates a new RemoveHarvestYearRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHarvestYearRequest
         * @static
         * @param {pond.IRemoveHarvestYearRequest=} [properties] Properties to set
         * @returns {pond.RemoveHarvestYearRequest} RemoveHarvestYearRequest instance
         */
        RemoveHarvestYearRequest.create = function create(properties) {
            return new RemoveHarvestYearRequest(properties);
        };

        /**
         * Creates a RemoveHarvestYearRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHarvestYearRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHarvestYearRequest} RemoveHarvestYearRequest
         */
        RemoveHarvestYearRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHarvestYearRequest)
                return object;
            var message = new $root.pond.RemoveHarvestYearRequest();
            if (object.harvestYear != null)
                message.harvestYear = String(object.harvestYear);
            return message;
        };

        /**
         * Creates a plain object from a RemoveHarvestYearRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHarvestYearRequest
         * @static
         * @param {pond.RemoveHarvestYearRequest} message RemoveHarvestYearRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHarvestYearRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestYear = "";
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = message.harvestYear;
            return object;
        };

        /**
         * Converts this RemoveHarvestYearRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveHarvestYearRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHarvestYearRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHarvestYearRequest;
    })();

    pond.RemoveHarvestYearResponse = (function() {

        /**
         * Properties of a RemoveHarvestYearResponse.
         * @memberof pond
         * @interface IRemoveHarvestYearResponse
         */

        /**
         * Constructs a new RemoveHarvestYearResponse.
         * @memberof pond
         * @classdesc Represents a RemoveHarvestYearResponse.
         * @implements IRemoveHarvestYearResponse
         * @constructor
         * @param {pond.IRemoveHarvestYearResponse=} [properties] Properties to set
         */
        function RemoveHarvestYearResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveHarvestYearResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHarvestYearResponse
         * @static
         * @param {pond.IRemoveHarvestYearResponse=} [properties] Properties to set
         * @returns {pond.RemoveHarvestYearResponse} RemoveHarvestYearResponse instance
         */
        RemoveHarvestYearResponse.create = function create(properties) {
            return new RemoveHarvestYearResponse(properties);
        };

        /**
         * Creates a RemoveHarvestYearResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHarvestYearResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHarvestYearResponse} RemoveHarvestYearResponse
         */
        RemoveHarvestYearResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHarvestYearResponse)
                return object;
            return new $root.pond.RemoveHarvestYearResponse();
        };

        /**
         * Creates a plain object from a RemoveHarvestYearResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHarvestYearResponse
         * @static
         * @param {pond.RemoveHarvestYearResponse} message RemoveHarvestYearResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHarvestYearResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveHarvestYearResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveHarvestYearResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHarvestYearResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHarvestYearResponse;
    })();

    pond.UpdateHarvestYearRequest = (function() {

        /**
         * Properties of an UpdateHarvestYearRequest.
         * @memberof pond
         * @interface IUpdateHarvestYearRequest
         * @property {pond.HarvestYearSettings|null} [harvestYear] UpdateHarvestYearRequest harvestYear
         */

        /**
         * Constructs a new UpdateHarvestYearRequest.
         * @memberof pond
         * @classdesc Represents an UpdateHarvestYearRequest.
         * @implements IUpdateHarvestYearRequest
         * @constructor
         * @param {pond.IUpdateHarvestYearRequest=} [properties] Properties to set
         */
        function UpdateHarvestYearRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateHarvestYearRequest harvestYear.
         * @member {pond.HarvestYearSettings|null|undefined} harvestYear
         * @memberof pond.UpdateHarvestYearRequest
         * @instance
         */
        UpdateHarvestYearRequest.prototype.harvestYear = null;

        /**
         * Creates a new UpdateHarvestYearRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHarvestYearRequest
         * @static
         * @param {pond.IUpdateHarvestYearRequest=} [properties] Properties to set
         * @returns {pond.UpdateHarvestYearRequest} UpdateHarvestYearRequest instance
         */
        UpdateHarvestYearRequest.create = function create(properties) {
            return new UpdateHarvestYearRequest(properties);
        };

        /**
         * Creates an UpdateHarvestYearRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHarvestYearRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHarvestYearRequest} UpdateHarvestYearRequest
         */
        UpdateHarvestYearRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHarvestYearRequest)
                return object;
            var message = new $root.pond.UpdateHarvestYearRequest();
            if (object.harvestYear != null) {
                if (typeof object.harvestYear !== "object")
                    throw TypeError(".pond.UpdateHarvestYearRequest.harvestYear: object expected");
                message.harvestYear = $root.pond.HarvestYearSettings.fromObject(object.harvestYear);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateHarvestYearRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHarvestYearRequest
         * @static
         * @param {pond.UpdateHarvestYearRequest} message UpdateHarvestYearRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHarvestYearRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestYear = null;
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = $root.pond.HarvestYearSettings.toObject(message.harvestYear, options);
            return object;
        };

        /**
         * Converts this UpdateHarvestYearRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateHarvestYearRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHarvestYearRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHarvestYearRequest;
    })();

    pond.UpdateHarvestYearResponse = (function() {

        /**
         * Properties of an UpdateHarvestYearResponse.
         * @memberof pond
         * @interface IUpdateHarvestYearResponse
         */

        /**
         * Constructs a new UpdateHarvestYearResponse.
         * @memberof pond
         * @classdesc Represents an UpdateHarvestYearResponse.
         * @implements IUpdateHarvestYearResponse
         * @constructor
         * @param {pond.IUpdateHarvestYearResponse=} [properties] Properties to set
         */
        function UpdateHarvestYearResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateHarvestYearResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHarvestYearResponse
         * @static
         * @param {pond.IUpdateHarvestYearResponse=} [properties] Properties to set
         * @returns {pond.UpdateHarvestYearResponse} UpdateHarvestYearResponse instance
         */
        UpdateHarvestYearResponse.create = function create(properties) {
            return new UpdateHarvestYearResponse(properties);
        };

        /**
         * Creates an UpdateHarvestYearResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHarvestYearResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHarvestYearResponse} UpdateHarvestYearResponse
         */
        UpdateHarvestYearResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHarvestYearResponse)
                return object;
            return new $root.pond.UpdateHarvestYearResponse();
        };

        /**
         * Creates a plain object from an UpdateHarvestYearResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHarvestYearResponse
         * @static
         * @param {pond.UpdateHarvestYearResponse} message UpdateHarvestYearResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHarvestYearResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateHarvestYearResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateHarvestYearResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHarvestYearResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHarvestYearResponse;
    })();

    pond.HarvestPlan = (function() {

        /**
         * Properties of a HarvestPlan.
         * @memberof pond
         * @interface IHarvestPlan
         * @property {pond.HarvestPlanSettings|null} [settings] HarvestPlan settings
         * @property {pond.HarvestPlanStatus|null} [status] HarvestPlan status
         * @property {Array.<pond.Permission>|null} [planPermissions] HarvestPlan planPermissions
         */

        /**
         * Constructs a new HarvestPlan.
         * @memberof pond
         * @classdesc Represents a HarvestPlan.
         * @implements IHarvestPlan
         * @constructor
         * @param {pond.IHarvestPlan=} [properties] Properties to set
         */
        function HarvestPlan(properties) {
            this.planPermissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestPlan settings.
         * @member {pond.HarvestPlanSettings|null|undefined} settings
         * @memberof pond.HarvestPlan
         * @instance
         */
        HarvestPlan.prototype.settings = null;

        /**
         * HarvestPlan status.
         * @member {pond.HarvestPlanStatus|null|undefined} status
         * @memberof pond.HarvestPlan
         * @instance
         */
        HarvestPlan.prototype.status = null;

        /**
         * HarvestPlan planPermissions.
         * @member {Array.<pond.Permission>} planPermissions
         * @memberof pond.HarvestPlan
         * @instance
         */
        HarvestPlan.prototype.planPermissions = $util.emptyArray;

        /**
         * Creates a new HarvestPlan instance using the specified properties.
         * @function create
         * @memberof pond.HarvestPlan
         * @static
         * @param {pond.IHarvestPlan=} [properties] Properties to set
         * @returns {pond.HarvestPlan} HarvestPlan instance
         */
        HarvestPlan.create = function create(properties) {
            return new HarvestPlan(properties);
        };

        /**
         * Creates a HarvestPlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestPlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestPlan} HarvestPlan
         */
        HarvestPlan.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestPlan)
                return object;
            var message = new $root.pond.HarvestPlan();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.HarvestPlan.settings: object expected");
                message.settings = $root.pond.HarvestPlanSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.HarvestPlan.status: object expected");
                message.status = $root.pond.HarvestPlanStatus.fromObject(object.status);
            }
            if (object.planPermissions) {
                if (!Array.isArray(object.planPermissions))
                    throw TypeError(".pond.HarvestPlan.planPermissions: array expected");
                message.planPermissions = [];
                for (var i = 0; i < object.planPermissions.length; ++i)
                    switch (object.planPermissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.planPermissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.planPermissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.planPermissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.planPermissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.planPermissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.planPermissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.planPermissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a HarvestPlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestPlan
         * @static
         * @param {pond.HarvestPlan} message HarvestPlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestPlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.planPermissions = [];
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.HarvestPlanSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.HarvestPlanStatus.toObject(message.status, options);
            if (message.planPermissions && message.planPermissions.length) {
                object.planPermissions = [];
                for (var j = 0; j < message.planPermissions.length; ++j)
                    object.planPermissions[j] = options.enums === String ? $root.pond.Permission[message.planPermissions[j]] : message.planPermissions[j];
            }
            return object;
        };

        /**
         * Converts this HarvestPlan to JSON.
         * @function toJSON
         * @memberof pond.HarvestPlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestPlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestPlan;
    })();

    pond.HarvestPlanSettings = (function() {

        /**
         * Properties of a HarvestPlanSettings.
         * @memberof pond
         * @interface IHarvestPlanSettings
         * @property {string|null} [key] HarvestPlanSettings key
         * @property {string|null} [field] HarvestPlanSettings field
         * @property {number|null} [harvestYear] HarvestPlanSettings harvestYear
         * @property {pond.Grain|null} [cropType] HarvestPlanSettings cropType
         * @property {string|null} [grainType] HarvestPlanSettings grainType
         * @property {number|null} [yieldTarget] HarvestPlanSettings yieldTarget
         * @property {number|null} [actualYield] HarvestPlanSettings actualYield
         * @property {number|null} [seedMaterials] HarvestPlanSettings seedMaterials
         * @property {number|null} [seedEquipment] HarvestPlanSettings seedEquipment
         * @property {number|null} [preSeedMaterials] HarvestPlanSettings preSeedMaterials
         * @property {number|null} [preSeedEquipment] HarvestPlanSettings preSeedEquipment
         * @property {number|null} [postSeedMaterials] HarvestPlanSettings postSeedMaterials
         * @property {number|null} [postSeedEquipment] HarvestPlanSettings postSeedEquipment
         * @property {number|null} [harvestMaterials] HarvestPlanSettings harvestMaterials
         * @property {number|null} [harvestEquipment] HarvestPlanSettings harvestEquipment
         * @property {Array.<string>|null} [taskIds] HarvestPlanSettings taskIds
         * @property {number|null} [createDate] HarvestPlanSettings createDate
         * @property {string|null} [title] HarvestPlanSettings title
         * @property {number|null} [bushelPrice] HarvestPlanSettings bushelPrice
         * @property {number|null} [fallMaterials] HarvestPlanSettings fallMaterials
         * @property {number|null} [fallEquipment] HarvestPlanSettings fallEquipment
         * @property {string|null} [customGrain] HarvestPlanSettings customGrain
         */

        /**
         * Constructs a new HarvestPlanSettings.
         * @memberof pond
         * @classdesc Represents a HarvestPlanSettings.
         * @implements IHarvestPlanSettings
         * @constructor
         * @param {pond.IHarvestPlanSettings=} [properties] Properties to set
         */
        function HarvestPlanSettings(properties) {
            this.taskIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestPlanSettings key.
         * @member {string} key
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.key = "";

        /**
         * HarvestPlanSettings field.
         * @member {string} field
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.field = "";

        /**
         * HarvestPlanSettings harvestYear.
         * @member {number} harvestYear
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.harvestYear = 0;

        /**
         * HarvestPlanSettings cropType.
         * @member {pond.Grain} cropType
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.cropType = 0;

        /**
         * HarvestPlanSettings grainType.
         * @member {string} grainType
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.grainType = "";

        /**
         * HarvestPlanSettings yieldTarget.
         * @member {number} yieldTarget
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.yieldTarget = 0;

        /**
         * HarvestPlanSettings actualYield.
         * @member {number} actualYield
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.actualYield = 0;

        /**
         * HarvestPlanSettings seedMaterials.
         * @member {number} seedMaterials
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.seedMaterials = 0;

        /**
         * HarvestPlanSettings seedEquipment.
         * @member {number} seedEquipment
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.seedEquipment = 0;

        /**
         * HarvestPlanSettings preSeedMaterials.
         * @member {number} preSeedMaterials
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.preSeedMaterials = 0;

        /**
         * HarvestPlanSettings preSeedEquipment.
         * @member {number} preSeedEquipment
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.preSeedEquipment = 0;

        /**
         * HarvestPlanSettings postSeedMaterials.
         * @member {number} postSeedMaterials
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.postSeedMaterials = 0;

        /**
         * HarvestPlanSettings postSeedEquipment.
         * @member {number} postSeedEquipment
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.postSeedEquipment = 0;

        /**
         * HarvestPlanSettings harvestMaterials.
         * @member {number} harvestMaterials
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.harvestMaterials = 0;

        /**
         * HarvestPlanSettings harvestEquipment.
         * @member {number} harvestEquipment
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.harvestEquipment = 0;

        /**
         * HarvestPlanSettings taskIds.
         * @member {Array.<string>} taskIds
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.taskIds = $util.emptyArray;

        /**
         * HarvestPlanSettings createDate.
         * @member {number} createDate
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.createDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HarvestPlanSettings title.
         * @member {string} title
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.title = "";

        /**
         * HarvestPlanSettings bushelPrice.
         * @member {number} bushelPrice
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.bushelPrice = 0;

        /**
         * HarvestPlanSettings fallMaterials.
         * @member {number} fallMaterials
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.fallMaterials = 0;

        /**
         * HarvestPlanSettings fallEquipment.
         * @member {number} fallEquipment
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.fallEquipment = 0;

        /**
         * HarvestPlanSettings customGrain.
         * @member {string} customGrain
         * @memberof pond.HarvestPlanSettings
         * @instance
         */
        HarvestPlanSettings.prototype.customGrain = "";

        /**
         * Creates a new HarvestPlanSettings instance using the specified properties.
         * @function create
         * @memberof pond.HarvestPlanSettings
         * @static
         * @param {pond.IHarvestPlanSettings=} [properties] Properties to set
         * @returns {pond.HarvestPlanSettings} HarvestPlanSettings instance
         */
        HarvestPlanSettings.create = function create(properties) {
            return new HarvestPlanSettings(properties);
        };

        /**
         * Creates a HarvestPlanSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestPlanSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestPlanSettings} HarvestPlanSettings
         */
        HarvestPlanSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestPlanSettings)
                return object;
            var message = new $root.pond.HarvestPlanSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.field != null)
                message.field = String(object.field);
            if (object.harvestYear != null)
                message.harvestYear = object.harvestYear >>> 0;
            switch (object.cropType) {
            case "GRAIN_INVALID":
            case 0:
                message.cropType = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.cropType = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.cropType = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.cropType = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.cropType = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.cropType = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.cropType = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.cropType = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.cropType = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.cropType = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.cropType = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.cropType = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.cropType = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.cropType = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.cropType = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.cropType = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.cropType = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.cropType = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.cropType = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.cropType = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.cropType = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.cropType = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.cropType = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.cropType = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.cropType = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.cropType = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.cropType = 26;
                break;
            }
            if (object.grainType != null)
                message.grainType = String(object.grainType);
            if (object.yieldTarget != null)
                message.yieldTarget = object.yieldTarget >>> 0;
            if (object.actualYield != null)
                message.actualYield = object.actualYield >>> 0;
            if (object.seedMaterials != null)
                message.seedMaterials = Number(object.seedMaterials);
            if (object.seedEquipment != null)
                message.seedEquipment = Number(object.seedEquipment);
            if (object.preSeedMaterials != null)
                message.preSeedMaterials = Number(object.preSeedMaterials);
            if (object.preSeedEquipment != null)
                message.preSeedEquipment = Number(object.preSeedEquipment);
            if (object.postSeedMaterials != null)
                message.postSeedMaterials = Number(object.postSeedMaterials);
            if (object.postSeedEquipment != null)
                message.postSeedEquipment = Number(object.postSeedEquipment);
            if (object.harvestMaterials != null)
                message.harvestMaterials = Number(object.harvestMaterials);
            if (object.harvestEquipment != null)
                message.harvestEquipment = Number(object.harvestEquipment);
            if (object.taskIds) {
                if (!Array.isArray(object.taskIds))
                    throw TypeError(".pond.HarvestPlanSettings.taskIds: array expected");
                message.taskIds = [];
                for (var i = 0; i < object.taskIds.length; ++i)
                    message.taskIds[i] = String(object.taskIds[i]);
            }
            if (object.createDate != null)
                if ($util.Long)
                    (message.createDate = $util.Long.fromValue(object.createDate)).unsigned = true;
                else if (typeof object.createDate === "string")
                    message.createDate = parseInt(object.createDate, 10);
                else if (typeof object.createDate === "number")
                    message.createDate = object.createDate;
                else if (typeof object.createDate === "object")
                    message.createDate = new $util.LongBits(object.createDate.low >>> 0, object.createDate.high >>> 0).toNumber(true);
            if (object.title != null)
                message.title = String(object.title);
            if (object.bushelPrice != null)
                message.bushelPrice = Number(object.bushelPrice);
            if (object.fallMaterials != null)
                message.fallMaterials = Number(object.fallMaterials);
            if (object.fallEquipment != null)
                message.fallEquipment = Number(object.fallEquipment);
            if (object.customGrain != null)
                message.customGrain = String(object.customGrain);
            return message;
        };

        /**
         * Creates a plain object from a HarvestPlanSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestPlanSettings
         * @static
         * @param {pond.HarvestPlanSettings} message HarvestPlanSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestPlanSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.taskIds = [];
            if (options.defaults) {
                object.key = "";
                object.field = "";
                object.harvestYear = 0;
                object.cropType = options.enums === String ? "GRAIN_INVALID" : 0;
                object.grainType = "";
                object.yieldTarget = 0;
                object.actualYield = 0;
                object.seedMaterials = 0;
                object.seedEquipment = 0;
                object.preSeedMaterials = 0;
                object.preSeedEquipment = 0;
                object.postSeedMaterials = 0;
                object.postSeedEquipment = 0;
                object.harvestMaterials = 0;
                object.harvestEquipment = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.createDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createDate = options.longs === String ? "0" : 0;
                object.title = "";
                object.bushelPrice = 0;
                object.fallMaterials = 0;
                object.fallEquipment = 0;
                object.customGrain = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            if (message.harvestYear != null && message.hasOwnProperty("harvestYear"))
                object.harvestYear = message.harvestYear;
            if (message.cropType != null && message.hasOwnProperty("cropType"))
                object.cropType = options.enums === String ? $root.pond.Grain[message.cropType] : message.cropType;
            if (message.grainType != null && message.hasOwnProperty("grainType"))
                object.grainType = message.grainType;
            if (message.yieldTarget != null && message.hasOwnProperty("yieldTarget"))
                object.yieldTarget = message.yieldTarget;
            if (message.actualYield != null && message.hasOwnProperty("actualYield"))
                object.actualYield = message.actualYield;
            if (message.seedMaterials != null && message.hasOwnProperty("seedMaterials"))
                object.seedMaterials = options.json && !isFinite(message.seedMaterials) ? String(message.seedMaterials) : message.seedMaterials;
            if (message.seedEquipment != null && message.hasOwnProperty("seedEquipment"))
                object.seedEquipment = options.json && !isFinite(message.seedEquipment) ? String(message.seedEquipment) : message.seedEquipment;
            if (message.preSeedMaterials != null && message.hasOwnProperty("preSeedMaterials"))
                object.preSeedMaterials = options.json && !isFinite(message.preSeedMaterials) ? String(message.preSeedMaterials) : message.preSeedMaterials;
            if (message.preSeedEquipment != null && message.hasOwnProperty("preSeedEquipment"))
                object.preSeedEquipment = options.json && !isFinite(message.preSeedEquipment) ? String(message.preSeedEquipment) : message.preSeedEquipment;
            if (message.postSeedMaterials != null && message.hasOwnProperty("postSeedMaterials"))
                object.postSeedMaterials = options.json && !isFinite(message.postSeedMaterials) ? String(message.postSeedMaterials) : message.postSeedMaterials;
            if (message.postSeedEquipment != null && message.hasOwnProperty("postSeedEquipment"))
                object.postSeedEquipment = options.json && !isFinite(message.postSeedEquipment) ? String(message.postSeedEquipment) : message.postSeedEquipment;
            if (message.harvestMaterials != null && message.hasOwnProperty("harvestMaterials"))
                object.harvestMaterials = options.json && !isFinite(message.harvestMaterials) ? String(message.harvestMaterials) : message.harvestMaterials;
            if (message.harvestEquipment != null && message.hasOwnProperty("harvestEquipment"))
                object.harvestEquipment = options.json && !isFinite(message.harvestEquipment) ? String(message.harvestEquipment) : message.harvestEquipment;
            if (message.taskIds && message.taskIds.length) {
                object.taskIds = [];
                for (var j = 0; j < message.taskIds.length; ++j)
                    object.taskIds[j] = message.taskIds[j];
            }
            if (message.createDate != null && message.hasOwnProperty("createDate"))
                if (typeof message.createDate === "number")
                    object.createDate = options.longs === String ? String(message.createDate) : message.createDate;
                else
                    object.createDate = options.longs === String ? $util.Long.prototype.toString.call(message.createDate) : options.longs === Number ? new $util.LongBits(message.createDate.low >>> 0, message.createDate.high >>> 0).toNumber(true) : message.createDate;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.bushelPrice != null && message.hasOwnProperty("bushelPrice"))
                object.bushelPrice = options.json && !isFinite(message.bushelPrice) ? String(message.bushelPrice) : message.bushelPrice;
            if (message.fallMaterials != null && message.hasOwnProperty("fallMaterials"))
                object.fallMaterials = options.json && !isFinite(message.fallMaterials) ? String(message.fallMaterials) : message.fallMaterials;
            if (message.fallEquipment != null && message.hasOwnProperty("fallEquipment"))
                object.fallEquipment = options.json && !isFinite(message.fallEquipment) ? String(message.fallEquipment) : message.fallEquipment;
            if (message.customGrain != null && message.hasOwnProperty("customGrain"))
                object.customGrain = message.customGrain;
            return object;
        };

        /**
         * Converts this HarvestPlanSettings to JSON.
         * @function toJSON
         * @memberof pond.HarvestPlanSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestPlanSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestPlanSettings;
    })();

    pond.HarvestPlanStatus = (function() {

        /**
         * Properties of a HarvestPlanStatus.
         * @memberof pond
         * @interface IHarvestPlanStatus
         * @property {string|null} [timestamp] HarvestPlanStatus timestamp
         */

        /**
         * Constructs a new HarvestPlanStatus.
         * @memberof pond
         * @classdesc Represents a HarvestPlanStatus.
         * @implements IHarvestPlanStatus
         * @constructor
         * @param {pond.IHarvestPlanStatus=} [properties] Properties to set
         */
        function HarvestPlanStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestPlanStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.HarvestPlanStatus
         * @instance
         */
        HarvestPlanStatus.prototype.timestamp = "";

        /**
         * Creates a new HarvestPlanStatus instance using the specified properties.
         * @function create
         * @memberof pond.HarvestPlanStatus
         * @static
         * @param {pond.IHarvestPlanStatus=} [properties] Properties to set
         * @returns {pond.HarvestPlanStatus} HarvestPlanStatus instance
         */
        HarvestPlanStatus.create = function create(properties) {
            return new HarvestPlanStatus(properties);
        };

        /**
         * Creates a HarvestPlanStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestPlanStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestPlanStatus} HarvestPlanStatus
         */
        HarvestPlanStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestPlanStatus)
                return object;
            var message = new $root.pond.HarvestPlanStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a HarvestPlanStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestPlanStatus
         * @static
         * @param {pond.HarvestPlanStatus} message HarvestPlanStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestPlanStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this HarvestPlanStatus to JSON.
         * @function toJSON
         * @memberof pond.HarvestPlanStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestPlanStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestPlanStatus;
    })();

    pond.HarvestPlanHistory = (function() {

        /**
         * Properties of a HarvestPlanHistory.
         * @memberof pond
         * @interface IHarvestPlanHistory
         * @property {pond.HarvestPlanSettings|null} [settings] HarvestPlanHistory settings
         * @property {string|null} [user] HarvestPlanHistory user
         * @property {string|null} [timestamp] HarvestPlanHistory timestamp
         * @property {string|null} [progress] HarvestPlanHistory progress
         */

        /**
         * Constructs a new HarvestPlanHistory.
         * @memberof pond
         * @classdesc Represents a HarvestPlanHistory.
         * @implements IHarvestPlanHistory
         * @constructor
         * @param {pond.IHarvestPlanHistory=} [properties] Properties to set
         */
        function HarvestPlanHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HarvestPlanHistory settings.
         * @member {pond.HarvestPlanSettings|null|undefined} settings
         * @memberof pond.HarvestPlanHistory
         * @instance
         */
        HarvestPlanHistory.prototype.settings = null;

        /**
         * HarvestPlanHistory user.
         * @member {string} user
         * @memberof pond.HarvestPlanHistory
         * @instance
         */
        HarvestPlanHistory.prototype.user = "";

        /**
         * HarvestPlanHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.HarvestPlanHistory
         * @instance
         */
        HarvestPlanHistory.prototype.timestamp = "";

        /**
         * HarvestPlanHistory progress.
         * @member {string} progress
         * @memberof pond.HarvestPlanHistory
         * @instance
         */
        HarvestPlanHistory.prototype.progress = "";

        /**
         * Creates a new HarvestPlanHistory instance using the specified properties.
         * @function create
         * @memberof pond.HarvestPlanHistory
         * @static
         * @param {pond.IHarvestPlanHistory=} [properties] Properties to set
         * @returns {pond.HarvestPlanHistory} HarvestPlanHistory instance
         */
        HarvestPlanHistory.create = function create(properties) {
            return new HarvestPlanHistory(properties);
        };

        /**
         * Creates a HarvestPlanHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HarvestPlanHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HarvestPlanHistory} HarvestPlanHistory
         */
        HarvestPlanHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HarvestPlanHistory)
                return object;
            var message = new $root.pond.HarvestPlanHistory();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.HarvestPlanHistory.settings: object expected");
                message.settings = $root.pond.HarvestPlanSettings.fromObject(object.settings);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.progress != null)
                message.progress = String(object.progress);
            return message;
        };

        /**
         * Creates a plain object from a HarvestPlanHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HarvestPlanHistory
         * @static
         * @param {pond.HarvestPlanHistory} message HarvestPlanHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HarvestPlanHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.user = "";
                object.timestamp = "";
                object.progress = "";
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.HarvestPlanSettings.toObject(message.settings, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            return object;
        };

        /**
         * Converts this HarvestPlanHistory to JSON.
         * @function toJSON
         * @memberof pond.HarvestPlanHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HarvestPlanHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HarvestPlanHistory;
    })();

    pond.ListHarvestPlanHistoryRequest = (function() {

        /**
         * Properties of a ListHarvestPlanHistoryRequest.
         * @memberof pond
         * @interface IListHarvestPlanHistoryRequest
         * @property {string|null} [key] ListHarvestPlanHistoryRequest key
         * @property {pond.Paging|null} [paging] ListHarvestPlanHistoryRequest paging
         */

        /**
         * Constructs a new ListHarvestPlanHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListHarvestPlanHistoryRequest.
         * @implements IListHarvestPlanHistoryRequest
         * @constructor
         * @param {pond.IListHarvestPlanHistoryRequest=} [properties] Properties to set
         */
        function ListHarvestPlanHistoryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestPlanHistoryRequest key.
         * @member {string} key
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @instance
         */
        ListHarvestPlanHistoryRequest.prototype.key = "";

        /**
         * ListHarvestPlanHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @instance
         */
        ListHarvestPlanHistoryRequest.prototype.paging = null;

        /**
         * Creates a new ListHarvestPlanHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @static
         * @param {pond.IListHarvestPlanHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListHarvestPlanHistoryRequest} ListHarvestPlanHistoryRequest instance
         */
        ListHarvestPlanHistoryRequest.create = function create(properties) {
            return new ListHarvestPlanHistoryRequest(properties);
        };

        /**
         * Creates a ListHarvestPlanHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestPlanHistoryRequest} ListHarvestPlanHistoryRequest
         */
        ListHarvestPlanHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestPlanHistoryRequest)
                return object;
            var message = new $root.pond.ListHarvestPlanHistoryRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListHarvestPlanHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestPlanHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @static
         * @param {pond.ListHarvestPlanHistoryRequest} message ListHarvestPlanHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestPlanHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.paging = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            return object;
        };

        /**
         * Converts this ListHarvestPlanHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestPlanHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestPlanHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestPlanHistoryRequest;
    })();

    pond.ListHarvestPlanHistoryResponse = (function() {

        /**
         * Properties of a ListHarvestPlanHistoryResponse.
         * @memberof pond
         * @interface IListHarvestPlanHistoryResponse
         * @property {Array.<pond.HarvestPlanHistory>|null} [history] ListHarvestPlanHistoryResponse history
         * @property {number|null} [nextOffset] ListHarvestPlanHistoryResponse nextOffset
         * @property {number|null} [total] ListHarvestPlanHistoryResponse total
         */

        /**
         * Constructs a new ListHarvestPlanHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListHarvestPlanHistoryResponse.
         * @implements IListHarvestPlanHistoryResponse
         * @constructor
         * @param {pond.IListHarvestPlanHistoryResponse=} [properties] Properties to set
         */
        function ListHarvestPlanHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestPlanHistoryResponse history.
         * @member {Array.<pond.HarvestPlanHistory>} history
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @instance
         */
        ListHarvestPlanHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListHarvestPlanHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @instance
         */
        ListHarvestPlanHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListHarvestPlanHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @instance
         */
        ListHarvestPlanHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListHarvestPlanHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @static
         * @param {pond.IListHarvestPlanHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListHarvestPlanHistoryResponse} ListHarvestPlanHistoryResponse instance
         */
        ListHarvestPlanHistoryResponse.create = function create(properties) {
            return new ListHarvestPlanHistoryResponse(properties);
        };

        /**
         * Creates a ListHarvestPlanHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestPlanHistoryResponse} ListHarvestPlanHistoryResponse
         */
        ListHarvestPlanHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestPlanHistoryResponse)
                return object;
            var message = new $root.pond.ListHarvestPlanHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListHarvestPlanHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListHarvestPlanHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.HarvestPlanHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestPlanHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @static
         * @param {pond.ListHarvestPlanHistoryResponse} message ListHarvestPlanHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestPlanHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.HarvestPlanHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListHarvestPlanHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestPlanHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestPlanHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestPlanHistoryResponse;
    })();

    pond.GetHarvestPlanRequest = (function() {

        /**
         * Properties of a GetHarvestPlanRequest.
         * @memberof pond
         * @interface IGetHarvestPlanRequest
         * @property {string|null} [harvestPlan] GetHarvestPlanRequest harvestPlan
         */

        /**
         * Constructs a new GetHarvestPlanRequest.
         * @memberof pond
         * @classdesc Represents a GetHarvestPlanRequest.
         * @implements IGetHarvestPlanRequest
         * @constructor
         * @param {pond.IGetHarvestPlanRequest=} [properties] Properties to set
         */
        function GetHarvestPlanRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetHarvestPlanRequest harvestPlan.
         * @member {string} harvestPlan
         * @memberof pond.GetHarvestPlanRequest
         * @instance
         */
        GetHarvestPlanRequest.prototype.harvestPlan = "";

        /**
         * Creates a new GetHarvestPlanRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetHarvestPlanRequest
         * @static
         * @param {pond.IGetHarvestPlanRequest=} [properties] Properties to set
         * @returns {pond.GetHarvestPlanRequest} GetHarvestPlanRequest instance
         */
        GetHarvestPlanRequest.create = function create(properties) {
            return new GetHarvestPlanRequest(properties);
        };

        /**
         * Creates a GetHarvestPlanRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetHarvestPlanRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetHarvestPlanRequest} GetHarvestPlanRequest
         */
        GetHarvestPlanRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetHarvestPlanRequest)
                return object;
            var message = new $root.pond.GetHarvestPlanRequest();
            if (object.harvestPlan != null)
                message.harvestPlan = String(object.harvestPlan);
            return message;
        };

        /**
         * Creates a plain object from a GetHarvestPlanRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetHarvestPlanRequest
         * @static
         * @param {pond.GetHarvestPlanRequest} message GetHarvestPlanRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHarvestPlanRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestPlan = "";
            if (message.harvestPlan != null && message.hasOwnProperty("harvestPlan"))
                object.harvestPlan = message.harvestPlan;
            return object;
        };

        /**
         * Converts this GetHarvestPlanRequest to JSON.
         * @function toJSON
         * @memberof pond.GetHarvestPlanRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHarvestPlanRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetHarvestPlanRequest;
    })();

    pond.AddHarvestPlanRequest = (function() {

        /**
         * Properties of an AddHarvestPlanRequest.
         * @memberof pond
         * @interface IAddHarvestPlanRequest
         * @property {pond.HarvestPlanSettings|null} [harvestPlan] AddHarvestPlanRequest harvestPlan
         */

        /**
         * Constructs a new AddHarvestPlanRequest.
         * @memberof pond
         * @classdesc Represents an AddHarvestPlanRequest.
         * @implements IAddHarvestPlanRequest
         * @constructor
         * @param {pond.IAddHarvestPlanRequest=} [properties] Properties to set
         */
        function AddHarvestPlanRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHarvestPlanRequest harvestPlan.
         * @member {pond.HarvestPlanSettings|null|undefined} harvestPlan
         * @memberof pond.AddHarvestPlanRequest
         * @instance
         */
        AddHarvestPlanRequest.prototype.harvestPlan = null;

        /**
         * Creates a new AddHarvestPlanRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddHarvestPlanRequest
         * @static
         * @param {pond.IAddHarvestPlanRequest=} [properties] Properties to set
         * @returns {pond.AddHarvestPlanRequest} AddHarvestPlanRequest instance
         */
        AddHarvestPlanRequest.create = function create(properties) {
            return new AddHarvestPlanRequest(properties);
        };

        /**
         * Creates an AddHarvestPlanRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHarvestPlanRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHarvestPlanRequest} AddHarvestPlanRequest
         */
        AddHarvestPlanRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHarvestPlanRequest)
                return object;
            var message = new $root.pond.AddHarvestPlanRequest();
            if (object.harvestPlan != null) {
                if (typeof object.harvestPlan !== "object")
                    throw TypeError(".pond.AddHarvestPlanRequest.harvestPlan: object expected");
                message.harvestPlan = $root.pond.HarvestPlanSettings.fromObject(object.harvestPlan);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddHarvestPlanRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHarvestPlanRequest
         * @static
         * @param {pond.AddHarvestPlanRequest} message AddHarvestPlanRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHarvestPlanRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestPlan = null;
            if (message.harvestPlan != null && message.hasOwnProperty("harvestPlan"))
                object.harvestPlan = $root.pond.HarvestPlanSettings.toObject(message.harvestPlan, options);
            return object;
        };

        /**
         * Converts this AddHarvestPlanRequest to JSON.
         * @function toJSON
         * @memberof pond.AddHarvestPlanRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHarvestPlanRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHarvestPlanRequest;
    })();

    pond.AddHarvestPlanResponse = (function() {

        /**
         * Properties of an AddHarvestPlanResponse.
         * @memberof pond
         * @interface IAddHarvestPlanResponse
         * @property {string|null} [harvestPlan] AddHarvestPlanResponse harvestPlan
         */

        /**
         * Constructs a new AddHarvestPlanResponse.
         * @memberof pond
         * @classdesc Represents an AddHarvestPlanResponse.
         * @implements IAddHarvestPlanResponse
         * @constructor
         * @param {pond.IAddHarvestPlanResponse=} [properties] Properties to set
         */
        function AddHarvestPlanResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddHarvestPlanResponse harvestPlan.
         * @member {string} harvestPlan
         * @memberof pond.AddHarvestPlanResponse
         * @instance
         */
        AddHarvestPlanResponse.prototype.harvestPlan = "";

        /**
         * Creates a new AddHarvestPlanResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddHarvestPlanResponse
         * @static
         * @param {pond.IAddHarvestPlanResponse=} [properties] Properties to set
         * @returns {pond.AddHarvestPlanResponse} AddHarvestPlanResponse instance
         */
        AddHarvestPlanResponse.create = function create(properties) {
            return new AddHarvestPlanResponse(properties);
        };

        /**
         * Creates an AddHarvestPlanResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddHarvestPlanResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddHarvestPlanResponse} AddHarvestPlanResponse
         */
        AddHarvestPlanResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddHarvestPlanResponse)
                return object;
            var message = new $root.pond.AddHarvestPlanResponse();
            if (object.harvestPlan != null)
                message.harvestPlan = String(object.harvestPlan);
            return message;
        };

        /**
         * Creates a plain object from an AddHarvestPlanResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddHarvestPlanResponse
         * @static
         * @param {pond.AddHarvestPlanResponse} message AddHarvestPlanResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddHarvestPlanResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestPlan = "";
            if (message.harvestPlan != null && message.hasOwnProperty("harvestPlan"))
                object.harvestPlan = message.harvestPlan;
            return object;
        };

        /**
         * Converts this AddHarvestPlanResponse to JSON.
         * @function toJSON
         * @memberof pond.AddHarvestPlanResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddHarvestPlanResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddHarvestPlanResponse;
    })();

    pond.ListHarvestPlansRequest = (function() {

        /**
         * Properties of a ListHarvestPlansRequest.
         * @memberof pond
         * @interface IListHarvestPlansRequest
         * @property {string|null} [key] ListHarvestPlansRequest key
         * @property {string|null} [field] ListHarvestPlansRequest field
         * @property {pond.Paging|null} [paging] ListHarvestPlansRequest paging
         * @property {pond.Sorting|null} [sorting] ListHarvestPlansRequest sorting
         * @property {string|null} [search] ListHarvestPlansRequest search
         * @property {pond.HarvestPlanSettings|null} [settingsMatch] ListHarvestPlansRequest settingsMatch
         * @property {pond.HarvestPlanStatus|null} [statusMatch] ListHarvestPlansRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListHarvestPlansRequest fieldContains
         */

        /**
         * Constructs a new ListHarvestPlansRequest.
         * @memberof pond
         * @classdesc Represents a ListHarvestPlansRequest.
         * @implements IListHarvestPlansRequest
         * @constructor
         * @param {pond.IListHarvestPlansRequest=} [properties] Properties to set
         */
        function ListHarvestPlansRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestPlansRequest key.
         * @member {string} key
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.key = "";

        /**
         * ListHarvestPlansRequest field.
         * @member {string} field
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.field = "";

        /**
         * ListHarvestPlansRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.paging = null;

        /**
         * ListHarvestPlansRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.sorting = null;

        /**
         * ListHarvestPlansRequest search.
         * @member {string} search
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.search = "";

        /**
         * ListHarvestPlansRequest settingsMatch.
         * @member {pond.HarvestPlanSettings|null|undefined} settingsMatch
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.settingsMatch = null;

        /**
         * ListHarvestPlansRequest statusMatch.
         * @member {pond.HarvestPlanStatus|null|undefined} statusMatch
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.statusMatch = null;

        /**
         * ListHarvestPlansRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         */
        ListHarvestPlansRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListHarvestPlansRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestPlansRequest
         * @static
         * @param {pond.IListHarvestPlansRequest=} [properties] Properties to set
         * @returns {pond.ListHarvestPlansRequest} ListHarvestPlansRequest instance
         */
        ListHarvestPlansRequest.create = function create(properties) {
            return new ListHarvestPlansRequest(properties);
        };

        /**
         * Creates a ListHarvestPlansRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestPlansRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestPlansRequest} ListHarvestPlansRequest
         */
        ListHarvestPlansRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestPlansRequest)
                return object;
            var message = new $root.pond.ListHarvestPlansRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.field != null)
                message.field = String(object.field);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListHarvestPlansRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListHarvestPlansRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListHarvestPlansRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.HarvestPlanSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListHarvestPlansRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.HarvestPlanStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListHarvestPlansRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestPlansRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestPlansRequest
         * @static
         * @param {pond.ListHarvestPlansRequest} message ListHarvestPlansRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestPlansRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.field = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.field != null && message.hasOwnProperty("field"))
                object.field = message.field;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.HarvestPlanSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.HarvestPlanStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListHarvestPlansRequest to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestPlansRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestPlansRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestPlansRequest;
    })();

    pond.ListHarvestPlansResponse = (function() {

        /**
         * Properties of a ListHarvestPlansResponse.
         * @memberof pond
         * @interface IListHarvestPlansResponse
         * @property {Array.<pond.HarvestPlan>|null} [harvestPlan] ListHarvestPlansResponse harvestPlan
         * @property {number|null} [nextOffset] ListHarvestPlansResponse nextOffset
         * @property {number|null} [total] ListHarvestPlansResponse total
         */

        /**
         * Constructs a new ListHarvestPlansResponse.
         * @memberof pond
         * @classdesc Represents a ListHarvestPlansResponse.
         * @implements IListHarvestPlansResponse
         * @constructor
         * @param {pond.IListHarvestPlansResponse=} [properties] Properties to set
         */
        function ListHarvestPlansResponse(properties) {
            this.harvestPlan = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListHarvestPlansResponse harvestPlan.
         * @member {Array.<pond.HarvestPlan>} harvestPlan
         * @memberof pond.ListHarvestPlansResponse
         * @instance
         */
        ListHarvestPlansResponse.prototype.harvestPlan = $util.emptyArray;

        /**
         * ListHarvestPlansResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListHarvestPlansResponse
         * @instance
         */
        ListHarvestPlansResponse.prototype.nextOffset = 0;

        /**
         * ListHarvestPlansResponse total.
         * @member {number} total
         * @memberof pond.ListHarvestPlansResponse
         * @instance
         */
        ListHarvestPlansResponse.prototype.total = 0;

        /**
         * Creates a new ListHarvestPlansResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListHarvestPlansResponse
         * @static
         * @param {pond.IListHarvestPlansResponse=} [properties] Properties to set
         * @returns {pond.ListHarvestPlansResponse} ListHarvestPlansResponse instance
         */
        ListHarvestPlansResponse.create = function create(properties) {
            return new ListHarvestPlansResponse(properties);
        };

        /**
         * Creates a ListHarvestPlansResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListHarvestPlansResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListHarvestPlansResponse} ListHarvestPlansResponse
         */
        ListHarvestPlansResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListHarvestPlansResponse)
                return object;
            var message = new $root.pond.ListHarvestPlansResponse();
            if (object.harvestPlan) {
                if (!Array.isArray(object.harvestPlan))
                    throw TypeError(".pond.ListHarvestPlansResponse.harvestPlan: array expected");
                message.harvestPlan = [];
                for (var i = 0; i < object.harvestPlan.length; ++i) {
                    if (typeof object.harvestPlan[i] !== "object")
                        throw TypeError(".pond.ListHarvestPlansResponse.harvestPlan: object expected");
                    message.harvestPlan[i] = $root.pond.HarvestPlan.fromObject(object.harvestPlan[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListHarvestPlansResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListHarvestPlansResponse
         * @static
         * @param {pond.ListHarvestPlansResponse} message ListHarvestPlansResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListHarvestPlansResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.harvestPlan = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.harvestPlan && message.harvestPlan.length) {
                object.harvestPlan = [];
                for (var j = 0; j < message.harvestPlan.length; ++j)
                    object.harvestPlan[j] = $root.pond.HarvestPlan.toObject(message.harvestPlan[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListHarvestPlansResponse to JSON.
         * @function toJSON
         * @memberof pond.ListHarvestPlansResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListHarvestPlansResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListHarvestPlansResponse;
    })();

    pond.RemoveHarvestPlanRequest = (function() {

        /**
         * Properties of a RemoveHarvestPlanRequest.
         * @memberof pond
         * @interface IRemoveHarvestPlanRequest
         * @property {string|null} [harvestPlan] RemoveHarvestPlanRequest harvestPlan
         */

        /**
         * Constructs a new RemoveHarvestPlanRequest.
         * @memberof pond
         * @classdesc Represents a RemoveHarvestPlanRequest.
         * @implements IRemoveHarvestPlanRequest
         * @constructor
         * @param {pond.IRemoveHarvestPlanRequest=} [properties] Properties to set
         */
        function RemoveHarvestPlanRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveHarvestPlanRequest harvestPlan.
         * @member {string} harvestPlan
         * @memberof pond.RemoveHarvestPlanRequest
         * @instance
         */
        RemoveHarvestPlanRequest.prototype.harvestPlan = "";

        /**
         * Creates a new RemoveHarvestPlanRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHarvestPlanRequest
         * @static
         * @param {pond.IRemoveHarvestPlanRequest=} [properties] Properties to set
         * @returns {pond.RemoveHarvestPlanRequest} RemoveHarvestPlanRequest instance
         */
        RemoveHarvestPlanRequest.create = function create(properties) {
            return new RemoveHarvestPlanRequest(properties);
        };

        /**
         * Creates a RemoveHarvestPlanRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHarvestPlanRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHarvestPlanRequest} RemoveHarvestPlanRequest
         */
        RemoveHarvestPlanRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHarvestPlanRequest)
                return object;
            var message = new $root.pond.RemoveHarvestPlanRequest();
            if (object.harvestPlan != null)
                message.harvestPlan = String(object.harvestPlan);
            return message;
        };

        /**
         * Creates a plain object from a RemoveHarvestPlanRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHarvestPlanRequest
         * @static
         * @param {pond.RemoveHarvestPlanRequest} message RemoveHarvestPlanRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHarvestPlanRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestPlan = "";
            if (message.harvestPlan != null && message.hasOwnProperty("harvestPlan"))
                object.harvestPlan = message.harvestPlan;
            return object;
        };

        /**
         * Converts this RemoveHarvestPlanRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveHarvestPlanRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHarvestPlanRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHarvestPlanRequest;
    })();

    pond.RemoveHarvestPlanResponse = (function() {

        /**
         * Properties of a RemoveHarvestPlanResponse.
         * @memberof pond
         * @interface IRemoveHarvestPlanResponse
         */

        /**
         * Constructs a new RemoveHarvestPlanResponse.
         * @memberof pond
         * @classdesc Represents a RemoveHarvestPlanResponse.
         * @implements IRemoveHarvestPlanResponse
         * @constructor
         * @param {pond.IRemoveHarvestPlanResponse=} [properties] Properties to set
         */
        function RemoveHarvestPlanResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveHarvestPlanResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveHarvestPlanResponse
         * @static
         * @param {pond.IRemoveHarvestPlanResponse=} [properties] Properties to set
         * @returns {pond.RemoveHarvestPlanResponse} RemoveHarvestPlanResponse instance
         */
        RemoveHarvestPlanResponse.create = function create(properties) {
            return new RemoveHarvestPlanResponse(properties);
        };

        /**
         * Creates a RemoveHarvestPlanResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveHarvestPlanResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveHarvestPlanResponse} RemoveHarvestPlanResponse
         */
        RemoveHarvestPlanResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveHarvestPlanResponse)
                return object;
            return new $root.pond.RemoveHarvestPlanResponse();
        };

        /**
         * Creates a plain object from a RemoveHarvestPlanResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveHarvestPlanResponse
         * @static
         * @param {pond.RemoveHarvestPlanResponse} message RemoveHarvestPlanResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveHarvestPlanResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveHarvestPlanResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveHarvestPlanResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveHarvestPlanResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveHarvestPlanResponse;
    })();

    pond.UpdateHarvestPlanRequest = (function() {

        /**
         * Properties of an UpdateHarvestPlanRequest.
         * @memberof pond
         * @interface IUpdateHarvestPlanRequest
         * @property {pond.HarvestPlanSettings|null} [harvestPlan] UpdateHarvestPlanRequest harvestPlan
         */

        /**
         * Constructs a new UpdateHarvestPlanRequest.
         * @memberof pond
         * @classdesc Represents an UpdateHarvestPlanRequest.
         * @implements IUpdateHarvestPlanRequest
         * @constructor
         * @param {pond.IUpdateHarvestPlanRequest=} [properties] Properties to set
         */
        function UpdateHarvestPlanRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateHarvestPlanRequest harvestPlan.
         * @member {pond.HarvestPlanSettings|null|undefined} harvestPlan
         * @memberof pond.UpdateHarvestPlanRequest
         * @instance
         */
        UpdateHarvestPlanRequest.prototype.harvestPlan = null;

        /**
         * Creates a new UpdateHarvestPlanRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHarvestPlanRequest
         * @static
         * @param {pond.IUpdateHarvestPlanRequest=} [properties] Properties to set
         * @returns {pond.UpdateHarvestPlanRequest} UpdateHarvestPlanRequest instance
         */
        UpdateHarvestPlanRequest.create = function create(properties) {
            return new UpdateHarvestPlanRequest(properties);
        };

        /**
         * Creates an UpdateHarvestPlanRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHarvestPlanRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHarvestPlanRequest} UpdateHarvestPlanRequest
         */
        UpdateHarvestPlanRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHarvestPlanRequest)
                return object;
            var message = new $root.pond.UpdateHarvestPlanRequest();
            if (object.harvestPlan != null) {
                if (typeof object.harvestPlan !== "object")
                    throw TypeError(".pond.UpdateHarvestPlanRequest.harvestPlan: object expected");
                message.harvestPlan = $root.pond.HarvestPlanSettings.fromObject(object.harvestPlan);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateHarvestPlanRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHarvestPlanRequest
         * @static
         * @param {pond.UpdateHarvestPlanRequest} message UpdateHarvestPlanRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHarvestPlanRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.harvestPlan = null;
            if (message.harvestPlan != null && message.hasOwnProperty("harvestPlan"))
                object.harvestPlan = $root.pond.HarvestPlanSettings.toObject(message.harvestPlan, options);
            return object;
        };

        /**
         * Converts this UpdateHarvestPlanRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateHarvestPlanRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHarvestPlanRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHarvestPlanRequest;
    })();

    pond.UpdateHarvestPlanResponse = (function() {

        /**
         * Properties of an UpdateHarvestPlanResponse.
         * @memberof pond
         * @interface IUpdateHarvestPlanResponse
         */

        /**
         * Constructs a new UpdateHarvestPlanResponse.
         * @memberof pond
         * @classdesc Represents an UpdateHarvestPlanResponse.
         * @implements IUpdateHarvestPlanResponse
         * @constructor
         * @param {pond.IUpdateHarvestPlanResponse=} [properties] Properties to set
         */
        function UpdateHarvestPlanResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateHarvestPlanResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateHarvestPlanResponse
         * @static
         * @param {pond.IUpdateHarvestPlanResponse=} [properties] Properties to set
         * @returns {pond.UpdateHarvestPlanResponse} UpdateHarvestPlanResponse instance
         */
        UpdateHarvestPlanResponse.create = function create(properties) {
            return new UpdateHarvestPlanResponse(properties);
        };

        /**
         * Creates an UpdateHarvestPlanResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateHarvestPlanResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateHarvestPlanResponse} UpdateHarvestPlanResponse
         */
        UpdateHarvestPlanResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateHarvestPlanResponse)
                return object;
            return new $root.pond.UpdateHarvestPlanResponse();
        };

        /**
         * Creates a plain object from an UpdateHarvestPlanResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateHarvestPlanResponse
         * @static
         * @param {pond.UpdateHarvestPlanResponse} message UpdateHarvestPlanResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateHarvestPlanResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateHarvestPlanResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateHarvestPlanResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateHarvestPlanResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateHarvestPlanResponse;
    })();

    pond.Task = (function() {

        /**
         * Properties of a Task.
         * @memberof pond
         * @interface ITask
         * @property {pond.TaskSettings|null} [settings] Task settings
         * @property {string|null} [key] Task key
         */

        /**
         * Constructs a new Task.
         * @memberof pond
         * @classdesc Represents a Task.
         * @implements ITask
         * @constructor
         * @param {pond.ITask=} [properties] Properties to set
         */
        function Task(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Task settings.
         * @member {pond.TaskSettings|null|undefined} settings
         * @memberof pond.Task
         * @instance
         */
        Task.prototype.settings = null;

        /**
         * Task key.
         * @member {string} key
         * @memberof pond.Task
         * @instance
         */
        Task.prototype.key = "";

        /**
         * Creates a new Task instance using the specified properties.
         * @function create
         * @memberof pond.Task
         * @static
         * @param {pond.ITask=} [properties] Properties to set
         * @returns {pond.Task} Task instance
         */
        Task.create = function create(properties) {
            return new Task(properties);
        };

        /**
         * Creates a Task message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Task
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Task} Task
         */
        Task.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Task)
                return object;
            var message = new $root.pond.Task();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Task.settings: object expected");
                message.settings = $root.pond.TaskSettings.fromObject(object.settings);
            }
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a Task message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Task
         * @static
         * @param {pond.Task} message Task
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Task.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.key = "";
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TaskSettings.toObject(message.settings, options);
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this Task to JSON.
         * @function toJSON
         * @memberof pond.Task
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Task.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Task;
    })();

    pond.TaskSettings = (function() {

        /**
         * Properties of a TaskSettings.
         * @memberof pond
         * @interface ITaskSettings
         * @property {string|null} [key] TaskSettings key
         * @property {string|null} [objectKey] TaskSettings objectKey
         * @property {string|null} [userId] TaskSettings userId
         * @property {string|null} [taskId] TaskSettings taskId
         * @property {string|null} [title] TaskSettings title
         * @property {string|null} [start] TaskSettings start
         * @property {string|null} [end] TaskSettings end
         * @property {string|null} [description] TaskSettings description
         * @property {string|null} [worker] TaskSettings worker
         * @property {boolean|null} [complete] TaskSettings complete
         * @property {string|null} [startTime] TaskSettings startTime
         * @property {string|null} [endTime] TaskSettings endTime
         * @property {string|null} [colour] TaskSettings colour
         * @property {string|null} [type] TaskSettings type
         * @property {number|null} [cost] TaskSettings cost
         * @property {number|null} [secondaryCost] TaskSettings secondaryCost
         * @property {Array.<string>|null} [users] TaskSettings users
         */

        /**
         * Constructs a new TaskSettings.
         * @memberof pond
         * @classdesc Represents a TaskSettings.
         * @implements ITaskSettings
         * @constructor
         * @param {pond.ITaskSettings=} [properties] Properties to set
         */
        function TaskSettings(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TaskSettings key.
         * @member {string} key
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.key = "";

        /**
         * TaskSettings objectKey.
         * @member {string} objectKey
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.objectKey = "";

        /**
         * TaskSettings userId.
         * @member {string} userId
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.userId = "";

        /**
         * TaskSettings taskId.
         * @member {string} taskId
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.taskId = "";

        /**
         * TaskSettings title.
         * @member {string} title
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.title = "";

        /**
         * TaskSettings start.
         * @member {string} start
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.start = "";

        /**
         * TaskSettings end.
         * @member {string} end
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.end = "";

        /**
         * TaskSettings description.
         * @member {string} description
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.description = "";

        /**
         * TaskSettings worker.
         * @member {string} worker
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.worker = "";

        /**
         * TaskSettings complete.
         * @member {boolean} complete
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.complete = false;

        /**
         * TaskSettings startTime.
         * @member {string} startTime
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.startTime = "";

        /**
         * TaskSettings endTime.
         * @member {string} endTime
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.endTime = "";

        /**
         * TaskSettings colour.
         * @member {string} colour
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.colour = "";

        /**
         * TaskSettings type.
         * @member {string} type
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.type = "";

        /**
         * TaskSettings cost.
         * @member {number} cost
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.cost = 0;

        /**
         * TaskSettings secondaryCost.
         * @member {number} secondaryCost
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.secondaryCost = 0;

        /**
         * TaskSettings users.
         * @member {Array.<string>} users
         * @memberof pond.TaskSettings
         * @instance
         */
        TaskSettings.prototype.users = $util.emptyArray;

        /**
         * Creates a new TaskSettings instance using the specified properties.
         * @function create
         * @memberof pond.TaskSettings
         * @static
         * @param {pond.ITaskSettings=} [properties] Properties to set
         * @returns {pond.TaskSettings} TaskSettings instance
         */
        TaskSettings.create = function create(properties) {
            return new TaskSettings(properties);
        };

        /**
         * Creates a TaskSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TaskSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TaskSettings} TaskSettings
         */
        TaskSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TaskSettings)
                return object;
            var message = new $root.pond.TaskSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.taskId != null)
                message.taskId = String(object.taskId);
            if (object.title != null)
                message.title = String(object.title);
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            if (object.description != null)
                message.description = String(object.description);
            if (object.worker != null)
                message.worker = String(object.worker);
            if (object.complete != null)
                message.complete = Boolean(object.complete);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            if (object.colour != null)
                message.colour = String(object.colour);
            if (object.type != null)
                message.type = String(object.type);
            if (object.cost != null)
                message.cost = Number(object.cost);
            if (object.secondaryCost != null)
                message.secondaryCost = Number(object.secondaryCost);
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.TaskSettings.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i)
                    message.users[i] = String(object.users[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a TaskSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TaskSettings
         * @static
         * @param {pond.TaskSettings} message TaskSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TaskSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.key = "";
                object.objectKey = "";
                object.userId = "";
                object.taskId = "";
                object.title = "";
                object.start = "";
                object.end = "";
                object.description = "";
                object.worker = "";
                object.complete = false;
                object.startTime = "";
                object.endTime = "";
                object.colour = "";
                object.type = "";
                object.cost = 0;
                object.secondaryCost = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.taskId != null && message.hasOwnProperty("taskId"))
                object.taskId = message.taskId;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.worker != null && message.hasOwnProperty("worker"))
                object.worker = message.worker;
            if (message.complete != null && message.hasOwnProperty("complete"))
                object.complete = message.complete;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.cost != null && message.hasOwnProperty("cost"))
                object.cost = options.json && !isFinite(message.cost) ? String(message.cost) : message.cost;
            if (message.secondaryCost != null && message.hasOwnProperty("secondaryCost"))
                object.secondaryCost = options.json && !isFinite(message.secondaryCost) ? String(message.secondaryCost) : message.secondaryCost;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = message.users[j];
            }
            return object;
        };

        /**
         * Converts this TaskSettings to JSON.
         * @function toJSON
         * @memberof pond.TaskSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TaskSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TaskSettings;
    })();

    pond.GetTaskRequest = (function() {

        /**
         * Properties of a GetTaskRequest.
         * @memberof pond
         * @interface IGetTaskRequest
         * @property {string|null} [task] GetTaskRequest task
         */

        /**
         * Constructs a new GetTaskRequest.
         * @memberof pond
         * @classdesc Represents a GetTaskRequest.
         * @implements IGetTaskRequest
         * @constructor
         * @param {pond.IGetTaskRequest=} [properties] Properties to set
         */
        function GetTaskRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTaskRequest task.
         * @member {string} task
         * @memberof pond.GetTaskRequest
         * @instance
         */
        GetTaskRequest.prototype.task = "";

        /**
         * Creates a new GetTaskRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTaskRequest
         * @static
         * @param {pond.IGetTaskRequest=} [properties] Properties to set
         * @returns {pond.GetTaskRequest} GetTaskRequest instance
         */
        GetTaskRequest.create = function create(properties) {
            return new GetTaskRequest(properties);
        };

        /**
         * Creates a GetTaskRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTaskRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTaskRequest} GetTaskRequest
         */
        GetTaskRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTaskRequest)
                return object;
            var message = new $root.pond.GetTaskRequest();
            if (object.task != null)
                message.task = String(object.task);
            return message;
        };

        /**
         * Creates a plain object from a GetTaskRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTaskRequest
         * @static
         * @param {pond.GetTaskRequest} message GetTaskRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTaskRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.task = "";
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = message.task;
            return object;
        };

        /**
         * Converts this GetTaskRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTaskRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTaskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTaskRequest;
    })();

    pond.AddTaskRequest = (function() {

        /**
         * Properties of an AddTaskRequest.
         * @memberof pond
         * @interface IAddTaskRequest
         * @property {pond.TaskSettings|null} [task] AddTaskRequest task
         */

        /**
         * Constructs a new AddTaskRequest.
         * @memberof pond
         * @classdesc Represents an AddTaskRequest.
         * @implements IAddTaskRequest
         * @constructor
         * @param {pond.IAddTaskRequest=} [properties] Properties to set
         */
        function AddTaskRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTaskRequest task.
         * @member {pond.TaskSettings|null|undefined} task
         * @memberof pond.AddTaskRequest
         * @instance
         */
        AddTaskRequest.prototype.task = null;

        /**
         * Creates a new AddTaskRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddTaskRequest
         * @static
         * @param {pond.IAddTaskRequest=} [properties] Properties to set
         * @returns {pond.AddTaskRequest} AddTaskRequest instance
         */
        AddTaskRequest.create = function create(properties) {
            return new AddTaskRequest(properties);
        };

        /**
         * Creates an AddTaskRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTaskRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTaskRequest} AddTaskRequest
         */
        AddTaskRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTaskRequest)
                return object;
            var message = new $root.pond.AddTaskRequest();
            if (object.task != null) {
                if (typeof object.task !== "object")
                    throw TypeError(".pond.AddTaskRequest.task: object expected");
                message.task = $root.pond.TaskSettings.fromObject(object.task);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTaskRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTaskRequest
         * @static
         * @param {pond.AddTaskRequest} message AddTaskRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTaskRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.task = null;
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = $root.pond.TaskSettings.toObject(message.task, options);
            return object;
        };

        /**
         * Converts this AddTaskRequest to JSON.
         * @function toJSON
         * @memberof pond.AddTaskRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTaskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTaskRequest;
    })();

    pond.AddTaskResponse = (function() {

        /**
         * Properties of an AddTaskResponse.
         * @memberof pond
         * @interface IAddTaskResponse
         * @property {string|null} [task] AddTaskResponse task
         */

        /**
         * Constructs a new AddTaskResponse.
         * @memberof pond
         * @classdesc Represents an AddTaskResponse.
         * @implements IAddTaskResponse
         * @constructor
         * @param {pond.IAddTaskResponse=} [properties] Properties to set
         */
        function AddTaskResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTaskResponse task.
         * @member {string} task
         * @memberof pond.AddTaskResponse
         * @instance
         */
        AddTaskResponse.prototype.task = "";

        /**
         * Creates a new AddTaskResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddTaskResponse
         * @static
         * @param {pond.IAddTaskResponse=} [properties] Properties to set
         * @returns {pond.AddTaskResponse} AddTaskResponse instance
         */
        AddTaskResponse.create = function create(properties) {
            return new AddTaskResponse(properties);
        };

        /**
         * Creates an AddTaskResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTaskResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTaskResponse} AddTaskResponse
         */
        AddTaskResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTaskResponse)
                return object;
            var message = new $root.pond.AddTaskResponse();
            if (object.task != null)
                message.task = String(object.task);
            return message;
        };

        /**
         * Creates a plain object from an AddTaskResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTaskResponse
         * @static
         * @param {pond.AddTaskResponse} message AddTaskResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTaskResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.task = "";
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = message.task;
            return object;
        };

        /**
         * Converts this AddTaskResponse to JSON.
         * @function toJSON
         * @memberof pond.AddTaskResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTaskResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTaskResponse;
    })();

    pond.ListTasksRequest = (function() {

        /**
         * Properties of a ListTasksRequest.
         * @memberof pond
         * @interface IListTasksRequest
         * @property {string|null} [key] ListTasksRequest key
         * @property {string|null} [userId] ListTasksRequest userId
         * @property {pond.Paging|null} [paging] ListTasksRequest paging
         * @property {pond.Sorting|null} [sorting] ListTasksRequest sorting
         * @property {string|null} [search] ListTasksRequest search
         * @property {pond.TaskSettings|null} [settingsMatch] ListTasksRequest settingsMatch
         * @property {Object.<string,string>|null} [fieldContains] ListTasksRequest fieldContains
         * @property {string|null} [fromDate] ListTasksRequest fromDate
         * @property {string|null} [toDate] ListTasksRequest toDate
         */

        /**
         * Constructs a new ListTasksRequest.
         * @memberof pond
         * @classdesc Represents a ListTasksRequest.
         * @implements IListTasksRequest
         * @constructor
         * @param {pond.IListTasksRequest=} [properties] Properties to set
         */
        function ListTasksRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTasksRequest key.
         * @member {string} key
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.key = "";

        /**
         * ListTasksRequest userId.
         * @member {string} userId
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.userId = "";

        /**
         * ListTasksRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.paging = null;

        /**
         * ListTasksRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.sorting = null;

        /**
         * ListTasksRequest search.
         * @member {string} search
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.search = "";

        /**
         * ListTasksRequest settingsMatch.
         * @member {pond.TaskSettings|null|undefined} settingsMatch
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.settingsMatch = null;

        /**
         * ListTasksRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListTasksRequest fromDate.
         * @member {string} fromDate
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.fromDate = "";

        /**
         * ListTasksRequest toDate.
         * @member {string} toDate
         * @memberof pond.ListTasksRequest
         * @instance
         */
        ListTasksRequest.prototype.toDate = "";

        /**
         * Creates a new ListTasksRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListTasksRequest
         * @static
         * @param {pond.IListTasksRequest=} [properties] Properties to set
         * @returns {pond.ListTasksRequest} ListTasksRequest instance
         */
        ListTasksRequest.create = function create(properties) {
            return new ListTasksRequest(properties);
        };

        /**
         * Creates a ListTasksRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTasksRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTasksRequest} ListTasksRequest
         */
        ListTasksRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTasksRequest)
                return object;
            var message = new $root.pond.ListTasksRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListTasksRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListTasksRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListTasksRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.TaskSettings.fromObject(object.settingsMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListTasksRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.fromDate != null)
                message.fromDate = String(object.fromDate);
            if (object.toDate != null)
                message.toDate = String(object.toDate);
            return message;
        };

        /**
         * Creates a plain object from a ListTasksRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTasksRequest
         * @static
         * @param {pond.ListTasksRequest} message ListTasksRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTasksRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.fromDate = "";
                object.toDate = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.TaskSettings.toObject(message.settingsMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                object.fromDate = message.fromDate;
            if (message.toDate != null && message.hasOwnProperty("toDate"))
                object.toDate = message.toDate;
            return object;
        };

        /**
         * Converts this ListTasksRequest to JSON.
         * @function toJSON
         * @memberof pond.ListTasksRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTasksRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTasksRequest;
    })();

    pond.ListTasksResponse = (function() {

        /**
         * Properties of a ListTasksResponse.
         * @memberof pond
         * @interface IListTasksResponse
         * @property {Array.<pond.Task>|null} [tasks] ListTasksResponse tasks
         * @property {number|null} [nextOffset] ListTasksResponse nextOffset
         * @property {number|null} [total] ListTasksResponse total
         */

        /**
         * Constructs a new ListTasksResponse.
         * @memberof pond
         * @classdesc Represents a ListTasksResponse.
         * @implements IListTasksResponse
         * @constructor
         * @param {pond.IListTasksResponse=} [properties] Properties to set
         */
        function ListTasksResponse(properties) {
            this.tasks = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTasksResponse tasks.
         * @member {Array.<pond.Task>} tasks
         * @memberof pond.ListTasksResponse
         * @instance
         */
        ListTasksResponse.prototype.tasks = $util.emptyArray;

        /**
         * ListTasksResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListTasksResponse
         * @instance
         */
        ListTasksResponse.prototype.nextOffset = 0;

        /**
         * ListTasksResponse total.
         * @member {number} total
         * @memberof pond.ListTasksResponse
         * @instance
         */
        ListTasksResponse.prototype.total = 0;

        /**
         * Creates a new ListTasksResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTasksResponse
         * @static
         * @param {pond.IListTasksResponse=} [properties] Properties to set
         * @returns {pond.ListTasksResponse} ListTasksResponse instance
         */
        ListTasksResponse.create = function create(properties) {
            return new ListTasksResponse(properties);
        };

        /**
         * Creates a ListTasksResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTasksResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTasksResponse} ListTasksResponse
         */
        ListTasksResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTasksResponse)
                return object;
            var message = new $root.pond.ListTasksResponse();
            if (object.tasks) {
                if (!Array.isArray(object.tasks))
                    throw TypeError(".pond.ListTasksResponse.tasks: array expected");
                message.tasks = [];
                for (var i = 0; i < object.tasks.length; ++i) {
                    if (typeof object.tasks[i] !== "object")
                        throw TypeError(".pond.ListTasksResponse.tasks: object expected");
                    message.tasks[i] = $root.pond.Task.fromObject(object.tasks[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListTasksResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTasksResponse
         * @static
         * @param {pond.ListTasksResponse} message ListTasksResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTasksResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tasks = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.tasks && message.tasks.length) {
                object.tasks = [];
                for (var j = 0; j < message.tasks.length; ++j)
                    object.tasks[j] = $root.pond.Task.toObject(message.tasks[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListTasksResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTasksResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTasksResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTasksResponse;
    })();

    pond.RemoveTaskRequest = (function() {

        /**
         * Properties of a RemoveTaskRequest.
         * @memberof pond
         * @interface IRemoveTaskRequest
         * @property {string|null} [task] RemoveTaskRequest task
         */

        /**
         * Constructs a new RemoveTaskRequest.
         * @memberof pond
         * @classdesc Represents a RemoveTaskRequest.
         * @implements IRemoveTaskRequest
         * @constructor
         * @param {pond.IRemoveTaskRequest=} [properties] Properties to set
         */
        function RemoveTaskRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTaskRequest task.
         * @member {string} task
         * @memberof pond.RemoveTaskRequest
         * @instance
         */
        RemoveTaskRequest.prototype.task = "";

        /**
         * Creates a new RemoveTaskRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTaskRequest
         * @static
         * @param {pond.IRemoveTaskRequest=} [properties] Properties to set
         * @returns {pond.RemoveTaskRequest} RemoveTaskRequest instance
         */
        RemoveTaskRequest.create = function create(properties) {
            return new RemoveTaskRequest(properties);
        };

        /**
         * Creates a RemoveTaskRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTaskRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTaskRequest} RemoveTaskRequest
         */
        RemoveTaskRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTaskRequest)
                return object;
            var message = new $root.pond.RemoveTaskRequest();
            if (object.task != null)
                message.task = String(object.task);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTaskRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTaskRequest
         * @static
         * @param {pond.RemoveTaskRequest} message RemoveTaskRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTaskRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.task = "";
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = message.task;
            return object;
        };

        /**
         * Converts this RemoveTaskRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveTaskRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTaskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTaskRequest;
    })();

    pond.RemoveTaskResponse = (function() {

        /**
         * Properties of a RemoveTaskResponse.
         * @memberof pond
         * @interface IRemoveTaskResponse
         */

        /**
         * Constructs a new RemoveTaskResponse.
         * @memberof pond
         * @classdesc Represents a RemoveTaskResponse.
         * @implements IRemoveTaskResponse
         * @constructor
         * @param {pond.IRemoveTaskResponse=} [properties] Properties to set
         */
        function RemoveTaskResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveTaskResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTaskResponse
         * @static
         * @param {pond.IRemoveTaskResponse=} [properties] Properties to set
         * @returns {pond.RemoveTaskResponse} RemoveTaskResponse instance
         */
        RemoveTaskResponse.create = function create(properties) {
            return new RemoveTaskResponse(properties);
        };

        /**
         * Creates a RemoveTaskResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTaskResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTaskResponse} RemoveTaskResponse
         */
        RemoveTaskResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTaskResponse)
                return object;
            return new $root.pond.RemoveTaskResponse();
        };

        /**
         * Creates a plain object from a RemoveTaskResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTaskResponse
         * @static
         * @param {pond.RemoveTaskResponse} message RemoveTaskResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTaskResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveTaskResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveTaskResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTaskResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTaskResponse;
    })();

    pond.UpdateTaskRequest = (function() {

        /**
         * Properties of an UpdateTaskRequest.
         * @memberof pond
         * @interface IUpdateTaskRequest
         * @property {pond.TaskSettings|null} [task] UpdateTaskRequest task
         */

        /**
         * Constructs a new UpdateTaskRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTaskRequest.
         * @implements IUpdateTaskRequest
         * @constructor
         * @param {pond.IUpdateTaskRequest=} [properties] Properties to set
         */
        function UpdateTaskRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTaskRequest task.
         * @member {pond.TaskSettings|null|undefined} task
         * @memberof pond.UpdateTaskRequest
         * @instance
         */
        UpdateTaskRequest.prototype.task = null;

        /**
         * Creates a new UpdateTaskRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTaskRequest
         * @static
         * @param {pond.IUpdateTaskRequest=} [properties] Properties to set
         * @returns {pond.UpdateTaskRequest} UpdateTaskRequest instance
         */
        UpdateTaskRequest.create = function create(properties) {
            return new UpdateTaskRequest(properties);
        };

        /**
         * Creates an UpdateTaskRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTaskRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTaskRequest} UpdateTaskRequest
         */
        UpdateTaskRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTaskRequest)
                return object;
            var message = new $root.pond.UpdateTaskRequest();
            if (object.task != null) {
                if (typeof object.task !== "object")
                    throw TypeError(".pond.UpdateTaskRequest.task: object expected");
                message.task = $root.pond.TaskSettings.fromObject(object.task);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTaskRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTaskRequest
         * @static
         * @param {pond.UpdateTaskRequest} message UpdateTaskRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTaskRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.task = null;
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = $root.pond.TaskSettings.toObject(message.task, options);
            return object;
        };

        /**
         * Converts this UpdateTaskRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTaskRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTaskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTaskRequest;
    })();

    pond.UpdateTaskResponse = (function() {

        /**
         * Properties of an UpdateTaskResponse.
         * @memberof pond
         * @interface IUpdateTaskResponse
         */

        /**
         * Constructs a new UpdateTaskResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTaskResponse.
         * @implements IUpdateTaskResponse
         * @constructor
         * @param {pond.IUpdateTaskResponse=} [properties] Properties to set
         */
        function UpdateTaskResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateTaskResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTaskResponse
         * @static
         * @param {pond.IUpdateTaskResponse=} [properties] Properties to set
         * @returns {pond.UpdateTaskResponse} UpdateTaskResponse instance
         */
        UpdateTaskResponse.create = function create(properties) {
            return new UpdateTaskResponse(properties);
        };

        /**
         * Creates an UpdateTaskResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTaskResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTaskResponse} UpdateTaskResponse
         */
        UpdateTaskResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTaskResponse)
                return object;
            return new $root.pond.UpdateTaskResponse();
        };

        /**
         * Creates a plain object from an UpdateTaskResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTaskResponse
         * @static
         * @param {pond.UpdateTaskResponse} message UpdateTaskResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTaskResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateTaskResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTaskResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTaskResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTaskResponse;
    })();

    pond.GetMultiTasksRequest = (function() {

        /**
         * Properties of a GetMultiTasksRequest.
         * @memberof pond
         * @interface IGetMultiTasksRequest
         * @property {Array.<string>|null} [keys] GetMultiTasksRequest keys
         * @property {pond.Paging|null} [paging] GetMultiTasksRequest paging
         * @property {pond.Sorting|null} [sorting] GetMultiTasksRequest sorting
         * @property {string|null} [search] GetMultiTasksRequest search
         */

        /**
         * Constructs a new GetMultiTasksRequest.
         * @memberof pond
         * @classdesc Represents a GetMultiTasksRequest.
         * @implements IGetMultiTasksRequest
         * @constructor
         * @param {pond.IGetMultiTasksRequest=} [properties] Properties to set
         */
        function GetMultiTasksRequest(properties) {
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiTasksRequest keys.
         * @member {Array.<string>} keys
         * @memberof pond.GetMultiTasksRequest
         * @instance
         */
        GetMultiTasksRequest.prototype.keys = $util.emptyArray;

        /**
         * GetMultiTasksRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.GetMultiTasksRequest
         * @instance
         */
        GetMultiTasksRequest.prototype.paging = null;

        /**
         * GetMultiTasksRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.GetMultiTasksRequest
         * @instance
         */
        GetMultiTasksRequest.prototype.sorting = null;

        /**
         * GetMultiTasksRequest search.
         * @member {string} search
         * @memberof pond.GetMultiTasksRequest
         * @instance
         */
        GetMultiTasksRequest.prototype.search = "";

        /**
         * Creates a new GetMultiTasksRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiTasksRequest
         * @static
         * @param {pond.IGetMultiTasksRequest=} [properties] Properties to set
         * @returns {pond.GetMultiTasksRequest} GetMultiTasksRequest instance
         */
        GetMultiTasksRequest.create = function create(properties) {
            return new GetMultiTasksRequest(properties);
        };

        /**
         * Creates a GetMultiTasksRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiTasksRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiTasksRequest} GetMultiTasksRequest
         */
        GetMultiTasksRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiTasksRequest)
                return object;
            var message = new $root.pond.GetMultiTasksRequest();
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.GetMultiTasksRequest.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.GetMultiTasksRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.GetMultiTasksRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a GetMultiTasksRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiTasksRequest
         * @static
         * @param {pond.GetMultiTasksRequest} message GetMultiTasksRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiTasksRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this GetMultiTasksRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMultiTasksRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiTasksRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiTasksRequest;
    })();

    pond.GetMultiTasksResponse = (function() {

        /**
         * Properties of a GetMultiTasksResponse.
         * @memberof pond
         * @interface IGetMultiTasksResponse
         * @property {Array.<pond.Task>|null} [tasks] GetMultiTasksResponse tasks
         * @property {number|null} [nextOffset] GetMultiTasksResponse nextOffset
         * @property {number|null} [total] GetMultiTasksResponse total
         */

        /**
         * Constructs a new GetMultiTasksResponse.
         * @memberof pond
         * @classdesc Represents a GetMultiTasksResponse.
         * @implements IGetMultiTasksResponse
         * @constructor
         * @param {pond.IGetMultiTasksResponse=} [properties] Properties to set
         */
        function GetMultiTasksResponse(properties) {
            this.tasks = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMultiTasksResponse tasks.
         * @member {Array.<pond.Task>} tasks
         * @memberof pond.GetMultiTasksResponse
         * @instance
         */
        GetMultiTasksResponse.prototype.tasks = $util.emptyArray;

        /**
         * GetMultiTasksResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.GetMultiTasksResponse
         * @instance
         */
        GetMultiTasksResponse.prototype.nextOffset = 0;

        /**
         * GetMultiTasksResponse total.
         * @member {number} total
         * @memberof pond.GetMultiTasksResponse
         * @instance
         */
        GetMultiTasksResponse.prototype.total = 0;

        /**
         * Creates a new GetMultiTasksResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMultiTasksResponse
         * @static
         * @param {pond.IGetMultiTasksResponse=} [properties] Properties to set
         * @returns {pond.GetMultiTasksResponse} GetMultiTasksResponse instance
         */
        GetMultiTasksResponse.create = function create(properties) {
            return new GetMultiTasksResponse(properties);
        };

        /**
         * Creates a GetMultiTasksResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMultiTasksResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMultiTasksResponse} GetMultiTasksResponse
         */
        GetMultiTasksResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMultiTasksResponse)
                return object;
            var message = new $root.pond.GetMultiTasksResponse();
            if (object.tasks) {
                if (!Array.isArray(object.tasks))
                    throw TypeError(".pond.GetMultiTasksResponse.tasks: array expected");
                message.tasks = [];
                for (var i = 0; i < object.tasks.length; ++i) {
                    if (typeof object.tasks[i] !== "object")
                        throw TypeError(".pond.GetMultiTasksResponse.tasks: object expected");
                    message.tasks[i] = $root.pond.Task.fromObject(object.tasks[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetMultiTasksResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMultiTasksResponse
         * @static
         * @param {pond.GetMultiTasksResponse} message GetMultiTasksResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMultiTasksResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tasks = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.tasks && message.tasks.length) {
                object.tasks = [];
                for (var j = 0; j < message.tasks.length; ++j)
                    object.tasks[j] = $root.pond.Task.toObject(message.tasks[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this GetMultiTasksResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMultiTasksResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMultiTasksResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMultiTasksResponse;
    })();

    pond.Site = (function() {

        /**
         * Properties of a Site.
         * @memberof pond
         * @interface ISite
         * @property {pond.SiteSettings|null} [settings] Site settings
         * @property {pond.SiteStatus|null} [status] Site status
         */

        /**
         * Constructs a new Site.
         * @memberof pond
         * @classdesc Represents a Site.
         * @implements ISite
         * @constructor
         * @param {pond.ISite=} [properties] Properties to set
         */
        function Site(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Site settings.
         * @member {pond.SiteSettings|null|undefined} settings
         * @memberof pond.Site
         * @instance
         */
        Site.prototype.settings = null;

        /**
         * Site status.
         * @member {pond.SiteStatus|null|undefined} status
         * @memberof pond.Site
         * @instance
         */
        Site.prototype.status = null;

        /**
         * Creates a new Site instance using the specified properties.
         * @function create
         * @memberof pond.Site
         * @static
         * @param {pond.ISite=} [properties] Properties to set
         * @returns {pond.Site} Site instance
         */
        Site.create = function create(properties) {
            return new Site(properties);
        };

        /**
         * Creates a Site message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Site
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Site} Site
         */
        Site.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Site)
                return object;
            var message = new $root.pond.Site();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Site.settings: object expected");
                message.settings = $root.pond.SiteSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Site.status: object expected");
                message.status = $root.pond.SiteStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Site message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Site
         * @static
         * @param {pond.Site} message Site
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Site.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.SiteSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.SiteStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Site to JSON.
         * @function toJSON
         * @memberof pond.Site
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Site.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Site;
    })();

    pond.SiteSettings = (function() {

        /**
         * Properties of a SiteSettings.
         * @memberof pond
         * @interface ISiteSettings
         * @property {string|null} [key] SiteSettings key
         * @property {string|null} [objectKey] SiteSettings objectKey
         * @property {string|null} [userId] SiteSettings userId
         * @property {string|null} [siteId] SiteSettings siteId
         * @property {string|null} [siteName] SiteSettings siteName
         * @property {string|null} [siteAddress] SiteSettings siteAddress
         * @property {string|null} [siteDescription] SiteSettings siteDescription
         * @property {string|null} [clientName] SiteSettings clientName
         * @property {string|null} [clientPhone] SiteSettings clientPhone
         * @property {string|null} [jobType] SiteSettings jobType
         * @property {string|null} [jobDetails] SiteSettings jobDetails
         * @property {number|null} [longitude] SiteSettings longitude
         * @property {number|null} [latitude] SiteSettings latitude
         * @property {pond.ObjectTheme|null} [theme] SiteSettings theme
         * @property {boolean|null} [active] SiteSettings active
         */

        /**
         * Constructs a new SiteSettings.
         * @memberof pond
         * @classdesc Represents a SiteSettings.
         * @implements ISiteSettings
         * @constructor
         * @param {pond.ISiteSettings=} [properties] Properties to set
         */
        function SiteSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SiteSettings key.
         * @member {string} key
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.key = "";

        /**
         * SiteSettings objectKey.
         * @member {string} objectKey
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.objectKey = "";

        /**
         * SiteSettings userId.
         * @member {string} userId
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.userId = "";

        /**
         * SiteSettings siteId.
         * @member {string} siteId
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.siteId = "";

        /**
         * SiteSettings siteName.
         * @member {string} siteName
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.siteName = "";

        /**
         * SiteSettings siteAddress.
         * @member {string} siteAddress
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.siteAddress = "";

        /**
         * SiteSettings siteDescription.
         * @member {string} siteDescription
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.siteDescription = "";

        /**
         * SiteSettings clientName.
         * @member {string} clientName
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.clientName = "";

        /**
         * SiteSettings clientPhone.
         * @member {string} clientPhone
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.clientPhone = "";

        /**
         * SiteSettings jobType.
         * @member {string} jobType
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.jobType = "";

        /**
         * SiteSettings jobDetails.
         * @member {string} jobDetails
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.jobDetails = "";

        /**
         * SiteSettings longitude.
         * @member {number} longitude
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.longitude = 0;

        /**
         * SiteSettings latitude.
         * @member {number} latitude
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.latitude = 0;

        /**
         * SiteSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.theme = null;

        /**
         * SiteSettings active.
         * @member {boolean} active
         * @memberof pond.SiteSettings
         * @instance
         */
        SiteSettings.prototype.active = false;

        /**
         * Creates a new SiteSettings instance using the specified properties.
         * @function create
         * @memberof pond.SiteSettings
         * @static
         * @param {pond.ISiteSettings=} [properties] Properties to set
         * @returns {pond.SiteSettings} SiteSettings instance
         */
        SiteSettings.create = function create(properties) {
            return new SiteSettings(properties);
        };

        /**
         * Creates a SiteSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SiteSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SiteSettings} SiteSettings
         */
        SiteSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SiteSettings)
                return object;
            var message = new $root.pond.SiteSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.siteId != null)
                message.siteId = String(object.siteId);
            if (object.siteName != null)
                message.siteName = String(object.siteName);
            if (object.siteAddress != null)
                message.siteAddress = String(object.siteAddress);
            if (object.siteDescription != null)
                message.siteDescription = String(object.siteDescription);
            if (object.clientName != null)
                message.clientName = String(object.clientName);
            if (object.clientPhone != null)
                message.clientPhone = String(object.clientPhone);
            if (object.jobType != null)
                message.jobType = String(object.jobType);
            if (object.jobDetails != null)
                message.jobDetails = String(object.jobDetails);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.SiteSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            if (object.active != null)
                message.active = Boolean(object.active);
            return message;
        };

        /**
         * Creates a plain object from a SiteSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SiteSettings
         * @static
         * @param {pond.SiteSettings} message SiteSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SiteSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.objectKey = "";
                object.userId = "";
                object.siteId = "";
                object.siteName = "";
                object.siteAddress = "";
                object.siteDescription = "";
                object.clientName = "";
                object.clientPhone = "";
                object.jobType = "";
                object.jobDetails = "";
                object.longitude = 0;
                object.latitude = 0;
                object.theme = null;
                object.active = false;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.siteId != null && message.hasOwnProperty("siteId"))
                object.siteId = message.siteId;
            if (message.siteName != null && message.hasOwnProperty("siteName"))
                object.siteName = message.siteName;
            if (message.siteAddress != null && message.hasOwnProperty("siteAddress"))
                object.siteAddress = message.siteAddress;
            if (message.siteDescription != null && message.hasOwnProperty("siteDescription"))
                object.siteDescription = message.siteDescription;
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                object.clientName = message.clientName;
            if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                object.clientPhone = message.clientPhone;
            if (message.jobType != null && message.hasOwnProperty("jobType"))
                object.jobType = message.jobType;
            if (message.jobDetails != null && message.hasOwnProperty("jobDetails"))
                object.jobDetails = message.jobDetails;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.active != null && message.hasOwnProperty("active"))
                object.active = message.active;
            return object;
        };

        /**
         * Converts this SiteSettings to JSON.
         * @function toJSON
         * @memberof pond.SiteSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SiteSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SiteSettings;
    })();

    pond.SiteStatus = (function() {

        /**
         * Properties of a SiteStatus.
         * @memberof pond
         * @interface ISiteStatus
         * @property {string|null} [timestamp] SiteStatus timestamp
         */

        /**
         * Constructs a new SiteStatus.
         * @memberof pond
         * @classdesc Represents a SiteStatus.
         * @implements ISiteStatus
         * @constructor
         * @param {pond.ISiteStatus=} [properties] Properties to set
         */
        function SiteStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SiteStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.SiteStatus
         * @instance
         */
        SiteStatus.prototype.timestamp = "";

        /**
         * Creates a new SiteStatus instance using the specified properties.
         * @function create
         * @memberof pond.SiteStatus
         * @static
         * @param {pond.ISiteStatus=} [properties] Properties to set
         * @returns {pond.SiteStatus} SiteStatus instance
         */
        SiteStatus.create = function create(properties) {
            return new SiteStatus(properties);
        };

        /**
         * Creates a SiteStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SiteStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SiteStatus} SiteStatus
         */
        SiteStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SiteStatus)
                return object;
            var message = new $root.pond.SiteStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a SiteStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SiteStatus
         * @static
         * @param {pond.SiteStatus} message SiteStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SiteStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this SiteStatus to JSON.
         * @function toJSON
         * @memberof pond.SiteStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SiteStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SiteStatus;
    })();

    pond.GetSiteRequest = (function() {

        /**
         * Properties of a GetSiteRequest.
         * @memberof pond
         * @interface IGetSiteRequest
         * @property {string|null} [site] GetSiteRequest site
         */

        /**
         * Constructs a new GetSiteRequest.
         * @memberof pond
         * @classdesc Represents a GetSiteRequest.
         * @implements IGetSiteRequest
         * @constructor
         * @param {pond.IGetSiteRequest=} [properties] Properties to set
         */
        function GetSiteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetSiteRequest site.
         * @member {string} site
         * @memberof pond.GetSiteRequest
         * @instance
         */
        GetSiteRequest.prototype.site = "";

        /**
         * Creates a new GetSiteRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetSiteRequest
         * @static
         * @param {pond.IGetSiteRequest=} [properties] Properties to set
         * @returns {pond.GetSiteRequest} GetSiteRequest instance
         */
        GetSiteRequest.create = function create(properties) {
            return new GetSiteRequest(properties);
        };

        /**
         * Creates a GetSiteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetSiteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetSiteRequest} GetSiteRequest
         */
        GetSiteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetSiteRequest)
                return object;
            var message = new $root.pond.GetSiteRequest();
            if (object.site != null)
                message.site = String(object.site);
            return message;
        };

        /**
         * Creates a plain object from a GetSiteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetSiteRequest
         * @static
         * @param {pond.GetSiteRequest} message GetSiteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetSiteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.site = "";
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = message.site;
            return object;
        };

        /**
         * Converts this GetSiteRequest to JSON.
         * @function toJSON
         * @memberof pond.GetSiteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetSiteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetSiteRequest;
    })();

    pond.AddSiteRequest = (function() {

        /**
         * Properties of an AddSiteRequest.
         * @memberof pond
         * @interface IAddSiteRequest
         * @property {pond.SiteSettings|null} [site] AddSiteRequest site
         */

        /**
         * Constructs a new AddSiteRequest.
         * @memberof pond
         * @classdesc Represents an AddSiteRequest.
         * @implements IAddSiteRequest
         * @constructor
         * @param {pond.IAddSiteRequest=} [properties] Properties to set
         */
        function AddSiteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSiteRequest site.
         * @member {pond.SiteSettings|null|undefined} site
         * @memberof pond.AddSiteRequest
         * @instance
         */
        AddSiteRequest.prototype.site = null;

        /**
         * Creates a new AddSiteRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddSiteRequest
         * @static
         * @param {pond.IAddSiteRequest=} [properties] Properties to set
         * @returns {pond.AddSiteRequest} AddSiteRequest instance
         */
        AddSiteRequest.create = function create(properties) {
            return new AddSiteRequest(properties);
        };

        /**
         * Creates an AddSiteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddSiteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddSiteRequest} AddSiteRequest
         */
        AddSiteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddSiteRequest)
                return object;
            var message = new $root.pond.AddSiteRequest();
            if (object.site != null) {
                if (typeof object.site !== "object")
                    throw TypeError(".pond.AddSiteRequest.site: object expected");
                message.site = $root.pond.SiteSettings.fromObject(object.site);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddSiteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddSiteRequest
         * @static
         * @param {pond.AddSiteRequest} message AddSiteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSiteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.site = null;
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = $root.pond.SiteSettings.toObject(message.site, options);
            return object;
        };

        /**
         * Converts this AddSiteRequest to JSON.
         * @function toJSON
         * @memberof pond.AddSiteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSiteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddSiteRequest;
    })();

    pond.AddSiteResponse = (function() {

        /**
         * Properties of an AddSiteResponse.
         * @memberof pond
         * @interface IAddSiteResponse
         * @property {string|null} [site] AddSiteResponse site
         */

        /**
         * Constructs a new AddSiteResponse.
         * @memberof pond
         * @classdesc Represents an AddSiteResponse.
         * @implements IAddSiteResponse
         * @constructor
         * @param {pond.IAddSiteResponse=} [properties] Properties to set
         */
        function AddSiteResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSiteResponse site.
         * @member {string} site
         * @memberof pond.AddSiteResponse
         * @instance
         */
        AddSiteResponse.prototype.site = "";

        /**
         * Creates a new AddSiteResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddSiteResponse
         * @static
         * @param {pond.IAddSiteResponse=} [properties] Properties to set
         * @returns {pond.AddSiteResponse} AddSiteResponse instance
         */
        AddSiteResponse.create = function create(properties) {
            return new AddSiteResponse(properties);
        };

        /**
         * Creates an AddSiteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddSiteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddSiteResponse} AddSiteResponse
         */
        AddSiteResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddSiteResponse)
                return object;
            var message = new $root.pond.AddSiteResponse();
            if (object.site != null)
                message.site = String(object.site);
            return message;
        };

        /**
         * Creates a plain object from an AddSiteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddSiteResponse
         * @static
         * @param {pond.AddSiteResponse} message AddSiteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSiteResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.site = "";
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = message.site;
            return object;
        };

        /**
         * Converts this AddSiteResponse to JSON.
         * @function toJSON
         * @memberof pond.AddSiteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSiteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddSiteResponse;
    })();

    pond.ListSitesRequest = (function() {

        /**
         * Properties of a ListSitesRequest.
         * @memberof pond
         * @interface IListSitesRequest
         * @property {string|null} [key] ListSitesRequest key
         * @property {string|null} [userId] ListSitesRequest userId
         * @property {pond.Paging|null} [paging] ListSitesRequest paging
         * @property {pond.Sorting|null} [sorting] ListSitesRequest sorting
         * @property {string|null} [search] ListSitesRequest search
         * @property {pond.SiteSettings|null} [settingsMatch] ListSitesRequest settingsMatch
         * @property {pond.SiteStatus|null} [statusMatch] ListSitesRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListSitesRequest fieldContains
         */

        /**
         * Constructs a new ListSitesRequest.
         * @memberof pond
         * @classdesc Represents a ListSitesRequest.
         * @implements IListSitesRequest
         * @constructor
         * @param {pond.IListSitesRequest=} [properties] Properties to set
         */
        function ListSitesRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSitesRequest key.
         * @member {string} key
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.key = "";

        /**
         * ListSitesRequest userId.
         * @member {string} userId
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.userId = "";

        /**
         * ListSitesRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.paging = null;

        /**
         * ListSitesRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.sorting = null;

        /**
         * ListSitesRequest search.
         * @member {string} search
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.search = "";

        /**
         * ListSitesRequest settingsMatch.
         * @member {pond.SiteSettings|null|undefined} settingsMatch
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.settingsMatch = null;

        /**
         * ListSitesRequest statusMatch.
         * @member {pond.SiteStatus|null|undefined} statusMatch
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.statusMatch = null;

        /**
         * ListSitesRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListSitesRequest
         * @instance
         */
        ListSitesRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListSitesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListSitesRequest
         * @static
         * @param {pond.IListSitesRequest=} [properties] Properties to set
         * @returns {pond.ListSitesRequest} ListSitesRequest instance
         */
        ListSitesRequest.create = function create(properties) {
            return new ListSitesRequest(properties);
        };

        /**
         * Creates a ListSitesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListSitesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListSitesRequest} ListSitesRequest
         */
        ListSitesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListSitesRequest)
                return object;
            var message = new $root.pond.ListSitesRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListSitesRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListSitesRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListSitesRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.SiteSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListSitesRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.SiteStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListSitesRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListSitesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListSitesRequest
         * @static
         * @param {pond.ListSitesRequest} message ListSitesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSitesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.SiteSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.SiteStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListSitesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListSitesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSitesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListSitesRequest;
    })();

    pond.ListSitesResponse = (function() {

        /**
         * Properties of a ListSitesResponse.
         * @memberof pond
         * @interface IListSitesResponse
         * @property {Array.<pond.Site>|null} [sites] ListSitesResponse sites
         * @property {number|null} [nextOffset] ListSitesResponse nextOffset
         * @property {number|null} [total] ListSitesResponse total
         */

        /**
         * Constructs a new ListSitesResponse.
         * @memberof pond
         * @classdesc Represents a ListSitesResponse.
         * @implements IListSitesResponse
         * @constructor
         * @param {pond.IListSitesResponse=} [properties] Properties to set
         */
        function ListSitesResponse(properties) {
            this.sites = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSitesResponse sites.
         * @member {Array.<pond.Site>} sites
         * @memberof pond.ListSitesResponse
         * @instance
         */
        ListSitesResponse.prototype.sites = $util.emptyArray;

        /**
         * ListSitesResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListSitesResponse
         * @instance
         */
        ListSitesResponse.prototype.nextOffset = 0;

        /**
         * ListSitesResponse total.
         * @member {number} total
         * @memberof pond.ListSitesResponse
         * @instance
         */
        ListSitesResponse.prototype.total = 0;

        /**
         * Creates a new ListSitesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListSitesResponse
         * @static
         * @param {pond.IListSitesResponse=} [properties] Properties to set
         * @returns {pond.ListSitesResponse} ListSitesResponse instance
         */
        ListSitesResponse.create = function create(properties) {
            return new ListSitesResponse(properties);
        };

        /**
         * Creates a ListSitesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListSitesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListSitesResponse} ListSitesResponse
         */
        ListSitesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListSitesResponse)
                return object;
            var message = new $root.pond.ListSitesResponse();
            if (object.sites) {
                if (!Array.isArray(object.sites))
                    throw TypeError(".pond.ListSitesResponse.sites: array expected");
                message.sites = [];
                for (var i = 0; i < object.sites.length; ++i) {
                    if (typeof object.sites[i] !== "object")
                        throw TypeError(".pond.ListSitesResponse.sites: object expected");
                    message.sites[i] = $root.pond.Site.fromObject(object.sites[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListSitesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListSitesResponse
         * @static
         * @param {pond.ListSitesResponse} message ListSitesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSitesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.sites = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.sites && message.sites.length) {
                object.sites = [];
                for (var j = 0; j < message.sites.length; ++j)
                    object.sites[j] = $root.pond.Site.toObject(message.sites[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListSitesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListSitesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSitesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListSitesResponse;
    })();

    pond.RemoveSiteRequest = (function() {

        /**
         * Properties of a RemoveSiteRequest.
         * @memberof pond
         * @interface IRemoveSiteRequest
         * @property {string|null} [site] RemoveSiteRequest site
         */

        /**
         * Constructs a new RemoveSiteRequest.
         * @memberof pond
         * @classdesc Represents a RemoveSiteRequest.
         * @implements IRemoveSiteRequest
         * @constructor
         * @param {pond.IRemoveSiteRequest=} [properties] Properties to set
         */
        function RemoveSiteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveSiteRequest site.
         * @member {string} site
         * @memberof pond.RemoveSiteRequest
         * @instance
         */
        RemoveSiteRequest.prototype.site = "";

        /**
         * Creates a new RemoveSiteRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveSiteRequest
         * @static
         * @param {pond.IRemoveSiteRequest=} [properties] Properties to set
         * @returns {pond.RemoveSiteRequest} RemoveSiteRequest instance
         */
        RemoveSiteRequest.create = function create(properties) {
            return new RemoveSiteRequest(properties);
        };

        /**
         * Creates a RemoveSiteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveSiteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveSiteRequest} RemoveSiteRequest
         */
        RemoveSiteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveSiteRequest)
                return object;
            var message = new $root.pond.RemoveSiteRequest();
            if (object.site != null)
                message.site = String(object.site);
            return message;
        };

        /**
         * Creates a plain object from a RemoveSiteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveSiteRequest
         * @static
         * @param {pond.RemoveSiteRequest} message RemoveSiteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveSiteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.site = "";
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = message.site;
            return object;
        };

        /**
         * Converts this RemoveSiteRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveSiteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveSiteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveSiteRequest;
    })();

    pond.RemoveSiteResponse = (function() {

        /**
         * Properties of a RemoveSiteResponse.
         * @memberof pond
         * @interface IRemoveSiteResponse
         */

        /**
         * Constructs a new RemoveSiteResponse.
         * @memberof pond
         * @classdesc Represents a RemoveSiteResponse.
         * @implements IRemoveSiteResponse
         * @constructor
         * @param {pond.IRemoveSiteResponse=} [properties] Properties to set
         */
        function RemoveSiteResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveSiteResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveSiteResponse
         * @static
         * @param {pond.IRemoveSiteResponse=} [properties] Properties to set
         * @returns {pond.RemoveSiteResponse} RemoveSiteResponse instance
         */
        RemoveSiteResponse.create = function create(properties) {
            return new RemoveSiteResponse(properties);
        };

        /**
         * Creates a RemoveSiteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveSiteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveSiteResponse} RemoveSiteResponse
         */
        RemoveSiteResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveSiteResponse)
                return object;
            return new $root.pond.RemoveSiteResponse();
        };

        /**
         * Creates a plain object from a RemoveSiteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveSiteResponse
         * @static
         * @param {pond.RemoveSiteResponse} message RemoveSiteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveSiteResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveSiteResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveSiteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveSiteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveSiteResponse;
    })();

    pond.UpdateSiteRequest = (function() {

        /**
         * Properties of an UpdateSiteRequest.
         * @memberof pond
         * @interface IUpdateSiteRequest
         * @property {pond.SiteSettings|null} [site] UpdateSiteRequest site
         */

        /**
         * Constructs a new UpdateSiteRequest.
         * @memberof pond
         * @classdesc Represents an UpdateSiteRequest.
         * @implements IUpdateSiteRequest
         * @constructor
         * @param {pond.IUpdateSiteRequest=} [properties] Properties to set
         */
        function UpdateSiteRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateSiteRequest site.
         * @member {pond.SiteSettings|null|undefined} site
         * @memberof pond.UpdateSiteRequest
         * @instance
         */
        UpdateSiteRequest.prototype.site = null;

        /**
         * Creates a new UpdateSiteRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateSiteRequest
         * @static
         * @param {pond.IUpdateSiteRequest=} [properties] Properties to set
         * @returns {pond.UpdateSiteRequest} UpdateSiteRequest instance
         */
        UpdateSiteRequest.create = function create(properties) {
            return new UpdateSiteRequest(properties);
        };

        /**
         * Creates an UpdateSiteRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateSiteRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateSiteRequest} UpdateSiteRequest
         */
        UpdateSiteRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateSiteRequest)
                return object;
            var message = new $root.pond.UpdateSiteRequest();
            if (object.site != null) {
                if (typeof object.site !== "object")
                    throw TypeError(".pond.UpdateSiteRequest.site: object expected");
                message.site = $root.pond.SiteSettings.fromObject(object.site);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateSiteRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateSiteRequest
         * @static
         * @param {pond.UpdateSiteRequest} message UpdateSiteRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSiteRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.site = null;
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = $root.pond.SiteSettings.toObject(message.site, options);
            return object;
        };

        /**
         * Converts this UpdateSiteRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateSiteRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSiteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateSiteRequest;
    })();

    pond.UpdateSiteResponse = (function() {

        /**
         * Properties of an UpdateSiteResponse.
         * @memberof pond
         * @interface IUpdateSiteResponse
         */

        /**
         * Constructs a new UpdateSiteResponse.
         * @memberof pond
         * @classdesc Represents an UpdateSiteResponse.
         * @implements IUpdateSiteResponse
         * @constructor
         * @param {pond.IUpdateSiteResponse=} [properties] Properties to set
         */
        function UpdateSiteResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateSiteResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateSiteResponse
         * @static
         * @param {pond.IUpdateSiteResponse=} [properties] Properties to set
         * @returns {pond.UpdateSiteResponse} UpdateSiteResponse instance
         */
        UpdateSiteResponse.create = function create(properties) {
            return new UpdateSiteResponse(properties);
        };

        /**
         * Creates an UpdateSiteResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateSiteResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateSiteResponse} UpdateSiteResponse
         */
        UpdateSiteResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateSiteResponse)
                return object;
            return new $root.pond.UpdateSiteResponse();
        };

        /**
         * Creates a plain object from an UpdateSiteResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateSiteResponse
         * @static
         * @param {pond.UpdateSiteResponse} message UpdateSiteResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSiteResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateSiteResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateSiteResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSiteResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateSiteResponse;
    })();

    pond.UpdateSiteLinkRequest = (function() {

        /**
         * Properties of an UpdateSiteLinkRequest.
         * @memberof pond
         * @interface IUpdateSiteLinkRequest
         * @property {string|null} [parentKey] UpdateSiteLinkRequest parentKey
         * @property {string|null} [parentType] UpdateSiteLinkRequest parentType
         * @property {string|null} [key] UpdateSiteLinkRequest key
         * @property {string|null} [type] UpdateSiteLinkRequest type
         * @property {Array.<string>|null} [permissions] UpdateSiteLinkRequest permissions
         */

        /**
         * Constructs a new UpdateSiteLinkRequest.
         * @memberof pond
         * @classdesc Represents an UpdateSiteLinkRequest.
         * @implements IUpdateSiteLinkRequest
         * @constructor
         * @param {pond.IUpdateSiteLinkRequest=} [properties] Properties to set
         */
        function UpdateSiteLinkRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateSiteLinkRequest parentKey.
         * @member {string} parentKey
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         */
        UpdateSiteLinkRequest.prototype.parentKey = "";

        /**
         * UpdateSiteLinkRequest parentType.
         * @member {string} parentType
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         */
        UpdateSiteLinkRequest.prototype.parentType = "";

        /**
         * UpdateSiteLinkRequest key.
         * @member {string} key
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         */
        UpdateSiteLinkRequest.prototype.key = "";

        /**
         * UpdateSiteLinkRequest type.
         * @member {string} type
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         */
        UpdateSiteLinkRequest.prototype.type = "";

        /**
         * UpdateSiteLinkRequest permissions.
         * @member {Array.<string>} permissions
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         */
        UpdateSiteLinkRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdateSiteLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateSiteLinkRequest
         * @static
         * @param {pond.IUpdateSiteLinkRequest=} [properties] Properties to set
         * @returns {pond.UpdateSiteLinkRequest} UpdateSiteLinkRequest instance
         */
        UpdateSiteLinkRequest.create = function create(properties) {
            return new UpdateSiteLinkRequest(properties);
        };

        /**
         * Creates an UpdateSiteLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateSiteLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateSiteLinkRequest} UpdateSiteLinkRequest
         */
        UpdateSiteLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateSiteLinkRequest)
                return object;
            var message = new $root.pond.UpdateSiteLinkRequest();
            if (object.parentKey != null)
                message.parentKey = String(object.parentKey);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                message.type = String(object.type);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.UpdateSiteLinkRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    message.permissions[i] = String(object.permissions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateSiteLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateSiteLinkRequest
         * @static
         * @param {pond.UpdateSiteLinkRequest} message UpdateSiteLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSiteLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.parentKey = "";
                object.parentType = "";
                object.key = "";
                object.type = "";
            }
            if (message.parentKey != null && message.hasOwnProperty("parentKey"))
                object.parentKey = message.parentKey;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdateSiteLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateSiteLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSiteLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateSiteLinkRequest;
    })();

    pond.UpdateSiteLinkResponse = (function() {

        /**
         * Properties of an UpdateSiteLinkResponse.
         * @memberof pond
         * @interface IUpdateSiteLinkResponse
         */

        /**
         * Constructs a new UpdateSiteLinkResponse.
         * @memberof pond
         * @classdesc Represents an UpdateSiteLinkResponse.
         * @implements IUpdateSiteLinkResponse
         * @constructor
         * @param {pond.IUpdateSiteLinkResponse=} [properties] Properties to set
         */
        function UpdateSiteLinkResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateSiteLinkResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateSiteLinkResponse
         * @static
         * @param {pond.IUpdateSiteLinkResponse=} [properties] Properties to set
         * @returns {pond.UpdateSiteLinkResponse} UpdateSiteLinkResponse instance
         */
        UpdateSiteLinkResponse.create = function create(properties) {
            return new UpdateSiteLinkResponse(properties);
        };

        /**
         * Creates an UpdateSiteLinkResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateSiteLinkResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateSiteLinkResponse} UpdateSiteLinkResponse
         */
        UpdateSiteLinkResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateSiteLinkResponse)
                return object;
            return new $root.pond.UpdateSiteLinkResponse();
        };

        /**
         * Creates a plain object from an UpdateSiteLinkResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateSiteLinkResponse
         * @static
         * @param {pond.UpdateSiteLinkResponse} message UpdateSiteLinkResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSiteLinkResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateSiteLinkResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateSiteLinkResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSiteLinkResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateSiteLinkResponse;
    })();

    pond.GetSitePageDataRequest = (function() {

        /**
         * Properties of a GetSitePageDataRequest.
         * @memberof pond
         * @interface IGetSitePageDataRequest
         * @property {string|null} [siteKey] GetSitePageDataRequest siteKey
         */

        /**
         * Constructs a new GetSitePageDataRequest.
         * @memberof pond
         * @classdesc Represents a GetSitePageDataRequest.
         * @implements IGetSitePageDataRequest
         * @constructor
         * @param {pond.IGetSitePageDataRequest=} [properties] Properties to set
         */
        function GetSitePageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetSitePageDataRequest siteKey.
         * @member {string} siteKey
         * @memberof pond.GetSitePageDataRequest
         * @instance
         */
        GetSitePageDataRequest.prototype.siteKey = "";

        /**
         * Creates a new GetSitePageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetSitePageDataRequest
         * @static
         * @param {pond.IGetSitePageDataRequest=} [properties] Properties to set
         * @returns {pond.GetSitePageDataRequest} GetSitePageDataRequest instance
         */
        GetSitePageDataRequest.create = function create(properties) {
            return new GetSitePageDataRequest(properties);
        };

        /**
         * Creates a GetSitePageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetSitePageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetSitePageDataRequest} GetSitePageDataRequest
         */
        GetSitePageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetSitePageDataRequest)
                return object;
            var message = new $root.pond.GetSitePageDataRequest();
            if (object.siteKey != null)
                message.siteKey = String(object.siteKey);
            return message;
        };

        /**
         * Creates a plain object from a GetSitePageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetSitePageDataRequest
         * @static
         * @param {pond.GetSitePageDataRequest} message GetSitePageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetSitePageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.siteKey = "";
            if (message.siteKey != null && message.hasOwnProperty("siteKey"))
                object.siteKey = message.siteKey;
            return object;
        };

        /**
         * Converts this GetSitePageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetSitePageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetSitePageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetSitePageDataRequest;
    })();

    pond.GetSitePageDataResponse = (function() {

        /**
         * Properties of a GetSitePageDataResponse.
         * @memberof pond
         * @interface IGetSitePageDataResponse
         * @property {pond.Site|null} [site] GetSitePageDataResponse site
         * @property {Array.<pond.ObjectHeaterData>|null} [heaterData] GetSitePageDataResponse heaterData
         */

        /**
         * Constructs a new GetSitePageDataResponse.
         * @memberof pond
         * @classdesc Represents a GetSitePageDataResponse.
         * @implements IGetSitePageDataResponse
         * @constructor
         * @param {pond.IGetSitePageDataResponse=} [properties] Properties to set
         */
        function GetSitePageDataResponse(properties) {
            this.heaterData = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetSitePageDataResponse site.
         * @member {pond.Site|null|undefined} site
         * @memberof pond.GetSitePageDataResponse
         * @instance
         */
        GetSitePageDataResponse.prototype.site = null;

        /**
         * GetSitePageDataResponse heaterData.
         * @member {Array.<pond.ObjectHeaterData>} heaterData
         * @memberof pond.GetSitePageDataResponse
         * @instance
         */
        GetSitePageDataResponse.prototype.heaterData = $util.emptyArray;

        /**
         * Creates a new GetSitePageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetSitePageDataResponse
         * @static
         * @param {pond.IGetSitePageDataResponse=} [properties] Properties to set
         * @returns {pond.GetSitePageDataResponse} GetSitePageDataResponse instance
         */
        GetSitePageDataResponse.create = function create(properties) {
            return new GetSitePageDataResponse(properties);
        };

        /**
         * Creates a GetSitePageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetSitePageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetSitePageDataResponse} GetSitePageDataResponse
         */
        GetSitePageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetSitePageDataResponse)
                return object;
            var message = new $root.pond.GetSitePageDataResponse();
            if (object.site != null) {
                if (typeof object.site !== "object")
                    throw TypeError(".pond.GetSitePageDataResponse.site: object expected");
                message.site = $root.pond.Site.fromObject(object.site);
            }
            if (object.heaterData) {
                if (!Array.isArray(object.heaterData))
                    throw TypeError(".pond.GetSitePageDataResponse.heaterData: array expected");
                message.heaterData = [];
                for (var i = 0; i < object.heaterData.length; ++i) {
                    if (typeof object.heaterData[i] !== "object")
                        throw TypeError(".pond.GetSitePageDataResponse.heaterData: object expected");
                    message.heaterData[i] = $root.pond.ObjectHeaterData.fromObject(object.heaterData[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetSitePageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetSitePageDataResponse
         * @static
         * @param {pond.GetSitePageDataResponse} message GetSitePageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetSitePageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.heaterData = [];
            if (options.defaults)
                object.site = null;
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = $root.pond.Site.toObject(message.site, options);
            if (message.heaterData && message.heaterData.length) {
                object.heaterData = [];
                for (var j = 0; j < message.heaterData.length; ++j)
                    object.heaterData[j] = $root.pond.ObjectHeaterData.toObject(message.heaterData[j], options);
            }
            return object;
        };

        /**
         * Converts this GetSitePageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetSitePageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetSitePageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetSitePageDataResponse;
    })();

    pond.SiteData = (function() {

        /**
         * Properties of a SiteData.
         * @memberof pond
         * @interface ISiteData
         * @property {pond.Site|null} [site] SiteData site
         * @property {Array.<pond.ObjectHeaterData>|null} [heaterData] SiteData heaterData
         * @property {Array.<pond.User>|null} [users] SiteData users
         */

        /**
         * Constructs a new SiteData.
         * @memberof pond
         * @classdesc Represents a SiteData.
         * @implements ISiteData
         * @constructor
         * @param {pond.ISiteData=} [properties] Properties to set
         */
        function SiteData(properties) {
            this.heaterData = [];
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SiteData site.
         * @member {pond.Site|null|undefined} site
         * @memberof pond.SiteData
         * @instance
         */
        SiteData.prototype.site = null;

        /**
         * SiteData heaterData.
         * @member {Array.<pond.ObjectHeaterData>} heaterData
         * @memberof pond.SiteData
         * @instance
         */
        SiteData.prototype.heaterData = $util.emptyArray;

        /**
         * SiteData users.
         * @member {Array.<pond.User>} users
         * @memberof pond.SiteData
         * @instance
         */
        SiteData.prototype.users = $util.emptyArray;

        /**
         * Creates a new SiteData instance using the specified properties.
         * @function create
         * @memberof pond.SiteData
         * @static
         * @param {pond.ISiteData=} [properties] Properties to set
         * @returns {pond.SiteData} SiteData instance
         */
        SiteData.create = function create(properties) {
            return new SiteData(properties);
        };

        /**
         * Creates a SiteData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SiteData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SiteData} SiteData
         */
        SiteData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SiteData)
                return object;
            var message = new $root.pond.SiteData();
            if (object.site != null) {
                if (typeof object.site !== "object")
                    throw TypeError(".pond.SiteData.site: object expected");
                message.site = $root.pond.Site.fromObject(object.site);
            }
            if (object.heaterData) {
                if (!Array.isArray(object.heaterData))
                    throw TypeError(".pond.SiteData.heaterData: array expected");
                message.heaterData = [];
                for (var i = 0; i < object.heaterData.length; ++i) {
                    if (typeof object.heaterData[i] !== "object")
                        throw TypeError(".pond.SiteData.heaterData: object expected");
                    message.heaterData[i] = $root.pond.ObjectHeaterData.fromObject(object.heaterData[i]);
                }
            }
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.SiteData.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".pond.SiteData.users: object expected");
                    message.users[i] = $root.pond.User.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SiteData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SiteData
         * @static
         * @param {pond.SiteData} message SiteData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SiteData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.heaterData = [];
                object.users = [];
            }
            if (options.defaults)
                object.site = null;
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = $root.pond.Site.toObject(message.site, options);
            if (message.heaterData && message.heaterData.length) {
                object.heaterData = [];
                for (var j = 0; j < message.heaterData.length; ++j)
                    object.heaterData[j] = $root.pond.ObjectHeaterData.toObject(message.heaterData[j], options);
            }
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.pond.User.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this SiteData to JSON.
         * @function toJSON
         * @memberof pond.SiteData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SiteData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SiteData;
    })();

    pond.ListSitesPageDataRequest = (function() {

        /**
         * Properties of a ListSitesPageDataRequest.
         * @memberof pond
         * @interface IListSitesPageDataRequest
         * @property {pond.Paging|null} [paging] ListSitesPageDataRequest paging
         * @property {pond.Sorting|null} [sorting] ListSitesPageDataRequest sorting
         * @property {string|null} [search] ListSitesPageDataRequest search
         * @property {pond.SiteSettings|null} [settingsMatch] ListSitesPageDataRequest settingsMatch
         * @property {pond.SiteStatus|null} [statusMatch] ListSitesPageDataRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListSitesPageDataRequest fieldContains
         */

        /**
         * Constructs a new ListSitesPageDataRequest.
         * @memberof pond
         * @classdesc Represents a ListSitesPageDataRequest.
         * @implements IListSitesPageDataRequest
         * @constructor
         * @param {pond.IListSitesPageDataRequest=} [properties] Properties to set
         */
        function ListSitesPageDataRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSitesPageDataRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.paging = null;

        /**
         * ListSitesPageDataRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.sorting = null;

        /**
         * ListSitesPageDataRequest search.
         * @member {string} search
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.search = "";

        /**
         * ListSitesPageDataRequest settingsMatch.
         * @member {pond.SiteSettings|null|undefined} settingsMatch
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.settingsMatch = null;

        /**
         * ListSitesPageDataRequest statusMatch.
         * @member {pond.SiteStatus|null|undefined} statusMatch
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.statusMatch = null;

        /**
         * ListSitesPageDataRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         */
        ListSitesPageDataRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListSitesPageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListSitesPageDataRequest
         * @static
         * @param {pond.IListSitesPageDataRequest=} [properties] Properties to set
         * @returns {pond.ListSitesPageDataRequest} ListSitesPageDataRequest instance
         */
        ListSitesPageDataRequest.create = function create(properties) {
            return new ListSitesPageDataRequest(properties);
        };

        /**
         * Creates a ListSitesPageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListSitesPageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListSitesPageDataRequest} ListSitesPageDataRequest
         */
        ListSitesPageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListSitesPageDataRequest)
                return object;
            var message = new $root.pond.ListSitesPageDataRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListSitesPageDataRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListSitesPageDataRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListSitesPageDataRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.SiteSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListSitesPageDataRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.SiteStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListSitesPageDataRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListSitesPageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListSitesPageDataRequest
         * @static
         * @param {pond.ListSitesPageDataRequest} message ListSitesPageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSitesPageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.SiteSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.SiteStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListSitesPageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.ListSitesPageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSitesPageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListSitesPageDataRequest;
    })();

    pond.ListSitesPageDataResponse = (function() {

        /**
         * Properties of a ListSitesPageDataResponse.
         * @memberof pond
         * @interface IListSitesPageDataResponse
         * @property {Array.<pond.SiteData>|null} [sites] ListSitesPageDataResponse sites
         * @property {number|null} [nextOffset] ListSitesPageDataResponse nextOffset
         * @property {number|null} [total] ListSitesPageDataResponse total
         */

        /**
         * Constructs a new ListSitesPageDataResponse.
         * @memberof pond
         * @classdesc Represents a ListSitesPageDataResponse.
         * @implements IListSitesPageDataResponse
         * @constructor
         * @param {pond.IListSitesPageDataResponse=} [properties] Properties to set
         */
        function ListSitesPageDataResponse(properties) {
            this.sites = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSitesPageDataResponse sites.
         * @member {Array.<pond.SiteData>} sites
         * @memberof pond.ListSitesPageDataResponse
         * @instance
         */
        ListSitesPageDataResponse.prototype.sites = $util.emptyArray;

        /**
         * ListSitesPageDataResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListSitesPageDataResponse
         * @instance
         */
        ListSitesPageDataResponse.prototype.nextOffset = 0;

        /**
         * ListSitesPageDataResponse total.
         * @member {number} total
         * @memberof pond.ListSitesPageDataResponse
         * @instance
         */
        ListSitesPageDataResponse.prototype.total = 0;

        /**
         * Creates a new ListSitesPageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListSitesPageDataResponse
         * @static
         * @param {pond.IListSitesPageDataResponse=} [properties] Properties to set
         * @returns {pond.ListSitesPageDataResponse} ListSitesPageDataResponse instance
         */
        ListSitesPageDataResponse.create = function create(properties) {
            return new ListSitesPageDataResponse(properties);
        };

        /**
         * Creates a ListSitesPageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListSitesPageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListSitesPageDataResponse} ListSitesPageDataResponse
         */
        ListSitesPageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListSitesPageDataResponse)
                return object;
            var message = new $root.pond.ListSitesPageDataResponse();
            if (object.sites) {
                if (!Array.isArray(object.sites))
                    throw TypeError(".pond.ListSitesPageDataResponse.sites: array expected");
                message.sites = [];
                for (var i = 0; i < object.sites.length; ++i) {
                    if (typeof object.sites[i] !== "object")
                        throw TypeError(".pond.ListSitesPageDataResponse.sites: object expected");
                    message.sites[i] = $root.pond.SiteData.fromObject(object.sites[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListSitesPageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListSitesPageDataResponse
         * @static
         * @param {pond.ListSitesPageDataResponse} message ListSitesPageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSitesPageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.sites = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.sites && message.sites.length) {
                object.sites = [];
                for (var j = 0; j < message.sites.length; ++j)
                    object.sites[j] = $root.pond.SiteData.toObject(message.sites[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListSitesPageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.ListSitesPageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSitesPageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListSitesPageDataResponse;
    })();

    pond.MineSensorPreferences = (function() {

        /**
         * Properties of a MineSensorPreferences.
         * @memberof pond
         * @interface IMineSensorPreferences
         * @property {boolean|null} [enabled] MineSensorPreferences enabled
         * @property {number|null} [x] MineSensorPreferences x
         * @property {number|null} [y] MineSensorPreferences y
         * @property {string|null} [nickname] MineSensorPreferences nickname
         */

        /**
         * Constructs a new MineSensorPreferences.
         * @memberof pond
         * @classdesc Represents a MineSensorPreferences.
         * @implements IMineSensorPreferences
         * @constructor
         * @param {pond.IMineSensorPreferences=} [properties] Properties to set
         */
        function MineSensorPreferences(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineSensorPreferences enabled.
         * @member {boolean} enabled
         * @memberof pond.MineSensorPreferences
         * @instance
         */
        MineSensorPreferences.prototype.enabled = false;

        /**
         * MineSensorPreferences x.
         * @member {number} x
         * @memberof pond.MineSensorPreferences
         * @instance
         */
        MineSensorPreferences.prototype.x = 0;

        /**
         * MineSensorPreferences y.
         * @member {number} y
         * @memberof pond.MineSensorPreferences
         * @instance
         */
        MineSensorPreferences.prototype.y = 0;

        /**
         * MineSensorPreferences nickname.
         * @member {string} nickname
         * @memberof pond.MineSensorPreferences
         * @instance
         */
        MineSensorPreferences.prototype.nickname = "";

        /**
         * Creates a new MineSensorPreferences instance using the specified properties.
         * @function create
         * @memberof pond.MineSensorPreferences
         * @static
         * @param {pond.IMineSensorPreferences=} [properties] Properties to set
         * @returns {pond.MineSensorPreferences} MineSensorPreferences instance
         */
        MineSensorPreferences.create = function create(properties) {
            return new MineSensorPreferences(properties);
        };

        /**
         * Creates a MineSensorPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineSensorPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineSensorPreferences} MineSensorPreferences
         */
        MineSensorPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineSensorPreferences)
                return object;
            var message = new $root.pond.MineSensorPreferences();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            if (object.x != null)
                message.x = Number(object.x);
            if (object.y != null)
                message.y = Number(object.y);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            return message;
        };

        /**
         * Creates a plain object from a MineSensorPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineSensorPreferences
         * @static
         * @param {pond.MineSensorPreferences} message MineSensorPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineSensorPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.enabled = false;
                object.x = 0;
                object.y = 0;
                object.nickname = "";
            }
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            return object;
        };

        /**
         * Converts this MineSensorPreferences to JSON.
         * @function toJSON
         * @memberof pond.MineSensorPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineSensorPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineSensorPreferences;
    })();

    pond.MineComponentPreferences = (function() {

        /**
         * Properties of a MineComponentPreferences.
         * @memberof pond
         * @interface IMineComponentPreferences
         * @property {Array.<pond.MineSensorPreferences>|null} [sensors] MineComponentPreferences sensors
         */

        /**
         * Constructs a new MineComponentPreferences.
         * @memberof pond
         * @classdesc Represents a MineComponentPreferences.
         * @implements IMineComponentPreferences
         * @constructor
         * @param {pond.IMineComponentPreferences=} [properties] Properties to set
         */
        function MineComponentPreferences(properties) {
            this.sensors = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineComponentPreferences sensors.
         * @member {Array.<pond.MineSensorPreferences>} sensors
         * @memberof pond.MineComponentPreferences
         * @instance
         */
        MineComponentPreferences.prototype.sensors = $util.emptyArray;

        /**
         * Creates a new MineComponentPreferences instance using the specified properties.
         * @function create
         * @memberof pond.MineComponentPreferences
         * @static
         * @param {pond.IMineComponentPreferences=} [properties] Properties to set
         * @returns {pond.MineComponentPreferences} MineComponentPreferences instance
         */
        MineComponentPreferences.create = function create(properties) {
            return new MineComponentPreferences(properties);
        };

        /**
         * Creates a MineComponentPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineComponentPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineComponentPreferences} MineComponentPreferences
         */
        MineComponentPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineComponentPreferences)
                return object;
            var message = new $root.pond.MineComponentPreferences();
            if (object.sensors) {
                if (!Array.isArray(object.sensors))
                    throw TypeError(".pond.MineComponentPreferences.sensors: array expected");
                message.sensors = [];
                for (var i = 0; i < object.sensors.length; ++i) {
                    if (typeof object.sensors[i] !== "object")
                        throw TypeError(".pond.MineComponentPreferences.sensors: object expected");
                    message.sensors[i] = $root.pond.MineSensorPreferences.fromObject(object.sensors[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MineComponentPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineComponentPreferences
         * @static
         * @param {pond.MineComponentPreferences} message MineComponentPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineComponentPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.sensors = [];
            if (message.sensors && message.sensors.length) {
                object.sensors = [];
                for (var j = 0; j < message.sensors.length; ++j)
                    object.sensors[j] = $root.pond.MineSensorPreferences.toObject(message.sensors[j], options);
            }
            return object;
        };

        /**
         * Converts this MineComponentPreferences to JSON.
         * @function toJSON
         * @memberof pond.MineComponentPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineComponentPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineComponentPreferences;
    })();

    pond.MineComponentPreferencesContainer = (function() {

        /**
         * Properties of a MineComponentPreferencesContainer.
         * @memberof pond
         * @interface IMineComponentPreferencesContainer
         * @property {Array.<pond.MineComponentPreferences>|null} [preferences] MineComponentPreferencesContainer preferences
         * @property {Array.<string>|null} [keys] MineComponentPreferencesContainer keys
         */

        /**
         * Constructs a new MineComponentPreferencesContainer.
         * @memberof pond
         * @classdesc Represents a MineComponentPreferencesContainer.
         * @implements IMineComponentPreferencesContainer
         * @constructor
         * @param {pond.IMineComponentPreferencesContainer=} [properties] Properties to set
         */
        function MineComponentPreferencesContainer(properties) {
            this.preferences = [];
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineComponentPreferencesContainer preferences.
         * @member {Array.<pond.MineComponentPreferences>} preferences
         * @memberof pond.MineComponentPreferencesContainer
         * @instance
         */
        MineComponentPreferencesContainer.prototype.preferences = $util.emptyArray;

        /**
         * MineComponentPreferencesContainer keys.
         * @member {Array.<string>} keys
         * @memberof pond.MineComponentPreferencesContainer
         * @instance
         */
        MineComponentPreferencesContainer.prototype.keys = $util.emptyArray;

        /**
         * Creates a new MineComponentPreferencesContainer instance using the specified properties.
         * @function create
         * @memberof pond.MineComponentPreferencesContainer
         * @static
         * @param {pond.IMineComponentPreferencesContainer=} [properties] Properties to set
         * @returns {pond.MineComponentPreferencesContainer} MineComponentPreferencesContainer instance
         */
        MineComponentPreferencesContainer.create = function create(properties) {
            return new MineComponentPreferencesContainer(properties);
        };

        /**
         * Creates a MineComponentPreferencesContainer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineComponentPreferencesContainer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineComponentPreferencesContainer} MineComponentPreferencesContainer
         */
        MineComponentPreferencesContainer.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineComponentPreferencesContainer)
                return object;
            var message = new $root.pond.MineComponentPreferencesContainer();
            if (object.preferences) {
                if (!Array.isArray(object.preferences))
                    throw TypeError(".pond.MineComponentPreferencesContainer.preferences: array expected");
                message.preferences = [];
                for (var i = 0; i < object.preferences.length; ++i) {
                    if (typeof object.preferences[i] !== "object")
                        throw TypeError(".pond.MineComponentPreferencesContainer.preferences: object expected");
                    message.preferences[i] = $root.pond.MineComponentPreferences.fromObject(object.preferences[i]);
                }
            }
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.MineComponentPreferencesContainer.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a MineComponentPreferencesContainer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineComponentPreferencesContainer
         * @static
         * @param {pond.MineComponentPreferencesContainer} message MineComponentPreferencesContainer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineComponentPreferencesContainer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.preferences = [];
                object.keys = [];
            }
            if (message.preferences && message.preferences.length) {
                object.preferences = [];
                for (var j = 0; j < message.preferences.length; ++j)
                    object.preferences[j] = $root.pond.MineComponentPreferences.toObject(message.preferences[j], options);
            }
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            return object;
        };

        /**
         * Converts this MineComponentPreferencesContainer to JSON.
         * @function toJSON
         * @memberof pond.MineComponentPreferencesContainer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineComponentPreferencesContainer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineComponentPreferencesContainer;
    })();

    pond.AddMineRequest = (function() {

        /**
         * Properties of an AddMineRequest.
         * @memberof pond
         * @interface IAddMineRequest
         * @property {pond.MineSettings|null} [mine] AddMineRequest mine
         */

        /**
         * Constructs a new AddMineRequest.
         * @memberof pond
         * @classdesc Represents an AddMineRequest.
         * @implements IAddMineRequest
         * @constructor
         * @param {pond.IAddMineRequest=} [properties] Properties to set
         */
        function AddMineRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddMineRequest mine.
         * @member {pond.MineSettings|null|undefined} mine
         * @memberof pond.AddMineRequest
         * @instance
         */
        AddMineRequest.prototype.mine = null;

        /**
         * Creates a new AddMineRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddMineRequest
         * @static
         * @param {pond.IAddMineRequest=} [properties] Properties to set
         * @returns {pond.AddMineRequest} AddMineRequest instance
         */
        AddMineRequest.create = function create(properties) {
            return new AddMineRequest(properties);
        };

        /**
         * Creates an AddMineRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMineRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMineRequest} AddMineRequest
         */
        AddMineRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMineRequest)
                return object;
            var message = new $root.pond.AddMineRequest();
            if (object.mine != null) {
                if (typeof object.mine !== "object")
                    throw TypeError(".pond.AddMineRequest.mine: object expected");
                message.mine = $root.pond.MineSettings.fromObject(object.mine);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddMineRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMineRequest
         * @static
         * @param {pond.AddMineRequest} message AddMineRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMineRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.mine = null;
            if (message.mine != null && message.hasOwnProperty("mine"))
                object.mine = $root.pond.MineSettings.toObject(message.mine, options);
            return object;
        };

        /**
         * Converts this AddMineRequest to JSON.
         * @function toJSON
         * @memberof pond.AddMineRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMineRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMineRequest;
    })();

    pond.AddMineResponse = (function() {

        /**
         * Properties of an AddMineResponse.
         * @memberof pond
         * @interface IAddMineResponse
         * @property {string|null} [key] AddMineResponse key
         */

        /**
         * Constructs a new AddMineResponse.
         * @memberof pond
         * @classdesc Represents an AddMineResponse.
         * @implements IAddMineResponse
         * @constructor
         * @param {pond.IAddMineResponse=} [properties] Properties to set
         */
        function AddMineResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddMineResponse key.
         * @member {string} key
         * @memberof pond.AddMineResponse
         * @instance
         */
        AddMineResponse.prototype.key = "";

        /**
         * Creates a new AddMineResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddMineResponse
         * @static
         * @param {pond.IAddMineResponse=} [properties] Properties to set
         * @returns {pond.AddMineResponse} AddMineResponse instance
         */
        AddMineResponse.create = function create(properties) {
            return new AddMineResponse(properties);
        };

        /**
         * Creates an AddMineResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddMineResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddMineResponse} AddMineResponse
         */
        AddMineResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddMineResponse)
                return object;
            var message = new $root.pond.AddMineResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddMineResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddMineResponse
         * @static
         * @param {pond.AddMineResponse} message AddMineResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddMineResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddMineResponse to JSON.
         * @function toJSON
         * @memberof pond.AddMineResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddMineResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddMineResponse;
    })();

    pond.GetMineRequest = (function() {

        /**
         * Properties of a GetMineRequest.
         * @memberof pond
         * @interface IGetMineRequest
         * @property {string|null} [key] GetMineRequest key
         * @property {string|null} [userId] GetMineRequest userId
         */

        /**
         * Constructs a new GetMineRequest.
         * @memberof pond
         * @classdesc Represents a GetMineRequest.
         * @implements IGetMineRequest
         * @constructor
         * @param {pond.IGetMineRequest=} [properties] Properties to set
         */
        function GetMineRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMineRequest key.
         * @member {string} key
         * @memberof pond.GetMineRequest
         * @instance
         */
        GetMineRequest.prototype.key = "";

        /**
         * GetMineRequest userId.
         * @member {string} userId
         * @memberof pond.GetMineRequest
         * @instance
         */
        GetMineRequest.prototype.userId = "";

        /**
         * Creates a new GetMineRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMineRequest
         * @static
         * @param {pond.IGetMineRequest=} [properties] Properties to set
         * @returns {pond.GetMineRequest} GetMineRequest instance
         */
        GetMineRequest.create = function create(properties) {
            return new GetMineRequest(properties);
        };

        /**
         * Creates a GetMineRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMineRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMineRequest} GetMineRequest
         */
        GetMineRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMineRequest)
                return object;
            var message = new $root.pond.GetMineRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.userId != null)
                message.userId = String(object.userId);
            return message;
        };

        /**
         * Creates a plain object from a GetMineRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMineRequest
         * @static
         * @param {pond.GetMineRequest} message GetMineRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMineRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.userId = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            return object;
        };

        /**
         * Converts this GetMineRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMineRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMineRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMineRequest;
    })();

    pond.GetMineResponse = (function() {

        /**
         * Properties of a GetMineResponse.
         * @memberof pond
         * @interface IGetMineResponse
         * @property {pond.Mine|null} [mine] GetMineResponse mine
         * @property {Array.<pond.Device>|null} [devices] GetMineResponse devices
         * @property {Array.<pond.Component>|null} [components] GetMineResponse components
         * @property {Array.<pond.Permission>|null} [permissions] GetMineResponse permissions
         * @property {Object.<string,pond.MineComponentPreferences>|null} [componentPreferences] GetMineResponse componentPreferences
         * @property {Object.<string,number>|null} [componentDevices] GetMineResponse componentDevices
         */

        /**
         * Constructs a new GetMineResponse.
         * @memberof pond
         * @classdesc Represents a GetMineResponse.
         * @implements IGetMineResponse
         * @constructor
         * @param {pond.IGetMineResponse=} [properties] Properties to set
         */
        function GetMineResponse(properties) {
            this.devices = [];
            this.components = [];
            this.permissions = [];
            this.componentPreferences = {};
            this.componentDevices = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMineResponse mine.
         * @member {pond.Mine|null|undefined} mine
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.mine = null;

        /**
         * GetMineResponse devices.
         * @member {Array.<pond.Device>} devices
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.devices = $util.emptyArray;

        /**
         * GetMineResponse components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.components = $util.emptyArray;

        /**
         * GetMineResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.permissions = $util.emptyArray;

        /**
         * GetMineResponse componentPreferences.
         * @member {Object.<string,pond.MineComponentPreferences>} componentPreferences
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.componentPreferences = $util.emptyObject;

        /**
         * GetMineResponse componentDevices.
         * @member {Object.<string,number>} componentDevices
         * @memberof pond.GetMineResponse
         * @instance
         */
        GetMineResponse.prototype.componentDevices = $util.emptyObject;

        /**
         * Creates a new GetMineResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMineResponse
         * @static
         * @param {pond.IGetMineResponse=} [properties] Properties to set
         * @returns {pond.GetMineResponse} GetMineResponse instance
         */
        GetMineResponse.create = function create(properties) {
            return new GetMineResponse(properties);
        };

        /**
         * Creates a GetMineResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMineResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMineResponse} GetMineResponse
         */
        GetMineResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMineResponse)
                return object;
            var message = new $root.pond.GetMineResponse();
            if (object.mine != null) {
                if (typeof object.mine !== "object")
                    throw TypeError(".pond.GetMineResponse.mine: object expected");
                message.mine = $root.pond.Mine.fromObject(object.mine);
            }
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GetMineResponse.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i) {
                    if (typeof object.devices[i] !== "object")
                        throw TypeError(".pond.GetMineResponse.devices: object expected");
                    message.devices[i] = $root.pond.Device.fromObject(object.devices[i]);
                }
            }
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.GetMineResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.GetMineResponse.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GetMineResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.componentPreferences) {
                if (typeof object.componentPreferences !== "object")
                    throw TypeError(".pond.GetMineResponse.componentPreferences: object expected");
                message.componentPreferences = {};
                for (var keys = Object.keys(object.componentPreferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.componentPreferences[keys[i]] !== "object")
                        throw TypeError(".pond.GetMineResponse.componentPreferences: object expected");
                    message.componentPreferences[keys[i]] = $root.pond.MineComponentPreferences.fromObject(object.componentPreferences[keys[i]]);
                }
            }
            if (object.componentDevices) {
                if (typeof object.componentDevices !== "object")
                    throw TypeError(".pond.GetMineResponse.componentDevices: object expected");
                message.componentDevices = {};
                for (var keys = Object.keys(object.componentDevices), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.componentDevices[keys[i]] = $util.Long.fromValue(object.componentDevices[keys[i]])).unsigned = true;
                    else if (typeof object.componentDevices[keys[i]] === "string")
                        message.componentDevices[keys[i]] = parseInt(object.componentDevices[keys[i]], 10);
                    else if (typeof object.componentDevices[keys[i]] === "number")
                        message.componentDevices[keys[i]] = object.componentDevices[keys[i]];
                    else if (typeof object.componentDevices[keys[i]] === "object")
                        message.componentDevices[keys[i]] = new $util.LongBits(object.componentDevices[keys[i]].low >>> 0, object.componentDevices[keys[i]].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMineResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMineResponse
         * @static
         * @param {pond.GetMineResponse} message GetMineResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMineResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.devices = [];
                object.components = [];
                object.permissions = [];
            }
            if (options.objects || options.defaults) {
                object.componentPreferences = {};
                object.componentDevices = {};
            }
            if (options.defaults)
                object.mine = null;
            if (message.mine != null && message.hasOwnProperty("mine"))
                object.mine = $root.pond.Mine.toObject(message.mine, options);
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    object.devices[j] = $root.pond.Device.toObject(message.devices[j], options);
            }
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            var keys2;
            if (message.componentPreferences && (keys2 = Object.keys(message.componentPreferences)).length) {
                object.componentPreferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.componentPreferences[keys2[j]] = $root.pond.MineComponentPreferences.toObject(message.componentPreferences[keys2[j]], options);
            }
            if (message.componentDevices && (keys2 = Object.keys(message.componentDevices)).length) {
                object.componentDevices = {};
                for (var j = 0; j < keys2.length; ++j)
                    if (typeof message.componentDevices[keys2[j]] === "number")
                        object.componentDevices[keys2[j]] = options.longs === String ? String(message.componentDevices[keys2[j]]) : message.componentDevices[keys2[j]];
                    else
                        object.componentDevices[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.componentDevices[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.componentDevices[keys2[j]].low >>> 0, message.componentDevices[keys2[j]].high >>> 0).toNumber(true) : message.componentDevices[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this GetMineResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMineResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMineResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMineResponse;
    })();

    pond.GiveMineDeviceRequest = (function() {

        /**
         * Properties of a GiveMineDeviceRequest.
         * @memberof pond
         * @interface IGiveMineDeviceRequest
         * @property {string|null} [mine] GiveMineDeviceRequest mine
         * @property {string|null} [device] GiveMineDeviceRequest device
         * @property {Array.<string>|null} [permissions] GiveMineDeviceRequest permissions
         */

        /**
         * Constructs a new GiveMineDeviceRequest.
         * @memberof pond
         * @classdesc Represents a GiveMineDeviceRequest.
         * @implements IGiveMineDeviceRequest
         * @constructor
         * @param {pond.IGiveMineDeviceRequest=} [properties] Properties to set
         */
        function GiveMineDeviceRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GiveMineDeviceRequest mine.
         * @member {string} mine
         * @memberof pond.GiveMineDeviceRequest
         * @instance
         */
        GiveMineDeviceRequest.prototype.mine = "";

        /**
         * GiveMineDeviceRequest device.
         * @member {string} device
         * @memberof pond.GiveMineDeviceRequest
         * @instance
         */
        GiveMineDeviceRequest.prototype.device = "";

        /**
         * GiveMineDeviceRequest permissions.
         * @member {Array.<string>} permissions
         * @memberof pond.GiveMineDeviceRequest
         * @instance
         */
        GiveMineDeviceRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new GiveMineDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.GiveMineDeviceRequest
         * @static
         * @param {pond.IGiveMineDeviceRequest=} [properties] Properties to set
         * @returns {pond.GiveMineDeviceRequest} GiveMineDeviceRequest instance
         */
        GiveMineDeviceRequest.create = function create(properties) {
            return new GiveMineDeviceRequest(properties);
        };

        /**
         * Creates a GiveMineDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GiveMineDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GiveMineDeviceRequest} GiveMineDeviceRequest
         */
        GiveMineDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GiveMineDeviceRequest)
                return object;
            var message = new $root.pond.GiveMineDeviceRequest();
            if (object.mine != null)
                message.mine = String(object.mine);
            if (object.device != null)
                message.device = String(object.device);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GiveMineDeviceRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    message.permissions[i] = String(object.permissions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GiveMineDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GiveMineDeviceRequest
         * @static
         * @param {pond.GiveMineDeviceRequest} message GiveMineDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GiveMineDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.mine = "";
                object.device = "";
            }
            if (message.mine != null && message.hasOwnProperty("mine"))
                object.mine = message.mine;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this GiveMineDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.GiveMineDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GiveMineDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GiveMineDeviceRequest;
    })();

    pond.GiveMineDeviceResponse = (function() {

        /**
         * Properties of a GiveMineDeviceResponse.
         * @memberof pond
         * @interface IGiveMineDeviceResponse
         */

        /**
         * Constructs a new GiveMineDeviceResponse.
         * @memberof pond
         * @classdesc Represents a GiveMineDeviceResponse.
         * @implements IGiveMineDeviceResponse
         * @constructor
         * @param {pond.IGiveMineDeviceResponse=} [properties] Properties to set
         */
        function GiveMineDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GiveMineDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.GiveMineDeviceResponse
         * @static
         * @param {pond.IGiveMineDeviceResponse=} [properties] Properties to set
         * @returns {pond.GiveMineDeviceResponse} GiveMineDeviceResponse instance
         */
        GiveMineDeviceResponse.create = function create(properties) {
            return new GiveMineDeviceResponse(properties);
        };

        /**
         * Creates a GiveMineDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GiveMineDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GiveMineDeviceResponse} GiveMineDeviceResponse
         */
        GiveMineDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GiveMineDeviceResponse)
                return object;
            return new $root.pond.GiveMineDeviceResponse();
        };

        /**
         * Creates a plain object from a GiveMineDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GiveMineDeviceResponse
         * @static
         * @param {pond.GiveMineDeviceResponse} message GiveMineDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GiveMineDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GiveMineDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.GiveMineDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GiveMineDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GiveMineDeviceResponse;
    })();

    pond.GiveMineComponentRequest = (function() {

        /**
         * Properties of a GiveMineComponentRequest.
         * @memberof pond
         * @interface IGiveMineComponentRequest
         * @property {string|null} [mine] GiveMineComponentRequest mine
         * @property {string|null} [device] GiveMineComponentRequest device
         * @property {string|null} [component] GiveMineComponentRequest component
         * @property {Array.<string>|null} [permissions] GiveMineComponentRequest permissions
         */

        /**
         * Constructs a new GiveMineComponentRequest.
         * @memberof pond
         * @classdesc Represents a GiveMineComponentRequest.
         * @implements IGiveMineComponentRequest
         * @constructor
         * @param {pond.IGiveMineComponentRequest=} [properties] Properties to set
         */
        function GiveMineComponentRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GiveMineComponentRequest mine.
         * @member {string} mine
         * @memberof pond.GiveMineComponentRequest
         * @instance
         */
        GiveMineComponentRequest.prototype.mine = "";

        /**
         * GiveMineComponentRequest device.
         * @member {string} device
         * @memberof pond.GiveMineComponentRequest
         * @instance
         */
        GiveMineComponentRequest.prototype.device = "";

        /**
         * GiveMineComponentRequest component.
         * @member {string} component
         * @memberof pond.GiveMineComponentRequest
         * @instance
         */
        GiveMineComponentRequest.prototype.component = "";

        /**
         * GiveMineComponentRequest permissions.
         * @member {Array.<string>} permissions
         * @memberof pond.GiveMineComponentRequest
         * @instance
         */
        GiveMineComponentRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new GiveMineComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.GiveMineComponentRequest
         * @static
         * @param {pond.IGiveMineComponentRequest=} [properties] Properties to set
         * @returns {pond.GiveMineComponentRequest} GiveMineComponentRequest instance
         */
        GiveMineComponentRequest.create = function create(properties) {
            return new GiveMineComponentRequest(properties);
        };

        /**
         * Creates a GiveMineComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GiveMineComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GiveMineComponentRequest} GiveMineComponentRequest
         */
        GiveMineComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GiveMineComponentRequest)
                return object;
            var message = new $root.pond.GiveMineComponentRequest();
            if (object.mine != null)
                message.mine = String(object.mine);
            if (object.device != null)
                message.device = String(object.device);
            if (object.component != null)
                message.component = String(object.component);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GiveMineComponentRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    message.permissions[i] = String(object.permissions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GiveMineComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GiveMineComponentRequest
         * @static
         * @param {pond.GiveMineComponentRequest} message GiveMineComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GiveMineComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.mine = "";
                object.device = "";
                object.component = "";
            }
            if (message.mine != null && message.hasOwnProperty("mine"))
                object.mine = message.mine;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this GiveMineComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.GiveMineComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GiveMineComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GiveMineComponentRequest;
    })();

    pond.GiveMineComponentResponse = (function() {

        /**
         * Properties of a GiveMineComponentResponse.
         * @memberof pond
         * @interface IGiveMineComponentResponse
         */

        /**
         * Constructs a new GiveMineComponentResponse.
         * @memberof pond
         * @classdesc Represents a GiveMineComponentResponse.
         * @implements IGiveMineComponentResponse
         * @constructor
         * @param {pond.IGiveMineComponentResponse=} [properties] Properties to set
         */
        function GiveMineComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GiveMineComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.GiveMineComponentResponse
         * @static
         * @param {pond.IGiveMineComponentResponse=} [properties] Properties to set
         * @returns {pond.GiveMineComponentResponse} GiveMineComponentResponse instance
         */
        GiveMineComponentResponse.create = function create(properties) {
            return new GiveMineComponentResponse(properties);
        };

        /**
         * Creates a GiveMineComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GiveMineComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GiveMineComponentResponse} GiveMineComponentResponse
         */
        GiveMineComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GiveMineComponentResponse)
                return object;
            return new $root.pond.GiveMineComponentResponse();
        };

        /**
         * Creates a plain object from a GiveMineComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GiveMineComponentResponse
         * @static
         * @param {pond.GiveMineComponentResponse} message GiveMineComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GiveMineComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GiveMineComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.GiveMineComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GiveMineComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GiveMineComponentResponse;
    })();

    pond.ListMinesRequest = (function() {

        /**
         * Properties of a ListMinesRequest.
         * @memberof pond
         * @interface IListMinesRequest
         * @property {pond.Paging|null} [paging] ListMinesRequest paging
         * @property {pond.Sorting|null} [sorting] ListMinesRequest sorting
         * @property {string|null} [search] ListMinesRequest search
         * @property {Object.<string,string>|null} [fieldContains] ListMinesRequest fieldContains
         * @property {boolean|null} [asRoot] ListMinesRequest asRoot
         */

        /**
         * Constructs a new ListMinesRequest.
         * @memberof pond
         * @classdesc Represents a ListMinesRequest.
         * @implements IListMinesRequest
         * @constructor
         * @param {pond.IListMinesRequest=} [properties] Properties to set
         */
        function ListMinesRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMinesRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListMinesRequest
         * @instance
         */
        ListMinesRequest.prototype.paging = null;

        /**
         * ListMinesRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListMinesRequest
         * @instance
         */
        ListMinesRequest.prototype.sorting = null;

        /**
         * ListMinesRequest search.
         * @member {string} search
         * @memberof pond.ListMinesRequest
         * @instance
         */
        ListMinesRequest.prototype.search = "";

        /**
         * ListMinesRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListMinesRequest
         * @instance
         */
        ListMinesRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListMinesRequest asRoot.
         * @member {boolean} asRoot
         * @memberof pond.ListMinesRequest
         * @instance
         */
        ListMinesRequest.prototype.asRoot = false;

        /**
         * Creates a new ListMinesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListMinesRequest
         * @static
         * @param {pond.IListMinesRequest=} [properties] Properties to set
         * @returns {pond.ListMinesRequest} ListMinesRequest instance
         */
        ListMinesRequest.create = function create(properties) {
            return new ListMinesRequest(properties);
        };

        /**
         * Creates a ListMinesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMinesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMinesRequest} ListMinesRequest
         */
        ListMinesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMinesRequest)
                return object;
            var message = new $root.pond.ListMinesRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListMinesRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListMinesRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListMinesRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.asRoot != null)
                message.asRoot = Boolean(object.asRoot);
            return message;
        };

        /**
         * Creates a plain object from a ListMinesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMinesRequest
         * @static
         * @param {pond.ListMinesRequest} message ListMinesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMinesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.asRoot = false;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.asRoot != null && message.hasOwnProperty("asRoot"))
                object.asRoot = message.asRoot;
            return object;
        };

        /**
         * Converts this ListMinesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListMinesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMinesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMinesRequest;
    })();

    pond.ListMinesSimpleRequest = (function() {

        /**
         * Properties of a ListMinesSimpleRequest.
         * @memberof pond
         * @interface IListMinesSimpleRequest
         * @property {pond.Paging|null} [paging] ListMinesSimpleRequest paging
         * @property {pond.Sorting|null} [sorting] ListMinesSimpleRequest sorting
         * @property {string|null} [search] ListMinesSimpleRequest search
         * @property {Object.<string,string>|null} [fieldContains] ListMinesSimpleRequest fieldContains
         * @property {boolean|null} [asRoot] ListMinesSimpleRequest asRoot
         */

        /**
         * Constructs a new ListMinesSimpleRequest.
         * @memberof pond
         * @classdesc Represents a ListMinesSimpleRequest.
         * @implements IListMinesSimpleRequest
         * @constructor
         * @param {pond.IListMinesSimpleRequest=} [properties] Properties to set
         */
        function ListMinesSimpleRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMinesSimpleRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         */
        ListMinesSimpleRequest.prototype.paging = null;

        /**
         * ListMinesSimpleRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         */
        ListMinesSimpleRequest.prototype.sorting = null;

        /**
         * ListMinesSimpleRequest search.
         * @member {string} search
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         */
        ListMinesSimpleRequest.prototype.search = "";

        /**
         * ListMinesSimpleRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         */
        ListMinesSimpleRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListMinesSimpleRequest asRoot.
         * @member {boolean} asRoot
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         */
        ListMinesSimpleRequest.prototype.asRoot = false;

        /**
         * Creates a new ListMinesSimpleRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListMinesSimpleRequest
         * @static
         * @param {pond.IListMinesSimpleRequest=} [properties] Properties to set
         * @returns {pond.ListMinesSimpleRequest} ListMinesSimpleRequest instance
         */
        ListMinesSimpleRequest.create = function create(properties) {
            return new ListMinesSimpleRequest(properties);
        };

        /**
         * Creates a ListMinesSimpleRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMinesSimpleRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMinesSimpleRequest} ListMinesSimpleRequest
         */
        ListMinesSimpleRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMinesSimpleRequest)
                return object;
            var message = new $root.pond.ListMinesSimpleRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListMinesSimpleRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListMinesSimpleRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListMinesSimpleRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.asRoot != null)
                message.asRoot = Boolean(object.asRoot);
            return message;
        };

        /**
         * Creates a plain object from a ListMinesSimpleRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMinesSimpleRequest
         * @static
         * @param {pond.ListMinesSimpleRequest} message ListMinesSimpleRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMinesSimpleRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.asRoot = false;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.asRoot != null && message.hasOwnProperty("asRoot"))
                object.asRoot = message.asRoot;
            return object;
        };

        /**
         * Converts this ListMinesSimpleRequest to JSON.
         * @function toJSON
         * @memberof pond.ListMinesSimpleRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMinesSimpleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMinesSimpleRequest;
    })();

    pond.ListMinesResponse = (function() {

        /**
         * Properties of a ListMinesResponse.
         * @memberof pond
         * @interface IListMinesResponse
         * @property {Array.<pond.Mine>|null} [mines] ListMinesResponse mines
         * @property {number|null} [nextOffset] ListMinesResponse nextOffset
         * @property {number|null} [total] ListMinesResponse total
         */

        /**
         * Constructs a new ListMinesResponse.
         * @memberof pond
         * @classdesc Represents a ListMinesResponse.
         * @implements IListMinesResponse
         * @constructor
         * @param {pond.IListMinesResponse=} [properties] Properties to set
         */
        function ListMinesResponse(properties) {
            this.mines = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMinesResponse mines.
         * @member {Array.<pond.Mine>} mines
         * @memberof pond.ListMinesResponse
         * @instance
         */
        ListMinesResponse.prototype.mines = $util.emptyArray;

        /**
         * ListMinesResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListMinesResponse
         * @instance
         */
        ListMinesResponse.prototype.nextOffset = 0;

        /**
         * ListMinesResponse total.
         * @member {number} total
         * @memberof pond.ListMinesResponse
         * @instance
         */
        ListMinesResponse.prototype.total = 0;

        /**
         * Creates a new ListMinesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListMinesResponse
         * @static
         * @param {pond.IListMinesResponse=} [properties] Properties to set
         * @returns {pond.ListMinesResponse} ListMinesResponse instance
         */
        ListMinesResponse.create = function create(properties) {
            return new ListMinesResponse(properties);
        };

        /**
         * Creates a ListMinesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMinesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMinesResponse} ListMinesResponse
         */
        ListMinesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMinesResponse)
                return object;
            var message = new $root.pond.ListMinesResponse();
            if (object.mines) {
                if (!Array.isArray(object.mines))
                    throw TypeError(".pond.ListMinesResponse.mines: array expected");
                message.mines = [];
                for (var i = 0; i < object.mines.length; ++i) {
                    if (typeof object.mines[i] !== "object")
                        throw TypeError(".pond.ListMinesResponse.mines: object expected");
                    message.mines[i] = $root.pond.Mine.fromObject(object.mines[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListMinesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMinesResponse
         * @static
         * @param {pond.ListMinesResponse} message ListMinesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMinesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mines = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.mines && message.mines.length) {
                object.mines = [];
                for (var j = 0; j < message.mines.length; ++j)
                    object.mines[j] = $root.pond.Mine.toObject(message.mines[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListMinesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListMinesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMinesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMinesResponse;
    })();

    pond.ListMinesSimpleResponse = (function() {

        /**
         * Properties of a ListMinesSimpleResponse.
         * @memberof pond
         * @interface IListMinesSimpleResponse
         * @property {Array.<pond.MineSimple>|null} [mines] ListMinesSimpleResponse mines
         * @property {number|null} [nextOffset] ListMinesSimpleResponse nextOffset
         * @property {number|null} [total] ListMinesSimpleResponse total
         */

        /**
         * Constructs a new ListMinesSimpleResponse.
         * @memberof pond
         * @classdesc Represents a ListMinesSimpleResponse.
         * @implements IListMinesSimpleResponse
         * @constructor
         * @param {pond.IListMinesSimpleResponse=} [properties] Properties to set
         */
        function ListMinesSimpleResponse(properties) {
            this.mines = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListMinesSimpleResponse mines.
         * @member {Array.<pond.MineSimple>} mines
         * @memberof pond.ListMinesSimpleResponse
         * @instance
         */
        ListMinesSimpleResponse.prototype.mines = $util.emptyArray;

        /**
         * ListMinesSimpleResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListMinesSimpleResponse
         * @instance
         */
        ListMinesSimpleResponse.prototype.nextOffset = 0;

        /**
         * ListMinesSimpleResponse total.
         * @member {number} total
         * @memberof pond.ListMinesSimpleResponse
         * @instance
         */
        ListMinesSimpleResponse.prototype.total = 0;

        /**
         * Creates a new ListMinesSimpleResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListMinesSimpleResponse
         * @static
         * @param {pond.IListMinesSimpleResponse=} [properties] Properties to set
         * @returns {pond.ListMinesSimpleResponse} ListMinesSimpleResponse instance
         */
        ListMinesSimpleResponse.create = function create(properties) {
            return new ListMinesSimpleResponse(properties);
        };

        /**
         * Creates a ListMinesSimpleResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListMinesSimpleResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListMinesSimpleResponse} ListMinesSimpleResponse
         */
        ListMinesSimpleResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListMinesSimpleResponse)
                return object;
            var message = new $root.pond.ListMinesSimpleResponse();
            if (object.mines) {
                if (!Array.isArray(object.mines))
                    throw TypeError(".pond.ListMinesSimpleResponse.mines: array expected");
                message.mines = [];
                for (var i = 0; i < object.mines.length; ++i) {
                    if (typeof object.mines[i] !== "object")
                        throw TypeError(".pond.ListMinesSimpleResponse.mines: object expected");
                    message.mines[i] = $root.pond.MineSimple.fromObject(object.mines[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListMinesSimpleResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListMinesSimpleResponse
         * @static
         * @param {pond.ListMinesSimpleResponse} message ListMinesSimpleResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListMinesSimpleResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mines = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.mines && message.mines.length) {
                object.mines = [];
                for (var j = 0; j < message.mines.length; ++j)
                    object.mines[j] = $root.pond.MineSimple.toObject(message.mines[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListMinesSimpleResponse to JSON.
         * @function toJSON
         * @memberof pond.ListMinesSimpleResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListMinesSimpleResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListMinesSimpleResponse;
    })();

    pond.UpdateMineRequest = (function() {

        /**
         * Properties of an UpdateMineRequest.
         * @memberof pond
         * @interface IUpdateMineRequest
         * @property {pond.MineSettings|null} [settings] UpdateMineRequest settings
         * @property {pond.MineComponentPreferencesContainer|null} [componentPreferences] UpdateMineRequest componentPreferences
         */

        /**
         * Constructs a new UpdateMineRequest.
         * @memberof pond
         * @classdesc Represents an UpdateMineRequest.
         * @implements IUpdateMineRequest
         * @constructor
         * @param {pond.IUpdateMineRequest=} [properties] Properties to set
         */
        function UpdateMineRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateMineRequest settings.
         * @member {pond.MineSettings|null|undefined} settings
         * @memberof pond.UpdateMineRequest
         * @instance
         */
        UpdateMineRequest.prototype.settings = null;

        /**
         * UpdateMineRequest componentPreferences.
         * @member {pond.MineComponentPreferencesContainer|null|undefined} componentPreferences
         * @memberof pond.UpdateMineRequest
         * @instance
         */
        UpdateMineRequest.prototype.componentPreferences = null;

        /**
         * Creates a new UpdateMineRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateMineRequest
         * @static
         * @param {pond.IUpdateMineRequest=} [properties] Properties to set
         * @returns {pond.UpdateMineRequest} UpdateMineRequest instance
         */
        UpdateMineRequest.create = function create(properties) {
            return new UpdateMineRequest(properties);
        };

        /**
         * Creates an UpdateMineRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateMineRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateMineRequest} UpdateMineRequest
         */
        UpdateMineRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateMineRequest)
                return object;
            var message = new $root.pond.UpdateMineRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateMineRequest.settings: object expected");
                message.settings = $root.pond.MineSettings.fromObject(object.settings);
            }
            if (object.componentPreferences != null) {
                if (typeof object.componentPreferences !== "object")
                    throw TypeError(".pond.UpdateMineRequest.componentPreferences: object expected");
                message.componentPreferences = $root.pond.MineComponentPreferencesContainer.fromObject(object.componentPreferences);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateMineRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateMineRequest
         * @static
         * @param {pond.UpdateMineRequest} message UpdateMineRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateMineRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.componentPreferences = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.MineSettings.toObject(message.settings, options);
            if (message.componentPreferences != null && message.hasOwnProperty("componentPreferences"))
                object.componentPreferences = $root.pond.MineComponentPreferencesContainer.toObject(message.componentPreferences, options);
            return object;
        };

        /**
         * Converts this UpdateMineRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateMineRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateMineRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateMineRequest;
    })();

    pond.UpdateMineResponse = (function() {

        /**
         * Properties of an UpdateMineResponse.
         * @memberof pond
         * @interface IUpdateMineResponse
         */

        /**
         * Constructs a new UpdateMineResponse.
         * @memberof pond
         * @classdesc Represents an UpdateMineResponse.
         * @implements IUpdateMineResponse
         * @constructor
         * @param {pond.IUpdateMineResponse=} [properties] Properties to set
         */
        function UpdateMineResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateMineResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateMineResponse
         * @static
         * @param {pond.IUpdateMineResponse=} [properties] Properties to set
         * @returns {pond.UpdateMineResponse} UpdateMineResponse instance
         */
        UpdateMineResponse.create = function create(properties) {
            return new UpdateMineResponse(properties);
        };

        /**
         * Creates an UpdateMineResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateMineResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateMineResponse} UpdateMineResponse
         */
        UpdateMineResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateMineResponse)
                return object;
            return new $root.pond.UpdateMineResponse();
        };

        /**
         * Creates a plain object from an UpdateMineResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateMineResponse
         * @static
         * @param {pond.UpdateMineResponse} message UpdateMineResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateMineResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateMineResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateMineResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateMineResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateMineResponse;
    })();

    pond.RemoveMineRequest = (function() {

        /**
         * Properties of a RemoveMineRequest.
         * @memberof pond
         * @interface IRemoveMineRequest
         * @property {string|null} [key] RemoveMineRequest key
         */

        /**
         * Constructs a new RemoveMineRequest.
         * @memberof pond
         * @classdesc Represents a RemoveMineRequest.
         * @implements IRemoveMineRequest
         * @constructor
         * @param {pond.IRemoveMineRequest=} [properties] Properties to set
         */
        function RemoveMineRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveMineRequest key.
         * @member {string} key
         * @memberof pond.RemoveMineRequest
         * @instance
         */
        RemoveMineRequest.prototype.key = "";

        /**
         * Creates a new RemoveMineRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveMineRequest
         * @static
         * @param {pond.IRemoveMineRequest=} [properties] Properties to set
         * @returns {pond.RemoveMineRequest} RemoveMineRequest instance
         */
        RemoveMineRequest.create = function create(properties) {
            return new RemoveMineRequest(properties);
        };

        /**
         * Creates a RemoveMineRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveMineRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveMineRequest} RemoveMineRequest
         */
        RemoveMineRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveMineRequest)
                return object;
            var message = new $root.pond.RemoveMineRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveMineRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveMineRequest
         * @static
         * @param {pond.RemoveMineRequest} message RemoveMineRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveMineRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveMineRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveMineRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveMineRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveMineRequest;
    })();

    pond.RemoveMineResponse = (function() {

        /**
         * Properties of a RemoveMineResponse.
         * @memberof pond
         * @interface IRemoveMineResponse
         * @property {boolean|null} [success] RemoveMineResponse success
         */

        /**
         * Constructs a new RemoveMineResponse.
         * @memberof pond
         * @classdesc Represents a RemoveMineResponse.
         * @implements IRemoveMineResponse
         * @constructor
         * @param {pond.IRemoveMineResponse=} [properties] Properties to set
         */
        function RemoveMineResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveMineResponse success.
         * @member {boolean} success
         * @memberof pond.RemoveMineResponse
         * @instance
         */
        RemoveMineResponse.prototype.success = false;

        /**
         * Creates a new RemoveMineResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveMineResponse
         * @static
         * @param {pond.IRemoveMineResponse=} [properties] Properties to set
         * @returns {pond.RemoveMineResponse} RemoveMineResponse instance
         */
        RemoveMineResponse.create = function create(properties) {
            return new RemoveMineResponse(properties);
        };

        /**
         * Creates a RemoveMineResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveMineResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveMineResponse} RemoveMineResponse
         */
        RemoveMineResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveMineResponse)
                return object;
            var message = new $root.pond.RemoveMineResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from a RemoveMineResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveMineResponse
         * @static
         * @param {pond.RemoveMineResponse} message RemoveMineResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveMineResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this RemoveMineResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveMineResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveMineResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveMineResponse;
    })();

    pond.Mine = (function() {

        /**
         * Properties of a Mine.
         * @memberof pond
         * @interface IMine
         * @property {pond.MineSettings|null} [settings] Mine settings
         * @property {pond.MineStatus|null} [status] Mine status
         */

        /**
         * Constructs a new Mine.
         * @memberof pond
         * @classdesc Represents a Mine.
         * @implements IMine
         * @constructor
         * @param {pond.IMine=} [properties] Properties to set
         */
        function Mine(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Mine settings.
         * @member {pond.MineSettings|null|undefined} settings
         * @memberof pond.Mine
         * @instance
         */
        Mine.prototype.settings = null;

        /**
         * Mine status.
         * @member {pond.MineStatus|null|undefined} status
         * @memberof pond.Mine
         * @instance
         */
        Mine.prototype.status = null;

        /**
         * Creates a new Mine instance using the specified properties.
         * @function create
         * @memberof pond.Mine
         * @static
         * @param {pond.IMine=} [properties] Properties to set
         * @returns {pond.Mine} Mine instance
         */
        Mine.create = function create(properties) {
            return new Mine(properties);
        };

        /**
         * Creates a Mine message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Mine
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Mine} Mine
         */
        Mine.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Mine)
                return object;
            var message = new $root.pond.Mine();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Mine.settings: object expected");
                message.settings = $root.pond.MineSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Mine.status: object expected");
                message.status = $root.pond.MineStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Mine message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Mine
         * @static
         * @param {pond.Mine} message Mine
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Mine.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.MineSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.MineStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Mine to JSON.
         * @function toJSON
         * @memberof pond.Mine
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Mine.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Mine;
    })();

    pond.MineSimple = (function() {

        /**
         * Properties of a MineSimple.
         * @memberof pond
         * @interface IMineSimple
         * @property {string|null} [key] MineSimple key
         * @property {string|null} [name] MineSimple name
         */

        /**
         * Constructs a new MineSimple.
         * @memberof pond
         * @classdesc Represents a MineSimple.
         * @implements IMineSimple
         * @constructor
         * @param {pond.IMineSimple=} [properties] Properties to set
         */
        function MineSimple(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineSimple key.
         * @member {string} key
         * @memberof pond.MineSimple
         * @instance
         */
        MineSimple.prototype.key = "";

        /**
         * MineSimple name.
         * @member {string} name
         * @memberof pond.MineSimple
         * @instance
         */
        MineSimple.prototype.name = "";

        /**
         * Creates a new MineSimple instance using the specified properties.
         * @function create
         * @memberof pond.MineSimple
         * @static
         * @param {pond.IMineSimple=} [properties] Properties to set
         * @returns {pond.MineSimple} MineSimple instance
         */
        MineSimple.create = function create(properties) {
            return new MineSimple(properties);
        };

        /**
         * Creates a MineSimple message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineSimple
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineSimple} MineSimple
         */
        MineSimple.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineSimple)
                return object;
            var message = new $root.pond.MineSimple();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a MineSimple message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineSimple
         * @static
         * @param {pond.MineSimple} message MineSimple
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineSimple.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this MineSimple to JSON.
         * @function toJSON
         * @memberof pond.MineSimple
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineSimple.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineSimple;
    })();

    pond.MineSettings = (function() {

        /**
         * Properties of a MineSettings.
         * @memberof pond
         * @interface IMineSettings
         * @property {string|null} [key] MineSettings key
         * @property {Array.<pond.Placeable>|null} [placeables] MineSettings placeables
         * @property {Array.<number>|null} [devices] MineSettings devices
         * @property {Array.<pond.MineSensor>|null} [sensors] MineSettings sensors
         * @property {string|null} [name] MineSettings name
         */

        /**
         * Constructs a new MineSettings.
         * @memberof pond
         * @classdesc Represents a MineSettings.
         * @implements IMineSettings
         * @constructor
         * @param {pond.IMineSettings=} [properties] Properties to set
         */
        function MineSettings(properties) {
            this.placeables = [];
            this.devices = [];
            this.sensors = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineSettings key.
         * @member {string} key
         * @memberof pond.MineSettings
         * @instance
         */
        MineSettings.prototype.key = "";

        /**
         * MineSettings placeables.
         * @member {Array.<pond.Placeable>} placeables
         * @memberof pond.MineSettings
         * @instance
         */
        MineSettings.prototype.placeables = $util.emptyArray;

        /**
         * MineSettings devices.
         * @member {Array.<number>} devices
         * @memberof pond.MineSettings
         * @instance
         */
        MineSettings.prototype.devices = $util.emptyArray;

        /**
         * MineSettings sensors.
         * @member {Array.<pond.MineSensor>} sensors
         * @memberof pond.MineSettings
         * @instance
         */
        MineSettings.prototype.sensors = $util.emptyArray;

        /**
         * MineSettings name.
         * @member {string} name
         * @memberof pond.MineSettings
         * @instance
         */
        MineSettings.prototype.name = "";

        /**
         * Creates a new MineSettings instance using the specified properties.
         * @function create
         * @memberof pond.MineSettings
         * @static
         * @param {pond.IMineSettings=} [properties] Properties to set
         * @returns {pond.MineSettings} MineSettings instance
         */
        MineSettings.create = function create(properties) {
            return new MineSettings(properties);
        };

        /**
         * Creates a MineSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineSettings} MineSettings
         */
        MineSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineSettings)
                return object;
            var message = new $root.pond.MineSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.placeables) {
                if (!Array.isArray(object.placeables))
                    throw TypeError(".pond.MineSettings.placeables: array expected");
                message.placeables = [];
                for (var i = 0; i < object.placeables.length; ++i) {
                    if (typeof object.placeables[i] !== "object")
                        throw TypeError(".pond.MineSettings.placeables: object expected");
                    message.placeables[i] = $root.pond.Placeable.fromObject(object.placeables[i]);
                }
            }
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.MineSettings.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i)
                    if ($util.Long)
                        (message.devices[i] = $util.Long.fromValue(object.devices[i])).unsigned = true;
                    else if (typeof object.devices[i] === "string")
                        message.devices[i] = parseInt(object.devices[i], 10);
                    else if (typeof object.devices[i] === "number")
                        message.devices[i] = object.devices[i];
                    else if (typeof object.devices[i] === "object")
                        message.devices[i] = new $util.LongBits(object.devices[i].low >>> 0, object.devices[i].high >>> 0).toNumber(true);
            }
            if (object.sensors) {
                if (!Array.isArray(object.sensors))
                    throw TypeError(".pond.MineSettings.sensors: array expected");
                message.sensors = [];
                for (var i = 0; i < object.sensors.length; ++i) {
                    if (typeof object.sensors[i] !== "object")
                        throw TypeError(".pond.MineSettings.sensors: object expected");
                    message.sensors[i] = $root.pond.MineSensor.fromObject(object.sensors[i]);
                }
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a MineSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineSettings
         * @static
         * @param {pond.MineSettings} message MineSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.placeables = [];
                object.devices = [];
                object.sensors = [];
            }
            if (options.defaults) {
                object.key = "";
                object.name = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.placeables && message.placeables.length) {
                object.placeables = [];
                for (var j = 0; j < message.placeables.length; ++j)
                    object.placeables[j] = $root.pond.Placeable.toObject(message.placeables[j], options);
            }
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    if (typeof message.devices[j] === "number")
                        object.devices[j] = options.longs === String ? String(message.devices[j]) : message.devices[j];
                    else
                        object.devices[j] = options.longs === String ? $util.Long.prototype.toString.call(message.devices[j]) : options.longs === Number ? new $util.LongBits(message.devices[j].low >>> 0, message.devices[j].high >>> 0).toNumber(true) : message.devices[j];
            }
            if (message.sensors && message.sensors.length) {
                object.sensors = [];
                for (var j = 0; j < message.sensors.length; ++j)
                    object.sensors[j] = $root.pond.MineSensor.toObject(message.sensors[j], options);
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this MineSettings to JSON.
         * @function toJSON
         * @memberof pond.MineSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineSettings;
    })();

    pond.MineStatus = (function() {

        /**
         * Properties of a MineStatus.
         * @memberof pond
         * @interface IMineStatus
         */

        /**
         * Constructs a new MineStatus.
         * @memberof pond
         * @classdesc Represents a MineStatus.
         * @implements IMineStatus
         * @constructor
         * @param {pond.IMineStatus=} [properties] Properties to set
         */
        function MineStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new MineStatus instance using the specified properties.
         * @function create
         * @memberof pond.MineStatus
         * @static
         * @param {pond.IMineStatus=} [properties] Properties to set
         * @returns {pond.MineStatus} MineStatus instance
         */
        MineStatus.create = function create(properties) {
            return new MineStatus(properties);
        };

        /**
         * Creates a MineStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineStatus} MineStatus
         */
        MineStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineStatus)
                return object;
            return new $root.pond.MineStatus();
        };

        /**
         * Creates a plain object from a MineStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineStatus
         * @static
         * @param {pond.MineStatus} message MineStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this MineStatus to JSON.
         * @function toJSON
         * @memberof pond.MineStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineStatus;
    })();

    pond.MineSensor = (function() {

        /**
         * Properties of a MineSensor.
         * @memberof pond
         * @interface IMineSensor
         * @property {number|null} [x] MineSensor x
         * @property {number|null} [y] MineSensor y
         * @property {string|null} [componentKey] MineSensor componentKey
         * @property {number|null} [index] MineSensor index
         */

        /**
         * Constructs a new MineSensor.
         * @memberof pond
         * @classdesc Represents a MineSensor.
         * @implements IMineSensor
         * @constructor
         * @param {pond.IMineSensor=} [properties] Properties to set
         */
        function MineSensor(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MineSensor x.
         * @member {number} x
         * @memberof pond.MineSensor
         * @instance
         */
        MineSensor.prototype.x = 0;

        /**
         * MineSensor y.
         * @member {number} y
         * @memberof pond.MineSensor
         * @instance
         */
        MineSensor.prototype.y = 0;

        /**
         * MineSensor componentKey.
         * @member {string} componentKey
         * @memberof pond.MineSensor
         * @instance
         */
        MineSensor.prototype.componentKey = "";

        /**
         * MineSensor index.
         * @member {number} index
         * @memberof pond.MineSensor
         * @instance
         */
        MineSensor.prototype.index = 0;

        /**
         * Creates a new MineSensor instance using the specified properties.
         * @function create
         * @memberof pond.MineSensor
         * @static
         * @param {pond.IMineSensor=} [properties] Properties to set
         * @returns {pond.MineSensor} MineSensor instance
         */
        MineSensor.create = function create(properties) {
            return new MineSensor(properties);
        };

        /**
         * Creates a MineSensor message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.MineSensor
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.MineSensor} MineSensor
         */
        MineSensor.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.MineSensor)
                return object;
            var message = new $root.pond.MineSensor();
            if (object.x != null)
                message.x = Number(object.x);
            if (object.y != null)
                message.y = Number(object.y);
            if (object.componentKey != null)
                message.componentKey = String(object.componentKey);
            if (object.index != null)
                message.index = object.index >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a MineSensor message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.MineSensor
         * @static
         * @param {pond.MineSensor} message MineSensor
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MineSensor.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.x = 0;
                object.y = 0;
                object.componentKey = "";
                object.index = 0;
            }
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
            if (message.componentKey != null && message.hasOwnProperty("componentKey"))
                object.componentKey = message.componentKey;
            if (message.index != null && message.hasOwnProperty("index"))
                object.index = message.index;
            return object;
        };

        /**
         * Converts this MineSensor to JSON.
         * @function toJSON
         * @memberof pond.MineSensor
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MineSensor.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MineSensor;
    })();

    pond.Placeable = (function() {

        /**
         * Properties of a Placeable.
         * @memberof pond
         * @interface IPlaceable
         * @property {number|null} [x] Placeable x
         * @property {number|null} [y] Placeable y
         * @property {number|null} [angle] Placeable angle
         * @property {number|null} [width] Placeable width
         * @property {number|null} [radius] Placeable radius
         * @property {number|null} [magnitude] Placeable magnitude
         * @property {number|null} [direction] Placeable direction
         * @property {pond.PlaceableType|null} [type] Placeable type
         * @property {number|null} [subtype] Placeable subtype
         */

        /**
         * Constructs a new Placeable.
         * @memberof pond
         * @classdesc Represents a Placeable.
         * @implements IPlaceable
         * @constructor
         * @param {pond.IPlaceable=} [properties] Properties to set
         */
        function Placeable(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Placeable x.
         * @member {number} x
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.x = 0;

        /**
         * Placeable y.
         * @member {number} y
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.y = 0;

        /**
         * Placeable angle.
         * @member {number} angle
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.angle = 0;

        /**
         * Placeable width.
         * @member {number} width
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.width = 0;

        /**
         * Placeable radius.
         * @member {number} radius
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.radius = 0;

        /**
         * Placeable magnitude.
         * @member {number} magnitude
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.magnitude = 0;

        /**
         * Placeable direction.
         * @member {number} direction
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.direction = 0;

        /**
         * Placeable type.
         * @member {pond.PlaceableType} type
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.type = 0;

        /**
         * Placeable subtype.
         * @member {number} subtype
         * @memberof pond.Placeable
         * @instance
         */
        Placeable.prototype.subtype = 0;

        /**
         * Creates a new Placeable instance using the specified properties.
         * @function create
         * @memberof pond.Placeable
         * @static
         * @param {pond.IPlaceable=} [properties] Properties to set
         * @returns {pond.Placeable} Placeable instance
         */
        Placeable.create = function create(properties) {
            return new Placeable(properties);
        };

        /**
         * Creates a Placeable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Placeable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Placeable} Placeable
         */
        Placeable.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Placeable)
                return object;
            var message = new $root.pond.Placeable();
            if (object.x != null)
                message.x = Number(object.x);
            if (object.y != null)
                message.y = Number(object.y);
            if (object.angle != null)
                message.angle = Number(object.angle);
            if (object.width != null)
                message.width = Number(object.width);
            if (object.radius != null)
                message.radius = Number(object.radius);
            if (object.magnitude != null)
                message.magnitude = Number(object.magnitude);
            if (object.direction != null)
                message.direction = object.direction | 0;
            switch (object.type) {
            case "PLACEABLE_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "PLACEABLE_TYPE_DEFAULT":
            case 1:
                message.type = 1;
                break;
            case "PLACEABLE_TYPE_FAN":
            case 2:
                message.type = 2;
                break;
            case "PLACEABLE_TYPE_SHAFT":
            case 3:
                message.type = 3;
                break;
            case "PLACEABLE_TYPE_SENSOR":
            case 4:
                message.type = 4;
                break;
            }
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Placeable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Placeable
         * @static
         * @param {pond.Placeable} message Placeable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Placeable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.x = 0;
                object.y = 0;
                object.angle = 0;
                object.width = 0;
                object.radius = 0;
                object.magnitude = 0;
                object.direction = 0;
                object.type = options.enums === String ? "PLACEABLE_TYPE_INVALID" : 0;
                object.subtype = 0;
            }
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
            if (message.angle != null && message.hasOwnProperty("angle"))
                object.angle = options.json && !isFinite(message.angle) ? String(message.angle) : message.angle;
            if (message.width != null && message.hasOwnProperty("width"))
                object.width = options.json && !isFinite(message.width) ? String(message.width) : message.width;
            if (message.radius != null && message.hasOwnProperty("radius"))
                object.radius = options.json && !isFinite(message.radius) ? String(message.radius) : message.radius;
            if (message.magnitude != null && message.hasOwnProperty("magnitude"))
                object.magnitude = options.json && !isFinite(message.magnitude) ? String(message.magnitude) : message.magnitude;
            if (message.direction != null && message.hasOwnProperty("direction"))
                object.direction = message.direction;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.PlaceableType[message.type] : message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            return object;
        };

        /**
         * Converts this Placeable to JSON.
         * @function toJSON
         * @memberof pond.Placeable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Placeable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Placeable;
    })();

    /**
     * PlaceableType enum.
     * @name pond.PlaceableType
     * @enum {string}
     * @property {number} PLACEABLE_TYPE_INVALID=0 PLACEABLE_TYPE_INVALID value
     * @property {number} PLACEABLE_TYPE_DEFAULT=1 PLACEABLE_TYPE_DEFAULT value
     * @property {number} PLACEABLE_TYPE_FAN=2 PLACEABLE_TYPE_FAN value
     * @property {number} PLACEABLE_TYPE_SHAFT=3 PLACEABLE_TYPE_SHAFT value
     * @property {number} PLACEABLE_TYPE_SENSOR=4 PLACEABLE_TYPE_SENSOR value
     */
    pond.PlaceableType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PLACEABLE_TYPE_INVALID"] = 0;
        values[valuesById[1] = "PLACEABLE_TYPE_DEFAULT"] = 1;
        values[valuesById[2] = "PLACEABLE_TYPE_FAN"] = 2;
        values[valuesById[3] = "PLACEABLE_TYPE_SHAFT"] = 3;
        values[valuesById[4] = "PLACEABLE_TYPE_SENSOR"] = 4;
        return values;
    })();

    /**
     * ShaftType enum.
     * @name pond.ShaftType
     * @enum {string}
     * @property {number} SHAFT_TYPE_INVALID=0 SHAFT_TYPE_INVALID value
     * @property {number} SHAFT_TYPE_DEFAULT=1 SHAFT_TYPE_DEFAULT value
     * @property {number} SHAFT_TYPE_CORNER=2 SHAFT_TYPE_CORNER value
     * @property {number} SHAFT_TYPE_BEZIER=3 SHAFT_TYPE_BEZIER value
     * @property {number} SHAFT_TYPE_T_BREAK=4 SHAFT_TYPE_T_BREAK value
     * @property {number} SHAFT_TYPE_Y_BREAK=5 SHAFT_TYPE_Y_BREAK value
     */
    pond.ShaftType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SHAFT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "SHAFT_TYPE_DEFAULT"] = 1;
        values[valuesById[2] = "SHAFT_TYPE_CORNER"] = 2;
        values[valuesById[3] = "SHAFT_TYPE_BEZIER"] = 3;
        values[valuesById[4] = "SHAFT_TYPE_T_BREAK"] = 4;
        values[valuesById[5] = "SHAFT_TYPE_Y_BREAK"] = 5;
        return values;
    })();

    pond.Bin = (function() {

        /**
         * Properties of a Bin.
         * @memberof pond
         * @interface IBin
         * @property {pond.BinSettings|null} [settings] Bin settings
         * @property {pond.BinStatus|null} [status] Bin status
         * @property {Array.<pond.Permission>|null} [binPermissions] Bin binPermissions
         */

        /**
         * Constructs a new Bin.
         * @memberof pond
         * @classdesc Represents a Bin.
         * @implements IBin
         * @constructor
         * @param {pond.IBin=} [properties] Properties to set
         */
        function Bin(properties) {
            this.binPermissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Bin settings.
         * @member {pond.BinSettings|null|undefined} settings
         * @memberof pond.Bin
         * @instance
         */
        Bin.prototype.settings = null;

        /**
         * Bin status.
         * @member {pond.BinStatus|null|undefined} status
         * @memberof pond.Bin
         * @instance
         */
        Bin.prototype.status = null;

        /**
         * Bin binPermissions.
         * @member {Array.<pond.Permission>} binPermissions
         * @memberof pond.Bin
         * @instance
         */
        Bin.prototype.binPermissions = $util.emptyArray;

        /**
         * Creates a new Bin instance using the specified properties.
         * @function create
         * @memberof pond.Bin
         * @static
         * @param {pond.IBin=} [properties] Properties to set
         * @returns {pond.Bin} Bin instance
         */
        Bin.create = function create(properties) {
            return new Bin(properties);
        };

        /**
         * Creates a Bin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Bin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Bin} Bin
         */
        Bin.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Bin)
                return object;
            var message = new $root.pond.Bin();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Bin.settings: object expected");
                message.settings = $root.pond.BinSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Bin.status: object expected");
                message.status = $root.pond.BinStatus.fromObject(object.status);
            }
            if (object.binPermissions) {
                if (!Array.isArray(object.binPermissions))
                    throw TypeError(".pond.Bin.binPermissions: array expected");
                message.binPermissions = [];
                for (var i = 0; i < object.binPermissions.length; ++i)
                    switch (object.binPermissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.binPermissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.binPermissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.binPermissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.binPermissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.binPermissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.binPermissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.binPermissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a Bin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Bin
         * @static
         * @param {pond.Bin} message Bin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Bin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.binPermissions = [];
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.BinSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.BinStatus.toObject(message.status, options);
            if (message.binPermissions && message.binPermissions.length) {
                object.binPermissions = [];
                for (var j = 0; j < message.binPermissions.length; ++j)
                    object.binPermissions[j] = options.enums === String ? $root.pond.Permission[message.binPermissions[j]] : message.binPermissions[j];
            }
            return object;
        };

        /**
         * Converts this Bin to JSON.
         * @function toJSON
         * @memberof pond.Bin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Bin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Bin;
    })();

    pond.BinYard = (function() {

        /**
         * Properties of a BinYard.
         * @memberof pond
         * @interface IBinYard
         * @property {string|null} [key] BinYard key
         * @property {pond.BinYardSettings|null} [settings] BinYard settings
         * @property {Array.<pond.Permission>|null} [yardPermissions] BinYard yardPermissions
         */

        /**
         * Constructs a new BinYard.
         * @memberof pond
         * @classdesc Represents a BinYard.
         * @implements IBinYard
         * @constructor
         * @param {pond.IBinYard=} [properties] Properties to set
         */
        function BinYard(properties) {
            this.yardPermissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinYard key.
         * @member {string} key
         * @memberof pond.BinYard
         * @instance
         */
        BinYard.prototype.key = "";

        /**
         * BinYard settings.
         * @member {pond.BinYardSettings|null|undefined} settings
         * @memberof pond.BinYard
         * @instance
         */
        BinYard.prototype.settings = null;

        /**
         * BinYard yardPermissions.
         * @member {Array.<pond.Permission>} yardPermissions
         * @memberof pond.BinYard
         * @instance
         */
        BinYard.prototype.yardPermissions = $util.emptyArray;

        /**
         * Creates a new BinYard instance using the specified properties.
         * @function create
         * @memberof pond.BinYard
         * @static
         * @param {pond.IBinYard=} [properties] Properties to set
         * @returns {pond.BinYard} BinYard instance
         */
        BinYard.create = function create(properties) {
            return new BinYard(properties);
        };

        /**
         * Creates a BinYard message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinYard
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinYard} BinYard
         */
        BinYard.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinYard)
                return object;
            var message = new $root.pond.BinYard();
            if (object.key != null)
                message.key = String(object.key);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.BinYard.settings: object expected");
                message.settings = $root.pond.BinYardSettings.fromObject(object.settings);
            }
            if (object.yardPermissions) {
                if (!Array.isArray(object.yardPermissions))
                    throw TypeError(".pond.BinYard.yardPermissions: array expected");
                message.yardPermissions = [];
                for (var i = 0; i < object.yardPermissions.length; ++i)
                    switch (object.yardPermissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.yardPermissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.yardPermissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.yardPermissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.yardPermissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.yardPermissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.yardPermissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.yardPermissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a BinYard message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinYard
         * @static
         * @param {pond.BinYard} message BinYard
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinYard.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.yardPermissions = [];
            if (options.defaults) {
                object.key = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.BinYardSettings.toObject(message.settings, options);
            if (message.yardPermissions && message.yardPermissions.length) {
                object.yardPermissions = [];
                for (var j = 0; j < message.yardPermissions.length; ++j)
                    object.yardPermissions[j] = options.enums === String ? $root.pond.Permission[message.yardPermissions[j]] : message.yardPermissions[j];
            }
            return object;
        };

        /**
         * Converts this BinYard to JSON.
         * @function toJSON
         * @memberof pond.BinYard
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinYard.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinYard;
    })();

    pond.BinYardSettings = (function() {

        /**
         * Properties of a BinYardSettings.
         * @memberof pond
         * @interface IBinYardSettings
         * @property {string|null} [name] BinYardSettings name
         * @property {string|null} [owner] BinYardSettings owner
         * @property {string|null} [key] BinYardSettings key
         * @property {string|null} [description] BinYardSettings description
         * @property {number|null} [sortPriority] BinYardSettings sortPriority
         * @property {Object.<string,number>|null} [userSort] BinYardSettings userSort
         * @property {number|null} [longitude] BinYardSettings longitude
         * @property {number|null} [latitude] BinYardSettings latitude
         * @property {pond.ObjectTheme|null} [theme] BinYardSettings theme
         */

        /**
         * Constructs a new BinYardSettings.
         * @memberof pond
         * @classdesc Represents a BinYardSettings.
         * @implements IBinYardSettings
         * @constructor
         * @param {pond.IBinYardSettings=} [properties] Properties to set
         */
        function BinYardSettings(properties) {
            this.userSort = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinYardSettings name.
         * @member {string} name
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.name = "";

        /**
         * BinYardSettings owner.
         * @member {string} owner
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.owner = "";

        /**
         * BinYardSettings key.
         * @member {string} key
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.key = "";

        /**
         * BinYardSettings description.
         * @member {string} description
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.description = "";

        /**
         * BinYardSettings sortPriority.
         * @member {number} sortPriority
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.sortPriority = 0;

        /**
         * BinYardSettings userSort.
         * @member {Object.<string,number>} userSort
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.userSort = $util.emptyObject;

        /**
         * BinYardSettings longitude.
         * @member {number} longitude
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.longitude = 0;

        /**
         * BinYardSettings latitude.
         * @member {number} latitude
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.latitude = 0;

        /**
         * BinYardSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.BinYardSettings
         * @instance
         */
        BinYardSettings.prototype.theme = null;

        /**
         * Creates a new BinYardSettings instance using the specified properties.
         * @function create
         * @memberof pond.BinYardSettings
         * @static
         * @param {pond.IBinYardSettings=} [properties] Properties to set
         * @returns {pond.BinYardSettings} BinYardSettings instance
         */
        BinYardSettings.create = function create(properties) {
            return new BinYardSettings(properties);
        };

        /**
         * Creates a BinYardSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinYardSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinYardSettings} BinYardSettings
         */
        BinYardSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinYardSettings)
                return object;
            var message = new $root.pond.BinYardSettings();
            if (object.name != null)
                message.name = String(object.name);
            if (object.owner != null)
                message.owner = String(object.owner);
            if (object.key != null)
                message.key = String(object.key);
            if (object.description != null)
                message.description = String(object.description);
            if (object.sortPriority != null)
                message.sortPriority = object.sortPriority >>> 0;
            if (object.userSort) {
                if (typeof object.userSort !== "object")
                    throw TypeError(".pond.BinYardSettings.userSort: object expected");
                message.userSort = {};
                for (var keys = Object.keys(object.userSort), i = 0; i < keys.length; ++i)
                    message.userSort[keys[i]] = object.userSort[keys[i]] >>> 0;
            }
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.BinYardSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            return message;
        };

        /**
         * Creates a plain object from a BinYardSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinYardSettings
         * @static
         * @param {pond.BinYardSettings} message BinYardSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinYardSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.userSort = {};
            if (options.defaults) {
                object.name = "";
                object.owner = "";
                object.key = "";
                object.description = "";
                object.sortPriority = 0;
                object.longitude = 0;
                object.latitude = 0;
                object.theme = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = message.owner;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.sortPriority != null && message.hasOwnProperty("sortPriority"))
                object.sortPriority = message.sortPriority;
            var keys2;
            if (message.userSort && (keys2 = Object.keys(message.userSort)).length) {
                object.userSort = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.userSort[keys2[j]] = message.userSort[keys2[j]];
            }
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            return object;
        };

        /**
         * Converts this BinYardSettings to JSON.
         * @function toJSON
         * @memberof pond.BinYardSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinYardSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinYardSettings;
    })();

    pond.AddBinYardRequest = (function() {

        /**
         * Properties of an AddBinYardRequest.
         * @memberof pond
         * @interface IAddBinYardRequest
         * @property {pond.BinYardSettings|null} [yard] AddBinYardRequest yard
         */

        /**
         * Constructs a new AddBinYardRequest.
         * @memberof pond
         * @classdesc Represents an AddBinYardRequest.
         * @implements IAddBinYardRequest
         * @constructor
         * @param {pond.IAddBinYardRequest=} [properties] Properties to set
         */
        function AddBinYardRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBinYardRequest yard.
         * @member {pond.BinYardSettings|null|undefined} yard
         * @memberof pond.AddBinYardRequest
         * @instance
         */
        AddBinYardRequest.prototype.yard = null;

        /**
         * Creates a new AddBinYardRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddBinYardRequest
         * @static
         * @param {pond.IAddBinYardRequest=} [properties] Properties to set
         * @returns {pond.AddBinYardRequest} AddBinYardRequest instance
         */
        AddBinYardRequest.create = function create(properties) {
            return new AddBinYardRequest(properties);
        };

        /**
         * Creates an AddBinYardRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinYardRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinYardRequest} AddBinYardRequest
         */
        AddBinYardRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinYardRequest)
                return object;
            var message = new $root.pond.AddBinYardRequest();
            if (object.yard != null) {
                if (typeof object.yard !== "object")
                    throw TypeError(".pond.AddBinYardRequest.yard: object expected");
                message.yard = $root.pond.BinYardSettings.fromObject(object.yard);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddBinYardRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinYardRequest
         * @static
         * @param {pond.AddBinYardRequest} message AddBinYardRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinYardRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.yard = null;
            if (message.yard != null && message.hasOwnProperty("yard"))
                object.yard = $root.pond.BinYardSettings.toObject(message.yard, options);
            return object;
        };

        /**
         * Converts this AddBinYardRequest to JSON.
         * @function toJSON
         * @memberof pond.AddBinYardRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinYardRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinYardRequest;
    })();

    pond.AddBinYardResponse = (function() {

        /**
         * Properties of an AddBinYardResponse.
         * @memberof pond
         * @interface IAddBinYardResponse
         * @property {string|null} [yard] AddBinYardResponse yard
         */

        /**
         * Constructs a new AddBinYardResponse.
         * @memberof pond
         * @classdesc Represents an AddBinYardResponse.
         * @implements IAddBinYardResponse
         * @constructor
         * @param {pond.IAddBinYardResponse=} [properties] Properties to set
         */
        function AddBinYardResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBinYardResponse yard.
         * @member {string} yard
         * @memberof pond.AddBinYardResponse
         * @instance
         */
        AddBinYardResponse.prototype.yard = "";

        /**
         * Creates a new AddBinYardResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddBinYardResponse
         * @static
         * @param {pond.IAddBinYardResponse=} [properties] Properties to set
         * @returns {pond.AddBinYardResponse} AddBinYardResponse instance
         */
        AddBinYardResponse.create = function create(properties) {
            return new AddBinYardResponse(properties);
        };

        /**
         * Creates an AddBinYardResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinYardResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinYardResponse} AddBinYardResponse
         */
        AddBinYardResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinYardResponse)
                return object;
            var message = new $root.pond.AddBinYardResponse();
            if (object.yard != null)
                message.yard = String(object.yard);
            return message;
        };

        /**
         * Creates a plain object from an AddBinYardResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinYardResponse
         * @static
         * @param {pond.AddBinYardResponse} message AddBinYardResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinYardResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.yard = "";
            if (message.yard != null && message.hasOwnProperty("yard"))
                object.yard = message.yard;
            return object;
        };

        /**
         * Converts this AddBinYardResponse to JSON.
         * @function toJSON
         * @memberof pond.AddBinYardResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinYardResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinYardResponse;
    })();

    pond.GetBinYardRequest = (function() {

        /**
         * Properties of a GetBinYardRequest.
         * @memberof pond
         * @interface IGetBinYardRequest
         * @property {string|null} [yardKey] GetBinYardRequest yardKey
         */

        /**
         * Constructs a new GetBinYardRequest.
         * @memberof pond
         * @classdesc Represents a GetBinYardRequest.
         * @implements IGetBinYardRequest
         * @constructor
         * @param {pond.IGetBinYardRequest=} [properties] Properties to set
         */
        function GetBinYardRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinYardRequest yardKey.
         * @member {string} yardKey
         * @memberof pond.GetBinYardRequest
         * @instance
         */
        GetBinYardRequest.prototype.yardKey = "";

        /**
         * Creates a new GetBinYardRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBinYardRequest
         * @static
         * @param {pond.IGetBinYardRequest=} [properties] Properties to set
         * @returns {pond.GetBinYardRequest} GetBinYardRequest instance
         */
        GetBinYardRequest.create = function create(properties) {
            return new GetBinYardRequest(properties);
        };

        /**
         * Creates a GetBinYardRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinYardRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinYardRequest} GetBinYardRequest
         */
        GetBinYardRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinYardRequest)
                return object;
            var message = new $root.pond.GetBinYardRequest();
            if (object.yardKey != null)
                message.yardKey = String(object.yardKey);
            return message;
        };

        /**
         * Creates a plain object from a GetBinYardRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinYardRequest
         * @static
         * @param {pond.GetBinYardRequest} message GetBinYardRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinYardRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.yardKey = "";
            if (message.yardKey != null && message.hasOwnProperty("yardKey"))
                object.yardKey = message.yardKey;
            return object;
        };

        /**
         * Converts this GetBinYardRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBinYardRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinYardRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinYardRequest;
    })();

    pond.GetBinYardResponse = (function() {

        /**
         * Properties of a GetBinYardResponse.
         * @memberof pond
         * @interface IGetBinYardResponse
         * @property {pond.BinYard|null} [yard] GetBinYardResponse yard
         */

        /**
         * Constructs a new GetBinYardResponse.
         * @memberof pond
         * @classdesc Represents a GetBinYardResponse.
         * @implements IGetBinYardResponse
         * @constructor
         * @param {pond.IGetBinYardResponse=} [properties] Properties to set
         */
        function GetBinYardResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinYardResponse yard.
         * @member {pond.BinYard|null|undefined} yard
         * @memberof pond.GetBinYardResponse
         * @instance
         */
        GetBinYardResponse.prototype.yard = null;

        /**
         * Creates a new GetBinYardResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetBinYardResponse
         * @static
         * @param {pond.IGetBinYardResponse=} [properties] Properties to set
         * @returns {pond.GetBinYardResponse} GetBinYardResponse instance
         */
        GetBinYardResponse.create = function create(properties) {
            return new GetBinYardResponse(properties);
        };

        /**
         * Creates a GetBinYardResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinYardResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinYardResponse} GetBinYardResponse
         */
        GetBinYardResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinYardResponse)
                return object;
            var message = new $root.pond.GetBinYardResponse();
            if (object.yard != null) {
                if (typeof object.yard !== "object")
                    throw TypeError(".pond.GetBinYardResponse.yard: object expected");
                message.yard = $root.pond.BinYard.fromObject(object.yard);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetBinYardResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinYardResponse
         * @static
         * @param {pond.GetBinYardResponse} message GetBinYardResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinYardResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.yard = null;
            if (message.yard != null && message.hasOwnProperty("yard"))
                object.yard = $root.pond.BinYard.toObject(message.yard, options);
            return object;
        };

        /**
         * Converts this GetBinYardResponse to JSON.
         * @function toJSON
         * @memberof pond.GetBinYardResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinYardResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinYardResponse;
    })();

    pond.RemoveBinYardRequest = (function() {

        /**
         * Properties of a RemoveBinYardRequest.
         * @memberof pond
         * @interface IRemoveBinYardRequest
         * @property {string|null} [binYardKey] RemoveBinYardRequest binYardKey
         */

        /**
         * Constructs a new RemoveBinYardRequest.
         * @memberof pond
         * @classdesc Represents a RemoveBinYardRequest.
         * @implements IRemoveBinYardRequest
         * @constructor
         * @param {pond.IRemoveBinYardRequest=} [properties] Properties to set
         */
        function RemoveBinYardRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveBinYardRequest binYardKey.
         * @member {string} binYardKey
         * @memberof pond.RemoveBinYardRequest
         * @instance
         */
        RemoveBinYardRequest.prototype.binYardKey = "";

        /**
         * Creates a new RemoveBinYardRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinYardRequest
         * @static
         * @param {pond.IRemoveBinYardRequest=} [properties] Properties to set
         * @returns {pond.RemoveBinYardRequest} RemoveBinYardRequest instance
         */
        RemoveBinYardRequest.create = function create(properties) {
            return new RemoveBinYardRequest(properties);
        };

        /**
         * Creates a RemoveBinYardRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinYardRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinYardRequest} RemoveBinYardRequest
         */
        RemoveBinYardRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinYardRequest)
                return object;
            var message = new $root.pond.RemoveBinYardRequest();
            if (object.binYardKey != null)
                message.binYardKey = String(object.binYardKey);
            return message;
        };

        /**
         * Creates a plain object from a RemoveBinYardRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinYardRequest
         * @static
         * @param {pond.RemoveBinYardRequest} message RemoveBinYardRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinYardRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.binYardKey = "";
            if (message.binYardKey != null && message.hasOwnProperty("binYardKey"))
                object.binYardKey = message.binYardKey;
            return object;
        };

        /**
         * Converts this RemoveBinYardRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinYardRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinYardRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinYardRequest;
    })();

    pond.RemoveBinYardResponse = (function() {

        /**
         * Properties of a RemoveBinYardResponse.
         * @memberof pond
         * @interface IRemoveBinYardResponse
         * @property {string|null} [binYardKey] RemoveBinYardResponse binYardKey
         */

        /**
         * Constructs a new RemoveBinYardResponse.
         * @memberof pond
         * @classdesc Represents a RemoveBinYardResponse.
         * @implements IRemoveBinYardResponse
         * @constructor
         * @param {pond.IRemoveBinYardResponse=} [properties] Properties to set
         */
        function RemoveBinYardResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveBinYardResponse binYardKey.
         * @member {string} binYardKey
         * @memberof pond.RemoveBinYardResponse
         * @instance
         */
        RemoveBinYardResponse.prototype.binYardKey = "";

        /**
         * Creates a new RemoveBinYardResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinYardResponse
         * @static
         * @param {pond.IRemoveBinYardResponse=} [properties] Properties to set
         * @returns {pond.RemoveBinYardResponse} RemoveBinYardResponse instance
         */
        RemoveBinYardResponse.create = function create(properties) {
            return new RemoveBinYardResponse(properties);
        };

        /**
         * Creates a RemoveBinYardResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinYardResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinYardResponse} RemoveBinYardResponse
         */
        RemoveBinYardResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinYardResponse)
                return object;
            var message = new $root.pond.RemoveBinYardResponse();
            if (object.binYardKey != null)
                message.binYardKey = String(object.binYardKey);
            return message;
        };

        /**
         * Creates a plain object from a RemoveBinYardResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinYardResponse
         * @static
         * @param {pond.RemoveBinYardResponse} message RemoveBinYardResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinYardResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.binYardKey = "";
            if (message.binYardKey != null && message.hasOwnProperty("binYardKey"))
                object.binYardKey = message.binYardKey;
            return object;
        };

        /**
         * Converts this RemoveBinYardResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinYardResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinYardResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinYardResponse;
    })();

    pond.ListBinYardsRequest = (function() {

        /**
         * Properties of a ListBinYardsRequest.
         * @memberof pond
         * @interface IListBinYardsRequest
         * @property {pond.Paging|null} [paging] ListBinYardsRequest paging
         * @property {pond.Sorting|null} [sorting] ListBinYardsRequest sorting
         * @property {string|null} [search] ListBinYardsRequest search
         * @property {pond.BinSettings|null} [settingsMatch] ListBinYardsRequest settingsMatch
         * @property {pond.BinStatus|null} [statusMatch] ListBinYardsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListBinYardsRequest fieldContains
         */

        /**
         * Constructs a new ListBinYardsRequest.
         * @memberof pond
         * @classdesc Represents a ListBinYardsRequest.
         * @implements IListBinYardsRequest
         * @constructor
         * @param {pond.IListBinYardsRequest=} [properties] Properties to set
         */
        function ListBinYardsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinYardsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.paging = null;

        /**
         * ListBinYardsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.sorting = null;

        /**
         * ListBinYardsRequest search.
         * @member {string} search
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.search = "";

        /**
         * ListBinYardsRequest settingsMatch.
         * @member {pond.BinSettings|null|undefined} settingsMatch
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.settingsMatch = null;

        /**
         * ListBinYardsRequest statusMatch.
         * @member {pond.BinStatus|null|undefined} statusMatch
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.statusMatch = null;

        /**
         * ListBinYardsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListBinYardsRequest
         * @instance
         */
        ListBinYardsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListBinYardsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinYardsRequest
         * @static
         * @param {pond.IListBinYardsRequest=} [properties] Properties to set
         * @returns {pond.ListBinYardsRequest} ListBinYardsRequest instance
         */
        ListBinYardsRequest.create = function create(properties) {
            return new ListBinYardsRequest(properties);
        };

        /**
         * Creates a ListBinYardsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinYardsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinYardsRequest} ListBinYardsRequest
         */
        ListBinYardsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinYardsRequest)
                return object;
            var message = new $root.pond.ListBinYardsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListBinYardsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListBinYardsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListBinYardsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.BinSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListBinYardsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.BinStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListBinYardsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinYardsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinYardsRequest
         * @static
         * @param {pond.ListBinYardsRequest} message ListBinYardsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinYardsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.BinSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.BinStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListBinYardsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinYardsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinYardsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinYardsRequest;
    })();

    pond.ListBinYardsResponse = (function() {

        /**
         * Properties of a ListBinYardsResponse.
         * @memberof pond
         * @interface IListBinYardsResponse
         * @property {Array.<pond.BinYard>|null} [yard] ListBinYardsResponse yard
         * @property {number|null} [nextOffset] ListBinYardsResponse nextOffset
         * @property {number|null} [total] ListBinYardsResponse total
         */

        /**
         * Constructs a new ListBinYardsResponse.
         * @memberof pond
         * @classdesc Represents a ListBinYardsResponse.
         * @implements IListBinYardsResponse
         * @constructor
         * @param {pond.IListBinYardsResponse=} [properties] Properties to set
         */
        function ListBinYardsResponse(properties) {
            this.yard = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinYardsResponse yard.
         * @member {Array.<pond.BinYard>} yard
         * @memberof pond.ListBinYardsResponse
         * @instance
         */
        ListBinYardsResponse.prototype.yard = $util.emptyArray;

        /**
         * ListBinYardsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListBinYardsResponse
         * @instance
         */
        ListBinYardsResponse.prototype.nextOffset = 0;

        /**
         * ListBinYardsResponse total.
         * @member {number} total
         * @memberof pond.ListBinYardsResponse
         * @instance
         */
        ListBinYardsResponse.prototype.total = 0;

        /**
         * Creates a new ListBinYardsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinYardsResponse
         * @static
         * @param {pond.IListBinYardsResponse=} [properties] Properties to set
         * @returns {pond.ListBinYardsResponse} ListBinYardsResponse instance
         */
        ListBinYardsResponse.create = function create(properties) {
            return new ListBinYardsResponse(properties);
        };

        /**
         * Creates a ListBinYardsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinYardsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinYardsResponse} ListBinYardsResponse
         */
        ListBinYardsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinYardsResponse)
                return object;
            var message = new $root.pond.ListBinYardsResponse();
            if (object.yard) {
                if (!Array.isArray(object.yard))
                    throw TypeError(".pond.ListBinYardsResponse.yard: array expected");
                message.yard = [];
                for (var i = 0; i < object.yard.length; ++i) {
                    if (typeof object.yard[i] !== "object")
                        throw TypeError(".pond.ListBinYardsResponse.yard: object expected");
                    message.yard[i] = $root.pond.BinYard.fromObject(object.yard[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListBinYardsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinYardsResponse
         * @static
         * @param {pond.ListBinYardsResponse} message ListBinYardsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinYardsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.yard = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.yard && message.yard.length) {
                object.yard = [];
                for (var j = 0; j < message.yard.length; ++j)
                    object.yard[j] = $root.pond.BinYard.toObject(message.yard[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListBinYardsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinYardsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinYardsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinYardsResponse;
    })();

    pond.DeviceComponents = (function() {

        /**
         * Properties of a DeviceComponents.
         * @memberof pond
         * @interface IDeviceComponents
         * @property {number|null} [device] DeviceComponents device
         * @property {Array.<string>|null} [components] DeviceComponents components
         */

        /**
         * Constructs a new DeviceComponents.
         * @memberof pond
         * @classdesc Represents a DeviceComponents.
         * @implements IDeviceComponents
         * @constructor
         * @param {pond.IDeviceComponents=} [properties] Properties to set
         */
        function DeviceComponents(properties) {
            this.components = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceComponents device.
         * @member {number} device
         * @memberof pond.DeviceComponents
         * @instance
         */
        DeviceComponents.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceComponents components.
         * @member {Array.<string>} components
         * @memberof pond.DeviceComponents
         * @instance
         */
        DeviceComponents.prototype.components = $util.emptyArray;

        /**
         * Creates a new DeviceComponents instance using the specified properties.
         * @function create
         * @memberof pond.DeviceComponents
         * @static
         * @param {pond.IDeviceComponents=} [properties] Properties to set
         * @returns {pond.DeviceComponents} DeviceComponents instance
         */
        DeviceComponents.create = function create(properties) {
            return new DeviceComponents(properties);
        };

        /**
         * Creates a DeviceComponents message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceComponents
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceComponents} DeviceComponents
         */
        DeviceComponents.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceComponents)
                return object;
            var message = new $root.pond.DeviceComponents();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.DeviceComponents.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i)
                    message.components[i] = String(object.components[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceComponents message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceComponents
         * @static
         * @param {pond.DeviceComponents} message DeviceComponents
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceComponents.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = message.components[j];
            }
            return object;
        };

        /**
         * Converts this DeviceComponents to JSON.
         * @function toJSON
         * @memberof pond.DeviceComponents
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceComponents.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceComponents;
    })();

    pond.BinSettings = (function() {

        /**
         * Properties of a BinSettings.
         * @memberof pond
         * @interface IBinSettings
         * @property {string|null} [key] BinSettings key
         * @property {string|null} [name] BinSettings name
         * @property {string|null} [yardKey] BinSettings yardKey
         * @property {pond.BinSpecs|null} [specs] BinSettings specs
         * @property {pond.BinMode|null} [mode] BinSettings mode
         * @property {number|null} [outdoorTemp] BinSettings outdoorTemp
         * @property {number|null} [outdoorHumidity] BinSettings outdoorHumidity
         * @property {pond.Fan|null} [fan] BinSettings fan
         * @property {pond.Location|null} [location] BinSettings location
         * @property {pond.BinInventory|null} [inventory] BinSettings inventory
         * @property {Array.<pond.DeviceComponents>|null} [deviceComponents] BinSettings deviceComponents
         * @property {boolean|null} [useLidar] BinSettings useLidar
         * @property {pond.ObjectTheme|null} [theme] BinSettings theme
         * @property {pond.BinStorage|null} [storage] BinSettings storage
         * @property {number|null} [highTemp] BinSettings highTemp
         * @property {number|null} [lowTemp] BinSettings lowTemp
         * @property {number|null} [fanId] BinSettings fanId
         * @property {boolean|null} [autoGrainNode] BinSettings autoGrainNode
         */

        /**
         * Constructs a new BinSettings.
         * @memberof pond
         * @classdesc Represents a BinSettings.
         * @implements IBinSettings
         * @constructor
         * @param {pond.IBinSettings=} [properties] Properties to set
         */
        function BinSettings(properties) {
            this.deviceComponents = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinSettings key.
         * @member {string} key
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.key = "";

        /**
         * BinSettings name.
         * @member {string} name
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.name = "";

        /**
         * BinSettings yardKey.
         * @member {string} yardKey
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.yardKey = "";

        /**
         * BinSettings specs.
         * @member {pond.BinSpecs|null|undefined} specs
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.specs = null;

        /**
         * BinSettings mode.
         * @member {pond.BinMode} mode
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.mode = 0;

        /**
         * BinSettings outdoorTemp.
         * @member {number} outdoorTemp
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.outdoorTemp = 0;

        /**
         * BinSettings outdoorHumidity.
         * @member {number} outdoorHumidity
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.outdoorHumidity = 0;

        /**
         * BinSettings fan.
         * @member {pond.Fan|null|undefined} fan
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.fan = null;

        /**
         * BinSettings location.
         * @member {pond.Location|null|undefined} location
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.location = null;

        /**
         * BinSettings inventory.
         * @member {pond.BinInventory|null|undefined} inventory
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.inventory = null;

        /**
         * BinSettings deviceComponents.
         * @member {Array.<pond.DeviceComponents>} deviceComponents
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.deviceComponents = $util.emptyArray;

        /**
         * BinSettings useLidar.
         * @member {boolean} useLidar
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.useLidar = false;

        /**
         * BinSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.theme = null;

        /**
         * BinSettings storage.
         * @member {pond.BinStorage} storage
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.storage = 0;

        /**
         * BinSettings highTemp.
         * @member {number} highTemp
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.highTemp = 0;

        /**
         * BinSettings lowTemp.
         * @member {number} lowTemp
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.lowTemp = 0;

        /**
         * BinSettings fanId.
         * @member {number} fanId
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.fanId = 0;

        /**
         * BinSettings autoGrainNode.
         * @member {boolean} autoGrainNode
         * @memberof pond.BinSettings
         * @instance
         */
        BinSettings.prototype.autoGrainNode = false;

        /**
         * Creates a new BinSettings instance using the specified properties.
         * @function create
         * @memberof pond.BinSettings
         * @static
         * @param {pond.IBinSettings=} [properties] Properties to set
         * @returns {pond.BinSettings} BinSettings instance
         */
        BinSettings.create = function create(properties) {
            return new BinSettings(properties);
        };

        /**
         * Creates a BinSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinSettings} BinSettings
         */
        BinSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinSettings)
                return object;
            var message = new $root.pond.BinSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.yardKey != null)
                message.yardKey = String(object.yardKey);
            if (object.specs != null) {
                if (typeof object.specs !== "object")
                    throw TypeError(".pond.BinSettings.specs: object expected");
                message.specs = $root.pond.BinSpecs.fromObject(object.specs);
            }
            switch (object.mode) {
            case "BIN_MODE_NONE":
            case 0:
                message.mode = 0;
                break;
            case "BIN_MODE_DRYING":
            case 1:
                message.mode = 1;
                break;
            case "BIN_MODE_COOLDOWN":
            case 2:
                message.mode = 2;
                break;
            case "BIN_MODE_STORAGE":
            case 3:
                message.mode = 3;
                break;
            case "BIN_MODE_HYDRATING":
            case 4:
                message.mode = 4;
                break;
            }
            if (object.outdoorTemp != null)
                message.outdoorTemp = Number(object.outdoorTemp);
            if (object.outdoorHumidity != null)
                message.outdoorHumidity = Number(object.outdoorHumidity);
            if (object.fan != null) {
                if (typeof object.fan !== "object")
                    throw TypeError(".pond.BinSettings.fan: object expected");
                message.fan = $root.pond.Fan.fromObject(object.fan);
            }
            if (object.location != null) {
                if (typeof object.location !== "object")
                    throw TypeError(".pond.BinSettings.location: object expected");
                message.location = $root.pond.Location.fromObject(object.location);
            }
            if (object.inventory != null) {
                if (typeof object.inventory !== "object")
                    throw TypeError(".pond.BinSettings.inventory: object expected");
                message.inventory = $root.pond.BinInventory.fromObject(object.inventory);
            }
            if (object.deviceComponents) {
                if (!Array.isArray(object.deviceComponents))
                    throw TypeError(".pond.BinSettings.deviceComponents: array expected");
                message.deviceComponents = [];
                for (var i = 0; i < object.deviceComponents.length; ++i) {
                    if (typeof object.deviceComponents[i] !== "object")
                        throw TypeError(".pond.BinSettings.deviceComponents: object expected");
                    message.deviceComponents[i] = $root.pond.DeviceComponents.fromObject(object.deviceComponents[i]);
                }
            }
            if (object.useLidar != null)
                message.useLidar = Boolean(object.useLidar);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.BinSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            switch (object.storage) {
            case "BIN_STORAGE_UNKNOWN":
            case 0:
                message.storage = 0;
                break;
            case "BIN_STORAGE_SUPPORTED_GRAIN":
            case 1:
                message.storage = 1;
                break;
            case "BIN_STORAGE_FERTILIZER":
            case 2:
                message.storage = 2;
                break;
            case "BIN_STORAGE_UNSUPPORTED_GRAIN":
            case 3:
                message.storage = 3;
                break;
            }
            if (object.highTemp != null)
                message.highTemp = Number(object.highTemp);
            if (object.lowTemp != null)
                message.lowTemp = Number(object.lowTemp);
            if (object.fanId != null)
                message.fanId = object.fanId | 0;
            if (object.autoGrainNode != null)
                message.autoGrainNode = Boolean(object.autoGrainNode);
            return message;
        };

        /**
         * Creates a plain object from a BinSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinSettings
         * @static
         * @param {pond.BinSettings} message BinSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.deviceComponents = [];
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.yardKey = "";
                object.specs = null;
                object.mode = options.enums === String ? "BIN_MODE_NONE" : 0;
                object.outdoorTemp = 0;
                object.outdoorHumidity = 0;
                object.fan = null;
                object.location = null;
                object.inventory = null;
                object.useLidar = false;
                object.theme = null;
                object.storage = options.enums === String ? "BIN_STORAGE_UNKNOWN" : 0;
                object.highTemp = 0;
                object.lowTemp = 0;
                object.fanId = 0;
                object.autoGrainNode = false;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.yardKey != null && message.hasOwnProperty("yardKey"))
                object.yardKey = message.yardKey;
            if (message.specs != null && message.hasOwnProperty("specs"))
                object.specs = $root.pond.BinSpecs.toObject(message.specs, options);
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.pond.BinMode[message.mode] : message.mode;
            if (message.outdoorTemp != null && message.hasOwnProperty("outdoorTemp"))
                object.outdoorTemp = options.json && !isFinite(message.outdoorTemp) ? String(message.outdoorTemp) : message.outdoorTemp;
            if (message.outdoorHumidity != null && message.hasOwnProperty("outdoorHumidity"))
                object.outdoorHumidity = options.json && !isFinite(message.outdoorHumidity) ? String(message.outdoorHumidity) : message.outdoorHumidity;
            if (message.fan != null && message.hasOwnProperty("fan"))
                object.fan = $root.pond.Fan.toObject(message.fan, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = $root.pond.Location.toObject(message.location, options);
            if (message.inventory != null && message.hasOwnProperty("inventory"))
                object.inventory = $root.pond.BinInventory.toObject(message.inventory, options);
            if (message.deviceComponents && message.deviceComponents.length) {
                object.deviceComponents = [];
                for (var j = 0; j < message.deviceComponents.length; ++j)
                    object.deviceComponents[j] = $root.pond.DeviceComponents.toObject(message.deviceComponents[j], options);
            }
            if (message.useLidar != null && message.hasOwnProperty("useLidar"))
                object.useLidar = message.useLidar;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.storage != null && message.hasOwnProperty("storage"))
                object.storage = options.enums === String ? $root.pond.BinStorage[message.storage] : message.storage;
            if (message.highTemp != null && message.hasOwnProperty("highTemp"))
                object.highTemp = options.json && !isFinite(message.highTemp) ? String(message.highTemp) : message.highTemp;
            if (message.lowTemp != null && message.hasOwnProperty("lowTemp"))
                object.lowTemp = options.json && !isFinite(message.lowTemp) ? String(message.lowTemp) : message.lowTemp;
            if (message.fanId != null && message.hasOwnProperty("fanId"))
                object.fanId = message.fanId;
            if (message.autoGrainNode != null && message.hasOwnProperty("autoGrainNode"))
                object.autoGrainNode = message.autoGrainNode;
            return object;
        };

        /**
         * Converts this BinSettings to JSON.
         * @function toJSON
         * @memberof pond.BinSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinSettings;
    })();

    pond.CableTrendData = (function() {

        /**
         * Properties of a CableTrendData.
         * @memberof pond
         * @interface ICableTrendData
         * @property {number|null} [temperatureCelsiusTrend] CableTrendData temperatureCelsiusTrend
         * @property {number|null} [relativeHumidityTrend] CableTrendData relativeHumidityTrend
         * @property {number|null} [emcTrend] CableTrendData emcTrend
         */

        /**
         * Constructs a new CableTrendData.
         * @memberof pond
         * @classdesc Represents a CableTrendData.
         * @implements ICableTrendData
         * @constructor
         * @param {pond.ICableTrendData=} [properties] Properties to set
         */
        function CableTrendData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CableTrendData temperatureCelsiusTrend.
         * @member {number} temperatureCelsiusTrend
         * @memberof pond.CableTrendData
         * @instance
         */
        CableTrendData.prototype.temperatureCelsiusTrend = 0;

        /**
         * CableTrendData relativeHumidityTrend.
         * @member {number} relativeHumidityTrend
         * @memberof pond.CableTrendData
         * @instance
         */
        CableTrendData.prototype.relativeHumidityTrend = 0;

        /**
         * CableTrendData emcTrend.
         * @member {number} emcTrend
         * @memberof pond.CableTrendData
         * @instance
         */
        CableTrendData.prototype.emcTrend = 0;

        /**
         * Creates a new CableTrendData instance using the specified properties.
         * @function create
         * @memberof pond.CableTrendData
         * @static
         * @param {pond.ICableTrendData=} [properties] Properties to set
         * @returns {pond.CableTrendData} CableTrendData instance
         */
        CableTrendData.create = function create(properties) {
            return new CableTrendData(properties);
        };

        /**
         * Creates a CableTrendData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CableTrendData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CableTrendData} CableTrendData
         */
        CableTrendData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CableTrendData)
                return object;
            var message = new $root.pond.CableTrendData();
            if (object.temperatureCelsiusTrend != null)
                message.temperatureCelsiusTrend = Number(object.temperatureCelsiusTrend);
            if (object.relativeHumidityTrend != null)
                message.relativeHumidityTrend = Number(object.relativeHumidityTrend);
            if (object.emcTrend != null)
                message.emcTrend = Number(object.emcTrend);
            return message;
        };

        /**
         * Creates a plain object from a CableTrendData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CableTrendData
         * @static
         * @param {pond.CableTrendData} message CableTrendData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CableTrendData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.temperatureCelsiusTrend = 0;
                object.relativeHumidityTrend = 0;
                object.emcTrend = 0;
            }
            if (message.temperatureCelsiusTrend != null && message.hasOwnProperty("temperatureCelsiusTrend"))
                object.temperatureCelsiusTrend = options.json && !isFinite(message.temperatureCelsiusTrend) ? String(message.temperatureCelsiusTrend) : message.temperatureCelsiusTrend;
            if (message.relativeHumidityTrend != null && message.hasOwnProperty("relativeHumidityTrend"))
                object.relativeHumidityTrend = options.json && !isFinite(message.relativeHumidityTrend) ? String(message.relativeHumidityTrend) : message.relativeHumidityTrend;
            if (message.emcTrend != null && message.hasOwnProperty("emcTrend"))
                object.emcTrend = options.json && !isFinite(message.emcTrend) ? String(message.emcTrend) : message.emcTrend;
            return object;
        };

        /**
         * Converts this CableTrendData to JSON.
         * @function toJSON
         * @memberof pond.CableTrendData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CableTrendData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CableTrendData;
    })();

    pond.GrainCable = (function() {

        /**
         * Properties of a GrainCable.
         * @memberof pond
         * @interface IGrainCable
         * @property {string|null} [name] GrainCable name
         * @property {Array.<number>|null} [celcius] GrainCable celcius
         * @property {Array.<number>|null} [relativeHumidity] GrainCable relativeHumidity
         * @property {Array.<number>|null} [moisture] GrainCable moisture
         * @property {string|null} [key] GrainCable key
         * @property {number|null} [device] GrainCable device
         * @property {number|null} [topNode] GrainCable topNode
         * @property {string|null} [address] GrainCable address
         * @property {string|null} [lastRead] GrainCable lastRead
         * @property {number|null} [measurementInterval] GrainCable measurementInterval
         */

        /**
         * Constructs a new GrainCable.
         * @memberof pond
         * @classdesc Represents a GrainCable.
         * @implements IGrainCable
         * @constructor
         * @param {pond.IGrainCable=} [properties] Properties to set
         */
        function GrainCable(properties) {
            this.celcius = [];
            this.relativeHumidity = [];
            this.moisture = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainCable name.
         * @member {string} name
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.name = "";

        /**
         * GrainCable celcius.
         * @member {Array.<number>} celcius
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.celcius = $util.emptyArray;

        /**
         * GrainCable relativeHumidity.
         * @member {Array.<number>} relativeHumidity
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.relativeHumidity = $util.emptyArray;

        /**
         * GrainCable moisture.
         * @member {Array.<number>} moisture
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.moisture = $util.emptyArray;

        /**
         * GrainCable key.
         * @member {string} key
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.key = "";

        /**
         * GrainCable device.
         * @member {number} device
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GrainCable topNode.
         * @member {number} topNode
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.topNode = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GrainCable address.
         * @member {string} address
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.address = "";

        /**
         * GrainCable lastRead.
         * @member {string} lastRead
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.lastRead = "";

        /**
         * GrainCable measurementInterval.
         * @member {number} measurementInterval
         * @memberof pond.GrainCable
         * @instance
         */
        GrainCable.prototype.measurementInterval = 0;

        /**
         * Creates a new GrainCable instance using the specified properties.
         * @function create
         * @memberof pond.GrainCable
         * @static
         * @param {pond.IGrainCable=} [properties] Properties to set
         * @returns {pond.GrainCable} GrainCable instance
         */
        GrainCable.create = function create(properties) {
            return new GrainCable(properties);
        };

        /**
         * Creates a GrainCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainCable} GrainCable
         */
        GrainCable.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainCable)
                return object;
            var message = new $root.pond.GrainCable();
            if (object.name != null)
                message.name = String(object.name);
            if (object.celcius) {
                if (!Array.isArray(object.celcius))
                    throw TypeError(".pond.GrainCable.celcius: array expected");
                message.celcius = [];
                for (var i = 0; i < object.celcius.length; ++i)
                    message.celcius[i] = Number(object.celcius[i]);
            }
            if (object.relativeHumidity) {
                if (!Array.isArray(object.relativeHumidity))
                    throw TypeError(".pond.GrainCable.relativeHumidity: array expected");
                message.relativeHumidity = [];
                for (var i = 0; i < object.relativeHumidity.length; ++i)
                    message.relativeHumidity[i] = Number(object.relativeHumidity[i]);
            }
            if (object.moisture) {
                if (!Array.isArray(object.moisture))
                    throw TypeError(".pond.GrainCable.moisture: array expected");
                message.moisture = [];
                for (var i = 0; i < object.moisture.length; ++i)
                    message.moisture[i] = Number(object.moisture[i]);
            }
            if (object.key != null)
                message.key = String(object.key);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.topNode != null)
                if ($util.Long)
                    (message.topNode = $util.Long.fromValue(object.topNode)).unsigned = true;
                else if (typeof object.topNode === "string")
                    message.topNode = parseInt(object.topNode, 10);
                else if (typeof object.topNode === "number")
                    message.topNode = object.topNode;
                else if (typeof object.topNode === "object")
                    message.topNode = new $util.LongBits(object.topNode.low >>> 0, object.topNode.high >>> 0).toNumber(true);
            if (object.address != null)
                message.address = String(object.address);
            if (object.lastRead != null)
                message.lastRead = String(object.lastRead);
            if (object.measurementInterval != null)
                message.measurementInterval = object.measurementInterval >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GrainCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainCable
         * @static
         * @param {pond.GrainCable} message GrainCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.celcius = [];
                object.relativeHumidity = [];
                object.moisture = [];
            }
            if (options.defaults) {
                object.name = "";
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.topNode = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.topNode = options.longs === String ? "0" : 0;
                object.address = "";
                object.lastRead = "";
                object.measurementInterval = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.celcius && message.celcius.length) {
                object.celcius = [];
                for (var j = 0; j < message.celcius.length; ++j)
                    object.celcius[j] = options.json && !isFinite(message.celcius[j]) ? String(message.celcius[j]) : message.celcius[j];
            }
            if (message.relativeHumidity && message.relativeHumidity.length) {
                object.relativeHumidity = [];
                for (var j = 0; j < message.relativeHumidity.length; ++j)
                    object.relativeHumidity[j] = options.json && !isFinite(message.relativeHumidity[j]) ? String(message.relativeHumidity[j]) : message.relativeHumidity[j];
            }
            if (message.moisture && message.moisture.length) {
                object.moisture = [];
                for (var j = 0; j < message.moisture.length; ++j)
                    object.moisture[j] = options.json && !isFinite(message.moisture[j]) ? String(message.moisture[j]) : message.moisture[j];
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.topNode != null && message.hasOwnProperty("topNode"))
                if (typeof message.topNode === "number")
                    object.topNode = options.longs === String ? String(message.topNode) : message.topNode;
                else
                    object.topNode = options.longs === String ? $util.Long.prototype.toString.call(message.topNode) : options.longs === Number ? new $util.LongBits(message.topNode.low >>> 0, message.topNode.high >>> 0).toNumber(true) : message.topNode;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.lastRead != null && message.hasOwnProperty("lastRead"))
                object.lastRead = message.lastRead;
            if (message.measurementInterval != null && message.hasOwnProperty("measurementInterval"))
                object.measurementInterval = message.measurementInterval;
            return object;
        };

        /**
         * Converts this GrainCable to JSON.
         * @function toJSON
         * @memberof pond.GrainCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainCable;
    })();

    pond.Plenum = (function() {

        /**
         * Properties of a Plenum.
         * @memberof pond
         * @interface IPlenum
         * @property {string|null} [name] Plenum name
         * @property {number|null} [celcius] Plenum celcius
         * @property {number|null} [relativeHumidity] Plenum relativeHumidity
         * @property {string|null} [key] Plenum key
         * @property {number|null} [device] Plenum device
         */

        /**
         * Constructs a new Plenum.
         * @memberof pond
         * @classdesc Represents a Plenum.
         * @implements IPlenum
         * @constructor
         * @param {pond.IPlenum=} [properties] Properties to set
         */
        function Plenum(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Plenum name.
         * @member {string} name
         * @memberof pond.Plenum
         * @instance
         */
        Plenum.prototype.name = "";

        /**
         * Plenum celcius.
         * @member {number} celcius
         * @memberof pond.Plenum
         * @instance
         */
        Plenum.prototype.celcius = 0;

        /**
         * Plenum relativeHumidity.
         * @member {number} relativeHumidity
         * @memberof pond.Plenum
         * @instance
         */
        Plenum.prototype.relativeHumidity = 0;

        /**
         * Plenum key.
         * @member {string} key
         * @memberof pond.Plenum
         * @instance
         */
        Plenum.prototype.key = "";

        /**
         * Plenum device.
         * @member {number} device
         * @memberof pond.Plenum
         * @instance
         */
        Plenum.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Plenum instance using the specified properties.
         * @function create
         * @memberof pond.Plenum
         * @static
         * @param {pond.IPlenum=} [properties] Properties to set
         * @returns {pond.Plenum} Plenum instance
         */
        Plenum.create = function create(properties) {
            return new Plenum(properties);
        };

        /**
         * Creates a Plenum message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Plenum
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Plenum} Plenum
         */
        Plenum.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Plenum)
                return object;
            var message = new $root.pond.Plenum();
            if (object.name != null)
                message.name = String(object.name);
            if (object.celcius != null)
                message.celcius = Number(object.celcius);
            if (object.relativeHumidity != null)
                message.relativeHumidity = Number(object.relativeHumidity);
            if (object.key != null)
                message.key = String(object.key);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Plenum message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Plenum
         * @static
         * @param {pond.Plenum} message Plenum
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Plenum.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.celcius = 0;
                object.relativeHumidity = 0;
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.celcius != null && message.hasOwnProperty("celcius"))
                object.celcius = options.json && !isFinite(message.celcius) ? String(message.celcius) : message.celcius;
            if (message.relativeHumidity != null && message.hasOwnProperty("relativeHumidity"))
                object.relativeHumidity = options.json && !isFinite(message.relativeHumidity) ? String(message.relativeHumidity) : message.relativeHumidity;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this Plenum to JSON.
         * @function toJSON
         * @memberof pond.Plenum
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Plenum.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Plenum;
    })();

    pond.Pressure = (function() {

        /**
         * Properties of a Pressure.
         * @memberof pond
         * @interface IPressure
         * @property {string|null} [name] Pressure name
         * @property {string|null} [key] Pressure key
         * @property {number|null} [pascals] Pressure pascals
         * @property {number|null} [fanId] Pressure fanId
         * @property {number|null} [device] Pressure device
         */

        /**
         * Constructs a new Pressure.
         * @memberof pond
         * @classdesc Represents a Pressure.
         * @implements IPressure
         * @constructor
         * @param {pond.IPressure=} [properties] Properties to set
         */
        function Pressure(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pressure name.
         * @member {string} name
         * @memberof pond.Pressure
         * @instance
         */
        Pressure.prototype.name = "";

        /**
         * Pressure key.
         * @member {string} key
         * @memberof pond.Pressure
         * @instance
         */
        Pressure.prototype.key = "";

        /**
         * Pressure pascals.
         * @member {number} pascals
         * @memberof pond.Pressure
         * @instance
         */
        Pressure.prototype.pascals = 0;

        /**
         * Pressure fanId.
         * @member {number} fanId
         * @memberof pond.Pressure
         * @instance
         */
        Pressure.prototype.fanId = 0;

        /**
         * Pressure device.
         * @member {number} device
         * @memberof pond.Pressure
         * @instance
         */
        Pressure.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Pressure instance using the specified properties.
         * @function create
         * @memberof pond.Pressure
         * @static
         * @param {pond.IPressure=} [properties] Properties to set
         * @returns {pond.Pressure} Pressure instance
         */
        Pressure.create = function create(properties) {
            return new Pressure(properties);
        };

        /**
         * Creates a Pressure message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Pressure
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Pressure} Pressure
         */
        Pressure.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Pressure)
                return object;
            var message = new $root.pond.Pressure();
            if (object.name != null)
                message.name = String(object.name);
            if (object.key != null)
                message.key = String(object.key);
            if (object.pascals != null)
                message.pascals = object.pascals | 0;
            if (object.fanId != null)
                message.fanId = object.fanId | 0;
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Pressure message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Pressure
         * @static
         * @param {pond.Pressure} message Pressure
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pressure.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.key = "";
                object.pascals = 0;
                object.fanId = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.pascals != null && message.hasOwnProperty("pascals"))
                object.pascals = message.pascals;
            if (message.fanId != null && message.hasOwnProperty("fanId"))
                object.fanId = message.fanId;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this Pressure to JSON.
         * @function toJSON
         * @memberof pond.Pressure
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pressure.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Pressure;
    })();

    pond.BinFan = (function() {

        /**
         * Properties of a BinFan.
         * @memberof pond
         * @interface IBinFan
         * @property {string|null} [name] BinFan name
         * @property {string|null} [key] BinFan key
         * @property {boolean|null} [state] BinFan state
         * @property {number|null} [device] BinFan device
         */

        /**
         * Constructs a new BinFan.
         * @memberof pond
         * @classdesc Represents a BinFan.
         * @implements IBinFan
         * @constructor
         * @param {pond.IBinFan=} [properties] Properties to set
         */
        function BinFan(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinFan name.
         * @member {string} name
         * @memberof pond.BinFan
         * @instance
         */
        BinFan.prototype.name = "";

        /**
         * BinFan key.
         * @member {string} key
         * @memberof pond.BinFan
         * @instance
         */
        BinFan.prototype.key = "";

        /**
         * BinFan state.
         * @member {boolean} state
         * @memberof pond.BinFan
         * @instance
         */
        BinFan.prototype.state = false;

        /**
         * BinFan device.
         * @member {number} device
         * @memberof pond.BinFan
         * @instance
         */
        BinFan.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new BinFan instance using the specified properties.
         * @function create
         * @memberof pond.BinFan
         * @static
         * @param {pond.IBinFan=} [properties] Properties to set
         * @returns {pond.BinFan} BinFan instance
         */
        BinFan.create = function create(properties) {
            return new BinFan(properties);
        };

        /**
         * Creates a BinFan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinFan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinFan} BinFan
         */
        BinFan.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinFan)
                return object;
            var message = new $root.pond.BinFan();
            if (object.name != null)
                message.name = String(object.name);
            if (object.key != null)
                message.key = String(object.key);
            if (object.state != null)
                message.state = Boolean(object.state);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a BinFan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinFan
         * @static
         * @param {pond.BinFan} message BinFan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinFan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.key = "";
                object.state = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this BinFan to JSON.
         * @function toJSON
         * @memberof pond.BinFan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinFan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinFan;
    })();

    pond.BinHeater = (function() {

        /**
         * Properties of a BinHeater.
         * @memberof pond
         * @interface IBinHeater
         * @property {string|null} [name] BinHeater name
         * @property {string|null} [key] BinHeater key
         * @property {boolean|null} [state] BinHeater state
         * @property {number|null} [device] BinHeater device
         */

        /**
         * Constructs a new BinHeater.
         * @memberof pond
         * @classdesc Represents a BinHeater.
         * @implements IBinHeater
         * @constructor
         * @param {pond.IBinHeater=} [properties] Properties to set
         */
        function BinHeater(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinHeater name.
         * @member {string} name
         * @memberof pond.BinHeater
         * @instance
         */
        BinHeater.prototype.name = "";

        /**
         * BinHeater key.
         * @member {string} key
         * @memberof pond.BinHeater
         * @instance
         */
        BinHeater.prototype.key = "";

        /**
         * BinHeater state.
         * @member {boolean} state
         * @memberof pond.BinHeater
         * @instance
         */
        BinHeater.prototype.state = false;

        /**
         * BinHeater device.
         * @member {number} device
         * @memberof pond.BinHeater
         * @instance
         */
        BinHeater.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new BinHeater instance using the specified properties.
         * @function create
         * @memberof pond.BinHeater
         * @static
         * @param {pond.IBinHeater=} [properties] Properties to set
         * @returns {pond.BinHeater} BinHeater instance
         */
        BinHeater.create = function create(properties) {
            return new BinHeater(properties);
        };

        /**
         * Creates a BinHeater message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinHeater
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinHeater} BinHeater
         */
        BinHeater.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinHeater)
                return object;
            var message = new $root.pond.BinHeater();
            if (object.name != null)
                message.name = String(object.name);
            if (object.key != null)
                message.key = String(object.key);
            if (object.state != null)
                message.state = Boolean(object.state);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a BinHeater message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinHeater
         * @static
         * @param {pond.BinHeater} message BinHeater
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinHeater.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.key = "";
                object.state = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this BinHeater to JSON.
         * @function toJSON
         * @memberof pond.BinHeater
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinHeater.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinHeater;
    })();

    pond.BinLidar = (function() {

        /**
         * Properties of a BinLidar.
         * @memberof pond
         * @interface IBinLidar
         * @property {string|null} [name] BinLidar name
         * @property {string|null} [key] BinLidar key
         * @property {number|null} [distance] BinLidar distance
         */

        /**
         * Constructs a new BinLidar.
         * @memberof pond
         * @classdesc Represents a BinLidar.
         * @implements IBinLidar
         * @constructor
         * @param {pond.IBinLidar=} [properties] Properties to set
         */
        function BinLidar(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinLidar name.
         * @member {string} name
         * @memberof pond.BinLidar
         * @instance
         */
        BinLidar.prototype.name = "";

        /**
         * BinLidar key.
         * @member {string} key
         * @memberof pond.BinLidar
         * @instance
         */
        BinLidar.prototype.key = "";

        /**
         * BinLidar distance.
         * @member {number} distance
         * @memberof pond.BinLidar
         * @instance
         */
        BinLidar.prototype.distance = 0;

        /**
         * Creates a new BinLidar instance using the specified properties.
         * @function create
         * @memberof pond.BinLidar
         * @static
         * @param {pond.IBinLidar=} [properties] Properties to set
         * @returns {pond.BinLidar} BinLidar instance
         */
        BinLidar.create = function create(properties) {
            return new BinLidar(properties);
        };

        /**
         * Creates a BinLidar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinLidar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinLidar} BinLidar
         */
        BinLidar.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinLidar)
                return object;
            var message = new $root.pond.BinLidar();
            if (object.name != null)
                message.name = String(object.name);
            if (object.key != null)
                message.key = String(object.key);
            if (object.distance != null)
                message.distance = Number(object.distance);
            return message;
        };

        /**
         * Creates a plain object from a BinLidar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinLidar
         * @static
         * @param {pond.BinLidar} message BinLidar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinLidar.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.key = "";
                object.distance = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            return object;
        };

        /**
         * Converts this BinLidar to JSON.
         * @function toJSON
         * @memberof pond.BinLidar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinLidar.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinLidar;
    })();

    pond.BinCO2 = (function() {

        /**
         * Properties of a BinCO2.
         * @memberof pond
         * @interface IBinCO2
         * @property {string|null} [name] BinCO2 name
         * @property {string|null} [key] BinCO2 key
         * @property {number|null} [device] BinCO2 device
         * @property {number|null} [ppm] BinCO2 ppm
         */

        /**
         * Constructs a new BinCO2.
         * @memberof pond
         * @classdesc Represents a BinCO2.
         * @implements IBinCO2
         * @constructor
         * @param {pond.IBinCO2=} [properties] Properties to set
         */
        function BinCO2(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinCO2 name.
         * @member {string} name
         * @memberof pond.BinCO2
         * @instance
         */
        BinCO2.prototype.name = "";

        /**
         * BinCO2 key.
         * @member {string} key
         * @memberof pond.BinCO2
         * @instance
         */
        BinCO2.prototype.key = "";

        /**
         * BinCO2 device.
         * @member {number} device
         * @memberof pond.BinCO2
         * @instance
         */
        BinCO2.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * BinCO2 ppm.
         * @member {number} ppm
         * @memberof pond.BinCO2
         * @instance
         */
        BinCO2.prototype.ppm = 0;

        /**
         * Creates a new BinCO2 instance using the specified properties.
         * @function create
         * @memberof pond.BinCO2
         * @static
         * @param {pond.IBinCO2=} [properties] Properties to set
         * @returns {pond.BinCO2} BinCO2 instance
         */
        BinCO2.create = function create(properties) {
            return new BinCO2(properties);
        };

        /**
         * Creates a BinCO2 message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinCO2
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinCO2} BinCO2
         */
        BinCO2.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinCO2)
                return object;
            var message = new $root.pond.BinCO2();
            if (object.name != null)
                message.name = String(object.name);
            if (object.key != null)
                message.key = String(object.key);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.ppm != null)
                message.ppm = Number(object.ppm);
            return message;
        };

        /**
         * Creates a plain object from a BinCO2 message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinCO2
         * @static
         * @param {pond.BinCO2} message BinCO2
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinCO2.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.key = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.ppm = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.ppm != null && message.hasOwnProperty("ppm"))
                object.ppm = options.json && !isFinite(message.ppm) ? String(message.ppm) : message.ppm;
            return object;
        };

        /**
         * Converts this BinCO2 to JSON.
         * @function toJSON
         * @memberof pond.BinCO2
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinCO2.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinCO2;
    })();

    pond.BinStatus = (function() {

        /**
         * Properties of a BinStatus.
         * @memberof pond
         * @interface IBinStatus
         * @property {string|null} [timestamp] BinStatus timestamp
         * @property {string|null} [lastModeChange] BinStatus lastModeChange
         * @property {string|null} [targetMoistureEstimation] BinStatus targetMoistureEstimation
         * @property {number|null} [fanCfm] BinStatus fanCfm
         * @property {number|null} [grainMoisture] BinStatus grainMoisture
         * @property {number|null} [grainHeight] BinStatus grainHeight
         * @property {number|null} [grainBushels] BinStatus grainBushels
         * @property {number|null} [cfmPerBushel] BinStatus cfmPerBushel
         * @property {number|null} [waterLiters] BinStatus waterLiters
         * @property {number|null} [litersPerHourDrying] BinStatus litersPerHourDrying
         * @property {quack.GrainCable|null} [lastGrainCable] BinStatus lastGrainCable
         * @property {quack.HumidityAndTemperature|null} [lastPlenum] BinStatus lastPlenum
         * @property {quack.Pressure|null} [lastPressure] BinStatus lastPressure
         * @property {Array.<pond.GrainCable>|null} [grainCables] BinStatus grainCables
         * @property {Array.<pond.Plenum>|null} [plenums] BinStatus plenums
         * @property {Array.<pond.Pressure>|null} [pressures] BinStatus pressures
         * @property {Array.<pond.BinFan>|null} [fans] BinStatus fans
         * @property {Array.<pond.BinHeater>|null} [heaters] BinStatus heaters
         * @property {number|null} [distance] BinStatus distance
         * @property {Object.<string,number>|null} [grainComposition] BinStatus grainComposition
         * @property {Object.<string,number>|null} [objectSourceMap] BinStatus objectSourceMap
         * @property {Array.<pond.BinCO2>|null} [co2] BinStatus co2
         * @property {Array.<pond.BinLidar>|null} [lidars] BinStatus lidars
         */

        /**
         * Constructs a new BinStatus.
         * @memberof pond
         * @classdesc Represents a BinStatus.
         * @implements IBinStatus
         * @constructor
         * @param {pond.IBinStatus=} [properties] Properties to set
         */
        function BinStatus(properties) {
            this.grainCables = [];
            this.plenums = [];
            this.pressures = [];
            this.fans = [];
            this.heaters = [];
            this.grainComposition = {};
            this.objectSourceMap = {};
            this.co2 = [];
            this.lidars = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.timestamp = "";

        /**
         * BinStatus lastModeChange.
         * @member {string} lastModeChange
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.lastModeChange = "";

        /**
         * BinStatus targetMoistureEstimation.
         * @member {string} targetMoistureEstimation
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.targetMoistureEstimation = "";

        /**
         * BinStatus fanCfm.
         * @member {number} fanCfm
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.fanCfm = 0;

        /**
         * BinStatus grainMoisture.
         * @member {number} grainMoisture
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.grainMoisture = 0;

        /**
         * BinStatus grainHeight.
         * @member {number} grainHeight
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.grainHeight = 0;

        /**
         * BinStatus grainBushels.
         * @member {number} grainBushels
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.grainBushels = 0;

        /**
         * BinStatus cfmPerBushel.
         * @member {number} cfmPerBushel
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.cfmPerBushel = 0;

        /**
         * BinStatus waterLiters.
         * @member {number} waterLiters
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.waterLiters = 0;

        /**
         * BinStatus litersPerHourDrying.
         * @member {number} litersPerHourDrying
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.litersPerHourDrying = 0;

        /**
         * BinStatus lastGrainCable.
         * @member {quack.GrainCable|null|undefined} lastGrainCable
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.lastGrainCable = null;

        /**
         * BinStatus lastPlenum.
         * @member {quack.HumidityAndTemperature|null|undefined} lastPlenum
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.lastPlenum = null;

        /**
         * BinStatus lastPressure.
         * @member {quack.Pressure|null|undefined} lastPressure
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.lastPressure = null;

        /**
         * BinStatus grainCables.
         * @member {Array.<pond.GrainCable>} grainCables
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.grainCables = $util.emptyArray;

        /**
         * BinStatus plenums.
         * @member {Array.<pond.Plenum>} plenums
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.plenums = $util.emptyArray;

        /**
         * BinStatus pressures.
         * @member {Array.<pond.Pressure>} pressures
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.pressures = $util.emptyArray;

        /**
         * BinStatus fans.
         * @member {Array.<pond.BinFan>} fans
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.fans = $util.emptyArray;

        /**
         * BinStatus heaters.
         * @member {Array.<pond.BinHeater>} heaters
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.heaters = $util.emptyArray;

        /**
         * BinStatus distance.
         * @member {number} distance
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.distance = 0;

        /**
         * BinStatus grainComposition.
         * @member {Object.<string,number>} grainComposition
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.grainComposition = $util.emptyObject;

        /**
         * BinStatus objectSourceMap.
         * @member {Object.<string,number>} objectSourceMap
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.objectSourceMap = $util.emptyObject;

        /**
         * BinStatus co2.
         * @member {Array.<pond.BinCO2>} co2
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.co2 = $util.emptyArray;

        /**
         * BinStatus lidars.
         * @member {Array.<pond.BinLidar>} lidars
         * @memberof pond.BinStatus
         * @instance
         */
        BinStatus.prototype.lidars = $util.emptyArray;

        /**
         * Creates a new BinStatus instance using the specified properties.
         * @function create
         * @memberof pond.BinStatus
         * @static
         * @param {pond.IBinStatus=} [properties] Properties to set
         * @returns {pond.BinStatus} BinStatus instance
         */
        BinStatus.create = function create(properties) {
            return new BinStatus(properties);
        };

        /**
         * Creates a BinStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinStatus} BinStatus
         */
        BinStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinStatus)
                return object;
            var message = new $root.pond.BinStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.lastModeChange != null)
                message.lastModeChange = String(object.lastModeChange);
            if (object.targetMoistureEstimation != null)
                message.targetMoistureEstimation = String(object.targetMoistureEstimation);
            if (object.fanCfm != null)
                message.fanCfm = Number(object.fanCfm);
            if (object.grainMoisture != null)
                message.grainMoisture = Number(object.grainMoisture);
            if (object.grainHeight != null)
                message.grainHeight = Number(object.grainHeight);
            if (object.grainBushels != null)
                message.grainBushels = Number(object.grainBushels);
            if (object.cfmPerBushel != null)
                message.cfmPerBushel = Number(object.cfmPerBushel);
            if (object.waterLiters != null)
                message.waterLiters = Number(object.waterLiters);
            if (object.litersPerHourDrying != null)
                message.litersPerHourDrying = Number(object.litersPerHourDrying);
            if (object.lastGrainCable != null) {
                if (typeof object.lastGrainCable !== "object")
                    throw TypeError(".pond.BinStatus.lastGrainCable: object expected");
                message.lastGrainCable = $root.quack.GrainCable.fromObject(object.lastGrainCable);
            }
            if (object.lastPlenum != null) {
                if (typeof object.lastPlenum !== "object")
                    throw TypeError(".pond.BinStatus.lastPlenum: object expected");
                message.lastPlenum = $root.quack.HumidityAndTemperature.fromObject(object.lastPlenum);
            }
            if (object.lastPressure != null) {
                if (typeof object.lastPressure !== "object")
                    throw TypeError(".pond.BinStatus.lastPressure: object expected");
                message.lastPressure = $root.quack.Pressure.fromObject(object.lastPressure);
            }
            if (object.grainCables) {
                if (!Array.isArray(object.grainCables))
                    throw TypeError(".pond.BinStatus.grainCables: array expected");
                message.grainCables = [];
                for (var i = 0; i < object.grainCables.length; ++i) {
                    if (typeof object.grainCables[i] !== "object")
                        throw TypeError(".pond.BinStatus.grainCables: object expected");
                    message.grainCables[i] = $root.pond.GrainCable.fromObject(object.grainCables[i]);
                }
            }
            if (object.plenums) {
                if (!Array.isArray(object.plenums))
                    throw TypeError(".pond.BinStatus.plenums: array expected");
                message.plenums = [];
                for (var i = 0; i < object.plenums.length; ++i) {
                    if (typeof object.plenums[i] !== "object")
                        throw TypeError(".pond.BinStatus.plenums: object expected");
                    message.plenums[i] = $root.pond.Plenum.fromObject(object.plenums[i]);
                }
            }
            if (object.pressures) {
                if (!Array.isArray(object.pressures))
                    throw TypeError(".pond.BinStatus.pressures: array expected");
                message.pressures = [];
                for (var i = 0; i < object.pressures.length; ++i) {
                    if (typeof object.pressures[i] !== "object")
                        throw TypeError(".pond.BinStatus.pressures: object expected");
                    message.pressures[i] = $root.pond.Pressure.fromObject(object.pressures[i]);
                }
            }
            if (object.fans) {
                if (!Array.isArray(object.fans))
                    throw TypeError(".pond.BinStatus.fans: array expected");
                message.fans = [];
                for (var i = 0; i < object.fans.length; ++i) {
                    if (typeof object.fans[i] !== "object")
                        throw TypeError(".pond.BinStatus.fans: object expected");
                    message.fans[i] = $root.pond.BinFan.fromObject(object.fans[i]);
                }
            }
            if (object.heaters) {
                if (!Array.isArray(object.heaters))
                    throw TypeError(".pond.BinStatus.heaters: array expected");
                message.heaters = [];
                for (var i = 0; i < object.heaters.length; ++i) {
                    if (typeof object.heaters[i] !== "object")
                        throw TypeError(".pond.BinStatus.heaters: object expected");
                    message.heaters[i] = $root.pond.BinHeater.fromObject(object.heaters[i]);
                }
            }
            if (object.distance != null)
                message.distance = Number(object.distance);
            if (object.grainComposition) {
                if (typeof object.grainComposition !== "object")
                    throw TypeError(".pond.BinStatus.grainComposition: object expected");
                message.grainComposition = {};
                for (var keys = Object.keys(object.grainComposition), i = 0; i < keys.length; ++i)
                    message.grainComposition[keys[i]] = Number(object.grainComposition[keys[i]]);
            }
            if (object.objectSourceMap) {
                if (typeof object.objectSourceMap !== "object")
                    throw TypeError(".pond.BinStatus.objectSourceMap: object expected");
                message.objectSourceMap = {};
                for (var keys = Object.keys(object.objectSourceMap), i = 0; i < keys.length; ++i)
                    message.objectSourceMap[keys[i]] = Number(object.objectSourceMap[keys[i]]);
            }
            if (object.co2) {
                if (!Array.isArray(object.co2))
                    throw TypeError(".pond.BinStatus.co2: array expected");
                message.co2 = [];
                for (var i = 0; i < object.co2.length; ++i) {
                    if (typeof object.co2[i] !== "object")
                        throw TypeError(".pond.BinStatus.co2: object expected");
                    message.co2[i] = $root.pond.BinCO2.fromObject(object.co2[i]);
                }
            }
            if (object.lidars) {
                if (!Array.isArray(object.lidars))
                    throw TypeError(".pond.BinStatus.lidars: array expected");
                message.lidars = [];
                for (var i = 0; i < object.lidars.length; ++i) {
                    if (typeof object.lidars[i] !== "object")
                        throw TypeError(".pond.BinStatus.lidars: object expected");
                    message.lidars[i] = $root.pond.BinLidar.fromObject(object.lidars[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BinStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinStatus
         * @static
         * @param {pond.BinStatus} message BinStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.grainCables = [];
                object.plenums = [];
                object.pressures = [];
                object.fans = [];
                object.heaters = [];
                object.co2 = [];
                object.lidars = [];
            }
            if (options.objects || options.defaults) {
                object.grainComposition = {};
                object.objectSourceMap = {};
            }
            if (options.defaults) {
                object.timestamp = "";
                object.lastModeChange = "";
                object.targetMoistureEstimation = "";
                object.fanCfm = 0;
                object.grainMoisture = 0;
                object.grainHeight = 0;
                object.grainBushels = 0;
                object.cfmPerBushel = 0;
                object.waterLiters = 0;
                object.litersPerHourDrying = 0;
                object.lastGrainCable = null;
                object.lastPlenum = null;
                object.lastPressure = null;
                object.distance = 0;
            }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.lastModeChange != null && message.hasOwnProperty("lastModeChange"))
                object.lastModeChange = message.lastModeChange;
            if (message.targetMoistureEstimation != null && message.hasOwnProperty("targetMoistureEstimation"))
                object.targetMoistureEstimation = message.targetMoistureEstimation;
            if (message.fanCfm != null && message.hasOwnProperty("fanCfm"))
                object.fanCfm = options.json && !isFinite(message.fanCfm) ? String(message.fanCfm) : message.fanCfm;
            if (message.grainMoisture != null && message.hasOwnProperty("grainMoisture"))
                object.grainMoisture = options.json && !isFinite(message.grainMoisture) ? String(message.grainMoisture) : message.grainMoisture;
            if (message.grainHeight != null && message.hasOwnProperty("grainHeight"))
                object.grainHeight = options.json && !isFinite(message.grainHeight) ? String(message.grainHeight) : message.grainHeight;
            if (message.grainBushels != null && message.hasOwnProperty("grainBushels"))
                object.grainBushels = options.json && !isFinite(message.grainBushels) ? String(message.grainBushels) : message.grainBushels;
            if (message.cfmPerBushel != null && message.hasOwnProperty("cfmPerBushel"))
                object.cfmPerBushel = options.json && !isFinite(message.cfmPerBushel) ? String(message.cfmPerBushel) : message.cfmPerBushel;
            if (message.waterLiters != null && message.hasOwnProperty("waterLiters"))
                object.waterLiters = options.json && !isFinite(message.waterLiters) ? String(message.waterLiters) : message.waterLiters;
            if (message.litersPerHourDrying != null && message.hasOwnProperty("litersPerHourDrying"))
                object.litersPerHourDrying = options.json && !isFinite(message.litersPerHourDrying) ? String(message.litersPerHourDrying) : message.litersPerHourDrying;
            if (message.lastGrainCable != null && message.hasOwnProperty("lastGrainCable"))
                object.lastGrainCable = $root.quack.GrainCable.toObject(message.lastGrainCable, options);
            if (message.lastPlenum != null && message.hasOwnProperty("lastPlenum"))
                object.lastPlenum = $root.quack.HumidityAndTemperature.toObject(message.lastPlenum, options);
            if (message.lastPressure != null && message.hasOwnProperty("lastPressure"))
                object.lastPressure = $root.quack.Pressure.toObject(message.lastPressure, options);
            if (message.grainCables && message.grainCables.length) {
                object.grainCables = [];
                for (var j = 0; j < message.grainCables.length; ++j)
                    object.grainCables[j] = $root.pond.GrainCable.toObject(message.grainCables[j], options);
            }
            if (message.plenums && message.plenums.length) {
                object.plenums = [];
                for (var j = 0; j < message.plenums.length; ++j)
                    object.plenums[j] = $root.pond.Plenum.toObject(message.plenums[j], options);
            }
            if (message.pressures && message.pressures.length) {
                object.pressures = [];
                for (var j = 0; j < message.pressures.length; ++j)
                    object.pressures[j] = $root.pond.Pressure.toObject(message.pressures[j], options);
            }
            if (message.fans && message.fans.length) {
                object.fans = [];
                for (var j = 0; j < message.fans.length; ++j)
                    object.fans[j] = $root.pond.BinFan.toObject(message.fans[j], options);
            }
            if (message.heaters && message.heaters.length) {
                object.heaters = [];
                for (var j = 0; j < message.heaters.length; ++j)
                    object.heaters[j] = $root.pond.BinHeater.toObject(message.heaters[j], options);
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            var keys2;
            if (message.grainComposition && (keys2 = Object.keys(message.grainComposition)).length) {
                object.grainComposition = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.grainComposition[keys2[j]] = options.json && !isFinite(message.grainComposition[keys2[j]]) ? String(message.grainComposition[keys2[j]]) : message.grainComposition[keys2[j]];
            }
            if (message.objectSourceMap && (keys2 = Object.keys(message.objectSourceMap)).length) {
                object.objectSourceMap = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.objectSourceMap[keys2[j]] = options.json && !isFinite(message.objectSourceMap[keys2[j]]) ? String(message.objectSourceMap[keys2[j]]) : message.objectSourceMap[keys2[j]];
            }
            if (message.co2 && message.co2.length) {
                object.co2 = [];
                for (var j = 0; j < message.co2.length; ++j)
                    object.co2[j] = $root.pond.BinCO2.toObject(message.co2[j], options);
            }
            if (message.lidars && message.lidars.length) {
                object.lidars = [];
                for (var j = 0; j < message.lidars.length; ++j)
                    object.lidars[j] = $root.pond.BinLidar.toObject(message.lidars[j], options);
            }
            return object;
        };

        /**
         * Converts this BinStatus to JSON.
         * @function toJSON
         * @memberof pond.BinStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinStatus;
    })();

    pond.BinSpecs = (function() {

        /**
         * Properties of a BinSpecs.
         * @memberof pond
         * @interface IBinSpecs
         * @property {number|null} [bushelCapacity] BinSpecs bushelCapacity
         * @property {pond.BinShape|null} [shape] BinSpecs shape
         * @property {number|null} [heightCm] BinSpecs heightCm
         * @property {number|null} [diameterCm] BinSpecs diameterCm
         * @property {pond.BinAdvancedDimensions|null} [advancedDimensions] BinSpecs advancedDimensions
         * @property {number|null} [modelId] BinSpecs modelId
         * @property {boolean|null} [useAdvanced] BinSpecs useAdvanced
         */

        /**
         * Constructs a new BinSpecs.
         * @memberof pond
         * @classdesc Represents a BinSpecs.
         * @implements IBinSpecs
         * @constructor
         * @param {pond.IBinSpecs=} [properties] Properties to set
         */
        function BinSpecs(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinSpecs bushelCapacity.
         * @member {number} bushelCapacity
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.bushelCapacity = 0;

        /**
         * BinSpecs shape.
         * @member {pond.BinShape} shape
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.shape = 0;

        /**
         * BinSpecs heightCm.
         * @member {number} heightCm
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.heightCm = 0;

        /**
         * BinSpecs diameterCm.
         * @member {number} diameterCm
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.diameterCm = 0;

        /**
         * BinSpecs advancedDimensions.
         * @member {pond.BinAdvancedDimensions|null|undefined} advancedDimensions
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.advancedDimensions = null;

        /**
         * BinSpecs modelId.
         * @member {number} modelId
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.modelId = 0;

        /**
         * BinSpecs useAdvanced.
         * @member {boolean} useAdvanced
         * @memberof pond.BinSpecs
         * @instance
         */
        BinSpecs.prototype.useAdvanced = false;

        /**
         * Creates a new BinSpecs instance using the specified properties.
         * @function create
         * @memberof pond.BinSpecs
         * @static
         * @param {pond.IBinSpecs=} [properties] Properties to set
         * @returns {pond.BinSpecs} BinSpecs instance
         */
        BinSpecs.create = function create(properties) {
            return new BinSpecs(properties);
        };

        /**
         * Creates a BinSpecs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinSpecs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinSpecs} BinSpecs
         */
        BinSpecs.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinSpecs)
                return object;
            var message = new $root.pond.BinSpecs();
            if (object.bushelCapacity != null)
                message.bushelCapacity = Number(object.bushelCapacity);
            switch (object.shape) {
            case "BIN_SHAPE_UNKNOWN":
            case 0:
                message.shape = 0;
                break;
            case "BIN_SHAPE_FLAT_BOTTOM":
            case 1:
                message.shape = 1;
                break;
            case "BIN_SHAPE_HOPPER_BOTTOM":
            case 2:
                message.shape = 2;
                break;
            }
            if (object.heightCm != null)
                message.heightCm = Number(object.heightCm);
            if (object.diameterCm != null)
                message.diameterCm = Number(object.diameterCm);
            if (object.advancedDimensions != null) {
                if (typeof object.advancedDimensions !== "object")
                    throw TypeError(".pond.BinSpecs.advancedDimensions: object expected");
                message.advancedDimensions = $root.pond.BinAdvancedDimensions.fromObject(object.advancedDimensions);
            }
            if (object.modelId != null)
                message.modelId = Number(object.modelId);
            if (object.useAdvanced != null)
                message.useAdvanced = Boolean(object.useAdvanced);
            return message;
        };

        /**
         * Creates a plain object from a BinSpecs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinSpecs
         * @static
         * @param {pond.BinSpecs} message BinSpecs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinSpecs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bushelCapacity = 0;
                object.shape = options.enums === String ? "BIN_SHAPE_UNKNOWN" : 0;
                object.heightCm = 0;
                object.diameterCm = 0;
                object.advancedDimensions = null;
                object.modelId = 0;
                object.useAdvanced = false;
            }
            if (message.bushelCapacity != null && message.hasOwnProperty("bushelCapacity"))
                object.bushelCapacity = options.json && !isFinite(message.bushelCapacity) ? String(message.bushelCapacity) : message.bushelCapacity;
            if (message.shape != null && message.hasOwnProperty("shape"))
                object.shape = options.enums === String ? $root.pond.BinShape[message.shape] : message.shape;
            if (message.heightCm != null && message.hasOwnProperty("heightCm"))
                object.heightCm = options.json && !isFinite(message.heightCm) ? String(message.heightCm) : message.heightCm;
            if (message.diameterCm != null && message.hasOwnProperty("diameterCm"))
                object.diameterCm = options.json && !isFinite(message.diameterCm) ? String(message.diameterCm) : message.diameterCm;
            if (message.advancedDimensions != null && message.hasOwnProperty("advancedDimensions"))
                object.advancedDimensions = $root.pond.BinAdvancedDimensions.toObject(message.advancedDimensions, options);
            if (message.modelId != null && message.hasOwnProperty("modelId"))
                object.modelId = options.json && !isFinite(message.modelId) ? String(message.modelId) : message.modelId;
            if (message.useAdvanced != null && message.hasOwnProperty("useAdvanced"))
                object.useAdvanced = message.useAdvanced;
            return object;
        };

        /**
         * Converts this BinSpecs to JSON.
         * @function toJSON
         * @memberof pond.BinSpecs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinSpecs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinSpecs;
    })();

    pond.BinAdvancedDimensions = (function() {

        /**
         * Properties of a BinAdvancedDimensions.
         * @memberof pond
         * @interface IBinAdvancedDimensions
         * @property {number|null} [topConeHeight] BinAdvancedDimensions topConeHeight
         * @property {number|null} [sidewallHeight] BinAdvancedDimensions sidewallHeight
         * @property {number|null} [hopperHeight] BinAdvancedDimensions hopperHeight
         * @property {number|null} [roofAngle] BinAdvancedDimensions roofAngle
         * @property {number|null} [hopperAngle] BinAdvancedDimensions hopperAngle
         */

        /**
         * Constructs a new BinAdvancedDimensions.
         * @memberof pond
         * @classdesc Represents a BinAdvancedDimensions.
         * @implements IBinAdvancedDimensions
         * @constructor
         * @param {pond.IBinAdvancedDimensions=} [properties] Properties to set
         */
        function BinAdvancedDimensions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinAdvancedDimensions topConeHeight.
         * @member {number} topConeHeight
         * @memberof pond.BinAdvancedDimensions
         * @instance
         */
        BinAdvancedDimensions.prototype.topConeHeight = 0;

        /**
         * BinAdvancedDimensions sidewallHeight.
         * @member {number} sidewallHeight
         * @memberof pond.BinAdvancedDimensions
         * @instance
         */
        BinAdvancedDimensions.prototype.sidewallHeight = 0;

        /**
         * BinAdvancedDimensions hopperHeight.
         * @member {number} hopperHeight
         * @memberof pond.BinAdvancedDimensions
         * @instance
         */
        BinAdvancedDimensions.prototype.hopperHeight = 0;

        /**
         * BinAdvancedDimensions roofAngle.
         * @member {number} roofAngle
         * @memberof pond.BinAdvancedDimensions
         * @instance
         */
        BinAdvancedDimensions.prototype.roofAngle = 0;

        /**
         * BinAdvancedDimensions hopperAngle.
         * @member {number} hopperAngle
         * @memberof pond.BinAdvancedDimensions
         * @instance
         */
        BinAdvancedDimensions.prototype.hopperAngle = 0;

        /**
         * Creates a new BinAdvancedDimensions instance using the specified properties.
         * @function create
         * @memberof pond.BinAdvancedDimensions
         * @static
         * @param {pond.IBinAdvancedDimensions=} [properties] Properties to set
         * @returns {pond.BinAdvancedDimensions} BinAdvancedDimensions instance
         */
        BinAdvancedDimensions.create = function create(properties) {
            return new BinAdvancedDimensions(properties);
        };

        /**
         * Creates a BinAdvancedDimensions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinAdvancedDimensions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinAdvancedDimensions} BinAdvancedDimensions
         */
        BinAdvancedDimensions.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinAdvancedDimensions)
                return object;
            var message = new $root.pond.BinAdvancedDimensions();
            if (object.topConeHeight != null)
                message.topConeHeight = Number(object.topConeHeight);
            if (object.sidewallHeight != null)
                message.sidewallHeight = Number(object.sidewallHeight);
            if (object.hopperHeight != null)
                message.hopperHeight = Number(object.hopperHeight);
            if (object.roofAngle != null)
                message.roofAngle = Number(object.roofAngle);
            if (object.hopperAngle != null)
                message.hopperAngle = Number(object.hopperAngle);
            return message;
        };

        /**
         * Creates a plain object from a BinAdvancedDimensions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinAdvancedDimensions
         * @static
         * @param {pond.BinAdvancedDimensions} message BinAdvancedDimensions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinAdvancedDimensions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.topConeHeight = 0;
                object.sidewallHeight = 0;
                object.hopperHeight = 0;
                object.roofAngle = 0;
                object.hopperAngle = 0;
            }
            if (message.topConeHeight != null && message.hasOwnProperty("topConeHeight"))
                object.topConeHeight = options.json && !isFinite(message.topConeHeight) ? String(message.topConeHeight) : message.topConeHeight;
            if (message.sidewallHeight != null && message.hasOwnProperty("sidewallHeight"))
                object.sidewallHeight = options.json && !isFinite(message.sidewallHeight) ? String(message.sidewallHeight) : message.sidewallHeight;
            if (message.hopperHeight != null && message.hasOwnProperty("hopperHeight"))
                object.hopperHeight = options.json && !isFinite(message.hopperHeight) ? String(message.hopperHeight) : message.hopperHeight;
            if (message.roofAngle != null && message.hasOwnProperty("roofAngle"))
                object.roofAngle = options.json && !isFinite(message.roofAngle) ? String(message.roofAngle) : message.roofAngle;
            if (message.hopperAngle != null && message.hasOwnProperty("hopperAngle"))
                object.hopperAngle = options.json && !isFinite(message.hopperAngle) ? String(message.hopperAngle) : message.hopperAngle;
            return object;
        };

        /**
         * Converts this BinAdvancedDimensions to JSON.
         * @function toJSON
         * @memberof pond.BinAdvancedDimensions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinAdvancedDimensions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinAdvancedDimensions;
    })();

    /**
     * BinShape enum.
     * @name pond.BinShape
     * @enum {string}
     * @property {number} BIN_SHAPE_UNKNOWN=0 BIN_SHAPE_UNKNOWN value
     * @property {number} BIN_SHAPE_FLAT_BOTTOM=1 BIN_SHAPE_FLAT_BOTTOM value
     * @property {number} BIN_SHAPE_HOPPER_BOTTOM=2 BIN_SHAPE_HOPPER_BOTTOM value
     */
    pond.BinShape = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BIN_SHAPE_UNKNOWN"] = 0;
        values[valuesById[1] = "BIN_SHAPE_FLAT_BOTTOM"] = 1;
        values[valuesById[2] = "BIN_SHAPE_HOPPER_BOTTOM"] = 2;
        return values;
    })();

    /**
     * BinMode enum.
     * @name pond.BinMode
     * @enum {string}
     * @property {number} BIN_MODE_NONE=0 BIN_MODE_NONE value
     * @property {number} BIN_MODE_DRYING=1 BIN_MODE_DRYING value
     * @property {number} BIN_MODE_COOLDOWN=2 BIN_MODE_COOLDOWN value
     * @property {number} BIN_MODE_STORAGE=3 BIN_MODE_STORAGE value
     * @property {number} BIN_MODE_HYDRATING=4 BIN_MODE_HYDRATING value
     */
    pond.BinMode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BIN_MODE_NONE"] = 0;
        values[valuesById[1] = "BIN_MODE_DRYING"] = 1;
        values[valuesById[2] = "BIN_MODE_COOLDOWN"] = 2;
        values[valuesById[3] = "BIN_MODE_STORAGE"] = 3;
        values[valuesById[4] = "BIN_MODE_HYDRATING"] = 4;
        return values;
    })();

    pond.Fan = (function() {

        /**
         * Properties of a Fan.
         * @memberof pond
         * @interface IFan
         * @property {pond.FanType|null} [type] Fan type
         * @property {pond.FanHp|null} [size] Fan size
         */

        /**
         * Constructs a new Fan.
         * @memberof pond
         * @classdesc Represents a Fan.
         * @implements IFan
         * @constructor
         * @param {pond.IFan=} [properties] Properties to set
         */
        function Fan(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Fan type.
         * @member {pond.FanType} type
         * @memberof pond.Fan
         * @instance
         */
        Fan.prototype.type = 0;

        /**
         * Fan size.
         * @member {pond.FanHp} size
         * @memberof pond.Fan
         * @instance
         */
        Fan.prototype.size = 0;

        /**
         * Creates a new Fan instance using the specified properties.
         * @function create
         * @memberof pond.Fan
         * @static
         * @param {pond.IFan=} [properties] Properties to set
         * @returns {pond.Fan} Fan instance
         */
        Fan.create = function create(properties) {
            return new Fan(properties);
        };

        /**
         * Creates a Fan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Fan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Fan} Fan
         */
        Fan.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Fan)
                return object;
            var message = new $root.pond.Fan();
            switch (object.type) {
            case "FAN_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "FAN_TYPE_CENTRIFUGAL_INLINE":
            case 1:
                message.type = 1;
                break;
            case "FAN_TYPE_CENTRIFUGAL_LOW_SPEED":
            case 2:
                message.type = 2;
                break;
            case "FAN_TYPE_CENTRIFUGAL_HIGH_SPEED":
            case 3:
                message.type = 3;
                break;
            }
            switch (object.size) {
            case "FAN_HP_UNKNOWN":
            case 0:
                message.size = 0;
                break;
            case "FAN_HP_THREE":
            case 1:
                message.size = 1;
                break;
            case "FAN_HP_FIVE":
            case 2:
                message.size = 2;
                break;
            case "FAN_HP_SEVEN":
            case 3:
                message.size = 3;
                break;
            case "FAN_HP_SEVENPOINTFIVE":
            case 4:
                message.size = 4;
                break;
            case "FAN_HP_TEN":
            case 5:
                message.size = 5;
                break;
            case "FAN_HP_FIFTEEN":
            case 6:
                message.size = 6;
                break;
            case "FAN_HP_TWENTY":
            case 7:
                message.size = 7;
                break;
            case "FAN_HP_TWENTYFIVE":
            case 8:
                message.size = 8;
                break;
            case "FAN_HP_THIRTY":
            case 9:
                message.size = 9;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Fan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Fan
         * @static
         * @param {pond.Fan} message Fan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Fan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "FAN_TYPE_UNKNOWN" : 0;
                object.size = options.enums === String ? "FAN_HP_UNKNOWN" : 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.FanType[message.type] : message.type;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = options.enums === String ? $root.pond.FanHp[message.size] : message.size;
            return object;
        };

        /**
         * Converts this Fan to JSON.
         * @function toJSON
         * @memberof pond.Fan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Fan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Fan;
    })();

    /**
     * FanType enum.
     * @name pond.FanType
     * @enum {string}
     * @property {number} FAN_TYPE_UNKNOWN=0 FAN_TYPE_UNKNOWN value
     * @property {number} FAN_TYPE_CENTRIFUGAL_INLINE=1 FAN_TYPE_CENTRIFUGAL_INLINE value
     * @property {number} FAN_TYPE_CENTRIFUGAL_LOW_SPEED=2 FAN_TYPE_CENTRIFUGAL_LOW_SPEED value
     * @property {number} FAN_TYPE_CENTRIFUGAL_HIGH_SPEED=3 FAN_TYPE_CENTRIFUGAL_HIGH_SPEED value
     */
    pond.FanType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FAN_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "FAN_TYPE_CENTRIFUGAL_INLINE"] = 1;
        values[valuesById[2] = "FAN_TYPE_CENTRIFUGAL_LOW_SPEED"] = 2;
        values[valuesById[3] = "FAN_TYPE_CENTRIFUGAL_HIGH_SPEED"] = 3;
        return values;
    })();

    /**
     * FanHp enum.
     * @name pond.FanHp
     * @enum {string}
     * @property {number} FAN_HP_UNKNOWN=0 FAN_HP_UNKNOWN value
     * @property {number} FAN_HP_THREE=1 FAN_HP_THREE value
     * @property {number} FAN_HP_FIVE=2 FAN_HP_FIVE value
     * @property {number} FAN_HP_SEVEN=3 FAN_HP_SEVEN value
     * @property {number} FAN_HP_SEVENPOINTFIVE=4 FAN_HP_SEVENPOINTFIVE value
     * @property {number} FAN_HP_TEN=5 FAN_HP_TEN value
     * @property {number} FAN_HP_FIFTEEN=6 FAN_HP_FIFTEEN value
     * @property {number} FAN_HP_TWENTY=7 FAN_HP_TWENTY value
     * @property {number} FAN_HP_TWENTYFIVE=8 FAN_HP_TWENTYFIVE value
     * @property {number} FAN_HP_THIRTY=9 FAN_HP_THIRTY value
     */
    pond.FanHp = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FAN_HP_UNKNOWN"] = 0;
        values[valuesById[1] = "FAN_HP_THREE"] = 1;
        values[valuesById[2] = "FAN_HP_FIVE"] = 2;
        values[valuesById[3] = "FAN_HP_SEVEN"] = 3;
        values[valuesById[4] = "FAN_HP_SEVENPOINTFIVE"] = 4;
        values[valuesById[5] = "FAN_HP_TEN"] = 5;
        values[valuesById[6] = "FAN_HP_FIFTEEN"] = 6;
        values[valuesById[7] = "FAN_HP_TWENTY"] = 7;
        values[valuesById[8] = "FAN_HP_TWENTYFIVE"] = 8;
        values[valuesById[9] = "FAN_HP_THIRTY"] = 9;
        return values;
    })();

    /**
     * BinInventoryControl enum.
     * @name pond.BinInventoryControl
     * @enum {string}
     * @property {number} BIN_INVENTORY_CONTROL_UNKNOWN=0 BIN_INVENTORY_CONTROL_UNKNOWN value
     * @property {number} BIN_INVENTORY_CONTROL_MANUAL=1 BIN_INVENTORY_CONTROL_MANUAL value
     * @property {number} BIN_INVENTORY_CONTROL_AUTOMATIC=2 BIN_INVENTORY_CONTROL_AUTOMATIC value
     * @property {number} BIN_INVENTORY_CONTROL_AUTOMATIC_LIDAR=3 BIN_INVENTORY_CONTROL_AUTOMATIC_LIDAR value
     */
    pond.BinInventoryControl = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BIN_INVENTORY_CONTROL_UNKNOWN"] = 0;
        values[valuesById[1] = "BIN_INVENTORY_CONTROL_MANUAL"] = 1;
        values[valuesById[2] = "BIN_INVENTORY_CONTROL_AUTOMATIC"] = 2;
        values[valuesById[3] = "BIN_INVENTORY_CONTROL_AUTOMATIC_LIDAR"] = 3;
        return values;
    })();

    pond.BinInventory = (function() {

        /**
         * Properties of a BinInventory.
         * @memberof pond
         * @interface IBinInventory
         * @property {boolean|null} [empty] BinInventory empty
         * @property {pond.Grain|null} [grainType] BinInventory grainType
         * @property {pond.GrainUse|null} [grainUse] BinInventory grainUse
         * @property {number|null} [grainBushels] BinInventory grainBushels
         * @property {number|null} [initialMoisture] BinInventory initialMoisture
         * @property {number|null} [targetMoisture] BinInventory targetMoisture
         * @property {string|null} [initialTimestamp] BinInventory initialTimestamp
         * @property {string|null} [grainSubtype] BinInventory grainSubtype
         * @property {string|null} [customTypeName] BinInventory customTypeName
         * @property {number|null} [bushelsPerTonne] BinInventory bushelsPerTonne
         * @property {number|null} [targetTemperature] BinInventory targetTemperature
         * @property {number|null} [moistureTargetDeviation] BinInventory moistureTargetDeviation
         * @property {pond.BinInventoryControl|null} [inventoryControl] BinInventory inventoryControl
         */

        /**
         * Constructs a new BinInventory.
         * @memberof pond
         * @classdesc Represents a BinInventory.
         * @implements IBinInventory
         * @constructor
         * @param {pond.IBinInventory=} [properties] Properties to set
         */
        function BinInventory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinInventory empty.
         * @member {boolean} empty
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.empty = false;

        /**
         * BinInventory grainType.
         * @member {pond.Grain} grainType
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.grainType = 0;

        /**
         * BinInventory grainUse.
         * @member {pond.GrainUse} grainUse
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.grainUse = 0;

        /**
         * BinInventory grainBushels.
         * @member {number} grainBushels
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.grainBushels = 0;

        /**
         * BinInventory initialMoisture.
         * @member {number} initialMoisture
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.initialMoisture = 0;

        /**
         * BinInventory targetMoisture.
         * @member {number} targetMoisture
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.targetMoisture = 0;

        /**
         * BinInventory initialTimestamp.
         * @member {string} initialTimestamp
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.initialTimestamp = "";

        /**
         * BinInventory grainSubtype.
         * @member {string} grainSubtype
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.grainSubtype = "";

        /**
         * BinInventory customTypeName.
         * @member {string} customTypeName
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.customTypeName = "";

        /**
         * BinInventory bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.bushelsPerTonne = 0;

        /**
         * BinInventory targetTemperature.
         * @member {number} targetTemperature
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.targetTemperature = 0;

        /**
         * BinInventory moistureTargetDeviation.
         * @member {number} moistureTargetDeviation
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.moistureTargetDeviation = 0;

        /**
         * BinInventory inventoryControl.
         * @member {pond.BinInventoryControl} inventoryControl
         * @memberof pond.BinInventory
         * @instance
         */
        BinInventory.prototype.inventoryControl = 0;

        /**
         * Creates a new BinInventory instance using the specified properties.
         * @function create
         * @memberof pond.BinInventory
         * @static
         * @param {pond.IBinInventory=} [properties] Properties to set
         * @returns {pond.BinInventory} BinInventory instance
         */
        BinInventory.create = function create(properties) {
            return new BinInventory(properties);
        };

        /**
         * Creates a BinInventory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinInventory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinInventory} BinInventory
         */
        BinInventory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinInventory)
                return object;
            var message = new $root.pond.BinInventory();
            if (object.empty != null)
                message.empty = Boolean(object.empty);
            switch (object.grainType) {
            case "GRAIN_INVALID":
            case 0:
                message.grainType = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.grainType = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.grainType = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.grainType = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.grainType = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.grainType = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.grainType = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.grainType = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.grainType = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.grainType = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.grainType = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.grainType = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.grainType = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.grainType = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.grainType = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.grainType = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.grainType = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.grainType = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.grainType = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.grainType = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.grainType = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.grainType = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.grainType = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.grainType = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.grainType = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.grainType = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.grainType = 26;
                break;
            }
            switch (object.grainUse) {
            case "GRAIN_USE_UNKNOWN":
            case 0:
                message.grainUse = 0;
                break;
            case "GRAIN_USE_SEED":
            case 1:
                message.grainUse = 1;
                break;
            case "GRAIN_USE_COMMERCIAL":
            case 2:
                message.grainUse = 2;
                break;
            case "GRAIN_USE_FEED":
            case 3:
                message.grainUse = 3;
                break;
            }
            if (object.grainBushels != null)
                message.grainBushels = Number(object.grainBushels);
            if (object.initialMoisture != null)
                message.initialMoisture = Number(object.initialMoisture);
            if (object.targetMoisture != null)
                message.targetMoisture = Number(object.targetMoisture);
            if (object.initialTimestamp != null)
                message.initialTimestamp = String(object.initialTimestamp);
            if (object.grainSubtype != null)
                message.grainSubtype = String(object.grainSubtype);
            if (object.customTypeName != null)
                message.customTypeName = String(object.customTypeName);
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            if (object.targetTemperature != null)
                message.targetTemperature = Number(object.targetTemperature);
            if (object.moistureTargetDeviation != null)
                message.moistureTargetDeviation = Number(object.moistureTargetDeviation);
            switch (object.inventoryControl) {
            case "BIN_INVENTORY_CONTROL_UNKNOWN":
            case 0:
                message.inventoryControl = 0;
                break;
            case "BIN_INVENTORY_CONTROL_MANUAL":
            case 1:
                message.inventoryControl = 1;
                break;
            case "BIN_INVENTORY_CONTROL_AUTOMATIC":
            case 2:
                message.inventoryControl = 2;
                break;
            case "BIN_INVENTORY_CONTROL_AUTOMATIC_LIDAR":
            case 3:
                message.inventoryControl = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a BinInventory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinInventory
         * @static
         * @param {pond.BinInventory} message BinInventory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinInventory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.empty = false;
                object.grainType = options.enums === String ? "GRAIN_INVALID" : 0;
                object.grainUse = options.enums === String ? "GRAIN_USE_UNKNOWN" : 0;
                object.grainBushels = 0;
                object.initialMoisture = 0;
                object.targetMoisture = 0;
                object.initialTimestamp = "";
                object.grainSubtype = "";
                object.customTypeName = "";
                object.bushelsPerTonne = 0;
                object.targetTemperature = 0;
                object.moistureTargetDeviation = 0;
                object.inventoryControl = options.enums === String ? "BIN_INVENTORY_CONTROL_UNKNOWN" : 0;
            }
            if (message.empty != null && message.hasOwnProperty("empty"))
                object.empty = message.empty;
            if (message.grainType != null && message.hasOwnProperty("grainType"))
                object.grainType = options.enums === String ? $root.pond.Grain[message.grainType] : message.grainType;
            if (message.grainUse != null && message.hasOwnProperty("grainUse"))
                object.grainUse = options.enums === String ? $root.pond.GrainUse[message.grainUse] : message.grainUse;
            if (message.grainBushels != null && message.hasOwnProperty("grainBushels"))
                object.grainBushels = options.json && !isFinite(message.grainBushels) ? String(message.grainBushels) : message.grainBushels;
            if (message.initialMoisture != null && message.hasOwnProperty("initialMoisture"))
                object.initialMoisture = options.json && !isFinite(message.initialMoisture) ? String(message.initialMoisture) : message.initialMoisture;
            if (message.targetMoisture != null && message.hasOwnProperty("targetMoisture"))
                object.targetMoisture = options.json && !isFinite(message.targetMoisture) ? String(message.targetMoisture) : message.targetMoisture;
            if (message.initialTimestamp != null && message.hasOwnProperty("initialTimestamp"))
                object.initialTimestamp = message.initialTimestamp;
            if (message.grainSubtype != null && message.hasOwnProperty("grainSubtype"))
                object.grainSubtype = message.grainSubtype;
            if (message.customTypeName != null && message.hasOwnProperty("customTypeName"))
                object.customTypeName = message.customTypeName;
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            if (message.targetTemperature != null && message.hasOwnProperty("targetTemperature"))
                object.targetTemperature = options.json && !isFinite(message.targetTemperature) ? String(message.targetTemperature) : message.targetTemperature;
            if (message.moistureTargetDeviation != null && message.hasOwnProperty("moistureTargetDeviation"))
                object.moistureTargetDeviation = options.json && !isFinite(message.moistureTargetDeviation) ? String(message.moistureTargetDeviation) : message.moistureTargetDeviation;
            if (message.inventoryControl != null && message.hasOwnProperty("inventoryControl"))
                object.inventoryControl = options.enums === String ? $root.pond.BinInventoryControl[message.inventoryControl] : message.inventoryControl;
            return object;
        };

        /**
         * Converts this BinInventory to JSON.
         * @function toJSON
         * @memberof pond.BinInventory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinInventory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinInventory;
    })();

    /**
     * GrainUse enum.
     * @name pond.GrainUse
     * @enum {string}
     * @property {number} GRAIN_USE_UNKNOWN=0 GRAIN_USE_UNKNOWN value
     * @property {number} GRAIN_USE_SEED=1 GRAIN_USE_SEED value
     * @property {number} GRAIN_USE_COMMERCIAL=2 GRAIN_USE_COMMERCIAL value
     * @property {number} GRAIN_USE_FEED=3 GRAIN_USE_FEED value
     */
    pond.GrainUse = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GRAIN_USE_UNKNOWN"] = 0;
        values[valuesById[1] = "GRAIN_USE_SEED"] = 1;
        values[valuesById[2] = "GRAIN_USE_COMMERCIAL"] = 2;
        values[valuesById[3] = "GRAIN_USE_FEED"] = 3;
        return values;
    })();

    pond.AddBinRequest = (function() {

        /**
         * Properties of an AddBinRequest.
         * @memberof pond
         * @interface IAddBinRequest
         * @property {pond.BinSettings|null} [bin] AddBinRequest bin
         */

        /**
         * Constructs a new AddBinRequest.
         * @memberof pond
         * @classdesc Represents an AddBinRequest.
         * @implements IAddBinRequest
         * @constructor
         * @param {pond.IAddBinRequest=} [properties] Properties to set
         */
        function AddBinRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBinRequest bin.
         * @member {pond.BinSettings|null|undefined} bin
         * @memberof pond.AddBinRequest
         * @instance
         */
        AddBinRequest.prototype.bin = null;

        /**
         * Creates a new AddBinRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddBinRequest
         * @static
         * @param {pond.IAddBinRequest=} [properties] Properties to set
         * @returns {pond.AddBinRequest} AddBinRequest instance
         */
        AddBinRequest.create = function create(properties) {
            return new AddBinRequest(properties);
        };

        /**
         * Creates an AddBinRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinRequest} AddBinRequest
         */
        AddBinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinRequest)
                return object;
            var message = new $root.pond.AddBinRequest();
            if (object.bin != null) {
                if (typeof object.bin !== "object")
                    throw TypeError(".pond.AddBinRequest.bin: object expected");
                message.bin = $root.pond.BinSettings.fromObject(object.bin);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddBinRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinRequest
         * @static
         * @param {pond.AddBinRequest} message AddBinRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = null;
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = $root.pond.BinSettings.toObject(message.bin, options);
            return object;
        };

        /**
         * Converts this AddBinRequest to JSON.
         * @function toJSON
         * @memberof pond.AddBinRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinRequest;
    })();

    pond.AddBinResponse = (function() {

        /**
         * Properties of an AddBinResponse.
         * @memberof pond
         * @interface IAddBinResponse
         * @property {string|null} [bin] AddBinResponse bin
         */

        /**
         * Constructs a new AddBinResponse.
         * @memberof pond
         * @classdesc Represents an AddBinResponse.
         * @implements IAddBinResponse
         * @constructor
         * @param {pond.IAddBinResponse=} [properties] Properties to set
         */
        function AddBinResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBinResponse bin.
         * @member {string} bin
         * @memberof pond.AddBinResponse
         * @instance
         */
        AddBinResponse.prototype.bin = "";

        /**
         * Creates a new AddBinResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddBinResponse
         * @static
         * @param {pond.IAddBinResponse=} [properties] Properties to set
         * @returns {pond.AddBinResponse} AddBinResponse instance
         */
        AddBinResponse.create = function create(properties) {
            return new AddBinResponse(properties);
        };

        /**
         * Creates an AddBinResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinResponse} AddBinResponse
         */
        AddBinResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinResponse)
                return object;
            var message = new $root.pond.AddBinResponse();
            if (object.bin != null)
                message.bin = String(object.bin);
            return message;
        };

        /**
         * Creates a plain object from an AddBinResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinResponse
         * @static
         * @param {pond.AddBinResponse} message AddBinResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            return object;
        };

        /**
         * Converts this AddBinResponse to JSON.
         * @function toJSON
         * @memberof pond.AddBinResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinResponse;
    })();

    pond.AddBinComponentRequest = (function() {

        /**
         * Properties of an AddBinComponentRequest.
         * @memberof pond
         * @interface IAddBinComponentRequest
         * @property {string|null} [bin] AddBinComponentRequest bin
         * @property {number|null} [device] AddBinComponentRequest device
         * @property {string|null} [component] AddBinComponentRequest component
         * @property {pond.BinComponent|null} [pref] AddBinComponentRequest pref
         * @property {number|null} [node] AddBinComponentRequest node
         */

        /**
         * Constructs a new AddBinComponentRequest.
         * @memberof pond
         * @classdesc Represents an AddBinComponentRequest.
         * @implements IAddBinComponentRequest
         * @constructor
         * @param {pond.IAddBinComponentRequest=} [properties] Properties to set
         */
        function AddBinComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBinComponentRequest bin.
         * @member {string} bin
         * @memberof pond.AddBinComponentRequest
         * @instance
         */
        AddBinComponentRequest.prototype.bin = "";

        /**
         * AddBinComponentRequest device.
         * @member {number} device
         * @memberof pond.AddBinComponentRequest
         * @instance
         */
        AddBinComponentRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddBinComponentRequest component.
         * @member {string} component
         * @memberof pond.AddBinComponentRequest
         * @instance
         */
        AddBinComponentRequest.prototype.component = "";

        /**
         * AddBinComponentRequest pref.
         * @member {pond.BinComponent} pref
         * @memberof pond.AddBinComponentRequest
         * @instance
         */
        AddBinComponentRequest.prototype.pref = 0;

        /**
         * AddBinComponentRequest node.
         * @member {number} node
         * @memberof pond.AddBinComponentRequest
         * @instance
         */
        AddBinComponentRequest.prototype.node = 0;

        /**
         * Creates a new AddBinComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddBinComponentRequest
         * @static
         * @param {pond.IAddBinComponentRequest=} [properties] Properties to set
         * @returns {pond.AddBinComponentRequest} AddBinComponentRequest instance
         */
        AddBinComponentRequest.create = function create(properties) {
            return new AddBinComponentRequest(properties);
        };

        /**
         * Creates an AddBinComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinComponentRequest} AddBinComponentRequest
         */
        AddBinComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinComponentRequest)
                return object;
            var message = new $root.pond.AddBinComponentRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null)
                message.component = String(object.component);
            switch (object.pref) {
            case "BIN_COMPONENT_UNKNOWN":
            case 0:
                message.pref = 0;
                break;
            case "BIN_COMPONENT_GRAIN_CABLE":
            case 1:
                message.pref = 1;
                break;
            case "BIN_COMPONENT_PLENUM":
            case 2:
                message.pref = 2;
                break;
            case "BIN_COMPONENT_SECOND_PLENUM":
            case 3:
                message.pref = 3;
                break;
            case "BIN_COMPONENT_HEATER":
            case 4:
                message.pref = 4;
                break;
            case "BIN_COMPONENT_FAN":
            case 5:
                message.pref = 5;
                break;
            case "BIN_COMPONENT_PRESSURE":
            case 6:
                message.pref = 6;
                break;
            case "BIN_COMPONENT_HEADSPACE":
            case 7:
                message.pref = 7;
                break;
            case "BIN_COMPONENT_AMBIENT":
            case 8:
                message.pref = 8;
                break;
            }
            if (object.node != null)
                message.node = object.node >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AddBinComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinComponentRequest
         * @static
         * @param {pond.AddBinComponentRequest} message AddBinComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = "";
                object.pref = options.enums === String ? "BIN_COMPONENT_UNKNOWN" : 0;
                object.node = 0;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.pref != null && message.hasOwnProperty("pref"))
                object.pref = options.enums === String ? $root.pond.BinComponent[message.pref] : message.pref;
            if (message.node != null && message.hasOwnProperty("node"))
                object.node = message.node;
            return object;
        };

        /**
         * Converts this AddBinComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.AddBinComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinComponentRequest;
    })();

    pond.AddBinComponentResponse = (function() {

        /**
         * Properties of an AddBinComponentResponse.
         * @memberof pond
         * @interface IAddBinComponentResponse
         */

        /**
         * Constructs a new AddBinComponentResponse.
         * @memberof pond
         * @classdesc Represents an AddBinComponentResponse.
         * @implements IAddBinComponentResponse
         * @constructor
         * @param {pond.IAddBinComponentResponse=} [properties] Properties to set
         */
        function AddBinComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddBinComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddBinComponentResponse
         * @static
         * @param {pond.IAddBinComponentResponse=} [properties] Properties to set
         * @returns {pond.AddBinComponentResponse} AddBinComponentResponse instance
         */
        AddBinComponentResponse.create = function create(properties) {
            return new AddBinComponentResponse(properties);
        };

        /**
         * Creates an AddBinComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBinComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBinComponentResponse} AddBinComponentResponse
         */
        AddBinComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBinComponentResponse)
                return object;
            return new $root.pond.AddBinComponentResponse();
        };

        /**
         * Creates a plain object from an AddBinComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBinComponentResponse
         * @static
         * @param {pond.AddBinComponentResponse} message AddBinComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBinComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddBinComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.AddBinComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBinComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBinComponentResponse;
    })();

    pond.RemoveBinComponentRequest = (function() {

        /**
         * Properties of a RemoveBinComponentRequest.
         * @memberof pond
         * @interface IRemoveBinComponentRequest
         * @property {string|null} [bin] RemoveBinComponentRequest bin
         * @property {string|null} [component] RemoveBinComponentRequest component
         */

        /**
         * Constructs a new RemoveBinComponentRequest.
         * @memberof pond
         * @classdesc Represents a RemoveBinComponentRequest.
         * @implements IRemoveBinComponentRequest
         * @constructor
         * @param {pond.IRemoveBinComponentRequest=} [properties] Properties to set
         */
        function RemoveBinComponentRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveBinComponentRequest bin.
         * @member {string} bin
         * @memberof pond.RemoveBinComponentRequest
         * @instance
         */
        RemoveBinComponentRequest.prototype.bin = "";

        /**
         * RemoveBinComponentRequest component.
         * @member {string} component
         * @memberof pond.RemoveBinComponentRequest
         * @instance
         */
        RemoveBinComponentRequest.prototype.component = "";

        /**
         * Creates a new RemoveBinComponentRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinComponentRequest
         * @static
         * @param {pond.IRemoveBinComponentRequest=} [properties] Properties to set
         * @returns {pond.RemoveBinComponentRequest} RemoveBinComponentRequest instance
         */
        RemoveBinComponentRequest.create = function create(properties) {
            return new RemoveBinComponentRequest(properties);
        };

        /**
         * Creates a RemoveBinComponentRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinComponentRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinComponentRequest} RemoveBinComponentRequest
         */
        RemoveBinComponentRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinComponentRequest)
                return object;
            var message = new $root.pond.RemoveBinComponentRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.component != null)
                message.component = String(object.component);
            return message;
        };

        /**
         * Creates a plain object from a RemoveBinComponentRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinComponentRequest
         * @static
         * @param {pond.RemoveBinComponentRequest} message RemoveBinComponentRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinComponentRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                object.component = "";
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            return object;
        };

        /**
         * Converts this RemoveBinComponentRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinComponentRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinComponentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinComponentRequest;
    })();

    pond.RemoveBinComponentResponse = (function() {

        /**
         * Properties of a RemoveBinComponentResponse.
         * @memberof pond
         * @interface IRemoveBinComponentResponse
         */

        /**
         * Constructs a new RemoveBinComponentResponse.
         * @memberof pond
         * @classdesc Represents a RemoveBinComponentResponse.
         * @implements IRemoveBinComponentResponse
         * @constructor
         * @param {pond.IRemoveBinComponentResponse=} [properties] Properties to set
         */
        function RemoveBinComponentResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveBinComponentResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinComponentResponse
         * @static
         * @param {pond.IRemoveBinComponentResponse=} [properties] Properties to set
         * @returns {pond.RemoveBinComponentResponse} RemoveBinComponentResponse instance
         */
        RemoveBinComponentResponse.create = function create(properties) {
            return new RemoveBinComponentResponse(properties);
        };

        /**
         * Creates a RemoveBinComponentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinComponentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinComponentResponse} RemoveBinComponentResponse
         */
        RemoveBinComponentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinComponentResponse)
                return object;
            return new $root.pond.RemoveBinComponentResponse();
        };

        /**
         * Creates a plain object from a RemoveBinComponentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinComponentResponse
         * @static
         * @param {pond.RemoveBinComponentResponse} message RemoveBinComponentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinComponentResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveBinComponentResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinComponentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinComponentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinComponentResponse;
    })();

    pond.RemoveAllBinComponentsRequest = (function() {

        /**
         * Properties of a RemoveAllBinComponentsRequest.
         * @memberof pond
         * @interface IRemoveAllBinComponentsRequest
         * @property {string|null} [bin] RemoveAllBinComponentsRequest bin
         */

        /**
         * Constructs a new RemoveAllBinComponentsRequest.
         * @memberof pond
         * @classdesc Represents a RemoveAllBinComponentsRequest.
         * @implements IRemoveAllBinComponentsRequest
         * @constructor
         * @param {pond.IRemoveAllBinComponentsRequest=} [properties] Properties to set
         */
        function RemoveAllBinComponentsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveAllBinComponentsRequest bin.
         * @member {string} bin
         * @memberof pond.RemoveAllBinComponentsRequest
         * @instance
         */
        RemoveAllBinComponentsRequest.prototype.bin = "";

        /**
         * Creates a new RemoveAllBinComponentsRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveAllBinComponentsRequest
         * @static
         * @param {pond.IRemoveAllBinComponentsRequest=} [properties] Properties to set
         * @returns {pond.RemoveAllBinComponentsRequest} RemoveAllBinComponentsRequest instance
         */
        RemoveAllBinComponentsRequest.create = function create(properties) {
            return new RemoveAllBinComponentsRequest(properties);
        };

        /**
         * Creates a RemoveAllBinComponentsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveAllBinComponentsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveAllBinComponentsRequest} RemoveAllBinComponentsRequest
         */
        RemoveAllBinComponentsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveAllBinComponentsRequest)
                return object;
            var message = new $root.pond.RemoveAllBinComponentsRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            return message;
        };

        /**
         * Creates a plain object from a RemoveAllBinComponentsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveAllBinComponentsRequest
         * @static
         * @param {pond.RemoveAllBinComponentsRequest} message RemoveAllBinComponentsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveAllBinComponentsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            return object;
        };

        /**
         * Converts this RemoveAllBinComponentsRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveAllBinComponentsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveAllBinComponentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveAllBinComponentsRequest;
    })();

    pond.RemoveAllBinComponentsResponse = (function() {

        /**
         * Properties of a RemoveAllBinComponentsResponse.
         * @memberof pond
         * @interface IRemoveAllBinComponentsResponse
         */

        /**
         * Constructs a new RemoveAllBinComponentsResponse.
         * @memberof pond
         * @classdesc Represents a RemoveAllBinComponentsResponse.
         * @implements IRemoveAllBinComponentsResponse
         * @constructor
         * @param {pond.IRemoveAllBinComponentsResponse=} [properties] Properties to set
         */
        function RemoveAllBinComponentsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveAllBinComponentsResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveAllBinComponentsResponse
         * @static
         * @param {pond.IRemoveAllBinComponentsResponse=} [properties] Properties to set
         * @returns {pond.RemoveAllBinComponentsResponse} RemoveAllBinComponentsResponse instance
         */
        RemoveAllBinComponentsResponse.create = function create(properties) {
            return new RemoveAllBinComponentsResponse(properties);
        };

        /**
         * Creates a RemoveAllBinComponentsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveAllBinComponentsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveAllBinComponentsResponse} RemoveAllBinComponentsResponse
         */
        RemoveAllBinComponentsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveAllBinComponentsResponse)
                return object;
            return new $root.pond.RemoveAllBinComponentsResponse();
        };

        /**
         * Creates a plain object from a RemoveAllBinComponentsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveAllBinComponentsResponse
         * @static
         * @param {pond.RemoveAllBinComponentsResponse} message RemoveAllBinComponentsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveAllBinComponentsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveAllBinComponentsResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveAllBinComponentsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveAllBinComponentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveAllBinComponentsResponse;
    })();

    pond.NewTopNode = (function() {

        /**
         * Properties of a NewTopNode.
         * @memberof pond
         * @interface INewTopNode
         * @property {number|null} [device] NewTopNode device
         * @property {string|null} [cableKey] NewTopNode cableKey
         * @property {number|null} [nodeNumber] NewTopNode nodeNumber
         */

        /**
         * Constructs a new NewTopNode.
         * @memberof pond
         * @classdesc Represents a NewTopNode.
         * @implements INewTopNode
         * @constructor
         * @param {pond.INewTopNode=} [properties] Properties to set
         */
        function NewTopNode(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NewTopNode device.
         * @member {number} device
         * @memberof pond.NewTopNode
         * @instance
         */
        NewTopNode.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * NewTopNode cableKey.
         * @member {string} cableKey
         * @memberof pond.NewTopNode
         * @instance
         */
        NewTopNode.prototype.cableKey = "";

        /**
         * NewTopNode nodeNumber.
         * @member {number} nodeNumber
         * @memberof pond.NewTopNode
         * @instance
         */
        NewTopNode.prototype.nodeNumber = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new NewTopNode instance using the specified properties.
         * @function create
         * @memberof pond.NewTopNode
         * @static
         * @param {pond.INewTopNode=} [properties] Properties to set
         * @returns {pond.NewTopNode} NewTopNode instance
         */
        NewTopNode.create = function create(properties) {
            return new NewTopNode(properties);
        };

        /**
         * Creates a NewTopNode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NewTopNode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NewTopNode} NewTopNode
         */
        NewTopNode.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NewTopNode)
                return object;
            var message = new $root.pond.NewTopNode();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.cableKey != null)
                message.cableKey = String(object.cableKey);
            if (object.nodeNumber != null)
                if ($util.Long)
                    (message.nodeNumber = $util.Long.fromValue(object.nodeNumber)).unsigned = true;
                else if (typeof object.nodeNumber === "string")
                    message.nodeNumber = parseInt(object.nodeNumber, 10);
                else if (typeof object.nodeNumber === "number")
                    message.nodeNumber = object.nodeNumber;
                else if (typeof object.nodeNumber === "object")
                    message.nodeNumber = new $util.LongBits(object.nodeNumber.low >>> 0, object.nodeNumber.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a NewTopNode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NewTopNode
         * @static
         * @param {pond.NewTopNode} message NewTopNode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NewTopNode.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.cableKey = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.nodeNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.nodeNumber = options.longs === String ? "0" : 0;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.cableKey != null && message.hasOwnProperty("cableKey"))
                object.cableKey = message.cableKey;
            if (message.nodeNumber != null && message.hasOwnProperty("nodeNumber"))
                if (typeof message.nodeNumber === "number")
                    object.nodeNumber = options.longs === String ? String(message.nodeNumber) : message.nodeNumber;
                else
                    object.nodeNumber = options.longs === String ? $util.Long.prototype.toString.call(message.nodeNumber) : options.longs === Number ? new $util.LongBits(message.nodeNumber.low >>> 0, message.nodeNumber.high >>> 0).toNumber(true) : message.nodeNumber;
            return object;
        };

        /**
         * Converts this NewTopNode to JSON.
         * @function toJSON
         * @memberof pond.NewTopNode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NewTopNode.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NewTopNode;
    })();

    pond.TopNodeList = (function() {

        /**
         * Properties of a TopNodeList.
         * @memberof pond
         * @interface ITopNodeList
         * @property {Array.<pond.NewTopNode>|null} [newTopNodes] TopNodeList newTopNodes
         */

        /**
         * Constructs a new TopNodeList.
         * @memberof pond
         * @classdesc Represents a TopNodeList.
         * @implements ITopNodeList
         * @constructor
         * @param {pond.ITopNodeList=} [properties] Properties to set
         */
        function TopNodeList(properties) {
            this.newTopNodes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TopNodeList newTopNodes.
         * @member {Array.<pond.NewTopNode>} newTopNodes
         * @memberof pond.TopNodeList
         * @instance
         */
        TopNodeList.prototype.newTopNodes = $util.emptyArray;

        /**
         * Creates a new TopNodeList instance using the specified properties.
         * @function create
         * @memberof pond.TopNodeList
         * @static
         * @param {pond.ITopNodeList=} [properties] Properties to set
         * @returns {pond.TopNodeList} TopNodeList instance
         */
        TopNodeList.create = function create(properties) {
            return new TopNodeList(properties);
        };

        /**
         * Creates a TopNodeList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TopNodeList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TopNodeList} TopNodeList
         */
        TopNodeList.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TopNodeList)
                return object;
            var message = new $root.pond.TopNodeList();
            if (object.newTopNodes) {
                if (!Array.isArray(object.newTopNodes))
                    throw TypeError(".pond.TopNodeList.newTopNodes: array expected");
                message.newTopNodes = [];
                for (var i = 0; i < object.newTopNodes.length; ++i) {
                    if (typeof object.newTopNodes[i] !== "object")
                        throw TypeError(".pond.TopNodeList.newTopNodes: object expected");
                    message.newTopNodes[i] = $root.pond.NewTopNode.fromObject(object.newTopNodes[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TopNodeList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TopNodeList
         * @static
         * @param {pond.TopNodeList} message TopNodeList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TopNodeList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.newTopNodes = [];
            if (message.newTopNodes && message.newTopNodes.length) {
                object.newTopNodes = [];
                for (var j = 0; j < message.newTopNodes.length; ++j)
                    object.newTopNodes[j] = $root.pond.NewTopNode.toObject(message.newTopNodes[j], options);
            }
            return object;
        };

        /**
         * Converts this TopNodeList to JSON.
         * @function toJSON
         * @memberof pond.TopNodeList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TopNodeList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TopNodeList;
    })();

    pond.UpdateTopNodesRequest = (function() {

        /**
         * Properties of an UpdateTopNodesRequest.
         * @memberof pond
         * @interface IUpdateTopNodesRequest
         * @property {string|null} [binKey] UpdateTopNodesRequest binKey
         * @property {pond.TopNodeList|null} [nodeList] UpdateTopNodesRequest nodeList
         */

        /**
         * Constructs a new UpdateTopNodesRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTopNodesRequest.
         * @implements IUpdateTopNodesRequest
         * @constructor
         * @param {pond.IUpdateTopNodesRequest=} [properties] Properties to set
         */
        function UpdateTopNodesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTopNodesRequest binKey.
         * @member {string} binKey
         * @memberof pond.UpdateTopNodesRequest
         * @instance
         */
        UpdateTopNodesRequest.prototype.binKey = "";

        /**
         * UpdateTopNodesRequest nodeList.
         * @member {pond.TopNodeList|null|undefined} nodeList
         * @memberof pond.UpdateTopNodesRequest
         * @instance
         */
        UpdateTopNodesRequest.prototype.nodeList = null;

        /**
         * Creates a new UpdateTopNodesRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTopNodesRequest
         * @static
         * @param {pond.IUpdateTopNodesRequest=} [properties] Properties to set
         * @returns {pond.UpdateTopNodesRequest} UpdateTopNodesRequest instance
         */
        UpdateTopNodesRequest.create = function create(properties) {
            return new UpdateTopNodesRequest(properties);
        };

        /**
         * Creates an UpdateTopNodesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTopNodesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTopNodesRequest} UpdateTopNodesRequest
         */
        UpdateTopNodesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTopNodesRequest)
                return object;
            var message = new $root.pond.UpdateTopNodesRequest();
            if (object.binKey != null)
                message.binKey = String(object.binKey);
            if (object.nodeList != null) {
                if (typeof object.nodeList !== "object")
                    throw TypeError(".pond.UpdateTopNodesRequest.nodeList: object expected");
                message.nodeList = $root.pond.TopNodeList.fromObject(object.nodeList);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTopNodesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTopNodesRequest
         * @static
         * @param {pond.UpdateTopNodesRequest} message UpdateTopNodesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTopNodesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.binKey = "";
                object.nodeList = null;
            }
            if (message.binKey != null && message.hasOwnProperty("binKey"))
                object.binKey = message.binKey;
            if (message.nodeList != null && message.hasOwnProperty("nodeList"))
                object.nodeList = $root.pond.TopNodeList.toObject(message.nodeList, options);
            return object;
        };

        /**
         * Converts this UpdateTopNodesRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTopNodesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTopNodesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTopNodesRequest;
    })();

    pond.UpdateTopNodesResponse = (function() {

        /**
         * Properties of an UpdateTopNodesResponse.
         * @memberof pond
         * @interface IUpdateTopNodesResponse
         */

        /**
         * Constructs a new UpdateTopNodesResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTopNodesResponse.
         * @implements IUpdateTopNodesResponse
         * @constructor
         * @param {pond.IUpdateTopNodesResponse=} [properties] Properties to set
         */
        function UpdateTopNodesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateTopNodesResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTopNodesResponse
         * @static
         * @param {pond.IUpdateTopNodesResponse=} [properties] Properties to set
         * @returns {pond.UpdateTopNodesResponse} UpdateTopNodesResponse instance
         */
        UpdateTopNodesResponse.create = function create(properties) {
            return new UpdateTopNodesResponse(properties);
        };

        /**
         * Creates an UpdateTopNodesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTopNodesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTopNodesResponse} UpdateTopNodesResponse
         */
        UpdateTopNodesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTopNodesResponse)
                return object;
            return new $root.pond.UpdateTopNodesResponse();
        };

        /**
         * Creates a plain object from an UpdateTopNodesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTopNodesResponse
         * @static
         * @param {pond.UpdateTopNodesResponse} message UpdateTopNodesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTopNodesResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateTopNodesResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTopNodesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTopNodesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTopNodesResponse;
    })();

    pond.GetBinsTrendDataRequest = (function() {

        /**
         * Properties of a GetBinsTrendDataRequest.
         * @memberof pond
         * @interface IGetBinsTrendDataRequest
         * @property {Array.<string>|null} [binKeys] GetBinsTrendDataRequest binKeys
         * @property {number|null} [trendDays] GetBinsTrendDataRequest trendDays
         */

        /**
         * Constructs a new GetBinsTrendDataRequest.
         * @memberof pond
         * @classdesc Represents a GetBinsTrendDataRequest.
         * @implements IGetBinsTrendDataRequest
         * @constructor
         * @param {pond.IGetBinsTrendDataRequest=} [properties] Properties to set
         */
        function GetBinsTrendDataRequest(properties) {
            this.binKeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinsTrendDataRequest binKeys.
         * @member {Array.<string>} binKeys
         * @memberof pond.GetBinsTrendDataRequest
         * @instance
         */
        GetBinsTrendDataRequest.prototype.binKeys = $util.emptyArray;

        /**
         * GetBinsTrendDataRequest trendDays.
         * @member {number} trendDays
         * @memberof pond.GetBinsTrendDataRequest
         * @instance
         */
        GetBinsTrendDataRequest.prototype.trendDays = 0;

        /**
         * Creates a new GetBinsTrendDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBinsTrendDataRequest
         * @static
         * @param {pond.IGetBinsTrendDataRequest=} [properties] Properties to set
         * @returns {pond.GetBinsTrendDataRequest} GetBinsTrendDataRequest instance
         */
        GetBinsTrendDataRequest.create = function create(properties) {
            return new GetBinsTrendDataRequest(properties);
        };

        /**
         * Creates a GetBinsTrendDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinsTrendDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinsTrendDataRequest} GetBinsTrendDataRequest
         */
        GetBinsTrendDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinsTrendDataRequest)
                return object;
            var message = new $root.pond.GetBinsTrendDataRequest();
            if (object.binKeys) {
                if (!Array.isArray(object.binKeys))
                    throw TypeError(".pond.GetBinsTrendDataRequest.binKeys: array expected");
                message.binKeys = [];
                for (var i = 0; i < object.binKeys.length; ++i)
                    message.binKeys[i] = String(object.binKeys[i]);
            }
            if (object.trendDays != null)
                message.trendDays = object.trendDays >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetBinsTrendDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinsTrendDataRequest
         * @static
         * @param {pond.GetBinsTrendDataRequest} message GetBinsTrendDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinsTrendDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.binKeys = [];
            if (options.defaults)
                object.trendDays = 0;
            if (message.binKeys && message.binKeys.length) {
                object.binKeys = [];
                for (var j = 0; j < message.binKeys.length; ++j)
                    object.binKeys[j] = message.binKeys[j];
            }
            if (message.trendDays != null && message.hasOwnProperty("trendDays"))
                object.trendDays = message.trendDays;
            return object;
        };

        /**
         * Converts this GetBinsTrendDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBinsTrendDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinsTrendDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinsTrendDataRequest;
    })();

    pond.NodeTrend = (function() {

        /**
         * Properties of a NodeTrend.
         * @memberof pond
         * @interface INodeTrend
         * @property {number|null} [tempTrend] NodeTrend tempTrend
         * @property {number|null} [humidityTrend] NodeTrend humidityTrend
         * @property {number|null} [emcTrend] NodeTrend emcTrend
         */

        /**
         * Constructs a new NodeTrend.
         * @memberof pond
         * @classdesc Represents a NodeTrend.
         * @implements INodeTrend
         * @constructor
         * @param {pond.INodeTrend=} [properties] Properties to set
         */
        function NodeTrend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NodeTrend tempTrend.
         * @member {number} tempTrend
         * @memberof pond.NodeTrend
         * @instance
         */
        NodeTrend.prototype.tempTrend = 0;

        /**
         * NodeTrend humidityTrend.
         * @member {number} humidityTrend
         * @memberof pond.NodeTrend
         * @instance
         */
        NodeTrend.prototype.humidityTrend = 0;

        /**
         * NodeTrend emcTrend.
         * @member {number} emcTrend
         * @memberof pond.NodeTrend
         * @instance
         */
        NodeTrend.prototype.emcTrend = 0;

        /**
         * Creates a new NodeTrend instance using the specified properties.
         * @function create
         * @memberof pond.NodeTrend
         * @static
         * @param {pond.INodeTrend=} [properties] Properties to set
         * @returns {pond.NodeTrend} NodeTrend instance
         */
        NodeTrend.create = function create(properties) {
            return new NodeTrend(properties);
        };

        /**
         * Creates a NodeTrend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NodeTrend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NodeTrend} NodeTrend
         */
        NodeTrend.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NodeTrend)
                return object;
            var message = new $root.pond.NodeTrend();
            if (object.tempTrend != null)
                message.tempTrend = Number(object.tempTrend);
            if (object.humidityTrend != null)
                message.humidityTrend = Number(object.humidityTrend);
            if (object.emcTrend != null)
                message.emcTrend = Number(object.emcTrend);
            return message;
        };

        /**
         * Creates a plain object from a NodeTrend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NodeTrend
         * @static
         * @param {pond.NodeTrend} message NodeTrend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NodeTrend.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.tempTrend = 0;
                object.humidityTrend = 0;
                object.emcTrend = 0;
            }
            if (message.tempTrend != null && message.hasOwnProperty("tempTrend"))
                object.tempTrend = options.json && !isFinite(message.tempTrend) ? String(message.tempTrend) : message.tempTrend;
            if (message.humidityTrend != null && message.hasOwnProperty("humidityTrend"))
                object.humidityTrend = options.json && !isFinite(message.humidityTrend) ? String(message.humidityTrend) : message.humidityTrend;
            if (message.emcTrend != null && message.hasOwnProperty("emcTrend"))
                object.emcTrend = options.json && !isFinite(message.emcTrend) ? String(message.emcTrend) : message.emcTrend;
            return object;
        };

        /**
         * Converts this NodeTrend to JSON.
         * @function toJSON
         * @memberof pond.NodeTrend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NodeTrend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NodeTrend;
    })();

    pond.CableTrend = (function() {

        /**
         * Properties of a CableTrend.
         * @memberof pond
         * @interface ICableTrend
         * @property {number|null} [grainCelciusTrend] CableTrend grainCelciusTrend
         * @property {number|null} [grainHumidityTrend] CableTrend grainHumidityTrend
         * @property {number|null} [grainEmcTrend] CableTrend grainEmcTrend
         * @property {pond.NodeTrend|null} [hotNodeTrend] CableTrend hotNodeTrend
         * @property {pond.NodeTrend|null} [coldNodeTrend] CableTrend coldNodeTrend
         */

        /**
         * Constructs a new CableTrend.
         * @memberof pond
         * @classdesc Represents a CableTrend.
         * @implements ICableTrend
         * @constructor
         * @param {pond.ICableTrend=} [properties] Properties to set
         */
        function CableTrend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CableTrend grainCelciusTrend.
         * @member {number} grainCelciusTrend
         * @memberof pond.CableTrend
         * @instance
         */
        CableTrend.prototype.grainCelciusTrend = 0;

        /**
         * CableTrend grainHumidityTrend.
         * @member {number} grainHumidityTrend
         * @memberof pond.CableTrend
         * @instance
         */
        CableTrend.prototype.grainHumidityTrend = 0;

        /**
         * CableTrend grainEmcTrend.
         * @member {number} grainEmcTrend
         * @memberof pond.CableTrend
         * @instance
         */
        CableTrend.prototype.grainEmcTrend = 0;

        /**
         * CableTrend hotNodeTrend.
         * @member {pond.NodeTrend|null|undefined} hotNodeTrend
         * @memberof pond.CableTrend
         * @instance
         */
        CableTrend.prototype.hotNodeTrend = null;

        /**
         * CableTrend coldNodeTrend.
         * @member {pond.NodeTrend|null|undefined} coldNodeTrend
         * @memberof pond.CableTrend
         * @instance
         */
        CableTrend.prototype.coldNodeTrend = null;

        /**
         * Creates a new CableTrend instance using the specified properties.
         * @function create
         * @memberof pond.CableTrend
         * @static
         * @param {pond.ICableTrend=} [properties] Properties to set
         * @returns {pond.CableTrend} CableTrend instance
         */
        CableTrend.create = function create(properties) {
            return new CableTrend(properties);
        };

        /**
         * Creates a CableTrend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CableTrend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CableTrend} CableTrend
         */
        CableTrend.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CableTrend)
                return object;
            var message = new $root.pond.CableTrend();
            if (object.grainCelciusTrend != null)
                message.grainCelciusTrend = Number(object.grainCelciusTrend);
            if (object.grainHumidityTrend != null)
                message.grainHumidityTrend = Number(object.grainHumidityTrend);
            if (object.grainEmcTrend != null)
                message.grainEmcTrend = Number(object.grainEmcTrend);
            if (object.hotNodeTrend != null) {
                if (typeof object.hotNodeTrend !== "object")
                    throw TypeError(".pond.CableTrend.hotNodeTrend: object expected");
                message.hotNodeTrend = $root.pond.NodeTrend.fromObject(object.hotNodeTrend);
            }
            if (object.coldNodeTrend != null) {
                if (typeof object.coldNodeTrend !== "object")
                    throw TypeError(".pond.CableTrend.coldNodeTrend: object expected");
                message.coldNodeTrend = $root.pond.NodeTrend.fromObject(object.coldNodeTrend);
            }
            return message;
        };

        /**
         * Creates a plain object from a CableTrend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CableTrend
         * @static
         * @param {pond.CableTrend} message CableTrend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CableTrend.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.grainCelciusTrend = 0;
                object.grainHumidityTrend = 0;
                object.grainEmcTrend = 0;
                object.hotNodeTrend = null;
                object.coldNodeTrend = null;
            }
            if (message.grainCelciusTrend != null && message.hasOwnProperty("grainCelciusTrend"))
                object.grainCelciusTrend = options.json && !isFinite(message.grainCelciusTrend) ? String(message.grainCelciusTrend) : message.grainCelciusTrend;
            if (message.grainHumidityTrend != null && message.hasOwnProperty("grainHumidityTrend"))
                object.grainHumidityTrend = options.json && !isFinite(message.grainHumidityTrend) ? String(message.grainHumidityTrend) : message.grainHumidityTrend;
            if (message.grainEmcTrend != null && message.hasOwnProperty("grainEmcTrend"))
                object.grainEmcTrend = options.json && !isFinite(message.grainEmcTrend) ? String(message.grainEmcTrend) : message.grainEmcTrend;
            if (message.hotNodeTrend != null && message.hasOwnProperty("hotNodeTrend"))
                object.hotNodeTrend = $root.pond.NodeTrend.toObject(message.hotNodeTrend, options);
            if (message.coldNodeTrend != null && message.hasOwnProperty("coldNodeTrend"))
                object.coldNodeTrend = $root.pond.NodeTrend.toObject(message.coldNodeTrend, options);
            return object;
        };

        /**
         * Converts this CableTrend to JSON.
         * @function toJSON
         * @memberof pond.CableTrend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CableTrend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CableTrend;
    })();

    pond.BinTrend = (function() {

        /**
         * Properties of a BinTrend.
         * @memberof pond
         * @interface IBinTrend
         * @property {Object.<string,pond.CableTrend>|null} [cableTrend] BinTrend cableTrend
         */

        /**
         * Constructs a new BinTrend.
         * @memberof pond
         * @classdesc Represents a BinTrend.
         * @implements IBinTrend
         * @constructor
         * @param {pond.IBinTrend=} [properties] Properties to set
         */
        function BinTrend(properties) {
            this.cableTrend = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinTrend cableTrend.
         * @member {Object.<string,pond.CableTrend>} cableTrend
         * @memberof pond.BinTrend
         * @instance
         */
        BinTrend.prototype.cableTrend = $util.emptyObject;

        /**
         * Creates a new BinTrend instance using the specified properties.
         * @function create
         * @memberof pond.BinTrend
         * @static
         * @param {pond.IBinTrend=} [properties] Properties to set
         * @returns {pond.BinTrend} BinTrend instance
         */
        BinTrend.create = function create(properties) {
            return new BinTrend(properties);
        };

        /**
         * Creates a BinTrend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinTrend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinTrend} BinTrend
         */
        BinTrend.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinTrend)
                return object;
            var message = new $root.pond.BinTrend();
            if (object.cableTrend) {
                if (typeof object.cableTrend !== "object")
                    throw TypeError(".pond.BinTrend.cableTrend: object expected");
                message.cableTrend = {};
                for (var keys = Object.keys(object.cableTrend), i = 0; i < keys.length; ++i) {
                    if (typeof object.cableTrend[keys[i]] !== "object")
                        throw TypeError(".pond.BinTrend.cableTrend: object expected");
                    message.cableTrend[keys[i]] = $root.pond.CableTrend.fromObject(object.cableTrend[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BinTrend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinTrend
         * @static
         * @param {pond.BinTrend} message BinTrend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinTrend.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.cableTrend = {};
            var keys2;
            if (message.cableTrend && (keys2 = Object.keys(message.cableTrend)).length) {
                object.cableTrend = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.cableTrend[keys2[j]] = $root.pond.CableTrend.toObject(message.cableTrend[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this BinTrend to JSON.
         * @function toJSON
         * @memberof pond.BinTrend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinTrend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinTrend;
    })();

    pond.GetBinsTrendDataResponse = (function() {

        /**
         * Properties of a GetBinsTrendDataResponse.
         * @memberof pond
         * @interface IGetBinsTrendDataResponse
         * @property {Object.<string,pond.BinTrend>|null} [trendData] GetBinsTrendDataResponse trendData
         */

        /**
         * Constructs a new GetBinsTrendDataResponse.
         * @memberof pond
         * @classdesc Represents a GetBinsTrendDataResponse.
         * @implements IGetBinsTrendDataResponse
         * @constructor
         * @param {pond.IGetBinsTrendDataResponse=} [properties] Properties to set
         */
        function GetBinsTrendDataResponse(properties) {
            this.trendData = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinsTrendDataResponse trendData.
         * @member {Object.<string,pond.BinTrend>} trendData
         * @memberof pond.GetBinsTrendDataResponse
         * @instance
         */
        GetBinsTrendDataResponse.prototype.trendData = $util.emptyObject;

        /**
         * Creates a new GetBinsTrendDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetBinsTrendDataResponse
         * @static
         * @param {pond.IGetBinsTrendDataResponse=} [properties] Properties to set
         * @returns {pond.GetBinsTrendDataResponse} GetBinsTrendDataResponse instance
         */
        GetBinsTrendDataResponse.create = function create(properties) {
            return new GetBinsTrendDataResponse(properties);
        };

        /**
         * Creates a GetBinsTrendDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinsTrendDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinsTrendDataResponse} GetBinsTrendDataResponse
         */
        GetBinsTrendDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinsTrendDataResponse)
                return object;
            var message = new $root.pond.GetBinsTrendDataResponse();
            if (object.trendData) {
                if (typeof object.trendData !== "object")
                    throw TypeError(".pond.GetBinsTrendDataResponse.trendData: object expected");
                message.trendData = {};
                for (var keys = Object.keys(object.trendData), i = 0; i < keys.length; ++i) {
                    if (typeof object.trendData[keys[i]] !== "object")
                        throw TypeError(".pond.GetBinsTrendDataResponse.trendData: object expected");
                    message.trendData[keys[i]] = $root.pond.BinTrend.fromObject(object.trendData[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetBinsTrendDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinsTrendDataResponse
         * @static
         * @param {pond.GetBinsTrendDataResponse} message GetBinsTrendDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinsTrendDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.trendData = {};
            var keys2;
            if (message.trendData && (keys2 = Object.keys(message.trendData)).length) {
                object.trendData = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.trendData[keys2[j]] = $root.pond.BinTrend.toObject(message.trendData[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this GetBinsTrendDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetBinsTrendDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinsTrendDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinsTrendDataResponse;
    })();

    pond.UpdateBinRequest = (function() {

        /**
         * Properties of an UpdateBinRequest.
         * @memberof pond
         * @interface IUpdateBinRequest
         * @property {pond.BinSettings|null} [bin] UpdateBinRequest bin
         */

        /**
         * Constructs a new UpdateBinRequest.
         * @memberof pond
         * @classdesc Represents an UpdateBinRequest.
         * @implements IUpdateBinRequest
         * @constructor
         * @param {pond.IUpdateBinRequest=} [properties] Properties to set
         */
        function UpdateBinRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateBinRequest bin.
         * @member {pond.BinSettings|null|undefined} bin
         * @memberof pond.UpdateBinRequest
         * @instance
         */
        UpdateBinRequest.prototype.bin = null;

        /**
         * Creates a new UpdateBinRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinRequest
         * @static
         * @param {pond.IUpdateBinRequest=} [properties] Properties to set
         * @returns {pond.UpdateBinRequest} UpdateBinRequest instance
         */
        UpdateBinRequest.create = function create(properties) {
            return new UpdateBinRequest(properties);
        };

        /**
         * Creates an UpdateBinRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinRequest} UpdateBinRequest
         */
        UpdateBinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinRequest)
                return object;
            var message = new $root.pond.UpdateBinRequest();
            if (object.bin != null) {
                if (typeof object.bin !== "object")
                    throw TypeError(".pond.UpdateBinRequest.bin: object expected");
                message.bin = $root.pond.BinSettings.fromObject(object.bin);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateBinRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinRequest
         * @static
         * @param {pond.UpdateBinRequest} message UpdateBinRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = null;
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = $root.pond.BinSettings.toObject(message.bin, options);
            return object;
        };

        /**
         * Converts this UpdateBinRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinRequest;
    })();

    pond.BulkBinUpdateRequest = (function() {

        /**
         * Properties of a BulkBinUpdateRequest.
         * @memberof pond
         * @interface IBulkBinUpdateRequest
         * @property {Array.<pond.BinSettings>|null} [bins] BulkBinUpdateRequest bins
         */

        /**
         * Constructs a new BulkBinUpdateRequest.
         * @memberof pond
         * @classdesc Represents a BulkBinUpdateRequest.
         * @implements IBulkBinUpdateRequest
         * @constructor
         * @param {pond.IBulkBinUpdateRequest=} [properties] Properties to set
         */
        function BulkBinUpdateRequest(properties) {
            this.bins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkBinUpdateRequest bins.
         * @member {Array.<pond.BinSettings>} bins
         * @memberof pond.BulkBinUpdateRequest
         * @instance
         */
        BulkBinUpdateRequest.prototype.bins = $util.emptyArray;

        /**
         * Creates a new BulkBinUpdateRequest instance using the specified properties.
         * @function create
         * @memberof pond.BulkBinUpdateRequest
         * @static
         * @param {pond.IBulkBinUpdateRequest=} [properties] Properties to set
         * @returns {pond.BulkBinUpdateRequest} BulkBinUpdateRequest instance
         */
        BulkBinUpdateRequest.create = function create(properties) {
            return new BulkBinUpdateRequest(properties);
        };

        /**
         * Creates a BulkBinUpdateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkBinUpdateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkBinUpdateRequest} BulkBinUpdateRequest
         */
        BulkBinUpdateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkBinUpdateRequest)
                return object;
            var message = new $root.pond.BulkBinUpdateRequest();
            if (object.bins) {
                if (!Array.isArray(object.bins))
                    throw TypeError(".pond.BulkBinUpdateRequest.bins: array expected");
                message.bins = [];
                for (var i = 0; i < object.bins.length; ++i) {
                    if (typeof object.bins[i] !== "object")
                        throw TypeError(".pond.BulkBinUpdateRequest.bins: object expected");
                    message.bins[i] = $root.pond.BinSettings.fromObject(object.bins[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BulkBinUpdateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkBinUpdateRequest
         * @static
         * @param {pond.BulkBinUpdateRequest} message BulkBinUpdateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkBinUpdateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bins = [];
            if (message.bins && message.bins.length) {
                object.bins = [];
                for (var j = 0; j < message.bins.length; ++j)
                    object.bins[j] = $root.pond.BinSettings.toObject(message.bins[j], options);
            }
            return object;
        };

        /**
         * Converts this BulkBinUpdateRequest to JSON.
         * @function toJSON
         * @memberof pond.BulkBinUpdateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkBinUpdateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkBinUpdateRequest;
    })();

    pond.UpdateBinYardRequest = (function() {

        /**
         * Properties of an UpdateBinYardRequest.
         * @memberof pond
         * @interface IUpdateBinYardRequest
         * @property {pond.BinYardSettings|null} [binYard] UpdateBinYardRequest binYard
         */

        /**
         * Constructs a new UpdateBinYardRequest.
         * @memberof pond
         * @classdesc Represents an UpdateBinYardRequest.
         * @implements IUpdateBinYardRequest
         * @constructor
         * @param {pond.IUpdateBinYardRequest=} [properties] Properties to set
         */
        function UpdateBinYardRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateBinYardRequest binYard.
         * @member {pond.BinYardSettings|null|undefined} binYard
         * @memberof pond.UpdateBinYardRequest
         * @instance
         */
        UpdateBinYardRequest.prototype.binYard = null;

        /**
         * Creates a new UpdateBinYardRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinYardRequest
         * @static
         * @param {pond.IUpdateBinYardRequest=} [properties] Properties to set
         * @returns {pond.UpdateBinYardRequest} UpdateBinYardRequest instance
         */
        UpdateBinYardRequest.create = function create(properties) {
            return new UpdateBinYardRequest(properties);
        };

        /**
         * Creates an UpdateBinYardRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinYardRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinYardRequest} UpdateBinYardRequest
         */
        UpdateBinYardRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinYardRequest)
                return object;
            var message = new $root.pond.UpdateBinYardRequest();
            if (object.binYard != null) {
                if (typeof object.binYard !== "object")
                    throw TypeError(".pond.UpdateBinYardRequest.binYard: object expected");
                message.binYard = $root.pond.BinYardSettings.fromObject(object.binYard);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateBinYardRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinYardRequest
         * @static
         * @param {pond.UpdateBinYardRequest} message UpdateBinYardRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinYardRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.binYard = null;
            if (message.binYard != null && message.hasOwnProperty("binYard"))
                object.binYard = $root.pond.BinYardSettings.toObject(message.binYard, options);
            return object;
        };

        /**
         * Converts this UpdateBinYardRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinYardRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinYardRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinYardRequest;
    })();

    pond.UpdateBinResponse = (function() {

        /**
         * Properties of an UpdateBinResponse.
         * @memberof pond
         * @interface IUpdateBinResponse
         */

        /**
         * Constructs a new UpdateBinResponse.
         * @memberof pond
         * @classdesc Represents an UpdateBinResponse.
         * @implements IUpdateBinResponse
         * @constructor
         * @param {pond.IUpdateBinResponse=} [properties] Properties to set
         */
        function UpdateBinResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateBinResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinResponse
         * @static
         * @param {pond.IUpdateBinResponse=} [properties] Properties to set
         * @returns {pond.UpdateBinResponse} UpdateBinResponse instance
         */
        UpdateBinResponse.create = function create(properties) {
            return new UpdateBinResponse(properties);
        };

        /**
         * Creates an UpdateBinResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinResponse} UpdateBinResponse
         */
        UpdateBinResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinResponse)
                return object;
            return new $root.pond.UpdateBinResponse();
        };

        /**
         * Creates a plain object from an UpdateBinResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinResponse
         * @static
         * @param {pond.UpdateBinResponse} message UpdateBinResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateBinResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinResponse;
    })();

    pond.BulkBinUpdateResponse = (function() {

        /**
         * Properties of a BulkBinUpdateResponse.
         * @memberof pond
         * @interface IBulkBinUpdateResponse
         * @property {number|null} [successfull] BulkBinUpdateResponse successfull
         */

        /**
         * Constructs a new BulkBinUpdateResponse.
         * @memberof pond
         * @classdesc Represents a BulkBinUpdateResponse.
         * @implements IBulkBinUpdateResponse
         * @constructor
         * @param {pond.IBulkBinUpdateResponse=} [properties] Properties to set
         */
        function BulkBinUpdateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkBinUpdateResponse successfull.
         * @member {number} successfull
         * @memberof pond.BulkBinUpdateResponse
         * @instance
         */
        BulkBinUpdateResponse.prototype.successfull = 0;

        /**
         * Creates a new BulkBinUpdateResponse instance using the specified properties.
         * @function create
         * @memberof pond.BulkBinUpdateResponse
         * @static
         * @param {pond.IBulkBinUpdateResponse=} [properties] Properties to set
         * @returns {pond.BulkBinUpdateResponse} BulkBinUpdateResponse instance
         */
        BulkBinUpdateResponse.create = function create(properties) {
            return new BulkBinUpdateResponse(properties);
        };

        /**
         * Creates a BulkBinUpdateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkBinUpdateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkBinUpdateResponse} BulkBinUpdateResponse
         */
        BulkBinUpdateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkBinUpdateResponse)
                return object;
            var message = new $root.pond.BulkBinUpdateResponse();
            if (object.successfull != null)
                message.successfull = object.successfull | 0;
            return message;
        };

        /**
         * Creates a plain object from a BulkBinUpdateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkBinUpdateResponse
         * @static
         * @param {pond.BulkBinUpdateResponse} message BulkBinUpdateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkBinUpdateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.successfull = 0;
            if (message.successfull != null && message.hasOwnProperty("successfull"))
                object.successfull = message.successfull;
            return object;
        };

        /**
         * Converts this BulkBinUpdateResponse to JSON.
         * @function toJSON
         * @memberof pond.BulkBinUpdateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkBinUpdateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkBinUpdateResponse;
    })();

    pond.UpdateBinYardResponse = (function() {

        /**
         * Properties of an UpdateBinYardResponse.
         * @memberof pond
         * @interface IUpdateBinYardResponse
         */

        /**
         * Constructs a new UpdateBinYardResponse.
         * @memberof pond
         * @classdesc Represents an UpdateBinYardResponse.
         * @implements IUpdateBinYardResponse
         * @constructor
         * @param {pond.IUpdateBinYardResponse=} [properties] Properties to set
         */
        function UpdateBinYardResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateBinYardResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinYardResponse
         * @static
         * @param {pond.IUpdateBinYardResponse=} [properties] Properties to set
         * @returns {pond.UpdateBinYardResponse} UpdateBinYardResponse instance
         */
        UpdateBinYardResponse.create = function create(properties) {
            return new UpdateBinYardResponse(properties);
        };

        /**
         * Creates an UpdateBinYardResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinYardResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinYardResponse} UpdateBinYardResponse
         */
        UpdateBinYardResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinYardResponse)
                return object;
            return new $root.pond.UpdateBinYardResponse();
        };

        /**
         * Creates a plain object from an UpdateBinYardResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinYardResponse
         * @static
         * @param {pond.UpdateBinYardResponse} message UpdateBinYardResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinYardResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateBinYardResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinYardResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinYardResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinYardResponse;
    })();

    pond.UpdateBinStatusRequest = (function() {

        /**
         * Properties of an UpdateBinStatusRequest.
         * @memberof pond
         * @interface IUpdateBinStatusRequest
         * @property {string|null} [bin] UpdateBinStatusRequest bin
         * @property {pond.BinStatus|null} [status] UpdateBinStatusRequest status
         */

        /**
         * Constructs a new UpdateBinStatusRequest.
         * @memberof pond
         * @classdesc Represents an UpdateBinStatusRequest.
         * @implements IUpdateBinStatusRequest
         * @constructor
         * @param {pond.IUpdateBinStatusRequest=} [properties] Properties to set
         */
        function UpdateBinStatusRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateBinStatusRequest bin.
         * @member {string} bin
         * @memberof pond.UpdateBinStatusRequest
         * @instance
         */
        UpdateBinStatusRequest.prototype.bin = "";

        /**
         * UpdateBinStatusRequest status.
         * @member {pond.BinStatus|null|undefined} status
         * @memberof pond.UpdateBinStatusRequest
         * @instance
         */
        UpdateBinStatusRequest.prototype.status = null;

        /**
         * Creates a new UpdateBinStatusRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinStatusRequest
         * @static
         * @param {pond.IUpdateBinStatusRequest=} [properties] Properties to set
         * @returns {pond.UpdateBinStatusRequest} UpdateBinStatusRequest instance
         */
        UpdateBinStatusRequest.create = function create(properties) {
            return new UpdateBinStatusRequest(properties);
        };

        /**
         * Creates an UpdateBinStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinStatusRequest} UpdateBinStatusRequest
         */
        UpdateBinStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinStatusRequest)
                return object;
            var message = new $root.pond.UpdateBinStatusRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.UpdateBinStatusRequest.status: object expected");
                message.status = $root.pond.BinStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateBinStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinStatusRequest
         * @static
         * @param {pond.UpdateBinStatusRequest} message UpdateBinStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                object.status = null;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.BinStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this UpdateBinStatusRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinStatusRequest;
    })();

    pond.UpdateBinStatusResponse = (function() {

        /**
         * Properties of an UpdateBinStatusResponse.
         * @memberof pond
         * @interface IUpdateBinStatusResponse
         */

        /**
         * Constructs a new UpdateBinStatusResponse.
         * @memberof pond
         * @classdesc Represents an UpdateBinStatusResponse.
         * @implements IUpdateBinStatusResponse
         * @constructor
         * @param {pond.IUpdateBinStatusResponse=} [properties] Properties to set
         */
        function UpdateBinStatusResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateBinStatusResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinStatusResponse
         * @static
         * @param {pond.IUpdateBinStatusResponse=} [properties] Properties to set
         * @returns {pond.UpdateBinStatusResponse} UpdateBinStatusResponse instance
         */
        UpdateBinStatusResponse.create = function create(properties) {
            return new UpdateBinStatusResponse(properties);
        };

        /**
         * Creates an UpdateBinStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinStatusResponse} UpdateBinStatusResponse
         */
        UpdateBinStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinStatusResponse)
                return object;
            return new $root.pond.UpdateBinStatusResponse();
        };

        /**
         * Creates a plain object from an UpdateBinStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinStatusResponse
         * @static
         * @param {pond.UpdateBinStatusResponse} message UpdateBinStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinStatusResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateBinStatusResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinStatusResponse;
    })();

    pond.RemoveBinRequest = (function() {

        /**
         * Properties of a RemoveBinRequest.
         * @memberof pond
         * @interface IRemoveBinRequest
         * @property {string|null} [bin] RemoveBinRequest bin
         */

        /**
         * Constructs a new RemoveBinRequest.
         * @memberof pond
         * @classdesc Represents a RemoveBinRequest.
         * @implements IRemoveBinRequest
         * @constructor
         * @param {pond.IRemoveBinRequest=} [properties] Properties to set
         */
        function RemoveBinRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveBinRequest bin.
         * @member {string} bin
         * @memberof pond.RemoveBinRequest
         * @instance
         */
        RemoveBinRequest.prototype.bin = "";

        /**
         * Creates a new RemoveBinRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinRequest
         * @static
         * @param {pond.IRemoveBinRequest=} [properties] Properties to set
         * @returns {pond.RemoveBinRequest} RemoveBinRequest instance
         */
        RemoveBinRequest.create = function create(properties) {
            return new RemoveBinRequest(properties);
        };

        /**
         * Creates a RemoveBinRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinRequest} RemoveBinRequest
         */
        RemoveBinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinRequest)
                return object;
            var message = new $root.pond.RemoveBinRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            return message;
        };

        /**
         * Creates a plain object from a RemoveBinRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinRequest
         * @static
         * @param {pond.RemoveBinRequest} message RemoveBinRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            return object;
        };

        /**
         * Converts this RemoveBinRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinRequest;
    })();

    pond.RemoveBinResponse = (function() {

        /**
         * Properties of a RemoveBinResponse.
         * @memberof pond
         * @interface IRemoveBinResponse
         */

        /**
         * Constructs a new RemoveBinResponse.
         * @memberof pond
         * @classdesc Represents a RemoveBinResponse.
         * @implements IRemoveBinResponse
         * @constructor
         * @param {pond.IRemoveBinResponse=} [properties] Properties to set
         */
        function RemoveBinResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveBinResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBinResponse
         * @static
         * @param {pond.IRemoveBinResponse=} [properties] Properties to set
         * @returns {pond.RemoveBinResponse} RemoveBinResponse instance
         */
        RemoveBinResponse.create = function create(properties) {
            return new RemoveBinResponse(properties);
        };

        /**
         * Creates a RemoveBinResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBinResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBinResponse} RemoveBinResponse
         */
        RemoveBinResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBinResponse)
                return object;
            return new $root.pond.RemoveBinResponse();
        };

        /**
         * Creates a plain object from a RemoveBinResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBinResponse
         * @static
         * @param {pond.RemoveBinResponse} message RemoveBinResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBinResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveBinResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveBinResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBinResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBinResponse;
    })();

    pond.GetBinRequest = (function() {

        /**
         * Properties of a GetBinRequest.
         * @memberof pond
         * @interface IGetBinRequest
         * @property {string|null} [bin] GetBinRequest bin
         */

        /**
         * Constructs a new GetBinRequest.
         * @memberof pond
         * @classdesc Represents a GetBinRequest.
         * @implements IGetBinRequest
         * @constructor
         * @param {pond.IGetBinRequest=} [properties] Properties to set
         */
        function GetBinRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinRequest bin.
         * @member {string} bin
         * @memberof pond.GetBinRequest
         * @instance
         */
        GetBinRequest.prototype.bin = "";

        /**
         * Creates a new GetBinRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBinRequest
         * @static
         * @param {pond.IGetBinRequest=} [properties] Properties to set
         * @returns {pond.GetBinRequest} GetBinRequest instance
         */
        GetBinRequest.create = function create(properties) {
            return new GetBinRequest(properties);
        };

        /**
         * Creates a GetBinRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinRequest} GetBinRequest
         */
        GetBinRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinRequest)
                return object;
            var message = new $root.pond.GetBinRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            return message;
        };

        /**
         * Creates a plain object from a GetBinRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinRequest
         * @static
         * @param {pond.GetBinRequest} message GetBinRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            return object;
        };

        /**
         * Converts this GetBinRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBinRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinRequest;
    })();

    pond.GrainSourceMapRequest = (function() {

        /**
         * Properties of a GrainSourceMapRequest.
         * @memberof pond
         * @interface IGrainSourceMapRequest
         * @property {Array.<string>|null} [sourceKeys] GrainSourceMapRequest sourceKeys
         */

        /**
         * Constructs a new GrainSourceMapRequest.
         * @memberof pond
         * @classdesc Represents a GrainSourceMapRequest.
         * @implements IGrainSourceMapRequest
         * @constructor
         * @param {pond.IGrainSourceMapRequest=} [properties] Properties to set
         */
        function GrainSourceMapRequest(properties) {
            this.sourceKeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainSourceMapRequest sourceKeys.
         * @member {Array.<string>} sourceKeys
         * @memberof pond.GrainSourceMapRequest
         * @instance
         */
        GrainSourceMapRequest.prototype.sourceKeys = $util.emptyArray;

        /**
         * Creates a new GrainSourceMapRequest instance using the specified properties.
         * @function create
         * @memberof pond.GrainSourceMapRequest
         * @static
         * @param {pond.IGrainSourceMapRequest=} [properties] Properties to set
         * @returns {pond.GrainSourceMapRequest} GrainSourceMapRequest instance
         */
        GrainSourceMapRequest.create = function create(properties) {
            return new GrainSourceMapRequest(properties);
        };

        /**
         * Creates a GrainSourceMapRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainSourceMapRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainSourceMapRequest} GrainSourceMapRequest
         */
        GrainSourceMapRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainSourceMapRequest)
                return object;
            var message = new $root.pond.GrainSourceMapRequest();
            if (object.sourceKeys) {
                if (!Array.isArray(object.sourceKeys))
                    throw TypeError(".pond.GrainSourceMapRequest.sourceKeys: array expected");
                message.sourceKeys = [];
                for (var i = 0; i < object.sourceKeys.length; ++i)
                    message.sourceKeys[i] = String(object.sourceKeys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainSourceMapRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainSourceMapRequest
         * @static
         * @param {pond.GrainSourceMapRequest} message GrainSourceMapRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainSourceMapRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.sourceKeys = [];
            if (message.sourceKeys && message.sourceKeys.length) {
                object.sourceKeys = [];
                for (var j = 0; j < message.sourceKeys.length; ++j)
                    object.sourceKeys[j] = message.sourceKeys[j];
            }
            return object;
        };

        /**
         * Converts this GrainSourceMapRequest to JSON.
         * @function toJSON
         * @memberof pond.GrainSourceMapRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainSourceMapRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainSourceMapRequest;
    })();

    pond.GrainSourceMapResponse = (function() {

        /**
         * Properties of a GrainSourceMapResponse.
         * @memberof pond
         * @interface IGrainSourceMapResponse
         * @property {Object.<string,string>|null} [nameMap] GrainSourceMapResponse nameMap
         */

        /**
         * Constructs a new GrainSourceMapResponse.
         * @memberof pond
         * @classdesc Represents a GrainSourceMapResponse.
         * @implements IGrainSourceMapResponse
         * @constructor
         * @param {pond.IGrainSourceMapResponse=} [properties] Properties to set
         */
        function GrainSourceMapResponse(properties) {
            this.nameMap = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainSourceMapResponse nameMap.
         * @member {Object.<string,string>} nameMap
         * @memberof pond.GrainSourceMapResponse
         * @instance
         */
        GrainSourceMapResponse.prototype.nameMap = $util.emptyObject;

        /**
         * Creates a new GrainSourceMapResponse instance using the specified properties.
         * @function create
         * @memberof pond.GrainSourceMapResponse
         * @static
         * @param {pond.IGrainSourceMapResponse=} [properties] Properties to set
         * @returns {pond.GrainSourceMapResponse} GrainSourceMapResponse instance
         */
        GrainSourceMapResponse.create = function create(properties) {
            return new GrainSourceMapResponse(properties);
        };

        /**
         * Creates a GrainSourceMapResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainSourceMapResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainSourceMapResponse} GrainSourceMapResponse
         */
        GrainSourceMapResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainSourceMapResponse)
                return object;
            var message = new $root.pond.GrainSourceMapResponse();
            if (object.nameMap) {
                if (typeof object.nameMap !== "object")
                    throw TypeError(".pond.GrainSourceMapResponse.nameMap: object expected");
                message.nameMap = {};
                for (var keys = Object.keys(object.nameMap), i = 0; i < keys.length; ++i)
                    message.nameMap[keys[i]] = String(object.nameMap[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainSourceMapResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainSourceMapResponse
         * @static
         * @param {pond.GrainSourceMapResponse} message GrainSourceMapResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainSourceMapResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.nameMap = {};
            var keys2;
            if (message.nameMap && (keys2 = Object.keys(message.nameMap)).length) {
                object.nameMap = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.nameMap[keys2[j]] = message.nameMap[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this GrainSourceMapResponse to JSON.
         * @function toJSON
         * @memberof pond.GrainSourceMapResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainSourceMapResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainSourceMapResponse;
    })();

    pond.ComponentCardData = (function() {

        /**
         * Properties of a ComponentCardData.
         * @memberof pond
         * @interface IComponentCardData
         * @property {pond.Component|null} [component] ComponentCardData component
         * @property {Array.<pond.Interaction>|null} [interactions] ComponentCardData interactions
         * @property {Array.<pond.Permission>|null} [permissions] ComponentCardData permissions
         */

        /**
         * Constructs a new ComponentCardData.
         * @memberof pond
         * @classdesc Represents a ComponentCardData.
         * @implements IComponentCardData
         * @constructor
         * @param {pond.IComponentCardData=} [properties] Properties to set
         */
        function ComponentCardData(properties) {
            this.interactions = [];
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentCardData component.
         * @member {pond.Component|null|undefined} component
         * @memberof pond.ComponentCardData
         * @instance
         */
        ComponentCardData.prototype.component = null;

        /**
         * ComponentCardData interactions.
         * @member {Array.<pond.Interaction>} interactions
         * @memberof pond.ComponentCardData
         * @instance
         */
        ComponentCardData.prototype.interactions = $util.emptyArray;

        /**
         * ComponentCardData permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.ComponentCardData
         * @instance
         */
        ComponentCardData.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new ComponentCardData instance using the specified properties.
         * @function create
         * @memberof pond.ComponentCardData
         * @static
         * @param {pond.IComponentCardData=} [properties] Properties to set
         * @returns {pond.ComponentCardData} ComponentCardData instance
         */
        ComponentCardData.create = function create(properties) {
            return new ComponentCardData(properties);
        };

        /**
         * Creates a ComponentCardData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ComponentCardData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ComponentCardData} ComponentCardData
         */
        ComponentCardData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ComponentCardData)
                return object;
            var message = new $root.pond.ComponentCardData();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.ComponentCardData.component: object expected");
                message.component = $root.pond.Component.fromObject(object.component);
            }
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.ComponentCardData.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.ComponentCardData.interactions: object expected");
                    message.interactions[i] = $root.pond.Interaction.fromObject(object.interactions[i]);
                }
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.ComponentCardData.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComponentCardData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ComponentCardData
         * @static
         * @param {pond.ComponentCardData} message ComponentCardData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentCardData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.interactions = [];
                object.permissions = [];
            }
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.Component.toObject(message.component, options);
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.Interaction.toObject(message.interactions[j], options);
            }
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this ComponentCardData to JSON.
         * @function toJSON
         * @memberof pond.ComponentCardData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentCardData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentCardData;
    })();

    pond.ListComponentCardDataRequest = (function() {

        /**
         * Properties of a ListComponentCardDataRequest.
         * @memberof pond
         * @interface IListComponentCardDataRequest
         * @property {number|null} [deviceId] ListComponentCardDataRequest deviceId
         */

        /**
         * Constructs a new ListComponentCardDataRequest.
         * @memberof pond
         * @classdesc Represents a ListComponentCardDataRequest.
         * @implements IListComponentCardDataRequest
         * @constructor
         * @param {pond.IListComponentCardDataRequest=} [properties] Properties to set
         */
        function ListComponentCardDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentCardDataRequest deviceId.
         * @member {number} deviceId
         * @memberof pond.ListComponentCardDataRequest
         * @instance
         */
        ListComponentCardDataRequest.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ListComponentCardDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentCardDataRequest
         * @static
         * @param {pond.IListComponentCardDataRequest=} [properties] Properties to set
         * @returns {pond.ListComponentCardDataRequest} ListComponentCardDataRequest instance
         */
        ListComponentCardDataRequest.create = function create(properties) {
            return new ListComponentCardDataRequest(properties);
        };

        /**
         * Creates a ListComponentCardDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentCardDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentCardDataRequest} ListComponentCardDataRequest
         */
        ListComponentCardDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentCardDataRequest)
                return object;
            var message = new $root.pond.ListComponentCardDataRequest();
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ListComponentCardDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentCardDataRequest
         * @static
         * @param {pond.ListComponentCardDataRequest} message ListComponentCardDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentCardDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            return object;
        };

        /**
         * Converts this ListComponentCardDataRequest to JSON.
         * @function toJSON
         * @memberof pond.ListComponentCardDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentCardDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentCardDataRequest;
    })();

    pond.ListComponentCardDataResponse = (function() {

        /**
         * Properties of a ListComponentCardDataResponse.
         * @memberof pond
         * @interface IListComponentCardDataResponse
         * @property {pond.Device|null} [device] ListComponentCardDataResponse device
         * @property {Array.<pond.ComponentCardData>|null} [componentCardData] ListComponentCardDataResponse componentCardData
         * @property {pond.User|null} [user] ListComponentCardDataResponse user
         */

        /**
         * Constructs a new ListComponentCardDataResponse.
         * @memberof pond
         * @classdesc Represents a ListComponentCardDataResponse.
         * @implements IListComponentCardDataResponse
         * @constructor
         * @param {pond.IListComponentCardDataResponse=} [properties] Properties to set
         */
        function ListComponentCardDataResponse(properties) {
            this.componentCardData = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComponentCardDataResponse device.
         * @member {pond.Device|null|undefined} device
         * @memberof pond.ListComponentCardDataResponse
         * @instance
         */
        ListComponentCardDataResponse.prototype.device = null;

        /**
         * ListComponentCardDataResponse componentCardData.
         * @member {Array.<pond.ComponentCardData>} componentCardData
         * @memberof pond.ListComponentCardDataResponse
         * @instance
         */
        ListComponentCardDataResponse.prototype.componentCardData = $util.emptyArray;

        /**
         * ListComponentCardDataResponse user.
         * @member {pond.User|null|undefined} user
         * @memberof pond.ListComponentCardDataResponse
         * @instance
         */
        ListComponentCardDataResponse.prototype.user = null;

        /**
         * Creates a new ListComponentCardDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListComponentCardDataResponse
         * @static
         * @param {pond.IListComponentCardDataResponse=} [properties] Properties to set
         * @returns {pond.ListComponentCardDataResponse} ListComponentCardDataResponse instance
         */
        ListComponentCardDataResponse.create = function create(properties) {
            return new ListComponentCardDataResponse(properties);
        };

        /**
         * Creates a ListComponentCardDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListComponentCardDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListComponentCardDataResponse} ListComponentCardDataResponse
         */
        ListComponentCardDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListComponentCardDataResponse)
                return object;
            var message = new $root.pond.ListComponentCardDataResponse();
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.ListComponentCardDataResponse.device: object expected");
                message.device = $root.pond.Device.fromObject(object.device);
            }
            if (object.componentCardData) {
                if (!Array.isArray(object.componentCardData))
                    throw TypeError(".pond.ListComponentCardDataResponse.componentCardData: array expected");
                message.componentCardData = [];
                for (var i = 0; i < object.componentCardData.length; ++i) {
                    if (typeof object.componentCardData[i] !== "object")
                        throw TypeError(".pond.ListComponentCardDataResponse.componentCardData: object expected");
                    message.componentCardData[i] = $root.pond.ComponentCardData.fromObject(object.componentCardData[i]);
                }
            }
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".pond.ListComponentCardDataResponse.user: object expected");
                message.user = $root.pond.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListComponentCardDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListComponentCardDataResponse
         * @static
         * @param {pond.ListComponentCardDataResponse} message ListComponentCardDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComponentCardDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.componentCardData = [];
            if (options.defaults) {
                object.device = null;
                object.user = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.Device.toObject(message.device, options);
            if (message.componentCardData && message.componentCardData.length) {
                object.componentCardData = [];
                for (var j = 0; j < message.componentCardData.length; ++j)
                    object.componentCardData[j] = $root.pond.ComponentCardData.toObject(message.componentCardData[j], options);
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.pond.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this ListComponentCardDataResponse to JSON.
         * @function toJSON
         * @memberof pond.ListComponentCardDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComponentCardDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListComponentCardDataResponse;
    })();

    pond.GetBinPageDataRequest = (function() {

        /**
         * Properties of a GetBinPageDataRequest.
         * @memberof pond
         * @interface IGetBinPageDataRequest
         * @property {string|null} [binKey] GetBinPageDataRequest binKey
         * @property {string|null} [userKey] GetBinPageDataRequest userKey
         * @property {string|null} [asKey] GetBinPageDataRequest asKey
         */

        /**
         * Constructs a new GetBinPageDataRequest.
         * @memberof pond
         * @classdesc Represents a GetBinPageDataRequest.
         * @implements IGetBinPageDataRequest
         * @constructor
         * @param {pond.IGetBinPageDataRequest=} [properties] Properties to set
         */
        function GetBinPageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinPageDataRequest binKey.
         * @member {string} binKey
         * @memberof pond.GetBinPageDataRequest
         * @instance
         */
        GetBinPageDataRequest.prototype.binKey = "";

        /**
         * GetBinPageDataRequest userKey.
         * @member {string} userKey
         * @memberof pond.GetBinPageDataRequest
         * @instance
         */
        GetBinPageDataRequest.prototype.userKey = "";

        /**
         * GetBinPageDataRequest asKey.
         * @member {string} asKey
         * @memberof pond.GetBinPageDataRequest
         * @instance
         */
        GetBinPageDataRequest.prototype.asKey = "";

        /**
         * Creates a new GetBinPageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBinPageDataRequest
         * @static
         * @param {pond.IGetBinPageDataRequest=} [properties] Properties to set
         * @returns {pond.GetBinPageDataRequest} GetBinPageDataRequest instance
         */
        GetBinPageDataRequest.create = function create(properties) {
            return new GetBinPageDataRequest(properties);
        };

        /**
         * Creates a GetBinPageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinPageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinPageDataRequest} GetBinPageDataRequest
         */
        GetBinPageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinPageDataRequest)
                return object;
            var message = new $root.pond.GetBinPageDataRequest();
            if (object.binKey != null)
                message.binKey = String(object.binKey);
            if (object.userKey != null)
                message.userKey = String(object.userKey);
            if (object.asKey != null)
                message.asKey = String(object.asKey);
            return message;
        };

        /**
         * Creates a plain object from a GetBinPageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinPageDataRequest
         * @static
         * @param {pond.GetBinPageDataRequest} message GetBinPageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinPageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.binKey = "";
                object.userKey = "";
                object.asKey = "";
            }
            if (message.binKey != null && message.hasOwnProperty("binKey"))
                object.binKey = message.binKey;
            if (message.userKey != null && message.hasOwnProperty("userKey"))
                object.userKey = message.userKey;
            if (message.asKey != null && message.hasOwnProperty("asKey"))
                object.asKey = message.asKey;
            return object;
        };

        /**
         * Converts this GetBinPageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBinPageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinPageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinPageDataRequest;
    })();

    pond.GetBinPageDataResponse = (function() {

        /**
         * Properties of a GetBinPageDataResponse.
         * @memberof pond
         * @interface IGetBinPageDataResponse
         * @property {pond.Bin|null} [bin] GetBinPageDataResponse bin
         * @property {Array.<pond.Permission>|null} [permissions] GetBinPageDataResponse permissions
         * @property {Array.<pond.Device>|null} [devices] GetBinPageDataResponse devices
         * @property {Array.<pond.Component>|null} [components] GetBinPageDataResponse components
         * @property {Array.<pond.Interaction>|null} [interactions] GetBinPageDataResponse interactions
         * @property {Object.<string,pond.BinComponentPreferences>|null} [preferences] GetBinPageDataResponse preferences
         * @property {Object.<string,number>|null} [componentDevices] GetBinPageDataResponse componentDevices
         * @property {Object.<string,string>|null} [grainCompositionNames] GetBinPageDataResponse grainCompositionNames
         * @property {Array.<pond.DevicePreset>|null} [presets] GetBinPageDataResponse presets
         * @property {Object.<string,number>|null} [interactionDevices] GetBinPageDataResponse interactionDevices
         */

        /**
         * Constructs a new GetBinPageDataResponse.
         * @memberof pond
         * @classdesc Represents a GetBinPageDataResponse.
         * @implements IGetBinPageDataResponse
         * @constructor
         * @param {pond.IGetBinPageDataResponse=} [properties] Properties to set
         */
        function GetBinPageDataResponse(properties) {
            this.permissions = [];
            this.devices = [];
            this.components = [];
            this.interactions = [];
            this.preferences = {};
            this.componentDevices = {};
            this.grainCompositionNames = {};
            this.presets = [];
            this.interactionDevices = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinPageDataResponse bin.
         * @member {pond.Bin|null|undefined} bin
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.bin = null;

        /**
         * GetBinPageDataResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.permissions = $util.emptyArray;

        /**
         * GetBinPageDataResponse devices.
         * @member {Array.<pond.Device>} devices
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.devices = $util.emptyArray;

        /**
         * GetBinPageDataResponse components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.components = $util.emptyArray;

        /**
         * GetBinPageDataResponse interactions.
         * @member {Array.<pond.Interaction>} interactions
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.interactions = $util.emptyArray;

        /**
         * GetBinPageDataResponse preferences.
         * @member {Object.<string,pond.BinComponentPreferences>} preferences
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.preferences = $util.emptyObject;

        /**
         * GetBinPageDataResponse componentDevices.
         * @member {Object.<string,number>} componentDevices
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.componentDevices = $util.emptyObject;

        /**
         * GetBinPageDataResponse grainCompositionNames.
         * @member {Object.<string,string>} grainCompositionNames
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.grainCompositionNames = $util.emptyObject;

        /**
         * GetBinPageDataResponse presets.
         * @member {Array.<pond.DevicePreset>} presets
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.presets = $util.emptyArray;

        /**
         * GetBinPageDataResponse interactionDevices.
         * @member {Object.<string,number>} interactionDevices
         * @memberof pond.GetBinPageDataResponse
         * @instance
         */
        GetBinPageDataResponse.prototype.interactionDevices = $util.emptyObject;

        /**
         * Creates a new GetBinPageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetBinPageDataResponse
         * @static
         * @param {pond.IGetBinPageDataResponse=} [properties] Properties to set
         * @returns {pond.GetBinPageDataResponse} GetBinPageDataResponse instance
         */
        GetBinPageDataResponse.create = function create(properties) {
            return new GetBinPageDataResponse(properties);
        };

        /**
         * Creates a GetBinPageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinPageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinPageDataResponse} GetBinPageDataResponse
         */
        GetBinPageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinPageDataResponse)
                return object;
            var message = new $root.pond.GetBinPageDataResponse();
            if (object.bin != null) {
                if (typeof object.bin !== "object")
                    throw TypeError(".pond.GetBinPageDataResponse.bin: object expected");
                message.bin = $root.pond.Bin.fromObject(object.bin);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GetBinPageDataResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.GetBinPageDataResponse.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i) {
                    if (typeof object.devices[i] !== "object")
                        throw TypeError(".pond.GetBinPageDataResponse.devices: object expected");
                    message.devices[i] = $root.pond.Device.fromObject(object.devices[i]);
                }
            }
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.GetBinPageDataResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.GetBinPageDataResponse.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.GetBinPageDataResponse.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.GetBinPageDataResponse.interactions: object expected");
                    message.interactions[i] = $root.pond.Interaction.fromObject(object.interactions[i]);
                }
            }
            if (object.preferences) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.GetBinPageDataResponse.preferences: object expected");
                message.preferences = {};
                for (var keys = Object.keys(object.preferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.preferences[keys[i]] !== "object")
                        throw TypeError(".pond.GetBinPageDataResponse.preferences: object expected");
                    message.preferences[keys[i]] = $root.pond.BinComponentPreferences.fromObject(object.preferences[keys[i]]);
                }
            }
            if (object.componentDevices) {
                if (typeof object.componentDevices !== "object")
                    throw TypeError(".pond.GetBinPageDataResponse.componentDevices: object expected");
                message.componentDevices = {};
                for (var keys = Object.keys(object.componentDevices), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.componentDevices[keys[i]] = $util.Long.fromValue(object.componentDevices[keys[i]])).unsigned = true;
                    else if (typeof object.componentDevices[keys[i]] === "string")
                        message.componentDevices[keys[i]] = parseInt(object.componentDevices[keys[i]], 10);
                    else if (typeof object.componentDevices[keys[i]] === "number")
                        message.componentDevices[keys[i]] = object.componentDevices[keys[i]];
                    else if (typeof object.componentDevices[keys[i]] === "object")
                        message.componentDevices[keys[i]] = new $util.LongBits(object.componentDevices[keys[i]].low >>> 0, object.componentDevices[keys[i]].high >>> 0).toNumber(true);
            }
            if (object.grainCompositionNames) {
                if (typeof object.grainCompositionNames !== "object")
                    throw TypeError(".pond.GetBinPageDataResponse.grainCompositionNames: object expected");
                message.grainCompositionNames = {};
                for (var keys = Object.keys(object.grainCompositionNames), i = 0; i < keys.length; ++i)
                    message.grainCompositionNames[keys[i]] = String(object.grainCompositionNames[keys[i]]);
            }
            if (object.presets) {
                if (!Array.isArray(object.presets))
                    throw TypeError(".pond.GetBinPageDataResponse.presets: array expected");
                message.presets = [];
                for (var i = 0; i < object.presets.length; ++i) {
                    if (typeof object.presets[i] !== "object")
                        throw TypeError(".pond.GetBinPageDataResponse.presets: object expected");
                    message.presets[i] = $root.pond.DevicePreset.fromObject(object.presets[i]);
                }
            }
            if (object.interactionDevices) {
                if (typeof object.interactionDevices !== "object")
                    throw TypeError(".pond.GetBinPageDataResponse.interactionDevices: object expected");
                message.interactionDevices = {};
                for (var keys = Object.keys(object.interactionDevices), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.interactionDevices[keys[i]] = $util.Long.fromValue(object.interactionDevices[keys[i]])).unsigned = true;
                    else if (typeof object.interactionDevices[keys[i]] === "string")
                        message.interactionDevices[keys[i]] = parseInt(object.interactionDevices[keys[i]], 10);
                    else if (typeof object.interactionDevices[keys[i]] === "number")
                        message.interactionDevices[keys[i]] = object.interactionDevices[keys[i]];
                    else if (typeof object.interactionDevices[keys[i]] === "object")
                        message.interactionDevices[keys[i]] = new $util.LongBits(object.interactionDevices[keys[i]].low >>> 0, object.interactionDevices[keys[i]].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetBinPageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinPageDataResponse
         * @static
         * @param {pond.GetBinPageDataResponse} message GetBinPageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinPageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.permissions = [];
                object.devices = [];
                object.components = [];
                object.interactions = [];
                object.presets = [];
            }
            if (options.objects || options.defaults) {
                object.preferences = {};
                object.componentDevices = {};
                object.grainCompositionNames = {};
                object.interactionDevices = {};
            }
            if (options.defaults)
                object.bin = null;
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = $root.pond.Bin.toObject(message.bin, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    object.devices[j] = $root.pond.Device.toObject(message.devices[j], options);
            }
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.Interaction.toObject(message.interactions[j], options);
            }
            var keys2;
            if (message.preferences && (keys2 = Object.keys(message.preferences)).length) {
                object.preferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.preferences[keys2[j]] = $root.pond.BinComponentPreferences.toObject(message.preferences[keys2[j]], options);
            }
            if (message.componentDevices && (keys2 = Object.keys(message.componentDevices)).length) {
                object.componentDevices = {};
                for (var j = 0; j < keys2.length; ++j)
                    if (typeof message.componentDevices[keys2[j]] === "number")
                        object.componentDevices[keys2[j]] = options.longs === String ? String(message.componentDevices[keys2[j]]) : message.componentDevices[keys2[j]];
                    else
                        object.componentDevices[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.componentDevices[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.componentDevices[keys2[j]].low >>> 0, message.componentDevices[keys2[j]].high >>> 0).toNumber(true) : message.componentDevices[keys2[j]];
            }
            if (message.grainCompositionNames && (keys2 = Object.keys(message.grainCompositionNames)).length) {
                object.grainCompositionNames = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.grainCompositionNames[keys2[j]] = message.grainCompositionNames[keys2[j]];
            }
            if (message.presets && message.presets.length) {
                object.presets = [];
                for (var j = 0; j < message.presets.length; ++j)
                    object.presets[j] = $root.pond.DevicePreset.toObject(message.presets[j], options);
            }
            if (message.interactionDevices && (keys2 = Object.keys(message.interactionDevices)).length) {
                object.interactionDevices = {};
                for (var j = 0; j < keys2.length; ++j)
                    if (typeof message.interactionDevices[keys2[j]] === "number")
                        object.interactionDevices[keys2[j]] = options.longs === String ? String(message.interactionDevices[keys2[j]]) : message.interactionDevices[keys2[j]];
                    else
                        object.interactionDevices[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.interactionDevices[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.interactionDevices[keys2[j]].low >>> 0, message.interactionDevices[keys2[j]].high >>> 0).toNumber(true) : message.interactionDevices[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this GetBinPageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetBinPageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinPageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinPageDataResponse;
    })();

    pond.ListBinsRequest = (function() {

        /**
         * Properties of a ListBinsRequest.
         * @memberof pond
         * @interface IListBinsRequest
         * @property {pond.Paging|null} [paging] ListBinsRequest paging
         * @property {pond.Sorting|null} [sorting] ListBinsRequest sorting
         * @property {string|null} [search] ListBinsRequest search
         * @property {pond.BinSettings|null} [settingsMatch] ListBinsRequest settingsMatch
         * @property {pond.BinStatus|null} [statusMatch] ListBinsRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListBinsRequest fieldContains
         */

        /**
         * Constructs a new ListBinsRequest.
         * @memberof pond
         * @classdesc Represents a ListBinsRequest.
         * @implements IListBinsRequest
         * @constructor
         * @param {pond.IListBinsRequest=} [properties] Properties to set
         */
        function ListBinsRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.paging = null;

        /**
         * ListBinsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.sorting = null;

        /**
         * ListBinsRequest search.
         * @member {string} search
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.search = "";

        /**
         * ListBinsRequest settingsMatch.
         * @member {pond.BinSettings|null|undefined} settingsMatch
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.settingsMatch = null;

        /**
         * ListBinsRequest statusMatch.
         * @member {pond.BinStatus|null|undefined} statusMatch
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.statusMatch = null;

        /**
         * ListBinsRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListBinsRequest
         * @instance
         */
        ListBinsRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListBinsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinsRequest
         * @static
         * @param {pond.IListBinsRequest=} [properties] Properties to set
         * @returns {pond.ListBinsRequest} ListBinsRequest instance
         */
        ListBinsRequest.create = function create(properties) {
            return new ListBinsRequest(properties);
        };

        /**
         * Creates a ListBinsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinsRequest} ListBinsRequest
         */
        ListBinsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinsRequest)
                return object;
            var message = new $root.pond.ListBinsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListBinsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListBinsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListBinsRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.BinSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListBinsRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.BinStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListBinsRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinsRequest
         * @static
         * @param {pond.ListBinsRequest} message ListBinsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.BinSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.BinStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListBinsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinsRequest;
    })();

    pond.ListBinsResponse = (function() {

        /**
         * Properties of a ListBinsResponse.
         * @memberof pond
         * @interface IListBinsResponse
         * @property {Array.<pond.Bin>|null} [bins] ListBinsResponse bins
         * @property {number|null} [nextOffset] ListBinsResponse nextOffset
         * @property {number|null} [total] ListBinsResponse total
         */

        /**
         * Constructs a new ListBinsResponse.
         * @memberof pond
         * @classdesc Represents a ListBinsResponse.
         * @implements IListBinsResponse
         * @constructor
         * @param {pond.IListBinsResponse=} [properties] Properties to set
         */
        function ListBinsResponse(properties) {
            this.bins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinsResponse bins.
         * @member {Array.<pond.Bin>} bins
         * @memberof pond.ListBinsResponse
         * @instance
         */
        ListBinsResponse.prototype.bins = $util.emptyArray;

        /**
         * ListBinsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListBinsResponse
         * @instance
         */
        ListBinsResponse.prototype.nextOffset = 0;

        /**
         * ListBinsResponse total.
         * @member {number} total
         * @memberof pond.ListBinsResponse
         * @instance
         */
        ListBinsResponse.prototype.total = 0;

        /**
         * Creates a new ListBinsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinsResponse
         * @static
         * @param {pond.IListBinsResponse=} [properties] Properties to set
         * @returns {pond.ListBinsResponse} ListBinsResponse instance
         */
        ListBinsResponse.create = function create(properties) {
            return new ListBinsResponse(properties);
        };

        /**
         * Creates a ListBinsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinsResponse} ListBinsResponse
         */
        ListBinsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinsResponse)
                return object;
            var message = new $root.pond.ListBinsResponse();
            if (object.bins) {
                if (!Array.isArray(object.bins))
                    throw TypeError(".pond.ListBinsResponse.bins: array expected");
                message.bins = [];
                for (var i = 0; i < object.bins.length; ++i) {
                    if (typeof object.bins[i] !== "object")
                        throw TypeError(".pond.ListBinsResponse.bins: object expected");
                    message.bins[i] = $root.pond.Bin.fromObject(object.bins[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListBinsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinsResponse
         * @static
         * @param {pond.ListBinsResponse} message ListBinsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bins = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.bins && message.bins.length) {
                object.bins = [];
                for (var j = 0; j < message.bins.length; ++j)
                    object.bins[j] = $root.pond.Bin.toObject(message.bins[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListBinsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinsResponse;
    })();

    pond.ListBinsAndDataResponse = (function() {

        /**
         * Properties of a ListBinsAndDataResponse.
         * @memberof pond
         * @interface IListBinsAndDataResponse
         * @property {Array.<pond.Bin>|null} [bins] ListBinsAndDataResponse bins
         * @property {Array.<pond.BinYard>|null} [binYards] ListBinsAndDataResponse binYards
         * @property {pond.BinMetrics|null} [metrics] ListBinsAndDataResponse metrics
         * @property {number|null} [nextOffset] ListBinsAndDataResponse nextOffset
         * @property {number|null} [total] ListBinsAndDataResponse total
         * @property {Array.<pond.GrainBag>|null} [bags] ListBinsAndDataResponse bags
         */

        /**
         * Constructs a new ListBinsAndDataResponse.
         * @memberof pond
         * @classdesc Represents a ListBinsAndDataResponse.
         * @implements IListBinsAndDataResponse
         * @constructor
         * @param {pond.IListBinsAndDataResponse=} [properties] Properties to set
         */
        function ListBinsAndDataResponse(properties) {
            this.bins = [];
            this.binYards = [];
            this.bags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinsAndDataResponse bins.
         * @member {Array.<pond.Bin>} bins
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.bins = $util.emptyArray;

        /**
         * ListBinsAndDataResponse binYards.
         * @member {Array.<pond.BinYard>} binYards
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.binYards = $util.emptyArray;

        /**
         * ListBinsAndDataResponse metrics.
         * @member {pond.BinMetrics|null|undefined} metrics
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.metrics = null;

        /**
         * ListBinsAndDataResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.nextOffset = 0;

        /**
         * ListBinsAndDataResponse total.
         * @member {number} total
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.total = 0;

        /**
         * ListBinsAndDataResponse bags.
         * @member {Array.<pond.GrainBag>} bags
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         */
        ListBinsAndDataResponse.prototype.bags = $util.emptyArray;

        /**
         * Creates a new ListBinsAndDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinsAndDataResponse
         * @static
         * @param {pond.IListBinsAndDataResponse=} [properties] Properties to set
         * @returns {pond.ListBinsAndDataResponse} ListBinsAndDataResponse instance
         */
        ListBinsAndDataResponse.create = function create(properties) {
            return new ListBinsAndDataResponse(properties);
        };

        /**
         * Creates a ListBinsAndDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinsAndDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinsAndDataResponse} ListBinsAndDataResponse
         */
        ListBinsAndDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinsAndDataResponse)
                return object;
            var message = new $root.pond.ListBinsAndDataResponse();
            if (object.bins) {
                if (!Array.isArray(object.bins))
                    throw TypeError(".pond.ListBinsAndDataResponse.bins: array expected");
                message.bins = [];
                for (var i = 0; i < object.bins.length; ++i) {
                    if (typeof object.bins[i] !== "object")
                        throw TypeError(".pond.ListBinsAndDataResponse.bins: object expected");
                    message.bins[i] = $root.pond.Bin.fromObject(object.bins[i]);
                }
            }
            if (object.binYards) {
                if (!Array.isArray(object.binYards))
                    throw TypeError(".pond.ListBinsAndDataResponse.binYards: array expected");
                message.binYards = [];
                for (var i = 0; i < object.binYards.length; ++i) {
                    if (typeof object.binYards[i] !== "object")
                        throw TypeError(".pond.ListBinsAndDataResponse.binYards: object expected");
                    message.binYards[i] = $root.pond.BinYard.fromObject(object.binYards[i]);
                }
            }
            if (object.metrics != null) {
                if (typeof object.metrics !== "object")
                    throw TypeError(".pond.ListBinsAndDataResponse.metrics: object expected");
                message.metrics = $root.pond.BinMetrics.fromObject(object.metrics);
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            if (object.bags) {
                if (!Array.isArray(object.bags))
                    throw TypeError(".pond.ListBinsAndDataResponse.bags: array expected");
                message.bags = [];
                for (var i = 0; i < object.bags.length; ++i) {
                    if (typeof object.bags[i] !== "object")
                        throw TypeError(".pond.ListBinsAndDataResponse.bags: object expected");
                    message.bags[i] = $root.pond.GrainBag.fromObject(object.bags[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinsAndDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinsAndDataResponse
         * @static
         * @param {pond.ListBinsAndDataResponse} message ListBinsAndDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinsAndDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.bins = [];
                object.binYards = [];
                object.bags = [];
            }
            if (options.defaults) {
                object.metrics = null;
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.bins && message.bins.length) {
                object.bins = [];
                for (var j = 0; j < message.bins.length; ++j)
                    object.bins[j] = $root.pond.Bin.toObject(message.bins[j], options);
            }
            if (message.binYards && message.binYards.length) {
                object.binYards = [];
                for (var j = 0; j < message.binYards.length; ++j)
                    object.binYards[j] = $root.pond.BinYard.toObject(message.binYards[j], options);
            }
            if (message.metrics != null && message.hasOwnProperty("metrics"))
                object.metrics = $root.pond.BinMetrics.toObject(message.metrics, options);
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.bags && message.bags.length) {
                object.bags = [];
                for (var j = 0; j < message.bags.length; ++j)
                    object.bags[j] = $root.pond.GrainBag.toObject(message.bags[j], options);
            }
            return object;
        };

        /**
         * Converts this ListBinsAndDataResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinsAndDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinsAndDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinsAndDataResponse;
    })();

    pond.ListBinStatusRequestFilters = (function() {

        /**
         * Properties of a ListBinStatusRequestFilters.
         * @memberof pond
         * @interface IListBinStatusRequestFilters
         * @property {string|null} [timestampStart] ListBinStatusRequestFilters timestampStart
         * @property {string|null} [timestampEnd] ListBinStatusRequestFilters timestampEnd
         */

        /**
         * Constructs a new ListBinStatusRequestFilters.
         * @memberof pond
         * @classdesc Represents a ListBinStatusRequestFilters.
         * @implements IListBinStatusRequestFilters
         * @constructor
         * @param {pond.IListBinStatusRequestFilters=} [properties] Properties to set
         */
        function ListBinStatusRequestFilters(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinStatusRequestFilters timestampStart.
         * @member {string} timestampStart
         * @memberof pond.ListBinStatusRequestFilters
         * @instance
         */
        ListBinStatusRequestFilters.prototype.timestampStart = "";

        /**
         * ListBinStatusRequestFilters timestampEnd.
         * @member {string} timestampEnd
         * @memberof pond.ListBinStatusRequestFilters
         * @instance
         */
        ListBinStatusRequestFilters.prototype.timestampEnd = "";

        /**
         * Creates a new ListBinStatusRequestFilters instance using the specified properties.
         * @function create
         * @memberof pond.ListBinStatusRequestFilters
         * @static
         * @param {pond.IListBinStatusRequestFilters=} [properties] Properties to set
         * @returns {pond.ListBinStatusRequestFilters} ListBinStatusRequestFilters instance
         */
        ListBinStatusRequestFilters.create = function create(properties) {
            return new ListBinStatusRequestFilters(properties);
        };

        /**
         * Creates a ListBinStatusRequestFilters message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinStatusRequestFilters
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinStatusRequestFilters} ListBinStatusRequestFilters
         */
        ListBinStatusRequestFilters.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinStatusRequestFilters)
                return object;
            var message = new $root.pond.ListBinStatusRequestFilters();
            if (object.timestampStart != null)
                message.timestampStart = String(object.timestampStart);
            if (object.timestampEnd != null)
                message.timestampEnd = String(object.timestampEnd);
            return message;
        };

        /**
         * Creates a plain object from a ListBinStatusRequestFilters message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinStatusRequestFilters
         * @static
         * @param {pond.ListBinStatusRequestFilters} message ListBinStatusRequestFilters
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinStatusRequestFilters.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timestampStart = "";
                object.timestampEnd = "";
            }
            if (message.timestampStart != null && message.hasOwnProperty("timestampStart"))
                object.timestampStart = message.timestampStart;
            if (message.timestampEnd != null && message.hasOwnProperty("timestampEnd"))
                object.timestampEnd = message.timestampEnd;
            return object;
        };

        /**
         * Converts this ListBinStatusRequestFilters to JSON.
         * @function toJSON
         * @memberof pond.ListBinStatusRequestFilters
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinStatusRequestFilters.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinStatusRequestFilters;
    })();

    pond.ListBinStatusRequest = (function() {

        /**
         * Properties of a ListBinStatusRequest.
         * @memberof pond
         * @interface IListBinStatusRequest
         * @property {string|null} [bin] ListBinStatusRequest bin
         * @property {pond.ListBinStatusRequestFilters|null} [filters] ListBinStatusRequest filters
         * @property {pond.Paging|null} [paging] ListBinStatusRequest paging
         * @property {pond.Sorting|null} [sorting] ListBinStatusRequest sorting
         */

        /**
         * Constructs a new ListBinStatusRequest.
         * @memberof pond
         * @classdesc Represents a ListBinStatusRequest.
         * @implements IListBinStatusRequest
         * @constructor
         * @param {pond.IListBinStatusRequest=} [properties] Properties to set
         */
        function ListBinStatusRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinStatusRequest bin.
         * @member {string} bin
         * @memberof pond.ListBinStatusRequest
         * @instance
         */
        ListBinStatusRequest.prototype.bin = "";

        /**
         * ListBinStatusRequest filters.
         * @member {pond.ListBinStatusRequestFilters|null|undefined} filters
         * @memberof pond.ListBinStatusRequest
         * @instance
         */
        ListBinStatusRequest.prototype.filters = null;

        /**
         * ListBinStatusRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListBinStatusRequest
         * @instance
         */
        ListBinStatusRequest.prototype.paging = null;

        /**
         * ListBinStatusRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListBinStatusRequest
         * @instance
         */
        ListBinStatusRequest.prototype.sorting = null;

        /**
         * Creates a new ListBinStatusRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinStatusRequest
         * @static
         * @param {pond.IListBinStatusRequest=} [properties] Properties to set
         * @returns {pond.ListBinStatusRequest} ListBinStatusRequest instance
         */
        ListBinStatusRequest.create = function create(properties) {
            return new ListBinStatusRequest(properties);
        };

        /**
         * Creates a ListBinStatusRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinStatusRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinStatusRequest} ListBinStatusRequest
         */
        ListBinStatusRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinStatusRequest)
                return object;
            var message = new $root.pond.ListBinStatusRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.filters != null) {
                if (typeof object.filters !== "object")
                    throw TypeError(".pond.ListBinStatusRequest.filters: object expected");
                message.filters = $root.pond.ListBinStatusRequestFilters.fromObject(object.filters);
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListBinStatusRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListBinStatusRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinStatusRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinStatusRequest
         * @static
         * @param {pond.ListBinStatusRequest} message ListBinStatusRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinStatusRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                object.filters = null;
                object.paging = null;
                object.sorting = null;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.filters != null && message.hasOwnProperty("filters"))
                object.filters = $root.pond.ListBinStatusRequestFilters.toObject(message.filters, options);
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            return object;
        };

        /**
         * Converts this ListBinStatusRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinStatusRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinStatusRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinStatusRequest;
    })();

    pond.ListBinStatusResponse = (function() {

        /**
         * Properties of a ListBinStatusResponse.
         * @memberof pond
         * @interface IListBinStatusResponse
         * @property {string|null} [bin] ListBinStatusResponse bin
         * @property {Array.<pond.BinStatus>|null} [statuses] ListBinStatusResponse statuses
         * @property {number|null} [nextOffset] ListBinStatusResponse nextOffset
         * @property {number|null} [total] ListBinStatusResponse total
         */

        /**
         * Constructs a new ListBinStatusResponse.
         * @memberof pond
         * @classdesc Represents a ListBinStatusResponse.
         * @implements IListBinStatusResponse
         * @constructor
         * @param {pond.IListBinStatusResponse=} [properties] Properties to set
         */
        function ListBinStatusResponse(properties) {
            this.statuses = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinStatusResponse bin.
         * @member {string} bin
         * @memberof pond.ListBinStatusResponse
         * @instance
         */
        ListBinStatusResponse.prototype.bin = "";

        /**
         * ListBinStatusResponse statuses.
         * @member {Array.<pond.BinStatus>} statuses
         * @memberof pond.ListBinStatusResponse
         * @instance
         */
        ListBinStatusResponse.prototype.statuses = $util.emptyArray;

        /**
         * ListBinStatusResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListBinStatusResponse
         * @instance
         */
        ListBinStatusResponse.prototype.nextOffset = 0;

        /**
         * ListBinStatusResponse total.
         * @member {number} total
         * @memberof pond.ListBinStatusResponse
         * @instance
         */
        ListBinStatusResponse.prototype.total = 0;

        /**
         * Creates a new ListBinStatusResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinStatusResponse
         * @static
         * @param {pond.IListBinStatusResponse=} [properties] Properties to set
         * @returns {pond.ListBinStatusResponse} ListBinStatusResponse instance
         */
        ListBinStatusResponse.create = function create(properties) {
            return new ListBinStatusResponse(properties);
        };

        /**
         * Creates a ListBinStatusResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinStatusResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinStatusResponse} ListBinStatusResponse
         */
        ListBinStatusResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinStatusResponse)
                return object;
            var message = new $root.pond.ListBinStatusResponse();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.statuses) {
                if (!Array.isArray(object.statuses))
                    throw TypeError(".pond.ListBinStatusResponse.statuses: array expected");
                message.statuses = [];
                for (var i = 0; i < object.statuses.length; ++i) {
                    if (typeof object.statuses[i] !== "object")
                        throw TypeError(".pond.ListBinStatusResponse.statuses: object expected");
                    message.statuses[i] = $root.pond.BinStatus.fromObject(object.statuses[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListBinStatusResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinStatusResponse
         * @static
         * @param {pond.ListBinStatusResponse} message ListBinStatusResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinStatusResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.statuses = [];
            if (options.defaults) {
                object.bin = "";
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.statuses && message.statuses.length) {
                object.statuses = [];
                for (var j = 0; j < message.statuses.length; ++j)
                    object.statuses[j] = $root.pond.BinStatus.toObject(message.statuses[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListBinStatusResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinStatusResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinStatusResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinStatusResponse;
    })();

    pond.BinHistory = (function() {

        /**
         * Properties of a BinHistory.
         * @memberof pond
         * @interface IBinHistory
         * @property {pond.BinSettings|null} [settings] BinHistory settings
         * @property {string|null} [user] BinHistory user
         * @property {string|null} [timestamp] BinHistory timestamp
         * @property {string|null} [progress] BinHistory progress
         */

        /**
         * Constructs a new BinHistory.
         * @memberof pond
         * @classdesc Represents a BinHistory.
         * @implements IBinHistory
         * @constructor
         * @param {pond.IBinHistory=} [properties] Properties to set
         */
        function BinHistory(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinHistory settings.
         * @member {pond.BinSettings|null|undefined} settings
         * @memberof pond.BinHistory
         * @instance
         */
        BinHistory.prototype.settings = null;

        /**
         * BinHistory user.
         * @member {string} user
         * @memberof pond.BinHistory
         * @instance
         */
        BinHistory.prototype.user = "";

        /**
         * BinHistory timestamp.
         * @member {string} timestamp
         * @memberof pond.BinHistory
         * @instance
         */
        BinHistory.prototype.timestamp = "";

        /**
         * BinHistory progress.
         * @member {string} progress
         * @memberof pond.BinHistory
         * @instance
         */
        BinHistory.prototype.progress = "";

        /**
         * Creates a new BinHistory instance using the specified properties.
         * @function create
         * @memberof pond.BinHistory
         * @static
         * @param {pond.IBinHistory=} [properties] Properties to set
         * @returns {pond.BinHistory} BinHistory instance
         */
        BinHistory.create = function create(properties) {
            return new BinHistory(properties);
        };

        /**
         * Creates a BinHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinHistory} BinHistory
         */
        BinHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinHistory)
                return object;
            var message = new $root.pond.BinHistory();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.BinHistory.settings: object expected");
                message.settings = $root.pond.BinSettings.fromObject(object.settings);
            }
            if (object.user != null)
                message.user = String(object.user);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.progress != null)
                message.progress = String(object.progress);
            return message;
        };

        /**
         * Creates a plain object from a BinHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinHistory
         * @static
         * @param {pond.BinHistory} message BinHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.user = "";
                object.timestamp = "";
                object.progress = "";
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.BinSettings.toObject(message.settings, options);
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = message.progress;
            return object;
        };

        /**
         * Converts this BinHistory to JSON.
         * @function toJSON
         * @memberof pond.BinHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinHistory;
    })();

    pond.ListBinHistoryRequest = (function() {

        /**
         * Properties of a ListBinHistoryRequest.
         * @memberof pond
         * @interface IListBinHistoryRequest
         * @property {string|null} [key] ListBinHistoryRequest key
         * @property {pond.Paging|null} [paging] ListBinHistoryRequest paging
         */

        /**
         * Constructs a new ListBinHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListBinHistoryRequest.
         * @implements IListBinHistoryRequest
         * @constructor
         * @param {pond.IListBinHistoryRequest=} [properties] Properties to set
         */
        function ListBinHistoryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinHistoryRequest key.
         * @member {string} key
         * @memberof pond.ListBinHistoryRequest
         * @instance
         */
        ListBinHistoryRequest.prototype.key = "";

        /**
         * ListBinHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListBinHistoryRequest
         * @instance
         */
        ListBinHistoryRequest.prototype.paging = null;

        /**
         * Creates a new ListBinHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinHistoryRequest
         * @static
         * @param {pond.IListBinHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListBinHistoryRequest} ListBinHistoryRequest instance
         */
        ListBinHistoryRequest.create = function create(properties) {
            return new ListBinHistoryRequest(properties);
        };

        /**
         * Creates a ListBinHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinHistoryRequest} ListBinHistoryRequest
         */
        ListBinHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinHistoryRequest)
                return object;
            var message = new $root.pond.ListBinHistoryRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListBinHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinHistoryRequest
         * @static
         * @param {pond.ListBinHistoryRequest} message ListBinHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.paging = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            return object;
        };

        /**
         * Converts this ListBinHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinHistoryRequest;
    })();

    pond.ListBinHistoryResponse = (function() {

        /**
         * Properties of a ListBinHistoryResponse.
         * @memberof pond
         * @interface IListBinHistoryResponse
         * @property {Array.<pond.BinHistory>|null} [history] ListBinHistoryResponse history
         * @property {number|null} [nextOffset] ListBinHistoryResponse nextOffset
         * @property {number|null} [total] ListBinHistoryResponse total
         */

        /**
         * Constructs a new ListBinHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListBinHistoryResponse.
         * @implements IListBinHistoryResponse
         * @constructor
         * @param {pond.IListBinHistoryResponse=} [properties] Properties to set
         */
        function ListBinHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinHistoryResponse history.
         * @member {Array.<pond.BinHistory>} history
         * @memberof pond.ListBinHistoryResponse
         * @instance
         */
        ListBinHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListBinHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListBinHistoryResponse
         * @instance
         */
        ListBinHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListBinHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListBinHistoryResponse
         * @instance
         */
        ListBinHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListBinHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinHistoryResponse
         * @static
         * @param {pond.IListBinHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListBinHistoryResponse} ListBinHistoryResponse instance
         */
        ListBinHistoryResponse.create = function create(properties) {
            return new ListBinHistoryResponse(properties);
        };

        /**
         * Creates a ListBinHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinHistoryResponse} ListBinHistoryResponse
         */
        ListBinHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinHistoryResponse)
                return object;
            var message = new $root.pond.ListBinHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListBinHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListBinHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.BinHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListBinHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinHistoryResponse
         * @static
         * @param {pond.ListBinHistoryResponse} message ListBinHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.BinHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListBinHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinHistoryResponse;
    })();

    pond.ListBinHistoryBetweenRequest = (function() {

        /**
         * Properties of a ListBinHistoryBetweenRequest.
         * @memberof pond
         * @interface IListBinHistoryBetweenRequest
         * @property {string|null} [key] ListBinHistoryBetweenRequest key
         * @property {pond.Paging|null} [paging] ListBinHistoryBetweenRequest paging
         * @property {string|null} [start] ListBinHistoryBetweenRequest start
         * @property {string|null} [end] ListBinHistoryBetweenRequest end
         */

        /**
         * Constructs a new ListBinHistoryBetweenRequest.
         * @memberof pond
         * @classdesc Represents a ListBinHistoryBetweenRequest.
         * @implements IListBinHistoryBetweenRequest
         * @constructor
         * @param {pond.IListBinHistoryBetweenRequest=} [properties] Properties to set
         */
        function ListBinHistoryBetweenRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinHistoryBetweenRequest key.
         * @member {string} key
         * @memberof pond.ListBinHistoryBetweenRequest
         * @instance
         */
        ListBinHistoryBetweenRequest.prototype.key = "";

        /**
         * ListBinHistoryBetweenRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListBinHistoryBetweenRequest
         * @instance
         */
        ListBinHistoryBetweenRequest.prototype.paging = null;

        /**
         * ListBinHistoryBetweenRequest start.
         * @member {string} start
         * @memberof pond.ListBinHistoryBetweenRequest
         * @instance
         */
        ListBinHistoryBetweenRequest.prototype.start = "";

        /**
         * ListBinHistoryBetweenRequest end.
         * @member {string} end
         * @memberof pond.ListBinHistoryBetweenRequest
         * @instance
         */
        ListBinHistoryBetweenRequest.prototype.end = "";

        /**
         * Creates a new ListBinHistoryBetweenRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinHistoryBetweenRequest
         * @static
         * @param {pond.IListBinHistoryBetweenRequest=} [properties] Properties to set
         * @returns {pond.ListBinHistoryBetweenRequest} ListBinHistoryBetweenRequest instance
         */
        ListBinHistoryBetweenRequest.create = function create(properties) {
            return new ListBinHistoryBetweenRequest(properties);
        };

        /**
         * Creates a ListBinHistoryBetweenRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinHistoryBetweenRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinHistoryBetweenRequest} ListBinHistoryBetweenRequest
         */
        ListBinHistoryBetweenRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinHistoryBetweenRequest)
                return object;
            var message = new $root.pond.ListBinHistoryBetweenRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListBinHistoryBetweenRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from a ListBinHistoryBetweenRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinHistoryBetweenRequest
         * @static
         * @param {pond.ListBinHistoryBetweenRequest} message ListBinHistoryBetweenRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinHistoryBetweenRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.paging = null;
                object.start = "";
                object.end = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this ListBinHistoryBetweenRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinHistoryBetweenRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinHistoryBetweenRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinHistoryBetweenRequest;
    })();

    pond.ListBinHistoryBetweenResponse = (function() {

        /**
         * Properties of a ListBinHistoryBetweenResponse.
         * @memberof pond
         * @interface IListBinHistoryBetweenResponse
         * @property {Array.<pond.BinHistory>|null} [history] ListBinHistoryBetweenResponse history
         * @property {number|null} [total] ListBinHistoryBetweenResponse total
         */

        /**
         * Constructs a new ListBinHistoryBetweenResponse.
         * @memberof pond
         * @classdesc Represents a ListBinHistoryBetweenResponse.
         * @implements IListBinHistoryBetweenResponse
         * @constructor
         * @param {pond.IListBinHistoryBetweenResponse=} [properties] Properties to set
         */
        function ListBinHistoryBetweenResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinHistoryBetweenResponse history.
         * @member {Array.<pond.BinHistory>} history
         * @memberof pond.ListBinHistoryBetweenResponse
         * @instance
         */
        ListBinHistoryBetweenResponse.prototype.history = $util.emptyArray;

        /**
         * ListBinHistoryBetweenResponse total.
         * @member {number} total
         * @memberof pond.ListBinHistoryBetweenResponse
         * @instance
         */
        ListBinHistoryBetweenResponse.prototype.total = 0;

        /**
         * Creates a new ListBinHistoryBetweenResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinHistoryBetweenResponse
         * @static
         * @param {pond.IListBinHistoryBetweenResponse=} [properties] Properties to set
         * @returns {pond.ListBinHistoryBetweenResponse} ListBinHistoryBetweenResponse instance
         */
        ListBinHistoryBetweenResponse.create = function create(properties) {
            return new ListBinHistoryBetweenResponse(properties);
        };

        /**
         * Creates a ListBinHistoryBetweenResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinHistoryBetweenResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinHistoryBetweenResponse} ListBinHistoryBetweenResponse
         */
        ListBinHistoryBetweenResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinHistoryBetweenResponse)
                return object;
            var message = new $root.pond.ListBinHistoryBetweenResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListBinHistoryBetweenResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListBinHistoryBetweenResponse.history: object expected");
                    message.history[i] = $root.pond.BinHistory.fromObject(object.history[i]);
                }
            }
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListBinHistoryBetweenResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinHistoryBetweenResponse
         * @static
         * @param {pond.ListBinHistoryBetweenResponse} message ListBinHistoryBetweenResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinHistoryBetweenResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults)
                object.total = 0;
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.BinHistory.toObject(message.history[j], options);
            }
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListBinHistoryBetweenResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinHistoryBetweenResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinHistoryBetweenResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinHistoryBetweenResponse;
    })();

    pond.DeviceComponent = (function() {

        /**
         * Properties of a DeviceComponent.
         * @memberof pond
         * @interface IDeviceComponent
         * @property {number|null} [device] DeviceComponent device
         * @property {pond.Component|null} [component] DeviceComponent component
         */

        /**
         * Constructs a new DeviceComponent.
         * @memberof pond
         * @classdesc Represents a DeviceComponent.
         * @implements IDeviceComponent
         * @constructor
         * @param {pond.IDeviceComponent=} [properties] Properties to set
         */
        function DeviceComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceComponent device.
         * @member {number} device
         * @memberof pond.DeviceComponent
         * @instance
         */
        DeviceComponent.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * DeviceComponent component.
         * @member {pond.Component|null|undefined} component
         * @memberof pond.DeviceComponent
         * @instance
         */
        DeviceComponent.prototype.component = null;

        /**
         * Creates a new DeviceComponent instance using the specified properties.
         * @function create
         * @memberof pond.DeviceComponent
         * @static
         * @param {pond.IDeviceComponent=} [properties] Properties to set
         * @returns {pond.DeviceComponent} DeviceComponent instance
         */
        DeviceComponent.create = function create(properties) {
            return new DeviceComponent(properties);
        };

        /**
         * Creates a DeviceComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeviceComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeviceComponent} DeviceComponent
         */
        DeviceComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeviceComponent)
                return object;
            var message = new $root.pond.DeviceComponent();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".pond.DeviceComponent.component: object expected");
                message.component = $root.pond.Component.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeviceComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeviceComponent
         * @static
         * @param {pond.DeviceComponent} message DeviceComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.component = null;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.pond.Component.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this DeviceComponent to JSON.
         * @function toJSON
         * @memberof pond.DeviceComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceComponent;
    })();

    pond.ListBinComponentsRequest = (function() {

        /**
         * Properties of a ListBinComponentsRequest.
         * @memberof pond
         * @interface IListBinComponentsRequest
         * @property {string|null} [bin] ListBinComponentsRequest bin
         */

        /**
         * Constructs a new ListBinComponentsRequest.
         * @memberof pond
         * @classdesc Represents a ListBinComponentsRequest.
         * @implements IListBinComponentsRequest
         * @constructor
         * @param {pond.IListBinComponentsRequest=} [properties] Properties to set
         */
        function ListBinComponentsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentsRequest bin.
         * @member {string} bin
         * @memberof pond.ListBinComponentsRequest
         * @instance
         */
        ListBinComponentsRequest.prototype.bin = "";

        /**
         * Creates a new ListBinComponentsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentsRequest
         * @static
         * @param {pond.IListBinComponentsRequest=} [properties] Properties to set
         * @returns {pond.ListBinComponentsRequest} ListBinComponentsRequest instance
         */
        ListBinComponentsRequest.create = function create(properties) {
            return new ListBinComponentsRequest(properties);
        };

        /**
         * Creates a ListBinComponentsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentsRequest} ListBinComponentsRequest
         */
        ListBinComponentsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentsRequest)
                return object;
            var message = new $root.pond.ListBinComponentsRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentsRequest
         * @static
         * @param {pond.ListBinComponentsRequest} message ListBinComponentsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            return object;
        };

        /**
         * Converts this ListBinComponentsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentsRequest;
    })();

    pond.ListBinComponentsResponse = (function() {

        /**
         * Properties of a ListBinComponentsResponse.
         * @memberof pond
         * @interface IListBinComponentsResponse
         * @property {Array.<pond.Component>|null} [components] ListBinComponentsResponse components
         * @property {Object.<string,number>|null} [componentDevices] ListBinComponentsResponse componentDevices
         */

        /**
         * Constructs a new ListBinComponentsResponse.
         * @memberof pond
         * @classdesc Represents a ListBinComponentsResponse.
         * @implements IListBinComponentsResponse
         * @constructor
         * @param {pond.IListBinComponentsResponse=} [properties] Properties to set
         */
        function ListBinComponentsResponse(properties) {
            this.components = [];
            this.componentDevices = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentsResponse components.
         * @member {Array.<pond.Component>} components
         * @memberof pond.ListBinComponentsResponse
         * @instance
         */
        ListBinComponentsResponse.prototype.components = $util.emptyArray;

        /**
         * ListBinComponentsResponse componentDevices.
         * @member {Object.<string,number>} componentDevices
         * @memberof pond.ListBinComponentsResponse
         * @instance
         */
        ListBinComponentsResponse.prototype.componentDevices = $util.emptyObject;

        /**
         * Creates a new ListBinComponentsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentsResponse
         * @static
         * @param {pond.IListBinComponentsResponse=} [properties] Properties to set
         * @returns {pond.ListBinComponentsResponse} ListBinComponentsResponse instance
         */
        ListBinComponentsResponse.create = function create(properties) {
            return new ListBinComponentsResponse(properties);
        };

        /**
         * Creates a ListBinComponentsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentsResponse} ListBinComponentsResponse
         */
        ListBinComponentsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentsResponse)
                return object;
            var message = new $root.pond.ListBinComponentsResponse();
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.ListBinComponentsResponse.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.ListBinComponentsResponse.components: object expected");
                    message.components[i] = $root.pond.Component.fromObject(object.components[i]);
                }
            }
            if (object.componentDevices) {
                if (typeof object.componentDevices !== "object")
                    throw TypeError(".pond.ListBinComponentsResponse.componentDevices: object expected");
                message.componentDevices = {};
                for (var keys = Object.keys(object.componentDevices), i = 0; i < keys.length; ++i)
                    if ($util.Long)
                        (message.componentDevices[keys[i]] = $util.Long.fromValue(object.componentDevices[keys[i]])).unsigned = true;
                    else if (typeof object.componentDevices[keys[i]] === "string")
                        message.componentDevices[keys[i]] = parseInt(object.componentDevices[keys[i]], 10);
                    else if (typeof object.componentDevices[keys[i]] === "number")
                        message.componentDevices[keys[i]] = object.componentDevices[keys[i]];
                    else if (typeof object.componentDevices[keys[i]] === "object")
                        message.componentDevices[keys[i]] = new $util.LongBits(object.componentDevices[keys[i]].low >>> 0, object.componentDevices[keys[i]].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentsResponse
         * @static
         * @param {pond.ListBinComponentsResponse} message ListBinComponentsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.components = [];
            if (options.objects || options.defaults)
                object.componentDevices = {};
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.Component.toObject(message.components[j], options);
            }
            var keys2;
            if (message.componentDevices && (keys2 = Object.keys(message.componentDevices)).length) {
                object.componentDevices = {};
                for (var j = 0; j < keys2.length; ++j)
                    if (typeof message.componentDevices[keys2[j]] === "number")
                        object.componentDevices[keys2[j]] = options.longs === String ? String(message.componentDevices[keys2[j]]) : message.componentDevices[keys2[j]];
                    else
                        object.componentDevices[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.componentDevices[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.componentDevices[keys2[j]].low >>> 0, message.componentDevices[keys2[j]].high >>> 0).toNumber(true) : message.componentDevices[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListBinComponentsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentsResponse;
    })();

    pond.ListBinComponentsMeasurementsRequest = (function() {

        /**
         * Properties of a ListBinComponentsMeasurementsRequest.
         * @memberof pond
         * @interface IListBinComponentsMeasurementsRequest
         * @property {string|null} [bin] ListBinComponentsMeasurementsRequest bin
         * @property {string|null} [startTime] ListBinComponentsMeasurementsRequest startTime
         * @property {string|null} [endTime] ListBinComponentsMeasurementsRequest endTime
         * @property {boolean|null} [showErrors] ListBinComponentsMeasurementsRequest showErrors
         */

        /**
         * Constructs a new ListBinComponentsMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListBinComponentsMeasurementsRequest.
         * @implements IListBinComponentsMeasurementsRequest
         * @constructor
         * @param {pond.IListBinComponentsMeasurementsRequest=} [properties] Properties to set
         */
        function ListBinComponentsMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentsMeasurementsRequest bin.
         * @member {string} bin
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @instance
         */
        ListBinComponentsMeasurementsRequest.prototype.bin = "";

        /**
         * ListBinComponentsMeasurementsRequest startTime.
         * @member {string} startTime
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @instance
         */
        ListBinComponentsMeasurementsRequest.prototype.startTime = "";

        /**
         * ListBinComponentsMeasurementsRequest endTime.
         * @member {string} endTime
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @instance
         */
        ListBinComponentsMeasurementsRequest.prototype.endTime = "";

        /**
         * ListBinComponentsMeasurementsRequest showErrors.
         * @member {boolean} showErrors
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @instance
         */
        ListBinComponentsMeasurementsRequest.prototype.showErrors = false;

        /**
         * Creates a new ListBinComponentsMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @static
         * @param {pond.IListBinComponentsMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListBinComponentsMeasurementsRequest} ListBinComponentsMeasurementsRequest instance
         */
        ListBinComponentsMeasurementsRequest.create = function create(properties) {
            return new ListBinComponentsMeasurementsRequest(properties);
        };

        /**
         * Creates a ListBinComponentsMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentsMeasurementsRequest} ListBinComponentsMeasurementsRequest
         */
        ListBinComponentsMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentsMeasurementsRequest)
                return object;
            var message = new $root.pond.ListBinComponentsMeasurementsRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            if (object.showErrors != null)
                message.showErrors = Boolean(object.showErrors);
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentsMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @static
         * @param {pond.ListBinComponentsMeasurementsRequest} message ListBinComponentsMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentsMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                object.startTime = "";
                object.endTime = "";
                object.showErrors = false;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            if (message.showErrors != null && message.hasOwnProperty("showErrors"))
                object.showErrors = message.showErrors;
            return object;
        };

        /**
         * Converts this ListBinComponentsMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentsMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentsMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentsMeasurementsRequest;
    })();

    pond.ListBinComponentsMeasurementsResponse = (function() {

        /**
         * Properties of a ListBinComponentsMeasurementsResponse.
         * @memberof pond
         * @interface IListBinComponentsMeasurementsResponse
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [measurements] ListBinComponentsMeasurementsResponse measurements
         */

        /**
         * Constructs a new ListBinComponentsMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListBinComponentsMeasurementsResponse.
         * @implements IListBinComponentsMeasurementsResponse
         * @constructor
         * @param {pond.IListBinComponentsMeasurementsResponse=} [properties] Properties to set
         */
        function ListBinComponentsMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentsMeasurementsResponse measurements.
         * @member {Array.<pond.UnitMeasurementsForComponent>} measurements
         * @memberof pond.ListBinComponentsMeasurementsResponse
         * @instance
         */
        ListBinComponentsMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * Creates a new ListBinComponentsMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentsMeasurementsResponse
         * @static
         * @param {pond.IListBinComponentsMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListBinComponentsMeasurementsResponse} ListBinComponentsMeasurementsResponse instance
         */
        ListBinComponentsMeasurementsResponse.create = function create(properties) {
            return new ListBinComponentsMeasurementsResponse(properties);
        };

        /**
         * Creates a ListBinComponentsMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentsMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentsMeasurementsResponse} ListBinComponentsMeasurementsResponse
         */
        ListBinComponentsMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentsMeasurementsResponse)
                return object;
            var message = new $root.pond.ListBinComponentsMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.ListBinComponentsMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.ListBinComponentsMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.measurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentsMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentsMeasurementsResponse
         * @static
         * @param {pond.ListBinComponentsMeasurementsResponse} message ListBinComponentsMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentsMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.measurements[j], options);
            }
            return object;
        };

        /**
         * Converts this ListBinComponentsMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentsMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentsMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentsMeasurementsResponse;
    })();

    pond.GrainInventory = (function() {

        /**
         * Properties of a GrainInventory.
         * @memberof pond
         * @interface IGrainInventory
         * @property {pond.Grain|null} [grainType] GrainInventory grainType
         * @property {number|null} [bushelAmount] GrainInventory bushelAmount
         * @property {number|null} [bushelCapacity] GrainInventory bushelCapacity
         * @property {Array.<string>|null} [bins] GrainInventory bins
         * @property {number|null} [bushelsPerTonne] GrainInventory bushelsPerTonne
         */

        /**
         * Constructs a new GrainInventory.
         * @memberof pond
         * @classdesc Represents a GrainInventory.
         * @implements IGrainInventory
         * @constructor
         * @param {pond.IGrainInventory=} [properties] Properties to set
         */
        function GrainInventory(properties) {
            this.bins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainInventory grainType.
         * @member {pond.Grain} grainType
         * @memberof pond.GrainInventory
         * @instance
         */
        GrainInventory.prototype.grainType = 0;

        /**
         * GrainInventory bushelAmount.
         * @member {number} bushelAmount
         * @memberof pond.GrainInventory
         * @instance
         */
        GrainInventory.prototype.bushelAmount = 0;

        /**
         * GrainInventory bushelCapacity.
         * @member {number} bushelCapacity
         * @memberof pond.GrainInventory
         * @instance
         */
        GrainInventory.prototype.bushelCapacity = 0;

        /**
         * GrainInventory bins.
         * @member {Array.<string>} bins
         * @memberof pond.GrainInventory
         * @instance
         */
        GrainInventory.prototype.bins = $util.emptyArray;

        /**
         * GrainInventory bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.GrainInventory
         * @instance
         */
        GrainInventory.prototype.bushelsPerTonne = 0;

        /**
         * Creates a new GrainInventory instance using the specified properties.
         * @function create
         * @memberof pond.GrainInventory
         * @static
         * @param {pond.IGrainInventory=} [properties] Properties to set
         * @returns {pond.GrainInventory} GrainInventory instance
         */
        GrainInventory.create = function create(properties) {
            return new GrainInventory(properties);
        };

        /**
         * Creates a GrainInventory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainInventory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainInventory} GrainInventory
         */
        GrainInventory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainInventory)
                return object;
            var message = new $root.pond.GrainInventory();
            switch (object.grainType) {
            case "GRAIN_INVALID":
            case 0:
                message.grainType = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.grainType = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.grainType = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.grainType = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.grainType = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.grainType = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.grainType = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.grainType = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.grainType = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.grainType = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.grainType = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.grainType = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.grainType = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.grainType = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.grainType = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.grainType = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.grainType = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.grainType = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.grainType = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.grainType = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.grainType = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.grainType = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.grainType = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.grainType = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.grainType = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.grainType = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.grainType = 26;
                break;
            }
            if (object.bushelAmount != null)
                message.bushelAmount = Number(object.bushelAmount);
            if (object.bushelCapacity != null)
                message.bushelCapacity = Number(object.bushelCapacity);
            if (object.bins) {
                if (!Array.isArray(object.bins))
                    throw TypeError(".pond.GrainInventory.bins: array expected");
                message.bins = [];
                for (var i = 0; i < object.bins.length; ++i)
                    message.bins[i] = String(object.bins[i]);
            }
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            return message;
        };

        /**
         * Creates a plain object from a GrainInventory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainInventory
         * @static
         * @param {pond.GrainInventory} message GrainInventory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainInventory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bins = [];
            if (options.defaults) {
                object.grainType = options.enums === String ? "GRAIN_INVALID" : 0;
                object.bushelAmount = 0;
                object.bushelCapacity = 0;
                object.bushelsPerTonne = 0;
            }
            if (message.grainType != null && message.hasOwnProperty("grainType"))
                object.grainType = options.enums === String ? $root.pond.Grain[message.grainType] : message.grainType;
            if (message.bushelAmount != null && message.hasOwnProperty("bushelAmount"))
                object.bushelAmount = options.json && !isFinite(message.bushelAmount) ? String(message.bushelAmount) : message.bushelAmount;
            if (message.bushelCapacity != null && message.hasOwnProperty("bushelCapacity"))
                object.bushelCapacity = options.json && !isFinite(message.bushelCapacity) ? String(message.bushelCapacity) : message.bushelCapacity;
            if (message.bins && message.bins.length) {
                object.bins = [];
                for (var j = 0; j < message.bins.length; ++j)
                    object.bins[j] = message.bins[j];
            }
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            return object;
        };

        /**
         * Converts this GrainInventory to JSON.
         * @function toJSON
         * @memberof pond.GrainInventory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainInventory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainInventory;
    })();

    pond.CustomInventory = (function() {

        /**
         * Properties of a CustomInventory.
         * @memberof pond
         * @interface ICustomInventory
         * @property {string|null} [name] CustomInventory name
         * @property {pond.BinStorage|null} [storageType] CustomInventory storageType
         * @property {number|null} [amount] CustomInventory amount
         * @property {number|null} [capacity] CustomInventory capacity
         * @property {Array.<string>|null} [bins] CustomInventory bins
         * @property {number|null} [bushelsPerTonne] CustomInventory bushelsPerTonne
         */

        /**
         * Constructs a new CustomInventory.
         * @memberof pond
         * @classdesc Represents a CustomInventory.
         * @implements ICustomInventory
         * @constructor
         * @param {pond.ICustomInventory=} [properties] Properties to set
         */
        function CustomInventory(properties) {
            this.bins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomInventory name.
         * @member {string} name
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.name = "";

        /**
         * CustomInventory storageType.
         * @member {pond.BinStorage} storageType
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.storageType = 0;

        /**
         * CustomInventory amount.
         * @member {number} amount
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.amount = 0;

        /**
         * CustomInventory capacity.
         * @member {number} capacity
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.capacity = 0;

        /**
         * CustomInventory bins.
         * @member {Array.<string>} bins
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.bins = $util.emptyArray;

        /**
         * CustomInventory bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.CustomInventory
         * @instance
         */
        CustomInventory.prototype.bushelsPerTonne = 0;

        /**
         * Creates a new CustomInventory instance using the specified properties.
         * @function create
         * @memberof pond.CustomInventory
         * @static
         * @param {pond.ICustomInventory=} [properties] Properties to set
         * @returns {pond.CustomInventory} CustomInventory instance
         */
        CustomInventory.create = function create(properties) {
            return new CustomInventory(properties);
        };

        /**
         * Creates a CustomInventory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CustomInventory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CustomInventory} CustomInventory
         */
        CustomInventory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CustomInventory)
                return object;
            var message = new $root.pond.CustomInventory();
            if (object.name != null)
                message.name = String(object.name);
            switch (object.storageType) {
            case "BIN_STORAGE_UNKNOWN":
            case 0:
                message.storageType = 0;
                break;
            case "BIN_STORAGE_SUPPORTED_GRAIN":
            case 1:
                message.storageType = 1;
                break;
            case "BIN_STORAGE_FERTILIZER":
            case 2:
                message.storageType = 2;
                break;
            case "BIN_STORAGE_UNSUPPORTED_GRAIN":
            case 3:
                message.storageType = 3;
                break;
            }
            if (object.amount != null)
                message.amount = Number(object.amount);
            if (object.capacity != null)
                message.capacity = Number(object.capacity);
            if (object.bins) {
                if (!Array.isArray(object.bins))
                    throw TypeError(".pond.CustomInventory.bins: array expected");
                message.bins = [];
                for (var i = 0; i < object.bins.length; ++i)
                    message.bins[i] = String(object.bins[i]);
            }
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            return message;
        };

        /**
         * Creates a plain object from a CustomInventory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CustomInventory
         * @static
         * @param {pond.CustomInventory} message CustomInventory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomInventory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bins = [];
            if (options.defaults) {
                object.name = "";
                object.storageType = options.enums === String ? "BIN_STORAGE_UNKNOWN" : 0;
                object.amount = 0;
                object.capacity = 0;
                object.bushelsPerTonne = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.storageType != null && message.hasOwnProperty("storageType"))
                object.storageType = options.enums === String ? $root.pond.BinStorage[message.storageType] : message.storageType;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
            if (message.capacity != null && message.hasOwnProperty("capacity"))
                object.capacity = options.json && !isFinite(message.capacity) ? String(message.capacity) : message.capacity;
            if (message.bins && message.bins.length) {
                object.bins = [];
                for (var j = 0; j < message.bins.length; ++j)
                    object.bins[j] = message.bins[j];
            }
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            return object;
        };

        /**
         * Converts this CustomInventory to JSON.
         * @function toJSON
         * @memberof pond.CustomInventory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomInventory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomInventory;
    })();

    pond.BinMetrics = (function() {

        /**
         * Properties of a BinMetrics.
         * @memberof pond
         * @interface IBinMetrics
         * @property {Array.<pond.GrainInventory>|null} [grainInventory] BinMetrics grainInventory
         * @property {Array.<pond.CustomInventory>|null} [customInventory] BinMetrics customInventory
         */

        /**
         * Constructs a new BinMetrics.
         * @memberof pond
         * @classdesc Represents a BinMetrics.
         * @implements IBinMetrics
         * @constructor
         * @param {pond.IBinMetrics=} [properties] Properties to set
         */
        function BinMetrics(properties) {
            this.grainInventory = [];
            this.customInventory = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinMetrics grainInventory.
         * @member {Array.<pond.GrainInventory>} grainInventory
         * @memberof pond.BinMetrics
         * @instance
         */
        BinMetrics.prototype.grainInventory = $util.emptyArray;

        /**
         * BinMetrics customInventory.
         * @member {Array.<pond.CustomInventory>} customInventory
         * @memberof pond.BinMetrics
         * @instance
         */
        BinMetrics.prototype.customInventory = $util.emptyArray;

        /**
         * Creates a new BinMetrics instance using the specified properties.
         * @function create
         * @memberof pond.BinMetrics
         * @static
         * @param {pond.IBinMetrics=} [properties] Properties to set
         * @returns {pond.BinMetrics} BinMetrics instance
         */
        BinMetrics.create = function create(properties) {
            return new BinMetrics(properties);
        };

        /**
         * Creates a BinMetrics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinMetrics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinMetrics} BinMetrics
         */
        BinMetrics.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinMetrics)
                return object;
            var message = new $root.pond.BinMetrics();
            if (object.grainInventory) {
                if (!Array.isArray(object.grainInventory))
                    throw TypeError(".pond.BinMetrics.grainInventory: array expected");
                message.grainInventory = [];
                for (var i = 0; i < object.grainInventory.length; ++i) {
                    if (typeof object.grainInventory[i] !== "object")
                        throw TypeError(".pond.BinMetrics.grainInventory: object expected");
                    message.grainInventory[i] = $root.pond.GrainInventory.fromObject(object.grainInventory[i]);
                }
            }
            if (object.customInventory) {
                if (!Array.isArray(object.customInventory))
                    throw TypeError(".pond.BinMetrics.customInventory: array expected");
                message.customInventory = [];
                for (var i = 0; i < object.customInventory.length; ++i) {
                    if (typeof object.customInventory[i] !== "object")
                        throw TypeError(".pond.BinMetrics.customInventory: object expected");
                    message.customInventory[i] = $root.pond.CustomInventory.fromObject(object.customInventory[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BinMetrics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinMetrics
         * @static
         * @param {pond.BinMetrics} message BinMetrics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinMetrics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.grainInventory = [];
                object.customInventory = [];
            }
            if (message.grainInventory && message.grainInventory.length) {
                object.grainInventory = [];
                for (var j = 0; j < message.grainInventory.length; ++j)
                    object.grainInventory[j] = $root.pond.GrainInventory.toObject(message.grainInventory[j], options);
            }
            if (message.customInventory && message.customInventory.length) {
                object.customInventory = [];
                for (var j = 0; j < message.customInventory.length; ++j)
                    object.customInventory[j] = $root.pond.CustomInventory.toObject(message.customInventory[j], options);
            }
            return object;
        };

        /**
         * Converts this BinMetrics to JSON.
         * @function toJSON
         * @memberof pond.BinMetrics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinMetrics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinMetrics;
    })();

    pond.GetBinMetricsRequest = (function() {

        /**
         * Properties of a GetBinMetricsRequest.
         * @memberof pond
         * @interface IGetBinMetricsRequest
         * @property {string|null} [search] GetBinMetricsRequest search
         */

        /**
         * Constructs a new GetBinMetricsRequest.
         * @memberof pond
         * @classdesc Represents a GetBinMetricsRequest.
         * @implements IGetBinMetricsRequest
         * @constructor
         * @param {pond.IGetBinMetricsRequest=} [properties] Properties to set
         */
        function GetBinMetricsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinMetricsRequest search.
         * @member {string} search
         * @memberof pond.GetBinMetricsRequest
         * @instance
         */
        GetBinMetricsRequest.prototype.search = "";

        /**
         * Creates a new GetBinMetricsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBinMetricsRequest
         * @static
         * @param {pond.IGetBinMetricsRequest=} [properties] Properties to set
         * @returns {pond.GetBinMetricsRequest} GetBinMetricsRequest instance
         */
        GetBinMetricsRequest.create = function create(properties) {
            return new GetBinMetricsRequest(properties);
        };

        /**
         * Creates a GetBinMetricsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinMetricsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinMetricsRequest} GetBinMetricsRequest
         */
        GetBinMetricsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinMetricsRequest)
                return object;
            var message = new $root.pond.GetBinMetricsRequest();
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a GetBinMetricsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinMetricsRequest
         * @static
         * @param {pond.GetBinMetricsRequest} message GetBinMetricsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinMetricsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.search = "";
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this GetBinMetricsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBinMetricsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinMetricsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinMetricsRequest;
    })();

    pond.GetBinMetricsResponse = (function() {

        /**
         * Properties of a GetBinMetricsResponse.
         * @memberof pond
         * @interface IGetBinMetricsResponse
         * @property {pond.BinMetrics|null} [metrics] GetBinMetricsResponse metrics
         */

        /**
         * Constructs a new GetBinMetricsResponse.
         * @memberof pond
         * @classdesc Represents a GetBinMetricsResponse.
         * @implements IGetBinMetricsResponse
         * @constructor
         * @param {pond.IGetBinMetricsResponse=} [properties] Properties to set
         */
        function GetBinMetricsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBinMetricsResponse metrics.
         * @member {pond.BinMetrics|null|undefined} metrics
         * @memberof pond.GetBinMetricsResponse
         * @instance
         */
        GetBinMetricsResponse.prototype.metrics = null;

        /**
         * Creates a new GetBinMetricsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetBinMetricsResponse
         * @static
         * @param {pond.IGetBinMetricsResponse=} [properties] Properties to set
         * @returns {pond.GetBinMetricsResponse} GetBinMetricsResponse instance
         */
        GetBinMetricsResponse.create = function create(properties) {
            return new GetBinMetricsResponse(properties);
        };

        /**
         * Creates a GetBinMetricsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBinMetricsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBinMetricsResponse} GetBinMetricsResponse
         */
        GetBinMetricsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBinMetricsResponse)
                return object;
            var message = new $root.pond.GetBinMetricsResponse();
            if (object.metrics != null) {
                if (typeof object.metrics !== "object")
                    throw TypeError(".pond.GetBinMetricsResponse.metrics: object expected");
                message.metrics = $root.pond.BinMetrics.fromObject(object.metrics);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetBinMetricsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBinMetricsResponse
         * @static
         * @param {pond.GetBinMetricsResponse} message GetBinMetricsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBinMetricsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.metrics = null;
            if (message.metrics != null && message.hasOwnProperty("metrics"))
                object.metrics = $root.pond.BinMetrics.toObject(message.metrics, options);
            return object;
        };

        /**
         * Converts this GetBinMetricsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetBinMetricsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBinMetricsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBinMetricsResponse;
    })();

    pond.ListBinLitersRequest = (function() {

        /**
         * Properties of a ListBinLitersRequest.
         * @memberof pond
         * @interface IListBinLitersRequest
         * @property {string|null} [binKey] ListBinLitersRequest binKey
         * @property {string|null} [startTime] ListBinLitersRequest startTime
         * @property {string|null} [endTime] ListBinLitersRequest endTime
         * @property {number|null} [initialMoisture] ListBinLitersRequest initialMoisture
         * @property {boolean|null} [unitMeasurements] ListBinLitersRequest unitMeasurements
         * @property {string|null} [plenum] ListBinLitersRequest plenum
         * @property {string|null} [pressure] ListBinLitersRequest pressure
         * @property {string|null} [mainCable] ListBinLitersRequest mainCable
         * @property {string|null} [fanController] ListBinLitersRequest fanController
         */

        /**
         * Constructs a new ListBinLitersRequest.
         * @memberof pond
         * @classdesc Represents a ListBinLitersRequest.
         * @implements IListBinLitersRequest
         * @constructor
         * @param {pond.IListBinLitersRequest=} [properties] Properties to set
         */
        function ListBinLitersRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinLitersRequest binKey.
         * @member {string} binKey
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.binKey = "";

        /**
         * ListBinLitersRequest startTime.
         * @member {string} startTime
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.startTime = "";

        /**
         * ListBinLitersRequest endTime.
         * @member {string} endTime
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.endTime = "";

        /**
         * ListBinLitersRequest initialMoisture.
         * @member {number} initialMoisture
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.initialMoisture = 0;

        /**
         * ListBinLitersRequest unitMeasurements.
         * @member {boolean} unitMeasurements
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.unitMeasurements = false;

        /**
         * ListBinLitersRequest plenum.
         * @member {string} plenum
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.plenum = "";

        /**
         * ListBinLitersRequest pressure.
         * @member {string} pressure
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.pressure = "";

        /**
         * ListBinLitersRequest mainCable.
         * @member {string} mainCable
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.mainCable = "";

        /**
         * ListBinLitersRequest fanController.
         * @member {string} fanController
         * @memberof pond.ListBinLitersRequest
         * @instance
         */
        ListBinLitersRequest.prototype.fanController = "";

        /**
         * Creates a new ListBinLitersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinLitersRequest
         * @static
         * @param {pond.IListBinLitersRequest=} [properties] Properties to set
         * @returns {pond.ListBinLitersRequest} ListBinLitersRequest instance
         */
        ListBinLitersRequest.create = function create(properties) {
            return new ListBinLitersRequest(properties);
        };

        /**
         * Creates a ListBinLitersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinLitersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinLitersRequest} ListBinLitersRequest
         */
        ListBinLitersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinLitersRequest)
                return object;
            var message = new $root.pond.ListBinLitersRequest();
            if (object.binKey != null)
                message.binKey = String(object.binKey);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            if (object.initialMoisture != null)
                message.initialMoisture = Number(object.initialMoisture);
            if (object.unitMeasurements != null)
                message.unitMeasurements = Boolean(object.unitMeasurements);
            if (object.plenum != null)
                message.plenum = String(object.plenum);
            if (object.pressure != null)
                message.pressure = String(object.pressure);
            if (object.mainCable != null)
                message.mainCable = String(object.mainCable);
            if (object.fanController != null)
                message.fanController = String(object.fanController);
            return message;
        };

        /**
         * Creates a plain object from a ListBinLitersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinLitersRequest
         * @static
         * @param {pond.ListBinLitersRequest} message ListBinLitersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinLitersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.binKey = "";
                object.startTime = "";
                object.endTime = "";
                object.initialMoisture = 0;
                object.unitMeasurements = false;
                object.plenum = "";
                object.pressure = "";
                object.mainCable = "";
                object.fanController = "";
            }
            if (message.binKey != null && message.hasOwnProperty("binKey"))
                object.binKey = message.binKey;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            if (message.initialMoisture != null && message.hasOwnProperty("initialMoisture"))
                object.initialMoisture = options.json && !isFinite(message.initialMoisture) ? String(message.initialMoisture) : message.initialMoisture;
            if (message.unitMeasurements != null && message.hasOwnProperty("unitMeasurements"))
                object.unitMeasurements = message.unitMeasurements;
            if (message.plenum != null && message.hasOwnProperty("plenum"))
                object.plenum = message.plenum;
            if (message.pressure != null && message.hasOwnProperty("pressure"))
                object.pressure = message.pressure;
            if (message.mainCable != null && message.hasOwnProperty("mainCable"))
                object.mainCable = message.mainCable;
            if (message.fanController != null && message.hasOwnProperty("fanController"))
                object.fanController = message.fanController;
            return object;
        };

        /**
         * Converts this ListBinLitersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinLitersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinLitersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinLitersRequest;
    })();

    pond.ListBinLiterResponse = (function() {

        /**
         * Properties of a ListBinLiterResponse.
         * @memberof pond
         * @interface IListBinLiterResponse
         * @property {Array.<pond.LitersAt>|null} [liters] ListBinLiterResponse liters
         */

        /**
         * Constructs a new ListBinLiterResponse.
         * @memberof pond
         * @classdesc Represents a ListBinLiterResponse.
         * @implements IListBinLiterResponse
         * @constructor
         * @param {pond.IListBinLiterResponse=} [properties] Properties to set
         */
        function ListBinLiterResponse(properties) {
            this.liters = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinLiterResponse liters.
         * @member {Array.<pond.LitersAt>} liters
         * @memberof pond.ListBinLiterResponse
         * @instance
         */
        ListBinLiterResponse.prototype.liters = $util.emptyArray;

        /**
         * Creates a new ListBinLiterResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinLiterResponse
         * @static
         * @param {pond.IListBinLiterResponse=} [properties] Properties to set
         * @returns {pond.ListBinLiterResponse} ListBinLiterResponse instance
         */
        ListBinLiterResponse.create = function create(properties) {
            return new ListBinLiterResponse(properties);
        };

        /**
         * Creates a ListBinLiterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinLiterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinLiterResponse} ListBinLiterResponse
         */
        ListBinLiterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinLiterResponse)
                return object;
            var message = new $root.pond.ListBinLiterResponse();
            if (object.liters) {
                if (!Array.isArray(object.liters))
                    throw TypeError(".pond.ListBinLiterResponse.liters: array expected");
                message.liters = [];
                for (var i = 0; i < object.liters.length; ++i) {
                    if (typeof object.liters[i] !== "object")
                        throw TypeError(".pond.ListBinLiterResponse.liters: object expected");
                    message.liters[i] = $root.pond.LitersAt.fromObject(object.liters[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinLiterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinLiterResponse
         * @static
         * @param {pond.ListBinLiterResponse} message ListBinLiterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinLiterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.liters = [];
            if (message.liters && message.liters.length) {
                object.liters = [];
                for (var j = 0; j < message.liters.length; ++j)
                    object.liters[j] = $root.pond.LitersAt.toObject(message.liters[j], options);
            }
            return object;
        };

        /**
         * Converts this ListBinLiterResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinLiterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinLiterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinLiterResponse;
    })();

    pond.LitersAt = (function() {

        /**
         * Properties of a LitersAt.
         * @memberof pond
         * @interface ILitersAt
         * @property {number|null} [liters] LitersAt liters
         * @property {string|null} [time] LitersAt time
         */

        /**
         * Constructs a new LitersAt.
         * @memberof pond
         * @classdesc Represents a LitersAt.
         * @implements ILitersAt
         * @constructor
         * @param {pond.ILitersAt=} [properties] Properties to set
         */
        function LitersAt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LitersAt liters.
         * @member {number} liters
         * @memberof pond.LitersAt
         * @instance
         */
        LitersAt.prototype.liters = 0;

        /**
         * LitersAt time.
         * @member {string} time
         * @memberof pond.LitersAt
         * @instance
         */
        LitersAt.prototype.time = "";

        /**
         * Creates a new LitersAt instance using the specified properties.
         * @function create
         * @memberof pond.LitersAt
         * @static
         * @param {pond.ILitersAt=} [properties] Properties to set
         * @returns {pond.LitersAt} LitersAt instance
         */
        LitersAt.create = function create(properties) {
            return new LitersAt(properties);
        };

        /**
         * Creates a LitersAt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LitersAt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LitersAt} LitersAt
         */
        LitersAt.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LitersAt)
                return object;
            var message = new $root.pond.LitersAt();
            if (object.liters != null)
                message.liters = Number(object.liters);
            if (object.time != null)
                message.time = String(object.time);
            return message;
        };

        /**
         * Creates a plain object from a LitersAt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LitersAt
         * @static
         * @param {pond.LitersAt} message LitersAt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LitersAt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.liters = 0;
                object.time = "";
            }
            if (message.liters != null && message.hasOwnProperty("liters"))
                object.liters = options.json && !isFinite(message.liters) ? String(message.liters) : message.liters;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            return object;
        };

        /**
         * Converts this LitersAt to JSON.
         * @function toJSON
         * @memberof pond.LitersAt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LitersAt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LitersAt;
    })();

    /**
     * NotificationMethod enum.
     * @name pond.NotificationMethod
     * @enum {string}
     * @property {number} NOTIFICATION_METHOD_INVALID=0 NOTIFICATION_METHOD_INVALID value
     * @property {number} NOTIFICATION_METHOD_EMAIL=1 NOTIFICATION_METHOD_EMAIL value
     * @property {number} NOTIFICATION_METHOD_TEXT=2 NOTIFICATION_METHOD_TEXT value
     * @property {number} NOTIFICATION_METHOD_APP=3 NOTIFICATION_METHOD_APP value
     */
    pond.NotificationMethod = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NOTIFICATION_METHOD_INVALID"] = 0;
        values[valuesById[1] = "NOTIFICATION_METHOD_EMAIL"] = 1;
        values[valuesById[2] = "NOTIFICATION_METHOD_TEXT"] = 2;
        values[valuesById[3] = "NOTIFICATION_METHOD_APP"] = 3;
        return values;
    })();

    /**
     * DistanceUnit enum.
     * @name pond.DistanceUnit
     * @enum {string}
     * @property {number} DISTANCE_UNIT_UNKNOWN=0 DISTANCE_UNIT_UNKNOWN value
     * @property {number} DISTANCE_UNIT_FEET=1 DISTANCE_UNIT_FEET value
     * @property {number} DISTANCE_UNIT_METERS=2 DISTANCE_UNIT_METERS value
     */
    pond.DistanceUnit = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DISTANCE_UNIT_UNKNOWN"] = 0;
        values[valuesById[1] = "DISTANCE_UNIT_FEET"] = 1;
        values[valuesById[2] = "DISTANCE_UNIT_METERS"] = 2;
        return values;
    })();

    /**
     * TemperatureUnit enum.
     * @name pond.TemperatureUnit
     * @enum {string}
     * @property {number} TEMPERATURE_UNIT_UNKNOWN=0 TEMPERATURE_UNIT_UNKNOWN value
     * @property {number} TEMPERATURE_UNIT_CELSIUS=1 TEMPERATURE_UNIT_CELSIUS value
     * @property {number} TEMPERATURE_UNIT_FAHRENHEIT=2 TEMPERATURE_UNIT_FAHRENHEIT value
     */
    pond.TemperatureUnit = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TEMPERATURE_UNIT_UNKNOWN"] = 0;
        values[valuesById[1] = "TEMPERATURE_UNIT_CELSIUS"] = 1;
        values[valuesById[2] = "TEMPERATURE_UNIT_FAHRENHEIT"] = 2;
        return values;
    })();

    /**
     * PressureUnit enum.
     * @name pond.PressureUnit
     * @enum {string}
     * @property {number} PRESSURE_UNIT_UNKNOWN=0 PRESSURE_UNIT_UNKNOWN value
     * @property {number} PRESSURE_UNIT_KILOPASCALS=1 PRESSURE_UNIT_KILOPASCALS value
     * @property {number} PRESSURE_UNIT_INCHES_OF_WATER=2 PRESSURE_UNIT_INCHES_OF_WATER value
     */
    pond.PressureUnit = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRESSURE_UNIT_UNKNOWN"] = 0;
        values[valuesById[1] = "PRESSURE_UNIT_KILOPASCALS"] = 1;
        values[valuesById[2] = "PRESSURE_UNIT_INCHES_OF_WATER"] = 2;
        return values;
    })();

    /**
     * GrainUnit enum.
     * @name pond.GrainUnit
     * @enum {string}
     * @property {number} GRAIN_UNIT_UNKNOWN=0 GRAIN_UNIT_UNKNOWN value
     * @property {number} GRAIN_UNIT_BUSHELS=1 GRAIN_UNIT_BUSHELS value
     * @property {number} GRAIN_UNIT_WEIGHT=2 GRAIN_UNIT_WEIGHT value
     */
    pond.GrainUnit = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GRAIN_UNIT_UNKNOWN"] = 0;
        values[valuesById[1] = "GRAIN_UNIT_BUSHELS"] = 1;
        values[valuesById[2] = "GRAIN_UNIT_WEIGHT"] = 2;
        return values;
    })();

    pond.Notification = (function() {

        /**
         * Properties of a Notification.
         * @memberof pond
         * @interface INotification
         * @property {pond.NotificationSettings|null} [settings] Notification settings
         * @property {pond.NotificationStatus|null} [status] Notification status
         */

        /**
         * Constructs a new Notification.
         * @memberof pond
         * @classdesc Represents a Notification.
         * @implements INotification
         * @constructor
         * @param {pond.INotification=} [properties] Properties to set
         */
        function Notification(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Notification settings.
         * @member {pond.NotificationSettings|null|undefined} settings
         * @memberof pond.Notification
         * @instance
         */
        Notification.prototype.settings = null;

        /**
         * Notification status.
         * @member {pond.NotificationStatus|null|undefined} status
         * @memberof pond.Notification
         * @instance
         */
        Notification.prototype.status = null;

        /**
         * Creates a new Notification instance using the specified properties.
         * @function create
         * @memberof pond.Notification
         * @static
         * @param {pond.INotification=} [properties] Properties to set
         * @returns {pond.Notification} Notification instance
         */
        Notification.create = function create(properties) {
            return new Notification(properties);
        };

        /**
         * Creates a Notification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Notification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Notification} Notification
         */
        Notification.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Notification)
                return object;
            var message = new $root.pond.Notification();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Notification.settings: object expected");
                message.settings = $root.pond.NotificationSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.Notification.status: object expected");
                message.status = $root.pond.NotificationStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a Notification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Notification
         * @static
         * @param {pond.Notification} message Notification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Notification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.NotificationSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.NotificationStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this Notification to JSON.
         * @function toJSON
         * @memberof pond.Notification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Notification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Notification;
    })();

    pond.NotificationSettings = (function() {

        /**
         * Properties of a NotificationSettings.
         * @memberof pond
         * @interface INotificationSettings
         * @property {string|null} [key] NotificationSettings key
         * @property {string|null} [title] NotificationSettings title
         * @property {string|null} [message] NotificationSettings message
         * @property {string|null} [subtitle] NotificationSettings subtitle
         * @property {string|null} [sourceType] NotificationSettings sourceType
         * @property {string|null} [sourceKey] NotificationSettings sourceKey
         * @property {quack.ComponentID|null} [componentSource] NotificationSettings componentSource
         * @property {string|null} [logo] NotificationSettings logo
         */

        /**
         * Constructs a new NotificationSettings.
         * @memberof pond
         * @classdesc Represents a NotificationSettings.
         * @implements INotificationSettings
         * @constructor
         * @param {pond.INotificationSettings=} [properties] Properties to set
         */
        function NotificationSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationSettings key.
         * @member {string} key
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.key = "";

        /**
         * NotificationSettings title.
         * @member {string} title
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.title = "";

        /**
         * NotificationSettings message.
         * @member {string} message
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.message = "";

        /**
         * NotificationSettings subtitle.
         * @member {string} subtitle
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.subtitle = "";

        /**
         * NotificationSettings sourceType.
         * @member {string} sourceType
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.sourceType = "";

        /**
         * NotificationSettings sourceKey.
         * @member {string} sourceKey
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.sourceKey = "";

        /**
         * NotificationSettings componentSource.
         * @member {quack.ComponentID|null|undefined} componentSource
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.componentSource = null;

        /**
         * NotificationSettings logo.
         * @member {string} logo
         * @memberof pond.NotificationSettings
         * @instance
         */
        NotificationSettings.prototype.logo = "";

        /**
         * Creates a new NotificationSettings instance using the specified properties.
         * @function create
         * @memberof pond.NotificationSettings
         * @static
         * @param {pond.INotificationSettings=} [properties] Properties to set
         * @returns {pond.NotificationSettings} NotificationSettings instance
         */
        NotificationSettings.create = function create(properties) {
            return new NotificationSettings(properties);
        };

        /**
         * Creates a NotificationSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NotificationSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NotificationSettings} NotificationSettings
         */
        NotificationSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NotificationSettings)
                return object;
            var message = new $root.pond.NotificationSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.title != null)
                message.title = String(object.title);
            if (object.message != null)
                message.message = String(object.message);
            if (object.subtitle != null)
                message.subtitle = String(object.subtitle);
            if (object.sourceType != null)
                message.sourceType = String(object.sourceType);
            if (object.sourceKey != null)
                message.sourceKey = String(object.sourceKey);
            if (object.componentSource != null) {
                if (typeof object.componentSource !== "object")
                    throw TypeError(".pond.NotificationSettings.componentSource: object expected");
                message.componentSource = $root.quack.ComponentID.fromObject(object.componentSource);
            }
            if (object.logo != null)
                message.logo = String(object.logo);
            return message;
        };

        /**
         * Creates a plain object from a NotificationSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NotificationSettings
         * @static
         * @param {pond.NotificationSettings} message NotificationSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.title = "";
                object.message = "";
                object.subtitle = "";
                object.sourceType = "";
                object.sourceKey = "";
                object.componentSource = null;
                object.logo = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.subtitle != null && message.hasOwnProperty("subtitle"))
                object.subtitle = message.subtitle;
            if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                object.sourceType = message.sourceType;
            if (message.sourceKey != null && message.hasOwnProperty("sourceKey"))
                object.sourceKey = message.sourceKey;
            if (message.componentSource != null && message.hasOwnProperty("componentSource"))
                object.componentSource = $root.quack.ComponentID.toObject(message.componentSource, options);
            if (message.logo != null && message.hasOwnProperty("logo"))
                object.logo = message.logo;
            return object;
        };

        /**
         * Converts this NotificationSettings to JSON.
         * @function toJSON
         * @memberof pond.NotificationSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationSettings;
    })();

    pond.NotificationStatus = (function() {

        /**
         * Properties of a NotificationStatus.
         * @memberof pond
         * @interface INotificationStatus
         * @property {string|null} [timestamp] NotificationStatus timestamp
         */

        /**
         * Constructs a new NotificationStatus.
         * @memberof pond
         * @classdesc Represents a NotificationStatus.
         * @implements INotificationStatus
         * @constructor
         * @param {pond.INotificationStatus=} [properties] Properties to set
         */
        function NotificationStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationStatus timestamp.
         * @member {string} timestamp
         * @memberof pond.NotificationStatus
         * @instance
         */
        NotificationStatus.prototype.timestamp = "";

        /**
         * Creates a new NotificationStatus instance using the specified properties.
         * @function create
         * @memberof pond.NotificationStatus
         * @static
         * @param {pond.INotificationStatus=} [properties] Properties to set
         * @returns {pond.NotificationStatus} NotificationStatus instance
         */
        NotificationStatus.create = function create(properties) {
            return new NotificationStatus(properties);
        };

        /**
         * Creates a NotificationStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NotificationStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NotificationStatus} NotificationStatus
         */
        NotificationStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NotificationStatus)
                return object;
            var message = new $root.pond.NotificationStatus();
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            return message;
        };

        /**
         * Creates a plain object from a NotificationStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NotificationStatus
         * @static
         * @param {pond.NotificationStatus} message NotificationStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.timestamp = "";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            return object;
        };

        /**
         * Converts this NotificationStatus to JSON.
         * @function toJSON
         * @memberof pond.NotificationStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationStatus;
    })();

    pond.UserSettings = (function() {

        /**
         * Properties of a UserSettings.
         * @memberof pond
         * @interface IUserSettings
         * @property {string|null} [id] UserSettings id
         * @property {string|null} [email] UserSettings email
         * @property {string|null} [name] UserSettings name
         * @property {string|null} [avatar] UserSettings avatar
         * @property {boolean|null} [notifyByDefault] UserSettings notifyByDefault
         * @property {Array.<pond.NotificationMethod>|null} [notificationMethods] UserSettings notificationMethods
         * @property {string|null} [phoneNumber] UserSettings phoneNumber
         * @property {string|null} [timezone] UserSettings timezone
         * @property {pond.DistanceUnit|null} [distanceUnit] UserSettings distanceUnit
         * @property {pond.TemperatureUnit|null} [temperatureUnit] UserSettings temperatureUnit
         * @property {pond.PressureUnit|null} [pressureUnit] UserSettings pressureUnit
         * @property {Array.<string>|null} [features] UserSettings features
         * @property {Array.<string>|null} [actions] UserSettings actions
         * @property {string|null} [recluseClient] UserSettings recluseClient
         * @property {Array.<string>|null} [binYards] UserSettings binYards
         * @property {string|null} [stripeKey] UserSettings stripeKey
         * @property {string|null} [defaultTeam] UserSettings defaultTeam
         * @property {boolean|null} [useTeam] UserSettings useTeam
         * @property {number|null} [mapZoom] UserSettings mapZoom
         * @property {pond.GrainUnit|null} [grainUnit] UserSettings grainUnit
         */

        /**
         * Constructs a new UserSettings.
         * @memberof pond
         * @classdesc Represents a UserSettings.
         * @implements IUserSettings
         * @constructor
         * @param {pond.IUserSettings=} [properties] Properties to set
         */
        function UserSettings(properties) {
            this.notificationMethods = [];
            this.features = [];
            this.actions = [];
            this.binYards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserSettings id.
         * @member {string} id
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.id = "";

        /**
         * UserSettings email.
         * @member {string} email
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.email = "";

        /**
         * UserSettings name.
         * @member {string} name
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.name = "";

        /**
         * UserSettings avatar.
         * @member {string} avatar
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.avatar = "";

        /**
         * UserSettings notifyByDefault.
         * @member {boolean} notifyByDefault
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.notifyByDefault = false;

        /**
         * UserSettings notificationMethods.
         * @member {Array.<pond.NotificationMethod>} notificationMethods
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.notificationMethods = $util.emptyArray;

        /**
         * UserSettings phoneNumber.
         * @member {string} phoneNumber
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.phoneNumber = "";

        /**
         * UserSettings timezone.
         * @member {string} timezone
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.timezone = "";

        /**
         * UserSettings distanceUnit.
         * @member {pond.DistanceUnit} distanceUnit
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.distanceUnit = 0;

        /**
         * UserSettings temperatureUnit.
         * @member {pond.TemperatureUnit} temperatureUnit
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.temperatureUnit = 0;

        /**
         * UserSettings pressureUnit.
         * @member {pond.PressureUnit} pressureUnit
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.pressureUnit = 0;

        /**
         * UserSettings features.
         * @member {Array.<string>} features
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.features = $util.emptyArray;

        /**
         * UserSettings actions.
         * @member {Array.<string>} actions
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.actions = $util.emptyArray;

        /**
         * UserSettings recluseClient.
         * @member {string} recluseClient
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.recluseClient = "";

        /**
         * UserSettings binYards.
         * @member {Array.<string>} binYards
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.binYards = $util.emptyArray;

        /**
         * UserSettings stripeKey.
         * @member {string} stripeKey
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.stripeKey = "";

        /**
         * UserSettings defaultTeam.
         * @member {string} defaultTeam
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.defaultTeam = "";

        /**
         * UserSettings useTeam.
         * @member {boolean} useTeam
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.useTeam = false;

        /**
         * UserSettings mapZoom.
         * @member {number} mapZoom
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.mapZoom = 0;

        /**
         * UserSettings grainUnit.
         * @member {pond.GrainUnit} grainUnit
         * @memberof pond.UserSettings
         * @instance
         */
        UserSettings.prototype.grainUnit = 0;

        /**
         * Creates a new UserSettings instance using the specified properties.
         * @function create
         * @memberof pond.UserSettings
         * @static
         * @param {pond.IUserSettings=} [properties] Properties to set
         * @returns {pond.UserSettings} UserSettings instance
         */
        UserSettings.create = function create(properties) {
            return new UserSettings(properties);
        };

        /**
         * Creates a UserSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UserSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UserSettings} UserSettings
         */
        UserSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UserSettings)
                return object;
            var message = new $root.pond.UserSettings();
            if (object.id != null)
                message.id = String(object.id);
            if (object.email != null)
                message.email = String(object.email);
            if (object.name != null)
                message.name = String(object.name);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.notifyByDefault != null)
                message.notifyByDefault = Boolean(object.notifyByDefault);
            if (object.notificationMethods) {
                if (!Array.isArray(object.notificationMethods))
                    throw TypeError(".pond.UserSettings.notificationMethods: array expected");
                message.notificationMethods = [];
                for (var i = 0; i < object.notificationMethods.length; ++i)
                    switch (object.notificationMethods[i]) {
                    default:
                    case "NOTIFICATION_METHOD_INVALID":
                    case 0:
                        message.notificationMethods[i] = 0;
                        break;
                    case "NOTIFICATION_METHOD_EMAIL":
                    case 1:
                        message.notificationMethods[i] = 1;
                        break;
                    case "NOTIFICATION_METHOD_TEXT":
                    case 2:
                        message.notificationMethods[i] = 2;
                        break;
                    case "NOTIFICATION_METHOD_APP":
                    case 3:
                        message.notificationMethods[i] = 3;
                        break;
                    }
            }
            if (object.phoneNumber != null)
                message.phoneNumber = String(object.phoneNumber);
            if (object.timezone != null)
                message.timezone = String(object.timezone);
            switch (object.distanceUnit) {
            case "DISTANCE_UNIT_UNKNOWN":
            case 0:
                message.distanceUnit = 0;
                break;
            case "DISTANCE_UNIT_FEET":
            case 1:
                message.distanceUnit = 1;
                break;
            case "DISTANCE_UNIT_METERS":
            case 2:
                message.distanceUnit = 2;
                break;
            }
            switch (object.temperatureUnit) {
            case "TEMPERATURE_UNIT_UNKNOWN":
            case 0:
                message.temperatureUnit = 0;
                break;
            case "TEMPERATURE_UNIT_CELSIUS":
            case 1:
                message.temperatureUnit = 1;
                break;
            case "TEMPERATURE_UNIT_FAHRENHEIT":
            case 2:
                message.temperatureUnit = 2;
                break;
            }
            switch (object.pressureUnit) {
            case "PRESSURE_UNIT_UNKNOWN":
            case 0:
                message.pressureUnit = 0;
                break;
            case "PRESSURE_UNIT_KILOPASCALS":
            case 1:
                message.pressureUnit = 1;
                break;
            case "PRESSURE_UNIT_INCHES_OF_WATER":
            case 2:
                message.pressureUnit = 2;
                break;
            }
            if (object.features) {
                if (!Array.isArray(object.features))
                    throw TypeError(".pond.UserSettings.features: array expected");
                message.features = [];
                for (var i = 0; i < object.features.length; ++i)
                    message.features[i] = String(object.features[i]);
            }
            if (object.actions) {
                if (!Array.isArray(object.actions))
                    throw TypeError(".pond.UserSettings.actions: array expected");
                message.actions = [];
                for (var i = 0; i < object.actions.length; ++i)
                    message.actions[i] = String(object.actions[i]);
            }
            if (object.recluseClient != null)
                message.recluseClient = String(object.recluseClient);
            if (object.binYards) {
                if (!Array.isArray(object.binYards))
                    throw TypeError(".pond.UserSettings.binYards: array expected");
                message.binYards = [];
                for (var i = 0; i < object.binYards.length; ++i)
                    message.binYards[i] = String(object.binYards[i]);
            }
            if (object.stripeKey != null)
                message.stripeKey = String(object.stripeKey);
            if (object.defaultTeam != null)
                message.defaultTeam = String(object.defaultTeam);
            if (object.useTeam != null)
                message.useTeam = Boolean(object.useTeam);
            if (object.mapZoom != null)
                message.mapZoom = object.mapZoom >>> 0;
            switch (object.grainUnit) {
            case "GRAIN_UNIT_UNKNOWN":
            case 0:
                message.grainUnit = 0;
                break;
            case "GRAIN_UNIT_BUSHELS":
            case 1:
                message.grainUnit = 1;
                break;
            case "GRAIN_UNIT_WEIGHT":
            case 2:
                message.grainUnit = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a UserSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UserSettings
         * @static
         * @param {pond.UserSettings} message UserSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.notificationMethods = [];
                object.features = [];
                object.actions = [];
                object.binYards = [];
            }
            if (options.defaults) {
                object.id = "";
                object.email = "";
                object.name = "";
                object.avatar = "";
                object.notifyByDefault = false;
                object.phoneNumber = "";
                object.timezone = "";
                object.distanceUnit = options.enums === String ? "DISTANCE_UNIT_UNKNOWN" : 0;
                object.temperatureUnit = options.enums === String ? "TEMPERATURE_UNIT_UNKNOWN" : 0;
                object.pressureUnit = options.enums === String ? "PRESSURE_UNIT_UNKNOWN" : 0;
                object.recluseClient = "";
                object.stripeKey = "";
                object.defaultTeam = "";
                object.useTeam = false;
                object.mapZoom = 0;
                object.grainUnit = options.enums === String ? "GRAIN_UNIT_UNKNOWN" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.notifyByDefault != null && message.hasOwnProperty("notifyByDefault"))
                object.notifyByDefault = message.notifyByDefault;
            if (message.notificationMethods && message.notificationMethods.length) {
                object.notificationMethods = [];
                for (var j = 0; j < message.notificationMethods.length; ++j)
                    object.notificationMethods[j] = options.enums === String ? $root.pond.NotificationMethod[message.notificationMethods[j]] : message.notificationMethods[j];
            }
            if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                object.phoneNumber = message.phoneNumber;
            if (message.timezone != null && message.hasOwnProperty("timezone"))
                object.timezone = message.timezone;
            if (message.distanceUnit != null && message.hasOwnProperty("distanceUnit"))
                object.distanceUnit = options.enums === String ? $root.pond.DistanceUnit[message.distanceUnit] : message.distanceUnit;
            if (message.temperatureUnit != null && message.hasOwnProperty("temperatureUnit"))
                object.temperatureUnit = options.enums === String ? $root.pond.TemperatureUnit[message.temperatureUnit] : message.temperatureUnit;
            if (message.pressureUnit != null && message.hasOwnProperty("pressureUnit"))
                object.pressureUnit = options.enums === String ? $root.pond.PressureUnit[message.pressureUnit] : message.pressureUnit;
            if (message.features && message.features.length) {
                object.features = [];
                for (var j = 0; j < message.features.length; ++j)
                    object.features[j] = message.features[j];
            }
            if (message.actions && message.actions.length) {
                object.actions = [];
                for (var j = 0; j < message.actions.length; ++j)
                    object.actions[j] = message.actions[j];
            }
            if (message.recluseClient != null && message.hasOwnProperty("recluseClient"))
                object.recluseClient = message.recluseClient;
            if (message.binYards && message.binYards.length) {
                object.binYards = [];
                for (var j = 0; j < message.binYards.length; ++j)
                    object.binYards[j] = message.binYards[j];
            }
            if (message.stripeKey != null && message.hasOwnProperty("stripeKey"))
                object.stripeKey = message.stripeKey;
            if (message.defaultTeam != null && message.hasOwnProperty("defaultTeam"))
                object.defaultTeam = message.defaultTeam;
            if (message.useTeam != null && message.hasOwnProperty("useTeam"))
                object.useTeam = message.useTeam;
            if (message.mapZoom != null && message.hasOwnProperty("mapZoom"))
                object.mapZoom = message.mapZoom;
            if (message.grainUnit != null && message.hasOwnProperty("grainUnit"))
                object.grainUnit = options.enums === String ? $root.pond.GrainUnit[message.grainUnit] : message.grainUnit;
            return object;
        };

        /**
         * Converts this UserSettings to JSON.
         * @function toJSON
         * @memberof pond.UserSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserSettings;
    })();

    pond.UserStatus = (function() {

        /**
         * Properties of a UserStatus.
         * @memberof pond
         * @interface IUserStatus
         * @property {string|null} [lastReadInbox] UserStatus lastReadInbox
         * @property {string|null} [finishedIntro] UserStatus finishedIntro
         * @property {string|null} [lastNotifiedTimestamp] UserStatus lastNotifiedTimestamp
         * @property {string|null} [lastNotificationViewed] UserStatus lastNotificationViewed
         * @property {string|null} [finishedBinIntro] UserStatus finishedBinIntro
         */

        /**
         * Constructs a new UserStatus.
         * @memberof pond
         * @classdesc Represents a UserStatus.
         * @implements IUserStatus
         * @constructor
         * @param {pond.IUserStatus=} [properties] Properties to set
         */
        function UserStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserStatus lastReadInbox.
         * @member {string} lastReadInbox
         * @memberof pond.UserStatus
         * @instance
         */
        UserStatus.prototype.lastReadInbox = "";

        /**
         * UserStatus finishedIntro.
         * @member {string} finishedIntro
         * @memberof pond.UserStatus
         * @instance
         */
        UserStatus.prototype.finishedIntro = "";

        /**
         * UserStatus lastNotifiedTimestamp.
         * @member {string} lastNotifiedTimestamp
         * @memberof pond.UserStatus
         * @instance
         */
        UserStatus.prototype.lastNotifiedTimestamp = "";

        /**
         * UserStatus lastNotificationViewed.
         * @member {string} lastNotificationViewed
         * @memberof pond.UserStatus
         * @instance
         */
        UserStatus.prototype.lastNotificationViewed = "";

        /**
         * UserStatus finishedBinIntro.
         * @member {string} finishedBinIntro
         * @memberof pond.UserStatus
         * @instance
         */
        UserStatus.prototype.finishedBinIntro = "";

        /**
         * Creates a new UserStatus instance using the specified properties.
         * @function create
         * @memberof pond.UserStatus
         * @static
         * @param {pond.IUserStatus=} [properties] Properties to set
         * @returns {pond.UserStatus} UserStatus instance
         */
        UserStatus.create = function create(properties) {
            return new UserStatus(properties);
        };

        /**
         * Creates a UserStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UserStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UserStatus} UserStatus
         */
        UserStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UserStatus)
                return object;
            var message = new $root.pond.UserStatus();
            if (object.lastReadInbox != null)
                message.lastReadInbox = String(object.lastReadInbox);
            if (object.finishedIntro != null)
                message.finishedIntro = String(object.finishedIntro);
            if (object.lastNotifiedTimestamp != null)
                message.lastNotifiedTimestamp = String(object.lastNotifiedTimestamp);
            if (object.lastNotificationViewed != null)
                message.lastNotificationViewed = String(object.lastNotificationViewed);
            if (object.finishedBinIntro != null)
                message.finishedBinIntro = String(object.finishedBinIntro);
            return message;
        };

        /**
         * Creates a plain object from a UserStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UserStatus
         * @static
         * @param {pond.UserStatus} message UserStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lastReadInbox = "";
                object.finishedIntro = "";
                object.lastNotifiedTimestamp = "";
                object.lastNotificationViewed = "";
                object.finishedBinIntro = "";
            }
            if (message.lastReadInbox != null && message.hasOwnProperty("lastReadInbox"))
                object.lastReadInbox = message.lastReadInbox;
            if (message.finishedIntro != null && message.hasOwnProperty("finishedIntro"))
                object.finishedIntro = message.finishedIntro;
            if (message.lastNotifiedTimestamp != null && message.hasOwnProperty("lastNotifiedTimestamp"))
                object.lastNotifiedTimestamp = message.lastNotifiedTimestamp;
            if (message.lastNotificationViewed != null && message.hasOwnProperty("lastNotificationViewed"))
                object.lastNotificationViewed = message.lastNotificationViewed;
            if (message.finishedBinIntro != null && message.hasOwnProperty("finishedBinIntro"))
                object.finishedBinIntro = message.finishedBinIntro;
            return object;
        };

        /**
         * Converts this UserStatus to JSON.
         * @function toJSON
         * @memberof pond.UserStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserStatus;
    })();

    pond.UserProfile = (function() {

        /**
         * Properties of a UserProfile.
         * @memberof pond
         * @interface IUserProfile
         * @property {string|null} [id] UserProfile id
         * @property {string|null} [name] UserProfile name
         * @property {string|null} [avatar] UserProfile avatar
         */

        /**
         * Constructs a new UserProfile.
         * @memberof pond
         * @classdesc Represents a UserProfile.
         * @implements IUserProfile
         * @constructor
         * @param {pond.IUserProfile=} [properties] Properties to set
         */
        function UserProfile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserProfile id.
         * @member {string} id
         * @memberof pond.UserProfile
         * @instance
         */
        UserProfile.prototype.id = "";

        /**
         * UserProfile name.
         * @member {string} name
         * @memberof pond.UserProfile
         * @instance
         */
        UserProfile.prototype.name = "";

        /**
         * UserProfile avatar.
         * @member {string} avatar
         * @memberof pond.UserProfile
         * @instance
         */
        UserProfile.prototype.avatar = "";

        /**
         * Creates a new UserProfile instance using the specified properties.
         * @function create
         * @memberof pond.UserProfile
         * @static
         * @param {pond.IUserProfile=} [properties] Properties to set
         * @returns {pond.UserProfile} UserProfile instance
         */
        UserProfile.create = function create(properties) {
            return new UserProfile(properties);
        };

        /**
         * Creates a UserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UserProfile} UserProfile
         */
        UserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UserProfile)
                return object;
            var message = new $root.pond.UserProfile();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            return message;
        };

        /**
         * Creates a plain object from a UserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UserProfile
         * @static
         * @param {pond.UserProfile} message UserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserProfile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.avatar = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            return object;
        };

        /**
         * Converts this UserProfile to JSON.
         * @function toJSON
         * @memberof pond.UserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserProfile;
    })();

    /**
     * Permission enum.
     * @name pond.Permission
     * @enum {string}
     * @property {number} PERMISSION_INVALID=0 PERMISSION_INVALID value
     * @property {number} PERMISSION_USERS=1 PERMISSION_USERS value
     * @property {number} PERMISSION_READ=2 PERMISSION_READ value
     * @property {number} PERMISSION_WRITE=3 PERMISSION_WRITE value
     * @property {number} PERMISSION_SHARE=4 PERMISSION_SHARE value
     * @property {number} PERMISSION_BILLING=5 PERMISSION_BILLING value
     * @property {number} PERMISSION_FILE_MANAGEMENT=6 PERMISSION_FILE_MANAGEMENT value
     */
    pond.Permission = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PERMISSION_INVALID"] = 0;
        values[valuesById[1] = "PERMISSION_USERS"] = 1;
        values[valuesById[2] = "PERMISSION_READ"] = 2;
        values[valuesById[3] = "PERMISSION_WRITE"] = 3;
        values[valuesById[4] = "PERMISSION_SHARE"] = 4;
        values[valuesById[5] = "PERMISSION_BILLING"] = 5;
        values[valuesById[6] = "PERMISSION_FILE_MANAGEMENT"] = 6;
        return values;
    })();

    pond.EvaluatePermissionsRequest = (function() {

        /**
         * Properties of an EvaluatePermissionsRequest.
         * @memberof pond
         * @interface IEvaluatePermissionsRequest
         * @property {string|null} [key] EvaluatePermissionsRequest key
         * @property {string|null} [kind] EvaluatePermissionsRequest kind
         */

        /**
         * Constructs a new EvaluatePermissionsRequest.
         * @memberof pond
         * @classdesc Represents an EvaluatePermissionsRequest.
         * @implements IEvaluatePermissionsRequest
         * @constructor
         * @param {pond.IEvaluatePermissionsRequest=} [properties] Properties to set
         */
        function EvaluatePermissionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EvaluatePermissionsRequest key.
         * @member {string} key
         * @memberof pond.EvaluatePermissionsRequest
         * @instance
         */
        EvaluatePermissionsRequest.prototype.key = "";

        /**
         * EvaluatePermissionsRequest kind.
         * @member {string} kind
         * @memberof pond.EvaluatePermissionsRequest
         * @instance
         */
        EvaluatePermissionsRequest.prototype.kind = "";

        /**
         * Creates a new EvaluatePermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.EvaluatePermissionsRequest
         * @static
         * @param {pond.IEvaluatePermissionsRequest=} [properties] Properties to set
         * @returns {pond.EvaluatePermissionsRequest} EvaluatePermissionsRequest instance
         */
        EvaluatePermissionsRequest.create = function create(properties) {
            return new EvaluatePermissionsRequest(properties);
        };

        /**
         * Creates an EvaluatePermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.EvaluatePermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.EvaluatePermissionsRequest} EvaluatePermissionsRequest
         */
        EvaluatePermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.EvaluatePermissionsRequest)
                return object;
            var message = new $root.pond.EvaluatePermissionsRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.kind != null)
                message.kind = String(object.kind);
            return message;
        };

        /**
         * Creates a plain object from an EvaluatePermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.EvaluatePermissionsRequest
         * @static
         * @param {pond.EvaluatePermissionsRequest} message EvaluatePermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EvaluatePermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.kind = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            return object;
        };

        /**
         * Converts this EvaluatePermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.EvaluatePermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EvaluatePermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EvaluatePermissionsRequest;
    })();

    pond.EvaluatePermissionsResponse = (function() {

        /**
         * Properties of an EvaluatePermissionsResponse.
         * @memberof pond
         * @interface IEvaluatePermissionsResponse
         * @property {Array.<pond.Permission>|null} [permissions] EvaluatePermissionsResponse permissions
         */

        /**
         * Constructs a new EvaluatePermissionsResponse.
         * @memberof pond
         * @classdesc Represents an EvaluatePermissionsResponse.
         * @implements IEvaluatePermissionsResponse
         * @constructor
         * @param {pond.IEvaluatePermissionsResponse=} [properties] Properties to set
         */
        function EvaluatePermissionsResponse(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EvaluatePermissionsResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.EvaluatePermissionsResponse
         * @instance
         */
        EvaluatePermissionsResponse.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new EvaluatePermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.EvaluatePermissionsResponse
         * @static
         * @param {pond.IEvaluatePermissionsResponse=} [properties] Properties to set
         * @returns {pond.EvaluatePermissionsResponse} EvaluatePermissionsResponse instance
         */
        EvaluatePermissionsResponse.create = function create(properties) {
            return new EvaluatePermissionsResponse(properties);
        };

        /**
         * Creates an EvaluatePermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.EvaluatePermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.EvaluatePermissionsResponse} EvaluatePermissionsResponse
         */
        EvaluatePermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.EvaluatePermissionsResponse)
                return object;
            var message = new $root.pond.EvaluatePermissionsResponse();
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.EvaluatePermissionsResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an EvaluatePermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.EvaluatePermissionsResponse
         * @static
         * @param {pond.EvaluatePermissionsResponse} message EvaluatePermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EvaluatePermissionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this EvaluatePermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.EvaluatePermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EvaluatePermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EvaluatePermissionsResponse;
    })();

    pond.UserPreferences = (function() {

        /**
         * Properties of a UserPreferences.
         * @memberof pond
         * @interface IUserPreferences
         * @property {boolean|null} [notify] UserPreferences notify
         * @property {boolean|null} [starred] UserPreferences starred
         * @property {Array.<string>|null} [childDisplayOrder] UserPreferences childDisplayOrder
         * @property {string|null} [chatViewedTimestamp] UserPreferences chatViewedTimestamp
         */

        /**
         * Constructs a new UserPreferences.
         * @memberof pond
         * @classdesc Represents a UserPreferences.
         * @implements IUserPreferences
         * @constructor
         * @param {pond.IUserPreferences=} [properties] Properties to set
         */
        function UserPreferences(properties) {
            this.childDisplayOrder = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserPreferences notify.
         * @member {boolean} notify
         * @memberof pond.UserPreferences
         * @instance
         */
        UserPreferences.prototype.notify = false;

        /**
         * UserPreferences starred.
         * @member {boolean} starred
         * @memberof pond.UserPreferences
         * @instance
         */
        UserPreferences.prototype.starred = false;

        /**
         * UserPreferences childDisplayOrder.
         * @member {Array.<string>} childDisplayOrder
         * @memberof pond.UserPreferences
         * @instance
         */
        UserPreferences.prototype.childDisplayOrder = $util.emptyArray;

        /**
         * UserPreferences chatViewedTimestamp.
         * @member {string} chatViewedTimestamp
         * @memberof pond.UserPreferences
         * @instance
         */
        UserPreferences.prototype.chatViewedTimestamp = "";

        /**
         * Creates a new UserPreferences instance using the specified properties.
         * @function create
         * @memberof pond.UserPreferences
         * @static
         * @param {pond.IUserPreferences=} [properties] Properties to set
         * @returns {pond.UserPreferences} UserPreferences instance
         */
        UserPreferences.create = function create(properties) {
            return new UserPreferences(properties);
        };

        /**
         * Creates a UserPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UserPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UserPreferences} UserPreferences
         */
        UserPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UserPreferences)
                return object;
            var message = new $root.pond.UserPreferences();
            if (object.notify != null)
                message.notify = Boolean(object.notify);
            if (object.starred != null)
                message.starred = Boolean(object.starred);
            if (object.childDisplayOrder) {
                if (!Array.isArray(object.childDisplayOrder))
                    throw TypeError(".pond.UserPreferences.childDisplayOrder: array expected");
                message.childDisplayOrder = [];
                for (var i = 0; i < object.childDisplayOrder.length; ++i)
                    message.childDisplayOrder[i] = String(object.childDisplayOrder[i]);
            }
            if (object.chatViewedTimestamp != null)
                message.chatViewedTimestamp = String(object.chatViewedTimestamp);
            return message;
        };

        /**
         * Creates a plain object from a UserPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UserPreferences
         * @static
         * @param {pond.UserPreferences} message UserPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.childDisplayOrder = [];
            if (options.defaults) {
                object.notify = false;
                object.starred = false;
                object.chatViewedTimestamp = "";
            }
            if (message.notify != null && message.hasOwnProperty("notify"))
                object.notify = message.notify;
            if (message.starred != null && message.hasOwnProperty("starred"))
                object.starred = message.starred;
            if (message.childDisplayOrder && message.childDisplayOrder.length) {
                object.childDisplayOrder = [];
                for (var j = 0; j < message.childDisplayOrder.length; ++j)
                    object.childDisplayOrder[j] = message.childDisplayOrder[j];
            }
            if (message.chatViewedTimestamp != null && message.hasOwnProperty("chatViewedTimestamp"))
                object.chatViewedTimestamp = message.chatViewedTimestamp;
            return object;
        };

        /**
         * Converts this UserPreferences to JSON.
         * @function toJSON
         * @memberof pond.UserPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserPreferences;
    })();

    pond.BinComponentPreferences = (function() {

        /**
         * Properties of a BinComponentPreferences.
         * @memberof pond
         * @interface IBinComponentPreferences
         * @property {pond.BinComponent|null} [type] BinComponentPreferences type
         * @property {number|null} [node] BinComponentPreferences node
         */

        /**
         * Constructs a new BinComponentPreferences.
         * @memberof pond
         * @classdesc Represents a BinComponentPreferences.
         * @implements IBinComponentPreferences
         * @constructor
         * @param {pond.IBinComponentPreferences=} [properties] Properties to set
         */
        function BinComponentPreferences(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BinComponentPreferences type.
         * @member {pond.BinComponent} type
         * @memberof pond.BinComponentPreferences
         * @instance
         */
        BinComponentPreferences.prototype.type = 0;

        /**
         * BinComponentPreferences node.
         * @member {number} node
         * @memberof pond.BinComponentPreferences
         * @instance
         */
        BinComponentPreferences.prototype.node = 0;

        /**
         * Creates a new BinComponentPreferences instance using the specified properties.
         * @function create
         * @memberof pond.BinComponentPreferences
         * @static
         * @param {pond.IBinComponentPreferences=} [properties] Properties to set
         * @returns {pond.BinComponentPreferences} BinComponentPreferences instance
         */
        BinComponentPreferences.create = function create(properties) {
            return new BinComponentPreferences(properties);
        };

        /**
         * Creates a BinComponentPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BinComponentPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BinComponentPreferences} BinComponentPreferences
         */
        BinComponentPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BinComponentPreferences)
                return object;
            var message = new $root.pond.BinComponentPreferences();
            switch (object.type) {
            case "BIN_COMPONENT_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "BIN_COMPONENT_GRAIN_CABLE":
            case 1:
                message.type = 1;
                break;
            case "BIN_COMPONENT_PLENUM":
            case 2:
                message.type = 2;
                break;
            case "BIN_COMPONENT_SECOND_PLENUM":
            case 3:
                message.type = 3;
                break;
            case "BIN_COMPONENT_HEATER":
            case 4:
                message.type = 4;
                break;
            case "BIN_COMPONENT_FAN":
            case 5:
                message.type = 5;
                break;
            case "BIN_COMPONENT_PRESSURE":
            case 6:
                message.type = 6;
                break;
            case "BIN_COMPONENT_HEADSPACE":
            case 7:
                message.type = 7;
                break;
            case "BIN_COMPONENT_AMBIENT":
            case 8:
                message.type = 8;
                break;
            }
            if (object.node != null)
                message.node = object.node >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BinComponentPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BinComponentPreferences
         * @static
         * @param {pond.BinComponentPreferences} message BinComponentPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BinComponentPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "BIN_COMPONENT_UNKNOWN" : 0;
                object.node = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.BinComponent[message.type] : message.type;
            if (message.node != null && message.hasOwnProperty("node"))
                object.node = message.node;
            return object;
        };

        /**
         * Converts this BinComponentPreferences to JSON.
         * @function toJSON
         * @memberof pond.BinComponentPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BinComponentPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BinComponentPreferences;
    })();

    pond.DevicePreferences = (function() {

        /**
         * Properties of a DevicePreferences.
         * @memberof pond
         * @interface IDevicePreferences
         * @property {Array.<string>|null} [childDisplayOrder] DevicePreferences childDisplayOrder
         * @property {boolean|null} [notify] DevicePreferences notify
         */

        /**
         * Constructs a new DevicePreferences.
         * @memberof pond
         * @classdesc Represents a DevicePreferences.
         * @implements IDevicePreferences
         * @constructor
         * @param {pond.IDevicePreferences=} [properties] Properties to set
         */
        function DevicePreferences(properties) {
            this.childDisplayOrder = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DevicePreferences childDisplayOrder.
         * @member {Array.<string>} childDisplayOrder
         * @memberof pond.DevicePreferences
         * @instance
         */
        DevicePreferences.prototype.childDisplayOrder = $util.emptyArray;

        /**
         * DevicePreferences notify.
         * @member {boolean} notify
         * @memberof pond.DevicePreferences
         * @instance
         */
        DevicePreferences.prototype.notify = false;

        /**
         * Creates a new DevicePreferences instance using the specified properties.
         * @function create
         * @memberof pond.DevicePreferences
         * @static
         * @param {pond.IDevicePreferences=} [properties] Properties to set
         * @returns {pond.DevicePreferences} DevicePreferences instance
         */
        DevicePreferences.create = function create(properties) {
            return new DevicePreferences(properties);
        };

        /**
         * Creates a DevicePreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DevicePreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DevicePreferences} DevicePreferences
         */
        DevicePreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DevicePreferences)
                return object;
            var message = new $root.pond.DevicePreferences();
            if (object.childDisplayOrder) {
                if (!Array.isArray(object.childDisplayOrder))
                    throw TypeError(".pond.DevicePreferences.childDisplayOrder: array expected");
                message.childDisplayOrder = [];
                for (var i = 0; i < object.childDisplayOrder.length; ++i)
                    message.childDisplayOrder[i] = String(object.childDisplayOrder[i]);
            }
            if (object.notify != null)
                message.notify = Boolean(object.notify);
            return message;
        };

        /**
         * Creates a plain object from a DevicePreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DevicePreferences
         * @static
         * @param {pond.DevicePreferences} message DevicePreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DevicePreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.childDisplayOrder = [];
            if (options.defaults)
                object.notify = false;
            if (message.childDisplayOrder && message.childDisplayOrder.length) {
                object.childDisplayOrder = [];
                for (var j = 0; j < message.childDisplayOrder.length; ++j)
                    object.childDisplayOrder[j] = message.childDisplayOrder[j];
            }
            if (message.notify != null && message.hasOwnProperty("notify"))
                object.notify = message.notify;
            return object;
        };

        /**
         * Converts this DevicePreferences to JSON.
         * @function toJSON
         * @memberof pond.DevicePreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DevicePreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DevicePreferences;
    })();

    pond.GetDevicePreferencesRequest = (function() {

        /**
         * Properties of a GetDevicePreferencesRequest.
         * @memberof pond
         * @interface IGetDevicePreferencesRequest
         * @property {string|null} [parent] GetDevicePreferencesRequest parent
         * @property {string|null} [parentType] GetDevicePreferencesRequest parentType
         * @property {number|null} [device] GetDevicePreferencesRequest device
         */

        /**
         * Constructs a new GetDevicePreferencesRequest.
         * @memberof pond
         * @classdesc Represents a GetDevicePreferencesRequest.
         * @implements IGetDevicePreferencesRequest
         * @constructor
         * @param {pond.IGetDevicePreferencesRequest=} [properties] Properties to set
         */
        function GetDevicePreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePreferencesRequest parent.
         * @member {string} parent
         * @memberof pond.GetDevicePreferencesRequest
         * @instance
         */
        GetDevicePreferencesRequest.prototype.parent = "";

        /**
         * GetDevicePreferencesRequest parentType.
         * @member {string} parentType
         * @memberof pond.GetDevicePreferencesRequest
         * @instance
         */
        GetDevicePreferencesRequest.prototype.parentType = "";

        /**
         * GetDevicePreferencesRequest device.
         * @member {number} device
         * @memberof pond.GetDevicePreferencesRequest
         * @instance
         */
        GetDevicePreferencesRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetDevicePreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePreferencesRequest
         * @static
         * @param {pond.IGetDevicePreferencesRequest=} [properties] Properties to set
         * @returns {pond.GetDevicePreferencesRequest} GetDevicePreferencesRequest instance
         */
        GetDevicePreferencesRequest.create = function create(properties) {
            return new GetDevicePreferencesRequest(properties);
        };

        /**
         * Creates a GetDevicePreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePreferencesRequest} GetDevicePreferencesRequest
         */
        GetDevicePreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePreferencesRequest)
                return object;
            var message = new $root.pond.GetDevicePreferencesRequest();
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePreferencesRequest
         * @static
         * @param {pond.GetDevicePreferencesRequest} message GetDevicePreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.parent = "";
                object.parentType = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            }
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetDevicePreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePreferencesRequest;
    })();

    pond.GetDevicePreferencesResponse = (function() {

        /**
         * Properties of a GetDevicePreferencesResponse.
         * @memberof pond
         * @interface IGetDevicePreferencesResponse
         * @property {pond.DevicePreferences|null} [preferences] GetDevicePreferencesResponse preferences
         */

        /**
         * Constructs a new GetDevicePreferencesResponse.
         * @memberof pond
         * @classdesc Represents a GetDevicePreferencesResponse.
         * @implements IGetDevicePreferencesResponse
         * @constructor
         * @param {pond.IGetDevicePreferencesResponse=} [properties] Properties to set
         */
        function GetDevicePreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePreferencesResponse preferences.
         * @member {pond.DevicePreferences|null|undefined} preferences
         * @memberof pond.GetDevicePreferencesResponse
         * @instance
         */
        GetDevicePreferencesResponse.prototype.preferences = null;

        /**
         * Creates a new GetDevicePreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePreferencesResponse
         * @static
         * @param {pond.IGetDevicePreferencesResponse=} [properties] Properties to set
         * @returns {pond.GetDevicePreferencesResponse} GetDevicePreferencesResponse instance
         */
        GetDevicePreferencesResponse.create = function create(properties) {
            return new GetDevicePreferencesResponse(properties);
        };

        /**
         * Creates a GetDevicePreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePreferencesResponse} GetDevicePreferencesResponse
         */
        GetDevicePreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePreferencesResponse)
                return object;
            var message = new $root.pond.GetDevicePreferencesResponse();
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.GetDevicePreferencesResponse.preferences: object expected");
                message.preferences = $root.pond.DevicePreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePreferencesResponse
         * @static
         * @param {pond.GetDevicePreferencesResponse} message GetDevicePreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePreferencesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.preferences = null;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.DevicePreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this GetDevicePreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePreferencesResponse;
    })();

    pond.GetUserRequest = (function() {

        /**
         * Properties of a GetUserRequest.
         * @memberof pond
         * @interface IGetUserRequest
         * @property {string|null} [id] GetUserRequest id
         * @property {string|null} [kind] GetUserRequest kind
         * @property {string|null} [key] GetUserRequest key
         */

        /**
         * Constructs a new GetUserRequest.
         * @memberof pond
         * @classdesc Represents a GetUserRequest.
         * @implements IGetUserRequest
         * @constructor
         * @param {pond.IGetUserRequest=} [properties] Properties to set
         */
        function GetUserRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserRequest id.
         * @member {string} id
         * @memberof pond.GetUserRequest
         * @instance
         */
        GetUserRequest.prototype.id = "";

        /**
         * GetUserRequest kind.
         * @member {string} kind
         * @memberof pond.GetUserRequest
         * @instance
         */
        GetUserRequest.prototype.kind = "";

        /**
         * GetUserRequest key.
         * @member {string} key
         * @memberof pond.GetUserRequest
         * @instance
         */
        GetUserRequest.prototype.key = "";

        /**
         * Creates a new GetUserRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetUserRequest
         * @static
         * @param {pond.IGetUserRequest=} [properties] Properties to set
         * @returns {pond.GetUserRequest} GetUserRequest instance
         */
        GetUserRequest.create = function create(properties) {
            return new GetUserRequest(properties);
        };

        /**
         * Creates a GetUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUserRequest} GetUserRequest
         */
        GetUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUserRequest)
                return object;
            var message = new $root.pond.GetUserRequest();
            if (object.id != null)
                message.id = String(object.id);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUserRequest
         * @static
         * @param {pond.GetUserRequest} message GetUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.kind = "";
                object.key = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetUserRequest to JSON.
         * @function toJSON
         * @memberof pond.GetUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserRequest;
    })();

    pond.GetUserWithTeamResponse = (function() {

        /**
         * Properties of a GetUserWithTeamResponse.
         * @memberof pond
         * @interface IGetUserWithTeamResponse
         * @property {pond.User|null} [user] GetUserWithTeamResponse user
         * @property {pond.Team|null} [team] GetUserWithTeamResponse team
         * @property {Array.<pond.Team>|null} [teams] GetUserWithTeamResponse teams
         */

        /**
         * Constructs a new GetUserWithTeamResponse.
         * @memberof pond
         * @classdesc Represents a GetUserWithTeamResponse.
         * @implements IGetUserWithTeamResponse
         * @constructor
         * @param {pond.IGetUserWithTeamResponse=} [properties] Properties to set
         */
        function GetUserWithTeamResponse(properties) {
            this.teams = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserWithTeamResponse user.
         * @member {pond.User|null|undefined} user
         * @memberof pond.GetUserWithTeamResponse
         * @instance
         */
        GetUserWithTeamResponse.prototype.user = null;

        /**
         * GetUserWithTeamResponse team.
         * @member {pond.Team|null|undefined} team
         * @memberof pond.GetUserWithTeamResponse
         * @instance
         */
        GetUserWithTeamResponse.prototype.team = null;

        /**
         * GetUserWithTeamResponse teams.
         * @member {Array.<pond.Team>} teams
         * @memberof pond.GetUserWithTeamResponse
         * @instance
         */
        GetUserWithTeamResponse.prototype.teams = $util.emptyArray;

        /**
         * Creates a new GetUserWithTeamResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetUserWithTeamResponse
         * @static
         * @param {pond.IGetUserWithTeamResponse=} [properties] Properties to set
         * @returns {pond.GetUserWithTeamResponse} GetUserWithTeamResponse instance
         */
        GetUserWithTeamResponse.create = function create(properties) {
            return new GetUserWithTeamResponse(properties);
        };

        /**
         * Creates a GetUserWithTeamResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUserWithTeamResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUserWithTeamResponse} GetUserWithTeamResponse
         */
        GetUserWithTeamResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUserWithTeamResponse)
                return object;
            var message = new $root.pond.GetUserWithTeamResponse();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".pond.GetUserWithTeamResponse.user: object expected");
                message.user = $root.pond.User.fromObject(object.user);
            }
            if (object.team != null) {
                if (typeof object.team !== "object")
                    throw TypeError(".pond.GetUserWithTeamResponse.team: object expected");
                message.team = $root.pond.Team.fromObject(object.team);
            }
            if (object.teams) {
                if (!Array.isArray(object.teams))
                    throw TypeError(".pond.GetUserWithTeamResponse.teams: array expected");
                message.teams = [];
                for (var i = 0; i < object.teams.length; ++i) {
                    if (typeof object.teams[i] !== "object")
                        throw TypeError(".pond.GetUserWithTeamResponse.teams: object expected");
                    message.teams[i] = $root.pond.Team.fromObject(object.teams[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserWithTeamResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUserWithTeamResponse
         * @static
         * @param {pond.GetUserWithTeamResponse} message GetUserWithTeamResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserWithTeamResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.teams = [];
            if (options.defaults) {
                object.user = null;
                object.team = null;
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.pond.User.toObject(message.user, options);
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = $root.pond.Team.toObject(message.team, options);
            if (message.teams && message.teams.length) {
                object.teams = [];
                for (var j = 0; j < message.teams.length; ++j)
                    object.teams[j] = $root.pond.Team.toObject(message.teams[j], options);
            }
            return object;
        };

        /**
         * Converts this GetUserWithTeamResponse to JSON.
         * @function toJSON
         * @memberof pond.GetUserWithTeamResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserWithTeamResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserWithTeamResponse;
    })();

    pond.GetUsersRequest = (function() {

        /**
         * Properties of a GetUsersRequest.
         * @memberof pond
         * @interface IGetUsersRequest
         * @property {Array.<string>|null} [users] GetUsersRequest users
         */

        /**
         * Constructs a new GetUsersRequest.
         * @memberof pond
         * @classdesc Represents a GetUsersRequest.
         * @implements IGetUsersRequest
         * @constructor
         * @param {pond.IGetUsersRequest=} [properties] Properties to set
         */
        function GetUsersRequest(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUsersRequest users.
         * @member {Array.<string>} users
         * @memberof pond.GetUsersRequest
         * @instance
         */
        GetUsersRequest.prototype.users = $util.emptyArray;

        /**
         * Creates a new GetUsersRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetUsersRequest
         * @static
         * @param {pond.IGetUsersRequest=} [properties] Properties to set
         * @returns {pond.GetUsersRequest} GetUsersRequest instance
         */
        GetUsersRequest.create = function create(properties) {
            return new GetUsersRequest(properties);
        };

        /**
         * Creates a GetUsersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUsersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUsersRequest} GetUsersRequest
         */
        GetUsersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUsersRequest)
                return object;
            var message = new $root.pond.GetUsersRequest();
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.GetUsersRequest.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i)
                    message.users[i] = String(object.users[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUsersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUsersRequest
         * @static
         * @param {pond.GetUsersRequest} message GetUsersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUsersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = message.users[j];
            }
            return object;
        };

        /**
         * Converts this GetUsersRequest to JSON.
         * @function toJSON
         * @memberof pond.GetUsersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUsersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUsersRequest;
    })();

    pond.GetUsersResponse = (function() {

        /**
         * Properties of a GetUsersResponse.
         * @memberof pond
         * @interface IGetUsersResponse
         * @property {Array.<pond.User>|null} [users] GetUsersResponse users
         */

        /**
         * Constructs a new GetUsersResponse.
         * @memberof pond
         * @classdesc Represents a GetUsersResponse.
         * @implements IGetUsersResponse
         * @constructor
         * @param {pond.IGetUsersResponse=} [properties] Properties to set
         */
        function GetUsersResponse(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUsersResponse users.
         * @member {Array.<pond.User>} users
         * @memberof pond.GetUsersResponse
         * @instance
         */
        GetUsersResponse.prototype.users = $util.emptyArray;

        /**
         * Creates a new GetUsersResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetUsersResponse
         * @static
         * @param {pond.IGetUsersResponse=} [properties] Properties to set
         * @returns {pond.GetUsersResponse} GetUsersResponse instance
         */
        GetUsersResponse.create = function create(properties) {
            return new GetUsersResponse(properties);
        };

        /**
         * Creates a GetUsersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUsersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUsersResponse} GetUsersResponse
         */
        GetUsersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUsersResponse)
                return object;
            var message = new $root.pond.GetUsersResponse();
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.GetUsersResponse.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".pond.GetUsersResponse.users: object expected");
                    message.users[i] = $root.pond.User.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUsersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUsersResponse
         * @static
         * @param {pond.GetUsersResponse} message GetUsersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUsersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.pond.User.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this GetUsersResponse to JSON.
         * @function toJSON
         * @memberof pond.GetUsersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUsersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUsersResponse;
    })();

    pond.User = (function() {

        /**
         * Properties of a User.
         * @memberof pond
         * @interface IUser
         * @property {pond.UserSettings|null} [settings] User settings
         * @property {pond.UserStatus|null} [status] User status
         * @property {Array.<pond.Permission>|null} [permissions] User permissions
         * @property {pond.UserPreferences|null} [preferences] User preferences
         */

        /**
         * Constructs a new User.
         * @memberof pond
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {pond.IUser=} [properties] Properties to set
         */
        function User(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User settings.
         * @member {pond.UserSettings|null|undefined} settings
         * @memberof pond.User
         * @instance
         */
        User.prototype.settings = null;

        /**
         * User status.
         * @member {pond.UserStatus|null|undefined} status
         * @memberof pond.User
         * @instance
         */
        User.prototype.status = null;

        /**
         * User permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.User
         * @instance
         */
        User.prototype.permissions = $util.emptyArray;

        /**
         * User preferences.
         * @member {pond.UserPreferences|null|undefined} preferences
         * @memberof pond.User
         * @instance
         */
        User.prototype.preferences = null;

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof pond.User
         * @static
         * @param {pond.IUser=} [properties] Properties to set
         * @returns {pond.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.User)
                return object;
            var message = new $root.pond.User();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.User.settings: object expected");
                message.settings = $root.pond.UserSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.User.status: object expected");
                message.status = $root.pond.UserStatus.fromObject(object.status);
            }
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.User.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.User.preferences: object expected");
                message.preferences = $root.pond.UserPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.User
         * @static
         * @param {pond.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.settings = null;
                object.status = null;
                object.preferences = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UserSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.UserStatus.toObject(message.status, options);
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.UserPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof pond.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    pond.ListUsersRequest = (function() {

        /**
         * Properties of a ListUsersRequest.
         * @memberof pond
         * @interface IListUsersRequest
         * @property {string|null} [kind] ListUsersRequest kind
         * @property {string|null} [key] ListUsersRequest key
         * @property {pond.Paging|null} [paging] ListUsersRequest paging
         * @property {pond.Sorting|null} [sorting] ListUsersRequest sorting
         * @property {string|null} [search] ListUsersRequest search
         * @property {pond.UserSettings|null} [settingsMatch] ListUsersRequest settingsMatch
         * @property {pond.UserStatus|null} [statusMatch] ListUsersRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListUsersRequest fieldContains
         * @property {string|null} [prefixSearch] ListUsersRequest prefixSearch
         */

        /**
         * Constructs a new ListUsersRequest.
         * @memberof pond
         * @classdesc Represents a ListUsersRequest.
         * @implements IListUsersRequest
         * @constructor
         * @param {pond.IListUsersRequest=} [properties] Properties to set
         */
        function ListUsersRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUsersRequest kind.
         * @member {string} kind
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.kind = "";

        /**
         * ListUsersRequest key.
         * @member {string} key
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.key = "";

        /**
         * ListUsersRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.paging = null;

        /**
         * ListUsersRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.sorting = null;

        /**
         * ListUsersRequest search.
         * @member {string} search
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.search = "";

        /**
         * ListUsersRequest settingsMatch.
         * @member {pond.UserSettings|null|undefined} settingsMatch
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.settingsMatch = null;

        /**
         * ListUsersRequest statusMatch.
         * @member {pond.UserStatus|null|undefined} statusMatch
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.statusMatch = null;

        /**
         * ListUsersRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * ListUsersRequest prefixSearch.
         * @member {string} prefixSearch
         * @memberof pond.ListUsersRequest
         * @instance
         */
        ListUsersRequest.prototype.prefixSearch = "";

        /**
         * Creates a new ListUsersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListUsersRequest
         * @static
         * @param {pond.IListUsersRequest=} [properties] Properties to set
         * @returns {pond.ListUsersRequest} ListUsersRequest instance
         */
        ListUsersRequest.create = function create(properties) {
            return new ListUsersRequest(properties);
        };

        /**
         * Creates a ListUsersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUsersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUsersRequest} ListUsersRequest
         */
        ListUsersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUsersRequest)
                return object;
            var message = new $root.pond.ListUsersRequest();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListUsersRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListUsersRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListUsersRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.UserSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListUsersRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.UserStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListUsersRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            if (object.prefixSearch != null)
                message.prefixSearch = String(object.prefixSearch);
            return message;
        };

        /**
         * Creates a plain object from a ListUsersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUsersRequest
         * @static
         * @param {pond.ListUsersRequest} message ListUsersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUsersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.kind = "";
                object.key = "";
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
                object.prefixSearch = "";
            }
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.UserSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.UserStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            if (message.prefixSearch != null && message.hasOwnProperty("prefixSearch"))
                object.prefixSearch = message.prefixSearch;
            return object;
        };

        /**
         * Converts this ListUsersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListUsersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUsersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUsersRequest;
    })();

    pond.ListUsersResponse = (function() {

        /**
         * Properties of a ListUsersResponse.
         * @memberof pond
         * @interface IListUsersResponse
         * @property {Array.<pond.User>|null} [users] ListUsersResponse users
         * @property {number|null} [nextOffset] ListUsersResponse nextOffset
         * @property {number|null} [total] ListUsersResponse total
         */

        /**
         * Constructs a new ListUsersResponse.
         * @memberof pond
         * @classdesc Represents a ListUsersResponse.
         * @implements IListUsersResponse
         * @constructor
         * @param {pond.IListUsersResponse=} [properties] Properties to set
         */
        function ListUsersResponse(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUsersResponse users.
         * @member {Array.<pond.User>} users
         * @memberof pond.ListUsersResponse
         * @instance
         */
        ListUsersResponse.prototype.users = $util.emptyArray;

        /**
         * ListUsersResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListUsersResponse
         * @instance
         */
        ListUsersResponse.prototype.nextOffset = 0;

        /**
         * ListUsersResponse total.
         * @member {number} total
         * @memberof pond.ListUsersResponse
         * @instance
         */
        ListUsersResponse.prototype.total = 0;

        /**
         * Creates a new ListUsersResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListUsersResponse
         * @static
         * @param {pond.IListUsersResponse=} [properties] Properties to set
         * @returns {pond.ListUsersResponse} ListUsersResponse instance
         */
        ListUsersResponse.create = function create(properties) {
            return new ListUsersResponse(properties);
        };

        /**
         * Creates a ListUsersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUsersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUsersResponse} ListUsersResponse
         */
        ListUsersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUsersResponse)
                return object;
            var message = new $root.pond.ListUsersResponse();
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.ListUsersResponse.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".pond.ListUsersResponse.users: object expected");
                    message.users[i] = $root.pond.User.fromObject(object.users[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListUsersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUsersResponse
         * @static
         * @param {pond.ListUsersResponse} message ListUsersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUsersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.pond.User.toObject(message.users[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListUsersResponse to JSON.
         * @function toJSON
         * @memberof pond.ListUsersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUsersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUsersResponse;
    })();

    pond.ListUserProfilesResponse = (function() {

        /**
         * Properties of a ListUserProfilesResponse.
         * @memberof pond
         * @interface IListUserProfilesResponse
         * @property {Array.<pond.UserProfile>|null} [users] ListUserProfilesResponse users
         */

        /**
         * Constructs a new ListUserProfilesResponse.
         * @memberof pond
         * @classdesc Represents a ListUserProfilesResponse.
         * @implements IListUserProfilesResponse
         * @constructor
         * @param {pond.IListUserProfilesResponse=} [properties] Properties to set
         */
        function ListUserProfilesResponse(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUserProfilesResponse users.
         * @member {Array.<pond.UserProfile>} users
         * @memberof pond.ListUserProfilesResponse
         * @instance
         */
        ListUserProfilesResponse.prototype.users = $util.emptyArray;

        /**
         * Creates a new ListUserProfilesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListUserProfilesResponse
         * @static
         * @param {pond.IListUserProfilesResponse=} [properties] Properties to set
         * @returns {pond.ListUserProfilesResponse} ListUserProfilesResponse instance
         */
        ListUserProfilesResponse.create = function create(properties) {
            return new ListUserProfilesResponse(properties);
        };

        /**
         * Creates a ListUserProfilesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListUserProfilesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListUserProfilesResponse} ListUserProfilesResponse
         */
        ListUserProfilesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListUserProfilesResponse)
                return object;
            var message = new $root.pond.ListUserProfilesResponse();
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".pond.ListUserProfilesResponse.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".pond.ListUserProfilesResponse.users: object expected");
                    message.users[i] = $root.pond.UserProfile.fromObject(object.users[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListUserProfilesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListUserProfilesResponse
         * @static
         * @param {pond.ListUserProfilesResponse} message ListUserProfilesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUserProfilesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.pond.UserProfile.toObject(message.users[j], options);
            }
            return object;
        };

        /**
         * Converts this ListUserProfilesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListUserProfilesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUserProfilesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListUserProfilesResponse;
    })();

    pond.AddUserRequest = (function() {

        /**
         * Properties of an AddUserRequest.
         * @memberof pond
         * @interface IAddUserRequest
         * @property {pond.UserSettings|null} [settings] AddUserRequest settings
         */

        /**
         * Constructs a new AddUserRequest.
         * @memberof pond
         * @classdesc Represents an AddUserRequest.
         * @implements IAddUserRequest
         * @constructor
         * @param {pond.IAddUserRequest=} [properties] Properties to set
         */
        function AddUserRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUserRequest settings.
         * @member {pond.UserSettings|null|undefined} settings
         * @memberof pond.AddUserRequest
         * @instance
         */
        AddUserRequest.prototype.settings = null;

        /**
         * Creates a new AddUserRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddUserRequest
         * @static
         * @param {pond.IAddUserRequest=} [properties] Properties to set
         * @returns {pond.AddUserRequest} AddUserRequest instance
         */
        AddUserRequest.create = function create(properties) {
            return new AddUserRequest(properties);
        };

        /**
         * Creates an AddUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddUserRequest} AddUserRequest
         */
        AddUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddUserRequest)
                return object;
            var message = new $root.pond.AddUserRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddUserRequest.settings: object expected");
                message.settings = $root.pond.UserSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddUserRequest
         * @static
         * @param {pond.AddUserRequest} message AddUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UserSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddUserRequest to JSON.
         * @function toJSON
         * @memberof pond.AddUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUserRequest;
    })();

    pond.AddUserResponse = (function() {

        /**
         * Properties of an AddUserResponse.
         * @memberof pond
         * @interface IAddUserResponse
         */

        /**
         * Constructs a new AddUserResponse.
         * @memberof pond
         * @classdesc Represents an AddUserResponse.
         * @implements IAddUserResponse
         * @constructor
         * @param {pond.IAddUserResponse=} [properties] Properties to set
         */
        function AddUserResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddUserResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddUserResponse
         * @static
         * @param {pond.IAddUserResponse=} [properties] Properties to set
         * @returns {pond.AddUserResponse} AddUserResponse instance
         */
        AddUserResponse.create = function create(properties) {
            return new AddUserResponse(properties);
        };

        /**
         * Creates an AddUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddUserResponse} AddUserResponse
         */
        AddUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddUserResponse)
                return object;
            return new $root.pond.AddUserResponse();
        };

        /**
         * Creates a plain object from an AddUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddUserResponse
         * @static
         * @param {pond.AddUserResponse} message AddUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUserResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddUserResponse to JSON.
         * @function toJSON
         * @memberof pond.AddUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUserResponse;
    })();

    pond.UpdateUserRequest = (function() {

        /**
         * Properties of an UpdateUserRequest.
         * @memberof pond
         * @interface IUpdateUserRequest
         * @property {pond.UserSettings|null} [settings] UpdateUserRequest settings
         * @property {pond.UserStatus|null} [status] UpdateUserRequest status
         */

        /**
         * Constructs a new UpdateUserRequest.
         * @memberof pond
         * @classdesc Represents an UpdateUserRequest.
         * @implements IUpdateUserRequest
         * @constructor
         * @param {pond.IUpdateUserRequest=} [properties] Properties to set
         */
        function UpdateUserRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUserRequest settings.
         * @member {pond.UserSettings|null|undefined} settings
         * @memberof pond.UpdateUserRequest
         * @instance
         */
        UpdateUserRequest.prototype.settings = null;

        /**
         * UpdateUserRequest status.
         * @member {pond.UserStatus|null|undefined} status
         * @memberof pond.UpdateUserRequest
         * @instance
         */
        UpdateUserRequest.prototype.status = null;

        /**
         * Creates a new UpdateUserRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateUserRequest
         * @static
         * @param {pond.IUpdateUserRequest=} [properties] Properties to set
         * @returns {pond.UpdateUserRequest} UpdateUserRequest instance
         */
        UpdateUserRequest.create = function create(properties) {
            return new UpdateUserRequest(properties);
        };

        /**
         * Creates an UpdateUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateUserRequest} UpdateUserRequest
         */
        UpdateUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateUserRequest)
                return object;
            var message = new $root.pond.UpdateUserRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateUserRequest.settings: object expected");
                message.settings = $root.pond.UserSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.UpdateUserRequest.status: object expected");
                message.status = $root.pond.UserStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateUserRequest
         * @static
         * @param {pond.UpdateUserRequest} message UpdateUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.UserSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.UserStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this UpdateUserRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserRequest;
    })();

    pond.UpdateUserResponse = (function() {

        /**
         * Properties of an UpdateUserResponse.
         * @memberof pond
         * @interface IUpdateUserResponse
         */

        /**
         * Constructs a new UpdateUserResponse.
         * @memberof pond
         * @classdesc Represents an UpdateUserResponse.
         * @implements IUpdateUserResponse
         * @constructor
         * @param {pond.IUpdateUserResponse=} [properties] Properties to set
         */
        function UpdateUserResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateUserResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateUserResponse
         * @static
         * @param {pond.IUpdateUserResponse=} [properties] Properties to set
         * @returns {pond.UpdateUserResponse} UpdateUserResponse instance
         */
        UpdateUserResponse.create = function create(properties) {
            return new UpdateUserResponse(properties);
        };

        /**
         * Creates an UpdateUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateUserResponse} UpdateUserResponse
         */
        UpdateUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateUserResponse)
                return object;
            return new $root.pond.UpdateUserResponse();
        };

        /**
         * Creates a plain object from an UpdateUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateUserResponse
         * @static
         * @param {pond.UpdateUserResponse} message UpdateUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUserResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateUserResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUserResponse;
    })();

    pond.SignupUserRequest = (function() {

        /**
         * Properties of a SignupUserRequest.
         * @memberof pond
         * @interface ISignupUserRequest
         * @property {string|null} [email] SignupUserRequest email
         * @property {string|null} [kind] SignupUserRequest kind
         * @property {string|null} [key] SignupUserRequest key
         * @property {Array.<pond.Permission>|null} [permissions] SignupUserRequest permissions
         * @property {string|null} [whitelabel] SignupUserRequest whitelabel
         */

        /**
         * Constructs a new SignupUserRequest.
         * @memberof pond
         * @classdesc Represents a SignupUserRequest.
         * @implements ISignupUserRequest
         * @constructor
         * @param {pond.ISignupUserRequest=} [properties] Properties to set
         */
        function SignupUserRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignupUserRequest email.
         * @member {string} email
         * @memberof pond.SignupUserRequest
         * @instance
         */
        SignupUserRequest.prototype.email = "";

        /**
         * SignupUserRequest kind.
         * @member {string} kind
         * @memberof pond.SignupUserRequest
         * @instance
         */
        SignupUserRequest.prototype.kind = "";

        /**
         * SignupUserRequest key.
         * @member {string} key
         * @memberof pond.SignupUserRequest
         * @instance
         */
        SignupUserRequest.prototype.key = "";

        /**
         * SignupUserRequest permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.SignupUserRequest
         * @instance
         */
        SignupUserRequest.prototype.permissions = $util.emptyArray;

        /**
         * SignupUserRequest whitelabel.
         * @member {string} whitelabel
         * @memberof pond.SignupUserRequest
         * @instance
         */
        SignupUserRequest.prototype.whitelabel = "";

        /**
         * Creates a new SignupUserRequest instance using the specified properties.
         * @function create
         * @memberof pond.SignupUserRequest
         * @static
         * @param {pond.ISignupUserRequest=} [properties] Properties to set
         * @returns {pond.SignupUserRequest} SignupUserRequest instance
         */
        SignupUserRequest.create = function create(properties) {
            return new SignupUserRequest(properties);
        };

        /**
         * Creates a SignupUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SignupUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SignupUserRequest} SignupUserRequest
         */
        SignupUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SignupUserRequest)
                return object;
            var message = new $root.pond.SignupUserRequest();
            if (object.email != null)
                message.email = String(object.email);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.SignupUserRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            if (object.whitelabel != null)
                message.whitelabel = String(object.whitelabel);
            return message;
        };

        /**
         * Creates a plain object from a SignupUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SignupUserRequest
         * @static
         * @param {pond.SignupUserRequest} message SignupUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignupUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.email = "";
                object.kind = "";
                object.key = "";
                object.whitelabel = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            if (message.whitelabel != null && message.hasOwnProperty("whitelabel"))
                object.whitelabel = message.whitelabel;
            return object;
        };

        /**
         * Converts this SignupUserRequest to JSON.
         * @function toJSON
         * @memberof pond.SignupUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignupUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignupUserRequest;
    })();

    pond.SignupUserResponse = (function() {

        /**
         * Properties of a SignupUserResponse.
         * @memberof pond
         * @interface ISignupUserResponse
         */

        /**
         * Constructs a new SignupUserResponse.
         * @memberof pond
         * @classdesc Represents a SignupUserResponse.
         * @implements ISignupUserResponse
         * @constructor
         * @param {pond.ISignupUserResponse=} [properties] Properties to set
         */
        function SignupUserResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SignupUserResponse instance using the specified properties.
         * @function create
         * @memberof pond.SignupUserResponse
         * @static
         * @param {pond.ISignupUserResponse=} [properties] Properties to set
         * @returns {pond.SignupUserResponse} SignupUserResponse instance
         */
        SignupUserResponse.create = function create(properties) {
            return new SignupUserResponse(properties);
        };

        /**
         * Creates a SignupUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SignupUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SignupUserResponse} SignupUserResponse
         */
        SignupUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SignupUserResponse)
                return object;
            return new $root.pond.SignupUserResponse();
        };

        /**
         * Creates a plain object from a SignupUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SignupUserResponse
         * @static
         * @param {pond.SignupUserResponse} message SignupUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignupUserResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SignupUserResponse to JSON.
         * @function toJSON
         * @memberof pond.SignupUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignupUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SignupUserResponse;
    })();

    pond.CompleteSignupUserRequest = (function() {

        /**
         * Properties of a CompleteSignupUserRequest.
         * @memberof pond
         * @interface ICompleteSignupUserRequest
         * @property {string|null} [id] CompleteSignupUserRequest id
         * @property {string|null} [email] CompleteSignupUserRequest email
         * @property {string|null} [name] CompleteSignupUserRequest name
         * @property {string|null} [avatar] CompleteSignupUserRequest avatar
         */

        /**
         * Constructs a new CompleteSignupUserRequest.
         * @memberof pond
         * @classdesc Represents a CompleteSignupUserRequest.
         * @implements ICompleteSignupUserRequest
         * @constructor
         * @param {pond.ICompleteSignupUserRequest=} [properties] Properties to set
         */
        function CompleteSignupUserRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompleteSignupUserRequest id.
         * @member {string} id
         * @memberof pond.CompleteSignupUserRequest
         * @instance
         */
        CompleteSignupUserRequest.prototype.id = "";

        /**
         * CompleteSignupUserRequest email.
         * @member {string} email
         * @memberof pond.CompleteSignupUserRequest
         * @instance
         */
        CompleteSignupUserRequest.prototype.email = "";

        /**
         * CompleteSignupUserRequest name.
         * @member {string} name
         * @memberof pond.CompleteSignupUserRequest
         * @instance
         */
        CompleteSignupUserRequest.prototype.name = "";

        /**
         * CompleteSignupUserRequest avatar.
         * @member {string} avatar
         * @memberof pond.CompleteSignupUserRequest
         * @instance
         */
        CompleteSignupUserRequest.prototype.avatar = "";

        /**
         * Creates a new CompleteSignupUserRequest instance using the specified properties.
         * @function create
         * @memberof pond.CompleteSignupUserRequest
         * @static
         * @param {pond.ICompleteSignupUserRequest=} [properties] Properties to set
         * @returns {pond.CompleteSignupUserRequest} CompleteSignupUserRequest instance
         */
        CompleteSignupUserRequest.create = function create(properties) {
            return new CompleteSignupUserRequest(properties);
        };

        /**
         * Creates a CompleteSignupUserRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CompleteSignupUserRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CompleteSignupUserRequest} CompleteSignupUserRequest
         */
        CompleteSignupUserRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CompleteSignupUserRequest)
                return object;
            var message = new $root.pond.CompleteSignupUserRequest();
            if (object.id != null)
                message.id = String(object.id);
            if (object.email != null)
                message.email = String(object.email);
            if (object.name != null)
                message.name = String(object.name);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            return message;
        };

        /**
         * Creates a plain object from a CompleteSignupUserRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CompleteSignupUserRequest
         * @static
         * @param {pond.CompleteSignupUserRequest} message CompleteSignupUserRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteSignupUserRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.email = "";
                object.name = "";
                object.avatar = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            return object;
        };

        /**
         * Converts this CompleteSignupUserRequest to JSON.
         * @function toJSON
         * @memberof pond.CompleteSignupUserRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteSignupUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteSignupUserRequest;
    })();

    pond.CompleteSignupUserResponse = (function() {

        /**
         * Properties of a CompleteSignupUserResponse.
         * @memberof pond
         * @interface ICompleteSignupUserResponse
         */

        /**
         * Constructs a new CompleteSignupUserResponse.
         * @memberof pond
         * @classdesc Represents a CompleteSignupUserResponse.
         * @implements ICompleteSignupUserResponse
         * @constructor
         * @param {pond.ICompleteSignupUserResponse=} [properties] Properties to set
         */
        function CompleteSignupUserResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CompleteSignupUserResponse instance using the specified properties.
         * @function create
         * @memberof pond.CompleteSignupUserResponse
         * @static
         * @param {pond.ICompleteSignupUserResponse=} [properties] Properties to set
         * @returns {pond.CompleteSignupUserResponse} CompleteSignupUserResponse instance
         */
        CompleteSignupUserResponse.create = function create(properties) {
            return new CompleteSignupUserResponse(properties);
        };

        /**
         * Creates a CompleteSignupUserResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CompleteSignupUserResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CompleteSignupUserResponse} CompleteSignupUserResponse
         */
        CompleteSignupUserResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CompleteSignupUserResponse)
                return object;
            return new $root.pond.CompleteSignupUserResponse();
        };

        /**
         * Creates a plain object from a CompleteSignupUserResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CompleteSignupUserResponse
         * @static
         * @param {pond.CompleteSignupUserResponse} message CompleteSignupUserResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompleteSignupUserResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CompleteSignupUserResponse to JSON.
         * @function toJSON
         * @memberof pond.CompleteSignupUserResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompleteSignupUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompleteSignupUserResponse;
    })();

    pond.HasPermissionsRequest = (function() {

        /**
         * Properties of a HasPermissionsRequest.
         * @memberof pond
         * @interface IHasPermissionsRequest
         * @property {string|null} [user] HasPermissionsRequest user
         * @property {string|null} [kind] HasPermissionsRequest kind
         * @property {string|null} [key] HasPermissionsRequest key
         * @property {Array.<pond.Permission>|null} [permissions] HasPermissionsRequest permissions
         */

        /**
         * Constructs a new HasPermissionsRequest.
         * @memberof pond
         * @classdesc Represents a HasPermissionsRequest.
         * @implements IHasPermissionsRequest
         * @constructor
         * @param {pond.IHasPermissionsRequest=} [properties] Properties to set
         */
        function HasPermissionsRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HasPermissionsRequest user.
         * @member {string} user
         * @memberof pond.HasPermissionsRequest
         * @instance
         */
        HasPermissionsRequest.prototype.user = "";

        /**
         * HasPermissionsRequest kind.
         * @member {string} kind
         * @memberof pond.HasPermissionsRequest
         * @instance
         */
        HasPermissionsRequest.prototype.kind = "";

        /**
         * HasPermissionsRequest key.
         * @member {string} key
         * @memberof pond.HasPermissionsRequest
         * @instance
         */
        HasPermissionsRequest.prototype.key = "";

        /**
         * HasPermissionsRequest permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.HasPermissionsRequest
         * @instance
         */
        HasPermissionsRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new HasPermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.HasPermissionsRequest
         * @static
         * @param {pond.IHasPermissionsRequest=} [properties] Properties to set
         * @returns {pond.HasPermissionsRequest} HasPermissionsRequest instance
         */
        HasPermissionsRequest.create = function create(properties) {
            return new HasPermissionsRequest(properties);
        };

        /**
         * Creates a HasPermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HasPermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HasPermissionsRequest} HasPermissionsRequest
         */
        HasPermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HasPermissionsRequest)
                return object;
            var message = new $root.pond.HasPermissionsRequest();
            if (object.user != null)
                message.user = String(object.user);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.HasPermissionsRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a HasPermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HasPermissionsRequest
         * @static
         * @param {pond.HasPermissionsRequest} message HasPermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HasPermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.user = "";
                object.kind = "";
                object.key = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this HasPermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.HasPermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HasPermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HasPermissionsRequest;
    })();

    pond.HasPermissionsResponse = (function() {

        /**
         * Properties of a HasPermissionsResponse.
         * @memberof pond
         * @interface IHasPermissionsResponse
         * @property {boolean|null} [hasPermissions] HasPermissionsResponse hasPermissions
         */

        /**
         * Constructs a new HasPermissionsResponse.
         * @memberof pond
         * @classdesc Represents a HasPermissionsResponse.
         * @implements IHasPermissionsResponse
         * @constructor
         * @param {pond.IHasPermissionsResponse=} [properties] Properties to set
         */
        function HasPermissionsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HasPermissionsResponse hasPermissions.
         * @member {boolean} hasPermissions
         * @memberof pond.HasPermissionsResponse
         * @instance
         */
        HasPermissionsResponse.prototype.hasPermissions = false;

        /**
         * Creates a new HasPermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.HasPermissionsResponse
         * @static
         * @param {pond.IHasPermissionsResponse=} [properties] Properties to set
         * @returns {pond.HasPermissionsResponse} HasPermissionsResponse instance
         */
        HasPermissionsResponse.create = function create(properties) {
            return new HasPermissionsResponse(properties);
        };

        /**
         * Creates a HasPermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HasPermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HasPermissionsResponse} HasPermissionsResponse
         */
        HasPermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HasPermissionsResponse)
                return object;
            var message = new $root.pond.HasPermissionsResponse();
            if (object.hasPermissions != null)
                message.hasPermissions = Boolean(object.hasPermissions);
            return message;
        };

        /**
         * Creates a plain object from a HasPermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HasPermissionsResponse
         * @static
         * @param {pond.HasPermissionsResponse} message HasPermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HasPermissionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.hasPermissions = false;
            if (message.hasPermissions != null && message.hasOwnProperty("hasPermissions"))
                object.hasPermissions = message.hasPermissions;
            return object;
        };

        /**
         * Converts this HasPermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.HasPermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HasPermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HasPermissionsResponse;
    })();

    pond.UpdatePermissionsRequest = (function() {

        /**
         * Properties of an UpdatePermissionsRequest.
         * @memberof pond
         * @interface IUpdatePermissionsRequest
         * @property {string|null} [user] UpdatePermissionsRequest user
         * @property {string|null} [kind] UpdatePermissionsRequest kind
         * @property {string|null} [key] UpdatePermissionsRequest key
         * @property {Array.<pond.Permission>|null} [permissions] UpdatePermissionsRequest permissions
         */

        /**
         * Constructs a new UpdatePermissionsRequest.
         * @memberof pond
         * @classdesc Represents an UpdatePermissionsRequest.
         * @implements IUpdatePermissionsRequest
         * @constructor
         * @param {pond.IUpdatePermissionsRequest=} [properties] Properties to set
         */
        function UpdatePermissionsRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePermissionsRequest user.
         * @member {string} user
         * @memberof pond.UpdatePermissionsRequest
         * @instance
         */
        UpdatePermissionsRequest.prototype.user = "";

        /**
         * UpdatePermissionsRequest kind.
         * @member {string} kind
         * @memberof pond.UpdatePermissionsRequest
         * @instance
         */
        UpdatePermissionsRequest.prototype.kind = "";

        /**
         * UpdatePermissionsRequest key.
         * @member {string} key
         * @memberof pond.UpdatePermissionsRequest
         * @instance
         */
        UpdatePermissionsRequest.prototype.key = "";

        /**
         * UpdatePermissionsRequest permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.UpdatePermissionsRequest
         * @instance
         */
        UpdatePermissionsRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdatePermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdatePermissionsRequest
         * @static
         * @param {pond.IUpdatePermissionsRequest=} [properties] Properties to set
         * @returns {pond.UpdatePermissionsRequest} UpdatePermissionsRequest instance
         */
        UpdatePermissionsRequest.create = function create(properties) {
            return new UpdatePermissionsRequest(properties);
        };

        /**
         * Creates an UpdatePermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdatePermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdatePermissionsRequest} UpdatePermissionsRequest
         */
        UpdatePermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdatePermissionsRequest)
                return object;
            var message = new $root.pond.UpdatePermissionsRequest();
            if (object.user != null)
                message.user = String(object.user);
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.UpdatePermissionsRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdatePermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdatePermissionsRequest
         * @static
         * @param {pond.UpdatePermissionsRequest} message UpdatePermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.user = "";
                object.kind = "";
                object.key = "";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = message.user;
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdatePermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdatePermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdatePermissionsRequest;
    })();

    pond.UpdateRelativePermissionsRequest = (function() {

        /**
         * Properties of an UpdateRelativePermissionsRequest.
         * @memberof pond
         * @interface IUpdateRelativePermissionsRequest
         * @property {string|null} [parent] UpdateRelativePermissionsRequest parent
         * @property {string|null} [parentType] UpdateRelativePermissionsRequest parentType
         * @property {string|null} [child] UpdateRelativePermissionsRequest child
         * @property {string|null} [childType] UpdateRelativePermissionsRequest childType
         * @property {Array.<pond.Permission>|null} [permissions] UpdateRelativePermissionsRequest permissions
         */

        /**
         * Constructs a new UpdateRelativePermissionsRequest.
         * @memberof pond
         * @classdesc Represents an UpdateRelativePermissionsRequest.
         * @implements IUpdateRelativePermissionsRequest
         * @constructor
         * @param {pond.IUpdateRelativePermissionsRequest=} [properties] Properties to set
         */
        function UpdateRelativePermissionsRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateRelativePermissionsRequest parent.
         * @member {string} parent
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         */
        UpdateRelativePermissionsRequest.prototype.parent = "";

        /**
         * UpdateRelativePermissionsRequest parentType.
         * @member {string} parentType
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         */
        UpdateRelativePermissionsRequest.prototype.parentType = "";

        /**
         * UpdateRelativePermissionsRequest child.
         * @member {string} child
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         */
        UpdateRelativePermissionsRequest.prototype.child = "";

        /**
         * UpdateRelativePermissionsRequest childType.
         * @member {string} childType
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         */
        UpdateRelativePermissionsRequest.prototype.childType = "";

        /**
         * UpdateRelativePermissionsRequest permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         */
        UpdateRelativePermissionsRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdateRelativePermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateRelativePermissionsRequest
         * @static
         * @param {pond.IUpdateRelativePermissionsRequest=} [properties] Properties to set
         * @returns {pond.UpdateRelativePermissionsRequest} UpdateRelativePermissionsRequest instance
         */
        UpdateRelativePermissionsRequest.create = function create(properties) {
            return new UpdateRelativePermissionsRequest(properties);
        };

        /**
         * Creates an UpdateRelativePermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateRelativePermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateRelativePermissionsRequest} UpdateRelativePermissionsRequest
         */
        UpdateRelativePermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateRelativePermissionsRequest)
                return object;
            var message = new $root.pond.UpdateRelativePermissionsRequest();
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.child != null)
                message.child = String(object.child);
            if (object.childType != null)
                message.childType = String(object.childType);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.UpdateRelativePermissionsRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateRelativePermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateRelativePermissionsRequest
         * @static
         * @param {pond.UpdateRelativePermissionsRequest} message UpdateRelativePermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateRelativePermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.parent = "";
                object.parentType = "";
                object.child = "";
                object.childType = "";
            }
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.child != null && message.hasOwnProperty("child"))
                object.child = message.child;
            if (message.childType != null && message.hasOwnProperty("childType"))
                object.childType = message.childType;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdateRelativePermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateRelativePermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateRelativePermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateRelativePermissionsRequest;
    })();

    pond.UpdatePermissionsResponse = (function() {

        /**
         * Properties of an UpdatePermissionsResponse.
         * @memberof pond
         * @interface IUpdatePermissionsResponse
         */

        /**
         * Constructs a new UpdatePermissionsResponse.
         * @memberof pond
         * @classdesc Represents an UpdatePermissionsResponse.
         * @implements IUpdatePermissionsResponse
         * @constructor
         * @param {pond.IUpdatePermissionsResponse=} [properties] Properties to set
         */
        function UpdatePermissionsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdatePermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdatePermissionsResponse
         * @static
         * @param {pond.IUpdatePermissionsResponse=} [properties] Properties to set
         * @returns {pond.UpdatePermissionsResponse} UpdatePermissionsResponse instance
         */
        UpdatePermissionsResponse.create = function create(properties) {
            return new UpdatePermissionsResponse(properties);
        };

        /**
         * Creates an UpdatePermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdatePermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdatePermissionsResponse} UpdatePermissionsResponse
         */
        UpdatePermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdatePermissionsResponse)
                return object;
            return new $root.pond.UpdatePermissionsResponse();
        };

        /**
         * Creates a plain object from an UpdatePermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdatePermissionsResponse
         * @static
         * @param {pond.UpdatePermissionsResponse} message UpdatePermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePermissionsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdatePermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdatePermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdatePermissionsResponse;
    })();

    pond.UpdateRelativePermissionsResponse = (function() {

        /**
         * Properties of an UpdateRelativePermissionsResponse.
         * @memberof pond
         * @interface IUpdateRelativePermissionsResponse
         */

        /**
         * Constructs a new UpdateRelativePermissionsResponse.
         * @memberof pond
         * @classdesc Represents an UpdateRelativePermissionsResponse.
         * @implements IUpdateRelativePermissionsResponse
         * @constructor
         * @param {pond.IUpdateRelativePermissionsResponse=} [properties] Properties to set
         */
        function UpdateRelativePermissionsResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateRelativePermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateRelativePermissionsResponse
         * @static
         * @param {pond.IUpdateRelativePermissionsResponse=} [properties] Properties to set
         * @returns {pond.UpdateRelativePermissionsResponse} UpdateRelativePermissionsResponse instance
         */
        UpdateRelativePermissionsResponse.create = function create(properties) {
            return new UpdateRelativePermissionsResponse(properties);
        };

        /**
         * Creates an UpdateRelativePermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateRelativePermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateRelativePermissionsResponse} UpdateRelativePermissionsResponse
         */
        UpdateRelativePermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateRelativePermissionsResponse)
                return object;
            return new $root.pond.UpdateRelativePermissionsResponse();
        };

        /**
         * Creates a plain object from an UpdateRelativePermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateRelativePermissionsResponse
         * @static
         * @param {pond.UpdateRelativePermissionsResponse} message UpdateRelativePermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateRelativePermissionsResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateRelativePermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateRelativePermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateRelativePermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateRelativePermissionsResponse;
    })();

    pond.GetRelativePermissionsRequest = (function() {

        /**
         * Properties of a GetRelativePermissionsRequest.
         * @memberof pond
         * @interface IGetRelativePermissionsRequest
         * @property {string|null} [as] GetRelativePermissionsRequest as
         * @property {string|null} [asType] GetRelativePermissionsRequest asType
         * @property {string|null} [object] GetRelativePermissionsRequest object
         * @property {string|null} [objectType] GetRelativePermissionsRequest objectType
         */

        /**
         * Constructs a new GetRelativePermissionsRequest.
         * @memberof pond
         * @classdesc Represents a GetRelativePermissionsRequest.
         * @implements IGetRelativePermissionsRequest
         * @constructor
         * @param {pond.IGetRelativePermissionsRequest=} [properties] Properties to set
         */
        function GetRelativePermissionsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRelativePermissionsRequest as.
         * @member {string} as
         * @memberof pond.GetRelativePermissionsRequest
         * @instance
         */
        GetRelativePermissionsRequest.prototype.as = "";

        /**
         * GetRelativePermissionsRequest asType.
         * @member {string} asType
         * @memberof pond.GetRelativePermissionsRequest
         * @instance
         */
        GetRelativePermissionsRequest.prototype.asType = "";

        /**
         * GetRelativePermissionsRequest object.
         * @member {string} object
         * @memberof pond.GetRelativePermissionsRequest
         * @instance
         */
        GetRelativePermissionsRequest.prototype.object = "";

        /**
         * GetRelativePermissionsRequest objectType.
         * @member {string} objectType
         * @memberof pond.GetRelativePermissionsRequest
         * @instance
         */
        GetRelativePermissionsRequest.prototype.objectType = "";

        /**
         * Creates a new GetRelativePermissionsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetRelativePermissionsRequest
         * @static
         * @param {pond.IGetRelativePermissionsRequest=} [properties] Properties to set
         * @returns {pond.GetRelativePermissionsRequest} GetRelativePermissionsRequest instance
         */
        GetRelativePermissionsRequest.create = function create(properties) {
            return new GetRelativePermissionsRequest(properties);
        };

        /**
         * Creates a GetRelativePermissionsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetRelativePermissionsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetRelativePermissionsRequest} GetRelativePermissionsRequest
         */
        GetRelativePermissionsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetRelativePermissionsRequest)
                return object;
            var message = new $root.pond.GetRelativePermissionsRequest();
            if (object.as != null)
                message.as = String(object.as);
            if (object.asType != null)
                message.asType = String(object.asType);
            if (object.object != null)
                message.object = String(object.object);
            if (object.objectType != null)
                message.objectType = String(object.objectType);
            return message;
        };

        /**
         * Creates a plain object from a GetRelativePermissionsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetRelativePermissionsRequest
         * @static
         * @param {pond.GetRelativePermissionsRequest} message GetRelativePermissionsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRelativePermissionsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.as = "";
                object.asType = "";
                object.object = "";
                object.objectType = "";
            }
            if (message.as != null && message.hasOwnProperty("as"))
                object.as = message.as;
            if (message.asType != null && message.hasOwnProperty("asType"))
                object.asType = message.asType;
            if (message.object != null && message.hasOwnProperty("object"))
                object.object = message.object;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = message.objectType;
            return object;
        };

        /**
         * Converts this GetRelativePermissionsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetRelativePermissionsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRelativePermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetRelativePermissionsRequest;
    })();

    pond.GetPermissionsResponse = (function() {

        /**
         * Properties of a GetPermissionsResponse.
         * @memberof pond
         * @interface IGetPermissionsResponse
         * @property {Array.<pond.Permission>|null} [permissions] GetPermissionsResponse permissions
         */

        /**
         * Constructs a new GetPermissionsResponse.
         * @memberof pond
         * @classdesc Represents a GetPermissionsResponse.
         * @implements IGetPermissionsResponse
         * @constructor
         * @param {pond.IGetPermissionsResponse=} [properties] Properties to set
         */
        function GetPermissionsResponse(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPermissionsResponse permissions.
         * @member {Array.<pond.Permission>} permissions
         * @memberof pond.GetPermissionsResponse
         * @instance
         */
        GetPermissionsResponse.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new GetPermissionsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetPermissionsResponse
         * @static
         * @param {pond.IGetPermissionsResponse=} [properties] Properties to set
         * @returns {pond.GetPermissionsResponse} GetPermissionsResponse instance
         */
        GetPermissionsResponse.create = function create(properties) {
            return new GetPermissionsResponse(properties);
        };

        /**
         * Creates a GetPermissionsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetPermissionsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetPermissionsResponse} GetPermissionsResponse
         */
        GetPermissionsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetPermissionsResponse)
                return object;
            var message = new $root.pond.GetPermissionsResponse();
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.GetPermissionsResponse.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                    case "PERMISSION_INVALID":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "PERMISSION_USERS":
                    case 1:
                        message.permissions[i] = 1;
                        break;
                    case "PERMISSION_READ":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "PERMISSION_WRITE":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "PERMISSION_SHARE":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "PERMISSION_BILLING":
                    case 5:
                        message.permissions[i] = 5;
                        break;
                    case "PERMISSION_FILE_MANAGEMENT":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetPermissionsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetPermissionsResponse
         * @static
         * @param {pond.GetPermissionsResponse} message GetPermissionsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPermissionsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.pond.Permission[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this GetPermissionsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetPermissionsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetPermissionsResponse;
    })();

    pond.GetPreferencesRequest = (function() {

        /**
         * Properties of a GetPreferencesRequest.
         * @memberof pond
         * @interface IGetPreferencesRequest
         * @property {string|null} [kind] GetPreferencesRequest kind
         * @property {Array.<string>|null} [keys] GetPreferencesRequest keys
         */

        /**
         * Constructs a new GetPreferencesRequest.
         * @memberof pond
         * @classdesc Represents a GetPreferencesRequest.
         * @implements IGetPreferencesRequest
         * @constructor
         * @param {pond.IGetPreferencesRequest=} [properties] Properties to set
         */
        function GetPreferencesRequest(properties) {
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPreferencesRequest kind.
         * @member {string} kind
         * @memberof pond.GetPreferencesRequest
         * @instance
         */
        GetPreferencesRequest.prototype.kind = "";

        /**
         * GetPreferencesRequest keys.
         * @member {Array.<string>} keys
         * @memberof pond.GetPreferencesRequest
         * @instance
         */
        GetPreferencesRequest.prototype.keys = $util.emptyArray;

        /**
         * Creates a new GetPreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetPreferencesRequest
         * @static
         * @param {pond.IGetPreferencesRequest=} [properties] Properties to set
         * @returns {pond.GetPreferencesRequest} GetPreferencesRequest instance
         */
        GetPreferencesRequest.create = function create(properties) {
            return new GetPreferencesRequest(properties);
        };

        /**
         * Creates a GetPreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetPreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetPreferencesRequest} GetPreferencesRequest
         */
        GetPreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetPreferencesRequest)
                return object;
            var message = new $root.pond.GetPreferencesRequest();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.GetPreferencesRequest.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetPreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetPreferencesRequest
         * @static
         * @param {pond.GetPreferencesRequest} message GetPreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (options.defaults)
                object.kind = "";
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            return object;
        };

        /**
         * Converts this GetPreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.GetPreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetPreferencesRequest;
    })();

    pond.ListBinComponentPreferencesRequest = (function() {

        /**
         * Properties of a ListBinComponentPreferencesRequest.
         * @memberof pond
         * @interface IListBinComponentPreferencesRequest
         * @property {string|null} [bin] ListBinComponentPreferencesRequest bin
         * @property {Array.<string>|null} [keys] ListBinComponentPreferencesRequest keys
         */

        /**
         * Constructs a new ListBinComponentPreferencesRequest.
         * @memberof pond
         * @classdesc Represents a ListBinComponentPreferencesRequest.
         * @implements IListBinComponentPreferencesRequest
         * @constructor
         * @param {pond.IListBinComponentPreferencesRequest=} [properties] Properties to set
         */
        function ListBinComponentPreferencesRequest(properties) {
            this.keys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentPreferencesRequest bin.
         * @member {string} bin
         * @memberof pond.ListBinComponentPreferencesRequest
         * @instance
         */
        ListBinComponentPreferencesRequest.prototype.bin = "";

        /**
         * ListBinComponentPreferencesRequest keys.
         * @member {Array.<string>} keys
         * @memberof pond.ListBinComponentPreferencesRequest
         * @instance
         */
        ListBinComponentPreferencesRequest.prototype.keys = $util.emptyArray;

        /**
         * Creates a new ListBinComponentPreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentPreferencesRequest
         * @static
         * @param {pond.IListBinComponentPreferencesRequest=} [properties] Properties to set
         * @returns {pond.ListBinComponentPreferencesRequest} ListBinComponentPreferencesRequest instance
         */
        ListBinComponentPreferencesRequest.create = function create(properties) {
            return new ListBinComponentPreferencesRequest(properties);
        };

        /**
         * Creates a ListBinComponentPreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentPreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentPreferencesRequest} ListBinComponentPreferencesRequest
         */
        ListBinComponentPreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentPreferencesRequest)
                return object;
            var message = new $root.pond.ListBinComponentPreferencesRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.keys) {
                if (!Array.isArray(object.keys))
                    throw TypeError(".pond.ListBinComponentPreferencesRequest.keys: array expected");
                message.keys = [];
                for (var i = 0; i < object.keys.length; ++i)
                    message.keys[i] = String(object.keys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentPreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentPreferencesRequest
         * @static
         * @param {pond.ListBinComponentPreferencesRequest} message ListBinComponentPreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentPreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.keys = [];
            if (options.defaults)
                object.bin = "";
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.keys && message.keys.length) {
                object.keys = [];
                for (var j = 0; j < message.keys.length; ++j)
                    object.keys[j] = message.keys[j];
            }
            return object;
        };

        /**
         * Converts this ListBinComponentPreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentPreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentPreferencesRequest;
    })();

    pond.ListBinComponentPreferencesResponse = (function() {

        /**
         * Properties of a ListBinComponentPreferencesResponse.
         * @memberof pond
         * @interface IListBinComponentPreferencesResponse
         * @property {Object.<string,pond.BinComponentPreferences>|null} [preferences] ListBinComponentPreferencesResponse preferences
         */

        /**
         * Constructs a new ListBinComponentPreferencesResponse.
         * @memberof pond
         * @classdesc Represents a ListBinComponentPreferencesResponse.
         * @implements IListBinComponentPreferencesResponse
         * @constructor
         * @param {pond.IListBinComponentPreferencesResponse=} [properties] Properties to set
         */
        function ListBinComponentPreferencesResponse(properties) {
            this.preferences = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBinComponentPreferencesResponse preferences.
         * @member {Object.<string,pond.BinComponentPreferences>} preferences
         * @memberof pond.ListBinComponentPreferencesResponse
         * @instance
         */
        ListBinComponentPreferencesResponse.prototype.preferences = $util.emptyObject;

        /**
         * Creates a new ListBinComponentPreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBinComponentPreferencesResponse
         * @static
         * @param {pond.IListBinComponentPreferencesResponse=} [properties] Properties to set
         * @returns {pond.ListBinComponentPreferencesResponse} ListBinComponentPreferencesResponse instance
         */
        ListBinComponentPreferencesResponse.create = function create(properties) {
            return new ListBinComponentPreferencesResponse(properties);
        };

        /**
         * Creates a ListBinComponentPreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBinComponentPreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBinComponentPreferencesResponse} ListBinComponentPreferencesResponse
         */
        ListBinComponentPreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBinComponentPreferencesResponse)
                return object;
            var message = new $root.pond.ListBinComponentPreferencesResponse();
            if (object.preferences) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.ListBinComponentPreferencesResponse.preferences: object expected");
                message.preferences = {};
                for (var keys = Object.keys(object.preferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.preferences[keys[i]] !== "object")
                        throw TypeError(".pond.ListBinComponentPreferencesResponse.preferences: object expected");
                    message.preferences[keys[i]] = $root.pond.BinComponentPreferences.fromObject(object.preferences[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBinComponentPreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBinComponentPreferencesResponse
         * @static
         * @param {pond.ListBinComponentPreferencesResponse} message ListBinComponentPreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBinComponentPreferencesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.preferences = {};
            var keys2;
            if (message.preferences && (keys2 = Object.keys(message.preferences)).length) {
                object.preferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.preferences[keys2[j]] = $root.pond.BinComponentPreferences.toObject(message.preferences[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this ListBinComponentPreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBinComponentPreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBinComponentPreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBinComponentPreferencesResponse;
    })();

    pond.ModelPreferences = (function() {

        /**
         * Properties of a ModelPreferences.
         * @memberof pond
         * @interface IModelPreferences
         * @property {string|null} [kind] ModelPreferences kind
         * @property {string|null} [key] ModelPreferences key
         * @property {pond.UserPreferences|null} [preferences] ModelPreferences preferences
         */

        /**
         * Constructs a new ModelPreferences.
         * @memberof pond
         * @classdesc Represents a ModelPreferences.
         * @implements IModelPreferences
         * @constructor
         * @param {pond.IModelPreferences=} [properties] Properties to set
         */
        function ModelPreferences(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ModelPreferences kind.
         * @member {string} kind
         * @memberof pond.ModelPreferences
         * @instance
         */
        ModelPreferences.prototype.kind = "";

        /**
         * ModelPreferences key.
         * @member {string} key
         * @memberof pond.ModelPreferences
         * @instance
         */
        ModelPreferences.prototype.key = "";

        /**
         * ModelPreferences preferences.
         * @member {pond.UserPreferences|null|undefined} preferences
         * @memberof pond.ModelPreferences
         * @instance
         */
        ModelPreferences.prototype.preferences = null;

        /**
         * Creates a new ModelPreferences instance using the specified properties.
         * @function create
         * @memberof pond.ModelPreferences
         * @static
         * @param {pond.IModelPreferences=} [properties] Properties to set
         * @returns {pond.ModelPreferences} ModelPreferences instance
         */
        ModelPreferences.create = function create(properties) {
            return new ModelPreferences(properties);
        };

        /**
         * Creates a ModelPreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ModelPreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ModelPreferences} ModelPreferences
         */
        ModelPreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ModelPreferences)
                return object;
            var message = new $root.pond.ModelPreferences();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.ModelPreferences.preferences: object expected");
                message.preferences = $root.pond.UserPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from a ModelPreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ModelPreferences
         * @static
         * @param {pond.ModelPreferences} message ModelPreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ModelPreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.kind = "";
                object.key = "";
                object.preferences = null;
            }
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.UserPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this ModelPreferences to JSON.
         * @function toJSON
         * @memberof pond.ModelPreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ModelPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ModelPreferences;
    })();

    pond.GetPreferencesResponse = (function() {

        /**
         * Properties of a GetPreferencesResponse.
         * @memberof pond
         * @interface IGetPreferencesResponse
         * @property {Array.<pond.ModelPreferences>|null} [preferences] GetPreferencesResponse preferences
         */

        /**
         * Constructs a new GetPreferencesResponse.
         * @memberof pond
         * @classdesc Represents a GetPreferencesResponse.
         * @implements IGetPreferencesResponse
         * @constructor
         * @param {pond.IGetPreferencesResponse=} [properties] Properties to set
         */
        function GetPreferencesResponse(properties) {
            this.preferences = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPreferencesResponse preferences.
         * @member {Array.<pond.ModelPreferences>} preferences
         * @memberof pond.GetPreferencesResponse
         * @instance
         */
        GetPreferencesResponse.prototype.preferences = $util.emptyArray;

        /**
         * Creates a new GetPreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetPreferencesResponse
         * @static
         * @param {pond.IGetPreferencesResponse=} [properties] Properties to set
         * @returns {pond.GetPreferencesResponse} GetPreferencesResponse instance
         */
        GetPreferencesResponse.create = function create(properties) {
            return new GetPreferencesResponse(properties);
        };

        /**
         * Creates a GetPreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetPreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetPreferencesResponse} GetPreferencesResponse
         */
        GetPreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetPreferencesResponse)
                return object;
            var message = new $root.pond.GetPreferencesResponse();
            if (object.preferences) {
                if (!Array.isArray(object.preferences))
                    throw TypeError(".pond.GetPreferencesResponse.preferences: array expected");
                message.preferences = [];
                for (var i = 0; i < object.preferences.length; ++i) {
                    if (typeof object.preferences[i] !== "object")
                        throw TypeError(".pond.GetPreferencesResponse.preferences: object expected");
                    message.preferences[i] = $root.pond.ModelPreferences.fromObject(object.preferences[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetPreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetPreferencesResponse
         * @static
         * @param {pond.GetPreferencesResponse} message GetPreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPreferencesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.preferences = [];
            if (message.preferences && message.preferences.length) {
                object.preferences = [];
                for (var j = 0; j < message.preferences.length; ++j)
                    object.preferences[j] = $root.pond.ModelPreferences.toObject(message.preferences[j], options);
            }
            return object;
        };

        /**
         * Converts this GetPreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.GetPreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetPreferencesResponse;
    })();

    pond.UpdatePreferencesRequest = (function() {

        /**
         * Properties of an UpdatePreferencesRequest.
         * @memberof pond
         * @interface IUpdatePreferencesRequest
         * @property {string|null} [kind] UpdatePreferencesRequest kind
         * @property {string|null} [key] UpdatePreferencesRequest key
         * @property {pond.UserPreferences|null} [preferences] UpdatePreferencesRequest preferences
         */

        /**
         * Constructs a new UpdatePreferencesRequest.
         * @memberof pond
         * @classdesc Represents an UpdatePreferencesRequest.
         * @implements IUpdatePreferencesRequest
         * @constructor
         * @param {pond.IUpdatePreferencesRequest=} [properties] Properties to set
         */
        function UpdatePreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePreferencesRequest kind.
         * @member {string} kind
         * @memberof pond.UpdatePreferencesRequest
         * @instance
         */
        UpdatePreferencesRequest.prototype.kind = "";

        /**
         * UpdatePreferencesRequest key.
         * @member {string} key
         * @memberof pond.UpdatePreferencesRequest
         * @instance
         */
        UpdatePreferencesRequest.prototype.key = "";

        /**
         * UpdatePreferencesRequest preferences.
         * @member {pond.UserPreferences|null|undefined} preferences
         * @memberof pond.UpdatePreferencesRequest
         * @instance
         */
        UpdatePreferencesRequest.prototype.preferences = null;

        /**
         * Creates a new UpdatePreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdatePreferencesRequest
         * @static
         * @param {pond.IUpdatePreferencesRequest=} [properties] Properties to set
         * @returns {pond.UpdatePreferencesRequest} UpdatePreferencesRequest instance
         */
        UpdatePreferencesRequest.create = function create(properties) {
            return new UpdatePreferencesRequest(properties);
        };

        /**
         * Creates an UpdatePreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdatePreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdatePreferencesRequest} UpdatePreferencesRequest
         */
        UpdatePreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdatePreferencesRequest)
                return object;
            var message = new $root.pond.UpdatePreferencesRequest();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.UpdatePreferencesRequest.preferences: object expected");
                message.preferences = $root.pond.UserPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdatePreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdatePreferencesRequest
         * @static
         * @param {pond.UpdatePreferencesRequest} message UpdatePreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.kind = "";
                object.key = "";
                object.preferences = null;
            }
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.UserPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this UpdatePreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdatePreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdatePreferencesRequest;
    })();

    pond.UpdatePreferencesResponse = (function() {

        /**
         * Properties of an UpdatePreferencesResponse.
         * @memberof pond
         * @interface IUpdatePreferencesResponse
         */

        /**
         * Constructs a new UpdatePreferencesResponse.
         * @memberof pond
         * @classdesc Represents an UpdatePreferencesResponse.
         * @implements IUpdatePreferencesResponse
         * @constructor
         * @param {pond.IUpdatePreferencesResponse=} [properties] Properties to set
         */
        function UpdatePreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdatePreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdatePreferencesResponse
         * @static
         * @param {pond.IUpdatePreferencesResponse=} [properties] Properties to set
         * @returns {pond.UpdatePreferencesResponse} UpdatePreferencesResponse instance
         */
        UpdatePreferencesResponse.create = function create(properties) {
            return new UpdatePreferencesResponse(properties);
        };

        /**
         * Creates an UpdatePreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdatePreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdatePreferencesResponse} UpdatePreferencesResponse
         */
        UpdatePreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdatePreferencesResponse)
                return object;
            return new $root.pond.UpdatePreferencesResponse();
        };

        /**
         * Creates a plain object from an UpdatePreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdatePreferencesResponse
         * @static
         * @param {pond.UpdatePreferencesResponse} message UpdatePreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePreferencesResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdatePreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdatePreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdatePreferencesResponse;
    })();

    pond.GetGatePreferencesRequest = (function() {

        /**
         * Properties of a GetGatePreferencesRequest.
         * @memberof pond
         * @interface IGetGatePreferencesRequest
         * @property {string|null} [gate] GetGatePreferencesRequest gate
         * @property {string|null} [type] GetGatePreferencesRequest type
         * @property {string|null} [key] GetGatePreferencesRequest key
         */

        /**
         * Constructs a new GetGatePreferencesRequest.
         * @memberof pond
         * @classdesc Represents a GetGatePreferencesRequest.
         * @implements IGetGatePreferencesRequest
         * @constructor
         * @param {pond.IGetGatePreferencesRequest=} [properties] Properties to set
         */
        function GetGatePreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGatePreferencesRequest gate.
         * @member {string} gate
         * @memberof pond.GetGatePreferencesRequest
         * @instance
         */
        GetGatePreferencesRequest.prototype.gate = "";

        /**
         * GetGatePreferencesRequest type.
         * @member {string} type
         * @memberof pond.GetGatePreferencesRequest
         * @instance
         */
        GetGatePreferencesRequest.prototype.type = "";

        /**
         * GetGatePreferencesRequest key.
         * @member {string} key
         * @memberof pond.GetGatePreferencesRequest
         * @instance
         */
        GetGatePreferencesRequest.prototype.key = "";

        /**
         * Creates a new GetGatePreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGatePreferencesRequest
         * @static
         * @param {pond.IGetGatePreferencesRequest=} [properties] Properties to set
         * @returns {pond.GetGatePreferencesRequest} GetGatePreferencesRequest instance
         */
        GetGatePreferencesRequest.create = function create(properties) {
            return new GetGatePreferencesRequest(properties);
        };

        /**
         * Creates a GetGatePreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGatePreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGatePreferencesRequest} GetGatePreferencesRequest
         */
        GetGatePreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGatePreferencesRequest)
                return object;
            var message = new $root.pond.GetGatePreferencesRequest();
            if (object.gate != null)
                message.gate = String(object.gate);
            if (object.type != null)
                message.type = String(object.type);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetGatePreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGatePreferencesRequest
         * @static
         * @param {pond.GetGatePreferencesRequest} message GetGatePreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGatePreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gate = "";
                object.type = "";
                object.key = "";
            }
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = message.gate;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetGatePreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGatePreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGatePreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGatePreferencesRequest;
    })();

    pond.GetGatePreferencesResponse = (function() {

        /**
         * Properties of a GetGatePreferencesResponse.
         * @memberof pond
         * @interface IGetGatePreferencesResponse
         * @property {pond.GatePreferences|null} [preferences] GetGatePreferencesResponse preferences
         */

        /**
         * Constructs a new GetGatePreferencesResponse.
         * @memberof pond
         * @classdesc Represents a GetGatePreferencesResponse.
         * @implements IGetGatePreferencesResponse
         * @constructor
         * @param {pond.IGetGatePreferencesResponse=} [properties] Properties to set
         */
        function GetGatePreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGatePreferencesResponse preferences.
         * @member {pond.GatePreferences|null|undefined} preferences
         * @memberof pond.GetGatePreferencesResponse
         * @instance
         */
        GetGatePreferencesResponse.prototype.preferences = null;

        /**
         * Creates a new GetGatePreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetGatePreferencesResponse
         * @static
         * @param {pond.IGetGatePreferencesResponse=} [properties] Properties to set
         * @returns {pond.GetGatePreferencesResponse} GetGatePreferencesResponse instance
         */
        GetGatePreferencesResponse.create = function create(properties) {
            return new GetGatePreferencesResponse(properties);
        };

        /**
         * Creates a GetGatePreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGatePreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGatePreferencesResponse} GetGatePreferencesResponse
         */
        GetGatePreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGatePreferencesResponse)
                return object;
            var message = new $root.pond.GetGatePreferencesResponse();
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.GetGatePreferencesResponse.preferences: object expected");
                message.preferences = $root.pond.GatePreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetGatePreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGatePreferencesResponse
         * @static
         * @param {pond.GetGatePreferencesResponse} message GetGatePreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGatePreferencesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.preferences = null;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.GatePreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this GetGatePreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.GetGatePreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGatePreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGatePreferencesResponse;
    })();

    pond.UpdateGatePreferencesRequest = (function() {

        /**
         * Properties of an UpdateGatePreferencesRequest.
         * @memberof pond
         * @interface IUpdateGatePreferencesRequest
         * @property {string|null} [gate] UpdateGatePreferencesRequest gate
         * @property {string|null} [type] UpdateGatePreferencesRequest type
         * @property {string|null} [key] UpdateGatePreferencesRequest key
         * @property {pond.GatePreferences|null} [preferences] UpdateGatePreferencesRequest preferences
         */

        /**
         * Constructs a new UpdateGatePreferencesRequest.
         * @memberof pond
         * @classdesc Represents an UpdateGatePreferencesRequest.
         * @implements IUpdateGatePreferencesRequest
         * @constructor
         * @param {pond.IUpdateGatePreferencesRequest=} [properties] Properties to set
         */
        function UpdateGatePreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGatePreferencesRequest gate.
         * @member {string} gate
         * @memberof pond.UpdateGatePreferencesRequest
         * @instance
         */
        UpdateGatePreferencesRequest.prototype.gate = "";

        /**
         * UpdateGatePreferencesRequest type.
         * @member {string} type
         * @memberof pond.UpdateGatePreferencesRequest
         * @instance
         */
        UpdateGatePreferencesRequest.prototype.type = "";

        /**
         * UpdateGatePreferencesRequest key.
         * @member {string} key
         * @memberof pond.UpdateGatePreferencesRequest
         * @instance
         */
        UpdateGatePreferencesRequest.prototype.key = "";

        /**
         * UpdateGatePreferencesRequest preferences.
         * @member {pond.GatePreferences|null|undefined} preferences
         * @memberof pond.UpdateGatePreferencesRequest
         * @instance
         */
        UpdateGatePreferencesRequest.prototype.preferences = null;

        /**
         * Creates a new UpdateGatePreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGatePreferencesRequest
         * @static
         * @param {pond.IUpdateGatePreferencesRequest=} [properties] Properties to set
         * @returns {pond.UpdateGatePreferencesRequest} UpdateGatePreferencesRequest instance
         */
        UpdateGatePreferencesRequest.create = function create(properties) {
            return new UpdateGatePreferencesRequest(properties);
        };

        /**
         * Creates an UpdateGatePreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGatePreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGatePreferencesRequest} UpdateGatePreferencesRequest
         */
        UpdateGatePreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGatePreferencesRequest)
                return object;
            var message = new $root.pond.UpdateGatePreferencesRequest();
            if (object.gate != null)
                message.gate = String(object.gate);
            if (object.type != null)
                message.type = String(object.type);
            if (object.key != null)
                message.key = String(object.key);
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.UpdateGatePreferencesRequest.preferences: object expected");
                message.preferences = $root.pond.GatePreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateGatePreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGatePreferencesRequest
         * @static
         * @param {pond.UpdateGatePreferencesRequest} message UpdateGatePreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGatePreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gate = "";
                object.type = "";
                object.key = "";
                object.preferences = null;
            }
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = message.gate;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.GatePreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this UpdateGatePreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateGatePreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGatePreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGatePreferencesRequest;
    })();

    pond.UpdateGatePreferencesResponse = (function() {

        /**
         * Properties of an UpdateGatePreferencesResponse.
         * @memberof pond
         * @interface IUpdateGatePreferencesResponse
         */

        /**
         * Constructs a new UpdateGatePreferencesResponse.
         * @memberof pond
         * @classdesc Represents an UpdateGatePreferencesResponse.
         * @implements IUpdateGatePreferencesResponse
         * @constructor
         * @param {pond.IUpdateGatePreferencesResponse=} [properties] Properties to set
         */
        function UpdateGatePreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGatePreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGatePreferencesResponse
         * @static
         * @param {pond.IUpdateGatePreferencesResponse=} [properties] Properties to set
         * @returns {pond.UpdateGatePreferencesResponse} UpdateGatePreferencesResponse instance
         */
        UpdateGatePreferencesResponse.create = function create(properties) {
            return new UpdateGatePreferencesResponse(properties);
        };

        /**
         * Creates an UpdateGatePreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGatePreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGatePreferencesResponse} UpdateGatePreferencesResponse
         */
        UpdateGatePreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGatePreferencesResponse)
                return object;
            return new $root.pond.UpdateGatePreferencesResponse();
        };

        /**
         * Creates a plain object from an UpdateGatePreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGatePreferencesResponse
         * @static
         * @param {pond.UpdateGatePreferencesResponse} message UpdateGatePreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGatePreferencesResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGatePreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateGatePreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGatePreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGatePreferencesResponse;
    })();

    pond.UpdateBinComponentPreferencesRequest = (function() {

        /**
         * Properties of an UpdateBinComponentPreferencesRequest.
         * @memberof pond
         * @interface IUpdateBinComponentPreferencesRequest
         * @property {string|null} [bin] UpdateBinComponentPreferencesRequest bin
         * @property {string|null} [component] UpdateBinComponentPreferencesRequest component
         * @property {pond.BinComponentPreferences|null} [preferences] UpdateBinComponentPreferencesRequest preferences
         */

        /**
         * Constructs a new UpdateBinComponentPreferencesRequest.
         * @memberof pond
         * @classdesc Represents an UpdateBinComponentPreferencesRequest.
         * @implements IUpdateBinComponentPreferencesRequest
         * @constructor
         * @param {pond.IUpdateBinComponentPreferencesRequest=} [properties] Properties to set
         */
        function UpdateBinComponentPreferencesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateBinComponentPreferencesRequest bin.
         * @member {string} bin
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @instance
         */
        UpdateBinComponentPreferencesRequest.prototype.bin = "";

        /**
         * UpdateBinComponentPreferencesRequest component.
         * @member {string} component
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @instance
         */
        UpdateBinComponentPreferencesRequest.prototype.component = "";

        /**
         * UpdateBinComponentPreferencesRequest preferences.
         * @member {pond.BinComponentPreferences|null|undefined} preferences
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @instance
         */
        UpdateBinComponentPreferencesRequest.prototype.preferences = null;

        /**
         * Creates a new UpdateBinComponentPreferencesRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @static
         * @param {pond.IUpdateBinComponentPreferencesRequest=} [properties] Properties to set
         * @returns {pond.UpdateBinComponentPreferencesRequest} UpdateBinComponentPreferencesRequest instance
         */
        UpdateBinComponentPreferencesRequest.create = function create(properties) {
            return new UpdateBinComponentPreferencesRequest(properties);
        };

        /**
         * Creates an UpdateBinComponentPreferencesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinComponentPreferencesRequest} UpdateBinComponentPreferencesRequest
         */
        UpdateBinComponentPreferencesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinComponentPreferencesRequest)
                return object;
            var message = new $root.pond.UpdateBinComponentPreferencesRequest();
            if (object.bin != null)
                message.bin = String(object.bin);
            if (object.component != null)
                message.component = String(object.component);
            if (object.preferences != null) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.UpdateBinComponentPreferencesRequest.preferences: object expected");
                message.preferences = $root.pond.BinComponentPreferences.fromObject(object.preferences);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateBinComponentPreferencesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @static
         * @param {pond.UpdateBinComponentPreferencesRequest} message UpdateBinComponentPreferencesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinComponentPreferencesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bin = "";
                object.component = "";
                object.preferences = null;
            }
            if (message.bin != null && message.hasOwnProperty("bin"))
                object.bin = message.bin;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = message.component;
            if (message.preferences != null && message.hasOwnProperty("preferences"))
                object.preferences = $root.pond.BinComponentPreferences.toObject(message.preferences, options);
            return object;
        };

        /**
         * Converts this UpdateBinComponentPreferencesRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinComponentPreferencesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinComponentPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinComponentPreferencesRequest;
    })();

    pond.UpdateBinComponentPreferencesResponse = (function() {

        /**
         * Properties of an UpdateBinComponentPreferencesResponse.
         * @memberof pond
         * @interface IUpdateBinComponentPreferencesResponse
         */

        /**
         * Constructs a new UpdateBinComponentPreferencesResponse.
         * @memberof pond
         * @classdesc Represents an UpdateBinComponentPreferencesResponse.
         * @implements IUpdateBinComponentPreferencesResponse
         * @constructor
         * @param {pond.IUpdateBinComponentPreferencesResponse=} [properties] Properties to set
         */
        function UpdateBinComponentPreferencesResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateBinComponentPreferencesResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBinComponentPreferencesResponse
         * @static
         * @param {pond.IUpdateBinComponentPreferencesResponse=} [properties] Properties to set
         * @returns {pond.UpdateBinComponentPreferencesResponse} UpdateBinComponentPreferencesResponse instance
         */
        UpdateBinComponentPreferencesResponse.create = function create(properties) {
            return new UpdateBinComponentPreferencesResponse(properties);
        };

        /**
         * Creates an UpdateBinComponentPreferencesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBinComponentPreferencesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBinComponentPreferencesResponse} UpdateBinComponentPreferencesResponse
         */
        UpdateBinComponentPreferencesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBinComponentPreferencesResponse)
                return object;
            return new $root.pond.UpdateBinComponentPreferencesResponse();
        };

        /**
         * Creates a plain object from an UpdateBinComponentPreferencesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBinComponentPreferencesResponse
         * @static
         * @param {pond.UpdateBinComponentPreferencesResponse} message UpdateBinComponentPreferencesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBinComponentPreferencesResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateBinComponentPreferencesResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateBinComponentPreferencesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBinComponentPreferencesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBinComponentPreferencesResponse;
    })();

    pond.GetUserObjectHistoriesRequest = (function() {

        /**
         * Properties of a GetUserObjectHistoriesRequest.
         * @memberof pond
         * @interface IGetUserObjectHistoriesRequest
         * @property {string|null} [userId] GetUserObjectHistoriesRequest userId
         * @property {Array.<pond.ObjectType>|null} [objectTypes] GetUserObjectHistoriesRequest objectTypes
         * @property {string|null} [start] GetUserObjectHistoriesRequest start
         * @property {string|null} [end] GetUserObjectHistoriesRequest end
         */

        /**
         * Constructs a new GetUserObjectHistoriesRequest.
         * @memberof pond
         * @classdesc Represents a GetUserObjectHistoriesRequest.
         * @implements IGetUserObjectHistoriesRequest
         * @constructor
         * @param {pond.IGetUserObjectHistoriesRequest=} [properties] Properties to set
         */
        function GetUserObjectHistoriesRequest(properties) {
            this.objectTypes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserObjectHistoriesRequest userId.
         * @member {string} userId
         * @memberof pond.GetUserObjectHistoriesRequest
         * @instance
         */
        GetUserObjectHistoriesRequest.prototype.userId = "";

        /**
         * GetUserObjectHistoriesRequest objectTypes.
         * @member {Array.<pond.ObjectType>} objectTypes
         * @memberof pond.GetUserObjectHistoriesRequest
         * @instance
         */
        GetUserObjectHistoriesRequest.prototype.objectTypes = $util.emptyArray;

        /**
         * GetUserObjectHistoriesRequest start.
         * @member {string} start
         * @memberof pond.GetUserObjectHistoriesRequest
         * @instance
         */
        GetUserObjectHistoriesRequest.prototype.start = "";

        /**
         * GetUserObjectHistoriesRequest end.
         * @member {string} end
         * @memberof pond.GetUserObjectHistoriesRequest
         * @instance
         */
        GetUserObjectHistoriesRequest.prototype.end = "";

        /**
         * Creates a new GetUserObjectHistoriesRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetUserObjectHistoriesRequest
         * @static
         * @param {pond.IGetUserObjectHistoriesRequest=} [properties] Properties to set
         * @returns {pond.GetUserObjectHistoriesRequest} GetUserObjectHistoriesRequest instance
         */
        GetUserObjectHistoriesRequest.create = function create(properties) {
            return new GetUserObjectHistoriesRequest(properties);
        };

        /**
         * Creates a GetUserObjectHistoriesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUserObjectHistoriesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUserObjectHistoriesRequest} GetUserObjectHistoriesRequest
         */
        GetUserObjectHistoriesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUserObjectHistoriesRequest)
                return object;
            var message = new $root.pond.GetUserObjectHistoriesRequest();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.objectTypes) {
                if (!Array.isArray(object.objectTypes))
                    throw TypeError(".pond.GetUserObjectHistoriesRequest.objectTypes: array expected");
                message.objectTypes = [];
                for (var i = 0; i < object.objectTypes.length; ++i)
                    switch (object.objectTypes[i]) {
                    default:
                    case "OBJECT_TYPE_UNKNOWN":
                    case 0:
                        message.objectTypes[i] = 0;
                        break;
                    case "OBJECT_TYPE_BIN":
                    case 1:
                        message.objectTypes[i] = 1;
                        break;
                    case "OBJECT_TYPE_SITE":
                    case 2:
                        message.objectTypes[i] = 2;
                        break;
                    case "OBJECT_TYPE_DEVICE":
                    case 3:
                        message.objectTypes[i] = 3;
                        break;
                    case "OBJECT_TYPE_COMPONENT":
                    case 4:
                        message.objectTypes[i] = 4;
                        break;
                    case "OBJECT_TYPE_INTERACTION":
                    case 5:
                        message.objectTypes[i] = 5;
                        break;
                    case "OBJECT_TYPE_NOTE":
                    case 6:
                        message.objectTypes[i] = 6;
                        break;
                    case "OBJECT_TYPE_FIELD":
                    case 7:
                        message.objectTypes[i] = 7;
                        break;
                    case "OBJECT_TYPE_FIELDMARKER":
                    case 8:
                        message.objectTypes[i] = 8;
                        break;
                    case "OBJECT_TYPE_HOMEMARKER":
                    case 9:
                        message.objectTypes[i] = 9;
                        break;
                    case "OBJECT_TYPE_HARVESTPLAN":
                    case 10:
                        message.objectTypes[i] = 10;
                        break;
                    case "OBJECT_TYPE_TASK":
                    case 11:
                        message.objectTypes[i] = 11;
                        break;
                    case "OBJECT_TYPE_MINE":
                    case 12:
                        message.objectTypes[i] = 12;
                        break;
                    case "OBJECT_TYPE_BINYARD":
                    case 13:
                        message.objectTypes[i] = 13;
                        break;
                    case "OBJECT_TYPE_TERMINAL":
                    case 14:
                        message.objectTypes[i] = 14;
                        break;
                    case "OBJECT_TYPE_GATE":
                    case 15:
                        message.objectTypes[i] = 15;
                        break;
                    case "OBJECT_TYPE_FIRMWARE":
                    case 16:
                        message.objectTypes[i] = 16;
                        break;
                    case "OBJECT_TYPE_GROUP":
                    case 17:
                        message.objectTypes[i] = 17;
                        break;
                    case "OBJECT_TYPE_UPGRADE":
                    case 18:
                        message.objectTypes[i] = 18;
                        break;
                    case "OBJECT_TYPE_USER":
                    case 19:
                        message.objectTypes[i] = 19;
                        break;
                    case "OBJECT_TYPE_BACKPACK":
                    case 20:
                        message.objectTypes[i] = 20;
                        break;
                    case "OBJECT_TYPE_HARVESTYEAR":
                    case 21:
                        message.objectTypes[i] = 21;
                        break;
                    case "OBJECT_TYPE_TAG":
                    case 22:
                        message.objectTypes[i] = 22;
                        break;
                    case "OBJECT_TYPE_TEAM":
                    case 23:
                        message.objectTypes[i] = 23;
                        break;
                    case "OBJECT_TYPE_LINK":
                    case 24:
                        message.objectTypes[i] = 24;
                        break;
                    case "OBJECT_TYPE_HEATER":
                    case 25:
                        message.objectTypes[i] = 25;
                        break;
                    case "OBJECT_TYPE_GRAIN_BAG":
                    case 26:
                        message.objectTypes[i] = 26;
                        break;
                    case "OBJECT_TYPE_CONTRACT":
                    case 27:
                        message.objectTypes[i] = 27;
                        break;
                    case "OBJECT_TYPE_TRANSACTION":
                    case 28:
                        message.objectTypes[i] = 28;
                        break;
                    case "OBJECT_TYPE_FILE":
                    case 29:
                        message.objectTypes[i] = 29;
                        break;
                    case "OBJECT_TYPE_NOTIFICATION_BANNER":
                    case 30:
                        message.objectTypes[i] = 30;
                        break;
                    case "OBJECT_TYPE_DEVICE_PRESET":
                    case 31:
                        message.objectTypes[i] = 31;
                        break;
                    }
            }
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from a GetUserObjectHistoriesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUserObjectHistoriesRequest
         * @static
         * @param {pond.GetUserObjectHistoriesRequest} message GetUserObjectHistoriesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserObjectHistoriesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.objectTypes = [];
            if (options.defaults) {
                object.userId = "";
                object.start = "";
                object.end = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.objectTypes && message.objectTypes.length) {
                object.objectTypes = [];
                for (var j = 0; j < message.objectTypes.length; ++j)
                    object.objectTypes[j] = options.enums === String ? $root.pond.ObjectType[message.objectTypes[j]] : message.objectTypes[j];
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this GetUserObjectHistoriesRequest to JSON.
         * @function toJSON
         * @memberof pond.GetUserObjectHistoriesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserObjectHistoriesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserObjectHistoriesRequest;
    })();

    pond.GetUserObjectHistoriesResponse = (function() {

        /**
         * Properties of a GetUserObjectHistoriesResponse.
         * @memberof pond
         * @interface IGetUserObjectHistoriesResponse
         * @property {Array.<pond.ObjectHistory>|null} [histories] GetUserObjectHistoriesResponse histories
         */

        /**
         * Constructs a new GetUserObjectHistoriesResponse.
         * @memberof pond
         * @classdesc Represents a GetUserObjectHistoriesResponse.
         * @implements IGetUserObjectHistoriesResponse
         * @constructor
         * @param {pond.IGetUserObjectHistoriesResponse=} [properties] Properties to set
         */
        function GetUserObjectHistoriesResponse(properties) {
            this.histories = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserObjectHistoriesResponse histories.
         * @member {Array.<pond.ObjectHistory>} histories
         * @memberof pond.GetUserObjectHistoriesResponse
         * @instance
         */
        GetUserObjectHistoriesResponse.prototype.histories = $util.emptyArray;

        /**
         * Creates a new GetUserObjectHistoriesResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetUserObjectHistoriesResponse
         * @static
         * @param {pond.IGetUserObjectHistoriesResponse=} [properties] Properties to set
         * @returns {pond.GetUserObjectHistoriesResponse} GetUserObjectHistoriesResponse instance
         */
        GetUserObjectHistoriesResponse.create = function create(properties) {
            return new GetUserObjectHistoriesResponse(properties);
        };

        /**
         * Creates a GetUserObjectHistoriesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetUserObjectHistoriesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetUserObjectHistoriesResponse} GetUserObjectHistoriesResponse
         */
        GetUserObjectHistoriesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetUserObjectHistoriesResponse)
                return object;
            var message = new $root.pond.GetUserObjectHistoriesResponse();
            if (object.histories) {
                if (!Array.isArray(object.histories))
                    throw TypeError(".pond.GetUserObjectHistoriesResponse.histories: array expected");
                message.histories = [];
                for (var i = 0; i < object.histories.length; ++i) {
                    if (typeof object.histories[i] !== "object")
                        throw TypeError(".pond.GetUserObjectHistoriesResponse.histories: object expected");
                    message.histories[i] = $root.pond.ObjectHistory.fromObject(object.histories[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUserObjectHistoriesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetUserObjectHistoriesResponse
         * @static
         * @param {pond.GetUserObjectHistoriesResponse} message GetUserObjectHistoriesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserObjectHistoriesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.histories = [];
            if (message.histories && message.histories.length) {
                object.histories = [];
                for (var j = 0; j < message.histories.length; ++j)
                    object.histories[j] = $root.pond.ObjectHistory.toObject(message.histories[j], options);
            }
            return object;
        };

        /**
         * Converts this GetUserObjectHistoriesResponse to JSON.
         * @function toJSON
         * @memberof pond.GetUserObjectHistoriesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserObjectHistoriesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUserObjectHistoriesResponse;
    })();

    pond.BackpackSettings = (function() {

        /**
         * Properties of a BackpackSettings.
         * @memberof pond
         * @interface IBackpackSettings
         * @property {number|null} [backpackId] BackpackSettings backpackId
         * @property {string|null} [name] BackpackSettings name
         * @property {pond.DeviceSettings|null} [device] BackpackSettings device
         * @property {Array.<pond.ComponentSettings>|null} [components] BackpackSettings components
         * @property {Array.<pond.InteractionSettings>|null} [interactions] BackpackSettings interactions
         * @property {Array.<string>|null} [tagKeys] BackpackSettings tagKeys
         * @property {pond.UserPreferences|null} [devicePreferences] BackpackSettings devicePreferences
         * @property {Object.<string,pond.UserPreferences>|null} [componentPreferences] BackpackSettings componentPreferences
         * @property {pond.DeviceProduct|null} [product] BackpackSettings product
         */

        /**
         * Constructs a new BackpackSettings.
         * @memberof pond
         * @classdesc Represents a BackpackSettings.
         * @implements IBackpackSettings
         * @constructor
         * @param {pond.IBackpackSettings=} [properties] Properties to set
         */
        function BackpackSettings(properties) {
            this.components = [];
            this.interactions = [];
            this.tagKeys = [];
            this.componentPreferences = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BackpackSettings backpackId.
         * @member {number} backpackId
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.backpackId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * BackpackSettings name.
         * @member {string} name
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.name = "";

        /**
         * BackpackSettings device.
         * @member {pond.DeviceSettings|null|undefined} device
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.device = null;

        /**
         * BackpackSettings components.
         * @member {Array.<pond.ComponentSettings>} components
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.components = $util.emptyArray;

        /**
         * BackpackSettings interactions.
         * @member {Array.<pond.InteractionSettings>} interactions
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.interactions = $util.emptyArray;

        /**
         * BackpackSettings tagKeys.
         * @member {Array.<string>} tagKeys
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.tagKeys = $util.emptyArray;

        /**
         * BackpackSettings devicePreferences.
         * @member {pond.UserPreferences|null|undefined} devicePreferences
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.devicePreferences = null;

        /**
         * BackpackSettings componentPreferences.
         * @member {Object.<string,pond.UserPreferences>} componentPreferences
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.componentPreferences = $util.emptyObject;

        /**
         * BackpackSettings product.
         * @member {pond.DeviceProduct} product
         * @memberof pond.BackpackSettings
         * @instance
         */
        BackpackSettings.prototype.product = 0;

        /**
         * Creates a new BackpackSettings instance using the specified properties.
         * @function create
         * @memberof pond.BackpackSettings
         * @static
         * @param {pond.IBackpackSettings=} [properties] Properties to set
         * @returns {pond.BackpackSettings} BackpackSettings instance
         */
        BackpackSettings.create = function create(properties) {
            return new BackpackSettings(properties);
        };

        /**
         * Creates a BackpackSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BackpackSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BackpackSettings} BackpackSettings
         */
        BackpackSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BackpackSettings)
                return object;
            var message = new $root.pond.BackpackSettings();
            if (object.backpackId != null)
                if ($util.Long)
                    (message.backpackId = $util.Long.fromValue(object.backpackId)).unsigned = true;
                else if (typeof object.backpackId === "string")
                    message.backpackId = parseInt(object.backpackId, 10);
                else if (typeof object.backpackId === "number")
                    message.backpackId = object.backpackId;
                else if (typeof object.backpackId === "object")
                    message.backpackId = new $util.LongBits(object.backpackId.low >>> 0, object.backpackId.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".pond.BackpackSettings.device: object expected");
                message.device = $root.pond.DeviceSettings.fromObject(object.device);
            }
            if (object.components) {
                if (!Array.isArray(object.components))
                    throw TypeError(".pond.BackpackSettings.components: array expected");
                message.components = [];
                for (var i = 0; i < object.components.length; ++i) {
                    if (typeof object.components[i] !== "object")
                        throw TypeError(".pond.BackpackSettings.components: object expected");
                    message.components[i] = $root.pond.ComponentSettings.fromObject(object.components[i]);
                }
            }
            if (object.interactions) {
                if (!Array.isArray(object.interactions))
                    throw TypeError(".pond.BackpackSettings.interactions: array expected");
                message.interactions = [];
                for (var i = 0; i < object.interactions.length; ++i) {
                    if (typeof object.interactions[i] !== "object")
                        throw TypeError(".pond.BackpackSettings.interactions: object expected");
                    message.interactions[i] = $root.pond.InteractionSettings.fromObject(object.interactions[i]);
                }
            }
            if (object.tagKeys) {
                if (!Array.isArray(object.tagKeys))
                    throw TypeError(".pond.BackpackSettings.tagKeys: array expected");
                message.tagKeys = [];
                for (var i = 0; i < object.tagKeys.length; ++i)
                    message.tagKeys[i] = String(object.tagKeys[i]);
            }
            if (object.devicePreferences != null) {
                if (typeof object.devicePreferences !== "object")
                    throw TypeError(".pond.BackpackSettings.devicePreferences: object expected");
                message.devicePreferences = $root.pond.UserPreferences.fromObject(object.devicePreferences);
            }
            if (object.componentPreferences) {
                if (typeof object.componentPreferences !== "object")
                    throw TypeError(".pond.BackpackSettings.componentPreferences: object expected");
                message.componentPreferences = {};
                for (var keys = Object.keys(object.componentPreferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.componentPreferences[keys[i]] !== "object")
                        throw TypeError(".pond.BackpackSettings.componentPreferences: object expected");
                    message.componentPreferences[keys[i]] = $root.pond.UserPreferences.fromObject(object.componentPreferences[keys[i]]);
                }
            }
            switch (object.product) {
            case "DEVICE_PRODUCT_NONE":
            case 0:
                message.product = 0;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS":
            case 1:
                message.product = 1;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_PRO":
            case 2:
                message.product = 2;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_LITE":
            case 3:
                message.product = 3;
                break;
            case "DEVICE_PRODUCT_BINDAPT_MINI":
            case 4:
                message.product = 4;
                break;
            case "DEVICE_PRODUCT_WEATHER_STATION":
            case 5:
                message.product = 5;
                break;
            case "DEVICE_PRODUCT_NEXUS_ST":
            case 6:
                message.product = 6;
                break;
            case "DEVICE_PRODUCT_OMNIAIR":
            case 7:
                message.product = 7;
                break;
            case "DEVICE_PRODUCT_BIN_MONITOR":
            case 8:
                message.product = 8;
                break;
            case "DEVICE_PRODUCT_BIN_HALO":
            case 9:
                message.product = 9;
                break;
            case "DEVICE_PRODUCT_BIN_ULTIMATE":
            case 10:
                message.product = 10;
                break;
            case "DEVICE_PRODUCT_MIPCA_V2":
            case 11:
                message.product = 11;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_MOD":
            case 12:
                message.product = 12;
                break;
            case "DEVICE_PRODUCT_BINDAPT_PLUS_PRO_MOD":
            case 13:
                message.product = 13;
                break;
            case "DEVICE_PRODUCT_BINDAPT_V2_MONITOR":
            case 14:
                message.product = 14;
                break;
            case "DEVICE_PRODUCT_BINDAPT_V2_AUTOMATE":
            case 15:
                message.product = 15;
                break;
            case "DEVICE_PRODUCT_MIVENT":
            case 16:
                message.product = 16;
                break;
            case "DEVICE_PRODUCT_MIVENT_V2":
            case 17:
                message.product = 17;
                break;
            case "DEVICE_PRODUCT_STREAMLINE_MONITOR":
            case 18:
                message.product = 18;
                break;
            case "DEVICE_PRODUCT_STREAMLINE_AUTOMATE":
            case 19:
                message.product = 19;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a BackpackSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BackpackSettings
         * @static
         * @param {pond.BackpackSettings} message BackpackSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BackpackSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.components = [];
                object.interactions = [];
                object.tagKeys = [];
            }
            if (options.objects || options.defaults)
                object.componentPreferences = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.backpackId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.backpackId = options.longs === String ? "0" : 0;
                object.name = "";
                object.device = null;
                object.devicePreferences = null;
                object.product = options.enums === String ? "DEVICE_PRODUCT_NONE" : 0;
            }
            if (message.backpackId != null && message.hasOwnProperty("backpackId"))
                if (typeof message.backpackId === "number")
                    object.backpackId = options.longs === String ? String(message.backpackId) : message.backpackId;
                else
                    object.backpackId = options.longs === String ? $util.Long.prototype.toString.call(message.backpackId) : options.longs === Number ? new $util.LongBits(message.backpackId.low >>> 0, message.backpackId.high >>> 0).toNumber(true) : message.backpackId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.pond.DeviceSettings.toObject(message.device, options);
            if (message.components && message.components.length) {
                object.components = [];
                for (var j = 0; j < message.components.length; ++j)
                    object.components[j] = $root.pond.ComponentSettings.toObject(message.components[j], options);
            }
            if (message.interactions && message.interactions.length) {
                object.interactions = [];
                for (var j = 0; j < message.interactions.length; ++j)
                    object.interactions[j] = $root.pond.InteractionSettings.toObject(message.interactions[j], options);
            }
            if (message.tagKeys && message.tagKeys.length) {
                object.tagKeys = [];
                for (var j = 0; j < message.tagKeys.length; ++j)
                    object.tagKeys[j] = message.tagKeys[j];
            }
            if (message.devicePreferences != null && message.hasOwnProperty("devicePreferences"))
                object.devicePreferences = $root.pond.UserPreferences.toObject(message.devicePreferences, options);
            var keys2;
            if (message.componentPreferences && (keys2 = Object.keys(message.componentPreferences)).length) {
                object.componentPreferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.componentPreferences[keys2[j]] = $root.pond.UserPreferences.toObject(message.componentPreferences[keys2[j]], options);
            }
            if (message.product != null && message.hasOwnProperty("product"))
                object.product = options.enums === String ? $root.pond.DeviceProduct[message.product] : message.product;
            return object;
        };

        /**
         * Converts this BackpackSettings to JSON.
         * @function toJSON
         * @memberof pond.BackpackSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BackpackSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BackpackSettings;
    })();

    pond.GetBackpackRequest = (function() {

        /**
         * Properties of a GetBackpackRequest.
         * @memberof pond
         * @interface IGetBackpackRequest
         * @property {number|null} [backpack] GetBackpackRequest backpack
         */

        /**
         * Constructs a new GetBackpackRequest.
         * @memberof pond
         * @classdesc Represents a GetBackpackRequest.
         * @implements IGetBackpackRequest
         * @constructor
         * @param {pond.IGetBackpackRequest=} [properties] Properties to set
         */
        function GetBackpackRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetBackpackRequest backpack.
         * @member {number} backpack
         * @memberof pond.GetBackpackRequest
         * @instance
         */
        GetBackpackRequest.prototype.backpack = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetBackpackRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetBackpackRequest
         * @static
         * @param {pond.IGetBackpackRequest=} [properties] Properties to set
         * @returns {pond.GetBackpackRequest} GetBackpackRequest instance
         */
        GetBackpackRequest.create = function create(properties) {
            return new GetBackpackRequest(properties);
        };

        /**
         * Creates a GetBackpackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetBackpackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetBackpackRequest} GetBackpackRequest
         */
        GetBackpackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetBackpackRequest)
                return object;
            var message = new $root.pond.GetBackpackRequest();
            if (object.backpack != null)
                if ($util.Long)
                    (message.backpack = $util.Long.fromValue(object.backpack)).unsigned = true;
                else if (typeof object.backpack === "string")
                    message.backpack = parseInt(object.backpack, 10);
                else if (typeof object.backpack === "number")
                    message.backpack = object.backpack;
                else if (typeof object.backpack === "object")
                    message.backpack = new $util.LongBits(object.backpack.low >>> 0, object.backpack.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetBackpackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetBackpackRequest
         * @static
         * @param {pond.GetBackpackRequest} message GetBackpackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetBackpackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.backpack = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.backpack = options.longs === String ? "0" : 0;
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                if (typeof message.backpack === "number")
                    object.backpack = options.longs === String ? String(message.backpack) : message.backpack;
                else
                    object.backpack = options.longs === String ? $util.Long.prototype.toString.call(message.backpack) : options.longs === Number ? new $util.LongBits(message.backpack.low >>> 0, message.backpack.high >>> 0).toNumber(true) : message.backpack;
            return object;
        };

        /**
         * Converts this GetBackpackRequest to JSON.
         * @function toJSON
         * @memberof pond.GetBackpackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetBackpackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetBackpackRequest;
    })();

    pond.Backpack = (function() {

        /**
         * Properties of a Backpack.
         * @memberof pond
         * @interface IBackpack
         * @property {pond.BackpackSettings|null} [settings] Backpack settings
         */

        /**
         * Constructs a new Backpack.
         * @memberof pond
         * @classdesc Represents a Backpack.
         * @implements IBackpack
         * @constructor
         * @param {pond.IBackpack=} [properties] Properties to set
         */
        function Backpack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Backpack settings.
         * @member {pond.BackpackSettings|null|undefined} settings
         * @memberof pond.Backpack
         * @instance
         */
        Backpack.prototype.settings = null;

        /**
         * Creates a new Backpack instance using the specified properties.
         * @function create
         * @memberof pond.Backpack
         * @static
         * @param {pond.IBackpack=} [properties] Properties to set
         * @returns {pond.Backpack} Backpack instance
         */
        Backpack.create = function create(properties) {
            return new Backpack(properties);
        };

        /**
         * Creates a Backpack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Backpack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Backpack} Backpack
         */
        Backpack.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Backpack)
                return object;
            var message = new $root.pond.Backpack();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Backpack.settings: object expected");
                message.settings = $root.pond.BackpackSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Backpack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Backpack
         * @static
         * @param {pond.Backpack} message Backpack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Backpack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.BackpackSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this Backpack to JSON.
         * @function toJSON
         * @memberof pond.Backpack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Backpack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Backpack;
    })();

    pond.ListBackpacksRequest = (function() {

        /**
         * Properties of a ListBackpacksRequest.
         * @memberof pond
         * @interface IListBackpacksRequest
         */

        /**
         * Constructs a new ListBackpacksRequest.
         * @memberof pond
         * @classdesc Represents a ListBackpacksRequest.
         * @implements IListBackpacksRequest
         * @constructor
         * @param {pond.IListBackpacksRequest=} [properties] Properties to set
         */
        function ListBackpacksRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListBackpacksRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListBackpacksRequest
         * @static
         * @param {pond.IListBackpacksRequest=} [properties] Properties to set
         * @returns {pond.ListBackpacksRequest} ListBackpacksRequest instance
         */
        ListBackpacksRequest.create = function create(properties) {
            return new ListBackpacksRequest(properties);
        };

        /**
         * Creates a ListBackpacksRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBackpacksRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBackpacksRequest} ListBackpacksRequest
         */
        ListBackpacksRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBackpacksRequest)
                return object;
            return new $root.pond.ListBackpacksRequest();
        };

        /**
         * Creates a plain object from a ListBackpacksRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBackpacksRequest
         * @static
         * @param {pond.ListBackpacksRequest} message ListBackpacksRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBackpacksRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListBackpacksRequest to JSON.
         * @function toJSON
         * @memberof pond.ListBackpacksRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBackpacksRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBackpacksRequest;
    })();

    pond.ListBackpacksResponse = (function() {

        /**
         * Properties of a ListBackpacksResponse.
         * @memberof pond
         * @interface IListBackpacksResponse
         * @property {Array.<pond.Backpack>|null} [backpacks] ListBackpacksResponse backpacks
         */

        /**
         * Constructs a new ListBackpacksResponse.
         * @memberof pond
         * @classdesc Represents a ListBackpacksResponse.
         * @implements IListBackpacksResponse
         * @constructor
         * @param {pond.IListBackpacksResponse=} [properties] Properties to set
         */
        function ListBackpacksResponse(properties) {
            this.backpacks = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListBackpacksResponse backpacks.
         * @member {Array.<pond.Backpack>} backpacks
         * @memberof pond.ListBackpacksResponse
         * @instance
         */
        ListBackpacksResponse.prototype.backpacks = $util.emptyArray;

        /**
         * Creates a new ListBackpacksResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListBackpacksResponse
         * @static
         * @param {pond.IListBackpacksResponse=} [properties] Properties to set
         * @returns {pond.ListBackpacksResponse} ListBackpacksResponse instance
         */
        ListBackpacksResponse.create = function create(properties) {
            return new ListBackpacksResponse(properties);
        };

        /**
         * Creates a ListBackpacksResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListBackpacksResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListBackpacksResponse} ListBackpacksResponse
         */
        ListBackpacksResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListBackpacksResponse)
                return object;
            var message = new $root.pond.ListBackpacksResponse();
            if (object.backpacks) {
                if (!Array.isArray(object.backpacks))
                    throw TypeError(".pond.ListBackpacksResponse.backpacks: array expected");
                message.backpacks = [];
                for (var i = 0; i < object.backpacks.length; ++i) {
                    if (typeof object.backpacks[i] !== "object")
                        throw TypeError(".pond.ListBackpacksResponse.backpacks: object expected");
                    message.backpacks[i] = $root.pond.Backpack.fromObject(object.backpacks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListBackpacksResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListBackpacksResponse
         * @static
         * @param {pond.ListBackpacksResponse} message ListBackpacksResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListBackpacksResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.backpacks = [];
            if (message.backpacks && message.backpacks.length) {
                object.backpacks = [];
                for (var j = 0; j < message.backpacks.length; ++j)
                    object.backpacks[j] = $root.pond.Backpack.toObject(message.backpacks[j], options);
            }
            return object;
        };

        /**
         * Converts this ListBackpacksResponse to JSON.
         * @function toJSON
         * @memberof pond.ListBackpacksResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListBackpacksResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListBackpacksResponse;
    })();

    pond.AddBackpackRequest = (function() {

        /**
         * Properties of an AddBackpackRequest.
         * @memberof pond
         * @interface IAddBackpackRequest
         * @property {pond.BackpackSettings|null} [backpack] AddBackpackRequest backpack
         */

        /**
         * Constructs a new AddBackpackRequest.
         * @memberof pond
         * @classdesc Represents an AddBackpackRequest.
         * @implements IAddBackpackRequest
         * @constructor
         * @param {pond.IAddBackpackRequest=} [properties] Properties to set
         */
        function AddBackpackRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBackpackRequest backpack.
         * @member {pond.BackpackSettings|null|undefined} backpack
         * @memberof pond.AddBackpackRequest
         * @instance
         */
        AddBackpackRequest.prototype.backpack = null;

        /**
         * Creates a new AddBackpackRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddBackpackRequest
         * @static
         * @param {pond.IAddBackpackRequest=} [properties] Properties to set
         * @returns {pond.AddBackpackRequest} AddBackpackRequest instance
         */
        AddBackpackRequest.create = function create(properties) {
            return new AddBackpackRequest(properties);
        };

        /**
         * Creates an AddBackpackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBackpackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBackpackRequest} AddBackpackRequest
         */
        AddBackpackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBackpackRequest)
                return object;
            var message = new $root.pond.AddBackpackRequest();
            if (object.backpack != null) {
                if (typeof object.backpack !== "object")
                    throw TypeError(".pond.AddBackpackRequest.backpack: object expected");
                message.backpack = $root.pond.BackpackSettings.fromObject(object.backpack);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddBackpackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBackpackRequest
         * @static
         * @param {pond.AddBackpackRequest} message AddBackpackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBackpackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.backpack = null;
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                object.backpack = $root.pond.BackpackSettings.toObject(message.backpack, options);
            return object;
        };

        /**
         * Converts this AddBackpackRequest to JSON.
         * @function toJSON
         * @memberof pond.AddBackpackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBackpackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBackpackRequest;
    })();

    pond.AddBackpackResponse = (function() {

        /**
         * Properties of an AddBackpackResponse.
         * @memberof pond
         * @interface IAddBackpackResponse
         * @property {number|null} [id] AddBackpackResponse id
         */

        /**
         * Constructs a new AddBackpackResponse.
         * @memberof pond
         * @classdesc Represents an AddBackpackResponse.
         * @implements IAddBackpackResponse
         * @constructor
         * @param {pond.IAddBackpackResponse=} [properties] Properties to set
         */
        function AddBackpackResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddBackpackResponse id.
         * @member {number} id
         * @memberof pond.AddBackpackResponse
         * @instance
         */
        AddBackpackResponse.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new AddBackpackResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddBackpackResponse
         * @static
         * @param {pond.IAddBackpackResponse=} [properties] Properties to set
         * @returns {pond.AddBackpackResponse} AddBackpackResponse instance
         */
        AddBackpackResponse.create = function create(properties) {
            return new AddBackpackResponse(properties);
        };

        /**
         * Creates an AddBackpackResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddBackpackResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddBackpackResponse} AddBackpackResponse
         */
        AddBackpackResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddBackpackResponse)
                return object;
            var message = new $root.pond.AddBackpackResponse();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an AddBackpackResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddBackpackResponse
         * @static
         * @param {pond.AddBackpackResponse} message AddBackpackResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddBackpackResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            return object;
        };

        /**
         * Converts this AddBackpackResponse to JSON.
         * @function toJSON
         * @memberof pond.AddBackpackResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddBackpackResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddBackpackResponse;
    })();

    pond.UpdateBackpackRequest = (function() {

        /**
         * Properties of an UpdateBackpackRequest.
         * @memberof pond
         * @interface IUpdateBackpackRequest
         * @property {pond.BackpackSettings|null} [backpack] UpdateBackpackRequest backpack
         */

        /**
         * Constructs a new UpdateBackpackRequest.
         * @memberof pond
         * @classdesc Represents an UpdateBackpackRequest.
         * @implements IUpdateBackpackRequest
         * @constructor
         * @param {pond.IUpdateBackpackRequest=} [properties] Properties to set
         */
        function UpdateBackpackRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateBackpackRequest backpack.
         * @member {pond.BackpackSettings|null|undefined} backpack
         * @memberof pond.UpdateBackpackRequest
         * @instance
         */
        UpdateBackpackRequest.prototype.backpack = null;

        /**
         * Creates a new UpdateBackpackRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBackpackRequest
         * @static
         * @param {pond.IUpdateBackpackRequest=} [properties] Properties to set
         * @returns {pond.UpdateBackpackRequest} UpdateBackpackRequest instance
         */
        UpdateBackpackRequest.create = function create(properties) {
            return new UpdateBackpackRequest(properties);
        };

        /**
         * Creates an UpdateBackpackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBackpackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBackpackRequest} UpdateBackpackRequest
         */
        UpdateBackpackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBackpackRequest)
                return object;
            var message = new $root.pond.UpdateBackpackRequest();
            if (object.backpack != null) {
                if (typeof object.backpack !== "object")
                    throw TypeError(".pond.UpdateBackpackRequest.backpack: object expected");
                message.backpack = $root.pond.BackpackSettings.fromObject(object.backpack);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateBackpackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBackpackRequest
         * @static
         * @param {pond.UpdateBackpackRequest} message UpdateBackpackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBackpackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.backpack = null;
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                object.backpack = $root.pond.BackpackSettings.toObject(message.backpack, options);
            return object;
        };

        /**
         * Converts this UpdateBackpackRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateBackpackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBackpackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBackpackRequest;
    })();

    pond.UpdateBackpackResponse = (function() {

        /**
         * Properties of an UpdateBackpackResponse.
         * @memberof pond
         * @interface IUpdateBackpackResponse
         */

        /**
         * Constructs a new UpdateBackpackResponse.
         * @memberof pond
         * @classdesc Represents an UpdateBackpackResponse.
         * @implements IUpdateBackpackResponse
         * @constructor
         * @param {pond.IUpdateBackpackResponse=} [properties] Properties to set
         */
        function UpdateBackpackResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateBackpackResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateBackpackResponse
         * @static
         * @param {pond.IUpdateBackpackResponse=} [properties] Properties to set
         * @returns {pond.UpdateBackpackResponse} UpdateBackpackResponse instance
         */
        UpdateBackpackResponse.create = function create(properties) {
            return new UpdateBackpackResponse(properties);
        };

        /**
         * Creates an UpdateBackpackResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateBackpackResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateBackpackResponse} UpdateBackpackResponse
         */
        UpdateBackpackResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateBackpackResponse)
                return object;
            return new $root.pond.UpdateBackpackResponse();
        };

        /**
         * Creates a plain object from an UpdateBackpackResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateBackpackResponse
         * @static
         * @param {pond.UpdateBackpackResponse} message UpdateBackpackResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateBackpackResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateBackpackResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateBackpackResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateBackpackResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateBackpackResponse;
    })();

    pond.RemoveBackpackRequest = (function() {

        /**
         * Properties of a RemoveBackpackRequest.
         * @memberof pond
         * @interface IRemoveBackpackRequest
         * @property {number|null} [backpack] RemoveBackpackRequest backpack
         */

        /**
         * Constructs a new RemoveBackpackRequest.
         * @memberof pond
         * @classdesc Represents a RemoveBackpackRequest.
         * @implements IRemoveBackpackRequest
         * @constructor
         * @param {pond.IRemoveBackpackRequest=} [properties] Properties to set
         */
        function RemoveBackpackRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveBackpackRequest backpack.
         * @member {number} backpack
         * @memberof pond.RemoveBackpackRequest
         * @instance
         */
        RemoveBackpackRequest.prototype.backpack = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new RemoveBackpackRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBackpackRequest
         * @static
         * @param {pond.IRemoveBackpackRequest=} [properties] Properties to set
         * @returns {pond.RemoveBackpackRequest} RemoveBackpackRequest instance
         */
        RemoveBackpackRequest.create = function create(properties) {
            return new RemoveBackpackRequest(properties);
        };

        /**
         * Creates a RemoveBackpackRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBackpackRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBackpackRequest} RemoveBackpackRequest
         */
        RemoveBackpackRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBackpackRequest)
                return object;
            var message = new $root.pond.RemoveBackpackRequest();
            if (object.backpack != null)
                if ($util.Long)
                    (message.backpack = $util.Long.fromValue(object.backpack)).unsigned = true;
                else if (typeof object.backpack === "string")
                    message.backpack = parseInt(object.backpack, 10);
                else if (typeof object.backpack === "number")
                    message.backpack = object.backpack;
                else if (typeof object.backpack === "object")
                    message.backpack = new $util.LongBits(object.backpack.low >>> 0, object.backpack.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a RemoveBackpackRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBackpackRequest
         * @static
         * @param {pond.RemoveBackpackRequest} message RemoveBackpackRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBackpackRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.backpack = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.backpack = options.longs === String ? "0" : 0;
            if (message.backpack != null && message.hasOwnProperty("backpack"))
                if (typeof message.backpack === "number")
                    object.backpack = options.longs === String ? String(message.backpack) : message.backpack;
                else
                    object.backpack = options.longs === String ? $util.Long.prototype.toString.call(message.backpack) : options.longs === Number ? new $util.LongBits(message.backpack.low >>> 0, message.backpack.high >>> 0).toNumber(true) : message.backpack;
            return object;
        };

        /**
         * Converts this RemoveBackpackRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveBackpackRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBackpackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBackpackRequest;
    })();

    pond.RemoveBackpackResponse = (function() {

        /**
         * Properties of a RemoveBackpackResponse.
         * @memberof pond
         * @interface IRemoveBackpackResponse
         */

        /**
         * Constructs a new RemoveBackpackResponse.
         * @memberof pond
         * @classdesc Represents a RemoveBackpackResponse.
         * @implements IRemoveBackpackResponse
         * @constructor
         * @param {pond.IRemoveBackpackResponse=} [properties] Properties to set
         */
        function RemoveBackpackResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveBackpackResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveBackpackResponse
         * @static
         * @param {pond.IRemoveBackpackResponse=} [properties] Properties to set
         * @returns {pond.RemoveBackpackResponse} RemoveBackpackResponse instance
         */
        RemoveBackpackResponse.create = function create(properties) {
            return new RemoveBackpackResponse(properties);
        };

        /**
         * Creates a RemoveBackpackResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveBackpackResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveBackpackResponse} RemoveBackpackResponse
         */
        RemoveBackpackResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveBackpackResponse)
                return object;
            return new $root.pond.RemoveBackpackResponse();
        };

        /**
         * Creates a plain object from a RemoveBackpackResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveBackpackResponse
         * @static
         * @param {pond.RemoveBackpackResponse} message RemoveBackpackResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveBackpackResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveBackpackResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveBackpackResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveBackpackResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveBackpackResponse;
    })();

    pond.TagSettings = (function() {

        /**
         * Properties of a TagSettings.
         * @memberof pond
         * @interface ITagSettings
         * @property {string|null} [key] TagSettings key
         * @property {string|null} [name] TagSettings name
         * @property {string|null} [colour] TagSettings colour
         */

        /**
         * Constructs a new TagSettings.
         * @memberof pond
         * @classdesc Represents a TagSettings.
         * @implements ITagSettings
         * @constructor
         * @param {pond.ITagSettings=} [properties] Properties to set
         */
        function TagSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TagSettings key.
         * @member {string} key
         * @memberof pond.TagSettings
         * @instance
         */
        TagSettings.prototype.key = "";

        /**
         * TagSettings name.
         * @member {string} name
         * @memberof pond.TagSettings
         * @instance
         */
        TagSettings.prototype.name = "";

        /**
         * TagSettings colour.
         * @member {string} colour
         * @memberof pond.TagSettings
         * @instance
         */
        TagSettings.prototype.colour = "";

        /**
         * Creates a new TagSettings instance using the specified properties.
         * @function create
         * @memberof pond.TagSettings
         * @static
         * @param {pond.ITagSettings=} [properties] Properties to set
         * @returns {pond.TagSettings} TagSettings instance
         */
        TagSettings.create = function create(properties) {
            return new TagSettings(properties);
        };

        /**
         * Creates a TagSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TagSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TagSettings} TagSettings
         */
        TagSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TagSettings)
                return object;
            var message = new $root.pond.TagSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.colour != null)
                message.colour = String(object.colour);
            return message;
        };

        /**
         * Creates a plain object from a TagSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TagSettings
         * @static
         * @param {pond.TagSettings} message TagSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TagSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.colour = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            return object;
        };

        /**
         * Converts this TagSettings to JSON.
         * @function toJSON
         * @memberof pond.TagSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TagSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TagSettings;
    })();

    pond.GetTagRequest = (function() {

        /**
         * Properties of a GetTagRequest.
         * @memberof pond
         * @interface IGetTagRequest
         * @property {string|null} [tag] GetTagRequest tag
         */

        /**
         * Constructs a new GetTagRequest.
         * @memberof pond
         * @classdesc Represents a GetTagRequest.
         * @implements IGetTagRequest
         * @constructor
         * @param {pond.IGetTagRequest=} [properties] Properties to set
         */
        function GetTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTagRequest tag.
         * @member {string} tag
         * @memberof pond.GetTagRequest
         * @instance
         */
        GetTagRequest.prototype.tag = "";

        /**
         * Creates a new GetTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTagRequest
         * @static
         * @param {pond.IGetTagRequest=} [properties] Properties to set
         * @returns {pond.GetTagRequest} GetTagRequest instance
         */
        GetTagRequest.create = function create(properties) {
            return new GetTagRequest(properties);
        };

        /**
         * Creates a GetTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTagRequest} GetTagRequest
         */
        GetTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTagRequest)
                return object;
            var message = new $root.pond.GetTagRequest();
            if (object.tag != null)
                message.tag = String(object.tag);
            return message;
        };

        /**
         * Creates a plain object from a GetTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTagRequest
         * @static
         * @param {pond.GetTagRequest} message GetTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.tag = "";
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = message.tag;
            return object;
        };

        /**
         * Converts this GetTagRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTagRequest;
    })();

    pond.Tag = (function() {

        /**
         * Properties of a Tag.
         * @memberof pond
         * @interface ITag
         * @property {pond.TagSettings|null} [settings] Tag settings
         */

        /**
         * Constructs a new Tag.
         * @memberof pond
         * @classdesc Represents a Tag.
         * @implements ITag
         * @constructor
         * @param {pond.ITag=} [properties] Properties to set
         */
        function Tag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Tag settings.
         * @member {pond.TagSettings|null|undefined} settings
         * @memberof pond.Tag
         * @instance
         */
        Tag.prototype.settings = null;

        /**
         * Creates a new Tag instance using the specified properties.
         * @function create
         * @memberof pond.Tag
         * @static
         * @param {pond.ITag=} [properties] Properties to set
         * @returns {pond.Tag} Tag instance
         */
        Tag.create = function create(properties) {
            return new Tag(properties);
        };

        /**
         * Creates a Tag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Tag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Tag} Tag
         */
        Tag.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Tag)
                return object;
            var message = new $root.pond.Tag();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Tag.settings: object expected");
                message.settings = $root.pond.TagSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Tag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Tag
         * @static
         * @param {pond.Tag} message Tag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Tag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TagSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this Tag to JSON.
         * @function toJSON
         * @memberof pond.Tag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Tag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Tag;
    })();

    pond.GetTagsRequest = (function() {

        /**
         * Properties of a GetTagsRequest.
         * @memberof pond
         * @interface IGetTagsRequest
         * @property {Array.<string>|null} [tags] GetTagsRequest tags
         */

        /**
         * Constructs a new GetTagsRequest.
         * @memberof pond
         * @classdesc Represents a GetTagsRequest.
         * @implements IGetTagsRequest
         * @constructor
         * @param {pond.IGetTagsRequest=} [properties] Properties to set
         */
        function GetTagsRequest(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTagsRequest tags.
         * @member {Array.<string>} tags
         * @memberof pond.GetTagsRequest
         * @instance
         */
        GetTagsRequest.prototype.tags = $util.emptyArray;

        /**
         * Creates a new GetTagsRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTagsRequest
         * @static
         * @param {pond.IGetTagsRequest=} [properties] Properties to set
         * @returns {pond.GetTagsRequest} GetTagsRequest instance
         */
        GetTagsRequest.create = function create(properties) {
            return new GetTagsRequest(properties);
        };

        /**
         * Creates a GetTagsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTagsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTagsRequest} GetTagsRequest
         */
        GetTagsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTagsRequest)
                return object;
            var message = new $root.pond.GetTagsRequest();
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.GetTagsRequest.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetTagsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTagsRequest
         * @static
         * @param {pond.GetTagsRequest} message GetTagsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTagsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            return object;
        };

        /**
         * Converts this GetTagsRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTagsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTagsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTagsRequest;
    })();

    pond.GetTagsResponse = (function() {

        /**
         * Properties of a GetTagsResponse.
         * @memberof pond
         * @interface IGetTagsResponse
         * @property {Array.<pond.Tag>|null} [tags] GetTagsResponse tags
         */

        /**
         * Constructs a new GetTagsResponse.
         * @memberof pond
         * @classdesc Represents a GetTagsResponse.
         * @implements IGetTagsResponse
         * @constructor
         * @param {pond.IGetTagsResponse=} [properties] Properties to set
         */
        function GetTagsResponse(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTagsResponse tags.
         * @member {Array.<pond.Tag>} tags
         * @memberof pond.GetTagsResponse
         * @instance
         */
        GetTagsResponse.prototype.tags = $util.emptyArray;

        /**
         * Creates a new GetTagsResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetTagsResponse
         * @static
         * @param {pond.IGetTagsResponse=} [properties] Properties to set
         * @returns {pond.GetTagsResponse} GetTagsResponse instance
         */
        GetTagsResponse.create = function create(properties) {
            return new GetTagsResponse(properties);
        };

        /**
         * Creates a GetTagsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTagsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTagsResponse} GetTagsResponse
         */
        GetTagsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTagsResponse)
                return object;
            var message = new $root.pond.GetTagsResponse();
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.GetTagsResponse.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i) {
                    if (typeof object.tags[i] !== "object")
                        throw TypeError(".pond.GetTagsResponse.tags: object expected");
                    message.tags[i] = $root.pond.Tag.fromObject(object.tags[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetTagsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTagsResponse
         * @static
         * @param {pond.GetTagsResponse} message GetTagsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTagsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = $root.pond.Tag.toObject(message.tags[j], options);
            }
            return object;
        };

        /**
         * Converts this GetTagsResponse to JSON.
         * @function toJSON
         * @memberof pond.GetTagsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTagsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTagsResponse;
    })();

    pond.ListTagsRequest = (function() {

        /**
         * Properties of a ListTagsRequest.
         * @memberof pond
         * @interface IListTagsRequest
         */

        /**
         * Constructs a new ListTagsRequest.
         * @memberof pond
         * @classdesc Represents a ListTagsRequest.
         * @implements IListTagsRequest
         * @constructor
         * @param {pond.IListTagsRequest=} [properties] Properties to set
         */
        function ListTagsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListTagsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListTagsRequest
         * @static
         * @param {pond.IListTagsRequest=} [properties] Properties to set
         * @returns {pond.ListTagsRequest} ListTagsRequest instance
         */
        ListTagsRequest.create = function create(properties) {
            return new ListTagsRequest(properties);
        };

        /**
         * Creates a ListTagsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTagsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTagsRequest} ListTagsRequest
         */
        ListTagsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTagsRequest)
                return object;
            return new $root.pond.ListTagsRequest();
        };

        /**
         * Creates a plain object from a ListTagsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTagsRequest
         * @static
         * @param {pond.ListTagsRequest} message ListTagsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTagsRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListTagsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListTagsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTagsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTagsRequest;
    })();

    pond.ListTagsResponse = (function() {

        /**
         * Properties of a ListTagsResponse.
         * @memberof pond
         * @interface IListTagsResponse
         * @property {Array.<pond.Tag>|null} [tags] ListTagsResponse tags
         */

        /**
         * Constructs a new ListTagsResponse.
         * @memberof pond
         * @classdesc Represents a ListTagsResponse.
         * @implements IListTagsResponse
         * @constructor
         * @param {pond.IListTagsResponse=} [properties] Properties to set
         */
        function ListTagsResponse(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTagsResponse tags.
         * @member {Array.<pond.Tag>} tags
         * @memberof pond.ListTagsResponse
         * @instance
         */
        ListTagsResponse.prototype.tags = $util.emptyArray;

        /**
         * Creates a new ListTagsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTagsResponse
         * @static
         * @param {pond.IListTagsResponse=} [properties] Properties to set
         * @returns {pond.ListTagsResponse} ListTagsResponse instance
         */
        ListTagsResponse.create = function create(properties) {
            return new ListTagsResponse(properties);
        };

        /**
         * Creates a ListTagsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTagsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTagsResponse} ListTagsResponse
         */
        ListTagsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTagsResponse)
                return object;
            var message = new $root.pond.ListTagsResponse();
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.ListTagsResponse.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i) {
                    if (typeof object.tags[i] !== "object")
                        throw TypeError(".pond.ListTagsResponse.tags: object expected");
                    message.tags[i] = $root.pond.Tag.fromObject(object.tags[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListTagsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTagsResponse
         * @static
         * @param {pond.ListTagsResponse} message ListTagsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTagsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = $root.pond.Tag.toObject(message.tags[j], options);
            }
            return object;
        };

        /**
         * Converts this ListTagsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTagsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTagsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTagsResponse;
    })();

    pond.AddTagRequest = (function() {

        /**
         * Properties of an AddTagRequest.
         * @memberof pond
         * @interface IAddTagRequest
         * @property {pond.TagSettings|null} [tag] AddTagRequest tag
         */

        /**
         * Constructs a new AddTagRequest.
         * @memberof pond
         * @classdesc Represents an AddTagRequest.
         * @implements IAddTagRequest
         * @constructor
         * @param {pond.IAddTagRequest=} [properties] Properties to set
         */
        function AddTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTagRequest tag.
         * @member {pond.TagSettings|null|undefined} tag
         * @memberof pond.AddTagRequest
         * @instance
         */
        AddTagRequest.prototype.tag = null;

        /**
         * Creates a new AddTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddTagRequest
         * @static
         * @param {pond.IAddTagRequest=} [properties] Properties to set
         * @returns {pond.AddTagRequest} AddTagRequest instance
         */
        AddTagRequest.create = function create(properties) {
            return new AddTagRequest(properties);
        };

        /**
         * Creates an AddTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTagRequest} AddTagRequest
         */
        AddTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTagRequest)
                return object;
            var message = new $root.pond.AddTagRequest();
            if (object.tag != null) {
                if (typeof object.tag !== "object")
                    throw TypeError(".pond.AddTagRequest.tag: object expected");
                message.tag = $root.pond.TagSettings.fromObject(object.tag);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTagRequest
         * @static
         * @param {pond.AddTagRequest} message AddTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.tag = null;
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = $root.pond.TagSettings.toObject(message.tag, options);
            return object;
        };

        /**
         * Converts this AddTagRequest to JSON.
         * @function toJSON
         * @memberof pond.AddTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTagRequest;
    })();

    pond.AddTagResponse = (function() {

        /**
         * Properties of an AddTagResponse.
         * @memberof pond
         * @interface IAddTagResponse
         * @property {string|null} [key] AddTagResponse key
         */

        /**
         * Constructs a new AddTagResponse.
         * @memberof pond
         * @classdesc Represents an AddTagResponse.
         * @implements IAddTagResponse
         * @constructor
         * @param {pond.IAddTagResponse=} [properties] Properties to set
         */
        function AddTagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTagResponse key.
         * @member {string} key
         * @memberof pond.AddTagResponse
         * @instance
         */
        AddTagResponse.prototype.key = "";

        /**
         * Creates a new AddTagResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddTagResponse
         * @static
         * @param {pond.IAddTagResponse=} [properties] Properties to set
         * @returns {pond.AddTagResponse} AddTagResponse instance
         */
        AddTagResponse.create = function create(properties) {
            return new AddTagResponse(properties);
        };

        /**
         * Creates an AddTagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTagResponse} AddTagResponse
         */
        AddTagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTagResponse)
                return object;
            var message = new $root.pond.AddTagResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddTagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTagResponse
         * @static
         * @param {pond.AddTagResponse} message AddTagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTagResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddTagResponse to JSON.
         * @function toJSON
         * @memberof pond.AddTagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTagResponse;
    })();

    pond.UpdateTagRequest = (function() {

        /**
         * Properties of an UpdateTagRequest.
         * @memberof pond
         * @interface IUpdateTagRequest
         * @property {pond.TagSettings|null} [tag] UpdateTagRequest tag
         */

        /**
         * Constructs a new UpdateTagRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTagRequest.
         * @implements IUpdateTagRequest
         * @constructor
         * @param {pond.IUpdateTagRequest=} [properties] Properties to set
         */
        function UpdateTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTagRequest tag.
         * @member {pond.TagSettings|null|undefined} tag
         * @memberof pond.UpdateTagRequest
         * @instance
         */
        UpdateTagRequest.prototype.tag = null;

        /**
         * Creates a new UpdateTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTagRequest
         * @static
         * @param {pond.IUpdateTagRequest=} [properties] Properties to set
         * @returns {pond.UpdateTagRequest} UpdateTagRequest instance
         */
        UpdateTagRequest.create = function create(properties) {
            return new UpdateTagRequest(properties);
        };

        /**
         * Creates an UpdateTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTagRequest} UpdateTagRequest
         */
        UpdateTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTagRequest)
                return object;
            var message = new $root.pond.UpdateTagRequest();
            if (object.tag != null) {
                if (typeof object.tag !== "object")
                    throw TypeError(".pond.UpdateTagRequest.tag: object expected");
                message.tag = $root.pond.TagSettings.fromObject(object.tag);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTagRequest
         * @static
         * @param {pond.UpdateTagRequest} message UpdateTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.tag = null;
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = $root.pond.TagSettings.toObject(message.tag, options);
            return object;
        };

        /**
         * Converts this UpdateTagRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTagRequest;
    })();

    pond.UpdateTagResponse = (function() {

        /**
         * Properties of an UpdateTagResponse.
         * @memberof pond
         * @interface IUpdateTagResponse
         */

        /**
         * Constructs a new UpdateTagResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTagResponse.
         * @implements IUpdateTagResponse
         * @constructor
         * @param {pond.IUpdateTagResponse=} [properties] Properties to set
         */
        function UpdateTagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateTagResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTagResponse
         * @static
         * @param {pond.IUpdateTagResponse=} [properties] Properties to set
         * @returns {pond.UpdateTagResponse} UpdateTagResponse instance
         */
        UpdateTagResponse.create = function create(properties) {
            return new UpdateTagResponse(properties);
        };

        /**
         * Creates an UpdateTagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTagResponse} UpdateTagResponse
         */
        UpdateTagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTagResponse)
                return object;
            return new $root.pond.UpdateTagResponse();
        };

        /**
         * Creates a plain object from an UpdateTagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTagResponse
         * @static
         * @param {pond.UpdateTagResponse} message UpdateTagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateTagResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTagResponse;
    })();

    pond.RemoveTagRequest = (function() {

        /**
         * Properties of a RemoveTagRequest.
         * @memberof pond
         * @interface IRemoveTagRequest
         * @property {string|null} [tag] RemoveTagRequest tag
         */

        /**
         * Constructs a new RemoveTagRequest.
         * @memberof pond
         * @classdesc Represents a RemoveTagRequest.
         * @implements IRemoveTagRequest
         * @constructor
         * @param {pond.IRemoveTagRequest=} [properties] Properties to set
         */
        function RemoveTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTagRequest tag.
         * @member {string} tag
         * @memberof pond.RemoveTagRequest
         * @instance
         */
        RemoveTagRequest.prototype.tag = "";

        /**
         * Creates a new RemoveTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTagRequest
         * @static
         * @param {pond.IRemoveTagRequest=} [properties] Properties to set
         * @returns {pond.RemoveTagRequest} RemoveTagRequest instance
         */
        RemoveTagRequest.create = function create(properties) {
            return new RemoveTagRequest(properties);
        };

        /**
         * Creates a RemoveTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTagRequest} RemoveTagRequest
         */
        RemoveTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTagRequest)
                return object;
            var message = new $root.pond.RemoveTagRequest();
            if (object.tag != null)
                message.tag = String(object.tag);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTagRequest
         * @static
         * @param {pond.RemoveTagRequest} message RemoveTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.tag = "";
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = message.tag;
            return object;
        };

        /**
         * Converts this RemoveTagRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTagRequest;
    })();

    pond.RemoveTagResponse = (function() {

        /**
         * Properties of a RemoveTagResponse.
         * @memberof pond
         * @interface IRemoveTagResponse
         */

        /**
         * Constructs a new RemoveTagResponse.
         * @memberof pond
         * @classdesc Represents a RemoveTagResponse.
         * @implements IRemoveTagResponse
         * @constructor
         * @param {pond.IRemoveTagResponse=} [properties] Properties to set
         */
        function RemoveTagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveTagResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTagResponse
         * @static
         * @param {pond.IRemoveTagResponse=} [properties] Properties to set
         * @returns {pond.RemoveTagResponse} RemoveTagResponse instance
         */
        RemoveTagResponse.create = function create(properties) {
            return new RemoveTagResponse(properties);
        };

        /**
         * Creates a RemoveTagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTagResponse} RemoveTagResponse
         */
        RemoveTagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTagResponse)
                return object;
            return new $root.pond.RemoveTagResponse();
        };

        /**
         * Creates a plain object from a RemoveTagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTagResponse
         * @static
         * @param {pond.RemoveTagResponse} message RemoveTagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveTagResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveTagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTagResponse;
    })();

    pond.AttachTagRequest = (function() {

        /**
         * Properties of an AttachTagRequest.
         * @memberof pond
         * @interface IAttachTagRequest
         * @property {string|null} [kind] AttachTagRequest kind
         * @property {string|null} [key] AttachTagRequest key
         * @property {string|null} [tag] AttachTagRequest tag
         */

        /**
         * Constructs a new AttachTagRequest.
         * @memberof pond
         * @classdesc Represents an AttachTagRequest.
         * @implements IAttachTagRequest
         * @constructor
         * @param {pond.IAttachTagRequest=} [properties] Properties to set
         */
        function AttachTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AttachTagRequest kind.
         * @member {string} kind
         * @memberof pond.AttachTagRequest
         * @instance
         */
        AttachTagRequest.prototype.kind = "";

        /**
         * AttachTagRequest key.
         * @member {string} key
         * @memberof pond.AttachTagRequest
         * @instance
         */
        AttachTagRequest.prototype.key = "";

        /**
         * AttachTagRequest tag.
         * @member {string} tag
         * @memberof pond.AttachTagRequest
         * @instance
         */
        AttachTagRequest.prototype.tag = "";

        /**
         * Creates a new AttachTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.AttachTagRequest
         * @static
         * @param {pond.IAttachTagRequest=} [properties] Properties to set
         * @returns {pond.AttachTagRequest} AttachTagRequest instance
         */
        AttachTagRequest.create = function create(properties) {
            return new AttachTagRequest(properties);
        };

        /**
         * Creates an AttachTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AttachTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AttachTagRequest} AttachTagRequest
         */
        AttachTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AttachTagRequest)
                return object;
            var message = new $root.pond.AttachTagRequest();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.tag != null)
                message.tag = String(object.tag);
            return message;
        };

        /**
         * Creates a plain object from an AttachTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AttachTagRequest
         * @static
         * @param {pond.AttachTagRequest} message AttachTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AttachTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.kind = "";
                object.key = "";
                object.tag = "";
            }
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = message.tag;
            return object;
        };

        /**
         * Converts this AttachTagRequest to JSON.
         * @function toJSON
         * @memberof pond.AttachTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AttachTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AttachTagRequest;
    })();

    pond.AttachTagResponse = (function() {

        /**
         * Properties of an AttachTagResponse.
         * @memberof pond
         * @interface IAttachTagResponse
         */

        /**
         * Constructs a new AttachTagResponse.
         * @memberof pond
         * @classdesc Represents an AttachTagResponse.
         * @implements IAttachTagResponse
         * @constructor
         * @param {pond.IAttachTagResponse=} [properties] Properties to set
         */
        function AttachTagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AttachTagResponse instance using the specified properties.
         * @function create
         * @memberof pond.AttachTagResponse
         * @static
         * @param {pond.IAttachTagResponse=} [properties] Properties to set
         * @returns {pond.AttachTagResponse} AttachTagResponse instance
         */
        AttachTagResponse.create = function create(properties) {
            return new AttachTagResponse(properties);
        };

        /**
         * Creates an AttachTagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AttachTagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AttachTagResponse} AttachTagResponse
         */
        AttachTagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AttachTagResponse)
                return object;
            return new $root.pond.AttachTagResponse();
        };

        /**
         * Creates a plain object from an AttachTagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AttachTagResponse
         * @static
         * @param {pond.AttachTagResponse} message AttachTagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AttachTagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AttachTagResponse to JSON.
         * @function toJSON
         * @memberof pond.AttachTagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AttachTagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AttachTagResponse;
    })();

    pond.DetachTagRequest = (function() {

        /**
         * Properties of a DetachTagRequest.
         * @memberof pond
         * @interface IDetachTagRequest
         * @property {string|null} [kind] DetachTagRequest kind
         * @property {string|null} [key] DetachTagRequest key
         * @property {string|null} [tag] DetachTagRequest tag
         */

        /**
         * Constructs a new DetachTagRequest.
         * @memberof pond
         * @classdesc Represents a DetachTagRequest.
         * @implements IDetachTagRequest
         * @constructor
         * @param {pond.IDetachTagRequest=} [properties] Properties to set
         */
        function DetachTagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DetachTagRequest kind.
         * @member {string} kind
         * @memberof pond.DetachTagRequest
         * @instance
         */
        DetachTagRequest.prototype.kind = "";

        /**
         * DetachTagRequest key.
         * @member {string} key
         * @memberof pond.DetachTagRequest
         * @instance
         */
        DetachTagRequest.prototype.key = "";

        /**
         * DetachTagRequest tag.
         * @member {string} tag
         * @memberof pond.DetachTagRequest
         * @instance
         */
        DetachTagRequest.prototype.tag = "";

        /**
         * Creates a new DetachTagRequest instance using the specified properties.
         * @function create
         * @memberof pond.DetachTagRequest
         * @static
         * @param {pond.IDetachTagRequest=} [properties] Properties to set
         * @returns {pond.DetachTagRequest} DetachTagRequest instance
         */
        DetachTagRequest.create = function create(properties) {
            return new DetachTagRequest(properties);
        };

        /**
         * Creates a DetachTagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DetachTagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DetachTagRequest} DetachTagRequest
         */
        DetachTagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DetachTagRequest)
                return object;
            var message = new $root.pond.DetachTagRequest();
            if (object.kind != null)
                message.kind = String(object.kind);
            if (object.key != null)
                message.key = String(object.key);
            if (object.tag != null)
                message.tag = String(object.tag);
            return message;
        };

        /**
         * Creates a plain object from a DetachTagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DetachTagRequest
         * @static
         * @param {pond.DetachTagRequest} message DetachTagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DetachTagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.kind = "";
                object.key = "";
                object.tag = "";
            }
            if (message.kind != null && message.hasOwnProperty("kind"))
                object.kind = message.kind;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.tag != null && message.hasOwnProperty("tag"))
                object.tag = message.tag;
            return object;
        };

        /**
         * Converts this DetachTagRequest to JSON.
         * @function toJSON
         * @memberof pond.DetachTagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DetachTagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DetachTagRequest;
    })();

    pond.DetachTagResponse = (function() {

        /**
         * Properties of a DetachTagResponse.
         * @memberof pond
         * @interface IDetachTagResponse
         */

        /**
         * Constructs a new DetachTagResponse.
         * @memberof pond
         * @classdesc Represents a DetachTagResponse.
         * @implements IDetachTagResponse
         * @constructor
         * @param {pond.IDetachTagResponse=} [properties] Properties to set
         */
        function DetachTagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DetachTagResponse instance using the specified properties.
         * @function create
         * @memberof pond.DetachTagResponse
         * @static
         * @param {pond.IDetachTagResponse=} [properties] Properties to set
         * @returns {pond.DetachTagResponse} DetachTagResponse instance
         */
        DetachTagResponse.create = function create(properties) {
            return new DetachTagResponse(properties);
        };

        /**
         * Creates a DetachTagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DetachTagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DetachTagResponse} DetachTagResponse
         */
        DetachTagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DetachTagResponse)
                return object;
            return new $root.pond.DetachTagResponse();
        };

        /**
         * Creates a plain object from a DetachTagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DetachTagResponse
         * @static
         * @param {pond.DetachTagResponse} message DetachTagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DetachTagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DetachTagResponse to JSON.
         * @function toJSON
         * @memberof pond.DetachTagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DetachTagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DetachTagResponse;
    })();

    pond.ShareableLinkSettings = (function() {

        /**
         * Properties of a ShareableLinkSettings.
         * @memberof pond
         * @interface IShareableLinkSettings
         * @property {string|null} [key] ShareableLinkSettings key
         * @property {string|null} [sharedKind] ShareableLinkSettings sharedKind
         * @property {string|null} [sharedKey] ShareableLinkSettings sharedKey
         * @property {string|null} [expiration] ShareableLinkSettings expiration
         */

        /**
         * Constructs a new ShareableLinkSettings.
         * @memberof pond
         * @classdesc Represents a ShareableLinkSettings.
         * @implements IShareableLinkSettings
         * @constructor
         * @param {pond.IShareableLinkSettings=} [properties] Properties to set
         */
        function ShareableLinkSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShareableLinkSettings key.
         * @member {string} key
         * @memberof pond.ShareableLinkSettings
         * @instance
         */
        ShareableLinkSettings.prototype.key = "";

        /**
         * ShareableLinkSettings sharedKind.
         * @member {string} sharedKind
         * @memberof pond.ShareableLinkSettings
         * @instance
         */
        ShareableLinkSettings.prototype.sharedKind = "";

        /**
         * ShareableLinkSettings sharedKey.
         * @member {string} sharedKey
         * @memberof pond.ShareableLinkSettings
         * @instance
         */
        ShareableLinkSettings.prototype.sharedKey = "";

        /**
         * ShareableLinkSettings expiration.
         * @member {string} expiration
         * @memberof pond.ShareableLinkSettings
         * @instance
         */
        ShareableLinkSettings.prototype.expiration = "";

        /**
         * Creates a new ShareableLinkSettings instance using the specified properties.
         * @function create
         * @memberof pond.ShareableLinkSettings
         * @static
         * @param {pond.IShareableLinkSettings=} [properties] Properties to set
         * @returns {pond.ShareableLinkSettings} ShareableLinkSettings instance
         */
        ShareableLinkSettings.create = function create(properties) {
            return new ShareableLinkSettings(properties);
        };

        /**
         * Creates a ShareableLinkSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ShareableLinkSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ShareableLinkSettings} ShareableLinkSettings
         */
        ShareableLinkSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ShareableLinkSettings)
                return object;
            var message = new $root.pond.ShareableLinkSettings();
            if (object.key != null)
                message.key = String(object.key);
            if (object.sharedKind != null)
                message.sharedKind = String(object.sharedKind);
            if (object.sharedKey != null)
                message.sharedKey = String(object.sharedKey);
            if (object.expiration != null)
                message.expiration = String(object.expiration);
            return message;
        };

        /**
         * Creates a plain object from a ShareableLinkSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ShareableLinkSettings
         * @static
         * @param {pond.ShareableLinkSettings} message ShareableLinkSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShareableLinkSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.sharedKind = "";
                object.sharedKey = "";
                object.expiration = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.sharedKind != null && message.hasOwnProperty("sharedKind"))
                object.sharedKind = message.sharedKind;
            if (message.sharedKey != null && message.hasOwnProperty("sharedKey"))
                object.sharedKey = message.sharedKey;
            if (message.expiration != null && message.hasOwnProperty("expiration"))
                object.expiration = message.expiration;
            return object;
        };

        /**
         * Converts this ShareableLinkSettings to JSON.
         * @function toJSON
         * @memberof pond.ShareableLinkSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShareableLinkSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShareableLinkSettings;
    })();

    pond.ShareableLinkStatus = (function() {

        /**
         * Properties of a ShareableLinkStatus.
         * @memberof pond
         * @interface IShareableLinkStatus
         */

        /**
         * Constructs a new ShareableLinkStatus.
         * @memberof pond
         * @classdesc Represents a ShareableLinkStatus.
         * @implements IShareableLinkStatus
         * @constructor
         * @param {pond.IShareableLinkStatus=} [properties] Properties to set
         */
        function ShareableLinkStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ShareableLinkStatus instance using the specified properties.
         * @function create
         * @memberof pond.ShareableLinkStatus
         * @static
         * @param {pond.IShareableLinkStatus=} [properties] Properties to set
         * @returns {pond.ShareableLinkStatus} ShareableLinkStatus instance
         */
        ShareableLinkStatus.create = function create(properties) {
            return new ShareableLinkStatus(properties);
        };

        /**
         * Creates a ShareableLinkStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ShareableLinkStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ShareableLinkStatus} ShareableLinkStatus
         */
        ShareableLinkStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ShareableLinkStatus)
                return object;
            return new $root.pond.ShareableLinkStatus();
        };

        /**
         * Creates a plain object from a ShareableLinkStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ShareableLinkStatus
         * @static
         * @param {pond.ShareableLinkStatus} message ShareableLinkStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShareableLinkStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ShareableLinkStatus to JSON.
         * @function toJSON
         * @memberof pond.ShareableLinkStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShareableLinkStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShareableLinkStatus;
    })();

    pond.GetShareableLinkRequest = (function() {

        /**
         * Properties of a GetShareableLinkRequest.
         * @memberof pond
         * @interface IGetShareableLinkRequest
         * @property {string|null} [link] GetShareableLinkRequest link
         */

        /**
         * Constructs a new GetShareableLinkRequest.
         * @memberof pond
         * @classdesc Represents a GetShareableLinkRequest.
         * @implements IGetShareableLinkRequest
         * @constructor
         * @param {pond.IGetShareableLinkRequest=} [properties] Properties to set
         */
        function GetShareableLinkRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetShareableLinkRequest link.
         * @member {string} link
         * @memberof pond.GetShareableLinkRequest
         * @instance
         */
        GetShareableLinkRequest.prototype.link = "";

        /**
         * Creates a new GetShareableLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetShareableLinkRequest
         * @static
         * @param {pond.IGetShareableLinkRequest=} [properties] Properties to set
         * @returns {pond.GetShareableLinkRequest} GetShareableLinkRequest instance
         */
        GetShareableLinkRequest.create = function create(properties) {
            return new GetShareableLinkRequest(properties);
        };

        /**
         * Creates a GetShareableLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetShareableLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetShareableLinkRequest} GetShareableLinkRequest
         */
        GetShareableLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetShareableLinkRequest)
                return object;
            var message = new $root.pond.GetShareableLinkRequest();
            if (object.link != null)
                message.link = String(object.link);
            return message;
        };

        /**
         * Creates a plain object from a GetShareableLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetShareableLinkRequest
         * @static
         * @param {pond.GetShareableLinkRequest} message GetShareableLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetShareableLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.link = "";
            if (message.link != null && message.hasOwnProperty("link"))
                object.link = message.link;
            return object;
        };

        /**
         * Converts this GetShareableLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.GetShareableLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetShareableLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetShareableLinkRequest;
    })();

    pond.ShareableLink = (function() {

        /**
         * Properties of a ShareableLink.
         * @memberof pond
         * @interface IShareableLink
         * @property {pond.ShareableLinkSettings|null} [settings] ShareableLink settings
         * @property {pond.ShareableLinkStatus|null} [status] ShareableLink status
         */

        /**
         * Constructs a new ShareableLink.
         * @memberof pond
         * @classdesc Represents a ShareableLink.
         * @implements IShareableLink
         * @constructor
         * @param {pond.IShareableLink=} [properties] Properties to set
         */
        function ShareableLink(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShareableLink settings.
         * @member {pond.ShareableLinkSettings|null|undefined} settings
         * @memberof pond.ShareableLink
         * @instance
         */
        ShareableLink.prototype.settings = null;

        /**
         * ShareableLink status.
         * @member {pond.ShareableLinkStatus|null|undefined} status
         * @memberof pond.ShareableLink
         * @instance
         */
        ShareableLink.prototype.status = null;

        /**
         * Creates a new ShareableLink instance using the specified properties.
         * @function create
         * @memberof pond.ShareableLink
         * @static
         * @param {pond.IShareableLink=} [properties] Properties to set
         * @returns {pond.ShareableLink} ShareableLink instance
         */
        ShareableLink.create = function create(properties) {
            return new ShareableLink(properties);
        };

        /**
         * Creates a ShareableLink message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ShareableLink
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ShareableLink} ShareableLink
         */
        ShareableLink.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ShareableLink)
                return object;
            var message = new $root.pond.ShareableLink();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.ShareableLink.settings: object expected");
                message.settings = $root.pond.ShareableLinkSettings.fromObject(object.settings);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".pond.ShareableLink.status: object expected");
                message.status = $root.pond.ShareableLinkStatus.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a ShareableLink message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ShareableLink
         * @static
         * @param {pond.ShareableLink} message ShareableLink
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShareableLink.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.settings = null;
                object.status = null;
            }
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ShareableLinkSettings.toObject(message.settings, options);
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = $root.pond.ShareableLinkStatus.toObject(message.status, options);
            return object;
        };

        /**
         * Converts this ShareableLink to JSON.
         * @function toJSON
         * @memberof pond.ShareableLink
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShareableLink.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ShareableLink;
    })();

    pond.ListShareableLinksRequest = (function() {

        /**
         * Properties of a ListShareableLinksRequest.
         * @memberof pond
         * @interface IListShareableLinksRequest
         * @property {pond.Paging|null} [paging] ListShareableLinksRequest paging
         * @property {pond.Sorting|null} [sorting] ListShareableLinksRequest sorting
         * @property {string|null} [search] ListShareableLinksRequest search
         * @property {pond.ShareableLinkSettings|null} [settingsMatch] ListShareableLinksRequest settingsMatch
         * @property {pond.ShareableLinkStatus|null} [statusMatch] ListShareableLinksRequest statusMatch
         * @property {Object.<string,string>|null} [fieldContains] ListShareableLinksRequest fieldContains
         */

        /**
         * Constructs a new ListShareableLinksRequest.
         * @memberof pond
         * @classdesc Represents a ListShareableLinksRequest.
         * @implements IListShareableLinksRequest
         * @constructor
         * @param {pond.IListShareableLinksRequest=} [properties] Properties to set
         */
        function ListShareableLinksRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListShareableLinksRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.paging = null;

        /**
         * ListShareableLinksRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.sorting = null;

        /**
         * ListShareableLinksRequest search.
         * @member {string} search
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.search = "";

        /**
         * ListShareableLinksRequest settingsMatch.
         * @member {pond.ShareableLinkSettings|null|undefined} settingsMatch
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.settingsMatch = null;

        /**
         * ListShareableLinksRequest statusMatch.
         * @member {pond.ShareableLinkStatus|null|undefined} statusMatch
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.statusMatch = null;

        /**
         * ListShareableLinksRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListShareableLinksRequest
         * @instance
         */
        ListShareableLinksRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListShareableLinksRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListShareableLinksRequest
         * @static
         * @param {pond.IListShareableLinksRequest=} [properties] Properties to set
         * @returns {pond.ListShareableLinksRequest} ListShareableLinksRequest instance
         */
        ListShareableLinksRequest.create = function create(properties) {
            return new ListShareableLinksRequest(properties);
        };

        /**
         * Creates a ListShareableLinksRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListShareableLinksRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListShareableLinksRequest} ListShareableLinksRequest
         */
        ListShareableLinksRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListShareableLinksRequest)
                return object;
            var message = new $root.pond.ListShareableLinksRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListShareableLinksRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListShareableLinksRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListShareableLinksRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.ShareableLinkSettings.fromObject(object.settingsMatch);
            }
            if (object.statusMatch != null) {
                if (typeof object.statusMatch !== "object")
                    throw TypeError(".pond.ListShareableLinksRequest.statusMatch: object expected");
                message.statusMatch = $root.pond.ShareableLinkStatus.fromObject(object.statusMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListShareableLinksRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListShareableLinksRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListShareableLinksRequest
         * @static
         * @param {pond.ListShareableLinksRequest} message ListShareableLinksRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListShareableLinksRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
                object.statusMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.ShareableLinkSettings.toObject(message.settingsMatch, options);
            if (message.statusMatch != null && message.hasOwnProperty("statusMatch"))
                object.statusMatch = $root.pond.ShareableLinkStatus.toObject(message.statusMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListShareableLinksRequest to JSON.
         * @function toJSON
         * @memberof pond.ListShareableLinksRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListShareableLinksRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListShareableLinksRequest;
    })();

    pond.ListShareableLinksResponse = (function() {

        /**
         * Properties of a ListShareableLinksResponse.
         * @memberof pond
         * @interface IListShareableLinksResponse
         * @property {Array.<pond.ShareableLink>|null} [links] ListShareableLinksResponse links
         * @property {number|null} [nextOffset] ListShareableLinksResponse nextOffset
         * @property {number|null} [total] ListShareableLinksResponse total
         */

        /**
         * Constructs a new ListShareableLinksResponse.
         * @memberof pond
         * @classdesc Represents a ListShareableLinksResponse.
         * @implements IListShareableLinksResponse
         * @constructor
         * @param {pond.IListShareableLinksResponse=} [properties] Properties to set
         */
        function ListShareableLinksResponse(properties) {
            this.links = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListShareableLinksResponse links.
         * @member {Array.<pond.ShareableLink>} links
         * @memberof pond.ListShareableLinksResponse
         * @instance
         */
        ListShareableLinksResponse.prototype.links = $util.emptyArray;

        /**
         * ListShareableLinksResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListShareableLinksResponse
         * @instance
         */
        ListShareableLinksResponse.prototype.nextOffset = 0;

        /**
         * ListShareableLinksResponse total.
         * @member {number} total
         * @memberof pond.ListShareableLinksResponse
         * @instance
         */
        ListShareableLinksResponse.prototype.total = 0;

        /**
         * Creates a new ListShareableLinksResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListShareableLinksResponse
         * @static
         * @param {pond.IListShareableLinksResponse=} [properties] Properties to set
         * @returns {pond.ListShareableLinksResponse} ListShareableLinksResponse instance
         */
        ListShareableLinksResponse.create = function create(properties) {
            return new ListShareableLinksResponse(properties);
        };

        /**
         * Creates a ListShareableLinksResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListShareableLinksResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListShareableLinksResponse} ListShareableLinksResponse
         */
        ListShareableLinksResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListShareableLinksResponse)
                return object;
            var message = new $root.pond.ListShareableLinksResponse();
            if (object.links) {
                if (!Array.isArray(object.links))
                    throw TypeError(".pond.ListShareableLinksResponse.links: array expected");
                message.links = [];
                for (var i = 0; i < object.links.length; ++i) {
                    if (typeof object.links[i] !== "object")
                        throw TypeError(".pond.ListShareableLinksResponse.links: object expected");
                    message.links[i] = $root.pond.ShareableLink.fromObject(object.links[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListShareableLinksResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListShareableLinksResponse
         * @static
         * @param {pond.ListShareableLinksResponse} message ListShareableLinksResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListShareableLinksResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.links = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.links && message.links.length) {
                object.links = [];
                for (var j = 0; j < message.links.length; ++j)
                    object.links[j] = $root.pond.ShareableLink.toObject(message.links[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListShareableLinksResponse to JSON.
         * @function toJSON
         * @memberof pond.ListShareableLinksResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListShareableLinksResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListShareableLinksResponse;
    })();

    pond.AddShareableLinkRequest = (function() {

        /**
         * Properties of an AddShareableLinkRequest.
         * @memberof pond
         * @interface IAddShareableLinkRequest
         * @property {pond.ShareableLinkSettings|null} [settings] AddShareableLinkRequest settings
         */

        /**
         * Constructs a new AddShareableLinkRequest.
         * @memberof pond
         * @classdesc Represents an AddShareableLinkRequest.
         * @implements IAddShareableLinkRequest
         * @constructor
         * @param {pond.IAddShareableLinkRequest=} [properties] Properties to set
         */
        function AddShareableLinkRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddShareableLinkRequest settings.
         * @member {pond.ShareableLinkSettings|null|undefined} settings
         * @memberof pond.AddShareableLinkRequest
         * @instance
         */
        AddShareableLinkRequest.prototype.settings = null;

        /**
         * Creates a new AddShareableLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddShareableLinkRequest
         * @static
         * @param {pond.IAddShareableLinkRequest=} [properties] Properties to set
         * @returns {pond.AddShareableLinkRequest} AddShareableLinkRequest instance
         */
        AddShareableLinkRequest.create = function create(properties) {
            return new AddShareableLinkRequest(properties);
        };

        /**
         * Creates an AddShareableLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddShareableLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddShareableLinkRequest} AddShareableLinkRequest
         */
        AddShareableLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddShareableLinkRequest)
                return object;
            var message = new $root.pond.AddShareableLinkRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddShareableLinkRequest.settings: object expected");
                message.settings = $root.pond.ShareableLinkSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddShareableLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddShareableLinkRequest
         * @static
         * @param {pond.AddShareableLinkRequest} message AddShareableLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddShareableLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ShareableLinkSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddShareableLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.AddShareableLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddShareableLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddShareableLinkRequest;
    })();

    pond.AddShareableLinkResponse = (function() {

        /**
         * Properties of an AddShareableLinkResponse.
         * @memberof pond
         * @interface IAddShareableLinkResponse
         * @property {string|null} [key] AddShareableLinkResponse key
         */

        /**
         * Constructs a new AddShareableLinkResponse.
         * @memberof pond
         * @classdesc Represents an AddShareableLinkResponse.
         * @implements IAddShareableLinkResponse
         * @constructor
         * @param {pond.IAddShareableLinkResponse=} [properties] Properties to set
         */
        function AddShareableLinkResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddShareableLinkResponse key.
         * @member {string} key
         * @memberof pond.AddShareableLinkResponse
         * @instance
         */
        AddShareableLinkResponse.prototype.key = "";

        /**
         * Creates a new AddShareableLinkResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddShareableLinkResponse
         * @static
         * @param {pond.IAddShareableLinkResponse=} [properties] Properties to set
         * @returns {pond.AddShareableLinkResponse} AddShareableLinkResponse instance
         */
        AddShareableLinkResponse.create = function create(properties) {
            return new AddShareableLinkResponse(properties);
        };

        /**
         * Creates an AddShareableLinkResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddShareableLinkResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddShareableLinkResponse} AddShareableLinkResponse
         */
        AddShareableLinkResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddShareableLinkResponse)
                return object;
            var message = new $root.pond.AddShareableLinkResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddShareableLinkResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddShareableLinkResponse
         * @static
         * @param {pond.AddShareableLinkResponse} message AddShareableLinkResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddShareableLinkResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddShareableLinkResponse to JSON.
         * @function toJSON
         * @memberof pond.AddShareableLinkResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddShareableLinkResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddShareableLinkResponse;
    })();

    pond.RemoveShareableLinkRequest = (function() {

        /**
         * Properties of a RemoveShareableLinkRequest.
         * @memberof pond
         * @interface IRemoveShareableLinkRequest
         * @property {string|null} [link] RemoveShareableLinkRequest link
         */

        /**
         * Constructs a new RemoveShareableLinkRequest.
         * @memberof pond
         * @classdesc Represents a RemoveShareableLinkRequest.
         * @implements IRemoveShareableLinkRequest
         * @constructor
         * @param {pond.IRemoveShareableLinkRequest=} [properties] Properties to set
         */
        function RemoveShareableLinkRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveShareableLinkRequest link.
         * @member {string} link
         * @memberof pond.RemoveShareableLinkRequest
         * @instance
         */
        RemoveShareableLinkRequest.prototype.link = "";

        /**
         * Creates a new RemoveShareableLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveShareableLinkRequest
         * @static
         * @param {pond.IRemoveShareableLinkRequest=} [properties] Properties to set
         * @returns {pond.RemoveShareableLinkRequest} RemoveShareableLinkRequest instance
         */
        RemoveShareableLinkRequest.create = function create(properties) {
            return new RemoveShareableLinkRequest(properties);
        };

        /**
         * Creates a RemoveShareableLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveShareableLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveShareableLinkRequest} RemoveShareableLinkRequest
         */
        RemoveShareableLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveShareableLinkRequest)
                return object;
            var message = new $root.pond.RemoveShareableLinkRequest();
            if (object.link != null)
                message.link = String(object.link);
            return message;
        };

        /**
         * Creates a plain object from a RemoveShareableLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveShareableLinkRequest
         * @static
         * @param {pond.RemoveShareableLinkRequest} message RemoveShareableLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveShareableLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.link = "";
            if (message.link != null && message.hasOwnProperty("link"))
                object.link = message.link;
            return object;
        };

        /**
         * Converts this RemoveShareableLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveShareableLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveShareableLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveShareableLinkRequest;
    })();

    pond.RemoveShareableLinkResponse = (function() {

        /**
         * Properties of a RemoveShareableLinkResponse.
         * @memberof pond
         * @interface IRemoveShareableLinkResponse
         */

        /**
         * Constructs a new RemoveShareableLinkResponse.
         * @memberof pond
         * @classdesc Represents a RemoveShareableLinkResponse.
         * @implements IRemoveShareableLinkResponse
         * @constructor
         * @param {pond.IRemoveShareableLinkResponse=} [properties] Properties to set
         */
        function RemoveShareableLinkResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveShareableLinkResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveShareableLinkResponse
         * @static
         * @param {pond.IRemoveShareableLinkResponse=} [properties] Properties to set
         * @returns {pond.RemoveShareableLinkResponse} RemoveShareableLinkResponse instance
         */
        RemoveShareableLinkResponse.create = function create(properties) {
            return new RemoveShareableLinkResponse(properties);
        };

        /**
         * Creates a RemoveShareableLinkResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveShareableLinkResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveShareableLinkResponse} RemoveShareableLinkResponse
         */
        RemoveShareableLinkResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveShareableLinkResponse)
                return object;
            return new $root.pond.RemoveShareableLinkResponse();
        };

        /**
         * Creates a plain object from a RemoveShareableLinkResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveShareableLinkResponse
         * @static
         * @param {pond.RemoveShareableLinkResponse} message RemoveShareableLinkResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveShareableLinkResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveShareableLinkResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveShareableLinkResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveShareableLinkResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveShareableLinkResponse;
    })();

    pond.HoloDevice = (function() {

        /**
         * Properties of a HoloDevice.
         * @memberof pond
         * @interface IHoloDevice
         * @property {number|null} [id] HoloDevice id
         * @property {pond.HoloLinks|null} [links] HoloDevice links
         * @property {pond.Session|null} [lastsession] HoloDevice lastsession
         */

        /**
         * Constructs a new HoloDevice.
         * @memberof pond
         * @classdesc Represents a HoloDevice.
         * @implements IHoloDevice
         * @constructor
         * @param {pond.IHoloDevice=} [properties] Properties to set
         */
        function HoloDevice(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HoloDevice id.
         * @member {number} id
         * @memberof pond.HoloDevice
         * @instance
         */
        HoloDevice.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloDevice links.
         * @member {pond.HoloLinks|null|undefined} links
         * @memberof pond.HoloDevice
         * @instance
         */
        HoloDevice.prototype.links = null;

        /**
         * HoloDevice lastsession.
         * @member {pond.Session|null|undefined} lastsession
         * @memberof pond.HoloDevice
         * @instance
         */
        HoloDevice.prototype.lastsession = null;

        /**
         * Creates a new HoloDevice instance using the specified properties.
         * @function create
         * @memberof pond.HoloDevice
         * @static
         * @param {pond.IHoloDevice=} [properties] Properties to set
         * @returns {pond.HoloDevice} HoloDevice instance
         */
        HoloDevice.create = function create(properties) {
            return new HoloDevice(properties);
        };

        /**
         * Creates a HoloDevice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HoloDevice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HoloDevice} HoloDevice
         */
        HoloDevice.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HoloDevice)
                return object;
            var message = new $root.pond.HoloDevice();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.links != null) {
                if (typeof object.links !== "object")
                    throw TypeError(".pond.HoloDevice.links: object expected");
                message.links = $root.pond.HoloLinks.fromObject(object.links);
            }
            if (object.lastsession != null) {
                if (typeof object.lastsession !== "object")
                    throw TypeError(".pond.HoloDevice.lastsession: object expected");
                message.lastsession = $root.pond.Session.fromObject(object.lastsession);
            }
            return message;
        };

        /**
         * Creates a plain object from a HoloDevice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HoloDevice
         * @static
         * @param {pond.HoloDevice} message HoloDevice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HoloDevice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.links = null;
                object.lastsession = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.links != null && message.hasOwnProperty("links"))
                object.links = $root.pond.HoloLinks.toObject(message.links, options);
            if (message.lastsession != null && message.hasOwnProperty("lastsession"))
                object.lastsession = $root.pond.Session.toObject(message.lastsession, options);
            return object;
        };

        /**
         * Converts this HoloDevice to JSON.
         * @function toJSON
         * @memberof pond.HoloDevice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HoloDevice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HoloDevice;
    })();

    pond.HoloLinks = (function() {

        /**
         * Properties of a HoloLinks.
         * @memberof pond
         * @interface IHoloLinks
         * @property {Array.<pond.CellularLink>|null} [cellular] HoloLinks cellular
         */

        /**
         * Constructs a new HoloLinks.
         * @memberof pond
         * @classdesc Represents a HoloLinks.
         * @implements IHoloLinks
         * @constructor
         * @param {pond.IHoloLinks=} [properties] Properties to set
         */
        function HoloLinks(properties) {
            this.cellular = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HoloLinks cellular.
         * @member {Array.<pond.CellularLink>} cellular
         * @memberof pond.HoloLinks
         * @instance
         */
        HoloLinks.prototype.cellular = $util.emptyArray;

        /**
         * Creates a new HoloLinks instance using the specified properties.
         * @function create
         * @memberof pond.HoloLinks
         * @static
         * @param {pond.IHoloLinks=} [properties] Properties to set
         * @returns {pond.HoloLinks} HoloLinks instance
         */
        HoloLinks.create = function create(properties) {
            return new HoloLinks(properties);
        };

        /**
         * Creates a HoloLinks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HoloLinks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HoloLinks} HoloLinks
         */
        HoloLinks.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HoloLinks)
                return object;
            var message = new $root.pond.HoloLinks();
            if (object.cellular) {
                if (!Array.isArray(object.cellular))
                    throw TypeError(".pond.HoloLinks.cellular: array expected");
                message.cellular = [];
                for (var i = 0; i < object.cellular.length; ++i) {
                    if (typeof object.cellular[i] !== "object")
                        throw TypeError(".pond.HoloLinks.cellular: object expected");
                    message.cellular[i] = $root.pond.CellularLink.fromObject(object.cellular[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a HoloLinks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HoloLinks
         * @static
         * @param {pond.HoloLinks} message HoloLinks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HoloLinks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cellular = [];
            if (message.cellular && message.cellular.length) {
                object.cellular = [];
                for (var j = 0; j < message.cellular.length; ++j)
                    object.cellular[j] = $root.pond.CellularLink.toObject(message.cellular[j], options);
            }
            return object;
        };

        /**
         * Converts this HoloLinks to JSON.
         * @function toJSON
         * @memberof pond.HoloLinks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HoloLinks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HoloLinks;
    })();

    pond.HoloDeviceSim = (function() {

        /**
         * Properties of a HoloDeviceSim.
         * @memberof pond
         * @interface IHoloDeviceSim
         * @property {number|null} [id] HoloDeviceSim id
         * @property {number|null} [link] HoloDeviceSim link
         * @property {string|null} [sim] HoloDeviceSim sim
         */

        /**
         * Constructs a new HoloDeviceSim.
         * @memberof pond
         * @classdesc Represents a HoloDeviceSim.
         * @implements IHoloDeviceSim
         * @constructor
         * @param {pond.IHoloDeviceSim=} [properties] Properties to set
         */
        function HoloDeviceSim(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HoloDeviceSim id.
         * @member {number} id
         * @memberof pond.HoloDeviceSim
         * @instance
         */
        HoloDeviceSim.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloDeviceSim link.
         * @member {number} link
         * @memberof pond.HoloDeviceSim
         * @instance
         */
        HoloDeviceSim.prototype.link = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloDeviceSim sim.
         * @member {string} sim
         * @memberof pond.HoloDeviceSim
         * @instance
         */
        HoloDeviceSim.prototype.sim = "";

        /**
         * Creates a new HoloDeviceSim instance using the specified properties.
         * @function create
         * @memberof pond.HoloDeviceSim
         * @static
         * @param {pond.IHoloDeviceSim=} [properties] Properties to set
         * @returns {pond.HoloDeviceSim} HoloDeviceSim instance
         */
        HoloDeviceSim.create = function create(properties) {
            return new HoloDeviceSim(properties);
        };

        /**
         * Creates a HoloDeviceSim message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HoloDeviceSim
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HoloDeviceSim} HoloDeviceSim
         */
        HoloDeviceSim.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HoloDeviceSim)
                return object;
            var message = new $root.pond.HoloDeviceSim();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.link != null)
                if ($util.Long)
                    (message.link = $util.Long.fromValue(object.link)).unsigned = true;
                else if (typeof object.link === "string")
                    message.link = parseInt(object.link, 10);
                else if (typeof object.link === "number")
                    message.link = object.link;
                else if (typeof object.link === "object")
                    message.link = new $util.LongBits(object.link.low >>> 0, object.link.high >>> 0).toNumber(true);
            if (object.sim != null)
                message.sim = String(object.sim);
            return message;
        };

        /**
         * Creates a plain object from a HoloDeviceSim message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HoloDeviceSim
         * @static
         * @param {pond.HoloDeviceSim} message HoloDeviceSim
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HoloDeviceSim.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.link = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.link = options.longs === String ? "0" : 0;
                object.sim = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.link != null && message.hasOwnProperty("link"))
                if (typeof message.link === "number")
                    object.link = options.longs === String ? String(message.link) : message.link;
                else
                    object.link = options.longs === String ? $util.Long.prototype.toString.call(message.link) : options.longs === Number ? new $util.LongBits(message.link.low >>> 0, message.link.high >>> 0).toNumber(true) : message.link;
            if (message.sim != null && message.hasOwnProperty("sim"))
                object.sim = message.sim;
            return object;
        };

        /**
         * Converts this HoloDeviceSim to JSON.
         * @function toJSON
         * @memberof pond.HoloDeviceSim
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HoloDeviceSim.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HoloDeviceSim;
    })();

    pond.HoloIdRequest = (function() {

        /**
         * Properties of a HoloIdRequest.
         * @memberof pond
         * @interface IHoloIdRequest
         * @property {number|null} [deviceid] HoloIdRequest deviceid
         * @property {number|null} [linkid] HoloIdRequest linkid
         * @property {string|null} [sim] HoloIdRequest sim
         * @property {string|null} [imei] HoloIdRequest imei
         */

        /**
         * Constructs a new HoloIdRequest.
         * @memberof pond
         * @classdesc Represents a HoloIdRequest.
         * @implements IHoloIdRequest
         * @constructor
         * @param {pond.IHoloIdRequest=} [properties] Properties to set
         */
        function HoloIdRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HoloIdRequest deviceid.
         * @member {number} deviceid
         * @memberof pond.HoloIdRequest
         * @instance
         */
        HoloIdRequest.prototype.deviceid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloIdRequest linkid.
         * @member {number} linkid
         * @memberof pond.HoloIdRequest
         * @instance
         */
        HoloIdRequest.prototype.linkid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloIdRequest sim.
         * @member {string} sim
         * @memberof pond.HoloIdRequest
         * @instance
         */
        HoloIdRequest.prototype.sim = "";

        /**
         * HoloIdRequest imei.
         * @member {string} imei
         * @memberof pond.HoloIdRequest
         * @instance
         */
        HoloIdRequest.prototype.imei = "";

        /**
         * Creates a new HoloIdRequest instance using the specified properties.
         * @function create
         * @memberof pond.HoloIdRequest
         * @static
         * @param {pond.IHoloIdRequest=} [properties] Properties to set
         * @returns {pond.HoloIdRequest} HoloIdRequest instance
         */
        HoloIdRequest.create = function create(properties) {
            return new HoloIdRequest(properties);
        };

        /**
         * Creates a HoloIdRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HoloIdRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HoloIdRequest} HoloIdRequest
         */
        HoloIdRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HoloIdRequest)
                return object;
            var message = new $root.pond.HoloIdRequest();
            if (object.deviceid != null)
                if ($util.Long)
                    (message.deviceid = $util.Long.fromValue(object.deviceid)).unsigned = true;
                else if (typeof object.deviceid === "string")
                    message.deviceid = parseInt(object.deviceid, 10);
                else if (typeof object.deviceid === "number")
                    message.deviceid = object.deviceid;
                else if (typeof object.deviceid === "object")
                    message.deviceid = new $util.LongBits(object.deviceid.low >>> 0, object.deviceid.high >>> 0).toNumber(true);
            if (object.linkid != null)
                if ($util.Long)
                    (message.linkid = $util.Long.fromValue(object.linkid)).unsigned = true;
                else if (typeof object.linkid === "string")
                    message.linkid = parseInt(object.linkid, 10);
                else if (typeof object.linkid === "number")
                    message.linkid = object.linkid;
                else if (typeof object.linkid === "object")
                    message.linkid = new $util.LongBits(object.linkid.low >>> 0, object.linkid.high >>> 0).toNumber(true);
            if (object.sim != null)
                message.sim = String(object.sim);
            if (object.imei != null)
                message.imei = String(object.imei);
            return message;
        };

        /**
         * Creates a plain object from a HoloIdRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HoloIdRequest
         * @static
         * @param {pond.HoloIdRequest} message HoloIdRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HoloIdRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceid = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.linkid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.linkid = options.longs === String ? "0" : 0;
                object.sim = "";
                object.imei = "";
            }
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (typeof message.deviceid === "number")
                    object.deviceid = options.longs === String ? String(message.deviceid) : message.deviceid;
                else
                    object.deviceid = options.longs === String ? $util.Long.prototype.toString.call(message.deviceid) : options.longs === Number ? new $util.LongBits(message.deviceid.low >>> 0, message.deviceid.high >>> 0).toNumber(true) : message.deviceid;
            if (message.linkid != null && message.hasOwnProperty("linkid"))
                if (typeof message.linkid === "number")
                    object.linkid = options.longs === String ? String(message.linkid) : message.linkid;
                else
                    object.linkid = options.longs === String ? $util.Long.prototype.toString.call(message.linkid) : options.longs === Number ? new $util.LongBits(message.linkid.low >>> 0, message.linkid.high >>> 0).toNumber(true) : message.linkid;
            if (message.sim != null && message.hasOwnProperty("sim"))
                object.sim = message.sim;
            if (message.imei != null && message.hasOwnProperty("imei"))
                object.imei = message.imei;
            return object;
        };

        /**
         * Converts this HoloIdRequest to JSON.
         * @function toJSON
         * @memberof pond.HoloIdRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HoloIdRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HoloIdRequest;
    })();

    pond.IsPausedDeviceRequest = (function() {

        /**
         * Properties of an IsPausedDeviceRequest.
         * @memberof pond
         * @interface IIsPausedDeviceRequest
         * @property {number|null} [device] IsPausedDeviceRequest device
         */

        /**
         * Constructs a new IsPausedDeviceRequest.
         * @memberof pond
         * @classdesc Represents an IsPausedDeviceRequest.
         * @implements IIsPausedDeviceRequest
         * @constructor
         * @param {pond.IIsPausedDeviceRequest=} [properties] Properties to set
         */
        function IsPausedDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsPausedDeviceRequest device.
         * @member {number} device
         * @memberof pond.IsPausedDeviceRequest
         * @instance
         */
        IsPausedDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new IsPausedDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.IsPausedDeviceRequest
         * @static
         * @param {pond.IIsPausedDeviceRequest=} [properties] Properties to set
         * @returns {pond.IsPausedDeviceRequest} IsPausedDeviceRequest instance
         */
        IsPausedDeviceRequest.create = function create(properties) {
            return new IsPausedDeviceRequest(properties);
        };

        /**
         * Creates an IsPausedDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsPausedDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsPausedDeviceRequest} IsPausedDeviceRequest
         */
        IsPausedDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsPausedDeviceRequest)
                return object;
            var message = new $root.pond.IsPausedDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an IsPausedDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsPausedDeviceRequest
         * @static
         * @param {pond.IsPausedDeviceRequest} message IsPausedDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsPausedDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this IsPausedDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.IsPausedDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsPausedDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsPausedDeviceRequest;
    })();

    pond.GetMonthlyDataCapDeviceRequest = (function() {

        /**
         * Properties of a GetMonthlyDataCapDeviceRequest.
         * @memberof pond
         * @interface IGetMonthlyDataCapDeviceRequest
         * @property {number|null} [device] GetMonthlyDataCapDeviceRequest device
         */

        /**
         * Constructs a new GetMonthlyDataCapDeviceRequest.
         * @memberof pond
         * @classdesc Represents a GetMonthlyDataCapDeviceRequest.
         * @implements IGetMonthlyDataCapDeviceRequest
         * @constructor
         * @param {pond.IGetMonthlyDataCapDeviceRequest=} [properties] Properties to set
         */
        function GetMonthlyDataCapDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMonthlyDataCapDeviceRequest device.
         * @member {number} device
         * @memberof pond.GetMonthlyDataCapDeviceRequest
         * @instance
         */
        GetMonthlyDataCapDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetMonthlyDataCapDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetMonthlyDataCapDeviceRequest
         * @static
         * @param {pond.IGetMonthlyDataCapDeviceRequest=} [properties] Properties to set
         * @returns {pond.GetMonthlyDataCapDeviceRequest} GetMonthlyDataCapDeviceRequest instance
         */
        GetMonthlyDataCapDeviceRequest.create = function create(properties) {
            return new GetMonthlyDataCapDeviceRequest(properties);
        };

        /**
         * Creates a GetMonthlyDataCapDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMonthlyDataCapDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMonthlyDataCapDeviceRequest} GetMonthlyDataCapDeviceRequest
         */
        GetMonthlyDataCapDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMonthlyDataCapDeviceRequest)
                return object;
            var message = new $root.pond.GetMonthlyDataCapDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetMonthlyDataCapDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMonthlyDataCapDeviceRequest
         * @static
         * @param {pond.GetMonthlyDataCapDeviceRequest} message GetMonthlyDataCapDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMonthlyDataCapDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this GetMonthlyDataCapDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.GetMonthlyDataCapDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMonthlyDataCapDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMonthlyDataCapDeviceRequest;
    })();

    pond.SetMonthlyDataCapDeviceRequest = (function() {

        /**
         * Properties of a SetMonthlyDataCapDeviceRequest.
         * @memberof pond
         * @interface ISetMonthlyDataCapDeviceRequest
         * @property {number|null} [device] SetMonthlyDataCapDeviceRequest device
         * @property {number|null} [limit] SetMonthlyDataCapDeviceRequest limit
         */

        /**
         * Constructs a new SetMonthlyDataCapDeviceRequest.
         * @memberof pond
         * @classdesc Represents a SetMonthlyDataCapDeviceRequest.
         * @implements ISetMonthlyDataCapDeviceRequest
         * @constructor
         * @param {pond.ISetMonthlyDataCapDeviceRequest=} [properties] Properties to set
         */
        function SetMonthlyDataCapDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetMonthlyDataCapDeviceRequest device.
         * @member {number} device
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @instance
         */
        SetMonthlyDataCapDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SetMonthlyDataCapDeviceRequest limit.
         * @member {number} limit
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @instance
         */
        SetMonthlyDataCapDeviceRequest.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SetMonthlyDataCapDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @static
         * @param {pond.ISetMonthlyDataCapDeviceRequest=} [properties] Properties to set
         * @returns {pond.SetMonthlyDataCapDeviceRequest} SetMonthlyDataCapDeviceRequest instance
         */
        SetMonthlyDataCapDeviceRequest.create = function create(properties) {
            return new SetMonthlyDataCapDeviceRequest(properties);
        };

        /**
         * Creates a SetMonthlyDataCapDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetMonthlyDataCapDeviceRequest} SetMonthlyDataCapDeviceRequest
         */
        SetMonthlyDataCapDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetMonthlyDataCapDeviceRequest)
                return object;
            var message = new $root.pond.SetMonthlyDataCapDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.limit != null)
                if ($util.Long)
                    (message.limit = $util.Long.fromValue(object.limit)).unsigned = false;
                else if (typeof object.limit === "string")
                    message.limit = parseInt(object.limit, 10);
                else if (typeof object.limit === "number")
                    message.limit = object.limit;
                else if (typeof object.limit === "object")
                    message.limit = new $util.LongBits(object.limit.low >>> 0, object.limit.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SetMonthlyDataCapDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @static
         * @param {pond.SetMonthlyDataCapDeviceRequest} message SetMonthlyDataCapDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetMonthlyDataCapDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.limit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.limit = options.longs === String ? "0" : 0;
            }
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (typeof message.limit === "number")
                    object.limit = options.longs === String ? String(message.limit) : message.limit;
                else
                    object.limit = options.longs === String ? $util.Long.prototype.toString.call(message.limit) : options.longs === Number ? new $util.LongBits(message.limit.low >>> 0, message.limit.high >>> 0).toNumber() : message.limit;
            return object;
        };

        /**
         * Converts this SetMonthlyDataCapDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.SetMonthlyDataCapDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetMonthlyDataCapDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetMonthlyDataCapDeviceRequest;
    })();

    pond.IsOverlimitDeviceRequest = (function() {

        /**
         * Properties of an IsOverlimitDeviceRequest.
         * @memberof pond
         * @interface IIsOverlimitDeviceRequest
         * @property {number|null} [device] IsOverlimitDeviceRequest device
         */

        /**
         * Constructs a new IsOverlimitDeviceRequest.
         * @memberof pond
         * @classdesc Represents an IsOverlimitDeviceRequest.
         * @implements IIsOverlimitDeviceRequest
         * @constructor
         * @param {pond.IIsOverlimitDeviceRequest=} [properties] Properties to set
         */
        function IsOverlimitDeviceRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsOverlimitDeviceRequest device.
         * @member {number} device
         * @memberof pond.IsOverlimitDeviceRequest
         * @instance
         */
        IsOverlimitDeviceRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new IsOverlimitDeviceRequest instance using the specified properties.
         * @function create
         * @memberof pond.IsOverlimitDeviceRequest
         * @static
         * @param {pond.IIsOverlimitDeviceRequest=} [properties] Properties to set
         * @returns {pond.IsOverlimitDeviceRequest} IsOverlimitDeviceRequest instance
         */
        IsOverlimitDeviceRequest.create = function create(properties) {
            return new IsOverlimitDeviceRequest(properties);
        };

        /**
         * Creates an IsOverlimitDeviceRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsOverlimitDeviceRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsOverlimitDeviceRequest} IsOverlimitDeviceRequest
         */
        IsOverlimitDeviceRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsOverlimitDeviceRequest)
                return object;
            var message = new $root.pond.IsOverlimitDeviceRequest();
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from an IsOverlimitDeviceRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsOverlimitDeviceRequest
         * @static
         * @param {pond.IsOverlimitDeviceRequest} message IsOverlimitDeviceRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsOverlimitDeviceRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            return object;
        };

        /**
         * Converts this IsOverlimitDeviceRequest to JSON.
         * @function toJSON
         * @memberof pond.IsOverlimitDeviceRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsOverlimitDeviceRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsOverlimitDeviceRequest;
    })();

    pond.IsOverlimitDeviceResponse = (function() {

        /**
         * Properties of an IsOverlimitDeviceResponse.
         * @memberof pond
         * @interface IIsOverlimitDeviceResponse
         * @property {boolean|null} [isover] IsOverlimitDeviceResponse isover
         */

        /**
         * Constructs a new IsOverlimitDeviceResponse.
         * @memberof pond
         * @classdesc Represents an IsOverlimitDeviceResponse.
         * @implements IIsOverlimitDeviceResponse
         * @constructor
         * @param {pond.IIsOverlimitDeviceResponse=} [properties] Properties to set
         */
        function IsOverlimitDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsOverlimitDeviceResponse isover.
         * @member {boolean} isover
         * @memberof pond.IsOverlimitDeviceResponse
         * @instance
         */
        IsOverlimitDeviceResponse.prototype.isover = false;

        /**
         * Creates a new IsOverlimitDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.IsOverlimitDeviceResponse
         * @static
         * @param {pond.IIsOverlimitDeviceResponse=} [properties] Properties to set
         * @returns {pond.IsOverlimitDeviceResponse} IsOverlimitDeviceResponse instance
         */
        IsOverlimitDeviceResponse.create = function create(properties) {
            return new IsOverlimitDeviceResponse(properties);
        };

        /**
         * Creates an IsOverlimitDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsOverlimitDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsOverlimitDeviceResponse} IsOverlimitDeviceResponse
         */
        IsOverlimitDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsOverlimitDeviceResponse)
                return object;
            var message = new $root.pond.IsOverlimitDeviceResponse();
            if (object.isover != null)
                message.isover = Boolean(object.isover);
            return message;
        };

        /**
         * Creates a plain object from an IsOverlimitDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsOverlimitDeviceResponse
         * @static
         * @param {pond.IsOverlimitDeviceResponse} message IsOverlimitDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsOverlimitDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.isover = false;
            if (message.isover != null && message.hasOwnProperty("isover"))
                object.isover = message.isover;
            return object;
        };

        /**
         * Converts this IsOverlimitDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.IsOverlimitDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsOverlimitDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsOverlimitDeviceResponse;
    })();

    pond.SetMonthlyDataCapDeviceResponse = (function() {

        /**
         * Properties of a SetMonthlyDataCapDeviceResponse.
         * @memberof pond
         * @interface ISetMonthlyDataCapDeviceResponse
         */

        /**
         * Constructs a new SetMonthlyDataCapDeviceResponse.
         * @memberof pond
         * @classdesc Represents a SetMonthlyDataCapDeviceResponse.
         * @implements ISetMonthlyDataCapDeviceResponse
         * @constructor
         * @param {pond.ISetMonthlyDataCapDeviceResponse=} [properties] Properties to set
         */
        function SetMonthlyDataCapDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SetMonthlyDataCapDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.SetMonthlyDataCapDeviceResponse
         * @static
         * @param {pond.ISetMonthlyDataCapDeviceResponse=} [properties] Properties to set
         * @returns {pond.SetMonthlyDataCapDeviceResponse} SetMonthlyDataCapDeviceResponse instance
         */
        SetMonthlyDataCapDeviceResponse.create = function create(properties) {
            return new SetMonthlyDataCapDeviceResponse(properties);
        };

        /**
         * Creates a SetMonthlyDataCapDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.SetMonthlyDataCapDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.SetMonthlyDataCapDeviceResponse} SetMonthlyDataCapDeviceResponse
         */
        SetMonthlyDataCapDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.SetMonthlyDataCapDeviceResponse)
                return object;
            return new $root.pond.SetMonthlyDataCapDeviceResponse();
        };

        /**
         * Creates a plain object from a SetMonthlyDataCapDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.SetMonthlyDataCapDeviceResponse
         * @static
         * @param {pond.SetMonthlyDataCapDeviceResponse} message SetMonthlyDataCapDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetMonthlyDataCapDeviceResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SetMonthlyDataCapDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.SetMonthlyDataCapDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetMonthlyDataCapDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetMonthlyDataCapDeviceResponse;
    })();

    pond.GetMonthlyDataCapDeviceResponse = (function() {

        /**
         * Properties of a GetMonthlyDataCapDeviceResponse.
         * @memberof pond
         * @interface IGetMonthlyDataCapDeviceResponse
         * @property {number|null} [overlimit] GetMonthlyDataCapDeviceResponse overlimit
         */

        /**
         * Constructs a new GetMonthlyDataCapDeviceResponse.
         * @memberof pond
         * @classdesc Represents a GetMonthlyDataCapDeviceResponse.
         * @implements IGetMonthlyDataCapDeviceResponse
         * @constructor
         * @param {pond.IGetMonthlyDataCapDeviceResponse=} [properties] Properties to set
         */
        function GetMonthlyDataCapDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMonthlyDataCapDeviceResponse overlimit.
         * @member {number} overlimit
         * @memberof pond.GetMonthlyDataCapDeviceResponse
         * @instance
         */
        GetMonthlyDataCapDeviceResponse.prototype.overlimit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new GetMonthlyDataCapDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetMonthlyDataCapDeviceResponse
         * @static
         * @param {pond.IGetMonthlyDataCapDeviceResponse=} [properties] Properties to set
         * @returns {pond.GetMonthlyDataCapDeviceResponse} GetMonthlyDataCapDeviceResponse instance
         */
        GetMonthlyDataCapDeviceResponse.create = function create(properties) {
            return new GetMonthlyDataCapDeviceResponse(properties);
        };

        /**
         * Creates a GetMonthlyDataCapDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetMonthlyDataCapDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetMonthlyDataCapDeviceResponse} GetMonthlyDataCapDeviceResponse
         */
        GetMonthlyDataCapDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetMonthlyDataCapDeviceResponse)
                return object;
            var message = new $root.pond.GetMonthlyDataCapDeviceResponse();
            if (object.overlimit != null)
                if ($util.Long)
                    (message.overlimit = $util.Long.fromValue(object.overlimit)).unsigned = false;
                else if (typeof object.overlimit === "string")
                    message.overlimit = parseInt(object.overlimit, 10);
                else if (typeof object.overlimit === "number")
                    message.overlimit = object.overlimit;
                else if (typeof object.overlimit === "object")
                    message.overlimit = new $util.LongBits(object.overlimit.low >>> 0, object.overlimit.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GetMonthlyDataCapDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetMonthlyDataCapDeviceResponse
         * @static
         * @param {pond.GetMonthlyDataCapDeviceResponse} message GetMonthlyDataCapDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMonthlyDataCapDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.overlimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.overlimit = options.longs === String ? "0" : 0;
            if (message.overlimit != null && message.hasOwnProperty("overlimit"))
                if (typeof message.overlimit === "number")
                    object.overlimit = options.longs === String ? String(message.overlimit) : message.overlimit;
                else
                    object.overlimit = options.longs === String ? $util.Long.prototype.toString.call(message.overlimit) : options.longs === Number ? new $util.LongBits(message.overlimit.low >>> 0, message.overlimit.high >>> 0).toNumber() : message.overlimit;
            return object;
        };

        /**
         * Converts this GetMonthlyDataCapDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.GetMonthlyDataCapDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMonthlyDataCapDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMonthlyDataCapDeviceResponse;
    })();

    pond.IsPausedDeviceResponse = (function() {

        /**
         * Properties of an IsPausedDeviceResponse.
         * @memberof pond
         * @interface IIsPausedDeviceResponse
         * @property {boolean|null} [paused] IsPausedDeviceResponse paused
         */

        /**
         * Constructs a new IsPausedDeviceResponse.
         * @memberof pond
         * @classdesc Represents an IsPausedDeviceResponse.
         * @implements IIsPausedDeviceResponse
         * @constructor
         * @param {pond.IIsPausedDeviceResponse=} [properties] Properties to set
         */
        function IsPausedDeviceResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsPausedDeviceResponse paused.
         * @member {boolean} paused
         * @memberof pond.IsPausedDeviceResponse
         * @instance
         */
        IsPausedDeviceResponse.prototype.paused = false;

        /**
         * Creates a new IsPausedDeviceResponse instance using the specified properties.
         * @function create
         * @memberof pond.IsPausedDeviceResponse
         * @static
         * @param {pond.IIsPausedDeviceResponse=} [properties] Properties to set
         * @returns {pond.IsPausedDeviceResponse} IsPausedDeviceResponse instance
         */
        IsPausedDeviceResponse.create = function create(properties) {
            return new IsPausedDeviceResponse(properties);
        };

        /**
         * Creates an IsPausedDeviceResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.IsPausedDeviceResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.IsPausedDeviceResponse} IsPausedDeviceResponse
         */
        IsPausedDeviceResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.IsPausedDeviceResponse)
                return object;
            var message = new $root.pond.IsPausedDeviceResponse();
            if (object.paused != null)
                message.paused = Boolean(object.paused);
            return message;
        };

        /**
         * Creates a plain object from an IsPausedDeviceResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.IsPausedDeviceResponse
         * @static
         * @param {pond.IsPausedDeviceResponse} message IsPausedDeviceResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsPausedDeviceResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.paused = false;
            if (message.paused != null && message.hasOwnProperty("paused"))
                object.paused = message.paused;
            return object;
        };

        /**
         * Converts this IsPausedDeviceResponse to JSON.
         * @function toJSON
         * @memberof pond.IsPausedDeviceResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsPausedDeviceResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IsPausedDeviceResponse;
    })();

    pond.CellularLink = (function() {

        /**
         * Properties of a CellularLink.
         * @memberof pond
         * @interface ICellularLink
         * @property {number|null} [id] CellularLink id
         * @property {number|null} [deviceid] CellularLink deviceid
         * @property {string|null} [sim] CellularLink sim
         * @property {string|null} [state] CellularLink state
         * @property {number|null} [overagelimit] CellularLink overagelimit
         * @property {number|null} [dataThreshold] CellularLink dataThreshold
         * @property {string|null} [deviceName] CellularLink deviceName
         */

        /**
         * Constructs a new CellularLink.
         * @memberof pond
         * @classdesc Represents a CellularLink.
         * @implements ICellularLink
         * @constructor
         * @param {pond.ICellularLink=} [properties] Properties to set
         */
        function CellularLink(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CellularLink id.
         * @member {number} id
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CellularLink deviceid.
         * @member {number} deviceid
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.deviceid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CellularLink sim.
         * @member {string} sim
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.sim = "";

        /**
         * CellularLink state.
         * @member {string} state
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.state = "";

        /**
         * CellularLink overagelimit.
         * @member {number} overagelimit
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.overagelimit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CellularLink dataThreshold.
         * @member {number} dataThreshold
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.dataThreshold = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CellularLink deviceName.
         * @member {string} deviceName
         * @memberof pond.CellularLink
         * @instance
         */
        CellularLink.prototype.deviceName = "";

        /**
         * Creates a new CellularLink instance using the specified properties.
         * @function create
         * @memberof pond.CellularLink
         * @static
         * @param {pond.ICellularLink=} [properties] Properties to set
         * @returns {pond.CellularLink} CellularLink instance
         */
        CellularLink.create = function create(properties) {
            return new CellularLink(properties);
        };

        /**
         * Creates a CellularLink message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CellularLink
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CellularLink} CellularLink
         */
        CellularLink.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CellularLink)
                return object;
            var message = new $root.pond.CellularLink();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.deviceid != null)
                if ($util.Long)
                    (message.deviceid = $util.Long.fromValue(object.deviceid)).unsigned = true;
                else if (typeof object.deviceid === "string")
                    message.deviceid = parseInt(object.deviceid, 10);
                else if (typeof object.deviceid === "number")
                    message.deviceid = object.deviceid;
                else if (typeof object.deviceid === "object")
                    message.deviceid = new $util.LongBits(object.deviceid.low >>> 0, object.deviceid.high >>> 0).toNumber(true);
            if (object.sim != null)
                message.sim = String(object.sim);
            if (object.state != null)
                message.state = String(object.state);
            if (object.overagelimit != null)
                if ($util.Long)
                    (message.overagelimit = $util.Long.fromValue(object.overagelimit)).unsigned = false;
                else if (typeof object.overagelimit === "string")
                    message.overagelimit = parseInt(object.overagelimit, 10);
                else if (typeof object.overagelimit === "number")
                    message.overagelimit = object.overagelimit;
                else if (typeof object.overagelimit === "object")
                    message.overagelimit = new $util.LongBits(object.overagelimit.low >>> 0, object.overagelimit.high >>> 0).toNumber();
            if (object.dataThreshold != null)
                if ($util.Long)
                    (message.dataThreshold = $util.Long.fromValue(object.dataThreshold)).unsigned = false;
                else if (typeof object.dataThreshold === "string")
                    message.dataThreshold = parseInt(object.dataThreshold, 10);
                else if (typeof object.dataThreshold === "number")
                    message.dataThreshold = object.dataThreshold;
                else if (typeof object.dataThreshold === "object")
                    message.dataThreshold = new $util.LongBits(object.dataThreshold.low >>> 0, object.dataThreshold.high >>> 0).toNumber();
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            return message;
        };

        /**
         * Creates a plain object from a CellularLink message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CellularLink
         * @static
         * @param {pond.CellularLink} message CellularLink
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CellularLink.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceid = options.longs === String ? "0" : 0;
                object.sim = "";
                object.state = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.overagelimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.overagelimit = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.dataThreshold = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.dataThreshold = options.longs === String ? "0" : 0;
                object.deviceName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.deviceid != null && message.hasOwnProperty("deviceid"))
                if (typeof message.deviceid === "number")
                    object.deviceid = options.longs === String ? String(message.deviceid) : message.deviceid;
                else
                    object.deviceid = options.longs === String ? $util.Long.prototype.toString.call(message.deviceid) : options.longs === Number ? new $util.LongBits(message.deviceid.low >>> 0, message.deviceid.high >>> 0).toNumber(true) : message.deviceid;
            if (message.sim != null && message.hasOwnProperty("sim"))
                object.sim = message.sim;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.overagelimit != null && message.hasOwnProperty("overagelimit"))
                if (typeof message.overagelimit === "number")
                    object.overagelimit = options.longs === String ? String(message.overagelimit) : message.overagelimit;
                else
                    object.overagelimit = options.longs === String ? $util.Long.prototype.toString.call(message.overagelimit) : options.longs === Number ? new $util.LongBits(message.overagelimit.low >>> 0, message.overagelimit.high >>> 0).toNumber() : message.overagelimit;
            if (message.dataThreshold != null && message.hasOwnProperty("dataThreshold"))
                if (typeof message.dataThreshold === "number")
                    object.dataThreshold = options.longs === String ? String(message.dataThreshold) : message.dataThreshold;
                else
                    object.dataThreshold = options.longs === String ? $util.Long.prototype.toString.call(message.dataThreshold) : options.longs === Number ? new $util.LongBits(message.dataThreshold.low >>> 0, message.dataThreshold.high >>> 0).toNumber() : message.dataThreshold;
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            return object;
        };

        /**
         * Converts this CellularLink to JSON.
         * @function toJSON
         * @memberof pond.CellularLink
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CellularLink.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CellularLink;
    })();

    pond.State = (function() {

        /**
         * Properties of a State.
         * @memberof pond
         * @interface IState
         * @property {number|null} [id] State id
         * @property {string|null} [timestamp] State timestamp
         * @property {number|null} [linkId] State linkId
         * @property {string|null} [oldstate] State oldstate
         * @property {string|null} [newstate] State newstate
         * @property {string|null} [reason] State reason
         */

        /**
         * Constructs a new State.
         * @memberof pond
         * @classdesc Represents a State.
         * @implements IState
         * @constructor
         * @param {pond.IState=} [properties] Properties to set
         */
        function State(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * State id.
         * @member {number} id
         * @memberof pond.State
         * @instance
         */
        State.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * State timestamp.
         * @member {string} timestamp
         * @memberof pond.State
         * @instance
         */
        State.prototype.timestamp = "";

        /**
         * State linkId.
         * @member {number} linkId
         * @memberof pond.State
         * @instance
         */
        State.prototype.linkId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * State oldstate.
         * @member {string} oldstate
         * @memberof pond.State
         * @instance
         */
        State.prototype.oldstate = "";

        /**
         * State newstate.
         * @member {string} newstate
         * @memberof pond.State
         * @instance
         */
        State.prototype.newstate = "";

        /**
         * State reason.
         * @member {string} reason
         * @memberof pond.State
         * @instance
         */
        State.prototype.reason = "";

        /**
         * Creates a new State instance using the specified properties.
         * @function create
         * @memberof pond.State
         * @static
         * @param {pond.IState=} [properties] Properties to set
         * @returns {pond.State} State instance
         */
        State.create = function create(properties) {
            return new State(properties);
        };

        /**
         * Creates a State message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.State
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.State} State
         */
        State.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.State)
                return object;
            var message = new $root.pond.State();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.linkId != null)
                if ($util.Long)
                    (message.linkId = $util.Long.fromValue(object.linkId)).unsigned = true;
                else if (typeof object.linkId === "string")
                    message.linkId = parseInt(object.linkId, 10);
                else if (typeof object.linkId === "number")
                    message.linkId = object.linkId;
                else if (typeof object.linkId === "object")
                    message.linkId = new $util.LongBits(object.linkId.low >>> 0, object.linkId.high >>> 0).toNumber(true);
            if (object.oldstate != null)
                message.oldstate = String(object.oldstate);
            if (object.newstate != null)
                message.newstate = String(object.newstate);
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from a State message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.State
         * @static
         * @param {pond.State} message State
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        State.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.timestamp = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.linkId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.linkId = options.longs === String ? "0" : 0;
                object.oldstate = "";
                object.newstate = "";
                object.reason = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.linkId != null && message.hasOwnProperty("linkId"))
                if (typeof message.linkId === "number")
                    object.linkId = options.longs === String ? String(message.linkId) : message.linkId;
                else
                    object.linkId = options.longs === String ? $util.Long.prototype.toString.call(message.linkId) : options.longs === Number ? new $util.LongBits(message.linkId.low >>> 0, message.linkId.high >>> 0).toNumber(true) : message.linkId;
            if (message.oldstate != null && message.hasOwnProperty("oldstate"))
                object.oldstate = message.oldstate;
            if (message.newstate != null && message.hasOwnProperty("newstate"))
                object.newstate = message.newstate;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this State to JSON.
         * @function toJSON
         * @memberof pond.State
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        State.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return State;
    })();

    pond.Plan = (function() {

        /**
         * Properties of a Plan.
         * @memberof pond
         * @interface IPlan
         * @property {number|null} [id] Plan id
         * @property {string|null} [name] Plan name
         * @property {number|null} [data] Plan data
         * @property {number|null} [recurring] Plan recurring
         * @property {number|null} [enabled] Plan enabled
         * @property {number|null} [billingPeriod] Plan billingPeriod
         */

        /**
         * Constructs a new Plan.
         * @memberof pond
         * @classdesc Represents a Plan.
         * @implements IPlan
         * @constructor
         * @param {pond.IPlan=} [properties] Properties to set
         */
        function Plan(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Plan id.
         * @member {number} id
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Plan name.
         * @member {string} name
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.name = "";

        /**
         * Plan data.
         * @member {number} data
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.data = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Plan recurring.
         * @member {number} recurring
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.recurring = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Plan enabled.
         * @member {number} enabled
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.enabled = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Plan billingPeriod.
         * @member {number} billingPeriod
         * @memberof pond.Plan
         * @instance
         */
        Plan.prototype.billingPeriod = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Plan instance using the specified properties.
         * @function create
         * @memberof pond.Plan
         * @static
         * @param {pond.IPlan=} [properties] Properties to set
         * @returns {pond.Plan} Plan instance
         */
        Plan.create = function create(properties) {
            return new Plan(properties);
        };

        /**
         * Creates a Plan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Plan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Plan} Plan
         */
        Plan.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Plan)
                return object;
            var message = new $root.pond.Plan();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.data != null)
                if ($util.Long)
                    (message.data = $util.Long.fromValue(object.data)).unsigned = true;
                else if (typeof object.data === "string")
                    message.data = parseInt(object.data, 10);
                else if (typeof object.data === "number")
                    message.data = object.data;
                else if (typeof object.data === "object")
                    message.data = new $util.LongBits(object.data.low >>> 0, object.data.high >>> 0).toNumber(true);
            if (object.recurring != null)
                if ($util.Long)
                    (message.recurring = $util.Long.fromValue(object.recurring)).unsigned = true;
                else if (typeof object.recurring === "string")
                    message.recurring = parseInt(object.recurring, 10);
                else if (typeof object.recurring === "number")
                    message.recurring = object.recurring;
                else if (typeof object.recurring === "object")
                    message.recurring = new $util.LongBits(object.recurring.low >>> 0, object.recurring.high >>> 0).toNumber(true);
            if (object.enabled != null)
                if ($util.Long)
                    (message.enabled = $util.Long.fromValue(object.enabled)).unsigned = true;
                else if (typeof object.enabled === "string")
                    message.enabled = parseInt(object.enabled, 10);
                else if (typeof object.enabled === "number")
                    message.enabled = object.enabled;
                else if (typeof object.enabled === "object")
                    message.enabled = new $util.LongBits(object.enabled.low >>> 0, object.enabled.high >>> 0).toNumber(true);
            if (object.billingPeriod != null)
                if ($util.Long)
                    (message.billingPeriod = $util.Long.fromValue(object.billingPeriod)).unsigned = true;
                else if (typeof object.billingPeriod === "string")
                    message.billingPeriod = parseInt(object.billingPeriod, 10);
                else if (typeof object.billingPeriod === "number")
                    message.billingPeriod = object.billingPeriod;
                else if (typeof object.billingPeriod === "object")
                    message.billingPeriod = new $util.LongBits(object.billingPeriod.low >>> 0, object.billingPeriod.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Plan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Plan
         * @static
         * @param {pond.Plan} message Plan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Plan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.data = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.data = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.recurring = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.recurring = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.enabled = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.enabled = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.billingPeriod = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.billingPeriod = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.data != null && message.hasOwnProperty("data"))
                if (typeof message.data === "number")
                    object.data = options.longs === String ? String(message.data) : message.data;
                else
                    object.data = options.longs === String ? $util.Long.prototype.toString.call(message.data) : options.longs === Number ? new $util.LongBits(message.data.low >>> 0, message.data.high >>> 0).toNumber(true) : message.data;
            if (message.recurring != null && message.hasOwnProperty("recurring"))
                if (typeof message.recurring === "number")
                    object.recurring = options.longs === String ? String(message.recurring) : message.recurring;
                else
                    object.recurring = options.longs === String ? $util.Long.prototype.toString.call(message.recurring) : options.longs === Number ? new $util.LongBits(message.recurring.low >>> 0, message.recurring.high >>> 0).toNumber(true) : message.recurring;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled === "number")
                    object.enabled = options.longs === String ? String(message.enabled) : message.enabled;
                else
                    object.enabled = options.longs === String ? $util.Long.prototype.toString.call(message.enabled) : options.longs === Number ? new $util.LongBits(message.enabled.low >>> 0, message.enabled.high >>> 0).toNumber(true) : message.enabled;
            if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod"))
                if (typeof message.billingPeriod === "number")
                    object.billingPeriod = options.longs === String ? String(message.billingPeriod) : message.billingPeriod;
                else
                    object.billingPeriod = options.longs === String ? $util.Long.prototype.toString.call(message.billingPeriod) : options.longs === Number ? new $util.LongBits(message.billingPeriod.low >>> 0, message.billingPeriod.high >>> 0).toNumber(true) : message.billingPeriod;
            return object;
        };

        /**
         * Converts this Plan to JSON.
         * @function toJSON
         * @memberof pond.Plan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Plan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Plan;
    })();

    pond.PageLink = (function() {

        /**
         * Properties of a PageLink.
         * @memberof pond
         * @interface IPageLink
         * @property {string|null} [path] PageLink path
         * @property {string|null} [base] PageLink base
         * @property {string|null} [next] PageLink next
         */

        /**
         * Constructs a new PageLink.
         * @memberof pond
         * @classdesc Represents a PageLink.
         * @implements IPageLink
         * @constructor
         * @param {pond.IPageLink=} [properties] Properties to set
         */
        function PageLink(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PageLink path.
         * @member {string} path
         * @memberof pond.PageLink
         * @instance
         */
        PageLink.prototype.path = "";

        /**
         * PageLink base.
         * @member {string} base
         * @memberof pond.PageLink
         * @instance
         */
        PageLink.prototype.base = "";

        /**
         * PageLink next.
         * @member {string} next
         * @memberof pond.PageLink
         * @instance
         */
        PageLink.prototype.next = "";

        /**
         * Creates a new PageLink instance using the specified properties.
         * @function create
         * @memberof pond.PageLink
         * @static
         * @param {pond.IPageLink=} [properties] Properties to set
         * @returns {pond.PageLink} PageLink instance
         */
        PageLink.create = function create(properties) {
            return new PageLink(properties);
        };

        /**
         * Creates a PageLink message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.PageLink
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.PageLink} PageLink
         */
        PageLink.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.PageLink)
                return object;
            var message = new $root.pond.PageLink();
            if (object.path != null)
                message.path = String(object.path);
            if (object.base != null)
                message.base = String(object.base);
            if (object.next != null)
                message.next = String(object.next);
            return message;
        };

        /**
         * Creates a plain object from a PageLink message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.PageLink
         * @static
         * @param {pond.PageLink} message PageLink
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PageLink.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.path = "";
                object.base = "";
                object.next = "";
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.base != null && message.hasOwnProperty("base"))
                object.base = message.base;
            if (message.next != null && message.hasOwnProperty("next"))
                object.next = message.next;
            return object;
        };

        /**
         * Converts this PageLink to JSON.
         * @function toJSON
         * @memberof pond.PageLink
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PageLink.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PageLink;
    })();

    pond.Price = (function() {

        /**
         * Properties of a Price.
         * @memberof pond
         * @interface IPrice
         * @property {number|null} [id] Price id
         * @property {string|null} [amount] Price amount
         * @property {string|null} [zone] Price zone
         * @property {string|null} [sms] Price sms
         * @property {string|null} [overage] Price overage
         * @property {number|null} [planId] Price planId
         * @property {string|null} [accountTier] Price accountTier
         */

        /**
         * Constructs a new Price.
         * @memberof pond
         * @classdesc Represents a Price.
         * @implements IPrice
         * @constructor
         * @param {pond.IPrice=} [properties] Properties to set
         */
        function Price(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Price id.
         * @member {number} id
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Price amount.
         * @member {string} amount
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.amount = "";

        /**
         * Price zone.
         * @member {string} zone
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.zone = "";

        /**
         * Price sms.
         * @member {string} sms
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.sms = "";

        /**
         * Price overage.
         * @member {string} overage
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.overage = "";

        /**
         * Price planId.
         * @member {number} planId
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.planId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Price accountTier.
         * @member {string} accountTier
         * @memberof pond.Price
         * @instance
         */
        Price.prototype.accountTier = "";

        /**
         * Creates a new Price instance using the specified properties.
         * @function create
         * @memberof pond.Price
         * @static
         * @param {pond.IPrice=} [properties] Properties to set
         * @returns {pond.Price} Price instance
         */
        Price.create = function create(properties) {
            return new Price(properties);
        };

        /**
         * Creates a Price message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Price
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Price} Price
         */
        Price.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Price)
                return object;
            var message = new $root.pond.Price();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.amount != null)
                message.amount = String(object.amount);
            if (object.zone != null)
                message.zone = String(object.zone);
            if (object.sms != null)
                message.sms = String(object.sms);
            if (object.overage != null)
                message.overage = String(object.overage);
            if (object.planId != null)
                if ($util.Long)
                    (message.planId = $util.Long.fromValue(object.planId)).unsigned = true;
                else if (typeof object.planId === "string")
                    message.planId = parseInt(object.planId, 10);
                else if (typeof object.planId === "number")
                    message.planId = object.planId;
                else if (typeof object.planId === "object")
                    message.planId = new $util.LongBits(object.planId.low >>> 0, object.planId.high >>> 0).toNumber(true);
            if (object.accountTier != null)
                message.accountTier = String(object.accountTier);
            return message;
        };

        /**
         * Creates a plain object from a Price message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Price
         * @static
         * @param {pond.Price} message Price
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Price.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.amount = "";
                object.zone = "";
                object.sms = "";
                object.overage = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.planId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.planId = options.longs === String ? "0" : 0;
                object.accountTier = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = message.amount;
            if (message.zone != null && message.hasOwnProperty("zone"))
                object.zone = message.zone;
            if (message.sms != null && message.hasOwnProperty("sms"))
                object.sms = message.sms;
            if (message.overage != null && message.hasOwnProperty("overage"))
                object.overage = message.overage;
            if (message.planId != null && message.hasOwnProperty("planId"))
                if (typeof message.planId === "number")
                    object.planId = options.longs === String ? String(message.planId) : message.planId;
                else
                    object.planId = options.longs === String ? $util.Long.prototype.toString.call(message.planId) : options.longs === Number ? new $util.LongBits(message.planId.low >>> 0, message.planId.high >>> 0).toNumber(true) : message.planId;
            if (message.accountTier != null && message.hasOwnProperty("accountTier"))
                object.accountTier = message.accountTier;
            return object;
        };

        /**
         * Converts this Price to JSON.
         * @function toJSON
         * @memberof pond.Price
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Price.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Price;
    })();

    pond.HoloMessage = (function() {

        /**
         * Properties of a HoloMessage.
         * @memberof pond
         * @interface IHoloMessage
         * @property {number|null} [id] HoloMessage id
         * @property {string|null} [logged] HoloMessage logged
         * @property {string|null} [expires] HoloMessage expires
         * @property {number|null} [deviceId] HoloMessage deviceId
         * @property {string|null} [data] HoloMessage data
         * @property {string|null} [recordId] HoloMessage recordId
         * @property {Array.<string>|null} [tags] HoloMessage tags
         */

        /**
         * Constructs a new HoloMessage.
         * @memberof pond
         * @classdesc Represents a HoloMessage.
         * @implements IHoloMessage
         * @constructor
         * @param {pond.IHoloMessage=} [properties] Properties to set
         */
        function HoloMessage(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HoloMessage id.
         * @member {number} id
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloMessage logged.
         * @member {string} logged
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.logged = "";

        /**
         * HoloMessage expires.
         * @member {string} expires
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.expires = "";

        /**
         * HoloMessage deviceId.
         * @member {number} deviceId
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.deviceId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * HoloMessage data.
         * @member {string} data
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.data = "";

        /**
         * HoloMessage recordId.
         * @member {string} recordId
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.recordId = "";

        /**
         * HoloMessage tags.
         * @member {Array.<string>} tags
         * @memberof pond.HoloMessage
         * @instance
         */
        HoloMessage.prototype.tags = $util.emptyArray;

        /**
         * Creates a new HoloMessage instance using the specified properties.
         * @function create
         * @memberof pond.HoloMessage
         * @static
         * @param {pond.IHoloMessage=} [properties] Properties to set
         * @returns {pond.HoloMessage} HoloMessage instance
         */
        HoloMessage.create = function create(properties) {
            return new HoloMessage(properties);
        };

        /**
         * Creates a HoloMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.HoloMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.HoloMessage} HoloMessage
         */
        HoloMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.HoloMessage)
                return object;
            var message = new $root.pond.HoloMessage();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.logged != null)
                message.logged = String(object.logged);
            if (object.expires != null)
                message.expires = String(object.expires);
            if (object.deviceId != null)
                if ($util.Long)
                    (message.deviceId = $util.Long.fromValue(object.deviceId)).unsigned = true;
                else if (typeof object.deviceId === "string")
                    message.deviceId = parseInt(object.deviceId, 10);
                else if (typeof object.deviceId === "number")
                    message.deviceId = object.deviceId;
                else if (typeof object.deviceId === "object")
                    message.deviceId = new $util.LongBits(object.deviceId.low >>> 0, object.deviceId.high >>> 0).toNumber(true);
            if (object.data != null)
                message.data = String(object.data);
            if (object.recordId != null)
                message.recordId = String(object.recordId);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.HoloMessage.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a HoloMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.HoloMessage
         * @static
         * @param {pond.HoloMessage} message HoloMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HoloMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.logged = "";
                object.expires = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.deviceId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deviceId = options.longs === String ? "0" : 0;
                object.data = "";
                object.recordId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.logged != null && message.hasOwnProperty("logged"))
                object.logged = message.logged;
            if (message.expires != null && message.hasOwnProperty("expires"))
                object.expires = message.expires;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (typeof message.deviceId === "number")
                    object.deviceId = options.longs === String ? String(message.deviceId) : message.deviceId;
                else
                    object.deviceId = options.longs === String ? $util.Long.prototype.toString.call(message.deviceId) : options.longs === Number ? new $util.LongBits(message.deviceId.low >>> 0, message.deviceId.high >>> 0).toNumber(true) : message.deviceId;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.recordId != null && message.hasOwnProperty("recordId"))
                object.recordId = message.recordId;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            return object;
        };

        /**
         * Converts this HoloMessage to JSON.
         * @function toJSON
         * @memberof pond.HoloMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HoloMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HoloMessage;
    })();

    pond.Balance = (function() {

        /**
         * Properties of a Balance.
         * @memberof pond
         * @interface IBalance
         * @property {number|null} [userId] Balance userId
         * @property {string|null} [balance] Balance balance
         * @property {string|null} [promoBalance] Balance promoBalance
         * @property {string|null} [minBalance] Balance minBalance
         * @property {string|null} [topOffAmount] Balance topOffAmount
         * @property {string|null} [pendingCharges] Balance pendingCharges
         */

        /**
         * Constructs a new Balance.
         * @memberof pond
         * @classdesc Represents a Balance.
         * @implements IBalance
         * @constructor
         * @param {pond.IBalance=} [properties] Properties to set
         */
        function Balance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Balance userId.
         * @member {number} userId
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Balance balance.
         * @member {string} balance
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.balance = "";

        /**
         * Balance promoBalance.
         * @member {string} promoBalance
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.promoBalance = "";

        /**
         * Balance minBalance.
         * @member {string} minBalance
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.minBalance = "";

        /**
         * Balance topOffAmount.
         * @member {string} topOffAmount
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.topOffAmount = "";

        /**
         * Balance pendingCharges.
         * @member {string} pendingCharges
         * @memberof pond.Balance
         * @instance
         */
        Balance.prototype.pendingCharges = "";

        /**
         * Creates a new Balance instance using the specified properties.
         * @function create
         * @memberof pond.Balance
         * @static
         * @param {pond.IBalance=} [properties] Properties to set
         * @returns {pond.Balance} Balance instance
         */
        Balance.create = function create(properties) {
            return new Balance(properties);
        };

        /**
         * Creates a Balance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Balance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Balance} Balance
         */
        Balance.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Balance)
                return object;
            var message = new $root.pond.Balance();
            if (object.userId != null)
                if ($util.Long)
                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = true;
                else if (typeof object.userId === "string")
                    message.userId = parseInt(object.userId, 10);
                else if (typeof object.userId === "number")
                    message.userId = object.userId;
                else if (typeof object.userId === "object")
                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber(true);
            if (object.balance != null)
                message.balance = String(object.balance);
            if (object.promoBalance != null)
                message.promoBalance = String(object.promoBalance);
            if (object.minBalance != null)
                message.minBalance = String(object.minBalance);
            if (object.topOffAmount != null)
                message.topOffAmount = String(object.topOffAmount);
            if (object.pendingCharges != null)
                message.pendingCharges = String(object.pendingCharges);
            return message;
        };

        /**
         * Creates a plain object from a Balance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Balance
         * @static
         * @param {pond.Balance} message Balance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Balance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userId = options.longs === String ? "0" : 0;
                object.balance = "";
                object.promoBalance = "";
                object.minBalance = "";
                object.topOffAmount = "";
                object.pendingCharges = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (typeof message.userId === "number")
                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                else
                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber(true) : message.userId;
            if (message.balance != null && message.hasOwnProperty("balance"))
                object.balance = message.balance;
            if (message.promoBalance != null && message.hasOwnProperty("promoBalance"))
                object.promoBalance = message.promoBalance;
            if (message.minBalance != null && message.hasOwnProperty("minBalance"))
                object.minBalance = message.minBalance;
            if (message.topOffAmount != null && message.hasOwnProperty("topOffAmount"))
                object.topOffAmount = message.topOffAmount;
            if (message.pendingCharges != null && message.hasOwnProperty("pendingCharges"))
                object.pendingCharges = message.pendingCharges;
            return object;
        };

        /**
         * Converts this Balance to JSON.
         * @function toJSON
         * @memberof pond.Balance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Balance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Balance;
    })();

    pond.BalanceHistory = (function() {

        /**
         * Properties of a BalanceHistory.
         * @memberof pond
         * @interface IBalanceHistory
         * @property {number|null} [id] BalanceHistory id
         * @property {string|null} [time] BalanceHistory time
         * @property {string|null} [description] BalanceHistory description
         * @property {string|null} [amount] BalanceHistory amount
         * @property {string|null} [transactionTypeId] BalanceHistory transactionTypeId
         * @property {number|null} [orderId] BalanceHistory orderId
         * @property {Array.<string>|null} [linkIds] BalanceHistory linkIds
         */

        /**
         * Constructs a new BalanceHistory.
         * @memberof pond
         * @classdesc Represents a BalanceHistory.
         * @implements IBalanceHistory
         * @constructor
         * @param {pond.IBalanceHistory=} [properties] Properties to set
         */
        function BalanceHistory(properties) {
            this.linkIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BalanceHistory id.
         * @member {number} id
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * BalanceHistory time.
         * @member {string} time
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.time = "";

        /**
         * BalanceHistory description.
         * @member {string} description
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.description = "";

        /**
         * BalanceHistory amount.
         * @member {string} amount
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.amount = "";

        /**
         * BalanceHistory transactionTypeId.
         * @member {string} transactionTypeId
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.transactionTypeId = "";

        /**
         * BalanceHistory orderId.
         * @member {number} orderId
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.orderId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * BalanceHistory linkIds.
         * @member {Array.<string>} linkIds
         * @memberof pond.BalanceHistory
         * @instance
         */
        BalanceHistory.prototype.linkIds = $util.emptyArray;

        /**
         * Creates a new BalanceHistory instance using the specified properties.
         * @function create
         * @memberof pond.BalanceHistory
         * @static
         * @param {pond.IBalanceHistory=} [properties] Properties to set
         * @returns {pond.BalanceHistory} BalanceHistory instance
         */
        BalanceHistory.create = function create(properties) {
            return new BalanceHistory(properties);
        };

        /**
         * Creates a BalanceHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BalanceHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BalanceHistory} BalanceHistory
         */
        BalanceHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BalanceHistory)
                return object;
            var message = new $root.pond.BalanceHistory();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.time != null)
                message.time = String(object.time);
            if (object.description != null)
                message.description = String(object.description);
            if (object.amount != null)
                message.amount = String(object.amount);
            if (object.transactionTypeId != null)
                message.transactionTypeId = String(object.transactionTypeId);
            if (object.orderId != null)
                if ($util.Long)
                    (message.orderId = $util.Long.fromValue(object.orderId)).unsigned = true;
                else if (typeof object.orderId === "string")
                    message.orderId = parseInt(object.orderId, 10);
                else if (typeof object.orderId === "number")
                    message.orderId = object.orderId;
                else if (typeof object.orderId === "object")
                    message.orderId = new $util.LongBits(object.orderId.low >>> 0, object.orderId.high >>> 0).toNumber(true);
            if (object.linkIds) {
                if (!Array.isArray(object.linkIds))
                    throw TypeError(".pond.BalanceHistory.linkIds: array expected");
                message.linkIds = [];
                for (var i = 0; i < object.linkIds.length; ++i)
                    message.linkIds[i] = String(object.linkIds[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a BalanceHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BalanceHistory
         * @static
         * @param {pond.BalanceHistory} message BalanceHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BalanceHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.linkIds = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.time = "";
                object.description = "";
                object.amount = "";
                object.transactionTypeId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.orderId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.orderId = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = message.amount;
            if (message.transactionTypeId != null && message.hasOwnProperty("transactionTypeId"))
                object.transactionTypeId = message.transactionTypeId;
            if (message.orderId != null && message.hasOwnProperty("orderId"))
                if (typeof message.orderId === "number")
                    object.orderId = options.longs === String ? String(message.orderId) : message.orderId;
                else
                    object.orderId = options.longs === String ? $util.Long.prototype.toString.call(message.orderId) : options.longs === Number ? new $util.LongBits(message.orderId.low >>> 0, message.orderId.high >>> 0).toNumber(true) : message.orderId;
            if (message.linkIds && message.linkIds.length) {
                object.linkIds = [];
                for (var j = 0; j < message.linkIds.length; ++j)
                    object.linkIds[j] = message.linkIds[j];
            }
            return object;
        };

        /**
         * Converts this BalanceHistory to JSON.
         * @function toJSON
         * @memberof pond.BalanceHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BalanceHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BalanceHistory;
    })();

    pond.Terminal = (function() {

        /**
         * Properties of a Terminal.
         * @memberof pond
         * @interface ITerminal
         * @property {string|null} [key] Terminal key
         * @property {string|null} [name] Terminal name
         * @property {pond.TerminalSettings|null} [settings] Terminal settings
         */

        /**
         * Constructs a new Terminal.
         * @memberof pond
         * @classdesc Represents a Terminal.
         * @implements ITerminal
         * @constructor
         * @param {pond.ITerminal=} [properties] Properties to set
         */
        function Terminal(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Terminal key.
         * @member {string} key
         * @memberof pond.Terminal
         * @instance
         */
        Terminal.prototype.key = "";

        /**
         * Terminal name.
         * @member {string} name
         * @memberof pond.Terminal
         * @instance
         */
        Terminal.prototype.name = "";

        /**
         * Terminal settings.
         * @member {pond.TerminalSettings|null|undefined} settings
         * @memberof pond.Terminal
         * @instance
         */
        Terminal.prototype.settings = null;

        /**
         * Creates a new Terminal instance using the specified properties.
         * @function create
         * @memberof pond.Terminal
         * @static
         * @param {pond.ITerminal=} [properties] Properties to set
         * @returns {pond.Terminal} Terminal instance
         */
        Terminal.create = function create(properties) {
            return new Terminal(properties);
        };

        /**
         * Creates a Terminal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Terminal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Terminal} Terminal
         */
        Terminal.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Terminal)
                return object;
            var message = new $root.pond.Terminal();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Terminal.settings: object expected");
                message.settings = $root.pond.TerminalSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Terminal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Terminal
         * @static
         * @param {pond.Terminal} message Terminal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Terminal.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TerminalSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this Terminal to JSON.
         * @function toJSON
         * @memberof pond.Terminal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Terminal.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Terminal;
    })();

    pond.TerminalSettings = (function() {

        /**
         * Properties of a TerminalSettings.
         * @memberof pond
         * @interface ITerminalSettings
         * @property {number|null} [longitude] TerminalSettings longitude
         * @property {number|null} [latitude] TerminalSettings latitude
         * @property {pond.ObjectTheme|null} [theme] TerminalSettings theme
         */

        /**
         * Constructs a new TerminalSettings.
         * @memberof pond
         * @classdesc Represents a TerminalSettings.
         * @implements ITerminalSettings
         * @constructor
         * @param {pond.ITerminalSettings=} [properties] Properties to set
         */
        function TerminalSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TerminalSettings longitude.
         * @member {number} longitude
         * @memberof pond.TerminalSettings
         * @instance
         */
        TerminalSettings.prototype.longitude = 0;

        /**
         * TerminalSettings latitude.
         * @member {number} latitude
         * @memberof pond.TerminalSettings
         * @instance
         */
        TerminalSettings.prototype.latitude = 0;

        /**
         * TerminalSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.TerminalSettings
         * @instance
         */
        TerminalSettings.prototype.theme = null;

        /**
         * Creates a new TerminalSettings instance using the specified properties.
         * @function create
         * @memberof pond.TerminalSettings
         * @static
         * @param {pond.ITerminalSettings=} [properties] Properties to set
         * @returns {pond.TerminalSettings} TerminalSettings instance
         */
        TerminalSettings.create = function create(properties) {
            return new TerminalSettings(properties);
        };

        /**
         * Creates a TerminalSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.TerminalSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.TerminalSettings} TerminalSettings
         */
        TerminalSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.TerminalSettings)
                return object;
            var message = new $root.pond.TerminalSettings();
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.TerminalSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            return message;
        };

        /**
         * Creates a plain object from a TerminalSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.TerminalSettings
         * @static
         * @param {pond.TerminalSettings} message TerminalSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TerminalSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.longitude = 0;
                object.latitude = 0;
                object.theme = null;
            }
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            return object;
        };

        /**
         * Converts this TerminalSettings to JSON.
         * @function toJSON
         * @memberof pond.TerminalSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TerminalSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TerminalSettings;
    })();

    pond.AddTerminalRequest = (function() {

        /**
         * Properties of an AddTerminalRequest.
         * @memberof pond
         * @interface IAddTerminalRequest
         * @property {string|null} [name] AddTerminalRequest name
         * @property {pond.TerminalSettings|null} [settings] AddTerminalRequest settings
         */

        /**
         * Constructs a new AddTerminalRequest.
         * @memberof pond
         * @classdesc Represents an AddTerminalRequest.
         * @implements IAddTerminalRequest
         * @constructor
         * @param {pond.IAddTerminalRequest=} [properties] Properties to set
         */
        function AddTerminalRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTerminalRequest name.
         * @member {string} name
         * @memberof pond.AddTerminalRequest
         * @instance
         */
        AddTerminalRequest.prototype.name = "";

        /**
         * AddTerminalRequest settings.
         * @member {pond.TerminalSettings|null|undefined} settings
         * @memberof pond.AddTerminalRequest
         * @instance
         */
        AddTerminalRequest.prototype.settings = null;

        /**
         * Creates a new AddTerminalRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddTerminalRequest
         * @static
         * @param {pond.IAddTerminalRequest=} [properties] Properties to set
         * @returns {pond.AddTerminalRequest} AddTerminalRequest instance
         */
        AddTerminalRequest.create = function create(properties) {
            return new AddTerminalRequest(properties);
        };

        /**
         * Creates an AddTerminalRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTerminalRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTerminalRequest} AddTerminalRequest
         */
        AddTerminalRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTerminalRequest)
                return object;
            var message = new $root.pond.AddTerminalRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddTerminalRequest.settings: object expected");
                message.settings = $root.pond.TerminalSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTerminalRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTerminalRequest
         * @static
         * @param {pond.AddTerminalRequest} message AddTerminalRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTerminalRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TerminalSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddTerminalRequest to JSON.
         * @function toJSON
         * @memberof pond.AddTerminalRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTerminalRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTerminalRequest;
    })();

    pond.AddTerminalResponse = (function() {

        /**
         * Properties of an AddTerminalResponse.
         * @memberof pond
         * @interface IAddTerminalResponse
         * @property {string|null} [key] AddTerminalResponse key
         */

        /**
         * Constructs a new AddTerminalResponse.
         * @memberof pond
         * @classdesc Represents an AddTerminalResponse.
         * @implements IAddTerminalResponse
         * @constructor
         * @param {pond.IAddTerminalResponse=} [properties] Properties to set
         */
        function AddTerminalResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTerminalResponse key.
         * @member {string} key
         * @memberof pond.AddTerminalResponse
         * @instance
         */
        AddTerminalResponse.prototype.key = "";

        /**
         * Creates a new AddTerminalResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddTerminalResponse
         * @static
         * @param {pond.IAddTerminalResponse=} [properties] Properties to set
         * @returns {pond.AddTerminalResponse} AddTerminalResponse instance
         */
        AddTerminalResponse.create = function create(properties) {
            return new AddTerminalResponse(properties);
        };

        /**
         * Creates an AddTerminalResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddTerminalResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddTerminalResponse} AddTerminalResponse
         */
        AddTerminalResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddTerminalResponse)
                return object;
            var message = new $root.pond.AddTerminalResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddTerminalResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddTerminalResponse
         * @static
         * @param {pond.AddTerminalResponse} message AddTerminalResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTerminalResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddTerminalResponse to JSON.
         * @function toJSON
         * @memberof pond.AddTerminalResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTerminalResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddTerminalResponse;
    })();

    pond.ListTerminalsRequest = (function() {

        /**
         * Properties of a ListTerminalsRequest.
         * @memberof pond
         * @interface IListTerminalsRequest
         * @property {pond.Paging|null} [paging] ListTerminalsRequest paging
         * @property {pond.Sorting|null} [sorting] ListTerminalsRequest sorting
         * @property {string|null} [search] ListTerminalsRequest search
         */

        /**
         * Constructs a new ListTerminalsRequest.
         * @memberof pond
         * @classdesc Represents a ListTerminalsRequest.
         * @implements IListTerminalsRequest
         * @constructor
         * @param {pond.IListTerminalsRequest=} [properties] Properties to set
         */
        function ListTerminalsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTerminalsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListTerminalsRequest
         * @instance
         */
        ListTerminalsRequest.prototype.paging = null;

        /**
         * ListTerminalsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListTerminalsRequest
         * @instance
         */
        ListTerminalsRequest.prototype.sorting = null;

        /**
         * ListTerminalsRequest search.
         * @member {string} search
         * @memberof pond.ListTerminalsRequest
         * @instance
         */
        ListTerminalsRequest.prototype.search = "";

        /**
         * Creates a new ListTerminalsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListTerminalsRequest
         * @static
         * @param {pond.IListTerminalsRequest=} [properties] Properties to set
         * @returns {pond.ListTerminalsRequest} ListTerminalsRequest instance
         */
        ListTerminalsRequest.create = function create(properties) {
            return new ListTerminalsRequest(properties);
        };

        /**
         * Creates a ListTerminalsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTerminalsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTerminalsRequest} ListTerminalsRequest
         */
        ListTerminalsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTerminalsRequest)
                return object;
            var message = new $root.pond.ListTerminalsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListTerminalsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListTerminalsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListTerminalsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTerminalsRequest
         * @static
         * @param {pond.ListTerminalsRequest} message ListTerminalsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTerminalsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListTerminalsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListTerminalsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTerminalsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTerminalsRequest;
    })();

    pond.ListTerminalsResponse = (function() {

        /**
         * Properties of a ListTerminalsResponse.
         * @memberof pond
         * @interface IListTerminalsResponse
         * @property {Array.<pond.Terminal>|null} [terminals] ListTerminalsResponse terminals
         * @property {number|null} [nextOffset] ListTerminalsResponse nextOffset
         * @property {number|null} [total] ListTerminalsResponse total
         */

        /**
         * Constructs a new ListTerminalsResponse.
         * @memberof pond
         * @classdesc Represents a ListTerminalsResponse.
         * @implements IListTerminalsResponse
         * @constructor
         * @param {pond.IListTerminalsResponse=} [properties] Properties to set
         */
        function ListTerminalsResponse(properties) {
            this.terminals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTerminalsResponse terminals.
         * @member {Array.<pond.Terminal>} terminals
         * @memberof pond.ListTerminalsResponse
         * @instance
         */
        ListTerminalsResponse.prototype.terminals = $util.emptyArray;

        /**
         * ListTerminalsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListTerminalsResponse
         * @instance
         */
        ListTerminalsResponse.prototype.nextOffset = 0;

        /**
         * ListTerminalsResponse total.
         * @member {number} total
         * @memberof pond.ListTerminalsResponse
         * @instance
         */
        ListTerminalsResponse.prototype.total = 0;

        /**
         * Creates a new ListTerminalsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTerminalsResponse
         * @static
         * @param {pond.IListTerminalsResponse=} [properties] Properties to set
         * @returns {pond.ListTerminalsResponse} ListTerminalsResponse instance
         */
        ListTerminalsResponse.create = function create(properties) {
            return new ListTerminalsResponse(properties);
        };

        /**
         * Creates a ListTerminalsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTerminalsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTerminalsResponse} ListTerminalsResponse
         */
        ListTerminalsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTerminalsResponse)
                return object;
            var message = new $root.pond.ListTerminalsResponse();
            if (object.terminals) {
                if (!Array.isArray(object.terminals))
                    throw TypeError(".pond.ListTerminalsResponse.terminals: array expected");
                message.terminals = [];
                for (var i = 0; i < object.terminals.length; ++i) {
                    if (typeof object.terminals[i] !== "object")
                        throw TypeError(".pond.ListTerminalsResponse.terminals: object expected");
                    message.terminals[i] = $root.pond.Terminal.fromObject(object.terminals[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListTerminalsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTerminalsResponse
         * @static
         * @param {pond.ListTerminalsResponse} message ListTerminalsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTerminalsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.terminals = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.terminals && message.terminals.length) {
                object.terminals = [];
                for (var j = 0; j < message.terminals.length; ++j)
                    object.terminals[j] = $root.pond.Terminal.toObject(message.terminals[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListTerminalsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTerminalsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTerminalsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTerminalsResponse;
    })();

    pond.ListTerminalsAndGatesResponse = (function() {

        /**
         * Properties of a ListTerminalsAndGatesResponse.
         * @memberof pond
         * @interface IListTerminalsAndGatesResponse
         * @property {Array.<pond.Terminal>|null} [terminals] ListTerminalsAndGatesResponse terminals
         * @property {Array.<pond.Gate>|null} [gates] ListTerminalsAndGatesResponse gates
         */

        /**
         * Constructs a new ListTerminalsAndGatesResponse.
         * @memberof pond
         * @classdesc Represents a ListTerminalsAndGatesResponse.
         * @implements IListTerminalsAndGatesResponse
         * @constructor
         * @param {pond.IListTerminalsAndGatesResponse=} [properties] Properties to set
         */
        function ListTerminalsAndGatesResponse(properties) {
            this.terminals = [];
            this.gates = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTerminalsAndGatesResponse terminals.
         * @member {Array.<pond.Terminal>} terminals
         * @memberof pond.ListTerminalsAndGatesResponse
         * @instance
         */
        ListTerminalsAndGatesResponse.prototype.terminals = $util.emptyArray;

        /**
         * ListTerminalsAndGatesResponse gates.
         * @member {Array.<pond.Gate>} gates
         * @memberof pond.ListTerminalsAndGatesResponse
         * @instance
         */
        ListTerminalsAndGatesResponse.prototype.gates = $util.emptyArray;

        /**
         * Creates a new ListTerminalsAndGatesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListTerminalsAndGatesResponse
         * @static
         * @param {pond.IListTerminalsAndGatesResponse=} [properties] Properties to set
         * @returns {pond.ListTerminalsAndGatesResponse} ListTerminalsAndGatesResponse instance
         */
        ListTerminalsAndGatesResponse.create = function create(properties) {
            return new ListTerminalsAndGatesResponse(properties);
        };

        /**
         * Creates a ListTerminalsAndGatesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListTerminalsAndGatesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListTerminalsAndGatesResponse} ListTerminalsAndGatesResponse
         */
        ListTerminalsAndGatesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListTerminalsAndGatesResponse)
                return object;
            var message = new $root.pond.ListTerminalsAndGatesResponse();
            if (object.terminals) {
                if (!Array.isArray(object.terminals))
                    throw TypeError(".pond.ListTerminalsAndGatesResponse.terminals: array expected");
                message.terminals = [];
                for (var i = 0; i < object.terminals.length; ++i) {
                    if (typeof object.terminals[i] !== "object")
                        throw TypeError(".pond.ListTerminalsAndGatesResponse.terminals: object expected");
                    message.terminals[i] = $root.pond.Terminal.fromObject(object.terminals[i]);
                }
            }
            if (object.gates) {
                if (!Array.isArray(object.gates))
                    throw TypeError(".pond.ListTerminalsAndGatesResponse.gates: array expected");
                message.gates = [];
                for (var i = 0; i < object.gates.length; ++i) {
                    if (typeof object.gates[i] !== "object")
                        throw TypeError(".pond.ListTerminalsAndGatesResponse.gates: object expected");
                    message.gates[i] = $root.pond.Gate.fromObject(object.gates[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListTerminalsAndGatesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListTerminalsAndGatesResponse
         * @static
         * @param {pond.ListTerminalsAndGatesResponse} message ListTerminalsAndGatesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTerminalsAndGatesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.terminals = [];
                object.gates = [];
            }
            if (message.terminals && message.terminals.length) {
                object.terminals = [];
                for (var j = 0; j < message.terminals.length; ++j)
                    object.terminals[j] = $root.pond.Terminal.toObject(message.terminals[j], options);
            }
            if (message.gates && message.gates.length) {
                object.gates = [];
                for (var j = 0; j < message.gates.length; ++j)
                    object.gates[j] = $root.pond.Gate.toObject(message.gates[j], options);
            }
            return object;
        };

        /**
         * Converts this ListTerminalsAndGatesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListTerminalsAndGatesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTerminalsAndGatesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListTerminalsAndGatesResponse;
    })();

    pond.GetTerminalRequest = (function() {

        /**
         * Properties of a GetTerminalRequest.
         * @memberof pond
         * @interface IGetTerminalRequest
         * @property {string|null} [key] GetTerminalRequest key
         */

        /**
         * Constructs a new GetTerminalRequest.
         * @memberof pond
         * @classdesc Represents a GetTerminalRequest.
         * @implements IGetTerminalRequest
         * @constructor
         * @param {pond.IGetTerminalRequest=} [properties] Properties to set
         */
        function GetTerminalRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTerminalRequest key.
         * @member {string} key
         * @memberof pond.GetTerminalRequest
         * @instance
         */
        GetTerminalRequest.prototype.key = "";

        /**
         * Creates a new GetTerminalRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetTerminalRequest
         * @static
         * @param {pond.IGetTerminalRequest=} [properties] Properties to set
         * @returns {pond.GetTerminalRequest} GetTerminalRequest instance
         */
        GetTerminalRequest.create = function create(properties) {
            return new GetTerminalRequest(properties);
        };

        /**
         * Creates a GetTerminalRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTerminalRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTerminalRequest} GetTerminalRequest
         */
        GetTerminalRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTerminalRequest)
                return object;
            var message = new $root.pond.GetTerminalRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetTerminalRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTerminalRequest
         * @static
         * @param {pond.GetTerminalRequest} message GetTerminalRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTerminalRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetTerminalRequest to JSON.
         * @function toJSON
         * @memberof pond.GetTerminalRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTerminalRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTerminalRequest;
    })();

    pond.GetTerminalResponse = (function() {

        /**
         * Properties of a GetTerminalResponse.
         * @memberof pond
         * @interface IGetTerminalResponse
         * @property {pond.Terminal|null} [terminal] GetTerminalResponse terminal
         */

        /**
         * Constructs a new GetTerminalResponse.
         * @memberof pond
         * @classdesc Represents a GetTerminalResponse.
         * @implements IGetTerminalResponse
         * @constructor
         * @param {pond.IGetTerminalResponse=} [properties] Properties to set
         */
        function GetTerminalResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTerminalResponse terminal.
         * @member {pond.Terminal|null|undefined} terminal
         * @memberof pond.GetTerminalResponse
         * @instance
         */
        GetTerminalResponse.prototype.terminal = null;

        /**
         * Creates a new GetTerminalResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetTerminalResponse
         * @static
         * @param {pond.IGetTerminalResponse=} [properties] Properties to set
         * @returns {pond.GetTerminalResponse} GetTerminalResponse instance
         */
        GetTerminalResponse.create = function create(properties) {
            return new GetTerminalResponse(properties);
        };

        /**
         * Creates a GetTerminalResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetTerminalResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetTerminalResponse} GetTerminalResponse
         */
        GetTerminalResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetTerminalResponse)
                return object;
            var message = new $root.pond.GetTerminalResponse();
            if (object.terminal != null) {
                if (typeof object.terminal !== "object")
                    throw TypeError(".pond.GetTerminalResponse.terminal: object expected");
                message.terminal = $root.pond.Terminal.fromObject(object.terminal);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetTerminalResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetTerminalResponse
         * @static
         * @param {pond.GetTerminalResponse} message GetTerminalResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTerminalResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.terminal = null;
            if (message.terminal != null && message.hasOwnProperty("terminal"))
                object.terminal = $root.pond.Terminal.toObject(message.terminal, options);
            return object;
        };

        /**
         * Converts this GetTerminalResponse to JSON.
         * @function toJSON
         * @memberof pond.GetTerminalResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTerminalResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetTerminalResponse;
    })();

    pond.UpdateTerminalRequest = (function() {

        /**
         * Properties of an UpdateTerminalRequest.
         * @memberof pond
         * @interface IUpdateTerminalRequest
         * @property {string|null} [key] UpdateTerminalRequest key
         * @property {string|null} [name] UpdateTerminalRequest name
         * @property {pond.TerminalSettings|null} [settings] UpdateTerminalRequest settings
         */

        /**
         * Constructs a new UpdateTerminalRequest.
         * @memberof pond
         * @classdesc Represents an UpdateTerminalRequest.
         * @implements IUpdateTerminalRequest
         * @constructor
         * @param {pond.IUpdateTerminalRequest=} [properties] Properties to set
         */
        function UpdateTerminalRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTerminalRequest key.
         * @member {string} key
         * @memberof pond.UpdateTerminalRequest
         * @instance
         */
        UpdateTerminalRequest.prototype.key = "";

        /**
         * UpdateTerminalRequest name.
         * @member {string} name
         * @memberof pond.UpdateTerminalRequest
         * @instance
         */
        UpdateTerminalRequest.prototype.name = "";

        /**
         * UpdateTerminalRequest settings.
         * @member {pond.TerminalSettings|null|undefined} settings
         * @memberof pond.UpdateTerminalRequest
         * @instance
         */
        UpdateTerminalRequest.prototype.settings = null;

        /**
         * Creates a new UpdateTerminalRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTerminalRequest
         * @static
         * @param {pond.IUpdateTerminalRequest=} [properties] Properties to set
         * @returns {pond.UpdateTerminalRequest} UpdateTerminalRequest instance
         */
        UpdateTerminalRequest.create = function create(properties) {
            return new UpdateTerminalRequest(properties);
        };

        /**
         * Creates an UpdateTerminalRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTerminalRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTerminalRequest} UpdateTerminalRequest
         */
        UpdateTerminalRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTerminalRequest)
                return object;
            var message = new $root.pond.UpdateTerminalRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateTerminalRequest.settings: object expected");
                message.settings = $root.pond.TerminalSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTerminalRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTerminalRequest
         * @static
         * @param {pond.UpdateTerminalRequest} message UpdateTerminalRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTerminalRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.TerminalSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateTerminalRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateTerminalRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTerminalRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTerminalRequest;
    })();

    pond.UpdateTerminalResponse = (function() {

        /**
         * Properties of an UpdateTerminalResponse.
         * @memberof pond
         * @interface IUpdateTerminalResponse
         * @property {boolean|null} [success] UpdateTerminalResponse success
         */

        /**
         * Constructs a new UpdateTerminalResponse.
         * @memberof pond
         * @classdesc Represents an UpdateTerminalResponse.
         * @implements IUpdateTerminalResponse
         * @constructor
         * @param {pond.IUpdateTerminalResponse=} [properties] Properties to set
         */
        function UpdateTerminalResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTerminalResponse success.
         * @member {boolean} success
         * @memberof pond.UpdateTerminalResponse
         * @instance
         */
        UpdateTerminalResponse.prototype.success = false;

        /**
         * Creates a new UpdateTerminalResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateTerminalResponse
         * @static
         * @param {pond.IUpdateTerminalResponse=} [properties] Properties to set
         * @returns {pond.UpdateTerminalResponse} UpdateTerminalResponse instance
         */
        UpdateTerminalResponse.create = function create(properties) {
            return new UpdateTerminalResponse(properties);
        };

        /**
         * Creates an UpdateTerminalResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateTerminalResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateTerminalResponse} UpdateTerminalResponse
         */
        UpdateTerminalResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateTerminalResponse)
                return object;
            var message = new $root.pond.UpdateTerminalResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an UpdateTerminalResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateTerminalResponse
         * @static
         * @param {pond.UpdateTerminalResponse} message UpdateTerminalResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTerminalResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this UpdateTerminalResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateTerminalResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTerminalResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateTerminalResponse;
    })();

    pond.RemoveTerminalRequest = (function() {

        /**
         * Properties of a RemoveTerminalRequest.
         * @memberof pond
         * @interface IRemoveTerminalRequest
         * @property {string|null} [key] RemoveTerminalRequest key
         */

        /**
         * Constructs a new RemoveTerminalRequest.
         * @memberof pond
         * @classdesc Represents a RemoveTerminalRequest.
         * @implements IRemoveTerminalRequest
         * @constructor
         * @param {pond.IRemoveTerminalRequest=} [properties] Properties to set
         */
        function RemoveTerminalRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTerminalRequest key.
         * @member {string} key
         * @memberof pond.RemoveTerminalRequest
         * @instance
         */
        RemoveTerminalRequest.prototype.key = "";

        /**
         * Creates a new RemoveTerminalRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTerminalRequest
         * @static
         * @param {pond.IRemoveTerminalRequest=} [properties] Properties to set
         * @returns {pond.RemoveTerminalRequest} RemoveTerminalRequest instance
         */
        RemoveTerminalRequest.create = function create(properties) {
            return new RemoveTerminalRequest(properties);
        };

        /**
         * Creates a RemoveTerminalRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTerminalRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTerminalRequest} RemoveTerminalRequest
         */
        RemoveTerminalRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTerminalRequest)
                return object;
            var message = new $root.pond.RemoveTerminalRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTerminalRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTerminalRequest
         * @static
         * @param {pond.RemoveTerminalRequest} message RemoveTerminalRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTerminalRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveTerminalRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveTerminalRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTerminalRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTerminalRequest;
    })();

    pond.RemoveTerminalResponse = (function() {

        /**
         * Properties of a RemoveTerminalResponse.
         * @memberof pond
         * @interface IRemoveTerminalResponse
         * @property {boolean|null} [success] RemoveTerminalResponse success
         */

        /**
         * Constructs a new RemoveTerminalResponse.
         * @memberof pond
         * @classdesc Represents a RemoveTerminalResponse.
         * @implements IRemoveTerminalResponse
         * @constructor
         * @param {pond.IRemoveTerminalResponse=} [properties] Properties to set
         */
        function RemoveTerminalResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTerminalResponse success.
         * @member {boolean} success
         * @memberof pond.RemoveTerminalResponse
         * @instance
         */
        RemoveTerminalResponse.prototype.success = false;

        /**
         * Creates a new RemoveTerminalResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveTerminalResponse
         * @static
         * @param {pond.IRemoveTerminalResponse=} [properties] Properties to set
         * @returns {pond.RemoveTerminalResponse} RemoveTerminalResponse instance
         */
        RemoveTerminalResponse.create = function create(properties) {
            return new RemoveTerminalResponse(properties);
        };

        /**
         * Creates a RemoveTerminalResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveTerminalResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveTerminalResponse} RemoveTerminalResponse
         */
        RemoveTerminalResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveTerminalResponse)
                return object;
            var message = new $root.pond.RemoveTerminalResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTerminalResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveTerminalResponse
         * @static
         * @param {pond.RemoveTerminalResponse} message RemoveTerminalResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTerminalResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this RemoveTerminalResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveTerminalResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTerminalResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveTerminalResponse;
    })();

    pond.Gate = (function() {

        /**
         * Properties of a Gate.
         * @memberof pond
         * @interface IGate
         * @property {string|null} [key] Gate key
         * @property {string|null} [name] Gate name
         * @property {pond.GateSettings|null} [settings] Gate settings
         * @property {Object.<string,pond.GateComponentType>|null} [componentPreferences] Gate componentPreferences
         * @property {Object.<string,pond.GateMutations>|null} [gateMutations] Gate gateMutations
         * @property {pond.PCAState|null} [pcaState] Gate pcaState
         */

        /**
         * Constructs a new Gate.
         * @memberof pond
         * @classdesc Represents a Gate.
         * @implements IGate
         * @constructor
         * @param {pond.IGate=} [properties] Properties to set
         */
        function Gate(properties) {
            this.componentPreferences = {};
            this.gateMutations = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Gate key.
         * @member {string} key
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.key = "";

        /**
         * Gate name.
         * @member {string} name
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.name = "";

        /**
         * Gate settings.
         * @member {pond.GateSettings|null|undefined} settings
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.settings = null;

        /**
         * Gate componentPreferences.
         * @member {Object.<string,pond.GateComponentType>} componentPreferences
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.componentPreferences = $util.emptyObject;

        /**
         * Gate gateMutations.
         * @member {Object.<string,pond.GateMutations>} gateMutations
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.gateMutations = $util.emptyObject;

        /**
         * Gate pcaState.
         * @member {pond.PCAState} pcaState
         * @memberof pond.Gate
         * @instance
         */
        Gate.prototype.pcaState = 0;

        /**
         * Creates a new Gate instance using the specified properties.
         * @function create
         * @memberof pond.Gate
         * @static
         * @param {pond.IGate=} [properties] Properties to set
         * @returns {pond.Gate} Gate instance
         */
        Gate.create = function create(properties) {
            return new Gate(properties);
        };

        /**
         * Creates a Gate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Gate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Gate} Gate
         */
        Gate.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Gate)
                return object;
            var message = new $root.pond.Gate();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Gate.settings: object expected");
                message.settings = $root.pond.GateSettings.fromObject(object.settings);
            }
            if (object.componentPreferences) {
                if (typeof object.componentPreferences !== "object")
                    throw TypeError(".pond.Gate.componentPreferences: object expected");
                message.componentPreferences = {};
                for (var keys = Object.keys(object.componentPreferences), i = 0; i < keys.length; ++i)
                    switch (object.componentPreferences[keys[i]]) {
                    case "GATE_COMPONENT_TYPE_UNKNOWN":
                    case 0:
                        message.componentPreferences[keys[i]] = 0;
                        break;
                    case "GATE_COMPONENT_TYPE_TEMP":
                    case 1:
                        message.componentPreferences[keys[i]] = 1;
                        break;
                    case "GATE_COMPONENT_TYPE_PRESSURE":
                    case 2:
                        message.componentPreferences[keys[i]] = 2;
                        break;
                    case "GATE_COMPONENT_TYPE_AMBIENT":
                    case 3:
                        message.componentPreferences[keys[i]] = 3;
                        break;
                    }
            }
            if (object.gateMutations) {
                if (typeof object.gateMutations !== "object")
                    throw TypeError(".pond.Gate.gateMutations: object expected");
                message.gateMutations = {};
                for (var keys = Object.keys(object.gateMutations), i = 0; i < keys.length; ++i) {
                    if (typeof object.gateMutations[keys[i]] !== "object")
                        throw TypeError(".pond.Gate.gateMutations: object expected");
                    message.gateMutations[keys[i]] = $root.pond.GateMutations.fromObject(object.gateMutations[keys[i]]);
                }
            }
            switch (object.pcaState) {
            case "PCA_STATE_UNKNOWN":
            case 0:
                message.pcaState = 0;
                break;
            case "PCA_STATE_OFF":
            case 1:
                message.pcaState = 1;
                break;
            case "PCA_STATE_IN_BOUNDS":
            case 2:
                message.pcaState = 2;
                break;
            case "PCA_STATE_OUT_BOUNDS":
            case 3:
                message.pcaState = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Gate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Gate
         * @static
         * @param {pond.Gate} message Gate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Gate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults) {
                object.componentPreferences = {};
                object.gateMutations = {};
            }
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
                object.pcaState = options.enums === String ? "PCA_STATE_UNKNOWN" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GateSettings.toObject(message.settings, options);
            var keys2;
            if (message.componentPreferences && (keys2 = Object.keys(message.componentPreferences)).length) {
                object.componentPreferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.componentPreferences[keys2[j]] = options.enums === String ? $root.pond.GateComponentType[message.componentPreferences[keys2[j]]] : message.componentPreferences[keys2[j]];
            }
            if (message.gateMutations && (keys2 = Object.keys(message.gateMutations)).length) {
                object.gateMutations = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.gateMutations[keys2[j]] = $root.pond.GateMutations.toObject(message.gateMutations[keys2[j]], options);
            }
            if (message.pcaState != null && message.hasOwnProperty("pcaState"))
                object.pcaState = options.enums === String ? $root.pond.PCAState[message.pcaState] : message.pcaState;
            return object;
        };

        /**
         * Converts this Gate to JSON.
         * @function toJSON
         * @memberof pond.Gate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Gate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Gate;
    })();

    /**
     * PCAState enum.
     * @name pond.PCAState
     * @enum {string}
     * @property {number} PCA_STATE_UNKNOWN=0 PCA_STATE_UNKNOWN value
     * @property {number} PCA_STATE_OFF=1 PCA_STATE_OFF value
     * @property {number} PCA_STATE_IN_BOUNDS=2 PCA_STATE_IN_BOUNDS value
     * @property {number} PCA_STATE_OUT_BOUNDS=3 PCA_STATE_OUT_BOUNDS value
     */
    pond.PCAState = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PCA_STATE_UNKNOWN"] = 0;
        values[valuesById[1] = "PCA_STATE_OFF"] = 1;
        values[valuesById[2] = "PCA_STATE_IN_BOUNDS"] = 2;
        values[valuesById[3] = "PCA_STATE_OUT_BOUNDS"] = 3;
        return values;
    })();

    pond.GateMutations = (function() {

        /**
         * Properties of a GateMutations.
         * @memberof pond
         * @interface IGateMutations
         * @property {number|null} [cfm] GateMutations cfm
         * @property {number|null} [temp] GateMutations temp
         */

        /**
         * Constructs a new GateMutations.
         * @memberof pond
         * @classdesc Represents a GateMutations.
         * @implements IGateMutations
         * @constructor
         * @param {pond.IGateMutations=} [properties] Properties to set
         */
        function GateMutations(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GateMutations cfm.
         * @member {number} cfm
         * @memberof pond.GateMutations
         * @instance
         */
        GateMutations.prototype.cfm = 0;

        /**
         * GateMutations temp.
         * @member {number} temp
         * @memberof pond.GateMutations
         * @instance
         */
        GateMutations.prototype.temp = 0;

        /**
         * Creates a new GateMutations instance using the specified properties.
         * @function create
         * @memberof pond.GateMutations
         * @static
         * @param {pond.IGateMutations=} [properties] Properties to set
         * @returns {pond.GateMutations} GateMutations instance
         */
        GateMutations.create = function create(properties) {
            return new GateMutations(properties);
        };

        /**
         * Creates a GateMutations message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GateMutations
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GateMutations} GateMutations
         */
        GateMutations.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GateMutations)
                return object;
            var message = new $root.pond.GateMutations();
            if (object.cfm != null)
                message.cfm = Number(object.cfm);
            if (object.temp != null)
                message.temp = Number(object.temp);
            return message;
        };

        /**
         * Creates a plain object from a GateMutations message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GateMutations
         * @static
         * @param {pond.GateMutations} message GateMutations
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GateMutations.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cfm = 0;
                object.temp = 0;
            }
            if (message.cfm != null && message.hasOwnProperty("cfm"))
                object.cfm = options.json && !isFinite(message.cfm) ? String(message.cfm) : message.cfm;
            if (message.temp != null && message.hasOwnProperty("temp"))
                object.temp = options.json && !isFinite(message.temp) ? String(message.temp) : message.temp;
            return object;
        };

        /**
         * Converts this GateMutations to JSON.
         * @function toJSON
         * @memberof pond.GateMutations
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GateMutations.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GateMutations;
    })();

    pond.GateSettings = (function() {

        /**
         * Properties of a GateSettings.
         * @memberof pond
         * @interface IGateSettings
         * @property {number|null} [longitude] GateSettings longitude
         * @property {number|null} [latitude] GateSettings latitude
         * @property {string|null} [terminal] GateSettings terminal
         * @property {number|null} [ductDiameter] GateSettings ductDiameter
         * @property {number|null} [ductLength] GateSettings ductLength
         * @property {number|null} [frictionFactor] GateSettings frictionFactor
         * @property {number|null} [thermalConductivity] GateSettings thermalConductivity
         * @property {number|null} [thermalResistance] GateSettings thermalResistance
         * @property {number|null} [upperFlow] GateSettings upperFlow
         * @property {number|null} [lowerFlow] GateSettings lowerFlow
         * @property {string|null} [pcaType] GateSettings pcaType
         * @property {string|null} [ductName] GateSettings ductName
         * @property {string|null} [airport] GateSettings airport
         * @property {string|null} [letterIdentifier] GateSettings letterIdentifier
         * @property {string|null} [numberIdentifier] GateSettings numberIdentifier
         * @property {number|null} [hourlyApuCost] GateSettings hourlyApuCost
         * @property {number|null} [hourlyPcaCost] GateSettings hourlyPcaCost
         * @property {pond.ObjectTheme|null} [theme] GateSettings theme
         */

        /**
         * Constructs a new GateSettings.
         * @memberof pond
         * @classdesc Represents a GateSettings.
         * @implements IGateSettings
         * @constructor
         * @param {pond.IGateSettings=} [properties] Properties to set
         */
        function GateSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GateSettings longitude.
         * @member {number} longitude
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.longitude = 0;

        /**
         * GateSettings latitude.
         * @member {number} latitude
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.latitude = 0;

        /**
         * GateSettings terminal.
         * @member {string} terminal
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.terminal = "";

        /**
         * GateSettings ductDiameter.
         * @member {number} ductDiameter
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.ductDiameter = 0;

        /**
         * GateSettings ductLength.
         * @member {number} ductLength
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.ductLength = 0;

        /**
         * GateSettings frictionFactor.
         * @member {number} frictionFactor
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.frictionFactor = 0;

        /**
         * GateSettings thermalConductivity.
         * @member {number} thermalConductivity
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.thermalConductivity = 0;

        /**
         * GateSettings thermalResistance.
         * @member {number} thermalResistance
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.thermalResistance = 0;

        /**
         * GateSettings upperFlow.
         * @member {number} upperFlow
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.upperFlow = 0;

        /**
         * GateSettings lowerFlow.
         * @member {number} lowerFlow
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.lowerFlow = 0;

        /**
         * GateSettings pcaType.
         * @member {string} pcaType
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.pcaType = "";

        /**
         * GateSettings ductName.
         * @member {string} ductName
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.ductName = "";

        /**
         * GateSettings airport.
         * @member {string} airport
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.airport = "";

        /**
         * GateSettings letterIdentifier.
         * @member {string} letterIdentifier
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.letterIdentifier = "";

        /**
         * GateSettings numberIdentifier.
         * @member {string} numberIdentifier
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.numberIdentifier = "";

        /**
         * GateSettings hourlyApuCost.
         * @member {number} hourlyApuCost
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.hourlyApuCost = 0;

        /**
         * GateSettings hourlyPcaCost.
         * @member {number} hourlyPcaCost
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.hourlyPcaCost = 0;

        /**
         * GateSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.GateSettings
         * @instance
         */
        GateSettings.prototype.theme = null;

        /**
         * Creates a new GateSettings instance using the specified properties.
         * @function create
         * @memberof pond.GateSettings
         * @static
         * @param {pond.IGateSettings=} [properties] Properties to set
         * @returns {pond.GateSettings} GateSettings instance
         */
        GateSettings.create = function create(properties) {
            return new GateSettings(properties);
        };

        /**
         * Creates a GateSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GateSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GateSettings} GateSettings
         */
        GateSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GateSettings)
                return object;
            var message = new $root.pond.GateSettings();
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.terminal != null)
                message.terminal = String(object.terminal);
            if (object.ductDiameter != null)
                message.ductDiameter = Number(object.ductDiameter);
            if (object.ductLength != null)
                message.ductLength = Number(object.ductLength);
            if (object.frictionFactor != null)
                message.frictionFactor = Number(object.frictionFactor);
            if (object.thermalConductivity != null)
                message.thermalConductivity = Number(object.thermalConductivity);
            if (object.thermalResistance != null)
                message.thermalResistance = Number(object.thermalResistance);
            if (object.upperFlow != null)
                message.upperFlow = Number(object.upperFlow);
            if (object.lowerFlow != null)
                message.lowerFlow = Number(object.lowerFlow);
            if (object.pcaType != null)
                message.pcaType = String(object.pcaType);
            if (object.ductName != null)
                message.ductName = String(object.ductName);
            if (object.airport != null)
                message.airport = String(object.airport);
            if (object.letterIdentifier != null)
                message.letterIdentifier = String(object.letterIdentifier);
            if (object.numberIdentifier != null)
                message.numberIdentifier = String(object.numberIdentifier);
            if (object.hourlyApuCost != null)
                message.hourlyApuCost = Number(object.hourlyApuCost);
            if (object.hourlyPcaCost != null)
                message.hourlyPcaCost = Number(object.hourlyPcaCost);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.GateSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            return message;
        };

        /**
         * Creates a plain object from a GateSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GateSettings
         * @static
         * @param {pond.GateSettings} message GateSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GateSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.longitude = 0;
                object.latitude = 0;
                object.terminal = "";
                object.ductDiameter = 0;
                object.ductLength = 0;
                object.frictionFactor = 0;
                object.thermalConductivity = 0;
                object.thermalResistance = 0;
                object.upperFlow = 0;
                object.lowerFlow = 0;
                object.pcaType = "";
                object.ductName = "";
                object.airport = "";
                object.letterIdentifier = "";
                object.numberIdentifier = "";
                object.hourlyApuCost = 0;
                object.hourlyPcaCost = 0;
                object.theme = null;
            }
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.terminal != null && message.hasOwnProperty("terminal"))
                object.terminal = message.terminal;
            if (message.ductDiameter != null && message.hasOwnProperty("ductDiameter"))
                object.ductDiameter = options.json && !isFinite(message.ductDiameter) ? String(message.ductDiameter) : message.ductDiameter;
            if (message.ductLength != null && message.hasOwnProperty("ductLength"))
                object.ductLength = options.json && !isFinite(message.ductLength) ? String(message.ductLength) : message.ductLength;
            if (message.frictionFactor != null && message.hasOwnProperty("frictionFactor"))
                object.frictionFactor = options.json && !isFinite(message.frictionFactor) ? String(message.frictionFactor) : message.frictionFactor;
            if (message.thermalConductivity != null && message.hasOwnProperty("thermalConductivity"))
                object.thermalConductivity = options.json && !isFinite(message.thermalConductivity) ? String(message.thermalConductivity) : message.thermalConductivity;
            if (message.thermalResistance != null && message.hasOwnProperty("thermalResistance"))
                object.thermalResistance = options.json && !isFinite(message.thermalResistance) ? String(message.thermalResistance) : message.thermalResistance;
            if (message.upperFlow != null && message.hasOwnProperty("upperFlow"))
                object.upperFlow = options.json && !isFinite(message.upperFlow) ? String(message.upperFlow) : message.upperFlow;
            if (message.lowerFlow != null && message.hasOwnProperty("lowerFlow"))
                object.lowerFlow = options.json && !isFinite(message.lowerFlow) ? String(message.lowerFlow) : message.lowerFlow;
            if (message.pcaType != null && message.hasOwnProperty("pcaType"))
                object.pcaType = message.pcaType;
            if (message.ductName != null && message.hasOwnProperty("ductName"))
                object.ductName = message.ductName;
            if (message.airport != null && message.hasOwnProperty("airport"))
                object.airport = message.airport;
            if (message.letterIdentifier != null && message.hasOwnProperty("letterIdentifier"))
                object.letterIdentifier = message.letterIdentifier;
            if (message.numberIdentifier != null && message.hasOwnProperty("numberIdentifier"))
                object.numberIdentifier = message.numberIdentifier;
            if (message.hourlyApuCost != null && message.hasOwnProperty("hourlyApuCost"))
                object.hourlyApuCost = options.json && !isFinite(message.hourlyApuCost) ? String(message.hourlyApuCost) : message.hourlyApuCost;
            if (message.hourlyPcaCost != null && message.hasOwnProperty("hourlyPcaCost"))
                object.hourlyPcaCost = options.json && !isFinite(message.hourlyPcaCost) ? String(message.hourlyPcaCost) : message.hourlyPcaCost;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            return object;
        };

        /**
         * Converts this GateSettings to JSON.
         * @function toJSON
         * @memberof pond.GateSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GateSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GateSettings;
    })();

    pond.AddGateRequest = (function() {

        /**
         * Properties of an AddGateRequest.
         * @memberof pond
         * @interface IAddGateRequest
         * @property {string|null} [name] AddGateRequest name
         * @property {pond.GateSettings|null} [settings] AddGateRequest settings
         */

        /**
         * Constructs a new AddGateRequest.
         * @memberof pond
         * @classdesc Represents an AddGateRequest.
         * @implements IAddGateRequest
         * @constructor
         * @param {pond.IAddGateRequest=} [properties] Properties to set
         */
        function AddGateRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGateRequest name.
         * @member {string} name
         * @memberof pond.AddGateRequest
         * @instance
         */
        AddGateRequest.prototype.name = "";

        /**
         * AddGateRequest settings.
         * @member {pond.GateSettings|null|undefined} settings
         * @memberof pond.AddGateRequest
         * @instance
         */
        AddGateRequest.prototype.settings = null;

        /**
         * Creates a new AddGateRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddGateRequest
         * @static
         * @param {pond.IAddGateRequest=} [properties] Properties to set
         * @returns {pond.AddGateRequest} AddGateRequest instance
         */
        AddGateRequest.create = function create(properties) {
            return new AddGateRequest(properties);
        };

        /**
         * Creates an AddGateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGateRequest} AddGateRequest
         */
        AddGateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGateRequest)
                return object;
            var message = new $root.pond.AddGateRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddGateRequest.settings: object expected");
                message.settings = $root.pond.GateSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddGateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGateRequest
         * @static
         * @param {pond.AddGateRequest} message AddGateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GateSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddGateRequest to JSON.
         * @function toJSON
         * @memberof pond.AddGateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGateRequest;
    })();

    pond.AddGateResponse = (function() {

        /**
         * Properties of an AddGateResponse.
         * @memberof pond
         * @interface IAddGateResponse
         * @property {string|null} [key] AddGateResponse key
         */

        /**
         * Constructs a new AddGateResponse.
         * @memberof pond
         * @classdesc Represents an AddGateResponse.
         * @implements IAddGateResponse
         * @constructor
         * @param {pond.IAddGateResponse=} [properties] Properties to set
         */
        function AddGateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGateResponse key.
         * @member {string} key
         * @memberof pond.AddGateResponse
         * @instance
         */
        AddGateResponse.prototype.key = "";

        /**
         * Creates a new AddGateResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddGateResponse
         * @static
         * @param {pond.IAddGateResponse=} [properties] Properties to set
         * @returns {pond.AddGateResponse} AddGateResponse instance
         */
        AddGateResponse.create = function create(properties) {
            return new AddGateResponse(properties);
        };

        /**
         * Creates an AddGateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGateResponse} AddGateResponse
         */
        AddGateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGateResponse)
                return object;
            var message = new $root.pond.AddGateResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddGateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGateResponse
         * @static
         * @param {pond.AddGateResponse} message AddGateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddGateResponse to JSON.
         * @function toJSON
         * @memberof pond.AddGateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGateResponse;
    })();

    pond.ListGatesRequest = (function() {

        /**
         * Properties of a ListGatesRequest.
         * @memberof pond
         * @interface IListGatesRequest
         * @property {pond.Paging|null} [paging] ListGatesRequest paging
         * @property {pond.Sorting|null} [sorting] ListGatesRequest sorting
         * @property {string|null} [search] ListGatesRequest search
         * @property {boolean|null} [withPcaState] ListGatesRequest withPcaState
         */

        /**
         * Constructs a new ListGatesRequest.
         * @memberof pond
         * @classdesc Represents a ListGatesRequest.
         * @implements IListGatesRequest
         * @constructor
         * @param {pond.IListGatesRequest=} [properties] Properties to set
         */
        function ListGatesRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGatesRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListGatesRequest
         * @instance
         */
        ListGatesRequest.prototype.paging = null;

        /**
         * ListGatesRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListGatesRequest
         * @instance
         */
        ListGatesRequest.prototype.sorting = null;

        /**
         * ListGatesRequest search.
         * @member {string} search
         * @memberof pond.ListGatesRequest
         * @instance
         */
        ListGatesRequest.prototype.search = "";

        /**
         * ListGatesRequest withPcaState.
         * @member {boolean} withPcaState
         * @memberof pond.ListGatesRequest
         * @instance
         */
        ListGatesRequest.prototype.withPcaState = false;

        /**
         * Creates a new ListGatesRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGatesRequest
         * @static
         * @param {pond.IListGatesRequest=} [properties] Properties to set
         * @returns {pond.ListGatesRequest} ListGatesRequest instance
         */
        ListGatesRequest.create = function create(properties) {
            return new ListGatesRequest(properties);
        };

        /**
         * Creates a ListGatesRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGatesRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGatesRequest} ListGatesRequest
         */
        ListGatesRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGatesRequest)
                return object;
            var message = new $root.pond.ListGatesRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListGatesRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListGatesRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.withPcaState != null)
                message.withPcaState = Boolean(object.withPcaState);
            return message;
        };

        /**
         * Creates a plain object from a ListGatesRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGatesRequest
         * @static
         * @param {pond.ListGatesRequest} message ListGatesRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGatesRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.withPcaState = false;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.withPcaState != null && message.hasOwnProperty("withPcaState"))
                object.withPcaState = message.withPcaState;
            return object;
        };

        /**
         * Converts this ListGatesRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGatesRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGatesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGatesRequest;
    })();

    pond.ListGatesResponse = (function() {

        /**
         * Properties of a ListGatesResponse.
         * @memberof pond
         * @interface IListGatesResponse
         * @property {Array.<pond.Gate>|null} [gates] ListGatesResponse gates
         * @property {number|null} [nextOffset] ListGatesResponse nextOffset
         * @property {number|null} [total] ListGatesResponse total
         */

        /**
         * Constructs a new ListGatesResponse.
         * @memberof pond
         * @classdesc Represents a ListGatesResponse.
         * @implements IListGatesResponse
         * @constructor
         * @param {pond.IListGatesResponse=} [properties] Properties to set
         */
        function ListGatesResponse(properties) {
            this.gates = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGatesResponse gates.
         * @member {Array.<pond.Gate>} gates
         * @memberof pond.ListGatesResponse
         * @instance
         */
        ListGatesResponse.prototype.gates = $util.emptyArray;

        /**
         * ListGatesResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListGatesResponse
         * @instance
         */
        ListGatesResponse.prototype.nextOffset = 0;

        /**
         * ListGatesResponse total.
         * @member {number} total
         * @memberof pond.ListGatesResponse
         * @instance
         */
        ListGatesResponse.prototype.total = 0;

        /**
         * Creates a new ListGatesResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGatesResponse
         * @static
         * @param {pond.IListGatesResponse=} [properties] Properties to set
         * @returns {pond.ListGatesResponse} ListGatesResponse instance
         */
        ListGatesResponse.create = function create(properties) {
            return new ListGatesResponse(properties);
        };

        /**
         * Creates a ListGatesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGatesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGatesResponse} ListGatesResponse
         */
        ListGatesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGatesResponse)
                return object;
            var message = new $root.pond.ListGatesResponse();
            if (object.gates) {
                if (!Array.isArray(object.gates))
                    throw TypeError(".pond.ListGatesResponse.gates: array expected");
                message.gates = [];
                for (var i = 0; i < object.gates.length; ++i) {
                    if (typeof object.gates[i] !== "object")
                        throw TypeError(".pond.ListGatesResponse.gates: object expected");
                    message.gates[i] = $root.pond.Gate.fromObject(object.gates[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListGatesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGatesResponse
         * @static
         * @param {pond.ListGatesResponse} message ListGatesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGatesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.gates = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.gates && message.gates.length) {
                object.gates = [];
                for (var j = 0; j < message.gates.length; ++j)
                    object.gates[j] = $root.pond.Gate.toObject(message.gates[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListGatesResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGatesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGatesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGatesResponse;
    })();

    pond.GetGateRequest = (function() {

        /**
         * Properties of a GetGateRequest.
         * @memberof pond
         * @interface IGetGateRequest
         * @property {string|null} [key] GetGateRequest key
         */

        /**
         * Constructs a new GetGateRequest.
         * @memberof pond
         * @classdesc Represents a GetGateRequest.
         * @implements IGetGateRequest
         * @constructor
         * @param {pond.IGetGateRequest=} [properties] Properties to set
         */
        function GetGateRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGateRequest key.
         * @member {string} key
         * @memberof pond.GetGateRequest
         * @instance
         */
        GetGateRequest.prototype.key = "";

        /**
         * Creates a new GetGateRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGateRequest
         * @static
         * @param {pond.IGetGateRequest=} [properties] Properties to set
         * @returns {pond.GetGateRequest} GetGateRequest instance
         */
        GetGateRequest.create = function create(properties) {
            return new GetGateRequest(properties);
        };

        /**
         * Creates a GetGateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGateRequest} GetGateRequest
         */
        GetGateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGateRequest)
                return object;
            var message = new $root.pond.GetGateRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetGateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGateRequest
         * @static
         * @param {pond.GetGateRequest} message GetGateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetGateRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGateRequest;
    })();

    pond.GetGateResponse = (function() {

        /**
         * Properties of a GetGateResponse.
         * @memberof pond
         * @interface IGetGateResponse
         * @property {pond.Gate|null} [gate] GetGateResponse gate
         */

        /**
         * Constructs a new GetGateResponse.
         * @memberof pond
         * @classdesc Represents a GetGateResponse.
         * @implements IGetGateResponse
         * @constructor
         * @param {pond.IGetGateResponse=} [properties] Properties to set
         */
        function GetGateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGateResponse gate.
         * @member {pond.Gate|null|undefined} gate
         * @memberof pond.GetGateResponse
         * @instance
         */
        GetGateResponse.prototype.gate = null;

        /**
         * Creates a new GetGateResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetGateResponse
         * @static
         * @param {pond.IGetGateResponse=} [properties] Properties to set
         * @returns {pond.GetGateResponse} GetGateResponse instance
         */
        GetGateResponse.create = function create(properties) {
            return new GetGateResponse(properties);
        };

        /**
         * Creates a GetGateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGateResponse} GetGateResponse
         */
        GetGateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGateResponse)
                return object;
            var message = new $root.pond.GetGateResponse();
            if (object.gate != null) {
                if (typeof object.gate !== "object")
                    throw TypeError(".pond.GetGateResponse.gate: object expected");
                message.gate = $root.pond.Gate.fromObject(object.gate);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetGateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGateResponse
         * @static
         * @param {pond.GetGateResponse} message GetGateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.gate = null;
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = $root.pond.Gate.toObject(message.gate, options);
            return object;
        };

        /**
         * Converts this GetGateResponse to JSON.
         * @function toJSON
         * @memberof pond.GetGateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGateResponse;
    })();

    pond.UpdateGateRequest = (function() {

        /**
         * Properties of an UpdateGateRequest.
         * @memberof pond
         * @interface IUpdateGateRequest
         * @property {string|null} [key] UpdateGateRequest key
         * @property {string|null} [name] UpdateGateRequest name
         * @property {pond.GateSettings|null} [settings] UpdateGateRequest settings
         */

        /**
         * Constructs a new UpdateGateRequest.
         * @memberof pond
         * @classdesc Represents an UpdateGateRequest.
         * @implements IUpdateGateRequest
         * @constructor
         * @param {pond.IUpdateGateRequest=} [properties] Properties to set
         */
        function UpdateGateRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGateRequest key.
         * @member {string} key
         * @memberof pond.UpdateGateRequest
         * @instance
         */
        UpdateGateRequest.prototype.key = "";

        /**
         * UpdateGateRequest name.
         * @member {string} name
         * @memberof pond.UpdateGateRequest
         * @instance
         */
        UpdateGateRequest.prototype.name = "";

        /**
         * UpdateGateRequest settings.
         * @member {pond.GateSettings|null|undefined} settings
         * @memberof pond.UpdateGateRequest
         * @instance
         */
        UpdateGateRequest.prototype.settings = null;

        /**
         * Creates a new UpdateGateRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGateRequest
         * @static
         * @param {pond.IUpdateGateRequest=} [properties] Properties to set
         * @returns {pond.UpdateGateRequest} UpdateGateRequest instance
         */
        UpdateGateRequest.create = function create(properties) {
            return new UpdateGateRequest(properties);
        };

        /**
         * Creates an UpdateGateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGateRequest} UpdateGateRequest
         */
        UpdateGateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGateRequest)
                return object;
            var message = new $root.pond.UpdateGateRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateGateRequest.settings: object expected");
                message.settings = $root.pond.GateSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateGateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGateRequest
         * @static
         * @param {pond.UpdateGateRequest} message UpdateGateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GateSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateGateRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateGateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGateRequest;
    })();

    pond.UpdateGateResponse = (function() {

        /**
         * Properties of an UpdateGateResponse.
         * @memberof pond
         * @interface IUpdateGateResponse
         * @property {boolean|null} [success] UpdateGateResponse success
         */

        /**
         * Constructs a new UpdateGateResponse.
         * @memberof pond
         * @classdesc Represents an UpdateGateResponse.
         * @implements IUpdateGateResponse
         * @constructor
         * @param {pond.IUpdateGateResponse=} [properties] Properties to set
         */
        function UpdateGateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGateResponse success.
         * @member {boolean} success
         * @memberof pond.UpdateGateResponse
         * @instance
         */
        UpdateGateResponse.prototype.success = false;

        /**
         * Creates a new UpdateGateResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGateResponse
         * @static
         * @param {pond.IUpdateGateResponse=} [properties] Properties to set
         * @returns {pond.UpdateGateResponse} UpdateGateResponse instance
         */
        UpdateGateResponse.create = function create(properties) {
            return new UpdateGateResponse(properties);
        };

        /**
         * Creates an UpdateGateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGateResponse} UpdateGateResponse
         */
        UpdateGateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGateResponse)
                return object;
            var message = new $root.pond.UpdateGateResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an UpdateGateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGateResponse
         * @static
         * @param {pond.UpdateGateResponse} message UpdateGateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this UpdateGateResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateGateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGateResponse;
    })();

    pond.RemoveGateRequest = (function() {

        /**
         * Properties of a RemoveGateRequest.
         * @memberof pond
         * @interface IRemoveGateRequest
         * @property {string|null} [key] RemoveGateRequest key
         */

        /**
         * Constructs a new RemoveGateRequest.
         * @memberof pond
         * @classdesc Represents a RemoveGateRequest.
         * @implements IRemoveGateRequest
         * @constructor
         * @param {pond.IRemoveGateRequest=} [properties] Properties to set
         */
        function RemoveGateRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveGateRequest key.
         * @member {string} key
         * @memberof pond.RemoveGateRequest
         * @instance
         */
        RemoveGateRequest.prototype.key = "";

        /**
         * Creates a new RemoveGateRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGateRequest
         * @static
         * @param {pond.IRemoveGateRequest=} [properties] Properties to set
         * @returns {pond.RemoveGateRequest} RemoveGateRequest instance
         */
        RemoveGateRequest.create = function create(properties) {
            return new RemoveGateRequest(properties);
        };

        /**
         * Creates a RemoveGateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGateRequest} RemoveGateRequest
         */
        RemoveGateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGateRequest)
                return object;
            var message = new $root.pond.RemoveGateRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveGateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGateRequest
         * @static
         * @param {pond.RemoveGateRequest} message RemoveGateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveGateRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveGateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGateRequest;
    })();

    pond.RemoveGateResponse = (function() {

        /**
         * Properties of a RemoveGateResponse.
         * @memberof pond
         * @interface IRemoveGateResponse
         * @property {boolean|null} [success] RemoveGateResponse success
         */

        /**
         * Constructs a new RemoveGateResponse.
         * @memberof pond
         * @classdesc Represents a RemoveGateResponse.
         * @implements IRemoveGateResponse
         * @constructor
         * @param {pond.IRemoveGateResponse=} [properties] Properties to set
         */
        function RemoveGateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveGateResponse success.
         * @member {boolean} success
         * @memberof pond.RemoveGateResponse
         * @instance
         */
        RemoveGateResponse.prototype.success = false;

        /**
         * Creates a new RemoveGateResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGateResponse
         * @static
         * @param {pond.IRemoveGateResponse=} [properties] Properties to set
         * @returns {pond.RemoveGateResponse} RemoveGateResponse instance
         */
        RemoveGateResponse.create = function create(properties) {
            return new RemoveGateResponse(properties);
        };

        /**
         * Creates a RemoveGateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGateResponse} RemoveGateResponse
         */
        RemoveGateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGateResponse)
                return object;
            var message = new $root.pond.RemoveGateResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from a RemoveGateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGateResponse
         * @static
         * @param {pond.RemoveGateResponse} message RemoveGateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this RemoveGateResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveGateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGateResponse;
    })();

    pond.UpdateGateLinkRequest = (function() {

        /**
         * Properties of an UpdateGateLinkRequest.
         * @memberof pond
         * @interface IUpdateGateLinkRequest
         * @property {string|null} [parentKey] UpdateGateLinkRequest parentKey
         * @property {string|null} [parentType] UpdateGateLinkRequest parentType
         * @property {string|null} [key] UpdateGateLinkRequest key
         * @property {string|null} [type] UpdateGateLinkRequest type
         * @property {Array.<string>|null} [permissions] UpdateGateLinkRequest permissions
         */

        /**
         * Constructs a new UpdateGateLinkRequest.
         * @memberof pond
         * @classdesc Represents an UpdateGateLinkRequest.
         * @implements IUpdateGateLinkRequest
         * @constructor
         * @param {pond.IUpdateGateLinkRequest=} [properties] Properties to set
         */
        function UpdateGateLinkRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGateLinkRequest parentKey.
         * @member {string} parentKey
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         */
        UpdateGateLinkRequest.prototype.parentKey = "";

        /**
         * UpdateGateLinkRequest parentType.
         * @member {string} parentType
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         */
        UpdateGateLinkRequest.prototype.parentType = "";

        /**
         * UpdateGateLinkRequest key.
         * @member {string} key
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         */
        UpdateGateLinkRequest.prototype.key = "";

        /**
         * UpdateGateLinkRequest type.
         * @member {string} type
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         */
        UpdateGateLinkRequest.prototype.type = "";

        /**
         * UpdateGateLinkRequest permissions.
         * @member {Array.<string>} permissions
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         */
        UpdateGateLinkRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdateGateLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGateLinkRequest
         * @static
         * @param {pond.IUpdateGateLinkRequest=} [properties] Properties to set
         * @returns {pond.UpdateGateLinkRequest} UpdateGateLinkRequest instance
         */
        UpdateGateLinkRequest.create = function create(properties) {
            return new UpdateGateLinkRequest(properties);
        };

        /**
         * Creates an UpdateGateLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGateLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGateLinkRequest} UpdateGateLinkRequest
         */
        UpdateGateLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGateLinkRequest)
                return object;
            var message = new $root.pond.UpdateGateLinkRequest();
            if (object.parentKey != null)
                message.parentKey = String(object.parentKey);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                message.type = String(object.type);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.UpdateGateLinkRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    message.permissions[i] = String(object.permissions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateGateLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGateLinkRequest
         * @static
         * @param {pond.UpdateGateLinkRequest} message UpdateGateLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGateLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.parentKey = "";
                object.parentType = "";
                object.key = "";
                object.type = "";
            }
            if (message.parentKey != null && message.hasOwnProperty("parentKey"))
                object.parentKey = message.parentKey;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdateGateLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateGateLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGateLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGateLinkRequest;
    })();

    pond.GetGatePageDataRequest = (function() {

        /**
         * Properties of a GetGatePageDataRequest.
         * @memberof pond
         * @interface IGetGatePageDataRequest
         * @property {string|null} [key] GetGatePageDataRequest key
         */

        /**
         * Constructs a new GetGatePageDataRequest.
         * @memberof pond
         * @classdesc Represents a GetGatePageDataRequest.
         * @implements IGetGatePageDataRequest
         * @constructor
         * @param {pond.IGetGatePageDataRequest=} [properties] Properties to set
         */
        function GetGatePageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGatePageDataRequest key.
         * @member {string} key
         * @memberof pond.GetGatePageDataRequest
         * @instance
         */
        GetGatePageDataRequest.prototype.key = "";

        /**
         * Creates a new GetGatePageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGatePageDataRequest
         * @static
         * @param {pond.IGetGatePageDataRequest=} [properties] Properties to set
         * @returns {pond.GetGatePageDataRequest} GetGatePageDataRequest instance
         */
        GetGatePageDataRequest.create = function create(properties) {
            return new GetGatePageDataRequest(properties);
        };

        /**
         * Creates a GetGatePageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGatePageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGatePageDataRequest} GetGatePageDataRequest
         */
        GetGatePageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGatePageDataRequest)
                return object;
            var message = new $root.pond.GetGatePageDataRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetGatePageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGatePageDataRequest
         * @static
         * @param {pond.GetGatePageDataRequest} message GetGatePageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGatePageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetGatePageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGatePageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGatePageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGatePageDataRequest;
    })();

    pond.GetGatePageDataResponse = (function() {

        /**
         * Properties of a GetGatePageDataResponse.
         * @memberof pond
         * @interface IGetGatePageDataResponse
         * @property {pond.Gate|null} [gate] GetGatePageDataResponse gate
         * @property {Array.<pond.ComprehensiveDevice>|null} [linkedDevices] GetGatePageDataResponse linkedDevices
         * @property {Array.<pond.Component>|null} [linkedComponents] GetGatePageDataResponse linkedComponents
         * @property {Object.<string,pond.GatePreferences>|null} [preferences] GetGatePageDataResponse preferences
         */

        /**
         * Constructs a new GetGatePageDataResponse.
         * @memberof pond
         * @classdesc Represents a GetGatePageDataResponse.
         * @implements IGetGatePageDataResponse
         * @constructor
         * @param {pond.IGetGatePageDataResponse=} [properties] Properties to set
         */
        function GetGatePageDataResponse(properties) {
            this.linkedDevices = [];
            this.linkedComponents = [];
            this.preferences = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGatePageDataResponse gate.
         * @member {pond.Gate|null|undefined} gate
         * @memberof pond.GetGatePageDataResponse
         * @instance
         */
        GetGatePageDataResponse.prototype.gate = null;

        /**
         * GetGatePageDataResponse linkedDevices.
         * @member {Array.<pond.ComprehensiveDevice>} linkedDevices
         * @memberof pond.GetGatePageDataResponse
         * @instance
         */
        GetGatePageDataResponse.prototype.linkedDevices = $util.emptyArray;

        /**
         * GetGatePageDataResponse linkedComponents.
         * @member {Array.<pond.Component>} linkedComponents
         * @memberof pond.GetGatePageDataResponse
         * @instance
         */
        GetGatePageDataResponse.prototype.linkedComponents = $util.emptyArray;

        /**
         * GetGatePageDataResponse preferences.
         * @member {Object.<string,pond.GatePreferences>} preferences
         * @memberof pond.GetGatePageDataResponse
         * @instance
         */
        GetGatePageDataResponse.prototype.preferences = $util.emptyObject;

        /**
         * Creates a new GetGatePageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetGatePageDataResponse
         * @static
         * @param {pond.IGetGatePageDataResponse=} [properties] Properties to set
         * @returns {pond.GetGatePageDataResponse} GetGatePageDataResponse instance
         */
        GetGatePageDataResponse.create = function create(properties) {
            return new GetGatePageDataResponse(properties);
        };

        /**
         * Creates a GetGatePageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGatePageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGatePageDataResponse} GetGatePageDataResponse
         */
        GetGatePageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGatePageDataResponse)
                return object;
            var message = new $root.pond.GetGatePageDataResponse();
            if (object.gate != null) {
                if (typeof object.gate !== "object")
                    throw TypeError(".pond.GetGatePageDataResponse.gate: object expected");
                message.gate = $root.pond.Gate.fromObject(object.gate);
            }
            if (object.linkedDevices) {
                if (!Array.isArray(object.linkedDevices))
                    throw TypeError(".pond.GetGatePageDataResponse.linkedDevices: array expected");
                message.linkedDevices = [];
                for (var i = 0; i < object.linkedDevices.length; ++i) {
                    if (typeof object.linkedDevices[i] !== "object")
                        throw TypeError(".pond.GetGatePageDataResponse.linkedDevices: object expected");
                    message.linkedDevices[i] = $root.pond.ComprehensiveDevice.fromObject(object.linkedDevices[i]);
                }
            }
            if (object.linkedComponents) {
                if (!Array.isArray(object.linkedComponents))
                    throw TypeError(".pond.GetGatePageDataResponse.linkedComponents: array expected");
                message.linkedComponents = [];
                for (var i = 0; i < object.linkedComponents.length; ++i) {
                    if (typeof object.linkedComponents[i] !== "object")
                        throw TypeError(".pond.GetGatePageDataResponse.linkedComponents: object expected");
                    message.linkedComponents[i] = $root.pond.Component.fromObject(object.linkedComponents[i]);
                }
            }
            if (object.preferences) {
                if (typeof object.preferences !== "object")
                    throw TypeError(".pond.GetGatePageDataResponse.preferences: object expected");
                message.preferences = {};
                for (var keys = Object.keys(object.preferences), i = 0; i < keys.length; ++i) {
                    if (typeof object.preferences[keys[i]] !== "object")
                        throw TypeError(".pond.GetGatePageDataResponse.preferences: object expected");
                    message.preferences[keys[i]] = $root.pond.GatePreferences.fromObject(object.preferences[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetGatePageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGatePageDataResponse
         * @static
         * @param {pond.GetGatePageDataResponse} message GetGatePageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGatePageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.linkedDevices = [];
                object.linkedComponents = [];
            }
            if (options.objects || options.defaults)
                object.preferences = {};
            if (options.defaults)
                object.gate = null;
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = $root.pond.Gate.toObject(message.gate, options);
            if (message.linkedDevices && message.linkedDevices.length) {
                object.linkedDevices = [];
                for (var j = 0; j < message.linkedDevices.length; ++j)
                    object.linkedDevices[j] = $root.pond.ComprehensiveDevice.toObject(message.linkedDevices[j], options);
            }
            if (message.linkedComponents && message.linkedComponents.length) {
                object.linkedComponents = [];
                for (var j = 0; j < message.linkedComponents.length; ++j)
                    object.linkedComponents[j] = $root.pond.Component.toObject(message.linkedComponents[j], options);
            }
            var keys2;
            if (message.preferences && (keys2 = Object.keys(message.preferences)).length) {
                object.preferences = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.preferences[keys2[j]] = $root.pond.GatePreferences.toObject(message.preferences[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this GetGatePageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetGatePageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGatePageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGatePageDataResponse;
    })();

    pond.GatePreferences = (function() {

        /**
         * Properties of a GatePreferences.
         * @memberof pond
         * @interface IGatePreferences
         * @property {pond.GateComponentType|null} [gateComponent] GatePreferences gateComponent
         * @property {pond.GateDeviceType|null} [gateDevice] GatePreferences gateDevice
         */

        /**
         * Constructs a new GatePreferences.
         * @memberof pond
         * @classdesc Represents a GatePreferences.
         * @implements IGatePreferences
         * @constructor
         * @param {pond.IGatePreferences=} [properties] Properties to set
         */
        function GatePreferences(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GatePreferences gateComponent.
         * @member {pond.GateComponentType} gateComponent
         * @memberof pond.GatePreferences
         * @instance
         */
        GatePreferences.prototype.gateComponent = 0;

        /**
         * GatePreferences gateDevice.
         * @member {pond.GateDeviceType} gateDevice
         * @memberof pond.GatePreferences
         * @instance
         */
        GatePreferences.prototype.gateDevice = 0;

        /**
         * Creates a new GatePreferences instance using the specified properties.
         * @function create
         * @memberof pond.GatePreferences
         * @static
         * @param {pond.IGatePreferences=} [properties] Properties to set
         * @returns {pond.GatePreferences} GatePreferences instance
         */
        GatePreferences.create = function create(properties) {
            return new GatePreferences(properties);
        };

        /**
         * Creates a GatePreferences message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GatePreferences
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GatePreferences} GatePreferences
         */
        GatePreferences.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GatePreferences)
                return object;
            var message = new $root.pond.GatePreferences();
            switch (object.gateComponent) {
            case "GATE_COMPONENT_TYPE_UNKNOWN":
            case 0:
                message.gateComponent = 0;
                break;
            case "GATE_COMPONENT_TYPE_TEMP":
            case 1:
                message.gateComponent = 1;
                break;
            case "GATE_COMPONENT_TYPE_PRESSURE":
            case 2:
                message.gateComponent = 2;
                break;
            case "GATE_COMPONENT_TYPE_AMBIENT":
            case 3:
                message.gateComponent = 3;
                break;
            }
            switch (object.gateDevice) {
            case "GATE_DEVICE_TYPE_UNKNOWN":
            case 0:
                message.gateDevice = 0;
                break;
            case "GATE_DEVICE_TYPE_PCA":
            case 1:
                message.gateDevice = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GatePreferences message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GatePreferences
         * @static
         * @param {pond.GatePreferences} message GatePreferences
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GatePreferences.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gateComponent = options.enums === String ? "GATE_COMPONENT_TYPE_UNKNOWN" : 0;
                object.gateDevice = options.enums === String ? "GATE_DEVICE_TYPE_UNKNOWN" : 0;
            }
            if (message.gateComponent != null && message.hasOwnProperty("gateComponent"))
                object.gateComponent = options.enums === String ? $root.pond.GateComponentType[message.gateComponent] : message.gateComponent;
            if (message.gateDevice != null && message.hasOwnProperty("gateDevice"))
                object.gateDevice = options.enums === String ? $root.pond.GateDeviceType[message.gateDevice] : message.gateDevice;
            return object;
        };

        /**
         * Converts this GatePreferences to JSON.
         * @function toJSON
         * @memberof pond.GatePreferences
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GatePreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GatePreferences;
    })();

    pond.UpdateGateLinkResponse = (function() {

        /**
         * Properties of an UpdateGateLinkResponse.
         * @memberof pond
         * @interface IUpdateGateLinkResponse
         */

        /**
         * Constructs a new UpdateGateLinkResponse.
         * @memberof pond
         * @classdesc Represents an UpdateGateLinkResponse.
         * @implements IUpdateGateLinkResponse
         * @constructor
         * @param {pond.IUpdateGateLinkResponse=} [properties] Properties to set
         */
        function UpdateGateLinkResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGateLinkResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGateLinkResponse
         * @static
         * @param {pond.IUpdateGateLinkResponse=} [properties] Properties to set
         * @returns {pond.UpdateGateLinkResponse} UpdateGateLinkResponse instance
         */
        UpdateGateLinkResponse.create = function create(properties) {
            return new UpdateGateLinkResponse(properties);
        };

        /**
         * Creates an UpdateGateLinkResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGateLinkResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGateLinkResponse} UpdateGateLinkResponse
         */
        UpdateGateLinkResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGateLinkResponse)
                return object;
            return new $root.pond.UpdateGateLinkResponse();
        };

        /**
         * Creates a plain object from an UpdateGateLinkResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGateLinkResponse
         * @static
         * @param {pond.UpdateGateLinkResponse} message UpdateGateLinkResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGateLinkResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGateLinkResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateGateLinkResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGateLinkResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGateLinkResponse;
    })();

    pond.ListGateAirflowRequest = (function() {

        /**
         * Properties of a ListGateAirflowRequest.
         * @memberof pond
         * @interface IListGateAirflowRequest
         * @property {string|null} [gate] ListGateAirflowRequest gate
         * @property {number|null} [device] ListGateAirflowRequest device
         * @property {string|null} [ambientComponent] ListGateAirflowRequest ambientComponent
         * @property {string|null} [pressureComponent] ListGateAirflowRequest pressureComponent
         * @property {string|null} [startTime] ListGateAirflowRequest startTime
         * @property {string|null} [endTime] ListGateAirflowRequest endTime
         */

        /**
         * Constructs a new ListGateAirflowRequest.
         * @memberof pond
         * @classdesc Represents a ListGateAirflowRequest.
         * @implements IListGateAirflowRequest
         * @constructor
         * @param {pond.IListGateAirflowRequest=} [properties] Properties to set
         */
        function ListGateAirflowRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateAirflowRequest gate.
         * @member {string} gate
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.gate = "";

        /**
         * ListGateAirflowRequest device.
         * @member {number} device
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListGateAirflowRequest ambientComponent.
         * @member {string} ambientComponent
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.ambientComponent = "";

        /**
         * ListGateAirflowRequest pressureComponent.
         * @member {string} pressureComponent
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.pressureComponent = "";

        /**
         * ListGateAirflowRequest startTime.
         * @member {string} startTime
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.startTime = "";

        /**
         * ListGateAirflowRequest endTime.
         * @member {string} endTime
         * @memberof pond.ListGateAirflowRequest
         * @instance
         */
        ListGateAirflowRequest.prototype.endTime = "";

        /**
         * Creates a new ListGateAirflowRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGateAirflowRequest
         * @static
         * @param {pond.IListGateAirflowRequest=} [properties] Properties to set
         * @returns {pond.ListGateAirflowRequest} ListGateAirflowRequest instance
         */
        ListGateAirflowRequest.create = function create(properties) {
            return new ListGateAirflowRequest(properties);
        };

        /**
         * Creates a ListGateAirflowRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateAirflowRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateAirflowRequest} ListGateAirflowRequest
         */
        ListGateAirflowRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateAirflowRequest)
                return object;
            var message = new $root.pond.ListGateAirflowRequest();
            if (object.gate != null)
                message.gate = String(object.gate);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.ambientComponent != null)
                message.ambientComponent = String(object.ambientComponent);
            if (object.pressureComponent != null)
                message.pressureComponent = String(object.pressureComponent);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            return message;
        };

        /**
         * Creates a plain object from a ListGateAirflowRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateAirflowRequest
         * @static
         * @param {pond.ListGateAirflowRequest} message ListGateAirflowRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateAirflowRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gate = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.ambientComponent = "";
                object.pressureComponent = "";
                object.startTime = "";
                object.endTime = "";
            }
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = message.gate;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.ambientComponent != null && message.hasOwnProperty("ambientComponent"))
                object.ambientComponent = message.ambientComponent;
            if (message.pressureComponent != null && message.hasOwnProperty("pressureComponent"))
                object.pressureComponent = message.pressureComponent;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            return object;
        };

        /**
         * Converts this ListGateAirflowRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGateAirflowRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateAirflowRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateAirflowRequest;
    })();

    pond.ListGateAirflowResponse = (function() {

        /**
         * Properties of a ListGateAirflowResponse.
         * @memberof pond
         * @interface IListGateAirflowResponse
         * @property {Array.<pond.FlowAt>|null} [values] ListGateAirflowResponse values
         */

        /**
         * Constructs a new ListGateAirflowResponse.
         * @memberof pond
         * @classdesc Represents a ListGateAirflowResponse.
         * @implements IListGateAirflowResponse
         * @constructor
         * @param {pond.IListGateAirflowResponse=} [properties] Properties to set
         */
        function ListGateAirflowResponse(properties) {
            this.values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateAirflowResponse values.
         * @member {Array.<pond.FlowAt>} values
         * @memberof pond.ListGateAirflowResponse
         * @instance
         */
        ListGateAirflowResponse.prototype.values = $util.emptyArray;

        /**
         * Creates a new ListGateAirflowResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGateAirflowResponse
         * @static
         * @param {pond.IListGateAirflowResponse=} [properties] Properties to set
         * @returns {pond.ListGateAirflowResponse} ListGateAirflowResponse instance
         */
        ListGateAirflowResponse.create = function create(properties) {
            return new ListGateAirflowResponse(properties);
        };

        /**
         * Creates a ListGateAirflowResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateAirflowResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateAirflowResponse} ListGateAirflowResponse
         */
        ListGateAirflowResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateAirflowResponse)
                return object;
            var message = new $root.pond.ListGateAirflowResponse();
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.ListGateAirflowResponse.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".pond.ListGateAirflowResponse.values: object expected");
                    message.values[i] = $root.pond.FlowAt.fromObject(object.values[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListGateAirflowResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateAirflowResponse
         * @static
         * @param {pond.ListGateAirflowResponse} message ListGateAirflowResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateAirflowResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.values = [];
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.pond.FlowAt.toObject(message.values[j], options);
            }
            return object;
        };

        /**
         * Converts this ListGateAirflowResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGateAirflowResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateAirflowResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateAirflowResponse;
    })();

    pond.ListGateFlowEventsRequest = (function() {

        /**
         * Properties of a ListGateFlowEventsRequest.
         * @memberof pond
         * @interface IListGateFlowEventsRequest
         * @property {string|null} [gate] ListGateFlowEventsRequest gate
         * @property {number|null} [device] ListGateFlowEventsRequest device
         * @property {string|null} [ambientComponent] ListGateFlowEventsRequest ambientComponent
         * @property {string|null} [pressureComponent] ListGateFlowEventsRequest pressureComponent
         * @property {string|null} [startTime] ListGateFlowEventsRequest startTime
         * @property {string|null} [endTime] ListGateFlowEventsRequest endTime
         * @property {number|null} [idleFlow] ListGateFlowEventsRequest idleFlow
         * @property {number|null} [variance] ListGateFlowEventsRequest variance
         */

        /**
         * Constructs a new ListGateFlowEventsRequest.
         * @memberof pond
         * @classdesc Represents a ListGateFlowEventsRequest.
         * @implements IListGateFlowEventsRequest
         * @constructor
         * @param {pond.IListGateFlowEventsRequest=} [properties] Properties to set
         */
        function ListGateFlowEventsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateFlowEventsRequest gate.
         * @member {string} gate
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.gate = "";

        /**
         * ListGateFlowEventsRequest device.
         * @member {number} device
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListGateFlowEventsRequest ambientComponent.
         * @member {string} ambientComponent
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.ambientComponent = "";

        /**
         * ListGateFlowEventsRequest pressureComponent.
         * @member {string} pressureComponent
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.pressureComponent = "";

        /**
         * ListGateFlowEventsRequest startTime.
         * @member {string} startTime
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.startTime = "";

        /**
         * ListGateFlowEventsRequest endTime.
         * @member {string} endTime
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.endTime = "";

        /**
         * ListGateFlowEventsRequest idleFlow.
         * @member {number} idleFlow
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.idleFlow = 0;

        /**
         * ListGateFlowEventsRequest variance.
         * @member {number} variance
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         */
        ListGateFlowEventsRequest.prototype.variance = 0;

        /**
         * Creates a new ListGateFlowEventsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGateFlowEventsRequest
         * @static
         * @param {pond.IListGateFlowEventsRequest=} [properties] Properties to set
         * @returns {pond.ListGateFlowEventsRequest} ListGateFlowEventsRequest instance
         */
        ListGateFlowEventsRequest.create = function create(properties) {
            return new ListGateFlowEventsRequest(properties);
        };

        /**
         * Creates a ListGateFlowEventsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateFlowEventsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateFlowEventsRequest} ListGateFlowEventsRequest
         */
        ListGateFlowEventsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateFlowEventsRequest)
                return object;
            var message = new $root.pond.ListGateFlowEventsRequest();
            if (object.gate != null)
                message.gate = String(object.gate);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.ambientComponent != null)
                message.ambientComponent = String(object.ambientComponent);
            if (object.pressureComponent != null)
                message.pressureComponent = String(object.pressureComponent);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            if (object.idleFlow != null)
                message.idleFlow = Number(object.idleFlow);
            if (object.variance != null)
                message.variance = Number(object.variance);
            return message;
        };

        /**
         * Creates a plain object from a ListGateFlowEventsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateFlowEventsRequest
         * @static
         * @param {pond.ListGateFlowEventsRequest} message ListGateFlowEventsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateFlowEventsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gate = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.ambientComponent = "";
                object.pressureComponent = "";
                object.startTime = "";
                object.endTime = "";
                object.idleFlow = 0;
                object.variance = 0;
            }
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = message.gate;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.ambientComponent != null && message.hasOwnProperty("ambientComponent"))
                object.ambientComponent = message.ambientComponent;
            if (message.pressureComponent != null && message.hasOwnProperty("pressureComponent"))
                object.pressureComponent = message.pressureComponent;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            if (message.idleFlow != null && message.hasOwnProperty("idleFlow"))
                object.idleFlow = options.json && !isFinite(message.idleFlow) ? String(message.idleFlow) : message.idleFlow;
            if (message.variance != null && message.hasOwnProperty("variance"))
                object.variance = options.json && !isFinite(message.variance) ? String(message.variance) : message.variance;
            return object;
        };

        /**
         * Converts this ListGateFlowEventsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGateFlowEventsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateFlowEventsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateFlowEventsRequest;
    })();

    pond.ListGateFlowEventsResponse = (function() {

        /**
         * Properties of a ListGateFlowEventsResponse.
         * @memberof pond
         * @interface IListGateFlowEventsResponse
         * @property {Array.<pond.AirFlowEvent>|null} [events] ListGateFlowEventsResponse events
         */

        /**
         * Constructs a new ListGateFlowEventsResponse.
         * @memberof pond
         * @classdesc Represents a ListGateFlowEventsResponse.
         * @implements IListGateFlowEventsResponse
         * @constructor
         * @param {pond.IListGateFlowEventsResponse=} [properties] Properties to set
         */
        function ListGateFlowEventsResponse(properties) {
            this.events = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateFlowEventsResponse events.
         * @member {Array.<pond.AirFlowEvent>} events
         * @memberof pond.ListGateFlowEventsResponse
         * @instance
         */
        ListGateFlowEventsResponse.prototype.events = $util.emptyArray;

        /**
         * Creates a new ListGateFlowEventsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGateFlowEventsResponse
         * @static
         * @param {pond.IListGateFlowEventsResponse=} [properties] Properties to set
         * @returns {pond.ListGateFlowEventsResponse} ListGateFlowEventsResponse instance
         */
        ListGateFlowEventsResponse.create = function create(properties) {
            return new ListGateFlowEventsResponse(properties);
        };

        /**
         * Creates a ListGateFlowEventsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateFlowEventsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateFlowEventsResponse} ListGateFlowEventsResponse
         */
        ListGateFlowEventsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateFlowEventsResponse)
                return object;
            var message = new $root.pond.ListGateFlowEventsResponse();
            if (object.events) {
                if (!Array.isArray(object.events))
                    throw TypeError(".pond.ListGateFlowEventsResponse.events: array expected");
                message.events = [];
                for (var i = 0; i < object.events.length; ++i) {
                    if (typeof object.events[i] !== "object")
                        throw TypeError(".pond.ListGateFlowEventsResponse.events: object expected");
                    message.events[i] = $root.pond.AirFlowEvent.fromObject(object.events[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListGateFlowEventsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateFlowEventsResponse
         * @static
         * @param {pond.ListGateFlowEventsResponse} message ListGateFlowEventsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateFlowEventsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.events = [];
            if (message.events && message.events.length) {
                object.events = [];
                for (var j = 0; j < message.events.length; ++j)
                    object.events[j] = $root.pond.AirFlowEvent.toObject(message.events[j], options);
            }
            return object;
        };

        /**
         * Converts this ListGateFlowEventsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGateFlowEventsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateFlowEventsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateFlowEventsResponse;
    })();

    pond.ListGateMeasurementsRequest = (function() {

        /**
         * Properties of a ListGateMeasurementsRequest.
         * @memberof pond
         * @interface IListGateMeasurementsRequest
         * @property {string|null} [gate] ListGateMeasurementsRequest gate
         * @property {number|null} [device] ListGateMeasurementsRequest device
         * @property {string|null} [startTime] ListGateMeasurementsRequest startTime
         * @property {string|null} [endTime] ListGateMeasurementsRequest endTime
         */

        /**
         * Constructs a new ListGateMeasurementsRequest.
         * @memberof pond
         * @classdesc Represents a ListGateMeasurementsRequest.
         * @implements IListGateMeasurementsRequest
         * @constructor
         * @param {pond.IListGateMeasurementsRequest=} [properties] Properties to set
         */
        function ListGateMeasurementsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateMeasurementsRequest gate.
         * @member {string} gate
         * @memberof pond.ListGateMeasurementsRequest
         * @instance
         */
        ListGateMeasurementsRequest.prototype.gate = "";

        /**
         * ListGateMeasurementsRequest device.
         * @member {number} device
         * @memberof pond.ListGateMeasurementsRequest
         * @instance
         */
        ListGateMeasurementsRequest.prototype.device = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListGateMeasurementsRequest startTime.
         * @member {string} startTime
         * @memberof pond.ListGateMeasurementsRequest
         * @instance
         */
        ListGateMeasurementsRequest.prototype.startTime = "";

        /**
         * ListGateMeasurementsRequest endTime.
         * @member {string} endTime
         * @memberof pond.ListGateMeasurementsRequest
         * @instance
         */
        ListGateMeasurementsRequest.prototype.endTime = "";

        /**
         * Creates a new ListGateMeasurementsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGateMeasurementsRequest
         * @static
         * @param {pond.IListGateMeasurementsRequest=} [properties] Properties to set
         * @returns {pond.ListGateMeasurementsRequest} ListGateMeasurementsRequest instance
         */
        ListGateMeasurementsRequest.create = function create(properties) {
            return new ListGateMeasurementsRequest(properties);
        };

        /**
         * Creates a ListGateMeasurementsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateMeasurementsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateMeasurementsRequest} ListGateMeasurementsRequest
         */
        ListGateMeasurementsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateMeasurementsRequest)
                return object;
            var message = new $root.pond.ListGateMeasurementsRequest();
            if (object.gate != null)
                message.gate = String(object.gate);
            if (object.device != null)
                if ($util.Long)
                    (message.device = $util.Long.fromValue(object.device)).unsigned = true;
                else if (typeof object.device === "string")
                    message.device = parseInt(object.device, 10);
                else if (typeof object.device === "number")
                    message.device = object.device;
                else if (typeof object.device === "object")
                    message.device = new $util.LongBits(object.device.low >>> 0, object.device.high >>> 0).toNumber(true);
            if (object.startTime != null)
                message.startTime = String(object.startTime);
            if (object.endTime != null)
                message.endTime = String(object.endTime);
            return message;
        };

        /**
         * Creates a plain object from a ListGateMeasurementsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateMeasurementsRequest
         * @static
         * @param {pond.ListGateMeasurementsRequest} message ListGateMeasurementsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateMeasurementsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gate = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, true);
                    object.device = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.device = options.longs === String ? "0" : 0;
                object.startTime = "";
                object.endTime = "";
            }
            if (message.gate != null && message.hasOwnProperty("gate"))
                object.gate = message.gate;
            if (message.device != null && message.hasOwnProperty("device"))
                if (typeof message.device === "number")
                    object.device = options.longs === String ? String(message.device) : message.device;
                else
                    object.device = options.longs === String ? $util.Long.prototype.toString.call(message.device) : options.longs === Number ? new $util.LongBits(message.device.low >>> 0, message.device.high >>> 0).toNumber(true) : message.device;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            return object;
        };

        /**
         * Converts this ListGateMeasurementsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGateMeasurementsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateMeasurementsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateMeasurementsRequest;
    })();

    pond.ListGateMeasurementsResponse = (function() {

        /**
         * Properties of a ListGateMeasurementsResponse.
         * @memberof pond
         * @interface IListGateMeasurementsResponse
         * @property {Array.<pond.UnitMeasurementsForComponent>|null} [measurements] ListGateMeasurementsResponse measurements
         */

        /**
         * Constructs a new ListGateMeasurementsResponse.
         * @memberof pond
         * @classdesc Represents a ListGateMeasurementsResponse.
         * @implements IListGateMeasurementsResponse
         * @constructor
         * @param {pond.IListGateMeasurementsResponse=} [properties] Properties to set
         */
        function ListGateMeasurementsResponse(properties) {
            this.measurements = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGateMeasurementsResponse measurements.
         * @member {Array.<pond.UnitMeasurementsForComponent>} measurements
         * @memberof pond.ListGateMeasurementsResponse
         * @instance
         */
        ListGateMeasurementsResponse.prototype.measurements = $util.emptyArray;

        /**
         * Creates a new ListGateMeasurementsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGateMeasurementsResponse
         * @static
         * @param {pond.IListGateMeasurementsResponse=} [properties] Properties to set
         * @returns {pond.ListGateMeasurementsResponse} ListGateMeasurementsResponse instance
         */
        ListGateMeasurementsResponse.create = function create(properties) {
            return new ListGateMeasurementsResponse(properties);
        };

        /**
         * Creates a ListGateMeasurementsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGateMeasurementsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGateMeasurementsResponse} ListGateMeasurementsResponse
         */
        ListGateMeasurementsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGateMeasurementsResponse)
                return object;
            var message = new $root.pond.ListGateMeasurementsResponse();
            if (object.measurements) {
                if (!Array.isArray(object.measurements))
                    throw TypeError(".pond.ListGateMeasurementsResponse.measurements: array expected");
                message.measurements = [];
                for (var i = 0; i < object.measurements.length; ++i) {
                    if (typeof object.measurements[i] !== "object")
                        throw TypeError(".pond.ListGateMeasurementsResponse.measurements: object expected");
                    message.measurements[i] = $root.pond.UnitMeasurementsForComponent.fromObject(object.measurements[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListGateMeasurementsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGateMeasurementsResponse
         * @static
         * @param {pond.ListGateMeasurementsResponse} message ListGateMeasurementsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGateMeasurementsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.measurements = [];
            if (message.measurements && message.measurements.length) {
                object.measurements = [];
                for (var j = 0; j < message.measurements.length; ++j)
                    object.measurements[j] = $root.pond.UnitMeasurementsForComponent.toObject(message.measurements[j], options);
            }
            return object;
        };

        /**
         * Converts this ListGateMeasurementsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGateMeasurementsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGateMeasurementsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGateMeasurementsResponse;
    })();

    pond.FlowAt = (function() {

        /**
         * Properties of a FlowAt.
         * @memberof pond
         * @interface IFlowAt
         * @property {number|null} [airFlow] FlowAt airFlow
         * @property {string|null} [time] FlowAt time
         */

        /**
         * Constructs a new FlowAt.
         * @memberof pond
         * @classdesc Represents a FlowAt.
         * @implements IFlowAt
         * @constructor
         * @param {pond.IFlowAt=} [properties] Properties to set
         */
        function FlowAt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FlowAt airFlow.
         * @member {number} airFlow
         * @memberof pond.FlowAt
         * @instance
         */
        FlowAt.prototype.airFlow = 0;

        /**
         * FlowAt time.
         * @member {string} time
         * @memberof pond.FlowAt
         * @instance
         */
        FlowAt.prototype.time = "";

        /**
         * Creates a new FlowAt instance using the specified properties.
         * @function create
         * @memberof pond.FlowAt
         * @static
         * @param {pond.IFlowAt=} [properties] Properties to set
         * @returns {pond.FlowAt} FlowAt instance
         */
        FlowAt.create = function create(properties) {
            return new FlowAt(properties);
        };

        /**
         * Creates a FlowAt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.FlowAt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.FlowAt} FlowAt
         */
        FlowAt.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.FlowAt)
                return object;
            var message = new $root.pond.FlowAt();
            if (object.airFlow != null)
                message.airFlow = Number(object.airFlow);
            if (object.time != null)
                message.time = String(object.time);
            return message;
        };

        /**
         * Creates a plain object from a FlowAt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.FlowAt
         * @static
         * @param {pond.FlowAt} message FlowAt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FlowAt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.airFlow = 0;
                object.time = "";
            }
            if (message.airFlow != null && message.hasOwnProperty("airFlow"))
                object.airFlow = options.json && !isFinite(message.airFlow) ? String(message.airFlow) : message.airFlow;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            return object;
        };

        /**
         * Converts this FlowAt to JSON.
         * @function toJSON
         * @memberof pond.FlowAt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FlowAt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FlowAt;
    })();

    pond.AirFlowEvent = (function() {

        /**
         * Properties of an AirFlowEvent.
         * @memberof pond
         * @interface IAirFlowEvent
         * @property {string|null} [start] AirFlowEvent start
         * @property {string|null} [end] AirFlowEvent end
         * @property {Array.<pond.FlowAt>|null} [readings] AirFlowEvent readings
         */

        /**
         * Constructs a new AirFlowEvent.
         * @memberof pond
         * @classdesc Represents an AirFlowEvent.
         * @implements IAirFlowEvent
         * @constructor
         * @param {pond.IAirFlowEvent=} [properties] Properties to set
         */
        function AirFlowEvent(properties) {
            this.readings = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AirFlowEvent start.
         * @member {string} start
         * @memberof pond.AirFlowEvent
         * @instance
         */
        AirFlowEvent.prototype.start = "";

        /**
         * AirFlowEvent end.
         * @member {string} end
         * @memberof pond.AirFlowEvent
         * @instance
         */
        AirFlowEvent.prototype.end = "";

        /**
         * AirFlowEvent readings.
         * @member {Array.<pond.FlowAt>} readings
         * @memberof pond.AirFlowEvent
         * @instance
         */
        AirFlowEvent.prototype.readings = $util.emptyArray;

        /**
         * Creates a new AirFlowEvent instance using the specified properties.
         * @function create
         * @memberof pond.AirFlowEvent
         * @static
         * @param {pond.IAirFlowEvent=} [properties] Properties to set
         * @returns {pond.AirFlowEvent} AirFlowEvent instance
         */
        AirFlowEvent.create = function create(properties) {
            return new AirFlowEvent(properties);
        };

        /**
         * Creates an AirFlowEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AirFlowEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AirFlowEvent} AirFlowEvent
         */
        AirFlowEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AirFlowEvent)
                return object;
            var message = new $root.pond.AirFlowEvent();
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            if (object.readings) {
                if (!Array.isArray(object.readings))
                    throw TypeError(".pond.AirFlowEvent.readings: array expected");
                message.readings = [];
                for (var i = 0; i < object.readings.length; ++i) {
                    if (typeof object.readings[i] !== "object")
                        throw TypeError(".pond.AirFlowEvent.readings: object expected");
                    message.readings[i] = $root.pond.FlowAt.fromObject(object.readings[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AirFlowEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AirFlowEvent
         * @static
         * @param {pond.AirFlowEvent} message AirFlowEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AirFlowEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.readings = [];
            if (options.defaults) {
                object.start = "";
                object.end = "";
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            if (message.readings && message.readings.length) {
                object.readings = [];
                for (var j = 0; j < message.readings.length; ++j)
                    object.readings[j] = $root.pond.FlowAt.toObject(message.readings[j], options);
            }
            return object;
        };

        /**
         * Converts this AirFlowEvent to JSON.
         * @function toJSON
         * @memberof pond.AirFlowEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AirFlowEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AirFlowEvent;
    })();

    pond.ObjectHeater = (function() {

        /**
         * Properties of an ObjectHeater.
         * @memberof pond
         * @interface IObjectHeater
         * @property {string|null} [key] ObjectHeater key
         * @property {string|null} [name] ObjectHeater name
         * @property {pond.ObjectHeaterSettings|null} [settings] ObjectHeater settings
         */

        /**
         * Constructs a new ObjectHeater.
         * @memberof pond
         * @classdesc Represents an ObjectHeater.
         * @implements IObjectHeater
         * @constructor
         * @param {pond.IObjectHeater=} [properties] Properties to set
         */
        function ObjectHeater(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectHeater key.
         * @member {string} key
         * @memberof pond.ObjectHeater
         * @instance
         */
        ObjectHeater.prototype.key = "";

        /**
         * ObjectHeater name.
         * @member {string} name
         * @memberof pond.ObjectHeater
         * @instance
         */
        ObjectHeater.prototype.name = "";

        /**
         * ObjectHeater settings.
         * @member {pond.ObjectHeaterSettings|null|undefined} settings
         * @memberof pond.ObjectHeater
         * @instance
         */
        ObjectHeater.prototype.settings = null;

        /**
         * Creates a new ObjectHeater instance using the specified properties.
         * @function create
         * @memberof pond.ObjectHeater
         * @static
         * @param {pond.IObjectHeater=} [properties] Properties to set
         * @returns {pond.ObjectHeater} ObjectHeater instance
         */
        ObjectHeater.create = function create(properties) {
            return new ObjectHeater(properties);
        };

        /**
         * Creates an ObjectHeater message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectHeater
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectHeater} ObjectHeater
         */
        ObjectHeater.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectHeater)
                return object;
            var message = new $root.pond.ObjectHeater();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.ObjectHeater.settings: object expected");
                message.settings = $root.pond.ObjectHeaterSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectHeater message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectHeater
         * @static
         * @param {pond.ObjectHeater} message ObjectHeater
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectHeater.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectHeaterSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this ObjectHeater to JSON.
         * @function toJSON
         * @memberof pond.ObjectHeater
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectHeater.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectHeater;
    })();

    /**
     * FuelType enum.
     * @name pond.FuelType
     * @enum {string}
     * @property {number} FUEL_TYPE_UNKNOWN=0 FUEL_TYPE_UNKNOWN value
     * @property {number} FUEL_TYPE_GASOLINE=1 FUEL_TYPE_GASOLINE value
     * @property {number} FUEL_TYPE_DIESEL=2 FUEL_TYPE_DIESEL value
     * @property {number} FUEL_TYPE_PROPANE=3 FUEL_TYPE_PROPANE value
     */
    pond.FuelType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FUEL_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "FUEL_TYPE_GASOLINE"] = 1;
        values[valuesById[2] = "FUEL_TYPE_DIESEL"] = 2;
        values[valuesById[3] = "FUEL_TYPE_PROPANE"] = 3;
        return values;
    })();

    pond.ObjectHeaterSettings = (function() {

        /**
         * Properties of an ObjectHeaterSettings.
         * @memberof pond
         * @interface IObjectHeaterSettings
         * @property {string|null} [siteKey] ObjectHeaterSettings siteKey
         * @property {string|null} [make] ObjectHeaterSettings make
         * @property {string|null} [model] ObjectHeaterSettings model
         * @property {pond.FuelType|null} [fuelType] ObjectHeaterSettings fuelType
         * @property {number|null} [tankSize] ObjectHeaterSettings tankSize
         * @property {number|null} [fuelConsumption] ObjectHeaterSettings fuelConsumption
         * @property {number|null} [airCirculation] ObjectHeaterSettings airCirculation
         * @property {Array.<pond.LinearMutation>|null} [mutations] ObjectHeaterSettings mutations
         */

        /**
         * Constructs a new ObjectHeaterSettings.
         * @memberof pond
         * @classdesc Represents an ObjectHeaterSettings.
         * @implements IObjectHeaterSettings
         * @constructor
         * @param {pond.IObjectHeaterSettings=} [properties] Properties to set
         */
        function ObjectHeaterSettings(properties) {
            this.mutations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectHeaterSettings siteKey.
         * @member {string} siteKey
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.siteKey = "";

        /**
         * ObjectHeaterSettings make.
         * @member {string} make
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.make = "";

        /**
         * ObjectHeaterSettings model.
         * @member {string} model
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.model = "";

        /**
         * ObjectHeaterSettings fuelType.
         * @member {pond.FuelType} fuelType
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.fuelType = 0;

        /**
         * ObjectHeaterSettings tankSize.
         * @member {number} tankSize
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.tankSize = 0;

        /**
         * ObjectHeaterSettings fuelConsumption.
         * @member {number} fuelConsumption
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.fuelConsumption = 0;

        /**
         * ObjectHeaterSettings airCirculation.
         * @member {number} airCirculation
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.airCirculation = 0;

        /**
         * ObjectHeaterSettings mutations.
         * @member {Array.<pond.LinearMutation>} mutations
         * @memberof pond.ObjectHeaterSettings
         * @instance
         */
        ObjectHeaterSettings.prototype.mutations = $util.emptyArray;

        /**
         * Creates a new ObjectHeaterSettings instance using the specified properties.
         * @function create
         * @memberof pond.ObjectHeaterSettings
         * @static
         * @param {pond.IObjectHeaterSettings=} [properties] Properties to set
         * @returns {pond.ObjectHeaterSettings} ObjectHeaterSettings instance
         */
        ObjectHeaterSettings.create = function create(properties) {
            return new ObjectHeaterSettings(properties);
        };

        /**
         * Creates an ObjectHeaterSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectHeaterSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectHeaterSettings} ObjectHeaterSettings
         */
        ObjectHeaterSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectHeaterSettings)
                return object;
            var message = new $root.pond.ObjectHeaterSettings();
            if (object.siteKey != null)
                message.siteKey = String(object.siteKey);
            if (object.make != null)
                message.make = String(object.make);
            if (object.model != null)
                message.model = String(object.model);
            switch (object.fuelType) {
            case "FUEL_TYPE_UNKNOWN":
            case 0:
                message.fuelType = 0;
                break;
            case "FUEL_TYPE_GASOLINE":
            case 1:
                message.fuelType = 1;
                break;
            case "FUEL_TYPE_DIESEL":
            case 2:
                message.fuelType = 2;
                break;
            case "FUEL_TYPE_PROPANE":
            case 3:
                message.fuelType = 3;
                break;
            }
            if (object.tankSize != null)
                message.tankSize = Number(object.tankSize);
            if (object.fuelConsumption != null)
                message.fuelConsumption = Number(object.fuelConsumption);
            if (object.airCirculation != null)
                message.airCirculation = Number(object.airCirculation);
            if (object.mutations) {
                if (!Array.isArray(object.mutations))
                    throw TypeError(".pond.ObjectHeaterSettings.mutations: array expected");
                message.mutations = [];
                for (var i = 0; i < object.mutations.length; ++i) {
                    if (typeof object.mutations[i] !== "object")
                        throw TypeError(".pond.ObjectHeaterSettings.mutations: object expected");
                    message.mutations[i] = $root.pond.LinearMutation.fromObject(object.mutations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectHeaterSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectHeaterSettings
         * @static
         * @param {pond.ObjectHeaterSettings} message ObjectHeaterSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectHeaterSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.mutations = [];
            if (options.defaults) {
                object.siteKey = "";
                object.make = "";
                object.model = "";
                object.fuelType = options.enums === String ? "FUEL_TYPE_UNKNOWN" : 0;
                object.tankSize = 0;
                object.fuelConsumption = 0;
                object.airCirculation = 0;
            }
            if (message.siteKey != null && message.hasOwnProperty("siteKey"))
                object.siteKey = message.siteKey;
            if (message.make != null && message.hasOwnProperty("make"))
                object.make = message.make;
            if (message.model != null && message.hasOwnProperty("model"))
                object.model = message.model;
            if (message.fuelType != null && message.hasOwnProperty("fuelType"))
                object.fuelType = options.enums === String ? $root.pond.FuelType[message.fuelType] : message.fuelType;
            if (message.tankSize != null && message.hasOwnProperty("tankSize"))
                object.tankSize = options.json && !isFinite(message.tankSize) ? String(message.tankSize) : message.tankSize;
            if (message.fuelConsumption != null && message.hasOwnProperty("fuelConsumption"))
                object.fuelConsumption = options.json && !isFinite(message.fuelConsumption) ? String(message.fuelConsumption) : message.fuelConsumption;
            if (message.airCirculation != null && message.hasOwnProperty("airCirculation"))
                object.airCirculation = options.json && !isFinite(message.airCirculation) ? String(message.airCirculation) : message.airCirculation;
            if (message.mutations && message.mutations.length) {
                object.mutations = [];
                for (var j = 0; j < message.mutations.length; ++j)
                    object.mutations[j] = $root.pond.LinearMutation.toObject(message.mutations[j], options);
            }
            return object;
        };

        /**
         * Converts this ObjectHeaterSettings to JSON.
         * @function toJSON
         * @memberof pond.ObjectHeaterSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectHeaterSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectHeaterSettings;
    })();

    pond.GetObjectHeaterRequest = (function() {

        /**
         * Properties of a GetObjectHeaterRequest.
         * @memberof pond
         * @interface IGetObjectHeaterRequest
         * @property {string|null} [key] GetObjectHeaterRequest key
         */

        /**
         * Constructs a new GetObjectHeaterRequest.
         * @memberof pond
         * @classdesc Represents a GetObjectHeaterRequest.
         * @implements IGetObjectHeaterRequest
         * @constructor
         * @param {pond.IGetObjectHeaterRequest=} [properties] Properties to set
         */
        function GetObjectHeaterRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetObjectHeaterRequest key.
         * @member {string} key
         * @memberof pond.GetObjectHeaterRequest
         * @instance
         */
        GetObjectHeaterRequest.prototype.key = "";

        /**
         * Creates a new GetObjectHeaterRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetObjectHeaterRequest
         * @static
         * @param {pond.IGetObjectHeaterRequest=} [properties] Properties to set
         * @returns {pond.GetObjectHeaterRequest} GetObjectHeaterRequest instance
         */
        GetObjectHeaterRequest.create = function create(properties) {
            return new GetObjectHeaterRequest(properties);
        };

        /**
         * Creates a GetObjectHeaterRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetObjectHeaterRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetObjectHeaterRequest} GetObjectHeaterRequest
         */
        GetObjectHeaterRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetObjectHeaterRequest)
                return object;
            var message = new $root.pond.GetObjectHeaterRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetObjectHeaterRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetObjectHeaterRequest
         * @static
         * @param {pond.GetObjectHeaterRequest} message GetObjectHeaterRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetObjectHeaterRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetObjectHeaterRequest to JSON.
         * @function toJSON
         * @memberof pond.GetObjectHeaterRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetObjectHeaterRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetObjectHeaterRequest;
    })();

    pond.GetObjectHeaterResponse = (function() {

        /**
         * Properties of a GetObjectHeaterResponse.
         * @memberof pond
         * @interface IGetObjectHeaterResponse
         * @property {pond.ObjectHeater|null} [heater] GetObjectHeaterResponse heater
         */

        /**
         * Constructs a new GetObjectHeaterResponse.
         * @memberof pond
         * @classdesc Represents a GetObjectHeaterResponse.
         * @implements IGetObjectHeaterResponse
         * @constructor
         * @param {pond.IGetObjectHeaterResponse=} [properties] Properties to set
         */
        function GetObjectHeaterResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetObjectHeaterResponse heater.
         * @member {pond.ObjectHeater|null|undefined} heater
         * @memberof pond.GetObjectHeaterResponse
         * @instance
         */
        GetObjectHeaterResponse.prototype.heater = null;

        /**
         * Creates a new GetObjectHeaterResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetObjectHeaterResponse
         * @static
         * @param {pond.IGetObjectHeaterResponse=} [properties] Properties to set
         * @returns {pond.GetObjectHeaterResponse} GetObjectHeaterResponse instance
         */
        GetObjectHeaterResponse.create = function create(properties) {
            return new GetObjectHeaterResponse(properties);
        };

        /**
         * Creates a GetObjectHeaterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetObjectHeaterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetObjectHeaterResponse} GetObjectHeaterResponse
         */
        GetObjectHeaterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetObjectHeaterResponse)
                return object;
            var message = new $root.pond.GetObjectHeaterResponse();
            if (object.heater != null) {
                if (typeof object.heater !== "object")
                    throw TypeError(".pond.GetObjectHeaterResponse.heater: object expected");
                message.heater = $root.pond.ObjectHeater.fromObject(object.heater);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetObjectHeaterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetObjectHeaterResponse
         * @static
         * @param {pond.GetObjectHeaterResponse} message GetObjectHeaterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetObjectHeaterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.heater = null;
            if (message.heater != null && message.hasOwnProperty("heater"))
                object.heater = $root.pond.ObjectHeater.toObject(message.heater, options);
            return object;
        };

        /**
         * Converts this GetObjectHeaterResponse to JSON.
         * @function toJSON
         * @memberof pond.GetObjectHeaterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetObjectHeaterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetObjectHeaterResponse;
    })();

    pond.ListObjectHeatersRequest = (function() {

        /**
         * Properties of a ListObjectHeatersRequest.
         * @memberof pond
         * @interface IListObjectHeatersRequest
         * @property {pond.Paging|null} [paging] ListObjectHeatersRequest paging
         * @property {pond.Sorting|null} [sorting] ListObjectHeatersRequest sorting
         * @property {string|null} [search] ListObjectHeatersRequest search
         */

        /**
         * Constructs a new ListObjectHeatersRequest.
         * @memberof pond
         * @classdesc Represents a ListObjectHeatersRequest.
         * @implements IListObjectHeatersRequest
         * @constructor
         * @param {pond.IListObjectHeatersRequest=} [properties] Properties to set
         */
        function ListObjectHeatersRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectHeatersRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListObjectHeatersRequest
         * @instance
         */
        ListObjectHeatersRequest.prototype.paging = null;

        /**
         * ListObjectHeatersRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListObjectHeatersRequest
         * @instance
         */
        ListObjectHeatersRequest.prototype.sorting = null;

        /**
         * ListObjectHeatersRequest search.
         * @member {string} search
         * @memberof pond.ListObjectHeatersRequest
         * @instance
         */
        ListObjectHeatersRequest.prototype.search = "";

        /**
         * Creates a new ListObjectHeatersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectHeatersRequest
         * @static
         * @param {pond.IListObjectHeatersRequest=} [properties] Properties to set
         * @returns {pond.ListObjectHeatersRequest} ListObjectHeatersRequest instance
         */
        ListObjectHeatersRequest.create = function create(properties) {
            return new ListObjectHeatersRequest(properties);
        };

        /**
         * Creates a ListObjectHeatersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectHeatersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectHeatersRequest} ListObjectHeatersRequest
         */
        ListObjectHeatersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectHeatersRequest)
                return object;
            var message = new $root.pond.ListObjectHeatersRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListObjectHeatersRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListObjectHeatersRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListObjectHeatersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectHeatersRequest
         * @static
         * @param {pond.ListObjectHeatersRequest} message ListObjectHeatersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectHeatersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListObjectHeatersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListObjectHeatersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectHeatersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectHeatersRequest;
    })();

    pond.ListObjectHeatersResponse = (function() {

        /**
         * Properties of a ListObjectHeatersResponse.
         * @memberof pond
         * @interface IListObjectHeatersResponse
         * @property {Array.<pond.ObjectHeater>|null} [heaters] ListObjectHeatersResponse heaters
         * @property {number|null} [nextOffset] ListObjectHeatersResponse nextOffset
         * @property {number|null} [total] ListObjectHeatersResponse total
         */

        /**
         * Constructs a new ListObjectHeatersResponse.
         * @memberof pond
         * @classdesc Represents a ListObjectHeatersResponse.
         * @implements IListObjectHeatersResponse
         * @constructor
         * @param {pond.IListObjectHeatersResponse=} [properties] Properties to set
         */
        function ListObjectHeatersResponse(properties) {
            this.heaters = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectHeatersResponse heaters.
         * @member {Array.<pond.ObjectHeater>} heaters
         * @memberof pond.ListObjectHeatersResponse
         * @instance
         */
        ListObjectHeatersResponse.prototype.heaters = $util.emptyArray;

        /**
         * ListObjectHeatersResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListObjectHeatersResponse
         * @instance
         */
        ListObjectHeatersResponse.prototype.nextOffset = 0;

        /**
         * ListObjectHeatersResponse total.
         * @member {number} total
         * @memberof pond.ListObjectHeatersResponse
         * @instance
         */
        ListObjectHeatersResponse.prototype.total = 0;

        /**
         * Creates a new ListObjectHeatersResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectHeatersResponse
         * @static
         * @param {pond.IListObjectHeatersResponse=} [properties] Properties to set
         * @returns {pond.ListObjectHeatersResponse} ListObjectHeatersResponse instance
         */
        ListObjectHeatersResponse.create = function create(properties) {
            return new ListObjectHeatersResponse(properties);
        };

        /**
         * Creates a ListObjectHeatersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectHeatersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectHeatersResponse} ListObjectHeatersResponse
         */
        ListObjectHeatersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectHeatersResponse)
                return object;
            var message = new $root.pond.ListObjectHeatersResponse();
            if (object.heaters) {
                if (!Array.isArray(object.heaters))
                    throw TypeError(".pond.ListObjectHeatersResponse.heaters: array expected");
                message.heaters = [];
                for (var i = 0; i < object.heaters.length; ++i) {
                    if (typeof object.heaters[i] !== "object")
                        throw TypeError(".pond.ListObjectHeatersResponse.heaters: object expected");
                    message.heaters[i] = $root.pond.ObjectHeater.fromObject(object.heaters[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListObjectHeatersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectHeatersResponse
         * @static
         * @param {pond.ListObjectHeatersResponse} message ListObjectHeatersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectHeatersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.heaters = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.heaters && message.heaters.length) {
                object.heaters = [];
                for (var j = 0; j < message.heaters.length; ++j)
                    object.heaters[j] = $root.pond.ObjectHeater.toObject(message.heaters[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListObjectHeatersResponse to JSON.
         * @function toJSON
         * @memberof pond.ListObjectHeatersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectHeatersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectHeatersResponse;
    })();

    pond.AddObjectHeaterRequest = (function() {

        /**
         * Properties of an AddObjectHeaterRequest.
         * @memberof pond
         * @interface IAddObjectHeaterRequest
         * @property {string|null} [name] AddObjectHeaterRequest name
         * @property {pond.ObjectHeaterSettings|null} [settings] AddObjectHeaterRequest settings
         */

        /**
         * Constructs a new AddObjectHeaterRequest.
         * @memberof pond
         * @classdesc Represents an AddObjectHeaterRequest.
         * @implements IAddObjectHeaterRequest
         * @constructor
         * @param {pond.IAddObjectHeaterRequest=} [properties] Properties to set
         */
        function AddObjectHeaterRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectHeaterRequest name.
         * @member {string} name
         * @memberof pond.AddObjectHeaterRequest
         * @instance
         */
        AddObjectHeaterRequest.prototype.name = "";

        /**
         * AddObjectHeaterRequest settings.
         * @member {pond.ObjectHeaterSettings|null|undefined} settings
         * @memberof pond.AddObjectHeaterRequest
         * @instance
         */
        AddObjectHeaterRequest.prototype.settings = null;

        /**
         * Creates a new AddObjectHeaterRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddObjectHeaterRequest
         * @static
         * @param {pond.IAddObjectHeaterRequest=} [properties] Properties to set
         * @returns {pond.AddObjectHeaterRequest} AddObjectHeaterRequest instance
         */
        AddObjectHeaterRequest.create = function create(properties) {
            return new AddObjectHeaterRequest(properties);
        };

        /**
         * Creates an AddObjectHeaterRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddObjectHeaterRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddObjectHeaterRequest} AddObjectHeaterRequest
         */
        AddObjectHeaterRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddObjectHeaterRequest)
                return object;
            var message = new $root.pond.AddObjectHeaterRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddObjectHeaterRequest.settings: object expected");
                message.settings = $root.pond.ObjectHeaterSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddObjectHeaterRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddObjectHeaterRequest
         * @static
         * @param {pond.AddObjectHeaterRequest} message AddObjectHeaterRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectHeaterRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectHeaterSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddObjectHeaterRequest to JSON.
         * @function toJSON
         * @memberof pond.AddObjectHeaterRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectHeaterRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddObjectHeaterRequest;
    })();

    pond.AddObjectHeaterResponse = (function() {

        /**
         * Properties of an AddObjectHeaterResponse.
         * @memberof pond
         * @interface IAddObjectHeaterResponse
         * @property {string|null} [key] AddObjectHeaterResponse key
         */

        /**
         * Constructs a new AddObjectHeaterResponse.
         * @memberof pond
         * @classdesc Represents an AddObjectHeaterResponse.
         * @implements IAddObjectHeaterResponse
         * @constructor
         * @param {pond.IAddObjectHeaterResponse=} [properties] Properties to set
         */
        function AddObjectHeaterResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectHeaterResponse key.
         * @member {string} key
         * @memberof pond.AddObjectHeaterResponse
         * @instance
         */
        AddObjectHeaterResponse.prototype.key = "";

        /**
         * Creates a new AddObjectHeaterResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddObjectHeaterResponse
         * @static
         * @param {pond.IAddObjectHeaterResponse=} [properties] Properties to set
         * @returns {pond.AddObjectHeaterResponse} AddObjectHeaterResponse instance
         */
        AddObjectHeaterResponse.create = function create(properties) {
            return new AddObjectHeaterResponse(properties);
        };

        /**
         * Creates an AddObjectHeaterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddObjectHeaterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddObjectHeaterResponse} AddObjectHeaterResponse
         */
        AddObjectHeaterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddObjectHeaterResponse)
                return object;
            var message = new $root.pond.AddObjectHeaterResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddObjectHeaterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddObjectHeaterResponse
         * @static
         * @param {pond.AddObjectHeaterResponse} message AddObjectHeaterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectHeaterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddObjectHeaterResponse to JSON.
         * @function toJSON
         * @memberof pond.AddObjectHeaterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectHeaterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddObjectHeaterResponse;
    })();

    pond.UpdateObjectHeaterRequest = (function() {

        /**
         * Properties of an UpdateObjectHeaterRequest.
         * @memberof pond
         * @interface IUpdateObjectHeaterRequest
         * @property {string|null} [key] UpdateObjectHeaterRequest key
         * @property {string|null} [name] UpdateObjectHeaterRequest name
         * @property {pond.ObjectHeaterSettings|null} [settings] UpdateObjectHeaterRequest settings
         */

        /**
         * Constructs a new UpdateObjectHeaterRequest.
         * @memberof pond
         * @classdesc Represents an UpdateObjectHeaterRequest.
         * @implements IUpdateObjectHeaterRequest
         * @constructor
         * @param {pond.IUpdateObjectHeaterRequest=} [properties] Properties to set
         */
        function UpdateObjectHeaterRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateObjectHeaterRequest key.
         * @member {string} key
         * @memberof pond.UpdateObjectHeaterRequest
         * @instance
         */
        UpdateObjectHeaterRequest.prototype.key = "";

        /**
         * UpdateObjectHeaterRequest name.
         * @member {string} name
         * @memberof pond.UpdateObjectHeaterRequest
         * @instance
         */
        UpdateObjectHeaterRequest.prototype.name = "";

        /**
         * UpdateObjectHeaterRequest settings.
         * @member {pond.ObjectHeaterSettings|null|undefined} settings
         * @memberof pond.UpdateObjectHeaterRequest
         * @instance
         */
        UpdateObjectHeaterRequest.prototype.settings = null;

        /**
         * Creates a new UpdateObjectHeaterRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectHeaterRequest
         * @static
         * @param {pond.IUpdateObjectHeaterRequest=} [properties] Properties to set
         * @returns {pond.UpdateObjectHeaterRequest} UpdateObjectHeaterRequest instance
         */
        UpdateObjectHeaterRequest.create = function create(properties) {
            return new UpdateObjectHeaterRequest(properties);
        };

        /**
         * Creates an UpdateObjectHeaterRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectHeaterRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectHeaterRequest} UpdateObjectHeaterRequest
         */
        UpdateObjectHeaterRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectHeaterRequest)
                return object;
            var message = new $root.pond.UpdateObjectHeaterRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateObjectHeaterRequest.settings: object expected");
                message.settings = $root.pond.ObjectHeaterSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateObjectHeaterRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectHeaterRequest
         * @static
         * @param {pond.UpdateObjectHeaterRequest} message UpdateObjectHeaterRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectHeaterRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectHeaterSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateObjectHeaterRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectHeaterRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectHeaterRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectHeaterRequest;
    })();

    pond.UpdateObjectHeaterResponse = (function() {

        /**
         * Properties of an UpdateObjectHeaterResponse.
         * @memberof pond
         * @interface IUpdateObjectHeaterResponse
         * @property {boolean|null} [success] UpdateObjectHeaterResponse success
         */

        /**
         * Constructs a new UpdateObjectHeaterResponse.
         * @memberof pond
         * @classdesc Represents an UpdateObjectHeaterResponse.
         * @implements IUpdateObjectHeaterResponse
         * @constructor
         * @param {pond.IUpdateObjectHeaterResponse=} [properties] Properties to set
         */
        function UpdateObjectHeaterResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateObjectHeaterResponse success.
         * @member {boolean} success
         * @memberof pond.UpdateObjectHeaterResponse
         * @instance
         */
        UpdateObjectHeaterResponse.prototype.success = false;

        /**
         * Creates a new UpdateObjectHeaterResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectHeaterResponse
         * @static
         * @param {pond.IUpdateObjectHeaterResponse=} [properties] Properties to set
         * @returns {pond.UpdateObjectHeaterResponse} UpdateObjectHeaterResponse instance
         */
        UpdateObjectHeaterResponse.create = function create(properties) {
            return new UpdateObjectHeaterResponse(properties);
        };

        /**
         * Creates an UpdateObjectHeaterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectHeaterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectHeaterResponse} UpdateObjectHeaterResponse
         */
        UpdateObjectHeaterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectHeaterResponse)
                return object;
            var message = new $root.pond.UpdateObjectHeaterResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an UpdateObjectHeaterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectHeaterResponse
         * @static
         * @param {pond.UpdateObjectHeaterResponse} message UpdateObjectHeaterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectHeaterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this UpdateObjectHeaterResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectHeaterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectHeaterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectHeaterResponse;
    })();

    pond.RemoveObjectHeaterRequest = (function() {

        /**
         * Properties of a RemoveObjectHeaterRequest.
         * @memberof pond
         * @interface IRemoveObjectHeaterRequest
         * @property {string|null} [key] RemoveObjectHeaterRequest key
         */

        /**
         * Constructs a new RemoveObjectHeaterRequest.
         * @memberof pond
         * @classdesc Represents a RemoveObjectHeaterRequest.
         * @implements IRemoveObjectHeaterRequest
         * @constructor
         * @param {pond.IRemoveObjectHeaterRequest=} [properties] Properties to set
         */
        function RemoveObjectHeaterRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectHeaterRequest key.
         * @member {string} key
         * @memberof pond.RemoveObjectHeaterRequest
         * @instance
         */
        RemoveObjectHeaterRequest.prototype.key = "";

        /**
         * Creates a new RemoveObjectHeaterRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveObjectHeaterRequest
         * @static
         * @param {pond.IRemoveObjectHeaterRequest=} [properties] Properties to set
         * @returns {pond.RemoveObjectHeaterRequest} RemoveObjectHeaterRequest instance
         */
        RemoveObjectHeaterRequest.create = function create(properties) {
            return new RemoveObjectHeaterRequest(properties);
        };

        /**
         * Creates a RemoveObjectHeaterRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveObjectHeaterRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveObjectHeaterRequest} RemoveObjectHeaterRequest
         */
        RemoveObjectHeaterRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveObjectHeaterRequest)
                return object;
            var message = new $root.pond.RemoveObjectHeaterRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectHeaterRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveObjectHeaterRequest
         * @static
         * @param {pond.RemoveObjectHeaterRequest} message RemoveObjectHeaterRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectHeaterRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveObjectHeaterRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveObjectHeaterRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectHeaterRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveObjectHeaterRequest;
    })();

    pond.RemoveObjectHeaterResponse = (function() {

        /**
         * Properties of a RemoveObjectHeaterResponse.
         * @memberof pond
         * @interface IRemoveObjectHeaterResponse
         * @property {boolean|null} [success] RemoveObjectHeaterResponse success
         */

        /**
         * Constructs a new RemoveObjectHeaterResponse.
         * @memberof pond
         * @classdesc Represents a RemoveObjectHeaterResponse.
         * @implements IRemoveObjectHeaterResponse
         * @constructor
         * @param {pond.IRemoveObjectHeaterResponse=} [properties] Properties to set
         */
        function RemoveObjectHeaterResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectHeaterResponse success.
         * @member {boolean} success
         * @memberof pond.RemoveObjectHeaterResponse
         * @instance
         */
        RemoveObjectHeaterResponse.prototype.success = false;

        /**
         * Creates a new RemoveObjectHeaterResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveObjectHeaterResponse
         * @static
         * @param {pond.IRemoveObjectHeaterResponse=} [properties] Properties to set
         * @returns {pond.RemoveObjectHeaterResponse} RemoveObjectHeaterResponse instance
         */
        RemoveObjectHeaterResponse.create = function create(properties) {
            return new RemoveObjectHeaterResponse(properties);
        };

        /**
         * Creates a RemoveObjectHeaterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveObjectHeaterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveObjectHeaterResponse} RemoveObjectHeaterResponse
         */
        RemoveObjectHeaterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveObjectHeaterResponse)
                return object;
            var message = new $root.pond.RemoveObjectHeaterResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectHeaterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveObjectHeaterResponse
         * @static
         * @param {pond.RemoveObjectHeaterResponse} message RemoveObjectHeaterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectHeaterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this RemoveObjectHeaterResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveObjectHeaterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectHeaterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveObjectHeaterResponse;
    })();

    pond.UpdateObjectHeaterLinkRequest = (function() {

        /**
         * Properties of an UpdateObjectHeaterLinkRequest.
         * @memberof pond
         * @interface IUpdateObjectHeaterLinkRequest
         * @property {string|null} [parentKey] UpdateObjectHeaterLinkRequest parentKey
         * @property {string|null} [parentType] UpdateObjectHeaterLinkRequest parentType
         * @property {string|null} [key] UpdateObjectHeaterLinkRequest key
         * @property {string|null} [type] UpdateObjectHeaterLinkRequest type
         * @property {Array.<string>|null} [permissions] UpdateObjectHeaterLinkRequest permissions
         */

        /**
         * Constructs a new UpdateObjectHeaterLinkRequest.
         * @memberof pond
         * @classdesc Represents an UpdateObjectHeaterLinkRequest.
         * @implements IUpdateObjectHeaterLinkRequest
         * @constructor
         * @param {pond.IUpdateObjectHeaterLinkRequest=} [properties] Properties to set
         */
        function UpdateObjectHeaterLinkRequest(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateObjectHeaterLinkRequest parentKey.
         * @member {string} parentKey
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         */
        UpdateObjectHeaterLinkRequest.prototype.parentKey = "";

        /**
         * UpdateObjectHeaterLinkRequest parentType.
         * @member {string} parentType
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         */
        UpdateObjectHeaterLinkRequest.prototype.parentType = "";

        /**
         * UpdateObjectHeaterLinkRequest key.
         * @member {string} key
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         */
        UpdateObjectHeaterLinkRequest.prototype.key = "";

        /**
         * UpdateObjectHeaterLinkRequest type.
         * @member {string} type
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         */
        UpdateObjectHeaterLinkRequest.prototype.type = "";

        /**
         * UpdateObjectHeaterLinkRequest permissions.
         * @member {Array.<string>} permissions
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         */
        UpdateObjectHeaterLinkRequest.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdateObjectHeaterLinkRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @static
         * @param {pond.IUpdateObjectHeaterLinkRequest=} [properties] Properties to set
         * @returns {pond.UpdateObjectHeaterLinkRequest} UpdateObjectHeaterLinkRequest instance
         */
        UpdateObjectHeaterLinkRequest.create = function create(properties) {
            return new UpdateObjectHeaterLinkRequest(properties);
        };

        /**
         * Creates an UpdateObjectHeaterLinkRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectHeaterLinkRequest} UpdateObjectHeaterLinkRequest
         */
        UpdateObjectHeaterLinkRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectHeaterLinkRequest)
                return object;
            var message = new $root.pond.UpdateObjectHeaterLinkRequest();
            if (object.parentKey != null)
                message.parentKey = String(object.parentKey);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.key != null)
                message.key = String(object.key);
            if (object.type != null)
                message.type = String(object.type);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".pond.UpdateObjectHeaterLinkRequest.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    message.permissions[i] = String(object.permissions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateObjectHeaterLinkRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @static
         * @param {pond.UpdateObjectHeaterLinkRequest} message UpdateObjectHeaterLinkRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectHeaterLinkRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.parentKey = "";
                object.parentType = "";
                object.key = "";
                object.type = "";
            }
            if (message.parentKey != null && message.hasOwnProperty("parentKey"))
                object.parentKey = message.parentKey;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdateObjectHeaterLinkRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectHeaterLinkRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectHeaterLinkRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectHeaterLinkRequest;
    })();

    pond.UpdateObjectHeaterLinkResponse = (function() {

        /**
         * Properties of an UpdateObjectHeaterLinkResponse.
         * @memberof pond
         * @interface IUpdateObjectHeaterLinkResponse
         */

        /**
         * Constructs a new UpdateObjectHeaterLinkResponse.
         * @memberof pond
         * @classdesc Represents an UpdateObjectHeaterLinkResponse.
         * @implements IUpdateObjectHeaterLinkResponse
         * @constructor
         * @param {pond.IUpdateObjectHeaterLinkResponse=} [properties] Properties to set
         */
        function UpdateObjectHeaterLinkResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateObjectHeaterLinkResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectHeaterLinkResponse
         * @static
         * @param {pond.IUpdateObjectHeaterLinkResponse=} [properties] Properties to set
         * @returns {pond.UpdateObjectHeaterLinkResponse} UpdateObjectHeaterLinkResponse instance
         */
        UpdateObjectHeaterLinkResponse.create = function create(properties) {
            return new UpdateObjectHeaterLinkResponse(properties);
        };

        /**
         * Creates an UpdateObjectHeaterLinkResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectHeaterLinkResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectHeaterLinkResponse} UpdateObjectHeaterLinkResponse
         */
        UpdateObjectHeaterLinkResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectHeaterLinkResponse)
                return object;
            return new $root.pond.UpdateObjectHeaterLinkResponse();
        };

        /**
         * Creates a plain object from an UpdateObjectHeaterLinkResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectHeaterLinkResponse
         * @static
         * @param {pond.UpdateObjectHeaterLinkResponse} message UpdateObjectHeaterLinkResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectHeaterLinkResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateObjectHeaterLinkResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectHeaterLinkResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectHeaterLinkResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectHeaterLinkResponse;
    })();

    pond.ListObjectHeatersPageDataRequest = (function() {

        /**
         * Properties of a ListObjectHeatersPageDataRequest.
         * @memberof pond
         * @interface IListObjectHeatersPageDataRequest
         * @property {pond.Paging|null} [paging] ListObjectHeatersPageDataRequest paging
         * @property {pond.Sorting|null} [sorting] ListObjectHeatersPageDataRequest sorting
         * @property {string|null} [search] ListObjectHeatersPageDataRequest search
         * @property {pond.ObjectHeaterSettings|null} [settingsMatch] ListObjectHeatersPageDataRequest settingsMatch
         * @property {Object.<string,string>|null} [fieldContains] ListObjectHeatersPageDataRequest fieldContains
         */

        /**
         * Constructs a new ListObjectHeatersPageDataRequest.
         * @memberof pond
         * @classdesc Represents a ListObjectHeatersPageDataRequest.
         * @implements IListObjectHeatersPageDataRequest
         * @constructor
         * @param {pond.IListObjectHeatersPageDataRequest=} [properties] Properties to set
         */
        function ListObjectHeatersPageDataRequest(properties) {
            this.fieldContains = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectHeatersPageDataRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         */
        ListObjectHeatersPageDataRequest.prototype.paging = null;

        /**
         * ListObjectHeatersPageDataRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         */
        ListObjectHeatersPageDataRequest.prototype.sorting = null;

        /**
         * ListObjectHeatersPageDataRequest search.
         * @member {string} search
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         */
        ListObjectHeatersPageDataRequest.prototype.search = "";

        /**
         * ListObjectHeatersPageDataRequest settingsMatch.
         * @member {pond.ObjectHeaterSettings|null|undefined} settingsMatch
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         */
        ListObjectHeatersPageDataRequest.prototype.settingsMatch = null;

        /**
         * ListObjectHeatersPageDataRequest fieldContains.
         * @member {Object.<string,string>} fieldContains
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         */
        ListObjectHeatersPageDataRequest.prototype.fieldContains = $util.emptyObject;

        /**
         * Creates a new ListObjectHeatersPageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @static
         * @param {pond.IListObjectHeatersPageDataRequest=} [properties] Properties to set
         * @returns {pond.ListObjectHeatersPageDataRequest} ListObjectHeatersPageDataRequest instance
         */
        ListObjectHeatersPageDataRequest.create = function create(properties) {
            return new ListObjectHeatersPageDataRequest(properties);
        };

        /**
         * Creates a ListObjectHeatersPageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectHeatersPageDataRequest} ListObjectHeatersPageDataRequest
         */
        ListObjectHeatersPageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectHeatersPageDataRequest)
                return object;
            var message = new $root.pond.ListObjectHeatersPageDataRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListObjectHeatersPageDataRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListObjectHeatersPageDataRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.settingsMatch != null) {
                if (typeof object.settingsMatch !== "object")
                    throw TypeError(".pond.ListObjectHeatersPageDataRequest.settingsMatch: object expected");
                message.settingsMatch = $root.pond.ObjectHeaterSettings.fromObject(object.settingsMatch);
            }
            if (object.fieldContains) {
                if (typeof object.fieldContains !== "object")
                    throw TypeError(".pond.ListObjectHeatersPageDataRequest.fieldContains: object expected");
                message.fieldContains = {};
                for (var keys = Object.keys(object.fieldContains), i = 0; i < keys.length; ++i)
                    message.fieldContains[keys[i]] = String(object.fieldContains[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListObjectHeatersPageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @static
         * @param {pond.ListObjectHeatersPageDataRequest} message ListObjectHeatersPageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectHeatersPageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.fieldContains = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.settingsMatch = null;
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.settingsMatch != null && message.hasOwnProperty("settingsMatch"))
                object.settingsMatch = $root.pond.ObjectHeaterSettings.toObject(message.settingsMatch, options);
            var keys2;
            if (message.fieldContains && (keys2 = Object.keys(message.fieldContains)).length) {
                object.fieldContains = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.fieldContains[keys2[j]] = message.fieldContains[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this ListObjectHeatersPageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.ListObjectHeatersPageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectHeatersPageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectHeatersPageDataRequest;
    })();

    pond.ListObjectHeatersPageDataResponse = (function() {

        /**
         * Properties of a ListObjectHeatersPageDataResponse.
         * @memberof pond
         * @interface IListObjectHeatersPageDataResponse
         * @property {Array.<pond.ObjectHeaterData>|null} [heaterData] ListObjectHeatersPageDataResponse heaterData
         * @property {number|null} [nextOffset] ListObjectHeatersPageDataResponse nextOffset
         * @property {number|null} [total] ListObjectHeatersPageDataResponse total
         */

        /**
         * Constructs a new ListObjectHeatersPageDataResponse.
         * @memberof pond
         * @classdesc Represents a ListObjectHeatersPageDataResponse.
         * @implements IListObjectHeatersPageDataResponse
         * @constructor
         * @param {pond.IListObjectHeatersPageDataResponse=} [properties] Properties to set
         */
        function ListObjectHeatersPageDataResponse(properties) {
            this.heaterData = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectHeatersPageDataResponse heaterData.
         * @member {Array.<pond.ObjectHeaterData>} heaterData
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @instance
         */
        ListObjectHeatersPageDataResponse.prototype.heaterData = $util.emptyArray;

        /**
         * ListObjectHeatersPageDataResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @instance
         */
        ListObjectHeatersPageDataResponse.prototype.nextOffset = 0;

        /**
         * ListObjectHeatersPageDataResponse total.
         * @member {number} total
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @instance
         */
        ListObjectHeatersPageDataResponse.prototype.total = 0;

        /**
         * Creates a new ListObjectHeatersPageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @static
         * @param {pond.IListObjectHeatersPageDataResponse=} [properties] Properties to set
         * @returns {pond.ListObjectHeatersPageDataResponse} ListObjectHeatersPageDataResponse instance
         */
        ListObjectHeatersPageDataResponse.create = function create(properties) {
            return new ListObjectHeatersPageDataResponse(properties);
        };

        /**
         * Creates a ListObjectHeatersPageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectHeatersPageDataResponse} ListObjectHeatersPageDataResponse
         */
        ListObjectHeatersPageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectHeatersPageDataResponse)
                return object;
            var message = new $root.pond.ListObjectHeatersPageDataResponse();
            if (object.heaterData) {
                if (!Array.isArray(object.heaterData))
                    throw TypeError(".pond.ListObjectHeatersPageDataResponse.heaterData: array expected");
                message.heaterData = [];
                for (var i = 0; i < object.heaterData.length; ++i) {
                    if (typeof object.heaterData[i] !== "object")
                        throw TypeError(".pond.ListObjectHeatersPageDataResponse.heaterData: object expected");
                    message.heaterData[i] = $root.pond.ObjectHeaterData.fromObject(object.heaterData[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListObjectHeatersPageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @static
         * @param {pond.ListObjectHeatersPageDataResponse} message ListObjectHeatersPageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectHeatersPageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.heaterData = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.heaterData && message.heaterData.length) {
                object.heaterData = [];
                for (var j = 0; j < message.heaterData.length; ++j)
                    object.heaterData[j] = $root.pond.ObjectHeaterData.toObject(message.heaterData[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListObjectHeatersPageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.ListObjectHeatersPageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectHeatersPageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectHeatersPageDataResponse;
    })();

    pond.ObjectHeaterData = (function() {

        /**
         * Properties of an ObjectHeaterData.
         * @memberof pond
         * @interface IObjectHeaterData
         * @property {pond.ObjectHeater|null} [heater] ObjectHeaterData heater
         * @property {pond.Site|null} [site] ObjectHeaterData site
         * @property {Array.<pond.ComprehensiveDevice>|null} [devices] ObjectHeaterData devices
         */

        /**
         * Constructs a new ObjectHeaterData.
         * @memberof pond
         * @classdesc Represents an ObjectHeaterData.
         * @implements IObjectHeaterData
         * @constructor
         * @param {pond.IObjectHeaterData=} [properties] Properties to set
         */
        function ObjectHeaterData(properties) {
            this.devices = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectHeaterData heater.
         * @member {pond.ObjectHeater|null|undefined} heater
         * @memberof pond.ObjectHeaterData
         * @instance
         */
        ObjectHeaterData.prototype.heater = null;

        /**
         * ObjectHeaterData site.
         * @member {pond.Site|null|undefined} site
         * @memberof pond.ObjectHeaterData
         * @instance
         */
        ObjectHeaterData.prototype.site = null;

        /**
         * ObjectHeaterData devices.
         * @member {Array.<pond.ComprehensiveDevice>} devices
         * @memberof pond.ObjectHeaterData
         * @instance
         */
        ObjectHeaterData.prototype.devices = $util.emptyArray;

        /**
         * Creates a new ObjectHeaterData instance using the specified properties.
         * @function create
         * @memberof pond.ObjectHeaterData
         * @static
         * @param {pond.IObjectHeaterData=} [properties] Properties to set
         * @returns {pond.ObjectHeaterData} ObjectHeaterData instance
         */
        ObjectHeaterData.create = function create(properties) {
            return new ObjectHeaterData(properties);
        };

        /**
         * Creates an ObjectHeaterData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectHeaterData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectHeaterData} ObjectHeaterData
         */
        ObjectHeaterData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectHeaterData)
                return object;
            var message = new $root.pond.ObjectHeaterData();
            if (object.heater != null) {
                if (typeof object.heater !== "object")
                    throw TypeError(".pond.ObjectHeaterData.heater: object expected");
                message.heater = $root.pond.ObjectHeater.fromObject(object.heater);
            }
            if (object.site != null) {
                if (typeof object.site !== "object")
                    throw TypeError(".pond.ObjectHeaterData.site: object expected");
                message.site = $root.pond.Site.fromObject(object.site);
            }
            if (object.devices) {
                if (!Array.isArray(object.devices))
                    throw TypeError(".pond.ObjectHeaterData.devices: array expected");
                message.devices = [];
                for (var i = 0; i < object.devices.length; ++i) {
                    if (typeof object.devices[i] !== "object")
                        throw TypeError(".pond.ObjectHeaterData.devices: object expected");
                    message.devices[i] = $root.pond.ComprehensiveDevice.fromObject(object.devices[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectHeaterData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectHeaterData
         * @static
         * @param {pond.ObjectHeaterData} message ObjectHeaterData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectHeaterData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.devices = [];
            if (options.defaults) {
                object.heater = null;
                object.site = null;
            }
            if (message.heater != null && message.hasOwnProperty("heater"))
                object.heater = $root.pond.ObjectHeater.toObject(message.heater, options);
            if (message.site != null && message.hasOwnProperty("site"))
                object.site = $root.pond.Site.toObject(message.site, options);
            if (message.devices && message.devices.length) {
                object.devices = [];
                for (var j = 0; j < message.devices.length; ++j)
                    object.devices[j] = $root.pond.ComprehensiveDevice.toObject(message.devices[j], options);
            }
            return object;
        };

        /**
         * Converts this ObjectHeaterData to JSON.
         * @function toJSON
         * @memberof pond.ObjectHeaterData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectHeaterData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectHeaterData;
    })();

    pond.NotificationBanner = (function() {

        /**
         * Properties of a NotificationBanner.
         * @memberof pond
         * @interface INotificationBanner
         * @property {string|null} [key] NotificationBanner key
         * @property {string|null} [name] NotificationBanner name
         * @property {pond.NotificationBannerSettings|null} [settings] NotificationBanner settings
         */

        /**
         * Constructs a new NotificationBanner.
         * @memberof pond
         * @classdesc Represents a NotificationBanner.
         * @implements INotificationBanner
         * @constructor
         * @param {pond.INotificationBanner=} [properties] Properties to set
         */
        function NotificationBanner(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationBanner key.
         * @member {string} key
         * @memberof pond.NotificationBanner
         * @instance
         */
        NotificationBanner.prototype.key = "";

        /**
         * NotificationBanner name.
         * @member {string} name
         * @memberof pond.NotificationBanner
         * @instance
         */
        NotificationBanner.prototype.name = "";

        /**
         * NotificationBanner settings.
         * @member {pond.NotificationBannerSettings|null|undefined} settings
         * @memberof pond.NotificationBanner
         * @instance
         */
        NotificationBanner.prototype.settings = null;

        /**
         * Creates a new NotificationBanner instance using the specified properties.
         * @function create
         * @memberof pond.NotificationBanner
         * @static
         * @param {pond.INotificationBanner=} [properties] Properties to set
         * @returns {pond.NotificationBanner} NotificationBanner instance
         */
        NotificationBanner.create = function create(properties) {
            return new NotificationBanner(properties);
        };

        /**
         * Creates a NotificationBanner message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NotificationBanner
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NotificationBanner} NotificationBanner
         */
        NotificationBanner.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NotificationBanner)
                return object;
            var message = new $root.pond.NotificationBanner();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.NotificationBanner.settings: object expected");
                message.settings = $root.pond.NotificationBannerSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a NotificationBanner message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NotificationBanner
         * @static
         * @param {pond.NotificationBanner} message NotificationBanner
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationBanner.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.NotificationBannerSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this NotificationBanner to JSON.
         * @function toJSON
         * @memberof pond.NotificationBanner
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationBanner.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationBanner;
    })();

    pond.NotificationBannerSettings = (function() {

        /**
         * Properties of a NotificationBannerSettings.
         * @memberof pond
         * @interface INotificationBannerSettings
         * @property {string|null} [message] NotificationBannerSettings message
         * @property {string|null} [caption] NotificationBannerSettings caption
         * @property {string|null} [icon] NotificationBannerSettings icon
         * @property {string|null} [timestamp] NotificationBannerSettings timestamp
         * @property {string|null} [expiryTimestamp] NotificationBannerSettings expiryTimestamp
         */

        /**
         * Constructs a new NotificationBannerSettings.
         * @memberof pond
         * @classdesc Represents a NotificationBannerSettings.
         * @implements INotificationBannerSettings
         * @constructor
         * @param {pond.INotificationBannerSettings=} [properties] Properties to set
         */
        function NotificationBannerSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NotificationBannerSettings message.
         * @member {string} message
         * @memberof pond.NotificationBannerSettings
         * @instance
         */
        NotificationBannerSettings.prototype.message = "";

        /**
         * NotificationBannerSettings caption.
         * @member {string} caption
         * @memberof pond.NotificationBannerSettings
         * @instance
         */
        NotificationBannerSettings.prototype.caption = "";

        /**
         * NotificationBannerSettings icon.
         * @member {string} icon
         * @memberof pond.NotificationBannerSettings
         * @instance
         */
        NotificationBannerSettings.prototype.icon = "";

        /**
         * NotificationBannerSettings timestamp.
         * @member {string} timestamp
         * @memberof pond.NotificationBannerSettings
         * @instance
         */
        NotificationBannerSettings.prototype.timestamp = "";

        /**
         * NotificationBannerSettings expiryTimestamp.
         * @member {string} expiryTimestamp
         * @memberof pond.NotificationBannerSettings
         * @instance
         */
        NotificationBannerSettings.prototype.expiryTimestamp = "";

        /**
         * Creates a new NotificationBannerSettings instance using the specified properties.
         * @function create
         * @memberof pond.NotificationBannerSettings
         * @static
         * @param {pond.INotificationBannerSettings=} [properties] Properties to set
         * @returns {pond.NotificationBannerSettings} NotificationBannerSettings instance
         */
        NotificationBannerSettings.create = function create(properties) {
            return new NotificationBannerSettings(properties);
        };

        /**
         * Creates a NotificationBannerSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.NotificationBannerSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.NotificationBannerSettings} NotificationBannerSettings
         */
        NotificationBannerSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.NotificationBannerSettings)
                return object;
            var message = new $root.pond.NotificationBannerSettings();
            if (object.message != null)
                message.message = String(object.message);
            if (object.caption != null)
                message.caption = String(object.caption);
            if (object.icon != null)
                message.icon = String(object.icon);
            if (object.timestamp != null)
                message.timestamp = String(object.timestamp);
            if (object.expiryTimestamp != null)
                message.expiryTimestamp = String(object.expiryTimestamp);
            return message;
        };

        /**
         * Creates a plain object from a NotificationBannerSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.NotificationBannerSettings
         * @static
         * @param {pond.NotificationBannerSettings} message NotificationBannerSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NotificationBannerSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.message = "";
                object.caption = "";
                object.icon = "";
                object.timestamp = "";
                object.expiryTimestamp = "";
            }
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.caption != null && message.hasOwnProperty("caption"))
                object.caption = message.caption;
            if (message.icon != null && message.hasOwnProperty("icon"))
                object.icon = message.icon;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                object.timestamp = message.timestamp;
            if (message.expiryTimestamp != null && message.hasOwnProperty("expiryTimestamp"))
                object.expiryTimestamp = message.expiryTimestamp;
            return object;
        };

        /**
         * Converts this NotificationBannerSettings to JSON.
         * @function toJSON
         * @memberof pond.NotificationBannerSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NotificationBannerSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationBannerSettings;
    })();

    pond.AddNotificationBannerRequest = (function() {

        /**
         * Properties of an AddNotificationBannerRequest.
         * @memberof pond
         * @interface IAddNotificationBannerRequest
         * @property {pond.NotificationBannerSettings|null} [settings] AddNotificationBannerRequest settings
         */

        /**
         * Constructs a new AddNotificationBannerRequest.
         * @memberof pond
         * @classdesc Represents an AddNotificationBannerRequest.
         * @implements IAddNotificationBannerRequest
         * @constructor
         * @param {pond.IAddNotificationBannerRequest=} [properties] Properties to set
         */
        function AddNotificationBannerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNotificationBannerRequest settings.
         * @member {pond.NotificationBannerSettings|null|undefined} settings
         * @memberof pond.AddNotificationBannerRequest
         * @instance
         */
        AddNotificationBannerRequest.prototype.settings = null;

        /**
         * Creates a new AddNotificationBannerRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddNotificationBannerRequest
         * @static
         * @param {pond.IAddNotificationBannerRequest=} [properties] Properties to set
         * @returns {pond.AddNotificationBannerRequest} AddNotificationBannerRequest instance
         */
        AddNotificationBannerRequest.create = function create(properties) {
            return new AddNotificationBannerRequest(properties);
        };

        /**
         * Creates an AddNotificationBannerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNotificationBannerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNotificationBannerRequest} AddNotificationBannerRequest
         */
        AddNotificationBannerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNotificationBannerRequest)
                return object;
            var message = new $root.pond.AddNotificationBannerRequest();
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddNotificationBannerRequest.settings: object expected");
                message.settings = $root.pond.NotificationBannerSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddNotificationBannerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNotificationBannerRequest
         * @static
         * @param {pond.AddNotificationBannerRequest} message AddNotificationBannerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNotificationBannerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.settings = null;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.NotificationBannerSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddNotificationBannerRequest to JSON.
         * @function toJSON
         * @memberof pond.AddNotificationBannerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNotificationBannerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNotificationBannerRequest;
    })();

    pond.AddNotificationBannerResponse = (function() {

        /**
         * Properties of an AddNotificationBannerResponse.
         * @memberof pond
         * @interface IAddNotificationBannerResponse
         * @property {string|null} [key] AddNotificationBannerResponse key
         */

        /**
         * Constructs a new AddNotificationBannerResponse.
         * @memberof pond
         * @classdesc Represents an AddNotificationBannerResponse.
         * @implements IAddNotificationBannerResponse
         * @constructor
         * @param {pond.IAddNotificationBannerResponse=} [properties] Properties to set
         */
        function AddNotificationBannerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddNotificationBannerResponse key.
         * @member {string} key
         * @memberof pond.AddNotificationBannerResponse
         * @instance
         */
        AddNotificationBannerResponse.prototype.key = "";

        /**
         * Creates a new AddNotificationBannerResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddNotificationBannerResponse
         * @static
         * @param {pond.IAddNotificationBannerResponse=} [properties] Properties to set
         * @returns {pond.AddNotificationBannerResponse} AddNotificationBannerResponse instance
         */
        AddNotificationBannerResponse.create = function create(properties) {
            return new AddNotificationBannerResponse(properties);
        };

        /**
         * Creates an AddNotificationBannerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddNotificationBannerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddNotificationBannerResponse} AddNotificationBannerResponse
         */
        AddNotificationBannerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddNotificationBannerResponse)
                return object;
            var message = new $root.pond.AddNotificationBannerResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddNotificationBannerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddNotificationBannerResponse
         * @static
         * @param {pond.AddNotificationBannerResponse} message AddNotificationBannerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddNotificationBannerResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddNotificationBannerResponse to JSON.
         * @function toJSON
         * @memberof pond.AddNotificationBannerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddNotificationBannerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddNotificationBannerResponse;
    })();

    pond.GetNotificationBannerRequest = (function() {

        /**
         * Properties of a GetNotificationBannerRequest.
         * @memberof pond
         * @interface IGetNotificationBannerRequest
         * @property {string|null} [key] GetNotificationBannerRequest key
         */

        /**
         * Constructs a new GetNotificationBannerRequest.
         * @memberof pond
         * @classdesc Represents a GetNotificationBannerRequest.
         * @implements IGetNotificationBannerRequest
         * @constructor
         * @param {pond.IGetNotificationBannerRequest=} [properties] Properties to set
         */
        function GetNotificationBannerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetNotificationBannerRequest key.
         * @member {string} key
         * @memberof pond.GetNotificationBannerRequest
         * @instance
         */
        GetNotificationBannerRequest.prototype.key = "";

        /**
         * Creates a new GetNotificationBannerRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetNotificationBannerRequest
         * @static
         * @param {pond.IGetNotificationBannerRequest=} [properties] Properties to set
         * @returns {pond.GetNotificationBannerRequest} GetNotificationBannerRequest instance
         */
        GetNotificationBannerRequest.create = function create(properties) {
            return new GetNotificationBannerRequest(properties);
        };

        /**
         * Creates a GetNotificationBannerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetNotificationBannerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetNotificationBannerRequest} GetNotificationBannerRequest
         */
        GetNotificationBannerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetNotificationBannerRequest)
                return object;
            var message = new $root.pond.GetNotificationBannerRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetNotificationBannerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetNotificationBannerRequest
         * @static
         * @param {pond.GetNotificationBannerRequest} message GetNotificationBannerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetNotificationBannerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetNotificationBannerRequest to JSON.
         * @function toJSON
         * @memberof pond.GetNotificationBannerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetNotificationBannerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetNotificationBannerRequest;
    })();

    pond.GetNotificationBannerResponse = (function() {

        /**
         * Properties of a GetNotificationBannerResponse.
         * @memberof pond
         * @interface IGetNotificationBannerResponse
         * @property {pond.NotificationBanner|null} [notificationBanner] GetNotificationBannerResponse notificationBanner
         */

        /**
         * Constructs a new GetNotificationBannerResponse.
         * @memberof pond
         * @classdesc Represents a GetNotificationBannerResponse.
         * @implements IGetNotificationBannerResponse
         * @constructor
         * @param {pond.IGetNotificationBannerResponse=} [properties] Properties to set
         */
        function GetNotificationBannerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetNotificationBannerResponse notificationBanner.
         * @member {pond.NotificationBanner|null|undefined} notificationBanner
         * @memberof pond.GetNotificationBannerResponse
         * @instance
         */
        GetNotificationBannerResponse.prototype.notificationBanner = null;

        /**
         * Creates a new GetNotificationBannerResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetNotificationBannerResponse
         * @static
         * @param {pond.IGetNotificationBannerResponse=} [properties] Properties to set
         * @returns {pond.GetNotificationBannerResponse} GetNotificationBannerResponse instance
         */
        GetNotificationBannerResponse.create = function create(properties) {
            return new GetNotificationBannerResponse(properties);
        };

        /**
         * Creates a GetNotificationBannerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetNotificationBannerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetNotificationBannerResponse} GetNotificationBannerResponse
         */
        GetNotificationBannerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetNotificationBannerResponse)
                return object;
            var message = new $root.pond.GetNotificationBannerResponse();
            if (object.notificationBanner != null) {
                if (typeof object.notificationBanner !== "object")
                    throw TypeError(".pond.GetNotificationBannerResponse.notificationBanner: object expected");
                message.notificationBanner = $root.pond.NotificationBanner.fromObject(object.notificationBanner);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetNotificationBannerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetNotificationBannerResponse
         * @static
         * @param {pond.GetNotificationBannerResponse} message GetNotificationBannerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetNotificationBannerResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.notificationBanner = null;
            if (message.notificationBanner != null && message.hasOwnProperty("notificationBanner"))
                object.notificationBanner = $root.pond.NotificationBanner.toObject(message.notificationBanner, options);
            return object;
        };

        /**
         * Converts this GetNotificationBannerResponse to JSON.
         * @function toJSON
         * @memberof pond.GetNotificationBannerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetNotificationBannerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetNotificationBannerResponse;
    })();

    pond.ListNotificationBannersRequest = (function() {

        /**
         * Properties of a ListNotificationBannersRequest.
         * @memberof pond
         * @interface IListNotificationBannersRequest
         * @property {pond.Paging|null} [paging] ListNotificationBannersRequest paging
         * @property {pond.Sorting|null} [sorting] ListNotificationBannersRequest sorting
         * @property {string|null} [search] ListNotificationBannersRequest search
         */

        /**
         * Constructs a new ListNotificationBannersRequest.
         * @memberof pond
         * @classdesc Represents a ListNotificationBannersRequest.
         * @implements IListNotificationBannersRequest
         * @constructor
         * @param {pond.IListNotificationBannersRequest=} [properties] Properties to set
         */
        function ListNotificationBannersRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotificationBannersRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListNotificationBannersRequest
         * @instance
         */
        ListNotificationBannersRequest.prototype.paging = null;

        /**
         * ListNotificationBannersRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListNotificationBannersRequest
         * @instance
         */
        ListNotificationBannersRequest.prototype.sorting = null;

        /**
         * ListNotificationBannersRequest search.
         * @member {string} search
         * @memberof pond.ListNotificationBannersRequest
         * @instance
         */
        ListNotificationBannersRequest.prototype.search = "";

        /**
         * Creates a new ListNotificationBannersRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListNotificationBannersRequest
         * @static
         * @param {pond.IListNotificationBannersRequest=} [properties] Properties to set
         * @returns {pond.ListNotificationBannersRequest} ListNotificationBannersRequest instance
         */
        ListNotificationBannersRequest.create = function create(properties) {
            return new ListNotificationBannersRequest(properties);
        };

        /**
         * Creates a ListNotificationBannersRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotificationBannersRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotificationBannersRequest} ListNotificationBannersRequest
         */
        ListNotificationBannersRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotificationBannersRequest)
                return object;
            var message = new $root.pond.ListNotificationBannersRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListNotificationBannersRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListNotificationBannersRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListNotificationBannersRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotificationBannersRequest
         * @static
         * @param {pond.ListNotificationBannersRequest} message ListNotificationBannersRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotificationBannersRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListNotificationBannersRequest to JSON.
         * @function toJSON
         * @memberof pond.ListNotificationBannersRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotificationBannersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotificationBannersRequest;
    })();

    pond.ListNotificationBannersResponse = (function() {

        /**
         * Properties of a ListNotificationBannersResponse.
         * @memberof pond
         * @interface IListNotificationBannersResponse
         * @property {Array.<pond.NotificationBanner>|null} [notificationBanners] ListNotificationBannersResponse notificationBanners
         * @property {number|null} [nextOffset] ListNotificationBannersResponse nextOffset
         * @property {number|null} [total] ListNotificationBannersResponse total
         */

        /**
         * Constructs a new ListNotificationBannersResponse.
         * @memberof pond
         * @classdesc Represents a ListNotificationBannersResponse.
         * @implements IListNotificationBannersResponse
         * @constructor
         * @param {pond.IListNotificationBannersResponse=} [properties] Properties to set
         */
        function ListNotificationBannersResponse(properties) {
            this.notificationBanners = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListNotificationBannersResponse notificationBanners.
         * @member {Array.<pond.NotificationBanner>} notificationBanners
         * @memberof pond.ListNotificationBannersResponse
         * @instance
         */
        ListNotificationBannersResponse.prototype.notificationBanners = $util.emptyArray;

        /**
         * ListNotificationBannersResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListNotificationBannersResponse
         * @instance
         */
        ListNotificationBannersResponse.prototype.nextOffset = 0;

        /**
         * ListNotificationBannersResponse total.
         * @member {number} total
         * @memberof pond.ListNotificationBannersResponse
         * @instance
         */
        ListNotificationBannersResponse.prototype.total = 0;

        /**
         * Creates a new ListNotificationBannersResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListNotificationBannersResponse
         * @static
         * @param {pond.IListNotificationBannersResponse=} [properties] Properties to set
         * @returns {pond.ListNotificationBannersResponse} ListNotificationBannersResponse instance
         */
        ListNotificationBannersResponse.create = function create(properties) {
            return new ListNotificationBannersResponse(properties);
        };

        /**
         * Creates a ListNotificationBannersResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListNotificationBannersResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListNotificationBannersResponse} ListNotificationBannersResponse
         */
        ListNotificationBannersResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListNotificationBannersResponse)
                return object;
            var message = new $root.pond.ListNotificationBannersResponse();
            if (object.notificationBanners) {
                if (!Array.isArray(object.notificationBanners))
                    throw TypeError(".pond.ListNotificationBannersResponse.notificationBanners: array expected");
                message.notificationBanners = [];
                for (var i = 0; i < object.notificationBanners.length; ++i) {
                    if (typeof object.notificationBanners[i] !== "object")
                        throw TypeError(".pond.ListNotificationBannersResponse.notificationBanners: object expected");
                    message.notificationBanners[i] = $root.pond.NotificationBanner.fromObject(object.notificationBanners[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListNotificationBannersResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListNotificationBannersResponse
         * @static
         * @param {pond.ListNotificationBannersResponse} message ListNotificationBannersResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListNotificationBannersResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.notificationBanners = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.notificationBanners && message.notificationBanners.length) {
                object.notificationBanners = [];
                for (var j = 0; j < message.notificationBanners.length; ++j)
                    object.notificationBanners[j] = $root.pond.NotificationBanner.toObject(message.notificationBanners[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListNotificationBannersResponse to JSON.
         * @function toJSON
         * @memberof pond.ListNotificationBannersResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListNotificationBannersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListNotificationBannersResponse;
    })();

    pond.RemoveNotificationBannerRequest = (function() {

        /**
         * Properties of a RemoveNotificationBannerRequest.
         * @memberof pond
         * @interface IRemoveNotificationBannerRequest
         * @property {string|null} [key] RemoveNotificationBannerRequest key
         */

        /**
         * Constructs a new RemoveNotificationBannerRequest.
         * @memberof pond
         * @classdesc Represents a RemoveNotificationBannerRequest.
         * @implements IRemoveNotificationBannerRequest
         * @constructor
         * @param {pond.IRemoveNotificationBannerRequest=} [properties] Properties to set
         */
        function RemoveNotificationBannerRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveNotificationBannerRequest key.
         * @member {string} key
         * @memberof pond.RemoveNotificationBannerRequest
         * @instance
         */
        RemoveNotificationBannerRequest.prototype.key = "";

        /**
         * Creates a new RemoveNotificationBannerRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveNotificationBannerRequest
         * @static
         * @param {pond.IRemoveNotificationBannerRequest=} [properties] Properties to set
         * @returns {pond.RemoveNotificationBannerRequest} RemoveNotificationBannerRequest instance
         */
        RemoveNotificationBannerRequest.create = function create(properties) {
            return new RemoveNotificationBannerRequest(properties);
        };

        /**
         * Creates a RemoveNotificationBannerRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveNotificationBannerRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveNotificationBannerRequest} RemoveNotificationBannerRequest
         */
        RemoveNotificationBannerRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveNotificationBannerRequest)
                return object;
            var message = new $root.pond.RemoveNotificationBannerRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveNotificationBannerRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveNotificationBannerRequest
         * @static
         * @param {pond.RemoveNotificationBannerRequest} message RemoveNotificationBannerRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveNotificationBannerRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveNotificationBannerRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveNotificationBannerRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveNotificationBannerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveNotificationBannerRequest;
    })();

    pond.RemoveNotificationBannerResponse = (function() {

        /**
         * Properties of a RemoveNotificationBannerResponse.
         * @memberof pond
         * @interface IRemoveNotificationBannerResponse
         */

        /**
         * Constructs a new RemoveNotificationBannerResponse.
         * @memberof pond
         * @classdesc Represents a RemoveNotificationBannerResponse.
         * @implements IRemoveNotificationBannerResponse
         * @constructor
         * @param {pond.IRemoveNotificationBannerResponse=} [properties] Properties to set
         */
        function RemoveNotificationBannerResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveNotificationBannerResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveNotificationBannerResponse
         * @static
         * @param {pond.IRemoveNotificationBannerResponse=} [properties] Properties to set
         * @returns {pond.RemoveNotificationBannerResponse} RemoveNotificationBannerResponse instance
         */
        RemoveNotificationBannerResponse.create = function create(properties) {
            return new RemoveNotificationBannerResponse(properties);
        };

        /**
         * Creates a RemoveNotificationBannerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveNotificationBannerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveNotificationBannerResponse} RemoveNotificationBannerResponse
         */
        RemoveNotificationBannerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveNotificationBannerResponse)
                return object;
            return new $root.pond.RemoveNotificationBannerResponse();
        };

        /**
         * Creates a plain object from a RemoveNotificationBannerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveNotificationBannerResponse
         * @static
         * @param {pond.RemoveNotificationBannerResponse} message RemoveNotificationBannerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveNotificationBannerResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveNotificationBannerResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveNotificationBannerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveNotificationBannerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveNotificationBannerResponse;
    })();

    pond.GrainBag = (function() {

        /**
         * Properties of a GrainBag.
         * @memberof pond
         * @interface IGrainBag
         * @property {string|null} [key] GrainBag key
         * @property {string|null} [name] GrainBag name
         * @property {pond.GrainBagSettings|null} [settings] GrainBag settings
         */

        /**
         * Constructs a new GrainBag.
         * @memberof pond
         * @classdesc Represents a GrainBag.
         * @implements IGrainBag
         * @constructor
         * @param {pond.IGrainBag=} [properties] Properties to set
         */
        function GrainBag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainBag key.
         * @member {string} key
         * @memberof pond.GrainBag
         * @instance
         */
        GrainBag.prototype.key = "";

        /**
         * GrainBag name.
         * @member {string} name
         * @memberof pond.GrainBag
         * @instance
         */
        GrainBag.prototype.name = "";

        /**
         * GrainBag settings.
         * @member {pond.GrainBagSettings|null|undefined} settings
         * @memberof pond.GrainBag
         * @instance
         */
        GrainBag.prototype.settings = null;

        /**
         * Creates a new GrainBag instance using the specified properties.
         * @function create
         * @memberof pond.GrainBag
         * @static
         * @param {pond.IGrainBag=} [properties] Properties to set
         * @returns {pond.GrainBag} GrainBag instance
         */
        GrainBag.create = function create(properties) {
            return new GrainBag(properties);
        };

        /**
         * Creates a GrainBag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainBag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainBag} GrainBag
         */
        GrainBag.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainBag)
                return object;
            var message = new $root.pond.GrainBag();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.GrainBag.settings: object expected");
                message.settings = $root.pond.GrainBagSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainBag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainBag
         * @static
         * @param {pond.GrainBag} message GrainBag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainBag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GrainBagSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this GrainBag to JSON.
         * @function toJSON
         * @memberof pond.GrainBag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainBag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainBag;
    })();

    pond.GrainBagSettings = (function() {

        /**
         * Properties of a GrainBagSettings.
         * @memberof pond
         * @interface IGrainBagSettings
         * @property {number|null} [length] GrainBagSettings length
         * @property {number|null} [diameter] GrainBagSettings diameter
         * @property {pond.Grain|null} [supportedGrain] GrainBagSettings supportedGrain
         * @property {string|null} [customGrain] GrainBagSettings customGrain
         * @property {string|null} [grainSubtype] GrainBagSettings grainSubtype
         * @property {number|null} [bushelCapacity] GrainBagSettings bushelCapacity
         * @property {number|null} [currentBushels] GrainBagSettings currentBushels
         * @property {pond.Location|null} [startLocation] GrainBagSettings startLocation
         * @property {pond.Location|null} [endLocation] GrainBagSettings endLocation
         * @property {pond.BinStorage|null} [storageType] GrainBagSettings storageType
         * @property {string|null} [fillDate] GrainBagSettings fillDate
         * @property {number|null} [initialMoisture] GrainBagSettings initialMoisture
         * @property {pond.ObjectTheme|null} [theme] GrainBagSettings theme
         * @property {number|null} [bushelsPerTonne] GrainBagSettings bushelsPerTonne
         */

        /**
         * Constructs a new GrainBagSettings.
         * @memberof pond
         * @classdesc Represents a GrainBagSettings.
         * @implements IGrainBagSettings
         * @constructor
         * @param {pond.IGrainBagSettings=} [properties] Properties to set
         */
        function GrainBagSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainBagSettings length.
         * @member {number} length
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.length = 0;

        /**
         * GrainBagSettings diameter.
         * @member {number} diameter
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.diameter = 0;

        /**
         * GrainBagSettings supportedGrain.
         * @member {pond.Grain} supportedGrain
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.supportedGrain = 0;

        /**
         * GrainBagSettings customGrain.
         * @member {string} customGrain
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.customGrain = "";

        /**
         * GrainBagSettings grainSubtype.
         * @member {string} grainSubtype
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.grainSubtype = "";

        /**
         * GrainBagSettings bushelCapacity.
         * @member {number} bushelCapacity
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.bushelCapacity = 0;

        /**
         * GrainBagSettings currentBushels.
         * @member {number} currentBushels
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.currentBushels = 0;

        /**
         * GrainBagSettings startLocation.
         * @member {pond.Location|null|undefined} startLocation
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.startLocation = null;

        /**
         * GrainBagSettings endLocation.
         * @member {pond.Location|null|undefined} endLocation
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.endLocation = null;

        /**
         * GrainBagSettings storageType.
         * @member {pond.BinStorage} storageType
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.storageType = 0;

        /**
         * GrainBagSettings fillDate.
         * @member {string} fillDate
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.fillDate = "";

        /**
         * GrainBagSettings initialMoisture.
         * @member {number} initialMoisture
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.initialMoisture = 0;

        /**
         * GrainBagSettings theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.theme = null;

        /**
         * GrainBagSettings bushelsPerTonne.
         * @member {number} bushelsPerTonne
         * @memberof pond.GrainBagSettings
         * @instance
         */
        GrainBagSettings.prototype.bushelsPerTonne = 0;

        /**
         * Creates a new GrainBagSettings instance using the specified properties.
         * @function create
         * @memberof pond.GrainBagSettings
         * @static
         * @param {pond.IGrainBagSettings=} [properties] Properties to set
         * @returns {pond.GrainBagSettings} GrainBagSettings instance
         */
        GrainBagSettings.create = function create(properties) {
            return new GrainBagSettings(properties);
        };

        /**
         * Creates a GrainBagSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GrainBagSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GrainBagSettings} GrainBagSettings
         */
        GrainBagSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GrainBagSettings)
                return object;
            var message = new $root.pond.GrainBagSettings();
            if (object.length != null)
                message.length = Number(object.length);
            if (object.diameter != null)
                message.diameter = Number(object.diameter);
            switch (object.supportedGrain) {
            case "GRAIN_INVALID":
            case 0:
                message.supportedGrain = 0;
                break;
            case "GRAIN_NONE":
            case 1:
                message.supportedGrain = 1;
                break;
            case "GRAIN_BARLEY":
            case 2:
                message.supportedGrain = 2;
                break;
            case "GRAIN_BUCKWHEAT":
            case 3:
                message.supportedGrain = 3;
                break;
            case "GRAIN_CANOLA":
            case 4:
                message.supportedGrain = 4;
                break;
            case "GRAIN_CORN":
            case 5:
                message.supportedGrain = 5;
                break;
            case "GRAIN_OATS":
            case 6:
                message.supportedGrain = 6;
                break;
            case "GRAIN_PEANUTS":
            case 7:
                message.supportedGrain = 7;
                break;
            case "GRAIN_RAPESEED":
            case 8:
                message.supportedGrain = 8;
                break;
            case "GRAIN_RICE_LONG":
            case 9:
                message.supportedGrain = 9;
                break;
            case "GRAIN_RICE_MEDIUM":
            case 10:
                message.supportedGrain = 10;
                break;
            case "GRAIN_RICE_SHORT":
            case 11:
                message.supportedGrain = 11;
                break;
            case "GRAIN_SORGHUM":
            case 12:
                message.supportedGrain = 12;
                break;
            case "GRAIN_SOYBEANS":
            case 13:
                message.supportedGrain = 13;
                break;
            case "GRAIN_SUNFLOWER":
            case 14:
                message.supportedGrain = 14;
                break;
            case "GRAIN_WHEAT_DURUM":
            case 15:
                message.supportedGrain = 15;
                break;
            case "GRAIN_WHEAT_HARD_RED":
            case 16:
                message.supportedGrain = 16;
                break;
            case "GRAIN_FLAX_UNRETTED":
            case 17:
                message.supportedGrain = 17;
                break;
            case "GRAIN_FLAX_DEW_RETTED":
            case 18:
                message.supportedGrain = 18;
                break;
            case "GRAIN_YELLOW_PEAS":
            case 19:
                message.supportedGrain = 19;
                break;
            case "GRAIN_LENTILS_ROBIN":
            case 20:
                message.supportedGrain = 20;
                break;
            case "GRAIN_LENTILS_REDBERRY":
            case 21:
                message.supportedGrain = 21;
                break;
            case "GRAIN_LENTILS_BLAZE":
            case 22:
                message.supportedGrain = 22;
                break;
            case "GRAIN_CUSTOM":
            case 23:
                message.supportedGrain = 23;
                break;
            case "GRAIN_MAIZE_WHITE":
            case 24:
                message.supportedGrain = 24;
                break;
            case "GRAIN_MAIZE_YELLOW":
            case 25:
                message.supportedGrain = 25;
                break;
            case "GRAIN_WHEAT_SAWOS":
            case 26:
                message.supportedGrain = 26;
                break;
            }
            if (object.customGrain != null)
                message.customGrain = String(object.customGrain);
            if (object.grainSubtype != null)
                message.grainSubtype = String(object.grainSubtype);
            if (object.bushelCapacity != null)
                message.bushelCapacity = Number(object.bushelCapacity);
            if (object.currentBushels != null)
                message.currentBushels = Number(object.currentBushels);
            if (object.startLocation != null) {
                if (typeof object.startLocation !== "object")
                    throw TypeError(".pond.GrainBagSettings.startLocation: object expected");
                message.startLocation = $root.pond.Location.fromObject(object.startLocation);
            }
            if (object.endLocation != null) {
                if (typeof object.endLocation !== "object")
                    throw TypeError(".pond.GrainBagSettings.endLocation: object expected");
                message.endLocation = $root.pond.Location.fromObject(object.endLocation);
            }
            switch (object.storageType) {
            case "BIN_STORAGE_UNKNOWN":
            case 0:
                message.storageType = 0;
                break;
            case "BIN_STORAGE_SUPPORTED_GRAIN":
            case 1:
                message.storageType = 1;
                break;
            case "BIN_STORAGE_FERTILIZER":
            case 2:
                message.storageType = 2;
                break;
            case "BIN_STORAGE_UNSUPPORTED_GRAIN":
            case 3:
                message.storageType = 3;
                break;
            }
            if (object.fillDate != null)
                message.fillDate = String(object.fillDate);
            if (object.initialMoisture != null)
                message.initialMoisture = Number(object.initialMoisture);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.GrainBagSettings.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            if (object.bushelsPerTonne != null)
                message.bushelsPerTonne = Number(object.bushelsPerTonne);
            return message;
        };

        /**
         * Creates a plain object from a GrainBagSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GrainBagSettings
         * @static
         * @param {pond.GrainBagSettings} message GrainBagSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainBagSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.length = 0;
                object.diameter = 0;
                object.supportedGrain = options.enums === String ? "GRAIN_INVALID" : 0;
                object.customGrain = "";
                object.grainSubtype = "";
                object.bushelCapacity = 0;
                object.currentBushels = 0;
                object.startLocation = null;
                object.endLocation = null;
                object.storageType = options.enums === String ? "BIN_STORAGE_UNKNOWN" : 0;
                object.fillDate = "";
                object.initialMoisture = 0;
                object.theme = null;
                object.bushelsPerTonne = 0;
            }
            if (message.length != null && message.hasOwnProperty("length"))
                object.length = options.json && !isFinite(message.length) ? String(message.length) : message.length;
            if (message.diameter != null && message.hasOwnProperty("diameter"))
                object.diameter = options.json && !isFinite(message.diameter) ? String(message.diameter) : message.diameter;
            if (message.supportedGrain != null && message.hasOwnProperty("supportedGrain"))
                object.supportedGrain = options.enums === String ? $root.pond.Grain[message.supportedGrain] : message.supportedGrain;
            if (message.customGrain != null && message.hasOwnProperty("customGrain"))
                object.customGrain = message.customGrain;
            if (message.grainSubtype != null && message.hasOwnProperty("grainSubtype"))
                object.grainSubtype = message.grainSubtype;
            if (message.bushelCapacity != null && message.hasOwnProperty("bushelCapacity"))
                object.bushelCapacity = options.json && !isFinite(message.bushelCapacity) ? String(message.bushelCapacity) : message.bushelCapacity;
            if (message.currentBushels != null && message.hasOwnProperty("currentBushels"))
                object.currentBushels = options.json && !isFinite(message.currentBushels) ? String(message.currentBushels) : message.currentBushels;
            if (message.startLocation != null && message.hasOwnProperty("startLocation"))
                object.startLocation = $root.pond.Location.toObject(message.startLocation, options);
            if (message.endLocation != null && message.hasOwnProperty("endLocation"))
                object.endLocation = $root.pond.Location.toObject(message.endLocation, options);
            if (message.storageType != null && message.hasOwnProperty("storageType"))
                object.storageType = options.enums === String ? $root.pond.BinStorage[message.storageType] : message.storageType;
            if (message.fillDate != null && message.hasOwnProperty("fillDate"))
                object.fillDate = message.fillDate;
            if (message.initialMoisture != null && message.hasOwnProperty("initialMoisture"))
                object.initialMoisture = options.json && !isFinite(message.initialMoisture) ? String(message.initialMoisture) : message.initialMoisture;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.bushelsPerTonne != null && message.hasOwnProperty("bushelsPerTonne"))
                object.bushelsPerTonne = options.json && !isFinite(message.bushelsPerTonne) ? String(message.bushelsPerTonne) : message.bushelsPerTonne;
            return object;
        };

        /**
         * Converts this GrainBagSettings to JSON.
         * @function toJSON
         * @memberof pond.GrainBagSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainBagSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainBagSettings;
    })();

    pond.AddGrainBagRequest = (function() {

        /**
         * Properties of an AddGrainBagRequest.
         * @memberof pond
         * @interface IAddGrainBagRequest
         * @property {string|null} [name] AddGrainBagRequest name
         * @property {pond.GrainBagSettings|null} [settings] AddGrainBagRequest settings
         */

        /**
         * Constructs a new AddGrainBagRequest.
         * @memberof pond
         * @classdesc Represents an AddGrainBagRequest.
         * @implements IAddGrainBagRequest
         * @constructor
         * @param {pond.IAddGrainBagRequest=} [properties] Properties to set
         */
        function AddGrainBagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGrainBagRequest name.
         * @member {string} name
         * @memberof pond.AddGrainBagRequest
         * @instance
         */
        AddGrainBagRequest.prototype.name = "";

        /**
         * AddGrainBagRequest settings.
         * @member {pond.GrainBagSettings|null|undefined} settings
         * @memberof pond.AddGrainBagRequest
         * @instance
         */
        AddGrainBagRequest.prototype.settings = null;

        /**
         * Creates a new AddGrainBagRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddGrainBagRequest
         * @static
         * @param {pond.IAddGrainBagRequest=} [properties] Properties to set
         * @returns {pond.AddGrainBagRequest} AddGrainBagRequest instance
         */
        AddGrainBagRequest.create = function create(properties) {
            return new AddGrainBagRequest(properties);
        };

        /**
         * Creates an AddGrainBagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGrainBagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGrainBagRequest} AddGrainBagRequest
         */
        AddGrainBagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGrainBagRequest)
                return object;
            var message = new $root.pond.AddGrainBagRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddGrainBagRequest.settings: object expected");
                message.settings = $root.pond.GrainBagSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddGrainBagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGrainBagRequest
         * @static
         * @param {pond.AddGrainBagRequest} message AddGrainBagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGrainBagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GrainBagSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddGrainBagRequest to JSON.
         * @function toJSON
         * @memberof pond.AddGrainBagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGrainBagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGrainBagRequest;
    })();

    pond.AddGrainBagResponse = (function() {

        /**
         * Properties of an AddGrainBagResponse.
         * @memberof pond
         * @interface IAddGrainBagResponse
         * @property {string|null} [key] AddGrainBagResponse key
         */

        /**
         * Constructs a new AddGrainBagResponse.
         * @memberof pond
         * @classdesc Represents an AddGrainBagResponse.
         * @implements IAddGrainBagResponse
         * @constructor
         * @param {pond.IAddGrainBagResponse=} [properties] Properties to set
         */
        function AddGrainBagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddGrainBagResponse key.
         * @member {string} key
         * @memberof pond.AddGrainBagResponse
         * @instance
         */
        AddGrainBagResponse.prototype.key = "";

        /**
         * Creates a new AddGrainBagResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddGrainBagResponse
         * @static
         * @param {pond.IAddGrainBagResponse=} [properties] Properties to set
         * @returns {pond.AddGrainBagResponse} AddGrainBagResponse instance
         */
        AddGrainBagResponse.create = function create(properties) {
            return new AddGrainBagResponse(properties);
        };

        /**
         * Creates an AddGrainBagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddGrainBagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddGrainBagResponse} AddGrainBagResponse
         */
        AddGrainBagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddGrainBagResponse)
                return object;
            var message = new $root.pond.AddGrainBagResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddGrainBagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddGrainBagResponse
         * @static
         * @param {pond.AddGrainBagResponse} message AddGrainBagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddGrainBagResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddGrainBagResponse to JSON.
         * @function toJSON
         * @memberof pond.AddGrainBagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddGrainBagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddGrainBagResponse;
    })();

    pond.GetGrainBagRequest = (function() {

        /**
         * Properties of a GetGrainBagRequest.
         * @memberof pond
         * @interface IGetGrainBagRequest
         * @property {string|null} [key] GetGrainBagRequest key
         */

        /**
         * Constructs a new GetGrainBagRequest.
         * @memberof pond
         * @classdesc Represents a GetGrainBagRequest.
         * @implements IGetGrainBagRequest
         * @constructor
         * @param {pond.IGetGrainBagRequest=} [properties] Properties to set
         */
        function GetGrainBagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGrainBagRequest key.
         * @member {string} key
         * @memberof pond.GetGrainBagRequest
         * @instance
         */
        GetGrainBagRequest.prototype.key = "";

        /**
         * Creates a new GetGrainBagRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetGrainBagRequest
         * @static
         * @param {pond.IGetGrainBagRequest=} [properties] Properties to set
         * @returns {pond.GetGrainBagRequest} GetGrainBagRequest instance
         */
        GetGrainBagRequest.create = function create(properties) {
            return new GetGrainBagRequest(properties);
        };

        /**
         * Creates a GetGrainBagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGrainBagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGrainBagRequest} GetGrainBagRequest
         */
        GetGrainBagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGrainBagRequest)
                return object;
            var message = new $root.pond.GetGrainBagRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetGrainBagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGrainBagRequest
         * @static
         * @param {pond.GetGrainBagRequest} message GetGrainBagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGrainBagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetGrainBagRequest to JSON.
         * @function toJSON
         * @memberof pond.GetGrainBagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGrainBagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGrainBagRequest;
    })();

    pond.GetGrainBagResponse = (function() {

        /**
         * Properties of a GetGrainBagResponse.
         * @memberof pond
         * @interface IGetGrainBagResponse
         * @property {pond.GrainBag|null} [grainBag] GetGrainBagResponse grainBag
         */

        /**
         * Constructs a new GetGrainBagResponse.
         * @memberof pond
         * @classdesc Represents a GetGrainBagResponse.
         * @implements IGetGrainBagResponse
         * @constructor
         * @param {pond.IGetGrainBagResponse=} [properties] Properties to set
         */
        function GetGrainBagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetGrainBagResponse grainBag.
         * @member {pond.GrainBag|null|undefined} grainBag
         * @memberof pond.GetGrainBagResponse
         * @instance
         */
        GetGrainBagResponse.prototype.grainBag = null;

        /**
         * Creates a new GetGrainBagResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetGrainBagResponse
         * @static
         * @param {pond.IGetGrainBagResponse=} [properties] Properties to set
         * @returns {pond.GetGrainBagResponse} GetGrainBagResponse instance
         */
        GetGrainBagResponse.create = function create(properties) {
            return new GetGrainBagResponse(properties);
        };

        /**
         * Creates a GetGrainBagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetGrainBagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetGrainBagResponse} GetGrainBagResponse
         */
        GetGrainBagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetGrainBagResponse)
                return object;
            var message = new $root.pond.GetGrainBagResponse();
            if (object.grainBag != null) {
                if (typeof object.grainBag !== "object")
                    throw TypeError(".pond.GetGrainBagResponse.grainBag: object expected");
                message.grainBag = $root.pond.GrainBag.fromObject(object.grainBag);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetGrainBagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetGrainBagResponse
         * @static
         * @param {pond.GetGrainBagResponse} message GetGrainBagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGrainBagResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.grainBag = null;
            if (message.grainBag != null && message.hasOwnProperty("grainBag"))
                object.grainBag = $root.pond.GrainBag.toObject(message.grainBag, options);
            return object;
        };

        /**
         * Converts this GetGrainBagResponse to JSON.
         * @function toJSON
         * @memberof pond.GetGrainBagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGrainBagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetGrainBagResponse;
    })();

    pond.ListGrainBagsRequest = (function() {

        /**
         * Properties of a ListGrainBagsRequest.
         * @memberof pond
         * @interface IListGrainBagsRequest
         * @property {pond.Paging|null} [paging] ListGrainBagsRequest paging
         * @property {pond.Sorting|null} [sorting] ListGrainBagsRequest sorting
         * @property {string|null} [search] ListGrainBagsRequest search
         */

        /**
         * Constructs a new ListGrainBagsRequest.
         * @memberof pond
         * @classdesc Represents a ListGrainBagsRequest.
         * @implements IListGrainBagsRequest
         * @constructor
         * @param {pond.IListGrainBagsRequest=} [properties] Properties to set
         */
        function ListGrainBagsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGrainBagsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListGrainBagsRequest
         * @instance
         */
        ListGrainBagsRequest.prototype.paging = null;

        /**
         * ListGrainBagsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListGrainBagsRequest
         * @instance
         */
        ListGrainBagsRequest.prototype.sorting = null;

        /**
         * ListGrainBagsRequest search.
         * @member {string} search
         * @memberof pond.ListGrainBagsRequest
         * @instance
         */
        ListGrainBagsRequest.prototype.search = "";

        /**
         * Creates a new ListGrainBagsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGrainBagsRequest
         * @static
         * @param {pond.IListGrainBagsRequest=} [properties] Properties to set
         * @returns {pond.ListGrainBagsRequest} ListGrainBagsRequest instance
         */
        ListGrainBagsRequest.create = function create(properties) {
            return new ListGrainBagsRequest(properties);
        };

        /**
         * Creates a ListGrainBagsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGrainBagsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGrainBagsRequest} ListGrainBagsRequest
         */
        ListGrainBagsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGrainBagsRequest)
                return object;
            var message = new $root.pond.ListGrainBagsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListGrainBagsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListGrainBagsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListGrainBagsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGrainBagsRequest
         * @static
         * @param {pond.ListGrainBagsRequest} message ListGrainBagsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGrainBagsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListGrainBagsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGrainBagsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGrainBagsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGrainBagsRequest;
    })();

    pond.ListGrainBagsResponse = (function() {

        /**
         * Properties of a ListGrainBagsResponse.
         * @memberof pond
         * @interface IListGrainBagsResponse
         * @property {Array.<pond.GrainBag>|null} [grainBags] ListGrainBagsResponse grainBags
         * @property {number|null} [nextOffset] ListGrainBagsResponse nextOffset
         * @property {number|null} [total] ListGrainBagsResponse total
         */

        /**
         * Constructs a new ListGrainBagsResponse.
         * @memberof pond
         * @classdesc Represents a ListGrainBagsResponse.
         * @implements IListGrainBagsResponse
         * @constructor
         * @param {pond.IListGrainBagsResponse=} [properties] Properties to set
         */
        function ListGrainBagsResponse(properties) {
            this.grainBags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGrainBagsResponse grainBags.
         * @member {Array.<pond.GrainBag>} grainBags
         * @memberof pond.ListGrainBagsResponse
         * @instance
         */
        ListGrainBagsResponse.prototype.grainBags = $util.emptyArray;

        /**
         * ListGrainBagsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListGrainBagsResponse
         * @instance
         */
        ListGrainBagsResponse.prototype.nextOffset = 0;

        /**
         * ListGrainBagsResponse total.
         * @member {number} total
         * @memberof pond.ListGrainBagsResponse
         * @instance
         */
        ListGrainBagsResponse.prototype.total = 0;

        /**
         * Creates a new ListGrainBagsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGrainBagsResponse
         * @static
         * @param {pond.IListGrainBagsResponse=} [properties] Properties to set
         * @returns {pond.ListGrainBagsResponse} ListGrainBagsResponse instance
         */
        ListGrainBagsResponse.create = function create(properties) {
            return new ListGrainBagsResponse(properties);
        };

        /**
         * Creates a ListGrainBagsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGrainBagsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGrainBagsResponse} ListGrainBagsResponse
         */
        ListGrainBagsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGrainBagsResponse)
                return object;
            var message = new $root.pond.ListGrainBagsResponse();
            if (object.grainBags) {
                if (!Array.isArray(object.grainBags))
                    throw TypeError(".pond.ListGrainBagsResponse.grainBags: array expected");
                message.grainBags = [];
                for (var i = 0; i < object.grainBags.length; ++i) {
                    if (typeof object.grainBags[i] !== "object")
                        throw TypeError(".pond.ListGrainBagsResponse.grainBags: object expected");
                    message.grainBags[i] = $root.pond.GrainBag.fromObject(object.grainBags[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListGrainBagsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGrainBagsResponse
         * @static
         * @param {pond.ListGrainBagsResponse} message ListGrainBagsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGrainBagsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.grainBags = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.grainBags && message.grainBags.length) {
                object.grainBags = [];
                for (var j = 0; j < message.grainBags.length; ++j)
                    object.grainBags[j] = $root.pond.GrainBag.toObject(message.grainBags[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListGrainBagsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGrainBagsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGrainBagsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGrainBagsResponse;
    })();

    pond.UpdateGrainBagRequest = (function() {

        /**
         * Properties of an UpdateGrainBagRequest.
         * @memberof pond
         * @interface IUpdateGrainBagRequest
         * @property {string|null} [key] UpdateGrainBagRequest key
         * @property {string|null} [name] UpdateGrainBagRequest name
         * @property {pond.GrainBagSettings|null} [settings] UpdateGrainBagRequest settings
         */

        /**
         * Constructs a new UpdateGrainBagRequest.
         * @memberof pond
         * @classdesc Represents an UpdateGrainBagRequest.
         * @implements IUpdateGrainBagRequest
         * @constructor
         * @param {pond.IUpdateGrainBagRequest=} [properties] Properties to set
         */
        function UpdateGrainBagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateGrainBagRequest key.
         * @member {string} key
         * @memberof pond.UpdateGrainBagRequest
         * @instance
         */
        UpdateGrainBagRequest.prototype.key = "";

        /**
         * UpdateGrainBagRequest name.
         * @member {string} name
         * @memberof pond.UpdateGrainBagRequest
         * @instance
         */
        UpdateGrainBagRequest.prototype.name = "";

        /**
         * UpdateGrainBagRequest settings.
         * @member {pond.GrainBagSettings|null|undefined} settings
         * @memberof pond.UpdateGrainBagRequest
         * @instance
         */
        UpdateGrainBagRequest.prototype.settings = null;

        /**
         * Creates a new UpdateGrainBagRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGrainBagRequest
         * @static
         * @param {pond.IUpdateGrainBagRequest=} [properties] Properties to set
         * @returns {pond.UpdateGrainBagRequest} UpdateGrainBagRequest instance
         */
        UpdateGrainBagRequest.create = function create(properties) {
            return new UpdateGrainBagRequest(properties);
        };

        /**
         * Creates an UpdateGrainBagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGrainBagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGrainBagRequest} UpdateGrainBagRequest
         */
        UpdateGrainBagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGrainBagRequest)
                return object;
            var message = new $root.pond.UpdateGrainBagRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateGrainBagRequest.settings: object expected");
                message.settings = $root.pond.GrainBagSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateGrainBagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGrainBagRequest
         * @static
         * @param {pond.UpdateGrainBagRequest} message UpdateGrainBagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGrainBagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.GrainBagSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateGrainBagRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateGrainBagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGrainBagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGrainBagRequest;
    })();

    pond.UpdateGrainBagResponse = (function() {

        /**
         * Properties of an UpdateGrainBagResponse.
         * @memberof pond
         * @interface IUpdateGrainBagResponse
         */

        /**
         * Constructs a new UpdateGrainBagResponse.
         * @memberof pond
         * @classdesc Represents an UpdateGrainBagResponse.
         * @implements IUpdateGrainBagResponse
         * @constructor
         * @param {pond.IUpdateGrainBagResponse=} [properties] Properties to set
         */
        function UpdateGrainBagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGrainBagResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateGrainBagResponse
         * @static
         * @param {pond.IUpdateGrainBagResponse=} [properties] Properties to set
         * @returns {pond.UpdateGrainBagResponse} UpdateGrainBagResponse instance
         */
        UpdateGrainBagResponse.create = function create(properties) {
            return new UpdateGrainBagResponse(properties);
        };

        /**
         * Creates an UpdateGrainBagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateGrainBagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateGrainBagResponse} UpdateGrainBagResponse
         */
        UpdateGrainBagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateGrainBagResponse)
                return object;
            return new $root.pond.UpdateGrainBagResponse();
        };

        /**
         * Creates a plain object from an UpdateGrainBagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateGrainBagResponse
         * @static
         * @param {pond.UpdateGrainBagResponse} message UpdateGrainBagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGrainBagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGrainBagResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateGrainBagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGrainBagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateGrainBagResponse;
    })();

    pond.RemoveGrainBagRequest = (function() {

        /**
         * Properties of a RemoveGrainBagRequest.
         * @memberof pond
         * @interface IRemoveGrainBagRequest
         * @property {string|null} [key] RemoveGrainBagRequest key
         */

        /**
         * Constructs a new RemoveGrainBagRequest.
         * @memberof pond
         * @classdesc Represents a RemoveGrainBagRequest.
         * @implements IRemoveGrainBagRequest
         * @constructor
         * @param {pond.IRemoveGrainBagRequest=} [properties] Properties to set
         */
        function RemoveGrainBagRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveGrainBagRequest key.
         * @member {string} key
         * @memberof pond.RemoveGrainBagRequest
         * @instance
         */
        RemoveGrainBagRequest.prototype.key = "";

        /**
         * Creates a new RemoveGrainBagRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGrainBagRequest
         * @static
         * @param {pond.IRemoveGrainBagRequest=} [properties] Properties to set
         * @returns {pond.RemoveGrainBagRequest} RemoveGrainBagRequest instance
         */
        RemoveGrainBagRequest.create = function create(properties) {
            return new RemoveGrainBagRequest(properties);
        };

        /**
         * Creates a RemoveGrainBagRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGrainBagRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGrainBagRequest} RemoveGrainBagRequest
         */
        RemoveGrainBagRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGrainBagRequest)
                return object;
            var message = new $root.pond.RemoveGrainBagRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveGrainBagRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGrainBagRequest
         * @static
         * @param {pond.RemoveGrainBagRequest} message RemoveGrainBagRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGrainBagRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveGrainBagRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveGrainBagRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGrainBagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGrainBagRequest;
    })();

    pond.RemoveGrainBagResponse = (function() {

        /**
         * Properties of a RemoveGrainBagResponse.
         * @memberof pond
         * @interface IRemoveGrainBagResponse
         */

        /**
         * Constructs a new RemoveGrainBagResponse.
         * @memberof pond
         * @classdesc Represents a RemoveGrainBagResponse.
         * @implements IRemoveGrainBagResponse
         * @constructor
         * @param {pond.IRemoveGrainBagResponse=} [properties] Properties to set
         */
        function RemoveGrainBagResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveGrainBagResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveGrainBagResponse
         * @static
         * @param {pond.IRemoveGrainBagResponse=} [properties] Properties to set
         * @returns {pond.RemoveGrainBagResponse} RemoveGrainBagResponse instance
         */
        RemoveGrainBagResponse.create = function create(properties) {
            return new RemoveGrainBagResponse(properties);
        };

        /**
         * Creates a RemoveGrainBagResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveGrainBagResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveGrainBagResponse} RemoveGrainBagResponse
         */
        RemoveGrainBagResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveGrainBagResponse)
                return object;
            return new $root.pond.RemoveGrainBagResponse();
        };

        /**
         * Creates a plain object from a RemoveGrainBagResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveGrainBagResponse
         * @static
         * @param {pond.RemoveGrainBagResponse} message RemoveGrainBagResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveGrainBagResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveGrainBagResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveGrainBagResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveGrainBagResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveGrainBagResponse;
    })();

    pond.ListGrainBagHistoryRequest = (function() {

        /**
         * Properties of a ListGrainBagHistoryRequest.
         * @memberof pond
         * @interface IListGrainBagHistoryRequest
         * @property {string|null} [key] ListGrainBagHistoryRequest key
         * @property {pond.Paging|null} [paging] ListGrainBagHistoryRequest paging
         * @property {string|null} [start] ListGrainBagHistoryRequest start
         * @property {string|null} [end] ListGrainBagHistoryRequest end
         */

        /**
         * Constructs a new ListGrainBagHistoryRequest.
         * @memberof pond
         * @classdesc Represents a ListGrainBagHistoryRequest.
         * @implements IListGrainBagHistoryRequest
         * @constructor
         * @param {pond.IListGrainBagHistoryRequest=} [properties] Properties to set
         */
        function ListGrainBagHistoryRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGrainBagHistoryRequest key.
         * @member {string} key
         * @memberof pond.ListGrainBagHistoryRequest
         * @instance
         */
        ListGrainBagHistoryRequest.prototype.key = "";

        /**
         * ListGrainBagHistoryRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListGrainBagHistoryRequest
         * @instance
         */
        ListGrainBagHistoryRequest.prototype.paging = null;

        /**
         * ListGrainBagHistoryRequest start.
         * @member {string} start
         * @memberof pond.ListGrainBagHistoryRequest
         * @instance
         */
        ListGrainBagHistoryRequest.prototype.start = "";

        /**
         * ListGrainBagHistoryRequest end.
         * @member {string} end
         * @memberof pond.ListGrainBagHistoryRequest
         * @instance
         */
        ListGrainBagHistoryRequest.prototype.end = "";

        /**
         * Creates a new ListGrainBagHistoryRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListGrainBagHistoryRequest
         * @static
         * @param {pond.IListGrainBagHistoryRequest=} [properties] Properties to set
         * @returns {pond.ListGrainBagHistoryRequest} ListGrainBagHistoryRequest instance
         */
        ListGrainBagHistoryRequest.create = function create(properties) {
            return new ListGrainBagHistoryRequest(properties);
        };

        /**
         * Creates a ListGrainBagHistoryRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGrainBagHistoryRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGrainBagHistoryRequest} ListGrainBagHistoryRequest
         */
        ListGrainBagHistoryRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGrainBagHistoryRequest)
                return object;
            var message = new $root.pond.ListGrainBagHistoryRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListGrainBagHistoryRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from a ListGrainBagHistoryRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGrainBagHistoryRequest
         * @static
         * @param {pond.ListGrainBagHistoryRequest} message ListGrainBagHistoryRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGrainBagHistoryRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.paging = null;
                object.start = "";
                object.end = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this ListGrainBagHistoryRequest to JSON.
         * @function toJSON
         * @memberof pond.ListGrainBagHistoryRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGrainBagHistoryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGrainBagHistoryRequest;
    })();

    pond.ListGrainBagHistoryResponse = (function() {

        /**
         * Properties of a ListGrainBagHistoryResponse.
         * @memberof pond
         * @interface IListGrainBagHistoryResponse
         * @property {Array.<pond.ObjectHistory>|null} [history] ListGrainBagHistoryResponse history
         * @property {number|null} [nextOffset] ListGrainBagHistoryResponse nextOffset
         * @property {number|null} [total] ListGrainBagHistoryResponse total
         */

        /**
         * Constructs a new ListGrainBagHistoryResponse.
         * @memberof pond
         * @classdesc Represents a ListGrainBagHistoryResponse.
         * @implements IListGrainBagHistoryResponse
         * @constructor
         * @param {pond.IListGrainBagHistoryResponse=} [properties] Properties to set
         */
        function ListGrainBagHistoryResponse(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListGrainBagHistoryResponse history.
         * @member {Array.<pond.ObjectHistory>} history
         * @memberof pond.ListGrainBagHistoryResponse
         * @instance
         */
        ListGrainBagHistoryResponse.prototype.history = $util.emptyArray;

        /**
         * ListGrainBagHistoryResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListGrainBagHistoryResponse
         * @instance
         */
        ListGrainBagHistoryResponse.prototype.nextOffset = 0;

        /**
         * ListGrainBagHistoryResponse total.
         * @member {number} total
         * @memberof pond.ListGrainBagHistoryResponse
         * @instance
         */
        ListGrainBagHistoryResponse.prototype.total = 0;

        /**
         * Creates a new ListGrainBagHistoryResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListGrainBagHistoryResponse
         * @static
         * @param {pond.IListGrainBagHistoryResponse=} [properties] Properties to set
         * @returns {pond.ListGrainBagHistoryResponse} ListGrainBagHistoryResponse instance
         */
        ListGrainBagHistoryResponse.create = function create(properties) {
            return new ListGrainBagHistoryResponse(properties);
        };

        /**
         * Creates a ListGrainBagHistoryResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListGrainBagHistoryResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListGrainBagHistoryResponse} ListGrainBagHistoryResponse
         */
        ListGrainBagHistoryResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListGrainBagHistoryResponse)
                return object;
            var message = new $root.pond.ListGrainBagHistoryResponse();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".pond.ListGrainBagHistoryResponse.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".pond.ListGrainBagHistoryResponse.history: object expected");
                    message.history[i] = $root.pond.ObjectHistory.fromObject(object.history[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListGrainBagHistoryResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListGrainBagHistoryResponse
         * @static
         * @param {pond.ListGrainBagHistoryResponse} message ListGrainBagHistoryResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListGrainBagHistoryResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.pond.ObjectHistory.toObject(message.history[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListGrainBagHistoryResponse to JSON.
         * @function toJSON
         * @memberof pond.ListGrainBagHistoryResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListGrainBagHistoryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListGrainBagHistoryResponse;
    })();

    pond.BulkGrainBagUpdateRequest = (function() {

        /**
         * Properties of a BulkGrainBagUpdateRequest.
         * @memberof pond
         * @interface IBulkGrainBagUpdateRequest
         * @property {Array.<pond.GrainBag>|null} [bags] BulkGrainBagUpdateRequest bags
         */

        /**
         * Constructs a new BulkGrainBagUpdateRequest.
         * @memberof pond
         * @classdesc Represents a BulkGrainBagUpdateRequest.
         * @implements IBulkGrainBagUpdateRequest
         * @constructor
         * @param {pond.IBulkGrainBagUpdateRequest=} [properties] Properties to set
         */
        function BulkGrainBagUpdateRequest(properties) {
            this.bags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkGrainBagUpdateRequest bags.
         * @member {Array.<pond.GrainBag>} bags
         * @memberof pond.BulkGrainBagUpdateRequest
         * @instance
         */
        BulkGrainBagUpdateRequest.prototype.bags = $util.emptyArray;

        /**
         * Creates a new BulkGrainBagUpdateRequest instance using the specified properties.
         * @function create
         * @memberof pond.BulkGrainBagUpdateRequest
         * @static
         * @param {pond.IBulkGrainBagUpdateRequest=} [properties] Properties to set
         * @returns {pond.BulkGrainBagUpdateRequest} BulkGrainBagUpdateRequest instance
         */
        BulkGrainBagUpdateRequest.create = function create(properties) {
            return new BulkGrainBagUpdateRequest(properties);
        };

        /**
         * Creates a BulkGrainBagUpdateRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkGrainBagUpdateRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkGrainBagUpdateRequest} BulkGrainBagUpdateRequest
         */
        BulkGrainBagUpdateRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkGrainBagUpdateRequest)
                return object;
            var message = new $root.pond.BulkGrainBagUpdateRequest();
            if (object.bags) {
                if (!Array.isArray(object.bags))
                    throw TypeError(".pond.BulkGrainBagUpdateRequest.bags: array expected");
                message.bags = [];
                for (var i = 0; i < object.bags.length; ++i) {
                    if (typeof object.bags[i] !== "object")
                        throw TypeError(".pond.BulkGrainBagUpdateRequest.bags: object expected");
                    message.bags[i] = $root.pond.GrainBag.fromObject(object.bags[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BulkGrainBagUpdateRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkGrainBagUpdateRequest
         * @static
         * @param {pond.BulkGrainBagUpdateRequest} message BulkGrainBagUpdateRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkGrainBagUpdateRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bags = [];
            if (message.bags && message.bags.length) {
                object.bags = [];
                for (var j = 0; j < message.bags.length; ++j)
                    object.bags[j] = $root.pond.GrainBag.toObject(message.bags[j], options);
            }
            return object;
        };

        /**
         * Converts this BulkGrainBagUpdateRequest to JSON.
         * @function toJSON
         * @memberof pond.BulkGrainBagUpdateRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkGrainBagUpdateRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkGrainBagUpdateRequest;
    })();

    pond.BulkGrainBagUpdateResponse = (function() {

        /**
         * Properties of a BulkGrainBagUpdateResponse.
         * @memberof pond
         * @interface IBulkGrainBagUpdateResponse
         * @property {number|null} [successfull] BulkGrainBagUpdateResponse successfull
         */

        /**
         * Constructs a new BulkGrainBagUpdateResponse.
         * @memberof pond
         * @classdesc Represents a BulkGrainBagUpdateResponse.
         * @implements IBulkGrainBagUpdateResponse
         * @constructor
         * @param {pond.IBulkGrainBagUpdateResponse=} [properties] Properties to set
         */
        function BulkGrainBagUpdateResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BulkGrainBagUpdateResponse successfull.
         * @member {number} successfull
         * @memberof pond.BulkGrainBagUpdateResponse
         * @instance
         */
        BulkGrainBagUpdateResponse.prototype.successfull = 0;

        /**
         * Creates a new BulkGrainBagUpdateResponse instance using the specified properties.
         * @function create
         * @memberof pond.BulkGrainBagUpdateResponse
         * @static
         * @param {pond.IBulkGrainBagUpdateResponse=} [properties] Properties to set
         * @returns {pond.BulkGrainBagUpdateResponse} BulkGrainBagUpdateResponse instance
         */
        BulkGrainBagUpdateResponse.create = function create(properties) {
            return new BulkGrainBagUpdateResponse(properties);
        };

        /**
         * Creates a BulkGrainBagUpdateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.BulkGrainBagUpdateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.BulkGrainBagUpdateResponse} BulkGrainBagUpdateResponse
         */
        BulkGrainBagUpdateResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.BulkGrainBagUpdateResponse)
                return object;
            var message = new $root.pond.BulkGrainBagUpdateResponse();
            if (object.successfull != null)
                message.successfull = object.successfull | 0;
            return message;
        };

        /**
         * Creates a plain object from a BulkGrainBagUpdateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.BulkGrainBagUpdateResponse
         * @static
         * @param {pond.BulkGrainBagUpdateResponse} message BulkGrainBagUpdateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BulkGrainBagUpdateResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.successfull = 0;
            if (message.successfull != null && message.hasOwnProperty("successfull"))
                object.successfull = message.successfull;
            return object;
        };

        /**
         * Converts this BulkGrainBagUpdateResponse to JSON.
         * @function toJSON
         * @memberof pond.BulkGrainBagUpdateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BulkGrainBagUpdateResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BulkGrainBagUpdateResponse;
    })();

    /**
     * DataOption enum.
     * @name pond.DataOption
     * @enum {string}
     * @property {number} DATA_OPTION_UNKNOWN=0 DATA_OPTION_UNKNOWN value
     * @property {number} DATA_OPTION_FIELDS=1 DATA_OPTION_FIELDS value
     * @property {number} DATA_OPTION_FLAGS=2 DATA_OPTION_FLAGS value
     * @property {number} DATA_OPTION_MACHINES=3 DATA_OPTION_MACHINES value
     * @property {number} DATA_OPTION_IMPLEMENTS=4 DATA_OPTION_IMPLEMENTS value
     * @property {number} DATA_OPTION_MAINTENENCE=5 DATA_OPTION_MAINTENENCE value
     * @property {number} DATA_OPTION_CHEMICALS=6 DATA_OPTION_CHEMICALS value
     * @property {number} DATA_OPTION_VARIETIES=7 DATA_OPTION_VARIETIES value
     * @property {number} DATA_OPTION_FERTILIZER=8 DATA_OPTION_FERTILIZER value
     * @property {number} DATA_OPTION_STAFF=9 DATA_OPTION_STAFF value
     * @property {number} DATA_OPTION_FILES=10 DATA_OPTION_FILES value
     * @property {number} DATA_OPTION_TASKS=11 DATA_OPTION_TASKS value
     * @property {number} DATA_OPTION_ASSETS=12 DATA_OPTION_ASSETS value
     * @property {number} DATA_OPTION_OPERATORS=13 DATA_OPTION_OPERATORS value
     * @property {number} DATA_OPTION_CLIENTS=14 DATA_OPTION_CLIENTS value
     * @property {number} DATA_OPTION_NOTIFICATIONS=15 DATA_OPTION_NOTIFICATIONS value
     */
    pond.DataOption = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DATA_OPTION_UNKNOWN"] = 0;
        values[valuesById[1] = "DATA_OPTION_FIELDS"] = 1;
        values[valuesById[2] = "DATA_OPTION_FLAGS"] = 2;
        values[valuesById[3] = "DATA_OPTION_MACHINES"] = 3;
        values[valuesById[4] = "DATA_OPTION_IMPLEMENTS"] = 4;
        values[valuesById[5] = "DATA_OPTION_MAINTENENCE"] = 5;
        values[valuesById[6] = "DATA_OPTION_CHEMICALS"] = 6;
        values[valuesById[7] = "DATA_OPTION_VARIETIES"] = 7;
        values[valuesById[8] = "DATA_OPTION_FERTILIZER"] = 8;
        values[valuesById[9] = "DATA_OPTION_STAFF"] = 9;
        values[valuesById[10] = "DATA_OPTION_FILES"] = 10;
        values[valuesById[11] = "DATA_OPTION_TASKS"] = 11;
        values[valuesById[12] = "DATA_OPTION_ASSETS"] = 12;
        values[valuesById[13] = "DATA_OPTION_OPERATORS"] = 13;
        values[valuesById[14] = "DATA_OPTION_CLIENTS"] = 14;
        values[valuesById[15] = "DATA_OPTION_NOTIFICATIONS"] = 15;
        return values;
    })();

    pond.JDAccount = (function() {

        /**
         * Properties of a JDAccount.
         * @memberof pond
         * @interface IJDAccount
         * @property {string|null} [key] JDAccount key
         * @property {string|null} [username] JDAccount username
         * @property {Array.<pond.DataOption>|null} [options] JDAccount options
         * @property {string|null} [refreshToken] JDAccount refreshToken
         */

        /**
         * Constructs a new JDAccount.
         * @memberof pond
         * @classdesc Represents a JDAccount.
         * @implements IJDAccount
         * @constructor
         * @param {pond.IJDAccount=} [properties] Properties to set
         */
        function JDAccount(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * JDAccount key.
         * @member {string} key
         * @memberof pond.JDAccount
         * @instance
         */
        JDAccount.prototype.key = "";

        /**
         * JDAccount username.
         * @member {string} username
         * @memberof pond.JDAccount
         * @instance
         */
        JDAccount.prototype.username = "";

        /**
         * JDAccount options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.JDAccount
         * @instance
         */
        JDAccount.prototype.options = $util.emptyArray;

        /**
         * JDAccount refreshToken.
         * @member {string} refreshToken
         * @memberof pond.JDAccount
         * @instance
         */
        JDAccount.prototype.refreshToken = "";

        /**
         * Creates a new JDAccount instance using the specified properties.
         * @function create
         * @memberof pond.JDAccount
         * @static
         * @param {pond.IJDAccount=} [properties] Properties to set
         * @returns {pond.JDAccount} JDAccount instance
         */
        JDAccount.create = function create(properties) {
            return new JDAccount(properties);
        };

        /**
         * Creates a JDAccount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.JDAccount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.JDAccount} JDAccount
         */
        JDAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.JDAccount)
                return object;
            var message = new $root.pond.JDAccount();
            if (object.key != null)
                message.key = String(object.key);
            if (object.username != null)
                message.username = String(object.username);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.JDAccount.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            if (object.refreshToken != null)
                message.refreshToken = String(object.refreshToken);
            return message;
        };

        /**
         * Creates a plain object from a JDAccount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.JDAccount
         * @static
         * @param {pond.JDAccount} message JDAccount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JDAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults) {
                object.key = "";
                object.username = "";
                object.refreshToken = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                object.refreshToken = message.refreshToken;
            return object;
        };

        /**
         * Converts this JDAccount to JSON.
         * @function toJSON
         * @memberof pond.JDAccount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JDAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JDAccount;
    })();

    pond.AddJDAccountRequest = (function() {

        /**
         * Properties of an AddJDAccountRequest.
         * @memberof pond
         * @interface IAddJDAccountRequest
         * @property {string|null} [userId] AddJDAccountRequest userId
         * @property {string|null} [teamKey] AddJDAccountRequest teamKey
         * @property {string|null} [code] AddJDAccountRequest code
         * @property {string|null} [jdUsername] AddJDAccountRequest jdUsername
         * @property {Array.<pond.DataOption>|null} [options] AddJDAccountRequest options
         */

        /**
         * Constructs a new AddJDAccountRequest.
         * @memberof pond
         * @classdesc Represents an AddJDAccountRequest.
         * @implements IAddJDAccountRequest
         * @constructor
         * @param {pond.IAddJDAccountRequest=} [properties] Properties to set
         */
        function AddJDAccountRequest(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddJDAccountRequest userId.
         * @member {string} userId
         * @memberof pond.AddJDAccountRequest
         * @instance
         */
        AddJDAccountRequest.prototype.userId = "";

        /**
         * AddJDAccountRequest teamKey.
         * @member {string} teamKey
         * @memberof pond.AddJDAccountRequest
         * @instance
         */
        AddJDAccountRequest.prototype.teamKey = "";

        /**
         * AddJDAccountRequest code.
         * @member {string} code
         * @memberof pond.AddJDAccountRequest
         * @instance
         */
        AddJDAccountRequest.prototype.code = "";

        /**
         * AddJDAccountRequest jdUsername.
         * @member {string} jdUsername
         * @memberof pond.AddJDAccountRequest
         * @instance
         */
        AddJDAccountRequest.prototype.jdUsername = "";

        /**
         * AddJDAccountRequest options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.AddJDAccountRequest
         * @instance
         */
        AddJDAccountRequest.prototype.options = $util.emptyArray;

        /**
         * Creates a new AddJDAccountRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddJDAccountRequest
         * @static
         * @param {pond.IAddJDAccountRequest=} [properties] Properties to set
         * @returns {pond.AddJDAccountRequest} AddJDAccountRequest instance
         */
        AddJDAccountRequest.create = function create(properties) {
            return new AddJDAccountRequest(properties);
        };

        /**
         * Creates an AddJDAccountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddJDAccountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddJDAccountRequest} AddJDAccountRequest
         */
        AddJDAccountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddJDAccountRequest)
                return object;
            var message = new $root.pond.AddJDAccountRequest();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.teamKey != null)
                message.teamKey = String(object.teamKey);
            if (object.code != null)
                message.code = String(object.code);
            if (object.jdUsername != null)
                message.jdUsername = String(object.jdUsername);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.AddJDAccountRequest.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an AddJDAccountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddJDAccountRequest
         * @static
         * @param {pond.AddJDAccountRequest} message AddJDAccountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddJDAccountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults) {
                object.userId = "";
                object.teamKey = "";
                object.code = "";
                object.jdUsername = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.teamKey != null && message.hasOwnProperty("teamKey"))
                object.teamKey = message.teamKey;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.jdUsername != null && message.hasOwnProperty("jdUsername"))
                object.jdUsername = message.jdUsername;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            return object;
        };

        /**
         * Converts this AddJDAccountRequest to JSON.
         * @function toJSON
         * @memberof pond.AddJDAccountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddJDAccountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddJDAccountRequest;
    })();

    pond.AddJDAccountResponse = (function() {

        /**
         * Properties of an AddJDAccountResponse.
         * @memberof pond
         * @interface IAddJDAccountResponse
         * @property {boolean|null} [success] AddJDAccountResponse success
         */

        /**
         * Constructs a new AddJDAccountResponse.
         * @memberof pond
         * @classdesc Represents an AddJDAccountResponse.
         * @implements IAddJDAccountResponse
         * @constructor
         * @param {pond.IAddJDAccountResponse=} [properties] Properties to set
         */
        function AddJDAccountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddJDAccountResponse success.
         * @member {boolean} success
         * @memberof pond.AddJDAccountResponse
         * @instance
         */
        AddJDAccountResponse.prototype.success = false;

        /**
         * Creates a new AddJDAccountResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddJDAccountResponse
         * @static
         * @param {pond.IAddJDAccountResponse=} [properties] Properties to set
         * @returns {pond.AddJDAccountResponse} AddJDAccountResponse instance
         */
        AddJDAccountResponse.create = function create(properties) {
            return new AddJDAccountResponse(properties);
        };

        /**
         * Creates an AddJDAccountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddJDAccountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddJDAccountResponse} AddJDAccountResponse
         */
        AddJDAccountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddJDAccountResponse)
                return object;
            var message = new $root.pond.AddJDAccountResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an AddJDAccountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddJDAccountResponse
         * @static
         * @param {pond.AddJDAccountResponse} message AddJDAccountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddJDAccountResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this AddJDAccountResponse to JSON.
         * @function toJSON
         * @memberof pond.AddJDAccountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddJDAccountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddJDAccountResponse;
    })();

    pond.ListJDAccountsRequest = (function() {

        /**
         * Properties of a ListJDAccountsRequest.
         * @memberof pond
         * @interface IListJDAccountsRequest
         * @property {pond.Paging|null} [paging] ListJDAccountsRequest paging
         * @property {pond.Sorting|null} [sorting] ListJDAccountsRequest sorting
         * @property {string|null} [search] ListJDAccountsRequest search
         */

        /**
         * Constructs a new ListJDAccountsRequest.
         * @memberof pond
         * @classdesc Represents a ListJDAccountsRequest.
         * @implements IListJDAccountsRequest
         * @constructor
         * @param {pond.IListJDAccountsRequest=} [properties] Properties to set
         */
        function ListJDAccountsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListJDAccountsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListJDAccountsRequest
         * @instance
         */
        ListJDAccountsRequest.prototype.paging = null;

        /**
         * ListJDAccountsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListJDAccountsRequest
         * @instance
         */
        ListJDAccountsRequest.prototype.sorting = null;

        /**
         * ListJDAccountsRequest search.
         * @member {string} search
         * @memberof pond.ListJDAccountsRequest
         * @instance
         */
        ListJDAccountsRequest.prototype.search = "";

        /**
         * Creates a new ListJDAccountsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListJDAccountsRequest
         * @static
         * @param {pond.IListJDAccountsRequest=} [properties] Properties to set
         * @returns {pond.ListJDAccountsRequest} ListJDAccountsRequest instance
         */
        ListJDAccountsRequest.create = function create(properties) {
            return new ListJDAccountsRequest(properties);
        };

        /**
         * Creates a ListJDAccountsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListJDAccountsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListJDAccountsRequest} ListJDAccountsRequest
         */
        ListJDAccountsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListJDAccountsRequest)
                return object;
            var message = new $root.pond.ListJDAccountsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListJDAccountsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListJDAccountsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListJDAccountsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListJDAccountsRequest
         * @static
         * @param {pond.ListJDAccountsRequest} message ListJDAccountsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListJDAccountsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListJDAccountsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListJDAccountsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListJDAccountsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListJDAccountsRequest;
    })();

    pond.ListJDAccountsResponse = (function() {

        /**
         * Properties of a ListJDAccountsResponse.
         * @memberof pond
         * @interface IListJDAccountsResponse
         * @property {Array.<pond.JDAccount>|null} [accounts] ListJDAccountsResponse accounts
         * @property {number|null} [nextOffset] ListJDAccountsResponse nextOffset
         * @property {number|null} [total] ListJDAccountsResponse total
         */

        /**
         * Constructs a new ListJDAccountsResponse.
         * @memberof pond
         * @classdesc Represents a ListJDAccountsResponse.
         * @implements IListJDAccountsResponse
         * @constructor
         * @param {pond.IListJDAccountsResponse=} [properties] Properties to set
         */
        function ListJDAccountsResponse(properties) {
            this.accounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListJDAccountsResponse accounts.
         * @member {Array.<pond.JDAccount>} accounts
         * @memberof pond.ListJDAccountsResponse
         * @instance
         */
        ListJDAccountsResponse.prototype.accounts = $util.emptyArray;

        /**
         * ListJDAccountsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListJDAccountsResponse
         * @instance
         */
        ListJDAccountsResponse.prototype.nextOffset = 0;

        /**
         * ListJDAccountsResponse total.
         * @member {number} total
         * @memberof pond.ListJDAccountsResponse
         * @instance
         */
        ListJDAccountsResponse.prototype.total = 0;

        /**
         * Creates a new ListJDAccountsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListJDAccountsResponse
         * @static
         * @param {pond.IListJDAccountsResponse=} [properties] Properties to set
         * @returns {pond.ListJDAccountsResponse} ListJDAccountsResponse instance
         */
        ListJDAccountsResponse.create = function create(properties) {
            return new ListJDAccountsResponse(properties);
        };

        /**
         * Creates a ListJDAccountsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListJDAccountsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListJDAccountsResponse} ListJDAccountsResponse
         */
        ListJDAccountsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListJDAccountsResponse)
                return object;
            var message = new $root.pond.ListJDAccountsResponse();
            if (object.accounts) {
                if (!Array.isArray(object.accounts))
                    throw TypeError(".pond.ListJDAccountsResponse.accounts: array expected");
                message.accounts = [];
                for (var i = 0; i < object.accounts.length; ++i) {
                    if (typeof object.accounts[i] !== "object")
                        throw TypeError(".pond.ListJDAccountsResponse.accounts: object expected");
                    message.accounts[i] = $root.pond.JDAccount.fromObject(object.accounts[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListJDAccountsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListJDAccountsResponse
         * @static
         * @param {pond.ListJDAccountsResponse} message ListJDAccountsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListJDAccountsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.accounts = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.accounts && message.accounts.length) {
                object.accounts = [];
                for (var j = 0; j < message.accounts.length; ++j)
                    object.accounts[j] = $root.pond.JDAccount.toObject(message.accounts[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListJDAccountsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListJDAccountsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListJDAccountsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListJDAccountsResponse;
    })();

    pond.ListJDFieldsRequest = (function() {

        /**
         * Properties of a ListJDFieldsRequest.
         * @memberof pond
         * @interface IListJDFieldsRequest
         * @property {pond.Paging|null} [paging] ListJDFieldsRequest paging
         * @property {pond.Sorting|null} [sorting] ListJDFieldsRequest sorting
         * @property {string|null} [search] ListJDFieldsRequest search
         */

        /**
         * Constructs a new ListJDFieldsRequest.
         * @memberof pond
         * @classdesc Represents a ListJDFieldsRequest.
         * @implements IListJDFieldsRequest
         * @constructor
         * @param {pond.IListJDFieldsRequest=} [properties] Properties to set
         */
        function ListJDFieldsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListJDFieldsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListJDFieldsRequest
         * @instance
         */
        ListJDFieldsRequest.prototype.paging = null;

        /**
         * ListJDFieldsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListJDFieldsRequest
         * @instance
         */
        ListJDFieldsRequest.prototype.sorting = null;

        /**
         * ListJDFieldsRequest search.
         * @member {string} search
         * @memberof pond.ListJDFieldsRequest
         * @instance
         */
        ListJDFieldsRequest.prototype.search = "";

        /**
         * Creates a new ListJDFieldsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListJDFieldsRequest
         * @static
         * @param {pond.IListJDFieldsRequest=} [properties] Properties to set
         * @returns {pond.ListJDFieldsRequest} ListJDFieldsRequest instance
         */
        ListJDFieldsRequest.create = function create(properties) {
            return new ListJDFieldsRequest(properties);
        };

        /**
         * Creates a ListJDFieldsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListJDFieldsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListJDFieldsRequest} ListJDFieldsRequest
         */
        ListJDFieldsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListJDFieldsRequest)
                return object;
            var message = new $root.pond.ListJDFieldsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListJDFieldsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListJDFieldsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListJDFieldsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListJDFieldsRequest
         * @static
         * @param {pond.ListJDFieldsRequest} message ListJDFieldsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListJDFieldsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListJDFieldsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListJDFieldsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListJDFieldsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListJDFieldsRequest;
    })();

    pond.ListJDFieldsResponse = (function() {

        /**
         * Properties of a ListJDFieldsResponse.
         * @memberof pond
         * @interface IListJDFieldsResponse
         * @property {Array.<pond.Field>|null} [fields] ListJDFieldsResponse fields
         * @property {number|null} [nextOffset] ListJDFieldsResponse nextOffset
         * @property {number|null} [total] ListJDFieldsResponse total
         */

        /**
         * Constructs a new ListJDFieldsResponse.
         * @memberof pond
         * @classdesc Represents a ListJDFieldsResponse.
         * @implements IListJDFieldsResponse
         * @constructor
         * @param {pond.IListJDFieldsResponse=} [properties] Properties to set
         */
        function ListJDFieldsResponse(properties) {
            this.fields = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListJDFieldsResponse fields.
         * @member {Array.<pond.Field>} fields
         * @memberof pond.ListJDFieldsResponse
         * @instance
         */
        ListJDFieldsResponse.prototype.fields = $util.emptyArray;

        /**
         * ListJDFieldsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListJDFieldsResponse
         * @instance
         */
        ListJDFieldsResponse.prototype.nextOffset = 0;

        /**
         * ListJDFieldsResponse total.
         * @member {number} total
         * @memberof pond.ListJDFieldsResponse
         * @instance
         */
        ListJDFieldsResponse.prototype.total = 0;

        /**
         * Creates a new ListJDFieldsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListJDFieldsResponse
         * @static
         * @param {pond.IListJDFieldsResponse=} [properties] Properties to set
         * @returns {pond.ListJDFieldsResponse} ListJDFieldsResponse instance
         */
        ListJDFieldsResponse.create = function create(properties) {
            return new ListJDFieldsResponse(properties);
        };

        /**
         * Creates a ListJDFieldsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListJDFieldsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListJDFieldsResponse} ListJDFieldsResponse
         */
        ListJDFieldsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListJDFieldsResponse)
                return object;
            var message = new $root.pond.ListJDFieldsResponse();
            if (object.fields) {
                if (!Array.isArray(object.fields))
                    throw TypeError(".pond.ListJDFieldsResponse.fields: array expected");
                message.fields = [];
                for (var i = 0; i < object.fields.length; ++i) {
                    if (typeof object.fields[i] !== "object")
                        throw TypeError(".pond.ListJDFieldsResponse.fields: object expected");
                    message.fields[i] = $root.pond.Field.fromObject(object.fields[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListJDFieldsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListJDFieldsResponse
         * @static
         * @param {pond.ListJDFieldsResponse} message ListJDFieldsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListJDFieldsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fields = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.fields && message.fields.length) {
                object.fields = [];
                for (var j = 0; j < message.fields.length; ++j)
                    object.fields[j] = $root.pond.Field.toObject(message.fields[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListJDFieldsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListJDFieldsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListJDFieldsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListJDFieldsResponse;
    })();

    pond.UpdateJDAccountRequest = (function() {

        /**
         * Properties of an UpdateJDAccountRequest.
         * @memberof pond
         * @interface IUpdateJDAccountRequest
         * @property {string|null} [key] UpdateJDAccountRequest key
         * @property {Array.<pond.DataOption>|null} [options] UpdateJDAccountRequest options
         */

        /**
         * Constructs a new UpdateJDAccountRequest.
         * @memberof pond
         * @classdesc Represents an UpdateJDAccountRequest.
         * @implements IUpdateJDAccountRequest
         * @constructor
         * @param {pond.IUpdateJDAccountRequest=} [properties] Properties to set
         */
        function UpdateJDAccountRequest(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateJDAccountRequest key.
         * @member {string} key
         * @memberof pond.UpdateJDAccountRequest
         * @instance
         */
        UpdateJDAccountRequest.prototype.key = "";

        /**
         * UpdateJDAccountRequest options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.UpdateJDAccountRequest
         * @instance
         */
        UpdateJDAccountRequest.prototype.options = $util.emptyArray;

        /**
         * Creates a new UpdateJDAccountRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateJDAccountRequest
         * @static
         * @param {pond.IUpdateJDAccountRequest=} [properties] Properties to set
         * @returns {pond.UpdateJDAccountRequest} UpdateJDAccountRequest instance
         */
        UpdateJDAccountRequest.create = function create(properties) {
            return new UpdateJDAccountRequest(properties);
        };

        /**
         * Creates an UpdateJDAccountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateJDAccountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateJDAccountRequest} UpdateJDAccountRequest
         */
        UpdateJDAccountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateJDAccountRequest)
                return object;
            var message = new $root.pond.UpdateJDAccountRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.UpdateJDAccountRequest.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateJDAccountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateJDAccountRequest
         * @static
         * @param {pond.UpdateJDAccountRequest} message UpdateJDAccountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateJDAccountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            return object;
        };

        /**
         * Converts this UpdateJDAccountRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateJDAccountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateJDAccountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateJDAccountRequest;
    })();

    pond.UpdateJDAccountResponse = (function() {

        /**
         * Properties of an UpdateJDAccountResponse.
         * @memberof pond
         * @interface IUpdateJDAccountResponse
         */

        /**
         * Constructs a new UpdateJDAccountResponse.
         * @memberof pond
         * @classdesc Represents an UpdateJDAccountResponse.
         * @implements IUpdateJDAccountResponse
         * @constructor
         * @param {pond.IUpdateJDAccountResponse=} [properties] Properties to set
         */
        function UpdateJDAccountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateJDAccountResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateJDAccountResponse
         * @static
         * @param {pond.IUpdateJDAccountResponse=} [properties] Properties to set
         * @returns {pond.UpdateJDAccountResponse} UpdateJDAccountResponse instance
         */
        UpdateJDAccountResponse.create = function create(properties) {
            return new UpdateJDAccountResponse(properties);
        };

        /**
         * Creates an UpdateJDAccountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateJDAccountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateJDAccountResponse} UpdateJDAccountResponse
         */
        UpdateJDAccountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateJDAccountResponse)
                return object;
            return new $root.pond.UpdateJDAccountResponse();
        };

        /**
         * Creates a plain object from an UpdateJDAccountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateJDAccountResponse
         * @static
         * @param {pond.UpdateJDAccountResponse} message UpdateJDAccountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateJDAccountResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateJDAccountResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateJDAccountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateJDAccountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateJDAccountResponse;
    })();

    pond.CNHiAccount = (function() {

        /**
         * Properties of a CNHiAccount.
         * @memberof pond
         * @interface ICNHiAccount
         * @property {string|null} [key] CNHiAccount key
         * @property {string|null} [username] CNHiAccount username
         * @property {Array.<pond.DataOption>|null} [options] CNHiAccount options
         * @property {string|null} [refreshToken] CNHiAccount refreshToken
         */

        /**
         * Constructs a new CNHiAccount.
         * @memberof pond
         * @classdesc Represents a CNHiAccount.
         * @implements ICNHiAccount
         * @constructor
         * @param {pond.ICNHiAccount=} [properties] Properties to set
         */
        function CNHiAccount(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CNHiAccount key.
         * @member {string} key
         * @memberof pond.CNHiAccount
         * @instance
         */
        CNHiAccount.prototype.key = "";

        /**
         * CNHiAccount username.
         * @member {string} username
         * @memberof pond.CNHiAccount
         * @instance
         */
        CNHiAccount.prototype.username = "";

        /**
         * CNHiAccount options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.CNHiAccount
         * @instance
         */
        CNHiAccount.prototype.options = $util.emptyArray;

        /**
         * CNHiAccount refreshToken.
         * @member {string} refreshToken
         * @memberof pond.CNHiAccount
         * @instance
         */
        CNHiAccount.prototype.refreshToken = "";

        /**
         * Creates a new CNHiAccount instance using the specified properties.
         * @function create
         * @memberof pond.CNHiAccount
         * @static
         * @param {pond.ICNHiAccount=} [properties] Properties to set
         * @returns {pond.CNHiAccount} CNHiAccount instance
         */
        CNHiAccount.create = function create(properties) {
            return new CNHiAccount(properties);
        };

        /**
         * Creates a CNHiAccount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.CNHiAccount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.CNHiAccount} CNHiAccount
         */
        CNHiAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.CNHiAccount)
                return object;
            var message = new $root.pond.CNHiAccount();
            if (object.key != null)
                message.key = String(object.key);
            if (object.username != null)
                message.username = String(object.username);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.CNHiAccount.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            if (object.refreshToken != null)
                message.refreshToken = String(object.refreshToken);
            return message;
        };

        /**
         * Creates a plain object from a CNHiAccount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.CNHiAccount
         * @static
         * @param {pond.CNHiAccount} message CNHiAccount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CNHiAccount.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults) {
                object.key = "";
                object.username = "";
                object.refreshToken = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                object.refreshToken = message.refreshToken;
            return object;
        };

        /**
         * Converts this CNHiAccount to JSON.
         * @function toJSON
         * @memberof pond.CNHiAccount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CNHiAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CNHiAccount;
    })();

    pond.AddCNHiAccountRequest = (function() {

        /**
         * Properties of an AddCNHiAccountRequest.
         * @memberof pond
         * @interface IAddCNHiAccountRequest
         * @property {string|null} [userId] AddCNHiAccountRequest userId
         * @property {string|null} [teamKey] AddCNHiAccountRequest teamKey
         * @property {string|null} [code] AddCNHiAccountRequest code
         * @property {string|null} [cnhiUsername] AddCNHiAccountRequest cnhiUsername
         * @property {Array.<pond.DataOption>|null} [options] AddCNHiAccountRequest options
         */

        /**
         * Constructs a new AddCNHiAccountRequest.
         * @memberof pond
         * @classdesc Represents an AddCNHiAccountRequest.
         * @implements IAddCNHiAccountRequest
         * @constructor
         * @param {pond.IAddCNHiAccountRequest=} [properties] Properties to set
         */
        function AddCNHiAccountRequest(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddCNHiAccountRequest userId.
         * @member {string} userId
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         */
        AddCNHiAccountRequest.prototype.userId = "";

        /**
         * AddCNHiAccountRequest teamKey.
         * @member {string} teamKey
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         */
        AddCNHiAccountRequest.prototype.teamKey = "";

        /**
         * AddCNHiAccountRequest code.
         * @member {string} code
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         */
        AddCNHiAccountRequest.prototype.code = "";

        /**
         * AddCNHiAccountRequest cnhiUsername.
         * @member {string} cnhiUsername
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         */
        AddCNHiAccountRequest.prototype.cnhiUsername = "";

        /**
         * AddCNHiAccountRequest options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         */
        AddCNHiAccountRequest.prototype.options = $util.emptyArray;

        /**
         * Creates a new AddCNHiAccountRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddCNHiAccountRequest
         * @static
         * @param {pond.IAddCNHiAccountRequest=} [properties] Properties to set
         * @returns {pond.AddCNHiAccountRequest} AddCNHiAccountRequest instance
         */
        AddCNHiAccountRequest.create = function create(properties) {
            return new AddCNHiAccountRequest(properties);
        };

        /**
         * Creates an AddCNHiAccountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddCNHiAccountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddCNHiAccountRequest} AddCNHiAccountRequest
         */
        AddCNHiAccountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddCNHiAccountRequest)
                return object;
            var message = new $root.pond.AddCNHiAccountRequest();
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.teamKey != null)
                message.teamKey = String(object.teamKey);
            if (object.code != null)
                message.code = String(object.code);
            if (object.cnhiUsername != null)
                message.cnhiUsername = String(object.cnhiUsername);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.AddCNHiAccountRequest.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an AddCNHiAccountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddCNHiAccountRequest
         * @static
         * @param {pond.AddCNHiAccountRequest} message AddCNHiAccountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddCNHiAccountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults) {
                object.userId = "";
                object.teamKey = "";
                object.code = "";
                object.cnhiUsername = "";
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.teamKey != null && message.hasOwnProperty("teamKey"))
                object.teamKey = message.teamKey;
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.cnhiUsername != null && message.hasOwnProperty("cnhiUsername"))
                object.cnhiUsername = message.cnhiUsername;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            return object;
        };

        /**
         * Converts this AddCNHiAccountRequest to JSON.
         * @function toJSON
         * @memberof pond.AddCNHiAccountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddCNHiAccountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddCNHiAccountRequest;
    })();

    pond.AddCNHiAccountResponse = (function() {

        /**
         * Properties of an AddCNHiAccountResponse.
         * @memberof pond
         * @interface IAddCNHiAccountResponse
         * @property {boolean|null} [success] AddCNHiAccountResponse success
         */

        /**
         * Constructs a new AddCNHiAccountResponse.
         * @memberof pond
         * @classdesc Represents an AddCNHiAccountResponse.
         * @implements IAddCNHiAccountResponse
         * @constructor
         * @param {pond.IAddCNHiAccountResponse=} [properties] Properties to set
         */
        function AddCNHiAccountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddCNHiAccountResponse success.
         * @member {boolean} success
         * @memberof pond.AddCNHiAccountResponse
         * @instance
         */
        AddCNHiAccountResponse.prototype.success = false;

        /**
         * Creates a new AddCNHiAccountResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddCNHiAccountResponse
         * @static
         * @param {pond.IAddCNHiAccountResponse=} [properties] Properties to set
         * @returns {pond.AddCNHiAccountResponse} AddCNHiAccountResponse instance
         */
        AddCNHiAccountResponse.create = function create(properties) {
            return new AddCNHiAccountResponse(properties);
        };

        /**
         * Creates an AddCNHiAccountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddCNHiAccountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddCNHiAccountResponse} AddCNHiAccountResponse
         */
        AddCNHiAccountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddCNHiAccountResponse)
                return object;
            var message = new $root.pond.AddCNHiAccountResponse();
            if (object.success != null)
                message.success = Boolean(object.success);
            return message;
        };

        /**
         * Creates a plain object from an AddCNHiAccountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddCNHiAccountResponse
         * @static
         * @param {pond.AddCNHiAccountResponse} message AddCNHiAccountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddCNHiAccountResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.success = false;
            if (message.success != null && message.hasOwnProperty("success"))
                object.success = message.success;
            return object;
        };

        /**
         * Converts this AddCNHiAccountResponse to JSON.
         * @function toJSON
         * @memberof pond.AddCNHiAccountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddCNHiAccountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddCNHiAccountResponse;
    })();

    pond.ListCNHiAccountsRequest = (function() {

        /**
         * Properties of a ListCNHiAccountsRequest.
         * @memberof pond
         * @interface IListCNHiAccountsRequest
         * @property {pond.Paging|null} [paging] ListCNHiAccountsRequest paging
         * @property {pond.Sorting|null} [sorting] ListCNHiAccountsRequest sorting
         * @property {string|null} [search] ListCNHiAccountsRequest search
         */

        /**
         * Constructs a new ListCNHiAccountsRequest.
         * @memberof pond
         * @classdesc Represents a ListCNHiAccountsRequest.
         * @implements IListCNHiAccountsRequest
         * @constructor
         * @param {pond.IListCNHiAccountsRequest=} [properties] Properties to set
         */
        function ListCNHiAccountsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCNHiAccountsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListCNHiAccountsRequest
         * @instance
         */
        ListCNHiAccountsRequest.prototype.paging = null;

        /**
         * ListCNHiAccountsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListCNHiAccountsRequest
         * @instance
         */
        ListCNHiAccountsRequest.prototype.sorting = null;

        /**
         * ListCNHiAccountsRequest search.
         * @member {string} search
         * @memberof pond.ListCNHiAccountsRequest
         * @instance
         */
        ListCNHiAccountsRequest.prototype.search = "";

        /**
         * Creates a new ListCNHiAccountsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListCNHiAccountsRequest
         * @static
         * @param {pond.IListCNHiAccountsRequest=} [properties] Properties to set
         * @returns {pond.ListCNHiAccountsRequest} ListCNHiAccountsRequest instance
         */
        ListCNHiAccountsRequest.create = function create(properties) {
            return new ListCNHiAccountsRequest(properties);
        };

        /**
         * Creates a ListCNHiAccountsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCNHiAccountsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCNHiAccountsRequest} ListCNHiAccountsRequest
         */
        ListCNHiAccountsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCNHiAccountsRequest)
                return object;
            var message = new $root.pond.ListCNHiAccountsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListCNHiAccountsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListCNHiAccountsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListCNHiAccountsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCNHiAccountsRequest
         * @static
         * @param {pond.ListCNHiAccountsRequest} message ListCNHiAccountsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCNHiAccountsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListCNHiAccountsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListCNHiAccountsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCNHiAccountsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCNHiAccountsRequest;
    })();

    pond.ListCNHiAccountsResponse = (function() {

        /**
         * Properties of a ListCNHiAccountsResponse.
         * @memberof pond
         * @interface IListCNHiAccountsResponse
         * @property {Array.<pond.CNHiAccount>|null} [accounts] ListCNHiAccountsResponse accounts
         * @property {number|null} [nextOffset] ListCNHiAccountsResponse nextOffset
         * @property {number|null} [total] ListCNHiAccountsResponse total
         */

        /**
         * Constructs a new ListCNHiAccountsResponse.
         * @memberof pond
         * @classdesc Represents a ListCNHiAccountsResponse.
         * @implements IListCNHiAccountsResponse
         * @constructor
         * @param {pond.IListCNHiAccountsResponse=} [properties] Properties to set
         */
        function ListCNHiAccountsResponse(properties) {
            this.accounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCNHiAccountsResponse accounts.
         * @member {Array.<pond.CNHiAccount>} accounts
         * @memberof pond.ListCNHiAccountsResponse
         * @instance
         */
        ListCNHiAccountsResponse.prototype.accounts = $util.emptyArray;

        /**
         * ListCNHiAccountsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListCNHiAccountsResponse
         * @instance
         */
        ListCNHiAccountsResponse.prototype.nextOffset = 0;

        /**
         * ListCNHiAccountsResponse total.
         * @member {number} total
         * @memberof pond.ListCNHiAccountsResponse
         * @instance
         */
        ListCNHiAccountsResponse.prototype.total = 0;

        /**
         * Creates a new ListCNHiAccountsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListCNHiAccountsResponse
         * @static
         * @param {pond.IListCNHiAccountsResponse=} [properties] Properties to set
         * @returns {pond.ListCNHiAccountsResponse} ListCNHiAccountsResponse instance
         */
        ListCNHiAccountsResponse.create = function create(properties) {
            return new ListCNHiAccountsResponse(properties);
        };

        /**
         * Creates a ListCNHiAccountsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCNHiAccountsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCNHiAccountsResponse} ListCNHiAccountsResponse
         */
        ListCNHiAccountsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCNHiAccountsResponse)
                return object;
            var message = new $root.pond.ListCNHiAccountsResponse();
            if (object.accounts) {
                if (!Array.isArray(object.accounts))
                    throw TypeError(".pond.ListCNHiAccountsResponse.accounts: array expected");
                message.accounts = [];
                for (var i = 0; i < object.accounts.length; ++i) {
                    if (typeof object.accounts[i] !== "object")
                        throw TypeError(".pond.ListCNHiAccountsResponse.accounts: object expected");
                    message.accounts[i] = $root.pond.CNHiAccount.fromObject(object.accounts[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListCNHiAccountsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCNHiAccountsResponse
         * @static
         * @param {pond.ListCNHiAccountsResponse} message ListCNHiAccountsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCNHiAccountsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.accounts = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.accounts && message.accounts.length) {
                object.accounts = [];
                for (var j = 0; j < message.accounts.length; ++j)
                    object.accounts[j] = $root.pond.CNHiAccount.toObject(message.accounts[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListCNHiAccountsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListCNHiAccountsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCNHiAccountsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCNHiAccountsResponse;
    })();

    pond.UpdateCNHiAccountRequest = (function() {

        /**
         * Properties of an UpdateCNHiAccountRequest.
         * @memberof pond
         * @interface IUpdateCNHiAccountRequest
         * @property {string|null} [key] UpdateCNHiAccountRequest key
         * @property {Array.<pond.DataOption>|null} [options] UpdateCNHiAccountRequest options
         */

        /**
         * Constructs a new UpdateCNHiAccountRequest.
         * @memberof pond
         * @classdesc Represents an UpdateCNHiAccountRequest.
         * @implements IUpdateCNHiAccountRequest
         * @constructor
         * @param {pond.IUpdateCNHiAccountRequest=} [properties] Properties to set
         */
        function UpdateCNHiAccountRequest(properties) {
            this.options = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateCNHiAccountRequest key.
         * @member {string} key
         * @memberof pond.UpdateCNHiAccountRequest
         * @instance
         */
        UpdateCNHiAccountRequest.prototype.key = "";

        /**
         * UpdateCNHiAccountRequest options.
         * @member {Array.<pond.DataOption>} options
         * @memberof pond.UpdateCNHiAccountRequest
         * @instance
         */
        UpdateCNHiAccountRequest.prototype.options = $util.emptyArray;

        /**
         * Creates a new UpdateCNHiAccountRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateCNHiAccountRequest
         * @static
         * @param {pond.IUpdateCNHiAccountRequest=} [properties] Properties to set
         * @returns {pond.UpdateCNHiAccountRequest} UpdateCNHiAccountRequest instance
         */
        UpdateCNHiAccountRequest.create = function create(properties) {
            return new UpdateCNHiAccountRequest(properties);
        };

        /**
         * Creates an UpdateCNHiAccountRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateCNHiAccountRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateCNHiAccountRequest} UpdateCNHiAccountRequest
         */
        UpdateCNHiAccountRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateCNHiAccountRequest)
                return object;
            var message = new $root.pond.UpdateCNHiAccountRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.options) {
                if (!Array.isArray(object.options))
                    throw TypeError(".pond.UpdateCNHiAccountRequest.options: array expected");
                message.options = [];
                for (var i = 0; i < object.options.length; ++i)
                    switch (object.options[i]) {
                    default:
                    case "DATA_OPTION_UNKNOWN":
                    case 0:
                        message.options[i] = 0;
                        break;
                    case "DATA_OPTION_FIELDS":
                    case 1:
                        message.options[i] = 1;
                        break;
                    case "DATA_OPTION_FLAGS":
                    case 2:
                        message.options[i] = 2;
                        break;
                    case "DATA_OPTION_MACHINES":
                    case 3:
                        message.options[i] = 3;
                        break;
                    case "DATA_OPTION_IMPLEMENTS":
                    case 4:
                        message.options[i] = 4;
                        break;
                    case "DATA_OPTION_MAINTENENCE":
                    case 5:
                        message.options[i] = 5;
                        break;
                    case "DATA_OPTION_CHEMICALS":
                    case 6:
                        message.options[i] = 6;
                        break;
                    case "DATA_OPTION_VARIETIES":
                    case 7:
                        message.options[i] = 7;
                        break;
                    case "DATA_OPTION_FERTILIZER":
                    case 8:
                        message.options[i] = 8;
                        break;
                    case "DATA_OPTION_STAFF":
                    case 9:
                        message.options[i] = 9;
                        break;
                    case "DATA_OPTION_FILES":
                    case 10:
                        message.options[i] = 10;
                        break;
                    case "DATA_OPTION_TASKS":
                    case 11:
                        message.options[i] = 11;
                        break;
                    case "DATA_OPTION_ASSETS":
                    case 12:
                        message.options[i] = 12;
                        break;
                    case "DATA_OPTION_OPERATORS":
                    case 13:
                        message.options[i] = 13;
                        break;
                    case "DATA_OPTION_CLIENTS":
                    case 14:
                        message.options[i] = 14;
                        break;
                    case "DATA_OPTION_NOTIFICATIONS":
                    case 15:
                        message.options[i] = 15;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateCNHiAccountRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateCNHiAccountRequest
         * @static
         * @param {pond.UpdateCNHiAccountRequest} message UpdateCNHiAccountRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCNHiAccountRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.options = [];
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.options && message.options.length) {
                object.options = [];
                for (var j = 0; j < message.options.length; ++j)
                    object.options[j] = options.enums === String ? $root.pond.DataOption[message.options[j]] : message.options[j];
            }
            return object;
        };

        /**
         * Converts this UpdateCNHiAccountRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateCNHiAccountRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCNHiAccountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCNHiAccountRequest;
    })();

    pond.UpdateCNHiAccountResponse = (function() {

        /**
         * Properties of an UpdateCNHiAccountResponse.
         * @memberof pond
         * @interface IUpdateCNHiAccountResponse
         */

        /**
         * Constructs a new UpdateCNHiAccountResponse.
         * @memberof pond
         * @classdesc Represents an UpdateCNHiAccountResponse.
         * @implements IUpdateCNHiAccountResponse
         * @constructor
         * @param {pond.IUpdateCNHiAccountResponse=} [properties] Properties to set
         */
        function UpdateCNHiAccountResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateCNHiAccountResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateCNHiAccountResponse
         * @static
         * @param {pond.IUpdateCNHiAccountResponse=} [properties] Properties to set
         * @returns {pond.UpdateCNHiAccountResponse} UpdateCNHiAccountResponse instance
         */
        UpdateCNHiAccountResponse.create = function create(properties) {
            return new UpdateCNHiAccountResponse(properties);
        };

        /**
         * Creates an UpdateCNHiAccountResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateCNHiAccountResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateCNHiAccountResponse} UpdateCNHiAccountResponse
         */
        UpdateCNHiAccountResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateCNHiAccountResponse)
                return object;
            return new $root.pond.UpdateCNHiAccountResponse();
        };

        /**
         * Creates a plain object from an UpdateCNHiAccountResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateCNHiAccountResponse
         * @static
         * @param {pond.UpdateCNHiAccountResponse} message UpdateCNHiAccountResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateCNHiAccountResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateCNHiAccountResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateCNHiAccountResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateCNHiAccountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateCNHiAccountResponse;
    })();

    pond.ListCNHiFieldsRequest = (function() {

        /**
         * Properties of a ListCNHiFieldsRequest.
         * @memberof pond
         * @interface IListCNHiFieldsRequest
         * @property {pond.Paging|null} [paging] ListCNHiFieldsRequest paging
         * @property {pond.Sorting|null} [sorting] ListCNHiFieldsRequest sorting
         * @property {string|null} [search] ListCNHiFieldsRequest search
         */

        /**
         * Constructs a new ListCNHiFieldsRequest.
         * @memberof pond
         * @classdesc Represents a ListCNHiFieldsRequest.
         * @implements IListCNHiFieldsRequest
         * @constructor
         * @param {pond.IListCNHiFieldsRequest=} [properties] Properties to set
         */
        function ListCNHiFieldsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCNHiFieldsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListCNHiFieldsRequest
         * @instance
         */
        ListCNHiFieldsRequest.prototype.paging = null;

        /**
         * ListCNHiFieldsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListCNHiFieldsRequest
         * @instance
         */
        ListCNHiFieldsRequest.prototype.sorting = null;

        /**
         * ListCNHiFieldsRequest search.
         * @member {string} search
         * @memberof pond.ListCNHiFieldsRequest
         * @instance
         */
        ListCNHiFieldsRequest.prototype.search = "";

        /**
         * Creates a new ListCNHiFieldsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListCNHiFieldsRequest
         * @static
         * @param {pond.IListCNHiFieldsRequest=} [properties] Properties to set
         * @returns {pond.ListCNHiFieldsRequest} ListCNHiFieldsRequest instance
         */
        ListCNHiFieldsRequest.create = function create(properties) {
            return new ListCNHiFieldsRequest(properties);
        };

        /**
         * Creates a ListCNHiFieldsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCNHiFieldsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCNHiFieldsRequest} ListCNHiFieldsRequest
         */
        ListCNHiFieldsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCNHiFieldsRequest)
                return object;
            var message = new $root.pond.ListCNHiFieldsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListCNHiFieldsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListCNHiFieldsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListCNHiFieldsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCNHiFieldsRequest
         * @static
         * @param {pond.ListCNHiFieldsRequest} message ListCNHiFieldsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCNHiFieldsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListCNHiFieldsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListCNHiFieldsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCNHiFieldsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCNHiFieldsRequest;
    })();

    pond.ListCNHiFieldsResponse = (function() {

        /**
         * Properties of a ListCNHiFieldsResponse.
         * @memberof pond
         * @interface IListCNHiFieldsResponse
         * @property {Array.<pond.Field>|null} [fields] ListCNHiFieldsResponse fields
         * @property {number|null} [nextOffset] ListCNHiFieldsResponse nextOffset
         * @property {number|null} [total] ListCNHiFieldsResponse total
         */

        /**
         * Constructs a new ListCNHiFieldsResponse.
         * @memberof pond
         * @classdesc Represents a ListCNHiFieldsResponse.
         * @implements IListCNHiFieldsResponse
         * @constructor
         * @param {pond.IListCNHiFieldsResponse=} [properties] Properties to set
         */
        function ListCNHiFieldsResponse(properties) {
            this.fields = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListCNHiFieldsResponse fields.
         * @member {Array.<pond.Field>} fields
         * @memberof pond.ListCNHiFieldsResponse
         * @instance
         */
        ListCNHiFieldsResponse.prototype.fields = $util.emptyArray;

        /**
         * ListCNHiFieldsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListCNHiFieldsResponse
         * @instance
         */
        ListCNHiFieldsResponse.prototype.nextOffset = 0;

        /**
         * ListCNHiFieldsResponse total.
         * @member {number} total
         * @memberof pond.ListCNHiFieldsResponse
         * @instance
         */
        ListCNHiFieldsResponse.prototype.total = 0;

        /**
         * Creates a new ListCNHiFieldsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListCNHiFieldsResponse
         * @static
         * @param {pond.IListCNHiFieldsResponse=} [properties] Properties to set
         * @returns {pond.ListCNHiFieldsResponse} ListCNHiFieldsResponse instance
         */
        ListCNHiFieldsResponse.create = function create(properties) {
            return new ListCNHiFieldsResponse(properties);
        };

        /**
         * Creates a ListCNHiFieldsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListCNHiFieldsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListCNHiFieldsResponse} ListCNHiFieldsResponse
         */
        ListCNHiFieldsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListCNHiFieldsResponse)
                return object;
            var message = new $root.pond.ListCNHiFieldsResponse();
            if (object.fields) {
                if (!Array.isArray(object.fields))
                    throw TypeError(".pond.ListCNHiFieldsResponse.fields: array expected");
                message.fields = [];
                for (var i = 0; i < object.fields.length; ++i) {
                    if (typeof object.fields[i] !== "object")
                        throw TypeError(".pond.ListCNHiFieldsResponse.fields: object expected");
                    message.fields[i] = $root.pond.Field.fromObject(object.fields[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListCNHiFieldsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListCNHiFieldsResponse
         * @static
         * @param {pond.ListCNHiFieldsResponse} message ListCNHiFieldsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListCNHiFieldsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.fields = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.fields && message.fields.length) {
                object.fields = [];
                for (var j = 0; j < message.fields.length; ++j)
                    object.fields[j] = $root.pond.Field.toObject(message.fields[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListCNHiFieldsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListCNHiFieldsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListCNHiFieldsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListCNHiFieldsResponse;
    })();

    pond.LinearMutationRequest = (function() {

        /**
         * Properties of a LinearMutationRequest.
         * @memberof pond
         * @interface ILinearMutationRequest
         * @property {pond.LinearMutation|null} [mutation] LinearMutationRequest mutation
         * @property {string|null} [start] LinearMutationRequest start
         * @property {string|null} [end] LinearMutationRequest end
         */

        /**
         * Constructs a new LinearMutationRequest.
         * @memberof pond
         * @classdesc Represents a LinearMutationRequest.
         * @implements ILinearMutationRequest
         * @constructor
         * @param {pond.ILinearMutationRequest=} [properties] Properties to set
         */
        function LinearMutationRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LinearMutationRequest mutation.
         * @member {pond.LinearMutation|null|undefined} mutation
         * @memberof pond.LinearMutationRequest
         * @instance
         */
        LinearMutationRequest.prototype.mutation = null;

        /**
         * LinearMutationRequest start.
         * @member {string} start
         * @memberof pond.LinearMutationRequest
         * @instance
         */
        LinearMutationRequest.prototype.start = "";

        /**
         * LinearMutationRequest end.
         * @member {string} end
         * @memberof pond.LinearMutationRequest
         * @instance
         */
        LinearMutationRequest.prototype.end = "";

        /**
         * Creates a new LinearMutationRequest instance using the specified properties.
         * @function create
         * @memberof pond.LinearMutationRequest
         * @static
         * @param {pond.ILinearMutationRequest=} [properties] Properties to set
         * @returns {pond.LinearMutationRequest} LinearMutationRequest instance
         */
        LinearMutationRequest.create = function create(properties) {
            return new LinearMutationRequest(properties);
        };

        /**
         * Creates a LinearMutationRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LinearMutationRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LinearMutationRequest} LinearMutationRequest
         */
        LinearMutationRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LinearMutationRequest)
                return object;
            var message = new $root.pond.LinearMutationRequest();
            if (object.mutation != null) {
                if (typeof object.mutation !== "object")
                    throw TypeError(".pond.LinearMutationRequest.mutation: object expected");
                message.mutation = $root.pond.LinearMutation.fromObject(object.mutation);
            }
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from a LinearMutationRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LinearMutationRequest
         * @static
         * @param {pond.LinearMutationRequest} message LinearMutationRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LinearMutationRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.mutation = null;
                object.start = "";
                object.end = "";
            }
            if (message.mutation != null && message.hasOwnProperty("mutation"))
                object.mutation = $root.pond.LinearMutation.toObject(message.mutation, options);
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this LinearMutationRequest to JSON.
         * @function toJSON
         * @memberof pond.LinearMutationRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LinearMutationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LinearMutationRequest;
    })();

    pond.LinearMutationResponse = (function() {

        /**
         * Properties of a LinearMutationResponse.
         * @memberof pond
         * @interface ILinearMutationResponse
         * @property {Array.<pond.ValueAt>|null} [values] LinearMutationResponse values
         * @property {pond.Mutator|null} [mutationType] LinearMutationResponse mutationType
         */

        /**
         * Constructs a new LinearMutationResponse.
         * @memberof pond
         * @classdesc Represents a LinearMutationResponse.
         * @implements ILinearMutationResponse
         * @constructor
         * @param {pond.ILinearMutationResponse=} [properties] Properties to set
         */
        function LinearMutationResponse(properties) {
            this.values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LinearMutationResponse values.
         * @member {Array.<pond.ValueAt>} values
         * @memberof pond.LinearMutationResponse
         * @instance
         */
        LinearMutationResponse.prototype.values = $util.emptyArray;

        /**
         * LinearMutationResponse mutationType.
         * @member {pond.Mutator} mutationType
         * @memberof pond.LinearMutationResponse
         * @instance
         */
        LinearMutationResponse.prototype.mutationType = 0;

        /**
         * Creates a new LinearMutationResponse instance using the specified properties.
         * @function create
         * @memberof pond.LinearMutationResponse
         * @static
         * @param {pond.ILinearMutationResponse=} [properties] Properties to set
         * @returns {pond.LinearMutationResponse} LinearMutationResponse instance
         */
        LinearMutationResponse.create = function create(properties) {
            return new LinearMutationResponse(properties);
        };

        /**
         * Creates a LinearMutationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.LinearMutationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.LinearMutationResponse} LinearMutationResponse
         */
        LinearMutationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.LinearMutationResponse)
                return object;
            var message = new $root.pond.LinearMutationResponse();
            if (object.values) {
                if (!Array.isArray(object.values))
                    throw TypeError(".pond.LinearMutationResponse.values: array expected");
                message.values = [];
                for (var i = 0; i < object.values.length; ++i) {
                    if (typeof object.values[i] !== "object")
                        throw TypeError(".pond.LinearMutationResponse.values: object expected");
                    message.values[i] = $root.pond.ValueAt.fromObject(object.values[i]);
                }
            }
            switch (object.mutationType) {
            case "MUTATOR_NONE":
            case 0:
                message.mutationType = 0;
                break;
            case "MUTATOR_EMC":
            case 1:
                message.mutationType = 1;
                break;
            case "MUTATOR_CFM":
            case 2:
                message.mutationType = 2;
                break;
            case "MUTATOR_FUEL_LEVEL":
            case 3:
                message.mutationType = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a LinearMutationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.LinearMutationResponse
         * @static
         * @param {pond.LinearMutationResponse} message LinearMutationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LinearMutationResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.values = [];
            if (options.defaults)
                object.mutationType = options.enums === String ? "MUTATOR_NONE" : 0;
            if (message.values && message.values.length) {
                object.values = [];
                for (var j = 0; j < message.values.length; ++j)
                    object.values[j] = $root.pond.ValueAt.toObject(message.values[j], options);
            }
            if (message.mutationType != null && message.hasOwnProperty("mutationType"))
                object.mutationType = options.enums === String ? $root.pond.Mutator[message.mutationType] : message.mutationType;
            return object;
        };

        /**
         * Converts this LinearMutationResponse to JSON.
         * @function toJSON
         * @memberof pond.LinearMutationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LinearMutationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LinearMutationResponse;
    })();

    /**
     * GateComponentType enum.
     * @name pond.GateComponentType
     * @enum {string}
     * @property {number} GATE_COMPONENT_TYPE_UNKNOWN=0 GATE_COMPONENT_TYPE_UNKNOWN value
     * @property {number} GATE_COMPONENT_TYPE_TEMP=1 GATE_COMPONENT_TYPE_TEMP value
     * @property {number} GATE_COMPONENT_TYPE_PRESSURE=2 GATE_COMPONENT_TYPE_PRESSURE value
     * @property {number} GATE_COMPONENT_TYPE_AMBIENT=3 GATE_COMPONENT_TYPE_AMBIENT value
     */
    pond.GateComponentType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GATE_COMPONENT_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "GATE_COMPONENT_TYPE_TEMP"] = 1;
        values[valuesById[2] = "GATE_COMPONENT_TYPE_PRESSURE"] = 2;
        values[valuesById[3] = "GATE_COMPONENT_TYPE_AMBIENT"] = 3;
        return values;
    })();

    /**
     * GateDeviceType enum.
     * @name pond.GateDeviceType
     * @enum {string}
     * @property {number} GATE_DEVICE_TYPE_UNKNOWN=0 GATE_DEVICE_TYPE_UNKNOWN value
     * @property {number} GATE_DEVICE_TYPE_PCA=1 GATE_DEVICE_TYPE_PCA value
     */
    pond.GateDeviceType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GATE_DEVICE_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "GATE_DEVICE_TYPE_PCA"] = 1;
        return values;
    })();

    /**
     * DuctType enum.
     * @name pond.DuctType
     * @enum {string}
     * @property {number} DUCT_TYPE_INVALID=0 DUCT_TYPE_INVALID value
     * @property {number} DUCT_TYPE_NONE=1 DUCT_TYPE_NONE value
     * @property {number} DUCT_TYPE_LAYFLAT=2 DUCT_TYPE_LAYFLAT value
     * @property {number} DUCT_TYPE_SPIRAL=3 DUCT_TYPE_SPIRAL value
     * @property {number} DUCT_TYPE_AVROLITE=4 DUCT_TYPE_AVROLITE value
     * @property {number} DUCT_TYPE_AVROTUBE=5 DUCT_TYPE_AVROTUBE value
     */
    pond.DuctType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DUCT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "DUCT_TYPE_NONE"] = 1;
        values[valuesById[2] = "DUCT_TYPE_LAYFLAT"] = 2;
        values[valuesById[3] = "DUCT_TYPE_SPIRAL"] = 3;
        values[valuesById[4] = "DUCT_TYPE_AVROLITE"] = 4;
        values[valuesById[5] = "DUCT_TYPE_AVROTUBE"] = 5;
        return values;
    })();

    pond.Contract = (function() {

        /**
         * Properties of a Contract.
         * @memberof pond
         * @interface IContract
         * @property {string|null} [key] Contract key
         * @property {string|null} [name] Contract name
         * @property {pond.ContractSettings|null} [settings] Contract settings
         */

        /**
         * Constructs a new Contract.
         * @memberof pond
         * @classdesc Represents a Contract.
         * @implements IContract
         * @constructor
         * @param {pond.IContract=} [properties] Properties to set
         */
        function Contract(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Contract key.
         * @member {string} key
         * @memberof pond.Contract
         * @instance
         */
        Contract.prototype.key = "";

        /**
         * Contract name.
         * @member {string} name
         * @memberof pond.Contract
         * @instance
         */
        Contract.prototype.name = "";

        /**
         * Contract settings.
         * @member {pond.ContractSettings|null|undefined} settings
         * @memberof pond.Contract
         * @instance
         */
        Contract.prototype.settings = null;

        /**
         * Creates a new Contract instance using the specified properties.
         * @function create
         * @memberof pond.Contract
         * @static
         * @param {pond.IContract=} [properties] Properties to set
         * @returns {pond.Contract} Contract instance
         */
        Contract.create = function create(properties) {
            return new Contract(properties);
        };

        /**
         * Creates a Contract message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.Contract
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.Contract} Contract
         */
        Contract.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.Contract)
                return object;
            var message = new $root.pond.Contract();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.Contract.settings: object expected");
                message.settings = $root.pond.ContractSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Contract message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.Contract
         * @static
         * @param {pond.Contract} message Contract
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Contract.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ContractSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this Contract to JSON.
         * @function toJSON
         * @memberof pond.Contract
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Contract.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Contract;
    })();

    pond.ContractSettings = (function() {

        /**
         * Properties of a ContractSettings.
         * @memberof pond
         * @interface IContractSettings
         * @property {string|null} [contractId] ContractSettings contractId
         * @property {string|null} [contractHolder] ContractSettings contractHolder
         * @property {pond.ContractDelivery|null} [deliveryWindow] ContractSettings deliveryWindow
         * @property {pond.ContractType|null} [type] ContractSettings type
         * @property {string|null} [customCommodity] ContractSettings customCommodity
         * @property {number|null} [size] ContractSettings size
         * @property {number|null} [delivered] ContractSettings delivered
         * @property {number|null} [totalValue] ContractSettings totalValue
         * @property {number|null} [commodity] ContractSettings commodity
         * @property {string|null} [contractDate] ContractSettings contractDate
         * @property {string|null} [commoditySubtype] ContractSettings commoditySubtype
         * @property {number|null} [conversionValue] ContractSettings conversionValue
         */

        /**
         * Constructs a new ContractSettings.
         * @memberof pond
         * @classdesc Represents a ContractSettings.
         * @implements IContractSettings
         * @constructor
         * @param {pond.IContractSettings=} [properties] Properties to set
         */
        function ContractSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractSettings contractId.
         * @member {string} contractId
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.contractId = "";

        /**
         * ContractSettings contractHolder.
         * @member {string} contractHolder
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.contractHolder = "";

        /**
         * ContractSettings deliveryWindow.
         * @member {pond.ContractDelivery|null|undefined} deliveryWindow
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.deliveryWindow = null;

        /**
         * ContractSettings type.
         * @member {pond.ContractType} type
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.type = 0;

        /**
         * ContractSettings customCommodity.
         * @member {string} customCommodity
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.customCommodity = "";

        /**
         * ContractSettings size.
         * @member {number} size
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.size = 0;

        /**
         * ContractSettings delivered.
         * @member {number} delivered
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.delivered = 0;

        /**
         * ContractSettings totalValue.
         * @member {number} totalValue
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.totalValue = 0;

        /**
         * ContractSettings commodity.
         * @member {number} commodity
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.commodity = 0;

        /**
         * ContractSettings contractDate.
         * @member {string} contractDate
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.contractDate = "";

        /**
         * ContractSettings commoditySubtype.
         * @member {string} commoditySubtype
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.commoditySubtype = "";

        /**
         * ContractSettings conversionValue.
         * @member {number} conversionValue
         * @memberof pond.ContractSettings
         * @instance
         */
        ContractSettings.prototype.conversionValue = 0;

        /**
         * Creates a new ContractSettings instance using the specified properties.
         * @function create
         * @memberof pond.ContractSettings
         * @static
         * @param {pond.IContractSettings=} [properties] Properties to set
         * @returns {pond.ContractSettings} ContractSettings instance
         */
        ContractSettings.create = function create(properties) {
            return new ContractSettings(properties);
        };

        /**
         * Creates a ContractSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ContractSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ContractSettings} ContractSettings
         */
        ContractSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ContractSettings)
                return object;
            var message = new $root.pond.ContractSettings();
            if (object.contractId != null)
                message.contractId = String(object.contractId);
            if (object.contractHolder != null)
                message.contractHolder = String(object.contractHolder);
            if (object.deliveryWindow != null) {
                if (typeof object.deliveryWindow !== "object")
                    throw TypeError(".pond.ContractSettings.deliveryWindow: object expected");
                message.deliveryWindow = $root.pond.ContractDelivery.fromObject(object.deliveryWindow);
            }
            switch (object.type) {
            case "CONTRACT_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "CONTRACT_TYPE_GRAIN":
            case 1:
                message.type = 1;
                break;
            }
            if (object.customCommodity != null)
                message.customCommodity = String(object.customCommodity);
            if (object.size != null)
                message.size = Number(object.size);
            if (object.delivered != null)
                message.delivered = Number(object.delivered);
            if (object.totalValue != null)
                message.totalValue = Number(object.totalValue);
            if (object.commodity != null)
                message.commodity = object.commodity | 0;
            if (object.contractDate != null)
                message.contractDate = String(object.contractDate);
            if (object.commoditySubtype != null)
                message.commoditySubtype = String(object.commoditySubtype);
            if (object.conversionValue != null)
                message.conversionValue = Number(object.conversionValue);
            return message;
        };

        /**
         * Creates a plain object from a ContractSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ContractSettings
         * @static
         * @param {pond.ContractSettings} message ContractSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.contractId = "";
                object.contractHolder = "";
                object.deliveryWindow = null;
                object.type = options.enums === String ? "CONTRACT_TYPE_UNKNOWN" : 0;
                object.customCommodity = "";
                object.size = 0;
                object.delivered = 0;
                object.totalValue = 0;
                object.commodity = 0;
                object.contractDate = "";
                object.commoditySubtype = "";
                object.conversionValue = 0;
            }
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.contractHolder != null && message.hasOwnProperty("contractHolder"))
                object.contractHolder = message.contractHolder;
            if (message.deliveryWindow != null && message.hasOwnProperty("deliveryWindow"))
                object.deliveryWindow = $root.pond.ContractDelivery.toObject(message.deliveryWindow, options);
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.ContractType[message.type] : message.type;
            if (message.customCommodity != null && message.hasOwnProperty("customCommodity"))
                object.customCommodity = message.customCommodity;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = options.json && !isFinite(message.size) ? String(message.size) : message.size;
            if (message.delivered != null && message.hasOwnProperty("delivered"))
                object.delivered = options.json && !isFinite(message.delivered) ? String(message.delivered) : message.delivered;
            if (message.totalValue != null && message.hasOwnProperty("totalValue"))
                object.totalValue = options.json && !isFinite(message.totalValue) ? String(message.totalValue) : message.totalValue;
            if (message.commodity != null && message.hasOwnProperty("commodity"))
                object.commodity = message.commodity;
            if (message.contractDate != null && message.hasOwnProperty("contractDate"))
                object.contractDate = message.contractDate;
            if (message.commoditySubtype != null && message.hasOwnProperty("commoditySubtype"))
                object.commoditySubtype = message.commoditySubtype;
            if (message.conversionValue != null && message.hasOwnProperty("conversionValue"))
                object.conversionValue = options.json && !isFinite(message.conversionValue) ? String(message.conversionValue) : message.conversionValue;
            return object;
        };

        /**
         * Converts this ContractSettings to JSON.
         * @function toJSON
         * @memberof pond.ContractSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractSettings;
    })();

    pond.ContractDelivery = (function() {

        /**
         * Properties of a ContractDelivery.
         * @memberof pond
         * @interface IContractDelivery
         * @property {string|null} [startDate] ContractDelivery startDate
         * @property {string|null} [endDate] ContractDelivery endDate
         */

        /**
         * Constructs a new ContractDelivery.
         * @memberof pond
         * @classdesc Represents a ContractDelivery.
         * @implements IContractDelivery
         * @constructor
         * @param {pond.IContractDelivery=} [properties] Properties to set
         */
        function ContractDelivery(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContractDelivery startDate.
         * @member {string} startDate
         * @memberof pond.ContractDelivery
         * @instance
         */
        ContractDelivery.prototype.startDate = "";

        /**
         * ContractDelivery endDate.
         * @member {string} endDate
         * @memberof pond.ContractDelivery
         * @instance
         */
        ContractDelivery.prototype.endDate = "";

        /**
         * Creates a new ContractDelivery instance using the specified properties.
         * @function create
         * @memberof pond.ContractDelivery
         * @static
         * @param {pond.IContractDelivery=} [properties] Properties to set
         * @returns {pond.ContractDelivery} ContractDelivery instance
         */
        ContractDelivery.create = function create(properties) {
            return new ContractDelivery(properties);
        };

        /**
         * Creates a ContractDelivery message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ContractDelivery
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ContractDelivery} ContractDelivery
         */
        ContractDelivery.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ContractDelivery)
                return object;
            var message = new $root.pond.ContractDelivery();
            if (object.startDate != null)
                message.startDate = String(object.startDate);
            if (object.endDate != null)
                message.endDate = String(object.endDate);
            return message;
        };

        /**
         * Creates a plain object from a ContractDelivery message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ContractDelivery
         * @static
         * @param {pond.ContractDelivery} message ContractDelivery
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContractDelivery.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.startDate = "";
                object.endDate = "";
            }
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                object.startDate = message.startDate;
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                object.endDate = message.endDate;
            return object;
        };

        /**
         * Converts this ContractDelivery to JSON.
         * @function toJSON
         * @memberof pond.ContractDelivery
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContractDelivery.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContractDelivery;
    })();

    /**
     * ContractType enum.
     * @name pond.ContractType
     * @enum {string}
     * @property {number} CONTRACT_TYPE_UNKNOWN=0 CONTRACT_TYPE_UNKNOWN value
     * @property {number} CONTRACT_TYPE_GRAIN=1 CONTRACT_TYPE_GRAIN value
     */
    pond.ContractType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CONTRACT_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "CONTRACT_TYPE_GRAIN"] = 1;
        return values;
    })();

    pond.GetContractRequest = (function() {

        /**
         * Properties of a GetContractRequest.
         * @memberof pond
         * @interface IGetContractRequest
         * @property {string|null} [key] GetContractRequest key
         */

        /**
         * Constructs a new GetContractRequest.
         * @memberof pond
         * @classdesc Represents a GetContractRequest.
         * @implements IGetContractRequest
         * @constructor
         * @param {pond.IGetContractRequest=} [properties] Properties to set
         */
        function GetContractRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetContractRequest key.
         * @member {string} key
         * @memberof pond.GetContractRequest
         * @instance
         */
        GetContractRequest.prototype.key = "";

        /**
         * Creates a new GetContractRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetContractRequest
         * @static
         * @param {pond.IGetContractRequest=} [properties] Properties to set
         * @returns {pond.GetContractRequest} GetContractRequest instance
         */
        GetContractRequest.create = function create(properties) {
            return new GetContractRequest(properties);
        };

        /**
         * Creates a GetContractRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetContractRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetContractRequest} GetContractRequest
         */
        GetContractRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetContractRequest)
                return object;
            var message = new $root.pond.GetContractRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetContractRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetContractRequest
         * @static
         * @param {pond.GetContractRequest} message GetContractRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetContractRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetContractRequest to JSON.
         * @function toJSON
         * @memberof pond.GetContractRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetContractRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetContractRequest;
    })();

    pond.GetContractResponse = (function() {

        /**
         * Properties of a GetContractResponse.
         * @memberof pond
         * @interface IGetContractResponse
         * @property {pond.Contract|null} [contract] GetContractResponse contract
         */

        /**
         * Constructs a new GetContractResponse.
         * @memberof pond
         * @classdesc Represents a GetContractResponse.
         * @implements IGetContractResponse
         * @constructor
         * @param {pond.IGetContractResponse=} [properties] Properties to set
         */
        function GetContractResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetContractResponse contract.
         * @member {pond.Contract|null|undefined} contract
         * @memberof pond.GetContractResponse
         * @instance
         */
        GetContractResponse.prototype.contract = null;

        /**
         * Creates a new GetContractResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetContractResponse
         * @static
         * @param {pond.IGetContractResponse=} [properties] Properties to set
         * @returns {pond.GetContractResponse} GetContractResponse instance
         */
        GetContractResponse.create = function create(properties) {
            return new GetContractResponse(properties);
        };

        /**
         * Creates a GetContractResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetContractResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetContractResponse} GetContractResponse
         */
        GetContractResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetContractResponse)
                return object;
            var message = new $root.pond.GetContractResponse();
            if (object.contract != null) {
                if (typeof object.contract !== "object")
                    throw TypeError(".pond.GetContractResponse.contract: object expected");
                message.contract = $root.pond.Contract.fromObject(object.contract);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetContractResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetContractResponse
         * @static
         * @param {pond.GetContractResponse} message GetContractResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetContractResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.contract = null;
            if (message.contract != null && message.hasOwnProperty("contract"))
                object.contract = $root.pond.Contract.toObject(message.contract, options);
            return object;
        };

        /**
         * Converts this GetContractResponse to JSON.
         * @function toJSON
         * @memberof pond.GetContractResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetContractResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetContractResponse;
    })();

    pond.ListContractsRequest = (function() {

        /**
         * Properties of a ListContractsRequest.
         * @memberof pond
         * @interface IListContractsRequest
         * @property {pond.Paging|null} [paging] ListContractsRequest paging
         * @property {pond.Sorting|null} [sorting] ListContractsRequest sorting
         * @property {string|null} [search] ListContractsRequest search
         */

        /**
         * Constructs a new ListContractsRequest.
         * @memberof pond
         * @classdesc Represents a ListContractsRequest.
         * @implements IListContractsRequest
         * @constructor
         * @param {pond.IListContractsRequest=} [properties] Properties to set
         */
        function ListContractsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListContractsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListContractsRequest
         * @instance
         */
        ListContractsRequest.prototype.paging = null;

        /**
         * ListContractsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListContractsRequest
         * @instance
         */
        ListContractsRequest.prototype.sorting = null;

        /**
         * ListContractsRequest search.
         * @member {string} search
         * @memberof pond.ListContractsRequest
         * @instance
         */
        ListContractsRequest.prototype.search = "";

        /**
         * Creates a new ListContractsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListContractsRequest
         * @static
         * @param {pond.IListContractsRequest=} [properties] Properties to set
         * @returns {pond.ListContractsRequest} ListContractsRequest instance
         */
        ListContractsRequest.create = function create(properties) {
            return new ListContractsRequest(properties);
        };

        /**
         * Creates a ListContractsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListContractsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListContractsRequest} ListContractsRequest
         */
        ListContractsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListContractsRequest)
                return object;
            var message = new $root.pond.ListContractsRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListContractsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListContractsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListContractsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListContractsRequest
         * @static
         * @param {pond.ListContractsRequest} message ListContractsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListContractsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListContractsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListContractsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListContractsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListContractsRequest;
    })();

    pond.ListContractsResponse = (function() {

        /**
         * Properties of a ListContractsResponse.
         * @memberof pond
         * @interface IListContractsResponse
         * @property {Array.<pond.Contract>|null} [contracts] ListContractsResponse contracts
         * @property {number|null} [nextOffset] ListContractsResponse nextOffset
         * @property {number|null} [total] ListContractsResponse total
         */

        /**
         * Constructs a new ListContractsResponse.
         * @memberof pond
         * @classdesc Represents a ListContractsResponse.
         * @implements IListContractsResponse
         * @constructor
         * @param {pond.IListContractsResponse=} [properties] Properties to set
         */
        function ListContractsResponse(properties) {
            this.contracts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListContractsResponse contracts.
         * @member {Array.<pond.Contract>} contracts
         * @memberof pond.ListContractsResponse
         * @instance
         */
        ListContractsResponse.prototype.contracts = $util.emptyArray;

        /**
         * ListContractsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListContractsResponse
         * @instance
         */
        ListContractsResponse.prototype.nextOffset = 0;

        /**
         * ListContractsResponse total.
         * @member {number} total
         * @memberof pond.ListContractsResponse
         * @instance
         */
        ListContractsResponse.prototype.total = 0;

        /**
         * Creates a new ListContractsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListContractsResponse
         * @static
         * @param {pond.IListContractsResponse=} [properties] Properties to set
         * @returns {pond.ListContractsResponse} ListContractsResponse instance
         */
        ListContractsResponse.create = function create(properties) {
            return new ListContractsResponse(properties);
        };

        /**
         * Creates a ListContractsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListContractsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListContractsResponse} ListContractsResponse
         */
        ListContractsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListContractsResponse)
                return object;
            var message = new $root.pond.ListContractsResponse();
            if (object.contracts) {
                if (!Array.isArray(object.contracts))
                    throw TypeError(".pond.ListContractsResponse.contracts: array expected");
                message.contracts = [];
                for (var i = 0; i < object.contracts.length; ++i) {
                    if (typeof object.contracts[i] !== "object")
                        throw TypeError(".pond.ListContractsResponse.contracts: object expected");
                    message.contracts[i] = $root.pond.Contract.fromObject(object.contracts[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListContractsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListContractsResponse
         * @static
         * @param {pond.ListContractsResponse} message ListContractsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListContractsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.contracts = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.contracts && message.contracts.length) {
                object.contracts = [];
                for (var j = 0; j < message.contracts.length; ++j)
                    object.contracts[j] = $root.pond.Contract.toObject(message.contracts[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListContractsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListContractsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListContractsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListContractsResponse;
    })();

    pond.AddContractRequest = (function() {

        /**
         * Properties of an AddContractRequest.
         * @memberof pond
         * @interface IAddContractRequest
         * @property {string|null} [name] AddContractRequest name
         * @property {pond.ContractSettings|null} [settings] AddContractRequest settings
         */

        /**
         * Constructs a new AddContractRequest.
         * @memberof pond
         * @classdesc Represents an AddContractRequest.
         * @implements IAddContractRequest
         * @constructor
         * @param {pond.IAddContractRequest=} [properties] Properties to set
         */
        function AddContractRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddContractRequest name.
         * @member {string} name
         * @memberof pond.AddContractRequest
         * @instance
         */
        AddContractRequest.prototype.name = "";

        /**
         * AddContractRequest settings.
         * @member {pond.ContractSettings|null|undefined} settings
         * @memberof pond.AddContractRequest
         * @instance
         */
        AddContractRequest.prototype.settings = null;

        /**
         * Creates a new AddContractRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddContractRequest
         * @static
         * @param {pond.IAddContractRequest=} [properties] Properties to set
         * @returns {pond.AddContractRequest} AddContractRequest instance
         */
        AddContractRequest.create = function create(properties) {
            return new AddContractRequest(properties);
        };

        /**
         * Creates an AddContractRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddContractRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddContractRequest} AddContractRequest
         */
        AddContractRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddContractRequest)
                return object;
            var message = new $root.pond.AddContractRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddContractRequest.settings: object expected");
                message.settings = $root.pond.ContractSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddContractRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddContractRequest
         * @static
         * @param {pond.AddContractRequest} message AddContractRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddContractRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ContractSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this AddContractRequest to JSON.
         * @function toJSON
         * @memberof pond.AddContractRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddContractRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddContractRequest;
    })();

    pond.AddContractResponse = (function() {

        /**
         * Properties of an AddContractResponse.
         * @memberof pond
         * @interface IAddContractResponse
         * @property {string|null} [key] AddContractResponse key
         */

        /**
         * Constructs a new AddContractResponse.
         * @memberof pond
         * @classdesc Represents an AddContractResponse.
         * @implements IAddContractResponse
         * @constructor
         * @param {pond.IAddContractResponse=} [properties] Properties to set
         */
        function AddContractResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddContractResponse key.
         * @member {string} key
         * @memberof pond.AddContractResponse
         * @instance
         */
        AddContractResponse.prototype.key = "";

        /**
         * Creates a new AddContractResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddContractResponse
         * @static
         * @param {pond.IAddContractResponse=} [properties] Properties to set
         * @returns {pond.AddContractResponse} AddContractResponse instance
         */
        AddContractResponse.create = function create(properties) {
            return new AddContractResponse(properties);
        };

        /**
         * Creates an AddContractResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddContractResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddContractResponse} AddContractResponse
         */
        AddContractResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddContractResponse)
                return object;
            var message = new $root.pond.AddContractResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddContractResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddContractResponse
         * @static
         * @param {pond.AddContractResponse} message AddContractResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddContractResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddContractResponse to JSON.
         * @function toJSON
         * @memberof pond.AddContractResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddContractResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddContractResponse;
    })();

    pond.UpdateContractRequest = (function() {

        /**
         * Properties of an UpdateContractRequest.
         * @memberof pond
         * @interface IUpdateContractRequest
         * @property {string|null} [key] UpdateContractRequest key
         * @property {string|null} [name] UpdateContractRequest name
         * @property {pond.ContractSettings|null} [settings] UpdateContractRequest settings
         */

        /**
         * Constructs a new UpdateContractRequest.
         * @memberof pond
         * @classdesc Represents an UpdateContractRequest.
         * @implements IUpdateContractRequest
         * @constructor
         * @param {pond.IUpdateContractRequest=} [properties] Properties to set
         */
        function UpdateContractRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateContractRequest key.
         * @member {string} key
         * @memberof pond.UpdateContractRequest
         * @instance
         */
        UpdateContractRequest.prototype.key = "";

        /**
         * UpdateContractRequest name.
         * @member {string} name
         * @memberof pond.UpdateContractRequest
         * @instance
         */
        UpdateContractRequest.prototype.name = "";

        /**
         * UpdateContractRequest settings.
         * @member {pond.ContractSettings|null|undefined} settings
         * @memberof pond.UpdateContractRequest
         * @instance
         */
        UpdateContractRequest.prototype.settings = null;

        /**
         * Creates a new UpdateContractRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateContractRequest
         * @static
         * @param {pond.IUpdateContractRequest=} [properties] Properties to set
         * @returns {pond.UpdateContractRequest} UpdateContractRequest instance
         */
        UpdateContractRequest.create = function create(properties) {
            return new UpdateContractRequest(properties);
        };

        /**
         * Creates an UpdateContractRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateContractRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateContractRequest} UpdateContractRequest
         */
        UpdateContractRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateContractRequest)
                return object;
            var message = new $root.pond.UpdateContractRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateContractRequest.settings: object expected");
                message.settings = $root.pond.ContractSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateContractRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateContractRequest
         * @static
         * @param {pond.UpdateContractRequest} message UpdateContractRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateContractRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ContractSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateContractRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateContractRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateContractRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateContractRequest;
    })();

    pond.UpdateContractResponse = (function() {

        /**
         * Properties of an UpdateContractResponse.
         * @memberof pond
         * @interface IUpdateContractResponse
         */

        /**
         * Constructs a new UpdateContractResponse.
         * @memberof pond
         * @classdesc Represents an UpdateContractResponse.
         * @implements IUpdateContractResponse
         * @constructor
         * @param {pond.IUpdateContractResponse=} [properties] Properties to set
         */
        function UpdateContractResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateContractResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateContractResponse
         * @static
         * @param {pond.IUpdateContractResponse=} [properties] Properties to set
         * @returns {pond.UpdateContractResponse} UpdateContractResponse instance
         */
        UpdateContractResponse.create = function create(properties) {
            return new UpdateContractResponse(properties);
        };

        /**
         * Creates an UpdateContractResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateContractResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateContractResponse} UpdateContractResponse
         */
        UpdateContractResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateContractResponse)
                return object;
            return new $root.pond.UpdateContractResponse();
        };

        /**
         * Creates a plain object from an UpdateContractResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateContractResponse
         * @static
         * @param {pond.UpdateContractResponse} message UpdateContractResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateContractResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateContractResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateContractResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateContractResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateContractResponse;
    })();

    pond.RemoveContractRequest = (function() {

        /**
         * Properties of a RemoveContractRequest.
         * @memberof pond
         * @interface IRemoveContractRequest
         * @property {string|null} [key] RemoveContractRequest key
         */

        /**
         * Constructs a new RemoveContractRequest.
         * @memberof pond
         * @classdesc Represents a RemoveContractRequest.
         * @implements IRemoveContractRequest
         * @constructor
         * @param {pond.IRemoveContractRequest=} [properties] Properties to set
         */
        function RemoveContractRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveContractRequest key.
         * @member {string} key
         * @memberof pond.RemoveContractRequest
         * @instance
         */
        RemoveContractRequest.prototype.key = "";

        /**
         * Creates a new RemoveContractRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveContractRequest
         * @static
         * @param {pond.IRemoveContractRequest=} [properties] Properties to set
         * @returns {pond.RemoveContractRequest} RemoveContractRequest instance
         */
        RemoveContractRequest.create = function create(properties) {
            return new RemoveContractRequest(properties);
        };

        /**
         * Creates a RemoveContractRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveContractRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveContractRequest} RemoveContractRequest
         */
        RemoveContractRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveContractRequest)
                return object;
            var message = new $root.pond.RemoveContractRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveContractRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveContractRequest
         * @static
         * @param {pond.RemoveContractRequest} message RemoveContractRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveContractRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveContractRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveContractRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveContractRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveContractRequest;
    })();

    pond.RemoveContractResponse = (function() {

        /**
         * Properties of a RemoveContractResponse.
         * @memberof pond
         * @interface IRemoveContractResponse
         */

        /**
         * Constructs a new RemoveContractResponse.
         * @memberof pond
         * @classdesc Represents a RemoveContractResponse.
         * @implements IRemoveContractResponse
         * @constructor
         * @param {pond.IRemoveContractResponse=} [properties] Properties to set
         */
        function RemoveContractResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RemoveContractResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveContractResponse
         * @static
         * @param {pond.IRemoveContractResponse=} [properties] Properties to set
         * @returns {pond.RemoveContractResponse} RemoveContractResponse instance
         */
        RemoveContractResponse.create = function create(properties) {
            return new RemoveContractResponse(properties);
        };

        /**
         * Creates a RemoveContractResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveContractResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveContractResponse} RemoveContractResponse
         */
        RemoveContractResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveContractResponse)
                return object;
            return new $root.pond.RemoveContractResponse();
        };

        /**
         * Creates a plain object from a RemoveContractResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveContractResponse
         * @static
         * @param {pond.RemoveContractResponse} message RemoveContractResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveContractResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RemoveContractResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveContractResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveContractResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveContractResponse;
    })();

    pond.ListContractsByYearRequest = (function() {

        /**
         * Properties of a ListContractsByYearRequest.
         * @memberof pond
         * @interface IListContractsByYearRequest
         * @property {pond.Paging|null} [paging] ListContractsByYearRequest paging
         * @property {pond.Sorting|null} [sorting] ListContractsByYearRequest sorting
         * @property {string|null} [search] ListContractsByYearRequest search
         * @property {string|null} [year] ListContractsByYearRequest year
         */

        /**
         * Constructs a new ListContractsByYearRequest.
         * @memberof pond
         * @classdesc Represents a ListContractsByYearRequest.
         * @implements IListContractsByYearRequest
         * @constructor
         * @param {pond.IListContractsByYearRequest=} [properties] Properties to set
         */
        function ListContractsByYearRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListContractsByYearRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListContractsByYearRequest
         * @instance
         */
        ListContractsByYearRequest.prototype.paging = null;

        /**
         * ListContractsByYearRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListContractsByYearRequest
         * @instance
         */
        ListContractsByYearRequest.prototype.sorting = null;

        /**
         * ListContractsByYearRequest search.
         * @member {string} search
         * @memberof pond.ListContractsByYearRequest
         * @instance
         */
        ListContractsByYearRequest.prototype.search = "";

        /**
         * ListContractsByYearRequest year.
         * @member {string} year
         * @memberof pond.ListContractsByYearRequest
         * @instance
         */
        ListContractsByYearRequest.prototype.year = "";

        /**
         * Creates a new ListContractsByYearRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListContractsByYearRequest
         * @static
         * @param {pond.IListContractsByYearRequest=} [properties] Properties to set
         * @returns {pond.ListContractsByYearRequest} ListContractsByYearRequest instance
         */
        ListContractsByYearRequest.create = function create(properties) {
            return new ListContractsByYearRequest(properties);
        };

        /**
         * Creates a ListContractsByYearRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListContractsByYearRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListContractsByYearRequest} ListContractsByYearRequest
         */
        ListContractsByYearRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListContractsByYearRequest)
                return object;
            var message = new $root.pond.ListContractsByYearRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListContractsByYearRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListContractsByYearRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.year != null)
                message.year = String(object.year);
            return message;
        };

        /**
         * Creates a plain object from a ListContractsByYearRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListContractsByYearRequest
         * @static
         * @param {pond.ListContractsByYearRequest} message ListContractsByYearRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListContractsByYearRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.year = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            return object;
        };

        /**
         * Converts this ListContractsByYearRequest to JSON.
         * @function toJSON
         * @memberof pond.ListContractsByYearRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListContractsByYearRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListContractsByYearRequest;
    })();

    pond.ListContractsByYearResponse = (function() {

        /**
         * Properties of a ListContractsByYearResponse.
         * @memberof pond
         * @interface IListContractsByYearResponse
         * @property {Array.<pond.Contract>|null} [contracts] ListContractsByYearResponse contracts
         * @property {number|null} [nextOffset] ListContractsByYearResponse nextOffset
         * @property {number|null} [total] ListContractsByYearResponse total
         * @property {Object.<string,pond.EvaluatePermissionsResponse>|null} [contractPermissions] ListContractsByYearResponse contractPermissions
         */

        /**
         * Constructs a new ListContractsByYearResponse.
         * @memberof pond
         * @classdesc Represents a ListContractsByYearResponse.
         * @implements IListContractsByYearResponse
         * @constructor
         * @param {pond.IListContractsByYearResponse=} [properties] Properties to set
         */
        function ListContractsByYearResponse(properties) {
            this.contracts = [];
            this.contractPermissions = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListContractsByYearResponse contracts.
         * @member {Array.<pond.Contract>} contracts
         * @memberof pond.ListContractsByYearResponse
         * @instance
         */
        ListContractsByYearResponse.prototype.contracts = $util.emptyArray;

        /**
         * ListContractsByYearResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListContractsByYearResponse
         * @instance
         */
        ListContractsByYearResponse.prototype.nextOffset = 0;

        /**
         * ListContractsByYearResponse total.
         * @member {number} total
         * @memberof pond.ListContractsByYearResponse
         * @instance
         */
        ListContractsByYearResponse.prototype.total = 0;

        /**
         * ListContractsByYearResponse contractPermissions.
         * @member {Object.<string,pond.EvaluatePermissionsResponse>} contractPermissions
         * @memberof pond.ListContractsByYearResponse
         * @instance
         */
        ListContractsByYearResponse.prototype.contractPermissions = $util.emptyObject;

        /**
         * Creates a new ListContractsByYearResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListContractsByYearResponse
         * @static
         * @param {pond.IListContractsByYearResponse=} [properties] Properties to set
         * @returns {pond.ListContractsByYearResponse} ListContractsByYearResponse instance
         */
        ListContractsByYearResponse.create = function create(properties) {
            return new ListContractsByYearResponse(properties);
        };

        /**
         * Creates a ListContractsByYearResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListContractsByYearResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListContractsByYearResponse} ListContractsByYearResponse
         */
        ListContractsByYearResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListContractsByYearResponse)
                return object;
            var message = new $root.pond.ListContractsByYearResponse();
            if (object.contracts) {
                if (!Array.isArray(object.contracts))
                    throw TypeError(".pond.ListContractsByYearResponse.contracts: array expected");
                message.contracts = [];
                for (var i = 0; i < object.contracts.length; ++i) {
                    if (typeof object.contracts[i] !== "object")
                        throw TypeError(".pond.ListContractsByYearResponse.contracts: object expected");
                    message.contracts[i] = $root.pond.Contract.fromObject(object.contracts[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            if (object.contractPermissions) {
                if (typeof object.contractPermissions !== "object")
                    throw TypeError(".pond.ListContractsByYearResponse.contractPermissions: object expected");
                message.contractPermissions = {};
                for (var keys = Object.keys(object.contractPermissions), i = 0; i < keys.length; ++i) {
                    if (typeof object.contractPermissions[keys[i]] !== "object")
                        throw TypeError(".pond.ListContractsByYearResponse.contractPermissions: object expected");
                    message.contractPermissions[keys[i]] = $root.pond.EvaluatePermissionsResponse.fromObject(object.contractPermissions[keys[i]]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListContractsByYearResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListContractsByYearResponse
         * @static
         * @param {pond.ListContractsByYearResponse} message ListContractsByYearResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListContractsByYearResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.contracts = [];
            if (options.objects || options.defaults)
                object.contractPermissions = {};
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.contracts && message.contracts.length) {
                object.contracts = [];
                for (var j = 0; j < message.contracts.length; ++j)
                    object.contracts[j] = $root.pond.Contract.toObject(message.contracts[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            var keys2;
            if (message.contractPermissions && (keys2 = Object.keys(message.contractPermissions)).length) {
                object.contractPermissions = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.contractPermissions[keys2[j]] = $root.pond.EvaluatePermissionsResponse.toObject(message.contractPermissions[keys2[j]], options);
            }
            return object;
        };

        /**
         * Converts this ListContractsByYearResponse to JSON.
         * @function toJSON
         * @memberof pond.ListContractsByYearResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListContractsByYearResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListContractsByYearResponse;
    })();

    pond.GetContractPageDataRequest = (function() {

        /**
         * Properties of a GetContractPageDataRequest.
         * @memberof pond
         * @interface IGetContractPageDataRequest
         * @property {string|null} [key] GetContractPageDataRequest key
         */

        /**
         * Constructs a new GetContractPageDataRequest.
         * @memberof pond
         * @classdesc Represents a GetContractPageDataRequest.
         * @implements IGetContractPageDataRequest
         * @constructor
         * @param {pond.IGetContractPageDataRequest=} [properties] Properties to set
         */
        function GetContractPageDataRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetContractPageDataRequest key.
         * @member {string} key
         * @memberof pond.GetContractPageDataRequest
         * @instance
         */
        GetContractPageDataRequest.prototype.key = "";

        /**
         * Creates a new GetContractPageDataRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetContractPageDataRequest
         * @static
         * @param {pond.IGetContractPageDataRequest=} [properties] Properties to set
         * @returns {pond.GetContractPageDataRequest} GetContractPageDataRequest instance
         */
        GetContractPageDataRequest.create = function create(properties) {
            return new GetContractPageDataRequest(properties);
        };

        /**
         * Creates a GetContractPageDataRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetContractPageDataRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetContractPageDataRequest} GetContractPageDataRequest
         */
        GetContractPageDataRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetContractPageDataRequest)
                return object;
            var message = new $root.pond.GetContractPageDataRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetContractPageDataRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetContractPageDataRequest
         * @static
         * @param {pond.GetContractPageDataRequest} message GetContractPageDataRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetContractPageDataRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetContractPageDataRequest to JSON.
         * @function toJSON
         * @memberof pond.GetContractPageDataRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetContractPageDataRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetContractPageDataRequest;
    })();

    pond.GetContractPageDataResponse = (function() {

        /**
         * Properties of a GetContractPageDataResponse.
         * @memberof pond
         * @interface IGetContractPageDataResponse
         * @property {pond.Contract|null} [contract] GetContractPageDataResponse contract
         * @property {Array.<pond.Transaction>|null} [transactions] GetContractPageDataResponse transactions
         * @property {Object.<string,string>|null} [nameMap] GetContractPageDataResponse nameMap
         */

        /**
         * Constructs a new GetContractPageDataResponse.
         * @memberof pond
         * @classdesc Represents a GetContractPageDataResponse.
         * @implements IGetContractPageDataResponse
         * @constructor
         * @param {pond.IGetContractPageDataResponse=} [properties] Properties to set
         */
        function GetContractPageDataResponse(properties) {
            this.transactions = [];
            this.nameMap = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetContractPageDataResponse contract.
         * @member {pond.Contract|null|undefined} contract
         * @memberof pond.GetContractPageDataResponse
         * @instance
         */
        GetContractPageDataResponse.prototype.contract = null;

        /**
         * GetContractPageDataResponse transactions.
         * @member {Array.<pond.Transaction>} transactions
         * @memberof pond.GetContractPageDataResponse
         * @instance
         */
        GetContractPageDataResponse.prototype.transactions = $util.emptyArray;

        /**
         * GetContractPageDataResponse nameMap.
         * @member {Object.<string,string>} nameMap
         * @memberof pond.GetContractPageDataResponse
         * @instance
         */
        GetContractPageDataResponse.prototype.nameMap = $util.emptyObject;

        /**
         * Creates a new GetContractPageDataResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetContractPageDataResponse
         * @static
         * @param {pond.IGetContractPageDataResponse=} [properties] Properties to set
         * @returns {pond.GetContractPageDataResponse} GetContractPageDataResponse instance
         */
        GetContractPageDataResponse.create = function create(properties) {
            return new GetContractPageDataResponse(properties);
        };

        /**
         * Creates a GetContractPageDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetContractPageDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetContractPageDataResponse} GetContractPageDataResponse
         */
        GetContractPageDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetContractPageDataResponse)
                return object;
            var message = new $root.pond.GetContractPageDataResponse();
            if (object.contract != null) {
                if (typeof object.contract !== "object")
                    throw TypeError(".pond.GetContractPageDataResponse.contract: object expected");
                message.contract = $root.pond.Contract.fromObject(object.contract);
            }
            if (object.transactions) {
                if (!Array.isArray(object.transactions))
                    throw TypeError(".pond.GetContractPageDataResponse.transactions: array expected");
                message.transactions = [];
                for (var i = 0; i < object.transactions.length; ++i) {
                    if (typeof object.transactions[i] !== "object")
                        throw TypeError(".pond.GetContractPageDataResponse.transactions: object expected");
                    message.transactions[i] = $root.pond.Transaction.fromObject(object.transactions[i]);
                }
            }
            if (object.nameMap) {
                if (typeof object.nameMap !== "object")
                    throw TypeError(".pond.GetContractPageDataResponse.nameMap: object expected");
                message.nameMap = {};
                for (var keys = Object.keys(object.nameMap), i = 0; i < keys.length; ++i)
                    message.nameMap[keys[i]] = String(object.nameMap[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetContractPageDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetContractPageDataResponse
         * @static
         * @param {pond.GetContractPageDataResponse} message GetContractPageDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetContractPageDataResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.transactions = [];
            if (options.objects || options.defaults)
                object.nameMap = {};
            if (options.defaults)
                object.contract = null;
            if (message.contract != null && message.hasOwnProperty("contract"))
                object.contract = $root.pond.Contract.toObject(message.contract, options);
            if (message.transactions && message.transactions.length) {
                object.transactions = [];
                for (var j = 0; j < message.transactions.length; ++j)
                    object.transactions[j] = $root.pond.Transaction.toObject(message.transactions[j], options);
            }
            var keys2;
            if (message.nameMap && (keys2 = Object.keys(message.nameMap)).length) {
                object.nameMap = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.nameMap[keys2[j]] = message.nameMap[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this GetContractPageDataResponse to JSON.
         * @function toJSON
         * @memberof pond.GetContractPageDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetContractPageDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetContractPageDataResponse;
    })();

    /**
     * PresetType enum.
     * @name pond.PresetType
     * @enum {string}
     * @property {number} PRESET_TYPE_UNKNOWN=0 PRESET_TYPE_UNKNOWN value
     * @property {number} PRESET_TYPE_DRYING=1 PRESET_TYPE_DRYING value
     * @property {number} PRESET_TYPE_COOLING=2 PRESET_TYPE_COOLING value
     * @property {number} PRESET_TYPE_HYDRATING=3 PRESET_TYPE_HYDRATING value
     */
    pond.PresetType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRESET_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "PRESET_TYPE_DRYING"] = 1;
        values[valuesById[2] = "PRESET_TYPE_COOLING"] = 2;
        values[valuesById[3] = "PRESET_TYPE_HYDRATING"] = 3;
        return values;
    })();

    /**
     * ControllerType enum.
     * @name pond.ControllerType
     * @enum {string}
     * @property {number} CONTROLLER_TYPE_UNKNOWN=0 CONTROLLER_TYPE_UNKNOWN value
     * @property {number} CONTROLLER_TYPE_HEATER=1 CONTROLLER_TYPE_HEATER value
     * @property {number} CONTROLLER_TYPE_FAN=2 CONTROLLER_TYPE_FAN value
     */
    pond.ControllerType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CONTROLLER_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "CONTROLLER_TYPE_HEATER"] = 1;
        values[valuesById[2] = "CONTROLLER_TYPE_FAN"] = 2;
        return values;
    })();

    pond.DevicePreset = (function() {

        /**
         * Properties of a DevicePreset.
         * @memberof pond
         * @interface IDevicePreset
         * @property {string|null} [key] DevicePreset key
         * @property {string|null} [name] DevicePreset name
         * @property {pond.DevicePresetSettings|null} [settings] DevicePreset settings
         */

        /**
         * Constructs a new DevicePreset.
         * @memberof pond
         * @classdesc Represents a DevicePreset.
         * @implements IDevicePreset
         * @constructor
         * @param {pond.IDevicePreset=} [properties] Properties to set
         */
        function DevicePreset(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DevicePreset key.
         * @member {string} key
         * @memberof pond.DevicePreset
         * @instance
         */
        DevicePreset.prototype.key = "";

        /**
         * DevicePreset name.
         * @member {string} name
         * @memberof pond.DevicePreset
         * @instance
         */
        DevicePreset.prototype.name = "";

        /**
         * DevicePreset settings.
         * @member {pond.DevicePresetSettings|null|undefined} settings
         * @memberof pond.DevicePreset
         * @instance
         */
        DevicePreset.prototype.settings = null;

        /**
         * Creates a new DevicePreset instance using the specified properties.
         * @function create
         * @memberof pond.DevicePreset
         * @static
         * @param {pond.IDevicePreset=} [properties] Properties to set
         * @returns {pond.DevicePreset} DevicePreset instance
         */
        DevicePreset.create = function create(properties) {
            return new DevicePreset(properties);
        };

        /**
         * Creates a DevicePreset message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DevicePreset
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DevicePreset} DevicePreset
         */
        DevicePreset.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DevicePreset)
                return object;
            var message = new $root.pond.DevicePreset();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.DevicePreset.settings: object expected");
                message.settings = $root.pond.DevicePresetSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from a DevicePreset message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DevicePreset
         * @static
         * @param {pond.DevicePreset} message DevicePreset
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DevicePreset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.DevicePresetSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this DevicePreset to JSON.
         * @function toJSON
         * @memberof pond.DevicePreset
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DevicePreset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DevicePreset;
    })();

    pond.DevicePresetSettings = (function() {

        /**
         * Properties of a DevicePresetSettings.
         * @memberof pond
         * @interface IDevicePresetSettings
         * @property {pond.PresetType|null} [type] DevicePresetSettings type
         * @property {pond.ControllerType|null} [controller] DevicePresetSettings controller
         * @property {number|null} [temperature] DevicePresetSettings temperature
         * @property {number|null} [humidity] DevicePresetSettings humidity
         * @property {boolean|null} [favorite] DevicePresetSettings favorite
         */

        /**
         * Constructs a new DevicePresetSettings.
         * @memberof pond
         * @classdesc Represents a DevicePresetSettings.
         * @implements IDevicePresetSettings
         * @constructor
         * @param {pond.IDevicePresetSettings=} [properties] Properties to set
         */
        function DevicePresetSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DevicePresetSettings type.
         * @member {pond.PresetType} type
         * @memberof pond.DevicePresetSettings
         * @instance
         */
        DevicePresetSettings.prototype.type = 0;

        /**
         * DevicePresetSettings controller.
         * @member {pond.ControllerType} controller
         * @memberof pond.DevicePresetSettings
         * @instance
         */
        DevicePresetSettings.prototype.controller = 0;

        /**
         * DevicePresetSettings temperature.
         * @member {number} temperature
         * @memberof pond.DevicePresetSettings
         * @instance
         */
        DevicePresetSettings.prototype.temperature = 0;

        /**
         * DevicePresetSettings humidity.
         * @member {number} humidity
         * @memberof pond.DevicePresetSettings
         * @instance
         */
        DevicePresetSettings.prototype.humidity = 0;

        /**
         * DevicePresetSettings favorite.
         * @member {boolean} favorite
         * @memberof pond.DevicePresetSettings
         * @instance
         */
        DevicePresetSettings.prototype.favorite = false;

        /**
         * Creates a new DevicePresetSettings instance using the specified properties.
         * @function create
         * @memberof pond.DevicePresetSettings
         * @static
         * @param {pond.IDevicePresetSettings=} [properties] Properties to set
         * @returns {pond.DevicePresetSettings} DevicePresetSettings instance
         */
        DevicePresetSettings.create = function create(properties) {
            return new DevicePresetSettings(properties);
        };

        /**
         * Creates a DevicePresetSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DevicePresetSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DevicePresetSettings} DevicePresetSettings
         */
        DevicePresetSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DevicePresetSettings)
                return object;
            var message = new $root.pond.DevicePresetSettings();
            switch (object.type) {
            case "PRESET_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "PRESET_TYPE_DRYING":
            case 1:
                message.type = 1;
                break;
            case "PRESET_TYPE_COOLING":
            case 2:
                message.type = 2;
                break;
            case "PRESET_TYPE_HYDRATING":
            case 3:
                message.type = 3;
                break;
            }
            switch (object.controller) {
            case "CONTROLLER_TYPE_UNKNOWN":
            case 0:
                message.controller = 0;
                break;
            case "CONTROLLER_TYPE_HEATER":
            case 1:
                message.controller = 1;
                break;
            case "CONTROLLER_TYPE_FAN":
            case 2:
                message.controller = 2;
                break;
            }
            if (object.temperature != null)
                message.temperature = Number(object.temperature);
            if (object.humidity != null)
                message.humidity = Number(object.humidity);
            if (object.favorite != null)
                message.favorite = Boolean(object.favorite);
            return message;
        };

        /**
         * Creates a plain object from a DevicePresetSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DevicePresetSettings
         * @static
         * @param {pond.DevicePresetSettings} message DevicePresetSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DevicePresetSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "PRESET_TYPE_UNKNOWN" : 0;
                object.controller = options.enums === String ? "CONTROLLER_TYPE_UNKNOWN" : 0;
                object.temperature = 0;
                object.humidity = 0;
                object.favorite = false;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.PresetType[message.type] : message.type;
            if (message.controller != null && message.hasOwnProperty("controller"))
                object.controller = options.enums === String ? $root.pond.ControllerType[message.controller] : message.controller;
            if (message.temperature != null && message.hasOwnProperty("temperature"))
                object.temperature = options.json && !isFinite(message.temperature) ? String(message.temperature) : message.temperature;
            if (message.humidity != null && message.hasOwnProperty("humidity"))
                object.humidity = options.json && !isFinite(message.humidity) ? String(message.humidity) : message.humidity;
            if (message.favorite != null && message.hasOwnProperty("favorite"))
                object.favorite = message.favorite;
            return object;
        };

        /**
         * Converts this DevicePresetSettings to JSON.
         * @function toJSON
         * @memberof pond.DevicePresetSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DevicePresetSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DevicePresetSettings;
    })();

    pond.AddDevicePresetRequest = (function() {

        /**
         * Properties of an AddDevicePresetRequest.
         * @memberof pond
         * @interface IAddDevicePresetRequest
         * @property {string|null} [name] AddDevicePresetRequest name
         * @property {pond.DevicePresetSettings|null} [settings] AddDevicePresetRequest settings
         * @property {string|null} [parent] AddDevicePresetRequest parent
         * @property {string|null} [parentType] AddDevicePresetRequest parentType
         */

        /**
         * Constructs a new AddDevicePresetRequest.
         * @memberof pond
         * @classdesc Represents an AddDevicePresetRequest.
         * @implements IAddDevicePresetRequest
         * @constructor
         * @param {pond.IAddDevicePresetRequest=} [properties] Properties to set
         */
        function AddDevicePresetRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddDevicePresetRequest name.
         * @member {string} name
         * @memberof pond.AddDevicePresetRequest
         * @instance
         */
        AddDevicePresetRequest.prototype.name = "";

        /**
         * AddDevicePresetRequest settings.
         * @member {pond.DevicePresetSettings|null|undefined} settings
         * @memberof pond.AddDevicePresetRequest
         * @instance
         */
        AddDevicePresetRequest.prototype.settings = null;

        /**
         * AddDevicePresetRequest parent.
         * @member {string} parent
         * @memberof pond.AddDevicePresetRequest
         * @instance
         */
        AddDevicePresetRequest.prototype.parent = "";

        /**
         * AddDevicePresetRequest parentType.
         * @member {string} parentType
         * @memberof pond.AddDevicePresetRequest
         * @instance
         */
        AddDevicePresetRequest.prototype.parentType = "";

        /**
         * Creates a new AddDevicePresetRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddDevicePresetRequest
         * @static
         * @param {pond.IAddDevicePresetRequest=} [properties] Properties to set
         * @returns {pond.AddDevicePresetRequest} AddDevicePresetRequest instance
         */
        AddDevicePresetRequest.create = function create(properties) {
            return new AddDevicePresetRequest(properties);
        };

        /**
         * Creates an AddDevicePresetRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddDevicePresetRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddDevicePresetRequest} AddDevicePresetRequest
         */
        AddDevicePresetRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddDevicePresetRequest)
                return object;
            var message = new $root.pond.AddDevicePresetRequest();
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddDevicePresetRequest.settings: object expected");
                message.settings = $root.pond.DevicePresetSettings.fromObject(object.settings);
            }
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            return message;
        };

        /**
         * Creates a plain object from an AddDevicePresetRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddDevicePresetRequest
         * @static
         * @param {pond.AddDevicePresetRequest} message AddDevicePresetRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddDevicePresetRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.settings = null;
                object.parent = "";
                object.parentType = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.DevicePresetSettings.toObject(message.settings, options);
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            return object;
        };

        /**
         * Converts this AddDevicePresetRequest to JSON.
         * @function toJSON
         * @memberof pond.AddDevicePresetRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddDevicePresetRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddDevicePresetRequest;
    })();

    pond.AddDevicePresetResponse = (function() {

        /**
         * Properties of an AddDevicePresetResponse.
         * @memberof pond
         * @interface IAddDevicePresetResponse
         * @property {string|null} [key] AddDevicePresetResponse key
         */

        /**
         * Constructs a new AddDevicePresetResponse.
         * @memberof pond
         * @classdesc Represents an AddDevicePresetResponse.
         * @implements IAddDevicePresetResponse
         * @constructor
         * @param {pond.IAddDevicePresetResponse=} [properties] Properties to set
         */
        function AddDevicePresetResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddDevicePresetResponse key.
         * @member {string} key
         * @memberof pond.AddDevicePresetResponse
         * @instance
         */
        AddDevicePresetResponse.prototype.key = "";

        /**
         * Creates a new AddDevicePresetResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddDevicePresetResponse
         * @static
         * @param {pond.IAddDevicePresetResponse=} [properties] Properties to set
         * @returns {pond.AddDevicePresetResponse} AddDevicePresetResponse instance
         */
        AddDevicePresetResponse.create = function create(properties) {
            return new AddDevicePresetResponse(properties);
        };

        /**
         * Creates an AddDevicePresetResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddDevicePresetResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddDevicePresetResponse} AddDevicePresetResponse
         */
        AddDevicePresetResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddDevicePresetResponse)
                return object;
            var message = new $root.pond.AddDevicePresetResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddDevicePresetResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddDevicePresetResponse
         * @static
         * @param {pond.AddDevicePresetResponse} message AddDevicePresetResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddDevicePresetResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddDevicePresetResponse to JSON.
         * @function toJSON
         * @memberof pond.AddDevicePresetResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddDevicePresetResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddDevicePresetResponse;
    })();

    pond.UpdateDevicePresetRequest = (function() {

        /**
         * Properties of an UpdateDevicePresetRequest.
         * @memberof pond
         * @interface IUpdateDevicePresetRequest
         * @property {string|null} [key] UpdateDevicePresetRequest key
         * @property {string|null} [name] UpdateDevicePresetRequest name
         * @property {pond.DevicePresetSettings|null} [settings] UpdateDevicePresetRequest settings
         */

        /**
         * Constructs a new UpdateDevicePresetRequest.
         * @memberof pond
         * @classdesc Represents an UpdateDevicePresetRequest.
         * @implements IUpdateDevicePresetRequest
         * @constructor
         * @param {pond.IUpdateDevicePresetRequest=} [properties] Properties to set
         */
        function UpdateDevicePresetRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDevicePresetRequest key.
         * @member {string} key
         * @memberof pond.UpdateDevicePresetRequest
         * @instance
         */
        UpdateDevicePresetRequest.prototype.key = "";

        /**
         * UpdateDevicePresetRequest name.
         * @member {string} name
         * @memberof pond.UpdateDevicePresetRequest
         * @instance
         */
        UpdateDevicePresetRequest.prototype.name = "";

        /**
         * UpdateDevicePresetRequest settings.
         * @member {pond.DevicePresetSettings|null|undefined} settings
         * @memberof pond.UpdateDevicePresetRequest
         * @instance
         */
        UpdateDevicePresetRequest.prototype.settings = null;

        /**
         * Creates a new UpdateDevicePresetRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDevicePresetRequest
         * @static
         * @param {pond.IUpdateDevicePresetRequest=} [properties] Properties to set
         * @returns {pond.UpdateDevicePresetRequest} UpdateDevicePresetRequest instance
         */
        UpdateDevicePresetRequest.create = function create(properties) {
            return new UpdateDevicePresetRequest(properties);
        };

        /**
         * Creates an UpdateDevicePresetRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDevicePresetRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDevicePresetRequest} UpdateDevicePresetRequest
         */
        UpdateDevicePresetRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDevicePresetRequest)
                return object;
            var message = new $root.pond.UpdateDevicePresetRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateDevicePresetRequest.settings: object expected");
                message.settings = $root.pond.DevicePresetSettings.fromObject(object.settings);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateDevicePresetRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDevicePresetRequest
         * @static
         * @param {pond.UpdateDevicePresetRequest} message UpdateDevicePresetRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDevicePresetRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.settings = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.DevicePresetSettings.toObject(message.settings, options);
            return object;
        };

        /**
         * Converts this UpdateDevicePresetRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateDevicePresetRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDevicePresetRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDevicePresetRequest;
    })();

    pond.UpdateDevicePresetResponse = (function() {

        /**
         * Properties of an UpdateDevicePresetResponse.
         * @memberof pond
         * @interface IUpdateDevicePresetResponse
         */

        /**
         * Constructs a new UpdateDevicePresetResponse.
         * @memberof pond
         * @classdesc Represents an UpdateDevicePresetResponse.
         * @implements IUpdateDevicePresetResponse
         * @constructor
         * @param {pond.IUpdateDevicePresetResponse=} [properties] Properties to set
         */
        function UpdateDevicePresetResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateDevicePresetResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateDevicePresetResponse
         * @static
         * @param {pond.IUpdateDevicePresetResponse=} [properties] Properties to set
         * @returns {pond.UpdateDevicePresetResponse} UpdateDevicePresetResponse instance
         */
        UpdateDevicePresetResponse.create = function create(properties) {
            return new UpdateDevicePresetResponse(properties);
        };

        /**
         * Creates an UpdateDevicePresetResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateDevicePresetResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateDevicePresetResponse} UpdateDevicePresetResponse
         */
        UpdateDevicePresetResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateDevicePresetResponse)
                return object;
            return new $root.pond.UpdateDevicePresetResponse();
        };

        /**
         * Creates a plain object from an UpdateDevicePresetResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateDevicePresetResponse
         * @static
         * @param {pond.UpdateDevicePresetResponse} message UpdateDevicePresetResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDevicePresetResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateDevicePresetResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateDevicePresetResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDevicePresetResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDevicePresetResponse;
    })();

    pond.ListDevicePresetRequest = (function() {

        /**
         * Properties of a ListDevicePresetRequest.
         * @memberof pond
         * @interface IListDevicePresetRequest
         * @property {pond.Paging|null} [paging] ListDevicePresetRequest paging
         * @property {pond.Sorting|null} [sorting] ListDevicePresetRequest sorting
         * @property {string|null} [search] ListDevicePresetRequest search
         */

        /**
         * Constructs a new ListDevicePresetRequest.
         * @memberof pond
         * @classdesc Represents a ListDevicePresetRequest.
         * @implements IListDevicePresetRequest
         * @constructor
         * @param {pond.IListDevicePresetRequest=} [properties] Properties to set
         */
        function ListDevicePresetRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDevicePresetRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListDevicePresetRequest
         * @instance
         */
        ListDevicePresetRequest.prototype.paging = null;

        /**
         * ListDevicePresetRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListDevicePresetRequest
         * @instance
         */
        ListDevicePresetRequest.prototype.sorting = null;

        /**
         * ListDevicePresetRequest search.
         * @member {string} search
         * @memberof pond.ListDevicePresetRequest
         * @instance
         */
        ListDevicePresetRequest.prototype.search = "";

        /**
         * Creates a new ListDevicePresetRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListDevicePresetRequest
         * @static
         * @param {pond.IListDevicePresetRequest=} [properties] Properties to set
         * @returns {pond.ListDevicePresetRequest} ListDevicePresetRequest instance
         */
        ListDevicePresetRequest.create = function create(properties) {
            return new ListDevicePresetRequest(properties);
        };

        /**
         * Creates a ListDevicePresetRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDevicePresetRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDevicePresetRequest} ListDevicePresetRequest
         */
        ListDevicePresetRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDevicePresetRequest)
                return object;
            var message = new $root.pond.ListDevicePresetRequest();
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListDevicePresetRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListDevicePresetRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            return message;
        };

        /**
         * Creates a plain object from a ListDevicePresetRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDevicePresetRequest
         * @static
         * @param {pond.ListDevicePresetRequest} message ListDevicePresetRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDevicePresetRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.paging = null;
                object.sorting = null;
                object.search = "";
            }
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            return object;
        };

        /**
         * Converts this ListDevicePresetRequest to JSON.
         * @function toJSON
         * @memberof pond.ListDevicePresetRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDevicePresetRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDevicePresetRequest;
    })();

    pond.ListDevicePresetResponse = (function() {

        /**
         * Properties of a ListDevicePresetResponse.
         * @memberof pond
         * @interface IListDevicePresetResponse
         * @property {Array.<pond.DevicePreset>|null} [presets] ListDevicePresetResponse presets
         * @property {number|null} [nextOffset] ListDevicePresetResponse nextOffset
         * @property {number|null} [total] ListDevicePresetResponse total
         */

        /**
         * Constructs a new ListDevicePresetResponse.
         * @memberof pond
         * @classdesc Represents a ListDevicePresetResponse.
         * @implements IListDevicePresetResponse
         * @constructor
         * @param {pond.IListDevicePresetResponse=} [properties] Properties to set
         */
        function ListDevicePresetResponse(properties) {
            this.presets = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListDevicePresetResponse presets.
         * @member {Array.<pond.DevicePreset>} presets
         * @memberof pond.ListDevicePresetResponse
         * @instance
         */
        ListDevicePresetResponse.prototype.presets = $util.emptyArray;

        /**
         * ListDevicePresetResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListDevicePresetResponse
         * @instance
         */
        ListDevicePresetResponse.prototype.nextOffset = 0;

        /**
         * ListDevicePresetResponse total.
         * @member {number} total
         * @memberof pond.ListDevicePresetResponse
         * @instance
         */
        ListDevicePresetResponse.prototype.total = 0;

        /**
         * Creates a new ListDevicePresetResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListDevicePresetResponse
         * @static
         * @param {pond.IListDevicePresetResponse=} [properties] Properties to set
         * @returns {pond.ListDevicePresetResponse} ListDevicePresetResponse instance
         */
        ListDevicePresetResponse.create = function create(properties) {
            return new ListDevicePresetResponse(properties);
        };

        /**
         * Creates a ListDevicePresetResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListDevicePresetResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListDevicePresetResponse} ListDevicePresetResponse
         */
        ListDevicePresetResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListDevicePresetResponse)
                return object;
            var message = new $root.pond.ListDevicePresetResponse();
            if (object.presets) {
                if (!Array.isArray(object.presets))
                    throw TypeError(".pond.ListDevicePresetResponse.presets: array expected");
                message.presets = [];
                for (var i = 0; i < object.presets.length; ++i) {
                    if (typeof object.presets[i] !== "object")
                        throw TypeError(".pond.ListDevicePresetResponse.presets: object expected");
                    message.presets[i] = $root.pond.DevicePreset.fromObject(object.presets[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListDevicePresetResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListDevicePresetResponse
         * @static
         * @param {pond.ListDevicePresetResponse} message ListDevicePresetResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListDevicePresetResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.presets = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.presets && message.presets.length) {
                object.presets = [];
                for (var j = 0; j < message.presets.length; ++j)
                    object.presets[j] = $root.pond.DevicePreset.toObject(message.presets[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListDevicePresetResponse to JSON.
         * @function toJSON
         * @memberof pond.ListDevicePresetResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListDevicePresetResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListDevicePresetResponse;
    })();

    pond.DeleteDevicePresetRequest = (function() {

        /**
         * Properties of a DeleteDevicePresetRequest.
         * @memberof pond
         * @interface IDeleteDevicePresetRequest
         * @property {string|null} [key] DeleteDevicePresetRequest key
         */

        /**
         * Constructs a new DeleteDevicePresetRequest.
         * @memberof pond
         * @classdesc Represents a DeleteDevicePresetRequest.
         * @implements IDeleteDevicePresetRequest
         * @constructor
         * @param {pond.IDeleteDevicePresetRequest=} [properties] Properties to set
         */
        function DeleteDevicePresetRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteDevicePresetRequest key.
         * @member {string} key
         * @memberof pond.DeleteDevicePresetRequest
         * @instance
         */
        DeleteDevicePresetRequest.prototype.key = "";

        /**
         * Creates a new DeleteDevicePresetRequest instance using the specified properties.
         * @function create
         * @memberof pond.DeleteDevicePresetRequest
         * @static
         * @param {pond.IDeleteDevicePresetRequest=} [properties] Properties to set
         * @returns {pond.DeleteDevicePresetRequest} DeleteDevicePresetRequest instance
         */
        DeleteDevicePresetRequest.create = function create(properties) {
            return new DeleteDevicePresetRequest(properties);
        };

        /**
         * Creates a DeleteDevicePresetRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeleteDevicePresetRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeleteDevicePresetRequest} DeleteDevicePresetRequest
         */
        DeleteDevicePresetRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeleteDevicePresetRequest)
                return object;
            var message = new $root.pond.DeleteDevicePresetRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a DeleteDevicePresetRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeleteDevicePresetRequest
         * @static
         * @param {pond.DeleteDevicePresetRequest} message DeleteDevicePresetRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteDevicePresetRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this DeleteDevicePresetRequest to JSON.
         * @function toJSON
         * @memberof pond.DeleteDevicePresetRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteDevicePresetRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeleteDevicePresetRequest;
    })();

    pond.DeleteDevicePresetResponse = (function() {

        /**
         * Properties of a DeleteDevicePresetResponse.
         * @memberof pond
         * @interface IDeleteDevicePresetResponse
         */

        /**
         * Constructs a new DeleteDevicePresetResponse.
         * @memberof pond
         * @classdesc Represents a DeleteDevicePresetResponse.
         * @implements IDeleteDevicePresetResponse
         * @constructor
         * @param {pond.IDeleteDevicePresetResponse=} [properties] Properties to set
         */
        function DeleteDevicePresetResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeleteDevicePresetResponse instance using the specified properties.
         * @function create
         * @memberof pond.DeleteDevicePresetResponse
         * @static
         * @param {pond.IDeleteDevicePresetResponse=} [properties] Properties to set
         * @returns {pond.DeleteDevicePresetResponse} DeleteDevicePresetResponse instance
         */
        DeleteDevicePresetResponse.create = function create(properties) {
            return new DeleteDevicePresetResponse(properties);
        };

        /**
         * Creates a DeleteDevicePresetResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.DeleteDevicePresetResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.DeleteDevicePresetResponse} DeleteDevicePresetResponse
         */
        DeleteDevicePresetResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.DeleteDevicePresetResponse)
                return object;
            return new $root.pond.DeleteDevicePresetResponse();
        };

        /**
         * Creates a plain object from a DeleteDevicePresetResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.DeleteDevicePresetResponse
         * @static
         * @param {pond.DeleteDevicePresetResponse} message DeleteDevicePresetResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteDevicePresetResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeleteDevicePresetResponse to JSON.
         * @function toJSON
         * @memberof pond.DeleteDevicePresetResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteDevicePresetResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeleteDevicePresetResponse;
    })();

    pond.GetDevicePresetRequest = (function() {

        /**
         * Properties of a GetDevicePresetRequest.
         * @memberof pond
         * @interface IGetDevicePresetRequest
         * @property {string|null} [key] GetDevicePresetRequest key
         */

        /**
         * Constructs a new GetDevicePresetRequest.
         * @memberof pond
         * @classdesc Represents a GetDevicePresetRequest.
         * @implements IGetDevicePresetRequest
         * @constructor
         * @param {pond.IGetDevicePresetRequest=} [properties] Properties to set
         */
        function GetDevicePresetRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePresetRequest key.
         * @member {string} key
         * @memberof pond.GetDevicePresetRequest
         * @instance
         */
        GetDevicePresetRequest.prototype.key = "";

        /**
         * Creates a new GetDevicePresetRequest instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePresetRequest
         * @static
         * @param {pond.IGetDevicePresetRequest=} [properties] Properties to set
         * @returns {pond.GetDevicePresetRequest} GetDevicePresetRequest instance
         */
        GetDevicePresetRequest.create = function create(properties) {
            return new GetDevicePresetRequest(properties);
        };

        /**
         * Creates a GetDevicePresetRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePresetRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePresetRequest} GetDevicePresetRequest
         */
        GetDevicePresetRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePresetRequest)
                return object;
            var message = new $root.pond.GetDevicePresetRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePresetRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePresetRequest
         * @static
         * @param {pond.GetDevicePresetRequest} message GetDevicePresetRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePresetRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this GetDevicePresetRequest to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePresetRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePresetRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePresetRequest;
    })();

    pond.GetDevicePresetResponse = (function() {

        /**
         * Properties of a GetDevicePresetResponse.
         * @memberof pond
         * @interface IGetDevicePresetResponse
         * @property {pond.DevicePreset|null} [preset] GetDevicePresetResponse preset
         */

        /**
         * Constructs a new GetDevicePresetResponse.
         * @memberof pond
         * @classdesc Represents a GetDevicePresetResponse.
         * @implements IGetDevicePresetResponse
         * @constructor
         * @param {pond.IGetDevicePresetResponse=} [properties] Properties to set
         */
        function GetDevicePresetResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetDevicePresetResponse preset.
         * @member {pond.DevicePreset|null|undefined} preset
         * @memberof pond.GetDevicePresetResponse
         * @instance
         */
        GetDevicePresetResponse.prototype.preset = null;

        /**
         * Creates a new GetDevicePresetResponse instance using the specified properties.
         * @function create
         * @memberof pond.GetDevicePresetResponse
         * @static
         * @param {pond.IGetDevicePresetResponse=} [properties] Properties to set
         * @returns {pond.GetDevicePresetResponse} GetDevicePresetResponse instance
         */
        GetDevicePresetResponse.create = function create(properties) {
            return new GetDevicePresetResponse(properties);
        };

        /**
         * Creates a GetDevicePresetResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.GetDevicePresetResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.GetDevicePresetResponse} GetDevicePresetResponse
         */
        GetDevicePresetResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.GetDevicePresetResponse)
                return object;
            var message = new $root.pond.GetDevicePresetResponse();
            if (object.preset != null) {
                if (typeof object.preset !== "object")
                    throw TypeError(".pond.GetDevicePresetResponse.preset: object expected");
                message.preset = $root.pond.DevicePreset.fromObject(object.preset);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetDevicePresetResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.GetDevicePresetResponse
         * @static
         * @param {pond.GetDevicePresetResponse} message GetDevicePresetResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetDevicePresetResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.preset = null;
            if (message.preset != null && message.hasOwnProperty("preset"))
                object.preset = $root.pond.DevicePreset.toObject(message.preset, options);
            return object;
        };

        /**
         * Converts this GetDevicePresetResponse to JSON.
         * @function toJSON
         * @memberof pond.GetDevicePresetResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetDevicePresetResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetDevicePresetResponse;
    })();

    /**
     * ObjectType enum.
     * @name pond.ObjectType
     * @enum {string}
     * @property {number} OBJECT_TYPE_UNKNOWN=0 OBJECT_TYPE_UNKNOWN value
     * @property {number} OBJECT_TYPE_BIN=1 OBJECT_TYPE_BIN value
     * @property {number} OBJECT_TYPE_SITE=2 OBJECT_TYPE_SITE value
     * @property {number} OBJECT_TYPE_DEVICE=3 OBJECT_TYPE_DEVICE value
     * @property {number} OBJECT_TYPE_COMPONENT=4 OBJECT_TYPE_COMPONENT value
     * @property {number} OBJECT_TYPE_INTERACTION=5 OBJECT_TYPE_INTERACTION value
     * @property {number} OBJECT_TYPE_NOTE=6 OBJECT_TYPE_NOTE value
     * @property {number} OBJECT_TYPE_FIELD=7 OBJECT_TYPE_FIELD value
     * @property {number} OBJECT_TYPE_FIELDMARKER=8 OBJECT_TYPE_FIELDMARKER value
     * @property {number} OBJECT_TYPE_HOMEMARKER=9 OBJECT_TYPE_HOMEMARKER value
     * @property {number} OBJECT_TYPE_HARVESTPLAN=10 OBJECT_TYPE_HARVESTPLAN value
     * @property {number} OBJECT_TYPE_TASK=11 OBJECT_TYPE_TASK value
     * @property {number} OBJECT_TYPE_MINE=12 OBJECT_TYPE_MINE value
     * @property {number} OBJECT_TYPE_BINYARD=13 OBJECT_TYPE_BINYARD value
     * @property {number} OBJECT_TYPE_TERMINAL=14 OBJECT_TYPE_TERMINAL value
     * @property {number} OBJECT_TYPE_GATE=15 OBJECT_TYPE_GATE value
     * @property {number} OBJECT_TYPE_FIRMWARE=16 OBJECT_TYPE_FIRMWARE value
     * @property {number} OBJECT_TYPE_GROUP=17 OBJECT_TYPE_GROUP value
     * @property {number} OBJECT_TYPE_UPGRADE=18 OBJECT_TYPE_UPGRADE value
     * @property {number} OBJECT_TYPE_USER=19 OBJECT_TYPE_USER value
     * @property {number} OBJECT_TYPE_BACKPACK=20 OBJECT_TYPE_BACKPACK value
     * @property {number} OBJECT_TYPE_HARVESTYEAR=21 OBJECT_TYPE_HARVESTYEAR value
     * @property {number} OBJECT_TYPE_TAG=22 OBJECT_TYPE_TAG value
     * @property {number} OBJECT_TYPE_TEAM=23 OBJECT_TYPE_TEAM value
     * @property {number} OBJECT_TYPE_LINK=24 OBJECT_TYPE_LINK value
     * @property {number} OBJECT_TYPE_HEATER=25 OBJECT_TYPE_HEATER value
     * @property {number} OBJECT_TYPE_GRAIN_BAG=26 OBJECT_TYPE_GRAIN_BAG value
     * @property {number} OBJECT_TYPE_CONTRACT=27 OBJECT_TYPE_CONTRACT value
     * @property {number} OBJECT_TYPE_TRANSACTION=28 OBJECT_TYPE_TRANSACTION value
     * @property {number} OBJECT_TYPE_FILE=29 OBJECT_TYPE_FILE value
     * @property {number} OBJECT_TYPE_NOTIFICATION_BANNER=30 OBJECT_TYPE_NOTIFICATION_BANNER value
     * @property {number} OBJECT_TYPE_DEVICE_PRESET=31 OBJECT_TYPE_DEVICE_PRESET value
     */
    pond.ObjectType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OBJECT_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "OBJECT_TYPE_BIN"] = 1;
        values[valuesById[2] = "OBJECT_TYPE_SITE"] = 2;
        values[valuesById[3] = "OBJECT_TYPE_DEVICE"] = 3;
        values[valuesById[4] = "OBJECT_TYPE_COMPONENT"] = 4;
        values[valuesById[5] = "OBJECT_TYPE_INTERACTION"] = 5;
        values[valuesById[6] = "OBJECT_TYPE_NOTE"] = 6;
        values[valuesById[7] = "OBJECT_TYPE_FIELD"] = 7;
        values[valuesById[8] = "OBJECT_TYPE_FIELDMARKER"] = 8;
        values[valuesById[9] = "OBJECT_TYPE_HOMEMARKER"] = 9;
        values[valuesById[10] = "OBJECT_TYPE_HARVESTPLAN"] = 10;
        values[valuesById[11] = "OBJECT_TYPE_TASK"] = 11;
        values[valuesById[12] = "OBJECT_TYPE_MINE"] = 12;
        values[valuesById[13] = "OBJECT_TYPE_BINYARD"] = 13;
        values[valuesById[14] = "OBJECT_TYPE_TERMINAL"] = 14;
        values[valuesById[15] = "OBJECT_TYPE_GATE"] = 15;
        values[valuesById[16] = "OBJECT_TYPE_FIRMWARE"] = 16;
        values[valuesById[17] = "OBJECT_TYPE_GROUP"] = 17;
        values[valuesById[18] = "OBJECT_TYPE_UPGRADE"] = 18;
        values[valuesById[19] = "OBJECT_TYPE_USER"] = 19;
        values[valuesById[20] = "OBJECT_TYPE_BACKPACK"] = 20;
        values[valuesById[21] = "OBJECT_TYPE_HARVESTYEAR"] = 21;
        values[valuesById[22] = "OBJECT_TYPE_TAG"] = 22;
        values[valuesById[23] = "OBJECT_TYPE_TEAM"] = 23;
        values[valuesById[24] = "OBJECT_TYPE_LINK"] = 24;
        values[valuesById[25] = "OBJECT_TYPE_HEATER"] = 25;
        values[valuesById[26] = "OBJECT_TYPE_GRAIN_BAG"] = 26;
        values[valuesById[27] = "OBJECT_TYPE_CONTRACT"] = 27;
        values[valuesById[28] = "OBJECT_TYPE_TRANSACTION"] = 28;
        values[valuesById[29] = "OBJECT_TYPE_FILE"] = 29;
        values[valuesById[30] = "OBJECT_TYPE_NOTIFICATION_BANNER"] = 30;
        values[valuesById[31] = "OBJECT_TYPE_DEVICE_PRESET"] = 31;
        return values;
    })();

    pond.ObjectSettings = (function() {

        /**
         * Properties of an ObjectSettings.
         * @memberof pond
         * @interface IObjectSettings
         * @property {pond.TaskSettings|null} [taskSettings] ObjectSettings taskSettings
         * @property {pond.TerminalSettings|null} [terminalSettings] ObjectSettings terminalSettings
         * @property {pond.GateSettings|null} [gateSettings] ObjectSettings gateSettings
         * @property {pond.DeviceSettings|null} [deviceSettings] ObjectSettings deviceSettings
         * @property {pond.ComponentSettings|null} [componentSettings] ObjectSettings componentSettings
         * @property {pond.InteractionSettings|null} [interactionSettings] ObjectSettings interactionSettings
         * @property {pond.BinSettings|null} [binSettings] ObjectSettings binSettings
         * @property {pond.SiteSettings|null} [siteSettings] ObjectSettings siteSettings
         * @property {pond.NoteSettings|null} [noteSettings] ObjectSettings noteSettings
         * @property {pond.FieldSettings|null} [fieldSettings] ObjectSettings fieldSettings
         * @property {pond.FieldMarkerSettings|null} [fieldMarkerSettings] ObjectSettings fieldMarkerSettings
         * @property {pond.HomeMarkerSettings|null} [homeMarkerSettings] ObjectSettings homeMarkerSettings
         * @property {pond.HarvestPlanSettings|null} [harvestPlanSettings] ObjectSettings harvestPlanSettings
         * @property {pond.MineSettings|null} [mineSettings] ObjectSettings mineSettings
         * @property {pond.BinYardSettings|null} [binyardSettings] ObjectSettings binyardSettings
         * @property {pond.FirmwareSettings|null} [firmwareSettings] ObjectSettings firmwareSettings
         * @property {pond.GroupSettings|null} [groupSettings] ObjectSettings groupSettings
         * @property {pond.UpgradeSettings|null} [upgradeSettings] ObjectSettings upgradeSettings
         * @property {pond.UserSettings|null} [userSettings] ObjectSettings userSettings
         * @property {pond.BackpackSettings|null} [backpackSettings] ObjectSettings backpackSettings
         * @property {pond.HarvestYearSettings|null} [harvestYearSettings] ObjectSettings harvestYearSettings
         * @property {pond.TagSettings|null} [tagSettings] ObjectSettings tagSettings
         * @property {pond.TeamSettings|null} [teamSettings] ObjectSettings teamSettings
         * @property {pond.ShareableLinkSettings|null} [linkSettings] ObjectSettings linkSettings
         * @property {pond.ObjectHeaterSettings|null} [heaterSettings] ObjectSettings heaterSettings
         * @property {pond.GrainBagSettings|null} [grainBagSettings] ObjectSettings grainBagSettings
         * @property {pond.ContractSettings|null} [contractSettings] ObjectSettings contractSettings
         * @property {pond.NotificationBannerSettings|null} [notificationBannerSettings] ObjectSettings notificationBannerSettings
         * @property {pond.DevicePresetSettings|null} [devicePresetSettings] ObjectSettings devicePresetSettings
         */

        /**
         * Constructs a new ObjectSettings.
         * @memberof pond
         * @classdesc Represents an ObjectSettings.
         * @implements IObjectSettings
         * @constructor
         * @param {pond.IObjectSettings=} [properties] Properties to set
         */
        function ObjectSettings(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectSettings taskSettings.
         * @member {pond.TaskSettings|null|undefined} taskSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.taskSettings = null;

        /**
         * ObjectSettings terminalSettings.
         * @member {pond.TerminalSettings|null|undefined} terminalSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.terminalSettings = null;

        /**
         * ObjectSettings gateSettings.
         * @member {pond.GateSettings|null|undefined} gateSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.gateSettings = null;

        /**
         * ObjectSettings deviceSettings.
         * @member {pond.DeviceSettings|null|undefined} deviceSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.deviceSettings = null;

        /**
         * ObjectSettings componentSettings.
         * @member {pond.ComponentSettings|null|undefined} componentSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.componentSettings = null;

        /**
         * ObjectSettings interactionSettings.
         * @member {pond.InteractionSettings|null|undefined} interactionSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.interactionSettings = null;

        /**
         * ObjectSettings binSettings.
         * @member {pond.BinSettings|null|undefined} binSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.binSettings = null;

        /**
         * ObjectSettings siteSettings.
         * @member {pond.SiteSettings|null|undefined} siteSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.siteSettings = null;

        /**
         * ObjectSettings noteSettings.
         * @member {pond.NoteSettings|null|undefined} noteSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.noteSettings = null;

        /**
         * ObjectSettings fieldSettings.
         * @member {pond.FieldSettings|null|undefined} fieldSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.fieldSettings = null;

        /**
         * ObjectSettings fieldMarkerSettings.
         * @member {pond.FieldMarkerSettings|null|undefined} fieldMarkerSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.fieldMarkerSettings = null;

        /**
         * ObjectSettings homeMarkerSettings.
         * @member {pond.HomeMarkerSettings|null|undefined} homeMarkerSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.homeMarkerSettings = null;

        /**
         * ObjectSettings harvestPlanSettings.
         * @member {pond.HarvestPlanSettings|null|undefined} harvestPlanSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.harvestPlanSettings = null;

        /**
         * ObjectSettings mineSettings.
         * @member {pond.MineSettings|null|undefined} mineSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.mineSettings = null;

        /**
         * ObjectSettings binyardSettings.
         * @member {pond.BinYardSettings|null|undefined} binyardSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.binyardSettings = null;

        /**
         * ObjectSettings firmwareSettings.
         * @member {pond.FirmwareSettings|null|undefined} firmwareSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.firmwareSettings = null;

        /**
         * ObjectSettings groupSettings.
         * @member {pond.GroupSettings|null|undefined} groupSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.groupSettings = null;

        /**
         * ObjectSettings upgradeSettings.
         * @member {pond.UpgradeSettings|null|undefined} upgradeSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.upgradeSettings = null;

        /**
         * ObjectSettings userSettings.
         * @member {pond.UserSettings|null|undefined} userSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.userSettings = null;

        /**
         * ObjectSettings backpackSettings.
         * @member {pond.BackpackSettings|null|undefined} backpackSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.backpackSettings = null;

        /**
         * ObjectSettings harvestYearSettings.
         * @member {pond.HarvestYearSettings|null|undefined} harvestYearSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.harvestYearSettings = null;

        /**
         * ObjectSettings tagSettings.
         * @member {pond.TagSettings|null|undefined} tagSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.tagSettings = null;

        /**
         * ObjectSettings teamSettings.
         * @member {pond.TeamSettings|null|undefined} teamSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.teamSettings = null;

        /**
         * ObjectSettings linkSettings.
         * @member {pond.ShareableLinkSettings|null|undefined} linkSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.linkSettings = null;

        /**
         * ObjectSettings heaterSettings.
         * @member {pond.ObjectHeaterSettings|null|undefined} heaterSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.heaterSettings = null;

        /**
         * ObjectSettings grainBagSettings.
         * @member {pond.GrainBagSettings|null|undefined} grainBagSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.grainBagSettings = null;

        /**
         * ObjectSettings contractSettings.
         * @member {pond.ContractSettings|null|undefined} contractSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.contractSettings = null;

        /**
         * ObjectSettings notificationBannerSettings.
         * @member {pond.NotificationBannerSettings|null|undefined} notificationBannerSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.notificationBannerSettings = null;

        /**
         * ObjectSettings devicePresetSettings.
         * @member {pond.DevicePresetSettings|null|undefined} devicePresetSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        ObjectSettings.prototype.devicePresetSettings = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * ObjectSettings objectSettings.
         * @member {"taskSettings"|"terminalSettings"|"gateSettings"|"deviceSettings"|"componentSettings"|"interactionSettings"|"binSettings"|"siteSettings"|"noteSettings"|"fieldSettings"|"fieldMarkerSettings"|"homeMarkerSettings"|"harvestPlanSettings"|"mineSettings"|"binyardSettings"|"firmwareSettings"|"groupSettings"|"upgradeSettings"|"userSettings"|"backpackSettings"|"harvestYearSettings"|"tagSettings"|"teamSettings"|"linkSettings"|"heaterSettings"|"grainBagSettings"|"contractSettings"|"notificationBannerSettings"|"devicePresetSettings"|undefined} objectSettings
         * @memberof pond.ObjectSettings
         * @instance
         */
        Object.defineProperty(ObjectSettings.prototype, "objectSettings", {
            get: $util.oneOfGetter($oneOfFields = ["taskSettings", "terminalSettings", "gateSettings", "deviceSettings", "componentSettings", "interactionSettings", "binSettings", "siteSettings", "noteSettings", "fieldSettings", "fieldMarkerSettings", "homeMarkerSettings", "harvestPlanSettings", "mineSettings", "binyardSettings", "firmwareSettings", "groupSettings", "upgradeSettings", "userSettings", "backpackSettings", "harvestYearSettings", "tagSettings", "teamSettings", "linkSettings", "heaterSettings", "grainBagSettings", "contractSettings", "notificationBannerSettings", "devicePresetSettings"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ObjectSettings instance using the specified properties.
         * @function create
         * @memberof pond.ObjectSettings
         * @static
         * @param {pond.IObjectSettings=} [properties] Properties to set
         * @returns {pond.ObjectSettings} ObjectSettings instance
         */
        ObjectSettings.create = function create(properties) {
            return new ObjectSettings(properties);
        };

        /**
         * Creates an ObjectSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectSettings} ObjectSettings
         */
        ObjectSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectSettings)
                return object;
            var message = new $root.pond.ObjectSettings();
            if (object.taskSettings != null) {
                if (typeof object.taskSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.taskSettings: object expected");
                message.taskSettings = $root.pond.TaskSettings.fromObject(object.taskSettings);
            }
            if (object.terminalSettings != null) {
                if (typeof object.terminalSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.terminalSettings: object expected");
                message.terminalSettings = $root.pond.TerminalSettings.fromObject(object.terminalSettings);
            }
            if (object.gateSettings != null) {
                if (typeof object.gateSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.gateSettings: object expected");
                message.gateSettings = $root.pond.GateSettings.fromObject(object.gateSettings);
            }
            if (object.deviceSettings != null) {
                if (typeof object.deviceSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.deviceSettings: object expected");
                message.deviceSettings = $root.pond.DeviceSettings.fromObject(object.deviceSettings);
            }
            if (object.componentSettings != null) {
                if (typeof object.componentSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.componentSettings: object expected");
                message.componentSettings = $root.pond.ComponentSettings.fromObject(object.componentSettings);
            }
            if (object.interactionSettings != null) {
                if (typeof object.interactionSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.interactionSettings: object expected");
                message.interactionSettings = $root.pond.InteractionSettings.fromObject(object.interactionSettings);
            }
            if (object.binSettings != null) {
                if (typeof object.binSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.binSettings: object expected");
                message.binSettings = $root.pond.BinSettings.fromObject(object.binSettings);
            }
            if (object.siteSettings != null) {
                if (typeof object.siteSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.siteSettings: object expected");
                message.siteSettings = $root.pond.SiteSettings.fromObject(object.siteSettings);
            }
            if (object.noteSettings != null) {
                if (typeof object.noteSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.noteSettings: object expected");
                message.noteSettings = $root.pond.NoteSettings.fromObject(object.noteSettings);
            }
            if (object.fieldSettings != null) {
                if (typeof object.fieldSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.fieldSettings: object expected");
                message.fieldSettings = $root.pond.FieldSettings.fromObject(object.fieldSettings);
            }
            if (object.fieldMarkerSettings != null) {
                if (typeof object.fieldMarkerSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.fieldMarkerSettings: object expected");
                message.fieldMarkerSettings = $root.pond.FieldMarkerSettings.fromObject(object.fieldMarkerSettings);
            }
            if (object.homeMarkerSettings != null) {
                if (typeof object.homeMarkerSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.homeMarkerSettings: object expected");
                message.homeMarkerSettings = $root.pond.HomeMarkerSettings.fromObject(object.homeMarkerSettings);
            }
            if (object.harvestPlanSettings != null) {
                if (typeof object.harvestPlanSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.harvestPlanSettings: object expected");
                message.harvestPlanSettings = $root.pond.HarvestPlanSettings.fromObject(object.harvestPlanSettings);
            }
            if (object.mineSettings != null) {
                if (typeof object.mineSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.mineSettings: object expected");
                message.mineSettings = $root.pond.MineSettings.fromObject(object.mineSettings);
            }
            if (object.binyardSettings != null) {
                if (typeof object.binyardSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.binyardSettings: object expected");
                message.binyardSettings = $root.pond.BinYardSettings.fromObject(object.binyardSettings);
            }
            if (object.firmwareSettings != null) {
                if (typeof object.firmwareSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.firmwareSettings: object expected");
                message.firmwareSettings = $root.pond.FirmwareSettings.fromObject(object.firmwareSettings);
            }
            if (object.groupSettings != null) {
                if (typeof object.groupSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.groupSettings: object expected");
                message.groupSettings = $root.pond.GroupSettings.fromObject(object.groupSettings);
            }
            if (object.upgradeSettings != null) {
                if (typeof object.upgradeSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.upgradeSettings: object expected");
                message.upgradeSettings = $root.pond.UpgradeSettings.fromObject(object.upgradeSettings);
            }
            if (object.userSettings != null) {
                if (typeof object.userSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.userSettings: object expected");
                message.userSettings = $root.pond.UserSettings.fromObject(object.userSettings);
            }
            if (object.backpackSettings != null) {
                if (typeof object.backpackSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.backpackSettings: object expected");
                message.backpackSettings = $root.pond.BackpackSettings.fromObject(object.backpackSettings);
            }
            if (object.harvestYearSettings != null) {
                if (typeof object.harvestYearSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.harvestYearSettings: object expected");
                message.harvestYearSettings = $root.pond.HarvestYearSettings.fromObject(object.harvestYearSettings);
            }
            if (object.tagSettings != null) {
                if (typeof object.tagSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.tagSettings: object expected");
                message.tagSettings = $root.pond.TagSettings.fromObject(object.tagSettings);
            }
            if (object.teamSettings != null) {
                if (typeof object.teamSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.teamSettings: object expected");
                message.teamSettings = $root.pond.TeamSettings.fromObject(object.teamSettings);
            }
            if (object.linkSettings != null) {
                if (typeof object.linkSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.linkSettings: object expected");
                message.linkSettings = $root.pond.ShareableLinkSettings.fromObject(object.linkSettings);
            }
            if (object.heaterSettings != null) {
                if (typeof object.heaterSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.heaterSettings: object expected");
                message.heaterSettings = $root.pond.ObjectHeaterSettings.fromObject(object.heaterSettings);
            }
            if (object.grainBagSettings != null) {
                if (typeof object.grainBagSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.grainBagSettings: object expected");
                message.grainBagSettings = $root.pond.GrainBagSettings.fromObject(object.grainBagSettings);
            }
            if (object.contractSettings != null) {
                if (typeof object.contractSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.contractSettings: object expected");
                message.contractSettings = $root.pond.ContractSettings.fromObject(object.contractSettings);
            }
            if (object.notificationBannerSettings != null) {
                if (typeof object.notificationBannerSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.notificationBannerSettings: object expected");
                message.notificationBannerSettings = $root.pond.NotificationBannerSettings.fromObject(object.notificationBannerSettings);
            }
            if (object.devicePresetSettings != null) {
                if (typeof object.devicePresetSettings !== "object")
                    throw TypeError(".pond.ObjectSettings.devicePresetSettings: object expected");
                message.devicePresetSettings = $root.pond.DevicePresetSettings.fromObject(object.devicePresetSettings);
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectSettings
         * @static
         * @param {pond.ObjectSettings} message ObjectSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (message.taskSettings != null && message.hasOwnProperty("taskSettings")) {
                object.taskSettings = $root.pond.TaskSettings.toObject(message.taskSettings, options);
                if (options.oneofs)
                    object.objectSettings = "taskSettings";
            }
            if (message.terminalSettings != null && message.hasOwnProperty("terminalSettings")) {
                object.terminalSettings = $root.pond.TerminalSettings.toObject(message.terminalSettings, options);
                if (options.oneofs)
                    object.objectSettings = "terminalSettings";
            }
            if (message.gateSettings != null && message.hasOwnProperty("gateSettings")) {
                object.gateSettings = $root.pond.GateSettings.toObject(message.gateSettings, options);
                if (options.oneofs)
                    object.objectSettings = "gateSettings";
            }
            if (message.deviceSettings != null && message.hasOwnProperty("deviceSettings")) {
                object.deviceSettings = $root.pond.DeviceSettings.toObject(message.deviceSettings, options);
                if (options.oneofs)
                    object.objectSettings = "deviceSettings";
            }
            if (message.componentSettings != null && message.hasOwnProperty("componentSettings")) {
                object.componentSettings = $root.pond.ComponentSettings.toObject(message.componentSettings, options);
                if (options.oneofs)
                    object.objectSettings = "componentSettings";
            }
            if (message.interactionSettings != null && message.hasOwnProperty("interactionSettings")) {
                object.interactionSettings = $root.pond.InteractionSettings.toObject(message.interactionSettings, options);
                if (options.oneofs)
                    object.objectSettings = "interactionSettings";
            }
            if (message.binSettings != null && message.hasOwnProperty("binSettings")) {
                object.binSettings = $root.pond.BinSettings.toObject(message.binSettings, options);
                if (options.oneofs)
                    object.objectSettings = "binSettings";
            }
            if (message.siteSettings != null && message.hasOwnProperty("siteSettings")) {
                object.siteSettings = $root.pond.SiteSettings.toObject(message.siteSettings, options);
                if (options.oneofs)
                    object.objectSettings = "siteSettings";
            }
            if (message.noteSettings != null && message.hasOwnProperty("noteSettings")) {
                object.noteSettings = $root.pond.NoteSettings.toObject(message.noteSettings, options);
                if (options.oneofs)
                    object.objectSettings = "noteSettings";
            }
            if (message.fieldSettings != null && message.hasOwnProperty("fieldSettings")) {
                object.fieldSettings = $root.pond.FieldSettings.toObject(message.fieldSettings, options);
                if (options.oneofs)
                    object.objectSettings = "fieldSettings";
            }
            if (message.fieldMarkerSettings != null && message.hasOwnProperty("fieldMarkerSettings")) {
                object.fieldMarkerSettings = $root.pond.FieldMarkerSettings.toObject(message.fieldMarkerSettings, options);
                if (options.oneofs)
                    object.objectSettings = "fieldMarkerSettings";
            }
            if (message.homeMarkerSettings != null && message.hasOwnProperty("homeMarkerSettings")) {
                object.homeMarkerSettings = $root.pond.HomeMarkerSettings.toObject(message.homeMarkerSettings, options);
                if (options.oneofs)
                    object.objectSettings = "homeMarkerSettings";
            }
            if (message.harvestPlanSettings != null && message.hasOwnProperty("harvestPlanSettings")) {
                object.harvestPlanSettings = $root.pond.HarvestPlanSettings.toObject(message.harvestPlanSettings, options);
                if (options.oneofs)
                    object.objectSettings = "harvestPlanSettings";
            }
            if (message.mineSettings != null && message.hasOwnProperty("mineSettings")) {
                object.mineSettings = $root.pond.MineSettings.toObject(message.mineSettings, options);
                if (options.oneofs)
                    object.objectSettings = "mineSettings";
            }
            if (message.binyardSettings != null && message.hasOwnProperty("binyardSettings")) {
                object.binyardSettings = $root.pond.BinYardSettings.toObject(message.binyardSettings, options);
                if (options.oneofs)
                    object.objectSettings = "binyardSettings";
            }
            if (message.firmwareSettings != null && message.hasOwnProperty("firmwareSettings")) {
                object.firmwareSettings = $root.pond.FirmwareSettings.toObject(message.firmwareSettings, options);
                if (options.oneofs)
                    object.objectSettings = "firmwareSettings";
            }
            if (message.groupSettings != null && message.hasOwnProperty("groupSettings")) {
                object.groupSettings = $root.pond.GroupSettings.toObject(message.groupSettings, options);
                if (options.oneofs)
                    object.objectSettings = "groupSettings";
            }
            if (message.upgradeSettings != null && message.hasOwnProperty("upgradeSettings")) {
                object.upgradeSettings = $root.pond.UpgradeSettings.toObject(message.upgradeSettings, options);
                if (options.oneofs)
                    object.objectSettings = "upgradeSettings";
            }
            if (message.userSettings != null && message.hasOwnProperty("userSettings")) {
                object.userSettings = $root.pond.UserSettings.toObject(message.userSettings, options);
                if (options.oneofs)
                    object.objectSettings = "userSettings";
            }
            if (message.backpackSettings != null && message.hasOwnProperty("backpackSettings")) {
                object.backpackSettings = $root.pond.BackpackSettings.toObject(message.backpackSettings, options);
                if (options.oneofs)
                    object.objectSettings = "backpackSettings";
            }
            if (message.harvestYearSettings != null && message.hasOwnProperty("harvestYearSettings")) {
                object.harvestYearSettings = $root.pond.HarvestYearSettings.toObject(message.harvestYearSettings, options);
                if (options.oneofs)
                    object.objectSettings = "harvestYearSettings";
            }
            if (message.tagSettings != null && message.hasOwnProperty("tagSettings")) {
                object.tagSettings = $root.pond.TagSettings.toObject(message.tagSettings, options);
                if (options.oneofs)
                    object.objectSettings = "tagSettings";
            }
            if (message.teamSettings != null && message.hasOwnProperty("teamSettings")) {
                object.teamSettings = $root.pond.TeamSettings.toObject(message.teamSettings, options);
                if (options.oneofs)
                    object.objectSettings = "teamSettings";
            }
            if (message.linkSettings != null && message.hasOwnProperty("linkSettings")) {
                object.linkSettings = $root.pond.ShareableLinkSettings.toObject(message.linkSettings, options);
                if (options.oneofs)
                    object.objectSettings = "linkSettings";
            }
            if (message.heaterSettings != null && message.hasOwnProperty("heaterSettings")) {
                object.heaterSettings = $root.pond.ObjectHeaterSettings.toObject(message.heaterSettings, options);
                if (options.oneofs)
                    object.objectSettings = "heaterSettings";
            }
            if (message.grainBagSettings != null && message.hasOwnProperty("grainBagSettings")) {
                object.grainBagSettings = $root.pond.GrainBagSettings.toObject(message.grainBagSettings, options);
                if (options.oneofs)
                    object.objectSettings = "grainBagSettings";
            }
            if (message.contractSettings != null && message.hasOwnProperty("contractSettings")) {
                object.contractSettings = $root.pond.ContractSettings.toObject(message.contractSettings, options);
                if (options.oneofs)
                    object.objectSettings = "contractSettings";
            }
            if (message.notificationBannerSettings != null && message.hasOwnProperty("notificationBannerSettings")) {
                object.notificationBannerSettings = $root.pond.NotificationBannerSettings.toObject(message.notificationBannerSettings, options);
                if (options.oneofs)
                    object.objectSettings = "notificationBannerSettings";
            }
            if (message.devicePresetSettings != null && message.hasOwnProperty("devicePresetSettings")) {
                object.devicePresetSettings = $root.pond.DevicePresetSettings.toObject(message.devicePresetSettings, options);
                if (options.oneofs)
                    object.objectSettings = "devicePresetSettings";
            }
            return object;
        };

        /**
         * Converts this ObjectSettings to JSON.
         * @function toJSON
         * @memberof pond.ObjectSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectSettings;
    })();

    pond.ObjectMeasurement = (function() {

        /**
         * Properties of an ObjectMeasurement.
         * @memberof pond
         * @interface IObjectMeasurement
         * @property {string|null} [objectKey] ObjectMeasurement objectKey
         * @property {number|null} [objectType] ObjectMeasurement objectType
         * @property {quack.MeasurementType|null} [unit] ObjectMeasurement unit
         * @property {pond.ValueArray|null} [values] ObjectMeasurement values
         */

        /**
         * Constructs a new ObjectMeasurement.
         * @memberof pond
         * @classdesc Represents an ObjectMeasurement.
         * @implements IObjectMeasurement
         * @constructor
         * @param {pond.IObjectMeasurement=} [properties] Properties to set
         */
        function ObjectMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectMeasurement objectKey.
         * @member {string} objectKey
         * @memberof pond.ObjectMeasurement
         * @instance
         */
        ObjectMeasurement.prototype.objectKey = "";

        /**
         * ObjectMeasurement objectType.
         * @member {number} objectType
         * @memberof pond.ObjectMeasurement
         * @instance
         */
        ObjectMeasurement.prototype.objectType = 0;

        /**
         * ObjectMeasurement unit.
         * @member {quack.MeasurementType} unit
         * @memberof pond.ObjectMeasurement
         * @instance
         */
        ObjectMeasurement.prototype.unit = 0;

        /**
         * ObjectMeasurement values.
         * @member {pond.ValueArray|null|undefined} values
         * @memberof pond.ObjectMeasurement
         * @instance
         */
        ObjectMeasurement.prototype.values = null;

        /**
         * Creates a new ObjectMeasurement instance using the specified properties.
         * @function create
         * @memberof pond.ObjectMeasurement
         * @static
         * @param {pond.IObjectMeasurement=} [properties] Properties to set
         * @returns {pond.ObjectMeasurement} ObjectMeasurement instance
         */
        ObjectMeasurement.create = function create(properties) {
            return new ObjectMeasurement(properties);
        };

        /**
         * Creates an ObjectMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectMeasurement} ObjectMeasurement
         */
        ObjectMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectMeasurement)
                return object;
            var message = new $root.pond.ObjectMeasurement();
            if (object.objectKey != null)
                message.objectKey = String(object.objectKey);
            if (object.objectType != null)
                message.objectType = object.objectType >>> 0;
            switch (object.unit) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.unit = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.unit = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.unit = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.unit = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.unit = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.unit = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.unit = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.unit = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.unit = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.unit = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.unit = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.unit = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.unit = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.unit = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.unit = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.unit = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.unit = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.unit = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.unit = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.unit = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.unit = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.unit = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.unit = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.unit = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.unit = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.unit = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.unit = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.unit = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.unit = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.unit = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.unit = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.unit = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.unit = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.unit = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.unit = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.unit = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.unit = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.unit = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.unit = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.unit = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.unit = 40;
                break;
            }
            if (object.values != null) {
                if (typeof object.values !== "object")
                    throw TypeError(".pond.ObjectMeasurement.values: object expected");
                message.values = $root.pond.ValueArray.fromObject(object.values);
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectMeasurement
         * @static
         * @param {pond.ObjectMeasurement} message ObjectMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.objectKey = "";
                object.objectType = 0;
                object.unit = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
                object.values = null;
            }
            if (message.objectKey != null && message.hasOwnProperty("objectKey"))
                object.objectKey = message.objectKey;
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = message.objectType;
            if (message.unit != null && message.hasOwnProperty("unit"))
                object.unit = options.enums === String ? $root.quack.MeasurementType[message.unit] : message.unit;
            if (message.values != null && message.hasOwnProperty("values"))
                object.values = $root.pond.ValueArray.toObject(message.values, options);
            return object;
        };

        /**
         * Converts this ObjectMeasurement to JSON.
         * @function toJSON
         * @memberof pond.ObjectMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectMeasurement;
    })();

    pond.ObjectData = (function() {

        /**
         * Properties of an ObjectData.
         * @memberof pond
         * @interface IObjectData
         */

        /**
         * Constructs a new ObjectData.
         * @memberof pond
         * @classdesc Represents an ObjectData.
         * @implements IObjectData
         * @constructor
         * @param {pond.IObjectData=} [properties] Properties to set
         */
        function ObjectData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ObjectData instance using the specified properties.
         * @function create
         * @memberof pond.ObjectData
         * @static
         * @param {pond.IObjectData=} [properties] Properties to set
         * @returns {pond.ObjectData} ObjectData instance
         */
        ObjectData.create = function create(properties) {
            return new ObjectData(properties);
        };

        /**
         * Creates an ObjectData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectData} ObjectData
         */
        ObjectData.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectData)
                return object;
            return new $root.pond.ObjectData();
        };

        /**
         * Creates a plain object from an ObjectData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectData
         * @static
         * @param {pond.ObjectData} message ObjectData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectData.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ObjectData to JSON.
         * @function toJSON
         * @memberof pond.ObjectData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectData;
    })();

    pond.ObjectTemplate = (function() {

        /**
         * Properties of an ObjectTemplate.
         * @memberof pond
         * @interface IObjectTemplate
         * @property {string|null} [key] ObjectTemplate key
         * @property {string|null} [name] ObjectTemplate name
         * @property {pond.ObjectType|null} [type] ObjectTemplate type
         * @property {pond.ObjectTheme|null} [theme] ObjectTemplate theme
         * @property {pond.ObjectSettings|null} [settings] ObjectTemplate settings
         * @property {pond.ObjectData|null} [data] ObjectTemplate data
         */

        /**
         * Constructs a new ObjectTemplate.
         * @memberof pond
         * @classdesc Represents an ObjectTemplate.
         * @implements IObjectTemplate
         * @constructor
         * @param {pond.IObjectTemplate=} [properties] Properties to set
         */
        function ObjectTemplate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ObjectTemplate key.
         * @member {string} key
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.key = "";

        /**
         * ObjectTemplate name.
         * @member {string} name
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.name = "";

        /**
         * ObjectTemplate type.
         * @member {pond.ObjectType} type
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.type = 0;

        /**
         * ObjectTemplate theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.theme = null;

        /**
         * ObjectTemplate settings.
         * @member {pond.ObjectSettings|null|undefined} settings
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.settings = null;

        /**
         * ObjectTemplate data.
         * @member {pond.ObjectData|null|undefined} data
         * @memberof pond.ObjectTemplate
         * @instance
         */
        ObjectTemplate.prototype.data = null;

        /**
         * Creates a new ObjectTemplate instance using the specified properties.
         * @function create
         * @memberof pond.ObjectTemplate
         * @static
         * @param {pond.IObjectTemplate=} [properties] Properties to set
         * @returns {pond.ObjectTemplate} ObjectTemplate instance
         */
        ObjectTemplate.create = function create(properties) {
            return new ObjectTemplate(properties);
        };

        /**
         * Creates an ObjectTemplate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ObjectTemplate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ObjectTemplate} ObjectTemplate
         */
        ObjectTemplate.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ObjectTemplate)
                return object;
            var message = new $root.pond.ObjectTemplate();
            if (object.key != null)
                message.key = String(object.key);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.type) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.type = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.type = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.type = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.type = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.type = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.type = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.type = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.type = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.type = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.type = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.type = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.type = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.type = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.type = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.type = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.type = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.type = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.type = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.type = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.type = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.type = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.type = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.type = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.type = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.type = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.type = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.type = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.type = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.type = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.type = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.type = 31;
                break;
            }
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.ObjectTemplate.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.ObjectTemplate.settings: object expected");
                message.settings = $root.pond.ObjectSettings.fromObject(object.settings);
            }
            if (object.data != null) {
                if (typeof object.data !== "object")
                    throw TypeError(".pond.ObjectTemplate.data: object expected");
                message.data = $root.pond.ObjectData.fromObject(object.data);
            }
            return message;
        };

        /**
         * Creates a plain object from an ObjectTemplate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ObjectTemplate
         * @static
         * @param {pond.ObjectTemplate} message ObjectTemplate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ObjectTemplate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.name = "";
                object.type = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.theme = null;
                object.settings = null;
                object.data = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.ObjectType[message.type] : message.type;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectSettings.toObject(message.settings, options);
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = $root.pond.ObjectData.toObject(message.data, options);
            return object;
        };

        /**
         * Converts this ObjectTemplate to JSON.
         * @function toJSON
         * @memberof pond.ObjectTemplate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ObjectTemplate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ObjectTemplate;
    })();

    pond.AddObjectRequest = (function() {

        /**
         * Properties of an AddObjectRequest.
         * @memberof pond
         * @interface IAddObjectRequest
         * @property {pond.ObjectType|null} [type] AddObjectRequest type
         * @property {string|null} [name] AddObjectRequest name
         * @property {pond.ObjectSettings|null} [settings] AddObjectRequest settings
         * @property {pond.ObjectTheme|null} [theme] AddObjectRequest theme
         * @property {string|null} [parent] AddObjectRequest parent
         * @property {string|null} [parentType] AddObjectRequest parentType
         * @property {pond.ObjectData|null} [data] AddObjectRequest data
         * @property {string|null} [typeString] AddObjectRequest typeString
         */

        /**
         * Constructs a new AddObjectRequest.
         * @memberof pond
         * @classdesc Represents an AddObjectRequest.
         * @implements IAddObjectRequest
         * @constructor
         * @param {pond.IAddObjectRequest=} [properties] Properties to set
         */
        function AddObjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectRequest type.
         * @member {pond.ObjectType} type
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.type = 0;

        /**
         * AddObjectRequest name.
         * @member {string} name
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.name = "";

        /**
         * AddObjectRequest settings.
         * @member {pond.ObjectSettings|null|undefined} settings
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.settings = null;

        /**
         * AddObjectRequest theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.theme = null;

        /**
         * AddObjectRequest parent.
         * @member {string} parent
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.parent = "";

        /**
         * AddObjectRequest parentType.
         * @member {string} parentType
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.parentType = "";

        /**
         * AddObjectRequest data.
         * @member {pond.ObjectData|null|undefined} data
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.data = null;

        /**
         * AddObjectRequest typeString.
         * @member {string} typeString
         * @memberof pond.AddObjectRequest
         * @instance
         */
        AddObjectRequest.prototype.typeString = "";

        /**
         * Creates a new AddObjectRequest instance using the specified properties.
         * @function create
         * @memberof pond.AddObjectRequest
         * @static
         * @param {pond.IAddObjectRequest=} [properties] Properties to set
         * @returns {pond.AddObjectRequest} AddObjectRequest instance
         */
        AddObjectRequest.create = function create(properties) {
            return new AddObjectRequest(properties);
        };

        /**
         * Creates an AddObjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddObjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddObjectRequest} AddObjectRequest
         */
        AddObjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddObjectRequest)
                return object;
            var message = new $root.pond.AddObjectRequest();
            switch (object.type) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.type = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.type = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.type = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.type = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.type = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.type = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.type = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.type = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.type = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.type = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.type = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.type = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.type = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.type = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.type = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.type = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.type = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.type = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.type = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.type = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.type = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.type = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.type = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.type = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.type = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.type = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.type = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.type = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.type = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.type = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.type = 31;
                break;
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.AddObjectRequest.settings: object expected");
                message.settings = $root.pond.ObjectSettings.fromObject(object.settings);
            }
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.AddObjectRequest.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            if (object.parent != null)
                message.parent = String(object.parent);
            if (object.parentType != null)
                message.parentType = String(object.parentType);
            if (object.data != null) {
                if (typeof object.data !== "object")
                    throw TypeError(".pond.AddObjectRequest.data: object expected");
                message.data = $root.pond.ObjectData.fromObject(object.data);
            }
            if (object.typeString != null)
                message.typeString = String(object.typeString);
            return message;
        };

        /**
         * Creates a plain object from an AddObjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddObjectRequest
         * @static
         * @param {pond.AddObjectRequest} message AddObjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.name = "";
                object.settings = null;
                object.theme = null;
                object.parent = "";
                object.parentType = "";
                object.data = null;
                object.typeString = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.pond.ObjectType[message.type] : message.type;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectSettings.toObject(message.settings, options);
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            if (message.parent != null && message.hasOwnProperty("parent"))
                object.parent = message.parent;
            if (message.parentType != null && message.hasOwnProperty("parentType"))
                object.parentType = message.parentType;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = $root.pond.ObjectData.toObject(message.data, options);
            if (message.typeString != null && message.hasOwnProperty("typeString"))
                object.typeString = message.typeString;
            return object;
        };

        /**
         * Converts this AddObjectRequest to JSON.
         * @function toJSON
         * @memberof pond.AddObjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddObjectRequest;
    })();

    pond.AddObjectResponse = (function() {

        /**
         * Properties of an AddObjectResponse.
         * @memberof pond
         * @interface IAddObjectResponse
         * @property {string|null} [key] AddObjectResponse key
         */

        /**
         * Constructs a new AddObjectResponse.
         * @memberof pond
         * @classdesc Represents an AddObjectResponse.
         * @implements IAddObjectResponse
         * @constructor
         * @param {pond.IAddObjectResponse=} [properties] Properties to set
         */
        function AddObjectResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectResponse key.
         * @member {string} key
         * @memberof pond.AddObjectResponse
         * @instance
         */
        AddObjectResponse.prototype.key = "";

        /**
         * Creates a new AddObjectResponse instance using the specified properties.
         * @function create
         * @memberof pond.AddObjectResponse
         * @static
         * @param {pond.IAddObjectResponse=} [properties] Properties to set
         * @returns {pond.AddObjectResponse} AddObjectResponse instance
         */
        AddObjectResponse.create = function create(properties) {
            return new AddObjectResponse(properties);
        };

        /**
         * Creates an AddObjectResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.AddObjectResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.AddObjectResponse} AddObjectResponse
         */
        AddObjectResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.AddObjectResponse)
                return object;
            var message = new $root.pond.AddObjectResponse();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from an AddObjectResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.AddObjectResponse
         * @static
         * @param {pond.AddObjectResponse} message AddObjectResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this AddObjectResponse to JSON.
         * @function toJSON
         * @memberof pond.AddObjectResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddObjectResponse;
    })();

    pond.ListObjectsRequest = (function() {

        /**
         * Properties of a ListObjectsRequest.
         * @memberof pond
         * @interface IListObjectsRequest
         * @property {pond.ObjectType|null} [objectType] ListObjectsRequest objectType
         * @property {pond.Paging|null} [paging] ListObjectsRequest paging
         * @property {pond.Sorting|null} [sorting] ListObjectsRequest sorting
         * @property {string|null} [search] ListObjectsRequest search
         * @property {string|null} [typeString] ListObjectsRequest typeString
         */

        /**
         * Constructs a new ListObjectsRequest.
         * @memberof pond
         * @classdesc Represents a ListObjectsRequest.
         * @implements IListObjectsRequest
         * @constructor
         * @param {pond.IListObjectsRequest=} [properties] Properties to set
         */
        function ListObjectsRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectsRequest objectType.
         * @member {pond.ObjectType} objectType
         * @memberof pond.ListObjectsRequest
         * @instance
         */
        ListObjectsRequest.prototype.objectType = 0;

        /**
         * ListObjectsRequest paging.
         * @member {pond.Paging|null|undefined} paging
         * @memberof pond.ListObjectsRequest
         * @instance
         */
        ListObjectsRequest.prototype.paging = null;

        /**
         * ListObjectsRequest sorting.
         * @member {pond.Sorting|null|undefined} sorting
         * @memberof pond.ListObjectsRequest
         * @instance
         */
        ListObjectsRequest.prototype.sorting = null;

        /**
         * ListObjectsRequest search.
         * @member {string} search
         * @memberof pond.ListObjectsRequest
         * @instance
         */
        ListObjectsRequest.prototype.search = "";

        /**
         * ListObjectsRequest typeString.
         * @member {string} typeString
         * @memberof pond.ListObjectsRequest
         * @instance
         */
        ListObjectsRequest.prototype.typeString = "";

        /**
         * Creates a new ListObjectsRequest instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectsRequest
         * @static
         * @param {pond.IListObjectsRequest=} [properties] Properties to set
         * @returns {pond.ListObjectsRequest} ListObjectsRequest instance
         */
        ListObjectsRequest.create = function create(properties) {
            return new ListObjectsRequest(properties);
        };

        /**
         * Creates a ListObjectsRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectsRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectsRequest} ListObjectsRequest
         */
        ListObjectsRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectsRequest)
                return object;
            var message = new $root.pond.ListObjectsRequest();
            switch (object.objectType) {
            case "OBJECT_TYPE_UNKNOWN":
            case 0:
                message.objectType = 0;
                break;
            case "OBJECT_TYPE_BIN":
            case 1:
                message.objectType = 1;
                break;
            case "OBJECT_TYPE_SITE":
            case 2:
                message.objectType = 2;
                break;
            case "OBJECT_TYPE_DEVICE":
            case 3:
                message.objectType = 3;
                break;
            case "OBJECT_TYPE_COMPONENT":
            case 4:
                message.objectType = 4;
                break;
            case "OBJECT_TYPE_INTERACTION":
            case 5:
                message.objectType = 5;
                break;
            case "OBJECT_TYPE_NOTE":
            case 6:
                message.objectType = 6;
                break;
            case "OBJECT_TYPE_FIELD":
            case 7:
                message.objectType = 7;
                break;
            case "OBJECT_TYPE_FIELDMARKER":
            case 8:
                message.objectType = 8;
                break;
            case "OBJECT_TYPE_HOMEMARKER":
            case 9:
                message.objectType = 9;
                break;
            case "OBJECT_TYPE_HARVESTPLAN":
            case 10:
                message.objectType = 10;
                break;
            case "OBJECT_TYPE_TASK":
            case 11:
                message.objectType = 11;
                break;
            case "OBJECT_TYPE_MINE":
            case 12:
                message.objectType = 12;
                break;
            case "OBJECT_TYPE_BINYARD":
            case 13:
                message.objectType = 13;
                break;
            case "OBJECT_TYPE_TERMINAL":
            case 14:
                message.objectType = 14;
                break;
            case "OBJECT_TYPE_GATE":
            case 15:
                message.objectType = 15;
                break;
            case "OBJECT_TYPE_FIRMWARE":
            case 16:
                message.objectType = 16;
                break;
            case "OBJECT_TYPE_GROUP":
            case 17:
                message.objectType = 17;
                break;
            case "OBJECT_TYPE_UPGRADE":
            case 18:
                message.objectType = 18;
                break;
            case "OBJECT_TYPE_USER":
            case 19:
                message.objectType = 19;
                break;
            case "OBJECT_TYPE_BACKPACK":
            case 20:
                message.objectType = 20;
                break;
            case "OBJECT_TYPE_HARVESTYEAR":
            case 21:
                message.objectType = 21;
                break;
            case "OBJECT_TYPE_TAG":
            case 22:
                message.objectType = 22;
                break;
            case "OBJECT_TYPE_TEAM":
            case 23:
                message.objectType = 23;
                break;
            case "OBJECT_TYPE_LINK":
            case 24:
                message.objectType = 24;
                break;
            case "OBJECT_TYPE_HEATER":
            case 25:
                message.objectType = 25;
                break;
            case "OBJECT_TYPE_GRAIN_BAG":
            case 26:
                message.objectType = 26;
                break;
            case "OBJECT_TYPE_CONTRACT":
            case 27:
                message.objectType = 27;
                break;
            case "OBJECT_TYPE_TRANSACTION":
            case 28:
                message.objectType = 28;
                break;
            case "OBJECT_TYPE_FILE":
            case 29:
                message.objectType = 29;
                break;
            case "OBJECT_TYPE_NOTIFICATION_BANNER":
            case 30:
                message.objectType = 30;
                break;
            case "OBJECT_TYPE_DEVICE_PRESET":
            case 31:
                message.objectType = 31;
                break;
            }
            if (object.paging != null) {
                if (typeof object.paging !== "object")
                    throw TypeError(".pond.ListObjectsRequest.paging: object expected");
                message.paging = $root.pond.Paging.fromObject(object.paging);
            }
            if (object.sorting != null) {
                if (typeof object.sorting !== "object")
                    throw TypeError(".pond.ListObjectsRequest.sorting: object expected");
                message.sorting = $root.pond.Sorting.fromObject(object.sorting);
            }
            if (object.search != null)
                message.search = String(object.search);
            if (object.typeString != null)
                message.typeString = String(object.typeString);
            return message;
        };

        /**
         * Creates a plain object from a ListObjectsRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectsRequest
         * @static
         * @param {pond.ListObjectsRequest} message ListObjectsRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectsRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.objectType = options.enums === String ? "OBJECT_TYPE_UNKNOWN" : 0;
                object.paging = null;
                object.sorting = null;
                object.search = "";
                object.typeString = "";
            }
            if (message.objectType != null && message.hasOwnProperty("objectType"))
                object.objectType = options.enums === String ? $root.pond.ObjectType[message.objectType] : message.objectType;
            if (message.paging != null && message.hasOwnProperty("paging"))
                object.paging = $root.pond.Paging.toObject(message.paging, options);
            if (message.sorting != null && message.hasOwnProperty("sorting"))
                object.sorting = $root.pond.Sorting.toObject(message.sorting, options);
            if (message.search != null && message.hasOwnProperty("search"))
                object.search = message.search;
            if (message.typeString != null && message.hasOwnProperty("typeString"))
                object.typeString = message.typeString;
            return object;
        };

        /**
         * Converts this ListObjectsRequest to JSON.
         * @function toJSON
         * @memberof pond.ListObjectsRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectsRequest;
    })();

    pond.ListObjectsResponse = (function() {

        /**
         * Properties of a ListObjectsResponse.
         * @memberof pond
         * @interface IListObjectsResponse
         * @property {Array.<pond.ObjectTemplate>|null} [objects] ListObjectsResponse objects
         * @property {number|null} [nextOffset] ListObjectsResponse nextOffset
         * @property {number|null} [total] ListObjectsResponse total
         */

        /**
         * Constructs a new ListObjectsResponse.
         * @memberof pond
         * @classdesc Represents a ListObjectsResponse.
         * @implements IListObjectsResponse
         * @constructor
         * @param {pond.IListObjectsResponse=} [properties] Properties to set
         */
        function ListObjectsResponse(properties) {
            this.objects = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListObjectsResponse objects.
         * @member {Array.<pond.ObjectTemplate>} objects
         * @memberof pond.ListObjectsResponse
         * @instance
         */
        ListObjectsResponse.prototype.objects = $util.emptyArray;

        /**
         * ListObjectsResponse nextOffset.
         * @member {number} nextOffset
         * @memberof pond.ListObjectsResponse
         * @instance
         */
        ListObjectsResponse.prototype.nextOffset = 0;

        /**
         * ListObjectsResponse total.
         * @member {number} total
         * @memberof pond.ListObjectsResponse
         * @instance
         */
        ListObjectsResponse.prototype.total = 0;

        /**
         * Creates a new ListObjectsResponse instance using the specified properties.
         * @function create
         * @memberof pond.ListObjectsResponse
         * @static
         * @param {pond.IListObjectsResponse=} [properties] Properties to set
         * @returns {pond.ListObjectsResponse} ListObjectsResponse instance
         */
        ListObjectsResponse.create = function create(properties) {
            return new ListObjectsResponse(properties);
        };

        /**
         * Creates a ListObjectsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.ListObjectsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.ListObjectsResponse} ListObjectsResponse
         */
        ListObjectsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.ListObjectsResponse)
                return object;
            var message = new $root.pond.ListObjectsResponse();
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".pond.ListObjectsResponse.objects: array expected");
                message.objects = [];
                for (var i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".pond.ListObjectsResponse.objects: object expected");
                    message.objects[i] = $root.pond.ObjectTemplate.fromObject(object.objects[i]);
                }
            }
            if (object.nextOffset != null)
                message.nextOffset = object.nextOffset >>> 0;
            if (object.total != null)
                message.total = object.total >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListObjectsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.ListObjectsResponse
         * @static
         * @param {pond.ListObjectsResponse} message ListObjectsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListObjectsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.objects = [];
            if (options.defaults) {
                object.nextOffset = 0;
                object.total = 0;
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (var j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.pond.ObjectTemplate.toObject(message.objects[j], options);
            }
            if (message.nextOffset != null && message.hasOwnProperty("nextOffset"))
                object.nextOffset = message.nextOffset;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            return object;
        };

        /**
         * Converts this ListObjectsResponse to JSON.
         * @function toJSON
         * @memberof pond.ListObjectsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListObjectsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListObjectsResponse;
    })();

    pond.UpdateObjectRequest = (function() {

        /**
         * Properties of an UpdateObjectRequest.
         * @memberof pond
         * @interface IUpdateObjectRequest
         * @property {string|null} [key] UpdateObjectRequest key
         * @property {pond.ObjectSettings|null} [settings] UpdateObjectRequest settings
         * @property {string|null} [name] UpdateObjectRequest name
         * @property {pond.ObjectTheme|null} [theme] UpdateObjectRequest theme
         */

        /**
         * Constructs a new UpdateObjectRequest.
         * @memberof pond
         * @classdesc Represents an UpdateObjectRequest.
         * @implements IUpdateObjectRequest
         * @constructor
         * @param {pond.IUpdateObjectRequest=} [properties] Properties to set
         */
        function UpdateObjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateObjectRequest key.
         * @member {string} key
         * @memberof pond.UpdateObjectRequest
         * @instance
         */
        UpdateObjectRequest.prototype.key = "";

        /**
         * UpdateObjectRequest settings.
         * @member {pond.ObjectSettings|null|undefined} settings
         * @memberof pond.UpdateObjectRequest
         * @instance
         */
        UpdateObjectRequest.prototype.settings = null;

        /**
         * UpdateObjectRequest name.
         * @member {string} name
         * @memberof pond.UpdateObjectRequest
         * @instance
         */
        UpdateObjectRequest.prototype.name = "";

        /**
         * UpdateObjectRequest theme.
         * @member {pond.ObjectTheme|null|undefined} theme
         * @memberof pond.UpdateObjectRequest
         * @instance
         */
        UpdateObjectRequest.prototype.theme = null;

        /**
         * Creates a new UpdateObjectRequest instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectRequest
         * @static
         * @param {pond.IUpdateObjectRequest=} [properties] Properties to set
         * @returns {pond.UpdateObjectRequest} UpdateObjectRequest instance
         */
        UpdateObjectRequest.create = function create(properties) {
            return new UpdateObjectRequest(properties);
        };

        /**
         * Creates an UpdateObjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectRequest} UpdateObjectRequest
         */
        UpdateObjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectRequest)
                return object;
            var message = new $root.pond.UpdateObjectRequest();
            if (object.key != null)
                message.key = String(object.key);
            if (object.settings != null) {
                if (typeof object.settings !== "object")
                    throw TypeError(".pond.UpdateObjectRequest.settings: object expected");
                message.settings = $root.pond.ObjectSettings.fromObject(object.settings);
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.theme != null) {
                if (typeof object.theme !== "object")
                    throw TypeError(".pond.UpdateObjectRequest.theme: object expected");
                message.theme = $root.pond.ObjectTheme.fromObject(object.theme);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateObjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectRequest
         * @static
         * @param {pond.UpdateObjectRequest} message UpdateObjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.key = "";
                object.settings = null;
                object.name = "";
                object.theme = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.settings != null && message.hasOwnProperty("settings"))
                object.settings = $root.pond.ObjectSettings.toObject(message.settings, options);
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.theme != null && message.hasOwnProperty("theme"))
                object.theme = $root.pond.ObjectTheme.toObject(message.theme, options);
            return object;
        };

        /**
         * Converts this UpdateObjectRequest to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectRequest;
    })();

    pond.UpdateObjectResponse = (function() {

        /**
         * Properties of an UpdateObjectResponse.
         * @memberof pond
         * @interface IUpdateObjectResponse
         * @property {boolean|null} [updated] UpdateObjectResponse updated
         */

        /**
         * Constructs a new UpdateObjectResponse.
         * @memberof pond
         * @classdesc Represents an UpdateObjectResponse.
         * @implements IUpdateObjectResponse
         * @constructor
         * @param {pond.IUpdateObjectResponse=} [properties] Properties to set
         */
        function UpdateObjectResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateObjectResponse updated.
         * @member {boolean} updated
         * @memberof pond.UpdateObjectResponse
         * @instance
         */
        UpdateObjectResponse.prototype.updated = false;

        /**
         * Creates a new UpdateObjectResponse instance using the specified properties.
         * @function create
         * @memberof pond.UpdateObjectResponse
         * @static
         * @param {pond.IUpdateObjectResponse=} [properties] Properties to set
         * @returns {pond.UpdateObjectResponse} UpdateObjectResponse instance
         */
        UpdateObjectResponse.create = function create(properties) {
            return new UpdateObjectResponse(properties);
        };

        /**
         * Creates an UpdateObjectResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UpdateObjectResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UpdateObjectResponse} UpdateObjectResponse
         */
        UpdateObjectResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UpdateObjectResponse)
                return object;
            var message = new $root.pond.UpdateObjectResponse();
            if (object.updated != null)
                message.updated = Boolean(object.updated);
            return message;
        };

        /**
         * Creates a plain object from an UpdateObjectResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UpdateObjectResponse
         * @static
         * @param {pond.UpdateObjectResponse} message UpdateObjectResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateObjectResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.updated = false;
            if (message.updated != null && message.hasOwnProperty("updated"))
                object.updated = message.updated;
            return object;
        };

        /**
         * Converts this UpdateObjectResponse to JSON.
         * @function toJSON
         * @memberof pond.UpdateObjectResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateObjectResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateObjectResponse;
    })();

    pond.RemoveObjectRequest = (function() {

        /**
         * Properties of a RemoveObjectRequest.
         * @memberof pond
         * @interface IRemoveObjectRequest
         * @property {string|null} [key] RemoveObjectRequest key
         */

        /**
         * Constructs a new RemoveObjectRequest.
         * @memberof pond
         * @classdesc Represents a RemoveObjectRequest.
         * @implements IRemoveObjectRequest
         * @constructor
         * @param {pond.IRemoveObjectRequest=} [properties] Properties to set
         */
        function RemoveObjectRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectRequest key.
         * @member {string} key
         * @memberof pond.RemoveObjectRequest
         * @instance
         */
        RemoveObjectRequest.prototype.key = "";

        /**
         * Creates a new RemoveObjectRequest instance using the specified properties.
         * @function create
         * @memberof pond.RemoveObjectRequest
         * @static
         * @param {pond.IRemoveObjectRequest=} [properties] Properties to set
         * @returns {pond.RemoveObjectRequest} RemoveObjectRequest instance
         */
        RemoveObjectRequest.create = function create(properties) {
            return new RemoveObjectRequest(properties);
        };

        /**
         * Creates a RemoveObjectRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveObjectRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveObjectRequest} RemoveObjectRequest
         */
        RemoveObjectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveObjectRequest)
                return object;
            var message = new $root.pond.RemoveObjectRequest();
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveObjectRequest
         * @static
         * @param {pond.RemoveObjectRequest} message RemoveObjectRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.key = "";
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this RemoveObjectRequest to JSON.
         * @function toJSON
         * @memberof pond.RemoveObjectRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveObjectRequest;
    })();

    pond.RemoveObjectResponse = (function() {

        /**
         * Properties of a RemoveObjectResponse.
         * @memberof pond
         * @interface IRemoveObjectResponse
         * @property {boolean|null} [removed] RemoveObjectResponse removed
         */

        /**
         * Constructs a new RemoveObjectResponse.
         * @memberof pond
         * @classdesc Represents a RemoveObjectResponse.
         * @implements IRemoveObjectResponse
         * @constructor
         * @param {pond.IRemoveObjectResponse=} [properties] Properties to set
         */
        function RemoveObjectResponse(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectResponse removed.
         * @member {boolean} removed
         * @memberof pond.RemoveObjectResponse
         * @instance
         */
        RemoveObjectResponse.prototype.removed = false;

        /**
         * Creates a new RemoveObjectResponse instance using the specified properties.
         * @function create
         * @memberof pond.RemoveObjectResponse
         * @static
         * @param {pond.IRemoveObjectResponse=} [properties] Properties to set
         * @returns {pond.RemoveObjectResponse} RemoveObjectResponse instance
         */
        RemoveObjectResponse.create = function create(properties) {
            return new RemoveObjectResponse(properties);
        };

        /**
         * Creates a RemoveObjectResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.RemoveObjectResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.RemoveObjectResponse} RemoveObjectResponse
         */
        RemoveObjectResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.RemoveObjectResponse)
                return object;
            var message = new $root.pond.RemoveObjectResponse();
            if (object.removed != null)
                message.removed = Boolean(object.removed);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.RemoveObjectResponse
         * @static
         * @param {pond.RemoveObjectResponse} message RemoveObjectResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.removed = false;
            if (message.removed != null && message.hasOwnProperty("removed"))
                object.removed = message.removed;
            return object;
        };

        /**
         * Converts this RemoveObjectResponse to JSON.
         * @function toJSON
         * @memberof pond.RemoveObjectResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveObjectResponse;
    })();

    pond.UploadImageRequest = (function() {

        /**
         * Properties of an UploadImageRequest.
         * @memberof pond
         * @interface IUploadImageRequest
         * @property {string|null} [file] UploadImageRequest file
         * @property {string|null} [fileName] UploadImageRequest fileName
         * @property {string|null} [filePath] UploadImageRequest filePath
         */

        /**
         * Constructs a new UploadImageRequest.
         * @memberof pond
         * @classdesc Represents an UploadImageRequest.
         * @implements IUploadImageRequest
         * @constructor
         * @param {pond.IUploadImageRequest=} [properties] Properties to set
         */
        function UploadImageRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadImageRequest file.
         * @member {string} file
         * @memberof pond.UploadImageRequest
         * @instance
         */
        UploadImageRequest.prototype.file = "";

        /**
         * UploadImageRequest fileName.
         * @member {string} fileName
         * @memberof pond.UploadImageRequest
         * @instance
         */
        UploadImageRequest.prototype.fileName = "";

        /**
         * UploadImageRequest filePath.
         * @member {string} filePath
         * @memberof pond.UploadImageRequest
         * @instance
         */
        UploadImageRequest.prototype.filePath = "";

        /**
         * Creates a new UploadImageRequest instance using the specified properties.
         * @function create
         * @memberof pond.UploadImageRequest
         * @static
         * @param {pond.IUploadImageRequest=} [properties] Properties to set
         * @returns {pond.UploadImageRequest} UploadImageRequest instance
         */
        UploadImageRequest.create = function create(properties) {
            return new UploadImageRequest(properties);
        };

        /**
         * Creates an UploadImageRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UploadImageRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UploadImageRequest} UploadImageRequest
         */
        UploadImageRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UploadImageRequest)
                return object;
            var message = new $root.pond.UploadImageRequest();
            if (object.file != null)
                message.file = String(object.file);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.filePath != null)
                message.filePath = String(object.filePath);
            return message;
        };

        /**
         * Creates a plain object from an UploadImageRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UploadImageRequest
         * @static
         * @param {pond.UploadImageRequest} message UploadImageRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadImageRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.file = "";
                object.fileName = "";
                object.filePath = "";
            }
            if (message.file != null && message.hasOwnProperty("file"))
                object.file = message.file;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                object.filePath = message.filePath;
            return object;
        };

        /**
         * Converts this UploadImageRequest to JSON.
         * @function toJSON
         * @memberof pond.UploadImageRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadImageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UploadImageRequest;
    })();

    pond.UploadImageResponse = (function() {

        /**
         * Properties of an UploadImageResponse.
         * @memberof pond
         * @interface IUploadImageResponse
         * @property {string|null} [fileId] UploadImageResponse fileId
         * @property {string|null} [name] UploadImageResponse name
         * @property {string|null} [url] UploadImageResponse url
         * @property {string|null} [thumbnailUrl] UploadImageResponse thumbnailUrl
         * @property {number|null} [height] UploadImageResponse height
         * @property {number|null} [width] UploadImageResponse width
         * @property {number|null} [size] UploadImageResponse size
         * @property {string|null} [fileType] UploadImageResponse fileType
         * @property {string|null} [filePath] UploadImageResponse filePath
         * @property {Array.<string>|null} [tags] UploadImageResponse tags
         * @property {boolean|null} [isPrivate] UploadImageResponse isPrivate
         * @property {string|null} [customCoordinates] UploadImageResponse customCoordinates
         */

        /**
         * Constructs a new UploadImageResponse.
         * @memberof pond
         * @classdesc Represents an UploadImageResponse.
         * @implements IUploadImageResponse
         * @constructor
         * @param {pond.IUploadImageResponse=} [properties] Properties to set
         */
        function UploadImageResponse(properties) {
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadImageResponse fileId.
         * @member {string} fileId
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.fileId = "";

        /**
         * UploadImageResponse name.
         * @member {string} name
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.name = "";

        /**
         * UploadImageResponse url.
         * @member {string} url
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.url = "";

        /**
         * UploadImageResponse thumbnailUrl.
         * @member {string} thumbnailUrl
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.thumbnailUrl = "";

        /**
         * UploadImageResponse height.
         * @member {number} height
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.height = 0;

        /**
         * UploadImageResponse width.
         * @member {number} width
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.width = 0;

        /**
         * UploadImageResponse size.
         * @member {number} size
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UploadImageResponse fileType.
         * @member {string} fileType
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.fileType = "";

        /**
         * UploadImageResponse filePath.
         * @member {string} filePath
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.filePath = "";

        /**
         * UploadImageResponse tags.
         * @member {Array.<string>} tags
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.tags = $util.emptyArray;

        /**
         * UploadImageResponse isPrivate.
         * @member {boolean} isPrivate
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.isPrivate = false;

        /**
         * UploadImageResponse customCoordinates.
         * @member {string} customCoordinates
         * @memberof pond.UploadImageResponse
         * @instance
         */
        UploadImageResponse.prototype.customCoordinates = "";

        /**
         * Creates a new UploadImageResponse instance using the specified properties.
         * @function create
         * @memberof pond.UploadImageResponse
         * @static
         * @param {pond.IUploadImageResponse=} [properties] Properties to set
         * @returns {pond.UploadImageResponse} UploadImageResponse instance
         */
        UploadImageResponse.create = function create(properties) {
            return new UploadImageResponse(properties);
        };

        /**
         * Creates an UploadImageResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pond.UploadImageResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pond.UploadImageResponse} UploadImageResponse
         */
        UploadImageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.pond.UploadImageResponse)
                return object;
            var message = new $root.pond.UploadImageResponse();
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.name != null)
                message.name = String(object.name);
            if (object.url != null)
                message.url = String(object.url);
            if (object.thumbnailUrl != null)
                message.thumbnailUrl = String(object.thumbnailUrl);
            if (object.height != null)
                message.height = object.height | 0;
            if (object.width != null)
                message.width = object.width | 0;
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
            if (object.fileType != null)
                message.fileType = String(object.fileType);
            if (object.filePath != null)
                message.filePath = String(object.filePath);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".pond.UploadImageResponse.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.isPrivate != null)
                message.isPrivate = Boolean(object.isPrivate);
            if (object.customCoordinates != null)
                message.customCoordinates = String(object.customCoordinates);
            return message;
        };

        /**
         * Creates a plain object from an UploadImageResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pond.UploadImageResponse
         * @static
         * @param {pond.UploadImageResponse} message UploadImageResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadImageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                object.fileId = "";
                object.name = "";
                object.url = "";
                object.thumbnailUrl = "";
                object.height = 0;
                object.width = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.fileType = "";
                object.filePath = "";
                object.isPrivate = false;
                object.customCoordinates = "";
            }
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                object.thumbnailUrl = message.thumbnailUrl;
            if (message.height != null && message.hasOwnProperty("height"))
                object.height = message.height;
            if (message.width != null && message.hasOwnProperty("width"))
                object.width = message.width;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                object.fileType = message.fileType;
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                object.filePath = message.filePath;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.isPrivate != null && message.hasOwnProperty("isPrivate"))
                object.isPrivate = message.isPrivate;
            if (message.customCoordinates != null && message.hasOwnProperty("customCoordinates"))
                object.customCoordinates = message.customCoordinates;
            return object;
        };

        /**
         * Converts this UploadImageResponse to JSON.
         * @function toJSON
         * @memberof pond.UploadImageResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadImageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UploadImageResponse;
    })();

    return pond;
})();

$root.quack = (function() {

    /**
     * Namespace quack.
     * @exports quack
     * @namespace
     */
    var quack = {};

    quack.Unknown = (function() {

        /**
         * Properties of an Unknown.
         * @memberof quack
         * @interface IUnknown
         * @property {number|null} [firmwareVersion] Unknown firmwareVersion
         */

        /**
         * Constructs a new Unknown.
         * @memberof quack
         * @classdesc Represents an Unknown.
         * @implements IUnknown
         * @constructor
         * @param {quack.IUnknown=} [properties] Properties to set
         */
        function Unknown(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Unknown firmwareVersion.
         * @member {number} firmwareVersion
         * @memberof quack.Unknown
         * @instance
         */
        Unknown.prototype.firmwareVersion = 0;

        /**
         * Creates a new Unknown instance using the specified properties.
         * @function create
         * @memberof quack.Unknown
         * @static
         * @param {quack.IUnknown=} [properties] Properties to set
         * @returns {quack.Unknown} Unknown instance
         */
        Unknown.create = function create(properties) {
            return new Unknown(properties);
        };

        /**
         * Creates an Unknown message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Unknown
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Unknown} Unknown
         */
        Unknown.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Unknown)
                return object;
            var message = new $root.quack.Unknown();
            if (object.firmwareVersion != null)
                message.firmwareVersion = object.firmwareVersion | 0;
            return message;
        };

        /**
         * Creates a plain object from an Unknown message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Unknown
         * @static
         * @param {quack.Unknown} message Unknown
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Unknown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.firmwareVersion = 0;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            return object;
        };

        /**
         * Converts this Unknown to JSON.
         * @function toJSON
         * @memberof quack.Unknown
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Unknown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Unknown;
    })();

    /**
     * ResponseCode enum.
     * @name quack.ResponseCode
     * @enum {string}
     * @property {number} RESPONSE_CODE_INVALID=0 RESPONSE_CODE_INVALID value
     * @property {number} RESPONSE_CODE_ACKNOWLEDGE=1 RESPONSE_CODE_ACKNOWLEDGE value
     * @property {number} RESPONSE_CODE_ERROR=2 RESPONSE_CODE_ERROR value
     */
    quack.ResponseCode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RESPONSE_CODE_INVALID"] = 0;
        values[valuesById[1] = "RESPONSE_CODE_ACKNOWLEDGE"] = 1;
        values[valuesById[2] = "RESPONSE_CODE_ERROR"] = 2;
        return values;
    })();

    quack.Ack = (function() {

        /**
         * Properties of an Ack.
         * @memberof quack
         * @interface IAck
         * @property {number|null} [unixTime] Ack unixTime
         */

        /**
         * Constructs a new Ack.
         * @memberof quack
         * @classdesc Represents an Ack.
         * @implements IAck
         * @constructor
         * @param {quack.IAck=} [properties] Properties to set
         */
        function Ack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Ack unixTime.
         * @member {number} unixTime
         * @memberof quack.Ack
         * @instance
         */
        Ack.prototype.unixTime = 0;

        /**
         * Creates a new Ack instance using the specified properties.
         * @function create
         * @memberof quack.Ack
         * @static
         * @param {quack.IAck=} [properties] Properties to set
         * @returns {quack.Ack} Ack instance
         */
        Ack.create = function create(properties) {
            return new Ack(properties);
        };

        /**
         * Creates an Ack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Ack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Ack} Ack
         */
        Ack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Ack)
                return object;
            var message = new $root.quack.Ack();
            if (object.unixTime != null)
                message.unixTime = object.unixTime >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Ack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Ack
         * @static
         * @param {quack.Ack} message Ack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.unixTime = 0;
            if (message.unixTime != null && message.hasOwnProperty("unixTime"))
                object.unixTime = message.unixTime;
            return object;
        };

        /**
         * Converts this Ack to JSON.
         * @function toJSON
         * @memberof quack.Ack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Ack;
    })();

    quack.Nack = (function() {

        /**
         * Properties of a Nack.
         * @memberof quack
         * @interface INack
         * @property {string|null} [errorMessage] Nack errorMessage
         */

        /**
         * Constructs a new Nack.
         * @memberof quack
         * @classdesc Represents a Nack.
         * @implements INack
         * @constructor
         * @param {quack.INack=} [properties] Properties to set
         */
        function Nack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Nack errorMessage.
         * @member {string} errorMessage
         * @memberof quack.Nack
         * @instance
         */
        Nack.prototype.errorMessage = "";

        /**
         * Creates a new Nack instance using the specified properties.
         * @function create
         * @memberof quack.Nack
         * @static
         * @param {quack.INack=} [properties] Properties to set
         * @returns {quack.Nack} Nack instance
         */
        Nack.create = function create(properties) {
            return new Nack(properties);
        };

        /**
         * Creates a Nack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Nack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Nack} Nack
         */
        Nack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Nack)
                return object;
            var message = new $root.quack.Nack();
            if (object.errorMessage != null)
                message.errorMessage = String(object.errorMessage);
            return message;
        };

        /**
         * Creates a plain object from a Nack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Nack
         * @static
         * @param {quack.Nack} message Nack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Nack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errorMessage = "";
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                object.errorMessage = message.errorMessage;
            return object;
        };

        /**
         * Converts this Nack to JSON.
         * @function toJSON
         * @memberof quack.Nack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Nack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Nack;
    })();

    /**
     * SleepType enum.
     * @name quack.SleepType
     * @enum {string}
     * @property {number} SLEEP_TYPE_NONE=0 SLEEP_TYPE_NONE value
     * @property {number} SLEEP_TYPE_NAP=1 SLEEP_TYPE_NAP value
     * @property {number} SLEEP_TYPE_DEEP=2 SLEEP_TYPE_DEEP value
     * @property {number} SLEEP_TYPE_HIBERNATE=3 SLEEP_TYPE_HIBERNATE value
     */
    quack.SleepType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SLEEP_TYPE_NONE"] = 0;
        values[valuesById[1] = "SLEEP_TYPE_NAP"] = 1;
        values[valuesById[2] = "SLEEP_TYPE_DEEP"] = 2;
        values[valuesById[3] = "SLEEP_TYPE_HIBERNATE"] = 3;
        return values;
    })();

    quack.UpdateDevice = (function() {

        /**
         * Properties of an UpdateDevice.
         * @memberof quack
         * @interface IUpdateDevice
         * @property {string|null} [name] UpdateDevice name
         * @property {quack.SleepType|null} [sleepType] UpdateDevice sleepType
         * @property {number|null} [sleepDurationS] UpdateDevice sleepDurationS
         * @property {number|null} [sleepDelayMs] UpdateDevice sleepDelayMs
         * @property {number|null} [pondCheckPeriodS] UpdateDevice pondCheckPeriodS
         * @property {number|null} [wakePin] UpdateDevice wakePin
         */

        /**
         * Constructs a new UpdateDevice.
         * @memberof quack
         * @classdesc Represents an UpdateDevice.
         * @implements IUpdateDevice
         * @constructor
         * @param {quack.IUpdateDevice=} [properties] Properties to set
         */
        function UpdateDevice(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDevice name.
         * @member {string} name
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.name = "";

        /**
         * UpdateDevice sleepType.
         * @member {quack.SleepType} sleepType
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepType = 0;

        /**
         * UpdateDevice sleepDurationS.
         * @member {number} sleepDurationS
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepDurationS = 0;

        /**
         * UpdateDevice sleepDelayMs.
         * @member {number} sleepDelayMs
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepDelayMs = 0;

        /**
         * UpdateDevice pondCheckPeriodS.
         * @member {number} pondCheckPeriodS
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.pondCheckPeriodS = 0;

        /**
         * UpdateDevice wakePin.
         * @member {number} wakePin
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.wakePin = 0;

        /**
         * Creates a new UpdateDevice instance using the specified properties.
         * @function create
         * @memberof quack.UpdateDevice
         * @static
         * @param {quack.IUpdateDevice=} [properties] Properties to set
         * @returns {quack.UpdateDevice} UpdateDevice instance
         */
        UpdateDevice.create = function create(properties) {
            return new UpdateDevice(properties);
        };

        /**
         * Creates an UpdateDevice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateDevice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateDevice} UpdateDevice
         */
        UpdateDevice.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateDevice)
                return object;
            var message = new $root.quack.UpdateDevice();
            if (object.name != null)
                message.name = String(object.name);
            switch (object.sleepType) {
            case "SLEEP_TYPE_NONE":
            case 0:
                message.sleepType = 0;
                break;
            case "SLEEP_TYPE_NAP":
            case 1:
                message.sleepType = 1;
                break;
            case "SLEEP_TYPE_DEEP":
            case 2:
                message.sleepType = 2;
                break;
            case "SLEEP_TYPE_HIBERNATE":
            case 3:
                message.sleepType = 3;
                break;
            }
            if (object.sleepDurationS != null)
                message.sleepDurationS = object.sleepDurationS >>> 0;
            if (object.sleepDelayMs != null)
                message.sleepDelayMs = object.sleepDelayMs >>> 0;
            if (object.pondCheckPeriodS != null)
                message.pondCheckPeriodS = object.pondCheckPeriodS >>> 0;
            if (object.wakePin != null)
                message.wakePin = object.wakePin >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an UpdateDevice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateDevice
         * @static
         * @param {quack.UpdateDevice} message UpdateDevice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDevice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.sleepType = options.enums === String ? "SLEEP_TYPE_NONE" : 0;
                object.sleepDurationS = 0;
                object.sleepDelayMs = 0;
                object.pondCheckPeriodS = 0;
                object.wakePin = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.sleepType != null && message.hasOwnProperty("sleepType"))
                object.sleepType = options.enums === String ? $root.quack.SleepType[message.sleepType] : message.sleepType;
            if (message.sleepDurationS != null && message.hasOwnProperty("sleepDurationS"))
                object.sleepDurationS = message.sleepDurationS;
            if (message.sleepDelayMs != null && message.hasOwnProperty("sleepDelayMs"))
                object.sleepDelayMs = message.sleepDelayMs;
            if (message.pondCheckPeriodS != null && message.hasOwnProperty("pondCheckPeriodS"))
                object.pondCheckPeriodS = message.pondCheckPeriodS;
            if (message.wakePin != null && message.hasOwnProperty("wakePin"))
                object.wakePin = message.wakePin;
            return object;
        };

        /**
         * Converts this UpdateDevice to JSON.
         * @function toJSON
         * @memberof quack.UpdateDevice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDevice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDevice;
    })();

    quack.Check = (function() {

        /**
         * Properties of a Check.
         * @memberof quack
         * @interface ICheck
         */

        /**
         * Constructs a new Check.
         * @memberof quack
         * @classdesc Represents a Check.
         * @implements ICheck
         * @constructor
         * @param {quack.ICheck=} [properties] Properties to set
         */
        function Check(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Check instance using the specified properties.
         * @function create
         * @memberof quack.Check
         * @static
         * @param {quack.ICheck=} [properties] Properties to set
         * @returns {quack.Check} Check instance
         */
        Check.create = function create(properties) {
            return new Check(properties);
        };

        /**
         * Creates a Check message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Check
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Check} Check
         */
        Check.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Check)
                return object;
            return new $root.quack.Check();
        };

        /**
         * Creates a plain object from a Check message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Check
         * @static
         * @param {quack.Check} message Check
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Check.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Check to JSON.
         * @function toJSON
         * @memberof quack.Check
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Check.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Check;
    })();

    quack.Firmware = (function() {

        /**
         * Properties of a Firmware.
         * @memberof quack
         * @interface IFirmware
         * @property {Uint8Array|null} [chunk] Firmware chunk
         * @property {number|null} [totalSize] Firmware totalSize
         * @property {number|null} [offset] Firmware offset
         */

        /**
         * Constructs a new Firmware.
         * @memberof quack
         * @classdesc Represents a Firmware.
         * @implements IFirmware
         * @constructor
         * @param {quack.IFirmware=} [properties] Properties to set
         */
        function Firmware(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Firmware chunk.
         * @member {Uint8Array} chunk
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.chunk = $util.newBuffer([]);

        /**
         * Firmware totalSize.
         * @member {number} totalSize
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.totalSize = 0;

        /**
         * Firmware offset.
         * @member {number} offset
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.offset = 0;

        /**
         * Creates a new Firmware instance using the specified properties.
         * @function create
         * @memberof quack.Firmware
         * @static
         * @param {quack.IFirmware=} [properties] Properties to set
         * @returns {quack.Firmware} Firmware instance
         */
        Firmware.create = function create(properties) {
            return new Firmware(properties);
        };

        /**
         * Creates a Firmware message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Firmware
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Firmware} Firmware
         */
        Firmware.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Firmware)
                return object;
            var message = new $root.quack.Firmware();
            if (object.chunk != null)
                if (typeof object.chunk === "string")
                    $util.base64.decode(object.chunk, message.chunk = $util.newBuffer($util.base64.length(object.chunk)), 0);
                else if (object.chunk.length)
                    message.chunk = object.chunk;
            if (object.totalSize != null)
                message.totalSize = object.totalSize >>> 0;
            if (object.offset != null)
                message.offset = object.offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Firmware message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Firmware
         * @static
         * @param {quack.Firmware} message Firmware
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Firmware.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.chunk = "";
                else {
                    object.chunk = [];
                    if (options.bytes !== Array)
                        object.chunk = $util.newBuffer(object.chunk);
                }
                object.totalSize = 0;
                object.offset = 0;
            }
            if (message.chunk != null && message.hasOwnProperty("chunk"))
                object.chunk = options.bytes === String ? $util.base64.encode(message.chunk, 0, message.chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.chunk) : message.chunk;
            if (message.totalSize != null && message.hasOwnProperty("totalSize"))
                object.totalSize = message.totalSize;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            return object;
        };

        /**
         * Converts this Firmware to JSON.
         * @function toJSON
         * @memberof quack.Firmware
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Firmware.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Firmware;
    })();

    quack.SyncTime = (function() {

        /**
         * Properties of a SyncTime.
         * @memberof quack
         * @interface ISyncTime
         */

        /**
         * Constructs a new SyncTime.
         * @memberof quack
         * @classdesc Represents a SyncTime.
         * @implements ISyncTime
         * @constructor
         * @param {quack.ISyncTime=} [properties] Properties to set
         */
        function SyncTime(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncTime instance using the specified properties.
         * @function create
         * @memberof quack.SyncTime
         * @static
         * @param {quack.ISyncTime=} [properties] Properties to set
         * @returns {quack.SyncTime} SyncTime instance
         */
        SyncTime.create = function create(properties) {
            return new SyncTime(properties);
        };

        /**
         * Creates a SyncTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.SyncTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.SyncTime} SyncTime
         */
        SyncTime.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.SyncTime)
                return object;
            return new $root.quack.SyncTime();
        };

        /**
         * Creates a plain object from a SyncTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.SyncTime
         * @static
         * @param {quack.SyncTime} message SyncTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncTime.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncTime to JSON.
         * @function toJSON
         * @memberof quack.SyncTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncTime;
    })();

    quack.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof quack
         * @interface IError
         * @property {string|null} [msg] Error msg
         */

        /**
         * Constructs a new Error.
         * @memberof quack
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {quack.IError=} [properties] Properties to set
         */
        function Error(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Error msg.
         * @member {string} msg
         * @memberof quack.Error
         * @instance
         */
        Error.prototype.msg = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof quack.Error
         * @static
         * @param {quack.IError=} [properties] Properties to set
         * @returns {quack.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Error} Error
         */
        Error.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Error)
                return object;
            var message = new $root.quack.Error();
            if (object.msg != null)
                message.msg = String(object.msg);
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Error
         * @static
         * @param {quack.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.msg = "";
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof quack.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Error;
    })();

    quack.Clear = (function() {

        /**
         * Properties of a Clear.
         * @memberof quack
         * @interface IClear
         */

        /**
         * Constructs a new Clear.
         * @memberof quack
         * @classdesc Represents a Clear.
         * @implements IClear
         * @constructor
         * @param {quack.IClear=} [properties] Properties to set
         */
        function Clear(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Clear instance using the specified properties.
         * @function create
         * @memberof quack.Clear
         * @static
         * @param {quack.IClear=} [properties] Properties to set
         * @returns {quack.Clear} Clear instance
         */
        Clear.create = function create(properties) {
            return new Clear(properties);
        };

        /**
         * Creates a Clear message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Clear
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Clear} Clear
         */
        Clear.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Clear)
                return object;
            return new $root.quack.Clear();
        };

        /**
         * Creates a plain object from a Clear message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Clear
         * @static
         * @param {quack.Clear} message Clear
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Clear.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Clear to JSON.
         * @function toJSON
         * @memberof quack.Clear
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Clear.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Clear;
    })();

    quack.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof quack
         * @interface IStatus
         * @property {string|null} [iccid] Status iccid
         * @property {string|null} [firmwareVersion] Status firmwareVersion
         * @property {number|null} [resetReason] Status resetReason
         */

        /**
         * Constructs a new Status.
         * @memberof quack
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {quack.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Status iccid.
         * @member {string} iccid
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.iccid = "";

        /**
         * Status firmwareVersion.
         * @member {string} firmwareVersion
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.firmwareVersion = "";

        /**
         * Status resetReason.
         * @member {number} resetReason
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.resetReason = 0;

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof quack.Status
         * @static
         * @param {quack.IStatus=} [properties] Properties to set
         * @returns {quack.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Status)
                return object;
            var message = new $root.quack.Status();
            if (object.iccid != null)
                message.iccid = String(object.iccid);
            if (object.firmwareVersion != null)
                message.firmwareVersion = String(object.firmwareVersion);
            if (object.resetReason != null)
                message.resetReason = object.resetReason >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Status
         * @static
         * @param {quack.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.iccid = "";
                object.firmwareVersion = "";
                object.resetReason = 0;
            }
            if (message.iccid != null && message.hasOwnProperty("iccid"))
                object.iccid = message.iccid;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            if (message.resetReason != null && message.hasOwnProperty("resetReason"))
                object.resetReason = message.resetReason;
            return object;
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof quack.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Status;
    })();

    quack.Connect = (function() {

        /**
         * Properties of a Connect.
         * @memberof quack
         * @interface IConnect
         * @property {string|null} [gateway] Connect gateway
         * @property {string|null} [password] Connect password
         */

        /**
         * Constructs a new Connect.
         * @memberof quack
         * @classdesc Represents a Connect.
         * @implements IConnect
         * @constructor
         * @param {quack.IConnect=} [properties] Properties to set
         */
        function Connect(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Connect gateway.
         * @member {string} gateway
         * @memberof quack.Connect
         * @instance
         */
        Connect.prototype.gateway = "";

        /**
         * Connect password.
         * @member {string} password
         * @memberof quack.Connect
         * @instance
         */
        Connect.prototype.password = "";

        /**
         * Creates a new Connect instance using the specified properties.
         * @function create
         * @memberof quack.Connect
         * @static
         * @param {quack.IConnect=} [properties] Properties to set
         * @returns {quack.Connect} Connect instance
         */
        Connect.create = function create(properties) {
            return new Connect(properties);
        };

        /**
         * Creates a Connect message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Connect
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Connect} Connect
         */
        Connect.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Connect)
                return object;
            var message = new $root.quack.Connect();
            if (object.gateway != null)
                message.gateway = String(object.gateway);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a Connect message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Connect
         * @static
         * @param {quack.Connect} message Connect
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Connect.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gateway = "";
                object.password = "";
            }
            if (message.gateway != null && message.hasOwnProperty("gateway"))
                object.gateway = message.gateway;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            return object;
        };

        /**
         * Converts this Connect to JSON.
         * @function toJSON
         * @memberof quack.Connect
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Connect.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Connect;
    })();

    /**
     * ComponentType enum.
     * @name quack.ComponentType
     * @enum {string}
     * @property {number} COMPONENT_TYPE_INVALID=0 COMPONENT_TYPE_INVALID value
     * @property {number} COMPONENT_TYPE_POWER=1 COMPONENT_TYPE_POWER value
     * @property {number} COMPONENT_TYPE_TEMPERATURE=2 COMPONENT_TYPE_TEMPERATURE value
     * @property {number} COMPONENT_TYPE_BOOLEAN_OUTPUT=3 COMPONENT_TYPE_BOOLEAN_OUTPUT value
     * @property {number} COMPONENT_TYPE_EDGE_TRIGGERED=4 COMPONENT_TYPE_EDGE_TRIGGERED value
     * @property {number} COMPONENT_TYPE_GRAIN_CABLE=5 COMPONENT_TYPE_GRAIN_CABLE value
     * @property {number} COMPONENT_TYPE_PRESSURE=6 COMPONENT_TYPE_PRESSURE value
     * @property {number} COMPONENT_TYPE_GPS=7 COMPONENT_TYPE_GPS value
     * @property {number} COMPONENT_TYPE_BOOLEAN_INPUT=8 COMPONENT_TYPE_BOOLEAN_INPUT value
     * @property {number} COMPONENT_TYPE_DHT=9 COMPONENT_TYPE_DHT value
     * @property {number} COMPONENT_TYPE_MODEM=10 COMPONENT_TYPE_MODEM value
     * @property {number} COMPONENT_TYPE_LIGHT=11 COMPONENT_TYPE_LIGHT value
     * @property {number} COMPONENT_TYPE_CO2=12 COMPONENT_TYPE_CO2 value
     * @property {number} COMPONENT_TYPE_STEPPER_MOTOR=13 COMPONENT_TYPE_STEPPER_MOTOR value
     * @property {number} COMPONENT_TYPE_ANALOG_INPUT=14 COMPONENT_TYPE_ANALOG_INPUT value
     * @property {number} COMPONENT_TYPE_O2=15 COMPONENT_TYPE_O2 value
     * @property {number} COMPONENT_TYPE_ETHYLENE=16 COMPONENT_TYPE_ETHYLENE value
     * @property {number} COMPONENT_TYPE_ORP=17 COMPONENT_TYPE_ORP value
     * @property {number} COMPONENT_TYPE_PH=18 COMPONENT_TYPE_PH value
     * @property {number} COMPONENT_TYPE_VOLTAGE=19 COMPONENT_TYPE_VOLTAGE value
     * @property {number} COMPONENT_TYPE_CALCIUM=20 COMPONENT_TYPE_CALCIUM value
     * @property {number} COMPONENT_TYPE_NITRATE=21 COMPONENT_TYPE_NITRATE value
     * @property {number} COMPONENT_TYPE_POTASSIUM=22 COMPONENT_TYPE_POTASSIUM value
     * @property {number} COMPONENT_TYPE_CONDUCTIVITY=23 COMPONENT_TYPE_CONDUCTIVITY value
     * @property {number} COMPONENT_TYPE_CAPACITANCE=24 COMPONENT_TYPE_CAPACITANCE value
     * @property {number} COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT=25 COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT value
     * @property {number} COMPONENT_TYPE_WEIGHT=26 COMPONENT_TYPE_WEIGHT value
     * @property {number} COMPONENT_TYPE_AIR_QUALITY=27 COMPONENT_TYPE_AIR_QUALITY value
     * @property {number} COMPONENT_TYPE_LIDAR=28 COMPONENT_TYPE_LIDAR value
     * @property {number} COMPONENT_TYPE_PRESSURE_CABLE=29 COMPONENT_TYPE_PRESSURE_CABLE value
     * @property {number} COMPONENT_TYPE_INTERNAL_FUNCTION=30 COMPONENT_TYPE_INTERNAL_FUNCTION value
     * @property {number} COMPONENT_TYPE_CAPACITOR_CABLE=31 COMPONENT_TYPE_CAPACITOR_CABLE value
     * @property {number} COMPONENT_TYPE_SEN5X=32 COMPONENT_TYPE_SEN5X value
     * @property {number} COMPONENT_TYPE_VIBRATION_CHAIN=33 COMPONENT_TYPE_VIBRATION_CHAIN value
     * @property {number} COMPONENT_TYPE_DRAGER_GAS_DONGLE=34 COMPONENT_TYPE_DRAGER_GAS_DONGLE value
     * @property {number} COMPONENT_TYPE_AIRFLOW=35 COMPONENT_TYPE_AIRFLOW value
     */
    quack.ComponentType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "COMPONENT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "COMPONENT_TYPE_POWER"] = 1;
        values[valuesById[2] = "COMPONENT_TYPE_TEMPERATURE"] = 2;
        values[valuesById[3] = "COMPONENT_TYPE_BOOLEAN_OUTPUT"] = 3;
        values[valuesById[4] = "COMPONENT_TYPE_EDGE_TRIGGERED"] = 4;
        values[valuesById[5] = "COMPONENT_TYPE_GRAIN_CABLE"] = 5;
        values[valuesById[6] = "COMPONENT_TYPE_PRESSURE"] = 6;
        values[valuesById[7] = "COMPONENT_TYPE_GPS"] = 7;
        values[valuesById[8] = "COMPONENT_TYPE_BOOLEAN_INPUT"] = 8;
        values[valuesById[9] = "COMPONENT_TYPE_DHT"] = 9;
        values[valuesById[10] = "COMPONENT_TYPE_MODEM"] = 10;
        values[valuesById[11] = "COMPONENT_TYPE_LIGHT"] = 11;
        values[valuesById[12] = "COMPONENT_TYPE_CO2"] = 12;
        values[valuesById[13] = "COMPONENT_TYPE_STEPPER_MOTOR"] = 13;
        values[valuesById[14] = "COMPONENT_TYPE_ANALOG_INPUT"] = 14;
        values[valuesById[15] = "COMPONENT_TYPE_O2"] = 15;
        values[valuesById[16] = "COMPONENT_TYPE_ETHYLENE"] = 16;
        values[valuesById[17] = "COMPONENT_TYPE_ORP"] = 17;
        values[valuesById[18] = "COMPONENT_TYPE_PH"] = 18;
        values[valuesById[19] = "COMPONENT_TYPE_VOLTAGE"] = 19;
        values[valuesById[20] = "COMPONENT_TYPE_CALCIUM"] = 20;
        values[valuesById[21] = "COMPONENT_TYPE_NITRATE"] = 21;
        values[valuesById[22] = "COMPONENT_TYPE_POTASSIUM"] = 22;
        values[valuesById[23] = "COMPONENT_TYPE_CONDUCTIVITY"] = 23;
        values[valuesById[24] = "COMPONENT_TYPE_CAPACITANCE"] = 24;
        values[valuesById[25] = "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT"] = 25;
        values[valuesById[26] = "COMPONENT_TYPE_WEIGHT"] = 26;
        values[valuesById[27] = "COMPONENT_TYPE_AIR_QUALITY"] = 27;
        values[valuesById[28] = "COMPONENT_TYPE_LIDAR"] = 28;
        values[valuesById[29] = "COMPONENT_TYPE_PRESSURE_CABLE"] = 29;
        values[valuesById[30] = "COMPONENT_TYPE_INTERNAL_FUNCTION"] = 30;
        values[valuesById[31] = "COMPONENT_TYPE_CAPACITOR_CABLE"] = 31;
        values[valuesById[32] = "COMPONENT_TYPE_SEN5X"] = 32;
        values[valuesById[33] = "COMPONENT_TYPE_VIBRATION_CHAIN"] = 33;
        values[valuesById[34] = "COMPONENT_TYPE_DRAGER_GAS_DONGLE"] = 34;
        values[valuesById[35] = "COMPONENT_TYPE_AIRFLOW"] = 35;
        return values;
    })();

    /**
     * AddressType enum.
     * @name quack.AddressType
     * @enum {string}
     * @property {number} ADDRESS_TYPE_INVALID=0 ADDRESS_TYPE_INVALID value
     * @property {number} ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY=1 ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY value
     * @property {number} ADDRESS_TYPE_I2C=2 ADDRESS_TYPE_I2C value
     * @property {number} ADDRESS_TYPE_DAC=3 ADDRESS_TYPE_DAC value
     * @property {number} ADDRESS_TYPE_POWER=4 ADDRESS_TYPE_POWER value
     * @property {number} ADDRESS_TYPE_GPS=5 ADDRESS_TYPE_GPS value
     * @property {number} ADDRESS_TYPE_MODEM=6 ADDRESS_TYPE_MODEM value
     * @property {number} ADDRESS_TYPE_I2C_WITH_CHANNELS=7 ADDRESS_TYPE_I2C_WITH_CHANNELS value
     * @property {number} ADDRESS_TYPE_INCREMENTAL=8 ADDRESS_TYPE_INCREMENTAL value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET1=9 ADDRESS_TYPE_PIN_OFFSET1 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET2=10 ADDRESS_TYPE_PIN_OFFSET2 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET3=11 ADDRESS_TYPE_PIN_OFFSET3 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET4=12 ADDRESS_TYPE_PIN_OFFSET4 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET5=13 ADDRESS_TYPE_PIN_OFFSET5 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET6=14 ADDRESS_TYPE_PIN_OFFSET6 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET7=15 ADDRESS_TYPE_PIN_OFFSET7 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET8=16 ADDRESS_TYPE_PIN_OFFSET8 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET9=17 ADDRESS_TYPE_PIN_OFFSET9 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET10=18 ADDRESS_TYPE_PIN_OFFSET10 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET11=19 ADDRESS_TYPE_PIN_OFFSET11 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET12=20 ADDRESS_TYPE_PIN_OFFSET12 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET13=21 ADDRESS_TYPE_PIN_OFFSET13 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET14=22 ADDRESS_TYPE_PIN_OFFSET14 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET15=23 ADDRESS_TYPE_PIN_OFFSET15 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET16=24 ADDRESS_TYPE_PIN_OFFSET16 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET17=25 ADDRESS_TYPE_PIN_OFFSET17 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET18=26 ADDRESS_TYPE_PIN_OFFSET18 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET19=27 ADDRESS_TYPE_PIN_OFFSET19 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET20=28 ADDRESS_TYPE_PIN_OFFSET20 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET21=29 ADDRESS_TYPE_PIN_OFFSET21 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET22=30 ADDRESS_TYPE_PIN_OFFSET22 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET23=31 ADDRESS_TYPE_PIN_OFFSET23 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET24=32 ADDRESS_TYPE_PIN_OFFSET24 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET25=33 ADDRESS_TYPE_PIN_OFFSET25 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET26=34 ADDRESS_TYPE_PIN_OFFSET26 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET27=35 ADDRESS_TYPE_PIN_OFFSET27 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET28=36 ADDRESS_TYPE_PIN_OFFSET28 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET29=37 ADDRESS_TYPE_PIN_OFFSET29 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET30=38 ADDRESS_TYPE_PIN_OFFSET30 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET31=39 ADDRESS_TYPE_PIN_OFFSET31 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET32=40 ADDRESS_TYPE_PIN_OFFSET32 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET33=41 ADDRESS_TYPE_PIN_OFFSET33 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET34=42 ADDRESS_TYPE_PIN_OFFSET34 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET35=43 ADDRESS_TYPE_PIN_OFFSET35 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET36=44 ADDRESS_TYPE_PIN_OFFSET36 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET37=45 ADDRESS_TYPE_PIN_OFFSET37 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET38=46 ADDRESS_TYPE_PIN_OFFSET38 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET39=47 ADDRESS_TYPE_PIN_OFFSET39 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET40=48 ADDRESS_TYPE_PIN_OFFSET40 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET41=49 ADDRESS_TYPE_PIN_OFFSET41 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET42=50 ADDRESS_TYPE_PIN_OFFSET42 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET43=51 ADDRESS_TYPE_PIN_OFFSET43 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET44=52 ADDRESS_TYPE_PIN_OFFSET44 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET45=53 ADDRESS_TYPE_PIN_OFFSET45 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET46=54 ADDRESS_TYPE_PIN_OFFSET46 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET47=55 ADDRESS_TYPE_PIN_OFFSET47 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET48=56 ADDRESS_TYPE_PIN_OFFSET48 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET49=57 ADDRESS_TYPE_PIN_OFFSET49 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET50=58 ADDRESS_TYPE_PIN_OFFSET50 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET51=59 ADDRESS_TYPE_PIN_OFFSET51 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET52=60 ADDRESS_TYPE_PIN_OFFSET52 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET53=61 ADDRESS_TYPE_PIN_OFFSET53 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET54=62 ADDRESS_TYPE_PIN_OFFSET54 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET55=63 ADDRESS_TYPE_PIN_OFFSET55 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET56=64 ADDRESS_TYPE_PIN_OFFSET56 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET57=65 ADDRESS_TYPE_PIN_OFFSET57 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET58=66 ADDRESS_TYPE_PIN_OFFSET58 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET59=67 ADDRESS_TYPE_PIN_OFFSET59 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET60=68 ADDRESS_TYPE_PIN_OFFSET60 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET61=69 ADDRESS_TYPE_PIN_OFFSET61 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET62=70 ADDRESS_TYPE_PIN_OFFSET62 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET63=71 ADDRESS_TYPE_PIN_OFFSET63 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET64=72 ADDRESS_TYPE_PIN_OFFSET64 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET65=73 ADDRESS_TYPE_PIN_OFFSET65 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET66=74 ADDRESS_TYPE_PIN_OFFSET66 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET67=75 ADDRESS_TYPE_PIN_OFFSET67 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET68=76 ADDRESS_TYPE_PIN_OFFSET68 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET69=77 ADDRESS_TYPE_PIN_OFFSET69 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET70=78 ADDRESS_TYPE_PIN_OFFSET70 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET71=79 ADDRESS_TYPE_PIN_OFFSET71 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET72=80 ADDRESS_TYPE_PIN_OFFSET72 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET73=81 ADDRESS_TYPE_PIN_OFFSET73 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET74=82 ADDRESS_TYPE_PIN_OFFSET74 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET75=83 ADDRESS_TYPE_PIN_OFFSET75 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET76=84 ADDRESS_TYPE_PIN_OFFSET76 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET77=85 ADDRESS_TYPE_PIN_OFFSET77 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET78=86 ADDRESS_TYPE_PIN_OFFSET78 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET79=87 ADDRESS_TYPE_PIN_OFFSET79 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET80=88 ADDRESS_TYPE_PIN_OFFSET80 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET81=89 ADDRESS_TYPE_PIN_OFFSET81 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET82=90 ADDRESS_TYPE_PIN_OFFSET82 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET83=91 ADDRESS_TYPE_PIN_OFFSET83 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET84=92 ADDRESS_TYPE_PIN_OFFSET84 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET85=93 ADDRESS_TYPE_PIN_OFFSET85 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET86=94 ADDRESS_TYPE_PIN_OFFSET86 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET87=95 ADDRESS_TYPE_PIN_OFFSET87 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET88=96 ADDRESS_TYPE_PIN_OFFSET88 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET89=97 ADDRESS_TYPE_PIN_OFFSET89 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET90=98 ADDRESS_TYPE_PIN_OFFSET90 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET91=99 ADDRESS_TYPE_PIN_OFFSET91 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET92=100 ADDRESS_TYPE_PIN_OFFSET92 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET93=101 ADDRESS_TYPE_PIN_OFFSET93 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET94=102 ADDRESS_TYPE_PIN_OFFSET94 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET95=103 ADDRESS_TYPE_PIN_OFFSET95 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET96=104 ADDRESS_TYPE_PIN_OFFSET96 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET97=105 ADDRESS_TYPE_PIN_OFFSET97 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET98=106 ADDRESS_TYPE_PIN_OFFSET98 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET99=107 ADDRESS_TYPE_PIN_OFFSET99 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET100=108 ADDRESS_TYPE_PIN_OFFSET100 value
     * @property {number} ADDRESS_TYPE_INTERNAL_SLEEP=109 ADDRESS_TYPE_INTERNAL_SLEEP value
     * @property {number} ADDRESS_TYPE_SPI=110 ADDRESS_TYPE_SPI value
     */
    quack.AddressType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ADDRESS_TYPE_INVALID"] = 0;
        values[valuesById[1] = "ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY"] = 1;
        values[valuesById[2] = "ADDRESS_TYPE_I2C"] = 2;
        values[valuesById[3] = "ADDRESS_TYPE_DAC"] = 3;
        values[valuesById[4] = "ADDRESS_TYPE_POWER"] = 4;
        values[valuesById[5] = "ADDRESS_TYPE_GPS"] = 5;
        values[valuesById[6] = "ADDRESS_TYPE_MODEM"] = 6;
        values[valuesById[7] = "ADDRESS_TYPE_I2C_WITH_CHANNELS"] = 7;
        values[valuesById[8] = "ADDRESS_TYPE_INCREMENTAL"] = 8;
        values[valuesById[9] = "ADDRESS_TYPE_PIN_OFFSET1"] = 9;
        values[valuesById[10] = "ADDRESS_TYPE_PIN_OFFSET2"] = 10;
        values[valuesById[11] = "ADDRESS_TYPE_PIN_OFFSET3"] = 11;
        values[valuesById[12] = "ADDRESS_TYPE_PIN_OFFSET4"] = 12;
        values[valuesById[13] = "ADDRESS_TYPE_PIN_OFFSET5"] = 13;
        values[valuesById[14] = "ADDRESS_TYPE_PIN_OFFSET6"] = 14;
        values[valuesById[15] = "ADDRESS_TYPE_PIN_OFFSET7"] = 15;
        values[valuesById[16] = "ADDRESS_TYPE_PIN_OFFSET8"] = 16;
        values[valuesById[17] = "ADDRESS_TYPE_PIN_OFFSET9"] = 17;
        values[valuesById[18] = "ADDRESS_TYPE_PIN_OFFSET10"] = 18;
        values[valuesById[19] = "ADDRESS_TYPE_PIN_OFFSET11"] = 19;
        values[valuesById[20] = "ADDRESS_TYPE_PIN_OFFSET12"] = 20;
        values[valuesById[21] = "ADDRESS_TYPE_PIN_OFFSET13"] = 21;
        values[valuesById[22] = "ADDRESS_TYPE_PIN_OFFSET14"] = 22;
        values[valuesById[23] = "ADDRESS_TYPE_PIN_OFFSET15"] = 23;
        values[valuesById[24] = "ADDRESS_TYPE_PIN_OFFSET16"] = 24;
        values[valuesById[25] = "ADDRESS_TYPE_PIN_OFFSET17"] = 25;
        values[valuesById[26] = "ADDRESS_TYPE_PIN_OFFSET18"] = 26;
        values[valuesById[27] = "ADDRESS_TYPE_PIN_OFFSET19"] = 27;
        values[valuesById[28] = "ADDRESS_TYPE_PIN_OFFSET20"] = 28;
        values[valuesById[29] = "ADDRESS_TYPE_PIN_OFFSET21"] = 29;
        values[valuesById[30] = "ADDRESS_TYPE_PIN_OFFSET22"] = 30;
        values[valuesById[31] = "ADDRESS_TYPE_PIN_OFFSET23"] = 31;
        values[valuesById[32] = "ADDRESS_TYPE_PIN_OFFSET24"] = 32;
        values[valuesById[33] = "ADDRESS_TYPE_PIN_OFFSET25"] = 33;
        values[valuesById[34] = "ADDRESS_TYPE_PIN_OFFSET26"] = 34;
        values[valuesById[35] = "ADDRESS_TYPE_PIN_OFFSET27"] = 35;
        values[valuesById[36] = "ADDRESS_TYPE_PIN_OFFSET28"] = 36;
        values[valuesById[37] = "ADDRESS_TYPE_PIN_OFFSET29"] = 37;
        values[valuesById[38] = "ADDRESS_TYPE_PIN_OFFSET30"] = 38;
        values[valuesById[39] = "ADDRESS_TYPE_PIN_OFFSET31"] = 39;
        values[valuesById[40] = "ADDRESS_TYPE_PIN_OFFSET32"] = 40;
        values[valuesById[41] = "ADDRESS_TYPE_PIN_OFFSET33"] = 41;
        values[valuesById[42] = "ADDRESS_TYPE_PIN_OFFSET34"] = 42;
        values[valuesById[43] = "ADDRESS_TYPE_PIN_OFFSET35"] = 43;
        values[valuesById[44] = "ADDRESS_TYPE_PIN_OFFSET36"] = 44;
        values[valuesById[45] = "ADDRESS_TYPE_PIN_OFFSET37"] = 45;
        values[valuesById[46] = "ADDRESS_TYPE_PIN_OFFSET38"] = 46;
        values[valuesById[47] = "ADDRESS_TYPE_PIN_OFFSET39"] = 47;
        values[valuesById[48] = "ADDRESS_TYPE_PIN_OFFSET40"] = 48;
        values[valuesById[49] = "ADDRESS_TYPE_PIN_OFFSET41"] = 49;
        values[valuesById[50] = "ADDRESS_TYPE_PIN_OFFSET42"] = 50;
        values[valuesById[51] = "ADDRESS_TYPE_PIN_OFFSET43"] = 51;
        values[valuesById[52] = "ADDRESS_TYPE_PIN_OFFSET44"] = 52;
        values[valuesById[53] = "ADDRESS_TYPE_PIN_OFFSET45"] = 53;
        values[valuesById[54] = "ADDRESS_TYPE_PIN_OFFSET46"] = 54;
        values[valuesById[55] = "ADDRESS_TYPE_PIN_OFFSET47"] = 55;
        values[valuesById[56] = "ADDRESS_TYPE_PIN_OFFSET48"] = 56;
        values[valuesById[57] = "ADDRESS_TYPE_PIN_OFFSET49"] = 57;
        values[valuesById[58] = "ADDRESS_TYPE_PIN_OFFSET50"] = 58;
        values[valuesById[59] = "ADDRESS_TYPE_PIN_OFFSET51"] = 59;
        values[valuesById[60] = "ADDRESS_TYPE_PIN_OFFSET52"] = 60;
        values[valuesById[61] = "ADDRESS_TYPE_PIN_OFFSET53"] = 61;
        values[valuesById[62] = "ADDRESS_TYPE_PIN_OFFSET54"] = 62;
        values[valuesById[63] = "ADDRESS_TYPE_PIN_OFFSET55"] = 63;
        values[valuesById[64] = "ADDRESS_TYPE_PIN_OFFSET56"] = 64;
        values[valuesById[65] = "ADDRESS_TYPE_PIN_OFFSET57"] = 65;
        values[valuesById[66] = "ADDRESS_TYPE_PIN_OFFSET58"] = 66;
        values[valuesById[67] = "ADDRESS_TYPE_PIN_OFFSET59"] = 67;
        values[valuesById[68] = "ADDRESS_TYPE_PIN_OFFSET60"] = 68;
        values[valuesById[69] = "ADDRESS_TYPE_PIN_OFFSET61"] = 69;
        values[valuesById[70] = "ADDRESS_TYPE_PIN_OFFSET62"] = 70;
        values[valuesById[71] = "ADDRESS_TYPE_PIN_OFFSET63"] = 71;
        values[valuesById[72] = "ADDRESS_TYPE_PIN_OFFSET64"] = 72;
        values[valuesById[73] = "ADDRESS_TYPE_PIN_OFFSET65"] = 73;
        values[valuesById[74] = "ADDRESS_TYPE_PIN_OFFSET66"] = 74;
        values[valuesById[75] = "ADDRESS_TYPE_PIN_OFFSET67"] = 75;
        values[valuesById[76] = "ADDRESS_TYPE_PIN_OFFSET68"] = 76;
        values[valuesById[77] = "ADDRESS_TYPE_PIN_OFFSET69"] = 77;
        values[valuesById[78] = "ADDRESS_TYPE_PIN_OFFSET70"] = 78;
        values[valuesById[79] = "ADDRESS_TYPE_PIN_OFFSET71"] = 79;
        values[valuesById[80] = "ADDRESS_TYPE_PIN_OFFSET72"] = 80;
        values[valuesById[81] = "ADDRESS_TYPE_PIN_OFFSET73"] = 81;
        values[valuesById[82] = "ADDRESS_TYPE_PIN_OFFSET74"] = 82;
        values[valuesById[83] = "ADDRESS_TYPE_PIN_OFFSET75"] = 83;
        values[valuesById[84] = "ADDRESS_TYPE_PIN_OFFSET76"] = 84;
        values[valuesById[85] = "ADDRESS_TYPE_PIN_OFFSET77"] = 85;
        values[valuesById[86] = "ADDRESS_TYPE_PIN_OFFSET78"] = 86;
        values[valuesById[87] = "ADDRESS_TYPE_PIN_OFFSET79"] = 87;
        values[valuesById[88] = "ADDRESS_TYPE_PIN_OFFSET80"] = 88;
        values[valuesById[89] = "ADDRESS_TYPE_PIN_OFFSET81"] = 89;
        values[valuesById[90] = "ADDRESS_TYPE_PIN_OFFSET82"] = 90;
        values[valuesById[91] = "ADDRESS_TYPE_PIN_OFFSET83"] = 91;
        values[valuesById[92] = "ADDRESS_TYPE_PIN_OFFSET84"] = 92;
        values[valuesById[93] = "ADDRESS_TYPE_PIN_OFFSET85"] = 93;
        values[valuesById[94] = "ADDRESS_TYPE_PIN_OFFSET86"] = 94;
        values[valuesById[95] = "ADDRESS_TYPE_PIN_OFFSET87"] = 95;
        values[valuesById[96] = "ADDRESS_TYPE_PIN_OFFSET88"] = 96;
        values[valuesById[97] = "ADDRESS_TYPE_PIN_OFFSET89"] = 97;
        values[valuesById[98] = "ADDRESS_TYPE_PIN_OFFSET90"] = 98;
        values[valuesById[99] = "ADDRESS_TYPE_PIN_OFFSET91"] = 99;
        values[valuesById[100] = "ADDRESS_TYPE_PIN_OFFSET92"] = 100;
        values[valuesById[101] = "ADDRESS_TYPE_PIN_OFFSET93"] = 101;
        values[valuesById[102] = "ADDRESS_TYPE_PIN_OFFSET94"] = 102;
        values[valuesById[103] = "ADDRESS_TYPE_PIN_OFFSET95"] = 103;
        values[valuesById[104] = "ADDRESS_TYPE_PIN_OFFSET96"] = 104;
        values[valuesById[105] = "ADDRESS_TYPE_PIN_OFFSET97"] = 105;
        values[valuesById[106] = "ADDRESS_TYPE_PIN_OFFSET98"] = 106;
        values[valuesById[107] = "ADDRESS_TYPE_PIN_OFFSET99"] = 107;
        values[valuesById[108] = "ADDRESS_TYPE_PIN_OFFSET100"] = 108;
        values[valuesById[109] = "ADDRESS_TYPE_INTERNAL_SLEEP"] = 109;
        values[valuesById[110] = "ADDRESS_TYPE_SPI"] = 110;
        return values;
    })();

    /**
     * PowerSubtype enum.
     * @name quack.PowerSubtype
     * @enum {string}
     * @property {number} POWER_SUBTYPE_NONE=0 POWER_SUBTYPE_NONE value
     * @property {number} POWER_SUBTYPE_NO_BATTERY=1 POWER_SUBTYPE_NO_BATTERY value
     */
    quack.PowerSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "POWER_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "POWER_SUBTYPE_NO_BATTERY"] = 1;
        return values;
    })();

    /**
     * TemperatureSubtype enum.
     * @name quack.TemperatureSubtype
     * @enum {string}
     * @property {number} TEMPERATURE_SUBTYPE_NONE=0 TEMPERATURE_SUBTYPE_NONE value
     * @property {number} TEMPERATURE_SUBTYPE_ONEWIRE_DS18=1 TEMPERATURE_SUBTYPE_ONEWIRE_DS18 value
     * @property {number} TEMPERATURE_SUBTYPE_ANALOG=2 TEMPERATURE_SUBTYPE_ANALOG value
     */
    quack.TemperatureSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TEMPERATURE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "TEMPERATURE_SUBTYPE_ONEWIRE_DS18"] = 1;
        values[valuesById[2] = "TEMPERATURE_SUBTYPE_ANALOG"] = 2;
        return values;
    })();

    /**
     * BooleanOutputSubtype enum.
     * @name quack.BooleanOutputSubtype
     * @enum {string}
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_NONE=0 BOOLEAN_OUTPUT_SUBTYPE_NONE value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_LED=1 BOOLEAN_OUTPUT_SUBTYPE_LED value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_HEATER=2 BOOLEAN_OUTPUT_SUBTYPE_HEATER value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN=3 BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN=4 BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN value
     */
    quack.BooleanOutputSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BOOLEAN_OUTPUT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "BOOLEAN_OUTPUT_SUBTYPE_LED"] = 1;
        values[valuesById[2] = "BOOLEAN_OUTPUT_SUBTYPE_HEATER"] = 2;
        values[valuesById[3] = "BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN"] = 3;
        values[valuesById[4] = "BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN"] = 4;
        return values;
    })();

    /**
     * EdgeTriggeredSubtype enum.
     * @name quack.EdgeTriggeredSubtype
     * @enum {string}
     * @property {number} EDGE_TRIGGERED_SUBTYPE_NONE=0 EDGE_TRIGGERED_SUBTYPE_NONE value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_DOOR=1 EDGE_TRIGGERED_SUBTYPE_DOOR value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_WATER=2 EDGE_TRIGGERED_SUBTYPE_WATER value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_RAIN=3 EDGE_TRIGGERED_SUBTYPE_RAIN value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_WIND_SPEED=4 EDGE_TRIGGERED_SUBTYPE_WIND_SPEED value
     */
    quack.EdgeTriggeredSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EDGE_TRIGGERED_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "EDGE_TRIGGERED_SUBTYPE_DOOR"] = 1;
        values[valuesById[2] = "EDGE_TRIGGERED_SUBTYPE_WATER"] = 2;
        values[valuesById[3] = "EDGE_TRIGGERED_SUBTYPE_RAIN"] = 3;
        values[valuesById[4] = "EDGE_TRIGGERED_SUBTYPE_WIND_SPEED"] = 4;
        return values;
    })();

    /**
     * PressureSubtype enum.
     * @name quack.PressureSubtype
     * @enum {string}
     * @property {number} PRESSURE_SUBTYPE_NONE=0 PRESSURE_SUBTYPE_NONE value
     * @property {number} PRESSURE_SUBTYPE_GAUGE=1 PRESSURE_SUBTYPE_GAUGE value
     * @property {number} PRESSURE_SUBTYPE_FROG=2 PRESSURE_SUBTYPE_FROG value
     */
    quack.PressureSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRESSURE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "PRESSURE_SUBTYPE_GAUGE"] = 1;
        values[valuesById[2] = "PRESSURE_SUBTYPE_FROG"] = 2;
        return values;
    })();

    /**
     * DHTSubtype enum.
     * @name quack.DHTSubtype
     * @enum {string}
     * @property {number} DHT_SUBTYPE_NONE=0 DHT_SUBTYPE_NONE value
     * @property {number} DHT_SUBTYPE_22=1 DHT_SUBTYPE_22 value
     * @property {number} DHT_SUBTYPE_SHT20=2 DHT_SUBTYPE_SHT20 value
     * @property {number} DHT_SUBTYPE_FROG=3 DHT_SUBTYPE_FROG value
     * @property {number} DHT_SUBTYPE_SCD30=4 DHT_SUBTYPE_SCD30 value
     */
    quack.DHTSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DHT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "DHT_SUBTYPE_22"] = 1;
        values[valuesById[2] = "DHT_SUBTYPE_SHT20"] = 2;
        values[valuesById[3] = "DHT_SUBTYPE_FROG"] = 3;
        values[valuesById[4] = "DHT_SUBTYPE_SCD30"] = 4;
        return values;
    })();

    /**
     * GrainCableSubtype enum.
     * @name quack.GrainCableSubtype
     * @enum {string}
     * @property {number} GRAIN_CABLE_SUBTYPE_NONE=0 GRAIN_CABLE_SUBTYPE_NONE value
     * @property {number} GRAIN_CABLE_SUBTYPE_FROG=1 GRAIN_CABLE_SUBTYPE_FROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_TEMP=2 GRAIN_CABLE_SUBTYPE_OPI_TEMP value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_SHT35=3 GRAIN_CABLE_SUBTYPE_OPI_SHT35 value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_DIAG=4 GRAIN_CABLE_SUBTYPE_OPI_DIAG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_REPROG=5 GRAIN_CABLE_SUBTYPE_OPI_REPROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG=6 GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG=7 GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC=8 GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC value
     * @property {number} GRAIN_CABLE_SUBTYPE_ANALOG=9 GRAIN_CABLE_SUBTYPE_ANALOG value
     */
    quack.GrainCableSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GRAIN_CABLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "GRAIN_CABLE_SUBTYPE_FROG"] = 1;
        values[valuesById[2] = "GRAIN_CABLE_SUBTYPE_OPI_TEMP"] = 2;
        values[valuesById[3] = "GRAIN_CABLE_SUBTYPE_OPI_SHT35"] = 3;
        values[valuesById[4] = "GRAIN_CABLE_SUBTYPE_OPI_DIAG"] = 4;
        values[valuesById[5] = "GRAIN_CABLE_SUBTYPE_OPI_REPROG"] = 5;
        values[valuesById[6] = "GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG"] = 6;
        values[valuesById[7] = "GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG"] = 7;
        values[valuesById[8] = "GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC"] = 8;
        values[valuesById[9] = "GRAIN_CABLE_SUBTYPE_ANALOG"] = 9;
        return values;
    })();

    /**
     * LidarSubtype enum.
     * @name quack.LidarSubtype
     * @enum {string}
     * @property {number} LIDAR_SUBTYPE_NONE=0 LIDAR_SUBTYPE_NONE value
     * @property {number} LIDAR_SUBTYPE_LONG_DISTANCE=1 LIDAR_SUBTYPE_LONG_DISTANCE value
     * @property {number} LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE=2 LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE value
     */
    quack.LidarSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LIDAR_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "LIDAR_SUBTYPE_LONG_DISTANCE"] = 1;
        values[valuesById[2] = "LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE"] = 2;
        return values;
    })();

    /**
     * CapacitorCableSubtype enum.
     * @name quack.CapacitorCableSubtype
     * @enum {string}
     * @property {number} CAPACITOR_CABLE_SUBTYPE_NONE=0 CAPACITOR_CABLE_SUBTYPE_NONE value
     * @property {number} CAPACITOR_CABLE_SUBTYPE_FROG=1 CAPACITOR_CABLE_SUBTYPE_FROG value
     */
    quack.CapacitorCableSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CAPACITOR_CABLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "CAPACITOR_CABLE_SUBTYPE_FROG"] = 1;
        return values;
    })();

    /**
     * AnalogInputSubtype enum.
     * @name quack.AnalogInputSubtype
     * @enum {string}
     * @property {number} ANALOG_INPUT_SUBTYPE_NONE=0 ANALOG_INPUT_SUBTYPE_NONE value
     * @property {number} ANALOG_INPUT_SUBTYPE_FUEL=1 ANALOG_INPUT_SUBTYPE_FUEL value
     * @property {number} ANALOG_INPUT_SUBTYPE_WIND_SPEED=2 ANALOG_INPUT_SUBTYPE_WIND_SPEED value
     * @property {number} ANALOG_INPUT_SUBTYPE_WIND_DIRECTION=3 ANALOG_INPUT_SUBTYPE_WIND_DIRECTION value
     * @property {number} ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER=4 ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER value
     */
    quack.AnalogInputSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ANALOG_INPUT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "ANALOG_INPUT_SUBTYPE_FUEL"] = 1;
        values[valuesById[2] = "ANALOG_INPUT_SUBTYPE_WIND_SPEED"] = 2;
        values[valuesById[3] = "ANALOG_INPUT_SUBTYPE_WIND_DIRECTION"] = 3;
        values[valuesById[4] = "ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER"] = 4;
        return values;
    })();

    /**
     * AirQualitySubtype enum.
     * @name quack.AirQualitySubtype
     * @enum {string}
     * @property {number} AIR_QUALITY_SUBTYPE_SGP30=0 AIR_QUALITY_SUBTYPE_SGP30 value
     */
    quack.AirQualitySubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AIR_QUALITY_SUBTYPE_SGP30"] = 0;
        return values;
    })();

    /**
     * CapacitanceSubtype enum.
     * @name quack.CapacitanceSubtype
     * @enum {string}
     * @property {number} CAPACITANCE_SUBTYPE_NONE=0 CAPACITANCE_SUBTYPE_NONE value
     * @property {number} CAPACITANCE_SUBTYPE_FDC=1 CAPACITANCE_SUBTYPE_FDC value
     */
    quack.CapacitanceSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CAPACITANCE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "CAPACITANCE_SUBTYPE_FDC"] = 1;
        return values;
    })();

    /**
     * DragerGasDongleSubtype enum.
     * @name quack.DragerGasDongleSubtype
     * @enum {string}
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_NONE=0 DRAGER_GAS_DONGLE_SUBTYPE_NONE value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE=1 DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2=2 DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO=3 DRAGER_GAS_DONGLE_SUBTYPE_CO value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO2=4 DRAGER_GAS_DONGLE_SUBTYPE_CO2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_NO2=5 DRAGER_GAS_DONGLE_SUBTYPE_NO2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_O2=6 DRAGER_GAS_DONGLE_SUBTYPE_O2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_H2S=7 DRAGER_GAS_DONGLE_SUBTYPE_H2S value
     */
    quack.DragerGasDongleSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DRAGER_GAS_DONGLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE"] = 1;
        values[valuesById[2] = "DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2"] = 2;
        values[valuesById[3] = "DRAGER_GAS_DONGLE_SUBTYPE_CO"] = 3;
        values[valuesById[4] = "DRAGER_GAS_DONGLE_SUBTYPE_CO2"] = 4;
        values[valuesById[5] = "DRAGER_GAS_DONGLE_SUBTYPE_NO2"] = 5;
        values[valuesById[6] = "DRAGER_GAS_DONGLE_SUBTYPE_O2"] = 6;
        values[valuesById[7] = "DRAGER_GAS_DONGLE_SUBTYPE_H2S"] = 7;
        return values;
    })();

    /**
     * AirFlowSubtype enum.
     * @name quack.AirFlowSubtype
     * @enum {string}
     * @property {number} AIR_FLOW_SUBTYPE_PROSENSE=0 AIR_FLOW_SUBTYPE_PROSENSE value
     * @property {number} AIR_FLOW_SUBTYPE_ULTRASONIC=1 AIR_FLOW_SUBTYPE_ULTRASONIC value
     */
    quack.AirFlowSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AIR_FLOW_SUBTYPE_PROSENSE"] = 0;
        values[valuesById[1] = "AIR_FLOW_SUBTYPE_ULTRASONIC"] = 1;
        return values;
    })();

    /**
     * OutputMode enum.
     * @name quack.OutputMode
     * @enum {string}
     * @property {number} OUTPUT_MODE_AUTO=0 OUTPUT_MODE_AUTO value
     * @property {number} OUTPUT_MODE_ON=1 OUTPUT_MODE_ON value
     * @property {number} OUTPUT_MODE_OFF=2 OUTPUT_MODE_OFF value
     */
    quack.OutputMode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OUTPUT_MODE_AUTO"] = 0;
        values[valuesById[1] = "OUTPUT_MODE_ON"] = 1;
        values[valuesById[2] = "OUTPUT_MODE_OFF"] = 2;
        return values;
    })();

    quack.Calibration = (function() {

        /**
         * Properties of a Calibration.
         * @memberof quack
         * @interface ICalibration
         * @property {number|null} [calibrationCoefficient] Calibration calibrationCoefficient
         * @property {number|null} [calibrationOffset] Calibration calibrationOffset
         * @property {quack.MeasurementType|null} [measurementType] Calibration measurementType
         */

        /**
         * Constructs a new Calibration.
         * @memberof quack
         * @classdesc Represents a Calibration.
         * @implements ICalibration
         * @constructor
         * @param {quack.ICalibration=} [properties] Properties to set
         */
        function Calibration(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Calibration calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.calibrationCoefficient = 0;

        /**
         * Calibration calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.calibrationOffset = 0;

        /**
         * Calibration measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.measurementType = 0;

        /**
         * Creates a new Calibration instance using the specified properties.
         * @function create
         * @memberof quack.Calibration
         * @static
         * @param {quack.ICalibration=} [properties] Properties to set
         * @returns {quack.Calibration} Calibration instance
         */
        Calibration.create = function create(properties) {
            return new Calibration(properties);
        };

        /**
         * Creates a Calibration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Calibration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Calibration} Calibration
         */
        Calibration.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Calibration)
                return object;
            var message = new $root.quack.Calibration();
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Calibration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Calibration
         * @static
         * @param {quack.Calibration} message Calibration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Calibration.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            }
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            return object;
        };

        /**
         * Converts this Calibration to JSON.
         * @function toJSON
         * @memberof quack.Calibration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Calibration.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Calibration;
    })();

    quack.Component = (function() {

        /**
         * Properties of a Component.
         * @memberof quack
         * @interface IComponent
         * @property {number|null} [type] Component type
         * @property {number|null} [subtype] Component subtype
         * @property {string|null} [name] Component name
         * @property {number|null} [reportPeriodMs] Component reportPeriodMs
         * @property {number|null} [measurementPeriodMs] Component measurementPeriodMs
         * @property {number|null} [defaultOutputState] Component defaultOutputState
         * @property {number|null} [minCycleTimeMs] Component minCycleTimeMs
         * @property {number|null} [addressType] Component addressType
         * @property {number|null} [address] Component address
         * @property {boolean|null} [calibrate] Component calibrate
         * @property {number|null} [calibrationCoefficient] Component calibrationCoefficient
         * @property {number|null} [calibrationOffset] Component calibrationOffset
         * @property {Array.<quack.Calibration>|null} [calibrations] Component calibrations
         */

        /**
         * Constructs a new Component.
         * @memberof quack
         * @classdesc Represents a Component.
         * @implements IComponent
         * @constructor
         * @param {quack.IComponent=} [properties] Properties to set
         */
        function Component(properties) {
            this.calibrations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Component type.
         * @member {number} type
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.type = 0;

        /**
         * Component subtype.
         * @member {number} subtype
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.subtype = 0;

        /**
         * Component name.
         * @member {string} name
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.name = "";

        /**
         * Component reportPeriodMs.
         * @member {number} reportPeriodMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.reportPeriodMs = 0;

        /**
         * Component measurementPeriodMs.
         * @member {number} measurementPeriodMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.measurementPeriodMs = 0;

        /**
         * Component defaultOutputState.
         * @member {number} defaultOutputState
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.defaultOutputState = 0;

        /**
         * Component minCycleTimeMs.
         * @member {number} minCycleTimeMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.minCycleTimeMs = 0;

        /**
         * Component addressType.
         * @member {number} addressType
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.addressType = 0;

        /**
         * Component address.
         * @member {number} address
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.address = 0;

        /**
         * Component calibrate.
         * @member {boolean} calibrate
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrate = false;

        /**
         * Component calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrationCoefficient = 0;

        /**
         * Component calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrationOffset = 0;

        /**
         * Component calibrations.
         * @member {Array.<quack.Calibration>} calibrations
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrations = $util.emptyArray;

        /**
         * Creates a new Component instance using the specified properties.
         * @function create
         * @memberof quack.Component
         * @static
         * @param {quack.IComponent=} [properties] Properties to set
         * @returns {quack.Component} Component instance
         */
        Component.create = function create(properties) {
            return new Component(properties);
        };

        /**
         * Creates a Component message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Component
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Component} Component
         */
        Component.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Component)
                return object;
            var message = new $root.quack.Component();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.name != null)
                message.name = String(object.name);
            if (object.reportPeriodMs != null)
                message.reportPeriodMs = object.reportPeriodMs >>> 0;
            if (object.measurementPeriodMs != null)
                message.measurementPeriodMs = object.measurementPeriodMs >>> 0;
            if (object.defaultOutputState != null)
                message.defaultOutputState = object.defaultOutputState >>> 0;
            if (object.minCycleTimeMs != null)
                message.minCycleTimeMs = object.minCycleTimeMs >>> 0;
            if (object.addressType != null)
                message.addressType = object.addressType >>> 0;
            if (object.address != null)
                message.address = object.address >>> 0;
            if (object.calibrate != null)
                message.calibrate = Boolean(object.calibrate);
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            if (object.calibrations) {
                if (!Array.isArray(object.calibrations))
                    throw TypeError(".quack.Component.calibrations: array expected");
                message.calibrations = [];
                for (var i = 0; i < object.calibrations.length; ++i) {
                    if (typeof object.calibrations[i] !== "object")
                        throw TypeError(".quack.Component.calibrations: object expected");
                    message.calibrations[i] = $root.quack.Calibration.fromObject(object.calibrations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Component message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Component
         * @static
         * @param {quack.Component} message Component
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Component.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.calibrations = [];
            if (options.defaults) {
                object.type = 0;
                object.subtype = 0;
                object.name = "";
                object.reportPeriodMs = 0;
                object.measurementPeriodMs = 0;
                object.defaultOutputState = 0;
                object.minCycleTimeMs = 0;
                object.addressType = 0;
                object.address = 0;
                object.calibrate = false;
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.reportPeriodMs != null && message.hasOwnProperty("reportPeriodMs"))
                object.reportPeriodMs = message.reportPeriodMs;
            if (message.measurementPeriodMs != null && message.hasOwnProperty("measurementPeriodMs"))
                object.measurementPeriodMs = message.measurementPeriodMs;
            if (message.defaultOutputState != null && message.hasOwnProperty("defaultOutputState"))
                object.defaultOutputState = message.defaultOutputState;
            if (message.minCycleTimeMs != null && message.hasOwnProperty("minCycleTimeMs"))
                object.minCycleTimeMs = message.minCycleTimeMs;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.calibrate != null && message.hasOwnProperty("calibrate"))
                object.calibrate = message.calibrate;
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.calibrations && message.calibrations.length) {
                object.calibrations = [];
                for (var j = 0; j < message.calibrations.length; ++j)
                    object.calibrations[j] = $root.quack.Calibration.toObject(message.calibrations[j], options);
            }
            return object;
        };

        /**
         * Converts this Component to JSON.
         * @function toJSON
         * @memberof quack.Component
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Component.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Component;
    })();

    quack.VirtualComponent = (function() {

        /**
         * Properties of a VirtualComponent.
         * @memberof quack
         * @interface IVirtualComponent
         * @property {number|null} [type] VirtualComponent type
         * @property {number|null} [subtype] VirtualComponent subtype
         * @property {number|null} [addressType] VirtualComponent addressType
         * @property {number|null} [address] VirtualComponent address
         * @property {boolean|null} [calibrate] VirtualComponent calibrate
         * @property {number|null} [calibrationCoefficient] VirtualComponent calibrationCoefficient
         * @property {number|null} [calibrationOffset] VirtualComponent calibrationOffset
         */

        /**
         * Constructs a new VirtualComponent.
         * @memberof quack
         * @classdesc Represents a VirtualComponent.
         * @implements IVirtualComponent
         * @constructor
         * @param {quack.IVirtualComponent=} [properties] Properties to set
         */
        function VirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VirtualComponent type.
         * @member {number} type
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.type = 0;

        /**
         * VirtualComponent subtype.
         * @member {number} subtype
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.subtype = 0;

        /**
         * VirtualComponent addressType.
         * @member {number} addressType
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.addressType = 0;

        /**
         * VirtualComponent address.
         * @member {number} address
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.address = 0;

        /**
         * VirtualComponent calibrate.
         * @member {boolean} calibrate
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrate = false;

        /**
         * VirtualComponent calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrationCoefficient = 0;

        /**
         * VirtualComponent calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrationOffset = 0;

        /**
         * Creates a new VirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.VirtualComponent
         * @static
         * @param {quack.IVirtualComponent=} [properties] Properties to set
         * @returns {quack.VirtualComponent} VirtualComponent instance
         */
        VirtualComponent.create = function create(properties) {
            return new VirtualComponent(properties);
        };

        /**
         * Creates a VirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VirtualComponent} VirtualComponent
         */
        VirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VirtualComponent)
                return object;
            var message = new $root.quack.VirtualComponent();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.addressType != null)
                message.addressType = object.addressType >>> 0;
            if (object.address != null)
                message.address = object.address >>> 0;
            if (object.calibrate != null)
                message.calibrate = Boolean(object.calibrate);
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            return message;
        };

        /**
         * Creates a plain object from a VirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VirtualComponent
         * @static
         * @param {quack.VirtualComponent} message VirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.subtype = 0;
                object.addressType = 0;
                object.address = 0;
                object.calibrate = false;
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.calibrate != null && message.hasOwnProperty("calibrate"))
                object.calibrate = message.calibrate;
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            return object;
        };

        /**
         * Converts this VirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.VirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VirtualComponent;
    })();

    quack.ComponentID = (function() {

        /**
         * Properties of a ComponentID.
         * @memberof quack
         * @interface IComponentID
         * @property {quack.ComponentType|null} [type] ComponentID type
         * @property {quack.AddressType|null} [addressType] ComponentID addressType
         * @property {number|null} [address] ComponentID address
         */

        /**
         * Constructs a new ComponentID.
         * @memberof quack
         * @classdesc Represents a ComponentID.
         * @implements IComponentID
         * @constructor
         * @param {quack.IComponentID=} [properties] Properties to set
         */
        function ComponentID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentID type.
         * @member {quack.ComponentType} type
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.type = 0;

        /**
         * ComponentID addressType.
         * @member {quack.AddressType} addressType
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.addressType = 0;

        /**
         * ComponentID address.
         * @member {number} address
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.address = 0;

        /**
         * Creates a new ComponentID instance using the specified properties.
         * @function create
         * @memberof quack.ComponentID
         * @static
         * @param {quack.IComponentID=} [properties] Properties to set
         * @returns {quack.ComponentID} ComponentID instance
         */
        ComponentID.create = function create(properties) {
            return new ComponentID(properties);
        };

        /**
         * Creates a ComponentID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ComponentID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ComponentID} ComponentID
         */
        ComponentID.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ComponentID)
                return object;
            var message = new $root.quack.ComponentID();
            switch (object.type) {
            case "COMPONENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "COMPONENT_TYPE_POWER":
            case 1:
                message.type = 1;
                break;
            case "COMPONENT_TYPE_TEMPERATURE":
            case 2:
                message.type = 2;
                break;
            case "COMPONENT_TYPE_BOOLEAN_OUTPUT":
            case 3:
                message.type = 3;
                break;
            case "COMPONENT_TYPE_EDGE_TRIGGERED":
            case 4:
                message.type = 4;
                break;
            case "COMPONENT_TYPE_GRAIN_CABLE":
            case 5:
                message.type = 5;
                break;
            case "COMPONENT_TYPE_PRESSURE":
            case 6:
                message.type = 6;
                break;
            case "COMPONENT_TYPE_GPS":
            case 7:
                message.type = 7;
                break;
            case "COMPONENT_TYPE_BOOLEAN_INPUT":
            case 8:
                message.type = 8;
                break;
            case "COMPONENT_TYPE_DHT":
            case 9:
                message.type = 9;
                break;
            case "COMPONENT_TYPE_MODEM":
            case 10:
                message.type = 10;
                break;
            case "COMPONENT_TYPE_LIGHT":
            case 11:
                message.type = 11;
                break;
            case "COMPONENT_TYPE_CO2":
            case 12:
                message.type = 12;
                break;
            case "COMPONENT_TYPE_STEPPER_MOTOR":
            case 13:
                message.type = 13;
                break;
            case "COMPONENT_TYPE_ANALOG_INPUT":
            case 14:
                message.type = 14;
                break;
            case "COMPONENT_TYPE_O2":
            case 15:
                message.type = 15;
                break;
            case "COMPONENT_TYPE_ETHYLENE":
            case 16:
                message.type = 16;
                break;
            case "COMPONENT_TYPE_ORP":
            case 17:
                message.type = 17;
                break;
            case "COMPONENT_TYPE_PH":
            case 18:
                message.type = 18;
                break;
            case "COMPONENT_TYPE_VOLTAGE":
            case 19:
                message.type = 19;
                break;
            case "COMPONENT_TYPE_CALCIUM":
            case 20:
                message.type = 20;
                break;
            case "COMPONENT_TYPE_NITRATE":
            case 21:
                message.type = 21;
                break;
            case "COMPONENT_TYPE_POTASSIUM":
            case 22:
                message.type = 22;
                break;
            case "COMPONENT_TYPE_CONDUCTIVITY":
            case 23:
                message.type = 23;
                break;
            case "COMPONENT_TYPE_CAPACITANCE":
            case 24:
                message.type = 24;
                break;
            case "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT":
            case 25:
                message.type = 25;
                break;
            case "COMPONENT_TYPE_WEIGHT":
            case 26:
                message.type = 26;
                break;
            case "COMPONENT_TYPE_AIR_QUALITY":
            case 27:
                message.type = 27;
                break;
            case "COMPONENT_TYPE_LIDAR":
            case 28:
                message.type = 28;
                break;
            case "COMPONENT_TYPE_PRESSURE_CABLE":
            case 29:
                message.type = 29;
                break;
            case "COMPONENT_TYPE_INTERNAL_FUNCTION":
            case 30:
                message.type = 30;
                break;
            case "COMPONENT_TYPE_CAPACITOR_CABLE":
            case 31:
                message.type = 31;
                break;
            case "COMPONENT_TYPE_SEN5X":
            case 32:
                message.type = 32;
                break;
            case "COMPONENT_TYPE_VIBRATION_CHAIN":
            case 33:
                message.type = 33;
                break;
            case "COMPONENT_TYPE_DRAGER_GAS_DONGLE":
            case 34:
                message.type = 34;
                break;
            case "COMPONENT_TYPE_AIRFLOW":
            case 35:
                message.type = 35;
                break;
            }
            switch (object.addressType) {
            case "ADDRESS_TYPE_INVALID":
            case 0:
                message.addressType = 0;
                break;
            case "ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY":
            case 1:
                message.addressType = 1;
                break;
            case "ADDRESS_TYPE_I2C":
            case 2:
                message.addressType = 2;
                break;
            case "ADDRESS_TYPE_DAC":
            case 3:
                message.addressType = 3;
                break;
            case "ADDRESS_TYPE_POWER":
            case 4:
                message.addressType = 4;
                break;
            case "ADDRESS_TYPE_GPS":
            case 5:
                message.addressType = 5;
                break;
            case "ADDRESS_TYPE_MODEM":
            case 6:
                message.addressType = 6;
                break;
            case "ADDRESS_TYPE_I2C_WITH_CHANNELS":
            case 7:
                message.addressType = 7;
                break;
            case "ADDRESS_TYPE_INCREMENTAL":
            case 8:
                message.addressType = 8;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET1":
            case 9:
                message.addressType = 9;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET2":
            case 10:
                message.addressType = 10;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET3":
            case 11:
                message.addressType = 11;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET4":
            case 12:
                message.addressType = 12;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET5":
            case 13:
                message.addressType = 13;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET6":
            case 14:
                message.addressType = 14;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET7":
            case 15:
                message.addressType = 15;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET8":
            case 16:
                message.addressType = 16;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET9":
            case 17:
                message.addressType = 17;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET10":
            case 18:
                message.addressType = 18;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET11":
            case 19:
                message.addressType = 19;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET12":
            case 20:
                message.addressType = 20;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET13":
            case 21:
                message.addressType = 21;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET14":
            case 22:
                message.addressType = 22;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET15":
            case 23:
                message.addressType = 23;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET16":
            case 24:
                message.addressType = 24;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET17":
            case 25:
                message.addressType = 25;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET18":
            case 26:
                message.addressType = 26;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET19":
            case 27:
                message.addressType = 27;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET20":
            case 28:
                message.addressType = 28;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET21":
            case 29:
                message.addressType = 29;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET22":
            case 30:
                message.addressType = 30;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET23":
            case 31:
                message.addressType = 31;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET24":
            case 32:
                message.addressType = 32;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET25":
            case 33:
                message.addressType = 33;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET26":
            case 34:
                message.addressType = 34;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET27":
            case 35:
                message.addressType = 35;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET28":
            case 36:
                message.addressType = 36;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET29":
            case 37:
                message.addressType = 37;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET30":
            case 38:
                message.addressType = 38;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET31":
            case 39:
                message.addressType = 39;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET32":
            case 40:
                message.addressType = 40;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET33":
            case 41:
                message.addressType = 41;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET34":
            case 42:
                message.addressType = 42;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET35":
            case 43:
                message.addressType = 43;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET36":
            case 44:
                message.addressType = 44;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET37":
            case 45:
                message.addressType = 45;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET38":
            case 46:
                message.addressType = 46;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET39":
            case 47:
                message.addressType = 47;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET40":
            case 48:
                message.addressType = 48;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET41":
            case 49:
                message.addressType = 49;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET42":
            case 50:
                message.addressType = 50;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET43":
            case 51:
                message.addressType = 51;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET44":
            case 52:
                message.addressType = 52;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET45":
            case 53:
                message.addressType = 53;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET46":
            case 54:
                message.addressType = 54;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET47":
            case 55:
                message.addressType = 55;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET48":
            case 56:
                message.addressType = 56;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET49":
            case 57:
                message.addressType = 57;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET50":
            case 58:
                message.addressType = 58;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET51":
            case 59:
                message.addressType = 59;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET52":
            case 60:
                message.addressType = 60;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET53":
            case 61:
                message.addressType = 61;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET54":
            case 62:
                message.addressType = 62;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET55":
            case 63:
                message.addressType = 63;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET56":
            case 64:
                message.addressType = 64;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET57":
            case 65:
                message.addressType = 65;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET58":
            case 66:
                message.addressType = 66;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET59":
            case 67:
                message.addressType = 67;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET60":
            case 68:
                message.addressType = 68;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET61":
            case 69:
                message.addressType = 69;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET62":
            case 70:
                message.addressType = 70;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET63":
            case 71:
                message.addressType = 71;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET64":
            case 72:
                message.addressType = 72;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET65":
            case 73:
                message.addressType = 73;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET66":
            case 74:
                message.addressType = 74;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET67":
            case 75:
                message.addressType = 75;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET68":
            case 76:
                message.addressType = 76;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET69":
            case 77:
                message.addressType = 77;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET70":
            case 78:
                message.addressType = 78;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET71":
            case 79:
                message.addressType = 79;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET72":
            case 80:
                message.addressType = 80;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET73":
            case 81:
                message.addressType = 81;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET74":
            case 82:
                message.addressType = 82;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET75":
            case 83:
                message.addressType = 83;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET76":
            case 84:
                message.addressType = 84;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET77":
            case 85:
                message.addressType = 85;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET78":
            case 86:
                message.addressType = 86;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET79":
            case 87:
                message.addressType = 87;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET80":
            case 88:
                message.addressType = 88;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET81":
            case 89:
                message.addressType = 89;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET82":
            case 90:
                message.addressType = 90;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET83":
            case 91:
                message.addressType = 91;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET84":
            case 92:
                message.addressType = 92;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET85":
            case 93:
                message.addressType = 93;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET86":
            case 94:
                message.addressType = 94;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET87":
            case 95:
                message.addressType = 95;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET88":
            case 96:
                message.addressType = 96;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET89":
            case 97:
                message.addressType = 97;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET90":
            case 98:
                message.addressType = 98;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET91":
            case 99:
                message.addressType = 99;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET92":
            case 100:
                message.addressType = 100;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET93":
            case 101:
                message.addressType = 101;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET94":
            case 102:
                message.addressType = 102;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET95":
            case 103:
                message.addressType = 103;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET96":
            case 104:
                message.addressType = 104;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET97":
            case 105:
                message.addressType = 105;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET98":
            case 106:
                message.addressType = 106;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET99":
            case 107:
                message.addressType = 107;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET100":
            case 108:
                message.addressType = 108;
                break;
            case "ADDRESS_TYPE_INTERNAL_SLEEP":
            case 109:
                message.addressType = 109;
                break;
            case "ADDRESS_TYPE_SPI":
            case 110:
                message.addressType = 110;
                break;
            }
            if (object.address != null)
                message.address = object.address >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ComponentID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ComponentID
         * @static
         * @param {quack.ComponentID} message ComponentID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "COMPONENT_TYPE_INVALID" : 0;
                object.addressType = options.enums === String ? "ADDRESS_TYPE_INVALID" : 0;
                object.address = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.ComponentType[message.type] : message.type;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = options.enums === String ? $root.quack.AddressType[message.addressType] : message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            return object;
        };

        /**
         * Converts this ComponentID to JSON.
         * @function toJSON
         * @memberof quack.ComponentID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentID;
    })();

    quack.AddComponent = (function() {

        /**
         * Properties of an AddComponent.
         * @memberof quack
         * @interface IAddComponent
         * @property {quack.Component|null} [component] AddComponent component
         */

        /**
         * Constructs a new AddComponent.
         * @memberof quack
         * @classdesc Represents an AddComponent.
         * @implements IAddComponent
         * @constructor
         * @param {quack.IAddComponent=} [properties] Properties to set
         */
        function AddComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddComponent component.
         * @member {quack.Component|null|undefined} component
         * @memberof quack.AddComponent
         * @instance
         */
        AddComponent.prototype.component = null;

        /**
         * Creates a new AddComponent instance using the specified properties.
         * @function create
         * @memberof quack.AddComponent
         * @static
         * @param {quack.IAddComponent=} [properties] Properties to set
         * @returns {quack.AddComponent} AddComponent instance
         */
        AddComponent.create = function create(properties) {
            return new AddComponent(properties);
        };

        /**
         * Creates an AddComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddComponent} AddComponent
         */
        AddComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddComponent)
                return object;
            var message = new $root.quack.AddComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.AddComponent.component: object expected");
                message.component = $root.quack.Component.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddComponent
         * @static
         * @param {quack.AddComponent} message AddComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.Component.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this AddComponent to JSON.
         * @function toJSON
         * @memberof quack.AddComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddComponent;
    })();

    quack.AddVirtualComponent = (function() {

        /**
         * Properties of an AddVirtualComponent.
         * @memberof quack
         * @interface IAddVirtualComponent
         * @property {quack.VirtualComponent|null} [component] AddVirtualComponent component
         */

        /**
         * Constructs a new AddVirtualComponent.
         * @memberof quack
         * @classdesc Represents an AddVirtualComponent.
         * @implements IAddVirtualComponent
         * @constructor
         * @param {quack.IAddVirtualComponent=} [properties] Properties to set
         */
        function AddVirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddVirtualComponent component.
         * @member {quack.VirtualComponent|null|undefined} component
         * @memberof quack.AddVirtualComponent
         * @instance
         */
        AddVirtualComponent.prototype.component = null;

        /**
         * Creates a new AddVirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {quack.IAddVirtualComponent=} [properties] Properties to set
         * @returns {quack.AddVirtualComponent} AddVirtualComponent instance
         */
        AddVirtualComponent.create = function create(properties) {
            return new AddVirtualComponent(properties);
        };

        /**
         * Creates an AddVirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddVirtualComponent} AddVirtualComponent
         */
        AddVirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddVirtualComponent)
                return object;
            var message = new $root.quack.AddVirtualComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.AddVirtualComponent.component: object expected");
                message.component = $root.quack.VirtualComponent.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddVirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {quack.AddVirtualComponent} message AddVirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddVirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.VirtualComponent.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this AddVirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.AddVirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddVirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddVirtualComponent;
    })();

    quack.RemoveComponent = (function() {

        /**
         * Properties of a RemoveComponent.
         * @memberof quack
         * @interface IRemoveComponent
         * @property {quack.ComponentID|null} [id] RemoveComponent id
         */

        /**
         * Constructs a new RemoveComponent.
         * @memberof quack
         * @classdesc Represents a RemoveComponent.
         * @implements IRemoveComponent
         * @constructor
         * @param {quack.IRemoveComponent=} [properties] Properties to set
         */
        function RemoveComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.RemoveComponent
         * @instance
         */
        RemoveComponent.prototype.id = null;

        /**
         * Creates a new RemoveComponent instance using the specified properties.
         * @function create
         * @memberof quack.RemoveComponent
         * @static
         * @param {quack.IRemoveComponent=} [properties] Properties to set
         * @returns {quack.RemoveComponent} RemoveComponent instance
         */
        RemoveComponent.create = function create(properties) {
            return new RemoveComponent(properties);
        };

        /**
         * Creates a RemoveComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveComponent} RemoveComponent
         */
        RemoveComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveComponent)
                return object;
            var message = new $root.quack.RemoveComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.RemoveComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a RemoveComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveComponent
         * @static
         * @param {quack.RemoveComponent} message RemoveComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this RemoveComponent to JSON.
         * @function toJSON
         * @memberof quack.RemoveComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveComponent;
    })();

    quack.UpdateVirtualComponent = (function() {

        /**
         * Properties of an UpdateVirtualComponent.
         * @memberof quack
         * @interface IUpdateVirtualComponent
         * @property {quack.VirtualComponent|null} [component] UpdateVirtualComponent component
         */

        /**
         * Constructs a new UpdateVirtualComponent.
         * @memberof quack
         * @classdesc Represents an UpdateVirtualComponent.
         * @implements IUpdateVirtualComponent
         * @constructor
         * @param {quack.IUpdateVirtualComponent=} [properties] Properties to set
         */
        function UpdateVirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateVirtualComponent component.
         * @member {quack.VirtualComponent|null|undefined} component
         * @memberof quack.UpdateVirtualComponent
         * @instance
         */
        UpdateVirtualComponent.prototype.component = null;

        /**
         * Creates a new UpdateVirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {quack.IUpdateVirtualComponent=} [properties] Properties to set
         * @returns {quack.UpdateVirtualComponent} UpdateVirtualComponent instance
         */
        UpdateVirtualComponent.create = function create(properties) {
            return new UpdateVirtualComponent(properties);
        };

        /**
         * Creates an UpdateVirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateVirtualComponent} UpdateVirtualComponent
         */
        UpdateVirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateVirtualComponent)
                return object;
            var message = new $root.quack.UpdateVirtualComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.UpdateVirtualComponent.component: object expected");
                message.component = $root.quack.VirtualComponent.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateVirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {quack.UpdateVirtualComponent} message UpdateVirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateVirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.VirtualComponent.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this UpdateVirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.UpdateVirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateVirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateVirtualComponent;
    })();

    quack.UpdateComponent = (function() {

        /**
         * Properties of an UpdateComponent.
         * @memberof quack
         * @interface IUpdateComponent
         * @property {quack.ComponentID|null} [id] UpdateComponent id
         * @property {quack.Component|null} [component] UpdateComponent component
         */

        /**
         * Constructs a new UpdateComponent.
         * @memberof quack
         * @classdesc Represents an UpdateComponent.
         * @implements IUpdateComponent
         * @constructor
         * @param {quack.IUpdateComponent=} [properties] Properties to set
         */
        function UpdateComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.UpdateComponent
         * @instance
         */
        UpdateComponent.prototype.id = null;

        /**
         * UpdateComponent component.
         * @member {quack.Component|null|undefined} component
         * @memberof quack.UpdateComponent
         * @instance
         */
        UpdateComponent.prototype.component = null;

        /**
         * Creates a new UpdateComponent instance using the specified properties.
         * @function create
         * @memberof quack.UpdateComponent
         * @static
         * @param {quack.IUpdateComponent=} [properties] Properties to set
         * @returns {quack.UpdateComponent} UpdateComponent instance
         */
        UpdateComponent.create = function create(properties) {
            return new UpdateComponent(properties);
        };

        /**
         * Creates an UpdateComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateComponent} UpdateComponent
         */
        UpdateComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateComponent)
                return object;
            var message = new $root.quack.UpdateComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.UpdateComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.UpdateComponent.component: object expected");
                message.component = $root.quack.Component.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateComponent
         * @static
         * @param {quack.UpdateComponent} message UpdateComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = null;
                object.component = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.Component.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this UpdateComponent to JSON.
         * @function toJSON
         * @memberof quack.UpdateComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateComponent;
    })();

    quack.GetComponent = (function() {

        /**
         * Properties of a GetComponent.
         * @memberof quack
         * @interface IGetComponent
         * @property {quack.ComponentID|null} [id] GetComponent id
         */

        /**
         * Constructs a new GetComponent.
         * @memberof quack
         * @classdesc Represents a GetComponent.
         * @implements IGetComponent
         * @constructor
         * @param {quack.IGetComponent=} [properties] Properties to set
         */
        function GetComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.GetComponent
         * @instance
         */
        GetComponent.prototype.id = null;

        /**
         * Creates a new GetComponent instance using the specified properties.
         * @function create
         * @memberof quack.GetComponent
         * @static
         * @param {quack.IGetComponent=} [properties] Properties to set
         * @returns {quack.GetComponent} GetComponent instance
         */
        GetComponent.create = function create(properties) {
            return new GetComponent(properties);
        };

        /**
         * Creates a GetComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetComponent} GetComponent
         */
        GetComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetComponent)
                return object;
            var message = new $root.quack.GetComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.GetComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetComponent
         * @static
         * @param {quack.GetComponent} message GetComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this GetComponent to JSON.
         * @function toJSON
         * @memberof quack.GetComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetComponent;
    })();

    quack.GetMeasurement = (function() {

        /**
         * Properties of a GetMeasurement.
         * @memberof quack
         * @interface IGetMeasurement
         * @property {quack.ComponentID|null} [id] GetMeasurement id
         */

        /**
         * Constructs a new GetMeasurement.
         * @memberof quack
         * @classdesc Represents a GetMeasurement.
         * @implements IGetMeasurement
         * @constructor
         * @param {quack.IGetMeasurement=} [properties] Properties to set
         */
        function GetMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMeasurement id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.GetMeasurement
         * @instance
         */
        GetMeasurement.prototype.id = null;

        /**
         * Creates a new GetMeasurement instance using the specified properties.
         * @function create
         * @memberof quack.GetMeasurement
         * @static
         * @param {quack.IGetMeasurement=} [properties] Properties to set
         * @returns {quack.GetMeasurement} GetMeasurement instance
         */
        GetMeasurement.create = function create(properties) {
            return new GetMeasurement(properties);
        };

        /**
         * Creates a GetMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetMeasurement} GetMeasurement
         */
        GetMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetMeasurement)
                return object;
            var message = new $root.quack.GetMeasurement();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.GetMeasurement.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetMeasurement
         * @static
         * @param {quack.GetMeasurement} message GetMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this GetMeasurement to JSON.
         * @function toJSON
         * @memberof quack.GetMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMeasurement;
    })();

    quack.Temperature = (function() {

        /**
         * Properties of a Temperature.
         * @memberof quack
         * @interface ITemperature
         * @property {number|null} [celciusTimes_10] Temperature celciusTimes_10
         */

        /**
         * Constructs a new Temperature.
         * @memberof quack
         * @classdesc Represents a Temperature.
         * @implements ITemperature
         * @constructor
         * @param {quack.ITemperature=} [properties] Properties to set
         */
        function Temperature(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Temperature celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.Temperature
         * @instance
         */
        Temperature.prototype.celciusTimes_10 = 0;

        /**
         * Creates a new Temperature instance using the specified properties.
         * @function create
         * @memberof quack.Temperature
         * @static
         * @param {quack.ITemperature=} [properties] Properties to set
         * @returns {quack.Temperature} Temperature instance
         */
        Temperature.create = function create(properties) {
            return new Temperature(properties);
        };

        /**
         * Creates a Temperature message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Temperature
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Temperature} Temperature
         */
        Temperature.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Temperature)
                return object;
            var message = new $root.quack.Temperature();
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            return message;
        };

        /**
         * Creates a plain object from a Temperature message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Temperature
         * @static
         * @param {quack.Temperature} message Temperature
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Temperature.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.celciusTimes_10 = 0;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            return object;
        };

        /**
         * Converts this Temperature to JSON.
         * @function toJSON
         * @memberof quack.Temperature
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Temperature.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Temperature;
    })();

    quack.EdgeTriggered = (function() {

        /**
         * Properties of an EdgeTriggered.
         * @memberof quack
         * @interface IEdgeTriggered
         * @property {boolean|null} [state] EdgeTriggered state
         * @property {number|null} [rises] EdgeTriggered rises
         * @property {number|null} [falls] EdgeTriggered falls
         * @property {number|null} [lastRise] EdgeTriggered lastRise
         * @property {number|null} [lastFall] EdgeTriggered lastFall
         */

        /**
         * Constructs a new EdgeTriggered.
         * @memberof quack
         * @classdesc Represents an EdgeTriggered.
         * @implements IEdgeTriggered
         * @constructor
         * @param {quack.IEdgeTriggered=} [properties] Properties to set
         */
        function EdgeTriggered(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EdgeTriggered state.
         * @member {boolean} state
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.state = false;

        /**
         * EdgeTriggered rises.
         * @member {number} rises
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.rises = 0;

        /**
         * EdgeTriggered falls.
         * @member {number} falls
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.falls = 0;

        /**
         * EdgeTriggered lastRise.
         * @member {number} lastRise
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.lastRise = 0;

        /**
         * EdgeTriggered lastFall.
         * @member {number} lastFall
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.lastFall = 0;

        /**
         * Creates a new EdgeTriggered instance using the specified properties.
         * @function create
         * @memberof quack.EdgeTriggered
         * @static
         * @param {quack.IEdgeTriggered=} [properties] Properties to set
         * @returns {quack.EdgeTriggered} EdgeTriggered instance
         */
        EdgeTriggered.create = function create(properties) {
            return new EdgeTriggered(properties);
        };

        /**
         * Creates an EdgeTriggered message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.EdgeTriggered
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.EdgeTriggered} EdgeTriggered
         */
        EdgeTriggered.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.EdgeTriggered)
                return object;
            var message = new $root.quack.EdgeTriggered();
            if (object.state != null)
                message.state = Boolean(object.state);
            if (object.rises != null)
                message.rises = object.rises >>> 0;
            if (object.falls != null)
                message.falls = object.falls >>> 0;
            if (object.lastRise != null)
                message.lastRise = object.lastRise >>> 0;
            if (object.lastFall != null)
                message.lastFall = object.lastFall >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an EdgeTriggered message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.EdgeTriggered
         * @static
         * @param {quack.EdgeTriggered} message EdgeTriggered
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EdgeTriggered.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.state = false;
                object.rises = 0;
                object.falls = 0;
                object.lastRise = 0;
                object.lastFall = 0;
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.rises != null && message.hasOwnProperty("rises"))
                object.rises = message.rises;
            if (message.falls != null && message.hasOwnProperty("falls"))
                object.falls = message.falls;
            if (message.lastRise != null && message.hasOwnProperty("lastRise"))
                object.lastRise = message.lastRise;
            if (message.lastFall != null && message.hasOwnProperty("lastFall"))
                object.lastFall = message.lastFall;
            return object;
        };

        /**
         * Converts this EdgeTriggered to JSON.
         * @function toJSON
         * @memberof quack.EdgeTriggered
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EdgeTriggered.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EdgeTriggered;
    })();

    quack.Power = (function() {

        /**
         * Properties of a Power.
         * @memberof quack
         * @interface IPower
         * @property {number|null} [inputVoltageTimes_10] Power inputVoltageTimes_10
         * @property {number|null} [percentChargedTimes_100] Power percentChargedTimes_100
         */

        /**
         * Constructs a new Power.
         * @memberof quack
         * @classdesc Represents a Power.
         * @implements IPower
         * @constructor
         * @param {quack.IPower=} [properties] Properties to set
         */
        function Power(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Power inputVoltageTimes_10.
         * @member {number} inputVoltageTimes_10
         * @memberof quack.Power
         * @instance
         */
        Power.prototype.inputVoltageTimes_10 = 0;

        /**
         * Power percentChargedTimes_100.
         * @member {number} percentChargedTimes_100
         * @memberof quack.Power
         * @instance
         */
        Power.prototype.percentChargedTimes_100 = 0;

        /**
         * Creates a new Power instance using the specified properties.
         * @function create
         * @memberof quack.Power
         * @static
         * @param {quack.IPower=} [properties] Properties to set
         * @returns {quack.Power} Power instance
         */
        Power.create = function create(properties) {
            return new Power(properties);
        };

        /**
         * Creates a Power message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Power
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Power} Power
         */
        Power.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Power)
                return object;
            var message = new $root.quack.Power();
            if (object.inputVoltageTimes_10 != null)
                message.inputVoltageTimes_10 = object.inputVoltageTimes_10 | 0;
            if (object.percentChargedTimes_100 != null)
                message.percentChargedTimes_100 = object.percentChargedTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Power message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Power
         * @static
         * @param {quack.Power} message Power
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Power.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.inputVoltageTimes_10 = 0;
                object.percentChargedTimes_100 = 0;
            }
            if (message.inputVoltageTimes_10 != null && message.hasOwnProperty("inputVoltageTimes_10"))
                object.inputVoltageTimes_10 = message.inputVoltageTimes_10;
            if (message.percentChargedTimes_100 != null && message.hasOwnProperty("percentChargedTimes_100"))
                object.percentChargedTimes_100 = message.percentChargedTimes_100;
            return object;
        };

        /**
         * Converts this Power to JSON.
         * @function toJSON
         * @memberof quack.Power
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Power.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Power;
    })();

    quack.GrainCable = (function() {

        /**
         * Properties of a GrainCable.
         * @memberof quack
         * @interface IGrainCable
         * @property {Array.<number>|null} [celciusTimes_10] GrainCable celciusTimes_10
         * @property {Array.<number>|null} [relativeHumidityTimes_100] GrainCable relativeHumidityTimes_100
         */

        /**
         * Constructs a new GrainCable.
         * @memberof quack
         * @classdesc Represents a GrainCable.
         * @implements IGrainCable
         * @constructor
         * @param {quack.IGrainCable=} [properties] Properties to set
         */
        function GrainCable(properties) {
            this.celciusTimes_10 = [];
            this.relativeHumidityTimes_100 = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainCable celciusTimes_10.
         * @member {Array.<number>} celciusTimes_10
         * @memberof quack.GrainCable
         * @instance
         */
        GrainCable.prototype.celciusTimes_10 = $util.emptyArray;

        /**
         * GrainCable relativeHumidityTimes_100.
         * @member {Array.<number>} relativeHumidityTimes_100
         * @memberof quack.GrainCable
         * @instance
         */
        GrainCable.prototype.relativeHumidityTimes_100 = $util.emptyArray;

        /**
         * Creates a new GrainCable instance using the specified properties.
         * @function create
         * @memberof quack.GrainCable
         * @static
         * @param {quack.IGrainCable=} [properties] Properties to set
         * @returns {quack.GrainCable} GrainCable instance
         */
        GrainCable.create = function create(properties) {
            return new GrainCable(properties);
        };

        /**
         * Creates a GrainCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GrainCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GrainCable} GrainCable
         */
        GrainCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GrainCable)
                return object;
            var message = new $root.quack.GrainCable();
            if (object.celciusTimes_10) {
                if (!Array.isArray(object.celciusTimes_10))
                    throw TypeError(".quack.GrainCable.celciusTimes_10: array expected");
                message.celciusTimes_10 = [];
                for (var i = 0; i < object.celciusTimes_10.length; ++i)
                    message.celciusTimes_10[i] = object.celciusTimes_10[i] | 0;
            }
            if (object.relativeHumidityTimes_100) {
                if (!Array.isArray(object.relativeHumidityTimes_100))
                    throw TypeError(".quack.GrainCable.relativeHumidityTimes_100: array expected");
                message.relativeHumidityTimes_100 = [];
                for (var i = 0; i < object.relativeHumidityTimes_100.length; ++i)
                    message.relativeHumidityTimes_100[i] = object.relativeHumidityTimes_100[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GrainCable
         * @static
         * @param {quack.GrainCable} message GrainCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.celciusTimes_10 = [];
                object.relativeHumidityTimes_100 = [];
            }
            if (message.celciusTimes_10 && message.celciusTimes_10.length) {
                object.celciusTimes_10 = [];
                for (var j = 0; j < message.celciusTimes_10.length; ++j)
                    object.celciusTimes_10[j] = message.celciusTimes_10[j];
            }
            if (message.relativeHumidityTimes_100 && message.relativeHumidityTimes_100.length) {
                object.relativeHumidityTimes_100 = [];
                for (var j = 0; j < message.relativeHumidityTimes_100.length; ++j)
                    object.relativeHumidityTimes_100[j] = message.relativeHumidityTimes_100[j];
            }
            return object;
        };

        /**
         * Converts this GrainCable to JSON.
         * @function toJSON
         * @memberof quack.GrainCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainCable;
    })();

    quack.CapacitorCable = (function() {

        /**
         * Properties of a CapacitorCable.
         * @memberof quack
         * @interface ICapacitorCable
         * @property {Array.<number>|null} [groundRefFf] CapacitorCable groundRefFf
         * @property {Array.<number>|null} [selfRefFf] CapacitorCable selfRefFf
         */

        /**
         * Constructs a new CapacitorCable.
         * @memberof quack
         * @classdesc Represents a CapacitorCable.
         * @implements ICapacitorCable
         * @constructor
         * @param {quack.ICapacitorCable=} [properties] Properties to set
         */
        function CapacitorCable(properties) {
            this.groundRefFf = [];
            this.selfRefFf = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CapacitorCable groundRefFf.
         * @member {Array.<number>} groundRefFf
         * @memberof quack.CapacitorCable
         * @instance
         */
        CapacitorCable.prototype.groundRefFf = $util.emptyArray;

        /**
         * CapacitorCable selfRefFf.
         * @member {Array.<number>} selfRefFf
         * @memberof quack.CapacitorCable
         * @instance
         */
        CapacitorCable.prototype.selfRefFf = $util.emptyArray;

        /**
         * Creates a new CapacitorCable instance using the specified properties.
         * @function create
         * @memberof quack.CapacitorCable
         * @static
         * @param {quack.ICapacitorCable=} [properties] Properties to set
         * @returns {quack.CapacitorCable} CapacitorCable instance
         */
        CapacitorCable.create = function create(properties) {
            return new CapacitorCable(properties);
        };

        /**
         * Creates a CapacitorCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.CapacitorCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.CapacitorCable} CapacitorCable
         */
        CapacitorCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.CapacitorCable)
                return object;
            var message = new $root.quack.CapacitorCable();
            if (object.groundRefFf) {
                if (!Array.isArray(object.groundRefFf))
                    throw TypeError(".quack.CapacitorCable.groundRefFf: array expected");
                message.groundRefFf = [];
                for (var i = 0; i < object.groundRefFf.length; ++i)
                    message.groundRefFf[i] = object.groundRefFf[i] | 0;
            }
            if (object.selfRefFf) {
                if (!Array.isArray(object.selfRefFf))
                    throw TypeError(".quack.CapacitorCable.selfRefFf: array expected");
                message.selfRefFf = [];
                for (var i = 0; i < object.selfRefFf.length; ++i)
                    message.selfRefFf[i] = object.selfRefFf[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a CapacitorCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.CapacitorCable
         * @static
         * @param {quack.CapacitorCable} message CapacitorCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CapacitorCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.groundRefFf = [];
                object.selfRefFf = [];
            }
            if (message.groundRefFf && message.groundRefFf.length) {
                object.groundRefFf = [];
                for (var j = 0; j < message.groundRefFf.length; ++j)
                    object.groundRefFf[j] = message.groundRefFf[j];
            }
            if (message.selfRefFf && message.selfRefFf.length) {
                object.selfRefFf = [];
                for (var j = 0; j < message.selfRefFf.length; ++j)
                    object.selfRefFf[j] = message.selfRefFf[j];
            }
            return object;
        };

        /**
         * Converts this CapacitorCable to JSON.
         * @function toJSON
         * @memberof quack.CapacitorCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CapacitorCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CapacitorCable;
    })();

    quack.BooleanOutput = (function() {

        /**
         * Properties of a BooleanOutput.
         * @memberof quack
         * @interface IBooleanOutput
         * @property {boolean|null} [value] BooleanOutput value
         */

        /**
         * Constructs a new BooleanOutput.
         * @memberof quack
         * @classdesc Represents a BooleanOutput.
         * @implements IBooleanOutput
         * @constructor
         * @param {quack.IBooleanOutput=} [properties] Properties to set
         */
        function BooleanOutput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BooleanOutput value.
         * @member {boolean} value
         * @memberof quack.BooleanOutput
         * @instance
         */
        BooleanOutput.prototype.value = false;

        /**
         * Creates a new BooleanOutput instance using the specified properties.
         * @function create
         * @memberof quack.BooleanOutput
         * @static
         * @param {quack.IBooleanOutput=} [properties] Properties to set
         * @returns {quack.BooleanOutput} BooleanOutput instance
         */
        BooleanOutput.create = function create(properties) {
            return new BooleanOutput(properties);
        };

        /**
         * Creates a BooleanOutput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.BooleanOutput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.BooleanOutput} BooleanOutput
         */
        BooleanOutput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.BooleanOutput)
                return object;
            var message = new $root.quack.BooleanOutput();
            if (object.value != null)
                message.value = Boolean(object.value);
            return message;
        };

        /**
         * Creates a plain object from a BooleanOutput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.BooleanOutput
         * @static
         * @param {quack.BooleanOutput} message BooleanOutput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BooleanOutput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = false;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this BooleanOutput to JSON.
         * @function toJSON
         * @memberof quack.BooleanOutput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BooleanOutput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BooleanOutput;
    })();

    quack.Pressure = (function() {

        /**
         * Properties of a Pressure.
         * @memberof quack
         * @interface IPressure
         * @property {number|null} [pascals] Pressure pascals
         */

        /**
         * Constructs a new Pressure.
         * @memberof quack
         * @classdesc Represents a Pressure.
         * @implements IPressure
         * @constructor
         * @param {quack.IPressure=} [properties] Properties to set
         */
        function Pressure(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pressure pascals.
         * @member {number} pascals
         * @memberof quack.Pressure
         * @instance
         */
        Pressure.prototype.pascals = 0;

        /**
         * Creates a new Pressure instance using the specified properties.
         * @function create
         * @memberof quack.Pressure
         * @static
         * @param {quack.IPressure=} [properties] Properties to set
         * @returns {quack.Pressure} Pressure instance
         */
        Pressure.create = function create(properties) {
            return new Pressure(properties);
        };

        /**
         * Creates a Pressure message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Pressure
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Pressure} Pressure
         */
        Pressure.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Pressure)
                return object;
            var message = new $root.quack.Pressure();
            if (object.pascals != null)
                message.pascals = object.pascals | 0;
            return message;
        };

        /**
         * Creates a plain object from a Pressure message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Pressure
         * @static
         * @param {quack.Pressure} message Pressure
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pressure.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pascals = 0;
            if (message.pascals != null && message.hasOwnProperty("pascals"))
                object.pascals = message.pascals;
            return object;
        };

        /**
         * Converts this Pressure to JSON.
         * @function toJSON
         * @memberof quack.Pressure
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pressure.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Pressure;
    })();

    quack.WifiAccessPoint = (function() {

        /**
         * Properties of a WifiAccessPoint.
         * @memberof quack
         * @interface IWifiAccessPoint
         * @property {Uint8Array|null} [mac] WifiAccessPoint mac
         * @property {number|null} [signalStrength] WifiAccessPoint signalStrength
         * @property {number|null} [channel] WifiAccessPoint channel
         */

        /**
         * Constructs a new WifiAccessPoint.
         * @memberof quack
         * @classdesc Represents a WifiAccessPoint.
         * @implements IWifiAccessPoint
         * @constructor
         * @param {quack.IWifiAccessPoint=} [properties] Properties to set
         */
        function WifiAccessPoint(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WifiAccessPoint mac.
         * @member {Uint8Array} mac
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.mac = $util.newBuffer([]);

        /**
         * WifiAccessPoint signalStrength.
         * @member {number} signalStrength
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.signalStrength = 0;

        /**
         * WifiAccessPoint channel.
         * @member {number} channel
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.channel = 0;

        /**
         * Creates a new WifiAccessPoint instance using the specified properties.
         * @function create
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {quack.IWifiAccessPoint=} [properties] Properties to set
         * @returns {quack.WifiAccessPoint} WifiAccessPoint instance
         */
        WifiAccessPoint.create = function create(properties) {
            return new WifiAccessPoint(properties);
        };

        /**
         * Creates a WifiAccessPoint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.WifiAccessPoint} WifiAccessPoint
         */
        WifiAccessPoint.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.WifiAccessPoint)
                return object;
            var message = new $root.quack.WifiAccessPoint();
            if (object.mac != null)
                if (typeof object.mac === "string")
                    $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
                else if (object.mac.length)
                    message.mac = object.mac;
            if (object.signalStrength != null)
                message.signalStrength = object.signalStrength | 0;
            if (object.channel != null)
                message.channel = object.channel >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a WifiAccessPoint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {quack.WifiAccessPoint} message WifiAccessPoint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WifiAccessPoint.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.mac = "";
                else {
                    object.mac = [];
                    if (options.bytes !== Array)
                        object.mac = $util.newBuffer(object.mac);
                }
                object.signalStrength = 0;
                object.channel = 0;
            }
            if (message.mac != null && message.hasOwnProperty("mac"))
                object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
            if (message.signalStrength != null && message.hasOwnProperty("signalStrength"))
                object.signalStrength = message.signalStrength;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            return object;
        };

        /**
         * Converts this WifiAccessPoint to JSON.
         * @function toJSON
         * @memberof quack.WifiAccessPoint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WifiAccessPoint.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WifiAccessPoint;
    })();

    quack.CellTower = (function() {

        /**
         * Properties of a CellTower.
         * @memberof quack
         * @interface ICellTower
         * @property {number|null} [cellId] CellTower cellId
         * @property {number|null} [locationAreaCode] CellTower locationAreaCode
         * @property {number|null} [mobileCountryCode] CellTower mobileCountryCode
         * @property {number|null} [mobileNetworkCode] CellTower mobileNetworkCode
         * @property {number|null} [signalStrength] CellTower signalStrength
         */

        /**
         * Constructs a new CellTower.
         * @memberof quack
         * @classdesc Represents a CellTower.
         * @implements ICellTower
         * @constructor
         * @param {quack.ICellTower=} [properties] Properties to set
         */
        function CellTower(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CellTower cellId.
         * @member {number} cellId
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.cellId = 0;

        /**
         * CellTower locationAreaCode.
         * @member {number} locationAreaCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.locationAreaCode = 0;

        /**
         * CellTower mobileCountryCode.
         * @member {number} mobileCountryCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.mobileCountryCode = 0;

        /**
         * CellTower mobileNetworkCode.
         * @member {number} mobileNetworkCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.mobileNetworkCode = 0;

        /**
         * CellTower signalStrength.
         * @member {number} signalStrength
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.signalStrength = 0;

        /**
         * Creates a new CellTower instance using the specified properties.
         * @function create
         * @memberof quack.CellTower
         * @static
         * @param {quack.ICellTower=} [properties] Properties to set
         * @returns {quack.CellTower} CellTower instance
         */
        CellTower.create = function create(properties) {
            return new CellTower(properties);
        };

        /**
         * Creates a CellTower message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.CellTower
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.CellTower} CellTower
         */
        CellTower.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.CellTower)
                return object;
            var message = new $root.quack.CellTower();
            if (object.cellId != null)
                message.cellId = object.cellId >>> 0;
            if (object.locationAreaCode != null)
                message.locationAreaCode = object.locationAreaCode >>> 0;
            if (object.mobileCountryCode != null)
                message.mobileCountryCode = object.mobileCountryCode >>> 0;
            if (object.mobileNetworkCode != null)
                message.mobileNetworkCode = object.mobileNetworkCode >>> 0;
            if (object.signalStrength != null)
                message.signalStrength = object.signalStrength | 0;
            return message;
        };

        /**
         * Creates a plain object from a CellTower message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.CellTower
         * @static
         * @param {quack.CellTower} message CellTower
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CellTower.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cellId = 0;
                object.locationAreaCode = 0;
                object.mobileCountryCode = 0;
                object.mobileNetworkCode = 0;
                object.signalStrength = 0;
            }
            if (message.cellId != null && message.hasOwnProperty("cellId"))
                object.cellId = message.cellId;
            if (message.locationAreaCode != null && message.hasOwnProperty("locationAreaCode"))
                object.locationAreaCode = message.locationAreaCode;
            if (message.mobileCountryCode != null && message.hasOwnProperty("mobileCountryCode"))
                object.mobileCountryCode = message.mobileCountryCode;
            if (message.mobileNetworkCode != null && message.hasOwnProperty("mobileNetworkCode"))
                object.mobileNetworkCode = message.mobileNetworkCode;
            if (message.signalStrength != null && message.hasOwnProperty("signalStrength"))
                object.signalStrength = message.signalStrength;
            return object;
        };

        /**
         * Converts this CellTower to JSON.
         * @function toJSON
         * @memberof quack.CellTower
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CellTower.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CellTower;
    })();

    quack.Location = (function() {

        /**
         * Properties of a Location.
         * @memberof quack
         * @interface ILocation
         * @property {number|null} [latitude] Location latitude
         * @property {number|null} [longitude] Location longitude
         * @property {number|null} [altitude] Location altitude
         * @property {number|null} [uncertainty] Location uncertainty
         */

        /**
         * Constructs a new Location.
         * @memberof quack
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {quack.ILocation=} [properties] Properties to set
         */
        function Location(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Location latitude.
         * @member {number} latitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.latitude = 0;

        /**
         * Location longitude.
         * @member {number} longitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.longitude = 0;

        /**
         * Location altitude.
         * @member {number} altitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.altitude = 0;

        /**
         * Location uncertainty.
         * @member {number} uncertainty
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.uncertainty = 0;

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof quack.Location
         * @static
         * @param {quack.ILocation=} [properties] Properties to set
         * @returns {quack.Location} Location instance
         */
        Location.create = function create(properties) {
            return new Location(properties);
        };

        /**
         * Creates a Location message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Location
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Location} Location
         */
        Location.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Location)
                return object;
            var message = new $root.quack.Location();
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.altitude != null)
                message.altitude = object.altitude | 0;
            if (object.uncertainty != null)
                message.uncertainty = object.uncertainty >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Location message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Location
         * @static
         * @param {quack.Location} message Location
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Location.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.latitude = 0;
                object.longitude = 0;
                object.altitude = 0;
                object.uncertainty = 0;
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.altitude != null && message.hasOwnProperty("altitude"))
                object.altitude = message.altitude;
            if (message.uncertainty != null && message.hasOwnProperty("uncertainty"))
                object.uncertainty = message.uncertainty;
            return object;
        };

        /**
         * Converts this Location to JSON.
         * @function toJSON
         * @memberof quack.Location
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Location;
    })();

    quack.GPS = (function() {

        /**
         * Properties of a GPS.
         * @memberof quack
         * @interface IGPS
         * @property {Array.<quack.WifiAccessPoint>|null} [wifiAccessPoints] GPS wifiAccessPoints
         * @property {quack.CellTower|null} [cellTower] GPS cellTower
         * @property {quack.Location|null} [location] GPS location
         */

        /**
         * Constructs a new GPS.
         * @memberof quack
         * @classdesc Represents a GPS.
         * @implements IGPS
         * @constructor
         * @param {quack.IGPS=} [properties] Properties to set
         */
        function GPS(properties) {
            this.wifiAccessPoints = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GPS wifiAccessPoints.
         * @member {Array.<quack.WifiAccessPoint>} wifiAccessPoints
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.wifiAccessPoints = $util.emptyArray;

        /**
         * GPS cellTower.
         * @member {quack.CellTower|null|undefined} cellTower
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.cellTower = null;

        /**
         * GPS location.
         * @member {quack.Location|null|undefined} location
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.location = null;

        /**
         * Creates a new GPS instance using the specified properties.
         * @function create
         * @memberof quack.GPS
         * @static
         * @param {quack.IGPS=} [properties] Properties to set
         * @returns {quack.GPS} GPS instance
         */
        GPS.create = function create(properties) {
            return new GPS(properties);
        };

        /**
         * Creates a GPS message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GPS
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GPS} GPS
         */
        GPS.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GPS)
                return object;
            var message = new $root.quack.GPS();
            if (object.wifiAccessPoints) {
                if (!Array.isArray(object.wifiAccessPoints))
                    throw TypeError(".quack.GPS.wifiAccessPoints: array expected");
                message.wifiAccessPoints = [];
                for (var i = 0; i < object.wifiAccessPoints.length; ++i) {
                    if (typeof object.wifiAccessPoints[i] !== "object")
                        throw TypeError(".quack.GPS.wifiAccessPoints: object expected");
                    message.wifiAccessPoints[i] = $root.quack.WifiAccessPoint.fromObject(object.wifiAccessPoints[i]);
                }
            }
            if (object.cellTower != null) {
                if (typeof object.cellTower !== "object")
                    throw TypeError(".quack.GPS.cellTower: object expected");
                message.cellTower = $root.quack.CellTower.fromObject(object.cellTower);
            }
            if (object.location != null) {
                if (typeof object.location !== "object")
                    throw TypeError(".quack.GPS.location: object expected");
                message.location = $root.quack.Location.fromObject(object.location);
            }
            return message;
        };

        /**
         * Creates a plain object from a GPS message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GPS
         * @static
         * @param {quack.GPS} message GPS
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GPS.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.wifiAccessPoints = [];
            if (options.defaults) {
                object.cellTower = null;
                object.location = null;
            }
            if (message.wifiAccessPoints && message.wifiAccessPoints.length) {
                object.wifiAccessPoints = [];
                for (var j = 0; j < message.wifiAccessPoints.length; ++j)
                    object.wifiAccessPoints[j] = $root.quack.WifiAccessPoint.toObject(message.wifiAccessPoints[j], options);
            }
            if (message.cellTower != null && message.hasOwnProperty("cellTower"))
                object.cellTower = $root.quack.CellTower.toObject(message.cellTower, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = $root.quack.Location.toObject(message.location, options);
            return object;
        };

        /**
         * Converts this GPS to JSON.
         * @function toJSON
         * @memberof quack.GPS
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GPS.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GPS;
    })();

    quack.BooleanInput = (function() {

        /**
         * Properties of a BooleanInput.
         * @memberof quack
         * @interface IBooleanInput
         * @property {boolean|null} [value] BooleanInput value
         */

        /**
         * Constructs a new BooleanInput.
         * @memberof quack
         * @classdesc Represents a BooleanInput.
         * @implements IBooleanInput
         * @constructor
         * @param {quack.IBooleanInput=} [properties] Properties to set
         */
        function BooleanInput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BooleanInput value.
         * @member {boolean} value
         * @memberof quack.BooleanInput
         * @instance
         */
        BooleanInput.prototype.value = false;

        /**
         * Creates a new BooleanInput instance using the specified properties.
         * @function create
         * @memberof quack.BooleanInput
         * @static
         * @param {quack.IBooleanInput=} [properties] Properties to set
         * @returns {quack.BooleanInput} BooleanInput instance
         */
        BooleanInput.create = function create(properties) {
            return new BooleanInput(properties);
        };

        /**
         * Creates a BooleanInput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.BooleanInput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.BooleanInput} BooleanInput
         */
        BooleanInput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.BooleanInput)
                return object;
            var message = new $root.quack.BooleanInput();
            if (object.value != null)
                message.value = Boolean(object.value);
            return message;
        };

        /**
         * Creates a plain object from a BooleanInput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.BooleanInput
         * @static
         * @param {quack.BooleanInput} message BooleanInput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BooleanInput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = false;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this BooleanInput to JSON.
         * @function toJSON
         * @memberof quack.BooleanInput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BooleanInput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BooleanInput;
    })();

    quack.HumidityAndTemperature = (function() {

        /**
         * Properties of a HumidityAndTemperature.
         * @memberof quack
         * @interface IHumidityAndTemperature
         * @property {number|null} [celciusTimes_10] HumidityAndTemperature celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] HumidityAndTemperature relativeHumidityTimes_100
         */

        /**
         * Constructs a new HumidityAndTemperature.
         * @memberof quack
         * @classdesc Represents a HumidityAndTemperature.
         * @implements IHumidityAndTemperature
         * @constructor
         * @param {quack.IHumidityAndTemperature=} [properties] Properties to set
         */
        function HumidityAndTemperature(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HumidityAndTemperature celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.HumidityAndTemperature
         * @instance
         */
        HumidityAndTemperature.prototype.celciusTimes_10 = 0;

        /**
         * HumidityAndTemperature relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.HumidityAndTemperature
         * @instance
         */
        HumidityAndTemperature.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Creates a new HumidityAndTemperature instance using the specified properties.
         * @function create
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {quack.IHumidityAndTemperature=} [properties] Properties to set
         * @returns {quack.HumidityAndTemperature} HumidityAndTemperature instance
         */
        HumidityAndTemperature.create = function create(properties) {
            return new HumidityAndTemperature(properties);
        };

        /**
         * Creates a HumidityAndTemperature message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.HumidityAndTemperature} HumidityAndTemperature
         */
        HumidityAndTemperature.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.HumidityAndTemperature)
                return object;
            var message = new $root.quack.HumidityAndTemperature();
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a HumidityAndTemperature message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {quack.HumidityAndTemperature} message HumidityAndTemperature
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HumidityAndTemperature.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
            }
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            return object;
        };

        /**
         * Converts this HumidityAndTemperature to JSON.
         * @function toJSON
         * @memberof quack.HumidityAndTemperature
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HumidityAndTemperature.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HumidityAndTemperature;
    })();

    quack.ModemSignal = (function() {

        /**
         * Properties of a ModemSignal.
         * @memberof quack
         * @interface IModemSignal
         * @property {number|null} [rssi] ModemSignal rssi
         * @property {number|null} [quality] ModemSignal quality
         */

        /**
         * Constructs a new ModemSignal.
         * @memberof quack
         * @classdesc Represents a ModemSignal.
         * @implements IModemSignal
         * @constructor
         * @param {quack.IModemSignal=} [properties] Properties to set
         */
        function ModemSignal(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ModemSignal rssi.
         * @member {number} rssi
         * @memberof quack.ModemSignal
         * @instance
         */
        ModemSignal.prototype.rssi = 0;

        /**
         * ModemSignal quality.
         * @member {number} quality
         * @memberof quack.ModemSignal
         * @instance
         */
        ModemSignal.prototype.quality = 0;

        /**
         * Creates a new ModemSignal instance using the specified properties.
         * @function create
         * @memberof quack.ModemSignal
         * @static
         * @param {quack.IModemSignal=} [properties] Properties to set
         * @returns {quack.ModemSignal} ModemSignal instance
         */
        ModemSignal.create = function create(properties) {
            return new ModemSignal(properties);
        };

        /**
         * Creates a ModemSignal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ModemSignal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ModemSignal} ModemSignal
         */
        ModemSignal.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ModemSignal)
                return object;
            var message = new $root.quack.ModemSignal();
            if (object.rssi != null)
                message.rssi = object.rssi | 0;
            if (object.quality != null)
                message.quality = object.quality | 0;
            return message;
        };

        /**
         * Creates a plain object from a ModemSignal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ModemSignal
         * @static
         * @param {quack.ModemSignal} message ModemSignal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ModemSignal.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.rssi = 0;
                object.quality = 0;
            }
            if (message.rssi != null && message.hasOwnProperty("rssi"))
                object.rssi = message.rssi;
            if (message.quality != null && message.hasOwnProperty("quality"))
                object.quality = message.quality;
            return object;
        };

        /**
         * Converts this ModemSignal to JSON.
         * @function toJSON
         * @memberof quack.ModemSignal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ModemSignal.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ModemSignal;
    })();

    quack.Light = (function() {

        /**
         * Properties of a Light.
         * @memberof quack
         * @interface ILight
         * @property {number|null} [fullSpectrum] Light fullSpectrum
         * @property {number|null} [infrared] Light infrared
         * @property {number|null} [visible] Light visible
         * @property {number|null} [luxTimes_100] Light luxTimes_100
         */

        /**
         * Constructs a new Light.
         * @memberof quack
         * @classdesc Represents a Light.
         * @implements ILight
         * @constructor
         * @param {quack.ILight=} [properties] Properties to set
         */
        function Light(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Light fullSpectrum.
         * @member {number} fullSpectrum
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.fullSpectrum = 0;

        /**
         * Light infrared.
         * @member {number} infrared
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.infrared = 0;

        /**
         * Light visible.
         * @member {number} visible
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.visible = 0;

        /**
         * Light luxTimes_100.
         * @member {number} luxTimes_100
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.luxTimes_100 = 0;

        /**
         * Creates a new Light instance using the specified properties.
         * @function create
         * @memberof quack.Light
         * @static
         * @param {quack.ILight=} [properties] Properties to set
         * @returns {quack.Light} Light instance
         */
        Light.create = function create(properties) {
            return new Light(properties);
        };

        /**
         * Creates a Light message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Light
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Light} Light
         */
        Light.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Light)
                return object;
            var message = new $root.quack.Light();
            if (object.fullSpectrum != null)
                message.fullSpectrum = object.fullSpectrum >>> 0;
            if (object.infrared != null)
                message.infrared = object.infrared >>> 0;
            if (object.visible != null)
                message.visible = object.visible >>> 0;
            if (object.luxTimes_100 != null)
                message.luxTimes_100 = object.luxTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Light message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Light
         * @static
         * @param {quack.Light} message Light
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Light.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fullSpectrum = 0;
                object.infrared = 0;
                object.visible = 0;
                object.luxTimes_100 = 0;
            }
            if (message.fullSpectrum != null && message.hasOwnProperty("fullSpectrum"))
                object.fullSpectrum = message.fullSpectrum;
            if (message.infrared != null && message.hasOwnProperty("infrared"))
                object.infrared = message.infrared;
            if (message.visible != null && message.hasOwnProperty("visible"))
                object.visible = message.visible;
            if (message.luxTimes_100 != null && message.hasOwnProperty("luxTimes_100"))
                object.luxTimes_100 = message.luxTimes_100;
            return object;
        };

        /**
         * Converts this Light to JSON.
         * @function toJSON
         * @memberof quack.Light
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Light.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Light;
    })();

    quack.Gas = (function() {

        /**
         * Properties of a Gas.
         * @memberof quack
         * @interface IGas
         * @property {number|null} [ppm] Gas ppm
         * @property {number|null} [ppb] Gas ppb
         */

        /**
         * Constructs a new Gas.
         * @memberof quack
         * @classdesc Represents a Gas.
         * @implements IGas
         * @constructor
         * @param {quack.IGas=} [properties] Properties to set
         */
        function Gas(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Gas ppm.
         * @member {number} ppm
         * @memberof quack.Gas
         * @instance
         */
        Gas.prototype.ppm = 0;

        /**
         * Gas ppb.
         * @member {number} ppb
         * @memberof quack.Gas
         * @instance
         */
        Gas.prototype.ppb = 0;

        /**
         * Creates a new Gas instance using the specified properties.
         * @function create
         * @memberof quack.Gas
         * @static
         * @param {quack.IGas=} [properties] Properties to set
         * @returns {quack.Gas} Gas instance
         */
        Gas.create = function create(properties) {
            return new Gas(properties);
        };

        /**
         * Creates a Gas message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Gas
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Gas} Gas
         */
        Gas.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Gas)
                return object;
            var message = new $root.quack.Gas();
            if (object.ppm != null)
                message.ppm = object.ppm >>> 0;
            if (object.ppb != null)
                message.ppb = object.ppb >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Gas message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Gas
         * @static
         * @param {quack.Gas} message Gas
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Gas.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ppm = 0;
                object.ppb = 0;
            }
            if (message.ppm != null && message.hasOwnProperty("ppm"))
                object.ppm = message.ppm;
            if (message.ppb != null && message.hasOwnProperty("ppb"))
                object.ppb = message.ppb;
            return object;
        };

        /**
         * Converts this Gas to JSON.
         * @function toJSON
         * @memberof quack.Gas
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Gas.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Gas;
    })();

    quack.StepperMotor = (function() {

        /**
         * Properties of a StepperMotor.
         * @memberof quack
         * @interface IStepperMotor
         * @property {boolean|null} [running] StepperMotor running
         */

        /**
         * Constructs a new StepperMotor.
         * @memberof quack
         * @classdesc Represents a StepperMotor.
         * @implements IStepperMotor
         * @constructor
         * @param {quack.IStepperMotor=} [properties] Properties to set
         */
        function StepperMotor(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StepperMotor running.
         * @member {boolean} running
         * @memberof quack.StepperMotor
         * @instance
         */
        StepperMotor.prototype.running = false;

        /**
         * Creates a new StepperMotor instance using the specified properties.
         * @function create
         * @memberof quack.StepperMotor
         * @static
         * @param {quack.IStepperMotor=} [properties] Properties to set
         * @returns {quack.StepperMotor} StepperMotor instance
         */
        StepperMotor.create = function create(properties) {
            return new StepperMotor(properties);
        };

        /**
         * Creates a StepperMotor message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.StepperMotor
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.StepperMotor} StepperMotor
         */
        StepperMotor.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.StepperMotor)
                return object;
            var message = new $root.quack.StepperMotor();
            if (object.running != null)
                message.running = Boolean(object.running);
            return message;
        };

        /**
         * Creates a plain object from a StepperMotor message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.StepperMotor
         * @static
         * @param {quack.StepperMotor} message StepperMotor
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StepperMotor.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.running = false;
            if (message.running != null && message.hasOwnProperty("running"))
                object.running = message.running;
            return object;
        };

        /**
         * Converts this StepperMotor to JSON.
         * @function toJSON
         * @memberof quack.StepperMotor
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StepperMotor.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StepperMotor;
    })();

    quack.AnalogInput = (function() {

        /**
         * Properties of an AnalogInput.
         * @memberof quack
         * @interface IAnalogInput
         * @property {number|null} [value] AnalogInput value
         */

        /**
         * Constructs a new AnalogInput.
         * @memberof quack
         * @classdesc Represents an AnalogInput.
         * @implements IAnalogInput
         * @constructor
         * @param {quack.IAnalogInput=} [properties] Properties to set
         */
        function AnalogInput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AnalogInput value.
         * @member {number} value
         * @memberof quack.AnalogInput
         * @instance
         */
        AnalogInput.prototype.value = 0;

        /**
         * Creates a new AnalogInput instance using the specified properties.
         * @function create
         * @memberof quack.AnalogInput
         * @static
         * @param {quack.IAnalogInput=} [properties] Properties to set
         * @returns {quack.AnalogInput} AnalogInput instance
         */
        AnalogInput.create = function create(properties) {
            return new AnalogInput(properties);
        };

        /**
         * Creates an AnalogInput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AnalogInput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AnalogInput} AnalogInput
         */
        AnalogInput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AnalogInput)
                return object;
            var message = new $root.quack.AnalogInput();
            if (object.value != null)
                message.value = object.value >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AnalogInput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AnalogInput
         * @static
         * @param {quack.AnalogInput} message AnalogInput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AnalogInput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this AnalogInput to JSON.
         * @function toJSON
         * @memberof quack.AnalogInput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AnalogInput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AnalogInput;
    })();

    quack.ORP = (function() {

        /**
         * Properties of a ORP.
         * @memberof quack
         * @interface IORP
         * @property {number|null} [microvolts] ORP microvolts
         */

        /**
         * Constructs a new ORP.
         * @memberof quack
         * @classdesc Represents a ORP.
         * @implements IORP
         * @constructor
         * @param {quack.IORP=} [properties] Properties to set
         */
        function ORP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ORP microvolts.
         * @member {number} microvolts
         * @memberof quack.ORP
         * @instance
         */
        ORP.prototype.microvolts = 0;

        /**
         * Creates a new ORP instance using the specified properties.
         * @function create
         * @memberof quack.ORP
         * @static
         * @param {quack.IORP=} [properties] Properties to set
         * @returns {quack.ORP} ORP instance
         */
        ORP.create = function create(properties) {
            return new ORP(properties);
        };

        /**
         * Creates a ORP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ORP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ORP} ORP
         */
        ORP.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ORP)
                return object;
            var message = new $root.quack.ORP();
            if (object.microvolts != null)
                message.microvolts = object.microvolts | 0;
            return message;
        };

        /**
         * Creates a plain object from a ORP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ORP
         * @static
         * @param {quack.ORP} message ORP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ORP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microvolts = 0;
            if (message.microvolts != null && message.hasOwnProperty("microvolts"))
                object.microvolts = message.microvolts;
            return object;
        };

        /**
         * Converts this ORP to JSON.
         * @function toJSON
         * @memberof quack.ORP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ORP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ORP;
    })();

    quack.PH = (function() {

        /**
         * Properties of a PH.
         * @memberof quack
         * @interface IPH
         * @property {number|null} [phTimes_100000] PH phTimes_100000
         */

        /**
         * Constructs a new PH.
         * @memberof quack
         * @classdesc Represents a PH.
         * @implements IPH
         * @constructor
         * @param {quack.IPH=} [properties] Properties to set
         */
        function PH(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PH phTimes_100000.
         * @member {number} phTimes_100000
         * @memberof quack.PH
         * @instance
         */
        PH.prototype.phTimes_100000 = 0;

        /**
         * Creates a new PH instance using the specified properties.
         * @function create
         * @memberof quack.PH
         * @static
         * @param {quack.IPH=} [properties] Properties to set
         * @returns {quack.PH} PH instance
         */
        PH.create = function create(properties) {
            return new PH(properties);
        };

        /**
         * Creates a PH message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.PH
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.PH} PH
         */
        PH.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.PH)
                return object;
            var message = new $root.quack.PH();
            if (object.phTimes_100000 != null)
                message.phTimes_100000 = object.phTimes_100000 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a PH message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.PH
         * @static
         * @param {quack.PH} message PH
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PH.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.phTimes_100000 = 0;
            if (message.phTimes_100000 != null && message.hasOwnProperty("phTimes_100000"))
                object.phTimes_100000 = message.phTimes_100000;
            return object;
        };

        /**
         * Converts this PH to JSON.
         * @function toJSON
         * @memberof quack.PH
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PH.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PH;
    })();

    quack.Voltage = (function() {

        /**
         * Properties of a Voltage.
         * @memberof quack
         * @interface IVoltage
         * @property {number|null} [microvolts] Voltage microvolts
         */

        /**
         * Constructs a new Voltage.
         * @memberof quack
         * @classdesc Represents a Voltage.
         * @implements IVoltage
         * @constructor
         * @param {quack.IVoltage=} [properties] Properties to set
         */
        function Voltage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Voltage microvolts.
         * @member {number} microvolts
         * @memberof quack.Voltage
         * @instance
         */
        Voltage.prototype.microvolts = 0;

        /**
         * Creates a new Voltage instance using the specified properties.
         * @function create
         * @memberof quack.Voltage
         * @static
         * @param {quack.IVoltage=} [properties] Properties to set
         * @returns {quack.Voltage} Voltage instance
         */
        Voltage.create = function create(properties) {
            return new Voltage(properties);
        };

        /**
         * Creates a Voltage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Voltage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Voltage} Voltage
         */
        Voltage.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Voltage)
                return object;
            var message = new $root.quack.Voltage();
            if (object.microvolts != null)
                message.microvolts = object.microvolts | 0;
            return message;
        };

        /**
         * Creates a plain object from a Voltage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Voltage
         * @static
         * @param {quack.Voltage} message Voltage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Voltage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microvolts = 0;
            if (message.microvolts != null && message.hasOwnProperty("microvolts"))
                object.microvolts = message.microvolts;
            return object;
        };

        /**
         * Converts this Voltage to JSON.
         * @function toJSON
         * @memberof quack.Voltage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Voltage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Voltage;
    })();

    quack.Concentration = (function() {

        /**
         * Properties of a Concentration.
         * @memberof quack
         * @interface IConcentration
         * @property {number|null} [ppb] Concentration ppb
         */

        /**
         * Constructs a new Concentration.
         * @memberof quack
         * @classdesc Represents a Concentration.
         * @implements IConcentration
         * @constructor
         * @param {quack.IConcentration=} [properties] Properties to set
         */
        function Concentration(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Concentration ppb.
         * @member {number} ppb
         * @memberof quack.Concentration
         * @instance
         */
        Concentration.prototype.ppb = 0;

        /**
         * Creates a new Concentration instance using the specified properties.
         * @function create
         * @memberof quack.Concentration
         * @static
         * @param {quack.IConcentration=} [properties] Properties to set
         * @returns {quack.Concentration} Concentration instance
         */
        Concentration.create = function create(properties) {
            return new Concentration(properties);
        };

        /**
         * Creates a Concentration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Concentration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Concentration} Concentration
         */
        Concentration.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Concentration)
                return object;
            var message = new $root.quack.Concentration();
            if (object.ppb != null)
                message.ppb = object.ppb >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Concentration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Concentration
         * @static
         * @param {quack.Concentration} message Concentration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Concentration.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ppb = 0;
            if (message.ppb != null && message.hasOwnProperty("ppb"))
                object.ppb = message.ppb;
            return object;
        };

        /**
         * Converts this Concentration to JSON.
         * @function toJSON
         * @memberof quack.Concentration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Concentration.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Concentration;
    })();

    quack.Conductivity = (function() {

        /**
         * Properties of a Conductivity.
         * @memberof quack
         * @interface IConductivity
         * @property {number|null} [microsiemensPerCm] Conductivity microsiemensPerCm
         */

        /**
         * Constructs a new Conductivity.
         * @memberof quack
         * @classdesc Represents a Conductivity.
         * @implements IConductivity
         * @constructor
         * @param {quack.IConductivity=} [properties] Properties to set
         */
        function Conductivity(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Conductivity microsiemensPerCm.
         * @member {number} microsiemensPerCm
         * @memberof quack.Conductivity
         * @instance
         */
        Conductivity.prototype.microsiemensPerCm = 0;

        /**
         * Creates a new Conductivity instance using the specified properties.
         * @function create
         * @memberof quack.Conductivity
         * @static
         * @param {quack.IConductivity=} [properties] Properties to set
         * @returns {quack.Conductivity} Conductivity instance
         */
        Conductivity.create = function create(properties) {
            return new Conductivity(properties);
        };

        /**
         * Creates a Conductivity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Conductivity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Conductivity} Conductivity
         */
        Conductivity.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Conductivity)
                return object;
            var message = new $root.quack.Conductivity();
            if (object.microsiemensPerCm != null)
                message.microsiemensPerCm = object.microsiemensPerCm >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Conductivity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Conductivity
         * @static
         * @param {quack.Conductivity} message Conductivity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Conductivity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microsiemensPerCm = 0;
            if (message.microsiemensPerCm != null && message.hasOwnProperty("microsiemensPerCm"))
                object.microsiemensPerCm = message.microsiemensPerCm;
            return object;
        };

        /**
         * Converts this Conductivity to JSON.
         * @function toJSON
         * @memberof quack.Conductivity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Conductivity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Conductivity;
    })();

    quack.Capacitance = (function() {

        /**
         * Properties of a Capacitance.
         * @memberof quack
         * @interface ICapacitance
         * @property {number|null} [picofarads] Capacitance picofarads
         */

        /**
         * Constructs a new Capacitance.
         * @memberof quack
         * @classdesc Represents a Capacitance.
         * @implements ICapacitance
         * @constructor
         * @param {quack.ICapacitance=} [properties] Properties to set
         */
        function Capacitance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Capacitance picofarads.
         * @member {number} picofarads
         * @memberof quack.Capacitance
         * @instance
         */
        Capacitance.prototype.picofarads = 0;

        /**
         * Creates a new Capacitance instance using the specified properties.
         * @function create
         * @memberof quack.Capacitance
         * @static
         * @param {quack.ICapacitance=} [properties] Properties to set
         * @returns {quack.Capacitance} Capacitance instance
         */
        Capacitance.create = function create(properties) {
            return new Capacitance(properties);
        };

        /**
         * Creates a Capacitance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Capacitance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Capacitance} Capacitance
         */
        Capacitance.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Capacitance)
                return object;
            var message = new $root.quack.Capacitance();
            if (object.picofarads != null)
                message.picofarads = object.picofarads | 0;
            return message;
        };

        /**
         * Creates a plain object from a Capacitance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Capacitance
         * @static
         * @param {quack.Capacitance} message Capacitance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Capacitance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.picofarads = 0;
            if (message.picofarads != null && message.hasOwnProperty("picofarads"))
                object.picofarads = message.picofarads;
            return object;
        };

        /**
         * Converts this Capacitance to JSON.
         * @function toJSON
         * @memberof quack.Capacitance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Capacitance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Capacitance;
    })();

    quack.VapourPressureDeficit = (function() {

        /**
         * Properties of a VapourPressureDeficit.
         * @memberof quack
         * @interface IVapourPressureDeficit
         * @property {number|null} [pascals] VapourPressureDeficit pascals
         * @property {number|null} [celciusTimes_10] VapourPressureDeficit celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] VapourPressureDeficit relativeHumidityTimes_100
         */

        /**
         * Constructs a new VapourPressureDeficit.
         * @memberof quack
         * @classdesc Represents a VapourPressureDeficit.
         * @implements IVapourPressureDeficit
         * @constructor
         * @param {quack.IVapourPressureDeficit=} [properties] Properties to set
         */
        function VapourPressureDeficit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VapourPressureDeficit pascals.
         * @member {number} pascals
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.pascals = 0;

        /**
         * VapourPressureDeficit celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.celciusTimes_10 = 0;

        /**
         * VapourPressureDeficit relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Creates a new VapourPressureDeficit instance using the specified properties.
         * @function create
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {quack.IVapourPressureDeficit=} [properties] Properties to set
         * @returns {quack.VapourPressureDeficit} VapourPressureDeficit instance
         */
        VapourPressureDeficit.create = function create(properties) {
            return new VapourPressureDeficit(properties);
        };

        /**
         * Creates a VapourPressureDeficit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VapourPressureDeficit} VapourPressureDeficit
         */
        VapourPressureDeficit.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VapourPressureDeficit)
                return object;
            var message = new $root.quack.VapourPressureDeficit();
            if (object.pascals != null)
                message.pascals = object.pascals | 0;
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a VapourPressureDeficit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {quack.VapourPressureDeficit} message VapourPressureDeficit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VapourPressureDeficit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pascals = 0;
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
            }
            if (message.pascals != null && message.hasOwnProperty("pascals"))
                object.pascals = message.pascals;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            return object;
        };

        /**
         * Converts this VapourPressureDeficit to JSON.
         * @function toJSON
         * @memberof quack.VapourPressureDeficit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VapourPressureDeficit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VapourPressureDeficit;
    })();

    quack.Weight = (function() {

        /**
         * Properties of a Weight.
         * @memberof quack
         * @interface IWeight
         * @property {number|null} [grams] Weight grams
         */

        /**
         * Constructs a new Weight.
         * @memberof quack
         * @classdesc Represents a Weight.
         * @implements IWeight
         * @constructor
         * @param {quack.IWeight=} [properties] Properties to set
         */
        function Weight(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Weight grams.
         * @member {number} grams
         * @memberof quack.Weight
         * @instance
         */
        Weight.prototype.grams = 0;

        /**
         * Creates a new Weight instance using the specified properties.
         * @function create
         * @memberof quack.Weight
         * @static
         * @param {quack.IWeight=} [properties] Properties to set
         * @returns {quack.Weight} Weight instance
         */
        Weight.create = function create(properties) {
            return new Weight(properties);
        };

        /**
         * Creates a Weight message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Weight
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Weight} Weight
         */
        Weight.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Weight)
                return object;
            var message = new $root.quack.Weight();
            if (object.grams != null)
                message.grams = object.grams >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Weight message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Weight
         * @static
         * @param {quack.Weight} message Weight
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Weight.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.grams = 0;
            if (message.grams != null && message.hasOwnProperty("grams"))
                object.grams = message.grams;
            return object;
        };

        /**
         * Converts this Weight to JSON.
         * @function toJSON
         * @memberof quack.Weight
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Weight.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Weight;
    })();

    quack.Distance = (function() {

        /**
         * Properties of a Distance.
         * @memberof quack
         * @interface IDistance
         * @property {number|null} [cm] Distance cm
         * @property {number|null} [errorCm] Distance errorCm
         */

        /**
         * Constructs a new Distance.
         * @memberof quack
         * @classdesc Represents a Distance.
         * @implements IDistance
         * @constructor
         * @param {quack.IDistance=} [properties] Properties to set
         */
        function Distance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Distance cm.
         * @member {number} cm
         * @memberof quack.Distance
         * @instance
         */
        Distance.prototype.cm = 0;

        /**
         * Distance errorCm.
         * @member {number} errorCm
         * @memberof quack.Distance
         * @instance
         */
        Distance.prototype.errorCm = 0;

        /**
         * Creates a new Distance instance using the specified properties.
         * @function create
         * @memberof quack.Distance
         * @static
         * @param {quack.IDistance=} [properties] Properties to set
         * @returns {quack.Distance} Distance instance
         */
        Distance.create = function create(properties) {
            return new Distance(properties);
        };

        /**
         * Creates a Distance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Distance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Distance} Distance
         */
        Distance.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Distance)
                return object;
            var message = new $root.quack.Distance();
            if (object.cm != null)
                message.cm = object.cm >>> 0;
            if (object.errorCm != null)
                message.errorCm = object.errorCm >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Distance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Distance
         * @static
         * @param {quack.Distance} message Distance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Distance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cm = 0;
                object.errorCm = 0;
            }
            if (message.cm != null && message.hasOwnProperty("cm"))
                object.cm = message.cm;
            if (message.errorCm != null && message.hasOwnProperty("errorCm"))
                object.errorCm = message.errorCm;
            return object;
        };

        /**
         * Converts this Distance to JSON.
         * @function toJSON
         * @memberof quack.Distance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Distance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Distance;
    })();

    quack.Sen5x = (function() {

        /**
         * Properties of a Sen5x.
         * @memberof quack
         * @interface ISen5x
         * @property {number|null} [dust_1ug] Sen5x dust_1ug
         * @property {number|null} [dust_2ug] Sen5x dust_2ug
         * @property {number|null} [dust_4ug] Sen5x dust_4ug
         * @property {number|null} [dust_10ug] Sen5x dust_10ug
         * @property {number|null} [celciusTimes_10] Sen5x celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] Sen5x relativeHumidityTimes_100
         * @property {number|null} [vocIndex] Sen5x vocIndex
         * @property {number|null} [noxIndex] Sen5x noxIndex
         */

        /**
         * Constructs a new Sen5x.
         * @memberof quack
         * @classdesc Represents a Sen5x.
         * @implements ISen5x
         * @constructor
         * @param {quack.ISen5x=} [properties] Properties to set
         */
        function Sen5x(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Sen5x dust_1ug.
         * @member {number} dust_1ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_1ug = 0;

        /**
         * Sen5x dust_2ug.
         * @member {number} dust_2ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_2ug = 0;

        /**
         * Sen5x dust_4ug.
         * @member {number} dust_4ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_4ug = 0;

        /**
         * Sen5x dust_10ug.
         * @member {number} dust_10ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_10ug = 0;

        /**
         * Sen5x celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.celciusTimes_10 = 0;

        /**
         * Sen5x relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Sen5x vocIndex.
         * @member {number} vocIndex
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.vocIndex = 0;

        /**
         * Sen5x noxIndex.
         * @member {number} noxIndex
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.noxIndex = 0;

        /**
         * Creates a new Sen5x instance using the specified properties.
         * @function create
         * @memberof quack.Sen5x
         * @static
         * @param {quack.ISen5x=} [properties] Properties to set
         * @returns {quack.Sen5x} Sen5x instance
         */
        Sen5x.create = function create(properties) {
            return new Sen5x(properties);
        };

        /**
         * Creates a Sen5x message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Sen5x
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Sen5x} Sen5x
         */
        Sen5x.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Sen5x)
                return object;
            var message = new $root.quack.Sen5x();
            if (object.dust_1ug != null)
                message.dust_1ug = object.dust_1ug >>> 0;
            if (object.dust_2ug != null)
                message.dust_2ug = object.dust_2ug >>> 0;
            if (object.dust_4ug != null)
                message.dust_4ug = object.dust_4ug >>> 0;
            if (object.dust_10ug != null)
                message.dust_10ug = object.dust_10ug >>> 0;
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            if (object.vocIndex != null)
                message.vocIndex = object.vocIndex | 0;
            if (object.noxIndex != null)
                message.noxIndex = object.noxIndex | 0;
            return message;
        };

        /**
         * Creates a plain object from a Sen5x message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Sen5x
         * @static
         * @param {quack.Sen5x} message Sen5x
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Sen5x.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.dust_1ug = 0;
                object.dust_2ug = 0;
                object.dust_4ug = 0;
                object.dust_10ug = 0;
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
                object.vocIndex = 0;
                object.noxIndex = 0;
            }
            if (message.dust_1ug != null && message.hasOwnProperty("dust_1ug"))
                object.dust_1ug = message.dust_1ug;
            if (message.dust_2ug != null && message.hasOwnProperty("dust_2ug"))
                object.dust_2ug = message.dust_2ug;
            if (message.dust_4ug != null && message.hasOwnProperty("dust_4ug"))
                object.dust_4ug = message.dust_4ug;
            if (message.dust_10ug != null && message.hasOwnProperty("dust_10ug"))
                object.dust_10ug = message.dust_10ug;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            if (message.vocIndex != null && message.hasOwnProperty("vocIndex"))
                object.vocIndex = message.vocIndex;
            if (message.noxIndex != null && message.hasOwnProperty("noxIndex"))
                object.noxIndex = message.noxIndex;
            return object;
        };

        /**
         * Converts this Sen5x to JSON.
         * @function toJSON
         * @memberof quack.Sen5x
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Sen5x.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Sen5x;
    })();

    quack.PressureCable = (function() {

        /**
         * Properties of a PressureCable.
         * @memberof quack
         * @interface IPressureCable
         * @property {Array.<number>|null} [pascals] PressureCable pascals
         */

        /**
         * Constructs a new PressureCable.
         * @memberof quack
         * @classdesc Represents a PressureCable.
         * @implements IPressureCable
         * @constructor
         * @param {quack.IPressureCable=} [properties] Properties to set
         */
        function PressureCable(properties) {
            this.pascals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PressureCable pascals.
         * @member {Array.<number>} pascals
         * @memberof quack.PressureCable
         * @instance
         */
        PressureCable.prototype.pascals = $util.emptyArray;

        /**
         * Creates a new PressureCable instance using the specified properties.
         * @function create
         * @memberof quack.PressureCable
         * @static
         * @param {quack.IPressureCable=} [properties] Properties to set
         * @returns {quack.PressureCable} PressureCable instance
         */
        PressureCable.create = function create(properties) {
            return new PressureCable(properties);
        };

        /**
         * Creates a PressureCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.PressureCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.PressureCable} PressureCable
         */
        PressureCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.PressureCable)
                return object;
            var message = new $root.quack.PressureCable();
            if (object.pascals) {
                if (!Array.isArray(object.pascals))
                    throw TypeError(".quack.PressureCable.pascals: array expected");
                message.pascals = [];
                for (var i = 0; i < object.pascals.length; ++i)
                    message.pascals[i] = object.pascals[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a PressureCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.PressureCable
         * @static
         * @param {quack.PressureCable} message PressureCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PressureCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pascals = [];
            if (message.pascals && message.pascals.length) {
                object.pascals = [];
                for (var j = 0; j < message.pascals.length; ++j)
                    object.pascals[j] = message.pascals[j];
            }
            return object;
        };

        /**
         * Converts this PressureCable to JSON.
         * @function toJSON
         * @memberof quack.PressureCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PressureCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PressureCable;
    })();

    quack.VibrationCable = (function() {

        /**
         * Properties of a VibrationCable.
         * @memberof quack
         * @interface IVibrationCable
         * @property {Array.<number>|null} [frequency] VibrationCable frequency
         * @property {Array.<number>|null} [singleAccelerationRms] VibrationCable singleAccelerationRms
         * @property {number|null} [totalAccelerationRms] VibrationCable totalAccelerationRms
         */

        /**
         * Constructs a new VibrationCable.
         * @memberof quack
         * @classdesc Represents a VibrationCable.
         * @implements IVibrationCable
         * @constructor
         * @param {quack.IVibrationCable=} [properties] Properties to set
         */
        function VibrationCable(properties) {
            this.frequency = [];
            this.singleAccelerationRms = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VibrationCable frequency.
         * @member {Array.<number>} frequency
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.frequency = $util.emptyArray;

        /**
         * VibrationCable singleAccelerationRms.
         * @member {Array.<number>} singleAccelerationRms
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.singleAccelerationRms = $util.emptyArray;

        /**
         * VibrationCable totalAccelerationRms.
         * @member {number} totalAccelerationRms
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.totalAccelerationRms = 0;

        /**
         * Creates a new VibrationCable instance using the specified properties.
         * @function create
         * @memberof quack.VibrationCable
         * @static
         * @param {quack.IVibrationCable=} [properties] Properties to set
         * @returns {quack.VibrationCable} VibrationCable instance
         */
        VibrationCable.create = function create(properties) {
            return new VibrationCable(properties);
        };

        /**
         * Creates a VibrationCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VibrationCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VibrationCable} VibrationCable
         */
        VibrationCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VibrationCable)
                return object;
            var message = new $root.quack.VibrationCable();
            if (object.frequency) {
                if (!Array.isArray(object.frequency))
                    throw TypeError(".quack.VibrationCable.frequency: array expected");
                message.frequency = [];
                for (var i = 0; i < object.frequency.length; ++i)
                    message.frequency[i] = object.frequency[i] >>> 0;
            }
            if (object.singleAccelerationRms) {
                if (!Array.isArray(object.singleAccelerationRms))
                    throw TypeError(".quack.VibrationCable.singleAccelerationRms: array expected");
                message.singleAccelerationRms = [];
                for (var i = 0; i < object.singleAccelerationRms.length; ++i)
                    message.singleAccelerationRms[i] = object.singleAccelerationRms[i] >>> 0;
            }
            if (object.totalAccelerationRms != null)
                message.totalAccelerationRms = object.totalAccelerationRms >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a VibrationCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VibrationCable
         * @static
         * @param {quack.VibrationCable} message VibrationCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VibrationCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.frequency = [];
                object.singleAccelerationRms = [];
            }
            if (options.defaults)
                object.totalAccelerationRms = 0;
            if (message.frequency && message.frequency.length) {
                object.frequency = [];
                for (var j = 0; j < message.frequency.length; ++j)
                    object.frequency[j] = message.frequency[j];
            }
            if (message.singleAccelerationRms && message.singleAccelerationRms.length) {
                object.singleAccelerationRms = [];
                for (var j = 0; j < message.singleAccelerationRms.length; ++j)
                    object.singleAccelerationRms[j] = message.singleAccelerationRms[j];
            }
            if (message.totalAccelerationRms != null && message.hasOwnProperty("totalAccelerationRms"))
                object.totalAccelerationRms = message.totalAccelerationRms;
            return object;
        };

        /**
         * Converts this VibrationCable to JSON.
         * @function toJSON
         * @memberof quack.VibrationCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VibrationCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VibrationCable;
    })();

    quack.DragerGasDongle = (function() {

        /**
         * Properties of a DragerGasDongle.
         * @memberof quack
         * @interface IDragerGasDongle
         * @property {Array.<number>|null} [ppm] DragerGasDongle ppm
         * @property {Array.<number>|null} [millivolts] DragerGasDongle millivolts
         */

        /**
         * Constructs a new DragerGasDongle.
         * @memberof quack
         * @classdesc Represents a DragerGasDongle.
         * @implements IDragerGasDongle
         * @constructor
         * @param {quack.IDragerGasDongle=} [properties] Properties to set
         */
        function DragerGasDongle(properties) {
            this.ppm = [];
            this.millivolts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DragerGasDongle ppm.
         * @member {Array.<number>} ppm
         * @memberof quack.DragerGasDongle
         * @instance
         */
        DragerGasDongle.prototype.ppm = $util.emptyArray;

        /**
         * DragerGasDongle millivolts.
         * @member {Array.<number>} millivolts
         * @memberof quack.DragerGasDongle
         * @instance
         */
        DragerGasDongle.prototype.millivolts = $util.emptyArray;

        /**
         * Creates a new DragerGasDongle instance using the specified properties.
         * @function create
         * @memberof quack.DragerGasDongle
         * @static
         * @param {quack.IDragerGasDongle=} [properties] Properties to set
         * @returns {quack.DragerGasDongle} DragerGasDongle instance
         */
        DragerGasDongle.create = function create(properties) {
            return new DragerGasDongle(properties);
        };

        /**
         * Creates a DragerGasDongle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.DragerGasDongle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.DragerGasDongle} DragerGasDongle
         */
        DragerGasDongle.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.DragerGasDongle)
                return object;
            var message = new $root.quack.DragerGasDongle();
            if (object.ppm) {
                if (!Array.isArray(object.ppm))
                    throw TypeError(".quack.DragerGasDongle.ppm: array expected");
                message.ppm = [];
                for (var i = 0; i < object.ppm.length; ++i)
                    message.ppm[i] = Number(object.ppm[i]);
            }
            if (object.millivolts) {
                if (!Array.isArray(object.millivolts))
                    throw TypeError(".quack.DragerGasDongle.millivolts: array expected");
                message.millivolts = [];
                for (var i = 0; i < object.millivolts.length; ++i)
                    message.millivolts[i] = object.millivolts[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a DragerGasDongle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.DragerGasDongle
         * @static
         * @param {quack.DragerGasDongle} message DragerGasDongle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DragerGasDongle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.ppm = [];
                object.millivolts = [];
            }
            if (message.ppm && message.ppm.length) {
                object.ppm = [];
                for (var j = 0; j < message.ppm.length; ++j)
                    object.ppm[j] = options.json && !isFinite(message.ppm[j]) ? String(message.ppm[j]) : message.ppm[j];
            }
            if (message.millivolts && message.millivolts.length) {
                object.millivolts = [];
                for (var j = 0; j < message.millivolts.length; ++j)
                    object.millivolts[j] = message.millivolts[j];
            }
            return object;
        };

        /**
         * Converts this DragerGasDongle to JSON.
         * @function toJSON
         * @memberof quack.DragerGasDongle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DragerGasDongle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DragerGasDongle;
    })();

    quack.AirFlow = (function() {

        /**
         * Properties of an AirFlow.
         * @memberof quack
         * @interface IAirFlow
         * @property {number|null} [cfm] AirFlow cfm
         */

        /**
         * Constructs a new AirFlow.
         * @memberof quack
         * @classdesc Represents an AirFlow.
         * @implements IAirFlow
         * @constructor
         * @param {quack.IAirFlow=} [properties] Properties to set
         */
        function AirFlow(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AirFlow cfm.
         * @member {number} cfm
         * @memberof quack.AirFlow
         * @instance
         */
        AirFlow.prototype.cfm = 0;

        /**
         * Creates a new AirFlow instance using the specified properties.
         * @function create
         * @memberof quack.AirFlow
         * @static
         * @param {quack.IAirFlow=} [properties] Properties to set
         * @returns {quack.AirFlow} AirFlow instance
         */
        AirFlow.create = function create(properties) {
            return new AirFlow(properties);
        };

        /**
         * Creates an AirFlow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AirFlow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AirFlow} AirFlow
         */
        AirFlow.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AirFlow)
                return object;
            var message = new $root.quack.AirFlow();
            if (object.cfm != null)
                message.cfm = Number(object.cfm);
            return message;
        };

        /**
         * Creates a plain object from an AirFlow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AirFlow
         * @static
         * @param {quack.AirFlow} message AirFlow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AirFlow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.cfm = 0;
            if (message.cfm != null && message.hasOwnProperty("cfm"))
                object.cfm = options.json && !isFinite(message.cfm) ? String(message.cfm) : message.cfm;
            return object;
        };

        /**
         * Converts this AirFlow to JSON.
         * @function toJSON
         * @memberof quack.AirFlow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AirFlow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AirFlow;
    })();

    quack.VirtualMeasurement = (function() {

        /**
         * Properties of a VirtualMeasurement.
         * @memberof quack
         * @interface IVirtualMeasurement
         * @property {quack.Measurement|null} [vMeasurement] VirtualMeasurement vMeasurement
         */

        /**
         * Constructs a new VirtualMeasurement.
         * @memberof quack
         * @classdesc Represents a VirtualMeasurement.
         * @implements IVirtualMeasurement
         * @constructor
         * @param {quack.IVirtualMeasurement=} [properties] Properties to set
         */
        function VirtualMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VirtualMeasurement vMeasurement.
         * @member {quack.Measurement|null|undefined} vMeasurement
         * @memberof quack.VirtualMeasurement
         * @instance
         */
        VirtualMeasurement.prototype.vMeasurement = null;

        /**
         * Creates a new VirtualMeasurement instance using the specified properties.
         * @function create
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {quack.IVirtualMeasurement=} [properties] Properties to set
         * @returns {quack.VirtualMeasurement} VirtualMeasurement instance
         */
        VirtualMeasurement.create = function create(properties) {
            return new VirtualMeasurement(properties);
        };

        /**
         * Creates a VirtualMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VirtualMeasurement} VirtualMeasurement
         */
        VirtualMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VirtualMeasurement)
                return object;
            var message = new $root.quack.VirtualMeasurement();
            if (object.vMeasurement != null) {
                if (typeof object.vMeasurement !== "object")
                    throw TypeError(".quack.VirtualMeasurement.vMeasurement: object expected");
                message.vMeasurement = $root.quack.Measurement.fromObject(object.vMeasurement);
            }
            return message;
        };

        /**
         * Creates a plain object from a VirtualMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {quack.VirtualMeasurement} message VirtualMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VirtualMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.vMeasurement = null;
            if (message.vMeasurement != null && message.hasOwnProperty("vMeasurement"))
                object.vMeasurement = $root.quack.Measurement.toObject(message.vMeasurement, options);
            return object;
        };

        /**
         * Converts this VirtualMeasurement to JSON.
         * @function toJSON
         * @memberof quack.VirtualMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VirtualMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VirtualMeasurement;
    })();

    quack.Measurement = (function() {

        /**
         * Properties of a Measurement.
         * @memberof quack
         * @interface IMeasurement
         * @property {quack.ComponentID|null} [id] Measurement id
         * @property {number|null} [subtype] Measurement subtype
         * @property {boolean|null} [triggered] Measurement triggered
         * @property {quack.Temperature|null} [temperature] Measurement temperature
         * @property {quack.EdgeTriggered|null} [edgeTriggered] Measurement edgeTriggered
         * @property {quack.Power|null} [power] Measurement power
         * @property {quack.GrainCable|null} [grainCable] Measurement grainCable
         * @property {quack.BooleanOutput|null} [booleanOutput] Measurement booleanOutput
         * @property {quack.Pressure|null} [pressure] Measurement pressure
         * @property {quack.GPS|null} [gps] Measurement gps
         * @property {quack.BooleanInput|null} [booleanInput] Measurement booleanInput
         * @property {quack.HumidityAndTemperature|null} [humidityAndTemperature] Measurement humidityAndTemperature
         * @property {quack.ModemSignal|null} [modemSignal] Measurement modemSignal
         * @property {quack.Light|null} [light] Measurement light
         * @property {quack.Gas|null} [gas] Measurement gas
         * @property {quack.StepperMotor|null} [stepperMotor] Measurement stepperMotor
         * @property {quack.AnalogInput|null} [analogInput] Measurement analogInput
         * @property {quack.ORP|null} [orp] Measurement orp
         * @property {quack.PH|null} [ph] Measurement ph
         * @property {quack.Voltage|null} [voltage] Measurement voltage
         * @property {quack.Concentration|null} [concentration] Measurement concentration
         * @property {quack.Conductivity|null} [conductivity] Measurement conductivity
         * @property {quack.Capacitance|null} [capacitance] Measurement capacitance
         * @property {quack.VapourPressureDeficit|null} [vpd] Measurement vpd
         * @property {quack.Weight|null} [weight] Measurement weight
         * @property {quack.Distance|null} [distance] Measurement distance
         * @property {quack.PressureCable|null} [pressureCable] Measurement pressureCable
         * @property {quack.CapacitorCable|null} [capacitorCable] Measurement capacitorCable
         * @property {quack.Sen5x|null} [sen5x] Measurement sen5x
         * @property {quack.VibrationCable|null} [vibrationCable] Measurement vibrationCable
         * @property {quack.DragerGasDongle|null} [dragerGasDongle] Measurement dragerGasDongle
         * @property {quack.AirFlow|null} [airflow] Measurement airflow
         */

        /**
         * Constructs a new Measurement.
         * @memberof quack
         * @classdesc Represents a Measurement.
         * @implements IMeasurement
         * @constructor
         * @param {quack.IMeasurement=} [properties] Properties to set
         */
        function Measurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Measurement id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.id = null;

        /**
         * Measurement subtype.
         * @member {number} subtype
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.subtype = 0;

        /**
         * Measurement triggered.
         * @member {boolean} triggered
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.triggered = false;

        /**
         * Measurement temperature.
         * @member {quack.Temperature|null|undefined} temperature
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.temperature = null;

        /**
         * Measurement edgeTriggered.
         * @member {quack.EdgeTriggered|null|undefined} edgeTriggered
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.edgeTriggered = null;

        /**
         * Measurement power.
         * @member {quack.Power|null|undefined} power
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.power = null;

        /**
         * Measurement grainCable.
         * @member {quack.GrainCable|null|undefined} grainCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.grainCable = null;

        /**
         * Measurement booleanOutput.
         * @member {quack.BooleanOutput|null|undefined} booleanOutput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.booleanOutput = null;

        /**
         * Measurement pressure.
         * @member {quack.Pressure|null|undefined} pressure
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.pressure = null;

        /**
         * Measurement gps.
         * @member {quack.GPS|null|undefined} gps
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.gps = null;

        /**
         * Measurement booleanInput.
         * @member {quack.BooleanInput|null|undefined} booleanInput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.booleanInput = null;

        /**
         * Measurement humidityAndTemperature.
         * @member {quack.HumidityAndTemperature|null|undefined} humidityAndTemperature
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.humidityAndTemperature = null;

        /**
         * Measurement modemSignal.
         * @member {quack.ModemSignal|null|undefined} modemSignal
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.modemSignal = null;

        /**
         * Measurement light.
         * @member {quack.Light|null|undefined} light
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.light = null;

        /**
         * Measurement gas.
         * @member {quack.Gas|null|undefined} gas
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.gas = null;

        /**
         * Measurement stepperMotor.
         * @member {quack.StepperMotor|null|undefined} stepperMotor
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.stepperMotor = null;

        /**
         * Measurement analogInput.
         * @member {quack.AnalogInput|null|undefined} analogInput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.analogInput = null;

        /**
         * Measurement orp.
         * @member {quack.ORP|null|undefined} orp
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.orp = null;

        /**
         * Measurement ph.
         * @member {quack.PH|null|undefined} ph
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.ph = null;

        /**
         * Measurement voltage.
         * @member {quack.Voltage|null|undefined} voltage
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.voltage = null;

        /**
         * Measurement concentration.
         * @member {quack.Concentration|null|undefined} concentration
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.concentration = null;

        /**
         * Measurement conductivity.
         * @member {quack.Conductivity|null|undefined} conductivity
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.conductivity = null;

        /**
         * Measurement capacitance.
         * @member {quack.Capacitance|null|undefined} capacitance
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.capacitance = null;

        /**
         * Measurement vpd.
         * @member {quack.VapourPressureDeficit|null|undefined} vpd
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.vpd = null;

        /**
         * Measurement weight.
         * @member {quack.Weight|null|undefined} weight
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.weight = null;

        /**
         * Measurement distance.
         * @member {quack.Distance|null|undefined} distance
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.distance = null;

        /**
         * Measurement pressureCable.
         * @member {quack.PressureCable|null|undefined} pressureCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.pressureCable = null;

        /**
         * Measurement capacitorCable.
         * @member {quack.CapacitorCable|null|undefined} capacitorCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.capacitorCable = null;

        /**
         * Measurement sen5x.
         * @member {quack.Sen5x|null|undefined} sen5x
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.sen5x = null;

        /**
         * Measurement vibrationCable.
         * @member {quack.VibrationCable|null|undefined} vibrationCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.vibrationCable = null;

        /**
         * Measurement dragerGasDongle.
         * @member {quack.DragerGasDongle|null|undefined} dragerGasDongle
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.dragerGasDongle = null;

        /**
         * Measurement airflow.
         * @member {quack.AirFlow|null|undefined} airflow
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.airflow = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Measurement measurement.
         * @member {"temperature"|"edgeTriggered"|"power"|"grainCable"|"booleanOutput"|"pressure"|"gps"|"booleanInput"|"humidityAndTemperature"|"modemSignal"|"light"|"gas"|"stepperMotor"|"analogInput"|"orp"|"ph"|"voltage"|"concentration"|"conductivity"|"capacitance"|"vpd"|"weight"|"distance"|"pressureCable"|"capacitorCable"|"sen5x"|"vibrationCable"|"dragerGasDongle"|"airflow"|undefined} measurement
         * @memberof quack.Measurement
         * @instance
         */
        Object.defineProperty(Measurement.prototype, "measurement", {
            get: $util.oneOfGetter($oneOfFields = ["temperature", "edgeTriggered", "power", "grainCable", "booleanOutput", "pressure", "gps", "booleanInput", "humidityAndTemperature", "modemSignal", "light", "gas", "stepperMotor", "analogInput", "orp", "ph", "voltage", "concentration", "conductivity", "capacitance", "vpd", "weight", "distance", "pressureCable", "capacitorCable", "sen5x", "vibrationCable", "dragerGasDongle", "airflow"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Measurement instance using the specified properties.
         * @function create
         * @memberof quack.Measurement
         * @static
         * @param {quack.IMeasurement=} [properties] Properties to set
         * @returns {quack.Measurement} Measurement instance
         */
        Measurement.create = function create(properties) {
            return new Measurement(properties);
        };

        /**
         * Creates a Measurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Measurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Measurement} Measurement
         */
        Measurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Measurement)
                return object;
            var message = new $root.quack.Measurement();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.Measurement.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.triggered != null)
                message.triggered = Boolean(object.triggered);
            if (object.temperature != null) {
                if (typeof object.temperature !== "object")
                    throw TypeError(".quack.Measurement.temperature: object expected");
                message.temperature = $root.quack.Temperature.fromObject(object.temperature);
            }
            if (object.edgeTriggered != null) {
                if (typeof object.edgeTriggered !== "object")
                    throw TypeError(".quack.Measurement.edgeTriggered: object expected");
                message.edgeTriggered = $root.quack.EdgeTriggered.fromObject(object.edgeTriggered);
            }
            if (object.power != null) {
                if (typeof object.power !== "object")
                    throw TypeError(".quack.Measurement.power: object expected");
                message.power = $root.quack.Power.fromObject(object.power);
            }
            if (object.grainCable != null) {
                if (typeof object.grainCable !== "object")
                    throw TypeError(".quack.Measurement.grainCable: object expected");
                message.grainCable = $root.quack.GrainCable.fromObject(object.grainCable);
            }
            if (object.booleanOutput != null) {
                if (typeof object.booleanOutput !== "object")
                    throw TypeError(".quack.Measurement.booleanOutput: object expected");
                message.booleanOutput = $root.quack.BooleanOutput.fromObject(object.booleanOutput);
            }
            if (object.pressure != null) {
                if (typeof object.pressure !== "object")
                    throw TypeError(".quack.Measurement.pressure: object expected");
                message.pressure = $root.quack.Pressure.fromObject(object.pressure);
            }
            if (object.gps != null) {
                if (typeof object.gps !== "object")
                    throw TypeError(".quack.Measurement.gps: object expected");
                message.gps = $root.quack.GPS.fromObject(object.gps);
            }
            if (object.booleanInput != null) {
                if (typeof object.booleanInput !== "object")
                    throw TypeError(".quack.Measurement.booleanInput: object expected");
                message.booleanInput = $root.quack.BooleanInput.fromObject(object.booleanInput);
            }
            if (object.humidityAndTemperature != null) {
                if (typeof object.humidityAndTemperature !== "object")
                    throw TypeError(".quack.Measurement.humidityAndTemperature: object expected");
                message.humidityAndTemperature = $root.quack.HumidityAndTemperature.fromObject(object.humidityAndTemperature);
            }
            if (object.modemSignal != null) {
                if (typeof object.modemSignal !== "object")
                    throw TypeError(".quack.Measurement.modemSignal: object expected");
                message.modemSignal = $root.quack.ModemSignal.fromObject(object.modemSignal);
            }
            if (object.light != null) {
                if (typeof object.light !== "object")
                    throw TypeError(".quack.Measurement.light: object expected");
                message.light = $root.quack.Light.fromObject(object.light);
            }
            if (object.gas != null) {
                if (typeof object.gas !== "object")
                    throw TypeError(".quack.Measurement.gas: object expected");
                message.gas = $root.quack.Gas.fromObject(object.gas);
            }
            if (object.stepperMotor != null) {
                if (typeof object.stepperMotor !== "object")
                    throw TypeError(".quack.Measurement.stepperMotor: object expected");
                message.stepperMotor = $root.quack.StepperMotor.fromObject(object.stepperMotor);
            }
            if (object.analogInput != null) {
                if (typeof object.analogInput !== "object")
                    throw TypeError(".quack.Measurement.analogInput: object expected");
                message.analogInput = $root.quack.AnalogInput.fromObject(object.analogInput);
            }
            if (object.orp != null) {
                if (typeof object.orp !== "object")
                    throw TypeError(".quack.Measurement.orp: object expected");
                message.orp = $root.quack.ORP.fromObject(object.orp);
            }
            if (object.ph != null) {
                if (typeof object.ph !== "object")
                    throw TypeError(".quack.Measurement.ph: object expected");
                message.ph = $root.quack.PH.fromObject(object.ph);
            }
            if (object.voltage != null) {
                if (typeof object.voltage !== "object")
                    throw TypeError(".quack.Measurement.voltage: object expected");
                message.voltage = $root.quack.Voltage.fromObject(object.voltage);
            }
            if (object.concentration != null) {
                if (typeof object.concentration !== "object")
                    throw TypeError(".quack.Measurement.concentration: object expected");
                message.concentration = $root.quack.Concentration.fromObject(object.concentration);
            }
            if (object.conductivity != null) {
                if (typeof object.conductivity !== "object")
                    throw TypeError(".quack.Measurement.conductivity: object expected");
                message.conductivity = $root.quack.Conductivity.fromObject(object.conductivity);
            }
            if (object.capacitance != null) {
                if (typeof object.capacitance !== "object")
                    throw TypeError(".quack.Measurement.capacitance: object expected");
                message.capacitance = $root.quack.Capacitance.fromObject(object.capacitance);
            }
            if (object.vpd != null) {
                if (typeof object.vpd !== "object")
                    throw TypeError(".quack.Measurement.vpd: object expected");
                message.vpd = $root.quack.VapourPressureDeficit.fromObject(object.vpd);
            }
            if (object.weight != null) {
                if (typeof object.weight !== "object")
                    throw TypeError(".quack.Measurement.weight: object expected");
                message.weight = $root.quack.Weight.fromObject(object.weight);
            }
            if (object.distance != null) {
                if (typeof object.distance !== "object")
                    throw TypeError(".quack.Measurement.distance: object expected");
                message.distance = $root.quack.Distance.fromObject(object.distance);
            }
            if (object.pressureCable != null) {
                if (typeof object.pressureCable !== "object")
                    throw TypeError(".quack.Measurement.pressureCable: object expected");
                message.pressureCable = $root.quack.PressureCable.fromObject(object.pressureCable);
            }
            if (object.capacitorCable != null) {
                if (typeof object.capacitorCable !== "object")
                    throw TypeError(".quack.Measurement.capacitorCable: object expected");
                message.capacitorCable = $root.quack.CapacitorCable.fromObject(object.capacitorCable);
            }
            if (object.sen5x != null) {
                if (typeof object.sen5x !== "object")
                    throw TypeError(".quack.Measurement.sen5x: object expected");
                message.sen5x = $root.quack.Sen5x.fromObject(object.sen5x);
            }
            if (object.vibrationCable != null) {
                if (typeof object.vibrationCable !== "object")
                    throw TypeError(".quack.Measurement.vibrationCable: object expected");
                message.vibrationCable = $root.quack.VibrationCable.fromObject(object.vibrationCable);
            }
            if (object.dragerGasDongle != null) {
                if (typeof object.dragerGasDongle !== "object")
                    throw TypeError(".quack.Measurement.dragerGasDongle: object expected");
                message.dragerGasDongle = $root.quack.DragerGasDongle.fromObject(object.dragerGasDongle);
            }
            if (object.airflow != null) {
                if (typeof object.airflow !== "object")
                    throw TypeError(".quack.Measurement.airflow: object expected");
                message.airflow = $root.quack.AirFlow.fromObject(object.airflow);
            }
            return message;
        };

        /**
         * Creates a plain object from a Measurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Measurement
         * @static
         * @param {quack.Measurement} message Measurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Measurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = null;
                object.subtype = 0;
                object.triggered = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.triggered != null && message.hasOwnProperty("triggered"))
                object.triggered = message.triggered;
            if (message.temperature != null && message.hasOwnProperty("temperature")) {
                object.temperature = $root.quack.Temperature.toObject(message.temperature, options);
                if (options.oneofs)
                    object.measurement = "temperature";
            }
            if (message.edgeTriggered != null && message.hasOwnProperty("edgeTriggered")) {
                object.edgeTriggered = $root.quack.EdgeTriggered.toObject(message.edgeTriggered, options);
                if (options.oneofs)
                    object.measurement = "edgeTriggered";
            }
            if (message.power != null && message.hasOwnProperty("power")) {
                object.power = $root.quack.Power.toObject(message.power, options);
                if (options.oneofs)
                    object.measurement = "power";
            }
            if (message.grainCable != null && message.hasOwnProperty("grainCable")) {
                object.grainCable = $root.quack.GrainCable.toObject(message.grainCable, options);
                if (options.oneofs)
                    object.measurement = "grainCable";
            }
            if (message.booleanOutput != null && message.hasOwnProperty("booleanOutput")) {
                object.booleanOutput = $root.quack.BooleanOutput.toObject(message.booleanOutput, options);
                if (options.oneofs)
                    object.measurement = "booleanOutput";
            }
            if (message.pressure != null && message.hasOwnProperty("pressure")) {
                object.pressure = $root.quack.Pressure.toObject(message.pressure, options);
                if (options.oneofs)
                    object.measurement = "pressure";
            }
            if (message.gps != null && message.hasOwnProperty("gps")) {
                object.gps = $root.quack.GPS.toObject(message.gps, options);
                if (options.oneofs)
                    object.measurement = "gps";
            }
            if (message.booleanInput != null && message.hasOwnProperty("booleanInput")) {
                object.booleanInput = $root.quack.BooleanInput.toObject(message.booleanInput, options);
                if (options.oneofs)
                    object.measurement = "booleanInput";
            }
            if (message.humidityAndTemperature != null && message.hasOwnProperty("humidityAndTemperature")) {
                object.humidityAndTemperature = $root.quack.HumidityAndTemperature.toObject(message.humidityAndTemperature, options);
                if (options.oneofs)
                    object.measurement = "humidityAndTemperature";
            }
            if (message.modemSignal != null && message.hasOwnProperty("modemSignal")) {
                object.modemSignal = $root.quack.ModemSignal.toObject(message.modemSignal, options);
                if (options.oneofs)
                    object.measurement = "modemSignal";
            }
            if (message.light != null && message.hasOwnProperty("light")) {
                object.light = $root.quack.Light.toObject(message.light, options);
                if (options.oneofs)
                    object.measurement = "light";
            }
            if (message.gas != null && message.hasOwnProperty("gas")) {
                object.gas = $root.quack.Gas.toObject(message.gas, options);
                if (options.oneofs)
                    object.measurement = "gas";
            }
            if (message.stepperMotor != null && message.hasOwnProperty("stepperMotor")) {
                object.stepperMotor = $root.quack.StepperMotor.toObject(message.stepperMotor, options);
                if (options.oneofs)
                    object.measurement = "stepperMotor";
            }
            if (message.analogInput != null && message.hasOwnProperty("analogInput")) {
                object.analogInput = $root.quack.AnalogInput.toObject(message.analogInput, options);
                if (options.oneofs)
                    object.measurement = "analogInput";
            }
            if (message.orp != null && message.hasOwnProperty("orp")) {
                object.orp = $root.quack.ORP.toObject(message.orp, options);
                if (options.oneofs)
                    object.measurement = "orp";
            }
            if (message.ph != null && message.hasOwnProperty("ph")) {
                object.ph = $root.quack.PH.toObject(message.ph, options);
                if (options.oneofs)
                    object.measurement = "ph";
            }
            if (message.voltage != null && message.hasOwnProperty("voltage")) {
                object.voltage = $root.quack.Voltage.toObject(message.voltage, options);
                if (options.oneofs)
                    object.measurement = "voltage";
            }
            if (message.concentration != null && message.hasOwnProperty("concentration")) {
                object.concentration = $root.quack.Concentration.toObject(message.concentration, options);
                if (options.oneofs)
                    object.measurement = "concentration";
            }
            if (message.conductivity != null && message.hasOwnProperty("conductivity")) {
                object.conductivity = $root.quack.Conductivity.toObject(message.conductivity, options);
                if (options.oneofs)
                    object.measurement = "conductivity";
            }
            if (message.capacitance != null && message.hasOwnProperty("capacitance")) {
                object.capacitance = $root.quack.Capacitance.toObject(message.capacitance, options);
                if (options.oneofs)
                    object.measurement = "capacitance";
            }
            if (message.vpd != null && message.hasOwnProperty("vpd")) {
                object.vpd = $root.quack.VapourPressureDeficit.toObject(message.vpd, options);
                if (options.oneofs)
                    object.measurement = "vpd";
            }
            if (message.weight != null && message.hasOwnProperty("weight")) {
                object.weight = $root.quack.Weight.toObject(message.weight, options);
                if (options.oneofs)
                    object.measurement = "weight";
            }
            if (message.distance != null && message.hasOwnProperty("distance")) {
                object.distance = $root.quack.Distance.toObject(message.distance, options);
                if (options.oneofs)
                    object.measurement = "distance";
            }
            if (message.pressureCable != null && message.hasOwnProperty("pressureCable")) {
                object.pressureCable = $root.quack.PressureCable.toObject(message.pressureCable, options);
                if (options.oneofs)
                    object.measurement = "pressureCable";
            }
            if (message.capacitorCable != null && message.hasOwnProperty("capacitorCable")) {
                object.capacitorCable = $root.quack.CapacitorCable.toObject(message.capacitorCable, options);
                if (options.oneofs)
                    object.measurement = "capacitorCable";
            }
            if (message.sen5x != null && message.hasOwnProperty("sen5x")) {
                object.sen5x = $root.quack.Sen5x.toObject(message.sen5x, options);
                if (options.oneofs)
                    object.measurement = "sen5x";
            }
            if (message.vibrationCable != null && message.hasOwnProperty("vibrationCable")) {
                object.vibrationCable = $root.quack.VibrationCable.toObject(message.vibrationCable, options);
                if (options.oneofs)
                    object.measurement = "vibrationCable";
            }
            if (message.dragerGasDongle != null && message.hasOwnProperty("dragerGasDongle")) {
                object.dragerGasDongle = $root.quack.DragerGasDongle.toObject(message.dragerGasDongle, options);
                if (options.oneofs)
                    object.measurement = "dragerGasDongle";
            }
            if (message.airflow != null && message.hasOwnProperty("airflow")) {
                object.airflow = $root.quack.AirFlow.toObject(message.airflow, options);
                if (options.oneofs)
                    object.measurement = "airflow";
            }
            return object;
        };

        /**
         * Converts this Measurement to JSON.
         * @function toJSON
         * @memberof quack.Measurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Measurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Measurement;
    })();

    /**
     * MeasurementType enum.
     * @name quack.MeasurementType
     * @enum {string}
     * @property {number} MEASUREMENT_TYPE_INVALID=0 MEASUREMENT_TYPE_INVALID value
     * @property {number} MEASUREMENT_TYPE_TEMPERATURE=1 MEASUREMENT_TYPE_TEMPERATURE value
     * @property {number} MEASUREMENT_TYPE_BOOLEAN=2 MEASUREMENT_TYPE_BOOLEAN value
     * @property {number} MEASUREMENT_TYPE_VOLTAGE=3 MEASUREMENT_TYPE_VOLTAGE value
     * @property {number} MEASUREMENT_TYPE_PERCENT=4 MEASUREMENT_TYPE_PERCENT value
     * @property {number} MEASUREMENT_TYPE_PRESSURE=5 MEASUREMENT_TYPE_PRESSURE value
     * @property {number} MEASUREMENT_TYPE_RSSI=6 MEASUREMENT_TYPE_RSSI value
     * @property {number} MEASUREMENT_TYPE_LIGHT=7 MEASUREMENT_TYPE_LIGHT value
     * @property {number} MEASUREMENT_TYPE_PPM=8 MEASUREMENT_TYPE_PPM value
     * @property {number} MEASUREMENT_TYPE_ANALOG=9 MEASUREMENT_TYPE_ANALOG value
     * @property {number} MEASUREMENT_TYPE_ORP=10 MEASUREMENT_TYPE_ORP value
     * @property {number} MEASUREMENT_TYPE_PH=11 MEASUREMENT_TYPE_PH value
     * @property {number} MEASUREMENT_TYPE_PPB=12 MEASUREMENT_TYPE_PPB value
     * @property {number} MEASUREMENT_TYPE_CONDUCTIVITY=13 MEASUREMENT_TYPE_CONDUCTIVITY value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE=14 MEASUREMENT_TYPE_CAPACITANCE value
     * @property {number} MEASUREMENT_TYPE_WEIGHT=15 MEASUREMENT_TYPE_WEIGHT value
     * @property {number} MEASUREMENT_TYPE_DISTANCE_CM=16 MEASUREMENT_TYPE_DISTANCE_CM value
     * @property {number} MEASUREMENT_TYPE_SPEED=17 MEASUREMENT_TYPE_SPEED value
     * @property {number} MEASUREMENT_TYPE_RAIN=18 MEASUREMENT_TYPE_RAIN value
     * @property {number} MEASUREMENT_TYPE_GRAIN_EMC=19 MEASUREMENT_TYPE_GRAIN_EMC value
     * @property {number} MEASUREMENT_TYPE_EDGE_RISES=20 MEASUREMENT_TYPE_EDGE_RISES value
     * @property {number} MEASUREMENT_TYPE_EDGE_FALLS=21 MEASUREMENT_TYPE_EDGE_FALLS value
     * @property {number} MEASUREMENT_TYPE_STATE_CHANGES=22 MEASUREMENT_TYPE_STATE_CHANGES value
     * @property {number} MEASUREMENT_TYPE_FULL_SPECTRUM=23 MEASUREMENT_TYPE_FULL_SPECTRUM value
     * @property {number} MEASUREMENT_TYPE_INFRARED=24 MEASUREMENT_TYPE_INFRARED value
     * @property {number} MEASUREMENT_TYPE_LUX=25 MEASUREMENT_TYPE_LUX value
     * @property {number} MEASUREMENT_TYPE_VISIBLE_LIGHT=26 MEASUREMENT_TYPE_VISIBLE_LIGHT value
     * @property {number} MEASUREMENT_TYPE_CFM=29 MEASUREMENT_TYPE_CFM value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE_GND_FF=27 MEASUREMENT_TYPE_CAPACITANCE_GND_FF value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE_SELF_FF=28 MEASUREMENT_TYPE_CAPACITANCE_SELF_FF value
     * @property {number} MEASUREMENT_TYPE_DUST_1UG=30 MEASUREMENT_TYPE_DUST_1UG value
     * @property {number} MEASUREMENT_TYPE_DUST_2UG=31 MEASUREMENT_TYPE_DUST_2UG value
     * @property {number} MEASUREMENT_TYPE_DUST_4UG=32 MEASUREMENT_TYPE_DUST_4UG value
     * @property {number} MEASUREMENT_TYPE_DUST_10UG=33 MEASUREMENT_TYPE_DUST_10UG value
     * @property {number} MEASUREMENT_TYPE_VOC_INDEX=34 MEASUREMENT_TYPE_VOC_INDEX value
     * @property {number} MEASUREMENT_TYPE_NOX_INDEX=35 MEASUREMENT_TYPE_NOX_INDEX value
     * @property {number} MEASUREMENT_TYPE_FREQUENCY=36 MEASUREMENT_TYPE_FREQUENCY value
     * @property {number} MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS=37 MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS value
     * @property {number} MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS=38 MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS value
     * @property {number} MEASUREMENT_TYPE_BUSHEL_CABLE=39 MEASUREMENT_TYPE_BUSHEL_CABLE value
     * @property {number} MEASUREMENT_TYPE_BUSHEL_LIDAR=40 MEASUREMENT_TYPE_BUSHEL_LIDAR value
     */
    quack.MeasurementType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MEASUREMENT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "MEASUREMENT_TYPE_TEMPERATURE"] = 1;
        values[valuesById[2] = "MEASUREMENT_TYPE_BOOLEAN"] = 2;
        values[valuesById[3] = "MEASUREMENT_TYPE_VOLTAGE"] = 3;
        values[valuesById[4] = "MEASUREMENT_TYPE_PERCENT"] = 4;
        values[valuesById[5] = "MEASUREMENT_TYPE_PRESSURE"] = 5;
        values[valuesById[6] = "MEASUREMENT_TYPE_RSSI"] = 6;
        values[valuesById[7] = "MEASUREMENT_TYPE_LIGHT"] = 7;
        values[valuesById[8] = "MEASUREMENT_TYPE_PPM"] = 8;
        values[valuesById[9] = "MEASUREMENT_TYPE_ANALOG"] = 9;
        values[valuesById[10] = "MEASUREMENT_TYPE_ORP"] = 10;
        values[valuesById[11] = "MEASUREMENT_TYPE_PH"] = 11;
        values[valuesById[12] = "MEASUREMENT_TYPE_PPB"] = 12;
        values[valuesById[13] = "MEASUREMENT_TYPE_CONDUCTIVITY"] = 13;
        values[valuesById[14] = "MEASUREMENT_TYPE_CAPACITANCE"] = 14;
        values[valuesById[15] = "MEASUREMENT_TYPE_WEIGHT"] = 15;
        values[valuesById[16] = "MEASUREMENT_TYPE_DISTANCE_CM"] = 16;
        values[valuesById[17] = "MEASUREMENT_TYPE_SPEED"] = 17;
        values[valuesById[18] = "MEASUREMENT_TYPE_RAIN"] = 18;
        values[valuesById[19] = "MEASUREMENT_TYPE_GRAIN_EMC"] = 19;
        values[valuesById[20] = "MEASUREMENT_TYPE_EDGE_RISES"] = 20;
        values[valuesById[21] = "MEASUREMENT_TYPE_EDGE_FALLS"] = 21;
        values[valuesById[22] = "MEASUREMENT_TYPE_STATE_CHANGES"] = 22;
        values[valuesById[23] = "MEASUREMENT_TYPE_FULL_SPECTRUM"] = 23;
        values[valuesById[24] = "MEASUREMENT_TYPE_INFRARED"] = 24;
        values[valuesById[25] = "MEASUREMENT_TYPE_LUX"] = 25;
        values[valuesById[26] = "MEASUREMENT_TYPE_VISIBLE_LIGHT"] = 26;
        values[valuesById[29] = "MEASUREMENT_TYPE_CFM"] = 29;
        values[valuesById[27] = "MEASUREMENT_TYPE_CAPACITANCE_GND_FF"] = 27;
        values[valuesById[28] = "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF"] = 28;
        values[valuesById[30] = "MEASUREMENT_TYPE_DUST_1UG"] = 30;
        values[valuesById[31] = "MEASUREMENT_TYPE_DUST_2UG"] = 31;
        values[valuesById[32] = "MEASUREMENT_TYPE_DUST_4UG"] = 32;
        values[valuesById[33] = "MEASUREMENT_TYPE_DUST_10UG"] = 33;
        values[valuesById[34] = "MEASUREMENT_TYPE_VOC_INDEX"] = 34;
        values[valuesById[35] = "MEASUREMENT_TYPE_NOX_INDEX"] = 35;
        values[valuesById[36] = "MEASUREMENT_TYPE_FREQUENCY"] = 36;
        values[valuesById[37] = "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS"] = 37;
        values[valuesById[38] = "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS"] = 38;
        values[valuesById[39] = "MEASUREMENT_TYPE_BUSHEL_CABLE"] = 39;
        values[valuesById[40] = "MEASUREMENT_TYPE_BUSHEL_LIDAR"] = 40;
        return values;
    })();

    /**
     * RelationalOperator enum.
     * @name quack.RelationalOperator
     * @enum {string}
     * @property {number} RELATIONAL_OPERATOR_INVALID=0 RELATIONAL_OPERATOR_INVALID value
     * @property {number} RELATIONAL_OPERATOR_EQUAL_TO=1 RELATIONAL_OPERATOR_EQUAL_TO value
     * @property {number} RELATIONAL_OPERATOR_LESS_THAN=2 RELATIONAL_OPERATOR_LESS_THAN value
     * @property {number} RELATIONAL_OPERATOR_GREATER_THAN=3 RELATIONAL_OPERATOR_GREATER_THAN value
     */
    quack.RelationalOperator = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RELATIONAL_OPERATOR_INVALID"] = 0;
        values[valuesById[1] = "RELATIONAL_OPERATOR_EQUAL_TO"] = 1;
        values[valuesById[2] = "RELATIONAL_OPERATOR_LESS_THAN"] = 2;
        values[valuesById[3] = "RELATIONAL_OPERATOR_GREATER_THAN"] = 3;
        return values;
    })();

    /**
     * InteractionResultType enum.
     * @name quack.InteractionResultType
     * @enum {string}
     * @property {number} INTERACTION_RESULT_TYPE_INVALID=0 INTERACTION_RESULT_TYPE_INVALID value
     * @property {number} INTERACTION_RESULT_TYPE_REPORT=1 INTERACTION_RESULT_TYPE_REPORT value
     * @property {number} INTERACTION_RESULT_TYPE_TOGGLE=2 INTERACTION_RESULT_TYPE_TOGGLE value
     * @property {number} INTERACTION_RESULT_TYPE_RUN=3 INTERACTION_RESULT_TYPE_RUN value
     * @property {number} INTERACTION_RESULT_TYPE_SET=4 INTERACTION_RESULT_TYPE_SET value
     */
    quack.InteractionResultType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INTERACTION_RESULT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "INTERACTION_RESULT_TYPE_REPORT"] = 1;
        values[valuesById[2] = "INTERACTION_RESULT_TYPE_TOGGLE"] = 2;
        values[valuesById[3] = "INTERACTION_RESULT_TYPE_RUN"] = 3;
        values[valuesById[4] = "INTERACTION_RESULT_TYPE_SET"] = 4;
        return values;
    })();

    quack.InteractionCondition = (function() {

        /**
         * Properties of an InteractionCondition.
         * @memberof quack
         * @interface IInteractionCondition
         * @property {number|null} [measurementType] InteractionCondition measurementType
         * @property {number|null} [comparison] InteractionCondition comparison
         * @property {number|null} [value] InteractionCondition value
         */

        /**
         * Constructs a new InteractionCondition.
         * @memberof quack
         * @classdesc Represents an InteractionCondition.
         * @implements IInteractionCondition
         * @constructor
         * @param {quack.IInteractionCondition=} [properties] Properties to set
         */
        function InteractionCondition(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionCondition measurementType.
         * @member {number} measurementType
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.measurementType = 0;

        /**
         * InteractionCondition comparison.
         * @member {number} comparison
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.comparison = 0;

        /**
         * InteractionCondition value.
         * @member {number} value
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.value = 0;

        /**
         * Creates a new InteractionCondition instance using the specified properties.
         * @function create
         * @memberof quack.InteractionCondition
         * @static
         * @param {quack.IInteractionCondition=} [properties] Properties to set
         * @returns {quack.InteractionCondition} InteractionCondition instance
         */
        InteractionCondition.create = function create(properties) {
            return new InteractionCondition(properties);
        };

        /**
         * Creates an InteractionCondition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionCondition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionCondition} InteractionCondition
         */
        InteractionCondition.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionCondition)
                return object;
            var message = new $root.quack.InteractionCondition();
            if (object.measurementType != null)
                message.measurementType = object.measurementType >>> 0;
            if (object.comparison != null)
                message.comparison = object.comparison >>> 0;
            if (object.value != null)
                message.value = object.value | 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionCondition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionCondition
         * @static
         * @param {quack.InteractionCondition} message InteractionCondition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionCondition.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.measurementType = 0;
                object.comparison = 0;
                object.value = 0;
            }
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = message.measurementType;
            if (message.comparison != null && message.hasOwnProperty("comparison"))
                object.comparison = message.comparison;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this InteractionCondition to JSON.
         * @function toJSON
         * @memberof quack.InteractionCondition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionCondition;
    })();

    quack.InteractionResult = (function() {

        /**
         * Properties of an InteractionResult.
         * @memberof quack
         * @interface IInteractionResult
         * @property {number|null} [type] InteractionResult type
         * @property {number|null} [value] InteractionResult value
         * @property {number|null} [mode] InteractionResult mode
         * @property {number|null} [dutyCycle] InteractionResult dutyCycle
         */

        /**
         * Constructs a new InteractionResult.
         * @memberof quack
         * @classdesc Represents an InteractionResult.
         * @implements IInteractionResult
         * @constructor
         * @param {quack.IInteractionResult=} [properties] Properties to set
         */
        function InteractionResult(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionResult type.
         * @member {number} type
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.type = 0;

        /**
         * InteractionResult value.
         * @member {number} value
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.value = 0;

        /**
         * InteractionResult mode.
         * @member {number} mode
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.mode = 0;

        /**
         * InteractionResult dutyCycle.
         * @member {number} dutyCycle
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.dutyCycle = 0;

        /**
         * Creates a new InteractionResult instance using the specified properties.
         * @function create
         * @memberof quack.InteractionResult
         * @static
         * @param {quack.IInteractionResult=} [properties] Properties to set
         * @returns {quack.InteractionResult} InteractionResult instance
         */
        InteractionResult.create = function create(properties) {
            return new InteractionResult(properties);
        };

        /**
         * Creates an InteractionResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionResult} InteractionResult
         */
        InteractionResult.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionResult)
                return object;
            var message = new $root.quack.InteractionResult();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.value != null)
                message.value = object.value | 0;
            if (object.mode != null)
                message.mode = object.mode >>> 0;
            if (object.dutyCycle != null)
                message.dutyCycle = object.dutyCycle >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionResult
         * @static
         * @param {quack.InteractionResult} message InteractionResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.value = 0;
                object.mode = 0;
                object.dutyCycle = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = message.mode;
            if (message.dutyCycle != null && message.hasOwnProperty("dutyCycle"))
                object.dutyCycle = message.dutyCycle;
            return object;
        };

        /**
         * Converts this InteractionResult to JSON.
         * @function toJSON
         * @memberof quack.InteractionResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionResult;
    })();

    quack.InteractionSchedule = (function() {

        /**
         * Properties of an InteractionSchedule.
         * @memberof quack
         * @interface IInteractionSchedule
         * @property {number|null} [weekdays] InteractionSchedule weekdays
         * @property {number|null} [timeOfDayStart] InteractionSchedule timeOfDayStart
         * @property {number|null} [timeOfDayEnd] InteractionSchedule timeOfDayEnd
         * @property {number|null} [utcOffset] InteractionSchedule utcOffset
         */

        /**
         * Constructs a new InteractionSchedule.
         * @memberof quack
         * @classdesc Represents an InteractionSchedule.
         * @implements IInteractionSchedule
         * @constructor
         * @param {quack.IInteractionSchedule=} [properties] Properties to set
         */
        function InteractionSchedule(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionSchedule weekdays.
         * @member {number} weekdays
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.weekdays = 0;

        /**
         * InteractionSchedule timeOfDayStart.
         * @member {number} timeOfDayStart
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayStart = 0;

        /**
         * InteractionSchedule timeOfDayEnd.
         * @member {number} timeOfDayEnd
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayEnd = 0;

        /**
         * InteractionSchedule utcOffset.
         * @member {number} utcOffset
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.utcOffset = 0;

        /**
         * Creates a new InteractionSchedule instance using the specified properties.
         * @function create
         * @memberof quack.InteractionSchedule
         * @static
         * @param {quack.IInteractionSchedule=} [properties] Properties to set
         * @returns {quack.InteractionSchedule} InteractionSchedule instance
         */
        InteractionSchedule.create = function create(properties) {
            return new InteractionSchedule(properties);
        };

        /**
         * Creates an InteractionSchedule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionSchedule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionSchedule} InteractionSchedule
         */
        InteractionSchedule.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionSchedule)
                return object;
            var message = new $root.quack.InteractionSchedule();
            if (object.weekdays != null)
                message.weekdays = object.weekdays >>> 0;
            if (object.timeOfDayStart != null)
                message.timeOfDayStart = object.timeOfDayStart >>> 0;
            if (object.timeOfDayEnd != null)
                message.timeOfDayEnd = object.timeOfDayEnd >>> 0;
            if (object.utcOffset != null)
                message.utcOffset = object.utcOffset | 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionSchedule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionSchedule
         * @static
         * @param {quack.InteractionSchedule} message InteractionSchedule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionSchedule.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.weekdays = 0;
                object.timeOfDayStart = 0;
                object.timeOfDayEnd = 0;
                object.utcOffset = 0;
            }
            if (message.weekdays != null && message.hasOwnProperty("weekdays"))
                object.weekdays = message.weekdays;
            if (message.timeOfDayStart != null && message.hasOwnProperty("timeOfDayStart"))
                object.timeOfDayStart = message.timeOfDayStart;
            if (message.timeOfDayEnd != null && message.hasOwnProperty("timeOfDayEnd"))
                object.timeOfDayEnd = message.timeOfDayEnd;
            if (message.utcOffset != null && message.hasOwnProperty("utcOffset"))
                object.utcOffset = message.utcOffset;
            return object;
        };

        /**
         * Converts this InteractionSchedule to JSON.
         * @function toJSON
         * @memberof quack.InteractionSchedule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionSchedule.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionSchedule;
    })();

    quack.Interaction = (function() {

        /**
         * Properties of an Interaction.
         * @memberof quack
         * @interface IInteraction
         * @property {quack.ComponentID|null} [source] Interaction source
         * @property {quack.ComponentID|null} [sink] Interaction sink
         * @property {number|null} [id] Interaction id
         * @property {Array.<quack.InteractionCondition>|null} [conditions] Interaction conditions
         * @property {quack.InteractionResult|null} [result] Interaction result
         * @property {boolean|null} [reports] Interaction reports
         * @property {quack.InteractionSchedule|null} [schedule] Interaction schedule
         * @property {number|null} [priority] Interaction priority
         * @property {number|null} [subtype] Interaction subtype
         */

        /**
         * Constructs a new Interaction.
         * @memberof quack
         * @classdesc Represents an Interaction.
         * @implements IInteraction
         * @constructor
         * @param {quack.IInteraction=} [properties] Properties to set
         */
        function Interaction(properties) {
            this.conditions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Interaction source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.source = null;

        /**
         * Interaction sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.sink = null;

        /**
         * Interaction id.
         * @member {number} id
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.id = 0;

        /**
         * Interaction conditions.
         * @member {Array.<quack.InteractionCondition>} conditions
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.conditions = $util.emptyArray;

        /**
         * Interaction result.
         * @member {quack.InteractionResult|null|undefined} result
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.result = null;

        /**
         * Interaction reports.
         * @member {boolean} reports
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.reports = false;

        /**
         * Interaction schedule.
         * @member {quack.InteractionSchedule|null|undefined} schedule
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.schedule = null;

        /**
         * Interaction priority.
         * @member {number} priority
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.priority = 0;

        /**
         * Interaction subtype.
         * @member {number} subtype
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.subtype = 0;

        /**
         * Creates a new Interaction instance using the specified properties.
         * @function create
         * @memberof quack.Interaction
         * @static
         * @param {quack.IInteraction=} [properties] Properties to set
         * @returns {quack.Interaction} Interaction instance
         */
        Interaction.create = function create(properties) {
            return new Interaction(properties);
        };

        /**
         * Creates an Interaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Interaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Interaction} Interaction
         */
        Interaction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Interaction)
                return object;
            var message = new $root.quack.Interaction();
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".quack.Interaction.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".quack.Interaction.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            if (object.id != null)
                message.id = object.id >>> 0;
            if (object.conditions) {
                if (!Array.isArray(object.conditions))
                    throw TypeError(".quack.Interaction.conditions: array expected");
                message.conditions = [];
                for (var i = 0; i < object.conditions.length; ++i) {
                    if (typeof object.conditions[i] !== "object")
                        throw TypeError(".quack.Interaction.conditions: object expected");
                    message.conditions[i] = $root.quack.InteractionCondition.fromObject(object.conditions[i]);
                }
            }
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".quack.Interaction.result: object expected");
                message.result = $root.quack.InteractionResult.fromObject(object.result);
            }
            if (object.reports != null)
                message.reports = Boolean(object.reports);
            if (object.schedule != null) {
                if (typeof object.schedule !== "object")
                    throw TypeError(".quack.Interaction.schedule: object expected");
                message.schedule = $root.quack.InteractionSchedule.fromObject(object.schedule);
            }
            if (object.priority != null)
                message.priority = object.priority >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Interaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Interaction
         * @static
         * @param {quack.Interaction} message Interaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Interaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.conditions = [];
            if (options.defaults) {
                object.source = null;
                object.sink = null;
                object.id = 0;
                object.result = null;
                object.reports = false;
                object.schedule = null;
                object.priority = 0;
                object.subtype = 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.conditions && message.conditions.length) {
                object.conditions = [];
                for (var j = 0; j < message.conditions.length; ++j)
                    object.conditions[j] = $root.quack.InteractionCondition.toObject(message.conditions[j], options);
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.quack.InteractionResult.toObject(message.result, options);
            if (message.reports != null && message.hasOwnProperty("reports"))
                object.reports = message.reports;
            if (message.schedule != null && message.hasOwnProperty("schedule"))
                object.schedule = $root.quack.InteractionSchedule.toObject(message.schedule, options);
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            return object;
        };

        /**
         * Converts this Interaction to JSON.
         * @function toJSON
         * @memberof quack.Interaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Interaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Interaction;
    })();

    quack.AddInteraction = (function() {

        /**
         * Properties of an AddInteraction.
         * @memberof quack
         * @interface IAddInteraction
         * @property {quack.Interaction|null} [interaction] AddInteraction interaction
         */

        /**
         * Constructs a new AddInteraction.
         * @memberof quack
         * @classdesc Represents an AddInteraction.
         * @implements IAddInteraction
         * @constructor
         * @param {quack.IAddInteraction=} [properties] Properties to set
         */
        function AddInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddInteraction interaction.
         * @member {quack.Interaction|null|undefined} interaction
         * @memberof quack.AddInteraction
         * @instance
         */
        AddInteraction.prototype.interaction = null;

        /**
         * Creates a new AddInteraction instance using the specified properties.
         * @function create
         * @memberof quack.AddInteraction
         * @static
         * @param {quack.IAddInteraction=} [properties] Properties to set
         * @returns {quack.AddInteraction} AddInteraction instance
         */
        AddInteraction.create = function create(properties) {
            return new AddInteraction(properties);
        };

        /**
         * Creates an AddInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddInteraction} AddInteraction
         */
        AddInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddInteraction)
                return object;
            var message = new $root.quack.AddInteraction();
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".quack.AddInteraction.interaction: object expected");
                message.interaction = $root.quack.Interaction.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddInteraction
         * @static
         * @param {quack.AddInteraction} message AddInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.interaction = null;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.quack.Interaction.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this AddInteraction to JSON.
         * @function toJSON
         * @memberof quack.AddInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteraction;
    })();

    quack.RemoveInteraction = (function() {

        /**
         * Properties of a RemoveInteraction.
         * @memberof quack
         * @interface IRemoveInteraction
         * @property {quack.ComponentID|null} [source] RemoveInteraction source
         * @property {quack.ComponentID|null} [sink] RemoveInteraction sink
         * @property {number|null} [id] RemoveInteraction id
         */

        /**
         * Constructs a new RemoveInteraction.
         * @memberof quack
         * @classdesc Represents a RemoveInteraction.
         * @implements IRemoveInteraction
         * @constructor
         * @param {quack.IRemoveInteraction=} [properties] Properties to set
         */
        function RemoveInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveInteraction source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.source = null;

        /**
         * RemoveInteraction sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.sink = null;

        /**
         * RemoveInteraction id.
         * @member {number} id
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.id = 0;

        /**
         * Creates a new RemoveInteraction instance using the specified properties.
         * @function create
         * @memberof quack.RemoveInteraction
         * @static
         * @param {quack.IRemoveInteraction=} [properties] Properties to set
         * @returns {quack.RemoveInteraction} RemoveInteraction instance
         */
        RemoveInteraction.create = function create(properties) {
            return new RemoveInteraction(properties);
        };

        /**
         * Creates a RemoveInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveInteraction} RemoveInteraction
         */
        RemoveInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveInteraction)
                return object;
            var message = new $root.quack.RemoveInteraction();
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".quack.RemoveInteraction.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".quack.RemoveInteraction.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            if (object.id != null)
                message.id = object.id >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RemoveInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveInteraction
         * @static
         * @param {quack.RemoveInteraction} message RemoveInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.source = null;
                object.sink = null;
                object.id = 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this RemoveInteraction to JSON.
         * @function toJSON
         * @memberof quack.RemoveInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveInteraction;
    })();

    quack.UpdateInteraction = (function() {

        /**
         * Properties of an UpdateInteraction.
         * @memberof quack
         * @interface IUpdateInteraction
         * @property {quack.Interaction|null} [interaction] UpdateInteraction interaction
         */

        /**
         * Constructs a new UpdateInteraction.
         * @memberof quack
         * @classdesc Represents an UpdateInteraction.
         * @implements IUpdateInteraction
         * @constructor
         * @param {quack.IUpdateInteraction=} [properties] Properties to set
         */
        function UpdateInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateInteraction interaction.
         * @member {quack.Interaction|null|undefined} interaction
         * @memberof quack.UpdateInteraction
         * @instance
         */
        UpdateInteraction.prototype.interaction = null;

        /**
         * Creates a new UpdateInteraction instance using the specified properties.
         * @function create
         * @memberof quack.UpdateInteraction
         * @static
         * @param {quack.IUpdateInteraction=} [properties] Properties to set
         * @returns {quack.UpdateInteraction} UpdateInteraction instance
         */
        UpdateInteraction.create = function create(properties) {
            return new UpdateInteraction(properties);
        };

        /**
         * Creates an UpdateInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateInteraction} UpdateInteraction
         */
        UpdateInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateInteraction)
                return object;
            var message = new $root.quack.UpdateInteraction();
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".quack.UpdateInteraction.interaction: object expected");
                message.interaction = $root.quack.Interaction.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateInteraction
         * @static
         * @param {quack.UpdateInteraction} message UpdateInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.interaction = null;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.quack.Interaction.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this UpdateInteraction to JSON.
         * @function toJSON
         * @memberof quack.UpdateInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteraction;
    })();

    /**
     * UserPermissions enum.
     * @name quack.UserPermissions
     * @enum {string}
     * @property {number} USER_PERMISSIONS_INVALID=0 USER_PERMISSIONS_INVALID value
     * @property {number} USER_PERMISSIONS_USER=1 USER_PERMISSIONS_USER value
     * @property {number} USER_PERMISSIONS_MASTER=2 USER_PERMISSIONS_MASTER value
     * @property {number} USER_PERMISSIONS_INSTALLER=3 USER_PERMISSIONS_INSTALLER value
     * @property {number} USER_PERMISSIONS_SERIAL=4 USER_PERMISSIONS_SERIAL value
     */
    quack.UserPermissions = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER_PERMISSIONS_INVALID"] = 0;
        values[valuesById[1] = "USER_PERMISSIONS_USER"] = 1;
        values[valuesById[2] = "USER_PERMISSIONS_MASTER"] = 2;
        values[valuesById[3] = "USER_PERMISSIONS_INSTALLER"] = 3;
        values[valuesById[4] = "USER_PERMISSIONS_SERIAL"] = 4;
        return values;
    })();

    quack.User = (function() {

        /**
         * Properties of a User.
         * @memberof quack
         * @interface IUser
         * @property {string|null} [id] User id
         * @property {boolean|null} [receivesEvents] User receivesEvents
         * @property {number|null} [permissions] User permissions
         */

        /**
         * Constructs a new User.
         * @memberof quack
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {quack.IUser=} [properties] Properties to set
         */
        function User(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User id.
         * @member {string} id
         * @memberof quack.User
         * @instance
         */
        User.prototype.id = "";

        /**
         * User receivesEvents.
         * @member {boolean} receivesEvents
         * @memberof quack.User
         * @instance
         */
        User.prototype.receivesEvents = false;

        /**
         * User permissions.
         * @member {number} permissions
         * @memberof quack.User
         * @instance
         */
        User.prototype.permissions = 0;

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof quack.User
         * @static
         * @param {quack.IUser=} [properties] Properties to set
         * @returns {quack.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.User)
                return object;
            var message = new $root.quack.User();
            if (object.id != null)
                message.id = String(object.id);
            if (object.receivesEvents != null)
                message.receivesEvents = Boolean(object.receivesEvents);
            if (object.permissions != null)
                message.permissions = object.permissions >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.User
         * @static
         * @param {quack.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.receivesEvents = false;
                object.permissions = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.receivesEvents != null && message.hasOwnProperty("receivesEvents"))
                object.receivesEvents = message.receivesEvents;
            if (message.permissions != null && message.hasOwnProperty("permissions"))
                object.permissions = message.permissions;
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof quack.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    quack.AddUser = (function() {

        /**
         * Properties of an AddUser.
         * @memberof quack
         * @interface IAddUser
         * @property {quack.User|null} [user] AddUser user
         */

        /**
         * Constructs a new AddUser.
         * @memberof quack
         * @classdesc Represents an AddUser.
         * @implements IAddUser
         * @constructor
         * @param {quack.IAddUser=} [properties] Properties to set
         */
        function AddUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUser user.
         * @member {quack.User|null|undefined} user
         * @memberof quack.AddUser
         * @instance
         */
        AddUser.prototype.user = null;

        /**
         * Creates a new AddUser instance using the specified properties.
         * @function create
         * @memberof quack.AddUser
         * @static
         * @param {quack.IAddUser=} [properties] Properties to set
         * @returns {quack.AddUser} AddUser instance
         */
        AddUser.create = function create(properties) {
            return new AddUser(properties);
        };

        /**
         * Creates an AddUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddUser} AddUser
         */
        AddUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddUser)
                return object;
            var message = new $root.quack.AddUser();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".quack.AddUser.user: object expected");
                message.user = $root.quack.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddUser
         * @static
         * @param {quack.AddUser} message AddUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.user = null;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.quack.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this AddUser to JSON.
         * @function toJSON
         * @memberof quack.AddUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUser;
    })();

    quack.RemoveUser = (function() {

        /**
         * Properties of a RemoveUser.
         * @memberof quack
         * @interface IRemoveUser
         * @property {string|null} [id] RemoveUser id
         */

        /**
         * Constructs a new RemoveUser.
         * @memberof quack
         * @classdesc Represents a RemoveUser.
         * @implements IRemoveUser
         * @constructor
         * @param {quack.IRemoveUser=} [properties] Properties to set
         */
        function RemoveUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUser id.
         * @member {string} id
         * @memberof quack.RemoveUser
         * @instance
         */
        RemoveUser.prototype.id = "";

        /**
         * Creates a new RemoveUser instance using the specified properties.
         * @function create
         * @memberof quack.RemoveUser
         * @static
         * @param {quack.IRemoveUser=} [properties] Properties to set
         * @returns {quack.RemoveUser} RemoveUser instance
         */
        RemoveUser.create = function create(properties) {
            return new RemoveUser(properties);
        };

        /**
         * Creates a RemoveUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveUser} RemoveUser
         */
        RemoveUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveUser)
                return object;
            var message = new $root.quack.RemoveUser();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveUser
         * @static
         * @param {quack.RemoveUser} message RemoveUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this RemoveUser to JSON.
         * @function toJSON
         * @memberof quack.RemoveUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveUser;
    })();

    quack.UpdateUser = (function() {

        /**
         * Properties of an UpdateUser.
         * @memberof quack
         * @interface IUpdateUser
         * @property {string|null} [id] UpdateUser id
         * @property {quack.User|null} [user] UpdateUser user
         */

        /**
         * Constructs a new UpdateUser.
         * @memberof quack
         * @classdesc Represents an UpdateUser.
         * @implements IUpdateUser
         * @constructor
         * @param {quack.IUpdateUser=} [properties] Properties to set
         */
        function UpdateUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUser id.
         * @member {string} id
         * @memberof quack.UpdateUser
         * @instance
         */
        UpdateUser.prototype.id = "";

        /**
         * UpdateUser user.
         * @member {quack.User|null|undefined} user
         * @memberof quack.UpdateUser
         * @instance
         */
        UpdateUser.prototype.user = null;

        /**
         * Creates a new UpdateUser instance using the specified properties.
         * @function create
         * @memberof quack.UpdateUser
         * @static
         * @param {quack.IUpdateUser=} [properties] Properties to set
         * @returns {quack.UpdateUser} UpdateUser instance
         */
        UpdateUser.create = function create(properties) {
            return new UpdateUser(properties);
        };

        /**
         * Creates an UpdateUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateUser} UpdateUser
         */
        UpdateUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateUser)
                return object;
            var message = new $root.quack.UpdateUser();
            if (object.id != null)
                message.id = String(object.id);
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".quack.UpdateUser.user: object expected");
                message.user = $root.quack.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateUser
         * @static
         * @param {quack.UpdateUser} message UpdateUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.user = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.quack.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this UpdateUser to JSON.
         * @function toJSON
         * @memberof quack.UpdateUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUser;
    })();

    quack.GetUser = (function() {

        /**
         * Properties of a GetUser.
         * @memberof quack
         * @interface IGetUser
         * @property {string|null} [id] GetUser id
         */

        /**
         * Constructs a new GetUser.
         * @memberof quack
         * @classdesc Represents a GetUser.
         * @implements IGetUser
         * @constructor
         * @param {quack.IGetUser=} [properties] Properties to set
         */
        function GetUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUser id.
         * @member {string} id
         * @memberof quack.GetUser
         * @instance
         */
        GetUser.prototype.id = "";

        /**
         * Creates a new GetUser instance using the specified properties.
         * @function create
         * @memberof quack.GetUser
         * @static
         * @param {quack.IGetUser=} [properties] Properties to set
         * @returns {quack.GetUser} GetUser instance
         */
        GetUser.create = function create(properties) {
            return new GetUser(properties);
        };

        /**
         * Creates a GetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetUser} GetUser
         */
        GetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetUser)
                return object;
            var message = new $root.quack.GetUser();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a GetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetUser
         * @static
         * @param {quack.GetUser} message GetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this GetUser to JSON.
         * @function toJSON
         * @memberof quack.GetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUser;
    })();

    quack.Quack = (function() {

        /**
         * Properties of a Quack.
         * @memberof quack
         * @interface IQuack
         * @property {Uint8Array|null} [deviceId] Quack deviceId
         * @property {number|null} [count] Quack count
         * @property {boolean|null} [queued] Quack queued
         * @property {quack.Unknown|null} [unknown] Quack unknown
         * @property {quack.Ack|null} [ack] Quack ack
         * @property {quack.Nack|null} [nack] Quack nack
         * @property {quack.Check|null} [check] Quack check
         * @property {quack.UpdateDevice|null} [updateDevice] Quack updateDevice
         * @property {quack.Firmware|null} [firmware] Quack firmware
         * @property {quack.SyncTime|null} [syncTime] Quack syncTime
         * @property {quack.Error|null} [error] Quack error
         * @property {quack.Clear|null} [clear] Quack clear
         * @property {quack.Status|null} [status] Quack status
         * @property {quack.Connect|null} [connect] Quack connect
         * @property {quack.AddComponent|null} [addComponent] Quack addComponent
         * @property {quack.RemoveComponent|null} [removeComponent] Quack removeComponent
         * @property {quack.UpdateComponent|null} [updateComponent] Quack updateComponent
         * @property {quack.UpdateVirtualComponent|null} [updateVComponent] Quack updateVComponent
         * @property {quack.AddInteraction|null} [addInteraction] Quack addInteraction
         * @property {quack.RemoveInteraction|null} [removeInteraction] Quack removeInteraction
         * @property {quack.UpdateInteraction|null} [updateInteraction] Quack updateInteraction
         * @property {quack.GetMeasurement|null} [getMeasurement] Quack getMeasurement
         * @property {quack.Measurement|null} [measurement] Quack measurement
         * @property {quack.VirtualMeasurement|null} [vMeasurement] Quack vMeasurement
         * @property {quack.AddUser|null} [addUser] Quack addUser
         * @property {quack.RemoveUser|null} [removeUser] Quack removeUser
         * @property {quack.UpdateUser|null} [updateUser] Quack updateUser
         */

        /**
         * Constructs a new Quack.
         * @memberof quack
         * @classdesc Represents a Quack.
         * @implements IQuack
         * @constructor
         * @param {quack.IQuack=} [properties] Properties to set
         */
        function Quack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quack deviceId.
         * @member {Uint8Array} deviceId
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.deviceId = $util.newBuffer([]);

        /**
         * Quack count.
         * @member {number} count
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.count = 0;

        /**
         * Quack queued.
         * @member {boolean} queued
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.queued = false;

        /**
         * Quack unknown.
         * @member {quack.Unknown|null|undefined} unknown
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.unknown = null;

        /**
         * Quack ack.
         * @member {quack.Ack|null|undefined} ack
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.ack = null;

        /**
         * Quack nack.
         * @member {quack.Nack|null|undefined} nack
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.nack = null;

        /**
         * Quack check.
         * @member {quack.Check|null|undefined} check
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.check = null;

        /**
         * Quack updateDevice.
         * @member {quack.UpdateDevice|null|undefined} updateDevice
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateDevice = null;

        /**
         * Quack firmware.
         * @member {quack.Firmware|null|undefined} firmware
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.firmware = null;

        /**
         * Quack syncTime.
         * @member {quack.SyncTime|null|undefined} syncTime
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.syncTime = null;

        /**
         * Quack error.
         * @member {quack.Error|null|undefined} error
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.error = null;

        /**
         * Quack clear.
         * @member {quack.Clear|null|undefined} clear
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.clear = null;

        /**
         * Quack status.
         * @member {quack.Status|null|undefined} status
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.status = null;

        /**
         * Quack connect.
         * @member {quack.Connect|null|undefined} connect
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.connect = null;

        /**
         * Quack addComponent.
         * @member {quack.AddComponent|null|undefined} addComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addComponent = null;

        /**
         * Quack removeComponent.
         * @member {quack.RemoveComponent|null|undefined} removeComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeComponent = null;

        /**
         * Quack updateComponent.
         * @member {quack.UpdateComponent|null|undefined} updateComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateComponent = null;

        /**
         * Quack updateVComponent.
         * @member {quack.UpdateVirtualComponent|null|undefined} updateVComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateVComponent = null;

        /**
         * Quack addInteraction.
         * @member {quack.AddInteraction|null|undefined} addInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addInteraction = null;

        /**
         * Quack removeInteraction.
         * @member {quack.RemoveInteraction|null|undefined} removeInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeInteraction = null;

        /**
         * Quack updateInteraction.
         * @member {quack.UpdateInteraction|null|undefined} updateInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateInteraction = null;

        /**
         * Quack getMeasurement.
         * @member {quack.GetMeasurement|null|undefined} getMeasurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.getMeasurement = null;

        /**
         * Quack measurement.
         * @member {quack.Measurement|null|undefined} measurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.measurement = null;

        /**
         * Quack vMeasurement.
         * @member {quack.VirtualMeasurement|null|undefined} vMeasurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.vMeasurement = null;

        /**
         * Quack addUser.
         * @member {quack.AddUser|null|undefined} addUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addUser = null;

        /**
         * Quack removeUser.
         * @member {quack.RemoveUser|null|undefined} removeUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeUser = null;

        /**
         * Quack updateUser.
         * @member {quack.UpdateUser|null|undefined} updateUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateUser = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Quack payload.
         * @member {"unknown"|"ack"|"nack"|"check"|"updateDevice"|"firmware"|"syncTime"|"error"|"clear"|"status"|"connect"|"addComponent"|"removeComponent"|"updateComponent"|"updateVComponent"|"addInteraction"|"removeInteraction"|"updateInteraction"|"getMeasurement"|"measurement"|"vMeasurement"|"addUser"|"removeUser"|"updateUser"|undefined} payload
         * @memberof quack.Quack
         * @instance
         */
        Object.defineProperty(Quack.prototype, "payload", {
            get: $util.oneOfGetter($oneOfFields = ["unknown", "ack", "nack", "check", "updateDevice", "firmware", "syncTime", "error", "clear", "status", "connect", "addComponent", "removeComponent", "updateComponent", "updateVComponent", "addInteraction", "removeInteraction", "updateInteraction", "getMeasurement", "measurement", "vMeasurement", "addUser", "removeUser", "updateUser"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Quack instance using the specified properties.
         * @function create
         * @memberof quack.Quack
         * @static
         * @param {quack.IQuack=} [properties] Properties to set
         * @returns {quack.Quack} Quack instance
         */
        Quack.create = function create(properties) {
            return new Quack(properties);
        };

        /**
         * Creates a Quack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Quack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Quack} Quack
         */
        Quack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Quack)
                return object;
            var message = new $root.quack.Quack();
            if (object.deviceId != null)
                if (typeof object.deviceId === "string")
                    $util.base64.decode(object.deviceId, message.deviceId = $util.newBuffer($util.base64.length(object.deviceId)), 0);
                else if (object.deviceId.length)
                    message.deviceId = object.deviceId;
            if (object.count != null)
                message.count = object.count >>> 0;
            if (object.queued != null)
                message.queued = Boolean(object.queued);
            if (object.unknown != null) {
                if (typeof object.unknown !== "object")
                    throw TypeError(".quack.Quack.unknown: object expected");
                message.unknown = $root.quack.Unknown.fromObject(object.unknown);
            }
            if (object.ack != null) {
                if (typeof object.ack !== "object")
                    throw TypeError(".quack.Quack.ack: object expected");
                message.ack = $root.quack.Ack.fromObject(object.ack);
            }
            if (object.nack != null) {
                if (typeof object.nack !== "object")
                    throw TypeError(".quack.Quack.nack: object expected");
                message.nack = $root.quack.Nack.fromObject(object.nack);
            }
            if (object.check != null) {
                if (typeof object.check !== "object")
                    throw TypeError(".quack.Quack.check: object expected");
                message.check = $root.quack.Check.fromObject(object.check);
            }
            if (object.updateDevice != null) {
                if (typeof object.updateDevice !== "object")
                    throw TypeError(".quack.Quack.updateDevice: object expected");
                message.updateDevice = $root.quack.UpdateDevice.fromObject(object.updateDevice);
            }
            if (object.firmware != null) {
                if (typeof object.firmware !== "object")
                    throw TypeError(".quack.Quack.firmware: object expected");
                message.firmware = $root.quack.Firmware.fromObject(object.firmware);
            }
            if (object.syncTime != null) {
                if (typeof object.syncTime !== "object")
                    throw TypeError(".quack.Quack.syncTime: object expected");
                message.syncTime = $root.quack.SyncTime.fromObject(object.syncTime);
            }
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".quack.Quack.error: object expected");
                message.error = $root.quack.Error.fromObject(object.error);
            }
            if (object.clear != null) {
                if (typeof object.clear !== "object")
                    throw TypeError(".quack.Quack.clear: object expected");
                message.clear = $root.quack.Clear.fromObject(object.clear);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".quack.Quack.status: object expected");
                message.status = $root.quack.Status.fromObject(object.status);
            }
            if (object.connect != null) {
                if (typeof object.connect !== "object")
                    throw TypeError(".quack.Quack.connect: object expected");
                message.connect = $root.quack.Connect.fromObject(object.connect);
            }
            if (object.addComponent != null) {
                if (typeof object.addComponent !== "object")
                    throw TypeError(".quack.Quack.addComponent: object expected");
                message.addComponent = $root.quack.AddComponent.fromObject(object.addComponent);
            }
            if (object.removeComponent != null) {
                if (typeof object.removeComponent !== "object")
                    throw TypeError(".quack.Quack.removeComponent: object expected");
                message.removeComponent = $root.quack.RemoveComponent.fromObject(object.removeComponent);
            }
            if (object.updateComponent != null) {
                if (typeof object.updateComponent !== "object")
                    throw TypeError(".quack.Quack.updateComponent: object expected");
                message.updateComponent = $root.quack.UpdateComponent.fromObject(object.updateComponent);
            }
            if (object.updateVComponent != null) {
                if (typeof object.updateVComponent !== "object")
                    throw TypeError(".quack.Quack.updateVComponent: object expected");
                message.updateVComponent = $root.quack.UpdateVirtualComponent.fromObject(object.updateVComponent);
            }
            if (object.addInteraction != null) {
                if (typeof object.addInteraction !== "object")
                    throw TypeError(".quack.Quack.addInteraction: object expected");
                message.addInteraction = $root.quack.AddInteraction.fromObject(object.addInteraction);
            }
            if (object.removeInteraction != null) {
                if (typeof object.removeInteraction !== "object")
                    throw TypeError(".quack.Quack.removeInteraction: object expected");
                message.removeInteraction = $root.quack.RemoveInteraction.fromObject(object.removeInteraction);
            }
            if (object.updateInteraction != null) {
                if (typeof object.updateInteraction !== "object")
                    throw TypeError(".quack.Quack.updateInteraction: object expected");
                message.updateInteraction = $root.quack.UpdateInteraction.fromObject(object.updateInteraction);
            }
            if (object.getMeasurement != null) {
                if (typeof object.getMeasurement !== "object")
                    throw TypeError(".quack.Quack.getMeasurement: object expected");
                message.getMeasurement = $root.quack.GetMeasurement.fromObject(object.getMeasurement);
            }
            if (object.measurement != null) {
                if (typeof object.measurement !== "object")
                    throw TypeError(".quack.Quack.measurement: object expected");
                message.measurement = $root.quack.Measurement.fromObject(object.measurement);
            }
            if (object.vMeasurement != null) {
                if (typeof object.vMeasurement !== "object")
                    throw TypeError(".quack.Quack.vMeasurement: object expected");
                message.vMeasurement = $root.quack.VirtualMeasurement.fromObject(object.vMeasurement);
            }
            if (object.addUser != null) {
                if (typeof object.addUser !== "object")
                    throw TypeError(".quack.Quack.addUser: object expected");
                message.addUser = $root.quack.AddUser.fromObject(object.addUser);
            }
            if (object.removeUser != null) {
                if (typeof object.removeUser !== "object")
                    throw TypeError(".quack.Quack.removeUser: object expected");
                message.removeUser = $root.quack.RemoveUser.fromObject(object.removeUser);
            }
            if (object.updateUser != null) {
                if (typeof object.updateUser !== "object")
                    throw TypeError(".quack.Quack.updateUser: object expected");
                message.updateUser = $root.quack.UpdateUser.fromObject(object.updateUser);
            }
            return message;
        };

        /**
         * Creates a plain object from a Quack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Quack
         * @static
         * @param {quack.Quack} message Quack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.deviceId = "";
                else {
                    object.deviceId = [];
                    if (options.bytes !== Array)
                        object.deviceId = $util.newBuffer(object.deviceId);
                }
                object.count = 0;
                object.queued = false;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = options.bytes === String ? $util.base64.encode(message.deviceId, 0, message.deviceId.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceId) : message.deviceId;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            if (message.queued != null && message.hasOwnProperty("queued"))
                object.queued = message.queued;
            if (message.unknown != null && message.hasOwnProperty("unknown")) {
                object.unknown = $root.quack.Unknown.toObject(message.unknown, options);
                if (options.oneofs)
                    object.payload = "unknown";
            }
            if (message.ack != null && message.hasOwnProperty("ack")) {
                object.ack = $root.quack.Ack.toObject(message.ack, options);
                if (options.oneofs)
                    object.payload = "ack";
            }
            if (message.nack != null && message.hasOwnProperty("nack")) {
                object.nack = $root.quack.Nack.toObject(message.nack, options);
                if (options.oneofs)
                    object.payload = "nack";
            }
            if (message.check != null && message.hasOwnProperty("check")) {
                object.check = $root.quack.Check.toObject(message.check, options);
                if (options.oneofs)
                    object.payload = "check";
            }
            if (message.updateDevice != null && message.hasOwnProperty("updateDevice")) {
                object.updateDevice = $root.quack.UpdateDevice.toObject(message.updateDevice, options);
                if (options.oneofs)
                    object.payload = "updateDevice";
            }
            if (message.firmware != null && message.hasOwnProperty("firmware")) {
                object.firmware = $root.quack.Firmware.toObject(message.firmware, options);
                if (options.oneofs)
                    object.payload = "firmware";
            }
            if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                object.syncTime = $root.quack.SyncTime.toObject(message.syncTime, options);
                if (options.oneofs)
                    object.payload = "syncTime";
            }
            if (message.error != null && message.hasOwnProperty("error")) {
                object.error = $root.quack.Error.toObject(message.error, options);
                if (options.oneofs)
                    object.payload = "error";
            }
            if (message.clear != null && message.hasOwnProperty("clear")) {
                object.clear = $root.quack.Clear.toObject(message.clear, options);
                if (options.oneofs)
                    object.payload = "clear";
            }
            if (message.status != null && message.hasOwnProperty("status")) {
                object.status = $root.quack.Status.toObject(message.status, options);
                if (options.oneofs)
                    object.payload = "status";
            }
            if (message.connect != null && message.hasOwnProperty("connect")) {
                object.connect = $root.quack.Connect.toObject(message.connect, options);
                if (options.oneofs)
                    object.payload = "connect";
            }
            if (message.addComponent != null && message.hasOwnProperty("addComponent")) {
                object.addComponent = $root.quack.AddComponent.toObject(message.addComponent, options);
                if (options.oneofs)
                    object.payload = "addComponent";
            }
            if (message.removeComponent != null && message.hasOwnProperty("removeComponent")) {
                object.removeComponent = $root.quack.RemoveComponent.toObject(message.removeComponent, options);
                if (options.oneofs)
                    object.payload = "removeComponent";
            }
            if (message.updateComponent != null && message.hasOwnProperty("updateComponent")) {
                object.updateComponent = $root.quack.UpdateComponent.toObject(message.updateComponent, options);
                if (options.oneofs)
                    object.payload = "updateComponent";
            }
            if (message.updateVComponent != null && message.hasOwnProperty("updateVComponent")) {
                object.updateVComponent = $root.quack.UpdateVirtualComponent.toObject(message.updateVComponent, options);
                if (options.oneofs)
                    object.payload = "updateVComponent";
            }
            if (message.addInteraction != null && message.hasOwnProperty("addInteraction")) {
                object.addInteraction = $root.quack.AddInteraction.toObject(message.addInteraction, options);
                if (options.oneofs)
                    object.payload = "addInteraction";
            }
            if (message.removeInteraction != null && message.hasOwnProperty("removeInteraction")) {
                object.removeInteraction = $root.quack.RemoveInteraction.toObject(message.removeInteraction, options);
                if (options.oneofs)
                    object.payload = "removeInteraction";
            }
            if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                object.updateInteraction = $root.quack.UpdateInteraction.toObject(message.updateInteraction, options);
                if (options.oneofs)
                    object.payload = "updateInteraction";
            }
            if (message.getMeasurement != null && message.hasOwnProperty("getMeasurement")) {
                object.getMeasurement = $root.quack.GetMeasurement.toObject(message.getMeasurement, options);
                if (options.oneofs)
                    object.payload = "getMeasurement";
            }
            if (message.measurement != null && message.hasOwnProperty("measurement")) {
                object.measurement = $root.quack.Measurement.toObject(message.measurement, options);
                if (options.oneofs)
                    object.payload = "measurement";
            }
            if (message.vMeasurement != null && message.hasOwnProperty("vMeasurement")) {
                object.vMeasurement = $root.quack.VirtualMeasurement.toObject(message.vMeasurement, options);
                if (options.oneofs)
                    object.payload = "vMeasurement";
            }
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                object.addUser = $root.quack.AddUser.toObject(message.addUser, options);
                if (options.oneofs)
                    object.payload = "addUser";
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                object.removeUser = $root.quack.RemoveUser.toObject(message.removeUser, options);
                if (options.oneofs)
                    object.payload = "removeUser";
            }
            if (message.updateUser != null && message.hasOwnProperty("updateUser")) {
                object.updateUser = $root.quack.UpdateUser.toObject(message.updateUser, options);
                if (options.oneofs)
                    object.payload = "updateUser";
            }
            return object;
        };

        /**
         * Converts this Quack to JSON.
         * @function toJSON
         * @memberof quack.Quack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quack;
    })();

    quack.Quacks = (function() {

        /**
         * Properties of a Quacks.
         * @memberof quack
         * @interface IQuacks
         * @property {Array.<quack.Quack>|null} [quacks] Quacks quacks
         */

        /**
         * Constructs a new Quacks.
         * @memberof quack
         * @classdesc Represents a Quacks.
         * @implements IQuacks
         * @constructor
         * @param {quack.IQuacks=} [properties] Properties to set
         */
        function Quacks(properties) {
            this.quacks = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quacks quacks.
         * @member {Array.<quack.Quack>} quacks
         * @memberof quack.Quacks
         * @instance
         */
        Quacks.prototype.quacks = $util.emptyArray;

        /**
         * Creates a new Quacks instance using the specified properties.
         * @function create
         * @memberof quack.Quacks
         * @static
         * @param {quack.IQuacks=} [properties] Properties to set
         * @returns {quack.Quacks} Quacks instance
         */
        Quacks.create = function create(properties) {
            return new Quacks(properties);
        };

        /**
         * Creates a Quacks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Quacks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Quacks} Quacks
         */
        Quacks.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Quacks)
                return object;
            var message = new $root.quack.Quacks();
            if (object.quacks) {
                if (!Array.isArray(object.quacks))
                    throw TypeError(".quack.Quacks.quacks: array expected");
                message.quacks = [];
                for (var i = 0; i < object.quacks.length; ++i) {
                    if (typeof object.quacks[i] !== "object")
                        throw TypeError(".quack.Quacks.quacks: object expected");
                    message.quacks[i] = $root.quack.Quack.fromObject(object.quacks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Quacks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Quacks
         * @static
         * @param {quack.Quacks} message Quacks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quacks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.quacks = [];
            if (message.quacks && message.quacks.length) {
                object.quacks = [];
                for (var j = 0; j < message.quacks.length; ++j)
                    object.quacks[j] = $root.quack.Quack.toObject(message.quacks[j], options);
            }
            return object;
        };

        /**
         * Converts this Quacks to JSON.
         * @function toJSON
         * @memberof quack.Quacks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quacks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quacks;
    })();

    return quack;
})();

module.exports = $root;
